/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  float8: any;
  inet: any;
  json: any;
  jsonb: any;
  lquery: any;
  ltree: any;
  ltxtquery: any;
  numeric: number;
  oid: any;
  smallint: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
};

export type AccessControlGetPinResponse = {
  __typename?: 'AccessControlGetPinResponse';
  pin?: Maybe<Scalars['String']>;
  valid_until?: Maybe<Scalars['timestamptz']>;
};

export type AccessControlSendPinSmsResponse = {
  __typename?: 'AccessControlSendPinSmsResponse';
  sent: Scalars['Boolean'];
};

export type AccountingBillingData = {
  __typename?: 'AccountingBillingData';
  internal_revenue_share?: Maybe<Scalars['Float']>;
  internal_transaction_costs_share?: Maybe<Scalars['Float']>;
  monthly_fee_local?: Maybe<Scalars['Float']>;
  transaction_costs_charge_type?: Maybe<TransactionCostsChargeType>;
};

export type AccountingDataExport = {
  __typename?: 'AccountingDataExport';
  file_format: Scalars['String'];
  lot_id: Scalars['String'];
  month: Scalars['String'];
  presigned_url: Scalars['String'];
};

export type AccountingRecordsByMonth = {
  __typename?: 'AccountingRecordsByMonth';
  billing_data: AccountingBillingData;
  client_revenue: RevenueData;
  internal_revenue: RevenueData;
};

export type AdyenResultCodeResponse = {
  __typename?: 'AdyenResultCodeResponse';
  adyen_result_code: Scalars['String'];
  end_date?: Maybe<Scalars['String']>;
  order_id: Scalars['String'];
  plate: Scalars['String'];
  price_valid_until: Scalars['String'];
  start_date: Scalars['String'];
};

export type ApplyDiscountCodeResult = {
  __typename?: 'ApplyDiscountCodeResult';
  applied_discount?: Maybe<Scalars['Float']>;
  applied_discount_codes?: Maybe<Array<Scalars['String']>>;
  order_status?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
};

export type B2CAdyenCheckoutResponse = {
  __typename?: 'B2CAdyenCheckoutResponse';
  adyen_id: Scalars['String'];
  adyen_session_data: Scalars['String'];
};

export type B2CCarpayLotExtendedInfo = {
  __typename?: 'B2CCarpayLotExtendedInfo';
  lot: B2CCarpayLotInfo;
  parking_contexts: Array<OrderParkingContext>;
};

export type B2CCarpayLotInfo = {
  __typename?: 'B2CCarpayLotInfo';
  address: Scalars['String'];
  arrival_detection_time?: Maybe<Scalars['Int']>;
  discount_types: Array<DiscountType>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  lot_id: Scalars['String'];
  lot_tariffs: Array<Scalars['String']>;
  lot_type: LotType;
  name: Scalars['String'];
  sv_lot_type: SvLotType;
  visible_toleration_time?: Maybe<Scalars['Int']>;
};

export type B2CCarpayLotShortInfo = {
  __typename?: 'B2CCarpayLotShortInfo';
  address: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  lot_id: Scalars['String'];
  name: Scalars['String'];
};

export type B2CCarpayLots = {
  __typename?: 'B2CCarpayLots';
  lots: Array<B2CCarpayLotShortInfo>;
};

export type B2CCarpayOrderInfo = {
  __typename?: 'B2CCarpayOrderInfo';
  end_date?: Maybe<Scalars['timestamptz']>;
  invoice_available: Scalars['Boolean'];
  order_id: Scalars['String'];
  plate: Scalars['String'];
  start_date: Scalars['timestamptz'];
  status: Scalars['String'];
};

export type B2CCarpayOrderResponse = {
  __typename?: 'B2CCarpayOrderResponse';
  orders: Array<B2CCarpayOrderView>;
};

export type B2CCarpayOrderView = {
  __typename?: 'B2CCarpayOrderView';
  lot: B2CCarpayLotInfo;
  order: B2CCarpayOrderInfo;
  parking_contexts: Array<OrderParkingContext>;
  price: B2CCarpayPriceInfo;
  scanned_codes: Array<Scalars['String']>;
};

export type B2CCarpayPriceInfo = {
  __typename?: 'B2CCarpayPriceInfo';
  applied_discount: Scalars['Float'];
  billable: Scalars['Boolean'];
  billable_end: Scalars['String'];
  billable_start: Scalars['String'];
  currency: Scalars['String'];
  discounted_parking_price: Scalars['Float'];
  illegal_parking_price: Scalars['Float'];
  parking_price: Scalars['Float'];
  payment_deadline?: Maybe<Scalars['timestamptz']>;
  price_valid_until: Scalars['timestamptz'];
  vat_rate: Scalars['Float'];
};

export type B2CDeletePaymentMethodResponse = {
  __typename?: 'B2CDeletePaymentMethodResponse';
  success: Scalars['Boolean'];
};

export type B2CInvoice = {
  __typename?: 'B2CInvoice';
  invoice_id: Scalars['String'];
  url: Scalars['String'];
};

export type B2CLotOccupancy = {
  __typename?: 'B2CLotOccupancy';
  free_spots?: Maybe<Scalars['Int']>;
  last_updated_at: Scalars['timestamptz'];
  occupancy_distribution?: Maybe<Array<Scalars['Int']>>;
};

export type B2CPaymentMethod = {
  __typename?: 'B2CPaymentMethod';
  card_data?: Maybe<CardPaymentMethod>;
  created_at: Scalars['String'];
  id: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type B2CSavePaymentMethodResponse = {
  __typename?: 'B2CSavePaymentMethodResponse';
  session_data: Scalars['String'];
  session_id: Scalars['String'];
};

export type BalenaDeviceOutput = {
  __typename?: 'BalenaDeviceOutput';
  devices: Scalars['json'];
};

export type BalenaReleaseOutput = {
  __typename?: 'BalenaReleaseOutput';
  releases: Scalars['json'];
};

export type BlacklistEntriesByPlateResponse = {
  __typename?: 'BlacklistEntriesByPlateResponse';
  comment?: Maybe<Scalars['String']>;
  company_id: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  start_date?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type BlacklistEntriesGroupedByPlateResponse = {
  __typename?: 'BlacklistEntriesGroupedByPlateResponse';
  blacklist_entries?: Maybe<Array<BlacklistEntry>>;
  total_count: Scalars['Int'];
};

export type BlacklistEntry = {
  __typename?: 'BlacklistEntry';
  comment: Scalars['String'];
  companyId: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['String'];
  endDate: Scalars['String'];
  lotId: Scalars['String'];
  plate: Scalars['String'];
  plateCount: Scalars['String'];
  startDate: Scalars['String'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type BookingAccountingRecordsByMonth = {
  __typename?: 'BookingAccountingRecordsByMonth';
  client_revenue?: Maybe<Scalars['Float']>;
  internal_revenue?: Maybe<Scalars['Float']>;
  internal_revenue_share?: Maybe<Scalars['Float']>;
};

export type BookingAnalyticsDuration = {
  __typename?: 'BookingAnalyticsDuration';
  duration: Scalars['Int'];
  total_revenue: Scalars['Float'];
};

export type BookingAnalyticsDurationByType = {
  __typename?: 'BookingAnalyticsDurationByType';
  duration_type?: Maybe<BookingAnalyticsDurationType>;
  durations: Array<BookingAnalyticsDuration>;
};

export type BookingAnalyticsDurationByTypeResponse = {
  __typename?: 'BookingAnalyticsDurationByTypeResponse';
  booking_duration_by_type: Array<BookingAnalyticsDurationByType>;
};

export enum BookingAnalyticsDurationType {
  Daily = 'daily',
  Hourly = 'hourly',
  MonthlySubscription = 'monthly_subscription',
  Nightly = 'nightly'
}

export enum BookingAnalyticsPeriodType {
  Payment = 'payment',
  Performance = 'performance'
}

export type BookingAnalyticsRevenue = {
  __typename?: 'BookingAnalyticsRevenue';
  duration_type: BookingAnalyticsDurationType;
  total_count: Scalars['Int'];
  total_revenue: Scalars['Float'];
};

export type BookingAnalyticsRevenueDaily = {
  __typename?: 'BookingAnalyticsRevenueDaily';
  day: Scalars['date'];
  revenue: Array<BookingAnalyticsRevenue>;
};

export type BookingAnalyticsRevenueDailyResponse = {
  __typename?: 'BookingAnalyticsRevenueDailyResponse';
  booking_revenue_by_day: Array<BookingAnalyticsRevenueDaily>;
};

export type BookingCancelUserSubscriptionResponse = {
  __typename?: 'BookingCancelUserSubscriptionResponse';
  success: Scalars['Boolean'];
};

export type BookingCreateAdyenSessionResponse = {
  __typename?: 'BookingCreateAdyenSessionResponse';
  session_data: Scalars['String'];
  session_id: Scalars['String'];
};

export type BookingCreateBookingResponse = {
  __typename?: 'BookingCreateBookingResponse';
  booking_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  unavailable_dates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BookingCreateLotConfigurationResponse = {
  __typename?: 'BookingCreateLotConfigurationResponse';
  success: Scalars['Boolean'];
};

export type BookingFeature = {
  __typename?: 'BookingFeature';
  config?: Maybe<Scalars['json']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BookingFeatureInput = {
  config?: InputMaybe<Scalars['json']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BookingGetLotAvailabilityResponse = {
  __typename?: 'BookingGetLotAvailabilityResponse';
  is_available?: Maybe<Scalars['Boolean']>;
};

export type BookingGetLotConfigurationResponse = {
  __typename?: 'BookingGetLotConfigurationResponse';
  adyen_merchant_id?: Maybe<Scalars['String']>;
  description?: Maybe<Description>;
  display_name?: Maybe<Scalars['String']>;
  earliest_booking_date?: Maybe<Scalars['String']>;
  end_of_live_date?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<BookingFeature>>>;
  go_live_date?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_public?: Maybe<Scalars['Boolean']>;
  lot_capacity?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  lot_legal_entity?: Maybe<EnrichedLotLegalEntity>;
  max_booking_duration?: Maybe<Scalars['String']>;
  min_booking_duration?: Maybe<Scalars['String']>;
  night_lot_capacity?: Maybe<Scalars['Int']>;
  opening_hours?: Maybe<OpeningHours>;
  pricing?: Maybe<Array<Maybe<BookingPrice>>>;
};

export type BookingGetLotImageUrls = {
  __typename?: 'BookingGetLotImageUrls';
  primary_url: Scalars['String'];
  secondary_urls: Array<Maybe<Scalars['String']>>;
};

export type BookingGetLotResponse = {
  __typename?: 'BookingGetLotResponse';
  active_features: Array<Maybe<BookingFeature>>;
  address: Scalars['String'];
  description: Scalars['String'];
  earliest_booking_date?: Maybe<Scalars['String']>;
  end_of_live_date?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_live?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  lot_country_code?: Maybe<Scalars['String']>;
  max_booking_duration?: Maybe<Scalars['String']>;
  min_booking_duration?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  opening_hours: OpeningHours;
  prices: Array<Maybe<BookingPrice>>;
};

export type BookingGetLotsResponse = {
  __typename?: 'BookingGetLotsResponse';
  address: Scalars['String'];
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  proximity_meters: Scalars['Int'];
};

export type BookingGetPriceHourlyResponse = {
  __typename?: 'BookingGetPriceHourlyResponse';
  offered_prices?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type BookingGetPriceResponse = {
  __typename?: 'BookingGetPriceResponse';
  price?: Maybe<Scalars['Float']>;
};

export type BookingGetPublicLotsResponse = {
  __typename?: 'BookingGetPublicLotsResponse';
  lots: Array<Maybe<Scalars['json']>>;
};

export type BookingInvoice = {
  __typename?: 'BookingInvoice';
  invoice_id: Scalars['String'];
};

export type BookingPlate = {
  __typename?: 'BookingPlate';
  plate: Scalars['String'];
};

export type BookingPrice = {
  __typename?: 'BookingPrice';
  day?: Maybe<Scalars['Float']>;
  hour?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Float']>;
  pricing_type?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['json']>>>;
  week?: Maybe<Scalars['Float']>;
};

export type BookingPriceInput = {
  day?: InputMaybe<Scalars['Float']>;
  hour?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
  pricing_type?: InputMaybe<BookingPricingModelType>;
  week?: InputMaybe<Scalars['Float']>;
};

export enum BookingPricingModelType {
  PrivateCommuter = 'PRIVATE_COMMUTER',
  PrivateEmployee = 'PRIVATE_EMPLOYEE',
  PrivateOther = 'PRIVATE_OTHER',
  PrivateResident = 'PRIVATE_RESIDENT',
  Public = 'PUBLIC',
  PublicNightly = 'PUBLIC_NIGHTLY'
}

export enum BookingType {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Nightly = 'NIGHTLY'
}

export type BookingUpdateLotConfigurationResponse = {
  __typename?: 'BookingUpdateLotConfigurationResponse';
  success: Scalars['Boolean'];
};

export type BookingUserLicensePlate = {
  __typename?: 'BookingUserLicensePlate';
  country: Scalars['String'];
  id: Scalars['uuid'];
  plate: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BucketedVisitsByCategory = {
  __typename?: 'BucketedVisitsByCategory';
  category: Scalars['String'];
  eventCount: Scalars['Int'];
};

export type CancelReimbursementOutput = {
  __typename?: 'CancelReimbursementOutput';
  message: Scalars['String'];
};

export type CancelViolationsByCaseIdsOutput = {
  __typename?: 'CancelViolationsByCaseIdsOutput';
  caseIdsCanceled: Array<Scalars['String']>;
  caseIdsFinalized: Array<Scalars['String']>;
  caseIdsNotFound: Array<Scalars['String']>;
};

export type CancelViolationsByPlateOutput = {
  __typename?: 'CancelViolationsByPlateOutput';
  canceledCases: Array<Scalars['jsonb']>;
  finalizedCases: Array<Scalars['jsonb']>;
};

export type CancellationAggregate = {
  __typename?: 'CancellationAggregate';
  co_tenant?: Maybe<Scalars['Int']>;
  disabled?: Maybe<Scalars['Int']>;
  employee?: Maybe<Scalars['Int']>;
  goodwill_customer?: Maybe<Scalars['Int']>;
  packstation?: Maybe<Scalars['Int']>;
  receipt_limit_exceeded?: Maybe<Scalars['Int']>;
  resident?: Maybe<Scalars['Int']>;
  service_supplier?: Maybe<Scalars['Int']>;
};

export type CancellationAggregateByDayResponse = {
  __typename?: 'CancellationAggregateByDayResponse';
  billable_cancellation_count: Scalars['Int'];
  cancellation_aggregate: CancellationAggregate;
  total_cancellation_count: Scalars['Int'];
};

export type CancellationsCustomerAggregate = {
  __typename?: 'CancellationsCustomerAggregate';
  violation_case_alltime: Scalars['jsonb'];
  violation_case_monthly: Scalars['jsonb'];
};

export type CancellationsCustomerOutput = {
  __typename?: 'CancellationsCustomerOutput';
  violation_case: Scalars['jsonb'];
  violation_case_aggregate: Scalars['jsonb'];
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  expiry_month?: Maybe<Scalars['String']>;
  expiry_year?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type CarpayCheckoutResult = {
  __typename?: 'CarpayCheckoutResult';
  adyen_id?: Maybe<Scalars['String']>;
  adyen_session_data?: Maybe<Scalars['String']>;
  country_code: Scalars['String'];
  currency: Scalars['String'];
  price: Scalars['Float'];
  stripe_session_id?: Maybe<Scalars['String']>;
  stripe_url?: Maybe<Scalars['String']>;
};

export type CarpayCompany = {
  __typename?: 'CarpayCompany';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CarpayCreateTerminalNotificationResponse = {
  __typename?: 'CarpayCreateTerminalNotificationResponse';
  success: Scalars['Boolean'];
};

export type CarpayDeleteSubscriptionResponse = {
  __typename?: 'CarpayDeleteSubscriptionResponse';
  success: Scalars['Boolean'];
};

export type CarpayDiscountBatchCreateResponse = {
  __typename?: 'CarpayDiscountBatchCreateResponse';
  discount_batch: CarpayDiscountBatchResponse;
  location: Scalars['String'];
};

export type CarpayDiscountBatchResponse = {
  __typename?: 'CarpayDiscountBatchResponse';
  active: Scalars['Boolean'];
  batch_id: Scalars['Int'];
  carpay_discount_model_id: Scalars['Int'];
  count: Scalars['Int'];
  expiration_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  value?: Maybe<Scalars['jsonb']>;
};

export type CarpayDiscountBatchesInternalDashboardResponse = {
  __typename?: 'CarpayDiscountBatchesInternalDashboardResponse';
  discount_batches: Array<CarpayDiscountBatchResponse>;
};

export type CarpayDiscountModelResponse = {
  __typename?: 'CarpayDiscountModelResponse';
  active: Scalars['Boolean'];
  code_type: Scalars['String'];
  company_id?: Maybe<Scalars['String']>;
  extractor_variables?: Maybe<Scalars['jsonb']>;
  generatable: Scalars['Boolean'];
  id: Scalars['Int'];
  lot_id?: Maybe<Scalars['String']>;
  validator_variables?: Maybe<Scalars['jsonb']>;
  value?: Maybe<Scalars['jsonb']>;
};

export type CarpayDiscountModelsInternalDashboardResponse = {
  __typename?: 'CarpayDiscountModelsInternalDashboardResponse';
  discount_models: Array<CarpayDiscountModelResponse>;
};

export type CarpayEasyParkResponse = {
  __typename?: 'CarpayEasyParkResponse';
  area_country_code: Scalars['String'];
  area_no: Scalars['Int'];
  easypark_enabled: Scalars['Boolean'];
  lot_id: Scalars['String'];
  parking_operator_id: Scalars['Int'];
};

export type CarpayGetLotCompaniesResponse = {
  __typename?: 'CarpayGetLotCompaniesResponse';
  companies: Array<CarpayCompany>;
};

export type CarpayGetLotConfigurationResponse = {
  __typename?: 'CarpayGetLotConfigurationResponse';
  carpay_enabled: Scalars['Boolean'];
  easypark_enabled: Scalars['Boolean'];
  lot_id: Scalars['String'];
  service_provider: Array<ServiceProvider>;
  webapp_enabled: Scalars['Boolean'];
};

export type CarpayInvoiceGenerationOutput = {
  __typename?: 'CarpayInvoiceGenerationOutput';
  invoice_generated: Scalars['Boolean'];
  invoice_s3_key: Scalars['String'];
};

export type CarpayInvoiceOutput = {
  __typename?: 'CarpayInvoiceOutput';
  signed_url: Scalars['String'];
};

export type CarpayLegalStatusResult = {
  __typename?: 'CarpayLegalStatusResult';
  billable: Scalars['Boolean'];
  billable_end: Scalars['String'];
  billable_start: Scalars['String'];
  illegal_timeranges: Array<CarpayLegalStatusTimerange>;
  legal_timeranges: Array<CarpayLegalStatusTimerange>;
};

export type CarpayLegalStatusTimerange = {
  __typename?: 'CarpayLegalStatusTimerange';
  end: Scalars['String'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type CarpayLotActionCreateSchedulePayload = {
  carpay_enabled: Scalars['Boolean'];
  easypark_enabled: Scalars['Boolean'];
  lot_id: Scalars['String'];
  webapp_enabled: Scalars['Boolean'];
};

export type CarpayLotActionCreateScheduleResponse = {
  __typename?: 'CarpayLotActionCreateScheduleResponse';
  message: Scalars['String'];
};

export type CarpayLotActionGetScheduleResponse = {
  __typename?: 'CarpayLotActionGetScheduleResponse';
  creation_date: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  payload: Scalars['String'];
  schedule_at: Scalars['String'];
  state: Scalars['String'];
};

export type CarpayLotCreatePolicyRequest = {
  lot_settings_optional?: InputMaybe<CarpayLotPolicyLotSettingsRequest>;
  lot_tariffs?: InputMaybe<Array<Scalars['String']>>;
  lot_type: LotType;
  parking?: InputMaybe<CarpayLotPolicyParkingRequest>;
  service_provider?: InputMaybe<Array<CarpayLotPolicyServiceProviderRequest>>;
};

export type CarpayLotPolicyLotSettingsRequest = {
  incomplete_order_cleanup_delta_hours?: InputMaybe<Scalars['Int']>;
};

export type CarpayLotPolicyLotSettingsResponse = {
  __typename?: 'CarpayLotPolicyLotSettingsResponse';
  incomplete_order_cleanup_delta_hours?: Maybe<Scalars['Int']>;
};

export type CarpayLotPolicyParkingRequest = {
  min_arrival_detection_sec?: InputMaybe<Scalars['Int']>;
  min_duration_sec?: InputMaybe<Scalars['Int']>;
  min_visible_toleration_sec?: InputMaybe<Scalars['Int']>;
};

export type CarpayLotPolicyParkingResponse = {
  __typename?: 'CarpayLotPolicyParkingResponse';
  matching: Scalars['jsonb'];
  min_arrival_detection_sec?: Maybe<Scalars['Int']>;
  min_duration_sec: Scalars['Int'];
  min_visible_toleration_sec?: Maybe<Scalars['Int']>;
};

export type CarpayLotPolicyResponse = {
  __typename?: 'CarpayLotPolicyResponse';
  lot_settings_optional: CarpayLotPolicyLotSettingsResponse;
  lot_tariffs: Array<Scalars['String']>;
  lot_type: LotType;
  parking: CarpayLotPolicyParkingResponse;
  service_provider: Array<CarpayLotPolicyServiceProviderResponse>;
};

export type CarpayLotPolicyServiceProviderRequest = {
  name: Scalars['String'];
  settings: CarpayLotPolicyServiceProviderSettingsRequest;
};

export type CarpayLotPolicyServiceProviderResponse = {
  __typename?: 'CarpayLotPolicyServiceProviderResponse';
  name: Scalars['String'];
  settings: CarpayLotPolicyServiceProviderSettingsResponse;
};

export type CarpayLotPolicyServiceProviderSettingsRequest = {
  account_id: Scalars['String'];
};

export type CarpayLotPolicyServiceProviderSettingsResponse = {
  __typename?: 'CarpayLotPolicyServiceProviderSettingsResponse';
  account_id: Scalars['String'];
};

export type CarpayLotResponse = {
  __typename?: 'CarpayLotResponse';
  carpay_enabled: Scalars['Boolean'];
  easypark_enabled: Scalars['Boolean'];
  lot_id: Scalars['String'];
  policy: CarpayLotPolicyResponse;
  webapp_enabled: Scalars['Boolean'];
};

export type CarpayLotUpdatePolicyRequest = {
  lot_settings_optional?: InputMaybe<CarpayLotPolicyLotSettingsRequest>;
  lot_tariffs?: InputMaybe<Array<Scalars['String']>>;
  lot_type?: InputMaybe<LotType>;
  parking?: InputMaybe<CarpayLotPolicyParkingRequest>;
  service_provider?: InputMaybe<Array<CarpayLotPolicyServiceProviderRequest>>;
};

export type CarpayNotificationConfig = {
  __typename?: 'CarpayNotificationConfig';
  fill_level_thresholds: Array<Scalars['Float']>;
  lot_id: Scalars['String'];
  max_cash: Scalars['Int'];
};

export type CarpayOrderCancelResponse = {
  __typename?: 'CarpayOrderCancelResponse';
  order_id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CarpayPayByPhoneResponse = {
  __typename?: 'CarpayPayByPhoneResponse';
  lot_id: Scalars['String'];
  paybyphone_enabled: Scalars['Boolean'];
  paybyphone_lot_id: Scalars['String'];
};

export type CarpayRevenueByPaymentMethod = {
  __typename?: 'CarpayRevenueByPaymentMethod';
  clientRevenue?: Maybe<Scalars['Float']>;
  paymentMethod: Scalars['String'];
  totalRevenue?: Maybe<Scalars['Float']>;
};

export type CarpaySubscription = {
  __typename?: 'CarpaySubscription';
  category: CarpaySubscriptionCategories;
  email: Scalars['String'];
  lot_id: Scalars['String'];
};

export enum CarpaySubscriptionCategories {
  CashCut = 'CASH_CUT',
  CashFillLevel = 'CASH_FILL_LEVEL',
  PrinterStatus = 'PRINTER_STATUS'
}

export type CarpaySubscriptionResponse = {
  __typename?: 'CarpaySubscriptionResponse';
  subscriptions: Array<CarpaySubscription>;
};

export type CarpayTerminalConfig = {
  __typename?: 'CarpayTerminalConfig';
  discount_models?: Maybe<Array<CarpayTerminalFullDiscountModel>>;
  lot_id: Scalars['String'];
  pricing: CarpayTerminalPricing;
};

export type CarpayTerminalConfigResponse = {
  __typename?: 'CarpayTerminalConfigResponse';
  config: Array<CarpayTerminalConfig>;
};

export type CarpayTerminalDiscountBatch = {
  __typename?: 'CarpayTerminalDiscountBatch';
  batch_id: Scalars['Int'];
  count?: Maybe<Scalars['Int']>;
  expiration_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  value?: Maybe<Scalars['jsonb']>;
};

export type CarpayTerminalDiscountModel = {
  __typename?: 'CarpayTerminalDiscountModel';
  code_type: Scalars['String'];
  extractor?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  validator?: Maybe<Scalars['jsonb']>;
  value?: Maybe<Scalars['jsonb']>;
};

export type CarpayTerminalFullDiscountModel = {
  __typename?: 'CarpayTerminalFullDiscountModel';
  discount_batches: Array<CarpayTerminalDiscountBatch>;
  discount_model: CarpayTerminalDiscountModel;
};

export type CarpayTerminalLegalStatus = {
  __typename?: 'CarpayTerminalLegalStatus';
  illegal_timeranges: Array<CarpayLegalStatusTimerange>;
  legal_timeranges: Array<CarpayLegalStatusTimerange>;
};

export type CarpayTerminalOrderResult = {
  __typename?: 'CarpayTerminalOrderResult';
  carpay_scanned_codes: Array<CarpayTerminalScannedCodeResult>;
  country: Scalars['String'];
  drive_in_timestamp?: Maybe<Scalars['String']>;
  drive_out_timestamp?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  lot_id: Scalars['String'];
  order_id: Scalars['String'];
  plate: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  price_valid_until?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  status: Scalars['String'];
  whitelist_id?: Maybe<Scalars['Int']>;
};

export type CarpayTerminalOrderResultV2 = {
  __typename?: 'CarpayTerminalOrderResultV2';
  carpay_scanned_codes: Array<CarpayTerminalScannedCodeResultV2>;
  country: Scalars['String'];
  drive_in_timestamp?: Maybe<Scalars['String']>;
  drive_out_timestamp?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  legal_status?: Maybe<CarpayTerminalLegalStatus>;
  lot_id: Scalars['String'];
  order_id: Scalars['String'];
  payment: CarpayTerminalPaymentResultV2;
  plate: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  price_valid_until?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  status: Scalars['String'];
  whitelist_id?: Maybe<Scalars['Int']>;
};

export type CarpayTerminalPaymentResultV2 = {
  __typename?: 'CarpayTerminalPaymentResultV2';
  paid_amount?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

export type CarpayTerminalPricing = {
  __typename?: 'CarpayTerminalPricing';
  context?: Maybe<Scalars['String']>;
  pricing_model: Scalars['jsonb'];
  timezone: Scalars['String'];
};

export type CarpayTerminalScannedCodeResult = {
  __typename?: 'CarpayTerminalScannedCodeResult';
  carpay_discount_model_id: Scalars['Int'];
  code: Scalars['String'];
  extractor_result: Scalars['jsonb'];
  order_id: Scalars['String'];
  validated: Scalars['Boolean'];
  value: Scalars['Float'];
};

export type CarpayTerminalScannedCodeResultV2 = {
  __typename?: 'CarpayTerminalScannedCodeResultV2';
  carpay_discount_batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id: Scalars['Int'];
  code: Scalars['String'];
  extractor_result: Scalars['jsonb'];
  order_id: Scalars['String'];
  original_value?: Maybe<Scalars['jsonb']>;
  value: Scalars['Float'];
};

export type CarpayUpdateServiceProviderResponse = {
  __typename?: 'CarpayUpdateServiceProviderResponse';
  success: Scalars['Boolean'];
};

export type ChangeLicensePlateData = {
  plate: Scalars['String'];
};

export type ChangeLicensePlateOutput = {
  __typename?: 'ChangeLicensePlateOutput';
  affected_row: Scalars['String'];
};

export type ChangeTransactionStatusOutput = {
  __typename?: 'ChangeTransactionStatusOutput';
  message?: Maybe<Scalars['String']>;
};

export type CleanCompanyDataOutput = {
  __typename?: 'CleanCompanyDataOutput';
  message: Scalars['String'];
};

export type CleanPersonDataOutput = {
  __typename?: 'CleanPersonDataOutput';
  message: Scalars['String'];
};

export type CompanyAddressesPreprocessingOutput = {
  __typename?: 'CompanyAddressesPreprocessingOutput';
  message: Scalars['String'];
};

export type CreateBookingUserRequest = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password: Scalars['String'];
};

export type CreateBookingUserResponse = {
  __typename?: 'CreateBookingUserResponse';
  success: Scalars['Boolean'];
};

export type CreateDatenhausRequestOutput = {
  __typename?: 'CreateDatenhausRequestOutput';
  message?: Maybe<Scalars['json']>;
};

export type CreateDriverInformationRequestOutput = {
  __typename?: 'CreateDriverInformationRequestOutput';
  message: Scalars['String'];
};

export type CreateErrorRatePredictionRequestOutput = {
  __typename?: 'CreateErrorRatePredictionRequestOutput';
  message: Scalars['String'];
  request_entry_id: Scalars['String'];
};

export type CreateLotAnalysisRequestOutput = {
  __typename?: 'CreateLotAnalysisRequestOutput';
  message: Scalars['String'];
  request_entry_id: Scalars['String'];
};

export type CreateOwnerInformationRequestOutput = {
  __typename?: 'CreateOwnerInformationRequestOutput';
  message: Scalars['String'];
};

export type CreateParkingResultOutput = {
  __typename?: 'CreateParkingResultOutput';
  message?: Maybe<Scalars['json']>;
};

export type CreateReimbursementOutput = {
  __typename?: 'CreateReimbursementOutput';
  message: Scalars['String'];
};

export type CreateUserLicensePlateRequest = {
  country: Scalars['String'];
  plate: Scalars['String'];
};

export type CreateUserLicensePlateResponse = {
  __typename?: 'CreateUserLicensePlateResponse';
  id: Scalars['uuid'];
};

export type CreateUserVehicleRequest = {
  manufacturer: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  plate_id: Scalars['uuid'];
  vehicle_type: Scalars['String'];
};

export type CreateUserVehicleResponse = {
  __typename?: 'CreateUserVehicleResponse';
  id: Scalars['uuid'];
};

export type CustomerPreflightResponse = {
  __typename?: 'CustomerPreflightResponse';
  preflight_response: Scalars['String'];
};

export type DailyCarpayRevenue = {
  __typename?: 'DailyCarpayRevenue';
  day: Scalars['String'];
  revenue?: Maybe<Array<CarpayRevenueByPaymentMethod>>;
};

export type DailyElectricAggregateEntry = {
  __typename?: 'DailyElectricAggregateEntry';
  day: Scalars['String'];
  electric: Scalars['Boolean'];
  num_electric: Scalars['Int'];
  parking_lot: Scalars['String'];
};

export type DailyOccupancyEntry = {
  __typename?: 'DailyOccupancyEntry';
  avg_occupancy?: Maybe<Scalars['Float']>;
  day: Scalars['String'];
  lot_id: Scalars['String'];
  max_occupancy?: Maybe<Scalars['Float']>;
};

export type DecryptImageOutput = {
  __typename?: 'DecryptImageOutput';
  images: Scalars['String'];
};

export type DeleteBlacklistEntriesResponse = {
  __typename?: 'DeleteBlacklistEntriesResponse';
  affectedRows: Scalars['Int'];
};

export type DeleteBlacklistEntry = {
  country: Scalars['String'];
  plate: Scalars['String'];
};

export type DeleteDiscountBatchResponse = {
  __typename?: 'DeleteDiscountBatchResponse';
  id: Scalars['Int'];
};

export type DeleteDiscountModelResponse = {
  __typename?: 'DeleteDiscountModelResponse';
  id: Scalars['Int'];
};

export type DeleteNotificationConfigResponse = {
  __typename?: 'DeleteNotificationConfigResponse';
  success: Scalars['Boolean'];
};

export type DeleteUserLicensePlateRequest = {
  id: Scalars['uuid'];
};

export type DeleteUserLicensePlateResponse = {
  __typename?: 'DeleteUserLicensePlateResponse';
  success: Scalars['Boolean'];
};

export type DeleteUserVehicleRequest = {
  plate_id: Scalars['uuid'];
  vehicle_id: Scalars['uuid'];
};

export type DeleteUserVehicleResponse = {
  __typename?: 'DeleteUserVehicleResponse';
  success: Scalars['Boolean'];
};

export type DeleteWhitelistEntriesResponse = {
  __typename?: 'DeleteWhitelistEntriesResponse';
  affectedRows: Scalars['Int'];
};

export type DeleteWhitelistEntry = {
  country: Scalars['String'];
  plate: Scalars['String'];
};

export type Description = {
  __typename?: 'Description';
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  pl?: Maybe<Scalars['String']>;
};

export type DeviceByConfig = {
  __typename?: 'DeviceByConfig';
  device_name: Scalars['String'];
  device_uuid: Scalars['String'];
  general_config: Scalars['json'];
};

export type DevicesByConfigOutput = {
  __typename?: 'DevicesByConfigOutput';
  matching_devices: Array<DeviceByConfig>;
  non_matching_devices: Array<DeviceByConfig>;
};

export enum DiscountType {
  ScannedCode = 'scanned_code',
  StringInput = 'string_input',
  Universal = 'universal'
}

export type DownloadLettersOutput = {
  __typename?: 'DownloadLettersOutput';
  presigned_urls?: Maybe<Array<Scalars['String']>>;
};

export type DownloadLettersWhereFields = {
  letter_type: Scalars['String'];
};

export type ElectricAggregateByDayResponse = {
  __typename?: 'ElectricAggregateByDayResponse';
  electric_aggregate_by_day?: Maybe<Array<DailyElectricAggregateEntry>>;
};

export type EnrichedLotLegalEntity = {
  __typename?: 'EnrichedLotLegalEntity';
  address: Scalars['String'];
  company_id: Scalars['String'];
  lot_id: Scalars['String'];
  name: Scalars['String'];
  product: Scalars['String'];
  vat_id: Scalars['String'];
};

export type ExportedWhitelistEntry = {
  __typename?: 'ExportedWhitelistEntry';
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lot_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type FetchLetterUrlWhereFields = {
  mail_id: Scalars['bigint'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type FloatComparisonExp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export type GenerateLetterOutput = {
  __typename?: 'GenerateLetterOutput';
  affected_rows: Scalars['Int'];
  mail_id: Scalars['bigint'];
};

export type GenerateSpecLetterOutput = {
  __typename?: 'GenerateSpecLetterOutput';
  message?: Maybe<Scalars['String']>;
};

export type GenerateViolationCaseResult = {
  __typename?: 'GenerateViolationCaseResult';
  message?: Maybe<Scalars['String']>;
};

export type GeneratedGuestJwt = {
  __typename?: 'GeneratedGuestJWT';
  token: Scalars['String'];
};

export type GetAtCarOwnerRequestsResponseOutput = {
  __typename?: 'GetATCarOwnerRequestsResponseOutput';
  message: Scalars['String'];
};

export type GetDriverInformationResponseOutput = {
  __typename?: 'GetDriverInformationResponseOutput';
  message: Scalars['String'];
};

export type GetEnvParameterEndpointOutput = {
  __typename?: 'GetEnvParameterEndpointOutput';
  parameter_contents: Scalars['String'];
};

export type GetHierarchyOutput = {
  __typename?: 'GetHierarchyOutput';
  company_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  lot_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetKbaResponseOutput = {
  __typename?: 'GetKbaResponseOutput';
  message: Scalars['String'];
};

export type GetMetabaseDashboardUrlOutput = {
  __typename?: 'GetMetabaseDashboardUrlOutput';
  metabase_url: Scalars['String'];
};

export type GetNewViolationCasesFileOutput = {
  __typename?: 'GetNewViolationCasesFileOutput';
  message: Scalars['String'];
};

export type GetPaidParkingClaimsOutput = {
  __typename?: 'GetPaidParkingClaimsOutput';
  paid_claims?: Maybe<Array<Maybe<Scalars['String']>>>;
  unpaid_amount?: Maybe<Scalars['float8']>;
};

export type GetPaidParkingClaimsV2Input = {
  illegal_end_timestamp: Scalars['timestamptz'];
  illegal_start_timestamp: Scalars['timestamptz'];
  parking_event_uuid: Scalars['String'];
};

export type GetPaidParkingClaimsV2Output = {
  __typename?: 'GetPaidParkingClaimsV2Output';
  paid_claims?: Maybe<Array<Maybe<GetPaidParkingClaimsV2PaidClaim>>>;
  parking_event_uuid: Scalars['String'];
  unpaid_claim: GetPaidParkingClaimsV2UnpaidClaim;
};

export type GetPaidParkingClaimsV2PaidClaim = {
  __typename?: 'GetPaidParkingClaimsV2PaidClaim';
  end_date: Scalars['timestamptz'];
  paid_claim?: Maybe<Scalars['float8']>;
  start_date: Scalars['timestamptz'];
};

export type GetPaidParkingClaimsV2UnpaidClaim = {
  __typename?: 'GetPaidParkingClaimsV2UnpaidClaim';
  end_date: Scalars['timestamptz'];
  start_date: Scalars['timestamptz'];
  unpaid_amount?: Maybe<Scalars['float8']>;
};

export type GetPlateEventsOutput = {
  __typename?: 'GetPlateEventsOutput';
  events?: Maybe<Scalars['json']>;
};

export type GetPotentialMlPsOutput = {
  __typename?: 'GetPotentialMLPsOutput';
  latest_timestamp?: Maybe<Scalars['timestamptz']>;
  potential_mlps: Array<Maybe<Scalars['jsonb']>>;
};

export type GetQrFlyerBatchResponse = {
  __typename?: 'GetQRFlyerBatchResponse';
  qr_batch_url: Scalars['String'];
};

export type GetQueueLengthOutput = {
  __typename?: 'GetQueueLengthOutput';
  queue_length: Scalars['Int'];
};

export type GetSpecialLetterOutput = {
  __typename?: 'GetSpecialLetterOutput';
  dataUrl?: Maybe<Scalars['String']>;
};

export type GetSpecialLetterPreviewResponse = {
  __typename?: 'GetSpecialLetterPreviewResponse';
  dataUrl?: Maybe<Scalars['String']>;
};

export type GetSpecialLetterTemplatesResponse = {
  __typename?: 'GetSpecialLetterTemplatesResponse';
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  templates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetTemplateOutput = {
  __typename?: 'GetTemplateOutput';
  template?: Maybe<Scalars['String']>;
};

export type GetUserInvoiceUrlResponse = {
  __typename?: 'GetUserInvoiceUrlResponse';
  signed_url: Scalars['String'];
};

export type GetViolationInfoOutput = {
  __typename?: 'GetViolationInfoOutput';
  already_paid?: Maybe<Scalars['Int']>;
  blurred_image_in?: Maybe<Scalars['String']>;
  blurred_image_out?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  lot_address?: Maybe<Scalars['String']>;
  offender?: Maybe<Scalars['json']>;
  payment_due_date?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['json']>;
  reminder_charges?: Maybe<Scalars['Int']>;
  stage_reached?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

export type GoLiveDates = {
  __typename?: 'GoLiveDates';
  booking_go_live?: Maybe<Scalars['String']>;
  carpay_go_live?: Maybe<Scalars['String']>;
  supervision_go_live?: Maybe<Scalars['String']>;
};

export type GroupedVisitsByDay = {
  __typename?: 'GroupedVisitsByDay';
  averageDuration: Scalars['Int'];
  category: Scalars['String'];
  eventCount: Scalars['Float'];
};

export type GroupedVisitsByWeekday = {
  __typename?: 'GroupedVisitsByWeekday';
  visits?: Maybe<Array<GroupedWeekdayVisitsByHour>>;
  weekday: Scalars['Int'];
};

export type GroupedWeekdayVisitsByHour = {
  __typename?: 'GroupedWeekdayVisitsByHour';
  category: Scalars['String'];
  eventCount: Scalars['Int'];
  hour: Scalars['String'];
};

export type HourlyOccupancyEntry = {
  __typename?: 'HourlyOccupancyEntry';
  avg_occupancy?: Maybe<Scalars['Float']>;
  hour: Scalars['Int'];
  weekday: Scalars['Int'];
};

export type InputBookingPlate = {
  plate: Scalars['String'];
};

export type InsertBlacklistInput = {
  comment?: InputMaybe<Scalars['String']>;
  company_id: Scalars['String'];
  country: Scalars['String'];
  lot_id: Scalars['String'];
  plate: Scalars['String'];
};

export type InsertBlacklistResponse = {
  __typename?: 'InsertBlacklistResponse';
  affectedRows: Scalars['Int'];
};

export type InsertLpGroupMember = {
  country: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
};

export type InsertSingleCarOwnerInformationOutput = {
  __typename?: 'InsertSingleCarOwnerInformationOutput';
  message: Scalars['String'];
};

export type InsertUserData = {
  contact_email?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  own_company: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type InsertWhitelistInput = {
  company_id: Scalars['String'];
  country: Scalars['String'];
  end_date?: InputMaybe<Scalars['timestamptz']>;
  lot_id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

export type InsertWhitelistResponse = {
  __typename?: 'InsertWhitelistResponse';
  affectedRows: Scalars['Int'];
  allowedLotIds: Array<Scalars['String']>;
  limitedLotIds: Array<Scalars['String']>;
  notAllowedLotIds: Array<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type IsInternalUserOutput = {
  __typename?: 'IsInternalUserOutput';
  is_internal_user: Scalars['Boolean'];
};

export type LpGroupCreationResponse = {
  __typename?: 'LPGroupCreationResponse';
  inserted_entries: Scalars['Int'];
};

export type LpGroupDeletionResponse = {
  __typename?: 'LPGroupDeletionResponse';
  deleted_lp_group_members?: Maybe<Array<Scalars['Int']>>;
  deleted_lp_groups?: Maybe<Array<Scalars['Int']>>;
};

export type LpGroupEntry = {
  __typename?: 'LPGroupEntry';
  company_id: Scalars['String'];
  lp_group_id: Scalars['bigint'];
  lp_group_members?: Maybe<Array<LicensePlateGroupMember>>;
  parking_permits: LpGroupPermitConfig;
};

export type LpGroupUpdateResponse = {
  __typename?: 'LPGroupUpdateResponse';
  updated_entries: Scalars['Int'];
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  address: Scalars['String'];
  company_id: Scalars['String'];
  name: Scalars['String'];
  vat_id: Scalars['String'];
};

export type LetterGeneratedCount = {
  __typename?: 'LetterGeneratedCount';
  count: Scalars['Int'];
};

export type LetterUrl = {
  __typename?: 'LetterUrl';
  presigned_url: Scalars['String'];
};

export type LicenseOrderInternalDashboardResponse = {
  __typename?: 'LicenseOrderInternalDashboardResponse';
  order_id: Scalars['String'];
  success: Scalars['Boolean'];
  whitelist_paid_parking_id?: Maybe<Scalars['Int']>;
};

export type LicensePlateGroupFilter = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  search_text?: InputMaybe<Scalars['String']>;
  user_groups?: InputMaybe<Array<Scalars['String']>>;
};

export type LicensePlateGroupMember = {
  __typename?: 'LicensePlateGroupMember';
  country?: Maybe<Scalars['String']>;
  member_id: Scalars['bigint'];
  owner?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

export type LicensePlateGroupPermitConfig = {
  contingent?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  rrule_duration?: InputMaybe<Scalars['String']>;
  rrule_string?: InputMaybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
  user_group: Scalars['String'];
};

export type LinkTransactionOutput = {
  __typename?: 'LinkTransactionOutput';
  message?: Maybe<Scalars['String']>;
};

export type LotImageUploadUrlRequest = {
  image_type: Scalars['String'];
  lot_id: Scalars['String'];
};

export type LotImageUploadUrlResponse = {
  __typename?: 'LotImageUploadUrlResponse';
  fields: Scalars['json'];
  url: Scalars['String'];
};

export type LotTariffPrices = {
  __typename?: 'LotTariffPrices';
  duration: Scalars['String'];
  price: Scalars['Int'];
};

export enum LotType {
  Hybrid = 'HYBRID',
  Postpaid = 'POSTPAID',
  Prepaid = 'PREPAID'
}

export type LpGroupPermitConfig = {
  __typename?: 'LpGroupPermitConfig';
  contingent?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  lot_ids?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  next_contingent?: Maybe<Scalars['Int']>;
  rrule_duration?: Maybe<Scalars['String']>;
  rrule_string?: Maybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
  user_group: Scalars['String'];
};

export type MergeCasesByLanguagesResponse = {
  __typename?: 'MergeCasesByLanguagesResponse';
  languages_to_cases?: Maybe<Scalars['jsonb']>;
};

export type MergeLettersOutput = {
  __typename?: 'MergeLettersOutput';
  presigned_url: Scalars['String'];
};

export type MoveUserToNewCompanyResponse = {
  __typename?: 'MoveUserToNewCompanyResponse';
  message: Scalars['String'];
};

export type NewCompanyViolator = {
  city: Scalars['String'];
  company_name: Scalars['String'];
  country: Scalars['String'];
  data_source: Scalars['String'];
  house_number: Scalars['String'];
  postal_code: Scalars['String'];
  street: Scalars['String'];
};

export type NewPerson = {
  city: Scalars['String'];
  country: Scalars['String'];
  data_source: Scalars['String'];
  first_name: Scalars['String'];
  gender: Scalars['String'];
  house_number: Scalars['String'];
  last_name: Scalars['String'];
  postal_code: Scalars['String'];
  street: Scalars['String'];
};

export type NewTransactionsInput = {
  amount: Scalars['Float'];
  payment_reference: Scalars['String'];
};

export type NewViolationCase = {
  already_paid: Scalars['Float'];
  cancellation_date?: InputMaybe<Scalars['String']>;
  cancellation_issuer?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  case_id: Scalars['String'];
  debt_collection_date?: InputMaybe<Scalars['String']>;
  driver_id?: InputMaybe<Scalars['bigint']>;
  duration_min: Scalars['bigint'];
  fee: Scalars['Float'];
  note?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  parking_lot: Scalars['String'];
  parking_results_id: Scalars['String'];
  payment_date?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
  plate_country: Scalars['String'];
  policy: Scalars['jsonb'];
  reason_info?: InputMaybe<Scalars['jsonb']>;
  reminder_charges?: InputMaybe<Scalars['Float']>;
  stage_id?: InputMaybe<Scalars['bigint']>;
  status: Scalars['String'];
  timestamp_in: Scalars['String'];
  timestamp_out: Scalars['String'];
  transferred_from: Scalars['bigint'];
  violated_rule: Scalars['jsonb'];
};

export type NightParkingConfig = {
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};

export type NightParkingData = {
  __typename?: 'NightParkingData';
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};

export type OccupancyByDayResponse = {
  __typename?: 'OccupancyByDayResponse';
  occupancy_by_day?: Maybe<Array<DailyOccupancyEntry>>;
};

export type OldViolationCaseChanges = {
  cancellation_date?: InputMaybe<Scalars['String']>;
  cancellation_issuer?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  opening_hours_rrules?: Maybe<Array<Maybe<OpeningHoursRrules>>>;
};

export type OpeningHoursRrules = {
  __typename?: 'OpeningHoursRrules';
  duration?: Maybe<Scalars['String']>;
  rrule?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  applied_discount: Scalars['Float'];
  applied_discount_codes: Array<Scalars['String']>;
  arrival_detection_time?: Maybe<Scalars['Int']>;
  billable: Scalars['Boolean'];
  billable_end: Scalars['String'];
  billable_start: Scalars['String'];
  currency: Scalars['String'];
  discount_types: Array<DiscountType>;
  end_date?: Maybe<Scalars['String']>;
  full_price: Scalars['Float'];
  lot_address: Scalars['String'];
  lot_id: Scalars['String'];
  lot_name: Scalars['String'];
  lot_tariffs: Array<Scalars['String']>;
  lot_type: LotType;
  order_id: Scalars['String'];
  order_status: Scalars['String'];
  parking_contexts: Array<OrderParkingContext>;
  plate: Scalars['String'];
  price: Scalars['Float'];
  price_valid_until: Scalars['String'];
  start_date: Scalars['String'];
  sv_lot_type: SvLotType;
  vat_rate: Scalars['Float'];
  visible_toleration_time?: Maybe<Scalars['Int']>;
};

export type OrderParkingContext = {
  __typename?: 'OrderParkingContext';
  uuid: Scalars['String'];
  vehicle_type?: Maybe<Scalars['String']>;
};

export type OveruseContingent = {
  __typename?: 'OveruseContingent';
  contingent: Scalars['Int'];
  contingent_id: Scalars['bigint'];
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
};

export type OveruseEvent = {
  __typename?: 'OveruseEvent';
  leader: OveruseMember;
  members?: Maybe<Array<OveruseMember>>;
  overuse_end: Scalars['timestamptz'];
  overuse_price?: Maybe<Scalars['bigint']>;
  overuse_start: Scalars['timestamptz'];
};

export type OveruseEventByDay = {
  __typename?: 'OveruseEventByDay';
  overuse_group_id: Scalars['Int'];
  overuse_group_name: Scalars['String'];
  overuse_min: Scalars['Float'];
  overused_slots: Scalars['Int'];
};

export type OveruseGroupPermit = {
  __typename?: 'OveruseGroupPermit';
  contingents: Array<Maybe<OveruseContingent>>;
  end_date?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  rrule_duration?: Maybe<Scalars['String']>;
  rrule_string?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

export type OveruseGroupReport = {
  __typename?: 'OveruseGroupReport';
  overuse_duration: Scalars['String'];
  overuse_event_count: Scalars['Int'];
  overuse_group_id: Scalars['Int'];
  overuse_group_name: Scalars['String'];
  overuse_price?: Maybe<Scalars['bigint']>;
};

export type OveruseMember = {
  __typename?: 'OveruseMember';
  country: Scalars['String'];
  member_id: Scalars['bigint'];
  member_name: Scalars['String'];
  plate: Scalars['String'];
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
};

export type OveruseReportByDay = {
  __typename?: 'OveruseReportByDay';
  day: Scalars['timestamptz'];
  overuse_events?: Maybe<Array<OveruseEventByDay>>;
};

export type OveruseReportByGroup = {
  __typename?: 'OveruseReportByGroup';
  group_permit: OveruseGroupPermit;
  overuse_events?: Maybe<Array<OveruseEvent>>;
};

export type ParkingDistributionByInterval = {
  __typename?: 'ParkingDistributionByInterval';
  interval_end: Scalars['Int'];
  interval_start: Scalars['Int'];
  visits?: Maybe<Array<BucketedVisitsByCategory>>;
};

export type ParkingPaymentsByInterval = {
  __typename?: 'ParkingPaymentsByInterval';
  interval_end: Scalars['Int'];
  interval_start: Scalars['Int'];
  payments?: Maybe<Array<ParkingPaymentsByMethod>>;
};

export type ParkingPaymentsByMethod = {
  __typename?: 'ParkingPaymentsByMethod';
  eventCount: Scalars['Int'];
  paymentMethod: Scalars['String'];
};

export type ParkingVisitsByDay = {
  __typename?: 'ParkingVisitsByDay';
  day: Scalars['String'];
  visits?: Maybe<Array<GroupedVisitsByDay>>;
};

export type ParseTransactionsOutput = {
  __typename?: 'ParseTransactionsOutput';
  matches: Array<Maybe<Scalars['json']>>;
  outliers: Array<Maybe<Scalars['bigint']>>;
};

export type PrivatePricingLot = {
  __typename?: 'PrivatePricingLot';
  lot_id?: Maybe<Scalars['String']>;
  pricing_type?: Maybe<BookingPricingModelType>;
};

export type ProvideNpsFeedbackResponse = {
  __typename?: 'ProvideNPSFeedbackResponse';
  message: Scalars['String'];
};

export type PurgeQueueOutput = {
  __typename?: 'PurgeQueueOutput';
  msg?: Maybe<Scalars['String']>;
};

export type PushCheckedMlPsOutput = {
  __typename?: 'PushCheckedMLPsOutput';
  message: Scalars['String'];
};

export type RemoveUserFromPpmRequest = {
  ppm_id: Scalars['Int'];
  user: Scalars['String'];
};

export type RemoveUserFromPpmResponse = {
  __typename?: 'RemoveUserFromPpmResponse';
  success: Scalars['Boolean'];
};

export type ReplaceWhitelistInput = {
  company_id: Scalars['String'];
  country: Scalars['String'];
  end_date?: InputMaybe<Scalars['timestamptz']>;
  lot_id: Scalars['String'];
  max_duration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

export type ReplaceWhitelistResponse = {
  __typename?: 'ReplaceWhitelistResponse';
  delete_whitelist: Scalars['jsonb'];
  delete_whitelist_subscription: Scalars['jsonb'];
  insert_whitelist: Scalars['jsonb'];
};

export type RevenueData = {
  __typename?: 'RevenueData';
  total_revenue: Scalars['jsonb'];
  transaction_costs: Scalars['jsonb'];
};

export type RevertParkingResultConfirmationOutput = {
  __typename?: 'RevertParkingResultConfirmationOutput';
  message: Scalars['String'];
};

export type SmsCommandOutput = {
  __typename?: 'SMSCommandOutput';
  message: Scalars['String'];
};

export type SmsStatusOutput = {
  __typename?: 'SMSStatusOutput';
  content: Scalars['String'];
  date: Scalars['timestamptz'];
  delivery_status: Scalars['String'];
};

export type SendCarOwnerRequestsAustriaOutput = {
  __typename?: 'SendCarOwnerRequestsAustriaOutput';
  message: Scalars['String'];
};

export type SendCarOwnerRequestsGermanyOutput = {
  __typename?: 'SendCarOwnerRequestsGermanyOutput';
  message: Scalars['String'];
};

export type SendExtendedKbaRequestEmailOutput = {
  __typename?: 'SendExtendedKbaRequestEmailOutput';
  message?: Maybe<Scalars['json']>;
};

export type SendInvoiceOutput = {
  __typename?: 'SendInvoiceOutput';
  sent: Scalars['Boolean'];
};

export type SendSpecialLettersToSftpOutput = {
  __typename?: 'SendSpecialLettersToSftpOutput';
  message: Scalars['String'];
};

export type SendToQueueOutput = {
  __typename?: 'SendToQueueOutput';
  msg?: Maybe<Scalars['String']>;
};

export type ServiceProvider = {
  __typename?: 'ServiceProvider';
  name: Scalars['String'];
  settings?: Maybe<ServiceProviderSettings>;
};

export type ServiceProviderInput = {
  name: Scalars['String'];
  settings?: InputMaybe<ServiceProviderSettingsInput>;
};

export type ServiceProviderSettings = {
  __typename?: 'ServiceProviderSettings';
  account_id: Scalars['String'];
};

export type ServiceProviderSettingsInput = {
  account_id: Scalars['String'];
};

export type SplitTransactionOutput = {
  __typename?: 'SplitTransactionOutput';
  message?: Maybe<Scalars['String']>;
  new_transaction_ids: Array<Scalars['bigint']>;
};

export type StartGenerationOfSpecialLettersOutput = {
  __typename?: 'StartGenerationOfSpecialLettersOutput';
  message: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export enum SvLotType {
  CarPark = 'car_park',
  Other = 'other',
  TollRoad = 'toll_road'
}

export type SystemImageOutput = {
  __typename?: 'SystemImageOutput';
  signed_url: Scalars['String'];
  timestamp: Scalars['String'];
};

export type TerminalConfirmOrderResult = {
  __typename?: 'TerminalConfirmOrderResult';
  message: Scalars['String'];
};

export enum TerminalNotificationEventType {
  CashCut = 'CASH_CUT',
  CashFillLevel = 'CASH_FILL_LEVEL',
  PrinterStatus = 'PRINTER_STATUS'
}

export type TerminalPayment = {
  details: Scalars['jsonb'];
  method: Scalars['String'];
  timestamp: Scalars['String'];
};

export type TerminalScannedCode = {
  carpay_discount_model_id: Scalars['Int'];
  code: Scalars['String'];
  extractor_result: Scalars['jsonb'];
  validated: Scalars['Boolean'];
  value: Scalars['Float'];
};

export type TerminalScannedCodeV2 = {
  carpay_discount_batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id: Scalars['Int'];
  code: Scalars['String'];
  extractor_result: Scalars['jsonb'];
  original_value: Scalars['jsonb'];
  value: Scalars['Float'];
};

export type TopCityCodesByDayEntry = {
  __typename?: 'TopCityCodesByDayEntry';
  percentage: Scalars['Float'];
  plate_city_code: Scalars['String'];
  plate_country_code: Scalars['String'];
};

export type TopCityCodesByDayResponse = {
  __typename?: 'TopCityCodesByDayResponse';
  top_city_codes?: Maybe<Array<TopCityCodesByDayEntry>>;
};

export enum TransactionCostsChargeType {
  ActualFee = 'actual_fee',
  InternalFee = 'internal_fee'
}

export type TransferViolationCaseOutput = {
  __typename?: 'TransferViolationCaseOutput';
  message: Scalars['String'];
  new_violation_case_id?: Maybe<Scalars['bigint']>;
};

export type UnlinkTransactionOutput = {
  __typename?: 'UnlinkTransactionOutput';
  message: Scalars['String'];
};

export type UpdateAndPushMlpCasesOutput = {
  __typename?: 'UpdateAndPushMLPCasesOutput';
  message: Scalars['String'];
};

export type UpdateBookingUserRequest = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type UpdateBookingUserResponse = {
  __typename?: 'UpdateBookingUserResponse';
  success: Scalars['Boolean'];
};

export type UpdateDeviceOutput = {
  __typename?: 'UpdateDeviceOutput';
  message: Scalars['String'];
};

export type UpdateLicensePlateGroupMember = {
  country?: InputMaybe<Scalars['String']>;
  member_id?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

export type UpdateLicensePlateGroupPermitConfig = {
  contingent?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  rrule_duration?: InputMaybe<Scalars['String']>;
  rrule_string?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  user_group?: InputMaybe<Scalars['String']>;
};

export type UpdateStationOutput = {
  __typename?: 'UpdateStationOutput';
  message: Scalars['String'];
};

export type UpdateUserData = {
  custom_reason?: InputMaybe<Scalars['json']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  own_company: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateUserLicensePlateRequest = {
  country: Scalars['String'];
  id: Scalars['uuid'];
  plate: Scalars['String'];
};

export type UpdateUserLicensePlateResponse = {
  __typename?: 'UpdateUserLicensePlateResponse';
  success: Scalars['Boolean'];
};

export type UpdateUserVehicleRequest = {
  id: Scalars['uuid'];
  manufacturer: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  vehicle_type: Scalars['String'];
};

export type UpdateUserVehicleResponse = {
  __typename?: 'UpdateUserVehicleResponse';
  success: Scalars['Boolean'];
};

export type UpdateViolationTransactionOutput = {
  __typename?: 'UpdateViolationTransactionOutput';
  returning: Array<Maybe<Scalars['json']>>;
};

export type UpdateViolatorImageData = {
  lot: Scalars['String'];
  plate: Scalars['String'];
  station: Scalars['Int'];
  timestamp: Scalars['timestamp'];
  type: Scalars['String'];
};

export type UpdateViolatorImageOutput = {
  __typename?: 'UpdateViolatorImageOutput';
  message: Scalars['String'];
};

export type UploadUsersToPpmRequest = {
  ppm_id: Scalars['Int'];
  ppm_type: BookingPricingModelType;
  users: Array<InputMaybe<Scalars['String']>>;
};

export type UploadUsersToPpmResponse = {
  __typename?: 'UploadUsersToPPMResponse';
  failed_to_upload_users?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type UploadViolatorImageOutput = {
  __typename?: 'UploadViolatorImageOutput';
  image_key: Scalars['String'];
};

export type UserBookingResponse = {
  __typename?: 'UserBookingResponse';
  booking_ref: Scalars['String'];
  booking_type: BookingType;
  created_at_iso_str: Scalars['String'];
  email: Scalars['String'];
  end_date: Scalars['String'];
  invoices?: Maybe<Array<BookingInvoice>>;
  lot_address: Scalars['String'];
  lot_id: Scalars['String'];
  lot_name: Scalars['String'];
  night_parking_data?: Maybe<NightParkingData>;
  payment_method: Scalars['String'];
  plates?: Maybe<Array<BookingPlate>>;
  price: Scalars['Float'];
  start_date: Scalars['String'];
};

export type UserData = {
  __typename?: 'UserData';
  admin_lots?: Maybe<Array<Maybe<Scalars['String']>>>;
  all_company_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  allow_analytics?: Maybe<Scalars['json']>;
  allow_cancellation?: Maybe<Scalars['json']>;
  allow_rental?: Maybe<Scalars['json']>;
  allow_user_management?: Maybe<Scalars['Boolean']>;
  allow_whitelist?: Maybe<Scalars['json']>;
  company?: Maybe<Company>;
  created_at?: Maybe<Scalars['String']>;
  custom_reason?: Maybe<Scalars['json']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['String']>;
  logins_count?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  own_company?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_lots?: Maybe<Array<Maybe<Scalars['String']>>>;
  video_modal?: Maybe<Scalars['json']>;
  video_permanent?: Maybe<Scalars['json']>;
};

export type UserDeletionResponse = {
  __typename?: 'UserDeletionResponse';
  deleted_bl_entries: Scalars['Int'];
  deleted_nps_feedback: Scalars['Int'];
  deleted_user?: Maybe<Scalars['String']>;
  deleted_wl_entries: Scalars['Int'];
  deleted_wl_subscriptions: Scalars['Int'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  license_plates?: Maybe<Array<Maybe<BookingUserLicensePlate>>>;
  private_pricing_lots?: Maybe<Array<Maybe<PrivatePricingLot>>>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
};

export type UserSubscriptionResponse = {
  __typename?: 'UserSubscriptionResponse';
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lot_address?: Maybe<Scalars['String']>;
  lot_id: Scalars['String'];
  lot_name?: Maybe<Scalars['String']>;
  plates?: Maybe<Array<Maybe<Scalars['String']>>>;
  start_date: Scalars['String'];
  subscription_bookings?: Maybe<Array<Maybe<UserBookingResponse>>>;
  subscription_price: Scalars['Float'];
  subscription_status?: Maybe<SubscriptionStatus>;
  user_email: Scalars['String'];
};

export type ValidatePersonalInformationOutput = {
  __typename?: 'ValidatePersonalInformationOutput';
  reason?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['uuid'];
  manufacturer: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  plate_id: Scalars['uuid'];
  vehicle_type: Scalars['String'];
};

export type VioTransactionsPreprocessingOutput = {
  __typename?: 'VioTransactionsPreprocessingOutput';
  message: Scalars['String'];
};

export type ViolationsByViolatorOutput = {
  __typename?: 'ViolationsByViolatorOutput';
  grouped_violations: Array<Array<Scalars['bigint']>>;
};

export type ViolatorImageOutput = {
  __typename?: 'ViolatorImageOutput';
  signed_url: Scalars['String'];
};

export type VisibleCompanyEntry = {
  __typename?: 'VisibleCompanyEntry';
  address: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VisibleLotEntry = {
  __typename?: 'VisibleLotEntry';
  address: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  go_live_dates: GoLiveDates;
  id: Scalars['String'];
  lot_type: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
};

export type VisibleLotsAndCompanies = {
  __typename?: 'VisibleLotsAndCompanies';
  companies?: Maybe<Array<VisibleCompanyEntry>>;
  lots?: Maybe<Array<VisibleLotEntry>>;
};

export type WhereFields = {
  email?: InputMaybe<Scalars['String']>;
  own_company?: InputMaybe<Scalars['String']>;
};

export type WhitelistEntriesByPlateResponse = {
  __typename?: 'WhitelistEntriesByPlateResponse';
  calendarEventPolicies?: Maybe<Array<Maybe<WhitelistEntryCalendarEventPolicy>>>;
  companyId: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  lotIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  plate: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type WhitelistEntry = {
  __typename?: 'WhitelistEntry';
  companyId: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  lotId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate: Scalars['String'];
  plateCount: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type WhitelistEntryCalendarEventPolicy = {
  __typename?: 'WhitelistEntryCalendarEventPolicy';
  rruleDuration: Scalars['String'];
  rruleString: Scalars['String'];
};

export type WhitelistPreprocessingOutput = {
  __typename?: 'WhitelistPreprocessingOutput';
  message: Scalars['String'];
};

/** Adyen settlement report object from webhook */
export type AdyenReport = {
  __typename?: 'adyen_report';
  /** An array relationship */
  adyen_transactions: Array<AdyenTransaction>;
  /** An aggregate relationship */
  adyen_transactions_aggregate: AdyenTransactionAggregate;
  batch_number: Scalars['Int'];
  event_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  merchant_account: Scalars['String'];
  merchant_reference: Scalars['String'];
  psp_reference: Scalars['String'];
  report_url: Scalars['String'];
};


/** Adyen settlement report object from webhook */
export type AdyenReportAdyenTransactionsArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


/** Adyen settlement report object from webhook */
export type AdyenReportAdyenTransactionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};

/** aggregated selection of "adyen_report" */
export type AdyenReportAggregate = {
  __typename?: 'adyen_report_aggregate';
  aggregate?: Maybe<AdyenReportAggregateFields>;
  nodes: Array<AdyenReport>;
};

/** aggregate fields of "adyen_report" */
export type AdyenReportAggregateFields = {
  __typename?: 'adyen_report_aggregate_fields';
  avg?: Maybe<AdyenReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdyenReportMaxFields>;
  min?: Maybe<AdyenReportMinFields>;
  stddev?: Maybe<AdyenReportStddevFields>;
  stddev_pop?: Maybe<AdyenReportStddevPopFields>;
  stddev_samp?: Maybe<AdyenReportStddevSampFields>;
  sum?: Maybe<AdyenReportSumFields>;
  var_pop?: Maybe<AdyenReportVarPopFields>;
  var_samp?: Maybe<AdyenReportVarSampFields>;
  variance?: Maybe<AdyenReportVarianceFields>;
};


/** aggregate fields of "adyen_report" */
export type AdyenReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdyenReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AdyenReportAvgFields = {
  __typename?: 'adyen_report_avg_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "adyen_report". All fields are combined with a logical 'AND'. */
export type AdyenReportBoolExp = {
  _and?: InputMaybe<Array<AdyenReportBoolExp>>;
  _not?: InputMaybe<AdyenReportBoolExp>;
  _or?: InputMaybe<Array<AdyenReportBoolExp>>;
  adyen_transactions?: InputMaybe<AdyenTransactionBoolExp>;
  adyen_transactions_aggregate?: InputMaybe<AdyenTransactionAggregateBoolExp>;
  batch_number?: InputMaybe<IntComparisonExp>;
  event_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant_account?: InputMaybe<StringComparisonExp>;
  merchant_reference?: InputMaybe<StringComparisonExp>;
  psp_reference?: InputMaybe<StringComparisonExp>;
  report_url?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "adyen_report" */
export enum AdyenReportConstraint {
  /** unique or primary key constraint on columns "id" */
  AdyenReportPkey = 'adyen_report_pkey'
}

/** input type for incrementing numeric columns in table "adyen_report" */
export type AdyenReportIncInput = {
  batch_number?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "adyen_report" */
export type AdyenReportInsertInput = {
  adyen_transactions?: InputMaybe<AdyenTransactionArrRelInsertInput>;
  batch_number?: InputMaybe<Scalars['Int']>;
  event_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_account?: InputMaybe<Scalars['String']>;
  merchant_reference?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  report_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdyenReportMaxFields = {
  __typename?: 'adyen_report_max_fields';
  batch_number?: Maybe<Scalars['Int']>;
  event_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  merchant_account?: Maybe<Scalars['String']>;
  merchant_reference?: Maybe<Scalars['String']>;
  psp_reference?: Maybe<Scalars['String']>;
  report_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AdyenReportMinFields = {
  __typename?: 'adyen_report_min_fields';
  batch_number?: Maybe<Scalars['Int']>;
  event_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  merchant_account?: Maybe<Scalars['String']>;
  merchant_reference?: Maybe<Scalars['String']>;
  psp_reference?: Maybe<Scalars['String']>;
  report_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "adyen_report" */
export type AdyenReportMutationResponse = {
  __typename?: 'adyen_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdyenReport>;
};

/** on_conflict condition type for table "adyen_report" */
export type AdyenReportOnConflict = {
  constraint: AdyenReportConstraint;
  update_columns?: Array<AdyenReportUpdateColumn>;
  where?: InputMaybe<AdyenReportBoolExp>;
};

/** Ordering options when selecting data from "adyen_report". */
export type AdyenReportOrderBy = {
  adyen_transactions_aggregate?: InputMaybe<AdyenTransactionAggregateOrderBy>;
  batch_number?: InputMaybe<OrderBy>;
  event_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_account?: InputMaybe<OrderBy>;
  merchant_reference?: InputMaybe<OrderBy>;
  psp_reference?: InputMaybe<OrderBy>;
  report_url?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: adyen_report */
export type AdyenReportPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "adyen_report" */
export enum AdyenReportSelectColumn {
  /** column name */
  BatchNumber = 'batch_number',
  /** column name */
  EventDate = 'event_date',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantAccount = 'merchant_account',
  /** column name */
  MerchantReference = 'merchant_reference',
  /** column name */
  PspReference = 'psp_reference',
  /** column name */
  ReportUrl = 'report_url'
}

/** input type for updating data in table "adyen_report" */
export type AdyenReportSetInput = {
  batch_number?: InputMaybe<Scalars['Int']>;
  event_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_account?: InputMaybe<Scalars['String']>;
  merchant_reference?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  report_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdyenReportStddevFields = {
  __typename?: 'adyen_report_stddev_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdyenReportStddevPopFields = {
  __typename?: 'adyen_report_stddev_pop_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdyenReportStddevSampFields = {
  __typename?: 'adyen_report_stddev_samp_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "adyen_report" */
export type AdyenReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdyenReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdyenReportStreamCursorValueInput = {
  batch_number?: InputMaybe<Scalars['Int']>;
  event_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_account?: InputMaybe<Scalars['String']>;
  merchant_reference?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  report_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AdyenReportSumFields = {
  __typename?: 'adyen_report_sum_fields';
  batch_number?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "adyen_report" */
export enum AdyenReportUpdateColumn {
  /** column name */
  BatchNumber = 'batch_number',
  /** column name */
  EventDate = 'event_date',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantAccount = 'merchant_account',
  /** column name */
  MerchantReference = 'merchant_reference',
  /** column name */
  PspReference = 'psp_reference',
  /** column name */
  ReportUrl = 'report_url'
}

export type AdyenReportUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdyenReportIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdyenReportSetInput>;
  /** filter the rows which have to be updated */
  where: AdyenReportBoolExp;
};

/** aggregate var_pop on columns */
export type AdyenReportVarPopFields = {
  __typename?: 'adyen_report_var_pop_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdyenReportVarSampFields = {
  __typename?: 'adyen_report_var_samp_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdyenReportVarianceFields = {
  __typename?: 'adyen_report_variance_fields';
  batch_number?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** adyen transaction objects from adyen reports */
export type AdyenTransaction = {
  __typename?: 'adyen_transaction';
  adyen_report_id: Scalars['bigint'];
  commission?: Maybe<Scalars['numeric']>;
  creation_date?: Maybe<Scalars['timestamptz']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  gross_credit?: Maybe<Scalars['numeric']>;
  gross_currency?: Maybe<Scalars['String']>;
  gross_debit?: Maybe<Scalars['numeric']>;
  id: Scalars['Int'];
  interchange?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  modification_merchant_reference?: Maybe<Scalars['String']>;
  modification_reference?: Maybe<Scalars['String']>;
  net_credit?: Maybe<Scalars['numeric']>;
  net_currency?: Maybe<Scalars['String']>;
  net_debit?: Maybe<Scalars['numeric']>;
  payment_method?: Maybe<Scalars['String']>;
  payment_method_variant?: Maybe<Scalars['String']>;
  psp_reference?: Maybe<Scalars['String']>;
  scheme_fees?: Maybe<Scalars['numeric']>;
  type: Scalars['String'];
};

/** aggregated selection of "adyen_transaction" */
export type AdyenTransactionAggregate = {
  __typename?: 'adyen_transaction_aggregate';
  aggregate?: Maybe<AdyenTransactionAggregateFields>;
  nodes: Array<AdyenTransaction>;
};

export type AdyenTransactionAggregateBoolExp = {
  count?: InputMaybe<AdyenTransactionAggregateBoolExpCount>;
};

export type AdyenTransactionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdyenTransactionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "adyen_transaction" */
export type AdyenTransactionAggregateFields = {
  __typename?: 'adyen_transaction_aggregate_fields';
  avg?: Maybe<AdyenTransactionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdyenTransactionMaxFields>;
  min?: Maybe<AdyenTransactionMinFields>;
  stddev?: Maybe<AdyenTransactionStddevFields>;
  stddev_pop?: Maybe<AdyenTransactionStddevPopFields>;
  stddev_samp?: Maybe<AdyenTransactionStddevSampFields>;
  sum?: Maybe<AdyenTransactionSumFields>;
  var_pop?: Maybe<AdyenTransactionVarPopFields>;
  var_samp?: Maybe<AdyenTransactionVarSampFields>;
  variance?: Maybe<AdyenTransactionVarianceFields>;
};


/** aggregate fields of "adyen_transaction" */
export type AdyenTransactionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "adyen_transaction" */
export type AdyenTransactionAggregateOrderBy = {
  avg?: InputMaybe<AdyenTransactionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdyenTransactionMaxOrderBy>;
  min?: InputMaybe<AdyenTransactionMinOrderBy>;
  stddev?: InputMaybe<AdyenTransactionStddevOrderBy>;
  stddev_pop?: InputMaybe<AdyenTransactionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdyenTransactionStddevSampOrderBy>;
  sum?: InputMaybe<AdyenTransactionSumOrderBy>;
  var_pop?: InputMaybe<AdyenTransactionVarPopOrderBy>;
  var_samp?: InputMaybe<AdyenTransactionVarSampOrderBy>;
  variance?: InputMaybe<AdyenTransactionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "adyen_transaction" */
export type AdyenTransactionArrRelInsertInput = {
  data: Array<AdyenTransactionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdyenTransactionOnConflict>;
};

/** aggregate avg on columns */
export type AdyenTransactionAvgFields = {
  __typename?: 'adyen_transaction_avg_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "adyen_transaction" */
export type AdyenTransactionAvgOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "adyen_transaction". All fields are combined with a logical 'AND'. */
export type AdyenTransactionBoolExp = {
  _and?: InputMaybe<Array<AdyenTransactionBoolExp>>;
  _not?: InputMaybe<AdyenTransactionBoolExp>;
  _or?: InputMaybe<Array<AdyenTransactionBoolExp>>;
  adyen_report_id?: InputMaybe<BigintComparisonExp>;
  commission?: InputMaybe<NumericComparisonExp>;
  creation_date?: InputMaybe<TimestamptzComparisonExp>;
  exchange_rate?: InputMaybe<NumericComparisonExp>;
  gross_credit?: InputMaybe<NumericComparisonExp>;
  gross_currency?: InputMaybe<StringComparisonExp>;
  gross_debit?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  interchange?: InputMaybe<NumericComparisonExp>;
  markup?: InputMaybe<NumericComparisonExp>;
  modification_merchant_reference?: InputMaybe<StringComparisonExp>;
  modification_reference?: InputMaybe<StringComparisonExp>;
  net_credit?: InputMaybe<NumericComparisonExp>;
  net_currency?: InputMaybe<StringComparisonExp>;
  net_debit?: InputMaybe<NumericComparisonExp>;
  payment_method?: InputMaybe<StringComparisonExp>;
  payment_method_variant?: InputMaybe<StringComparisonExp>;
  psp_reference?: InputMaybe<StringComparisonExp>;
  scheme_fees?: InputMaybe<NumericComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "adyen_transaction" */
export enum AdyenTransactionConstraint {
  /** unique or primary key constraint on columns "id" */
  AdyenTransactionPkey = 'adyen_transaction_pkey'
}

/** input type for incrementing numeric columns in table "adyen_transaction" */
export type AdyenTransactionIncInput = {
  adyen_report_id?: InputMaybe<Scalars['bigint']>;
  commission?: InputMaybe<Scalars['numeric']>;
  exchange_rate?: InputMaybe<Scalars['numeric']>;
  gross_credit?: InputMaybe<Scalars['numeric']>;
  gross_debit?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  interchange?: InputMaybe<Scalars['numeric']>;
  markup?: InputMaybe<Scalars['numeric']>;
  net_credit?: InputMaybe<Scalars['numeric']>;
  net_debit?: InputMaybe<Scalars['numeric']>;
  scheme_fees?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "adyen_transaction" */
export type AdyenTransactionInsertInput = {
  adyen_report_id?: InputMaybe<Scalars['bigint']>;
  commission?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  exchange_rate?: InputMaybe<Scalars['numeric']>;
  gross_credit?: InputMaybe<Scalars['numeric']>;
  gross_currency?: InputMaybe<Scalars['String']>;
  gross_debit?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  interchange?: InputMaybe<Scalars['numeric']>;
  markup?: InputMaybe<Scalars['numeric']>;
  modification_merchant_reference?: InputMaybe<Scalars['String']>;
  modification_reference?: InputMaybe<Scalars['String']>;
  net_credit?: InputMaybe<Scalars['numeric']>;
  net_currency?: InputMaybe<Scalars['String']>;
  net_debit?: InputMaybe<Scalars['numeric']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_method_variant?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  scheme_fees?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdyenTransactionMaxFields = {
  __typename?: 'adyen_transaction_max_fields';
  adyen_report_id?: Maybe<Scalars['bigint']>;
  commission?: Maybe<Scalars['numeric']>;
  creation_date?: Maybe<Scalars['timestamptz']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  gross_credit?: Maybe<Scalars['numeric']>;
  gross_currency?: Maybe<Scalars['String']>;
  gross_debit?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  interchange?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  modification_merchant_reference?: Maybe<Scalars['String']>;
  modification_reference?: Maybe<Scalars['String']>;
  net_credit?: Maybe<Scalars['numeric']>;
  net_currency?: Maybe<Scalars['String']>;
  net_debit?: Maybe<Scalars['numeric']>;
  payment_method?: Maybe<Scalars['String']>;
  payment_method_variant?: Maybe<Scalars['String']>;
  psp_reference?: Maybe<Scalars['String']>;
  scheme_fees?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "adyen_transaction" */
export type AdyenTransactionMaxOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  creation_date?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_currency?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  modification_merchant_reference?: InputMaybe<OrderBy>;
  modification_reference?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_currency?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_method_variant?: InputMaybe<OrderBy>;
  psp_reference?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdyenTransactionMinFields = {
  __typename?: 'adyen_transaction_min_fields';
  adyen_report_id?: Maybe<Scalars['bigint']>;
  commission?: Maybe<Scalars['numeric']>;
  creation_date?: Maybe<Scalars['timestamptz']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  gross_credit?: Maybe<Scalars['numeric']>;
  gross_currency?: Maybe<Scalars['String']>;
  gross_debit?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  interchange?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  modification_merchant_reference?: Maybe<Scalars['String']>;
  modification_reference?: Maybe<Scalars['String']>;
  net_credit?: Maybe<Scalars['numeric']>;
  net_currency?: Maybe<Scalars['String']>;
  net_debit?: Maybe<Scalars['numeric']>;
  payment_method?: Maybe<Scalars['String']>;
  payment_method_variant?: Maybe<Scalars['String']>;
  psp_reference?: Maybe<Scalars['String']>;
  scheme_fees?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "adyen_transaction" */
export type AdyenTransactionMinOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  creation_date?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_currency?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  modification_merchant_reference?: InputMaybe<OrderBy>;
  modification_reference?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_currency?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_method_variant?: InputMaybe<OrderBy>;
  psp_reference?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "adyen_transaction" */
export type AdyenTransactionMutationResponse = {
  __typename?: 'adyen_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdyenTransaction>;
};

/** on_conflict condition type for table "adyen_transaction" */
export type AdyenTransactionOnConflict = {
  constraint: AdyenTransactionConstraint;
  update_columns?: Array<AdyenTransactionUpdateColumn>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};

/** Ordering options when selecting data from "adyen_transaction". */
export type AdyenTransactionOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  creation_date?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_currency?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  modification_merchant_reference?: InputMaybe<OrderBy>;
  modification_reference?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_currency?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_method_variant?: InputMaybe<OrderBy>;
  psp_reference?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: adyen_transaction */
export type AdyenTransactionPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "adyen_transaction" */
export enum AdyenTransactionSelectColumn {
  /** column name */
  AdyenReportId = 'adyen_report_id',
  /** column name */
  Commission = 'commission',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  GrossCredit = 'gross_credit',
  /** column name */
  GrossCurrency = 'gross_currency',
  /** column name */
  GrossDebit = 'gross_debit',
  /** column name */
  Id = 'id',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  Markup = 'markup',
  /** column name */
  ModificationMerchantReference = 'modification_merchant_reference',
  /** column name */
  ModificationReference = 'modification_reference',
  /** column name */
  NetCredit = 'net_credit',
  /** column name */
  NetCurrency = 'net_currency',
  /** column name */
  NetDebit = 'net_debit',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentMethodVariant = 'payment_method_variant',
  /** column name */
  PspReference = 'psp_reference',
  /** column name */
  SchemeFees = 'scheme_fees',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "adyen_transaction" */
export type AdyenTransactionSetInput = {
  adyen_report_id?: InputMaybe<Scalars['bigint']>;
  commission?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  exchange_rate?: InputMaybe<Scalars['numeric']>;
  gross_credit?: InputMaybe<Scalars['numeric']>;
  gross_currency?: InputMaybe<Scalars['String']>;
  gross_debit?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  interchange?: InputMaybe<Scalars['numeric']>;
  markup?: InputMaybe<Scalars['numeric']>;
  modification_merchant_reference?: InputMaybe<Scalars['String']>;
  modification_reference?: InputMaybe<Scalars['String']>;
  net_credit?: InputMaybe<Scalars['numeric']>;
  net_currency?: InputMaybe<Scalars['String']>;
  net_debit?: InputMaybe<Scalars['numeric']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_method_variant?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  scheme_fees?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdyenTransactionStddevFields = {
  __typename?: 'adyen_transaction_stddev_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "adyen_transaction" */
export type AdyenTransactionStddevOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdyenTransactionStddevPopFields = {
  __typename?: 'adyen_transaction_stddev_pop_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "adyen_transaction" */
export type AdyenTransactionStddevPopOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdyenTransactionStddevSampFields = {
  __typename?: 'adyen_transaction_stddev_samp_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "adyen_transaction" */
export type AdyenTransactionStddevSampOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "adyen_transaction" */
export type AdyenTransactionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdyenTransactionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdyenTransactionStreamCursorValueInput = {
  adyen_report_id?: InputMaybe<Scalars['bigint']>;
  commission?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  exchange_rate?: InputMaybe<Scalars['numeric']>;
  gross_credit?: InputMaybe<Scalars['numeric']>;
  gross_currency?: InputMaybe<Scalars['String']>;
  gross_debit?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  interchange?: InputMaybe<Scalars['numeric']>;
  markup?: InputMaybe<Scalars['numeric']>;
  modification_merchant_reference?: InputMaybe<Scalars['String']>;
  modification_reference?: InputMaybe<Scalars['String']>;
  net_credit?: InputMaybe<Scalars['numeric']>;
  net_currency?: InputMaybe<Scalars['String']>;
  net_debit?: InputMaybe<Scalars['numeric']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_method_variant?: InputMaybe<Scalars['String']>;
  psp_reference?: InputMaybe<Scalars['String']>;
  scheme_fees?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AdyenTransactionSumFields = {
  __typename?: 'adyen_transaction_sum_fields';
  adyen_report_id?: Maybe<Scalars['bigint']>;
  commission?: Maybe<Scalars['numeric']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  gross_credit?: Maybe<Scalars['numeric']>;
  gross_debit?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  interchange?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  net_credit?: Maybe<Scalars['numeric']>;
  net_debit?: Maybe<Scalars['numeric']>;
  scheme_fees?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "adyen_transaction" */
export type AdyenTransactionSumOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** update columns of table "adyen_transaction" */
export enum AdyenTransactionUpdateColumn {
  /** column name */
  AdyenReportId = 'adyen_report_id',
  /** column name */
  Commission = 'commission',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  GrossCredit = 'gross_credit',
  /** column name */
  GrossCurrency = 'gross_currency',
  /** column name */
  GrossDebit = 'gross_debit',
  /** column name */
  Id = 'id',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  Markup = 'markup',
  /** column name */
  ModificationMerchantReference = 'modification_merchant_reference',
  /** column name */
  ModificationReference = 'modification_reference',
  /** column name */
  NetCredit = 'net_credit',
  /** column name */
  NetCurrency = 'net_currency',
  /** column name */
  NetDebit = 'net_debit',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentMethodVariant = 'payment_method_variant',
  /** column name */
  PspReference = 'psp_reference',
  /** column name */
  SchemeFees = 'scheme_fees',
  /** column name */
  Type = 'type'
}

export type AdyenTransactionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdyenTransactionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdyenTransactionSetInput>;
  /** filter the rows which have to be updated */
  where: AdyenTransactionBoolExp;
};

/** aggregate var_pop on columns */
export type AdyenTransactionVarPopFields = {
  __typename?: 'adyen_transaction_var_pop_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "adyen_transaction" */
export type AdyenTransactionVarPopOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdyenTransactionVarSampFields = {
  __typename?: 'adyen_transaction_var_samp_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "adyen_transaction" */
export type AdyenTransactionVarSampOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdyenTransactionVarianceFields = {
  __typename?: 'adyen_transaction_variance_fields';
  adyen_report_id?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  exchange_rate?: Maybe<Scalars['Float']>;
  gross_credit?: Maybe<Scalars['Float']>;
  gross_debit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interchange?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  net_credit?: Maybe<Scalars['Float']>;
  net_debit?: Maybe<Scalars['Float']>;
  scheme_fees?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "adyen_transaction" */
export type AdyenTransactionVarianceOrderBy = {
  adyen_report_id?: InputMaybe<OrderBy>;
  commission?: InputMaybe<OrderBy>;
  exchange_rate?: InputMaybe<OrderBy>;
  gross_credit?: InputMaybe<OrderBy>;
  gross_debit?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interchange?: InputMaybe<OrderBy>;
  markup?: InputMaybe<OrderBy>;
  net_credit?: InputMaybe<OrderBy>;
  net_debit?: InputMaybe<OrderBy>;
  scheme_fees?: InputMaybe<OrderBy>;
};

/** Stores all parking permits that were applied during the classification of a parking result */
export type AppliedPermit = {
  __typename?: 'applied_permit';
  application_end: Scalars['timestamptz'];
  application_start: Scalars['timestamptz'];
  company_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  parking_result_id: Scalars['uuid'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "applied_permit" */
export type AppliedPermitAggregate = {
  __typename?: 'applied_permit_aggregate';
  aggregate?: Maybe<AppliedPermitAggregateFields>;
  nodes: Array<AppliedPermit>;
};

/** aggregate fields of "applied_permit" */
export type AppliedPermitAggregateFields = {
  __typename?: 'applied_permit_aggregate_fields';
  avg?: Maybe<AppliedPermitAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppliedPermitMaxFields>;
  min?: Maybe<AppliedPermitMinFields>;
  stddev?: Maybe<AppliedPermitStddevFields>;
  stddev_pop?: Maybe<AppliedPermitStddevPopFields>;
  stddev_samp?: Maybe<AppliedPermitStddevSampFields>;
  sum?: Maybe<AppliedPermitSumFields>;
  var_pop?: Maybe<AppliedPermitVarPopFields>;
  var_samp?: Maybe<AppliedPermitVarSampFields>;
  variance?: Maybe<AppliedPermitVarianceFields>;
};


/** aggregate fields of "applied_permit" */
export type AppliedPermitAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppliedPermitSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AppliedPermitAvgFields = {
  __typename?: 'applied_permit_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "applied_permit". All fields are combined with a logical 'AND'. */
export type AppliedPermitBoolExp = {
  _and?: InputMaybe<Array<AppliedPermitBoolExp>>;
  _not?: InputMaybe<AppliedPermitBoolExp>;
  _or?: InputMaybe<Array<AppliedPermitBoolExp>>;
  application_end?: InputMaybe<TimestamptzComparisonExp>;
  application_start?: InputMaybe<TimestamptzComparisonExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_result_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "applied_permit" */
export enum AppliedPermitConstraint {
  /** unique or primary key constraint on columns "id" */
  AppliedPermitPkey = 'applied_permit_pkey'
}

/** input type for incrementing numeric columns in table "applied_permit" */
export type AppliedPermitIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "applied_permit" */
export type AppliedPermitInsertInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppliedPermitMaxFields = {
  __typename?: 'applied_permit_max_fields';
  application_end?: Maybe<Scalars['timestamptz']>;
  application_start?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AppliedPermitMinFields = {
  __typename?: 'applied_permit_min_fields';
  application_end?: Maybe<Scalars['timestamptz']>;
  application_start?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "applied_permit" */
export type AppliedPermitMutationResponse = {
  __typename?: 'applied_permit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppliedPermit>;
};

/** on_conflict condition type for table "applied_permit" */
export type AppliedPermitOnConflict = {
  constraint: AppliedPermitConstraint;
  update_columns?: Array<AppliedPermitUpdateColumn>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};

/** Ordering options when selecting data from "applied_permit". */
export type AppliedPermitOrderBy = {
  application_end?: InputMaybe<OrderBy>;
  application_start?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_result_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applied_permit */
export type AppliedPermitPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "applied_permit" */
export enum AppliedPermitSelectColumn {
  /** column name */
  ApplicationEnd = 'application_end',
  /** column name */
  ApplicationStart = 'application_start',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultId = 'parking_result_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "applied_permit" */
export type AppliedPermitSetInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AppliedPermitStddevFields = {
  __typename?: 'applied_permit_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AppliedPermitStddevPopFields = {
  __typename?: 'applied_permit_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AppliedPermitStddevSampFields = {
  __typename?: 'applied_permit_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "applied_permit" */
export type AppliedPermitStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppliedPermitStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppliedPermitStreamCursorValueInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AppliedPermitSumFields = {
  __typename?: 'applied_permit_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "applied_permit" */
export enum AppliedPermitUpdateColumn {
  /** column name */
  ApplicationEnd = 'application_end',
  /** column name */
  ApplicationStart = 'application_start',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultId = 'parking_result_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type AppliedPermitUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AppliedPermitIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppliedPermitSetInput>;
  /** filter the rows which have to be updated */
  where: AppliedPermitBoolExp;
};

/** aggregate var_pop on columns */
export type AppliedPermitVarPopFields = {
  __typename?: 'applied_permit_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AppliedPermitVarSampFields = {
  __typename?: 'applied_permit_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AppliedPermitVarianceFields = {
  __typename?: 'applied_permit_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Used to store all the whitelists that were applied during the classification of a parking result */
export type AppliedWhitelist = {
  __typename?: 'applied_whitelist';
  application_end: Scalars['timestamptz'];
  application_start: Scalars['timestamptz'];
  company_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  end_margin_applied_min: Scalars['Int'];
  id: Scalars['bigint'];
  parking_result_id: Scalars['uuid'];
  start_margin_applied_min: Scalars['Int'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "applied_whitelist" */
export type AppliedWhitelistAggregate = {
  __typename?: 'applied_whitelist_aggregate';
  aggregate?: Maybe<AppliedWhitelistAggregateFields>;
  nodes: Array<AppliedWhitelist>;
};

/** aggregate fields of "applied_whitelist" */
export type AppliedWhitelistAggregateFields = {
  __typename?: 'applied_whitelist_aggregate_fields';
  avg?: Maybe<AppliedWhitelistAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppliedWhitelistMaxFields>;
  min?: Maybe<AppliedWhitelistMinFields>;
  stddev?: Maybe<AppliedWhitelistStddevFields>;
  stddev_pop?: Maybe<AppliedWhitelistStddevPopFields>;
  stddev_samp?: Maybe<AppliedWhitelistStddevSampFields>;
  sum?: Maybe<AppliedWhitelistSumFields>;
  var_pop?: Maybe<AppliedWhitelistVarPopFields>;
  var_samp?: Maybe<AppliedWhitelistVarSampFields>;
  variance?: Maybe<AppliedWhitelistVarianceFields>;
};


/** aggregate fields of "applied_whitelist" */
export type AppliedWhitelistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppliedWhitelistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AppliedWhitelistAvgFields = {
  __typename?: 'applied_whitelist_avg_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "applied_whitelist". All fields are combined with a logical 'AND'. */
export type AppliedWhitelistBoolExp = {
  _and?: InputMaybe<Array<AppliedWhitelistBoolExp>>;
  _not?: InputMaybe<AppliedWhitelistBoolExp>;
  _or?: InputMaybe<Array<AppliedWhitelistBoolExp>>;
  application_end?: InputMaybe<TimestamptzComparisonExp>;
  application_start?: InputMaybe<TimestamptzComparisonExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_margin_applied_min?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_result_id?: InputMaybe<UuidComparisonExp>;
  start_margin_applied_min?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "applied_whitelist" */
export enum AppliedWhitelistConstraint {
  /** unique or primary key constraint on columns "id" */
  AppliedWhitelistPkey = 'applied_whitelist_pkey'
}

/** input type for incrementing numeric columns in table "applied_whitelist" */
export type AppliedWhitelistIncInput = {
  end_margin_applied_min?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  start_margin_applied_min?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applied_whitelist" */
export type AppliedWhitelistInsertInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_margin_applied_min?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  start_margin_applied_min?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppliedWhitelistMaxFields = {
  __typename?: 'applied_whitelist_max_fields';
  application_end?: Maybe<Scalars['timestamptz']>;
  application_start?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_margin_applied_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  start_margin_applied_min?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AppliedWhitelistMinFields = {
  __typename?: 'applied_whitelist_min_fields';
  application_end?: Maybe<Scalars['timestamptz']>;
  application_start?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_margin_applied_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  start_margin_applied_min?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "applied_whitelist" */
export type AppliedWhitelistMutationResponse = {
  __typename?: 'applied_whitelist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppliedWhitelist>;
};

/** on_conflict condition type for table "applied_whitelist" */
export type AppliedWhitelistOnConflict = {
  constraint: AppliedWhitelistConstraint;
  update_columns?: Array<AppliedWhitelistUpdateColumn>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};

/** Ordering options when selecting data from "applied_whitelist". */
export type AppliedWhitelistOrderBy = {
  application_end?: InputMaybe<OrderBy>;
  application_start?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_margin_applied_min?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_result_id?: InputMaybe<OrderBy>;
  start_margin_applied_min?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applied_whitelist */
export type AppliedWhitelistPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "applied_whitelist" */
export enum AppliedWhitelistSelectColumn {
  /** column name */
  ApplicationEnd = 'application_end',
  /** column name */
  ApplicationStart = 'application_start',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndMarginAppliedMin = 'end_margin_applied_min',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultId = 'parking_result_id',
  /** column name */
  StartMarginAppliedMin = 'start_margin_applied_min',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "applied_whitelist" */
export type AppliedWhitelistSetInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_margin_applied_min?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  start_margin_applied_min?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AppliedWhitelistStddevFields = {
  __typename?: 'applied_whitelist_stddev_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AppliedWhitelistStddevPopFields = {
  __typename?: 'applied_whitelist_stddev_pop_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AppliedWhitelistStddevSampFields = {
  __typename?: 'applied_whitelist_stddev_samp_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "applied_whitelist" */
export type AppliedWhitelistStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppliedWhitelistStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppliedWhitelistStreamCursorValueInput = {
  application_end?: InputMaybe<Scalars['timestamptz']>;
  application_start?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_margin_applied_min?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  start_margin_applied_min?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AppliedWhitelistSumFields = {
  __typename?: 'applied_whitelist_sum_fields';
  end_margin_applied_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  start_margin_applied_min?: Maybe<Scalars['Int']>;
};

/** update columns of table "applied_whitelist" */
export enum AppliedWhitelistUpdateColumn {
  /** column name */
  ApplicationEnd = 'application_end',
  /** column name */
  ApplicationStart = 'application_start',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndMarginAppliedMin = 'end_margin_applied_min',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultId = 'parking_result_id',
  /** column name */
  StartMarginAppliedMin = 'start_margin_applied_min',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type AppliedWhitelistUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AppliedWhitelistIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppliedWhitelistSetInput>;
  /** filter the rows which have to be updated */
  where: AppliedWhitelistBoolExp;
};

/** aggregate var_pop on columns */
export type AppliedWhitelistVarPopFields = {
  __typename?: 'applied_whitelist_var_pop_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AppliedWhitelistVarSampFields = {
  __typename?: 'applied_whitelist_var_samp_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AppliedWhitelistVarianceFields = {
  __typename?: 'applied_whitelist_variance_fields';
  end_margin_applied_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  start_margin_applied_min?: Maybe<Scalars['Float']>;
};

/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type AuditLoggedActions = {
  __typename?: 'audit_logged_actions';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action: Scalars['String'];
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk: Scalars['timestamptz'];
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm: Scalars['timestamptz'];
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx: Scalars['timestamptz'];
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: Maybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: Maybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  client_addr?: Maybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: Maybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id: Scalars['bigint'];
  hasura_user?: Maybe<Scalars['jsonb']>;
  pk_id?: Maybe<Scalars['String']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid: Scalars['oid'];
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: Maybe<Scalars['jsonb']>;
  /** Database schema audited table for this event is in */
  schema_name: Scalars['String'];
  /** Login / session user whose statement caused the audited event */
  session_user_name?: Maybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statement_only: Scalars['Boolean'];
  /** Non-schema-qualified table name of table event occured in */
  table_name: Scalars['String'];
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['bigint']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type AuditLoggedActionsChangedFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type AuditLoggedActionsHasuraUserArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type AuditLoggedActionsRowDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audit.logged_actions" */
export type AuditLoggedActionsAggregate = {
  __typename?: 'audit_logged_actions_aggregate';
  aggregate?: Maybe<AuditLoggedActionsAggregateFields>;
  nodes: Array<AuditLoggedActions>;
};

/** aggregate fields of "audit.logged_actions" */
export type AuditLoggedActionsAggregateFields = {
  __typename?: 'audit_logged_actions_aggregate_fields';
  avg?: Maybe<AuditLoggedActionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AuditLoggedActionsMaxFields>;
  min?: Maybe<AuditLoggedActionsMinFields>;
  stddev?: Maybe<AuditLoggedActionsStddevFields>;
  stddev_pop?: Maybe<AuditLoggedActionsStddevPopFields>;
  stddev_samp?: Maybe<AuditLoggedActionsStddevSampFields>;
  sum?: Maybe<AuditLoggedActionsSumFields>;
  var_pop?: Maybe<AuditLoggedActionsVarPopFields>;
  var_samp?: Maybe<AuditLoggedActionsVarSampFields>;
  variance?: Maybe<AuditLoggedActionsVarianceFields>;
};


/** aggregate fields of "audit.logged_actions" */
export type AuditLoggedActionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AuditLoggedActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuditLoggedActionsAppendInput = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['jsonb']>;
  hasura_user?: InputMaybe<Scalars['jsonb']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AuditLoggedActionsAvgFields = {
  __typename?: 'audit_logged_actions_avg_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audit.logged_actions". All fields are combined with a logical 'AND'. */
export type AuditLoggedActionsBoolExp = {
  _and?: InputMaybe<Array<AuditLoggedActionsBoolExp>>;
  _not?: InputMaybe<AuditLoggedActionsBoolExp>;
  _or?: InputMaybe<Array<AuditLoggedActionsBoolExp>>;
  action?: InputMaybe<StringComparisonExp>;
  action_tstamp_clk?: InputMaybe<TimestamptzComparisonExp>;
  action_tstamp_stm?: InputMaybe<TimestamptzComparisonExp>;
  action_tstamp_tx?: InputMaybe<TimestamptzComparisonExp>;
  application_name?: InputMaybe<StringComparisonExp>;
  changed_fields?: InputMaybe<JsonbComparisonExp>;
  client_addr?: InputMaybe<InetComparisonExp>;
  client_port?: InputMaybe<IntComparisonExp>;
  client_query?: InputMaybe<StringComparisonExp>;
  event_id?: InputMaybe<BigintComparisonExp>;
  hasura_user?: InputMaybe<JsonbComparisonExp>;
  pk_id?: InputMaybe<StringComparisonExp>;
  relid?: InputMaybe<OidComparisonExp>;
  row_data?: InputMaybe<JsonbComparisonExp>;
  schema_name?: InputMaybe<StringComparisonExp>;
  session_user_name?: InputMaybe<StringComparisonExp>;
  statement_only?: InputMaybe<BooleanComparisonExp>;
  table_name?: InputMaybe<StringComparisonExp>;
  transaction_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "audit.logged_actions" */
export enum AuditLoggedActionsConstraint {
  /** unique or primary key constraint on columns "event_id" */
  LoggedActionsPkey = 'logged_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuditLoggedActionsDeleteAtPathInput = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Array<Scalars['String']>>;
  hasura_user?: InputMaybe<Array<Scalars['String']>>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuditLoggedActionsDeleteElemInput = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['Int']>;
  hasura_user?: InputMaybe<Scalars['Int']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuditLoggedActionsDeleteKeyInput = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['String']>;
  hasura_user?: InputMaybe<Scalars['String']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audit.logged_actions" */
export type AuditLoggedActionsIncInput = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: InputMaybe<Scalars['Int']>;
  /** Unique identifier for each auditable event */
  event_id?: InputMaybe<Scalars['bigint']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "audit.logged_actions" */
export type AuditLoggedActionsInsertInput = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: InputMaybe<Scalars['timestamptz']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  client_addr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: InputMaybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id?: InputMaybe<Scalars['bigint']>;
  hasura_user?: InputMaybe<Scalars['jsonb']>;
  pk_id?: InputMaybe<Scalars['String']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['jsonb']>;
  /** Database schema audited table for this event is in */
  schema_name?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  session_user_name?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statement_only?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AuditLoggedActionsMaxFields = {
  __typename?: 'audit_logged_actions_max_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: Maybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk?: Maybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm?: Maybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: Maybe<Scalars['timestamptz']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: Maybe<Scalars['String']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: Maybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['bigint']>;
  pk_id?: Maybe<Scalars['String']>;
  /** Database schema audited table for this event is in */
  schema_name?: Maybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  session_user_name?: Maybe<Scalars['String']>;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: Maybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AuditLoggedActionsMinFields = {
  __typename?: 'audit_logged_actions_min_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: Maybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk?: Maybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm?: Maybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: Maybe<Scalars['timestamptz']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: Maybe<Scalars['String']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: Maybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['bigint']>;
  pk_id?: Maybe<Scalars['String']>;
  /** Database schema audited table for this event is in */
  schema_name?: Maybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  session_user_name?: Maybe<Scalars['String']>;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: Maybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "audit.logged_actions" */
export type AuditLoggedActionsMutationResponse = {
  __typename?: 'audit_logged_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuditLoggedActions>;
};

/** on_conflict condition type for table "audit.logged_actions" */
export type AuditLoggedActionsOnConflict = {
  constraint: AuditLoggedActionsConstraint;
  update_columns?: Array<AuditLoggedActionsUpdateColumn>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};

/** Ordering options when selecting data from "audit.logged_actions". */
export type AuditLoggedActionsOrderBy = {
  action?: InputMaybe<OrderBy>;
  action_tstamp_clk?: InputMaybe<OrderBy>;
  action_tstamp_stm?: InputMaybe<OrderBy>;
  action_tstamp_tx?: InputMaybe<OrderBy>;
  application_name?: InputMaybe<OrderBy>;
  changed_fields?: InputMaybe<OrderBy>;
  client_addr?: InputMaybe<OrderBy>;
  client_port?: InputMaybe<OrderBy>;
  client_query?: InputMaybe<OrderBy>;
  event_id?: InputMaybe<OrderBy>;
  hasura_user?: InputMaybe<OrderBy>;
  pk_id?: InputMaybe<OrderBy>;
  relid?: InputMaybe<OrderBy>;
  row_data?: InputMaybe<OrderBy>;
  schema_name?: InputMaybe<OrderBy>;
  session_user_name?: InputMaybe<OrderBy>;
  statement_only?: InputMaybe<OrderBy>;
  table_name?: InputMaybe<OrderBy>;
  transaction_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audit.logged_actions */
export type AuditLoggedActionsPkColumnsInput = {
  /** Unique identifier for each auditable event */
  event_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuditLoggedActionsPrependInput = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['jsonb']>;
  hasura_user?: InputMaybe<Scalars['jsonb']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audit.logged_actions" */
export enum AuditLoggedActionsSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstampClk = 'action_tstamp_clk',
  /** column name */
  ActionTstampStm = 'action_tstamp_stm',
  /** column name */
  ActionTstampTx = 'action_tstamp_tx',
  /** column name */
  ApplicationName = 'application_name',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  ClientAddr = 'client_addr',
  /** column name */
  ClientPort = 'client_port',
  /** column name */
  ClientQuery = 'client_query',
  /** column name */
  EventId = 'event_id',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  PkId = 'pk_id',
  /** column name */
  Relid = 'relid',
  /** column name */
  RowData = 'row_data',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  SessionUserName = 'session_user_name',
  /** column name */
  StatementOnly = 'statement_only',
  /** column name */
  TableName = 'table_name',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "audit.logged_actions" */
export type AuditLoggedActionsSetInput = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: InputMaybe<Scalars['timestamptz']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  client_addr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: InputMaybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id?: InputMaybe<Scalars['bigint']>;
  hasura_user?: InputMaybe<Scalars['jsonb']>;
  pk_id?: InputMaybe<Scalars['String']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['jsonb']>;
  /** Database schema audited table for this event is in */
  schema_name?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  session_user_name?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statement_only?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AuditLoggedActionsStddevFields = {
  __typename?: 'audit_logged_actions_stddev_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AuditLoggedActionsStddevPopFields = {
  __typename?: 'audit_logged_actions_stddev_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AuditLoggedActionsStddevSampFields = {
  __typename?: 'audit_logged_actions_stddev_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audit_logged_actions" */
export type AuditLoggedActionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AuditLoggedActionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AuditLoggedActionsStreamCursorValueInput = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  action_tstamp_clk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  action_tstamp_stm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: InputMaybe<Scalars['timestamptz']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  application_name?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changed_fields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  client_addr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  client_query?: InputMaybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  event_id?: InputMaybe<Scalars['bigint']>;
  hasura_user?: InputMaybe<Scalars['jsonb']>;
  pk_id?: InputMaybe<Scalars['String']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: InputMaybe<Scalars['jsonb']>;
  /** Database schema audited table for this event is in */
  schema_name?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  session_user_name?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statement_only?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AuditLoggedActionsSumFields = {
  __typename?: 'audit_logged_actions_sum_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Int']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['bigint']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "audit.logged_actions" */
export enum AuditLoggedActionsUpdateColumn {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstampClk = 'action_tstamp_clk',
  /** column name */
  ActionTstampStm = 'action_tstamp_stm',
  /** column name */
  ActionTstampTx = 'action_tstamp_tx',
  /** column name */
  ApplicationName = 'application_name',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  ClientAddr = 'client_addr',
  /** column name */
  ClientPort = 'client_port',
  /** column name */
  ClientQuery = 'client_query',
  /** column name */
  EventId = 'event_id',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  PkId = 'pk_id',
  /** column name */
  Relid = 'relid',
  /** column name */
  RowData = 'row_data',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  SessionUserName = 'session_user_name',
  /** column name */
  StatementOnly = 'statement_only',
  /** column name */
  TableName = 'table_name',
  /** column name */
  TransactionId = 'transaction_id'
}

export type AuditLoggedActionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuditLoggedActionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuditLoggedActionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuditLoggedActionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuditLoggedActionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuditLoggedActionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuditLoggedActionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuditLoggedActionsSetInput>;
  /** filter the rows which have to be updated */
  where: AuditLoggedActionsBoolExp;
};

/** aggregate var_pop on columns */
export type AuditLoggedActionsVarPopFields = {
  __typename?: 'audit_logged_actions_var_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AuditLoggedActionsVarSampFields = {
  __typename?: 'audit_logged_actions_var_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AuditLoggedActionsVarianceFields = {
  __typename?: 'audit_logged_actions_variance_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  client_port?: Maybe<Scalars['Float']>;
  /** Unique identifier for each auditable event */
  event_id?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transaction_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "blacklist" */
export type Blacklist = {
  __typename?: 'blacklist';
  comment?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  country: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  /** An object relationship */
  lot?: Maybe<Lot>;
  lot_id?: Maybe<Scalars['String']>;
  plate: Scalars['String'];
  scope: Scalars['String'];
  start_date?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "blacklist" */
export type BlacklistAggregate = {
  __typename?: 'blacklist_aggregate';
  aggregate?: Maybe<BlacklistAggregateFields>;
  nodes: Array<Blacklist>;
};

export type BlacklistAggregateBoolExp = {
  count?: InputMaybe<BlacklistAggregateBoolExpCount>;
};

export type BlacklistAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BlacklistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BlacklistBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "blacklist" */
export type BlacklistAggregateFields = {
  __typename?: 'blacklist_aggregate_fields';
  avg?: Maybe<BlacklistAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BlacklistMaxFields>;
  min?: Maybe<BlacklistMinFields>;
  stddev?: Maybe<BlacklistStddevFields>;
  stddev_pop?: Maybe<BlacklistStddevPopFields>;
  stddev_samp?: Maybe<BlacklistStddevSampFields>;
  sum?: Maybe<BlacklistSumFields>;
  var_pop?: Maybe<BlacklistVarPopFields>;
  var_samp?: Maybe<BlacklistVarSampFields>;
  variance?: Maybe<BlacklistVarianceFields>;
};


/** aggregate fields of "blacklist" */
export type BlacklistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BlacklistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "blacklist" */
export type BlacklistAggregateOrderBy = {
  avg?: InputMaybe<BlacklistAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BlacklistMaxOrderBy>;
  min?: InputMaybe<BlacklistMinOrderBy>;
  stddev?: InputMaybe<BlacklistStddevOrderBy>;
  stddev_pop?: InputMaybe<BlacklistStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BlacklistStddevSampOrderBy>;
  sum?: InputMaybe<BlacklistSumOrderBy>;
  var_pop?: InputMaybe<BlacklistVarPopOrderBy>;
  var_samp?: InputMaybe<BlacklistVarSampOrderBy>;
  variance?: InputMaybe<BlacklistVarianceOrderBy>;
};

/** aggregate avg on columns */
export type BlacklistAvgFields = {
  __typename?: 'blacklist_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "blacklist" */
export type BlacklistAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "blacklist". All fields are combined with a logical 'AND'. */
export type BlacklistBoolExp = {
  _and?: InputMaybe<Array<BlacklistBoolExp>>;
  _not?: InputMaybe<BlacklistBoolExp>;
  _or?: InputMaybe<Array<BlacklistBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  scope?: InputMaybe<StringComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "blacklist_by_plate_view" */
export type BlacklistByPlateView = {
  __typename?: 'blacklist_by_plate_view';
  /** An array relationship */
  blacklist: Array<Blacklist>;
  /** An aggregate relationship */
  blacklist_aggregate: BlacklistAggregate;
  max_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
};


/** columns and relationships of "blacklist_by_plate_view" */
export type BlacklistByPlateViewBlacklistArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


/** columns and relationships of "blacklist_by_plate_view" */
export type BlacklistByPlateViewBlacklistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};

/** aggregated selection of "blacklist_by_plate_view" */
export type BlacklistByPlateViewAggregate = {
  __typename?: 'blacklist_by_plate_view_aggregate';
  aggregate?: Maybe<BlacklistByPlateViewAggregateFields>;
  nodes: Array<BlacklistByPlateView>;
};

/** aggregate fields of "blacklist_by_plate_view" */
export type BlacklistByPlateViewAggregateFields = {
  __typename?: 'blacklist_by_plate_view_aggregate_fields';
  avg?: Maybe<BlacklistByPlateViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BlacklistByPlateViewMaxFields>;
  min?: Maybe<BlacklistByPlateViewMinFields>;
  stddev?: Maybe<BlacklistByPlateViewStddevFields>;
  stddev_pop?: Maybe<BlacklistByPlateViewStddevPopFields>;
  stddev_samp?: Maybe<BlacklistByPlateViewStddevSampFields>;
  sum?: Maybe<BlacklistByPlateViewSumFields>;
  var_pop?: Maybe<BlacklistByPlateViewVarPopFields>;
  var_samp?: Maybe<BlacklistByPlateViewVarSampFields>;
  variance?: Maybe<BlacklistByPlateViewVarianceFields>;
};


/** aggregate fields of "blacklist_by_plate_view" */
export type BlacklistByPlateViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BlacklistByPlateViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BlacklistByPlateViewAvgFields = {
  __typename?: 'blacklist_by_plate_view_avg_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "blacklist_by_plate_view". All fields are combined with a logical 'AND'. */
export type BlacklistByPlateViewBoolExp = {
  _and?: InputMaybe<Array<BlacklistByPlateViewBoolExp>>;
  _not?: InputMaybe<BlacklistByPlateViewBoolExp>;
  _or?: InputMaybe<Array<BlacklistByPlateViewBoolExp>>;
  blacklist?: InputMaybe<BlacklistBoolExp>;
  blacklist_aggregate?: InputMaybe<BlacklistAggregateBoolExp>;
  max_id?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type BlacklistByPlateViewMaxFields = {
  __typename?: 'blacklist_by_plate_view_max_fields';
  max_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BlacklistByPlateViewMinFields = {
  __typename?: 'blacklist_by_plate_view_min_fields';
  max_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "blacklist_by_plate_view". */
export type BlacklistByPlateViewOrderBy = {
  blacklist_aggregate?: InputMaybe<BlacklistAggregateOrderBy>;
  max_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
};

/** select columns of table "blacklist_by_plate_view" */
export enum BlacklistByPlateViewSelectColumn {
  /** column name */
  MaxId = 'max_id',
  /** column name */
  Plate = 'plate'
}

/** aggregate stddev on columns */
export type BlacklistByPlateViewStddevFields = {
  __typename?: 'blacklist_by_plate_view_stddev_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BlacklistByPlateViewStddevPopFields = {
  __typename?: 'blacklist_by_plate_view_stddev_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BlacklistByPlateViewStddevSampFields = {
  __typename?: 'blacklist_by_plate_view_stddev_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "blacklist_by_plate_view" */
export type BlacklistByPlateViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BlacklistByPlateViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BlacklistByPlateViewStreamCursorValueInput = {
  max_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BlacklistByPlateViewSumFields = {
  __typename?: 'blacklist_by_plate_view_sum_fields';
  max_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type BlacklistByPlateViewVarPopFields = {
  __typename?: 'blacklist_by_plate_view_var_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BlacklistByPlateViewVarSampFields = {
  __typename?: 'blacklist_by_plate_view_var_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BlacklistByPlateViewVarianceFields = {
  __typename?: 'blacklist_by_plate_view_variance_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "blacklist" */
export enum BlacklistConstraint {
  /** unique or primary key constraint on columns "id" */
  BlacklistPkey = 'blacklist_pkey'
}

/** input type for incrementing numeric columns in table "blacklist" */
export type BlacklistIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "blacklist" */
export type BlacklistInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BlacklistMaxFields = {
  __typename?: 'blacklist_max_fields';
  comment?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "blacklist" */
export type BlacklistMaxOrderBy = {
  comment?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BlacklistMinFields = {
  __typename?: 'blacklist_min_fields';
  comment?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "blacklist" */
export type BlacklistMinOrderBy = {
  comment?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "blacklist" */
export type BlacklistMutationResponse = {
  __typename?: 'blacklist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Blacklist>;
};

/** on_conflict condition type for table "blacklist" */
export type BlacklistOnConflict = {
  constraint: BlacklistConstraint;
  update_columns?: Array<BlacklistUpdateColumn>;
  where?: InputMaybe<BlacklistBoolExp>;
};

/** Ordering options when selecting data from "blacklist". */
export type BlacklistOrderBy = {
  comment?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: blacklist */
export type BlacklistPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "blacklist" */
export enum BlacklistSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "blacklist" */
export type BlacklistSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BlacklistStddevFields = {
  __typename?: 'blacklist_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "blacklist" */
export type BlacklistStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BlacklistStddevPopFields = {
  __typename?: 'blacklist_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "blacklist" */
export type BlacklistStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BlacklistStddevSampFields = {
  __typename?: 'blacklist_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "blacklist" */
export type BlacklistStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "blacklist" */
export type BlacklistStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BlacklistStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BlacklistStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BlacklistSumFields = {
  __typename?: 'blacklist_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "blacklist" */
export type BlacklistSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "blacklist" */
export enum BlacklistUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type BlacklistUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BlacklistIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BlacklistSetInput>;
  /** filter the rows which have to be updated */
  where: BlacklistBoolExp;
};

/** aggregate var_pop on columns */
export type BlacklistVarPopFields = {
  __typename?: 'blacklist_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "blacklist" */
export type BlacklistVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BlacklistVarSampFields = {
  __typename?: 'blacklist_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "blacklist" */
export type BlacklistVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BlacklistVarianceFields = {
  __typename?: 'blacklist_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "blacklist" */
export type BlacklistVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.booking" */
export type BookingBooking = {
  __typename?: 'booking_booking';
  booking_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  end_timestamp: Scalars['timestamptz'];
  /** An object relationship */
  hourly_booking?: Maybe<BookingHourlyBooking>;
  id: Scalars['Int'];
  /** An array relationship */
  invoices: Array<BookingBookingInvoice>;
  /** An aggregate relationship */
  invoices_aggregate: BookingBookingInvoiceAggregate;
  /** An object relationship */
  lot: BookingLot;
  lot_id: Scalars['String'];
  /** An object relationship */
  payment?: Maybe<BookingPayment>;
  /** An array relationship */
  plates: Array<BookingBookingPlate>;
  /** An aggregate relationship */
  plates_aggregate: BookingBookingPlateAggregate;
  pricing_type: Scalars['String'];
  /** An array relationship */
  recurring_bookings: Array<BookingRecurringBooking>;
  /** An aggregate relationship */
  recurring_bookings_aggregate: BookingRecurringBookingAggregate;
  shopper_locale: Scalars['String'];
  start_timestamp: Scalars['timestamptz'];
  status: BookingEnumBookingStatusEnum;
  total_amount: Scalars['numeric'];
  type: BookingBookingTypeEnum;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  whitelists: Array<BookingBookingWhitelist>;
  /** An aggregate relationship */
  whitelists_aggregate: BookingBookingWhitelistAggregate;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingInvoicesArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingInvoicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingPlatesArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingPlatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingRecurringBookingsArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingRecurringBookingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingWhitelistsArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


/** columns and relationships of "booking.booking" */
export type BookingBookingWhitelistsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};

/** aggregated selection of "booking.booking" */
export type BookingBookingAggregate = {
  __typename?: 'booking_booking_aggregate';
  aggregate?: Maybe<BookingBookingAggregateFields>;
  nodes: Array<BookingBooking>;
};

export type BookingBookingAggregateBoolExp = {
  count?: InputMaybe<BookingBookingAggregateBoolExpCount>;
};

export type BookingBookingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingBookingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.booking" */
export type BookingBookingAggregateFields = {
  __typename?: 'booking_booking_aggregate_fields';
  avg?: Maybe<BookingBookingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingBookingMaxFields>;
  min?: Maybe<BookingBookingMinFields>;
  stddev?: Maybe<BookingBookingStddevFields>;
  stddev_pop?: Maybe<BookingBookingStddevPopFields>;
  stddev_samp?: Maybe<BookingBookingStddevSampFields>;
  sum?: Maybe<BookingBookingSumFields>;
  var_pop?: Maybe<BookingBookingVarPopFields>;
  var_samp?: Maybe<BookingBookingVarSampFields>;
  variance?: Maybe<BookingBookingVarianceFields>;
};


/** aggregate fields of "booking.booking" */
export type BookingBookingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.booking" */
export type BookingBookingAggregateOrderBy = {
  avg?: InputMaybe<BookingBookingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingBookingMaxOrderBy>;
  min?: InputMaybe<BookingBookingMinOrderBy>;
  stddev?: InputMaybe<BookingBookingStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingBookingStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingBookingStddevSampOrderBy>;
  sum?: InputMaybe<BookingBookingSumOrderBy>;
  var_pop?: InputMaybe<BookingBookingVarPopOrderBy>;
  var_samp?: InputMaybe<BookingBookingVarSampOrderBy>;
  variance?: InputMaybe<BookingBookingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.booking" */
export type BookingBookingArrRelInsertInput = {
  data: Array<BookingBookingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingBookingOnConflict>;
};

/** aggregate avg on columns */
export type BookingBookingAvgFields = {
  __typename?: 'booking_booking_avg_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.booking" */
export type BookingBookingAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.booking". All fields are combined with a logical 'AND'. */
export type BookingBookingBoolExp = {
  _and?: InputMaybe<Array<BookingBookingBoolExp>>;
  _not?: InputMaybe<BookingBookingBoolExp>;
  _or?: InputMaybe<Array<BookingBookingBoolExp>>;
  booking_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  end_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  hourly_booking?: InputMaybe<BookingHourlyBookingBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  invoices?: InputMaybe<BookingBookingInvoiceBoolExp>;
  invoices_aggregate?: InputMaybe<BookingBookingInvoiceAggregateBoolExp>;
  lot?: InputMaybe<BookingLotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  payment?: InputMaybe<BookingPaymentBoolExp>;
  plates?: InputMaybe<BookingBookingPlateBoolExp>;
  plates_aggregate?: InputMaybe<BookingBookingPlateAggregateBoolExp>;
  pricing_type?: InputMaybe<StringComparisonExp>;
  recurring_bookings?: InputMaybe<BookingRecurringBookingBoolExp>;
  recurring_bookings_aggregate?: InputMaybe<BookingRecurringBookingAggregateBoolExp>;
  shopper_locale?: InputMaybe<StringComparisonExp>;
  start_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<BookingEnumBookingStatusEnumComparisonExp>;
  total_amount?: InputMaybe<NumericComparisonExp>;
  type?: InputMaybe<BookingBookingTypeEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelists?: InputMaybe<BookingBookingWhitelistBoolExp>;
  whitelists_aggregate?: InputMaybe<BookingBookingWhitelistAggregateBoolExp>;
};

/** unique or primary key constraints on table "booking.booking" */
export enum BookingBookingConstraint {
  /** unique or primary key constraint on columns "booking_id" */
  BookingBookingIdKey = 'booking_booking_id_key',
  /** unique or primary key constraint on columns "id" */
  BookingPkey = 'booking_pkey'
}

/** input type for incrementing numeric columns in table "booking.booking" */
export type BookingBookingIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "booking.booking" */
export type BookingBookingInsertInput = {
  booking_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  end_timestamp?: InputMaybe<Scalars['timestamptz']>;
  hourly_booking?: InputMaybe<BookingHourlyBookingObjRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  invoices?: InputMaybe<BookingBookingInvoiceArrRelInsertInput>;
  lot?: InputMaybe<BookingLotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentObjRelInsertInput>;
  plates?: InputMaybe<BookingBookingPlateArrRelInsertInput>;
  pricing_type?: InputMaybe<Scalars['String']>;
  recurring_bookings?: InputMaybe<BookingRecurringBookingArrRelInsertInput>;
  shopper_locale?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BookingEnumBookingStatusEnum>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<BookingBookingTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelists?: InputMaybe<BookingBookingWhitelistArrRelInsertInput>;
};

/** columns and relationships of "booking.booking_invoice" */
export type BookingBookingInvoice = {
  __typename?: 'booking_booking_invoice';
  booking_id: Scalars['Int'];
  invoice_id: Scalars['String'];
};

/** aggregated selection of "booking.booking_invoice" */
export type BookingBookingInvoiceAggregate = {
  __typename?: 'booking_booking_invoice_aggregate';
  aggregate?: Maybe<BookingBookingInvoiceAggregateFields>;
  nodes: Array<BookingBookingInvoice>;
};

export type BookingBookingInvoiceAggregateBoolExp = {
  count?: InputMaybe<BookingBookingInvoiceAggregateBoolExpCount>;
};

export type BookingBookingInvoiceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingBookingInvoiceBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.booking_invoice" */
export type BookingBookingInvoiceAggregateFields = {
  __typename?: 'booking_booking_invoice_aggregate_fields';
  avg?: Maybe<BookingBookingInvoiceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingBookingInvoiceMaxFields>;
  min?: Maybe<BookingBookingInvoiceMinFields>;
  stddev?: Maybe<BookingBookingInvoiceStddevFields>;
  stddev_pop?: Maybe<BookingBookingInvoiceStddevPopFields>;
  stddev_samp?: Maybe<BookingBookingInvoiceStddevSampFields>;
  sum?: Maybe<BookingBookingInvoiceSumFields>;
  var_pop?: Maybe<BookingBookingInvoiceVarPopFields>;
  var_samp?: Maybe<BookingBookingInvoiceVarSampFields>;
  variance?: Maybe<BookingBookingInvoiceVarianceFields>;
};


/** aggregate fields of "booking.booking_invoice" */
export type BookingBookingInvoiceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.booking_invoice" */
export type BookingBookingInvoiceAggregateOrderBy = {
  avg?: InputMaybe<BookingBookingInvoiceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingBookingInvoiceMaxOrderBy>;
  min?: InputMaybe<BookingBookingInvoiceMinOrderBy>;
  stddev?: InputMaybe<BookingBookingInvoiceStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingBookingInvoiceStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingBookingInvoiceStddevSampOrderBy>;
  sum?: InputMaybe<BookingBookingInvoiceSumOrderBy>;
  var_pop?: InputMaybe<BookingBookingInvoiceVarPopOrderBy>;
  var_samp?: InputMaybe<BookingBookingInvoiceVarSampOrderBy>;
  variance?: InputMaybe<BookingBookingInvoiceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.booking_invoice" */
export type BookingBookingInvoiceArrRelInsertInput = {
  data: Array<BookingBookingInvoiceInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingBookingInvoiceOnConflict>;
};

/** aggregate avg on columns */
export type BookingBookingInvoiceAvgFields = {
  __typename?: 'booking_booking_invoice_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceAvgOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.booking_invoice". All fields are combined with a logical 'AND'. */
export type BookingBookingInvoiceBoolExp = {
  _and?: InputMaybe<Array<BookingBookingInvoiceBoolExp>>;
  _not?: InputMaybe<BookingBookingInvoiceBoolExp>;
  _or?: InputMaybe<Array<BookingBookingInvoiceBoolExp>>;
  booking_id?: InputMaybe<IntComparisonExp>;
  invoice_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.booking_invoice" */
export enum BookingBookingInvoiceConstraint {
  /** unique or primary key constraint on columns "invoice_id", "booking_id" */
  BookingInvoicePkey = 'booking_invoice_pkey'
}

/** input type for incrementing numeric columns in table "booking.booking_invoice" */
export type BookingBookingInvoiceIncInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.booking_invoice" */
export type BookingBookingInvoiceInsertInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  invoice_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingBookingInvoiceMaxFields = {
  __typename?: 'booking_booking_invoice_max_fields';
  booking_id?: Maybe<Scalars['Int']>;
  invoice_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingBookingInvoiceMinFields = {
  __typename?: 'booking_booking_invoice_min_fields';
  booking_id?: Maybe<Scalars['Int']>;
  invoice_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.booking_invoice" */
export type BookingBookingInvoiceMutationResponse = {
  __typename?: 'booking_booking_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingBookingInvoice>;
};

/** on_conflict condition type for table "booking.booking_invoice" */
export type BookingBookingInvoiceOnConflict = {
  constraint: BookingBookingInvoiceConstraint;
  update_columns?: Array<BookingBookingInvoiceUpdateColumn>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};

/** Ordering options when selecting data from "booking.booking_invoice". */
export type BookingBookingInvoiceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.booking_invoice */
export type BookingBookingInvoicePkColumnsInput = {
  booking_id: Scalars['Int'];
  invoice_id: Scalars['String'];
};

/** select columns of table "booking.booking_invoice" */
export enum BookingBookingInvoiceSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  InvoiceId = 'invoice_id'
}

/** input type for updating data in table "booking.booking_invoice" */
export type BookingBookingInvoiceSetInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  invoice_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BookingBookingInvoiceStddevFields = {
  __typename?: 'booking_booking_invoice_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceStddevOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingBookingInvoiceStddevPopFields = {
  __typename?: 'booking_booking_invoice_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceStddevPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingBookingInvoiceStddevSampFields = {
  __typename?: 'booking_booking_invoice_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceStddevSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_booking_invoice" */
export type BookingBookingInvoiceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingBookingInvoiceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingBookingInvoiceStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  invoice_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BookingBookingInvoiceSumFields = {
  __typename?: 'booking_booking_invoice_sum_fields';
  booking_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceSumOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.booking_invoice" */
export enum BookingBookingInvoiceUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  InvoiceId = 'invoice_id'
}

export type BookingBookingInvoiceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingBookingInvoiceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingBookingInvoiceSetInput>;
  /** filter the rows which have to be updated */
  where: BookingBookingInvoiceBoolExp;
};

/** aggregate var_pop on columns */
export type BookingBookingInvoiceVarPopFields = {
  __typename?: 'booking_booking_invoice_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceVarPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingBookingInvoiceVarSampFields = {
  __typename?: 'booking_booking_invoice_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceVarSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingBookingInvoiceVarianceFields = {
  __typename?: 'booking_booking_invoice_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.booking_invoice" */
export type BookingBookingInvoiceVarianceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type BookingBookingMaxFields = {
  __typename?: 'booking_booking_max_fields';
  booking_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  pricing_type?: Maybe<Scalars['String']>;
  shopper_locale?: Maybe<Scalars['String']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "booking.booking" */
export type BookingBookingMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  end_timestamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pricing_type?: InputMaybe<OrderBy>;
  shopper_locale?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingBookingMinFields = {
  __typename?: 'booking_booking_min_fields';
  booking_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  pricing_type?: Maybe<Scalars['String']>;
  shopper_locale?: Maybe<Scalars['String']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "booking.booking" */
export type BookingBookingMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  end_timestamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pricing_type?: InputMaybe<OrderBy>;
  shopper_locale?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.booking" */
export type BookingBookingMutationResponse = {
  __typename?: 'booking_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingBooking>;
};

/** input type for inserting object relation for remote table "booking.booking" */
export type BookingBookingObjRelInsertInput = {
  data: BookingBookingInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingBookingOnConflict>;
};

/** on_conflict condition type for table "booking.booking" */
export type BookingBookingOnConflict = {
  constraint: BookingBookingConstraint;
  update_columns?: Array<BookingBookingUpdateColumn>;
  where?: InputMaybe<BookingBookingBoolExp>;
};

/** Ordering options when selecting data from "booking.booking". */
export type BookingBookingOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  end_timestamp?: InputMaybe<OrderBy>;
  hourly_booking?: InputMaybe<BookingHourlyBookingOrderBy>;
  id?: InputMaybe<OrderBy>;
  invoices_aggregate?: InputMaybe<BookingBookingInvoiceAggregateOrderBy>;
  lot?: InputMaybe<BookingLotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  payment?: InputMaybe<BookingPaymentOrderBy>;
  plates_aggregate?: InputMaybe<BookingBookingPlateAggregateOrderBy>;
  pricing_type?: InputMaybe<OrderBy>;
  recurring_bookings_aggregate?: InputMaybe<BookingRecurringBookingAggregateOrderBy>;
  shopper_locale?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelists_aggregate?: InputMaybe<BookingBookingWhitelistAggregateOrderBy>;
};

/** primary key columns input for table: booking.booking */
export type BookingBookingPkColumnsInput = {
  id: Scalars['Int'];
};

/** columns and relationships of "booking.booking_plate" */
export type BookingBookingPlate = {
  __typename?: 'booking_booking_plate';
  booking_id: Scalars['Int'];
  plate: Scalars['String'];
};

/** aggregated selection of "booking.booking_plate" */
export type BookingBookingPlateAggregate = {
  __typename?: 'booking_booking_plate_aggregate';
  aggregate?: Maybe<BookingBookingPlateAggregateFields>;
  nodes: Array<BookingBookingPlate>;
};

export type BookingBookingPlateAggregateBoolExp = {
  count?: InputMaybe<BookingBookingPlateAggregateBoolExpCount>;
};

export type BookingBookingPlateAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingBookingPlateBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.booking_plate" */
export type BookingBookingPlateAggregateFields = {
  __typename?: 'booking_booking_plate_aggregate_fields';
  avg?: Maybe<BookingBookingPlateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingBookingPlateMaxFields>;
  min?: Maybe<BookingBookingPlateMinFields>;
  stddev?: Maybe<BookingBookingPlateStddevFields>;
  stddev_pop?: Maybe<BookingBookingPlateStddevPopFields>;
  stddev_samp?: Maybe<BookingBookingPlateStddevSampFields>;
  sum?: Maybe<BookingBookingPlateSumFields>;
  var_pop?: Maybe<BookingBookingPlateVarPopFields>;
  var_samp?: Maybe<BookingBookingPlateVarSampFields>;
  variance?: Maybe<BookingBookingPlateVarianceFields>;
};


/** aggregate fields of "booking.booking_plate" */
export type BookingBookingPlateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.booking_plate" */
export type BookingBookingPlateAggregateOrderBy = {
  avg?: InputMaybe<BookingBookingPlateAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingBookingPlateMaxOrderBy>;
  min?: InputMaybe<BookingBookingPlateMinOrderBy>;
  stddev?: InputMaybe<BookingBookingPlateStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingBookingPlateStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingBookingPlateStddevSampOrderBy>;
  sum?: InputMaybe<BookingBookingPlateSumOrderBy>;
  var_pop?: InputMaybe<BookingBookingPlateVarPopOrderBy>;
  var_samp?: InputMaybe<BookingBookingPlateVarSampOrderBy>;
  variance?: InputMaybe<BookingBookingPlateVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.booking_plate" */
export type BookingBookingPlateArrRelInsertInput = {
  data: Array<BookingBookingPlateInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingBookingPlateOnConflict>;
};

/** aggregate avg on columns */
export type BookingBookingPlateAvgFields = {
  __typename?: 'booking_booking_plate_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.booking_plate" */
export type BookingBookingPlateAvgOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.booking_plate". All fields are combined with a logical 'AND'. */
export type BookingBookingPlateBoolExp = {
  _and?: InputMaybe<Array<BookingBookingPlateBoolExp>>;
  _not?: InputMaybe<BookingBookingPlateBoolExp>;
  _or?: InputMaybe<Array<BookingBookingPlateBoolExp>>;
  booking_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.booking_plate" */
export enum BookingBookingPlateConstraint {
  /** unique or primary key constraint on columns "plate", "booking_id" */
  BookingPlatePkey = 'booking_plate_pkey'
}

/** input type for incrementing numeric columns in table "booking.booking_plate" */
export type BookingBookingPlateIncInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.booking_plate" */
export type BookingBookingPlateInsertInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingBookingPlateMaxFields = {
  __typename?: 'booking_booking_plate_max_fields';
  booking_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "booking.booking_plate" */
export type BookingBookingPlateMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingBookingPlateMinFields = {
  __typename?: 'booking_booking_plate_min_fields';
  booking_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "booking.booking_plate" */
export type BookingBookingPlateMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.booking_plate" */
export type BookingBookingPlateMutationResponse = {
  __typename?: 'booking_booking_plate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingBookingPlate>;
};

/** on_conflict condition type for table "booking.booking_plate" */
export type BookingBookingPlateOnConflict = {
  constraint: BookingBookingPlateConstraint;
  update_columns?: Array<BookingBookingPlateUpdateColumn>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};

/** Ordering options when selecting data from "booking.booking_plate". */
export type BookingBookingPlateOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.booking_plate */
export type BookingBookingPlatePkColumnsInput = {
  booking_id: Scalars['Int'];
  plate: Scalars['String'];
};

/** select columns of table "booking.booking_plate" */
export enum BookingBookingPlateSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  Plate = 'plate'
}

/** input type for updating data in table "booking.booking_plate" */
export type BookingBookingPlateSetInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BookingBookingPlateStddevFields = {
  __typename?: 'booking_booking_plate_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.booking_plate" */
export type BookingBookingPlateStddevOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingBookingPlateStddevPopFields = {
  __typename?: 'booking_booking_plate_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.booking_plate" */
export type BookingBookingPlateStddevPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingBookingPlateStddevSampFields = {
  __typename?: 'booking_booking_plate_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.booking_plate" */
export type BookingBookingPlateStddevSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_booking_plate" */
export type BookingBookingPlateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingBookingPlateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingBookingPlateStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BookingBookingPlateSumFields = {
  __typename?: 'booking_booking_plate_sum_fields';
  booking_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.booking_plate" */
export type BookingBookingPlateSumOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.booking_plate" */
export enum BookingBookingPlateUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  Plate = 'plate'
}

export type BookingBookingPlateUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingBookingPlateIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingBookingPlateSetInput>;
  /** filter the rows which have to be updated */
  where: BookingBookingPlateBoolExp;
};

/** aggregate var_pop on columns */
export type BookingBookingPlateVarPopFields = {
  __typename?: 'booking_booking_plate_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.booking_plate" */
export type BookingBookingPlateVarPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingBookingPlateVarSampFields = {
  __typename?: 'booking_booking_plate_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.booking_plate" */
export type BookingBookingPlateVarSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingBookingPlateVarianceFields = {
  __typename?: 'booking_booking_plate_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.booking_plate" */
export type BookingBookingPlateVarianceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** select columns of table "booking.booking" */
export enum BookingBookingSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EndTimestamp = 'end_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PricingType = 'pricing_type',
  /** column name */
  ShopperLocale = 'shopper_locale',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "booking.booking" */
export type BookingBookingSetInput = {
  booking_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  end_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pricing_type?: InputMaybe<Scalars['String']>;
  shopper_locale?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BookingEnumBookingStatusEnum>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<BookingBookingTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type BookingBookingStddevFields = {
  __typename?: 'booking_booking_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.booking" */
export type BookingBookingStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingBookingStddevPopFields = {
  __typename?: 'booking_booking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.booking" */
export type BookingBookingStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingBookingStddevSampFields = {
  __typename?: 'booking_booking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.booking" */
export type BookingBookingStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_booking" */
export type BookingBookingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingBookingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingBookingStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  end_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pricing_type?: InputMaybe<Scalars['String']>;
  shopper_locale?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BookingEnumBookingStatusEnum>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<BookingBookingTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type BookingBookingSumFields = {
  __typename?: 'booking_booking_sum_fields';
  id?: Maybe<Scalars['Int']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "booking.booking" */
export type BookingBookingSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** Enum table for the different booking types used within the booking platform */
export type BookingBookingType = {
  __typename?: 'booking_booking_type';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.booking_type" */
export type BookingBookingTypeAggregate = {
  __typename?: 'booking_booking_type_aggregate';
  aggregate?: Maybe<BookingBookingTypeAggregateFields>;
  nodes: Array<BookingBookingType>;
};

/** aggregate fields of "booking.booking_type" */
export type BookingBookingTypeAggregateFields = {
  __typename?: 'booking_booking_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingBookingTypeMaxFields>;
  min?: Maybe<BookingBookingTypeMinFields>;
};


/** aggregate fields of "booking.booking_type" */
export type BookingBookingTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingBookingTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.booking_type". All fields are combined with a logical 'AND'. */
export type BookingBookingTypeBoolExp = {
  _and?: InputMaybe<Array<BookingBookingTypeBoolExp>>;
  _not?: InputMaybe<BookingBookingTypeBoolExp>;
  _or?: InputMaybe<Array<BookingBookingTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.booking_type" */
export enum BookingBookingTypeConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingTypePkey = 'booking_type_pkey'
}

export enum BookingBookingTypeEnum {
  /** A daily booking */
  Daily = 'DAILY',
  /** An hourly booking */
  Hourly = 'HOURLY',
  /** A nightly booking */
  Nightly = 'NIGHTLY'
}

/** Boolean expression to compare columns of type "booking_booking_type_enum". All fields are combined with logical 'AND'. */
export type BookingBookingTypeEnumComparisonExp = {
  _eq?: InputMaybe<BookingBookingTypeEnum>;
  _in?: InputMaybe<Array<BookingBookingTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingBookingTypeEnum>;
  _nin?: InputMaybe<Array<BookingBookingTypeEnum>>;
};

/** input type for inserting data into table "booking.booking_type" */
export type BookingBookingTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingBookingTypeMaxFields = {
  __typename?: 'booking_booking_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingBookingTypeMinFields = {
  __typename?: 'booking_booking_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.booking_type" */
export type BookingBookingTypeMutationResponse = {
  __typename?: 'booking_booking_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingBookingType>;
};

/** on_conflict condition type for table "booking.booking_type" */
export type BookingBookingTypeOnConflict = {
  constraint: BookingBookingTypeConstraint;
  update_columns?: Array<BookingBookingTypeUpdateColumn>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};

/** Ordering options when selecting data from "booking.booking_type". */
export type BookingBookingTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.booking_type */
export type BookingBookingTypePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.booking_type" */
export enum BookingBookingTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.booking_type" */
export type BookingBookingTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_booking_type" */
export type BookingBookingTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingBookingTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingBookingTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.booking_type" */
export enum BookingBookingTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingBookingTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingBookingTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BookingBookingTypeBoolExp;
};

/** update columns of table "booking.booking" */
export enum BookingBookingUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EndTimestamp = 'end_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PricingType = 'pricing_type',
  /** column name */
  ShopperLocale = 'shopper_locale',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type BookingBookingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingBookingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingBookingSetInput>;
  /** filter the rows which have to be updated */
  where: BookingBookingBoolExp;
};

/** aggregate var_pop on columns */
export type BookingBookingVarPopFields = {
  __typename?: 'booking_booking_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.booking" */
export type BookingBookingVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingBookingVarSampFields = {
  __typename?: 'booking_booking_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.booking" */
export type BookingBookingVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingBookingVarianceFields = {
  __typename?: 'booking_booking_variance_fields';
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.booking" */
export type BookingBookingVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  total_amount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.booking_whitelist" */
export type BookingBookingWhitelist = {
  __typename?: 'booking_booking_whitelist';
  booking_id: Scalars['Int'];
  type: BookingWhitelistTypeEnum;
  whitelist_id: Scalars['Int'];
};

/** aggregated selection of "booking.booking_whitelist" */
export type BookingBookingWhitelistAggregate = {
  __typename?: 'booking_booking_whitelist_aggregate';
  aggregate?: Maybe<BookingBookingWhitelistAggregateFields>;
  nodes: Array<BookingBookingWhitelist>;
};

export type BookingBookingWhitelistAggregateBoolExp = {
  count?: InputMaybe<BookingBookingWhitelistAggregateBoolExpCount>;
};

export type BookingBookingWhitelistAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingBookingWhitelistBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.booking_whitelist" */
export type BookingBookingWhitelistAggregateFields = {
  __typename?: 'booking_booking_whitelist_aggregate_fields';
  avg?: Maybe<BookingBookingWhitelistAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingBookingWhitelistMaxFields>;
  min?: Maybe<BookingBookingWhitelistMinFields>;
  stddev?: Maybe<BookingBookingWhitelistStddevFields>;
  stddev_pop?: Maybe<BookingBookingWhitelistStddevPopFields>;
  stddev_samp?: Maybe<BookingBookingWhitelistStddevSampFields>;
  sum?: Maybe<BookingBookingWhitelistSumFields>;
  var_pop?: Maybe<BookingBookingWhitelistVarPopFields>;
  var_samp?: Maybe<BookingBookingWhitelistVarSampFields>;
  variance?: Maybe<BookingBookingWhitelistVarianceFields>;
};


/** aggregate fields of "booking.booking_whitelist" */
export type BookingBookingWhitelistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.booking_whitelist" */
export type BookingBookingWhitelistAggregateOrderBy = {
  avg?: InputMaybe<BookingBookingWhitelistAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingBookingWhitelistMaxOrderBy>;
  min?: InputMaybe<BookingBookingWhitelistMinOrderBy>;
  stddev?: InputMaybe<BookingBookingWhitelistStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingBookingWhitelistStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingBookingWhitelistStddevSampOrderBy>;
  sum?: InputMaybe<BookingBookingWhitelistSumOrderBy>;
  var_pop?: InputMaybe<BookingBookingWhitelistVarPopOrderBy>;
  var_samp?: InputMaybe<BookingBookingWhitelistVarSampOrderBy>;
  variance?: InputMaybe<BookingBookingWhitelistVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.booking_whitelist" */
export type BookingBookingWhitelistArrRelInsertInput = {
  data: Array<BookingBookingWhitelistInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingBookingWhitelistOnConflict>;
};

/** aggregate avg on columns */
export type BookingBookingWhitelistAvgFields = {
  __typename?: 'booking_booking_whitelist_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistAvgOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.booking_whitelist". All fields are combined with a logical 'AND'. */
export type BookingBookingWhitelistBoolExp = {
  _and?: InputMaybe<Array<BookingBookingWhitelistBoolExp>>;
  _not?: InputMaybe<BookingBookingWhitelistBoolExp>;
  _or?: InputMaybe<Array<BookingBookingWhitelistBoolExp>>;
  booking_id?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<BookingWhitelistTypeEnumComparisonExp>;
  whitelist_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "booking.booking_whitelist" */
export enum BookingBookingWhitelistConstraint {
  /** unique or primary key constraint on columns "whitelist_id", "booking_id" */
  BookingWhitelistPkey = 'booking_whitelist_pkey'
}

/** input type for incrementing numeric columns in table "booking.booking_whitelist" */
export type BookingBookingWhitelistIncInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.booking_whitelist" */
export type BookingBookingWhitelistInsertInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<BookingWhitelistTypeEnum>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type BookingBookingWhitelistMaxFields = {
  __typename?: 'booking_booking_whitelist_max_fields';
  booking_id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingBookingWhitelistMinFields = {
  __typename?: 'booking_booking_whitelist_min_fields';
  booking_id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.booking_whitelist" */
export type BookingBookingWhitelistMutationResponse = {
  __typename?: 'booking_booking_whitelist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingBookingWhitelist>;
};

/** on_conflict condition type for table "booking.booking_whitelist" */
export type BookingBookingWhitelistOnConflict = {
  constraint: BookingBookingWhitelistConstraint;
  update_columns?: Array<BookingBookingWhitelistUpdateColumn>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};

/** Ordering options when selecting data from "booking.booking_whitelist". */
export type BookingBookingWhitelistOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.booking_whitelist */
export type BookingBookingWhitelistPkColumnsInput = {
  booking_id: Scalars['Int'];
  whitelist_id: Scalars['Int'];
};

/** select columns of table "booking.booking_whitelist" */
export enum BookingBookingWhitelistSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  Type = 'type',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "booking.booking_whitelist" */
export type BookingBookingWhitelistSetInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<BookingWhitelistTypeEnum>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type BookingBookingWhitelistStddevFields = {
  __typename?: 'booking_booking_whitelist_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistStddevOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingBookingWhitelistStddevPopFields = {
  __typename?: 'booking_booking_whitelist_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistStddevPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingBookingWhitelistStddevSampFields = {
  __typename?: 'booking_booking_whitelist_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistStddevSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_booking_whitelist" */
export type BookingBookingWhitelistStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingBookingWhitelistStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingBookingWhitelistStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<BookingWhitelistTypeEnum>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type BookingBookingWhitelistSumFields = {
  __typename?: 'booking_booking_whitelist_sum_fields';
  booking_id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistSumOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.booking_whitelist" */
export enum BookingBookingWhitelistUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  Type = 'type',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type BookingBookingWhitelistUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingBookingWhitelistIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingBookingWhitelistSetInput>;
  /** filter the rows which have to be updated */
  where: BookingBookingWhitelistBoolExp;
};

/** aggregate var_pop on columns */
export type BookingBookingWhitelistVarPopFields = {
  __typename?: 'booking_booking_whitelist_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistVarPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingBookingWhitelistVarSampFields = {
  __typename?: 'booking_booking_whitelist_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistVarSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingBookingWhitelistVarianceFields = {
  __typename?: 'booking_booking_whitelist_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.booking_whitelist" */
export type BookingBookingWhitelistVarianceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.enum_booking_status" */
export type BookingEnumBookingStatus = {
  __typename?: 'booking_enum_booking_status';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.enum_booking_status" */
export type BookingEnumBookingStatusAggregate = {
  __typename?: 'booking_enum_booking_status_aggregate';
  aggregate?: Maybe<BookingEnumBookingStatusAggregateFields>;
  nodes: Array<BookingEnumBookingStatus>;
};

/** aggregate fields of "booking.enum_booking_status" */
export type BookingEnumBookingStatusAggregateFields = {
  __typename?: 'booking_enum_booking_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingEnumBookingStatusMaxFields>;
  min?: Maybe<BookingEnumBookingStatusMinFields>;
};


/** aggregate fields of "booking.enum_booking_status" */
export type BookingEnumBookingStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingEnumBookingStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.enum_booking_status". All fields are combined with a logical 'AND'. */
export type BookingEnumBookingStatusBoolExp = {
  _and?: InputMaybe<Array<BookingEnumBookingStatusBoolExp>>;
  _not?: InputMaybe<BookingEnumBookingStatusBoolExp>;
  _or?: InputMaybe<Array<BookingEnumBookingStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.enum_booking_status" */
export enum BookingEnumBookingStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  EnumBookingStatusPkey = 'enum_booking_status_pkey'
}

export enum BookingEnumBookingStatusEnum {
  /** Payment from booking has been received */
  Paid = 'PAID',
  /** Booking confirmed but payment is still pending */
  PaymentPending = 'PAYMENT_PENDING',
  /** The booking order just got created and has yet to be paid */
  Unpaid = 'UNPAID'
}

/** Boolean expression to compare columns of type "booking_enum_booking_status_enum". All fields are combined with logical 'AND'. */
export type BookingEnumBookingStatusEnumComparisonExp = {
  _eq?: InputMaybe<BookingEnumBookingStatusEnum>;
  _in?: InputMaybe<Array<BookingEnumBookingStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingEnumBookingStatusEnum>;
  _nin?: InputMaybe<Array<BookingEnumBookingStatusEnum>>;
};

/** input type for inserting data into table "booking.enum_booking_status" */
export type BookingEnumBookingStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingEnumBookingStatusMaxFields = {
  __typename?: 'booking_enum_booking_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingEnumBookingStatusMinFields = {
  __typename?: 'booking_enum_booking_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.enum_booking_status" */
export type BookingEnumBookingStatusMutationResponse = {
  __typename?: 'booking_enum_booking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingEnumBookingStatus>;
};

/** on_conflict condition type for table "booking.enum_booking_status" */
export type BookingEnumBookingStatusOnConflict = {
  constraint: BookingEnumBookingStatusConstraint;
  update_columns?: Array<BookingEnumBookingStatusUpdateColumn>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};

/** Ordering options when selecting data from "booking.enum_booking_status". */
export type BookingEnumBookingStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.enum_booking_status */
export type BookingEnumBookingStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.enum_booking_status" */
export enum BookingEnumBookingStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.enum_booking_status" */
export type BookingEnumBookingStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_enum_booking_status" */
export type BookingEnumBookingStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingEnumBookingStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingEnumBookingStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.enum_booking_status" */
export enum BookingEnumBookingStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingEnumBookingStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingEnumBookingStatusSetInput>;
  /** filter the rows which have to be updated */
  where: BookingEnumBookingStatusBoolExp;
};

/** columns and relationships of "booking.hourly_booking" */
export type BookingHourlyBooking = {
  __typename?: 'booking_hourly_booking';
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
};

/** aggregated selection of "booking.hourly_booking" */
export type BookingHourlyBookingAggregate = {
  __typename?: 'booking_hourly_booking_aggregate';
  aggregate?: Maybe<BookingHourlyBookingAggregateFields>;
  nodes: Array<BookingHourlyBooking>;
};

/** aggregate fields of "booking.hourly_booking" */
export type BookingHourlyBookingAggregateFields = {
  __typename?: 'booking_hourly_booking_aggregate_fields';
  avg?: Maybe<BookingHourlyBookingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingHourlyBookingMaxFields>;
  min?: Maybe<BookingHourlyBookingMinFields>;
  stddev?: Maybe<BookingHourlyBookingStddevFields>;
  stddev_pop?: Maybe<BookingHourlyBookingStddevPopFields>;
  stddev_samp?: Maybe<BookingHourlyBookingStddevSampFields>;
  sum?: Maybe<BookingHourlyBookingSumFields>;
  var_pop?: Maybe<BookingHourlyBookingVarPopFields>;
  var_samp?: Maybe<BookingHourlyBookingVarSampFields>;
  variance?: Maybe<BookingHourlyBookingVarianceFields>;
};


/** aggregate fields of "booking.hourly_booking" */
export type BookingHourlyBookingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingHourlyBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BookingHourlyBookingAvgFields = {
  __typename?: 'booking_hourly_booking_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booking.hourly_booking". All fields are combined with a logical 'AND'. */
export type BookingHourlyBookingBoolExp = {
  _and?: InputMaybe<Array<BookingHourlyBookingBoolExp>>;
  _not?: InputMaybe<BookingHourlyBookingBoolExp>;
  _or?: InputMaybe<Array<BookingHourlyBookingBoolExp>>;
  booking_id?: InputMaybe<IntComparisonExp>;
  iso_duration?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.hourly_booking" */
export enum BookingHourlyBookingConstraint {
  /** unique or primary key constraint on columns "booking_id" */
  HourlyBookingPkey = 'hourly_booking_pkey'
}

/** input type for incrementing numeric columns in table "booking.hourly_booking" */
export type BookingHourlyBookingIncInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.hourly_booking" */
export type BookingHourlyBookingInsertInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingHourlyBookingMaxFields = {
  __typename?: 'booking_hourly_booking_max_fields';
  booking_id?: Maybe<Scalars['Int']>;
  iso_duration?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingHourlyBookingMinFields = {
  __typename?: 'booking_hourly_booking_min_fields';
  booking_id?: Maybe<Scalars['Int']>;
  iso_duration?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.hourly_booking" */
export type BookingHourlyBookingMutationResponse = {
  __typename?: 'booking_hourly_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingHourlyBooking>;
};

/** input type for inserting object relation for remote table "booking.hourly_booking" */
export type BookingHourlyBookingObjRelInsertInput = {
  data: BookingHourlyBookingInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingHourlyBookingOnConflict>;
};

/** on_conflict condition type for table "booking.hourly_booking" */
export type BookingHourlyBookingOnConflict = {
  constraint: BookingHourlyBookingConstraint;
  update_columns?: Array<BookingHourlyBookingUpdateColumn>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};

/** Ordering options when selecting data from "booking.hourly_booking". */
export type BookingHourlyBookingOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  iso_duration?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.hourly_booking */
export type BookingHourlyBookingPkColumnsInput = {
  booking_id: Scalars['Int'];
};

/** select columns of table "booking.hourly_booking" */
export enum BookingHourlyBookingSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  IsoDuration = 'iso_duration'
}

/** input type for updating data in table "booking.hourly_booking" */
export type BookingHourlyBookingSetInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BookingHourlyBookingStddevFields = {
  __typename?: 'booking_hourly_booking_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BookingHourlyBookingStddevPopFields = {
  __typename?: 'booking_hourly_booking_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BookingHourlyBookingStddevSampFields = {
  __typename?: 'booking_hourly_booking_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "booking_hourly_booking" */
export type BookingHourlyBookingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingHourlyBookingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingHourlyBookingStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BookingHourlyBookingSumFields = {
  __typename?: 'booking_hourly_booking_sum_fields';
  booking_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "booking.hourly_booking" */
export enum BookingHourlyBookingUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  IsoDuration = 'iso_duration'
}

export type BookingHourlyBookingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingHourlyBookingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingHourlyBookingSetInput>;
  /** filter the rows which have to be updated */
  where: BookingHourlyBookingBoolExp;
};

/** aggregate var_pop on columns */
export type BookingHourlyBookingVarPopFields = {
  __typename?: 'booking_hourly_booking_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BookingHourlyBookingVarSampFields = {
  __typename?: 'booking_hourly_booking_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BookingHourlyBookingVarianceFields = {
  __typename?: 'booking_hourly_booking_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "booking.license_plate" */
export type BookingLicensePlate = {
  __typename?: 'booking_license_plate';
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  plate: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "booking.license_plate" */
export type BookingLicensePlateAggregate = {
  __typename?: 'booking_license_plate_aggregate';
  aggregate?: Maybe<BookingLicensePlateAggregateFields>;
  nodes: Array<BookingLicensePlate>;
};

/** aggregate fields of "booking.license_plate" */
export type BookingLicensePlateAggregateFields = {
  __typename?: 'booking_license_plate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingLicensePlateMaxFields>;
  min?: Maybe<BookingLicensePlateMinFields>;
};


/** aggregate fields of "booking.license_plate" */
export type BookingLicensePlateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingLicensePlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.license_plate". All fields are combined with a logical 'AND'. */
export type BookingLicensePlateBoolExp = {
  _and?: InputMaybe<Array<BookingLicensePlateBoolExp>>;
  _not?: InputMaybe<BookingLicensePlateBoolExp>;
  _or?: InputMaybe<Array<BookingLicensePlateBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.license_plate" */
export enum BookingLicensePlateConstraint {
  /** unique or primary key constraint on columns "id" */
  LicensePlatePkey = 'license_plate_pkey'
}

/** input type for inserting data into table "booking.license_plate" */
export type BookingLicensePlateInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingLicensePlateMaxFields = {
  __typename?: 'booking_license_plate_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type BookingLicensePlateMinFields = {
  __typename?: 'booking_license_plate_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "booking.license_plate" */
export type BookingLicensePlateMutationResponse = {
  __typename?: 'booking_license_plate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingLicensePlate>;
};

/** input type for inserting object relation for remote table "booking.license_plate" */
export type BookingLicensePlateObjRelInsertInput = {
  data: BookingLicensePlateInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingLicensePlateOnConflict>;
};

/** on_conflict condition type for table "booking.license_plate" */
export type BookingLicensePlateOnConflict = {
  constraint: BookingLicensePlateConstraint;
  update_columns?: Array<BookingLicensePlateUpdateColumn>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};

/** Ordering options when selecting data from "booking.license_plate". */
export type BookingLicensePlateOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.license_plate */
export type BookingLicensePlatePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "booking.license_plate" */
export enum BookingLicensePlateSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Plate = 'plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "booking.license_plate" */
export type BookingLicensePlateSetInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "booking_license_plate" */
export type BookingLicensePlateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingLicensePlateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingLicensePlateStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "booking.license_plate" */
export enum BookingLicensePlateUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Plate = 'plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type BookingLicensePlateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingLicensePlateSetInput>;
  /** filter the rows which have to be updated */
  where: BookingLicensePlateBoolExp;
};

/** columns and relationships of "booking.lot" */
export type BookingLot = {
  __typename?: 'booking_lot';
  adyen_merchant_id: Scalars['String'];
  /** An array relationship */
  bookings: Array<BookingBooking>;
  /** An aggregate relationship */
  bookings_aggregate: BookingBookingAggregate;
  /** An array relationship */
  configurations: Array<BookingLotConfiguration>;
  /** An aggregate relationship */
  configurations_aggregate: BookingLotConfigurationAggregate;
  go_live_date: Scalars['timestamptz'];
  id: Scalars['String'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  /** An object relationship */
  lot: Lot;
  /** An array relationship */
  pricing_rules: Array<BookingPricingRules>;
  /** An aggregate relationship */
  pricing_rules_aggregate: BookingPricingRulesAggregate;
};


/** columns and relationships of "booking.lot" */
export type BookingLotBookingsArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


/** columns and relationships of "booking.lot" */
export type BookingLotBookingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


/** columns and relationships of "booking.lot" */
export type BookingLotConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


/** columns and relationships of "booking.lot" */
export type BookingLotConfigurationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


/** columns and relationships of "booking.lot" */
export type BookingLotPricingRulesArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


/** columns and relationships of "booking.lot" */
export type BookingLotPricingRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};

/** aggregated selection of "booking.lot" */
export type BookingLotAggregate = {
  __typename?: 'booking_lot_aggregate';
  aggregate?: Maybe<BookingLotAggregateFields>;
  nodes: Array<BookingLot>;
};

/** aggregate fields of "booking.lot" */
export type BookingLotAggregateFields = {
  __typename?: 'booking_lot_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingLotMaxFields>;
  min?: Maybe<BookingLotMinFields>;
};


/** aggregate fields of "booking.lot" */
export type BookingLotAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingLotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.lot". All fields are combined with a logical 'AND'. */
export type BookingLotBoolExp = {
  _and?: InputMaybe<Array<BookingLotBoolExp>>;
  _not?: InputMaybe<BookingLotBoolExp>;
  _or?: InputMaybe<Array<BookingLotBoolExp>>;
  adyen_merchant_id?: InputMaybe<StringComparisonExp>;
  bookings?: InputMaybe<BookingBookingBoolExp>;
  bookings_aggregate?: InputMaybe<BookingBookingAggregateBoolExp>;
  configurations?: InputMaybe<BookingLotConfigurationBoolExp>;
  configurations_aggregate?: InputMaybe<BookingLotConfigurationAggregateBoolExp>;
  go_live_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  is_active?: InputMaybe<BooleanComparisonExp>;
  is_public?: InputMaybe<BooleanComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  pricing_rules?: InputMaybe<BookingPricingRulesBoolExp>;
  pricing_rules_aggregate?: InputMaybe<BookingPricingRulesAggregateBoolExp>;
};

/** columns and relationships of "booking.lot_configuration" */
export type BookingLotConfiguration = {
  __typename?: 'booking_lot_configuration';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['jsonb']>;
  earliest_booking_date: Scalars['date'];
  end_of_live_date: Scalars['date'];
  id: Scalars['bigint'];
  lot_id: Scalars['String'];
  max_booking_duration: Scalars['String'];
  min_booking_duration: Scalars['String'];
  opening_hours: Scalars['jsonb'];
  policy: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
};


/** columns and relationships of "booking.lot_configuration" */
export type BookingLotConfigurationDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "booking.lot_configuration" */
export type BookingLotConfigurationOpeningHoursArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "booking.lot_configuration" */
export type BookingLotConfigurationPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "booking.lot_configuration" */
export type BookingLotConfigurationAggregate = {
  __typename?: 'booking_lot_configuration_aggregate';
  aggregate?: Maybe<BookingLotConfigurationAggregateFields>;
  nodes: Array<BookingLotConfiguration>;
};

export type BookingLotConfigurationAggregateBoolExp = {
  count?: InputMaybe<BookingLotConfigurationAggregateBoolExpCount>;
};

export type BookingLotConfigurationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingLotConfigurationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.lot_configuration" */
export type BookingLotConfigurationAggregateFields = {
  __typename?: 'booking_lot_configuration_aggregate_fields';
  avg?: Maybe<BookingLotConfigurationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingLotConfigurationMaxFields>;
  min?: Maybe<BookingLotConfigurationMinFields>;
  stddev?: Maybe<BookingLotConfigurationStddevFields>;
  stddev_pop?: Maybe<BookingLotConfigurationStddevPopFields>;
  stddev_samp?: Maybe<BookingLotConfigurationStddevSampFields>;
  sum?: Maybe<BookingLotConfigurationSumFields>;
  var_pop?: Maybe<BookingLotConfigurationVarPopFields>;
  var_samp?: Maybe<BookingLotConfigurationVarSampFields>;
  variance?: Maybe<BookingLotConfigurationVarianceFields>;
};


/** aggregate fields of "booking.lot_configuration" */
export type BookingLotConfigurationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.lot_configuration" */
export type BookingLotConfigurationAggregateOrderBy = {
  avg?: InputMaybe<BookingLotConfigurationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingLotConfigurationMaxOrderBy>;
  min?: InputMaybe<BookingLotConfigurationMinOrderBy>;
  stddev?: InputMaybe<BookingLotConfigurationStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingLotConfigurationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingLotConfigurationStddevSampOrderBy>;
  sum?: InputMaybe<BookingLotConfigurationSumOrderBy>;
  var_pop?: InputMaybe<BookingLotConfigurationVarPopOrderBy>;
  var_samp?: InputMaybe<BookingLotConfigurationVarSampOrderBy>;
  variance?: InputMaybe<BookingLotConfigurationVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BookingLotConfigurationAppendInput = {
  description?: InputMaybe<Scalars['jsonb']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "booking.lot_configuration" */
export type BookingLotConfigurationArrRelInsertInput = {
  data: Array<BookingLotConfigurationInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingLotConfigurationOnConflict>;
};

/** aggregate avg on columns */
export type BookingLotConfigurationAvgFields = {
  __typename?: 'booking_lot_configuration_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.lot_configuration". All fields are combined with a logical 'AND'. */
export type BookingLotConfigurationBoolExp = {
  _and?: InputMaybe<Array<BookingLotConfigurationBoolExp>>;
  _not?: InputMaybe<BookingLotConfigurationBoolExp>;
  _or?: InputMaybe<Array<BookingLotConfigurationBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<JsonbComparisonExp>;
  earliest_booking_date?: InputMaybe<DateComparisonExp>;
  end_of_live_date?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  max_booking_duration?: InputMaybe<StringComparisonExp>;
  min_booking_duration?: InputMaybe<StringComparisonExp>;
  opening_hours?: InputMaybe<JsonbComparisonExp>;
  policy?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "booking.lot_configuration" */
export enum BookingLotConfigurationConstraint {
  /** unique or primary key constraint on columns "id" */
  LotConfigurationPkey = 'lot_configuration_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BookingLotConfigurationDeleteAtPathInput = {
  description?: InputMaybe<Array<Scalars['String']>>;
  opening_hours?: InputMaybe<Array<Scalars['String']>>;
  policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BookingLotConfigurationDeleteElemInput = {
  description?: InputMaybe<Scalars['Int']>;
  opening_hours?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BookingLotConfigurationDeleteKeyInput = {
  description?: InputMaybe<Scalars['String']>;
  opening_hours?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "booking.lot_configuration" */
export type BookingLotConfigurationIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "booking.lot_configuration" */
export type BookingLotConfigurationInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['jsonb']>;
  earliest_booking_date?: InputMaybe<Scalars['date']>;
  end_of_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_booking_duration?: InputMaybe<Scalars['String']>;
  min_booking_duration?: InputMaybe<Scalars['String']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type BookingLotConfigurationMaxFields = {
  __typename?: 'booking_lot_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  earliest_booking_date?: Maybe<Scalars['date']>;
  end_of_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  max_booking_duration?: Maybe<Scalars['String']>;
  min_booking_duration?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  earliest_booking_date?: InputMaybe<OrderBy>;
  end_of_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  max_booking_duration?: InputMaybe<OrderBy>;
  min_booking_duration?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingLotConfigurationMinFields = {
  __typename?: 'booking_lot_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  earliest_booking_date?: Maybe<Scalars['date']>;
  end_of_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  max_booking_duration?: Maybe<Scalars['String']>;
  min_booking_duration?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  earliest_booking_date?: InputMaybe<OrderBy>;
  end_of_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  max_booking_duration?: InputMaybe<OrderBy>;
  min_booking_duration?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.lot_configuration" */
export type BookingLotConfigurationMutationResponse = {
  __typename?: 'booking_lot_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingLotConfiguration>;
};

/** on_conflict condition type for table "booking.lot_configuration" */
export type BookingLotConfigurationOnConflict = {
  constraint: BookingLotConfigurationConstraint;
  update_columns?: Array<BookingLotConfigurationUpdateColumn>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};

/** Ordering options when selecting data from "booking.lot_configuration". */
export type BookingLotConfigurationOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  earliest_booking_date?: InputMaybe<OrderBy>;
  end_of_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  max_booking_duration?: InputMaybe<OrderBy>;
  min_booking_duration?: InputMaybe<OrderBy>;
  opening_hours?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.lot_configuration */
export type BookingLotConfigurationPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BookingLotConfigurationPrependInput = {
  description?: InputMaybe<Scalars['jsonb']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "booking.lot_configuration" */
export enum BookingLotConfigurationSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EarliestBookingDate = 'earliest_booking_date',
  /** column name */
  EndOfLiveDate = 'end_of_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MaxBookingDuration = 'max_booking_duration',
  /** column name */
  MinBookingDuration = 'min_booking_duration',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  Policy = 'policy',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "booking.lot_configuration" */
export type BookingLotConfigurationSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['jsonb']>;
  earliest_booking_date?: InputMaybe<Scalars['date']>;
  end_of_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_booking_duration?: InputMaybe<Scalars['String']>;
  min_booking_duration?: InputMaybe<Scalars['String']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type BookingLotConfigurationStddevFields = {
  __typename?: 'booking_lot_configuration_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingLotConfigurationStddevPopFields = {
  __typename?: 'booking_lot_configuration_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingLotConfigurationStddevSampFields = {
  __typename?: 'booking_lot_configuration_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_lot_configuration" */
export type BookingLotConfigurationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingLotConfigurationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingLotConfigurationStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['jsonb']>;
  earliest_booking_date?: InputMaybe<Scalars['date']>;
  end_of_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_booking_duration?: InputMaybe<Scalars['String']>;
  min_booking_duration?: InputMaybe<Scalars['String']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type BookingLotConfigurationSumFields = {
  __typename?: 'booking_lot_configuration_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.lot_configuration" */
export enum BookingLotConfigurationUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EarliestBookingDate = 'earliest_booking_date',
  /** column name */
  EndOfLiveDate = 'end_of_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MaxBookingDuration = 'max_booking_duration',
  /** column name */
  MinBookingDuration = 'min_booking_duration',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  Policy = 'policy',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type BookingLotConfigurationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BookingLotConfigurationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BookingLotConfigurationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BookingLotConfigurationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BookingLotConfigurationDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingLotConfigurationIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BookingLotConfigurationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingLotConfigurationSetInput>;
  /** filter the rows which have to be updated */
  where: BookingLotConfigurationBoolExp;
};

/** aggregate var_pop on columns */
export type BookingLotConfigurationVarPopFields = {
  __typename?: 'booking_lot_configuration_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingLotConfigurationVarSampFields = {
  __typename?: 'booking_lot_configuration_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingLotConfigurationVarianceFields = {
  __typename?: 'booking_lot_configuration_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.lot_configuration" */
export type BookingLotConfigurationVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "booking.lot" */
export enum BookingLotConstraint {
  /** unique or primary key constraint on columns "id" */
  LotPkey = 'lot_pkey'
}

/** input type for inserting data into table "booking.lot" */
export type BookingLotInsertInput = {
  adyen_merchant_id?: InputMaybe<Scalars['String']>;
  bookings?: InputMaybe<BookingBookingArrRelInsertInput>;
  configurations?: InputMaybe<BookingLotConfigurationArrRelInsertInput>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  pricing_rules?: InputMaybe<BookingPricingRulesArrRelInsertInput>;
};

/** aggregate max on columns */
export type BookingLotMaxFields = {
  __typename?: 'booking_lot_max_fields';
  adyen_merchant_id?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingLotMinFields = {
  __typename?: 'booking_lot_min_fields';
  adyen_merchant_id?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.lot" */
export type BookingLotMutationResponse = {
  __typename?: 'booking_lot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingLot>;
};

/** input type for inserting object relation for remote table "booking.lot" */
export type BookingLotObjRelInsertInput = {
  data: BookingLotInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingLotOnConflict>;
};

/** on_conflict condition type for table "booking.lot" */
export type BookingLotOnConflict = {
  constraint: BookingLotConstraint;
  update_columns?: Array<BookingLotUpdateColumn>;
  where?: InputMaybe<BookingLotBoolExp>;
};

/** Ordering options when selecting data from "booking.lot". */
export type BookingLotOrderBy = {
  adyen_merchant_id?: InputMaybe<OrderBy>;
  bookings_aggregate?: InputMaybe<BookingBookingAggregateOrderBy>;
  configurations_aggregate?: InputMaybe<BookingLotConfigurationAggregateOrderBy>;
  go_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_active?: InputMaybe<OrderBy>;
  is_public?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  pricing_rules_aggregate?: InputMaybe<BookingPricingRulesAggregateOrderBy>;
};

/** primary key columns input for table: booking.lot */
export type BookingLotPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "booking.lot" */
export enum BookingLotSelectColumn {
  /** column name */
  AdyenMerchantId = 'adyen_merchant_id',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public'
}

/** input type for updating data in table "booking.lot" */
export type BookingLotSetInput = {
  adyen_merchant_id?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "booking_lot" */
export type BookingLotStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingLotStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingLotStreamCursorValueInput = {
  adyen_merchant_id?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "booking.lot" */
export enum BookingLotUpdateColumn {
  /** column name */
  AdyenMerchantId = 'adyen_merchant_id',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public'
}

export type BookingLotUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingLotSetInput>;
  /** filter the rows which have to be updated */
  where: BookingLotBoolExp;
};

/** columns and relationships of "booking.payment" */
export type BookingPayment = {
  __typename?: 'booking_payment';
  amount: Scalars['numeric'];
  /** An object relationship */
  booking: BookingBooking;
  booking_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  details: Scalars['jsonb'];
  id: Scalars['Int'];
};


/** columns and relationships of "booking.payment" */
export type BookingPaymentDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "booking.payment" */
export type BookingPaymentAggregate = {
  __typename?: 'booking_payment_aggregate';
  aggregate?: Maybe<BookingPaymentAggregateFields>;
  nodes: Array<BookingPayment>;
};

/** aggregate fields of "booking.payment" */
export type BookingPaymentAggregateFields = {
  __typename?: 'booking_payment_aggregate_fields';
  avg?: Maybe<BookingPaymentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingPaymentMaxFields>;
  min?: Maybe<BookingPaymentMinFields>;
  stddev?: Maybe<BookingPaymentStddevFields>;
  stddev_pop?: Maybe<BookingPaymentStddevPopFields>;
  stddev_samp?: Maybe<BookingPaymentStddevSampFields>;
  sum?: Maybe<BookingPaymentSumFields>;
  var_pop?: Maybe<BookingPaymentVarPopFields>;
  var_samp?: Maybe<BookingPaymentVarSampFields>;
  variance?: Maybe<BookingPaymentVarianceFields>;
};


/** aggregate fields of "booking.payment" */
export type BookingPaymentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingPaymentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BookingPaymentAppendInput = {
  details?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type BookingPaymentAvgFields = {
  __typename?: 'booking_payment_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booking.payment". All fields are combined with a logical 'AND'. */
export type BookingPaymentBoolExp = {
  _and?: InputMaybe<Array<BookingPaymentBoolExp>>;
  _not?: InputMaybe<BookingPaymentBoolExp>;
  _or?: InputMaybe<Array<BookingPaymentBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  booking?: InputMaybe<BookingBookingBoolExp>;
  booking_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "booking.payment" */
export enum BookingPaymentConstraint {
  /** unique or primary key constraint on columns "booking_id" */
  PaymentBookingIdKey = 'payment_booking_id_key',
  /** unique or primary key constraint on columns "id" */
  PaymentPkey = 'payment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BookingPaymentDeleteAtPathInput = {
  details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BookingPaymentDeleteElemInput = {
  details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BookingPaymentDeleteKeyInput = {
  details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "booking.payment" */
export type BookingPaymentIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.payment" */
export type BookingPaymentInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking?: InputMaybe<BookingBookingObjRelInsertInput>;
  booking_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type BookingPaymentMaxFields = {
  __typename?: 'booking_payment_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  booking_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type BookingPaymentMinFields = {
  __typename?: 'booking_payment_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  booking_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "booking.payment" */
export type BookingPaymentMutationResponse = {
  __typename?: 'booking_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingPayment>;
};

/** input type for inserting object relation for remote table "booking.payment" */
export type BookingPaymentObjRelInsertInput = {
  data: BookingPaymentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingPaymentOnConflict>;
};

/** on_conflict condition type for table "booking.payment" */
export type BookingPaymentOnConflict = {
  constraint: BookingPaymentConstraint;
  update_columns?: Array<BookingPaymentUpdateColumn>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};

/** Ordering options when selecting data from "booking.payment". */
export type BookingPaymentOrderBy = {
  amount?: InputMaybe<OrderBy>;
  booking?: InputMaybe<BookingBookingOrderBy>;
  booking_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.payment */
export type BookingPaymentPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BookingPaymentPrependInput = {
  details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "booking.payment" */
export enum BookingPaymentSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "booking.payment" */
export type BookingPaymentSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type BookingPaymentStddevFields = {
  __typename?: 'booking_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BookingPaymentStddevPopFields = {
  __typename?: 'booking_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BookingPaymentStddevSampFields = {
  __typename?: 'booking_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "booking_payment" */
export type BookingPaymentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingPaymentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingPaymentStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type BookingPaymentSumFields = {
  __typename?: 'booking_payment_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  booking_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "booking.payment" */
export enum BookingPaymentUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id'
}

export type BookingPaymentUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BookingPaymentAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BookingPaymentDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BookingPaymentDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BookingPaymentDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingPaymentIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BookingPaymentPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingPaymentSetInput>;
  /** filter the rows which have to be updated */
  where: BookingPaymentBoolExp;
};

/** aggregate var_pop on columns */
export type BookingPaymentVarPopFields = {
  __typename?: 'booking_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BookingPaymentVarSampFields = {
  __typename?: 'booking_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BookingPaymentVarianceFields = {
  __typename?: 'booking_payment_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  booking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "booking.pricing_rules" */
export type BookingPricingRules = {
  __typename?: 'booking_pricing_rules';
  id: Scalars['Int'];
  /** An object relationship */
  lot: BookingLot;
  lot_id: Scalars['String'];
  /** An array relationship */
  private_pricing_users: Array<BookingPrivatePricingUser>;
  /** An aggregate relationship */
  private_pricing_users_aggregate: BookingPrivatePricingUserAggregate;
  rules: Scalars['jsonb'];
  type: BookingPricingTypeEnum;
};


/** columns and relationships of "booking.pricing_rules" */
export type BookingPricingRulesPrivatePricingUsersArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


/** columns and relationships of "booking.pricing_rules" */
export type BookingPricingRulesPrivatePricingUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


/** columns and relationships of "booking.pricing_rules" */
export type BookingPricingRulesRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "booking.pricing_rules" */
export type BookingPricingRulesAggregate = {
  __typename?: 'booking_pricing_rules_aggregate';
  aggregate?: Maybe<BookingPricingRulesAggregateFields>;
  nodes: Array<BookingPricingRules>;
};

export type BookingPricingRulesAggregateBoolExp = {
  count?: InputMaybe<BookingPricingRulesAggregateBoolExpCount>;
};

export type BookingPricingRulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingPricingRulesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.pricing_rules" */
export type BookingPricingRulesAggregateFields = {
  __typename?: 'booking_pricing_rules_aggregate_fields';
  avg?: Maybe<BookingPricingRulesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingPricingRulesMaxFields>;
  min?: Maybe<BookingPricingRulesMinFields>;
  stddev?: Maybe<BookingPricingRulesStddevFields>;
  stddev_pop?: Maybe<BookingPricingRulesStddevPopFields>;
  stddev_samp?: Maybe<BookingPricingRulesStddevSampFields>;
  sum?: Maybe<BookingPricingRulesSumFields>;
  var_pop?: Maybe<BookingPricingRulesVarPopFields>;
  var_samp?: Maybe<BookingPricingRulesVarSampFields>;
  variance?: Maybe<BookingPricingRulesVarianceFields>;
};


/** aggregate fields of "booking.pricing_rules" */
export type BookingPricingRulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.pricing_rules" */
export type BookingPricingRulesAggregateOrderBy = {
  avg?: InputMaybe<BookingPricingRulesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingPricingRulesMaxOrderBy>;
  min?: InputMaybe<BookingPricingRulesMinOrderBy>;
  stddev?: InputMaybe<BookingPricingRulesStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingPricingRulesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingPricingRulesStddevSampOrderBy>;
  sum?: InputMaybe<BookingPricingRulesSumOrderBy>;
  var_pop?: InputMaybe<BookingPricingRulesVarPopOrderBy>;
  var_samp?: InputMaybe<BookingPricingRulesVarSampOrderBy>;
  variance?: InputMaybe<BookingPricingRulesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BookingPricingRulesAppendInput = {
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "booking.pricing_rules" */
export type BookingPricingRulesArrRelInsertInput = {
  data: Array<BookingPricingRulesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingPricingRulesOnConflict>;
};

/** aggregate avg on columns */
export type BookingPricingRulesAvgFields = {
  __typename?: 'booking_pricing_rules_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.pricing_rules". All fields are combined with a logical 'AND'. */
export type BookingPricingRulesBoolExp = {
  _and?: InputMaybe<Array<BookingPricingRulesBoolExp>>;
  _not?: InputMaybe<BookingPricingRulesBoolExp>;
  _or?: InputMaybe<Array<BookingPricingRulesBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  lot?: InputMaybe<BookingLotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  private_pricing_users?: InputMaybe<BookingPrivatePricingUserBoolExp>;
  private_pricing_users_aggregate?: InputMaybe<BookingPrivatePricingUserAggregateBoolExp>;
  rules?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<BookingPricingTypeEnumComparisonExp>;
};

/** unique or primary key constraints on table "booking.pricing_rules" */
export enum BookingPricingRulesConstraint {
  /** unique or primary key constraint on columns "type", "lot_id" */
  PricingRulesLotIdTypeKey = 'pricing_rules_lot_id_type_key',
  /** unique or primary key constraint on columns "id" */
  PricingRulesPkey = 'pricing_rules_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BookingPricingRulesDeleteAtPathInput = {
  rules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BookingPricingRulesDeleteElemInput = {
  rules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BookingPricingRulesDeleteKeyInput = {
  rules?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "booking.pricing_rules" */
export type BookingPricingRulesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.pricing_rules" */
export type BookingPricingRulesInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  lot?: InputMaybe<BookingLotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  private_pricing_users?: InputMaybe<BookingPrivatePricingUserArrRelInsertInput>;
  rules?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<BookingPricingTypeEnum>;
};

/** aggregate max on columns */
export type BookingPricingRulesMaxFields = {
  __typename?: 'booking_pricing_rules_max_fields';
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingPricingRulesMinFields = {
  __typename?: 'booking_pricing_rules_min_fields';
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.pricing_rules" */
export type BookingPricingRulesMutationResponse = {
  __typename?: 'booking_pricing_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingPricingRules>;
};

/** input type for inserting object relation for remote table "booking.pricing_rules" */
export type BookingPricingRulesObjRelInsertInput = {
  data: BookingPricingRulesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingPricingRulesOnConflict>;
};

/** on_conflict condition type for table "booking.pricing_rules" */
export type BookingPricingRulesOnConflict = {
  constraint: BookingPricingRulesConstraint;
  update_columns?: Array<BookingPricingRulesUpdateColumn>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};

/** Ordering options when selecting data from "booking.pricing_rules". */
export type BookingPricingRulesOrderBy = {
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<BookingLotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  private_pricing_users_aggregate?: InputMaybe<BookingPrivatePricingUserAggregateOrderBy>;
  rules?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.pricing_rules */
export type BookingPricingRulesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BookingPricingRulesPrependInput = {
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "booking.pricing_rules" */
export enum BookingPricingRulesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Rules = 'rules',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "booking.pricing_rules" */
export type BookingPricingRulesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<BookingPricingTypeEnum>;
};

/** aggregate stddev on columns */
export type BookingPricingRulesStddevFields = {
  __typename?: 'booking_pricing_rules_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingPricingRulesStddevPopFields = {
  __typename?: 'booking_pricing_rules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingPricingRulesStddevSampFields = {
  __typename?: 'booking_pricing_rules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_pricing_rules" */
export type BookingPricingRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingPricingRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingPricingRulesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<BookingPricingTypeEnum>;
};

/** aggregate sum on columns */
export type BookingPricingRulesSumFields = {
  __typename?: 'booking_pricing_rules_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.pricing_rules" */
export enum BookingPricingRulesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Rules = 'rules',
  /** column name */
  Type = 'type'
}

export type BookingPricingRulesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BookingPricingRulesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BookingPricingRulesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BookingPricingRulesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BookingPricingRulesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingPricingRulesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BookingPricingRulesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingPricingRulesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingPricingRulesBoolExp;
};

/** aggregate var_pop on columns */
export type BookingPricingRulesVarPopFields = {
  __typename?: 'booking_pricing_rules_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingPricingRulesVarSampFields = {
  __typename?: 'booking_pricing_rules_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingPricingRulesVarianceFields = {
  __typename?: 'booking_pricing_rules_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.pricing_rules" */
export type BookingPricingRulesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.pricing_type" */
export type BookingPricingType = {
  __typename?: 'booking_pricing_type';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.pricing_type" */
export type BookingPricingTypeAggregate = {
  __typename?: 'booking_pricing_type_aggregate';
  aggregate?: Maybe<BookingPricingTypeAggregateFields>;
  nodes: Array<BookingPricingType>;
};

/** aggregate fields of "booking.pricing_type" */
export type BookingPricingTypeAggregateFields = {
  __typename?: 'booking_pricing_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingPricingTypeMaxFields>;
  min?: Maybe<BookingPricingTypeMinFields>;
};


/** aggregate fields of "booking.pricing_type" */
export type BookingPricingTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingPricingTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.pricing_type". All fields are combined with a logical 'AND'. */
export type BookingPricingTypeBoolExp = {
  _and?: InputMaybe<Array<BookingPricingTypeBoolExp>>;
  _not?: InputMaybe<BookingPricingTypeBoolExp>;
  _or?: InputMaybe<Array<BookingPricingTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.pricing_type" */
export enum BookingPricingTypeConstraint {
  /** unique or primary key constraint on columns "value" */
  PricingTypePkey = 'pricing_type_pkey'
}

export enum BookingPricingTypeEnum {
  /** private commuter parking price */
  PrivateCommuter = 'PRIVATE_COMMUTER',
  /** private employee parking */
  PrivateEmployee = 'PRIVATE_EMPLOYEE',
  /** A fallback private price model of a lot */
  PrivateOther = 'PRIVATE_OTHER',
  /** private resident parking price  */
  PrivateResident = 'PRIVATE_RESIDENT',
  /** The public price model of a lot */
  Public = 'PUBLIC',
  /** Public night parking prices for the booking platform */
  PublicNightly = 'PUBLIC_NIGHTLY'
}

/** Boolean expression to compare columns of type "booking_pricing_type_enum". All fields are combined with logical 'AND'. */
export type BookingPricingTypeEnumComparisonExp = {
  _eq?: InputMaybe<BookingPricingTypeEnum>;
  _in?: InputMaybe<Array<BookingPricingTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingPricingTypeEnum>;
  _nin?: InputMaybe<Array<BookingPricingTypeEnum>>;
};

/** input type for inserting data into table "booking.pricing_type" */
export type BookingPricingTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingPricingTypeMaxFields = {
  __typename?: 'booking_pricing_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingPricingTypeMinFields = {
  __typename?: 'booking_pricing_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.pricing_type" */
export type BookingPricingTypeMutationResponse = {
  __typename?: 'booking_pricing_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingPricingType>;
};

/** on_conflict condition type for table "booking.pricing_type" */
export type BookingPricingTypeOnConflict = {
  constraint: BookingPricingTypeConstraint;
  update_columns?: Array<BookingPricingTypeUpdateColumn>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};

/** Ordering options when selecting data from "booking.pricing_type". */
export type BookingPricingTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.pricing_type */
export type BookingPricingTypePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.pricing_type" */
export enum BookingPricingTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.pricing_type" */
export type BookingPricingTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_pricing_type" */
export type BookingPricingTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingPricingTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingPricingTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.pricing_type" */
export enum BookingPricingTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingPricingTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingPricingTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BookingPricingTypeBoolExp;
};

/** columns and relationships of "booking.private_pricing_user" */
export type BookingPrivatePricingUser = {
  __typename?: 'booking_private_pricing_user';
  created_at: Scalars['timestamptz'];
  price_model_id: Scalars['Int'];
  /** An object relationship */
  pricing_rule: BookingPricingRules;
  /** An object relationship */
  user: BookingUser;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "booking.private_pricing_user" */
export type BookingPrivatePricingUserAggregate = {
  __typename?: 'booking_private_pricing_user_aggregate';
  aggregate?: Maybe<BookingPrivatePricingUserAggregateFields>;
  nodes: Array<BookingPrivatePricingUser>;
};

export type BookingPrivatePricingUserAggregateBoolExp = {
  count?: InputMaybe<BookingPrivatePricingUserAggregateBoolExpCount>;
};

export type BookingPrivatePricingUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingPrivatePricingUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.private_pricing_user" */
export type BookingPrivatePricingUserAggregateFields = {
  __typename?: 'booking_private_pricing_user_aggregate_fields';
  avg?: Maybe<BookingPrivatePricingUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingPrivatePricingUserMaxFields>;
  min?: Maybe<BookingPrivatePricingUserMinFields>;
  stddev?: Maybe<BookingPrivatePricingUserStddevFields>;
  stddev_pop?: Maybe<BookingPrivatePricingUserStddevPopFields>;
  stddev_samp?: Maybe<BookingPrivatePricingUserStddevSampFields>;
  sum?: Maybe<BookingPrivatePricingUserSumFields>;
  var_pop?: Maybe<BookingPrivatePricingUserVarPopFields>;
  var_samp?: Maybe<BookingPrivatePricingUserVarSampFields>;
  variance?: Maybe<BookingPrivatePricingUserVarianceFields>;
};


/** aggregate fields of "booking.private_pricing_user" */
export type BookingPrivatePricingUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserAggregateOrderBy = {
  avg?: InputMaybe<BookingPrivatePricingUserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingPrivatePricingUserMaxOrderBy>;
  min?: InputMaybe<BookingPrivatePricingUserMinOrderBy>;
  stddev?: InputMaybe<BookingPrivatePricingUserStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingPrivatePricingUserStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingPrivatePricingUserStddevSampOrderBy>;
  sum?: InputMaybe<BookingPrivatePricingUserSumOrderBy>;
  var_pop?: InputMaybe<BookingPrivatePricingUserVarPopOrderBy>;
  var_samp?: InputMaybe<BookingPrivatePricingUserVarSampOrderBy>;
  variance?: InputMaybe<BookingPrivatePricingUserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.private_pricing_user" */
export type BookingPrivatePricingUserArrRelInsertInput = {
  data: Array<BookingPrivatePricingUserInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingPrivatePricingUserOnConflict>;
};

/** aggregate avg on columns */
export type BookingPrivatePricingUserAvgFields = {
  __typename?: 'booking_private_pricing_user_avg_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserAvgOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.private_pricing_user". All fields are combined with a logical 'AND'. */
export type BookingPrivatePricingUserBoolExp = {
  _and?: InputMaybe<Array<BookingPrivatePricingUserBoolExp>>;
  _not?: InputMaybe<BookingPrivatePricingUserBoolExp>;
  _or?: InputMaybe<Array<BookingPrivatePricingUserBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  price_model_id?: InputMaybe<IntComparisonExp>;
  pricing_rule?: InputMaybe<BookingPricingRulesBoolExp>;
  user?: InputMaybe<BookingUserBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.private_pricing_user" */
export enum BookingPrivatePricingUserConstraint {
  /** unique or primary key constraint on columns "user_id", "price_model_id" */
  PrivatePricingUserPkey = 'private_pricing_user_pkey'
}

/** input type for incrementing numeric columns in table "booking.private_pricing_user" */
export type BookingPrivatePricingUserIncInput = {
  price_model_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.private_pricing_user" */
export type BookingPrivatePricingUserInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  price_model_id?: InputMaybe<Scalars['Int']>;
  pricing_rule?: InputMaybe<BookingPricingRulesObjRelInsertInput>;
  user?: InputMaybe<BookingUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingPrivatePricingUserMaxFields = {
  __typename?: 'booking_private_pricing_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  price_model_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  price_model_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingPrivatePricingUserMinFields = {
  __typename?: 'booking_private_pricing_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  price_model_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  price_model_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.private_pricing_user" */
export type BookingPrivatePricingUserMutationResponse = {
  __typename?: 'booking_private_pricing_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingPrivatePricingUser>;
};

/** on_conflict condition type for table "booking.private_pricing_user" */
export type BookingPrivatePricingUserOnConflict = {
  constraint: BookingPrivatePricingUserConstraint;
  update_columns?: Array<BookingPrivatePricingUserUpdateColumn>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};

/** Ordering options when selecting data from "booking.private_pricing_user". */
export type BookingPrivatePricingUserOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  price_model_id?: InputMaybe<OrderBy>;
  pricing_rule?: InputMaybe<BookingPricingRulesOrderBy>;
  user?: InputMaybe<BookingUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.private_pricing_user */
export type BookingPrivatePricingUserPkColumnsInput = {
  price_model_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** select columns of table "booking.private_pricing_user" */
export enum BookingPrivatePricingUserSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PriceModelId = 'price_model_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "booking.private_pricing_user" */
export type BookingPrivatePricingUserSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  price_model_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type BookingPrivatePricingUserStddevFields = {
  __typename?: 'booking_private_pricing_user_stddev_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserStddevOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingPrivatePricingUserStddevPopFields = {
  __typename?: 'booking_private_pricing_user_stddev_pop_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserStddevPopOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingPrivatePricingUserStddevSampFields = {
  __typename?: 'booking_private_pricing_user_stddev_samp_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserStddevSampOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_private_pricing_user" */
export type BookingPrivatePricingUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingPrivatePricingUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingPrivatePricingUserStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  price_model_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type BookingPrivatePricingUserSumFields = {
  __typename?: 'booking_private_pricing_user_sum_fields';
  price_model_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserSumOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.private_pricing_user" */
export enum BookingPrivatePricingUserUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PriceModelId = 'price_model_id',
  /** column name */
  UserId = 'user_id'
}

export type BookingPrivatePricingUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingPrivatePricingUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingPrivatePricingUserSetInput>;
  /** filter the rows which have to be updated */
  where: BookingPrivatePricingUserBoolExp;
};

/** aggregate var_pop on columns */
export type BookingPrivatePricingUserVarPopFields = {
  __typename?: 'booking_private_pricing_user_var_pop_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserVarPopOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingPrivatePricingUserVarSampFields = {
  __typename?: 'booking_private_pricing_user_var_samp_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserVarSampOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingPrivatePricingUserVarianceFields = {
  __typename?: 'booking_private_pricing_user_variance_fields';
  price_model_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.private_pricing_user" */
export type BookingPrivatePricingUserVarianceOrderBy = {
  price_model_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.recurring_booking" */
export type BookingRecurringBooking = {
  __typename?: 'booking_recurring_booking';
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};

/** aggregated selection of "booking.recurring_booking" */
export type BookingRecurringBookingAggregate = {
  __typename?: 'booking_recurring_booking_aggregate';
  aggregate?: Maybe<BookingRecurringBookingAggregateFields>;
  nodes: Array<BookingRecurringBooking>;
};

export type BookingRecurringBookingAggregateBoolExp = {
  count?: InputMaybe<BookingRecurringBookingAggregateBoolExpCount>;
};

export type BookingRecurringBookingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingRecurringBookingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.recurring_booking" */
export type BookingRecurringBookingAggregateFields = {
  __typename?: 'booking_recurring_booking_aggregate_fields';
  avg?: Maybe<BookingRecurringBookingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingRecurringBookingMaxFields>;
  min?: Maybe<BookingRecurringBookingMinFields>;
  stddev?: Maybe<BookingRecurringBookingStddevFields>;
  stddev_pop?: Maybe<BookingRecurringBookingStddevPopFields>;
  stddev_samp?: Maybe<BookingRecurringBookingStddevSampFields>;
  sum?: Maybe<BookingRecurringBookingSumFields>;
  var_pop?: Maybe<BookingRecurringBookingVarPopFields>;
  var_samp?: Maybe<BookingRecurringBookingVarSampFields>;
  variance?: Maybe<BookingRecurringBookingVarianceFields>;
};


/** aggregate fields of "booking.recurring_booking" */
export type BookingRecurringBookingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.recurring_booking" */
export type BookingRecurringBookingAggregateOrderBy = {
  avg?: InputMaybe<BookingRecurringBookingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingRecurringBookingMaxOrderBy>;
  min?: InputMaybe<BookingRecurringBookingMinOrderBy>;
  stddev?: InputMaybe<BookingRecurringBookingStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingRecurringBookingStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingRecurringBookingStddevSampOrderBy>;
  sum?: InputMaybe<BookingRecurringBookingSumOrderBy>;
  var_pop?: InputMaybe<BookingRecurringBookingVarPopOrderBy>;
  var_samp?: InputMaybe<BookingRecurringBookingVarSampOrderBy>;
  variance?: InputMaybe<BookingRecurringBookingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.recurring_booking" */
export type BookingRecurringBookingArrRelInsertInput = {
  data: Array<BookingRecurringBookingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingRecurringBookingOnConflict>;
};

/** aggregate avg on columns */
export type BookingRecurringBookingAvgFields = {
  __typename?: 'booking_recurring_booking_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingAvgOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.recurring_booking". All fields are combined with a logical 'AND'. */
export type BookingRecurringBookingBoolExp = {
  _and?: InputMaybe<Array<BookingRecurringBookingBoolExp>>;
  _not?: InputMaybe<BookingRecurringBookingBoolExp>;
  _or?: InputMaybe<Array<BookingRecurringBookingBoolExp>>;
  booking_id?: InputMaybe<IntComparisonExp>;
  iso_duration?: InputMaybe<StringComparisonExp>;
  rrule?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.recurring_booking" */
export enum BookingRecurringBookingConstraint {
  /** unique or primary key constraint on columns "rrule", "iso_duration", "booking_id" */
  RecurringBookingPkey = 'recurring_booking_pkey'
}

/** input type for incrementing numeric columns in table "booking.recurring_booking" */
export type BookingRecurringBookingIncInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booking.recurring_booking" */
export type BookingRecurringBookingInsertInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
  rrule?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingRecurringBookingMaxFields = {
  __typename?: 'booking_recurring_booking_max_fields';
  booking_id?: Maybe<Scalars['Int']>;
  iso_duration?: Maybe<Scalars['String']>;
  rrule?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  iso_duration?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingRecurringBookingMinFields = {
  __typename?: 'booking_recurring_booking_min_fields';
  booking_id?: Maybe<Scalars['Int']>;
  iso_duration?: Maybe<Scalars['String']>;
  rrule?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  iso_duration?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.recurring_booking" */
export type BookingRecurringBookingMutationResponse = {
  __typename?: 'booking_recurring_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingRecurringBooking>;
};

/** on_conflict condition type for table "booking.recurring_booking" */
export type BookingRecurringBookingOnConflict = {
  constraint: BookingRecurringBookingConstraint;
  update_columns?: Array<BookingRecurringBookingUpdateColumn>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};

/** Ordering options when selecting data from "booking.recurring_booking". */
export type BookingRecurringBookingOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  iso_duration?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.recurring_booking */
export type BookingRecurringBookingPkColumnsInput = {
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};

/** select columns of table "booking.recurring_booking" */
export enum BookingRecurringBookingSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  IsoDuration = 'iso_duration',
  /** column name */
  Rrule = 'rrule'
}

/** input type for updating data in table "booking.recurring_booking" */
export type BookingRecurringBookingSetInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
  rrule?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BookingRecurringBookingStddevFields = {
  __typename?: 'booking_recurring_booking_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingStddevOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingRecurringBookingStddevPopFields = {
  __typename?: 'booking_recurring_booking_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingStddevPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingRecurringBookingStddevSampFields = {
  __typename?: 'booking_recurring_booking_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingStddevSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_recurring_booking" */
export type BookingRecurringBookingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingRecurringBookingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingRecurringBookingStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['Int']>;
  iso_duration?: InputMaybe<Scalars['String']>;
  rrule?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BookingRecurringBookingSumFields = {
  __typename?: 'booking_recurring_booking_sum_fields';
  booking_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingSumOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.recurring_booking" */
export enum BookingRecurringBookingUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  IsoDuration = 'iso_duration',
  /** column name */
  Rrule = 'rrule'
}

export type BookingRecurringBookingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingRecurringBookingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingRecurringBookingSetInput>;
  /** filter the rows which have to be updated */
  where: BookingRecurringBookingBoolExp;
};

/** aggregate var_pop on columns */
export type BookingRecurringBookingVarPopFields = {
  __typename?: 'booking_recurring_booking_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingVarPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingRecurringBookingVarSampFields = {
  __typename?: 'booking_recurring_booking_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingVarSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingRecurringBookingVarianceFields = {
  __typename?: 'booking_recurring_booking_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.recurring_booking" */
export type BookingRecurringBookingVarianceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.subscription_booking" */
export type BookingSubscriptionBooking = {
  __typename?: 'booking_subscription_booking';
  booking_id: Scalars['bigint'];
  /** An object relationship */
  user_booking: BookingUserBooking;
  user_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};

/** aggregated selection of "booking.subscription_booking" */
export type BookingSubscriptionBookingAggregate = {
  __typename?: 'booking_subscription_booking_aggregate';
  aggregate?: Maybe<BookingSubscriptionBookingAggregateFields>;
  nodes: Array<BookingSubscriptionBooking>;
};

export type BookingSubscriptionBookingAggregateBoolExp = {
  count?: InputMaybe<BookingSubscriptionBookingAggregateBoolExpCount>;
};

export type BookingSubscriptionBookingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingSubscriptionBookingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.subscription_booking" */
export type BookingSubscriptionBookingAggregateFields = {
  __typename?: 'booking_subscription_booking_aggregate_fields';
  avg?: Maybe<BookingSubscriptionBookingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingSubscriptionBookingMaxFields>;
  min?: Maybe<BookingSubscriptionBookingMinFields>;
  stddev?: Maybe<BookingSubscriptionBookingStddevFields>;
  stddev_pop?: Maybe<BookingSubscriptionBookingStddevPopFields>;
  stddev_samp?: Maybe<BookingSubscriptionBookingStddevSampFields>;
  sum?: Maybe<BookingSubscriptionBookingSumFields>;
  var_pop?: Maybe<BookingSubscriptionBookingVarPopFields>;
  var_samp?: Maybe<BookingSubscriptionBookingVarSampFields>;
  variance?: Maybe<BookingSubscriptionBookingVarianceFields>;
};


/** aggregate fields of "booking.subscription_booking" */
export type BookingSubscriptionBookingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.subscription_booking" */
export type BookingSubscriptionBookingAggregateOrderBy = {
  avg?: InputMaybe<BookingSubscriptionBookingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingSubscriptionBookingMaxOrderBy>;
  min?: InputMaybe<BookingSubscriptionBookingMinOrderBy>;
  stddev?: InputMaybe<BookingSubscriptionBookingStddevOrderBy>;
  stddev_pop?: InputMaybe<BookingSubscriptionBookingStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BookingSubscriptionBookingStddevSampOrderBy>;
  sum?: InputMaybe<BookingSubscriptionBookingSumOrderBy>;
  var_pop?: InputMaybe<BookingSubscriptionBookingVarPopOrderBy>;
  var_samp?: InputMaybe<BookingSubscriptionBookingVarSampOrderBy>;
  variance?: InputMaybe<BookingSubscriptionBookingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "booking.subscription_booking" */
export type BookingSubscriptionBookingArrRelInsertInput = {
  data: Array<BookingSubscriptionBookingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingSubscriptionBookingOnConflict>;
};

/** aggregate avg on columns */
export type BookingSubscriptionBookingAvgFields = {
  __typename?: 'booking_subscription_booking_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingAvgOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "booking.subscription_booking". All fields are combined with a logical 'AND'. */
export type BookingSubscriptionBookingBoolExp = {
  _and?: InputMaybe<Array<BookingSubscriptionBookingBoolExp>>;
  _not?: InputMaybe<BookingSubscriptionBookingBoolExp>;
  _or?: InputMaybe<Array<BookingSubscriptionBookingBoolExp>>;
  booking_id?: InputMaybe<BigintComparisonExp>;
  user_booking?: InputMaybe<BookingUserBookingBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
  user_subscription_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.subscription_booking" */
export enum BookingSubscriptionBookingConstraint {
  /** unique or primary key constraint on columns "user_id", "user_subscription_id", "booking_id" */
  SubscriptionBookingPkey = 'subscription_booking_pkey'
}

/** input type for incrementing numeric columns in table "booking.subscription_booking" */
export type BookingSubscriptionBookingIncInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "booking.subscription_booking" */
export type BookingSubscriptionBookingInsertInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_booking?: InputMaybe<BookingUserBookingObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingSubscriptionBookingMaxFields = {
  __typename?: 'booking_subscription_booking_max_fields';
  booking_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingMaxOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingSubscriptionBookingMinFields = {
  __typename?: 'booking_subscription_booking_min_fields';
  booking_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingMinOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.subscription_booking" */
export type BookingSubscriptionBookingMutationResponse = {
  __typename?: 'booking_subscription_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingSubscriptionBooking>;
};

/** on_conflict condition type for table "booking.subscription_booking" */
export type BookingSubscriptionBookingOnConflict = {
  constraint: BookingSubscriptionBookingConstraint;
  update_columns?: Array<BookingSubscriptionBookingUpdateColumn>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};

/** Ordering options when selecting data from "booking.subscription_booking". */
export type BookingSubscriptionBookingOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
  user_booking?: InputMaybe<BookingUserBookingOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.subscription_booking */
export type BookingSubscriptionBookingPkColumnsInput = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};

/** select columns of table "booking.subscription_booking" */
export enum BookingSubscriptionBookingSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSubscriptionId = 'user_subscription_id'
}

/** input type for updating data in table "booking.subscription_booking" */
export type BookingSubscriptionBookingSetInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type BookingSubscriptionBookingStddevFields = {
  __typename?: 'booking_subscription_booking_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingStddevOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BookingSubscriptionBookingStddevPopFields = {
  __typename?: 'booking_subscription_booking_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingStddevPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BookingSubscriptionBookingStddevSampFields = {
  __typename?: 'booking_subscription_booking_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingStddevSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "booking_subscription_booking" */
export type BookingSubscriptionBookingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingSubscriptionBookingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingSubscriptionBookingStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type BookingSubscriptionBookingSumFields = {
  __typename?: 'booking_subscription_booking_sum_fields';
  booking_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingSumOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** update columns of table "booking.subscription_booking" */
export enum BookingSubscriptionBookingUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSubscriptionId = 'user_subscription_id'
}

export type BookingSubscriptionBookingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingSubscriptionBookingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingSubscriptionBookingSetInput>;
  /** filter the rows which have to be updated */
  where: BookingSubscriptionBookingBoolExp;
};

/** aggregate var_pop on columns */
export type BookingSubscriptionBookingVarPopFields = {
  __typename?: 'booking_subscription_booking_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingVarPopOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BookingSubscriptionBookingVarSampFields = {
  __typename?: 'booking_subscription_booking_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingVarSampOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BookingSubscriptionBookingVarianceFields = {
  __typename?: 'booking_subscription_booking_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking.subscription_booking" */
export type BookingSubscriptionBookingVarianceOrderBy = {
  booking_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlate = {
  __typename?: 'booking_subscription_license_plate';
  /** An object relationship */
  license_plate: BookingLicensePlate;
  license_plate_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};

/** aggregated selection of "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateAggregate = {
  __typename?: 'booking_subscription_license_plate_aggregate';
  aggregate?: Maybe<BookingSubscriptionLicensePlateAggregateFields>;
  nodes: Array<BookingSubscriptionLicensePlate>;
};

export type BookingSubscriptionLicensePlateAggregateBoolExp = {
  count?: InputMaybe<BookingSubscriptionLicensePlateAggregateBoolExpCount>;
};

export type BookingSubscriptionLicensePlateAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateAggregateFields = {
  __typename?: 'booking_subscription_license_plate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingSubscriptionLicensePlateMaxFields>;
  min?: Maybe<BookingSubscriptionLicensePlateMinFields>;
};


/** aggregate fields of "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BookingSubscriptionLicensePlateMaxOrderBy>;
  min?: InputMaybe<BookingSubscriptionLicensePlateMinOrderBy>;
};

/** input type for inserting array relation for remote table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateArrRelInsertInput = {
  data: Array<BookingSubscriptionLicensePlateInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingSubscriptionLicensePlateOnConflict>;
};

/** Boolean expression to filter rows from the table "booking.subscription_license_plate". All fields are combined with a logical 'AND'. */
export type BookingSubscriptionLicensePlateBoolExp = {
  _and?: InputMaybe<Array<BookingSubscriptionLicensePlateBoolExp>>;
  _not?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
  _or?: InputMaybe<Array<BookingSubscriptionLicensePlateBoolExp>>;
  license_plate?: InputMaybe<BookingLicensePlateBoolExp>;
  license_plate_id?: InputMaybe<UuidComparisonExp>;
  user_subscription_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.subscription_license_plate" */
export enum BookingSubscriptionLicensePlateConstraint {
  /** unique or primary key constraint on columns "license_plate_id", "user_subscription_id" */
  SubscriptionLicensePlatePkey = 'subscription_license_plate_pkey'
}

/** input type for inserting data into table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateInsertInput = {
  license_plate?: InputMaybe<BookingLicensePlateObjRelInsertInput>;
  license_plate_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingSubscriptionLicensePlateMaxFields = {
  __typename?: 'booking_subscription_license_plate_max_fields';
  license_plate_id?: Maybe<Scalars['uuid']>;
  user_subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateMaxOrderBy = {
  license_plate_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BookingSubscriptionLicensePlateMinFields = {
  __typename?: 'booking_subscription_license_plate_min_fields';
  license_plate_id?: Maybe<Scalars['uuid']>;
  user_subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateMinOrderBy = {
  license_plate_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateMutationResponse = {
  __typename?: 'booking_subscription_license_plate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingSubscriptionLicensePlate>;
};

/** on_conflict condition type for table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateOnConflict = {
  constraint: BookingSubscriptionLicensePlateConstraint;
  update_columns?: Array<BookingSubscriptionLicensePlateUpdateColumn>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};

/** Ordering options when selecting data from "booking.subscription_license_plate". */
export type BookingSubscriptionLicensePlateOrderBy = {
  license_plate?: InputMaybe<BookingLicensePlateOrderBy>;
  license_plate_id?: InputMaybe<OrderBy>;
  user_subscription_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.subscription_license_plate */
export type BookingSubscriptionLicensePlatePkColumnsInput = {
  license_plate_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};

/** select columns of table "booking.subscription_license_plate" */
export enum BookingSubscriptionLicensePlateSelectColumn {
  /** column name */
  LicensePlateId = 'license_plate_id',
  /** column name */
  UserSubscriptionId = 'user_subscription_id'
}

/** input type for updating data in table "booking.subscription_license_plate" */
export type BookingSubscriptionLicensePlateSetInput = {
  license_plate_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "booking_subscription_license_plate" */
export type BookingSubscriptionLicensePlateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingSubscriptionLicensePlateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingSubscriptionLicensePlateStreamCursorValueInput = {
  license_plate_id?: InputMaybe<Scalars['uuid']>;
  user_subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "booking.subscription_license_plate" */
export enum BookingSubscriptionLicensePlateUpdateColumn {
  /** column name */
  LicensePlateId = 'license_plate_id',
  /** column name */
  UserSubscriptionId = 'user_subscription_id'
}

export type BookingSubscriptionLicensePlateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingSubscriptionLicensePlateSetInput>;
  /** filter the rows which have to be updated */
  where: BookingSubscriptionLicensePlateBoolExp;
};

/** columns and relationships of "booking.subscription_status" */
export type BookingSubscriptionStatus = {
  __typename?: 'booking_subscription_status';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.subscription_status" */
export type BookingSubscriptionStatusAggregate = {
  __typename?: 'booking_subscription_status_aggregate';
  aggregate?: Maybe<BookingSubscriptionStatusAggregateFields>;
  nodes: Array<BookingSubscriptionStatus>;
};

/** aggregate fields of "booking.subscription_status" */
export type BookingSubscriptionStatusAggregateFields = {
  __typename?: 'booking_subscription_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingSubscriptionStatusMaxFields>;
  min?: Maybe<BookingSubscriptionStatusMinFields>;
};


/** aggregate fields of "booking.subscription_status" */
export type BookingSubscriptionStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingSubscriptionStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.subscription_status". All fields are combined with a logical 'AND'. */
export type BookingSubscriptionStatusBoolExp = {
  _and?: InputMaybe<Array<BookingSubscriptionStatusBoolExp>>;
  _not?: InputMaybe<BookingSubscriptionStatusBoolExp>;
  _or?: InputMaybe<Array<BookingSubscriptionStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.subscription_status" */
export enum BookingSubscriptionStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  SubscriptionStatusPkey = 'subscription_status_pkey'
}

export enum BookingSubscriptionStatusEnum {
  /** Subscription is active */
  Active = 'ACTIVE',
  /** Subscription is cancelled by user */
  Cancelled = 'CANCELLED',
  /** Subscription is cancelled by our system */
  CancelledError = 'CANCELLED_ERROR'
}

/** Boolean expression to compare columns of type "booking_subscription_status_enum". All fields are combined with logical 'AND'. */
export type BookingSubscriptionStatusEnumComparisonExp = {
  _eq?: InputMaybe<BookingSubscriptionStatusEnum>;
  _in?: InputMaybe<Array<BookingSubscriptionStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingSubscriptionStatusEnum>;
  _nin?: InputMaybe<Array<BookingSubscriptionStatusEnum>>;
};

/** input type for inserting data into table "booking.subscription_status" */
export type BookingSubscriptionStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingSubscriptionStatusMaxFields = {
  __typename?: 'booking_subscription_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingSubscriptionStatusMinFields = {
  __typename?: 'booking_subscription_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.subscription_status" */
export type BookingSubscriptionStatusMutationResponse = {
  __typename?: 'booking_subscription_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingSubscriptionStatus>;
};

/** on_conflict condition type for table "booking.subscription_status" */
export type BookingSubscriptionStatusOnConflict = {
  constraint: BookingSubscriptionStatusConstraint;
  update_columns?: Array<BookingSubscriptionStatusUpdateColumn>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};

/** Ordering options when selecting data from "booking.subscription_status". */
export type BookingSubscriptionStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.subscription_status */
export type BookingSubscriptionStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.subscription_status" */
export enum BookingSubscriptionStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.subscription_status" */
export type BookingSubscriptionStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_subscription_status" */
export type BookingSubscriptionStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingSubscriptionStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingSubscriptionStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.subscription_status" */
export enum BookingSubscriptionStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingSubscriptionStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingSubscriptionStatusSetInput>;
  /** filter the rows which have to be updated */
  where: BookingSubscriptionStatusBoolExp;
};

/** columns and relationships of "booking.user" */
export type BookingUser = {
  __typename?: 'booking_user';
  auth_0_user_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['uuid'];
  last_name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "booking.user" */
export type BookingUserAggregate = {
  __typename?: 'booking_user_aggregate';
  aggregate?: Maybe<BookingUserAggregateFields>;
  nodes: Array<BookingUser>;
};

/** aggregate fields of "booking.user" */
export type BookingUserAggregateFields = {
  __typename?: 'booking_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingUserMaxFields>;
  min?: Maybe<BookingUserMinFields>;
};


/** aggregate fields of "booking.user" */
export type BookingUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "booking.user_booking" */
export type BookingUserBooking = {
  __typename?: 'booking_user_booking';
  /** An object relationship */
  booking: BookingBooking;
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "booking.user_booking" */
export type BookingUserBookingAggregate = {
  __typename?: 'booking_user_booking_aggregate';
  aggregate?: Maybe<BookingUserBookingAggregateFields>;
  nodes: Array<BookingUserBooking>;
};

/** aggregate fields of "booking.user_booking" */
export type BookingUserBookingAggregateFields = {
  __typename?: 'booking_user_booking_aggregate_fields';
  avg?: Maybe<BookingUserBookingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BookingUserBookingMaxFields>;
  min?: Maybe<BookingUserBookingMinFields>;
  stddev?: Maybe<BookingUserBookingStddevFields>;
  stddev_pop?: Maybe<BookingUserBookingStddevPopFields>;
  stddev_samp?: Maybe<BookingUserBookingStddevSampFields>;
  sum?: Maybe<BookingUserBookingSumFields>;
  var_pop?: Maybe<BookingUserBookingVarPopFields>;
  var_samp?: Maybe<BookingUserBookingVarSampFields>;
  variance?: Maybe<BookingUserBookingVarianceFields>;
};


/** aggregate fields of "booking.user_booking" */
export type BookingUserBookingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingUserBookingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BookingUserBookingAvgFields = {
  __typename?: 'booking_user_booking_avg_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booking.user_booking". All fields are combined with a logical 'AND'. */
export type BookingUserBookingBoolExp = {
  _and?: InputMaybe<Array<BookingUserBookingBoolExp>>;
  _not?: InputMaybe<BookingUserBookingBoolExp>;
  _or?: InputMaybe<Array<BookingUserBookingBoolExp>>;
  booking?: InputMaybe<BookingBookingBoolExp>;
  booking_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.user_booking" */
export enum BookingUserBookingConstraint {
  /** unique or primary key constraint on columns "user_id", "booking_id" */
  UserBookingPkey = 'user_booking_pkey'
}

/** input type for incrementing numeric columns in table "booking.user_booking" */
export type BookingUserBookingIncInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "booking.user_booking" */
export type BookingUserBookingInsertInput = {
  booking?: InputMaybe<BookingBookingObjRelInsertInput>;
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingUserBookingMaxFields = {
  __typename?: 'booking_user_booking_max_fields';
  booking_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type BookingUserBookingMinFields = {
  __typename?: 'booking_user_booking_min_fields';
  booking_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "booking.user_booking" */
export type BookingUserBookingMutationResponse = {
  __typename?: 'booking_user_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingUserBooking>;
};

/** input type for inserting object relation for remote table "booking.user_booking" */
export type BookingUserBookingObjRelInsertInput = {
  data: BookingUserBookingInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingUserBookingOnConflict>;
};

/** on_conflict condition type for table "booking.user_booking" */
export type BookingUserBookingOnConflict = {
  constraint: BookingUserBookingConstraint;
  update_columns?: Array<BookingUserBookingUpdateColumn>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};

/** Ordering options when selecting data from "booking.user_booking". */
export type BookingUserBookingOrderBy = {
  booking?: InputMaybe<BookingBookingOrderBy>;
  booking_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.user_booking */
export type BookingUserBookingPkColumnsInput = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};

/** select columns of table "booking.user_booking" */
export enum BookingUserBookingSelectColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "booking.user_booking" */
export type BookingUserBookingSetInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type BookingUserBookingStddevFields = {
  __typename?: 'booking_user_booking_stddev_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BookingUserBookingStddevPopFields = {
  __typename?: 'booking_user_booking_stddev_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BookingUserBookingStddevSampFields = {
  __typename?: 'booking_user_booking_stddev_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "booking_user_booking" */
export type BookingUserBookingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingUserBookingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingUserBookingStreamCursorValueInput = {
  booking_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type BookingUserBookingSumFields = {
  __typename?: 'booking_user_booking_sum_fields';
  booking_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "booking.user_booking" */
export enum BookingUserBookingUpdateColumn {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  UserId = 'user_id'
}

export type BookingUserBookingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BookingUserBookingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingUserBookingSetInput>;
  /** filter the rows which have to be updated */
  where: BookingUserBookingBoolExp;
};

/** aggregate var_pop on columns */
export type BookingUserBookingVarPopFields = {
  __typename?: 'booking_user_booking_var_pop_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BookingUserBookingVarSampFields = {
  __typename?: 'booking_user_booking_var_samp_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BookingUserBookingVarianceFields = {
  __typename?: 'booking_user_booking_variance_fields';
  booking_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booking.user". All fields are combined with a logical 'AND'. */
export type BookingUserBoolExp = {
  _and?: InputMaybe<Array<BookingUserBoolExp>>;
  _not?: InputMaybe<BookingUserBoolExp>;
  _or?: InputMaybe<Array<BookingUserBoolExp>>;
  auth_0_user_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  first_name?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "booking.user" */
export enum BookingUserConstraint {
  /** unique or primary key constraint on columns "auth_0_user_id" */
  UserAuth_0UserIdKey = 'user_auth_0_user_id_key',
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "booking.user" */
export type BookingUserInsertInput = {
  auth_0_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type BookingUserMaxFields = {
  __typename?: 'booking_user_max_fields';
  auth_0_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type BookingUserMinFields = {
  __typename?: 'booking_user_min_fields';
  auth_0_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "booking.user" */
export type BookingUserMutationResponse = {
  __typename?: 'booking_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingUser>;
};

/** input type for inserting object relation for remote table "booking.user" */
export type BookingUserObjRelInsertInput = {
  data: BookingUserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingUserOnConflict>;
};

/** on_conflict condition type for table "booking.user" */
export type BookingUserOnConflict = {
  constraint: BookingUserConstraint;
  update_columns?: Array<BookingUserUpdateColumn>;
  where?: InputMaybe<BookingUserBoolExp>;
};

/** Ordering options when selecting data from "booking.user". */
export type BookingUserOrderBy = {
  auth_0_user_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  first_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** columns and relationships of "booking.user_payment_method" */
export type BookingUserPaymentMethod = {
  __typename?: 'booking_user_payment_method';
  card_data?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  token_id: Scalars['String'];
  user_id: Scalars['uuid'];
  variant?: Maybe<Scalars['String']>;
};


/** columns and relationships of "booking.user_payment_method" */
export type BookingUserPaymentMethodCardDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "booking.user_payment_method" */
export type BookingUserPaymentMethodAggregate = {
  __typename?: 'booking_user_payment_method_aggregate';
  aggregate?: Maybe<BookingUserPaymentMethodAggregateFields>;
  nodes: Array<BookingUserPaymentMethod>;
};

/** aggregate fields of "booking.user_payment_method" */
export type BookingUserPaymentMethodAggregateFields = {
  __typename?: 'booking_user_payment_method_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingUserPaymentMethodMaxFields>;
  min?: Maybe<BookingUserPaymentMethodMinFields>;
};


/** aggregate fields of "booking.user_payment_method" */
export type BookingUserPaymentMethodAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingUserPaymentMethodSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BookingUserPaymentMethodAppendInput = {
  card_data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "booking.user_payment_method". All fields are combined with a logical 'AND'. */
export type BookingUserPaymentMethodBoolExp = {
  _and?: InputMaybe<Array<BookingUserPaymentMethodBoolExp>>;
  _not?: InputMaybe<BookingUserPaymentMethodBoolExp>;
  _or?: InputMaybe<Array<BookingUserPaymentMethodBoolExp>>;
  card_data?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  token_id?: InputMaybe<StringComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
  variant?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.user_payment_method" */
export enum BookingUserPaymentMethodConstraint {
  /** unique or primary key constraint on columns "id" */
  PaymentMethodPkey = 'payment_method_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BookingUserPaymentMethodDeleteAtPathInput = {
  card_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BookingUserPaymentMethodDeleteElemInput = {
  card_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BookingUserPaymentMethodDeleteKeyInput = {
  card_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "booking.user_payment_method" */
export type BookingUserPaymentMethodInsertInput = {
  card_data?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  token_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  variant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingUserPaymentMethodMaxFields = {
  __typename?: 'booking_user_payment_method_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  variant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingUserPaymentMethodMinFields = {
  __typename?: 'booking_user_payment_method_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  variant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.user_payment_method" */
export type BookingUserPaymentMethodMutationResponse = {
  __typename?: 'booking_user_payment_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingUserPaymentMethod>;
};

/** on_conflict condition type for table "booking.user_payment_method" */
export type BookingUserPaymentMethodOnConflict = {
  constraint: BookingUserPaymentMethodConstraint;
  update_columns?: Array<BookingUserPaymentMethodUpdateColumn>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};

/** Ordering options when selecting data from "booking.user_payment_method". */
export type BookingUserPaymentMethodOrderBy = {
  card_data?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  token_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  variant?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.user_payment_method */
export type BookingUserPaymentMethodPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BookingUserPaymentMethodPrependInput = {
  card_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "booking.user_payment_method" */
export enum BookingUserPaymentMethodSelectColumn {
  /** column name */
  CardData = 'card_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Variant = 'variant'
}

/** input type for updating data in table "booking.user_payment_method" */
export type BookingUserPaymentMethodSetInput = {
  card_data?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  token_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  variant?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_user_payment_method" */
export type BookingUserPaymentMethodStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingUserPaymentMethodStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingUserPaymentMethodStreamCursorValueInput = {
  card_data?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  token_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  variant?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.user_payment_method" */
export enum BookingUserPaymentMethodUpdateColumn {
  /** column name */
  CardData = 'card_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Variant = 'variant'
}

export type BookingUserPaymentMethodUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BookingUserPaymentMethodAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BookingUserPaymentMethodDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BookingUserPaymentMethodDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BookingUserPaymentMethodDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BookingUserPaymentMethodPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingUserPaymentMethodSetInput>;
  /** filter the rows which have to be updated */
  where: BookingUserPaymentMethodBoolExp;
};

/** primary key columns input for table: booking.user */
export type BookingUserPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "booking.user" */
export enum BookingUserSelectColumn {
  /** column name */
  Auth_0UserId = 'auth_0_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "booking.user" */
export type BookingUserSetInput = {
  auth_0_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "booking_user" */
export type BookingUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingUserStreamCursorValueInput = {
  auth_0_user_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "booking.user_subscription" */
export type BookingUserSubscription = {
  __typename?: 'booking_user_subscription';
  created_at: Scalars['timestamptz'];
  end_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  last_processed_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  lot: BookingLot;
  lot_id: Scalars['String'];
  start_date: Scalars['date'];
  /** An array relationship */
  subscription_bookings: Array<BookingSubscriptionBooking>;
  /** An aggregate relationship */
  subscription_bookings_aggregate: BookingSubscriptionBookingAggregate;
  /** An array relationship */
  subscription_license_plates: Array<BookingSubscriptionLicensePlate>;
  /** An aggregate relationship */
  subscription_license_plates_aggregate: BookingSubscriptionLicensePlateAggregate;
  subscription_status: BookingSubscriptionStatusEnum;
  /** An object relationship */
  user: BookingUser;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "booking.user_subscription" */
export type BookingUserSubscriptionSubscriptionBookingsArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


/** columns and relationships of "booking.user_subscription" */
export type BookingUserSubscriptionSubscriptionBookingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


/** columns and relationships of "booking.user_subscription" */
export type BookingUserSubscriptionSubscriptionLicensePlatesArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


/** columns and relationships of "booking.user_subscription" */
export type BookingUserSubscriptionSubscriptionLicensePlatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};

/** aggregated selection of "booking.user_subscription" */
export type BookingUserSubscriptionAggregate = {
  __typename?: 'booking_user_subscription_aggregate';
  aggregate?: Maybe<BookingUserSubscriptionAggregateFields>;
  nodes: Array<BookingUserSubscription>;
};

/** aggregate fields of "booking.user_subscription" */
export type BookingUserSubscriptionAggregateFields = {
  __typename?: 'booking_user_subscription_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingUserSubscriptionMaxFields>;
  min?: Maybe<BookingUserSubscriptionMinFields>;
};


/** aggregate fields of "booking.user_subscription" */
export type BookingUserSubscriptionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingUserSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.user_subscription". All fields are combined with a logical 'AND'. */
export type BookingUserSubscriptionBoolExp = {
  _and?: InputMaybe<Array<BookingUserSubscriptionBoolExp>>;
  _not?: InputMaybe<BookingUserSubscriptionBoolExp>;
  _or?: InputMaybe<Array<BookingUserSubscriptionBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_date?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_processed_date?: InputMaybe<DateComparisonExp>;
  lot?: InputMaybe<BookingLotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  start_date?: InputMaybe<DateComparisonExp>;
  subscription_bookings?: InputMaybe<BookingSubscriptionBookingBoolExp>;
  subscription_bookings_aggregate?: InputMaybe<BookingSubscriptionBookingAggregateBoolExp>;
  subscription_license_plates?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
  subscription_license_plates_aggregate?: InputMaybe<BookingSubscriptionLicensePlateAggregateBoolExp>;
  subscription_status?: InputMaybe<BookingSubscriptionStatusEnumComparisonExp>;
  user?: InputMaybe<BookingUserBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.user_subscription" */
export enum BookingUserSubscriptionConstraint {
  /** unique or primary key constraint on columns "id" */
  UserSubscriptionPkey = 'user_subscription_pkey'
}

/** input type for inserting data into table "booking.user_subscription" */
export type BookingUserSubscriptionInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_processed_date?: InputMaybe<Scalars['date']>;
  lot?: InputMaybe<BookingLotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  subscription_bookings?: InputMaybe<BookingSubscriptionBookingArrRelInsertInput>;
  subscription_license_plates?: InputMaybe<BookingSubscriptionLicensePlateArrRelInsertInput>;
  subscription_status?: InputMaybe<BookingSubscriptionStatusEnum>;
  user?: InputMaybe<BookingUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingUserSubscriptionMaxFields = {
  __typename?: 'booking_user_subscription_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  last_processed_date?: Maybe<Scalars['date']>;
  lot_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type BookingUserSubscriptionMinFields = {
  __typename?: 'booking_user_subscription_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  last_processed_date?: Maybe<Scalars['date']>;
  lot_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "booking.user_subscription" */
export type BookingUserSubscriptionMutationResponse = {
  __typename?: 'booking_user_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingUserSubscription>;
};

/** on_conflict condition type for table "booking.user_subscription" */
export type BookingUserSubscriptionOnConflict = {
  constraint: BookingUserSubscriptionConstraint;
  update_columns?: Array<BookingUserSubscriptionUpdateColumn>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};

/** Ordering options when selecting data from "booking.user_subscription". */
export type BookingUserSubscriptionOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_processed_date?: InputMaybe<OrderBy>;
  lot?: InputMaybe<BookingLotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  subscription_bookings_aggregate?: InputMaybe<BookingSubscriptionBookingAggregateOrderBy>;
  subscription_license_plates_aggregate?: InputMaybe<BookingSubscriptionLicensePlateAggregateOrderBy>;
  subscription_status?: InputMaybe<OrderBy>;
  user?: InputMaybe<BookingUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.user_subscription */
export type BookingUserSubscriptionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "booking.user_subscription" */
export enum BookingUserSubscriptionSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastProcessedDate = 'last_processed_date',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "booking.user_subscription" */
export type BookingUserSubscriptionSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_processed_date?: InputMaybe<Scalars['date']>;
  lot_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  subscription_status?: InputMaybe<BookingSubscriptionStatusEnum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "booking_user_subscription" */
export type BookingUserSubscriptionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingUserSubscriptionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingUserSubscriptionStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_processed_date?: InputMaybe<Scalars['date']>;
  lot_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  subscription_status?: InputMaybe<BookingSubscriptionStatusEnum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "booking.user_subscription" */
export enum BookingUserSubscriptionUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastProcessedDate = 'last_processed_date',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  UserId = 'user_id'
}

export type BookingUserSubscriptionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingUserSubscriptionSetInput>;
  /** filter the rows which have to be updated */
  where: BookingUserSubscriptionBoolExp;
};

/** update columns of table "booking.user" */
export enum BookingUserUpdateColumn {
  /** column name */
  Auth_0UserId = 'auth_0_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type BookingUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingUserSetInput>;
  /** filter the rows which have to be updated */
  where: BookingUserBoolExp;
};

/** columns and relationships of "booking.vehicle" */
export type BookingVehicle = {
  __typename?: 'booking_vehicle';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  manufacturer: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  plate_id: Scalars['uuid'];
  type: BookingVehicleTypeEnum;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "booking.vehicle" */
export type BookingVehicleAggregate = {
  __typename?: 'booking_vehicle_aggregate';
  aggregate?: Maybe<BookingVehicleAggregateFields>;
  nodes: Array<BookingVehicle>;
};

/** aggregate fields of "booking.vehicle" */
export type BookingVehicleAggregateFields = {
  __typename?: 'booking_vehicle_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingVehicleMaxFields>;
  min?: Maybe<BookingVehicleMinFields>;
};


/** aggregate fields of "booking.vehicle" */
export type BookingVehicleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingVehicleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.vehicle". All fields are combined with a logical 'AND'. */
export type BookingVehicleBoolExp = {
  _and?: InputMaybe<Array<BookingVehicleBoolExp>>;
  _not?: InputMaybe<BookingVehicleBoolExp>;
  _or?: InputMaybe<Array<BookingVehicleBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  manufacturer?: InputMaybe<StringComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  plate_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<BookingVehicleTypeEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "booking.vehicle" */
export enum BookingVehicleConstraint {
  /** unique or primary key constraint on columns "id" */
  VehiclePkey = 'vehicle_pkey',
  /** unique or primary key constraint on columns "plate_id" */
  VehiclePlateIdKey = 'vehicle_plate_id_key'
}

/** input type for inserting data into table "booking.vehicle" */
export type BookingVehicleInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<BookingVehicleTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BookingVehicleMaxFields = {
  __typename?: 'booking_vehicle_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type BookingVehicleMinFields = {
  __typename?: 'booking_vehicle_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "booking.vehicle" */
export type BookingVehicleMutationResponse = {
  __typename?: 'booking_vehicle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingVehicle>;
};

/** on_conflict condition type for table "booking.vehicle" */
export type BookingVehicleOnConflict = {
  constraint: BookingVehicleConstraint;
  update_columns?: Array<BookingVehicleUpdateColumn>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};

/** Ordering options when selecting data from "booking.vehicle". */
export type BookingVehicleOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  manufacturer?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plate_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.vehicle */
export type BookingVehiclePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "booking.vehicle" */
export enum BookingVehicleSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  PlateId = 'plate_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "booking.vehicle" */
export type BookingVehicleSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<BookingVehicleTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "booking_vehicle" */
export type BookingVehicleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingVehicleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingVehicleStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<BookingVehicleTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "booking.vehicle_type" */
export type BookingVehicleType = {
  __typename?: 'booking_vehicle_type';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.vehicle_type" */
export type BookingVehicleTypeAggregate = {
  __typename?: 'booking_vehicle_type_aggregate';
  aggregate?: Maybe<BookingVehicleTypeAggregateFields>;
  nodes: Array<BookingVehicleType>;
};

/** aggregate fields of "booking.vehicle_type" */
export type BookingVehicleTypeAggregateFields = {
  __typename?: 'booking_vehicle_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingVehicleTypeMaxFields>;
  min?: Maybe<BookingVehicleTypeMinFields>;
};


/** aggregate fields of "booking.vehicle_type" */
export type BookingVehicleTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingVehicleTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.vehicle_type". All fields are combined with a logical 'AND'. */
export type BookingVehicleTypeBoolExp = {
  _and?: InputMaybe<Array<BookingVehicleTypeBoolExp>>;
  _not?: InputMaybe<BookingVehicleTypeBoolExp>;
  _or?: InputMaybe<Array<BookingVehicleTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.vehicle_type" */
export enum BookingVehicleTypeConstraint {
  /** unique or primary key constraint on columns "value" */
  VehicleTypePkey = 'vehicle_type_pkey'
}

export enum BookingVehicleTypeEnum {
  /** a camper van */
  CamperVan = 'CAMPER_VAN',
  /** a caravan */
  Caravan = 'CARAVAN',
  /** a compact car */
  CompactCar = 'COMPACT_CAR',
  /** a delivery van */
  DeliveryVan = 'DELIVERY_VAN',
  /** a family van */
  FamilyVan = 'FAMILY_VAN',
  /** a motorcycle */
  Motorcycle = 'MOTORCYCLE',
  /** a motorhome */
  Motorhome = 'MOTORHOME',
  /** an SUV car */
  Suv = 'SUV',
  /** a trailer */
  Trailer = 'TRAILER',
  /** a wagon car */
  Wagon = 'WAGON'
}

/** Boolean expression to compare columns of type "booking_vehicle_type_enum". All fields are combined with logical 'AND'. */
export type BookingVehicleTypeEnumComparisonExp = {
  _eq?: InputMaybe<BookingVehicleTypeEnum>;
  _in?: InputMaybe<Array<BookingVehicleTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingVehicleTypeEnum>;
  _nin?: InputMaybe<Array<BookingVehicleTypeEnum>>;
};

/** input type for inserting data into table "booking.vehicle_type" */
export type BookingVehicleTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingVehicleTypeMaxFields = {
  __typename?: 'booking_vehicle_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingVehicleTypeMinFields = {
  __typename?: 'booking_vehicle_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.vehicle_type" */
export type BookingVehicleTypeMutationResponse = {
  __typename?: 'booking_vehicle_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingVehicleType>;
};

/** on_conflict condition type for table "booking.vehicle_type" */
export type BookingVehicleTypeOnConflict = {
  constraint: BookingVehicleTypeConstraint;
  update_columns?: Array<BookingVehicleTypeUpdateColumn>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};

/** Ordering options when selecting data from "booking.vehicle_type". */
export type BookingVehicleTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.vehicle_type */
export type BookingVehicleTypePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.vehicle_type" */
export enum BookingVehicleTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.vehicle_type" */
export type BookingVehicleTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_vehicle_type" */
export type BookingVehicleTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingVehicleTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingVehicleTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.vehicle_type" */
export enum BookingVehicleTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingVehicleTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingVehicleTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BookingVehicleTypeBoolExp;
};

/** update columns of table "booking.vehicle" */
export enum BookingVehicleUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  PlateId = 'plate_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type BookingVehicleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingVehicleSetInput>;
  /** filter the rows which have to be updated */
  where: BookingVehicleBoolExp;
};

/** contains the different whitelist types used by the booking platform */
export type BookingWhitelistType = {
  __typename?: 'booking_whitelist_type';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "booking.whitelist_type" */
export type BookingWhitelistTypeAggregate = {
  __typename?: 'booking_whitelist_type_aggregate';
  aggregate?: Maybe<BookingWhitelistTypeAggregateFields>;
  nodes: Array<BookingWhitelistType>;
};

/** aggregate fields of "booking.whitelist_type" */
export type BookingWhitelistTypeAggregateFields = {
  __typename?: 'booking_whitelist_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BookingWhitelistTypeMaxFields>;
  min?: Maybe<BookingWhitelistTypeMinFields>;
};


/** aggregate fields of "booking.whitelist_type" */
export type BookingWhitelistTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingWhitelistTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking.whitelist_type". All fields are combined with a logical 'AND'. */
export type BookingWhitelistTypeBoolExp = {
  _and?: InputMaybe<Array<BookingWhitelistTypeBoolExp>>;
  _not?: InputMaybe<BookingWhitelistTypeBoolExp>;
  _or?: InputMaybe<Array<BookingWhitelistTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking.whitelist_type" */
export enum BookingWhitelistTypeConstraint {
  /** unique or primary key constraint on columns "value" */
  WhitelistTypePkey = 'whitelist_type_pkey'
}

export enum BookingWhitelistTypeEnum {
  /** A regular whitelist entry */
  Basic = 'BASIC',
  /** A duration based whitelist entry */
  Duration = 'DURATION',
  /** A recurring whitelist entry */
  Recurring = 'RECURRING'
}

/** Boolean expression to compare columns of type "booking_whitelist_type_enum". All fields are combined with logical 'AND'. */
export type BookingWhitelistTypeEnumComparisonExp = {
  _eq?: InputMaybe<BookingWhitelistTypeEnum>;
  _in?: InputMaybe<Array<BookingWhitelistTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingWhitelistTypeEnum>;
  _nin?: InputMaybe<Array<BookingWhitelistTypeEnum>>;
};

/** input type for inserting data into table "booking.whitelist_type" */
export type BookingWhitelistTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingWhitelistTypeMaxFields = {
  __typename?: 'booking_whitelist_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingWhitelistTypeMinFields = {
  __typename?: 'booking_whitelist_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking.whitelist_type" */
export type BookingWhitelistTypeMutationResponse = {
  __typename?: 'booking_whitelist_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingWhitelistType>;
};

/** on_conflict condition type for table "booking.whitelist_type" */
export type BookingWhitelistTypeOnConflict = {
  constraint: BookingWhitelistTypeConstraint;
  update_columns?: Array<BookingWhitelistTypeUpdateColumn>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};

/** Ordering options when selecting data from "booking.whitelist_type". */
export type BookingWhitelistTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking.whitelist_type */
export type BookingWhitelistTypePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking.whitelist_type" */
export enum BookingWhitelistTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking.whitelist_type" */
export type BookingWhitelistTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_whitelist_type" */
export type BookingWhitelistTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BookingWhitelistTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingWhitelistTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking.whitelist_type" */
export enum BookingWhitelistTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingWhitelistTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingWhitelistTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BookingWhitelistTypeBoolExp;
};

/** Table to model calendar events with a recurrence policy */
export type CalendarEventPolicy = {
  __typename?: 'calendar_event_policy';
  created_at?: Maybe<Scalars['timestamptz']>;
  duration: Scalars['String'];
  id: Scalars['bigint'];
  rrule_string: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  whitelist_calendar_event_policies: Array<WhitelistCalendarEventPolicy>;
  /** An aggregate relationship */
  whitelist_calendar_event_policies_aggregate: WhitelistCalendarEventPolicyAggregate;
};


/** Table to model calendar events with a recurrence policy */
export type CalendarEventPolicyWhitelistCalendarEventPoliciesArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


/** Table to model calendar events with a recurrence policy */
export type CalendarEventPolicyWhitelistCalendarEventPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};

/** aggregated selection of "calendar_event_policy" */
export type CalendarEventPolicyAggregate = {
  __typename?: 'calendar_event_policy_aggregate';
  aggregate?: Maybe<CalendarEventPolicyAggregateFields>;
  nodes: Array<CalendarEventPolicy>;
};

/** aggregate fields of "calendar_event_policy" */
export type CalendarEventPolicyAggregateFields = {
  __typename?: 'calendar_event_policy_aggregate_fields';
  avg?: Maybe<CalendarEventPolicyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CalendarEventPolicyMaxFields>;
  min?: Maybe<CalendarEventPolicyMinFields>;
  stddev?: Maybe<CalendarEventPolicyStddevFields>;
  stddev_pop?: Maybe<CalendarEventPolicyStddevPopFields>;
  stddev_samp?: Maybe<CalendarEventPolicyStddevSampFields>;
  sum?: Maybe<CalendarEventPolicySumFields>;
  var_pop?: Maybe<CalendarEventPolicyVarPopFields>;
  var_samp?: Maybe<CalendarEventPolicyVarSampFields>;
  variance?: Maybe<CalendarEventPolicyVarianceFields>;
};


/** aggregate fields of "calendar_event_policy" */
export type CalendarEventPolicyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CalendarEventPolicySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CalendarEventPolicyAvgFields = {
  __typename?: 'calendar_event_policy_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "calendar_event_policy". All fields are combined with a logical 'AND'. */
export type CalendarEventPolicyBoolExp = {
  _and?: InputMaybe<Array<CalendarEventPolicyBoolExp>>;
  _not?: InputMaybe<CalendarEventPolicyBoolExp>;
  _or?: InputMaybe<Array<CalendarEventPolicyBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  duration?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  rrule_string?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelist_calendar_event_policies?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
  whitelist_calendar_event_policies_aggregate?: InputMaybe<WhitelistCalendarEventPolicyAggregateBoolExp>;
};

/** unique or primary key constraints on table "calendar_event_policy" */
export enum CalendarEventPolicyConstraint {
  /** unique or primary key constraint on columns "id" */
  CalendarEventPolicyPkey = 'calendar_event_policy_pkey'
}

/** input type for incrementing numeric columns in table "calendar_event_policy" */
export type CalendarEventPolicyIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "calendar_event_policy" */
export type CalendarEventPolicyInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  rrule_string?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_calendar_event_policies?: InputMaybe<WhitelistCalendarEventPolicyArrRelInsertInput>;
};

/** aggregate max on columns */
export type CalendarEventPolicyMaxFields = {
  __typename?: 'calendar_event_policy_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  rrule_string?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CalendarEventPolicyMinFields = {
  __typename?: 'calendar_event_policy_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  rrule_string?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "calendar_event_policy" */
export type CalendarEventPolicyMutationResponse = {
  __typename?: 'calendar_event_policy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarEventPolicy>;
};

/** input type for inserting object relation for remote table "calendar_event_policy" */
export type CalendarEventPolicyObjRelInsertInput = {
  data: CalendarEventPolicyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CalendarEventPolicyOnConflict>;
};

/** on_conflict condition type for table "calendar_event_policy" */
export type CalendarEventPolicyOnConflict = {
  constraint: CalendarEventPolicyConstraint;
  update_columns?: Array<CalendarEventPolicyUpdateColumn>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};

/** Ordering options when selecting data from "calendar_event_policy". */
export type CalendarEventPolicyOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rrule_string?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_calendar_event_policies_aggregate?: InputMaybe<WhitelistCalendarEventPolicyAggregateOrderBy>;
};

/** primary key columns input for table: calendar_event_policy */
export type CalendarEventPolicyPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "calendar_event_policy" */
export enum CalendarEventPolicySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  RruleString = 'rrule_string',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "calendar_event_policy" */
export type CalendarEventPolicySetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  rrule_string?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CalendarEventPolicyStddevFields = {
  __typename?: 'calendar_event_policy_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CalendarEventPolicyStddevPopFields = {
  __typename?: 'calendar_event_policy_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CalendarEventPolicyStddevSampFields = {
  __typename?: 'calendar_event_policy_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "calendar_event_policy" */
export type CalendarEventPolicyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CalendarEventPolicyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarEventPolicyStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  rrule_string?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CalendarEventPolicySumFields = {
  __typename?: 'calendar_event_policy_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "calendar_event_policy" */
export enum CalendarEventPolicyUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  RruleString = 'rrule_string',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CalendarEventPolicyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CalendarEventPolicyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarEventPolicySetInput>;
  /** filter the rows which have to be updated */
  where: CalendarEventPolicyBoolExp;
};

/** aggregate var_pop on columns */
export type CalendarEventPolicyVarPopFields = {
  __typename?: 'calendar_event_policy_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CalendarEventPolicyVarSampFields = {
  __typename?: 'calendar_event_policy_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CalendarEventPolicyVarianceFields = {
  __typename?: 'calendar_event_policy_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type CancelViolationCaseApiOutput = {
  __typename?: 'cancelViolationCaseAPIOutput';
  canceled?: Maybe<Array<Scalars['Int']>>;
  message: Scalars['String'];
  not_canceled?: Maybe<Array<Maybe<SummaryNotCancelled>>>;
};

/** columns and relationships of "cancellation_reason_view" */
export type CancellationReasonView = {
  __typename?: 'cancellation_reason_view';
  cancellation_reason?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
};

/** aggregated selection of "cancellation_reason_view" */
export type CancellationReasonViewAggregate = {
  __typename?: 'cancellation_reason_view_aggregate';
  aggregate?: Maybe<CancellationReasonViewAggregateFields>;
  nodes: Array<CancellationReasonView>;
};

/** aggregate fields of "cancellation_reason_view" */
export type CancellationReasonViewAggregateFields = {
  __typename?: 'cancellation_reason_view_aggregate_fields';
  avg?: Maybe<CancellationReasonViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CancellationReasonViewMaxFields>;
  min?: Maybe<CancellationReasonViewMinFields>;
  stddev?: Maybe<CancellationReasonViewStddevFields>;
  stddev_pop?: Maybe<CancellationReasonViewStddevPopFields>;
  stddev_samp?: Maybe<CancellationReasonViewStddevSampFields>;
  sum?: Maybe<CancellationReasonViewSumFields>;
  var_pop?: Maybe<CancellationReasonViewVarPopFields>;
  var_samp?: Maybe<CancellationReasonViewVarSampFields>;
  variance?: Maybe<CancellationReasonViewVarianceFields>;
};


/** aggregate fields of "cancellation_reason_view" */
export type CancellationReasonViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CancellationReasonViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CancellationReasonViewAvgFields = {
  __typename?: 'cancellation_reason_view_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cancellation_reason_view". All fields are combined with a logical 'AND'. */
export type CancellationReasonViewBoolExp = {
  _and?: InputMaybe<Array<CancellationReasonViewBoolExp>>;
  _not?: InputMaybe<CancellationReasonViewBoolExp>;
  _or?: InputMaybe<Array<CancellationReasonViewBoolExp>>;
  cancellation_reason?: InputMaybe<StringComparisonExp>;
  count?: InputMaybe<BigintComparisonExp>;
  month?: InputMaybe<TimestamptzComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type CancellationReasonViewMaxFields = {
  __typename?: 'cancellation_reason_view_max_fields';
  cancellation_reason?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CancellationReasonViewMinFields = {
  __typename?: 'cancellation_reason_view_min_fields';
  cancellation_reason?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "cancellation_reason_view". */
export type CancellationReasonViewOrderBy = {
  cancellation_reason?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  month?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
};

/** select columns of table "cancellation_reason_view" */
export enum CancellationReasonViewSelectColumn {
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  Count = 'count',
  /** column name */
  Month = 'month',
  /** column name */
  ParkingLot = 'parking_lot'
}

/** aggregate stddev on columns */
export type CancellationReasonViewStddevFields = {
  __typename?: 'cancellation_reason_view_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CancellationReasonViewStddevPopFields = {
  __typename?: 'cancellation_reason_view_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CancellationReasonViewStddevSampFields = {
  __typename?: 'cancellation_reason_view_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cancellation_reason_view" */
export type CancellationReasonViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CancellationReasonViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CancellationReasonViewStreamCursorValueInput = {
  cancellation_reason?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['bigint']>;
  month?: InputMaybe<Scalars['timestamptz']>;
  parking_lot?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CancellationReasonViewSumFields = {
  __typename?: 'cancellation_reason_view_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CancellationReasonViewVarPopFields = {
  __typename?: 'cancellation_reason_view_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CancellationReasonViewVarSampFields = {
  __typename?: 'cancellation_reason_view_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CancellationReasonViewVarianceFields = {
  __typename?: 'cancellation_reason_view_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cancellations" */
export type Cancellations = {
  __typename?: 'cancellations';
  cancelled_by?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  lot_id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reason_info?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "cancellations" */
export type CancellationsReasonInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cancellations" */
export type CancellationsAggregate = {
  __typename?: 'cancellations_aggregate';
  aggregate?: Maybe<CancellationsAggregateFields>;
  nodes: Array<Cancellations>;
};

/** aggregate fields of "cancellations" */
export type CancellationsAggregateFields = {
  __typename?: 'cancellations_aggregate_fields';
  avg?: Maybe<CancellationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CancellationsMaxFields>;
  min?: Maybe<CancellationsMinFields>;
  stddev?: Maybe<CancellationsStddevFields>;
  stddev_pop?: Maybe<CancellationsStddevPopFields>;
  stddev_samp?: Maybe<CancellationsStddevSampFields>;
  sum?: Maybe<CancellationsSumFields>;
  var_pop?: Maybe<CancellationsVarPopFields>;
  var_samp?: Maybe<CancellationsVarSampFields>;
  variance?: Maybe<CancellationsVarianceFields>;
};


/** aggregate fields of "cancellations" */
export type CancellationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CancellationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CancellationsAppendInput = {
  reason_info?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CancellationsAvgFields = {
  __typename?: 'cancellations_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cancellations". All fields are combined with a logical 'AND'. */
export type CancellationsBoolExp = {
  _and?: InputMaybe<Array<CancellationsBoolExp>>;
  _not?: InputMaybe<CancellationsBoolExp>;
  _or?: InputMaybe<Array<CancellationsBoolExp>>;
  cancelled_by?: InputMaybe<StringComparisonExp>;
  case_id?: InputMaybe<StringComparisonExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  plate_country?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  reason_info?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "cancellations" */
export enum CancellationsConstraint {
  /** unique or primary key constraint on columns "id" */
  CancellationsPkey = 'cancellations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CancellationsDeleteAtPathInput = {
  reason_info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CancellationsDeleteElemInput = {
  reason_info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CancellationsDeleteKeyInput = {
  reason_info?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "cancellations" */
export type CancellationsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "cancellations" */
export type CancellationsInsertInput = {
  cancelled_by?: InputMaybe<Scalars['String']>;
  case_id?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CancellationsMaxFields = {
  __typename?: 'cancellations_max_fields';
  cancelled_by?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CancellationsMinFields = {
  __typename?: 'cancellations_min_fields';
  cancelled_by?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cancellations" */
export type CancellationsMutationResponse = {
  __typename?: 'cancellations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cancellations>;
};

/** on_conflict condition type for table "cancellations" */
export type CancellationsOnConflict = {
  constraint: CancellationsConstraint;
  update_columns?: Array<CancellationsUpdateColumn>;
  where?: InputMaybe<CancellationsBoolExp>;
};

/** Ordering options when selecting data from "cancellations". */
export type CancellationsOrderBy = {
  cancelled_by?: InputMaybe<OrderBy>;
  case_id?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  reason_info?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cancellations */
export type CancellationsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CancellationsPrependInput = {
  reason_info?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cancellations" */
export enum CancellationsSelectColumn {
  /** column name */
  CancelledBy = 'cancelled_by',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cancellations" */
export type CancellationsSetInput = {
  cancelled_by?: InputMaybe<Scalars['String']>;
  case_id?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CancellationsStddevFields = {
  __typename?: 'cancellations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CancellationsStddevPopFields = {
  __typename?: 'cancellations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CancellationsStddevSampFields = {
  __typename?: 'cancellations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cancellations" */
export type CancellationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CancellationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CancellationsStreamCursorValueInput = {
  cancelled_by?: InputMaybe<Scalars['String']>;
  case_id?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CancellationsSumFields = {
  __typename?: 'cancellations_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cancellations" */
export enum CancellationsUpdateColumn {
  /** column name */
  CancelledBy = 'cancelled_by',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CancellationsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CancellationsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CancellationsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CancellationsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CancellationsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CancellationsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CancellationsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CancellationsSetInput>;
  /** filter the rows which have to be updated */
  where: CancellationsBoolExp;
};

/** aggregate var_pop on columns */
export type CancellationsVarPopFields = {
  __typename?: 'cancellations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CancellationsVarSampFields = {
  __typename?: 'cancellations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CancellationsVarianceFields = {
  __typename?: 'cancellations_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "car_driver" */
export type CarDriver = {
  __typename?: 'car_driver';
  car_make?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  company_violator?: Maybe<CompanyViolator>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  /** An object relationship */
  person?: Maybe<Person>;
  person_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  violation_cases: Array<ViolationCase>;
  /** An aggregate relationship */
  violation_cases_aggregate: ViolationCaseAggregate;
};


/** columns and relationships of "car_driver" */
export type CarDriverViolationCasesArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


/** columns and relationships of "car_driver" */
export type CarDriverViolationCasesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};

/** aggregated selection of "car_driver" */
export type CarDriverAggregate = {
  __typename?: 'car_driver_aggregate';
  aggregate?: Maybe<CarDriverAggregateFields>;
  nodes: Array<CarDriver>;
};

/** aggregate fields of "car_driver" */
export type CarDriverAggregateFields = {
  __typename?: 'car_driver_aggregate_fields';
  avg?: Maybe<CarDriverAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarDriverMaxFields>;
  min?: Maybe<CarDriverMinFields>;
  stddev?: Maybe<CarDriverStddevFields>;
  stddev_pop?: Maybe<CarDriverStddevPopFields>;
  stddev_samp?: Maybe<CarDriverStddevSampFields>;
  sum?: Maybe<CarDriverSumFields>;
  var_pop?: Maybe<CarDriverVarPopFields>;
  var_samp?: Maybe<CarDriverVarSampFields>;
  variance?: Maybe<CarDriverVarianceFields>;
};


/** aggregate fields of "car_driver" */
export type CarDriverAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarDriverSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarDriverAvgFields = {
  __typename?: 'car_driver_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "car_driver". All fields are combined with a logical 'AND'. */
export type CarDriverBoolExp = {
  _and?: InputMaybe<Array<CarDriverBoolExp>>;
  _not?: InputMaybe<CarDriverBoolExp>;
  _or?: InputMaybe<Array<CarDriverBoolExp>>;
  car_make?: InputMaybe<StringComparisonExp>;
  company_id?: InputMaybe<BigintComparisonExp>;
  company_violator?: InputMaybe<CompanyViolatorBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  person?: InputMaybe<PersonBoolExp>;
  person_id?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  received_at?: InputMaybe<DateComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violation_cases?: InputMaybe<ViolationCaseBoolExp>;
  violation_cases_aggregate?: InputMaybe<ViolationCaseAggregateBoolExp>;
};

/** unique or primary key constraints on table "car_driver" */
export enum CarDriverConstraint {
  /** unique or primary key constraint on columns "id" */
  CarDriverPkey = 'car_driver_pkey'
}

/** input type for incrementing numeric columns in table "car_driver" */
export type CarDriverIncInput = {
  company_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "car_driver" */
export type CarDriverInsertInput = {
  car_make?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  company_violator?: InputMaybe<CompanyViolatorObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person?: InputMaybe<PersonObjRelInsertInput>;
  person_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_cases?: InputMaybe<ViolationCaseArrRelInsertInput>;
};

/** aggregate max on columns */
export type CarDriverMaxFields = {
  __typename?: 'car_driver_max_fields';
  car_make?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CarDriverMinFields = {
  __typename?: 'car_driver_min_fields';
  car_make?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "car_driver" */
export type CarDriverMutationResponse = {
  __typename?: 'car_driver_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarDriver>;
};

/** input type for inserting object relation for remote table "car_driver" */
export type CarDriverObjRelInsertInput = {
  data: CarDriverInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarDriverOnConflict>;
};

/** on_conflict condition type for table "car_driver" */
export type CarDriverOnConflict = {
  constraint: CarDriverConstraint;
  update_columns?: Array<CarDriverUpdateColumn>;
  where?: InputMaybe<CarDriverBoolExp>;
};

/** Ordering options when selecting data from "car_driver". */
export type CarDriverOrderBy = {
  car_make?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  company_violator?: InputMaybe<CompanyViolatorOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person?: InputMaybe<PersonOrderBy>;
  person_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_cases_aggregate?: InputMaybe<ViolationCaseAggregateOrderBy>;
};

/** primary key columns input for table: car_driver */
export type CarDriverPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "car_driver" */
export enum CarDriverSelectColumn {
  /** column name */
  CarMake = 'car_make',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonId = 'person_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "car_driver" */
export type CarDriverSetInput = {
  car_make?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CarDriverStddevFields = {
  __typename?: 'car_driver_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarDriverStddevPopFields = {
  __typename?: 'car_driver_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarDriverStddevSampFields = {
  __typename?: 'car_driver_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "car_driver" */
export type CarDriverStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarDriverStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarDriverStreamCursorValueInput = {
  car_make?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CarDriverSumFields = {
  __typename?: 'car_driver_sum_fields';
  company_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "car_driver" */
export enum CarDriverUpdateColumn {
  /** column name */
  CarMake = 'car_make',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonId = 'person_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CarDriverUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarDriverIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarDriverSetInput>;
  /** filter the rows which have to be updated */
  where: CarDriverBoolExp;
};

/** aggregate var_pop on columns */
export type CarDriverVarPopFields = {
  __typename?: 'car_driver_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarDriverVarSampFields = {
  __typename?: 'car_driver_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarDriverVarianceFields = {
  __typename?: 'car_driver_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "car_owner" */
export type CarOwner = {
  __typename?: 'car_owner';
  car_make?: Maybe<Scalars['String']>;
  /** An object relationship */
  car_owner_request?: Maybe<CarOwnerRequests>;
  company_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  company_violator?: Maybe<CompanyViolator>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  /** An object relationship */
  person?: Maybe<Person>;
  person_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  violation_cases: Array<ViolationCase>;
  /** An aggregate relationship */
  violation_cases_aggregate: ViolationCaseAggregate;
};


/** columns and relationships of "car_owner" */
export type CarOwnerViolationCasesArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


/** columns and relationships of "car_owner" */
export type CarOwnerViolationCasesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};

/** aggregated selection of "car_owner" */
export type CarOwnerAggregate = {
  __typename?: 'car_owner_aggregate';
  aggregate?: Maybe<CarOwnerAggregateFields>;
  nodes: Array<CarOwner>;
};

export type CarOwnerAggregateBoolExp = {
  count?: InputMaybe<CarOwnerAggregateBoolExpCount>;
};

export type CarOwnerAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarOwnerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarOwnerBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "car_owner" */
export type CarOwnerAggregateFields = {
  __typename?: 'car_owner_aggregate_fields';
  avg?: Maybe<CarOwnerAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarOwnerMaxFields>;
  min?: Maybe<CarOwnerMinFields>;
  stddev?: Maybe<CarOwnerStddevFields>;
  stddev_pop?: Maybe<CarOwnerStddevPopFields>;
  stddev_samp?: Maybe<CarOwnerStddevSampFields>;
  sum?: Maybe<CarOwnerSumFields>;
  var_pop?: Maybe<CarOwnerVarPopFields>;
  var_samp?: Maybe<CarOwnerVarSampFields>;
  variance?: Maybe<CarOwnerVarianceFields>;
};


/** aggregate fields of "car_owner" */
export type CarOwnerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarOwnerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "car_owner" */
export type CarOwnerAggregateOrderBy = {
  avg?: InputMaybe<CarOwnerAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarOwnerMaxOrderBy>;
  min?: InputMaybe<CarOwnerMinOrderBy>;
  stddev?: InputMaybe<CarOwnerStddevOrderBy>;
  stddev_pop?: InputMaybe<CarOwnerStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarOwnerStddevSampOrderBy>;
  sum?: InputMaybe<CarOwnerSumOrderBy>;
  var_pop?: InputMaybe<CarOwnerVarPopOrderBy>;
  var_samp?: InputMaybe<CarOwnerVarSampOrderBy>;
  variance?: InputMaybe<CarOwnerVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "car_owner" */
export type CarOwnerArrRelInsertInput = {
  data: Array<CarOwnerInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarOwnerOnConflict>;
};

/** aggregate avg on columns */
export type CarOwnerAvgFields = {
  __typename?: 'car_owner_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "car_owner" */
export type CarOwnerAvgOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "car_owner". All fields are combined with a logical 'AND'. */
export type CarOwnerBoolExp = {
  _and?: InputMaybe<Array<CarOwnerBoolExp>>;
  _not?: InputMaybe<CarOwnerBoolExp>;
  _or?: InputMaybe<Array<CarOwnerBoolExp>>;
  car_make?: InputMaybe<StringComparisonExp>;
  car_owner_request?: InputMaybe<CarOwnerRequestsBoolExp>;
  company_id?: InputMaybe<IntComparisonExp>;
  company_violator?: InputMaybe<CompanyViolatorBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  person?: InputMaybe<PersonBoolExp>;
  person_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  received_at?: InputMaybe<DateComparisonExp>;
  request_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violation_cases?: InputMaybe<ViolationCaseBoolExp>;
  violation_cases_aggregate?: InputMaybe<ViolationCaseAggregateBoolExp>;
};

/** unique or primary key constraints on table "car_owner" */
export enum CarOwnerConstraint {
  /** unique or primary key constraint on columns "id" */
  CarOwnerPkey = 'car_owner_pkey'
}

/** input type for incrementing numeric columns in table "car_owner" */
export type CarOwnerIncInput = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['Int']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "car_owner" */
export type CarOwnerInsertInput = {
  car_make?: InputMaybe<Scalars['String']>;
  car_owner_request?: InputMaybe<CarOwnerRequestsObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['Int']>;
  company_violator?: InputMaybe<CompanyViolatorObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person?: InputMaybe<PersonObjRelInsertInput>;
  person_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_cases?: InputMaybe<ViolationCaseArrRelInsertInput>;
};

/** aggregate max on columns */
export type CarOwnerMaxFields = {
  __typename?: 'car_owner_max_fields';
  car_make?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "car_owner" */
export type CarOwnerMaxOrderBy = {
  car_make?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarOwnerMinFields = {
  __typename?: 'car_owner_min_fields';
  car_make?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "car_owner" */
export type CarOwnerMinOrderBy = {
  car_make?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "car_owner" */
export type CarOwnerMutationResponse = {
  __typename?: 'car_owner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarOwner>;
};

/** input type for inserting object relation for remote table "car_owner" */
export type CarOwnerObjRelInsertInput = {
  data: CarOwnerInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarOwnerOnConflict>;
};

/** on_conflict condition type for table "car_owner" */
export type CarOwnerOnConflict = {
  constraint: CarOwnerConstraint;
  update_columns?: Array<CarOwnerUpdateColumn>;
  where?: InputMaybe<CarOwnerBoolExp>;
};

/** Ordering options when selecting data from "car_owner". */
export type CarOwnerOrderBy = {
  car_make?: InputMaybe<OrderBy>;
  car_owner_request?: InputMaybe<CarOwnerRequestsOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  company_violator?: InputMaybe<CompanyViolatorOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person?: InputMaybe<PersonOrderBy>;
  person_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_cases_aggregate?: InputMaybe<ViolationCaseAggregateOrderBy>;
};

/** primary key columns input for table: car_owner */
export type CarOwnerPkColumnsInput = {
  id: Scalars['bigint'];
};

/** columns and relationships of "car_owner_requests" */
export type CarOwnerRequests = {
  __typename?: 'car_owner_requests';
  batch_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  car_owners: Array<CarOwner>;
  /** An aggregate relationship */
  car_owners_aggregate: CarOwnerAggregate;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  parking_results?: Maybe<ParkingResults>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  requested_at?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};


/** columns and relationships of "car_owner_requests" */
export type CarOwnerRequestsCarOwnersArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


/** columns and relationships of "car_owner_requests" */
export type CarOwnerRequestsCarOwnersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};

/** aggregated selection of "car_owner_requests" */
export type CarOwnerRequestsAggregate = {
  __typename?: 'car_owner_requests_aggregate';
  aggregate?: Maybe<CarOwnerRequestsAggregateFields>;
  nodes: Array<CarOwnerRequests>;
};

/** aggregate fields of "car_owner_requests" */
export type CarOwnerRequestsAggregateFields = {
  __typename?: 'car_owner_requests_aggregate_fields';
  avg?: Maybe<CarOwnerRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarOwnerRequestsMaxFields>;
  min?: Maybe<CarOwnerRequestsMinFields>;
  stddev?: Maybe<CarOwnerRequestsStddevFields>;
  stddev_pop?: Maybe<CarOwnerRequestsStddevPopFields>;
  stddev_samp?: Maybe<CarOwnerRequestsStddevSampFields>;
  sum?: Maybe<CarOwnerRequestsSumFields>;
  var_pop?: Maybe<CarOwnerRequestsVarPopFields>;
  var_samp?: Maybe<CarOwnerRequestsVarSampFields>;
  variance?: Maybe<CarOwnerRequestsVarianceFields>;
};


/** aggregate fields of "car_owner_requests" */
export type CarOwnerRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarOwnerRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarOwnerRequestsAvgFields = {
  __typename?: 'car_owner_requests_avg_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "car_owner_requests". All fields are combined with a logical 'AND'. */
export type CarOwnerRequestsBoolExp = {
  _and?: InputMaybe<Array<CarOwnerRequestsBoolExp>>;
  _not?: InputMaybe<CarOwnerRequestsBoolExp>;
  _or?: InputMaybe<Array<CarOwnerRequestsBoolExp>>;
  batch_id?: InputMaybe<IntComparisonExp>;
  car_owners?: InputMaybe<CarOwnerBoolExp>;
  car_owners_aggregate?: InputMaybe<CarOwnerAggregateBoolExp>;
  country?: InputMaybe<StringComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_results?: InputMaybe<ParkingResultsBoolExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  received_at?: InputMaybe<DateComparisonExp>;
  requested_at?: InputMaybe<DateComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "car_owner_requests" */
export enum CarOwnerRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  CarOwnerRequestsPkey = 'car_owner_requests_pkey'
}

/** input type for incrementing numeric columns in table "car_owner_requests" */
export type CarOwnerRequestsIncInput = {
  batch_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "car_owner_requests" */
export type CarOwnerRequestsInsertInput = {
  batch_id?: InputMaybe<Scalars['Int']>;
  car_owners?: InputMaybe<CarOwnerArrRelInsertInput>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results?: InputMaybe<ParkingResultsObjRelInsertInput>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  requested_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CarOwnerRequestsMaxFields = {
  __typename?: 'car_owner_requests_max_fields';
  batch_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  requested_at?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CarOwnerRequestsMinFields = {
  __typename?: 'car_owner_requests_min_fields';
  batch_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  received_at?: Maybe<Scalars['date']>;
  requested_at?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "car_owner_requests" */
export type CarOwnerRequestsMutationResponse = {
  __typename?: 'car_owner_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarOwnerRequests>;
};

/** input type for inserting object relation for remote table "car_owner_requests" */
export type CarOwnerRequestsObjRelInsertInput = {
  data: CarOwnerRequestsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarOwnerRequestsOnConflict>;
};

/** on_conflict condition type for table "car_owner_requests" */
export type CarOwnerRequestsOnConflict = {
  constraint: CarOwnerRequestsConstraint;
  update_columns?: Array<CarOwnerRequestsUpdateColumn>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};

/** Ordering options when selecting data from "car_owner_requests". */
export type CarOwnerRequestsOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  car_owners_aggregate?: InputMaybe<CarOwnerAggregateOrderBy>;
  country?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_results?: InputMaybe<ParkingResultsOrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  requested_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: car_owner_requests */
export type CarOwnerRequestsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "car_owner_requests" */
export enum CarOwnerRequestsSelectColumn {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Country = 'country',
  /** column name */
  Department = 'department',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "car_owner_requests" */
export type CarOwnerRequestsSetInput = {
  batch_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  requested_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CarOwnerRequestsStddevFields = {
  __typename?: 'car_owner_requests_stddev_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarOwnerRequestsStddevPopFields = {
  __typename?: 'car_owner_requests_stddev_pop_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarOwnerRequestsStddevSampFields = {
  __typename?: 'car_owner_requests_stddev_samp_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "car_owner_requests" */
export type CarOwnerRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarOwnerRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarOwnerRequestsStreamCursorValueInput = {
  batch_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  requested_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CarOwnerRequestsSumFields = {
  __typename?: 'car_owner_requests_sum_fields';
  batch_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "car_owner_requests" */
export enum CarOwnerRequestsUpdateColumn {
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Country = 'country',
  /** column name */
  Department = 'department',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status'
}

export type CarOwnerRequestsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarOwnerRequestsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarOwnerRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: CarOwnerRequestsBoolExp;
};

/** aggregate var_pop on columns */
export type CarOwnerRequestsVarPopFields = {
  __typename?: 'car_owner_requests_var_pop_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarOwnerRequestsVarSampFields = {
  __typename?: 'car_owner_requests_var_samp_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarOwnerRequestsVarianceFields = {
  __typename?: 'car_owner_requests_variance_fields';
  batch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "car_owner" */
export enum CarOwnerSelectColumn {
  /** column name */
  CarMake = 'car_make',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonId = 'person_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "car_owner" */
export type CarOwnerSetInput = {
  car_make?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CarOwnerStddevFields = {
  __typename?: 'car_owner_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "car_owner" */
export type CarOwnerStddevOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarOwnerStddevPopFields = {
  __typename?: 'car_owner_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "car_owner" */
export type CarOwnerStddevPopOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarOwnerStddevSampFields = {
  __typename?: 'car_owner_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "car_owner" */
export type CarOwnerStddevSampOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "car_owner" */
export type CarOwnerStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarOwnerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarOwnerStreamCursorValueInput = {
  car_make?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  person_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  received_at?: InputMaybe<Scalars['date']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CarOwnerSumFields = {
  __typename?: 'car_owner_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  person_id?: Maybe<Scalars['Int']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "car_owner" */
export type CarOwnerSumOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** update columns of table "car_owner" */
export enum CarOwnerUpdateColumn {
  /** column name */
  CarMake = 'car_make',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonId = 'person_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CarOwnerUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarOwnerIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarOwnerSetInput>;
  /** filter the rows which have to be updated */
  where: CarOwnerBoolExp;
};

/** aggregate var_pop on columns */
export type CarOwnerVarPopFields = {
  __typename?: 'car_owner_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "car_owner" */
export type CarOwnerVarPopOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarOwnerVarSampFields = {
  __typename?: 'car_owner_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "car_owner" */
export type CarOwnerVarSampOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarOwnerVarianceFields = {
  __typename?: 'car_owner_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  person_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "car_owner" */
export type CarOwnerVarianceOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person_id?: InputMaybe<OrderBy>;
  request_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPin = {
  __typename?: 'carpay_access_control_lp_pin';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  license_plate: Scalars['String'];
  lot_id: Scalars['String'];
  pin: Scalars['String'];
  valid_until: Scalars['timestamptz'];
};

/** aggregated selection of "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinAggregate = {
  __typename?: 'carpay_access_control_lp_pin_aggregate';
  aggregate?: Maybe<CarpayAccessControlLpPinAggregateFields>;
  nodes: Array<CarpayAccessControlLpPin>;
};

/** aggregate fields of "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinAggregateFields = {
  __typename?: 'carpay_access_control_lp_pin_aggregate_fields';
  avg?: Maybe<CarpayAccessControlLpPinAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayAccessControlLpPinMaxFields>;
  min?: Maybe<CarpayAccessControlLpPinMinFields>;
  stddev?: Maybe<CarpayAccessControlLpPinStddevFields>;
  stddev_pop?: Maybe<CarpayAccessControlLpPinStddevPopFields>;
  stddev_samp?: Maybe<CarpayAccessControlLpPinStddevSampFields>;
  sum?: Maybe<CarpayAccessControlLpPinSumFields>;
  var_pop?: Maybe<CarpayAccessControlLpPinVarPopFields>;
  var_samp?: Maybe<CarpayAccessControlLpPinVarSampFields>;
  variance?: Maybe<CarpayAccessControlLpPinVarianceFields>;
};


/** aggregate fields of "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayAccessControlLpPinSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayAccessControlLpPinAvgFields = {
  __typename?: 'carpay_access_control_lp_pin_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_access_control_lp_pin". All fields are combined with a logical 'AND'. */
export type CarpayAccessControlLpPinBoolExp = {
  _and?: InputMaybe<Array<CarpayAccessControlLpPinBoolExp>>;
  _not?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
  _or?: InputMaybe<Array<CarpayAccessControlLpPinBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  license_plate?: InputMaybe<StringComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  pin?: InputMaybe<StringComparisonExp>;
  valid_until?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "carpay_access_control_lp_pin" */
export enum CarpayAccessControlLpPinConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayAccessControlLpPinPkey = 'carpay_access_control_lp_pin_pkey'
}

/** input type for incrementing numeric columns in table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  license_plate?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  valid_until?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CarpayAccessControlLpPinMaxFields = {
  __typename?: 'carpay_access_control_lp_pin_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  license_plate?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  valid_until?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CarpayAccessControlLpPinMinFields = {
  __typename?: 'carpay_access_control_lp_pin_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  license_plate?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  valid_until?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinMutationResponse = {
  __typename?: 'carpay_access_control_lp_pin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayAccessControlLpPin>;
};

/** on_conflict condition type for table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinOnConflict = {
  constraint: CarpayAccessControlLpPinConstraint;
  update_columns?: Array<CarpayAccessControlLpPinUpdateColumn>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};

/** Ordering options when selecting data from "carpay_access_control_lp_pin". */
export type CarpayAccessControlLpPinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  license_plate?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pin?: InputMaybe<OrderBy>;
  valid_until?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_access_control_lp_pin */
export type CarpayAccessControlLpPinPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_access_control_lp_pin" */
export enum CarpayAccessControlLpPinSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Pin = 'pin',
  /** column name */
  ValidUntil = 'valid_until'
}

/** input type for updating data in table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  license_plate?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  valid_until?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CarpayAccessControlLpPinStddevFields = {
  __typename?: 'carpay_access_control_lp_pin_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayAccessControlLpPinStddevPopFields = {
  __typename?: 'carpay_access_control_lp_pin_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayAccessControlLpPinStddevSampFields = {
  __typename?: 'carpay_access_control_lp_pin_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_access_control_lp_pin" */
export type CarpayAccessControlLpPinStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayAccessControlLpPinStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayAccessControlLpPinStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  license_plate?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  valid_until?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CarpayAccessControlLpPinSumFields = {
  __typename?: 'carpay_access_control_lp_pin_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_access_control_lp_pin" */
export enum CarpayAccessControlLpPinUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Pin = 'pin',
  /** column name */
  ValidUntil = 'valid_until'
}

export type CarpayAccessControlLpPinUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayAccessControlLpPinIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayAccessControlLpPinSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayAccessControlLpPinBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayAccessControlLpPinVarPopFields = {
  __typename?: 'carpay_access_control_lp_pin_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayAccessControlLpPinVarSampFields = {
  __typename?: 'carpay_access_control_lp_pin_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayAccessControlLpPinVarianceFields = {
  __typename?: 'carpay_access_control_lp_pin_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_discount_batch" */
export type CarpayDiscountBatch = {
  __typename?: 'carpay_discount_batch';
  active: Scalars['Boolean'];
  batch_id: Scalars['Int'];
  /** An object relationship */
  carpay_discount_model: CarpayDiscountModel;
  carpay_discount_model_id: Scalars['Int'];
  code_type: EnumCarpayDiscountModelCodeTypeEnum;
  count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  expiration_date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  value?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "carpay_discount_batch" */
export type CarpayDiscountBatchValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_discount_batch" */
export type CarpayDiscountBatchAggregate = {
  __typename?: 'carpay_discount_batch_aggregate';
  aggregate?: Maybe<CarpayDiscountBatchAggregateFields>;
  nodes: Array<CarpayDiscountBatch>;
};

export type CarpayDiscountBatchAggregateBoolExp = {
  bool_and?: InputMaybe<CarpayDiscountBatchAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CarpayDiscountBatchAggregateBoolExpBoolOr>;
  count?: InputMaybe<CarpayDiscountBatchAggregateBoolExpCount>;
};

export type CarpayDiscountBatchAggregateBoolExpBoolAnd = {
  arguments: CarpayDiscountBatchSelectColumnCarpayDiscountBatchAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountBatchBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayDiscountBatchAggregateBoolExpBoolOr = {
  arguments: CarpayDiscountBatchSelectColumnCarpayDiscountBatchAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountBatchBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayDiscountBatchAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountBatchBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_discount_batch" */
export type CarpayDiscountBatchAggregateFields = {
  __typename?: 'carpay_discount_batch_aggregate_fields';
  avg?: Maybe<CarpayDiscountBatchAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayDiscountBatchMaxFields>;
  min?: Maybe<CarpayDiscountBatchMinFields>;
  stddev?: Maybe<CarpayDiscountBatchStddevFields>;
  stddev_pop?: Maybe<CarpayDiscountBatchStddevPopFields>;
  stddev_samp?: Maybe<CarpayDiscountBatchStddevSampFields>;
  sum?: Maybe<CarpayDiscountBatchSumFields>;
  var_pop?: Maybe<CarpayDiscountBatchVarPopFields>;
  var_samp?: Maybe<CarpayDiscountBatchVarSampFields>;
  variance?: Maybe<CarpayDiscountBatchVarianceFields>;
};


/** aggregate fields of "carpay_discount_batch" */
export type CarpayDiscountBatchAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_discount_batch" */
export type CarpayDiscountBatchAggregateOrderBy = {
  avg?: InputMaybe<CarpayDiscountBatchAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayDiscountBatchMaxOrderBy>;
  min?: InputMaybe<CarpayDiscountBatchMinOrderBy>;
  stddev?: InputMaybe<CarpayDiscountBatchStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayDiscountBatchStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayDiscountBatchStddevSampOrderBy>;
  sum?: InputMaybe<CarpayDiscountBatchSumOrderBy>;
  var_pop?: InputMaybe<CarpayDiscountBatchVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayDiscountBatchVarSampOrderBy>;
  variance?: InputMaybe<CarpayDiscountBatchVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayDiscountBatchAppendInput = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "carpay_discount_batch" */
export type CarpayDiscountBatchArrRelInsertInput = {
  data: Array<CarpayDiscountBatchInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayDiscountBatchOnConflict>;
};

/** aggregate avg on columns */
export type CarpayDiscountBatchAvgFields = {
  __typename?: 'carpay_discount_batch_avg_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchAvgOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_discount_batch". All fields are combined with a logical 'AND'. */
export type CarpayDiscountBatchBoolExp = {
  _and?: InputMaybe<Array<CarpayDiscountBatchBoolExp>>;
  _not?: InputMaybe<CarpayDiscountBatchBoolExp>;
  _or?: InputMaybe<Array<CarpayDiscountBatchBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  batch_id?: InputMaybe<IntComparisonExp>;
  carpay_discount_model?: InputMaybe<CarpayDiscountModelBoolExp>;
  carpay_discount_model_id?: InputMaybe<IntComparisonExp>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnumComparisonExp>;
  count?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  expiration_date?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "carpay_discount_batch" */
export enum CarpayDiscountBatchConstraint {
  /** unique or primary key constraint on columns "batch_id", "carpay_discount_model_id" */
  CarpayDiscountBatchBatchIdCarpayDiscountModelIdKey = 'carpay_discount_batch_batch_id_carpay_discount_model_id_key',
  /** unique or primary key constraint on columns "batch_id", "code_type" */
  CarpayDiscountBatchBatchIdCodeTypeKey = 'carpay_discount_batch_batch_id_code_type_key',
  /** unique or primary key constraint on columns "id" */
  CarpayDiscountBatchPkey = 'carpay_discount_batch_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayDiscountBatchDeleteAtPathInput = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayDiscountBatchDeleteElemInput = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayDiscountBatchDeleteKeyInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_discount_batch" */
export type CarpayDiscountBatchIncInput = {
  batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_discount_batch" */
export type CarpayDiscountBatchInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model?: InputMaybe<CarpayDiscountModelObjRelInsertInput>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CarpayDiscountBatchMaxFields = {
  __typename?: 'carpay_discount_batch_max_fields';
  batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchMaxOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  expiration_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayDiscountBatchMinFields = {
  __typename?: 'carpay_discount_batch_min_fields';
  batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchMinOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  expiration_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_discount_batch" */
export type CarpayDiscountBatchMutationResponse = {
  __typename?: 'carpay_discount_batch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayDiscountBatch>;
};

/** input type for inserting object relation for remote table "carpay_discount_batch" */
export type CarpayDiscountBatchObjRelInsertInput = {
  data: CarpayDiscountBatchInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayDiscountBatchOnConflict>;
};

/** on_conflict condition type for table "carpay_discount_batch" */
export type CarpayDiscountBatchOnConflict = {
  constraint: CarpayDiscountBatchConstraint;
  update_columns?: Array<CarpayDiscountBatchUpdateColumn>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};

/** Ordering options when selecting data from "carpay_discount_batch". */
export type CarpayDiscountBatchOrderBy = {
  active?: InputMaybe<OrderBy>;
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model?: InputMaybe<CarpayDiscountModelOrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  code_type?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  expiration_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_discount_batch */
export type CarpayDiscountBatchPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayDiscountBatchPrependInput = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_discount_batch" */
export enum CarpayDiscountBatchSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  CarpayDiscountModelId = 'carpay_discount_model_id',
  /** column name */
  CodeType = 'code_type',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** select "carpay_discount_batch_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carpay_discount_batch" */
export enum CarpayDiscountBatchSelectColumnCarpayDiscountBatchAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "carpay_discount_batch_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carpay_discount_batch" */
export enum CarpayDiscountBatchSelectColumnCarpayDiscountBatchAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "carpay_discount_batch" */
export type CarpayDiscountBatchSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CarpayDiscountBatchStddevFields = {
  __typename?: 'carpay_discount_batch_stddev_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchStddevOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayDiscountBatchStddevPopFields = {
  __typename?: 'carpay_discount_batch_stddev_pop_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchStddevPopOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayDiscountBatchStddevSampFields = {
  __typename?: 'carpay_discount_batch_stddev_samp_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchStddevSampOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_discount_batch" */
export type CarpayDiscountBatchStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayDiscountBatchStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayDiscountBatchStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type CarpayDiscountBatchSumFields = {
  __typename?: 'carpay_discount_batch_sum_fields';
  batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchSumOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_discount_batch" */
export enum CarpayDiscountBatchUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  CarpayDiscountModelId = 'carpay_discount_model_id',
  /** column name */
  CodeType = 'code_type',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type CarpayDiscountBatchUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayDiscountBatchAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayDiscountBatchDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayDiscountBatchDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayDiscountBatchDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayDiscountBatchIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayDiscountBatchPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayDiscountBatchSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayDiscountBatchBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayDiscountBatchVarPopFields = {
  __typename?: 'carpay_discount_batch_var_pop_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchVarPopOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayDiscountBatchVarSampFields = {
  __typename?: 'carpay_discount_batch_var_samp_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchVarSampOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayDiscountBatchVarianceFields = {
  __typename?: 'carpay_discount_batch_variance_fields';
  batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_discount_batch" */
export type CarpayDiscountBatchVarianceOrderBy = {
  batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModel = {
  __typename?: 'carpay_discount_model';
  active: Scalars['Boolean'];
  /** An array relationship */
  carpay_discount_batches: Array<CarpayDiscountBatch>;
  /** An aggregate relationship */
  carpay_discount_batches_aggregate: CarpayDiscountBatchAggregate;
  /** An object relationship */
  carpay_lot?: Maybe<CarpayLot>;
  /** An array relationship */
  carpay_scanned_codes: Array<CarpayScannedCodes>;
  /** An aggregate relationship */
  carpay_scanned_codes_aggregate: CarpayScannedCodesAggregate;
  code_type: EnumCarpayDiscountModelCodeTypeEnum;
  company_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  company_id_id?: Maybe<Company>;
  extractor?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  lot_id?: Maybe<Scalars['String']>;
  validator?: Maybe<Scalars['jsonb']>;
  value?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelCarpayDiscountBatchesArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelCarpayDiscountBatchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelCarpayScannedCodesArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelCarpayScannedCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelExtractorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelValidatorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_discount_model" */
export type CarpayDiscountModelValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_discount_model" */
export type CarpayDiscountModelAggregate = {
  __typename?: 'carpay_discount_model_aggregate';
  aggregate?: Maybe<CarpayDiscountModelAggregateFields>;
  nodes: Array<CarpayDiscountModel>;
};

export type CarpayDiscountModelAggregateBoolExp = {
  bool_and?: InputMaybe<CarpayDiscountModelAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CarpayDiscountModelAggregateBoolExpBoolOr>;
  count?: InputMaybe<CarpayDiscountModelAggregateBoolExpCount>;
};

export type CarpayDiscountModelAggregateBoolExpBoolAnd = {
  arguments: CarpayDiscountModelSelectColumnCarpayDiscountModelAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountModelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayDiscountModelAggregateBoolExpBoolOr = {
  arguments: CarpayDiscountModelSelectColumnCarpayDiscountModelAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountModelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayDiscountModelAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayDiscountModelBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_discount_model" */
export type CarpayDiscountModelAggregateFields = {
  __typename?: 'carpay_discount_model_aggregate_fields';
  avg?: Maybe<CarpayDiscountModelAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayDiscountModelMaxFields>;
  min?: Maybe<CarpayDiscountModelMinFields>;
  stddev?: Maybe<CarpayDiscountModelStddevFields>;
  stddev_pop?: Maybe<CarpayDiscountModelStddevPopFields>;
  stddev_samp?: Maybe<CarpayDiscountModelStddevSampFields>;
  sum?: Maybe<CarpayDiscountModelSumFields>;
  var_pop?: Maybe<CarpayDiscountModelVarPopFields>;
  var_samp?: Maybe<CarpayDiscountModelVarSampFields>;
  variance?: Maybe<CarpayDiscountModelVarianceFields>;
};


/** aggregate fields of "carpay_discount_model" */
export type CarpayDiscountModelAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_discount_model" */
export type CarpayDiscountModelAggregateOrderBy = {
  avg?: InputMaybe<CarpayDiscountModelAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayDiscountModelMaxOrderBy>;
  min?: InputMaybe<CarpayDiscountModelMinOrderBy>;
  stddev?: InputMaybe<CarpayDiscountModelStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayDiscountModelStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayDiscountModelStddevSampOrderBy>;
  sum?: InputMaybe<CarpayDiscountModelSumOrderBy>;
  var_pop?: InputMaybe<CarpayDiscountModelVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayDiscountModelVarSampOrderBy>;
  variance?: InputMaybe<CarpayDiscountModelVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayDiscountModelAppendInput = {
  extractor?: InputMaybe<Scalars['jsonb']>;
  validator?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "carpay_discount_model" */
export type CarpayDiscountModelArrRelInsertInput = {
  data: Array<CarpayDiscountModelInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayDiscountModelOnConflict>;
};

/** aggregate avg on columns */
export type CarpayDiscountModelAvgFields = {
  __typename?: 'carpay_discount_model_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_discount_model". All fields are combined with a logical 'AND'. */
export type CarpayDiscountModelBoolExp = {
  _and?: InputMaybe<Array<CarpayDiscountModelBoolExp>>;
  _not?: InputMaybe<CarpayDiscountModelBoolExp>;
  _or?: InputMaybe<Array<CarpayDiscountModelBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  carpay_discount_batches?: InputMaybe<CarpayDiscountBatchBoolExp>;
  carpay_discount_batches_aggregate?: InputMaybe<CarpayDiscountBatchAggregateBoolExp>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  carpay_scanned_codes?: InputMaybe<CarpayScannedCodesBoolExp>;
  carpay_scanned_codes_aggregate?: InputMaybe<CarpayScannedCodesAggregateBoolExp>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnumComparisonExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  company_id_id?: InputMaybe<CompanyBoolExp>;
  extractor?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  validator?: InputMaybe<JsonbComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "carpay_discount_model" */
export enum CarpayDiscountModelConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayDiscountModelPkey = 'carpay_discount_model_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayDiscountModelDeleteAtPathInput = {
  extractor?: InputMaybe<Array<Scalars['String']>>;
  validator?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayDiscountModelDeleteElemInput = {
  extractor?: InputMaybe<Scalars['Int']>;
  validator?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayDiscountModelDeleteKeyInput = {
  extractor?: InputMaybe<Scalars['String']>;
  validator?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_discount_model" */
export type CarpayDiscountModelIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_discount_model" */
export type CarpayDiscountModelInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  carpay_discount_batches?: InputMaybe<CarpayDiscountBatchArrRelInsertInput>;
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  carpay_scanned_codes?: InputMaybe<CarpayScannedCodesArrRelInsertInput>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  company_id?: InputMaybe<Scalars['String']>;
  company_id_id?: InputMaybe<CompanyObjRelInsertInput>;
  extractor?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  validator?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CarpayDiscountModelMaxFields = {
  __typename?: 'carpay_discount_model_max_fields';
  company_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelMaxOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayDiscountModelMinFields = {
  __typename?: 'carpay_discount_model_min_fields';
  company_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelMinOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_discount_model" */
export type CarpayDiscountModelMutationResponse = {
  __typename?: 'carpay_discount_model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayDiscountModel>;
};

/** input type for inserting object relation for remote table "carpay_discount_model" */
export type CarpayDiscountModelObjRelInsertInput = {
  data: CarpayDiscountModelInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayDiscountModelOnConflict>;
};

/** on_conflict condition type for table "carpay_discount_model" */
export type CarpayDiscountModelOnConflict = {
  constraint: CarpayDiscountModelConstraint;
  update_columns?: Array<CarpayDiscountModelUpdateColumn>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};

/** Ordering options when selecting data from "carpay_discount_model". */
export type CarpayDiscountModelOrderBy = {
  active?: InputMaybe<OrderBy>;
  carpay_discount_batches_aggregate?: InputMaybe<CarpayDiscountBatchAggregateOrderBy>;
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  carpay_scanned_codes_aggregate?: InputMaybe<CarpayScannedCodesAggregateOrderBy>;
  code_type?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  company_id_id?: InputMaybe<CompanyOrderBy>;
  extractor?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  validator?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_discount_model */
export type CarpayDiscountModelPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayDiscountModelPrependInput = {
  extractor?: InputMaybe<Scalars['jsonb']>;
  validator?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_discount_model" */
export enum CarpayDiscountModelSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CodeType = 'code_type',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Extractor = 'extractor',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Validator = 'validator',
  /** column name */
  Value = 'value'
}

/** select "carpay_discount_model_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carpay_discount_model" */
export enum CarpayDiscountModelSelectColumnCarpayDiscountModelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "carpay_discount_model_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carpay_discount_model" */
export enum CarpayDiscountModelSelectColumnCarpayDiscountModelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "carpay_discount_model" */
export type CarpayDiscountModelSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  company_id?: InputMaybe<Scalars['String']>;
  extractor?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  validator?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CarpayDiscountModelStddevFields = {
  __typename?: 'carpay_discount_model_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayDiscountModelStddevPopFields = {
  __typename?: 'carpay_discount_model_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayDiscountModelStddevSampFields = {
  __typename?: 'carpay_discount_model_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_discount_model" */
export type CarpayDiscountModelStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayDiscountModelStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayDiscountModelStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code_type?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  company_id?: InputMaybe<Scalars['String']>;
  extractor?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  validator?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type CarpayDiscountModelSumFields = {
  __typename?: 'carpay_discount_model_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_discount_model" */
export enum CarpayDiscountModelUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CodeType = 'code_type',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Extractor = 'extractor',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Validator = 'validator',
  /** column name */
  Value = 'value'
}

export type CarpayDiscountModelUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayDiscountModelAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayDiscountModelDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayDiscountModelDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayDiscountModelDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayDiscountModelIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayDiscountModelPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayDiscountModelSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayDiscountModelBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayDiscountModelVarPopFields = {
  __typename?: 'carpay_discount_model_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayDiscountModelVarSampFields = {
  __typename?: 'carpay_discount_model_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayDiscountModelVarianceFields = {
  __typename?: 'carpay_discount_model_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_discount_model" */
export type CarpayDiscountModelVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_lot" */
export type CarpayLot = {
  __typename?: 'carpay_lot';
  carpay_enabled: Scalars['Boolean'];
  /** An array relationship */
  carpay_pricing_recurrences: Array<CarpayPricingRecurrence>;
  /** An aggregate relationship */
  carpay_pricing_recurrences_aggregate: CarpayPricingRecurrenceAggregate;
  /** An object relationship */
  carpay_terminal_notification_config?: Maybe<CarpayTerminalNotificationConfig>;
  /** An array relationship */
  discount_models: Array<CarpayDiscountModel>;
  /** An aggregate relationship */
  discount_models_aggregate: CarpayDiscountModelAggregate;
  /** An object relationship */
  easypark_lot?: Maybe<EasyparkLot>;
  /** An object relationship */
  lot: Lot;
  lot_id: Scalars['String'];
  /** An array relationship */
  orders: Array<CarpayOrder>;
  /** An aggregate relationship */
  orders_aggregate: CarpayOrderAggregate;
  /** An object relationship */
  paybyphone_lot?: Maybe<PaybyphoneLot>;
  policy: Scalars['jsonb'];
  /** An array relationship */
  pricings: Array<CarpayPricing>;
  /** An aggregate relationship */
  pricings_aggregate: CarpayPricingAggregate;
  webapp_enabled: Scalars['Boolean'];
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotCarpayPricingRecurrencesArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotCarpayPricingRecurrencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotDiscountModelsArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotDiscountModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotOrdersArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotOrdersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotPricingsArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


/** columns and relationships of "carpay_lot" */
export type CarpayLotPricingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};

/** aggregated selection of "carpay_lot" */
export type CarpayLotAggregate = {
  __typename?: 'carpay_lot_aggregate';
  aggregate?: Maybe<CarpayLotAggregateFields>;
  nodes: Array<CarpayLot>;
};

/** aggregate fields of "carpay_lot" */
export type CarpayLotAggregateFields = {
  __typename?: 'carpay_lot_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CarpayLotMaxFields>;
  min?: Maybe<CarpayLotMinFields>;
};


/** aggregate fields of "carpay_lot" */
export type CarpayLotAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayLotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayLotAppendInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "carpay_lot". All fields are combined with a logical 'AND'. */
export type CarpayLotBoolExp = {
  _and?: InputMaybe<Array<CarpayLotBoolExp>>;
  _not?: InputMaybe<CarpayLotBoolExp>;
  _or?: InputMaybe<Array<CarpayLotBoolExp>>;
  carpay_enabled?: InputMaybe<BooleanComparisonExp>;
  carpay_pricing_recurrences?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
  carpay_pricing_recurrences_aggregate?: InputMaybe<CarpayPricingRecurrenceAggregateBoolExp>;
  carpay_terminal_notification_config?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
  discount_models?: InputMaybe<CarpayDiscountModelBoolExp>;
  discount_models_aggregate?: InputMaybe<CarpayDiscountModelAggregateBoolExp>;
  easypark_lot?: InputMaybe<EasyparkLotBoolExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  orders?: InputMaybe<CarpayOrderBoolExp>;
  orders_aggregate?: InputMaybe<CarpayOrderAggregateBoolExp>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotBoolExp>;
  policy?: InputMaybe<JsonbComparisonExp>;
  pricings?: InputMaybe<CarpayPricingBoolExp>;
  pricings_aggregate?: InputMaybe<CarpayPricingAggregateBoolExp>;
  webapp_enabled?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "carpay_lot" */
export enum CarpayLotConstraint {
  /** unique or primary key constraint on columns "lot_id" */
  CarpayLotLotIdKey = 'carpay_lot_lot_id_key',
  /** unique or primary key constraint on columns "lot_id" */
  CarpayLotPkey = 'carpay_lot_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayLotDeleteAtPathInput = {
  policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayLotDeleteElemInput = {
  policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayLotDeleteKeyInput = {
  policy?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "carpay_lot" */
export type CarpayLotInsertInput = {
  carpay_enabled?: InputMaybe<Scalars['Boolean']>;
  carpay_pricing_recurrences?: InputMaybe<CarpayPricingRecurrenceArrRelInsertInput>;
  carpay_terminal_notification_config?: InputMaybe<CarpayTerminalNotificationConfigObjRelInsertInput>;
  discount_models?: InputMaybe<CarpayDiscountModelArrRelInsertInput>;
  easypark_lot?: InputMaybe<EasyparkLotObjRelInsertInput>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<CarpayOrderArrRelInsertInput>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotObjRelInsertInput>;
  policy?: InputMaybe<Scalars['jsonb']>;
  pricings?: InputMaybe<CarpayPricingArrRelInsertInput>;
  webapp_enabled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type CarpayLotMaxFields = {
  __typename?: 'carpay_lot_max_fields';
  lot_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CarpayLotMinFields = {
  __typename?: 'carpay_lot_min_fields';
  lot_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "carpay_lot" */
export type CarpayLotMutationResponse = {
  __typename?: 'carpay_lot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayLot>;
};

/** input type for inserting object relation for remote table "carpay_lot" */
export type CarpayLotObjRelInsertInput = {
  data: CarpayLotInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayLotOnConflict>;
};

/** on_conflict condition type for table "carpay_lot" */
export type CarpayLotOnConflict = {
  constraint: CarpayLotConstraint;
  update_columns?: Array<CarpayLotUpdateColumn>;
  where?: InputMaybe<CarpayLotBoolExp>;
};

/** Ordering options when selecting data from "carpay_lot". */
export type CarpayLotOrderBy = {
  carpay_enabled?: InputMaybe<OrderBy>;
  carpay_pricing_recurrences_aggregate?: InputMaybe<CarpayPricingRecurrenceAggregateOrderBy>;
  carpay_terminal_notification_config?: InputMaybe<CarpayTerminalNotificationConfigOrderBy>;
  discount_models_aggregate?: InputMaybe<CarpayDiscountModelAggregateOrderBy>;
  easypark_lot?: InputMaybe<EasyparkLotOrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  orders_aggregate?: InputMaybe<CarpayOrderAggregateOrderBy>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotOrderBy>;
  policy?: InputMaybe<OrderBy>;
  pricings_aggregate?: InputMaybe<CarpayPricingAggregateOrderBy>;
  webapp_enabled?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_lot */
export type CarpayLotPkColumnsInput = {
  lot_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayLotPrependInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_lot" */
export enum CarpayLotSelectColumn {
  /** column name */
  CarpayEnabled = 'carpay_enabled',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  WebappEnabled = 'webapp_enabled'
}

/** input type for updating data in table "carpay_lot" */
export type CarpayLotSetInput = {
  carpay_enabled?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  webapp_enabled?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "carpay_lot" */
export type CarpayLotStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayLotStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayLotStreamCursorValueInput = {
  carpay_enabled?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  webapp_enabled?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "carpay_lot" */
export enum CarpayLotUpdateColumn {
  /** column name */
  CarpayEnabled = 'carpay_enabled',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  WebappEnabled = 'webapp_enabled'
}

export type CarpayLotUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayLotAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayLotDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayLotDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayLotDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayLotPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayLotSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayLotBoolExp;
};

/** columns and relationships of "carpay_notification_subscriber" */
export type CarpayNotificationSubscriber = {
  __typename?: 'carpay_notification_subscriber';
  email: Scalars['String'];
  id: Scalars['Int'];
};

/** aggregated selection of "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberAggregate = {
  __typename?: 'carpay_notification_subscriber_aggregate';
  aggregate?: Maybe<CarpayNotificationSubscriberAggregateFields>;
  nodes: Array<CarpayNotificationSubscriber>;
};

/** aggregate fields of "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberAggregateFields = {
  __typename?: 'carpay_notification_subscriber_aggregate_fields';
  avg?: Maybe<CarpayNotificationSubscriberAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayNotificationSubscriberMaxFields>;
  min?: Maybe<CarpayNotificationSubscriberMinFields>;
  stddev?: Maybe<CarpayNotificationSubscriberStddevFields>;
  stddev_pop?: Maybe<CarpayNotificationSubscriberStddevPopFields>;
  stddev_samp?: Maybe<CarpayNotificationSubscriberStddevSampFields>;
  sum?: Maybe<CarpayNotificationSubscriberSumFields>;
  var_pop?: Maybe<CarpayNotificationSubscriberVarPopFields>;
  var_samp?: Maybe<CarpayNotificationSubscriberVarSampFields>;
  variance?: Maybe<CarpayNotificationSubscriberVarianceFields>;
};


/** aggregate fields of "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayNotificationSubscriberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayNotificationSubscriberAvgFields = {
  __typename?: 'carpay_notification_subscriber_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_notification_subscriber". All fields are combined with a logical 'AND'. */
export type CarpayNotificationSubscriberBoolExp = {
  _and?: InputMaybe<Array<CarpayNotificationSubscriberBoolExp>>;
  _not?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
  _or?: InputMaybe<Array<CarpayNotificationSubscriberBoolExp>>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_notification_subscriber" */
export enum CarpayNotificationSubscriberConstraint {
  /** unique or primary key constraint on columns "email" */
  CarpayNotificationSubscriberEmailKey = 'carpay_notification_subscriber_email_key',
  /** unique or primary key constraint on columns "id" */
  CarpayNotificationSubscriberPkey = 'carpay_notification_subscriber_pkey'
}

/** input type for incrementing numeric columns in table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberInsertInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayNotificationSubscriberMaxFields = {
  __typename?: 'carpay_notification_subscriber_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CarpayNotificationSubscriberMinFields = {
  __typename?: 'carpay_notification_subscriber_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberMutationResponse = {
  __typename?: 'carpay_notification_subscriber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayNotificationSubscriber>;
};

/** input type for inserting object relation for remote table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberObjRelInsertInput = {
  data: CarpayNotificationSubscriberInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayNotificationSubscriberOnConflict>;
};

/** on_conflict condition type for table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberOnConflict = {
  constraint: CarpayNotificationSubscriberConstraint;
  update_columns?: Array<CarpayNotificationSubscriberUpdateColumn>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};

/** Ordering options when selecting data from "carpay_notification_subscriber". */
export type CarpayNotificationSubscriberOrderBy = {
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_notification_subscriber */
export type CarpayNotificationSubscriberPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_notification_subscriber" */
export enum CarpayNotificationSubscriberSelectColumn {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberSetInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayNotificationSubscriberStddevFields = {
  __typename?: 'carpay_notification_subscriber_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayNotificationSubscriberStddevPopFields = {
  __typename?: 'carpay_notification_subscriber_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayNotificationSubscriberStddevSampFields = {
  __typename?: 'carpay_notification_subscriber_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_notification_subscriber" */
export type CarpayNotificationSubscriberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayNotificationSubscriberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayNotificationSubscriberStreamCursorValueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayNotificationSubscriberSumFields = {
  __typename?: 'carpay_notification_subscriber_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_notification_subscriber" */
export enum CarpayNotificationSubscriberUpdateColumn {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id'
}

export type CarpayNotificationSubscriberUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayNotificationSubscriberIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayNotificationSubscriberSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayNotificationSubscriberBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayNotificationSubscriberVarPopFields = {
  __typename?: 'carpay_notification_subscriber_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayNotificationSubscriberVarSampFields = {
  __typename?: 'carpay_notification_subscriber_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayNotificationSubscriberVarianceFields = {
  __typename?: 'carpay_notification_subscriber_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_notification_subscription" */
export type CarpayNotificationSubscription = {
  __typename?: 'carpay_notification_subscription';
  /** An object relationship */
  carpay_notification_subscriber: CarpayNotificationSubscriber;
  /** An object relationship */
  carpay_notification_subscription_category: CarpayNotificationSubscriptionCategory;
  category_id: Scalars['Int'];
  lot_id: Scalars['String'];
  subscriber_id: Scalars['Int'];
};

/** aggregated selection of "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionAggregate = {
  __typename?: 'carpay_notification_subscription_aggregate';
  aggregate?: Maybe<CarpayNotificationSubscriptionAggregateFields>;
  nodes: Array<CarpayNotificationSubscription>;
};

/** aggregate fields of "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionAggregateFields = {
  __typename?: 'carpay_notification_subscription_aggregate_fields';
  avg?: Maybe<CarpayNotificationSubscriptionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayNotificationSubscriptionMaxFields>;
  min?: Maybe<CarpayNotificationSubscriptionMinFields>;
  stddev?: Maybe<CarpayNotificationSubscriptionStddevFields>;
  stddev_pop?: Maybe<CarpayNotificationSubscriptionStddevPopFields>;
  stddev_samp?: Maybe<CarpayNotificationSubscriptionStddevSampFields>;
  sum?: Maybe<CarpayNotificationSubscriptionSumFields>;
  var_pop?: Maybe<CarpayNotificationSubscriptionVarPopFields>;
  var_samp?: Maybe<CarpayNotificationSubscriptionVarSampFields>;
  variance?: Maybe<CarpayNotificationSubscriptionVarianceFields>;
};


/** aggregate fields of "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayNotificationSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayNotificationSubscriptionAvgFields = {
  __typename?: 'carpay_notification_subscription_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_notification_subscription". All fields are combined with a logical 'AND'. */
export type CarpayNotificationSubscriptionBoolExp = {
  _and?: InputMaybe<Array<CarpayNotificationSubscriptionBoolExp>>;
  _not?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
  _or?: InputMaybe<Array<CarpayNotificationSubscriptionBoolExp>>;
  carpay_notification_subscriber?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
  carpay_notification_subscription_category?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
  category_id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  subscriber_id?: InputMaybe<IntComparisonExp>;
};

/** columns and relationships of "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategory = {
  __typename?: 'carpay_notification_subscription_category';
  category: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** aggregated selection of "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryAggregate = {
  __typename?: 'carpay_notification_subscription_category_aggregate';
  aggregate?: Maybe<CarpayNotificationSubscriptionCategoryAggregateFields>;
  nodes: Array<CarpayNotificationSubscriptionCategory>;
};

/** aggregate fields of "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryAggregateFields = {
  __typename?: 'carpay_notification_subscription_category_aggregate_fields';
  avg?: Maybe<CarpayNotificationSubscriptionCategoryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayNotificationSubscriptionCategoryMaxFields>;
  min?: Maybe<CarpayNotificationSubscriptionCategoryMinFields>;
  stddev?: Maybe<CarpayNotificationSubscriptionCategoryStddevFields>;
  stddev_pop?: Maybe<CarpayNotificationSubscriptionCategoryStddevPopFields>;
  stddev_samp?: Maybe<CarpayNotificationSubscriptionCategoryStddevSampFields>;
  sum?: Maybe<CarpayNotificationSubscriptionCategorySumFields>;
  var_pop?: Maybe<CarpayNotificationSubscriptionCategoryVarPopFields>;
  var_samp?: Maybe<CarpayNotificationSubscriptionCategoryVarSampFields>;
  variance?: Maybe<CarpayNotificationSubscriptionCategoryVarianceFields>;
};


/** aggregate fields of "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayNotificationSubscriptionCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayNotificationSubscriptionCategoryAvgFields = {
  __typename?: 'carpay_notification_subscription_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_notification_subscription_category". All fields are combined with a logical 'AND'. */
export type CarpayNotificationSubscriptionCategoryBoolExp = {
  _and?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryBoolExp>>;
  _not?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
  _or?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_notification_subscription_category" */
export enum CarpayNotificationSubscriptionCategoryConstraint {
  /** unique or primary key constraint on columns "category" */
  CarpayNotificationSubscriptionCategoryCategoryKey = 'carpay_notification_subscription_category_category_key',
  /** unique or primary key constraint on columns "id" */
  CarpayNotificationSubscriptionCategoryPkey = 'carpay_notification_subscription_category_pkey'
}

/** input type for incrementing numeric columns in table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryInsertInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayNotificationSubscriptionCategoryMaxFields = {
  __typename?: 'carpay_notification_subscription_category_max_fields';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CarpayNotificationSubscriptionCategoryMinFields = {
  __typename?: 'carpay_notification_subscription_category_min_fields';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryMutationResponse = {
  __typename?: 'carpay_notification_subscription_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayNotificationSubscriptionCategory>;
};

/** input type for inserting object relation for remote table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryObjRelInsertInput = {
  data: CarpayNotificationSubscriptionCategoryInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayNotificationSubscriptionCategoryOnConflict>;
};

/** on_conflict condition type for table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryOnConflict = {
  constraint: CarpayNotificationSubscriptionCategoryConstraint;
  update_columns?: Array<CarpayNotificationSubscriptionCategoryUpdateColumn>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};

/** Ordering options when selecting data from "carpay_notification_subscription_category". */
export type CarpayNotificationSubscriptionCategoryOrderBy = {
  category?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_notification_subscription_category */
export type CarpayNotificationSubscriptionCategoryPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_notification_subscription_category" */
export enum CarpayNotificationSubscriptionCategorySelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategorySetInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayNotificationSubscriptionCategoryStddevFields = {
  __typename?: 'carpay_notification_subscription_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayNotificationSubscriptionCategoryStddevPopFields = {
  __typename?: 'carpay_notification_subscription_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayNotificationSubscriptionCategoryStddevSampFields = {
  __typename?: 'carpay_notification_subscription_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_notification_subscription_category" */
export type CarpayNotificationSubscriptionCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayNotificationSubscriptionCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayNotificationSubscriptionCategoryStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayNotificationSubscriptionCategorySumFields = {
  __typename?: 'carpay_notification_subscription_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_notification_subscription_category" */
export enum CarpayNotificationSubscriptionCategoryUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

export type CarpayNotificationSubscriptionCategoryUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayNotificationSubscriptionCategoryIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayNotificationSubscriptionCategorySetInput>;
  /** filter the rows which have to be updated */
  where: CarpayNotificationSubscriptionCategoryBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayNotificationSubscriptionCategoryVarPopFields = {
  __typename?: 'carpay_notification_subscription_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayNotificationSubscriptionCategoryVarSampFields = {
  __typename?: 'carpay_notification_subscription_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayNotificationSubscriptionCategoryVarianceFields = {
  __typename?: 'carpay_notification_subscription_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "carpay_notification_subscription" */
export enum CarpayNotificationSubscriptionConstraint {
  /** unique or primary key constraint on columns "lot_id", "subscriber_id", "category_id" */
  CarpayNotificationSubscriptionPkey = 'carpay_notification_subscription_pkey'
}

/** input type for incrementing numeric columns in table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionIncInput = {
  category_id?: InputMaybe<Scalars['Int']>;
  subscriber_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionInsertInput = {
  carpay_notification_subscriber?: InputMaybe<CarpayNotificationSubscriberObjRelInsertInput>;
  carpay_notification_subscription_category?: InputMaybe<CarpayNotificationSubscriptionCategoryObjRelInsertInput>;
  category_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  subscriber_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayNotificationSubscriptionMaxFields = {
  __typename?: 'carpay_notification_subscription_max_fields';
  category_id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  subscriber_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CarpayNotificationSubscriptionMinFields = {
  __typename?: 'carpay_notification_subscription_min_fields';
  category_id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  subscriber_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionMutationResponse = {
  __typename?: 'carpay_notification_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayNotificationSubscription>;
};

/** on_conflict condition type for table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionOnConflict = {
  constraint: CarpayNotificationSubscriptionConstraint;
  update_columns?: Array<CarpayNotificationSubscriptionUpdateColumn>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};

/** Ordering options when selecting data from "carpay_notification_subscription". */
export type CarpayNotificationSubscriptionOrderBy = {
  carpay_notification_subscriber?: InputMaybe<CarpayNotificationSubscriberOrderBy>;
  carpay_notification_subscription_category?: InputMaybe<CarpayNotificationSubscriptionCategoryOrderBy>;
  category_id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  subscriber_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_notification_subscription */
export type CarpayNotificationSubscriptionPkColumnsInput = {
  category_id: Scalars['Int'];
  lot_id: Scalars['String'];
  subscriber_id: Scalars['Int'];
};

/** select columns of table "carpay_notification_subscription" */
export enum CarpayNotificationSubscriptionSelectColumn {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SubscriberId = 'subscriber_id'
}

/** input type for updating data in table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionSetInput = {
  category_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  subscriber_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayNotificationSubscriptionStddevFields = {
  __typename?: 'carpay_notification_subscription_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayNotificationSubscriptionStddevPopFields = {
  __typename?: 'carpay_notification_subscription_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayNotificationSubscriptionStddevSampFields = {
  __typename?: 'carpay_notification_subscription_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_notification_subscription" */
export type CarpayNotificationSubscriptionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayNotificationSubscriptionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayNotificationSubscriptionStreamCursorValueInput = {
  category_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  subscriber_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayNotificationSubscriptionSumFields = {
  __typename?: 'carpay_notification_subscription_sum_fields';
  category_id?: Maybe<Scalars['Int']>;
  subscriber_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_notification_subscription" */
export enum CarpayNotificationSubscriptionUpdateColumn {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SubscriberId = 'subscriber_id'
}

export type CarpayNotificationSubscriptionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayNotificationSubscriptionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayNotificationSubscriptionSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayNotificationSubscriptionBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayNotificationSubscriptionVarPopFields = {
  __typename?: 'carpay_notification_subscription_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayNotificationSubscriptionVarSampFields = {
  __typename?: 'carpay_notification_subscription_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayNotificationSubscriptionVarianceFields = {
  __typename?: 'carpay_notification_subscription_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  subscriber_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_order" */
export type CarpayOrder = {
  __typename?: 'carpay_order';
  /** An object relationship */
  carpay_lot: CarpayLot;
  /** An object relationship */
  carpay_order_user?: Maybe<CarpayOrderUser>;
  /** An array relationship */
  carpay_scanned_codes: Array<CarpayScannedCodes>;
  /** An aggregate relationship */
  carpay_scanned_codes_aggregate: CarpayScannedCodesAggregate;
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  easypark_order?: Maybe<EasyparkOrder>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  illegal_timeranges?: Maybe<Scalars['jsonb']>;
  invoice_generated_at?: Maybe<Scalars['timestamptz']>;
  invoice_id?: Maybe<Scalars['String']>;
  legal_timeranges?: Maybe<Scalars['jsonb']>;
  lot_id: Scalars['String'];
  order_id: Scalars['String'];
  /** An array relationship */
  paid_match: Array<CarpayOrderMatches>;
  /** An aggregate relationship */
  paid_match_aggregate: CarpayOrderMatchesAggregate;
  /** An object relationship */
  parking_context?: Maybe<ParkingContext>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_details?: Maybe<Scalars['jsonb']>;
  parking_details_out?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  parking_results?: Maybe<ParkingResults>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  parking_results_matching_info?: Maybe<Scalars['jsonb']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  parking_uuid_out?: Maybe<Scalars['uuid']>;
  payment?: Maybe<Scalars['jsonb']>;
  plate: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  price_valid_until?: Maybe<Scalars['timestamptz']>;
  start_date: Scalars['timestamptz'];
  status: Scalars['String'];
  /** An array relationship */
  unpaid_match: Array<CarpayOrderMatches>;
  /** An aggregate relationship */
  unpaid_match_aggregate: CarpayOrderMatchesAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  whitelist?: Maybe<WhitelistPaidParking>;
  whitelist_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderCarpayScannedCodesArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderCarpayScannedCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderIllegalTimerangesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderLegalTimerangesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderPaidMatchArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderPaidMatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderParkingDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderParkingDetailsOutArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderParkingResultsMatchingInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderPaymentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderUnpaidMatchArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


/** columns and relationships of "carpay_order" */
export type CarpayOrderUnpaidMatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};

/** aggregated selection of "carpay_order" */
export type CarpayOrderAggregate = {
  __typename?: 'carpay_order_aggregate';
  aggregate?: Maybe<CarpayOrderAggregateFields>;
  nodes: Array<CarpayOrder>;
};

export type CarpayOrderAggregateBoolExp = {
  count?: InputMaybe<CarpayOrderAggregateBoolExpCount>;
};

export type CarpayOrderAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayOrderBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_order" */
export type CarpayOrderAggregateFields = {
  __typename?: 'carpay_order_aggregate_fields';
  avg?: Maybe<CarpayOrderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayOrderMaxFields>;
  min?: Maybe<CarpayOrderMinFields>;
  stddev?: Maybe<CarpayOrderStddevFields>;
  stddev_pop?: Maybe<CarpayOrderStddevPopFields>;
  stddev_samp?: Maybe<CarpayOrderStddevSampFields>;
  sum?: Maybe<CarpayOrderSumFields>;
  var_pop?: Maybe<CarpayOrderVarPopFields>;
  var_samp?: Maybe<CarpayOrderVarSampFields>;
  variance?: Maybe<CarpayOrderVarianceFields>;
};


/** aggregate fields of "carpay_order" */
export type CarpayOrderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_order" */
export type CarpayOrderAggregateOrderBy = {
  avg?: InputMaybe<CarpayOrderAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayOrderMaxOrderBy>;
  min?: InputMaybe<CarpayOrderMinOrderBy>;
  stddev?: InputMaybe<CarpayOrderStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayOrderStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayOrderStddevSampOrderBy>;
  sum?: InputMaybe<CarpayOrderSumOrderBy>;
  var_pop?: InputMaybe<CarpayOrderVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayOrderVarSampOrderBy>;
  variance?: InputMaybe<CarpayOrderVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayOrderAppendInput = {
  illegal_timeranges?: InputMaybe<Scalars['jsonb']>;
  legal_timeranges?: InputMaybe<Scalars['jsonb']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_details_out?: InputMaybe<Scalars['jsonb']>;
  parking_results_matching_info?: InputMaybe<Scalars['jsonb']>;
  payment?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "carpay_order" */
export type CarpayOrderArrRelInsertInput = {
  data: Array<CarpayOrderInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayOrderOnConflict>;
};

/** aggregate avg on columns */
export type CarpayOrderAvgFields = {
  __typename?: 'carpay_order_avg_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_order" */
export type CarpayOrderAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_order". All fields are combined with a logical 'AND'. */
export type CarpayOrderBoolExp = {
  _and?: InputMaybe<Array<CarpayOrderBoolExp>>;
  _not?: InputMaybe<CarpayOrderBoolExp>;
  _or?: InputMaybe<Array<CarpayOrderBoolExp>>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  carpay_order_user?: InputMaybe<CarpayOrderUserBoolExp>;
  carpay_scanned_codes?: InputMaybe<CarpayScannedCodesBoolExp>;
  carpay_scanned_codes_aggregate?: InputMaybe<CarpayScannedCodesAggregateBoolExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  drive_in_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  drive_out_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  easypark_order?: InputMaybe<EasyparkOrderBoolExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  illegal_timeranges?: InputMaybe<JsonbComparisonExp>;
  invoice_generated_at?: InputMaybe<TimestamptzComparisonExp>;
  invoice_id?: InputMaybe<StringComparisonExp>;
  legal_timeranges?: InputMaybe<JsonbComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  order_id?: InputMaybe<StringComparisonExp>;
  paid_match?: InputMaybe<CarpayOrderMatchesBoolExp>;
  paid_match_aggregate?: InputMaybe<CarpayOrderMatchesAggregateBoolExp>;
  parking_context?: InputMaybe<ParkingContextBoolExp>;
  parking_context_uuid?: InputMaybe<UuidComparisonExp>;
  parking_details?: InputMaybe<JsonbComparisonExp>;
  parking_details_out?: InputMaybe<JsonbComparisonExp>;
  parking_results?: InputMaybe<ParkingResultsBoolExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  parking_results_matching_info?: InputMaybe<JsonbComparisonExp>;
  parking_uuid?: InputMaybe<UuidComparisonExp>;
  parking_uuid_out?: InputMaybe<UuidComparisonExp>;
  payment?: InputMaybe<JsonbComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  price?: InputMaybe<FloatComparisonExp>;
  price_valid_until?: InputMaybe<TimestamptzComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  unpaid_match?: InputMaybe<CarpayOrderMatchesBoolExp>;
  unpaid_match_aggregate?: InputMaybe<CarpayOrderMatchesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelist?: InputMaybe<WhitelistPaidParkingBoolExp>;
  whitelist_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_order" */
export enum CarpayOrderConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayOrderIdKey = 'carpay_order_id_key',
  /** unique or primary key constraint on columns "invoice_id" */
  CarpayOrderInvoiceIdKey = 'carpay_order_invoice_id_key',
  /** unique or primary key constraint on columns "order_id" */
  CarpayOrderOrderIdKey = 'carpay_order_order_id_key',
  /** unique or primary key constraint on columns "id" */
  CarpayOrderPkey = 'carpay_order_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayOrderDeleteAtPathInput = {
  illegal_timeranges?: InputMaybe<Array<Scalars['String']>>;
  legal_timeranges?: InputMaybe<Array<Scalars['String']>>;
  parking_details?: InputMaybe<Array<Scalars['String']>>;
  parking_details_out?: InputMaybe<Array<Scalars['String']>>;
  parking_results_matching_info?: InputMaybe<Array<Scalars['String']>>;
  payment?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayOrderDeleteElemInput = {
  illegal_timeranges?: InputMaybe<Scalars['Int']>;
  legal_timeranges?: InputMaybe<Scalars['Int']>;
  parking_details?: InputMaybe<Scalars['Int']>;
  parking_details_out?: InputMaybe<Scalars['Int']>;
  parking_results_matching_info?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayOrderDeleteKeyInput = {
  illegal_timeranges?: InputMaybe<Scalars['String']>;
  legal_timeranges?: InputMaybe<Scalars['String']>;
  parking_details?: InputMaybe<Scalars['String']>;
  parking_details_out?: InputMaybe<Scalars['String']>;
  parking_results_matching_info?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_order" */
export type CarpayOrderIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['Float']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_order" */
export type CarpayOrderInsertInput = {
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  carpay_order_user?: InputMaybe<CarpayOrderUserObjRelInsertInput>;
  carpay_scanned_codes?: InputMaybe<CarpayScannedCodesArrRelInsertInput>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  easypark_order?: InputMaybe<EasyparkOrderObjRelInsertInput>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  illegal_timeranges?: InputMaybe<Scalars['jsonb']>;
  invoice_generated_at?: InputMaybe<Scalars['timestamptz']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  legal_timeranges?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  paid_match?: InputMaybe<CarpayOrderMatchesArrRelInsertInput>;
  parking_context?: InputMaybe<ParkingContextObjRelInsertInput>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_details_out?: InputMaybe<Scalars['jsonb']>;
  parking_results?: InputMaybe<ParkingResultsObjRelInsertInput>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  parking_results_matching_info?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  parking_uuid_out?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_valid_until?: InputMaybe<Scalars['timestamptz']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  unpaid_match?: InputMaybe<CarpayOrderMatchesArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist?: InputMaybe<WhitelistPaidParkingObjRelInsertInput>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "carpay_order_matches" */
export type CarpayOrderMatches = {
  __typename?: 'carpay_order_matches';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  matched_paid_order: CarpayOrder;
  /** An object relationship */
  matched_unpaid_order: CarpayOrder;
  paid_order: Scalars['bigint'];
  unpaid_order: Scalars['bigint'];
};

/** aggregated selection of "carpay_order_matches" */
export type CarpayOrderMatchesAggregate = {
  __typename?: 'carpay_order_matches_aggregate';
  aggregate?: Maybe<CarpayOrderMatchesAggregateFields>;
  nodes: Array<CarpayOrderMatches>;
};

export type CarpayOrderMatchesAggregateBoolExp = {
  count?: InputMaybe<CarpayOrderMatchesAggregateBoolExpCount>;
};

export type CarpayOrderMatchesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayOrderMatchesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_order_matches" */
export type CarpayOrderMatchesAggregateFields = {
  __typename?: 'carpay_order_matches_aggregate_fields';
  avg?: Maybe<CarpayOrderMatchesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayOrderMatchesMaxFields>;
  min?: Maybe<CarpayOrderMatchesMinFields>;
  stddev?: Maybe<CarpayOrderMatchesStddevFields>;
  stddev_pop?: Maybe<CarpayOrderMatchesStddevPopFields>;
  stddev_samp?: Maybe<CarpayOrderMatchesStddevSampFields>;
  sum?: Maybe<CarpayOrderMatchesSumFields>;
  var_pop?: Maybe<CarpayOrderMatchesVarPopFields>;
  var_samp?: Maybe<CarpayOrderMatchesVarSampFields>;
  variance?: Maybe<CarpayOrderMatchesVarianceFields>;
};


/** aggregate fields of "carpay_order_matches" */
export type CarpayOrderMatchesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_order_matches" */
export type CarpayOrderMatchesAggregateOrderBy = {
  avg?: InputMaybe<CarpayOrderMatchesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayOrderMatchesMaxOrderBy>;
  min?: InputMaybe<CarpayOrderMatchesMinOrderBy>;
  stddev?: InputMaybe<CarpayOrderMatchesStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayOrderMatchesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayOrderMatchesStddevSampOrderBy>;
  sum?: InputMaybe<CarpayOrderMatchesSumOrderBy>;
  var_pop?: InputMaybe<CarpayOrderMatchesVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayOrderMatchesVarSampOrderBy>;
  variance?: InputMaybe<CarpayOrderMatchesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "carpay_order_matches" */
export type CarpayOrderMatchesArrRelInsertInput = {
  data: Array<CarpayOrderMatchesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayOrderMatchesOnConflict>;
};

/** aggregate avg on columns */
export type CarpayOrderMatchesAvgFields = {
  __typename?: 'carpay_order_matches_avg_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_order_matches". All fields are combined with a logical 'AND'. */
export type CarpayOrderMatchesBoolExp = {
  _and?: InputMaybe<Array<CarpayOrderMatchesBoolExp>>;
  _not?: InputMaybe<CarpayOrderMatchesBoolExp>;
  _or?: InputMaybe<Array<CarpayOrderMatchesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  matched_paid_order?: InputMaybe<CarpayOrderBoolExp>;
  matched_unpaid_order?: InputMaybe<CarpayOrderBoolExp>;
  paid_order?: InputMaybe<BigintComparisonExp>;
  unpaid_order?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "carpay_order_matches" */
export enum CarpayOrderMatchesConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayOrderMatchesPkey = 'carpay_order_matches_pkey'
}

/** input type for incrementing numeric columns in table "carpay_order_matches" */
export type CarpayOrderMatchesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  paid_order?: InputMaybe<Scalars['bigint']>;
  unpaid_order?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "carpay_order_matches" */
export type CarpayOrderMatchesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  matched_paid_order?: InputMaybe<CarpayOrderObjRelInsertInput>;
  matched_unpaid_order?: InputMaybe<CarpayOrderObjRelInsertInput>;
  paid_order?: InputMaybe<Scalars['bigint']>;
  unpaid_order?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type CarpayOrderMatchesMaxFields = {
  __typename?: 'carpay_order_matches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paid_order?: Maybe<Scalars['bigint']>;
  unpaid_order?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayOrderMatchesMinFields = {
  __typename?: 'carpay_order_matches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paid_order?: Maybe<Scalars['bigint']>;
  unpaid_order?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_order_matches" */
export type CarpayOrderMatchesMutationResponse = {
  __typename?: 'carpay_order_matches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayOrderMatches>;
};

/** on_conflict condition type for table "carpay_order_matches" */
export type CarpayOrderMatchesOnConflict = {
  constraint: CarpayOrderMatchesConstraint;
  update_columns?: Array<CarpayOrderMatchesUpdateColumn>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};

/** Ordering options when selecting data from "carpay_order_matches". */
export type CarpayOrderMatchesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matched_paid_order?: InputMaybe<CarpayOrderOrderBy>;
  matched_unpaid_order?: InputMaybe<CarpayOrderOrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_order_matches */
export type CarpayOrderMatchesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_order_matches" */
export enum CarpayOrderMatchesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaidOrder = 'paid_order',
  /** column name */
  UnpaidOrder = 'unpaid_order'
}

/** input type for updating data in table "carpay_order_matches" */
export type CarpayOrderMatchesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paid_order?: InputMaybe<Scalars['bigint']>;
  unpaid_order?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type CarpayOrderMatchesStddevFields = {
  __typename?: 'carpay_order_matches_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayOrderMatchesStddevPopFields = {
  __typename?: 'carpay_order_matches_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayOrderMatchesStddevSampFields = {
  __typename?: 'carpay_order_matches_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_order_matches" */
export type CarpayOrderMatchesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayOrderMatchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayOrderMatchesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paid_order?: InputMaybe<Scalars['bigint']>;
  unpaid_order?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CarpayOrderMatchesSumFields = {
  __typename?: 'carpay_order_matches_sum_fields';
  id?: Maybe<Scalars['Int']>;
  paid_order?: Maybe<Scalars['bigint']>;
  unpaid_order?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_order_matches" */
export enum CarpayOrderMatchesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaidOrder = 'paid_order',
  /** column name */
  UnpaidOrder = 'unpaid_order'
}

export type CarpayOrderMatchesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayOrderMatchesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayOrderMatchesSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayOrderMatchesBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayOrderMatchesVarPopFields = {
  __typename?: 'carpay_order_matches_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayOrderMatchesVarSampFields = {
  __typename?: 'carpay_order_matches_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayOrderMatchesVarianceFields = {
  __typename?: 'carpay_order_matches_variance_fields';
  id?: Maybe<Scalars['Float']>;
  paid_order?: Maybe<Scalars['Float']>;
  unpaid_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_order_matches" */
export type CarpayOrderMatchesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  paid_order?: InputMaybe<OrderBy>;
  unpaid_order?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type CarpayOrderMaxFields = {
  __typename?: 'carpay_order_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_generated_at?: Maybe<Scalars['timestamptz']>;
  invoice_id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  parking_uuid_out?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  price_valid_until?: Maybe<Scalars['timestamptz']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "carpay_order" */
export type CarpayOrderMaxOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  drive_in_timestamp?: InputMaybe<OrderBy>;
  drive_out_timestamp?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_generated_at?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  parking_uuid?: InputMaybe<OrderBy>;
  parking_uuid_out?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  price_valid_until?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayOrderMinFields = {
  __typename?: 'carpay_order_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_generated_at?: Maybe<Scalars['timestamptz']>;
  invoice_id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  parking_uuid_out?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  price_valid_until?: Maybe<Scalars['timestamptz']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "carpay_order" */
export type CarpayOrderMinOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  drive_in_timestamp?: InputMaybe<OrderBy>;
  drive_out_timestamp?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_generated_at?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  parking_uuid?: InputMaybe<OrderBy>;
  parking_uuid_out?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  price_valid_until?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_order" */
export type CarpayOrderMutationResponse = {
  __typename?: 'carpay_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayOrder>;
};

/** input type for inserting object relation for remote table "carpay_order" */
export type CarpayOrderObjRelInsertInput = {
  data: CarpayOrderInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayOrderOnConflict>;
};

/** on_conflict condition type for table "carpay_order" */
export type CarpayOrderOnConflict = {
  constraint: CarpayOrderConstraint;
  update_columns?: Array<CarpayOrderUpdateColumn>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};

/** Ordering options when selecting data from "carpay_order". */
export type CarpayOrderOrderBy = {
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  carpay_order_user?: InputMaybe<CarpayOrderUserOrderBy>;
  carpay_scanned_codes_aggregate?: InputMaybe<CarpayScannedCodesAggregateOrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  drive_in_timestamp?: InputMaybe<OrderBy>;
  drive_out_timestamp?: InputMaybe<OrderBy>;
  easypark_order?: InputMaybe<EasyparkOrderOrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  illegal_timeranges?: InputMaybe<OrderBy>;
  invoice_generated_at?: InputMaybe<OrderBy>;
  invoice_id?: InputMaybe<OrderBy>;
  legal_timeranges?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  paid_match_aggregate?: InputMaybe<CarpayOrderMatchesAggregateOrderBy>;
  parking_context?: InputMaybe<ParkingContextOrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
  parking_details?: InputMaybe<OrderBy>;
  parking_details_out?: InputMaybe<OrderBy>;
  parking_results?: InputMaybe<ParkingResultsOrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  parking_results_matching_info?: InputMaybe<OrderBy>;
  parking_uuid?: InputMaybe<OrderBy>;
  parking_uuid_out?: InputMaybe<OrderBy>;
  payment?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  price_valid_until?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unpaid_match_aggregate?: InputMaybe<CarpayOrderMatchesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist?: InputMaybe<WhitelistPaidParkingOrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_order */
export type CarpayOrderPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayOrderPrependInput = {
  illegal_timeranges?: InputMaybe<Scalars['jsonb']>;
  legal_timeranges?: InputMaybe<Scalars['jsonb']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_details_out?: InputMaybe<Scalars['jsonb']>;
  parking_results_matching_info?: InputMaybe<Scalars['jsonb']>;
  payment?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_order" */
export enum CarpayOrderSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriveInTimestamp = 'drive_in_timestamp',
  /** column name */
  DriveOutTimestamp = 'drive_out_timestamp',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IllegalTimeranges = 'illegal_timeranges',
  /** column name */
  InvoiceGeneratedAt = 'invoice_generated_at',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LegalTimeranges = 'legal_timeranges',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingDetailsOut = 'parking_details_out',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  ParkingResultsMatchingInfo = 'parking_results_matching_info',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  ParkingUuidOut = 'parking_uuid_out',
  /** column name */
  Payment = 'payment',
  /** column name */
  Plate = 'plate',
  /** column name */
  Price = 'price',
  /** column name */
  PriceValidUntil = 'price_valid_until',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "carpay_order" */
export type CarpayOrderSetInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  illegal_timeranges?: InputMaybe<Scalars['jsonb']>;
  invoice_generated_at?: InputMaybe<Scalars['timestamptz']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  legal_timeranges?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_details_out?: InputMaybe<Scalars['jsonb']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  parking_results_matching_info?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  parking_uuid_out?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_valid_until?: InputMaybe<Scalars['timestamptz']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayOrderStddevFields = {
  __typename?: 'carpay_order_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_order" */
export type CarpayOrderStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayOrderStddevPopFields = {
  __typename?: 'carpay_order_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_order" */
export type CarpayOrderStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayOrderStddevSampFields = {
  __typename?: 'carpay_order_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_order" */
export type CarpayOrderStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_order" */
export type CarpayOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayOrderStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  illegal_timeranges?: InputMaybe<Scalars['jsonb']>;
  invoice_generated_at?: InputMaybe<Scalars['timestamptz']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  legal_timeranges?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_details_out?: InputMaybe<Scalars['jsonb']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  parking_results_matching_info?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  parking_uuid_out?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_valid_until?: InputMaybe<Scalars['timestamptz']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayOrderSumFields = {
  __typename?: 'carpay_order_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_order" */
export type CarpayOrderSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_order" */
export enum CarpayOrderUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriveInTimestamp = 'drive_in_timestamp',
  /** column name */
  DriveOutTimestamp = 'drive_out_timestamp',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IllegalTimeranges = 'illegal_timeranges',
  /** column name */
  InvoiceGeneratedAt = 'invoice_generated_at',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LegalTimeranges = 'legal_timeranges',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingDetailsOut = 'parking_details_out',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  ParkingResultsMatchingInfo = 'parking_results_matching_info',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  ParkingUuidOut = 'parking_uuid_out',
  /** column name */
  Payment = 'payment',
  /** column name */
  Plate = 'plate',
  /** column name */
  Price = 'price',
  /** column name */
  PriceValidUntil = 'price_valid_until',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type CarpayOrderUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayOrderAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayOrderDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayOrderDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayOrderDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayOrderIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayOrderPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayOrderSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayOrderBoolExp;
};

/** Table to match N carpay_orders and 1 booking user */
export type CarpayOrderUser = {
  __typename?: 'carpay_order_user';
  order_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "carpay_order_user" */
export type CarpayOrderUserAggregate = {
  __typename?: 'carpay_order_user_aggregate';
  aggregate?: Maybe<CarpayOrderUserAggregateFields>;
  nodes: Array<CarpayOrderUser>;
};

/** aggregate fields of "carpay_order_user" */
export type CarpayOrderUserAggregateFields = {
  __typename?: 'carpay_order_user_aggregate_fields';
  avg?: Maybe<CarpayOrderUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayOrderUserMaxFields>;
  min?: Maybe<CarpayOrderUserMinFields>;
  stddev?: Maybe<CarpayOrderUserStddevFields>;
  stddev_pop?: Maybe<CarpayOrderUserStddevPopFields>;
  stddev_samp?: Maybe<CarpayOrderUserStddevSampFields>;
  sum?: Maybe<CarpayOrderUserSumFields>;
  var_pop?: Maybe<CarpayOrderUserVarPopFields>;
  var_samp?: Maybe<CarpayOrderUserVarSampFields>;
  variance?: Maybe<CarpayOrderUserVarianceFields>;
};


/** aggregate fields of "carpay_order_user" */
export type CarpayOrderUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayOrderUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayOrderUserAvgFields = {
  __typename?: 'carpay_order_user_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_order_user". All fields are combined with a logical 'AND'. */
export type CarpayOrderUserBoolExp = {
  _and?: InputMaybe<Array<CarpayOrderUserBoolExp>>;
  _not?: InputMaybe<CarpayOrderUserBoolExp>;
  _or?: InputMaybe<Array<CarpayOrderUserBoolExp>>;
  order_id?: InputMaybe<IntComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "carpay_order_user" */
export enum CarpayOrderUserConstraint {
  /** unique or primary key constraint on columns "order_id" */
  CarpayOrderUserPkey = 'carpay_order_user_pkey'
}

/** input type for incrementing numeric columns in table "carpay_order_user" */
export type CarpayOrderUserIncInput = {
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_order_user" */
export type CarpayOrderUserInsertInput = {
  order_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CarpayOrderUserMaxFields = {
  __typename?: 'carpay_order_user_max_fields';
  order_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CarpayOrderUserMinFields = {
  __typename?: 'carpay_order_user_min_fields';
  order_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "carpay_order_user" */
export type CarpayOrderUserMutationResponse = {
  __typename?: 'carpay_order_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayOrderUser>;
};

/** input type for inserting object relation for remote table "carpay_order_user" */
export type CarpayOrderUserObjRelInsertInput = {
  data: CarpayOrderUserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayOrderUserOnConflict>;
};

/** on_conflict condition type for table "carpay_order_user" */
export type CarpayOrderUserOnConflict = {
  constraint: CarpayOrderUserConstraint;
  update_columns?: Array<CarpayOrderUserUpdateColumn>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};

/** Ordering options when selecting data from "carpay_order_user". */
export type CarpayOrderUserOrderBy = {
  order_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_order_user */
export type CarpayOrderUserPkColumnsInput = {
  order_id: Scalars['Int'];
};

/** select columns of table "carpay_order_user" */
export enum CarpayOrderUserSelectColumn {
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "carpay_order_user" */
export type CarpayOrderUserSetInput = {
  order_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type CarpayOrderUserStddevFields = {
  __typename?: 'carpay_order_user_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayOrderUserStddevPopFields = {
  __typename?: 'carpay_order_user_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayOrderUserStddevSampFields = {
  __typename?: 'carpay_order_user_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_order_user" */
export type CarpayOrderUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayOrderUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayOrderUserStreamCursorValueInput = {
  order_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type CarpayOrderUserSumFields = {
  __typename?: 'carpay_order_user_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_order_user" */
export enum CarpayOrderUserUpdateColumn {
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UserId = 'user_id'
}

export type CarpayOrderUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayOrderUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayOrderUserSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayOrderUserBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayOrderUserVarPopFields = {
  __typename?: 'carpay_order_user_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayOrderUserVarSampFields = {
  __typename?: 'carpay_order_user_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayOrderUserVarianceFields = {
  __typename?: 'carpay_order_user_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type CarpayOrderVarPopFields = {
  __typename?: 'carpay_order_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_order" */
export type CarpayOrderVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayOrderVarSampFields = {
  __typename?: 'carpay_order_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_order" */
export type CarpayOrderVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayOrderVarianceFields = {
  __typename?: 'carpay_order_variance_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_order" */
export type CarpayOrderVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_parking_detection" */
export type CarpayParkingDetection = {
  __typename?: 'carpay_parking_detection';
  created_at: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  timestamp: Scalars['timestamptz'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "carpay_parking_detection" */
export type CarpayParkingDetectionDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_parking_detection" */
export type CarpayParkingDetectionAggregate = {
  __typename?: 'carpay_parking_detection_aggregate';
  aggregate?: Maybe<CarpayParkingDetectionAggregateFields>;
  nodes: Array<CarpayParkingDetection>;
};

/** aggregate fields of "carpay_parking_detection" */
export type CarpayParkingDetectionAggregateFields = {
  __typename?: 'carpay_parking_detection_aggregate_fields';
  avg?: Maybe<CarpayParkingDetectionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayParkingDetectionMaxFields>;
  min?: Maybe<CarpayParkingDetectionMinFields>;
  stddev?: Maybe<CarpayParkingDetectionStddevFields>;
  stddev_pop?: Maybe<CarpayParkingDetectionStddevPopFields>;
  stddev_samp?: Maybe<CarpayParkingDetectionStddevSampFields>;
  sum?: Maybe<CarpayParkingDetectionSumFields>;
  var_pop?: Maybe<CarpayParkingDetectionVarPopFields>;
  var_samp?: Maybe<CarpayParkingDetectionVarSampFields>;
  variance?: Maybe<CarpayParkingDetectionVarianceFields>;
};


/** aggregate fields of "carpay_parking_detection" */
export type CarpayParkingDetectionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayParkingDetectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayParkingDetectionAppendInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CarpayParkingDetectionAvgFields = {
  __typename?: 'carpay_parking_detection_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_parking_detection". All fields are combined with a logical 'AND'. */
export type CarpayParkingDetectionBoolExp = {
  _and?: InputMaybe<Array<CarpayParkingDetectionBoolExp>>;
  _not?: InputMaybe<CarpayParkingDetectionBoolExp>;
  _or?: InputMaybe<Array<CarpayParkingDetectionBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "carpay_parking_detection" */
export enum CarpayParkingDetectionConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayParkingDetectionPkey = 'carpay_parking_detection_pkey',
  /** unique or primary key constraint on columns "uuid" */
  CarpayParkingDetectionUuidKey = 'carpay_parking_detection_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayParkingDetectionDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayParkingDetectionDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayParkingDetectionDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_parking_detection" */
export type CarpayParkingDetectionIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_parking_detection" */
export type CarpayParkingDetectionInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CarpayParkingDetectionMaxFields = {
  __typename?: 'carpay_parking_detection_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CarpayParkingDetectionMinFields = {
  __typename?: 'carpay_parking_detection_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "carpay_parking_detection" */
export type CarpayParkingDetectionMutationResponse = {
  __typename?: 'carpay_parking_detection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayParkingDetection>;
};

/** on_conflict condition type for table "carpay_parking_detection" */
export type CarpayParkingDetectionOnConflict = {
  constraint: CarpayParkingDetectionConstraint;
  update_columns?: Array<CarpayParkingDetectionUpdateColumn>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};

/** Ordering options when selecting data from "carpay_parking_detection". */
export type CarpayParkingDetectionOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_parking_detection */
export type CarpayParkingDetectionPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayParkingDetectionPrependInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_parking_detection" */
export enum CarpayParkingDetectionSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "carpay_parking_detection" */
export type CarpayParkingDetectionSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type CarpayParkingDetectionStddevFields = {
  __typename?: 'carpay_parking_detection_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayParkingDetectionStddevPopFields = {
  __typename?: 'carpay_parking_detection_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayParkingDetectionStddevSampFields = {
  __typename?: 'carpay_parking_detection_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_parking_detection" */
export type CarpayParkingDetectionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayParkingDetectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayParkingDetectionStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type CarpayParkingDetectionSumFields = {
  __typename?: 'carpay_parking_detection_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_parking_detection" */
export enum CarpayParkingDetectionUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Uuid = 'uuid'
}

export type CarpayParkingDetectionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayParkingDetectionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayParkingDetectionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayParkingDetectionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayParkingDetectionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayParkingDetectionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayParkingDetectionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayParkingDetectionSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayParkingDetectionBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayParkingDetectionVarPopFields = {
  __typename?: 'carpay_parking_detection_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayParkingDetectionVarSampFields = {
  __typename?: 'carpay_parking_detection_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayParkingDetectionVarianceFields = {
  __typename?: 'carpay_parking_detection_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Contains pricing models (described as rules) for the Carpay product */
export type CarpayPricing = {
  __typename?: 'carpay_pricing';
  /** An object relationship */
  carpay_lot?: Maybe<CarpayLot>;
  company_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_default?: Maybe<Scalars['Boolean']>;
  lot_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  parking_context?: Maybe<ParkingContext>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  rules: Scalars['jsonb'];
};


/** Contains pricing models (described as rules) for the Carpay product */
export type CarpayPricingRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_pricing" */
export type CarpayPricingAggregate = {
  __typename?: 'carpay_pricing_aggregate';
  aggregate?: Maybe<CarpayPricingAggregateFields>;
  nodes: Array<CarpayPricing>;
};

export type CarpayPricingAggregateBoolExp = {
  bool_and?: InputMaybe<CarpayPricingAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CarpayPricingAggregateBoolExpBoolOr>;
  count?: InputMaybe<CarpayPricingAggregateBoolExpCount>;
};

export type CarpayPricingAggregateBoolExpBoolAnd = {
  arguments: CarpayPricingSelectColumnCarpayPricingAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayPricingAggregateBoolExpBoolOr = {
  arguments: CarpayPricingSelectColumnCarpayPricingAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayPricingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_pricing" */
export type CarpayPricingAggregateFields = {
  __typename?: 'carpay_pricing_aggregate_fields';
  avg?: Maybe<CarpayPricingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayPricingMaxFields>;
  min?: Maybe<CarpayPricingMinFields>;
  stddev?: Maybe<CarpayPricingStddevFields>;
  stddev_pop?: Maybe<CarpayPricingStddevPopFields>;
  stddev_samp?: Maybe<CarpayPricingStddevSampFields>;
  sum?: Maybe<CarpayPricingSumFields>;
  var_pop?: Maybe<CarpayPricingVarPopFields>;
  var_samp?: Maybe<CarpayPricingVarSampFields>;
  variance?: Maybe<CarpayPricingVarianceFields>;
};


/** aggregate fields of "carpay_pricing" */
export type CarpayPricingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_pricing" */
export type CarpayPricingAggregateOrderBy = {
  avg?: InputMaybe<CarpayPricingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayPricingMaxOrderBy>;
  min?: InputMaybe<CarpayPricingMinOrderBy>;
  stddev?: InputMaybe<CarpayPricingStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayPricingStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayPricingStddevSampOrderBy>;
  sum?: InputMaybe<CarpayPricingSumOrderBy>;
  var_pop?: InputMaybe<CarpayPricingVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayPricingVarSampOrderBy>;
  variance?: InputMaybe<CarpayPricingVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayPricingAppendInput = {
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "carpay_pricing" */
export type CarpayPricingArrRelInsertInput = {
  data: Array<CarpayPricingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayPricingOnConflict>;
};

/** aggregate avg on columns */
export type CarpayPricingAvgFields = {
  __typename?: 'carpay_pricing_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_pricing" */
export type CarpayPricingAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_pricing". All fields are combined with a logical 'AND'. */
export type CarpayPricingBoolExp = {
  _and?: InputMaybe<Array<CarpayPricingBoolExp>>;
  _not?: InputMaybe<CarpayPricingBoolExp>;
  _or?: InputMaybe<Array<CarpayPricingBoolExp>>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  is_default?: InputMaybe<BooleanComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  parking_context?: InputMaybe<ParkingContextBoolExp>;
  parking_context_uuid?: InputMaybe<UuidComparisonExp>;
  rules?: InputMaybe<JsonbComparisonExp>;
};

/** columns and relationships of "carpay_pricing_config_group" */
export type CarpayPricingConfigGroup = {
  __typename?: 'carpay_pricing_config_group';
  carpay_pricing_id: Scalars['Int'];
  config_group_id: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupAggregate = {
  __typename?: 'carpay_pricing_config_group_aggregate';
  aggregate?: Maybe<CarpayPricingConfigGroupAggregateFields>;
  nodes: Array<CarpayPricingConfigGroup>;
};

/** aggregate fields of "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupAggregateFields = {
  __typename?: 'carpay_pricing_config_group_aggregate_fields';
  avg?: Maybe<CarpayPricingConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayPricingConfigGroupMaxFields>;
  min?: Maybe<CarpayPricingConfigGroupMinFields>;
  stddev?: Maybe<CarpayPricingConfigGroupStddevFields>;
  stddev_pop?: Maybe<CarpayPricingConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<CarpayPricingConfigGroupStddevSampFields>;
  sum?: Maybe<CarpayPricingConfigGroupSumFields>;
  var_pop?: Maybe<CarpayPricingConfigGroupVarPopFields>;
  var_samp?: Maybe<CarpayPricingConfigGroupVarSampFields>;
  variance?: Maybe<CarpayPricingConfigGroupVarianceFields>;
};


/** aggregate fields of "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayPricingConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayPricingConfigGroupAvgFields = {
  __typename?: 'carpay_pricing_config_group_avg_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_pricing_config_group". All fields are combined with a logical 'AND'. */
export type CarpayPricingConfigGroupBoolExp = {
  _and?: InputMaybe<Array<CarpayPricingConfigGroupBoolExp>>;
  _not?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
  _or?: InputMaybe<Array<CarpayPricingConfigGroupBoolExp>>;
  carpay_pricing_id?: InputMaybe<IntComparisonExp>;
  config_group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "carpay_pricing_config_group" */
export enum CarpayPricingConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayPricingConfigGroupPkey = 'carpay_pricing_config_group_pkey'
}

/** input type for incrementing numeric columns in table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupIncInput = {
  carpay_pricing_id?: InputMaybe<Scalars['Int']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupInsertInput = {
  carpay_pricing_id?: InputMaybe<Scalars['Int']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type CarpayPricingConfigGroupMaxFields = {
  __typename?: 'carpay_pricing_config_group_max_fields';
  carpay_pricing_id?: Maybe<Scalars['Int']>;
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CarpayPricingConfigGroupMinFields = {
  __typename?: 'carpay_pricing_config_group_min_fields';
  carpay_pricing_id?: Maybe<Scalars['Int']>;
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupMutationResponse = {
  __typename?: 'carpay_pricing_config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayPricingConfigGroup>;
};

/** on_conflict condition type for table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupOnConflict = {
  constraint: CarpayPricingConfigGroupConstraint;
  update_columns?: Array<CarpayPricingConfigGroupUpdateColumn>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "carpay_pricing_config_group". */
export type CarpayPricingConfigGroupOrderBy = {
  carpay_pricing_id?: InputMaybe<OrderBy>;
  config_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_pricing_config_group */
export type CarpayPricingConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "carpay_pricing_config_group" */
export enum CarpayPricingConfigGroupSelectColumn {
  /** column name */
  CarpayPricingId = 'carpay_pricing_id',
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupSetInput = {
  carpay_pricing_id?: InputMaybe<Scalars['Int']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type CarpayPricingConfigGroupStddevFields = {
  __typename?: 'carpay_pricing_config_group_stddev_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayPricingConfigGroupStddevPopFields = {
  __typename?: 'carpay_pricing_config_group_stddev_pop_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayPricingConfigGroupStddevSampFields = {
  __typename?: 'carpay_pricing_config_group_stddev_samp_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_pricing_config_group" */
export type CarpayPricingConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayPricingConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayPricingConfigGroupStreamCursorValueInput = {
  carpay_pricing_id?: InputMaybe<Scalars['Int']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CarpayPricingConfigGroupSumFields = {
  __typename?: 'carpay_pricing_config_group_sum_fields';
  carpay_pricing_id?: Maybe<Scalars['Int']>;
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "carpay_pricing_config_group" */
export enum CarpayPricingConfigGroupUpdateColumn {
  /** column name */
  CarpayPricingId = 'carpay_pricing_id',
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id'
}

export type CarpayPricingConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayPricingConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayPricingConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayPricingConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayPricingConfigGroupVarPopFields = {
  __typename?: 'carpay_pricing_config_group_var_pop_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayPricingConfigGroupVarSampFields = {
  __typename?: 'carpay_pricing_config_group_var_samp_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayPricingConfigGroupVarianceFields = {
  __typename?: 'carpay_pricing_config_group_variance_fields';
  carpay_pricing_id?: Maybe<Scalars['Float']>;
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "carpay_pricing" */
export enum CarpayPricingConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayPricingPkey = 'carpay_pricing_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayPricingDeleteAtPathInput = {
  rules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayPricingDeleteElemInput = {
  rules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayPricingDeleteKeyInput = {
  rules?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_pricing" */
export type CarpayPricingIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_pricing" */
export type CarpayPricingInsertInput = {
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_context?: InputMaybe<ParkingContextObjRelInsertInput>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CarpayPricingMaxFields = {
  __typename?: 'carpay_pricing_max_fields';
  company_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "carpay_pricing" */
export type CarpayPricingMaxOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayPricingMinFields = {
  __typename?: 'carpay_pricing_min_fields';
  company_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "carpay_pricing" */
export type CarpayPricingMinOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_pricing" */
export type CarpayPricingMutationResponse = {
  __typename?: 'carpay_pricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayPricing>;
};

/** on_conflict condition type for table "carpay_pricing" */
export type CarpayPricingOnConflict = {
  constraint: CarpayPricingConstraint;
  update_columns?: Array<CarpayPricingUpdateColumn>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};

/** Ordering options when selecting data from "carpay_pricing". */
export type CarpayPricingOrderBy = {
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_default?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  parking_context?: InputMaybe<ParkingContextOrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
  rules?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_pricing_period" */
export type CarpayPricingPeriod = {
  __typename?: 'carpay_pricing_period';
  /** An object relationship */
  carpay_pricing_recurrence: CarpayPricingRecurrence;
  /** An object relationship */
  carpay_pricing_rules: CarpayPricingRules;
  end_time: Scalars['timetz'];
  extend_free_time: Scalars['Boolean'];
  pricing_recurrence_id: Scalars['String'];
  pricing_rules_id: Scalars['String'];
  start_time: Scalars['timetz'];
  uuid: Scalars['Int'];
};

/** aggregated selection of "carpay_pricing_period" */
export type CarpayPricingPeriodAggregate = {
  __typename?: 'carpay_pricing_period_aggregate';
  aggregate?: Maybe<CarpayPricingPeriodAggregateFields>;
  nodes: Array<CarpayPricingPeriod>;
};

export type CarpayPricingPeriodAggregateBoolExp = {
  bool_and?: InputMaybe<CarpayPricingPeriodAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CarpayPricingPeriodAggregateBoolExpBoolOr>;
  count?: InputMaybe<CarpayPricingPeriodAggregateBoolExpCount>;
};

export type CarpayPricingPeriodAggregateBoolExpBoolAnd = {
  arguments: CarpayPricingPeriodSelectColumnCarpayPricingPeriodAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingPeriodBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayPricingPeriodAggregateBoolExpBoolOr = {
  arguments: CarpayPricingPeriodSelectColumnCarpayPricingPeriodAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingPeriodBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayPricingPeriodAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingPeriodBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_pricing_period" */
export type CarpayPricingPeriodAggregateFields = {
  __typename?: 'carpay_pricing_period_aggregate_fields';
  avg?: Maybe<CarpayPricingPeriodAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayPricingPeriodMaxFields>;
  min?: Maybe<CarpayPricingPeriodMinFields>;
  stddev?: Maybe<CarpayPricingPeriodStddevFields>;
  stddev_pop?: Maybe<CarpayPricingPeriodStddevPopFields>;
  stddev_samp?: Maybe<CarpayPricingPeriodStddevSampFields>;
  sum?: Maybe<CarpayPricingPeriodSumFields>;
  var_pop?: Maybe<CarpayPricingPeriodVarPopFields>;
  var_samp?: Maybe<CarpayPricingPeriodVarSampFields>;
  variance?: Maybe<CarpayPricingPeriodVarianceFields>;
};


/** aggregate fields of "carpay_pricing_period" */
export type CarpayPricingPeriodAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_pricing_period" */
export type CarpayPricingPeriodAggregateOrderBy = {
  avg?: InputMaybe<CarpayPricingPeriodAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayPricingPeriodMaxOrderBy>;
  min?: InputMaybe<CarpayPricingPeriodMinOrderBy>;
  stddev?: InputMaybe<CarpayPricingPeriodStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayPricingPeriodStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayPricingPeriodStddevSampOrderBy>;
  sum?: InputMaybe<CarpayPricingPeriodSumOrderBy>;
  var_pop?: InputMaybe<CarpayPricingPeriodVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayPricingPeriodVarSampOrderBy>;
  variance?: InputMaybe<CarpayPricingPeriodVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "carpay_pricing_period" */
export type CarpayPricingPeriodArrRelInsertInput = {
  data: Array<CarpayPricingPeriodInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayPricingPeriodOnConflict>;
};

/** aggregate avg on columns */
export type CarpayPricingPeriodAvgFields = {
  __typename?: 'carpay_pricing_period_avg_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodAvgOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_pricing_period". All fields are combined with a logical 'AND'. */
export type CarpayPricingPeriodBoolExp = {
  _and?: InputMaybe<Array<CarpayPricingPeriodBoolExp>>;
  _not?: InputMaybe<CarpayPricingPeriodBoolExp>;
  _or?: InputMaybe<Array<CarpayPricingPeriodBoolExp>>;
  carpay_pricing_recurrence?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
  carpay_pricing_rules?: InputMaybe<CarpayPricingRulesBoolExp>;
  end_time?: InputMaybe<TimetzComparisonExp>;
  extend_free_time?: InputMaybe<BooleanComparisonExp>;
  pricing_recurrence_id?: InputMaybe<StringComparisonExp>;
  pricing_rules_id?: InputMaybe<StringComparisonExp>;
  start_time?: InputMaybe<TimetzComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_pricing_period" */
export enum CarpayPricingPeriodConstraint {
  /** unique or primary key constraint on columns "uuid" */
  CarpayPricingPeriodPkey = 'carpay_pricing_period_pkey'
}

/** input type for incrementing numeric columns in table "carpay_pricing_period" */
export type CarpayPricingPeriodIncInput = {
  uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_pricing_period" */
export type CarpayPricingPeriodInsertInput = {
  carpay_pricing_recurrence?: InputMaybe<CarpayPricingRecurrenceObjRelInsertInput>;
  carpay_pricing_rules?: InputMaybe<CarpayPricingRulesObjRelInsertInput>;
  end_time?: InputMaybe<Scalars['timetz']>;
  extend_free_time?: InputMaybe<Scalars['Boolean']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timetz']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayPricingPeriodMaxFields = {
  __typename?: 'carpay_pricing_period_max_fields';
  end_time?: Maybe<Scalars['timetz']>;
  pricing_recurrence_id?: Maybe<Scalars['String']>;
  pricing_rules_id?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodMaxOrderBy = {
  end_time?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  pricing_rules_id?: InputMaybe<OrderBy>;
  start_time?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayPricingPeriodMinFields = {
  __typename?: 'carpay_pricing_period_min_fields';
  end_time?: Maybe<Scalars['timetz']>;
  pricing_recurrence_id?: Maybe<Scalars['String']>;
  pricing_rules_id?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodMinOrderBy = {
  end_time?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  pricing_rules_id?: InputMaybe<OrderBy>;
  start_time?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_pricing_period" */
export type CarpayPricingPeriodMutationResponse = {
  __typename?: 'carpay_pricing_period_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayPricingPeriod>;
};

/** on_conflict condition type for table "carpay_pricing_period" */
export type CarpayPricingPeriodOnConflict = {
  constraint: CarpayPricingPeriodConstraint;
  update_columns?: Array<CarpayPricingPeriodUpdateColumn>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};

/** Ordering options when selecting data from "carpay_pricing_period". */
export type CarpayPricingPeriodOrderBy = {
  carpay_pricing_recurrence?: InputMaybe<CarpayPricingRecurrenceOrderBy>;
  carpay_pricing_rules?: InputMaybe<CarpayPricingRulesOrderBy>;
  end_time?: InputMaybe<OrderBy>;
  extend_free_time?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  pricing_rules_id?: InputMaybe<OrderBy>;
  start_time?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_pricing_period */
export type CarpayPricingPeriodPkColumnsInput = {
  uuid: Scalars['Int'];
};

/** select columns of table "carpay_pricing_period" */
export enum CarpayPricingPeriodSelectColumn {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ExtendFreeTime = 'extend_free_time',
  /** column name */
  PricingRecurrenceId = 'pricing_recurrence_id',
  /** column name */
  PricingRulesId = 'pricing_rules_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Uuid = 'uuid'
}

/** select "carpay_pricing_period_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carpay_pricing_period" */
export enum CarpayPricingPeriodSelectColumnCarpayPricingPeriodAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ExtendFreeTime = 'extend_free_time'
}

/** select "carpay_pricing_period_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carpay_pricing_period" */
export enum CarpayPricingPeriodSelectColumnCarpayPricingPeriodAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ExtendFreeTime = 'extend_free_time'
}

/** input type for updating data in table "carpay_pricing_period" */
export type CarpayPricingPeriodSetInput = {
  end_time?: InputMaybe<Scalars['timetz']>;
  extend_free_time?: InputMaybe<Scalars['Boolean']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timetz']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayPricingPeriodStddevFields = {
  __typename?: 'carpay_pricing_period_stddev_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodStddevOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayPricingPeriodStddevPopFields = {
  __typename?: 'carpay_pricing_period_stddev_pop_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodStddevPopOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayPricingPeriodStddevSampFields = {
  __typename?: 'carpay_pricing_period_stddev_samp_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodStddevSampOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_pricing_period" */
export type CarpayPricingPeriodStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayPricingPeriodStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayPricingPeriodStreamCursorValueInput = {
  end_time?: InputMaybe<Scalars['timetz']>;
  extend_free_time?: InputMaybe<Scalars['Boolean']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timetz']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayPricingPeriodSumFields = {
  __typename?: 'carpay_pricing_period_sum_fields';
  uuid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodSumOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_pricing_period" */
export enum CarpayPricingPeriodUpdateColumn {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ExtendFreeTime = 'extend_free_time',
  /** column name */
  PricingRecurrenceId = 'pricing_recurrence_id',
  /** column name */
  PricingRulesId = 'pricing_rules_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Uuid = 'uuid'
}

export type CarpayPricingPeriodUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayPricingPeriodIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayPricingPeriodSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayPricingPeriodBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayPricingPeriodVarPopFields = {
  __typename?: 'carpay_pricing_period_var_pop_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodVarPopOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayPricingPeriodVarSampFields = {
  __typename?: 'carpay_pricing_period_var_samp_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodVarSampOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayPricingPeriodVarianceFields = {
  __typename?: 'carpay_pricing_period_variance_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_pricing_period" */
export type CarpayPricingPeriodVarianceOrderBy = {
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_pricing */
export type CarpayPricingPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayPricingPrependInput = {
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrence = {
  __typename?: 'carpay_pricing_recurrence';
  /** An object relationship */
  carpay_lot: CarpayLot;
  /** An array relationship */
  carpay_pricing_periods: Array<CarpayPricingPeriod>;
  /** An aggregate relationship */
  carpay_pricing_periods_aggregate: CarpayPricingPeriodAggregate;
  dtstart: Scalars['date'];
  lot_id: Scalars['String'];
  pricing_recurrence_id: Scalars['String'];
  priority: Scalars['Int'];
  rrule: Scalars['String'];
  until?: Maybe<Scalars['date']>;
  uuid: Scalars['Int'];
};


/** columns and relationships of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceCarpayPricingPeriodsArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


/** columns and relationships of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceCarpayPricingPeriodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};

/** aggregated selection of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceAggregate = {
  __typename?: 'carpay_pricing_recurrence_aggregate';
  aggregate?: Maybe<CarpayPricingRecurrenceAggregateFields>;
  nodes: Array<CarpayPricingRecurrence>;
};

export type CarpayPricingRecurrenceAggregateBoolExp = {
  count?: InputMaybe<CarpayPricingRecurrenceAggregateBoolExpCount>;
};

export type CarpayPricingRecurrenceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceAggregateFields = {
  __typename?: 'carpay_pricing_recurrence_aggregate_fields';
  avg?: Maybe<CarpayPricingRecurrenceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayPricingRecurrenceMaxFields>;
  min?: Maybe<CarpayPricingRecurrenceMinFields>;
  stddev?: Maybe<CarpayPricingRecurrenceStddevFields>;
  stddev_pop?: Maybe<CarpayPricingRecurrenceStddevPopFields>;
  stddev_samp?: Maybe<CarpayPricingRecurrenceStddevSampFields>;
  sum?: Maybe<CarpayPricingRecurrenceSumFields>;
  var_pop?: Maybe<CarpayPricingRecurrenceVarPopFields>;
  var_samp?: Maybe<CarpayPricingRecurrenceVarSampFields>;
  variance?: Maybe<CarpayPricingRecurrenceVarianceFields>;
};


/** aggregate fields of "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceAggregateOrderBy = {
  avg?: InputMaybe<CarpayPricingRecurrenceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayPricingRecurrenceMaxOrderBy>;
  min?: InputMaybe<CarpayPricingRecurrenceMinOrderBy>;
  stddev?: InputMaybe<CarpayPricingRecurrenceStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayPricingRecurrenceStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayPricingRecurrenceStddevSampOrderBy>;
  sum?: InputMaybe<CarpayPricingRecurrenceSumOrderBy>;
  var_pop?: InputMaybe<CarpayPricingRecurrenceVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayPricingRecurrenceVarSampOrderBy>;
  variance?: InputMaybe<CarpayPricingRecurrenceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceArrRelInsertInput = {
  data: Array<CarpayPricingRecurrenceInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayPricingRecurrenceOnConflict>;
};

/** aggregate avg on columns */
export type CarpayPricingRecurrenceAvgFields = {
  __typename?: 'carpay_pricing_recurrence_avg_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceAvgOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_pricing_recurrence". All fields are combined with a logical 'AND'. */
export type CarpayPricingRecurrenceBoolExp = {
  _and?: InputMaybe<Array<CarpayPricingRecurrenceBoolExp>>;
  _not?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
  _or?: InputMaybe<Array<CarpayPricingRecurrenceBoolExp>>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  carpay_pricing_periods?: InputMaybe<CarpayPricingPeriodBoolExp>;
  carpay_pricing_periods_aggregate?: InputMaybe<CarpayPricingPeriodAggregateBoolExp>;
  dtstart?: InputMaybe<DateComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  pricing_recurrence_id?: InputMaybe<StringComparisonExp>;
  priority?: InputMaybe<IntComparisonExp>;
  rrule?: InputMaybe<StringComparisonExp>;
  until?: InputMaybe<DateComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_pricing_recurrence" */
export enum CarpayPricingRecurrenceConstraint {
  /** unique or primary key constraint on columns "uuid" */
  CarpayPricingRecurrencePkey = 'carpay_pricing_recurrence_pkey',
  /** unique or primary key constraint on columns "pricing_recurrence_id" */
  CarpayPricingRecurrencePricingRecurrenceIdKey = 'carpay_pricing_recurrence_pricing_recurrence_id_key'
}

/** input type for incrementing numeric columns in table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceIncInput = {
  priority?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceInsertInput = {
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  carpay_pricing_periods?: InputMaybe<CarpayPricingPeriodArrRelInsertInput>;
  dtstart?: InputMaybe<Scalars['date']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  rrule?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['date']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayPricingRecurrenceMaxFields = {
  __typename?: 'carpay_pricing_recurrence_max_fields';
  dtstart?: Maybe<Scalars['date']>;
  lot_id?: Maybe<Scalars['String']>;
  pricing_recurrence_id?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  rrule?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['date']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceMaxOrderBy = {
  dtstart?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
  until?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayPricingRecurrenceMinFields = {
  __typename?: 'carpay_pricing_recurrence_min_fields';
  dtstart?: Maybe<Scalars['date']>;
  lot_id?: Maybe<Scalars['String']>;
  pricing_recurrence_id?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  rrule?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['date']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceMinOrderBy = {
  dtstart?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
  until?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceMutationResponse = {
  __typename?: 'carpay_pricing_recurrence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayPricingRecurrence>;
};

/** input type for inserting object relation for remote table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceObjRelInsertInput = {
  data: CarpayPricingRecurrenceInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayPricingRecurrenceOnConflict>;
};

/** on_conflict condition type for table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceOnConflict = {
  constraint: CarpayPricingRecurrenceConstraint;
  update_columns?: Array<CarpayPricingRecurrenceUpdateColumn>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};

/** Ordering options when selecting data from "carpay_pricing_recurrence". */
export type CarpayPricingRecurrenceOrderBy = {
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  carpay_pricing_periods_aggregate?: InputMaybe<CarpayPricingPeriodAggregateOrderBy>;
  dtstart?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pricing_recurrence_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  rrule?: InputMaybe<OrderBy>;
  until?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_pricing_recurrence */
export type CarpayPricingRecurrencePkColumnsInput = {
  uuid: Scalars['Int'];
};

/** select columns of table "carpay_pricing_recurrence" */
export enum CarpayPricingRecurrenceSelectColumn {
  /** column name */
  Dtstart = 'dtstart',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PricingRecurrenceId = 'pricing_recurrence_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Rrule = 'rrule',
  /** column name */
  Until = 'until',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceSetInput = {
  dtstart?: InputMaybe<Scalars['date']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  rrule?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['date']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayPricingRecurrenceStddevFields = {
  __typename?: 'carpay_pricing_recurrence_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceStddevOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayPricingRecurrenceStddevPopFields = {
  __typename?: 'carpay_pricing_recurrence_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceStddevPopOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayPricingRecurrenceStddevSampFields = {
  __typename?: 'carpay_pricing_recurrence_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceStddevSampOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayPricingRecurrenceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayPricingRecurrenceStreamCursorValueInput = {
  dtstart?: InputMaybe<Scalars['date']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pricing_recurrence_id?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  rrule?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['date']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayPricingRecurrenceSumFields = {
  __typename?: 'carpay_pricing_recurrence_sum_fields';
  priority?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceSumOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_pricing_recurrence" */
export enum CarpayPricingRecurrenceUpdateColumn {
  /** column name */
  Dtstart = 'dtstart',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PricingRecurrenceId = 'pricing_recurrence_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Rrule = 'rrule',
  /** column name */
  Until = 'until',
  /** column name */
  Uuid = 'uuid'
}

export type CarpayPricingRecurrenceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayPricingRecurrenceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayPricingRecurrenceSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayPricingRecurrenceBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayPricingRecurrenceVarPopFields = {
  __typename?: 'carpay_pricing_recurrence_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceVarPopOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayPricingRecurrenceVarSampFields = {
  __typename?: 'carpay_pricing_recurrence_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceVarSampOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayPricingRecurrenceVarianceFields = {
  __typename?: 'carpay_pricing_recurrence_variance_fields';
  priority?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_pricing_recurrence" */
export type CarpayPricingRecurrenceVarianceOrderBy = {
  priority?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_pricing_rules" */
export type CarpayPricingRules = {
  __typename?: 'carpay_pricing_rules';
  pricing_rules: Scalars['jsonb'];
  pricing_rules_id: Scalars['String'];
  uuid: Scalars['Int'];
};


/** columns and relationships of "carpay_pricing_rules" */
export type CarpayPricingRulesPricingRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_pricing_rules" */
export type CarpayPricingRulesAggregate = {
  __typename?: 'carpay_pricing_rules_aggregate';
  aggregate?: Maybe<CarpayPricingRulesAggregateFields>;
  nodes: Array<CarpayPricingRules>;
};

/** aggregate fields of "carpay_pricing_rules" */
export type CarpayPricingRulesAggregateFields = {
  __typename?: 'carpay_pricing_rules_aggregate_fields';
  avg?: Maybe<CarpayPricingRulesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayPricingRulesMaxFields>;
  min?: Maybe<CarpayPricingRulesMinFields>;
  stddev?: Maybe<CarpayPricingRulesStddevFields>;
  stddev_pop?: Maybe<CarpayPricingRulesStddevPopFields>;
  stddev_samp?: Maybe<CarpayPricingRulesStddevSampFields>;
  sum?: Maybe<CarpayPricingRulesSumFields>;
  var_pop?: Maybe<CarpayPricingRulesVarPopFields>;
  var_samp?: Maybe<CarpayPricingRulesVarSampFields>;
  variance?: Maybe<CarpayPricingRulesVarianceFields>;
};


/** aggregate fields of "carpay_pricing_rules" */
export type CarpayPricingRulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayPricingRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayPricingRulesAppendInput = {
  pricing_rules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CarpayPricingRulesAvgFields = {
  __typename?: 'carpay_pricing_rules_avg_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_pricing_rules". All fields are combined with a logical 'AND'. */
export type CarpayPricingRulesBoolExp = {
  _and?: InputMaybe<Array<CarpayPricingRulesBoolExp>>;
  _not?: InputMaybe<CarpayPricingRulesBoolExp>;
  _or?: InputMaybe<Array<CarpayPricingRulesBoolExp>>;
  pricing_rules?: InputMaybe<JsonbComparisonExp>;
  pricing_rules_id?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "carpay_pricing_rules" */
export enum CarpayPricingRulesConstraint {
  /** unique or primary key constraint on columns "uuid" */
  CarpayPricingRulesPkey = 'carpay_pricing_rules_pkey',
  /** unique or primary key constraint on columns "pricing_rules_id" */
  CarpayPricingRulesPricingRulesIdKey = 'carpay_pricing_rules_pricing_rules_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayPricingRulesDeleteAtPathInput = {
  pricing_rules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayPricingRulesDeleteElemInput = {
  pricing_rules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayPricingRulesDeleteKeyInput = {
  pricing_rules?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_pricing_rules" */
export type CarpayPricingRulesIncInput = {
  uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "carpay_pricing_rules" */
export type CarpayPricingRulesInsertInput = {
  pricing_rules?: InputMaybe<Scalars['jsonb']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CarpayPricingRulesMaxFields = {
  __typename?: 'carpay_pricing_rules_max_fields';
  pricing_rules_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CarpayPricingRulesMinFields = {
  __typename?: 'carpay_pricing_rules_min_fields';
  pricing_rules_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "carpay_pricing_rules" */
export type CarpayPricingRulesMutationResponse = {
  __typename?: 'carpay_pricing_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayPricingRules>;
};

/** input type for inserting object relation for remote table "carpay_pricing_rules" */
export type CarpayPricingRulesObjRelInsertInput = {
  data: CarpayPricingRulesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayPricingRulesOnConflict>;
};

/** on_conflict condition type for table "carpay_pricing_rules" */
export type CarpayPricingRulesOnConflict = {
  constraint: CarpayPricingRulesConstraint;
  update_columns?: Array<CarpayPricingRulesUpdateColumn>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};

/** Ordering options when selecting data from "carpay_pricing_rules". */
export type CarpayPricingRulesOrderBy = {
  pricing_rules?: InputMaybe<OrderBy>;
  pricing_rules_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_pricing_rules */
export type CarpayPricingRulesPkColumnsInput = {
  uuid: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayPricingRulesPrependInput = {
  pricing_rules?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_pricing_rules" */
export enum CarpayPricingRulesSelectColumn {
  /** column name */
  PricingRules = 'pricing_rules',
  /** column name */
  PricingRulesId = 'pricing_rules_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "carpay_pricing_rules" */
export type CarpayPricingRulesSetInput = {
  pricing_rules?: InputMaybe<Scalars['jsonb']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CarpayPricingRulesStddevFields = {
  __typename?: 'carpay_pricing_rules_stddev_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayPricingRulesStddevPopFields = {
  __typename?: 'carpay_pricing_rules_stddev_pop_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayPricingRulesStddevSampFields = {
  __typename?: 'carpay_pricing_rules_stddev_samp_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_pricing_rules" */
export type CarpayPricingRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayPricingRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayPricingRulesStreamCursorValueInput = {
  pricing_rules?: InputMaybe<Scalars['jsonb']>;
  pricing_rules_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CarpayPricingRulesSumFields = {
  __typename?: 'carpay_pricing_rules_sum_fields';
  uuid?: Maybe<Scalars['Int']>;
};

/** update columns of table "carpay_pricing_rules" */
export enum CarpayPricingRulesUpdateColumn {
  /** column name */
  PricingRules = 'pricing_rules',
  /** column name */
  PricingRulesId = 'pricing_rules_id',
  /** column name */
  Uuid = 'uuid'
}

export type CarpayPricingRulesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayPricingRulesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayPricingRulesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayPricingRulesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayPricingRulesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayPricingRulesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayPricingRulesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayPricingRulesSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayPricingRulesBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayPricingRulesVarPopFields = {
  __typename?: 'carpay_pricing_rules_var_pop_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayPricingRulesVarSampFields = {
  __typename?: 'carpay_pricing_rules_var_samp_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayPricingRulesVarianceFields = {
  __typename?: 'carpay_pricing_rules_variance_fields';
  uuid?: Maybe<Scalars['Float']>;
};

/** select columns of table "carpay_pricing" */
export enum CarpayPricingSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  Rules = 'rules'
}

/** select "carpay_pricing_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carpay_pricing" */
export enum CarpayPricingSelectColumnCarpayPricingAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

/** select "carpay_pricing_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carpay_pricing" */
export enum CarpayPricingSelectColumnCarpayPricingAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "carpay_pricing" */
export type CarpayPricingSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CarpayPricingStddevFields = {
  __typename?: 'carpay_pricing_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_pricing" */
export type CarpayPricingStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayPricingStddevPopFields = {
  __typename?: 'carpay_pricing_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_pricing" */
export type CarpayPricingStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayPricingStddevSampFields = {
  __typename?: 'carpay_pricing_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_pricing" */
export type CarpayPricingStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_pricing" */
export type CarpayPricingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayPricingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayPricingStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  rules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type CarpayPricingSumFields = {
  __typename?: 'carpay_pricing_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "carpay_pricing" */
export type CarpayPricingSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_pricing" */
export enum CarpayPricingUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  Rules = 'rules'
}

export type CarpayPricingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayPricingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayPricingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayPricingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayPricingDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayPricingIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayPricingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayPricingSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayPricingBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayPricingVarPopFields = {
  __typename?: 'carpay_pricing_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_pricing" */
export type CarpayPricingVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayPricingVarSampFields = {
  __typename?: 'carpay_pricing_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_pricing" */
export type CarpayPricingVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayPricingVarianceFields = {
  __typename?: 'carpay_pricing_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_pricing" */
export type CarpayPricingVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_scanned_codes" */
export type CarpayScannedCodes = {
  __typename?: 'carpay_scanned_codes';
  /** An object relationship */
  carpay_discount_batch?: Maybe<CarpayDiscountBatch>;
  carpay_discount_batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id: Scalars['Int'];
  /** An object relationship */
  carpay_discount_model_id_id: CarpayDiscountModel;
  /** An object relationship */
  carpay_order: CarpayOrder;
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  extractor_result: Scalars['jsonb'];
  id: Scalars['bigint'];
  order_id: Scalars['bigint'];
  original_value?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  validated?: Maybe<Scalars['Boolean']>;
  value: Scalars['numeric'];
};


/** columns and relationships of "carpay_scanned_codes" */
export type CarpayScannedCodesExtractorResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "carpay_scanned_codes" */
export type CarpayScannedCodesOriginalValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "carpay_scanned_codes" */
export type CarpayScannedCodesAggregate = {
  __typename?: 'carpay_scanned_codes_aggregate';
  aggregate?: Maybe<CarpayScannedCodesAggregateFields>;
  nodes: Array<CarpayScannedCodes>;
};

export type CarpayScannedCodesAggregateBoolExp = {
  bool_and?: InputMaybe<CarpayScannedCodesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CarpayScannedCodesAggregateBoolExpBoolOr>;
  count?: InputMaybe<CarpayScannedCodesAggregateBoolExpCount>;
};

export type CarpayScannedCodesAggregateBoolExpBoolAnd = {
  arguments: CarpayScannedCodesSelectColumnCarpayScannedCodesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayScannedCodesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayScannedCodesAggregateBoolExpBoolOr = {
  arguments: CarpayScannedCodesSelectColumnCarpayScannedCodesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayScannedCodesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CarpayScannedCodesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CarpayScannedCodesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "carpay_scanned_codes" */
export type CarpayScannedCodesAggregateFields = {
  __typename?: 'carpay_scanned_codes_aggregate_fields';
  avg?: Maybe<CarpayScannedCodesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayScannedCodesMaxFields>;
  min?: Maybe<CarpayScannedCodesMinFields>;
  stddev?: Maybe<CarpayScannedCodesStddevFields>;
  stddev_pop?: Maybe<CarpayScannedCodesStddevPopFields>;
  stddev_samp?: Maybe<CarpayScannedCodesStddevSampFields>;
  sum?: Maybe<CarpayScannedCodesSumFields>;
  var_pop?: Maybe<CarpayScannedCodesVarPopFields>;
  var_samp?: Maybe<CarpayScannedCodesVarSampFields>;
  variance?: Maybe<CarpayScannedCodesVarianceFields>;
};


/** aggregate fields of "carpay_scanned_codes" */
export type CarpayScannedCodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "carpay_scanned_codes" */
export type CarpayScannedCodesAggregateOrderBy = {
  avg?: InputMaybe<CarpayScannedCodesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CarpayScannedCodesMaxOrderBy>;
  min?: InputMaybe<CarpayScannedCodesMinOrderBy>;
  stddev?: InputMaybe<CarpayScannedCodesStddevOrderBy>;
  stddev_pop?: InputMaybe<CarpayScannedCodesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CarpayScannedCodesStddevSampOrderBy>;
  sum?: InputMaybe<CarpayScannedCodesSumOrderBy>;
  var_pop?: InputMaybe<CarpayScannedCodesVarPopOrderBy>;
  var_samp?: InputMaybe<CarpayScannedCodesVarSampOrderBy>;
  variance?: InputMaybe<CarpayScannedCodesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CarpayScannedCodesAppendInput = {
  extractor_result?: InputMaybe<Scalars['jsonb']>;
  original_value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "carpay_scanned_codes" */
export type CarpayScannedCodesArrRelInsertInput = {
  data: Array<CarpayScannedCodesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayScannedCodesOnConflict>;
};

/** aggregate avg on columns */
export type CarpayScannedCodesAvgFields = {
  __typename?: 'carpay_scanned_codes_avg_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesAvgOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "carpay_scanned_codes". All fields are combined with a logical 'AND'. */
export type CarpayScannedCodesBoolExp = {
  _and?: InputMaybe<Array<CarpayScannedCodesBoolExp>>;
  _not?: InputMaybe<CarpayScannedCodesBoolExp>;
  _or?: InputMaybe<Array<CarpayScannedCodesBoolExp>>;
  carpay_discount_batch?: InputMaybe<CarpayDiscountBatchBoolExp>;
  carpay_discount_batch_id?: InputMaybe<IntComparisonExp>;
  carpay_discount_model_id?: InputMaybe<IntComparisonExp>;
  carpay_discount_model_id_id?: InputMaybe<CarpayDiscountModelBoolExp>;
  carpay_order?: InputMaybe<CarpayOrderBoolExp>;
  code?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  extractor_result?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  order_id?: InputMaybe<BigintComparisonExp>;
  original_value?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  validated?: InputMaybe<BooleanComparisonExp>;
  value?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "carpay_scanned_codes" */
export enum CarpayScannedCodesConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayScannedCodesPkey = 'carpay_scanned_codes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CarpayScannedCodesDeleteAtPathInput = {
  extractor_result?: InputMaybe<Array<Scalars['String']>>;
  original_value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CarpayScannedCodesDeleteElemInput = {
  extractor_result?: InputMaybe<Scalars['Int']>;
  original_value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CarpayScannedCodesDeleteKeyInput = {
  extractor_result?: InputMaybe<Scalars['String']>;
  original_value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "carpay_scanned_codes" */
export type CarpayScannedCodesIncInput = {
  carpay_discount_batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "carpay_scanned_codes" */
export type CarpayScannedCodesInsertInput = {
  carpay_discount_batch?: InputMaybe<CarpayDiscountBatchObjRelInsertInput>;
  carpay_discount_batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id_id?: InputMaybe<CarpayDiscountModelObjRelInsertInput>;
  carpay_order?: InputMaybe<CarpayOrderObjRelInsertInput>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extractor_result?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  original_value?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CarpayScannedCodesMaxFields = {
  __typename?: 'carpay_scanned_codes_max_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesMaxOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CarpayScannedCodesMinFields = {
  __typename?: 'carpay_scanned_codes_min_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesMinOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "carpay_scanned_codes" */
export type CarpayScannedCodesMutationResponse = {
  __typename?: 'carpay_scanned_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayScannedCodes>;
};

/** on_conflict condition type for table "carpay_scanned_codes" */
export type CarpayScannedCodesOnConflict = {
  constraint: CarpayScannedCodesConstraint;
  update_columns?: Array<CarpayScannedCodesUpdateColumn>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};

/** Ordering options when selecting data from "carpay_scanned_codes". */
export type CarpayScannedCodesOrderBy = {
  carpay_discount_batch?: InputMaybe<CarpayDiscountBatchOrderBy>;
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id_id?: InputMaybe<CarpayDiscountModelOrderBy>;
  carpay_order?: InputMaybe<CarpayOrderOrderBy>;
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  extractor_result?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  original_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  validated?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_scanned_codes */
export type CarpayScannedCodesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CarpayScannedCodesPrependInput = {
  extractor_result?: InputMaybe<Scalars['jsonb']>;
  original_value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "carpay_scanned_codes" */
export enum CarpayScannedCodesSelectColumn {
  /** column name */
  CarpayDiscountBatchId = 'carpay_discount_batch_id',
  /** column name */
  CarpayDiscountModelId = 'carpay_discount_model_id',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtractorResult = 'extractor_result',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OriginalValue = 'original_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Validated = 'validated',
  /** column name */
  Value = 'value'
}

/** select "carpay_scanned_codes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carpay_scanned_codes" */
export enum CarpayScannedCodesSelectColumnCarpayScannedCodesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Validated = 'validated'
}

/** select "carpay_scanned_codes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carpay_scanned_codes" */
export enum CarpayScannedCodesSelectColumnCarpayScannedCodesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Validated = 'validated'
}

/** input type for updating data in table "carpay_scanned_codes" */
export type CarpayScannedCodesSetInput = {
  carpay_discount_batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extractor_result?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  original_value?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CarpayScannedCodesStddevFields = {
  __typename?: 'carpay_scanned_codes_stddev_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesStddevOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CarpayScannedCodesStddevPopFields = {
  __typename?: 'carpay_scanned_codes_stddev_pop_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesStddevPopOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CarpayScannedCodesStddevSampFields = {
  __typename?: 'carpay_scanned_codes_stddev_samp_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesStddevSampOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "carpay_scanned_codes" */
export type CarpayScannedCodesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayScannedCodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayScannedCodesStreamCursorValueInput = {
  carpay_discount_batch_id?: InputMaybe<Scalars['Int']>;
  carpay_discount_model_id?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extractor_result?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  original_value?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CarpayScannedCodesSumFields = {
  __typename?: 'carpay_scanned_codes_sum_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Int']>;
  carpay_discount_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesSumOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** update columns of table "carpay_scanned_codes" */
export enum CarpayScannedCodesUpdateColumn {
  /** column name */
  CarpayDiscountBatchId = 'carpay_discount_batch_id',
  /** column name */
  CarpayDiscountModelId = 'carpay_discount_model_id',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtractorResult = 'extractor_result',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OriginalValue = 'original_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Validated = 'validated',
  /** column name */
  Value = 'value'
}

export type CarpayScannedCodesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CarpayScannedCodesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CarpayScannedCodesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CarpayScannedCodesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CarpayScannedCodesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayScannedCodesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CarpayScannedCodesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayScannedCodesSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayScannedCodesBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayScannedCodesVarPopFields = {
  __typename?: 'carpay_scanned_codes_var_pop_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesVarPopOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CarpayScannedCodesVarSampFields = {
  __typename?: 'carpay_scanned_codes_var_samp_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesVarSampOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CarpayScannedCodesVarianceFields = {
  __typename?: 'carpay_scanned_codes_variance_fields';
  carpay_discount_batch_id?: Maybe<Scalars['Float']>;
  carpay_discount_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "carpay_scanned_codes" */
export type CarpayScannedCodesVarianceOrderBy = {
  carpay_discount_batch_id?: InputMaybe<OrderBy>;
  carpay_discount_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** columns and relationships of "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotification = {
  __typename?: 'carpay_terminal_cash_cut_notification';
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  lot_id: Scalars['String'];
  pdf_filename: Scalars['String'];
  sent_to?: Maybe<Array<Scalars['String']>>;
  terminal_id: Scalars['numeric'];
};

/** aggregated selection of "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationAggregate = {
  __typename?: 'carpay_terminal_cash_cut_notification_aggregate';
  aggregate?: Maybe<CarpayTerminalCashCutNotificationAggregateFields>;
  nodes: Array<CarpayTerminalCashCutNotification>;
};

/** aggregate fields of "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationAggregateFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_aggregate_fields';
  avg?: Maybe<CarpayTerminalCashCutNotificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayTerminalCashCutNotificationMaxFields>;
  min?: Maybe<CarpayTerminalCashCutNotificationMinFields>;
  stddev?: Maybe<CarpayTerminalCashCutNotificationStddevFields>;
  stddev_pop?: Maybe<CarpayTerminalCashCutNotificationStddevPopFields>;
  stddev_samp?: Maybe<CarpayTerminalCashCutNotificationStddevSampFields>;
  sum?: Maybe<CarpayTerminalCashCutNotificationSumFields>;
  var_pop?: Maybe<CarpayTerminalCashCutNotificationVarPopFields>;
  var_samp?: Maybe<CarpayTerminalCashCutNotificationVarSampFields>;
  variance?: Maybe<CarpayTerminalCashCutNotificationVarianceFields>;
};


/** aggregate fields of "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayTerminalCashCutNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayTerminalCashCutNotificationAvgFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_terminal_cash_cut_notification". All fields are combined with a logical 'AND'. */
export type CarpayTerminalCashCutNotificationBoolExp = {
  _and?: InputMaybe<Array<CarpayTerminalCashCutNotificationBoolExp>>;
  _not?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
  _or?: InputMaybe<Array<CarpayTerminalCashCutNotificationBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  pdf_filename?: InputMaybe<StringComparisonExp>;
  sent_to?: InputMaybe<StringArrayComparisonExp>;
  terminal_id?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "carpay_terminal_cash_cut_notification" */
export enum CarpayTerminalCashCutNotificationConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayTerminalCashEmptyNotificationPkey = 'carpay_terminal_cash_empty_notification_pkey'
}

/** input type for incrementing numeric columns in table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pdf_filename?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CarpayTerminalCashCutNotificationMaxFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  pdf_filename?: Maybe<Scalars['String']>;
  sent_to?: Maybe<Array<Scalars['String']>>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type CarpayTerminalCashCutNotificationMinFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  pdf_filename?: Maybe<Scalars['String']>;
  sent_to?: Maybe<Array<Scalars['String']>>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationMutationResponse = {
  __typename?: 'carpay_terminal_cash_cut_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayTerminalCashCutNotification>;
};

/** on_conflict condition type for table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationOnConflict = {
  constraint: CarpayTerminalCashCutNotificationConstraint;
  update_columns?: Array<CarpayTerminalCashCutNotificationUpdateColumn>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};

/** Ordering options when selecting data from "carpay_terminal_cash_cut_notification". */
export type CarpayTerminalCashCutNotificationOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  pdf_filename?: InputMaybe<OrderBy>;
  sent_to?: InputMaybe<OrderBy>;
  terminal_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_terminal_cash_cut_notification */
export type CarpayTerminalCashCutNotificationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_terminal_cash_cut_notification" */
export enum CarpayTerminalCashCutNotificationSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PdfFilename = 'pdf_filename',
  /** column name */
  SentTo = 'sent_to',
  /** column name */
  TerminalId = 'terminal_id'
}

/** input type for updating data in table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pdf_filename?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CarpayTerminalCashCutNotificationStddevFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayTerminalCashCutNotificationStddevPopFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayTerminalCashCutNotificationStddevSampFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_terminal_cash_cut_notification" */
export type CarpayTerminalCashCutNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayTerminalCashCutNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayTerminalCashCutNotificationStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  pdf_filename?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CarpayTerminalCashCutNotificationSumFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "carpay_terminal_cash_cut_notification" */
export enum CarpayTerminalCashCutNotificationUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PdfFilename = 'pdf_filename',
  /** column name */
  SentTo = 'sent_to',
  /** column name */
  TerminalId = 'terminal_id'
}

export type CarpayTerminalCashCutNotificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayTerminalCashCutNotificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayTerminalCashCutNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayTerminalCashCutNotificationBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayTerminalCashCutNotificationVarPopFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayTerminalCashCutNotificationVarSampFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayTerminalCashCutNotificationVarianceFields = {
  __typename?: 'carpay_terminal_cash_cut_notification_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotification = {
  __typename?: 'carpay_terminal_cash_fill_level_notification';
  amount: Scalars['numeric'];
  configured_max_cash: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  fill_level: Scalars['numeric'];
  id: Scalars['Int'];
  lot_id: Scalars['String'];
  terminal_id: Scalars['numeric'];
};

/** aggregated selection of "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationAggregate = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_aggregate';
  aggregate?: Maybe<CarpayTerminalCashFillLevelNotificationAggregateFields>;
  nodes: Array<CarpayTerminalCashFillLevelNotification>;
};

/** aggregate fields of "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationAggregateFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_aggregate_fields';
  avg?: Maybe<CarpayTerminalCashFillLevelNotificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayTerminalCashFillLevelNotificationMaxFields>;
  min?: Maybe<CarpayTerminalCashFillLevelNotificationMinFields>;
  stddev?: Maybe<CarpayTerminalCashFillLevelNotificationStddevFields>;
  stddev_pop?: Maybe<CarpayTerminalCashFillLevelNotificationStddevPopFields>;
  stddev_samp?: Maybe<CarpayTerminalCashFillLevelNotificationStddevSampFields>;
  sum?: Maybe<CarpayTerminalCashFillLevelNotificationSumFields>;
  var_pop?: Maybe<CarpayTerminalCashFillLevelNotificationVarPopFields>;
  var_samp?: Maybe<CarpayTerminalCashFillLevelNotificationVarSampFields>;
  variance?: Maybe<CarpayTerminalCashFillLevelNotificationVarianceFields>;
};


/** aggregate fields of "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayTerminalCashFillLevelNotificationAvgFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_terminal_cash_fill_level_notification". All fields are combined with a logical 'AND'. */
export type CarpayTerminalCashFillLevelNotificationBoolExp = {
  _and?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationBoolExp>>;
  _not?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
  _or?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  configured_max_cash?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  fill_level?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  terminal_id?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "carpay_terminal_cash_fill_level_notification" */
export enum CarpayTerminalCashFillLevelNotificationConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayTerminalFillLevelNotificationPkey = 'carpay_terminal_fill_level_notification_pkey'
}

/** input type for incrementing numeric columns in table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  configured_max_cash?: InputMaybe<Scalars['numeric']>;
  fill_level?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  configured_max_cash?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fill_level?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CarpayTerminalCashFillLevelNotificationMaxFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  configured_max_cash?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fill_level?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type CarpayTerminalCashFillLevelNotificationMinFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  configured_max_cash?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fill_level?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationMutationResponse = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayTerminalCashFillLevelNotification>;
};

/** on_conflict condition type for table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationOnConflict = {
  constraint: CarpayTerminalCashFillLevelNotificationConstraint;
  update_columns?: Array<CarpayTerminalCashFillLevelNotificationUpdateColumn>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};

/** Ordering options when selecting data from "carpay_terminal_cash_fill_level_notification". */
export type CarpayTerminalCashFillLevelNotificationOrderBy = {
  amount?: InputMaybe<OrderBy>;
  configured_max_cash?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  fill_level?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  terminal_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_terminal_cash_fill_level_notification */
export type CarpayTerminalCashFillLevelNotificationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_terminal_cash_fill_level_notification" */
export enum CarpayTerminalCashFillLevelNotificationSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ConfiguredMaxCash = 'configured_max_cash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FillLevel = 'fill_level',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  TerminalId = 'terminal_id'
}

/** input type for updating data in table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  configured_max_cash?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fill_level?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CarpayTerminalCashFillLevelNotificationStddevFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayTerminalCashFillLevelNotificationStddevPopFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayTerminalCashFillLevelNotificationStddevSampFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_terminal_cash_fill_level_notification" */
export type CarpayTerminalCashFillLevelNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayTerminalCashFillLevelNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayTerminalCashFillLevelNotificationStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  configured_max_cash?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fill_level?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CarpayTerminalCashFillLevelNotificationSumFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  configured_max_cash?: Maybe<Scalars['numeric']>;
  fill_level?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "carpay_terminal_cash_fill_level_notification" */
export enum CarpayTerminalCashFillLevelNotificationUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ConfiguredMaxCash = 'configured_max_cash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FillLevel = 'fill_level',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  TerminalId = 'terminal_id'
}

export type CarpayTerminalCashFillLevelNotificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayTerminalCashFillLevelNotificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayTerminalCashFillLevelNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayTerminalCashFillLevelNotificationBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayTerminalCashFillLevelNotificationVarPopFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayTerminalCashFillLevelNotificationVarSampFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayTerminalCashFillLevelNotificationVarianceFields = {
  __typename?: 'carpay_terminal_cash_fill_level_notification_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  configured_max_cash?: Maybe<Scalars['Float']>;
  fill_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfig = {
  __typename?: 'carpay_terminal_notification_config';
  fill_level_thresholds: Array<Scalars['numeric']>;
  lot_id: Scalars['String'];
  max_cash: Scalars['numeric'];
};

/** aggregated selection of "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigAggregate = {
  __typename?: 'carpay_terminal_notification_config_aggregate';
  aggregate?: Maybe<CarpayTerminalNotificationConfigAggregateFields>;
  nodes: Array<CarpayTerminalNotificationConfig>;
};

/** aggregate fields of "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigAggregateFields = {
  __typename?: 'carpay_terminal_notification_config_aggregate_fields';
  avg?: Maybe<CarpayTerminalNotificationConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayTerminalNotificationConfigMaxFields>;
  min?: Maybe<CarpayTerminalNotificationConfigMinFields>;
  stddev?: Maybe<CarpayTerminalNotificationConfigStddevFields>;
  stddev_pop?: Maybe<CarpayTerminalNotificationConfigStddevPopFields>;
  stddev_samp?: Maybe<CarpayTerminalNotificationConfigStddevSampFields>;
  sum?: Maybe<CarpayTerminalNotificationConfigSumFields>;
  var_pop?: Maybe<CarpayTerminalNotificationConfigVarPopFields>;
  var_samp?: Maybe<CarpayTerminalNotificationConfigVarSampFields>;
  variance?: Maybe<CarpayTerminalNotificationConfigVarianceFields>;
};


/** aggregate fields of "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayTerminalNotificationConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayTerminalNotificationConfigAvgFields = {
  __typename?: 'carpay_terminal_notification_config_avg_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_terminal_notification_config". All fields are combined with a logical 'AND'. */
export type CarpayTerminalNotificationConfigBoolExp = {
  _and?: InputMaybe<Array<CarpayTerminalNotificationConfigBoolExp>>;
  _not?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
  _or?: InputMaybe<Array<CarpayTerminalNotificationConfigBoolExp>>;
  fill_level_thresholds?: InputMaybe<NumericArrayComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  max_cash?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "carpay_terminal_notification_config" */
export enum CarpayTerminalNotificationConfigConstraint {
  /** unique or primary key constraint on columns "lot_id" */
  CarpayTerminalNotificationConfigLotIdKey = 'carpay_terminal_notification_config_lot_id_key',
  /** unique or primary key constraint on columns "lot_id" */
  CarpayTerminalNotificationConfigPkey = 'carpay_terminal_notification_config_pkey'
}

/** input type for incrementing numeric columns in table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigIncInput = {
  max_cash?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigInsertInput = {
  fill_level_thresholds?: InputMaybe<Array<Scalars['numeric']>>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_cash?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CarpayTerminalNotificationConfigMaxFields = {
  __typename?: 'carpay_terminal_notification_config_max_fields';
  fill_level_thresholds?: Maybe<Array<Scalars['numeric']>>;
  lot_id?: Maybe<Scalars['String']>;
  max_cash?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type CarpayTerminalNotificationConfigMinFields = {
  __typename?: 'carpay_terminal_notification_config_min_fields';
  fill_level_thresholds?: Maybe<Array<Scalars['numeric']>>;
  lot_id?: Maybe<Scalars['String']>;
  max_cash?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigMutationResponse = {
  __typename?: 'carpay_terminal_notification_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayTerminalNotificationConfig>;
};

/** input type for inserting object relation for remote table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigObjRelInsertInput = {
  data: CarpayTerminalNotificationConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CarpayTerminalNotificationConfigOnConflict>;
};

/** on_conflict condition type for table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigOnConflict = {
  constraint: CarpayTerminalNotificationConfigConstraint;
  update_columns?: Array<CarpayTerminalNotificationConfigUpdateColumn>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};

/** Ordering options when selecting data from "carpay_terminal_notification_config". */
export type CarpayTerminalNotificationConfigOrderBy = {
  fill_level_thresholds?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  max_cash?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_terminal_notification_config */
export type CarpayTerminalNotificationConfigPkColumnsInput = {
  lot_id: Scalars['String'];
};

/** select columns of table "carpay_terminal_notification_config" */
export enum CarpayTerminalNotificationConfigSelectColumn {
  /** column name */
  FillLevelThresholds = 'fill_level_thresholds',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MaxCash = 'max_cash'
}

/** input type for updating data in table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigSetInput = {
  fill_level_thresholds?: InputMaybe<Array<Scalars['numeric']>>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_cash?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CarpayTerminalNotificationConfigStddevFields = {
  __typename?: 'carpay_terminal_notification_config_stddev_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayTerminalNotificationConfigStddevPopFields = {
  __typename?: 'carpay_terminal_notification_config_stddev_pop_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayTerminalNotificationConfigStddevSampFields = {
  __typename?: 'carpay_terminal_notification_config_stddev_samp_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_terminal_notification_config" */
export type CarpayTerminalNotificationConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayTerminalNotificationConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayTerminalNotificationConfigStreamCursorValueInput = {
  fill_level_thresholds?: InputMaybe<Array<Scalars['numeric']>>;
  lot_id?: InputMaybe<Scalars['String']>;
  max_cash?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CarpayTerminalNotificationConfigSumFields = {
  __typename?: 'carpay_terminal_notification_config_sum_fields';
  max_cash?: Maybe<Scalars['numeric']>;
};

/** update columns of table "carpay_terminal_notification_config" */
export enum CarpayTerminalNotificationConfigUpdateColumn {
  /** column name */
  FillLevelThresholds = 'fill_level_thresholds',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MaxCash = 'max_cash'
}

export type CarpayTerminalNotificationConfigUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayTerminalNotificationConfigIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayTerminalNotificationConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayTerminalNotificationConfigBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayTerminalNotificationConfigVarPopFields = {
  __typename?: 'carpay_terminal_notification_config_var_pop_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayTerminalNotificationConfigVarSampFields = {
  __typename?: 'carpay_terminal_notification_config_var_samp_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayTerminalNotificationConfigVarianceFields = {
  __typename?: 'carpay_terminal_notification_config_variance_fields';
  max_cash?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotification = {
  __typename?: 'carpay_terminal_printer_status_notification';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  lot_id: Scalars['String'];
  sent_to?: Maybe<Array<Scalars['String']>>;
  status: Scalars['String'];
  terminal_id: Scalars['numeric'];
};

/** aggregated selection of "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationAggregate = {
  __typename?: 'carpay_terminal_printer_status_notification_aggregate';
  aggregate?: Maybe<CarpayTerminalPrinterStatusNotificationAggregateFields>;
  nodes: Array<CarpayTerminalPrinterStatusNotification>;
};

/** aggregate fields of "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationAggregateFields = {
  __typename?: 'carpay_terminal_printer_status_notification_aggregate_fields';
  avg?: Maybe<CarpayTerminalPrinterStatusNotificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CarpayTerminalPrinterStatusNotificationMaxFields>;
  min?: Maybe<CarpayTerminalPrinterStatusNotificationMinFields>;
  stddev?: Maybe<CarpayTerminalPrinterStatusNotificationStddevFields>;
  stddev_pop?: Maybe<CarpayTerminalPrinterStatusNotificationStddevPopFields>;
  stddev_samp?: Maybe<CarpayTerminalPrinterStatusNotificationStddevSampFields>;
  sum?: Maybe<CarpayTerminalPrinterStatusNotificationSumFields>;
  var_pop?: Maybe<CarpayTerminalPrinterStatusNotificationVarPopFields>;
  var_samp?: Maybe<CarpayTerminalPrinterStatusNotificationVarSampFields>;
  variance?: Maybe<CarpayTerminalPrinterStatusNotificationVarianceFields>;
};


/** aggregate fields of "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CarpayTerminalPrinterStatusNotificationAvgFields = {
  __typename?: 'carpay_terminal_printer_status_notification_avg_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "carpay_terminal_printer_status_notification". All fields are combined with a logical 'AND'. */
export type CarpayTerminalPrinterStatusNotificationBoolExp = {
  _and?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationBoolExp>>;
  _not?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
  _or?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  sent_to?: InputMaybe<StringArrayComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  terminal_id?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "carpay_terminal_printer_status_notification" */
export enum CarpayTerminalPrinterStatusNotificationConstraint {
  /** unique or primary key constraint on columns "id" */
  CarpayTerminalPrinterStatusNotificationPkey = 'carpay_terminal_printer_status_notification_pkey'
}

/** input type for incrementing numeric columns in table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CarpayTerminalPrinterStatusNotificationMaxFields = {
  __typename?: 'carpay_terminal_printer_status_notification_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  sent_to?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type CarpayTerminalPrinterStatusNotificationMinFields = {
  __typename?: 'carpay_terminal_printer_status_notification_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  sent_to?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationMutationResponse = {
  __typename?: 'carpay_terminal_printer_status_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayTerminalPrinterStatusNotification>;
};

/** on_conflict condition type for table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationOnConflict = {
  constraint: CarpayTerminalPrinterStatusNotificationConstraint;
  update_columns?: Array<CarpayTerminalPrinterStatusNotificationUpdateColumn>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};

/** Ordering options when selecting data from "carpay_terminal_printer_status_notification". */
export type CarpayTerminalPrinterStatusNotificationOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  sent_to?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  terminal_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_terminal_printer_status_notification */
export type CarpayTerminalPrinterStatusNotificationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "carpay_terminal_printer_status_notification" */
export enum CarpayTerminalPrinterStatusNotificationSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SentTo = 'sent_to',
  /** column name */
  Status = 'status',
  /** column name */
  TerminalId = 'terminal_id'
}

/** input type for updating data in table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CarpayTerminalPrinterStatusNotificationStddevFields = {
  __typename?: 'carpay_terminal_printer_status_notification_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CarpayTerminalPrinterStatusNotificationStddevPopFields = {
  __typename?: 'carpay_terminal_printer_status_notification_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CarpayTerminalPrinterStatusNotificationStddevSampFields = {
  __typename?: 'carpay_terminal_printer_status_notification_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "carpay_terminal_printer_status_notification" */
export type CarpayTerminalPrinterStatusNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayTerminalPrinterStatusNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayTerminalPrinterStatusNotificationStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  sent_to?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CarpayTerminalPrinterStatusNotificationSumFields = {
  __typename?: 'carpay_terminal_printer_status_notification_sum_fields';
  id?: Maybe<Scalars['Int']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "carpay_terminal_printer_status_notification" */
export enum CarpayTerminalPrinterStatusNotificationUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SentTo = 'sent_to',
  /** column name */
  Status = 'status',
  /** column name */
  TerminalId = 'terminal_id'
}

export type CarpayTerminalPrinterStatusNotificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CarpayTerminalPrinterStatusNotificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayTerminalPrinterStatusNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayTerminalPrinterStatusNotificationBoolExp;
};

/** aggregate var_pop on columns */
export type CarpayTerminalPrinterStatusNotificationVarPopFields = {
  __typename?: 'carpay_terminal_printer_status_notification_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CarpayTerminalPrinterStatusNotificationVarSampFields = {
  __typename?: 'carpay_terminal_printer_status_notification_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CarpayTerminalPrinterStatusNotificationVarianceFields = {
  __typename?: 'carpay_terminal_printer_status_notification_variance_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** This is a temporary table for B2C to be able to verify the plate of the user. The idea is to lookup in this plate whether person used the plate before. */
export type CarpayUserVerifiedPlate = {
  __typename?: 'carpay_user_verified_plate';
  created_at: Scalars['timestamptz'];
  normalized_plate: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateAggregate = {
  __typename?: 'carpay_user_verified_plate_aggregate';
  aggregate?: Maybe<CarpayUserVerifiedPlateAggregateFields>;
  nodes: Array<CarpayUserVerifiedPlate>;
};

/** aggregate fields of "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateAggregateFields = {
  __typename?: 'carpay_user_verified_plate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CarpayUserVerifiedPlateMaxFields>;
  min?: Maybe<CarpayUserVerifiedPlateMinFields>;
};


/** aggregate fields of "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CarpayUserVerifiedPlateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "carpay_user_verified_plate". All fields are combined with a logical 'AND'. */
export type CarpayUserVerifiedPlateBoolExp = {
  _and?: InputMaybe<Array<CarpayUserVerifiedPlateBoolExp>>;
  _not?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
  _or?: InputMaybe<Array<CarpayUserVerifiedPlateBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  normalized_plate?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "carpay_user_verified_plate" */
export enum CarpayUserVerifiedPlateConstraint {
  /** unique or primary key constraint on columns "normalized_plate", "user_id" */
  CarpayUserVerifiedPlatePkey = 'carpay_user_verified_plate_pkey'
}

/** input type for inserting data into table "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CarpayUserVerifiedPlateMaxFields = {
  __typename?: 'carpay_user_verified_plate_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  normalized_plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CarpayUserVerifiedPlateMinFields = {
  __typename?: 'carpay_user_verified_plate_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  normalized_plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateMutationResponse = {
  __typename?: 'carpay_user_verified_plate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CarpayUserVerifiedPlate>;
};

/** on_conflict condition type for table "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateOnConflict = {
  constraint: CarpayUserVerifiedPlateConstraint;
  update_columns?: Array<CarpayUserVerifiedPlateUpdateColumn>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};

/** Ordering options when selecting data from "carpay_user_verified_plate". */
export type CarpayUserVerifiedPlateOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  normalized_plate?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: carpay_user_verified_plate */
export type CarpayUserVerifiedPlatePkColumnsInput = {
  normalized_plate: Scalars['String'];
  user_id: Scalars['uuid'];
};

/** select columns of table "carpay_user_verified_plate" */
export enum CarpayUserVerifiedPlateSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NormalizedPlate = 'normalized_plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "carpay_user_verified_plate" */
export type CarpayUserVerifiedPlateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CarpayUserVerifiedPlateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CarpayUserVerifiedPlateStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "carpay_user_verified_plate" */
export enum CarpayUserVerifiedPlateUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NormalizedPlate = 'normalized_plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type CarpayUserVerifiedPlateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CarpayUserVerifiedPlateSetInput>;
  /** filter the rows which have to be updated */
  where: CarpayUserVerifiedPlateBoolExp;
};

/** columns and relationships of "chain" */
export type Chain = {
  __typename?: 'chain';
  /** An array relationship */
  companies: Array<Company>;
  /** An aggregate relationship */
  companies_aggregate: CompanyAggregate;
  id: Scalars['String'];
};


/** columns and relationships of "chain" */
export type ChainCompaniesArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


/** columns and relationships of "chain" */
export type ChainCompaniesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};

/** aggregated selection of "chain" */
export type ChainAggregate = {
  __typename?: 'chain_aggregate';
  aggregate?: Maybe<ChainAggregateFields>;
  nodes: Array<Chain>;
};

/** aggregate fields of "chain" */
export type ChainAggregateFields = {
  __typename?: 'chain_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ChainMaxFields>;
  min?: Maybe<ChainMinFields>;
};


/** aggregate fields of "chain" */
export type ChainAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChainSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chain". All fields are combined with a logical 'AND'. */
export type ChainBoolExp = {
  _and?: InputMaybe<Array<ChainBoolExp>>;
  _not?: InputMaybe<ChainBoolExp>;
  _or?: InputMaybe<Array<ChainBoolExp>>;
  companies?: InputMaybe<CompanyBoolExp>;
  companies_aggregate?: InputMaybe<CompanyAggregateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "chain" */
export enum ChainConstraint {
  /** unique or primary key constraint on columns "id" */
  ChainPkey = 'chain_pkey'
}

/** input type for inserting data into table "chain" */
export type ChainInsertInput = {
  companies?: InputMaybe<CompanyArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ChainMaxFields = {
  __typename?: 'chain_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ChainMinFields = {
  __typename?: 'chain_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chain" */
export type ChainMutationResponse = {
  __typename?: 'chain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chain>;
};

/** input type for inserting object relation for remote table "chain" */
export type ChainObjRelInsertInput = {
  data: ChainInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ChainOnConflict>;
};

/** on_conflict condition type for table "chain" */
export type ChainOnConflict = {
  constraint: ChainConstraint;
  update_columns?: Array<ChainUpdateColumn>;
  where?: InputMaybe<ChainBoolExp>;
};

/** Ordering options when selecting data from "chain". */
export type ChainOrderBy = {
  companies_aggregate?: InputMaybe<CompanyAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: chain */
export type ChainPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "chain" */
export enum ChainSelectColumn {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "chain" */
export type ChainSetInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "chain" */
export type ChainStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ChainStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChainStreamCursorValueInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chain" */
export enum ChainUpdateColumn {
  /** column name */
  Id = 'id'
}

export type ChainUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChainSetInput>;
  /** filter the rows which have to be updated */
  where: ChainBoolExp;
};

/** columns and relationships of "city_codes" */
export type CityCodes = {
  __typename?: 'city_codes';
  city: Scalars['String'];
  code: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  department?: Maybe<Department>;
  department_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "city_codes" */
export type CityCodesAggregate = {
  __typename?: 'city_codes_aggregate';
  aggregate?: Maybe<CityCodesAggregateFields>;
  nodes: Array<CityCodes>;
};

/** aggregate fields of "city_codes" */
export type CityCodesAggregateFields = {
  __typename?: 'city_codes_aggregate_fields';
  avg?: Maybe<CityCodesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CityCodesMaxFields>;
  min?: Maybe<CityCodesMinFields>;
  stddev?: Maybe<CityCodesStddevFields>;
  stddev_pop?: Maybe<CityCodesStddevPopFields>;
  stddev_samp?: Maybe<CityCodesStddevSampFields>;
  sum?: Maybe<CityCodesSumFields>;
  var_pop?: Maybe<CityCodesVarPopFields>;
  var_samp?: Maybe<CityCodesVarSampFields>;
  variance?: Maybe<CityCodesVarianceFields>;
};


/** aggregate fields of "city_codes" */
export type CityCodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CityCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CityCodesAvgFields = {
  __typename?: 'city_codes_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "city_codes". All fields are combined with a logical 'AND'. */
export type CityCodesBoolExp = {
  _and?: InputMaybe<Array<CityCodesBoolExp>>;
  _not?: InputMaybe<CityCodesBoolExp>;
  _or?: InputMaybe<Array<CityCodesBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentBoolExp>;
  department_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for incrementing numeric columns in table "city_codes" */
export type CityCodesIncInput = {
  department_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "city_codes" */
export type CityCodesInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  department?: InputMaybe<DepartmentObjRelInsertInput>;
  department_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CityCodesMaxFields = {
  __typename?: 'city_codes_max_fields';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CityCodesMinFields = {
  __typename?: 'city_codes_min_fields';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "city_codes" */
export type CityCodesMutationResponse = {
  __typename?: 'city_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CityCodes>;
};

/** Ordering options when selecting data from "city_codes". */
export type CityCodesOrderBy = {
  city?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentOrderBy>;
  department_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "city_codes" */
export enum CityCodesSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "city_codes" */
export type CityCodesSetInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CityCodesStddevFields = {
  __typename?: 'city_codes_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CityCodesStddevPopFields = {
  __typename?: 'city_codes_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CityCodesStddevSampFields = {
  __typename?: 'city_codes_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "city_codes" */
export type CityCodesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CityCodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CityCodesStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CityCodesSumFields = {
  __typename?: 'city_codes_sum_fields';
  department_id?: Maybe<Scalars['bigint']>;
};

export type CityCodesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CityCodesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CityCodesSetInput>;
  /** filter the rows which have to be updated */
  where: CityCodesBoolExp;
};

/** aggregate var_pop on columns */
export type CityCodesVarPopFields = {
  __typename?: 'city_codes_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CityCodesVarSampFields = {
  __typename?: 'city_codes_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CityCodesVarianceFields = {
  __typename?: 'city_codes_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  address: Scalars['String'];
  /** An object relationship */
  chain?: Maybe<Chain>;
  chain_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  company_hierarchy: Array<CompanyHierarchy>;
  /** An aggregate relationship */
  company_hierarchy_aggregate: CompanyHierarchyAggregate;
  /** An array relationship */
  company_lot_sections: Array<CompanyLotSection>;
  /** An aggregate relationship */
  company_lot_sections_aggregate: CompanyLotSectionAggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['String'];
  /** An array relationship */
  lot_hierarchies: Array<LotHierarchy>;
  /** An aggregate relationship */
  lot_hierarchies_aggregate: LotHierarchyAggregate;
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  whitelists: Array<Whitelist>;
  /** An aggregate relationship */
  whitelists_aggregate: WhitelistAggregate;
};


/** columns and relationships of "company" */
export type CompanyCompanyHierarchyArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyCompanyHierarchyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyCompanyLotSectionsArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyCompanyLotSectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyLotHierarchiesArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyLotHierarchiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyWhitelistsArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyWhitelistsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};

/** aggregated selection of "company" */
export type CompanyAggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<CompanyAggregateFields>;
  nodes: Array<Company>;
};

export type CompanyAggregateBoolExp = {
  count?: InputMaybe<CompanyAggregateBoolExpCount>;
};

export type CompanyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "company" */
export type CompanyAggregateFields = {
  __typename?: 'company_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CompanyMaxFields>;
  min?: Maybe<CompanyMinFields>;
};


/** aggregate fields of "company" */
export type CompanyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company" */
export type CompanyAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyMaxOrderBy>;
  min?: InputMaybe<CompanyMinOrderBy>;
};

/** input type for inserting array relation for remote table "company" */
export type CompanyArrRelInsertInput = {
  data: Array<CompanyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyOnConflict>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type CompanyBoolExp = {
  _and?: InputMaybe<Array<CompanyBoolExp>>;
  _not?: InputMaybe<CompanyBoolExp>;
  _or?: InputMaybe<Array<CompanyBoolExp>>;
  address?: InputMaybe<StringComparisonExp>;
  chain?: InputMaybe<ChainBoolExp>;
  chain_id?: InputMaybe<StringComparisonExp>;
  company_hierarchy?: InputMaybe<CompanyHierarchyBoolExp>;
  company_hierarchy_aggregate?: InputMaybe<CompanyHierarchyAggregateBoolExp>;
  company_lot_sections?: InputMaybe<CompanyLotSectionBoolExp>;
  company_lot_sections_aggregate?: InputMaybe<CompanyLotSectionAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  lot_hierarchies?: InputMaybe<LotHierarchyBoolExp>;
  lot_hierarchies_aggregate?: InputMaybe<LotHierarchyAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelists?: InputMaybe<WhitelistBoolExp>;
  whitelists_aggregate?: InputMaybe<WhitelistAggregateBoolExp>;
};

/** columns and relationships of "company_config_group" */
export type CompanyConfigGroup = {
  __typename?: 'company_config_group';
  company_id: Scalars['String'];
  config_group_id: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "company_config_group" */
export type CompanyConfigGroupAggregate = {
  __typename?: 'company_config_group_aggregate';
  aggregate?: Maybe<CompanyConfigGroupAggregateFields>;
  nodes: Array<CompanyConfigGroup>;
};

/** aggregate fields of "company_config_group" */
export type CompanyConfigGroupAggregateFields = {
  __typename?: 'company_config_group_aggregate_fields';
  avg?: Maybe<CompanyConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyConfigGroupMaxFields>;
  min?: Maybe<CompanyConfigGroupMinFields>;
  stddev?: Maybe<CompanyConfigGroupStddevFields>;
  stddev_pop?: Maybe<CompanyConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<CompanyConfigGroupStddevSampFields>;
  sum?: Maybe<CompanyConfigGroupSumFields>;
  var_pop?: Maybe<CompanyConfigGroupVarPopFields>;
  var_samp?: Maybe<CompanyConfigGroupVarSampFields>;
  variance?: Maybe<CompanyConfigGroupVarianceFields>;
};


/** aggregate fields of "company_config_group" */
export type CompanyConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyConfigGroupAvgFields = {
  __typename?: 'company_config_group_avg_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_config_group". All fields are combined with a logical 'AND'. */
export type CompanyConfigGroupBoolExp = {
  _and?: InputMaybe<Array<CompanyConfigGroupBoolExp>>;
  _not?: InputMaybe<CompanyConfigGroupBoolExp>;
  _or?: InputMaybe<Array<CompanyConfigGroupBoolExp>>;
  company_id?: InputMaybe<StringComparisonExp>;
  config_group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "company_config_group" */
export enum CompanyConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  CompanyConfigGroupPkey = 'company_config_group_pkey'
}

/** input type for incrementing numeric columns in table "company_config_group" */
export type CompanyConfigGroupIncInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "company_config_group" */
export type CompanyConfigGroupInsertInput = {
  company_id?: InputMaybe<Scalars['String']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type CompanyConfigGroupMaxFields = {
  __typename?: 'company_config_group_max_fields';
  company_id?: Maybe<Scalars['String']>;
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CompanyConfigGroupMinFields = {
  __typename?: 'company_config_group_min_fields';
  company_id?: Maybe<Scalars['String']>;
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "company_config_group" */
export type CompanyConfigGroupMutationResponse = {
  __typename?: 'company_config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyConfigGroup>;
};

/** on_conflict condition type for table "company_config_group" */
export type CompanyConfigGroupOnConflict = {
  constraint: CompanyConfigGroupConstraint;
  update_columns?: Array<CompanyConfigGroupUpdateColumn>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "company_config_group". */
export type CompanyConfigGroupOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  config_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_config_group */
export type CompanyConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "company_config_group" */
export enum CompanyConfigGroupSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "company_config_group" */
export type CompanyConfigGroupSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type CompanyConfigGroupStddevFields = {
  __typename?: 'company_config_group_stddev_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CompanyConfigGroupStddevPopFields = {
  __typename?: 'company_config_group_stddev_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CompanyConfigGroupStddevSampFields = {
  __typename?: 'company_config_group_stddev_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_config_group" */
export type CompanyConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyConfigGroupStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CompanyConfigGroupSumFields = {
  __typename?: 'company_config_group_sum_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "company_config_group" */
export enum CompanyConfigGroupUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id'
}

export type CompanyConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type CompanyConfigGroupVarPopFields = {
  __typename?: 'company_config_group_var_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CompanyConfigGroupVarSampFields = {
  __typename?: 'company_config_group_var_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyConfigGroupVarianceFields = {
  __typename?: 'company_config_group_variance_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "company" */
export enum CompanyConstraint {
  /** unique or primary key constraint on columns "id" */
  CompanyIdKey = 'company_id_key',
  /** unique or primary key constraint on columns "id" */
  CompanyPkey = 'company_pkey'
}

/** Table to model company hierarchies with the ltree extension */
export type CompanyHierarchy = {
  __typename?: 'company_hierarchy';
  chain_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  path: Scalars['ltree'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "company_hierarchy" */
export type CompanyHierarchyAggregate = {
  __typename?: 'company_hierarchy_aggregate';
  aggregate?: Maybe<CompanyHierarchyAggregateFields>;
  nodes: Array<CompanyHierarchy>;
};

export type CompanyHierarchyAggregateBoolExp = {
  count?: InputMaybe<CompanyHierarchyAggregateBoolExpCount>;
};

export type CompanyHierarchyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyHierarchyBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "company_hierarchy" */
export type CompanyHierarchyAggregateFields = {
  __typename?: 'company_hierarchy_aggregate_fields';
  avg?: Maybe<CompanyHierarchyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyHierarchyMaxFields>;
  min?: Maybe<CompanyHierarchyMinFields>;
  stddev?: Maybe<CompanyHierarchyStddevFields>;
  stddev_pop?: Maybe<CompanyHierarchyStddevPopFields>;
  stddev_samp?: Maybe<CompanyHierarchyStddevSampFields>;
  sum?: Maybe<CompanyHierarchySumFields>;
  var_pop?: Maybe<CompanyHierarchyVarPopFields>;
  var_samp?: Maybe<CompanyHierarchyVarSampFields>;
  variance?: Maybe<CompanyHierarchyVarianceFields>;
};


/** aggregate fields of "company_hierarchy" */
export type CompanyHierarchyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_hierarchy" */
export type CompanyHierarchyAggregateOrderBy = {
  avg?: InputMaybe<CompanyHierarchyAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyHierarchyMaxOrderBy>;
  min?: InputMaybe<CompanyHierarchyMinOrderBy>;
  stddev?: InputMaybe<CompanyHierarchyStddevOrderBy>;
  stddev_pop?: InputMaybe<CompanyHierarchyStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CompanyHierarchyStddevSampOrderBy>;
  sum?: InputMaybe<CompanyHierarchySumOrderBy>;
  var_pop?: InputMaybe<CompanyHierarchyVarPopOrderBy>;
  var_samp?: InputMaybe<CompanyHierarchyVarSampOrderBy>;
  variance?: InputMaybe<CompanyHierarchyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "company_hierarchy" */
export type CompanyHierarchyArrRelInsertInput = {
  data: Array<CompanyHierarchyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyHierarchyOnConflict>;
};

/** aggregate avg on columns */
export type CompanyHierarchyAvgFields = {
  __typename?: 'company_hierarchy_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_hierarchy" */
export type CompanyHierarchyAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "company_hierarchy". All fields are combined with a logical 'AND'. */
export type CompanyHierarchyBoolExp = {
  _and?: InputMaybe<Array<CompanyHierarchyBoolExp>>;
  _not?: InputMaybe<CompanyHierarchyBoolExp>;
  _or?: InputMaybe<Array<CompanyHierarchyBoolExp>>;
  chain_id?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  path?: InputMaybe<LtreeComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_hierarchy" */
export enum CompanyHierarchyConstraint {
  /** unique or primary key constraint on columns "path" */
  CompanyHierarchyPathKey = 'company_hierarchy_path_key',
  /** unique or primary key constraint on columns "id" */
  CompanyHierarchyPkey = 'company_hierarchy_pkey'
}

/** input type for incrementing numeric columns in table "company_hierarchy" */
export type CompanyHierarchyIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "company_hierarchy" */
export type CompanyHierarchyInsertInput = {
  chain_id?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyHierarchyMaxFields = {
  __typename?: 'company_hierarchy_max_fields';
  chain_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company_hierarchy" */
export type CompanyHierarchyMaxOrderBy = {
  chain_id?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyHierarchyMinFields = {
  __typename?: 'company_hierarchy_min_fields';
  chain_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company_hierarchy" */
export type CompanyHierarchyMinOrderBy = {
  chain_id?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_hierarchy" */
export type CompanyHierarchyMutationResponse = {
  __typename?: 'company_hierarchy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyHierarchy>;
};

/** on_conflict condition type for table "company_hierarchy" */
export type CompanyHierarchyOnConflict = {
  constraint: CompanyHierarchyConstraint;
  update_columns?: Array<CompanyHierarchyUpdateColumn>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};

/** Ordering options when selecting data from "company_hierarchy". */
export type CompanyHierarchyOrderBy = {
  chain_id?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_hierarchy */
export type CompanyHierarchyPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "company_hierarchy" */
export enum CompanyHierarchySelectColumn {
  /** column name */
  ChainId = 'chain_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company_hierarchy" */
export type CompanyHierarchySetInput = {
  chain_id?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CompanyHierarchyStddevFields = {
  __typename?: 'company_hierarchy_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_hierarchy" */
export type CompanyHierarchyStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CompanyHierarchyStddevPopFields = {
  __typename?: 'company_hierarchy_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company_hierarchy" */
export type CompanyHierarchyStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CompanyHierarchyStddevSampFields = {
  __typename?: 'company_hierarchy_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company_hierarchy" */
export type CompanyHierarchyStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "company_hierarchy" */
export type CompanyHierarchyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyHierarchyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyHierarchyStreamCursorValueInput = {
  chain_id?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CompanyHierarchySumFields = {
  __typename?: 'company_hierarchy_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "company_hierarchy" */
export type CompanyHierarchySumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "company_hierarchy" */
export enum CompanyHierarchyUpdateColumn {
  /** column name */
  ChainId = 'chain_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CompanyHierarchyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyHierarchyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyHierarchySetInput>;
  /** filter the rows which have to be updated */
  where: CompanyHierarchyBoolExp;
};

/** aggregate var_pop on columns */
export type CompanyHierarchyVarPopFields = {
  __typename?: 'company_hierarchy_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company_hierarchy" */
export type CompanyHierarchyVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CompanyHierarchyVarSampFields = {
  __typename?: 'company_hierarchy_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company_hierarchy" */
export type CompanyHierarchyVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompanyHierarchyVarianceFields = {
  __typename?: 'company_hierarchy_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_hierarchy" */
export type CompanyHierarchyVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** input type for inserting data into table "company" */
export type CompanyInsertInput = {
  address?: InputMaybe<Scalars['String']>;
  chain?: InputMaybe<ChainObjRelInsertInput>;
  chain_id?: InputMaybe<Scalars['String']>;
  company_hierarchy?: InputMaybe<CompanyHierarchyArrRelInsertInput>;
  company_lot_sections?: InputMaybe<CompanyLotSectionArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  lot_hierarchies?: InputMaybe<LotHierarchyArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelists?: InputMaybe<WhitelistArrRelInsertInput>;
};

/** columns and relationships of "company_lot_section" */
export type CompanyLotSection = {
  __typename?: 'company_lot_section';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  lot_section: LotSection;
  lot_section_id: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_limit?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "company_lot_section" */
export type CompanyLotSectionAggregate = {
  __typename?: 'company_lot_section_aggregate';
  aggregate?: Maybe<CompanyLotSectionAggregateFields>;
  nodes: Array<CompanyLotSection>;
};

export type CompanyLotSectionAggregateBoolExp = {
  count?: InputMaybe<CompanyLotSectionAggregateBoolExpCount>;
};

export type CompanyLotSectionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyLotSectionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "company_lot_section" */
export type CompanyLotSectionAggregateFields = {
  __typename?: 'company_lot_section_aggregate_fields';
  avg?: Maybe<CompanyLotSectionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyLotSectionMaxFields>;
  min?: Maybe<CompanyLotSectionMinFields>;
  stddev?: Maybe<CompanyLotSectionStddevFields>;
  stddev_pop?: Maybe<CompanyLotSectionStddevPopFields>;
  stddev_samp?: Maybe<CompanyLotSectionStddevSampFields>;
  sum?: Maybe<CompanyLotSectionSumFields>;
  var_pop?: Maybe<CompanyLotSectionVarPopFields>;
  var_samp?: Maybe<CompanyLotSectionVarSampFields>;
  variance?: Maybe<CompanyLotSectionVarianceFields>;
};


/** aggregate fields of "company_lot_section" */
export type CompanyLotSectionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_lot_section" */
export type CompanyLotSectionAggregateOrderBy = {
  avg?: InputMaybe<CompanyLotSectionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyLotSectionMaxOrderBy>;
  min?: InputMaybe<CompanyLotSectionMinOrderBy>;
  stddev?: InputMaybe<CompanyLotSectionStddevOrderBy>;
  stddev_pop?: InputMaybe<CompanyLotSectionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CompanyLotSectionStddevSampOrderBy>;
  sum?: InputMaybe<CompanyLotSectionSumOrderBy>;
  var_pop?: InputMaybe<CompanyLotSectionVarPopOrderBy>;
  var_samp?: InputMaybe<CompanyLotSectionVarSampOrderBy>;
  variance?: InputMaybe<CompanyLotSectionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "company_lot_section" */
export type CompanyLotSectionArrRelInsertInput = {
  data: Array<CompanyLotSectionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyLotSectionOnConflict>;
};

/** aggregate avg on columns */
export type CompanyLotSectionAvgFields = {
  __typename?: 'company_lot_section_avg_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_lot_section" */
export type CompanyLotSectionAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "company_lot_section". All fields are combined with a logical 'AND'. */
export type CompanyLotSectionBoolExp = {
  _and?: InputMaybe<Array<CompanyLotSectionBoolExp>>;
  _not?: InputMaybe<CompanyLotSectionBoolExp>;
  _or?: InputMaybe<Array<CompanyLotSectionBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_section?: InputMaybe<LotSectionBoolExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelist_limit?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "company_lot_section" */
export enum CompanyLotSectionConstraint {
  /** unique or primary key constraint on columns "lot_section_id", "company_id" */
  CompanyLotSectionCompanyIdLotSectionIdKey = 'company_lot_section_company_id_lot_section_id_key',
  /** unique or primary key constraint on columns "id" */
  CompanyLotSectionPkey = 'company_lot_section_pkey'
}

/** input type for incrementing numeric columns in table "company_lot_section" */
export type CompanyLotSectionIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  whitelist_limit?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_lot_section" */
export type CompanyLotSectionInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section?: InputMaybe<LotSectionObjRelInsertInput>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_limit?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CompanyLotSectionMaxFields = {
  __typename?: 'company_lot_section_max_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_limit?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "company_lot_section" */
export type CompanyLotSectionMaxOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyLotSectionMinFields = {
  __typename?: 'company_lot_section_min_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_limit?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "company_lot_section" */
export type CompanyLotSectionMinOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_lot_section" */
export type CompanyLotSectionMutationResponse = {
  __typename?: 'company_lot_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyLotSection>;
};

/** on_conflict condition type for table "company_lot_section" */
export type CompanyLotSectionOnConflict = {
  constraint: CompanyLotSectionConstraint;
  update_columns?: Array<CompanyLotSectionUpdateColumn>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};

/** Ordering options when selecting data from "company_lot_section". */
export type CompanyLotSectionOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section?: InputMaybe<LotSectionOrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_lot_section */
export type CompanyLotSectionPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "company_lot_section" */
export enum CompanyLotSectionSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistLimit = 'whitelist_limit'
}

/** input type for updating data in table "company_lot_section" */
export type CompanyLotSectionSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_limit?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CompanyLotSectionStddevFields = {
  __typename?: 'company_lot_section_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_lot_section" */
export type CompanyLotSectionStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CompanyLotSectionStddevPopFields = {
  __typename?: 'company_lot_section_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company_lot_section" */
export type CompanyLotSectionStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CompanyLotSectionStddevSampFields = {
  __typename?: 'company_lot_section_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company_lot_section" */
export type CompanyLotSectionStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "company_lot_section" */
export type CompanyLotSectionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyLotSectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyLotSectionStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_limit?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CompanyLotSectionSumFields = {
  __typename?: 'company_lot_section_sum_fields';
  id?: Maybe<Scalars['Int']>;
  whitelist_limit?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company_lot_section" */
export type CompanyLotSectionSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** update columns of table "company_lot_section" */
export enum CompanyLotSectionUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistLimit = 'whitelist_limit'
}

export type CompanyLotSectionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyLotSectionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyLotSectionSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyLotSectionBoolExp;
};

/** aggregate var_pop on columns */
export type CompanyLotSectionVarPopFields = {
  __typename?: 'company_lot_section_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company_lot_section" */
export type CompanyLotSectionVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CompanyLotSectionVarSampFields = {
  __typename?: 'company_lot_section_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company_lot_section" */
export type CompanyLotSectionVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompanyLotSectionVarianceFields = {
  __typename?: 'company_lot_section_variance_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_lot_section" */
export type CompanyLotSectionVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_limit?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type CompanyMaxFields = {
  __typename?: 'company_max_fields';
  address?: Maybe<Scalars['String']>;
  chain_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company" */
export type CompanyMaxOrderBy = {
  address?: InputMaybe<OrderBy>;
  chain_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyMinFields = {
  __typename?: 'company_min_fields';
  address?: Maybe<Scalars['String']>;
  chain_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company" */
export type CompanyMinOrderBy = {
  address?: InputMaybe<OrderBy>;
  chain_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company" */
export type CompanyMutationResponse = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type CompanyObjRelInsertInput = {
  data: CompanyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyOnConflict>;
};

/** on_conflict condition type for table "company" */
export type CompanyOnConflict = {
  constraint: CompanyConstraint;
  update_columns?: Array<CompanyUpdateColumn>;
  where?: InputMaybe<CompanyBoolExp>;
};

/** Ordering options when selecting data from "company". */
export type CompanyOrderBy = {
  address?: InputMaybe<OrderBy>;
  chain?: InputMaybe<ChainOrderBy>;
  chain_id?: InputMaybe<OrderBy>;
  company_hierarchy_aggregate?: InputMaybe<CompanyHierarchyAggregateOrderBy>;
  company_lot_sections_aggregate?: InputMaybe<CompanyLotSectionAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_hierarchies_aggregate?: InputMaybe<LotHierarchyAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelists_aggregate?: InputMaybe<WhitelistAggregateOrderBy>;
};

/** primary key columns input for table: company */
export type CompanyPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "company" */
export enum CompanySelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  ChainId = 'chain_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company" */
export type CompanySetInput = {
  address?: InputMaybe<Scalars['String']>;
  chain_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company" */
export type CompanyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']>;
  chain_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company" */
export enum CompanyUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  ChainId = 'chain_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CompanyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanySetInput>;
  /** filter the rows which have to be updated */
  where: CompanyBoolExp;
};

/** columns and relationships of "company_vat_id" */
export type CompanyVatId = {
  __typename?: 'company_vat_id';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  vat_id: Scalars['String'];
};

/** aggregated selection of "company_vat_id" */
export type CompanyVatIdAggregate = {
  __typename?: 'company_vat_id_aggregate';
  aggregate?: Maybe<CompanyVatIdAggregateFields>;
  nodes: Array<CompanyVatId>;
};

/** aggregate fields of "company_vat_id" */
export type CompanyVatIdAggregateFields = {
  __typename?: 'company_vat_id_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CompanyVatIdMaxFields>;
  min?: Maybe<CompanyVatIdMinFields>;
};


/** aggregate fields of "company_vat_id" */
export type CompanyVatIdAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyVatIdSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_vat_id". All fields are combined with a logical 'AND'. */
export type CompanyVatIdBoolExp = {
  _and?: InputMaybe<Array<CompanyVatIdBoolExp>>;
  _not?: InputMaybe<CompanyVatIdBoolExp>;
  _or?: InputMaybe<Array<CompanyVatIdBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  vat_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "company_vat_id" */
export enum CompanyVatIdConstraint {
  /** unique or primary key constraint on columns "company_id" */
  CompanyVatIdPkey = 'company_vat_id_pkey',
  /** unique or primary key constraint on columns "vat_id" */
  CompanyVatIdVatIdKey = 'company_vat_id_vat_id_key'
}

/** input type for inserting data into table "company_vat_id" */
export type CompanyVatIdInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  vat_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompanyVatIdMaxFields = {
  __typename?: 'company_vat_id_max_fields';
  company_id?: Maybe<Scalars['String']>;
  vat_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompanyVatIdMinFields = {
  __typename?: 'company_vat_id_min_fields';
  company_id?: Maybe<Scalars['String']>;
  vat_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_vat_id" */
export type CompanyVatIdMutationResponse = {
  __typename?: 'company_vat_id_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyVatId>;
};

/** input type for inserting object relation for remote table "company_vat_id" */
export type CompanyVatIdObjRelInsertInput = {
  data: CompanyVatIdInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyVatIdOnConflict>;
};

/** on_conflict condition type for table "company_vat_id" */
export type CompanyVatIdOnConflict = {
  constraint: CompanyVatIdConstraint;
  update_columns?: Array<CompanyVatIdUpdateColumn>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};

/** Ordering options when selecting data from "company_vat_id". */
export type CompanyVatIdOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  vat_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_vat_id */
export type CompanyVatIdPkColumnsInput = {
  company_id: Scalars['String'];
};

/** select columns of table "company_vat_id" */
export enum CompanyVatIdSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  VatId = 'vat_id'
}

/** input type for updating data in table "company_vat_id" */
export type CompanyVatIdSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  vat_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "company_vat_id" */
export type CompanyVatIdStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyVatIdStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyVatIdStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  vat_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "company_vat_id" */
export enum CompanyVatIdUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  VatId = 'vat_id'
}

export type CompanyVatIdUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyVatIdSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyVatIdBoolExp;
};

/** columns and relationships of "company_violator" */
export type CompanyViolator = {
  __typename?: 'company_violator';
  /** An object relationship */
  car_owner?: Maybe<CarOwner>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  data_source?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "company_violator" */
export type CompanyViolatorAggregate = {
  __typename?: 'company_violator_aggregate';
  aggregate?: Maybe<CompanyViolatorAggregateFields>;
  nodes: Array<CompanyViolator>;
};

/** aggregate fields of "company_violator" */
export type CompanyViolatorAggregateFields = {
  __typename?: 'company_violator_aggregate_fields';
  avg?: Maybe<CompanyViolatorAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyViolatorMaxFields>;
  min?: Maybe<CompanyViolatorMinFields>;
  stddev?: Maybe<CompanyViolatorStddevFields>;
  stddev_pop?: Maybe<CompanyViolatorStddevPopFields>;
  stddev_samp?: Maybe<CompanyViolatorStddevSampFields>;
  sum?: Maybe<CompanyViolatorSumFields>;
  var_pop?: Maybe<CompanyViolatorVarPopFields>;
  var_samp?: Maybe<CompanyViolatorVarSampFields>;
  variance?: Maybe<CompanyViolatorVarianceFields>;
};


/** aggregate fields of "company_violator" */
export type CompanyViolatorAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyViolatorSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyViolatorAvgFields = {
  __typename?: 'company_violator_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_violator". All fields are combined with a logical 'AND'. */
export type CompanyViolatorBoolExp = {
  _and?: InputMaybe<Array<CompanyViolatorBoolExp>>;
  _not?: InputMaybe<CompanyViolatorBoolExp>;
  _or?: InputMaybe<Array<CompanyViolatorBoolExp>>;
  car_owner?: InputMaybe<CarOwnerBoolExp>;
  city?: InputMaybe<StringComparisonExp>;
  company_name?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  data_source?: InputMaybe<StringComparisonExp>;
  house_number?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  postal_code?: InputMaybe<StringComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_violator" */
export enum CompanyViolatorConstraint {
  /** unique or primary key constraint on columns "id" */
  CompanyViolatorPkey = 'company_violator_pkey'
}

/** input type for incrementing numeric columns in table "company_violator" */
export type CompanyViolatorIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_violator" */
export type CompanyViolatorInsertInput = {
  car_owner?: InputMaybe<CarOwnerObjRelInsertInput>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyViolatorMaxFields = {
  __typename?: 'company_violator_max_fields';
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_source?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CompanyViolatorMinFields = {
  __typename?: 'company_violator_min_fields';
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_source?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_violator" */
export type CompanyViolatorMutationResponse = {
  __typename?: 'company_violator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyViolator>;
};

/** input type for inserting object relation for remote table "company_violator" */
export type CompanyViolatorObjRelInsertInput = {
  data: CompanyViolatorInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyViolatorOnConflict>;
};

/** on_conflict condition type for table "company_violator" */
export type CompanyViolatorOnConflict = {
  constraint: CompanyViolatorConstraint;
  update_columns?: Array<CompanyViolatorUpdateColumn>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};

/** Ordering options when selecting data from "company_violator". */
export type CompanyViolatorOrderBy = {
  car_owner?: InputMaybe<CarOwnerOrderBy>;
  city?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  data_source?: InputMaybe<OrderBy>;
  house_number?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  postal_code?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_violator */
export type CompanyViolatorPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "company_violator" */
export enum CompanyViolatorSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company_violator" */
export type CompanyViolatorSetInput = {
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CompanyViolatorStddevFields = {
  __typename?: 'company_violator_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CompanyViolatorStddevPopFields = {
  __typename?: 'company_violator_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CompanyViolatorStddevSampFields = {
  __typename?: 'company_violator_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_violator" */
export type CompanyViolatorStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompanyViolatorStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyViolatorStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CompanyViolatorSumFields = {
  __typename?: 'company_violator_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "company_violator" */
export enum CompanyViolatorUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CompanyViolatorUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyViolatorIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyViolatorSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyViolatorBoolExp;
};

/** aggregate var_pop on columns */
export type CompanyViolatorVarPopFields = {
  __typename?: 'company_violator_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CompanyViolatorVarSampFields = {
  __typename?: 'company_violator_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyViolatorVarianceFields = {
  __typename?: 'company_violator_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "config_group" */
export type ConfigGroup = {
  __typename?: 'config_group';
  company_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  end: Scalars['timestamptz'];
  id: Scalars['bigint'];
  start: Scalars['timestamptz'];
};

/** aggregated selection of "config_group" */
export type ConfigGroupAggregate = {
  __typename?: 'config_group_aggregate';
  aggregate?: Maybe<ConfigGroupAggregateFields>;
  nodes: Array<ConfigGroup>;
};

/** aggregate fields of "config_group" */
export type ConfigGroupAggregateFields = {
  __typename?: 'config_group_aggregate_fields';
  avg?: Maybe<ConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ConfigGroupMaxFields>;
  min?: Maybe<ConfigGroupMinFields>;
  stddev?: Maybe<ConfigGroupStddevFields>;
  stddev_pop?: Maybe<ConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<ConfigGroupStddevSampFields>;
  sum?: Maybe<ConfigGroupSumFields>;
  var_pop?: Maybe<ConfigGroupVarPopFields>;
  var_samp?: Maybe<ConfigGroupVarSampFields>;
  variance?: Maybe<ConfigGroupVarianceFields>;
};


/** aggregate fields of "config_group" */
export type ConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ConfigGroupAvgFields = {
  __typename?: 'config_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "config_group". All fields are combined with a logical 'AND'. */
export type ConfigGroupBoolExp = {
  _and?: InputMaybe<Array<ConfigGroupBoolExp>>;
  _not?: InputMaybe<ConfigGroupBoolExp>;
  _or?: InputMaybe<Array<ConfigGroupBoolExp>>;
  company_id?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "config_group" */
export enum ConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  ConfigGroupPkey = 'config_group_pkey'
}

/** input type for incrementing numeric columns in table "config_group" */
export type ConfigGroupIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "config_group" */
export type ConfigGroupInsertInput = {
  company_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ConfigGroupMaxFields = {
  __typename?: 'config_group_max_fields';
  company_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  start?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ConfigGroupMinFields = {
  __typename?: 'config_group_min_fields';
  company_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  start?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "config_group" */
export type ConfigGroupMutationResponse = {
  __typename?: 'config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigGroup>;
};

/** on_conflict condition type for table "config_group" */
export type ConfigGroupOnConflict = {
  constraint: ConfigGroupConstraint;
  update_columns?: Array<ConfigGroupUpdateColumn>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "config_group". */
export type ConfigGroupOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: config_group */
export type ConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "config_group" */
export enum ConfigGroupSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Start = 'start'
}

/** input type for updating data in table "config_group" */
export type ConfigGroupSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ConfigGroupStddevFields = {
  __typename?: 'config_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ConfigGroupStddevPopFields = {
  __typename?: 'config_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ConfigGroupStddevSampFields = {
  __typename?: 'config_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "config_group" */
export type ConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigGroupStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ConfigGroupSumFields = {
  __typename?: 'config_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "config_group" */
export enum ConfigGroupUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Start = 'start'
}

export type ConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: ConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type ConfigGroupVarPopFields = {
  __typename?: 'config_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ConfigGroupVarSampFields = {
  __typename?: 'config_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ConfigGroupVarianceFields = {
  __typename?: 'config_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Versioned list of countries with ISO 3166 codes and currency information */
export type Country = {
  __typename?: 'country';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_uuid: Scalars['Int'];
  id: Scalars['Int'];
  iso_alpha_2: EnumCountryCodeEnum;
  iso_alpha_3: Scalars['String'];
  iso_numeric: Scalars['Int'];
  /** An array relationship */
  lots: Array<Lot>;
  /** An aggregate relationship */
  lots_aggregate: LotAggregate;
  name: Scalars['String'];
  uuid: Scalars['Int'];
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
};


/** Versioned list of countries with ISO 3166 codes and currency information */
export type CountryLotsArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};


/** Versioned list of countries with ISO 3166 codes and currency information */
export type CountryLotsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};

/** aggregated selection of "country" */
export type CountryAggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<CountryAggregateFields>;
  nodes: Array<Country>;
};

export type CountryAggregateBoolExp = {
  count?: InputMaybe<CountryAggregateBoolExpCount>;
};

export type CountryAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CountrySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CountryBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "country" */
export type CountryAggregateFields = {
  __typename?: 'country_aggregate_fields';
  avg?: Maybe<CountryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountryMaxFields>;
  min?: Maybe<CountryMinFields>;
  stddev?: Maybe<CountryStddevFields>;
  stddev_pop?: Maybe<CountryStddevPopFields>;
  stddev_samp?: Maybe<CountryStddevSampFields>;
  sum?: Maybe<CountrySumFields>;
  var_pop?: Maybe<CountryVarPopFields>;
  var_samp?: Maybe<CountryVarSampFields>;
  variance?: Maybe<CountryVarianceFields>;
};


/** aggregate fields of "country" */
export type CountryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountrySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "country" */
export type CountryAggregateOrderBy = {
  avg?: InputMaybe<CountryAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CountryMaxOrderBy>;
  min?: InputMaybe<CountryMinOrderBy>;
  stddev?: InputMaybe<CountryStddevOrderBy>;
  stddev_pop?: InputMaybe<CountryStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CountryStddevSampOrderBy>;
  sum?: InputMaybe<CountrySumOrderBy>;
  var_pop?: InputMaybe<CountryVarPopOrderBy>;
  var_samp?: InputMaybe<CountryVarSampOrderBy>;
  variance?: InputMaybe<CountryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "country" */
export type CountryArrRelInsertInput = {
  data: Array<CountryInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CountryOnConflict>;
};

/** aggregate avg on columns */
export type CountryAvgFields = {
  __typename?: 'country_avg_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "country" */
export type CountryAvgOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type CountryBoolExp = {
  _and?: InputMaybe<Array<CountryBoolExp>>;
  _not?: InputMaybe<CountryBoolExp>;
  _or?: InputMaybe<Array<CountryBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_uuid?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  iso_alpha_2?: InputMaybe<EnumCountryCodeEnumComparisonExp>;
  iso_alpha_3?: InputMaybe<StringComparisonExp>;
  iso_numeric?: InputMaybe<IntComparisonExp>;
  lots?: InputMaybe<LotBoolExp>;
  lots_aggregate?: InputMaybe<LotAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "country" */
export enum CountryConstraint {
  /** unique or primary key constraint on columns "uuid" */
  CountryPkey = 'country_pkey'
}

/** input type for incrementing numeric columns in table "country" */
export type CountryIncInput = {
  currency_uuid?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_numeric?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "country" */
export type CountryInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_uuid?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_alpha_2?: InputMaybe<EnumCountryCodeEnum>;
  iso_alpha_3?: InputMaybe<Scalars['String']>;
  iso_numeric?: InputMaybe<Scalars['Int']>;
  lots?: InputMaybe<LotArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CountryMaxFields = {
  __typename?: 'country_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_uuid?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  iso_alpha_3?: Maybe<Scalars['String']>;
  iso_numeric?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "country" */
export type CountryMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_alpha_3?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CountryMinFields = {
  __typename?: 'country_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_uuid?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  iso_alpha_3?: Maybe<Scalars['String']>;
  iso_numeric?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "country" */
export type CountryMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_alpha_3?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "country" */
export type CountryMutationResponse = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type CountryObjRelInsertInput = {
  data: CountryInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CountryOnConflict>;
};

/** on_conflict condition type for table "country" */
export type CountryOnConflict = {
  constraint: CountryConstraint;
  update_columns?: Array<CountryUpdateColumn>;
  where?: InputMaybe<CountryBoolExp>;
};

/** Ordering options when selecting data from "country". */
export type CountryOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_alpha_2?: InputMaybe<OrderBy>;
  iso_alpha_3?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  lots_aggregate?: InputMaybe<LotAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country */
export type CountryPkColumnsInput = {
  uuid: Scalars['Int'];
};

/** select columns of table "country" */
export enum CountrySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyUuid = 'currency_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  IsoAlpha_2 = 'iso_alpha_2',
  /** column name */
  IsoAlpha_3 = 'iso_alpha_3',
  /** column name */
  IsoNumeric = 'iso_numeric',
  /** column name */
  Name = 'name',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "country" */
export type CountrySetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_uuid?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_alpha_2?: InputMaybe<EnumCountryCodeEnum>;
  iso_alpha_3?: InputMaybe<Scalars['String']>;
  iso_numeric?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CountryStddevFields = {
  __typename?: 'country_stddev_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "country" */
export type CountryStddevOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CountryStddevPopFields = {
  __typename?: 'country_stddev_pop_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "country" */
export type CountryStddevPopOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CountryStddevSampFields = {
  __typename?: 'country_stddev_samp_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "country" */
export type CountryStddevSampOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "country" */
export type CountryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CountryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountryStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_uuid?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_alpha_2?: InputMaybe<EnumCountryCodeEnum>;
  iso_alpha_3?: InputMaybe<Scalars['String']>;
  iso_numeric?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CountrySumFields = {
  __typename?: 'country_sum_fields';
  currency_uuid?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  iso_numeric?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "country" */
export type CountrySumOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** update columns of table "country" */
export enum CountryUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyUuid = 'currency_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  IsoAlpha_2 = 'iso_alpha_2',
  /** column name */
  IsoAlpha_3 = 'iso_alpha_3',
  /** column name */
  IsoNumeric = 'iso_numeric',
  /** column name */
  Name = 'name',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type CountryUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CountryIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountrySetInput>;
  /** filter the rows which have to be updated */
  where: CountryBoolExp;
};

/** aggregate var_pop on columns */
export type CountryVarPopFields = {
  __typename?: 'country_var_pop_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "country" */
export type CountryVarPopOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CountryVarSampFields = {
  __typename?: 'country_var_samp_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "country" */
export type CountryVarSampOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CountryVarianceFields = {
  __typename?: 'country_variance_fields';
  currency_uuid?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  iso_numeric?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "country" */
export type CountryVarianceOrderBy = {
  currency_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso_numeric?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** fields of action: "create_driver_information_request" */
export type CreateDriverInformationRequest = {
  __typename?: 'create_driver_information_request';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<CreateDriverInformationRequestOutput>;
};

/** list of currency codes */
export type Currency = {
  __typename?: 'currency';
  /** An array relationship */
  countries: Array<Country>;
  /** An aggregate relationship */
  countries_aggregate: CountryAggregate;
  created_at: Scalars['timestamptz'];
  iso_code: Scalars['String'];
  iso_num: Scalars['Int'];
  name: Scalars['String'];
  uuid: Scalars['Int'];
};


/** list of currency codes */
export type CurrencyCountriesArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


/** list of currency codes */
export type CurrencyCountriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};

/** aggregated selection of "currency" */
export type CurrencyAggregate = {
  __typename?: 'currency_aggregate';
  aggregate?: Maybe<CurrencyAggregateFields>;
  nodes: Array<Currency>;
};

/** aggregate fields of "currency" */
export type CurrencyAggregateFields = {
  __typename?: 'currency_aggregate_fields';
  avg?: Maybe<CurrencyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CurrencyMaxFields>;
  min?: Maybe<CurrencyMinFields>;
  stddev?: Maybe<CurrencyStddevFields>;
  stddev_pop?: Maybe<CurrencyStddevPopFields>;
  stddev_samp?: Maybe<CurrencyStddevSampFields>;
  sum?: Maybe<CurrencySumFields>;
  var_pop?: Maybe<CurrencyVarPopFields>;
  var_samp?: Maybe<CurrencyVarSampFields>;
  variance?: Maybe<CurrencyVarianceFields>;
};


/** aggregate fields of "currency" */
export type CurrencyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CurrencySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CurrencyAvgFields = {
  __typename?: 'currency_avg_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "currency". All fields are combined with a logical 'AND'. */
export type CurrencyBoolExp = {
  _and?: InputMaybe<Array<CurrencyBoolExp>>;
  _not?: InputMaybe<CurrencyBoolExp>;
  _or?: InputMaybe<Array<CurrencyBoolExp>>;
  countries?: InputMaybe<CountryBoolExp>;
  countries_aggregate?: InputMaybe<CountryAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  iso_code?: InputMaybe<StringComparisonExp>;
  iso_num?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "currency" */
export enum CurrencyConstraint {
  /** unique or primary key constraint on columns "iso_code" */
  CurrencyIsoCodeKey = 'currency_iso_code_key',
  /** unique or primary key constraint on columns "iso_num" */
  CurrencyIsoNumKey = 'currency_iso_num_key',
  /** unique or primary key constraint on columns "uuid" */
  CurrencyPkey = 'currency_pkey'
}

/** input type for incrementing numeric columns in table "currency" */
export type CurrencyIncInput = {
  iso_num?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "currency" */
export type CurrencyInsertInput = {
  countries?: InputMaybe<CountryArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  iso_code?: InputMaybe<Scalars['String']>;
  iso_num?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CurrencyMaxFields = {
  __typename?: 'currency_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  iso_code?: Maybe<Scalars['String']>;
  iso_num?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CurrencyMinFields = {
  __typename?: 'currency_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  iso_code?: Maybe<Scalars['String']>;
  iso_num?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "currency" */
export type CurrencyMutationResponse = {
  __typename?: 'currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency>;
};

/** input type for inserting object relation for remote table "currency" */
export type CurrencyObjRelInsertInput = {
  data: CurrencyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};

/** on_conflict condition type for table "currency" */
export type CurrencyOnConflict = {
  constraint: CurrencyConstraint;
  update_columns?: Array<CurrencyUpdateColumn>;
  where?: InputMaybe<CurrencyBoolExp>;
};

/** Ordering options when selecting data from "currency". */
export type CurrencyOrderBy = {
  countries_aggregate?: InputMaybe<CountryAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  iso_code?: InputMaybe<OrderBy>;
  iso_num?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: currency */
export type CurrencyPkColumnsInput = {
  uuid: Scalars['Int'];
};

/** select columns of table "currency" */
export enum CurrencySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  IsoNum = 'iso_num',
  /** column name */
  Name = 'name',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "currency" */
export type CurrencySetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  iso_code?: InputMaybe<Scalars['String']>;
  iso_num?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CurrencyStddevFields = {
  __typename?: 'currency_stddev_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CurrencyStddevPopFields = {
  __typename?: 'currency_stddev_pop_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CurrencyStddevSampFields = {
  __typename?: 'currency_stddev_samp_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "currency" */
export type CurrencyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CurrencyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrencyStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  iso_code?: InputMaybe<Scalars['String']>;
  iso_num?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CurrencySumFields = {
  __typename?: 'currency_sum_fields';
  iso_num?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

/** update columns of table "currency" */
export enum CurrencyUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  IsoNum = 'iso_num',
  /** column name */
  Name = 'name',
  /** column name */
  Uuid = 'uuid'
}

export type CurrencyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CurrencyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CurrencySetInput>;
  /** filter the rows which have to be updated */
  where: CurrencyBoolExp;
};

/** aggregate var_pop on columns */
export type CurrencyVarPopFields = {
  __typename?: 'currency_var_pop_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CurrencyVarSampFields = {
  __typename?: 'currency_var_samp_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CurrencyVarianceFields = {
  __typename?: 'currency_variance_fields';
  iso_num?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** This table tracks the customer feedback via the net promoter score (NPS). */
export type CustomerDashboardNpsFeedback = {
  __typename?: 'customer_dashboard_nps_feedback';
  created_at: Scalars['timestamptz'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  net_promoter_score: Scalars['Int'];
  updated_at: Scalars['timestamp'];
  user_id: Scalars['String'];
};

/** aggregated selection of "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackAggregate = {
  __typename?: 'customer_dashboard_nps_feedback_aggregate';
  aggregate?: Maybe<CustomerDashboardNpsFeedbackAggregateFields>;
  nodes: Array<CustomerDashboardNpsFeedback>;
};

/** aggregate fields of "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackAggregateFields = {
  __typename?: 'customer_dashboard_nps_feedback_aggregate_fields';
  avg?: Maybe<CustomerDashboardNpsFeedbackAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CustomerDashboardNpsFeedbackMaxFields>;
  min?: Maybe<CustomerDashboardNpsFeedbackMinFields>;
  stddev?: Maybe<CustomerDashboardNpsFeedbackStddevFields>;
  stddev_pop?: Maybe<CustomerDashboardNpsFeedbackStddevPopFields>;
  stddev_samp?: Maybe<CustomerDashboardNpsFeedbackStddevSampFields>;
  sum?: Maybe<CustomerDashboardNpsFeedbackSumFields>;
  var_pop?: Maybe<CustomerDashboardNpsFeedbackVarPopFields>;
  var_samp?: Maybe<CustomerDashboardNpsFeedbackVarSampFields>;
  variance?: Maybe<CustomerDashboardNpsFeedbackVarianceFields>;
};


/** aggregate fields of "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CustomerDashboardNpsFeedbackSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CustomerDashboardNpsFeedbackAvgFields = {
  __typename?: 'customer_dashboard_nps_feedback_avg_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "customer_dashboard_nps_feedback". All fields are combined with a logical 'AND'. */
export type CustomerDashboardNpsFeedbackBoolExp = {
  _and?: InputMaybe<Array<CustomerDashboardNpsFeedbackBoolExp>>;
  _not?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
  _or?: InputMaybe<Array<CustomerDashboardNpsFeedbackBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  feedback?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  net_promoter_score?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestampComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "customer_dashboard_nps_feedback" */
export enum CustomerDashboardNpsFeedbackConstraint {
  /** unique or primary key constraint on columns "id" */
  CustomerDashboardNpsFeedbackPkey = 'customer_dashboard_nps_feedback_pkey'
}

/** input type for incrementing numeric columns in table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  net_promoter_score?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  net_promoter_score?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CustomerDashboardNpsFeedbackMaxFields = {
  __typename?: 'customer_dashboard_nps_feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  net_promoter_score?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CustomerDashboardNpsFeedbackMinFields = {
  __typename?: 'customer_dashboard_nps_feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  net_promoter_score?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackMutationResponse = {
  __typename?: 'customer_dashboard_nps_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomerDashboardNpsFeedback>;
};

/** on_conflict condition type for table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackOnConflict = {
  constraint: CustomerDashboardNpsFeedbackConstraint;
  update_columns?: Array<CustomerDashboardNpsFeedbackUpdateColumn>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};

/** Ordering options when selecting data from "customer_dashboard_nps_feedback". */
export type CustomerDashboardNpsFeedbackOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  feedback?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  net_promoter_score?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: customer_dashboard_nps_feedback */
export type CustomerDashboardNpsFeedbackPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "customer_dashboard_nps_feedback" */
export enum CustomerDashboardNpsFeedbackSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  NetPromoterScore = 'net_promoter_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  net_promoter_score?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CustomerDashboardNpsFeedbackStddevFields = {
  __typename?: 'customer_dashboard_nps_feedback_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CustomerDashboardNpsFeedbackStddevPopFields = {
  __typename?: 'customer_dashboard_nps_feedback_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CustomerDashboardNpsFeedbackStddevSampFields = {
  __typename?: 'customer_dashboard_nps_feedback_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customer_dashboard_nps_feedback" */
export type CustomerDashboardNpsFeedbackStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CustomerDashboardNpsFeedbackStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomerDashboardNpsFeedbackStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  net_promoter_score?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CustomerDashboardNpsFeedbackSumFields = {
  __typename?: 'customer_dashboard_nps_feedback_sum_fields';
  id?: Maybe<Scalars['Int']>;
  net_promoter_score?: Maybe<Scalars['Int']>;
};

/** update columns of table "customer_dashboard_nps_feedback" */
export enum CustomerDashboardNpsFeedbackUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  NetPromoterScore = 'net_promoter_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type CustomerDashboardNpsFeedbackUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomerDashboardNpsFeedbackIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomerDashboardNpsFeedbackSetInput>;
  /** filter the rows which have to be updated */
  where: CustomerDashboardNpsFeedbackBoolExp;
};

/** aggregate var_pop on columns */
export type CustomerDashboardNpsFeedbackVarPopFields = {
  __typename?: 'customer_dashboard_nps_feedback_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CustomerDashboardNpsFeedbackVarSampFields = {
  __typename?: 'customer_dashboard_nps_feedback_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CustomerDashboardNpsFeedbackVarianceFields = {
  __typename?: 'customer_dashboard_nps_feedback_variance_fields';
  id?: Maybe<Scalars['Float']>;
  net_promoter_score?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "daily_failure" */
export type DailyFailure = {
  __typename?: 'daily_failure';
  created_at: Scalars['timestamptz'];
  day: Scalars['date'];
  id: Scalars['Int'];
  /** An object relationship */
  lot_section: LotSection;
  lot_section_id: Scalars['String'];
};

/** aggregated selection of "daily_failure" */
export type DailyFailureAggregate = {
  __typename?: 'daily_failure_aggregate';
  aggregate?: Maybe<DailyFailureAggregateFields>;
  nodes: Array<DailyFailure>;
};

export type DailyFailureAggregateBoolExp = {
  count?: InputMaybe<DailyFailureAggregateBoolExpCount>;
};

export type DailyFailureAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DailyFailureSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyFailureBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "daily_failure" */
export type DailyFailureAggregateFields = {
  __typename?: 'daily_failure_aggregate_fields';
  avg?: Maybe<DailyFailureAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DailyFailureMaxFields>;
  min?: Maybe<DailyFailureMinFields>;
  stddev?: Maybe<DailyFailureStddevFields>;
  stddev_pop?: Maybe<DailyFailureStddevPopFields>;
  stddev_samp?: Maybe<DailyFailureStddevSampFields>;
  sum?: Maybe<DailyFailureSumFields>;
  var_pop?: Maybe<DailyFailureVarPopFields>;
  var_samp?: Maybe<DailyFailureVarSampFields>;
  variance?: Maybe<DailyFailureVarianceFields>;
};


/** aggregate fields of "daily_failure" */
export type DailyFailureAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DailyFailureSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daily_failure" */
export type DailyFailureAggregateOrderBy = {
  avg?: InputMaybe<DailyFailureAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DailyFailureMaxOrderBy>;
  min?: InputMaybe<DailyFailureMinOrderBy>;
  stddev?: InputMaybe<DailyFailureStddevOrderBy>;
  stddev_pop?: InputMaybe<DailyFailureStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DailyFailureStddevSampOrderBy>;
  sum?: InputMaybe<DailyFailureSumOrderBy>;
  var_pop?: InputMaybe<DailyFailureVarPopOrderBy>;
  var_samp?: InputMaybe<DailyFailureVarSampOrderBy>;
  variance?: InputMaybe<DailyFailureVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "daily_failure" */
export type DailyFailureArrRelInsertInput = {
  data: Array<DailyFailureInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DailyFailureOnConflict>;
};

/** aggregate avg on columns */
export type DailyFailureAvgFields = {
  __typename?: 'daily_failure_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daily_failure" */
export type DailyFailureAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "daily_failure". All fields are combined with a logical 'AND'. */
export type DailyFailureBoolExp = {
  _and?: InputMaybe<Array<DailyFailureBoolExp>>;
  _not?: InputMaybe<DailyFailureBoolExp>;
  _or?: InputMaybe<Array<DailyFailureBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  day?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_section?: InputMaybe<LotSectionBoolExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "daily_failure" */
export enum DailyFailureConstraint {
  /** unique or primary key constraint on columns "id" */
  DailyFailurePkey = 'daily_failure_pkey'
}

/** input type for incrementing numeric columns in table "daily_failure" */
export type DailyFailureIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "daily_failure" */
export type DailyFailureInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section?: InputMaybe<LotSectionObjRelInsertInput>;
  lot_section_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DailyFailureMaxFields = {
  __typename?: 'daily_failure_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  day?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "daily_failure" */
export type DailyFailureMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DailyFailureMinFields = {
  __typename?: 'daily_failure_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  day?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "daily_failure" */
export type DailyFailureMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "daily_failure" */
export type DailyFailureMutationResponse = {
  __typename?: 'daily_failure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DailyFailure>;
};

/** on_conflict condition type for table "daily_failure" */
export type DailyFailureOnConflict = {
  constraint: DailyFailureConstraint;
  update_columns?: Array<DailyFailureUpdateColumn>;
  where?: InputMaybe<DailyFailureBoolExp>;
};

/** Ordering options when selecting data from "daily_failure". */
export type DailyFailureOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section?: InputMaybe<LotSectionOrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: daily_failure */
export type DailyFailurePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "daily_failure" */
export enum DailyFailureSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id'
}

/** input type for updating data in table "daily_failure" */
export type DailyFailureSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DailyFailureStddevFields = {
  __typename?: 'daily_failure_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daily_failure" */
export type DailyFailureStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DailyFailureStddevPopFields = {
  __typename?: 'daily_failure_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daily_failure" */
export type DailyFailureStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DailyFailureStddevSampFields = {
  __typename?: 'daily_failure_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daily_failure" */
export type DailyFailureStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "daily_failure" */
export type DailyFailureStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DailyFailureStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DailyFailureStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DailyFailureSumFields = {
  __typename?: 'daily_failure_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "daily_failure" */
export type DailyFailureSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "daily_failure" */
export enum DailyFailureUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id'
}

export type DailyFailureUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DailyFailureIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DailyFailureSetInput>;
  /** filter the rows which have to be updated */
  where: DailyFailureBoolExp;
};

/** aggregate var_pop on columns */
export type DailyFailureVarPopFields = {
  __typename?: 'daily_failure_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daily_failure" */
export type DailyFailureVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DailyFailureVarSampFields = {
  __typename?: 'daily_failure_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daily_failure" */
export type DailyFailureVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DailyFailureVarianceFields = {
  __typename?: 'daily_failure_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daily_failure" */
export type DailyFailureVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "daily_stats" */
export type DailyStats = {
  __typename?: 'daily_stats';
  created_at: Scalars['timestamptz'];
  day: Scalars['date'];
  error_rate: Scalars['float8'];
  id: Scalars['Int'];
  /** An object relationship */
  lot_section: LotSection;
  lot_section_id: Scalars['String'];
  num_correct: Scalars['Int'];
  num_error: Scalars['Int'];
  num_event: Scalars['Int'];
  num_open: Scalars['Int'];
  num_violator: Scalars['Int'];
};

/** aggregated selection of "daily_stats" */
export type DailyStatsAggregate = {
  __typename?: 'daily_stats_aggregate';
  aggregate?: Maybe<DailyStatsAggregateFields>;
  nodes: Array<DailyStats>;
};

export type DailyStatsAggregateBoolExp = {
  avg?: InputMaybe<DailyStatsAggregateBoolExpAvg>;
  corr?: InputMaybe<DailyStatsAggregateBoolExpCorr>;
  count?: InputMaybe<DailyStatsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<DailyStatsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<DailyStatsAggregateBoolExpMax>;
  min?: InputMaybe<DailyStatsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<DailyStatsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<DailyStatsAggregateBoolExpSum>;
  var_samp?: InputMaybe<DailyStatsAggregateBoolExpVarSamp>;
};

export type DailyStatsAggregateBoolExpAvg = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpCorr = {
  arguments: DailyStatsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpCorrArguments = {
  X: DailyStatsSelectColumnDailyStatsAggregateBoolExpCorrArgumentsColumns;
  Y: DailyStatsSelectColumnDailyStatsAggregateBoolExpCorrArgumentsColumns;
};

export type DailyStatsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DailyStatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: IntComparisonExp;
};

export type DailyStatsAggregateBoolExpCovarSamp = {
  arguments: DailyStatsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpCovarSampArguments = {
  X: DailyStatsSelectColumnDailyStatsAggregateBoolExpCovarSampArgumentsColumns;
  Y: DailyStatsSelectColumnDailyStatsAggregateBoolExpCovarSampArgumentsColumns;
};

export type DailyStatsAggregateBoolExpMax = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpMin = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpStddevSamp = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpSum = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DailyStatsAggregateBoolExpVarSamp = {
  arguments: DailyStatsSelectColumnDailyStatsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DailyStatsBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "daily_stats" */
export type DailyStatsAggregateFields = {
  __typename?: 'daily_stats_aggregate_fields';
  avg?: Maybe<DailyStatsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DailyStatsMaxFields>;
  min?: Maybe<DailyStatsMinFields>;
  stddev?: Maybe<DailyStatsStddevFields>;
  stddev_pop?: Maybe<DailyStatsStddevPopFields>;
  stddev_samp?: Maybe<DailyStatsStddevSampFields>;
  sum?: Maybe<DailyStatsSumFields>;
  var_pop?: Maybe<DailyStatsVarPopFields>;
  var_samp?: Maybe<DailyStatsVarSampFields>;
  variance?: Maybe<DailyStatsVarianceFields>;
};


/** aggregate fields of "daily_stats" */
export type DailyStatsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DailyStatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daily_stats" */
export type DailyStatsAggregateOrderBy = {
  avg?: InputMaybe<DailyStatsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DailyStatsMaxOrderBy>;
  min?: InputMaybe<DailyStatsMinOrderBy>;
  stddev?: InputMaybe<DailyStatsStddevOrderBy>;
  stddev_pop?: InputMaybe<DailyStatsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DailyStatsStddevSampOrderBy>;
  sum?: InputMaybe<DailyStatsSumOrderBy>;
  var_pop?: InputMaybe<DailyStatsVarPopOrderBy>;
  var_samp?: InputMaybe<DailyStatsVarSampOrderBy>;
  variance?: InputMaybe<DailyStatsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "daily_stats" */
export type DailyStatsArrRelInsertInput = {
  data: Array<DailyStatsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DailyStatsOnConflict>;
};

/** aggregate avg on columns */
export type DailyStatsAvgFields = {
  __typename?: 'daily_stats_avg_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daily_stats" */
export type DailyStatsAvgOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "daily_stats". All fields are combined with a logical 'AND'. */
export type DailyStatsBoolExp = {
  _and?: InputMaybe<Array<DailyStatsBoolExp>>;
  _not?: InputMaybe<DailyStatsBoolExp>;
  _or?: InputMaybe<Array<DailyStatsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  day?: InputMaybe<DateComparisonExp>;
  error_rate?: InputMaybe<Float8ComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_section?: InputMaybe<LotSectionBoolExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
  num_correct?: InputMaybe<IntComparisonExp>;
  num_error?: InputMaybe<IntComparisonExp>;
  num_event?: InputMaybe<IntComparisonExp>;
  num_open?: InputMaybe<IntComparisonExp>;
  num_violator?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "daily_stats" */
export enum DailyStatsConstraint {
  /** unique or primary key constraint on columns "id" */
  DailyStatsPkey = 'daily_stats_pkey'
}

/** input type for incrementing numeric columns in table "daily_stats" */
export type DailyStatsIncInput = {
  error_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  num_correct?: InputMaybe<Scalars['Int']>;
  num_error?: InputMaybe<Scalars['Int']>;
  num_event?: InputMaybe<Scalars['Int']>;
  num_open?: InputMaybe<Scalars['Int']>;
  num_violator?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "daily_stats" */
export type DailyStatsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  error_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section?: InputMaybe<LotSectionObjRelInsertInput>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  num_correct?: InputMaybe<Scalars['Int']>;
  num_error?: InputMaybe<Scalars['Int']>;
  num_event?: InputMaybe<Scalars['Int']>;
  num_open?: InputMaybe<Scalars['Int']>;
  num_violator?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DailyStatsMaxFields = {
  __typename?: 'daily_stats_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  day?: Maybe<Scalars['date']>;
  error_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
  num_correct?: Maybe<Scalars['Int']>;
  num_error?: Maybe<Scalars['Int']>;
  num_event?: Maybe<Scalars['Int']>;
  num_open?: Maybe<Scalars['Int']>;
  num_violator?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "daily_stats" */
export type DailyStatsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DailyStatsMinFields = {
  __typename?: 'daily_stats_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  day?: Maybe<Scalars['date']>;
  error_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  lot_section_id?: Maybe<Scalars['String']>;
  num_correct?: Maybe<Scalars['Int']>;
  num_error?: Maybe<Scalars['Int']>;
  num_event?: Maybe<Scalars['Int']>;
  num_open?: Maybe<Scalars['Int']>;
  num_violator?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "daily_stats" */
export type DailyStatsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "daily_stats" */
export type DailyStatsMutationResponse = {
  __typename?: 'daily_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DailyStats>;
};

/** on_conflict condition type for table "daily_stats" */
export type DailyStatsOnConflict = {
  constraint: DailyStatsConstraint;
  update_columns?: Array<DailyStatsUpdateColumn>;
  where?: InputMaybe<DailyStatsBoolExp>;
};

/** Ordering options when selecting data from "daily_stats". */
export type DailyStatsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section?: InputMaybe<LotSectionOrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: daily_stats */
export type DailyStatsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "daily_stats" */
export enum DailyStatsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  ErrorRate = 'error_rate',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  NumCorrect = 'num_correct',
  /** column name */
  NumError = 'num_error',
  /** column name */
  NumEvent = 'num_event',
  /** column name */
  NumOpen = 'num_open',
  /** column name */
  NumViolator = 'num_violator'
}

/** select "daily_stats_aggregate_bool_exp_avg_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_corr_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_max_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_min_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_sum_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** select "daily_stats_aggregate_bool_exp_var_samp_arguments_columns" columns of table "daily_stats" */
export enum DailyStatsSelectColumnDailyStatsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  ErrorRate = 'error_rate'
}

/** input type for updating data in table "daily_stats" */
export type DailyStatsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  error_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  num_correct?: InputMaybe<Scalars['Int']>;
  num_error?: InputMaybe<Scalars['Int']>;
  num_event?: InputMaybe<Scalars['Int']>;
  num_open?: InputMaybe<Scalars['Int']>;
  num_violator?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DailyStatsStddevFields = {
  __typename?: 'daily_stats_stddev_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daily_stats" */
export type DailyStatsStddevOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DailyStatsStddevPopFields = {
  __typename?: 'daily_stats_stddev_pop_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daily_stats" */
export type DailyStatsStddevPopOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DailyStatsStddevSampFields = {
  __typename?: 'daily_stats_stddev_samp_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daily_stats" */
export type DailyStatsStddevSampOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "daily_stats" */
export type DailyStatsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DailyStatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DailyStatsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day?: InputMaybe<Scalars['date']>;
  error_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  num_correct?: InputMaybe<Scalars['Int']>;
  num_error?: InputMaybe<Scalars['Int']>;
  num_event?: InputMaybe<Scalars['Int']>;
  num_open?: InputMaybe<Scalars['Int']>;
  num_violator?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DailyStatsSumFields = {
  __typename?: 'daily_stats_sum_fields';
  error_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  num_correct?: Maybe<Scalars['Int']>;
  num_error?: Maybe<Scalars['Int']>;
  num_event?: Maybe<Scalars['Int']>;
  num_open?: Maybe<Scalars['Int']>;
  num_violator?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "daily_stats" */
export type DailyStatsSumOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** update columns of table "daily_stats" */
export enum DailyStatsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  ErrorRate = 'error_rate',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  NumCorrect = 'num_correct',
  /** column name */
  NumError = 'num_error',
  /** column name */
  NumEvent = 'num_event',
  /** column name */
  NumOpen = 'num_open',
  /** column name */
  NumViolator = 'num_violator'
}

export type DailyStatsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DailyStatsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DailyStatsSetInput>;
  /** filter the rows which have to be updated */
  where: DailyStatsBoolExp;
};

/** aggregate var_pop on columns */
export type DailyStatsVarPopFields = {
  __typename?: 'daily_stats_var_pop_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daily_stats" */
export type DailyStatsVarPopOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DailyStatsVarSampFields = {
  __typename?: 'daily_stats_var_samp_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daily_stats" */
export type DailyStatsVarSampOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DailyStatsVarianceFields = {
  __typename?: 'daily_stats_variance_fields';
  error_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  num_correct?: Maybe<Scalars['Float']>;
  num_error?: Maybe<Scalars['Float']>;
  num_event?: Maybe<Scalars['Float']>;
  num_open?: Maybe<Scalars['Float']>;
  num_violator?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daily_stats" */
export type DailyStatsVarianceOrderBy = {
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  num_correct?: InputMaybe<OrderBy>;
  num_error?: InputMaybe<OrderBy>;
  num_event?: InputMaybe<OrderBy>;
  num_open?: InputMaybe<OrderBy>;
  num_violator?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "department" */
export type Department = {
  __typename?: 'department';
  code?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  query_information?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "department" */
export type DepartmentQueryInformationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "department" */
export type DepartmentAggregate = {
  __typename?: 'department_aggregate';
  aggregate?: Maybe<DepartmentAggregateFields>;
  nodes: Array<Department>;
};

/** aggregate fields of "department" */
export type DepartmentAggregateFields = {
  __typename?: 'department_aggregate_fields';
  avg?: Maybe<DepartmentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DepartmentMaxFields>;
  min?: Maybe<DepartmentMinFields>;
  stddev?: Maybe<DepartmentStddevFields>;
  stddev_pop?: Maybe<DepartmentStddevPopFields>;
  stddev_samp?: Maybe<DepartmentStddevSampFields>;
  sum?: Maybe<DepartmentSumFields>;
  var_pop?: Maybe<DepartmentVarPopFields>;
  var_samp?: Maybe<DepartmentVarSampFields>;
  variance?: Maybe<DepartmentVarianceFields>;
};


/** aggregate fields of "department" */
export type DepartmentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DepartmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DepartmentAppendInput = {
  query_information?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type DepartmentAvgFields = {
  __typename?: 'department_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type DepartmentBoolExp = {
  _and?: InputMaybe<Array<DepartmentBoolExp>>;
  _not?: InputMaybe<DepartmentBoolExp>;
  _or?: InputMaybe<Array<DepartmentBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  query_information?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "department" */
export enum DepartmentConstraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentPkey = 'department_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DepartmentDeleteAtPathInput = {
  query_information?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DepartmentDeleteElemInput = {
  query_information?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DepartmentDeleteKeyInput = {
  query_information?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "department" */
export type DepartmentIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "department" */
export type DepartmentInsertInput = {
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  query_information?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type DepartmentMaxFields = {
  __typename?: 'department_max_fields';
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DepartmentMinFields = {
  __typename?: 'department_min_fields';
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "department" */
export type DepartmentMutationResponse = {
  __typename?: 'department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department>;
};

/** input type for inserting object relation for remote table "department" */
export type DepartmentObjRelInsertInput = {
  data: DepartmentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DepartmentOnConflict>;
};

/** on_conflict condition type for table "department" */
export type DepartmentOnConflict = {
  constraint: DepartmentConstraint;
  update_columns?: Array<DepartmentUpdateColumn>;
  where?: InputMaybe<DepartmentBoolExp>;
};

/** Ordering options when selecting data from "department". */
export type DepartmentOrderBy = {
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  query_information?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: department */
export type DepartmentPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DepartmentPrependInput = {
  query_information?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "department" */
export enum DepartmentSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  QueryInformation = 'query_information'
}

/** input type for updating data in table "department" */
export type DepartmentSetInput = {
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  query_information?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type DepartmentStddevFields = {
  __typename?: 'department_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DepartmentStddevPopFields = {
  __typename?: 'department_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DepartmentStddevSampFields = {
  __typename?: 'department_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "department" */
export type DepartmentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DepartmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DepartmentStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  query_information?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type DepartmentSumFields = {
  __typename?: 'department_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "department" */
export enum DepartmentUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  QueryInformation = 'query_information'
}

export type DepartmentUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DepartmentAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DepartmentDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DepartmentDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DepartmentDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DepartmentIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DepartmentPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DepartmentSetInput>;
  /** filter the rows which have to be updated */
  where: DepartmentBoolExp;
};

/** aggregate var_pop on columns */
export type DepartmentVarPopFields = {
  __typename?: 'department_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DepartmentVarSampFields = {
  __typename?: 'department_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DepartmentVarianceFields = {
  __typename?: 'department_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "detection_type_enum" */
export type DetectionTypeEnum = {
  __typename?: 'detection_type_enum';
  description: Scalars['String'];
  detection_type?: Maybe<Scalars['smallint']>;
  id: Scalars['uuid'];
};

/** aggregated selection of "detection_type_enum" */
export type DetectionTypeEnumAggregate = {
  __typename?: 'detection_type_enum_aggregate';
  aggregate?: Maybe<DetectionTypeEnumAggregateFields>;
  nodes: Array<DetectionTypeEnum>;
};

/** aggregate fields of "detection_type_enum" */
export type DetectionTypeEnumAggregateFields = {
  __typename?: 'detection_type_enum_aggregate_fields';
  avg?: Maybe<DetectionTypeEnumAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DetectionTypeEnumMaxFields>;
  min?: Maybe<DetectionTypeEnumMinFields>;
  stddev?: Maybe<DetectionTypeEnumStddevFields>;
  stddev_pop?: Maybe<DetectionTypeEnumStddevPopFields>;
  stddev_samp?: Maybe<DetectionTypeEnumStddevSampFields>;
  sum?: Maybe<DetectionTypeEnumSumFields>;
  var_pop?: Maybe<DetectionTypeEnumVarPopFields>;
  var_samp?: Maybe<DetectionTypeEnumVarSampFields>;
  variance?: Maybe<DetectionTypeEnumVarianceFields>;
};


/** aggregate fields of "detection_type_enum" */
export type DetectionTypeEnumAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DetectionTypeEnumSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DetectionTypeEnumAvgFields = {
  __typename?: 'detection_type_enum_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "detection_type_enum". All fields are combined with a logical 'AND'. */
export type DetectionTypeEnumBoolExp = {
  _and?: InputMaybe<Array<DetectionTypeEnumBoolExp>>;
  _not?: InputMaybe<DetectionTypeEnumBoolExp>;
  _or?: InputMaybe<Array<DetectionTypeEnumBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "detection_type_enum" */
export enum DetectionTypeEnumConstraint {
  /** unique or primary key constraint on columns "detection_type" */
  DetectionTypeEnumDetectionTypeKey = 'detection_type_enum_detection_type_key',
  /** unique or primary key constraint on columns "id" */
  DetectionTypeEnumPkey = 'detection_type_enum_pkey'
}

/** input type for incrementing numeric columns in table "detection_type_enum" */
export type DetectionTypeEnumIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "detection_type_enum" */
export type DetectionTypeEnumInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type DetectionTypeEnumMaxFields = {
  __typename?: 'detection_type_enum_max_fields';
  description?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type DetectionTypeEnumMinFields = {
  __typename?: 'detection_type_enum_min_fields';
  description?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "detection_type_enum" */
export type DetectionTypeEnumMutationResponse = {
  __typename?: 'detection_type_enum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DetectionTypeEnum>;
};

/** on_conflict condition type for table "detection_type_enum" */
export type DetectionTypeEnumOnConflict = {
  constraint: DetectionTypeEnumConstraint;
  update_columns?: Array<DetectionTypeEnumUpdateColumn>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};

/** Ordering options when selecting data from "detection_type_enum". */
export type DetectionTypeEnumOrderBy = {
  description?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: detection_type_enum */
export type DetectionTypeEnumPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "detection_type_enum" */
export enum DetectionTypeEnumSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "detection_type_enum" */
export type DetectionTypeEnumSetInput = {
  description?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type DetectionTypeEnumStddevFields = {
  __typename?: 'detection_type_enum_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DetectionTypeEnumStddevPopFields = {
  __typename?: 'detection_type_enum_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DetectionTypeEnumStddevSampFields = {
  __typename?: 'detection_type_enum_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "detection_type_enum" */
export type DetectionTypeEnumStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DetectionTypeEnumStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DetectionTypeEnumStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type DetectionTypeEnumSumFields = {
  __typename?: 'detection_type_enum_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "detection_type_enum" */
export enum DetectionTypeEnumUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  Id = 'id'
}

export type DetectionTypeEnumUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DetectionTypeEnumIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DetectionTypeEnumSetInput>;
  /** filter the rows which have to be updated */
  where: DetectionTypeEnumBoolExp;
};

/** aggregate var_pop on columns */
export type DetectionTypeEnumVarPopFields = {
  __typename?: 'detection_type_enum_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DetectionTypeEnumVarSampFields = {
  __typename?: 'detection_type_enum_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DetectionTypeEnumVarianceFields = {
  __typename?: 'detection_type_enum_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "device" */
export type Device = {
  __typename?: 'device';
  config?: Maybe<Scalars['jsonb']>;
  config_current_timestamp?: Maybe<Scalars['timestamptz']>;
  config_error?: Maybe<Scalars['String']>;
  config_force_update: Scalars['Boolean'];
  config_locked: Scalars['Boolean'];
  config_target_timestamp?: Maybe<Scalars['timestamptz']>;
  device_name?: Maybe<Scalars['String']>;
  hw_data?: Maybe<Scalars['jsonb']>;
  type: Scalars['String'];
  uuid: Scalars['String'];
};


/** columns and relationships of "device" */
export type DeviceConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "device" */
export type DeviceHwDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "device" */
export type DeviceAggregate = {
  __typename?: 'device_aggregate';
  aggregate?: Maybe<DeviceAggregateFields>;
  nodes: Array<Device>;
};

/** aggregate fields of "device" */
export type DeviceAggregateFields = {
  __typename?: 'device_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DeviceMaxFields>;
  min?: Maybe<DeviceMinFields>;
};


/** aggregate fields of "device" */
export type DeviceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DeviceAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  hw_data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "device". All fields are combined with a logical 'AND'. */
export type DeviceBoolExp = {
  _and?: InputMaybe<Array<DeviceBoolExp>>;
  _not?: InputMaybe<DeviceBoolExp>;
  _or?: InputMaybe<Array<DeviceBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  config_current_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  config_error?: InputMaybe<StringComparisonExp>;
  config_force_update?: InputMaybe<BooleanComparisonExp>;
  config_locked?: InputMaybe<BooleanComparisonExp>;
  config_target_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  device_name?: InputMaybe<StringComparisonExp>;
  hw_data?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "device" */
export enum DeviceConstraint {
  /** unique or primary key constraint on columns "uuid" */
  DeviceNewPkey = 'device_new_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DeviceDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  hw_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DeviceDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  hw_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DeviceDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  hw_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "device" */
export type DeviceInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_current_timestamp?: InputMaybe<Scalars['timestamptz']>;
  config_error?: InputMaybe<Scalars['String']>;
  config_force_update?: InputMaybe<Scalars['Boolean']>;
  config_locked?: InputMaybe<Scalars['Boolean']>;
  config_target_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device_name?: InputMaybe<Scalars['String']>;
  hw_data?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DeviceMaxFields = {
  __typename?: 'device_max_fields';
  config_current_timestamp?: Maybe<Scalars['timestamptz']>;
  config_error?: Maybe<Scalars['String']>;
  config_target_timestamp?: Maybe<Scalars['timestamptz']>;
  device_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DeviceMinFields = {
  __typename?: 'device_min_fields';
  config_current_timestamp?: Maybe<Scalars['timestamptz']>;
  config_error?: Maybe<Scalars['String']>;
  config_target_timestamp?: Maybe<Scalars['timestamptz']>;
  device_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "device" */
export type DeviceMutationResponse = {
  __typename?: 'device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Device>;
};

/** input type for inserting object relation for remote table "device" */
export type DeviceObjRelInsertInput = {
  data: DeviceInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DeviceOnConflict>;
};

/** on_conflict condition type for table "device" */
export type DeviceOnConflict = {
  constraint: DeviceConstraint;
  update_columns?: Array<DeviceUpdateColumn>;
  where?: InputMaybe<DeviceBoolExp>;
};

/** Ordering options when selecting data from "device". */
export type DeviceOrderBy = {
  config?: InputMaybe<OrderBy>;
  config_current_timestamp?: InputMaybe<OrderBy>;
  config_error?: InputMaybe<OrderBy>;
  config_force_update?: InputMaybe<OrderBy>;
  config_locked?: InputMaybe<OrderBy>;
  config_target_timestamp?: InputMaybe<OrderBy>;
  device_name?: InputMaybe<OrderBy>;
  hw_data?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: device */
export type DevicePkColumnsInput = {
  uuid: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DevicePrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  hw_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "device" */
export enum DeviceSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigCurrentTimestamp = 'config_current_timestamp',
  /** column name */
  ConfigError = 'config_error',
  /** column name */
  ConfigForceUpdate = 'config_force_update',
  /** column name */
  ConfigLocked = 'config_locked',
  /** column name */
  ConfigTargetTimestamp = 'config_target_timestamp',
  /** column name */
  DeviceName = 'device_name',
  /** column name */
  HwData = 'hw_data',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "device" */
export type DeviceSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_current_timestamp?: InputMaybe<Scalars['timestamptz']>;
  config_error?: InputMaybe<Scalars['String']>;
  config_force_update?: InputMaybe<Scalars['Boolean']>;
  config_locked?: InputMaybe<Scalars['Boolean']>;
  config_target_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device_name?: InputMaybe<Scalars['String']>;
  hw_data?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "device" */
export type DeviceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DeviceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_current_timestamp?: InputMaybe<Scalars['timestamptz']>;
  config_error?: InputMaybe<Scalars['String']>;
  config_force_update?: InputMaybe<Scalars['Boolean']>;
  config_locked?: InputMaybe<Scalars['Boolean']>;
  config_target_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device_name?: InputMaybe<Scalars['String']>;
  hw_data?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** update columns of table "device" */
export enum DeviceUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigCurrentTimestamp = 'config_current_timestamp',
  /** column name */
  ConfigError = 'config_error',
  /** column name */
  ConfigForceUpdate = 'config_force_update',
  /** column name */
  ConfigLocked = 'config_locked',
  /** column name */
  ConfigTargetTimestamp = 'config_target_timestamp',
  /** column name */
  DeviceName = 'device_name',
  /** column name */
  HwData = 'hw_data',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

export type DeviceUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DeviceAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DeviceDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DeviceDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DeviceDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DevicePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeviceSetInput>;
  /** filter the rows which have to be updated */
  where: DeviceBoolExp;
};

/** columns and relationships of "easypark_lot" */
export type EasyparkLot = {
  __typename?: 'easypark_lot';
  area_country_code: Scalars['String'];
  area_no?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  carpay_lot: CarpayLot;
  easypark_enabled: Scalars['Boolean'];
  /** An array relationship */
  easypark_orders: Array<EasyparkOrder>;
  /** An aggregate relationship */
  easypark_orders_aggregate: EasyparkOrderAggregate;
  lot_id: Scalars['String'];
  parking_operator_area_no?: Maybe<Scalars['String']>;
  parking_operator_id: Scalars['bigint'];
  uuid: Scalars['bigint'];
};


/** columns and relationships of "easypark_lot" */
export type EasyparkLotEasyparkOrdersArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


/** columns and relationships of "easypark_lot" */
export type EasyparkLotEasyparkOrdersAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};

/** aggregated selection of "easypark_lot" */
export type EasyparkLotAggregate = {
  __typename?: 'easypark_lot_aggregate';
  aggregate?: Maybe<EasyparkLotAggregateFields>;
  nodes: Array<EasyparkLot>;
};

/** aggregate fields of "easypark_lot" */
export type EasyparkLotAggregateFields = {
  __typename?: 'easypark_lot_aggregate_fields';
  avg?: Maybe<EasyparkLotAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EasyparkLotMaxFields>;
  min?: Maybe<EasyparkLotMinFields>;
  stddev?: Maybe<EasyparkLotStddevFields>;
  stddev_pop?: Maybe<EasyparkLotStddevPopFields>;
  stddev_samp?: Maybe<EasyparkLotStddevSampFields>;
  sum?: Maybe<EasyparkLotSumFields>;
  var_pop?: Maybe<EasyparkLotVarPopFields>;
  var_samp?: Maybe<EasyparkLotVarSampFields>;
  variance?: Maybe<EasyparkLotVarianceFields>;
};


/** aggregate fields of "easypark_lot" */
export type EasyparkLotAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EasyparkLotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EasyparkLotAvgFields = {
  __typename?: 'easypark_lot_avg_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "easypark_lot". All fields are combined with a logical 'AND'. */
export type EasyparkLotBoolExp = {
  _and?: InputMaybe<Array<EasyparkLotBoolExp>>;
  _not?: InputMaybe<EasyparkLotBoolExp>;
  _or?: InputMaybe<Array<EasyparkLotBoolExp>>;
  area_country_code?: InputMaybe<StringComparisonExp>;
  area_no?: InputMaybe<BigintComparisonExp>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  easypark_enabled?: InputMaybe<BooleanComparisonExp>;
  easypark_orders?: InputMaybe<EasyparkOrderBoolExp>;
  easypark_orders_aggregate?: InputMaybe<EasyparkOrderAggregateBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  parking_operator_area_no?: InputMaybe<StringComparisonExp>;
  parking_operator_id?: InputMaybe<BigintComparisonExp>;
  uuid?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "easypark_lot" */
export enum EasyparkLotConstraint {
  /** unique or primary key constraint on columns "area_country_code", "area_no" */
  EasyparkLotAreaNoAreaCountryCodeKey = 'easypark_lot_area_no_area_country_code_key',
  /** unique or primary key constraint on columns "lot_id" */
  EasyparkLotLotIdKey = 'easypark_lot_lot_id_key',
  /** unique or primary key constraint on columns "parking_operator_area_no" */
  EasyparkLotParkingOperatorAreaNoKey = 'easypark_lot_parking_operator_area_no_key',
  /** unique or primary key constraint on columns "uuid" */
  EasyparkLotPkey = 'easypark_lot_pkey'
}

/** input type for incrementing numeric columns in table "easypark_lot" */
export type EasyparkLotIncInput = {
  area_no?: InputMaybe<Scalars['bigint']>;
  parking_operator_id?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "easypark_lot" */
export type EasyparkLotInsertInput = {
  area_country_code?: InputMaybe<Scalars['String']>;
  area_no?: InputMaybe<Scalars['bigint']>;
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  easypark_enabled?: InputMaybe<Scalars['Boolean']>;
  easypark_orders?: InputMaybe<EasyparkOrderArrRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_operator_area_no?: InputMaybe<Scalars['String']>;
  parking_operator_id?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EasyparkLotMaxFields = {
  __typename?: 'easypark_lot_max_fields';
  area_country_code?: Maybe<Scalars['String']>;
  area_no?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  parking_operator_area_no?: Maybe<Scalars['String']>;
  parking_operator_id?: Maybe<Scalars['bigint']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EasyparkLotMinFields = {
  __typename?: 'easypark_lot_min_fields';
  area_country_code?: Maybe<Scalars['String']>;
  area_no?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  parking_operator_area_no?: Maybe<Scalars['String']>;
  parking_operator_id?: Maybe<Scalars['bigint']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "easypark_lot" */
export type EasyparkLotMutationResponse = {
  __typename?: 'easypark_lot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EasyparkLot>;
};

/** input type for inserting object relation for remote table "easypark_lot" */
export type EasyparkLotObjRelInsertInput = {
  data: EasyparkLotInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EasyparkLotOnConflict>;
};

/** on_conflict condition type for table "easypark_lot" */
export type EasyparkLotOnConflict = {
  constraint: EasyparkLotConstraint;
  update_columns?: Array<EasyparkLotUpdateColumn>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};

/** Ordering options when selecting data from "easypark_lot". */
export type EasyparkLotOrderBy = {
  area_country_code?: InputMaybe<OrderBy>;
  area_no?: InputMaybe<OrderBy>;
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  easypark_enabled?: InputMaybe<OrderBy>;
  easypark_orders_aggregate?: InputMaybe<EasyparkOrderAggregateOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  parking_operator_area_no?: InputMaybe<OrderBy>;
  parking_operator_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: easypark_lot */
export type EasyparkLotPkColumnsInput = {
  uuid: Scalars['bigint'];
};

/** select columns of table "easypark_lot" */
export enum EasyparkLotSelectColumn {
  /** column name */
  AreaCountryCode = 'area_country_code',
  /** column name */
  AreaNo = 'area_no',
  /** column name */
  EasyparkEnabled = 'easypark_enabled',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ParkingOperatorAreaNo = 'parking_operator_area_no',
  /** column name */
  ParkingOperatorId = 'parking_operator_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "easypark_lot" */
export type EasyparkLotSetInput = {
  area_country_code?: InputMaybe<Scalars['String']>;
  area_no?: InputMaybe<Scalars['bigint']>;
  easypark_enabled?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_operator_area_no?: InputMaybe<Scalars['String']>;
  parking_operator_id?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type EasyparkLotStddevFields = {
  __typename?: 'easypark_lot_stddev_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EasyparkLotStddevPopFields = {
  __typename?: 'easypark_lot_stddev_pop_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EasyparkLotStddevSampFields = {
  __typename?: 'easypark_lot_stddev_samp_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "easypark_lot" */
export type EasyparkLotStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EasyparkLotStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EasyparkLotStreamCursorValueInput = {
  area_country_code?: InputMaybe<Scalars['String']>;
  area_no?: InputMaybe<Scalars['bigint']>;
  easypark_enabled?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  parking_operator_area_no?: InputMaybe<Scalars['String']>;
  parking_operator_id?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EasyparkLotSumFields = {
  __typename?: 'easypark_lot_sum_fields';
  area_no?: Maybe<Scalars['bigint']>;
  parking_operator_id?: Maybe<Scalars['bigint']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** update columns of table "easypark_lot" */
export enum EasyparkLotUpdateColumn {
  /** column name */
  AreaCountryCode = 'area_country_code',
  /** column name */
  AreaNo = 'area_no',
  /** column name */
  EasyparkEnabled = 'easypark_enabled',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ParkingOperatorAreaNo = 'parking_operator_area_no',
  /** column name */
  ParkingOperatorId = 'parking_operator_id',
  /** column name */
  Uuid = 'uuid'
}

export type EasyparkLotUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EasyparkLotIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EasyparkLotSetInput>;
  /** filter the rows which have to be updated */
  where: EasyparkLotBoolExp;
};

/** aggregate var_pop on columns */
export type EasyparkLotVarPopFields = {
  __typename?: 'easypark_lot_var_pop_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EasyparkLotVarSampFields = {
  __typename?: 'easypark_lot_var_samp_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EasyparkLotVarianceFields = {
  __typename?: 'easypark_lot_variance_fields';
  area_no?: Maybe<Scalars['Float']>;
  parking_operator_id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "easypark_order" */
export type EasyparkOrder = {
  __typename?: 'easypark_order';
  /** An object relationship */
  carpay_order: CarpayOrder;
  carpay_order_id: Scalars['String'];
  /** An object relationship */
  easypark_lot: EasyparkLot;
  easypark_lot_id: Scalars['String'];
  id: Scalars['String'];
  parking_fee?: Maybe<Scalars['Float']>;
  start_timestamp: Scalars['timestamptz'];
  start_type: Scalars['String'];
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
  uuid: Scalars['bigint'];
};

/** aggregated selection of "easypark_order" */
export type EasyparkOrderAggregate = {
  __typename?: 'easypark_order_aggregate';
  aggregate?: Maybe<EasyparkOrderAggregateFields>;
  nodes: Array<EasyparkOrder>;
};

export type EasyparkOrderAggregateBoolExp = {
  count?: InputMaybe<EasyparkOrderAggregateBoolExpCount>;
};

export type EasyparkOrderAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EasyparkOrderBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "easypark_order" */
export type EasyparkOrderAggregateFields = {
  __typename?: 'easypark_order_aggregate_fields';
  avg?: Maybe<EasyparkOrderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EasyparkOrderMaxFields>;
  min?: Maybe<EasyparkOrderMinFields>;
  stddev?: Maybe<EasyparkOrderStddevFields>;
  stddev_pop?: Maybe<EasyparkOrderStddevPopFields>;
  stddev_samp?: Maybe<EasyparkOrderStddevSampFields>;
  sum?: Maybe<EasyparkOrderSumFields>;
  var_pop?: Maybe<EasyparkOrderVarPopFields>;
  var_samp?: Maybe<EasyparkOrderVarSampFields>;
  variance?: Maybe<EasyparkOrderVarianceFields>;
};


/** aggregate fields of "easypark_order" */
export type EasyparkOrderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "easypark_order" */
export type EasyparkOrderAggregateOrderBy = {
  avg?: InputMaybe<EasyparkOrderAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EasyparkOrderMaxOrderBy>;
  min?: InputMaybe<EasyparkOrderMinOrderBy>;
  stddev?: InputMaybe<EasyparkOrderStddevOrderBy>;
  stddev_pop?: InputMaybe<EasyparkOrderStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EasyparkOrderStddevSampOrderBy>;
  sum?: InputMaybe<EasyparkOrderSumOrderBy>;
  var_pop?: InputMaybe<EasyparkOrderVarPopOrderBy>;
  var_samp?: InputMaybe<EasyparkOrderVarSampOrderBy>;
  variance?: InputMaybe<EasyparkOrderVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "easypark_order" */
export type EasyparkOrderArrRelInsertInput = {
  data: Array<EasyparkOrderInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EasyparkOrderOnConflict>;
};

/** aggregate avg on columns */
export type EasyparkOrderAvgFields = {
  __typename?: 'easypark_order_avg_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "easypark_order" */
export type EasyparkOrderAvgOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "easypark_order". All fields are combined with a logical 'AND'. */
export type EasyparkOrderBoolExp = {
  _and?: InputMaybe<Array<EasyparkOrderBoolExp>>;
  _not?: InputMaybe<EasyparkOrderBoolExp>;
  _or?: InputMaybe<Array<EasyparkOrderBoolExp>>;
  carpay_order?: InputMaybe<CarpayOrderBoolExp>;
  carpay_order_id?: InputMaybe<StringComparisonExp>;
  easypark_lot?: InputMaybe<EasyparkLotBoolExp>;
  easypark_lot_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  parking_fee?: InputMaybe<FloatComparisonExp>;
  start_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  start_type?: InputMaybe<StringComparisonExp>;
  stop_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  stop_type?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "easypark_order" */
export enum EasyparkOrderConstraint {
  /** unique or primary key constraint on columns "carpay_order_id" */
  EasyparkOrderCarpayOrderIdKey = 'easypark_order_carpay_order_id_key',
  /** unique or primary key constraint on columns "id" */
  EasyparkOrderIdKey = 'easypark_order_id_key',
  /** unique or primary key constraint on columns "uuid" */
  EasyparkOrderPkey = 'easypark_order_pkey'
}

/** input type for incrementing numeric columns in table "easypark_order" */
export type EasyparkOrderIncInput = {
  parking_fee?: InputMaybe<Scalars['Float']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "easypark_order" */
export type EasyparkOrderInsertInput = {
  carpay_order?: InputMaybe<CarpayOrderObjRelInsertInput>;
  carpay_order_id?: InputMaybe<Scalars['String']>;
  easypark_lot?: InputMaybe<EasyparkLotObjRelInsertInput>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EasyparkOrderMaxFields = {
  __typename?: 'easypark_order_max_fields';
  carpay_order_id?: Maybe<Scalars['String']>;
  easypark_lot_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parking_fee?: Maybe<Scalars['Float']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  start_type?: Maybe<Scalars['String']>;
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "easypark_order" */
export type EasyparkOrderMaxOrderBy = {
  carpay_order_id?: InputMaybe<OrderBy>;
  easypark_lot_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_fee?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  start_type?: InputMaybe<OrderBy>;
  stop_timestamp?: InputMaybe<OrderBy>;
  stop_type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EasyparkOrderMinFields = {
  __typename?: 'easypark_order_min_fields';
  carpay_order_id?: Maybe<Scalars['String']>;
  easypark_lot_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parking_fee?: Maybe<Scalars['Float']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  start_type?: Maybe<Scalars['String']>;
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "easypark_order" */
export type EasyparkOrderMinOrderBy = {
  carpay_order_id?: InputMaybe<OrderBy>;
  easypark_lot_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_fee?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  start_type?: InputMaybe<OrderBy>;
  stop_timestamp?: InputMaybe<OrderBy>;
  stop_type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "easypark_order" */
export type EasyparkOrderMutationResponse = {
  __typename?: 'easypark_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EasyparkOrder>;
};

/** input type for inserting object relation for remote table "easypark_order" */
export type EasyparkOrderObjRelInsertInput = {
  data: EasyparkOrderInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EasyparkOrderOnConflict>;
};

/** on_conflict condition type for table "easypark_order" */
export type EasyparkOrderOnConflict = {
  constraint: EasyparkOrderConstraint;
  update_columns?: Array<EasyparkOrderUpdateColumn>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};

/** Ordering options when selecting data from "easypark_order". */
export type EasyparkOrderOrderBy = {
  carpay_order?: InputMaybe<CarpayOrderOrderBy>;
  carpay_order_id?: InputMaybe<OrderBy>;
  easypark_lot?: InputMaybe<EasyparkLotOrderBy>;
  easypark_lot_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_fee?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  start_type?: InputMaybe<OrderBy>;
  stop_timestamp?: InputMaybe<OrderBy>;
  stop_type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: easypark_order */
export type EasyparkOrderPkColumnsInput = {
  uuid: Scalars['bigint'];
};

/** select columns of table "easypark_order" */
export enum EasyparkOrderSelectColumn {
  /** column name */
  CarpayOrderId = 'carpay_order_id',
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingFee = 'parking_fee',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  StartType = 'start_type',
  /** column name */
  StopTimestamp = 'stop_timestamp',
  /** column name */
  StopType = 'stop_type',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "easypark_order" */
export type EasyparkOrderSetInput = {
  carpay_order_id?: InputMaybe<Scalars['String']>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type EasyparkOrderStddevFields = {
  __typename?: 'easypark_order_stddev_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "easypark_order" */
export type EasyparkOrderStddevOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EasyparkOrderStddevPopFields = {
  __typename?: 'easypark_order_stddev_pop_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "easypark_order" */
export type EasyparkOrderStddevPopOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EasyparkOrderStddevSampFields = {
  __typename?: 'easypark_order_stddev_samp_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "easypark_order" */
export type EasyparkOrderStddevSampOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "easypark_order" */
export type EasyparkOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EasyparkOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EasyparkOrderStreamCursorValueInput = {
  carpay_order_id?: InputMaybe<Scalars['String']>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EasyparkOrderSumFields = {
  __typename?: 'easypark_order_sum_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "easypark_order" */
export type EasyparkOrderSumOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** update columns of table "easypark_order" */
export enum EasyparkOrderUpdateColumn {
  /** column name */
  CarpayOrderId = 'carpay_order_id',
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingFee = 'parking_fee',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  StartType = 'start_type',
  /** column name */
  StopTimestamp = 'stop_timestamp',
  /** column name */
  StopType = 'stop_type',
  /** column name */
  Uuid = 'uuid'
}

export type EasyparkOrderUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EasyparkOrderIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EasyparkOrderSetInput>;
  /** filter the rows which have to be updated */
  where: EasyparkOrderBoolExp;
};

/** columns and relationships of "easypark_order_v2" */
export type EasyparkOrderV2 = {
  __typename?: 'easypark_order_v2';
  /** An object relationship */
  easypark_lot: EasyparkLot;
  easypark_lot_id: Scalars['String'];
  easypark_order_id: Scalars['String'];
  id: Scalars['bigint'];
  parking_details?: Maybe<Scalars['jsonb']>;
  parking_fee?: Maybe<Scalars['Float']>;
  parking_uuid: Scalars['uuid'];
  payment?: Maybe<Scalars['jsonb']>;
  permit_id?: Maybe<Scalars['Int']>;
  plate: Scalars['String'];
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  start_type: Scalars['String'];
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "easypark_order_v2" */
export type EasyparkOrderV2ParkingDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "easypark_order_v2" */
export type EasyparkOrderV2PaymentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "easypark_order_v2" */
export type EasyparkOrderV2Aggregate = {
  __typename?: 'easypark_order_v2_aggregate';
  aggregate?: Maybe<EasyparkOrderV2AggregateFields>;
  nodes: Array<EasyparkOrderV2>;
};

/** aggregate fields of "easypark_order_v2" */
export type EasyparkOrderV2AggregateFields = {
  __typename?: 'easypark_order_v2_aggregate_fields';
  avg?: Maybe<EasyparkOrderV2AvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EasyparkOrderV2MaxFields>;
  min?: Maybe<EasyparkOrderV2MinFields>;
  stddev?: Maybe<EasyparkOrderV2StddevFields>;
  stddev_pop?: Maybe<EasyparkOrderV2StddevPopFields>;
  stddev_samp?: Maybe<EasyparkOrderV2StddevSampFields>;
  sum?: Maybe<EasyparkOrderV2SumFields>;
  var_pop?: Maybe<EasyparkOrderV2VarPopFields>;
  var_samp?: Maybe<EasyparkOrderV2VarSampFields>;
  variance?: Maybe<EasyparkOrderV2VarianceFields>;
};


/** aggregate fields of "easypark_order_v2" */
export type EasyparkOrderV2AggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EasyparkOrderV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EasyparkOrderV2AppendInput = {
  parking_details?: InputMaybe<Scalars['jsonb']>;
  payment?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EasyparkOrderV2AvgFields = {
  __typename?: 'easypark_order_v2_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "easypark_order_v2". All fields are combined with a logical 'AND'. */
export type EasyparkOrderV2BoolExp = {
  _and?: InputMaybe<Array<EasyparkOrderV2BoolExp>>;
  _not?: InputMaybe<EasyparkOrderV2BoolExp>;
  _or?: InputMaybe<Array<EasyparkOrderV2BoolExp>>;
  easypark_lot?: InputMaybe<EasyparkLotBoolExp>;
  easypark_lot_id?: InputMaybe<StringComparisonExp>;
  easypark_order_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_details?: InputMaybe<JsonbComparisonExp>;
  parking_fee?: InputMaybe<FloatComparisonExp>;
  parking_uuid?: InputMaybe<UuidComparisonExp>;
  payment?: InputMaybe<JsonbComparisonExp>;
  permit_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  start_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  start_type?: InputMaybe<StringComparisonExp>;
  stop_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  stop_type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "easypark_order_v2" */
export enum EasyparkOrderV2Constraint {
  /** unique or primary key constraint on columns "easypark_order_id" */
  EasyparkOrderV2EasyparkOrderIdKey = 'easypark_order_v2_easypark_order_id_key',
  /** unique or primary key constraint on columns "parking_uuid" */
  EasyparkOrderV2ParkingUuidKey = 'easypark_order_v2_parking_uuid_key',
  /** unique or primary key constraint on columns "id" */
  EasyparkOrderV2Pkey = 'easypark_order_v2_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EasyparkOrderV2DeleteAtPathInput = {
  parking_details?: InputMaybe<Array<Scalars['String']>>;
  payment?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EasyparkOrderV2DeleteElemInput = {
  parking_details?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EasyparkOrderV2DeleteKeyInput = {
  parking_details?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "easypark_order_v2" */
export type EasyparkOrderV2IncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  permit_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "easypark_order_v2" */
export type EasyparkOrderV2InsertInput = {
  easypark_lot?: InputMaybe<EasyparkLotObjRelInsertInput>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  easypark_order_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  permit_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EasyparkOrderV2MaxFields = {
  __typename?: 'easypark_order_v2_max_fields';
  easypark_lot_id?: Maybe<Scalars['String']>;
  easypark_order_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_fee?: Maybe<Scalars['Float']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  permit_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  start_type?: Maybe<Scalars['String']>;
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EasyparkOrderV2MinFields = {
  __typename?: 'easypark_order_v2_min_fields';
  easypark_lot_id?: Maybe<Scalars['String']>;
  easypark_order_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_fee?: Maybe<Scalars['Float']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  permit_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  start_type?: Maybe<Scalars['String']>;
  stop_timestamp?: Maybe<Scalars['timestamptz']>;
  stop_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "easypark_order_v2" */
export type EasyparkOrderV2MutationResponse = {
  __typename?: 'easypark_order_v2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EasyparkOrderV2>;
};

/** on_conflict condition type for table "easypark_order_v2" */
export type EasyparkOrderV2OnConflict = {
  constraint: EasyparkOrderV2Constraint;
  update_columns?: Array<EasyparkOrderV2UpdateColumn>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};

/** Ordering options when selecting data from "easypark_order_v2". */
export type EasyparkOrderV2OrderBy = {
  easypark_lot?: InputMaybe<EasyparkLotOrderBy>;
  easypark_lot_id?: InputMaybe<OrderBy>;
  easypark_order_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_details?: InputMaybe<OrderBy>;
  parking_fee?: InputMaybe<OrderBy>;
  parking_uuid?: InputMaybe<OrderBy>;
  payment?: InputMaybe<OrderBy>;
  permit_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  start_timestamp?: InputMaybe<OrderBy>;
  start_type?: InputMaybe<OrderBy>;
  stop_timestamp?: InputMaybe<OrderBy>;
  stop_type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: easypark_order_v2 */
export type EasyparkOrderV2PkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EasyparkOrderV2PrependInput = {
  parking_details?: InputMaybe<Scalars['jsonb']>;
  payment?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "easypark_order_v2" */
export enum EasyparkOrderV2SelectColumn {
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  EasyparkOrderId = 'easypark_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingFee = 'parking_fee',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  Payment = 'payment',
  /** column name */
  PermitId = 'permit_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  StartType = 'start_type',
  /** column name */
  StopTimestamp = 'stop_timestamp',
  /** column name */
  StopType = 'stop_type'
}

/** input type for updating data in table "easypark_order_v2" */
export type EasyparkOrderV2SetInput = {
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  easypark_order_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  permit_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EasyparkOrderV2StddevFields = {
  __typename?: 'easypark_order_v2_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EasyparkOrderV2StddevPopFields = {
  __typename?: 'easypark_order_v2_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EasyparkOrderV2StddevSampFields = {
  __typename?: 'easypark_order_v2_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "easypark_order_v2" */
export type EasyparkOrderV2StreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EasyparkOrderV2StreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EasyparkOrderV2StreamCursorValueInput = {
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  easypark_order_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_fee?: InputMaybe<Scalars['Float']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Scalars['jsonb']>;
  permit_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']>;
  start_type?: InputMaybe<Scalars['String']>;
  stop_timestamp?: InputMaybe<Scalars['timestamptz']>;
  stop_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EasyparkOrderV2SumFields = {
  __typename?: 'easypark_order_v2_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "easypark_order_v2" */
export enum EasyparkOrderV2UpdateColumn {
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  EasyparkOrderId = 'easypark_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingFee = 'parking_fee',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  Payment = 'payment',
  /** column name */
  PermitId = 'permit_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  StartType = 'start_type',
  /** column name */
  StopTimestamp = 'stop_timestamp',
  /** column name */
  StopType = 'stop_type'
}

export type EasyparkOrderV2Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EasyparkOrderV2AppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EasyparkOrderV2DeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EasyparkOrderV2DeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EasyparkOrderV2DeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EasyparkOrderV2IncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EasyparkOrderV2PrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EasyparkOrderV2SetInput>;
  /** filter the rows which have to be updated */
  where: EasyparkOrderV2BoolExp;
};

/** aggregate var_pop on columns */
export type EasyparkOrderV2VarPopFields = {
  __typename?: 'easypark_order_v2_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EasyparkOrderV2VarSampFields = {
  __typename?: 'easypark_order_v2_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EasyparkOrderV2VarianceFields = {
  __typename?: 'easypark_order_v2_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parking_fee?: Maybe<Scalars['Float']>;
  permit_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type EasyparkOrderVarPopFields = {
  __typename?: 'easypark_order_var_pop_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "easypark_order" */
export type EasyparkOrderVarPopOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EasyparkOrderVarSampFields = {
  __typename?: 'easypark_order_var_samp_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "easypark_order" */
export type EasyparkOrderVarSampOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EasyparkOrderVarianceFields = {
  __typename?: 'easypark_order_variance_fields';
  parking_fee?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "easypark_order" */
export type EasyparkOrderVarianceOrderBy = {
  parking_fee?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** columns and relationships of "easypark_parking_info" */
export type EasyparkParkingInfo = {
  __typename?: 'easypark_parking_info';
  country: Scalars['String'];
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  easypark_lot_id: Scalars['String'];
  id: Scalars['bigint'];
  normalized_plate: Scalars['String'];
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_details?: Maybe<Scalars['jsonb']>;
  parking_uuid: Scalars['uuid'];
  plate: Scalars['String'];
  revision: Scalars['Int'];
};


/** columns and relationships of "easypark_parking_info" */
export type EasyparkParkingInfoParkingDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "easypark_parking_info" */
export type EasyparkParkingInfoAggregate = {
  __typename?: 'easypark_parking_info_aggregate';
  aggregate?: Maybe<EasyparkParkingInfoAggregateFields>;
  nodes: Array<EasyparkParkingInfo>;
};

/** aggregate fields of "easypark_parking_info" */
export type EasyparkParkingInfoAggregateFields = {
  __typename?: 'easypark_parking_info_aggregate_fields';
  avg?: Maybe<EasyparkParkingInfoAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EasyparkParkingInfoMaxFields>;
  min?: Maybe<EasyparkParkingInfoMinFields>;
  stddev?: Maybe<EasyparkParkingInfoStddevFields>;
  stddev_pop?: Maybe<EasyparkParkingInfoStddevPopFields>;
  stddev_samp?: Maybe<EasyparkParkingInfoStddevSampFields>;
  sum?: Maybe<EasyparkParkingInfoSumFields>;
  var_pop?: Maybe<EasyparkParkingInfoVarPopFields>;
  var_samp?: Maybe<EasyparkParkingInfoVarSampFields>;
  variance?: Maybe<EasyparkParkingInfoVarianceFields>;
};


/** aggregate fields of "easypark_parking_info" */
export type EasyparkParkingInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EasyparkParkingInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EasyparkParkingInfoAppendInput = {
  parking_details?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EasyparkParkingInfoAvgFields = {
  __typename?: 'easypark_parking_info_avg_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "easypark_parking_info". All fields are combined with a logical 'AND'. */
export type EasyparkParkingInfoBoolExp = {
  _and?: InputMaybe<Array<EasyparkParkingInfoBoolExp>>;
  _not?: InputMaybe<EasyparkParkingInfoBoolExp>;
  _or?: InputMaybe<Array<EasyparkParkingInfoBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  drive_in_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  drive_out_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  easypark_lot_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  normalized_plate?: InputMaybe<StringComparisonExp>;
  parking_context_uuid?: InputMaybe<UuidComparisonExp>;
  parking_details?: InputMaybe<JsonbComparisonExp>;
  parking_uuid?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  revision?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "easypark_parking_info" */
export enum EasyparkParkingInfoConstraint {
  /** unique or primary key constraint on columns "parking_uuid" */
  EasyparkParkingInfoParkingUuidKey = 'easypark_parking_info_parking_uuid_key',
  /** unique or primary key constraint on columns "id" */
  EasyparkParkingInfoPkey = 'easypark_parking_info_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EasyparkParkingInfoDeleteAtPathInput = {
  parking_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EasyparkParkingInfoDeleteElemInput = {
  parking_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EasyparkParkingInfoDeleteKeyInput = {
  parking_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "easypark_parking_info" */
export type EasyparkParkingInfoIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  revision?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "easypark_parking_info" */
export type EasyparkParkingInfoInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type EasyparkParkingInfoMaxFields = {
  __typename?: 'easypark_parking_info_max_fields';
  country?: Maybe<Scalars['String']>;
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  easypark_lot_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  normalized_plate?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type EasyparkParkingInfoMinFields = {
  __typename?: 'easypark_parking_info_min_fields';
  country?: Maybe<Scalars['String']>;
  drive_in_timestamp?: Maybe<Scalars['timestamptz']>;
  drive_out_timestamp?: Maybe<Scalars['timestamptz']>;
  easypark_lot_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  normalized_plate?: Maybe<Scalars['String']>;
  parking_context_uuid?: Maybe<Scalars['uuid']>;
  parking_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "easypark_parking_info" */
export type EasyparkParkingInfoMutationResponse = {
  __typename?: 'easypark_parking_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EasyparkParkingInfo>;
};

/** on_conflict condition type for table "easypark_parking_info" */
export type EasyparkParkingInfoOnConflict = {
  constraint: EasyparkParkingInfoConstraint;
  update_columns?: Array<EasyparkParkingInfoUpdateColumn>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};

/** Ordering options when selecting data from "easypark_parking_info". */
export type EasyparkParkingInfoOrderBy = {
  country?: InputMaybe<OrderBy>;
  drive_in_timestamp?: InputMaybe<OrderBy>;
  drive_out_timestamp?: InputMaybe<OrderBy>;
  easypark_lot_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  normalized_plate?: InputMaybe<OrderBy>;
  parking_context_uuid?: InputMaybe<OrderBy>;
  parking_details?: InputMaybe<OrderBy>;
  parking_uuid?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  revision?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: easypark_parking_info */
export type EasyparkParkingInfoPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EasyparkParkingInfoPrependInput = {
  parking_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "easypark_parking_info" */
export enum EasyparkParkingInfoSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  DriveInTimestamp = 'drive_in_timestamp',
  /** column name */
  DriveOutTimestamp = 'drive_out_timestamp',
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  Id = 'id',
  /** column name */
  NormalizedPlate = 'normalized_plate',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  Revision = 'revision'
}

/** input type for updating data in table "easypark_parking_info" */
export type EasyparkParkingInfoSetInput = {
  country?: InputMaybe<Scalars['String']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type EasyparkParkingInfoStddevFields = {
  __typename?: 'easypark_parking_info_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EasyparkParkingInfoStddevPopFields = {
  __typename?: 'easypark_parking_info_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EasyparkParkingInfoStddevSampFields = {
  __typename?: 'easypark_parking_info_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "easypark_parking_info" */
export type EasyparkParkingInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EasyparkParkingInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EasyparkParkingInfoStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  drive_in_timestamp?: InputMaybe<Scalars['timestamptz']>;
  drive_out_timestamp?: InputMaybe<Scalars['timestamptz']>;
  easypark_lot_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  normalized_plate?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['uuid']>;
  parking_details?: InputMaybe<Scalars['jsonb']>;
  parking_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type EasyparkParkingInfoSumFields = {
  __typename?: 'easypark_parking_info_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  revision?: Maybe<Scalars['Int']>;
};

/** update columns of table "easypark_parking_info" */
export enum EasyparkParkingInfoUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  DriveInTimestamp = 'drive_in_timestamp',
  /** column name */
  DriveOutTimestamp = 'drive_out_timestamp',
  /** column name */
  EasyparkLotId = 'easypark_lot_id',
  /** column name */
  Id = 'id',
  /** column name */
  NormalizedPlate = 'normalized_plate',
  /** column name */
  ParkingContextUuid = 'parking_context_uuid',
  /** column name */
  ParkingDetails = 'parking_details',
  /** column name */
  ParkingUuid = 'parking_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  Revision = 'revision'
}

export type EasyparkParkingInfoUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EasyparkParkingInfoAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EasyparkParkingInfoDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EasyparkParkingInfoDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EasyparkParkingInfoDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EasyparkParkingInfoIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EasyparkParkingInfoPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EasyparkParkingInfoSetInput>;
  /** filter the rows which have to be updated */
  where: EasyparkParkingInfoBoolExp;
};

/** aggregate var_pop on columns */
export type EasyparkParkingInfoVarPopFields = {
  __typename?: 'easypark_parking_info_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EasyparkParkingInfoVarSampFields = {
  __typename?: 'easypark_parking_info_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EasyparkParkingInfoVarianceFields = {
  __typename?: 'easypark_parking_info_variance_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "enforcement_daily_stats" */
export type EnforcementDailyStats = {
  __typename?: 'enforcement_daily_stats';
  created_at: Scalars['timestamptz'];
  cxl_cost?: Maybe<Scalars['float8']>;
  cxl_count?: Maybe<Scalars['Int']>;
  cxl_revenue?: Maybe<Scalars['float8']>;
  day: Scalars['date'];
  id: Scalars['bigint'];
  matching_rate_transactions?: Maybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['numeric']>;
  mean_cxl_duration?: Maybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_payment_duration?: Maybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Int']>;
  nr_failed_owner_requests?: Maybe<Scalars['jsonb']>;
  nr_letters_sent?: Maybe<Scalars['jsonb']>;
  nr_lots_live?: Maybe<Scalars['Int']>;
  nr_offences_not_cxl?: Maybe<Scalars['Int']>;
  nr_owner_requests?: Maybe<Scalars['jsonb']>;
  nr_returned_letters?: Maybe<Scalars['Int']>;
  share_billable_cxl?: Maybe<Scalars['numeric']>;
  share_paid_offences?: Maybe<Scalars['numeric']>;
  ticket_website_activity?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "enforcement_daily_stats" */
export type EnforcementDailyStatsNrFailedOwnerRequestsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "enforcement_daily_stats" */
export type EnforcementDailyStatsNrLettersSentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "enforcement_daily_stats" */
export type EnforcementDailyStatsNrOwnerRequestsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "enforcement_daily_stats" */
export type EnforcementDailyStatsTicketWebsiteActivityArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "enforcement_daily_stats" */
export type EnforcementDailyStatsAggregate = {
  __typename?: 'enforcement_daily_stats_aggregate';
  aggregate?: Maybe<EnforcementDailyStatsAggregateFields>;
  nodes: Array<EnforcementDailyStats>;
};

/** aggregate fields of "enforcement_daily_stats" */
export type EnforcementDailyStatsAggregateFields = {
  __typename?: 'enforcement_daily_stats_aggregate_fields';
  avg?: Maybe<EnforcementDailyStatsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EnforcementDailyStatsMaxFields>;
  min?: Maybe<EnforcementDailyStatsMinFields>;
  stddev?: Maybe<EnforcementDailyStatsStddevFields>;
  stddev_pop?: Maybe<EnforcementDailyStatsStddevPopFields>;
  stddev_samp?: Maybe<EnforcementDailyStatsStddevSampFields>;
  sum?: Maybe<EnforcementDailyStatsSumFields>;
  var_pop?: Maybe<EnforcementDailyStatsVarPopFields>;
  var_samp?: Maybe<EnforcementDailyStatsVarSampFields>;
  variance?: Maybe<EnforcementDailyStatsVarianceFields>;
};


/** aggregate fields of "enforcement_daily_stats" */
export type EnforcementDailyStatsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnforcementDailyStatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EnforcementDailyStatsAppendInput = {
  nr_failed_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_letters_sent?: InputMaybe<Scalars['jsonb']>;
  nr_owner_requests?: InputMaybe<Scalars['jsonb']>;
  ticket_website_activity?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EnforcementDailyStatsAvgFields = {
  __typename?: 'enforcement_daily_stats_avg_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "enforcement_daily_stats". All fields are combined with a logical 'AND'. */
export type EnforcementDailyStatsBoolExp = {
  _and?: InputMaybe<Array<EnforcementDailyStatsBoolExp>>;
  _not?: InputMaybe<EnforcementDailyStatsBoolExp>;
  _or?: InputMaybe<Array<EnforcementDailyStatsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  cxl_cost?: InputMaybe<Float8ComparisonExp>;
  cxl_count?: InputMaybe<IntComparisonExp>;
  cxl_revenue?: InputMaybe<Float8ComparisonExp>;
  day?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  matching_rate_transactions?: InputMaybe<NumericComparisonExp>;
  mean_clicking_performance_tinder?: InputMaybe<NumericComparisonExp>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<Float8ComparisonExp>;
  mean_cxl_count_per_lotmonth?: InputMaybe<NumericComparisonExp>;
  mean_cxl_duration?: InputMaybe<NumericComparisonExp>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<Float8ComparisonExp>;
  mean_payment_duration?: InputMaybe<NumericComparisonExp>;
  nr_failed_endpoint_runs?: InputMaybe<IntComparisonExp>;
  nr_failed_owner_requests?: InputMaybe<JsonbComparisonExp>;
  nr_letters_sent?: InputMaybe<JsonbComparisonExp>;
  nr_lots_live?: InputMaybe<IntComparisonExp>;
  nr_offences_not_cxl?: InputMaybe<IntComparisonExp>;
  nr_owner_requests?: InputMaybe<JsonbComparisonExp>;
  nr_returned_letters?: InputMaybe<IntComparisonExp>;
  share_billable_cxl?: InputMaybe<NumericComparisonExp>;
  share_paid_offences?: InputMaybe<NumericComparisonExp>;
  ticket_website_activity?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "enforcement_daily_stats" */
export enum EnforcementDailyStatsConstraint {
  /** unique or primary key constraint on columns "id" */
  EnforcementDailyStatsPkey = 'enforcement_daily_stats_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EnforcementDailyStatsDeleteAtPathInput = {
  nr_failed_owner_requests?: InputMaybe<Array<Scalars['String']>>;
  nr_letters_sent?: InputMaybe<Array<Scalars['String']>>;
  nr_owner_requests?: InputMaybe<Array<Scalars['String']>>;
  ticket_website_activity?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EnforcementDailyStatsDeleteElemInput = {
  nr_failed_owner_requests?: InputMaybe<Scalars['Int']>;
  nr_letters_sent?: InputMaybe<Scalars['Int']>;
  nr_owner_requests?: InputMaybe<Scalars['Int']>;
  ticket_website_activity?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EnforcementDailyStatsDeleteKeyInput = {
  nr_failed_owner_requests?: InputMaybe<Scalars['String']>;
  nr_letters_sent?: InputMaybe<Scalars['String']>;
  nr_owner_requests?: InputMaybe<Scalars['String']>;
  ticket_website_activity?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "enforcement_daily_stats" */
export type EnforcementDailyStatsIncInput = {
  cxl_cost?: InputMaybe<Scalars['float8']>;
  cxl_count?: InputMaybe<Scalars['Int']>;
  cxl_revenue?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  matching_rate_transactions?: InputMaybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: InputMaybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: InputMaybe<Scalars['numeric']>;
  mean_cxl_duration?: InputMaybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_payment_duration?: InputMaybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: InputMaybe<Scalars['Int']>;
  nr_lots_live?: InputMaybe<Scalars['Int']>;
  nr_offences_not_cxl?: InputMaybe<Scalars['Int']>;
  nr_returned_letters?: InputMaybe<Scalars['Int']>;
  share_billable_cxl?: InputMaybe<Scalars['numeric']>;
  share_paid_offences?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "enforcement_daily_stats" */
export type EnforcementDailyStatsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cxl_cost?: InputMaybe<Scalars['float8']>;
  cxl_count?: InputMaybe<Scalars['Int']>;
  cxl_revenue?: InputMaybe<Scalars['float8']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  matching_rate_transactions?: InputMaybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: InputMaybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: InputMaybe<Scalars['numeric']>;
  mean_cxl_duration?: InputMaybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_payment_duration?: InputMaybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: InputMaybe<Scalars['Int']>;
  nr_failed_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_letters_sent?: InputMaybe<Scalars['jsonb']>;
  nr_lots_live?: InputMaybe<Scalars['Int']>;
  nr_offences_not_cxl?: InputMaybe<Scalars['Int']>;
  nr_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_returned_letters?: InputMaybe<Scalars['Int']>;
  share_billable_cxl?: InputMaybe<Scalars['numeric']>;
  share_paid_offences?: InputMaybe<Scalars['numeric']>;
  ticket_website_activity?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type EnforcementDailyStatsMaxFields = {
  __typename?: 'enforcement_daily_stats_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cxl_cost?: Maybe<Scalars['float8']>;
  cxl_count?: Maybe<Scalars['Int']>;
  cxl_revenue?: Maybe<Scalars['float8']>;
  day?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  matching_rate_transactions?: Maybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['numeric']>;
  mean_cxl_duration?: Maybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_payment_duration?: Maybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Int']>;
  nr_lots_live?: Maybe<Scalars['Int']>;
  nr_offences_not_cxl?: Maybe<Scalars['Int']>;
  nr_returned_letters?: Maybe<Scalars['Int']>;
  share_billable_cxl?: Maybe<Scalars['numeric']>;
  share_paid_offences?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type EnforcementDailyStatsMinFields = {
  __typename?: 'enforcement_daily_stats_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cxl_cost?: Maybe<Scalars['float8']>;
  cxl_count?: Maybe<Scalars['Int']>;
  cxl_revenue?: Maybe<Scalars['float8']>;
  day?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  matching_rate_transactions?: Maybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['numeric']>;
  mean_cxl_duration?: Maybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_payment_duration?: Maybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Int']>;
  nr_lots_live?: Maybe<Scalars['Int']>;
  nr_offences_not_cxl?: Maybe<Scalars['Int']>;
  nr_returned_letters?: Maybe<Scalars['Int']>;
  share_billable_cxl?: Maybe<Scalars['numeric']>;
  share_paid_offences?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "enforcement_daily_stats" */
export type EnforcementDailyStatsMutationResponse = {
  __typename?: 'enforcement_daily_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnforcementDailyStats>;
};

/** on_conflict condition type for table "enforcement_daily_stats" */
export type EnforcementDailyStatsOnConflict = {
  constraint: EnforcementDailyStatsConstraint;
  update_columns?: Array<EnforcementDailyStatsUpdateColumn>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};

/** Ordering options when selecting data from "enforcement_daily_stats". */
export type EnforcementDailyStatsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  cxl_cost?: InputMaybe<OrderBy>;
  cxl_count?: InputMaybe<OrderBy>;
  cxl_revenue?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matching_rate_transactions?: InputMaybe<OrderBy>;
  mean_clicking_performance_tinder?: InputMaybe<OrderBy>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<OrderBy>;
  mean_cxl_count_per_lotmonth?: InputMaybe<OrderBy>;
  mean_cxl_duration?: InputMaybe<OrderBy>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<OrderBy>;
  mean_payment_duration?: InputMaybe<OrderBy>;
  nr_failed_endpoint_runs?: InputMaybe<OrderBy>;
  nr_failed_owner_requests?: InputMaybe<OrderBy>;
  nr_letters_sent?: InputMaybe<OrderBy>;
  nr_lots_live?: InputMaybe<OrderBy>;
  nr_offences_not_cxl?: InputMaybe<OrderBy>;
  nr_owner_requests?: InputMaybe<OrderBy>;
  nr_returned_letters?: InputMaybe<OrderBy>;
  share_billable_cxl?: InputMaybe<OrderBy>;
  share_paid_offences?: InputMaybe<OrderBy>;
  ticket_website_activity?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enforcement_daily_stats */
export type EnforcementDailyStatsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EnforcementDailyStatsPrependInput = {
  nr_failed_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_letters_sent?: InputMaybe<Scalars['jsonb']>;
  nr_owner_requests?: InputMaybe<Scalars['jsonb']>;
  ticket_website_activity?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "enforcement_daily_stats" */
export enum EnforcementDailyStatsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CxlCost = 'cxl_cost',
  /** column name */
  CxlCount = 'cxl_count',
  /** column name */
  CxlRevenue = 'cxl_revenue',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingRateTransactions = 'matching_rate_transactions',
  /** column name */
  MeanClickingPerformanceTinder = 'mean_clicking_performance_tinder',
  /** column name */
  MeanCxlCostPerLotmonth = 'mean_cxl_cost_per_lotmonth',
  /** column name */
  MeanCxlCountPerLotmonth = 'mean_cxl_count_per_lotmonth',
  /** column name */
  MeanCxlDuration = 'mean_cxl_duration',
  /** column name */
  MeanCxlRevenuePerLotmonth = 'mean_cxl_revenue_per_lotmonth',
  /** column name */
  MeanPaymentDuration = 'mean_payment_duration',
  /** column name */
  NrFailedEndpointRuns = 'nr_failed_endpoint_runs',
  /** column name */
  NrFailedOwnerRequests = 'nr_failed_owner_requests',
  /** column name */
  NrLettersSent = 'nr_letters_sent',
  /** column name */
  NrLotsLive = 'nr_lots_live',
  /** column name */
  NrOffencesNotCxl = 'nr_offences_not_cxl',
  /** column name */
  NrOwnerRequests = 'nr_owner_requests',
  /** column name */
  NrReturnedLetters = 'nr_returned_letters',
  /** column name */
  ShareBillableCxl = 'share_billable_cxl',
  /** column name */
  SharePaidOffences = 'share_paid_offences',
  /** column name */
  TicketWebsiteActivity = 'ticket_website_activity'
}

/** input type for updating data in table "enforcement_daily_stats" */
export type EnforcementDailyStatsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cxl_cost?: InputMaybe<Scalars['float8']>;
  cxl_count?: InputMaybe<Scalars['Int']>;
  cxl_revenue?: InputMaybe<Scalars['float8']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  matching_rate_transactions?: InputMaybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: InputMaybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: InputMaybe<Scalars['numeric']>;
  mean_cxl_duration?: InputMaybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_payment_duration?: InputMaybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: InputMaybe<Scalars['Int']>;
  nr_failed_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_letters_sent?: InputMaybe<Scalars['jsonb']>;
  nr_lots_live?: InputMaybe<Scalars['Int']>;
  nr_offences_not_cxl?: InputMaybe<Scalars['Int']>;
  nr_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_returned_letters?: InputMaybe<Scalars['Int']>;
  share_billable_cxl?: InputMaybe<Scalars['numeric']>;
  share_paid_offences?: InputMaybe<Scalars['numeric']>;
  ticket_website_activity?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type EnforcementDailyStatsStddevFields = {
  __typename?: 'enforcement_daily_stats_stddev_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EnforcementDailyStatsStddevPopFields = {
  __typename?: 'enforcement_daily_stats_stddev_pop_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EnforcementDailyStatsStddevSampFields = {
  __typename?: 'enforcement_daily_stats_stddev_samp_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "enforcement_daily_stats" */
export type EnforcementDailyStatsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnforcementDailyStatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnforcementDailyStatsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cxl_cost?: InputMaybe<Scalars['float8']>;
  cxl_count?: InputMaybe<Scalars['Int']>;
  cxl_revenue?: InputMaybe<Scalars['float8']>;
  day?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  matching_rate_transactions?: InputMaybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: InputMaybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: InputMaybe<Scalars['numeric']>;
  mean_cxl_duration?: InputMaybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: InputMaybe<Scalars['float8']>;
  mean_payment_duration?: InputMaybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: InputMaybe<Scalars['Int']>;
  nr_failed_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_letters_sent?: InputMaybe<Scalars['jsonb']>;
  nr_lots_live?: InputMaybe<Scalars['Int']>;
  nr_offences_not_cxl?: InputMaybe<Scalars['Int']>;
  nr_owner_requests?: InputMaybe<Scalars['jsonb']>;
  nr_returned_letters?: InputMaybe<Scalars['Int']>;
  share_billable_cxl?: InputMaybe<Scalars['numeric']>;
  share_paid_offences?: InputMaybe<Scalars['numeric']>;
  ticket_website_activity?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type EnforcementDailyStatsSumFields = {
  __typename?: 'enforcement_daily_stats_sum_fields';
  cxl_cost?: Maybe<Scalars['float8']>;
  cxl_count?: Maybe<Scalars['Int']>;
  cxl_revenue?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  matching_rate_transactions?: Maybe<Scalars['numeric']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['numeric']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['numeric']>;
  mean_cxl_duration?: Maybe<Scalars['numeric']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['float8']>;
  mean_payment_duration?: Maybe<Scalars['numeric']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Int']>;
  nr_lots_live?: Maybe<Scalars['Int']>;
  nr_offences_not_cxl?: Maybe<Scalars['Int']>;
  nr_returned_letters?: Maybe<Scalars['Int']>;
  share_billable_cxl?: Maybe<Scalars['numeric']>;
  share_paid_offences?: Maybe<Scalars['numeric']>;
};

/** update columns of table "enforcement_daily_stats" */
export enum EnforcementDailyStatsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CxlCost = 'cxl_cost',
  /** column name */
  CxlCount = 'cxl_count',
  /** column name */
  CxlRevenue = 'cxl_revenue',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  MatchingRateTransactions = 'matching_rate_transactions',
  /** column name */
  MeanClickingPerformanceTinder = 'mean_clicking_performance_tinder',
  /** column name */
  MeanCxlCostPerLotmonth = 'mean_cxl_cost_per_lotmonth',
  /** column name */
  MeanCxlCountPerLotmonth = 'mean_cxl_count_per_lotmonth',
  /** column name */
  MeanCxlDuration = 'mean_cxl_duration',
  /** column name */
  MeanCxlRevenuePerLotmonth = 'mean_cxl_revenue_per_lotmonth',
  /** column name */
  MeanPaymentDuration = 'mean_payment_duration',
  /** column name */
  NrFailedEndpointRuns = 'nr_failed_endpoint_runs',
  /** column name */
  NrFailedOwnerRequests = 'nr_failed_owner_requests',
  /** column name */
  NrLettersSent = 'nr_letters_sent',
  /** column name */
  NrLotsLive = 'nr_lots_live',
  /** column name */
  NrOffencesNotCxl = 'nr_offences_not_cxl',
  /** column name */
  NrOwnerRequests = 'nr_owner_requests',
  /** column name */
  NrReturnedLetters = 'nr_returned_letters',
  /** column name */
  ShareBillableCxl = 'share_billable_cxl',
  /** column name */
  SharePaidOffences = 'share_paid_offences',
  /** column name */
  TicketWebsiteActivity = 'ticket_website_activity'
}

export type EnforcementDailyStatsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EnforcementDailyStatsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EnforcementDailyStatsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EnforcementDailyStatsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EnforcementDailyStatsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EnforcementDailyStatsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EnforcementDailyStatsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnforcementDailyStatsSetInput>;
  /** filter the rows which have to be updated */
  where: EnforcementDailyStatsBoolExp;
};

/** aggregate var_pop on columns */
export type EnforcementDailyStatsVarPopFields = {
  __typename?: 'enforcement_daily_stats_var_pop_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EnforcementDailyStatsVarSampFields = {
  __typename?: 'enforcement_daily_stats_var_samp_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EnforcementDailyStatsVarianceFields = {
  __typename?: 'enforcement_daily_stats_variance_fields';
  cxl_cost?: Maybe<Scalars['Float']>;
  cxl_count?: Maybe<Scalars['Float']>;
  cxl_revenue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  matching_rate_transactions?: Maybe<Scalars['Float']>;
  mean_clicking_performance_tinder?: Maybe<Scalars['Float']>;
  mean_cxl_cost_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_count_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_cxl_duration?: Maybe<Scalars['Float']>;
  mean_cxl_revenue_per_lotmonth?: Maybe<Scalars['Float']>;
  mean_payment_duration?: Maybe<Scalars['Float']>;
  nr_failed_endpoint_runs?: Maybe<Scalars['Float']>;
  nr_lots_live?: Maybe<Scalars['Float']>;
  nr_offences_not_cxl?: Maybe<Scalars['Float']>;
  nr_returned_letters?: Maybe<Scalars['Float']>;
  share_billable_cxl?: Maybe<Scalars['Float']>;
  share_paid_offences?: Maybe<Scalars['Float']>;
};

/** Code type enum for carpay_discount_model table */
export type EnumCarpayDiscountModelCodeType = {
  __typename?: 'enum_carpay_discount_model_code_type';
  code_type: Scalars['String'];
  description: Scalars['String'];
};

/** aggregated selection of "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeAggregate = {
  __typename?: 'enum_carpay_discount_model_code_type_aggregate';
  aggregate?: Maybe<EnumCarpayDiscountModelCodeTypeAggregateFields>;
  nodes: Array<EnumCarpayDiscountModelCodeType>;
};

/** aggregate fields of "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeAggregateFields = {
  __typename?: 'enum_carpay_discount_model_code_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumCarpayDiscountModelCodeTypeMaxFields>;
  min?: Maybe<EnumCarpayDiscountModelCodeTypeMinFields>;
};


/** aggregate fields of "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_carpay_discount_model_code_type". All fields are combined with a logical 'AND'. */
export type EnumCarpayDiscountModelCodeTypeBoolExp = {
  _and?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeBoolExp>>;
  _not?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
  _or?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeBoolExp>>;
  code_type?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_carpay_discount_model_code_type" */
export enum EnumCarpayDiscountModelCodeTypeConstraint {
  /** unique or primary key constraint on columns "code_type" */
  EnumCarpayDiscountModelCodeTypePkey = 'enum_carpay_discount_model_code_type_pkey'
}

export enum EnumCarpayDiscountModelCodeTypeEnum {
  /** QR codes printed on Austrian receipt as part of the Austrian Fiscal Law (RKSV) */
  AustrianFiscalQr = 'austrian_fiscal_qr',
  /** Set of digits printed on receipts containing metainformation in substrings */
  Barcode = 'barcode',
  /** QR codes printed on flyers encoded in base64, containing code and password-generated checksum */
  FlyerBase64Checksum = 'flyer_base64_checksum',
  /** QR codes printed on German receipt as part of the KassenSichV */
  GermanFiscalQr = 'german_fiscal_qr',
  /** Discount model type for 8-alphanumeric symbols containing information about batch, code and buffer */
  ShortCode = 'short_code'
}

/** Boolean expression to compare columns of type "enum_carpay_discount_model_code_type_enum". All fields are combined with logical 'AND'. */
export type EnumCarpayDiscountModelCodeTypeEnumComparisonExp = {
  _eq?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  _in?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EnumCarpayDiscountModelCodeTypeEnum>;
  _nin?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeEnum>>;
};

/** input type for inserting data into table "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeInsertInput = {
  code_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumCarpayDiscountModelCodeTypeMaxFields = {
  __typename?: 'enum_carpay_discount_model_code_type_max_fields';
  code_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumCarpayDiscountModelCodeTypeMinFields = {
  __typename?: 'enum_carpay_discount_model_code_type_min_fields';
  code_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeMutationResponse = {
  __typename?: 'enum_carpay_discount_model_code_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumCarpayDiscountModelCodeType>;
};

/** on_conflict condition type for table "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeOnConflict = {
  constraint: EnumCarpayDiscountModelCodeTypeConstraint;
  update_columns?: Array<EnumCarpayDiscountModelCodeTypeUpdateColumn>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};

/** Ordering options when selecting data from "enum_carpay_discount_model_code_type". */
export type EnumCarpayDiscountModelCodeTypeOrderBy = {
  code_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_carpay_discount_model_code_type */
export type EnumCarpayDiscountModelCodeTypePkColumnsInput = {
  code_type: Scalars['String'];
};

/** select columns of table "enum_carpay_discount_model_code_type" */
export enum EnumCarpayDiscountModelCodeTypeSelectColumn {
  /** column name */
  CodeType = 'code_type',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeSetInput = {
  code_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_carpay_discount_model_code_type" */
export type EnumCarpayDiscountModelCodeTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumCarpayDiscountModelCodeTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumCarpayDiscountModelCodeTypeStreamCursorValueInput = {
  code_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_carpay_discount_model_code_type" */
export enum EnumCarpayDiscountModelCodeTypeUpdateColumn {
  /** column name */
  CodeType = 'code_type',
  /** column name */
  Description = 'description'
}

export type EnumCarpayDiscountModelCodeTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumCarpayDiscountModelCodeTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumCarpayDiscountModelCodeTypeBoolExp;
};

/** columns and relationships of "enum_country_code" */
export type EnumCountryCode = {
  __typename?: 'enum_country_code';
  country: Scalars['String'];
  description: Scalars['String'];
};

/** aggregated selection of "enum_country_code" */
export type EnumCountryCodeAggregate = {
  __typename?: 'enum_country_code_aggregate';
  aggregate?: Maybe<EnumCountryCodeAggregateFields>;
  nodes: Array<EnumCountryCode>;
};

/** aggregate fields of "enum_country_code" */
export type EnumCountryCodeAggregateFields = {
  __typename?: 'enum_country_code_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumCountryCodeMaxFields>;
  min?: Maybe<EnumCountryCodeMinFields>;
};


/** aggregate fields of "enum_country_code" */
export type EnumCountryCodeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumCountryCodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_country_code". All fields are combined with a logical 'AND'. */
export type EnumCountryCodeBoolExp = {
  _and?: InputMaybe<Array<EnumCountryCodeBoolExp>>;
  _not?: InputMaybe<EnumCountryCodeBoolExp>;
  _or?: InputMaybe<Array<EnumCountryCodeBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_country_code" */
export enum EnumCountryCodeConstraint {
  /** unique or primary key constraint on columns "country" */
  EnumCountryCodePkey = 'enum_country_code_pkey'
}

export enum EnumCountryCodeEnum {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates (the) */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia (Plurinational State of) */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas (the) */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands (the) */
  Cc = 'CC',
  /** Congo (the Democratic Republic of the) */
  Cd = 'CD',
  /** Central African Republic (the) */
  Cf = 'CF',
  /** Congo (the) */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands (the) */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic (the) */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Europe */
  Eu = 'EU',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (the) [Malvinas] */
  Fk = 'FK',
  /** Micronesia (Federated States of) */
  Fm = 'FM',
  /** Faroe Islands (the) */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom of Great Britain and Northern Ireland (the) */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia (the) */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** International */
  Int = 'INT',
  /** British Indian Ocean Territory (the) */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran (Islamic Republic of) */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros (the) */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** Korea (the Democratic People's Republic of) */
  Kp = 'KP',
  /** Korea (the Republic of) */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands (the) */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic (the) */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova (the Republic of) */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands (the) */
  Mh = 'MH',
  /** Republic of North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands (the) */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger (the) */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands (the) */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines (the) */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation (the) */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan (the) */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands (the) */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories (the) */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan (Province of China) */
  Tw = 'TW',
  /** Tanzania, United Republic of */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands (the) */
  Um = 'UM',
  /** Unknown country */
  Unk = 'UNK',
  /** United States of America (the) */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (the) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela (Bolivarian Republic of) */
  Ve = 'VE',
  /** Virgin Islands (British) */
  Vg = 'VG',
  /** Virgin Islands (U.S.) */
  Vi = 'VI',
  /** Viet Nam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** Boolean expression to compare columns of type "enum_country_code_enum". All fields are combined with logical 'AND'. */
export type EnumCountryCodeEnumComparisonExp = {
  _eq?: InputMaybe<EnumCountryCodeEnum>;
  _in?: InputMaybe<Array<EnumCountryCodeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EnumCountryCodeEnum>;
  _nin?: InputMaybe<Array<EnumCountryCodeEnum>>;
};

/** input type for inserting data into table "enum_country_code" */
export type EnumCountryCodeInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumCountryCodeMaxFields = {
  __typename?: 'enum_country_code_max_fields';
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumCountryCodeMinFields = {
  __typename?: 'enum_country_code_min_fields';
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_country_code" */
export type EnumCountryCodeMutationResponse = {
  __typename?: 'enum_country_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumCountryCode>;
};

/** on_conflict condition type for table "enum_country_code" */
export type EnumCountryCodeOnConflict = {
  constraint: EnumCountryCodeConstraint;
  update_columns?: Array<EnumCountryCodeUpdateColumn>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};

/** Ordering options when selecting data from "enum_country_code". */
export type EnumCountryCodeOrderBy = {
  country?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_country_code */
export type EnumCountryCodePkColumnsInput = {
  country: Scalars['String'];
};

/** select columns of table "enum_country_code" */
export enum EnumCountryCodeSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "enum_country_code" */
export type EnumCountryCodeSetInput = {
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_country_code" */
export type EnumCountryCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumCountryCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumCountryCodeStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_country_code" */
export enum EnumCountryCodeUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description'
}

export type EnumCountryCodeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumCountryCodeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumCountryCodeBoolExp;
};

/** columns and relationships of "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurpose = {
  __typename?: 'enum_customer_whitelist_purpose';
  description: Scalars['String'];
  purpose: Scalars['String'];
};

/** aggregated selection of "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeAggregate = {
  __typename?: 'enum_customer_whitelist_purpose_aggregate';
  aggregate?: Maybe<EnumCustomerWhitelistPurposeAggregateFields>;
  nodes: Array<EnumCustomerWhitelistPurpose>;
};

/** aggregate fields of "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeAggregateFields = {
  __typename?: 'enum_customer_whitelist_purpose_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumCustomerWhitelistPurposeMaxFields>;
  min?: Maybe<EnumCustomerWhitelistPurposeMinFields>;
};


/** aggregate fields of "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumCustomerWhitelistPurposeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_customer_whitelist_purpose". All fields are combined with a logical 'AND'. */
export type EnumCustomerWhitelistPurposeBoolExp = {
  _and?: InputMaybe<Array<EnumCustomerWhitelistPurposeBoolExp>>;
  _not?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
  _or?: InputMaybe<Array<EnumCustomerWhitelistPurposeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  purpose?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_customer_whitelist_purpose" */
export enum EnumCustomerWhitelistPurposeConstraint {
  /** unique or primary key constraint on columns "purpose" */
  EnumCustomerWhitelistPurposePkey = 'enum_customer_whitelist_purpose_pkey'
}

/** input type for inserting data into table "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumCustomerWhitelistPurposeMaxFields = {
  __typename?: 'enum_customer_whitelist_purpose_max_fields';
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumCustomerWhitelistPurposeMinFields = {
  __typename?: 'enum_customer_whitelist_purpose_min_fields';
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeMutationResponse = {
  __typename?: 'enum_customer_whitelist_purpose_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumCustomerWhitelistPurpose>;
};

/** on_conflict condition type for table "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeOnConflict = {
  constraint: EnumCustomerWhitelistPurposeConstraint;
  update_columns?: Array<EnumCustomerWhitelistPurposeUpdateColumn>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};

/** Ordering options when selecting data from "enum_customer_whitelist_purpose". */
export type EnumCustomerWhitelistPurposeOrderBy = {
  description?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_customer_whitelist_purpose */
export type EnumCustomerWhitelistPurposePkColumnsInput = {
  purpose: Scalars['String'];
};

/** select columns of table "enum_customer_whitelist_purpose" */
export enum EnumCustomerWhitelistPurposeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Purpose = 'purpose'
}

/** input type for updating data in table "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_customer_whitelist_purpose" */
export type EnumCustomerWhitelistPurposeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumCustomerWhitelistPurposeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumCustomerWhitelistPurposeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_customer_whitelist_purpose" */
export enum EnumCustomerWhitelistPurposeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Purpose = 'purpose'
}

export type EnumCustomerWhitelistPurposeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumCustomerWhitelistPurposeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumCustomerWhitelistPurposeBoolExp;
};

/** columns and relationships of "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatus = {
  __typename?: 'enum_customer_whitelist_status';
  description: Scalars['String'];
  status: Scalars['String'];
};

/** aggregated selection of "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusAggregate = {
  __typename?: 'enum_customer_whitelist_status_aggregate';
  aggregate?: Maybe<EnumCustomerWhitelistStatusAggregateFields>;
  nodes: Array<EnumCustomerWhitelistStatus>;
};

/** aggregate fields of "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusAggregateFields = {
  __typename?: 'enum_customer_whitelist_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumCustomerWhitelistStatusMaxFields>;
  min?: Maybe<EnumCustomerWhitelistStatusMinFields>;
};


/** aggregate fields of "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumCustomerWhitelistStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_customer_whitelist_status". All fields are combined with a logical 'AND'. */
export type EnumCustomerWhitelistStatusBoolExp = {
  _and?: InputMaybe<Array<EnumCustomerWhitelistStatusBoolExp>>;
  _not?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
  _or?: InputMaybe<Array<EnumCustomerWhitelistStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_customer_whitelist_status" */
export enum EnumCustomerWhitelistStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  EnumCustomerWhitelistStatusPkey = 'enum_customer_whitelist_status_pkey'
}

/** input type for inserting data into table "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumCustomerWhitelistStatusMaxFields = {
  __typename?: 'enum_customer_whitelist_status_max_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumCustomerWhitelistStatusMinFields = {
  __typename?: 'enum_customer_whitelist_status_min_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusMutationResponse = {
  __typename?: 'enum_customer_whitelist_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumCustomerWhitelistStatus>;
};

/** on_conflict condition type for table "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusOnConflict = {
  constraint: EnumCustomerWhitelistStatusConstraint;
  update_columns?: Array<EnumCustomerWhitelistStatusUpdateColumn>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};

/** Ordering options when selecting data from "enum_customer_whitelist_status". */
export type EnumCustomerWhitelistStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_customer_whitelist_status */
export type EnumCustomerWhitelistStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "enum_customer_whitelist_status" */
export enum EnumCustomerWhitelistStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_customer_whitelist_status" */
export type EnumCustomerWhitelistStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumCustomerWhitelistStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumCustomerWhitelistStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_customer_whitelist_status" */
export enum EnumCustomerWhitelistStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type EnumCustomerWhitelistStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumCustomerWhitelistStatusSetInput>;
  /** filter the rows which have to be updated */
  where: EnumCustomerWhitelistStatusBoolExp;
};

/** Enumeration table with AIoT hardware device types */
export type EnumDeviceType = {
  __typename?: 'enum_device_type';
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "enum_device_type" */
export type EnumDeviceTypeAggregate = {
  __typename?: 'enum_device_type_aggregate';
  aggregate?: Maybe<EnumDeviceTypeAggregateFields>;
  nodes: Array<EnumDeviceType>;
};

/** aggregate fields of "enum_device_type" */
export type EnumDeviceTypeAggregateFields = {
  __typename?: 'enum_device_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumDeviceTypeMaxFields>;
  min?: Maybe<EnumDeviceTypeMinFields>;
};


/** aggregate fields of "enum_device_type" */
export type EnumDeviceTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumDeviceTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_device_type". All fields are combined with a logical 'AND'. */
export type EnumDeviceTypeBoolExp = {
  _and?: InputMaybe<Array<EnumDeviceTypeBoolExp>>;
  _not?: InputMaybe<EnumDeviceTypeBoolExp>;
  _or?: InputMaybe<Array<EnumDeviceTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_device_type" */
export enum EnumDeviceTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  EnumDeviceTypePkey = 'enum_device_type_pkey'
}

/** input type for inserting data into table "enum_device_type" */
export type EnumDeviceTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumDeviceTypeMaxFields = {
  __typename?: 'enum_device_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumDeviceTypeMinFields = {
  __typename?: 'enum_device_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_device_type" */
export type EnumDeviceTypeMutationResponse = {
  __typename?: 'enum_device_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumDeviceType>;
};

/** on_conflict condition type for table "enum_device_type" */
export type EnumDeviceTypeOnConflict = {
  constraint: EnumDeviceTypeConstraint;
  update_columns?: Array<EnumDeviceTypeUpdateColumn>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};

/** Ordering options when selecting data from "enum_device_type". */
export type EnumDeviceTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_device_type */
export type EnumDeviceTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "enum_device_type" */
export enum EnumDeviceTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enum_device_type" */
export type EnumDeviceTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_device_type" */
export type EnumDeviceTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumDeviceTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumDeviceTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_device_type" */
export enum EnumDeviceTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type EnumDeviceTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumDeviceTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumDeviceTypeBoolExp;
};

/** Enumeration table containing all the possible driver request types */
export type EnumDriverRequestType = {
  __typename?: 'enum_driver_request_type';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "enum_driver_request_type" */
export type EnumDriverRequestTypeAggregate = {
  __typename?: 'enum_driver_request_type_aggregate';
  aggregate?: Maybe<EnumDriverRequestTypeAggregateFields>;
  nodes: Array<EnumDriverRequestType>;
};

/** aggregate fields of "enum_driver_request_type" */
export type EnumDriverRequestTypeAggregateFields = {
  __typename?: 'enum_driver_request_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumDriverRequestTypeMaxFields>;
  min?: Maybe<EnumDriverRequestTypeMinFields>;
};


/** aggregate fields of "enum_driver_request_type" */
export type EnumDriverRequestTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumDriverRequestTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_driver_request_type". All fields are combined with a logical 'AND'. */
export type EnumDriverRequestTypeBoolExp = {
  _and?: InputMaybe<Array<EnumDriverRequestTypeBoolExp>>;
  _not?: InputMaybe<EnumDriverRequestTypeBoolExp>;
  _or?: InputMaybe<Array<EnumDriverRequestTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_driver_request_type" */
export enum EnumDriverRequestTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  EnumDriverRequestTypePkey = 'enum_driver_request_type_pkey'
}

/** input type for inserting data into table "enum_driver_request_type" */
export type EnumDriverRequestTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumDriverRequestTypeMaxFields = {
  __typename?: 'enum_driver_request_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumDriverRequestTypeMinFields = {
  __typename?: 'enum_driver_request_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_driver_request_type" */
export type EnumDriverRequestTypeMutationResponse = {
  __typename?: 'enum_driver_request_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumDriverRequestType>;
};

/** on_conflict condition type for table "enum_driver_request_type" */
export type EnumDriverRequestTypeOnConflict = {
  constraint: EnumDriverRequestTypeConstraint;
  update_columns?: Array<EnumDriverRequestTypeUpdateColumn>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};

/** Ordering options when selecting data from "enum_driver_request_type". */
export type EnumDriverRequestTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_driver_request_type */
export type EnumDriverRequestTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "enum_driver_request_type" */
export enum EnumDriverRequestTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enum_driver_request_type" */
export type EnumDriverRequestTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_driver_request_type" */
export type EnumDriverRequestTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumDriverRequestTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumDriverRequestTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_driver_request_type" */
export enum EnumDriverRequestTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type EnumDriverRequestTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumDriverRequestTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumDriverRequestTypeBoolExp;
};

/** Enum table to limit values for purpose column in guest_jwt table */
export type EnumGuestJwtPurpose = {
  __typename?: 'enum_guest_jwt_purpose';
  description: Scalars['String'];
  purpose: Scalars['String'];
};

/** aggregated selection of "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeAggregate = {
  __typename?: 'enum_guest_jwt_purpose_aggregate';
  aggregate?: Maybe<EnumGuestJwtPurposeAggregateFields>;
  nodes: Array<EnumGuestJwtPurpose>;
};

/** aggregate fields of "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeAggregateFields = {
  __typename?: 'enum_guest_jwt_purpose_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumGuestJwtPurposeMaxFields>;
  min?: Maybe<EnumGuestJwtPurposeMinFields>;
};


/** aggregate fields of "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumGuestJwtPurposeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_guest_jwt_purpose". All fields are combined with a logical 'AND'. */
export type EnumGuestJwtPurposeBoolExp = {
  _and?: InputMaybe<Array<EnumGuestJwtPurposeBoolExp>>;
  _not?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
  _or?: InputMaybe<Array<EnumGuestJwtPurposeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  purpose?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_guest_jwt_purpose" */
export enum EnumGuestJwtPurposeConstraint {
  /** unique or primary key constraint on columns "purpose" */
  EnumGuestJwtPurposePkey = 'enum_guest_jwt_purpose_pkey'
}

export enum EnumGuestJwtPurposeEnum {
  /** QR Code scans will generate a customer whitelist entry */
  CustomerWhitelist = 'customer_whitelist',
  /** QR Code scans will link towards the ev charging proof guest website */
  EvChargingProof = 'ev_charging_proof',
  /** QR Code scans will generate a parking time discount */
  TimeDiscount = 'time_discount'
}

/** Boolean expression to compare columns of type "enum_guest_jwt_purpose_enum". All fields are combined with logical 'AND'. */
export type EnumGuestJwtPurposeEnumComparisonExp = {
  _eq?: InputMaybe<EnumGuestJwtPurposeEnum>;
  _in?: InputMaybe<Array<EnumGuestJwtPurposeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EnumGuestJwtPurposeEnum>;
  _nin?: InputMaybe<Array<EnumGuestJwtPurposeEnum>>;
};

/** input type for inserting data into table "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumGuestJwtPurposeMaxFields = {
  __typename?: 'enum_guest_jwt_purpose_max_fields';
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumGuestJwtPurposeMinFields = {
  __typename?: 'enum_guest_jwt_purpose_min_fields';
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeMutationResponse = {
  __typename?: 'enum_guest_jwt_purpose_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumGuestJwtPurpose>;
};

/** on_conflict condition type for table "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeOnConflict = {
  constraint: EnumGuestJwtPurposeConstraint;
  update_columns?: Array<EnumGuestJwtPurposeUpdateColumn>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};

/** Ordering options when selecting data from "enum_guest_jwt_purpose". */
export type EnumGuestJwtPurposeOrderBy = {
  description?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_guest_jwt_purpose */
export type EnumGuestJwtPurposePkColumnsInput = {
  purpose: Scalars['String'];
};

/** select columns of table "enum_guest_jwt_purpose" */
export enum EnumGuestJwtPurposeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Purpose = 'purpose'
}

/** input type for updating data in table "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_guest_jwt_purpose" */
export type EnumGuestJwtPurposeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumGuestJwtPurposeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumGuestJwtPurposeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_guest_jwt_purpose" */
export enum EnumGuestJwtPurposeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Purpose = 'purpose'
}

export type EnumGuestJwtPurposeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumGuestJwtPurposeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumGuestJwtPurposeBoolExp;
};

/** Enumeration table for the statuses of supervision mlp request entries */
export type EnumSupervisionMlpRequestStatus = {
  __typename?: 'enum_supervision_mlp_request_status';
  description?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** aggregated selection of "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusAggregate = {
  __typename?: 'enum_supervision_mlp_request_status_aggregate';
  aggregate?: Maybe<EnumSupervisionMlpRequestStatusAggregateFields>;
  nodes: Array<EnumSupervisionMlpRequestStatus>;
};

/** aggregate fields of "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusAggregateFields = {
  __typename?: 'enum_supervision_mlp_request_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumSupervisionMlpRequestStatusMaxFields>;
  min?: Maybe<EnumSupervisionMlpRequestStatusMinFields>;
};


/** aggregate fields of "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumSupervisionMlpRequestStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_supervision_mlp_request_status". All fields are combined with a logical 'AND'. */
export type EnumSupervisionMlpRequestStatusBoolExp = {
  _and?: InputMaybe<Array<EnumSupervisionMlpRequestStatusBoolExp>>;
  _not?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
  _or?: InputMaybe<Array<EnumSupervisionMlpRequestStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_supervision_mlp_request_status" */
export enum EnumSupervisionMlpRequestStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  EnumSupervisionMlpRequestStatusPkey = 'enum_supervision_mlp_request_status_pkey'
}

/** input type for inserting data into table "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumSupervisionMlpRequestStatusMaxFields = {
  __typename?: 'enum_supervision_mlp_request_status_max_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumSupervisionMlpRequestStatusMinFields = {
  __typename?: 'enum_supervision_mlp_request_status_min_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusMutationResponse = {
  __typename?: 'enum_supervision_mlp_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumSupervisionMlpRequestStatus>;
};

/** on_conflict condition type for table "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusOnConflict = {
  constraint: EnumSupervisionMlpRequestStatusConstraint;
  update_columns?: Array<EnumSupervisionMlpRequestStatusUpdateColumn>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};

/** Ordering options when selecting data from "enum_supervision_mlp_request_status". */
export type EnumSupervisionMlpRequestStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_supervision_mlp_request_status */
export type EnumSupervisionMlpRequestStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "enum_supervision_mlp_request_status" */
export enum EnumSupervisionMlpRequestStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_supervision_mlp_request_status" */
export type EnumSupervisionMlpRequestStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumSupervisionMlpRequestStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumSupervisionMlpRequestStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_supervision_mlp_request_status" */
export enum EnumSupervisionMlpRequestStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type EnumSupervisionMlpRequestStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumSupervisionMlpRequestStatusSetInput>;
  /** filter the rows which have to be updated */
  where: EnumSupervisionMlpRequestStatusBoolExp;
};

/** columns and relationships of "enum_violation_cancellation" */
export type EnumViolationCancellation = {
  __typename?: 'enum_violation_cancellation';
  violation_cancellation: Scalars['String'];
};

/** aggregated selection of "enum_violation_cancellation" */
export type EnumViolationCancellationAggregate = {
  __typename?: 'enum_violation_cancellation_aggregate';
  aggregate?: Maybe<EnumViolationCancellationAggregateFields>;
  nodes: Array<EnumViolationCancellation>;
};

/** aggregate fields of "enum_violation_cancellation" */
export type EnumViolationCancellationAggregateFields = {
  __typename?: 'enum_violation_cancellation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumViolationCancellationMaxFields>;
  min?: Maybe<EnumViolationCancellationMinFields>;
};


/** aggregate fields of "enum_violation_cancellation" */
export type EnumViolationCancellationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumViolationCancellationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_violation_cancellation". All fields are combined with a logical 'AND'. */
export type EnumViolationCancellationBoolExp = {
  _and?: InputMaybe<Array<EnumViolationCancellationBoolExp>>;
  _not?: InputMaybe<EnumViolationCancellationBoolExp>;
  _or?: InputMaybe<Array<EnumViolationCancellationBoolExp>>;
  violation_cancellation?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_violation_cancellation" */
export enum EnumViolationCancellationConstraint {
  /** unique or primary key constraint on columns "violation_cancellation" */
  EnumViolationCancellationPkey = 'enum_violation_cancellation_pkey'
}

/** input type for inserting data into table "enum_violation_cancellation" */
export type EnumViolationCancellationInsertInput = {
  violation_cancellation?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumViolationCancellationMaxFields = {
  __typename?: 'enum_violation_cancellation_max_fields';
  violation_cancellation?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumViolationCancellationMinFields = {
  __typename?: 'enum_violation_cancellation_min_fields';
  violation_cancellation?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_violation_cancellation" */
export type EnumViolationCancellationMutationResponse = {
  __typename?: 'enum_violation_cancellation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumViolationCancellation>;
};

/** on_conflict condition type for table "enum_violation_cancellation" */
export type EnumViolationCancellationOnConflict = {
  constraint: EnumViolationCancellationConstraint;
  update_columns?: Array<EnumViolationCancellationUpdateColumn>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};

/** Ordering options when selecting data from "enum_violation_cancellation". */
export type EnumViolationCancellationOrderBy = {
  violation_cancellation?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_violation_cancellation */
export type EnumViolationCancellationPkColumnsInput = {
  violation_cancellation: Scalars['String'];
};

/** select columns of table "enum_violation_cancellation" */
export enum EnumViolationCancellationSelectColumn {
  /** column name */
  ViolationCancellation = 'violation_cancellation'
}

/** input type for updating data in table "enum_violation_cancellation" */
export type EnumViolationCancellationSetInput = {
  violation_cancellation?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_violation_cancellation" */
export type EnumViolationCancellationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumViolationCancellationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumViolationCancellationStreamCursorValueInput = {
  violation_cancellation?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_violation_cancellation" */
export enum EnumViolationCancellationUpdateColumn {
  /** column name */
  ViolationCancellation = 'violation_cancellation'
}

export type EnumViolationCancellationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumViolationCancellationSetInput>;
  /** filter the rows which have to be updated */
  where: EnumViolationCancellationBoolExp;
};

/** Enum table to control invalidation reasons of violation case charges table */
export type EnumViolationCaseChargesInvalidationReason = {
  __typename?: 'enum_violation_case_charges_invalidation_reason';
  description: Scalars['String'];
  invalidation_reason: Scalars['String'];
};

/** aggregated selection of "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonAggregate = {
  __typename?: 'enum_violation_case_charges_invalidation_reason_aggregate';
  aggregate?: Maybe<EnumViolationCaseChargesInvalidationReasonAggregateFields>;
  nodes: Array<EnumViolationCaseChargesInvalidationReason>;
};

/** aggregate fields of "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonAggregateFields = {
  __typename?: 'enum_violation_case_charges_invalidation_reason_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumViolationCaseChargesInvalidationReasonMaxFields>;
  min?: Maybe<EnumViolationCaseChargesInvalidationReasonMinFields>;
};


/** aggregate fields of "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_violation_case_charges_invalidation_reason". All fields are combined with a logical 'AND'. */
export type EnumViolationCaseChargesInvalidationReasonBoolExp = {
  _and?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonBoolExp>>;
  _not?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
  _or?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  invalidation_reason?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_violation_case_charges_invalidation_reason" */
export enum EnumViolationCaseChargesInvalidationReasonConstraint {
  /** unique or primary key constraint on columns "invalidation_reason" */
  EnumViolationCaseChargesInvalidationReasonPkey = 'enum_violation_case_charges_invalidation_reason_pkey'
}

/** input type for inserting data into table "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumViolationCaseChargesInvalidationReasonMaxFields = {
  __typename?: 'enum_violation_case_charges_invalidation_reason_max_fields';
  description?: Maybe<Scalars['String']>;
  invalidation_reason?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumViolationCaseChargesInvalidationReasonMinFields = {
  __typename?: 'enum_violation_case_charges_invalidation_reason_min_fields';
  description?: Maybe<Scalars['String']>;
  invalidation_reason?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonMutationResponse = {
  __typename?: 'enum_violation_case_charges_invalidation_reason_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumViolationCaseChargesInvalidationReason>;
};

/** on_conflict condition type for table "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonOnConflict = {
  constraint: EnumViolationCaseChargesInvalidationReasonConstraint;
  update_columns?: Array<EnumViolationCaseChargesInvalidationReasonUpdateColumn>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};

/** Ordering options when selecting data from "enum_violation_case_charges_invalidation_reason". */
export type EnumViolationCaseChargesInvalidationReasonOrderBy = {
  description?: InputMaybe<OrderBy>;
  invalidation_reason?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_violation_case_charges_invalidation_reason */
export type EnumViolationCaseChargesInvalidationReasonPkColumnsInput = {
  invalidation_reason: Scalars['String'];
};

/** select columns of table "enum_violation_case_charges_invalidation_reason" */
export enum EnumViolationCaseChargesInvalidationReasonSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  InvalidationReason = 'invalidation_reason'
}

/** input type for updating data in table "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonSetInput = {
  description?: InputMaybe<Scalars['String']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_violation_case_charges_invalidation_reason" */
export type EnumViolationCaseChargesInvalidationReasonStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumViolationCaseChargesInvalidationReasonStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumViolationCaseChargesInvalidationReasonStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_violation_case_charges_invalidation_reason" */
export enum EnumViolationCaseChargesInvalidationReasonUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  InvalidationReason = 'invalidation_reason'
}

export type EnumViolationCaseChargesInvalidationReasonUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumViolationCaseChargesInvalidationReasonSetInput>;
  /** filter the rows which have to be updated */
  where: EnumViolationCaseChargesInvalidationReasonBoolExp;
};

/** Enum table to keep track of allowed types of violation_case_charges */
export type EnumViolationCaseChargesType = {
  __typename?: 'enum_violation_case_charges_type';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeAggregate = {
  __typename?: 'enum_violation_case_charges_type_aggregate';
  aggregate?: Maybe<EnumViolationCaseChargesTypeAggregateFields>;
  nodes: Array<EnumViolationCaseChargesType>;
};

/** aggregate fields of "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeAggregateFields = {
  __typename?: 'enum_violation_case_charges_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumViolationCaseChargesTypeMaxFields>;
  min?: Maybe<EnumViolationCaseChargesTypeMinFields>;
};


/** aggregate fields of "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumViolationCaseChargesTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_violation_case_charges_type". All fields are combined with a logical 'AND'. */
export type EnumViolationCaseChargesTypeBoolExp = {
  _and?: InputMaybe<Array<EnumViolationCaseChargesTypeBoolExp>>;
  _not?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
  _or?: InputMaybe<Array<EnumViolationCaseChargesTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_violation_case_charges_type" */
export enum EnumViolationCaseChargesTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  EnumViolationCaseChargesTypePkey = 'enum_violation_case_charges_type_pkey'
}

/** input type for inserting data into table "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumViolationCaseChargesTypeMaxFields = {
  __typename?: 'enum_violation_case_charges_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumViolationCaseChargesTypeMinFields = {
  __typename?: 'enum_violation_case_charges_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeMutationResponse = {
  __typename?: 'enum_violation_case_charges_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumViolationCaseChargesType>;
};

/** on_conflict condition type for table "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeOnConflict = {
  constraint: EnumViolationCaseChargesTypeConstraint;
  update_columns?: Array<EnumViolationCaseChargesTypeUpdateColumn>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};

/** Ordering options when selecting data from "enum_violation_case_charges_type". */
export type EnumViolationCaseChargesTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_violation_case_charges_type */
export type EnumViolationCaseChargesTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "enum_violation_case_charges_type" */
export enum EnumViolationCaseChargesTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_violation_case_charges_type" */
export type EnumViolationCaseChargesTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumViolationCaseChargesTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumViolationCaseChargesTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_violation_case_charges_type" */
export enum EnumViolationCaseChargesTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type EnumViolationCaseChargesTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumViolationCaseChargesTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumViolationCaseChargesTypeBoolExp;
};

/** columns and relationships of "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypes = {
  __typename?: 'enum_whitelist_paid_parking_types';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesAggregate = {
  __typename?: 'enum_whitelist_paid_parking_types_aggregate';
  aggregate?: Maybe<EnumWhitelistPaidParkingTypesAggregateFields>;
  nodes: Array<EnumWhitelistPaidParkingTypes>;
};

/** aggregate fields of "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesAggregateFields = {
  __typename?: 'enum_whitelist_paid_parking_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumWhitelistPaidParkingTypesMaxFields>;
  min?: Maybe<EnumWhitelistPaidParkingTypesMinFields>;
};


/** aggregate fields of "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumWhitelistPaidParkingTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_whitelist_paid_parking_types". All fields are combined with a logical 'AND'. */
export type EnumWhitelistPaidParkingTypesBoolExp = {
  _and?: InputMaybe<Array<EnumWhitelistPaidParkingTypesBoolExp>>;
  _not?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
  _or?: InputMaybe<Array<EnumWhitelistPaidParkingTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_whitelist_paid_parking_types" */
export enum EnumWhitelistPaidParkingTypesConstraint {
  /** unique or primary key constraint on columns "type" */
  EnumWhitelistPaidParkingTypesPkey = 'enum_whitelist_paid_parking_types_pkey'
}

/** input type for inserting data into table "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumWhitelistPaidParkingTypesMaxFields = {
  __typename?: 'enum_whitelist_paid_parking_types_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumWhitelistPaidParkingTypesMinFields = {
  __typename?: 'enum_whitelist_paid_parking_types_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesMutationResponse = {
  __typename?: 'enum_whitelist_paid_parking_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumWhitelistPaidParkingTypes>;
};

/** on_conflict condition type for table "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesOnConflict = {
  constraint: EnumWhitelistPaidParkingTypesConstraint;
  update_columns?: Array<EnumWhitelistPaidParkingTypesUpdateColumn>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};

/** Ordering options when selecting data from "enum_whitelist_paid_parking_types". */
export type EnumWhitelistPaidParkingTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_whitelist_paid_parking_types */
export type EnumWhitelistPaidParkingTypesPkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "enum_whitelist_paid_parking_types" */
export enum EnumWhitelistPaidParkingTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_whitelist_paid_parking_types" */
export type EnumWhitelistPaidParkingTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumWhitelistPaidParkingTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumWhitelistPaidParkingTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_whitelist_paid_parking_types" */
export enum EnumWhitelistPaidParkingTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type EnumWhitelistPaidParkingTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumWhitelistPaidParkingTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EnumWhitelistPaidParkingTypesBoolExp;
};

/** columns and relationships of "enum_whitelist_scope" */
export type EnumWhitelistScope = {
  __typename?: 'enum_whitelist_scope';
  description: Scalars['String'];
  scope: Scalars['String'];
};

/** aggregated selection of "enum_whitelist_scope" */
export type EnumWhitelistScopeAggregate = {
  __typename?: 'enum_whitelist_scope_aggregate';
  aggregate?: Maybe<EnumWhitelistScopeAggregateFields>;
  nodes: Array<EnumWhitelistScope>;
};

/** aggregate fields of "enum_whitelist_scope" */
export type EnumWhitelistScopeAggregateFields = {
  __typename?: 'enum_whitelist_scope_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumWhitelistScopeMaxFields>;
  min?: Maybe<EnumWhitelistScopeMinFields>;
};


/** aggregate fields of "enum_whitelist_scope" */
export type EnumWhitelistScopeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumWhitelistScopeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_whitelist_scope". All fields are combined with a logical 'AND'. */
export type EnumWhitelistScopeBoolExp = {
  _and?: InputMaybe<Array<EnumWhitelistScopeBoolExp>>;
  _not?: InputMaybe<EnumWhitelistScopeBoolExp>;
  _or?: InputMaybe<Array<EnumWhitelistScopeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  scope?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_whitelist_scope" */
export enum EnumWhitelistScopeConstraint {
  /** unique or primary key constraint on columns "scope" */
  EnumWhitelistScopePkey = 'enum_whitelist_scope_pkey',
  /** unique or primary key constraint on columns "scope" */
  EnumWhitelistScopeScopeKey = 'enum_whitelist_scope_scope_key'
}

export enum EnumWhitelistScopeEnum {
  /** Whitelist is valid for all lots */
  Global = 'global',
  /** Whitelisting is specific to one lot referenced in lot_id column */
  Local = 'local'
}

/** Boolean expression to compare columns of type "enum_whitelist_scope_enum". All fields are combined with logical 'AND'. */
export type EnumWhitelistScopeEnumComparisonExp = {
  _eq?: InputMaybe<EnumWhitelistScopeEnum>;
  _in?: InputMaybe<Array<EnumWhitelistScopeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EnumWhitelistScopeEnum>;
  _nin?: InputMaybe<Array<EnumWhitelistScopeEnum>>;
};

/** input type for inserting data into table "enum_whitelist_scope" */
export type EnumWhitelistScopeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumWhitelistScopeMaxFields = {
  __typename?: 'enum_whitelist_scope_max_fields';
  description?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumWhitelistScopeMinFields = {
  __typename?: 'enum_whitelist_scope_min_fields';
  description?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_whitelist_scope" */
export type EnumWhitelistScopeMutationResponse = {
  __typename?: 'enum_whitelist_scope_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumWhitelistScope>;
};

/** on_conflict condition type for table "enum_whitelist_scope" */
export type EnumWhitelistScopeOnConflict = {
  constraint: EnumWhitelistScopeConstraint;
  update_columns?: Array<EnumWhitelistScopeUpdateColumn>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};

/** Ordering options when selecting data from "enum_whitelist_scope". */
export type EnumWhitelistScopeOrderBy = {
  description?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_whitelist_scope */
export type EnumWhitelistScopePkColumnsInput = {
  scope: Scalars['String'];
};

/** select columns of table "enum_whitelist_scope" */
export enum EnumWhitelistScopeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Scope = 'scope'
}

/** input type for updating data in table "enum_whitelist_scope" */
export type EnumWhitelistScopeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_whitelist_scope" */
export type EnumWhitelistScopeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumWhitelistScopeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumWhitelistScopeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_whitelist_scope" */
export enum EnumWhitelistScopeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Scope = 'scope'
}

export type EnumWhitelistScopeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumWhitelistScopeSetInput>;
  /** filter the rows which have to be updated */
  where: EnumWhitelistScopeBoolExp;
};

/** columns and relationships of "enum_whitelist_status" */
export type EnumWhitelistStatus = {
  __typename?: 'enum_whitelist_status';
  description?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** aggregated selection of "enum_whitelist_status" */
export type EnumWhitelistStatusAggregate = {
  __typename?: 'enum_whitelist_status_aggregate';
  aggregate?: Maybe<EnumWhitelistStatusAggregateFields>;
  nodes: Array<EnumWhitelistStatus>;
};

/** aggregate fields of "enum_whitelist_status" */
export type EnumWhitelistStatusAggregateFields = {
  __typename?: 'enum_whitelist_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumWhitelistStatusMaxFields>;
  min?: Maybe<EnumWhitelistStatusMinFields>;
};


/** aggregate fields of "enum_whitelist_status" */
export type EnumWhitelistStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumWhitelistStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_whitelist_status". All fields are combined with a logical 'AND'. */
export type EnumWhitelistStatusBoolExp = {
  _and?: InputMaybe<Array<EnumWhitelistStatusBoolExp>>;
  _not?: InputMaybe<EnumWhitelistStatusBoolExp>;
  _or?: InputMaybe<Array<EnumWhitelistStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_whitelist_status" */
export enum EnumWhitelistStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  WhitelistPaidParkingStatusPkey = 'whitelist_paid_parking_status_pkey'
}

export enum EnumWhitelistStatusEnum {
  /** Car should be considered for whitelisting */
  Active = 'active',
  /** The whitelisting has been actively deleted */
  Deleted = 'deleted',
  /** The whitelisting is not active anymore */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "enum_whitelist_status_enum". All fields are combined with logical 'AND'. */
export type EnumWhitelistStatusEnumComparisonExp = {
  _eq?: InputMaybe<EnumWhitelistStatusEnum>;
  _in?: InputMaybe<Array<EnumWhitelistStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EnumWhitelistStatusEnum>;
  _nin?: InputMaybe<Array<EnumWhitelistStatusEnum>>;
};

/** input type for inserting data into table "enum_whitelist_status" */
export type EnumWhitelistStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumWhitelistStatusMaxFields = {
  __typename?: 'enum_whitelist_status_max_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumWhitelistStatusMinFields = {
  __typename?: 'enum_whitelist_status_min_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_whitelist_status" */
export type EnumWhitelistStatusMutationResponse = {
  __typename?: 'enum_whitelist_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumWhitelistStatus>;
};

/** input type for inserting object relation for remote table "enum_whitelist_status" */
export type EnumWhitelistStatusObjRelInsertInput = {
  data: EnumWhitelistStatusInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EnumWhitelistStatusOnConflict>;
};

/** on_conflict condition type for table "enum_whitelist_status" */
export type EnumWhitelistStatusOnConflict = {
  constraint: EnumWhitelistStatusConstraint;
  update_columns?: Array<EnumWhitelistStatusUpdateColumn>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};

/** Ordering options when selecting data from "enum_whitelist_status". */
export type EnumWhitelistStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_whitelist_status */
export type EnumWhitelistStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "enum_whitelist_status" */
export enum EnumWhitelistStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "enum_whitelist_status" */
export type EnumWhitelistStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_whitelist_status" */
export type EnumWhitelistStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumWhitelistStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumWhitelistStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_whitelist_status" */
export enum EnumWhitelistStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type EnumWhitelistStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumWhitelistStatusSetInput>;
  /** filter the rows which have to be updated */
  where: EnumWhitelistStatusBoolExp;
};

/** columns and relationships of "enum_whitelist_types" */
export type EnumWhitelistTypes = {
  __typename?: 'enum_whitelist_types';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "enum_whitelist_types" */
export type EnumWhitelistTypesAggregate = {
  __typename?: 'enum_whitelist_types_aggregate';
  aggregate?: Maybe<EnumWhitelistTypesAggregateFields>;
  nodes: Array<EnumWhitelistTypes>;
};

/** aggregate fields of "enum_whitelist_types" */
export type EnumWhitelistTypesAggregateFields = {
  __typename?: 'enum_whitelist_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EnumWhitelistTypesMaxFields>;
  min?: Maybe<EnumWhitelistTypesMinFields>;
};


/** aggregate fields of "enum_whitelist_types" */
export type EnumWhitelistTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EnumWhitelistTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_whitelist_types". All fields are combined with a logical 'AND'. */
export type EnumWhitelistTypesBoolExp = {
  _and?: InputMaybe<Array<EnumWhitelistTypesBoolExp>>;
  _not?: InputMaybe<EnumWhitelistTypesBoolExp>;
  _or?: InputMaybe<Array<EnumWhitelistTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "enum_whitelist_types" */
export enum EnumWhitelistTypesConstraint {
  /** unique or primary key constraint on columns "type" */
  EnumWhitelistTypesPkey = 'enum_whitelist_types_pkey'
}

/** input type for inserting data into table "enum_whitelist_types" */
export type EnumWhitelistTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EnumWhitelistTypesMaxFields = {
  __typename?: 'enum_whitelist_types_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EnumWhitelistTypesMinFields = {
  __typename?: 'enum_whitelist_types_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_whitelist_types" */
export type EnumWhitelistTypesMutationResponse = {
  __typename?: 'enum_whitelist_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumWhitelistTypes>;
};

/** on_conflict condition type for table "enum_whitelist_types" */
export type EnumWhitelistTypesOnConflict = {
  constraint: EnumWhitelistTypesConstraint;
  update_columns?: Array<EnumWhitelistTypesUpdateColumn>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};

/** Ordering options when selecting data from "enum_whitelist_types". */
export type EnumWhitelistTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: enum_whitelist_types */
export type EnumWhitelistTypesPkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "enum_whitelist_types" */
export enum EnumWhitelistTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enum_whitelist_types" */
export type EnumWhitelistTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enum_whitelist_types" */
export type EnumWhitelistTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EnumWhitelistTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumWhitelistTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_whitelist_types" */
export enum EnumWhitelistTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type EnumWhitelistTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumWhitelistTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EnumWhitelistTypesBoolExp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "generated_id_view" */
export type GeneratedIdView = {
  __typename?: 'generated_id_view';
  created_at?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "generated_id_view" */
export type GeneratedIdViewAggregate = {
  __typename?: 'generated_id_view_aggregate';
  aggregate?: Maybe<GeneratedIdViewAggregateFields>;
  nodes: Array<GeneratedIdView>;
};

/** aggregate fields of "generated_id_view" */
export type GeneratedIdViewAggregateFields = {
  __typename?: 'generated_id_view_aggregate_fields';
  avg?: Maybe<GeneratedIdViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GeneratedIdViewMaxFields>;
  min?: Maybe<GeneratedIdViewMinFields>;
  stddev?: Maybe<GeneratedIdViewStddevFields>;
  stddev_pop?: Maybe<GeneratedIdViewStddevPopFields>;
  stddev_samp?: Maybe<GeneratedIdViewStddevSampFields>;
  sum?: Maybe<GeneratedIdViewSumFields>;
  var_pop?: Maybe<GeneratedIdViewVarPopFields>;
  var_samp?: Maybe<GeneratedIdViewVarSampFields>;
  variance?: Maybe<GeneratedIdViewVarianceFields>;
};


/** aggregate fields of "generated_id_view" */
export type GeneratedIdViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GeneratedIdViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GeneratedIdViewAvgFields = {
  __typename?: 'generated_id_view_avg_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "generated_id_view". All fields are combined with a logical 'AND'. */
export type GeneratedIdViewBoolExp = {
  _and?: InputMaybe<Array<GeneratedIdViewBoolExp>>;
  _not?: InputMaybe<GeneratedIdViewBoolExp>;
  _or?: InputMaybe<Array<GeneratedIdViewBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_result_id?: InputMaybe<UuidComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  violation_case_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type GeneratedIdViewMaxFields = {
  __typename?: 'generated_id_view_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type GeneratedIdViewMinFields = {
  __typename?: 'generated_id_view_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_result_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "generated_id_view". */
export type GeneratedIdViewOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_result_id?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** select columns of table "generated_id_view" */
export enum GeneratedIdViewSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultId = 'parking_result_id',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

/** aggregate stddev on columns */
export type GeneratedIdViewStddevFields = {
  __typename?: 'generated_id_view_stddev_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GeneratedIdViewStddevPopFields = {
  __typename?: 'generated_id_view_stddev_pop_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GeneratedIdViewStddevSampFields = {
  __typename?: 'generated_id_view_stddev_samp_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "generated_id_view" */
export type GeneratedIdViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GeneratedIdViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeneratedIdViewStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_result_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type GeneratedIdViewSumFields = {
  __typename?: 'generated_id_view_sum_fields';
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type GeneratedIdViewVarPopFields = {
  __typename?: 'generated_id_view_var_pop_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GeneratedIdViewVarSampFields = {
  __typename?: 'generated_id_view_var_samp_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GeneratedIdViewVarianceFields = {
  __typename?: 'generated_id_view_variance_fields';
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "guest_jwt" */
export type GuestJwt = {
  __typename?: 'guest_jwt';
  anonymous: Scalars['Boolean'];
  /** An object relationship */
  calendar_event_policy?: Maybe<CalendarEventPolicy>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  expires_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  language: Scalars['String'];
  lot_ids: Scalars['jsonb'];
  previous_token?: Maybe<Scalars['String']>;
  purpose: EnumGuestJwtPurposeEnum;
  qr_metadata?: Maybe<Scalars['Int']>;
  /** An array relationship */
  qrs: Array<GuestQr>;
  /** An aggregate relationship */
  qrs_aggregate: GuestQrAggregate;
  scans_per_day?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  token_expiration_in_days?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
  validity_policy?: Maybe<Scalars['bigint']>;
  whitelist_duration?: Maybe<Scalars['String']>;
};


/** columns and relationships of "guest_jwt" */
export type GuestJwtLotIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "guest_jwt" */
export type GuestJwtQrsArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


/** columns and relationships of "guest_jwt" */
export type GuestJwtQrsAggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};

/** aggregated selection of "guest_jwt" */
export type GuestJwtAggregate = {
  __typename?: 'guest_jwt_aggregate';
  aggregate?: Maybe<GuestJwtAggregateFields>;
  nodes: Array<GuestJwt>;
};

/** aggregate fields of "guest_jwt" */
export type GuestJwtAggregateFields = {
  __typename?: 'guest_jwt_aggregate_fields';
  avg?: Maybe<GuestJwtAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GuestJwtMaxFields>;
  min?: Maybe<GuestJwtMinFields>;
  stddev?: Maybe<GuestJwtStddevFields>;
  stddev_pop?: Maybe<GuestJwtStddevPopFields>;
  stddev_samp?: Maybe<GuestJwtStddevSampFields>;
  sum?: Maybe<GuestJwtSumFields>;
  var_pop?: Maybe<GuestJwtVarPopFields>;
  var_samp?: Maybe<GuestJwtVarSampFields>;
  variance?: Maybe<GuestJwtVarianceFields>;
};


/** aggregate fields of "guest_jwt" */
export type GuestJwtAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GuestJwtSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GuestJwtAppendInput = {
  lot_ids?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type GuestJwtAvgFields = {
  __typename?: 'guest_jwt_avg_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "guest_jwt". All fields are combined with a logical 'AND'. */
export type GuestJwtBoolExp = {
  _and?: InputMaybe<Array<GuestJwtBoolExp>>;
  _not?: InputMaybe<GuestJwtBoolExp>;
  _or?: InputMaybe<Array<GuestJwtBoolExp>>;
  anonymous?: InputMaybe<BooleanComparisonExp>;
  calendar_event_policy?: InputMaybe<CalendarEventPolicyBoolExp>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  expires_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  language?: InputMaybe<StringComparisonExp>;
  lot_ids?: InputMaybe<JsonbComparisonExp>;
  previous_token?: InputMaybe<StringComparisonExp>;
  purpose?: InputMaybe<EnumGuestJwtPurposeEnumComparisonExp>;
  qr_metadata?: InputMaybe<IntComparisonExp>;
  qrs?: InputMaybe<GuestQrBoolExp>;
  qrs_aggregate?: InputMaybe<GuestQrAggregateBoolExp>;
  scans_per_day?: InputMaybe<IntComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
  token_expiration_in_days?: InputMaybe<IntComparisonExp>;
  transferred_to?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
  validity_policy?: InputMaybe<BigintComparisonExp>;
  whitelist_duration?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "guest_jwt" */
export enum GuestJwtConstraint {
  /** unique or primary key constraint on columns "id" */
  GuestJwtPkey = 'guest_jwt_pkey',
  /** unique or primary key constraint on columns "uuid" */
  GuestJwtUuidKey = 'guest_jwt_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GuestJwtDeleteAtPathInput = {
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GuestJwtDeleteElemInput = {
  lot_ids?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GuestJwtDeleteKeyInput = {
  lot_ids?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "guest_jwt" */
export type GuestJwtIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  qr_metadata?: InputMaybe<Scalars['Int']>;
  scans_per_day?: InputMaybe<Scalars['Int']>;
  token_expiration_in_days?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['Int']>;
  validity_policy?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "guest_jwt" */
export type GuestJwtInsertInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  calendar_event_policy?: InputMaybe<CalendarEventPolicyObjRelInsertInput>;
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  lot_ids?: InputMaybe<Scalars['jsonb']>;
  previous_token?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<EnumGuestJwtPurposeEnum>;
  qr_metadata?: InputMaybe<Scalars['Int']>;
  qrs?: InputMaybe<GuestQrArrRelInsertInput>;
  scans_per_day?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  token_expiration_in_days?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
  validity_policy?: InputMaybe<Scalars['bigint']>;
  whitelist_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GuestJwtMaxFields = {
  __typename?: 'guest_jwt_max_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  previous_token?: Maybe<Scalars['String']>;
  qr_metadata?: Maybe<Scalars['Int']>;
  scans_per_day?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  token_expiration_in_days?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
  validity_policy?: Maybe<Scalars['bigint']>;
  whitelist_duration?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GuestJwtMinFields = {
  __typename?: 'guest_jwt_min_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  previous_token?: Maybe<Scalars['String']>;
  qr_metadata?: Maybe<Scalars['Int']>;
  scans_per_day?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  token_expiration_in_days?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
  validity_policy?: Maybe<Scalars['bigint']>;
  whitelist_duration?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "guest_jwt" */
export type GuestJwtMutationResponse = {
  __typename?: 'guest_jwt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GuestJwt>;
};

/** input type for inserting object relation for remote table "guest_jwt" */
export type GuestJwtObjRelInsertInput = {
  data: GuestJwtInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestJwtOnConflict>;
};

/** on_conflict condition type for table "guest_jwt" */
export type GuestJwtOnConflict = {
  constraint: GuestJwtConstraint;
  update_columns?: Array<GuestJwtUpdateColumn>;
  where?: InputMaybe<GuestJwtBoolExp>;
};

/** Ordering options when selecting data from "guest_jwt". */
export type GuestJwtOrderBy = {
  anonymous?: InputMaybe<OrderBy>;
  calendar_event_policy?: InputMaybe<CalendarEventPolicyOrderBy>;
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  expires_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  lot_ids?: InputMaybe<OrderBy>;
  previous_token?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
  qr_metadata?: InputMaybe<OrderBy>;
  qrs_aggregate?: InputMaybe<GuestQrAggregateOrderBy>;
  scans_per_day?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  token_expiration_in_days?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  validity_policy?: InputMaybe<OrderBy>;
  whitelist_duration?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: guest_jwt */
export type GuestJwtPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GuestJwtPrependInput = {
  lot_ids?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "guest_jwt" */
export enum GuestJwtSelectColumn {
  /** column name */
  Anonymous = 'anonymous',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LotIds = 'lot_ids',
  /** column name */
  PreviousToken = 'previous_token',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  QrMetadata = 'qr_metadata',
  /** column name */
  ScansPerDay = 'scans_per_day',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpirationInDays = 'token_expiration_in_days',
  /** column name */
  TransferredTo = 'transferred_to',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidityPolicy = 'validity_policy',
  /** column name */
  WhitelistDuration = 'whitelist_duration'
}

/** input type for updating data in table "guest_jwt" */
export type GuestJwtSetInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  lot_ids?: InputMaybe<Scalars['jsonb']>;
  previous_token?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<EnumGuestJwtPurposeEnum>;
  qr_metadata?: InputMaybe<Scalars['Int']>;
  scans_per_day?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  token_expiration_in_days?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
  validity_policy?: InputMaybe<Scalars['bigint']>;
  whitelist_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GuestJwtStddevFields = {
  __typename?: 'guest_jwt_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GuestJwtStddevPopFields = {
  __typename?: 'guest_jwt_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GuestJwtStddevSampFields = {
  __typename?: 'guest_jwt_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "guest_jwt" */
export type GuestJwtStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GuestJwtStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GuestJwtStreamCursorValueInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  lot_ids?: InputMaybe<Scalars['jsonb']>;
  previous_token?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<EnumGuestJwtPurposeEnum>;
  qr_metadata?: InputMaybe<Scalars['Int']>;
  scans_per_day?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  token_expiration_in_days?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
  validity_policy?: InputMaybe<Scalars['bigint']>;
  whitelist_duration?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GuestJwtSumFields = {
  __typename?: 'guest_jwt_sum_fields';
  id?: Maybe<Scalars['Int']>;
  qr_metadata?: Maybe<Scalars['Int']>;
  scans_per_day?: Maybe<Scalars['Int']>;
  token_expiration_in_days?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['Int']>;
  validity_policy?: Maybe<Scalars['bigint']>;
};

/** update columns of table "guest_jwt" */
export enum GuestJwtUpdateColumn {
  /** column name */
  Anonymous = 'anonymous',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LotIds = 'lot_ids',
  /** column name */
  PreviousToken = 'previous_token',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  QrMetadata = 'qr_metadata',
  /** column name */
  ScansPerDay = 'scans_per_day',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpirationInDays = 'token_expiration_in_days',
  /** column name */
  TransferredTo = 'transferred_to',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidityPolicy = 'validity_policy',
  /** column name */
  WhitelistDuration = 'whitelist_duration'
}

export type GuestJwtUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<GuestJwtAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<GuestJwtDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<GuestJwtDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<GuestJwtDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GuestJwtIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<GuestJwtPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GuestJwtSetInput>;
  /** filter the rows which have to be updated */
  where: GuestJwtBoolExp;
};

/** aggregate var_pop on columns */
export type GuestJwtVarPopFields = {
  __typename?: 'guest_jwt_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GuestJwtVarSampFields = {
  __typename?: 'guest_jwt_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GuestJwtVarianceFields = {
  __typename?: 'guest_jwt_variance_fields';
  id?: Maybe<Scalars['Float']>;
  qr_metadata?: Maybe<Scalars['Float']>;
  scans_per_day?: Maybe<Scalars['Float']>;
  token_expiration_in_days?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  validity_policy?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "guest_qr" */
export type GuestQr = {
  __typename?: 'guest_qr';
  created_at: Scalars['timestamptz'];
  email_for_update: Scalars['String'];
  id: Scalars['Int'];
  jwt_id: Scalars['Int'];
  template: Scalars['String'];
};

/** aggregated selection of "guest_qr" */
export type GuestQrAggregate = {
  __typename?: 'guest_qr_aggregate';
  aggregate?: Maybe<GuestQrAggregateFields>;
  nodes: Array<GuestQr>;
};

export type GuestQrAggregateBoolExp = {
  count?: InputMaybe<GuestQrAggregateBoolExpCount>;
};

export type GuestQrAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GuestQrSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GuestQrBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "guest_qr" */
export type GuestQrAggregateFields = {
  __typename?: 'guest_qr_aggregate_fields';
  avg?: Maybe<GuestQrAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GuestQrMaxFields>;
  min?: Maybe<GuestQrMinFields>;
  stddev?: Maybe<GuestQrStddevFields>;
  stddev_pop?: Maybe<GuestQrStddevPopFields>;
  stddev_samp?: Maybe<GuestQrStddevSampFields>;
  sum?: Maybe<GuestQrSumFields>;
  var_pop?: Maybe<GuestQrVarPopFields>;
  var_samp?: Maybe<GuestQrVarSampFields>;
  variance?: Maybe<GuestQrVarianceFields>;
};


/** aggregate fields of "guest_qr" */
export type GuestQrAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GuestQrSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guest_qr" */
export type GuestQrAggregateOrderBy = {
  avg?: InputMaybe<GuestQrAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GuestQrMaxOrderBy>;
  min?: InputMaybe<GuestQrMinOrderBy>;
  stddev?: InputMaybe<GuestQrStddevOrderBy>;
  stddev_pop?: InputMaybe<GuestQrStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GuestQrStddevSampOrderBy>;
  sum?: InputMaybe<GuestQrSumOrderBy>;
  var_pop?: InputMaybe<GuestQrVarPopOrderBy>;
  var_samp?: InputMaybe<GuestQrVarSampOrderBy>;
  variance?: InputMaybe<GuestQrVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "guest_qr" */
export type GuestQrArrRelInsertInput = {
  data: Array<GuestQrInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestQrOnConflict>;
};

/** aggregate avg on columns */
export type GuestQrAvgFields = {
  __typename?: 'guest_qr_avg_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guest_qr" */
export type GuestQrAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "guest_qr". All fields are combined with a logical 'AND'. */
export type GuestQrBoolExp = {
  _and?: InputMaybe<Array<GuestQrBoolExp>>;
  _not?: InputMaybe<GuestQrBoolExp>;
  _or?: InputMaybe<Array<GuestQrBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email_for_update?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  jwt_id?: InputMaybe<IntComparisonExp>;
  template?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "guest_qr" */
export enum GuestQrConstraint {
  /** unique or primary key constraint on columns "email_for_update", "jwt_id" */
  GuestQrJwtIdEmailForUpdateKey = 'guest_qr_jwt_id_email_for_update_key',
  /** unique or primary key constraint on columns "id" */
  GuestQrPkey = 'guest_qr_pkey'
}

/** input type for incrementing numeric columns in table "guest_qr" */
export type GuestQrIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "guest_qr" */
export type GuestQrInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_for_update?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GuestQrMaxFields = {
  __typename?: 'guest_qr_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_for_update?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jwt_id?: Maybe<Scalars['Int']>;
  template?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "guest_qr" */
export type GuestQrMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  email_for_update?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GuestQrMinFields = {
  __typename?: 'guest_qr_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_for_update?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jwt_id?: Maybe<Scalars['Int']>;
  template?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "guest_qr" */
export type GuestQrMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  email_for_update?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "guest_qr" */
export type GuestQrMutationResponse = {
  __typename?: 'guest_qr_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GuestQr>;
};

/** on_conflict condition type for table "guest_qr" */
export type GuestQrOnConflict = {
  constraint: GuestQrConstraint;
  update_columns?: Array<GuestQrUpdateColumn>;
  where?: InputMaybe<GuestQrBoolExp>;
};

/** Ordering options when selecting data from "guest_qr". */
export type GuestQrOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  email_for_update?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: guest_qr */
export type GuestQrPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "guest_qr" */
export enum GuestQrSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailForUpdate = 'email_for_update',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  Template = 'template'
}

/** input type for updating data in table "guest_qr" */
export type GuestQrSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_for_update?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GuestQrStddevFields = {
  __typename?: 'guest_qr_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guest_qr" */
export type GuestQrStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GuestQrStddevPopFields = {
  __typename?: 'guest_qr_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guest_qr" */
export type GuestQrStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GuestQrStddevSampFields = {
  __typename?: 'guest_qr_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guest_qr" */
export type GuestQrStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "guest_qr" */
export type GuestQrStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GuestQrStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GuestQrStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_for_update?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GuestQrSumFields = {
  __typename?: 'guest_qr_sum_fields';
  id?: Maybe<Scalars['Int']>;
  jwt_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "guest_qr" */
export type GuestQrSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** update columns of table "guest_qr" */
export enum GuestQrUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailForUpdate = 'email_for_update',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  Template = 'template'
}

export type GuestQrUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GuestQrIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GuestQrSetInput>;
  /** filter the rows which have to be updated */
  where: GuestQrBoolExp;
};

/** aggregate var_pop on columns */
export type GuestQrVarPopFields = {
  __typename?: 'guest_qr_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guest_qr" */
export type GuestQrVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GuestQrVarSampFields = {
  __typename?: 'guest_qr_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guest_qr" */
export type GuestQrVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GuestQrVarianceFields = {
  __typename?: 'guest_qr_variance_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guest_qr" */
export type GuestQrVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type InetComparisonExp = {
  _eq?: InputMaybe<Scalars['inet']>;
  _gt?: InputMaybe<Scalars['inet']>;
  _gte?: InputMaybe<Scalars['inet']>;
  _in?: InputMaybe<Array<Scalars['inet']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['inet']>;
  _lte?: InputMaybe<Scalars['inet']>;
  _neq?: InputMaybe<Scalars['inet']>;
  _nin?: InputMaybe<Array<Scalars['inet']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lot" */
export type Lot = {
  __typename?: 'lot';
  address: Scalars['String'];
  /** An object relationship */
  carpay_lot?: Maybe<CarpayLot>;
  cepik_registration_date?: Maybe<Scalars['date']>;
  country?: Maybe<Scalars['String']>;
  /** An object relationship */
  country_object?: Maybe<Country>;
  country_uuid?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  go_live_date?: Maybe<Scalars['date']>;
  id: Scalars['String'];
  kba_registered: Scalars['Boolean'];
  latitude?: Maybe<Scalars['numeric']>;
  legal_language: Scalars['String'];
  longitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lot_display_names: Array<LotDisplayName>;
  /** An aggregate relationship */
  lot_display_names_aggregate: LotDisplayNameAggregate;
  /** An array relationship */
  lot_hierarchies: Array<LotHierarchy>;
  /** An aggregate relationship */
  lot_hierarchies_aggregate: LotHierarchyAggregate;
  /** An array relationship */
  lot_sections: Array<LotSection>;
  /** An aggregate relationship */
  lot_sections_aggregate: LotSectionAggregate;
  name: Scalars['String'];
  /** An array relationship */
  parking_contexts: Array<ParkingContext>;
  /** An aggregate relationship */
  parking_contexts_aggregate: ParkingContextAggregate;
  rental_policy?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  rental_pricings: Array<RentalPricing>;
  /** An aggregate relationship */
  rental_pricings_aggregate: RentalPricingAggregate;
  size?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  tax?: Maybe<Tax>;
  tax_uuid?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  whitelists: Array<Whitelist>;
  /** An aggregate relationship */
  whitelists_aggregate: WhitelistAggregate;
};


/** columns and relationships of "lot" */
export type LotLotDisplayNamesArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


/** columns and relationships of "lot" */
export type LotLotDisplayNamesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


/** columns and relationships of "lot" */
export type LotLotHierarchiesArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


/** columns and relationships of "lot" */
export type LotLotHierarchiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


/** columns and relationships of "lot" */
export type LotLotSectionsArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


/** columns and relationships of "lot" */
export type LotLotSectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


/** columns and relationships of "lot" */
export type LotParkingContextsArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


/** columns and relationships of "lot" */
export type LotParkingContextsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


/** columns and relationships of "lot" */
export type LotRentalPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "lot" */
export type LotRentalPricingsArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


/** columns and relationships of "lot" */
export type LotRentalPricingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


/** columns and relationships of "lot" */
export type LotWhitelistsArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


/** columns and relationships of "lot" */
export type LotWhitelistsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};

/** aggregated selection of "lot" */
export type LotAggregate = {
  __typename?: 'lot_aggregate';
  aggregate?: Maybe<LotAggregateFields>;
  nodes: Array<Lot>;
};

export type LotAggregateBoolExp = {
  bool_and?: InputMaybe<LotAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<LotAggregateBoolExpBoolOr>;
  count?: InputMaybe<LotAggregateBoolExpCount>;
};

export type LotAggregateBoolExpBoolAnd = {
  arguments: LotSelectColumnLotAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LotAggregateBoolExpBoolOr = {
  arguments: LotSelectColumnLotAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LotAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lot" */
export type LotAggregateFields = {
  __typename?: 'lot_aggregate_fields';
  avg?: Maybe<LotAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LotMaxFields>;
  min?: Maybe<LotMinFields>;
  stddev?: Maybe<LotStddevFields>;
  stddev_pop?: Maybe<LotStddevPopFields>;
  stddev_samp?: Maybe<LotStddevSampFields>;
  sum?: Maybe<LotSumFields>;
  var_pop?: Maybe<LotVarPopFields>;
  var_samp?: Maybe<LotVarSampFields>;
  variance?: Maybe<LotVarianceFields>;
};


/** aggregate fields of "lot" */
export type LotAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lot" */
export type LotAggregateOrderBy = {
  avg?: InputMaybe<LotAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LotMaxOrderBy>;
  min?: InputMaybe<LotMinOrderBy>;
  stddev?: InputMaybe<LotStddevOrderBy>;
  stddev_pop?: InputMaybe<LotStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LotStddevSampOrderBy>;
  sum?: InputMaybe<LotSumOrderBy>;
  var_pop?: InputMaybe<LotVarPopOrderBy>;
  var_samp?: InputMaybe<LotVarSampOrderBy>;
  variance?: InputMaybe<LotVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LotAppendInput = {
  rental_policy?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "lot" */
export type LotArrRelInsertInput = {
  data: Array<LotInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LotOnConflict>;
};

/** aggregate avg on columns */
export type LotAvgFields = {
  __typename?: 'lot_avg_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lot" */
export type LotAvgOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lot". All fields are combined with a logical 'AND'. */
export type LotBoolExp = {
  _and?: InputMaybe<Array<LotBoolExp>>;
  _not?: InputMaybe<LotBoolExp>;
  _or?: InputMaybe<Array<LotBoolExp>>;
  address?: InputMaybe<StringComparisonExp>;
  carpay_lot?: InputMaybe<CarpayLotBoolExp>;
  cepik_registration_date?: InputMaybe<DateComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  country_object?: InputMaybe<CountryBoolExp>;
  country_uuid?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  go_live_date?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  kba_registered?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  legal_language?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  lot_display_names?: InputMaybe<LotDisplayNameBoolExp>;
  lot_display_names_aggregate?: InputMaybe<LotDisplayNameAggregateBoolExp>;
  lot_hierarchies?: InputMaybe<LotHierarchyBoolExp>;
  lot_hierarchies_aggregate?: InputMaybe<LotHierarchyAggregateBoolExp>;
  lot_sections?: InputMaybe<LotSectionBoolExp>;
  lot_sections_aggregate?: InputMaybe<LotSectionAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  parking_contexts?: InputMaybe<ParkingContextBoolExp>;
  parking_contexts_aggregate?: InputMaybe<ParkingContextAggregateBoolExp>;
  rental_policy?: InputMaybe<JsonbComparisonExp>;
  rental_pricings?: InputMaybe<RentalPricingBoolExp>;
  rental_pricings_aggregate?: InputMaybe<RentalPricingAggregateBoolExp>;
  size?: InputMaybe<IntComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  tax?: InputMaybe<TaxBoolExp>;
  tax_uuid?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelists?: InputMaybe<WhitelistBoolExp>;
  whitelists_aggregate?: InputMaybe<WhitelistAggregateBoolExp>;
};

/** columns and relationships of "lot_config_group" */
export type LotConfigGroup = {
  __typename?: 'lot_config_group';
  config_group_id: Scalars['bigint'];
  id: Scalars['bigint'];
  lot_id: Scalars['String'];
};

/** aggregated selection of "lot_config_group" */
export type LotConfigGroupAggregate = {
  __typename?: 'lot_config_group_aggregate';
  aggregate?: Maybe<LotConfigGroupAggregateFields>;
  nodes: Array<LotConfigGroup>;
};

/** aggregate fields of "lot_config_group" */
export type LotConfigGroupAggregateFields = {
  __typename?: 'lot_config_group_aggregate_fields';
  avg?: Maybe<LotConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LotConfigGroupMaxFields>;
  min?: Maybe<LotConfigGroupMinFields>;
  stddev?: Maybe<LotConfigGroupStddevFields>;
  stddev_pop?: Maybe<LotConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<LotConfigGroupStddevSampFields>;
  sum?: Maybe<LotConfigGroupSumFields>;
  var_pop?: Maybe<LotConfigGroupVarPopFields>;
  var_samp?: Maybe<LotConfigGroupVarSampFields>;
  variance?: Maybe<LotConfigGroupVarianceFields>;
};


/** aggregate fields of "lot_config_group" */
export type LotConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LotConfigGroupAvgFields = {
  __typename?: 'lot_config_group_avg_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lot_config_group". All fields are combined with a logical 'AND'. */
export type LotConfigGroupBoolExp = {
  _and?: InputMaybe<Array<LotConfigGroupBoolExp>>;
  _not?: InputMaybe<LotConfigGroupBoolExp>;
  _or?: InputMaybe<Array<LotConfigGroupBoolExp>>;
  config_group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lot_config_group" */
export enum LotConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  LotConfigGroupPkey = 'lot_config_group_pkey'
}

/** input type for incrementing numeric columns in table "lot_config_group" */
export type LotConfigGroupIncInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lot_config_group" */
export type LotConfigGroupInsertInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LotConfigGroupMaxFields = {
  __typename?: 'lot_config_group_max_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LotConfigGroupMinFields = {
  __typename?: 'lot_config_group_min_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lot_config_group" */
export type LotConfigGroupMutationResponse = {
  __typename?: 'lot_config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotConfigGroup>;
};

/** on_conflict condition type for table "lot_config_group" */
export type LotConfigGroupOnConflict = {
  constraint: LotConfigGroupConstraint;
  update_columns?: Array<LotConfigGroupUpdateColumn>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "lot_config_group". */
export type LotConfigGroupOrderBy = {
  config_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_config_group */
export type LotConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lot_config_group" */
export enum LotConfigGroupSelectColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id'
}

/** input type for updating data in table "lot_config_group" */
export type LotConfigGroupSetInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LotConfigGroupStddevFields = {
  __typename?: 'lot_config_group_stddev_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LotConfigGroupStddevPopFields = {
  __typename?: 'lot_config_group_stddev_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LotConfigGroupStddevSampFields = {
  __typename?: 'lot_config_group_stddev_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lot_config_group" */
export type LotConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotConfigGroupStreamCursorValueInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LotConfigGroupSumFields = {
  __typename?: 'lot_config_group_sum_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lot_config_group" */
export enum LotConfigGroupUpdateColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id'
}

export type LotConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LotConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: LotConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type LotConfigGroupVarPopFields = {
  __typename?: 'lot_config_group_var_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LotConfigGroupVarSampFields = {
  __typename?: 'lot_config_group_var_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LotConfigGroupVarianceFields = {
  __typename?: 'lot_config_group_variance_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "lot" */
export enum LotConstraint {
  /** unique or primary key constraint on columns "id" */
  ParkingLotsPkey = 'parking_lots_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LotDeleteAtPathInput = {
  rental_policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LotDeleteElemInput = {
  rental_policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LotDeleteKeyInput = {
  rental_policy?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lot_display_name" */
export type LotDisplayName = {
  __typename?: 'lot_display_name';
  display_name?: Maybe<Scalars['String']>;
  lot_id: Scalars['String'];
};

/** aggregated selection of "lot_display_name" */
export type LotDisplayNameAggregate = {
  __typename?: 'lot_display_name_aggregate';
  aggregate?: Maybe<LotDisplayNameAggregateFields>;
  nodes: Array<LotDisplayName>;
};

export type LotDisplayNameAggregateBoolExp = {
  count?: InputMaybe<LotDisplayNameAggregateBoolExpCount>;
};

export type LotDisplayNameAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotDisplayNameBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lot_display_name" */
export type LotDisplayNameAggregateFields = {
  __typename?: 'lot_display_name_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LotDisplayNameMaxFields>;
  min?: Maybe<LotDisplayNameMinFields>;
};


/** aggregate fields of "lot_display_name" */
export type LotDisplayNameAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lot_display_name" */
export type LotDisplayNameAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LotDisplayNameMaxOrderBy>;
  min?: InputMaybe<LotDisplayNameMinOrderBy>;
};

/** input type for inserting array relation for remote table "lot_display_name" */
export type LotDisplayNameArrRelInsertInput = {
  data: Array<LotDisplayNameInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LotDisplayNameOnConflict>;
};

/** Boolean expression to filter rows from the table "lot_display_name". All fields are combined with a logical 'AND'. */
export type LotDisplayNameBoolExp = {
  _and?: InputMaybe<Array<LotDisplayNameBoolExp>>;
  _not?: InputMaybe<LotDisplayNameBoolExp>;
  _or?: InputMaybe<Array<LotDisplayNameBoolExp>>;
  display_name?: InputMaybe<StringComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lot_display_name" */
export enum LotDisplayNameConstraint {
  /** unique or primary key constraint on columns "lot_id" */
  LotDisplayNamePkey = 'lot_display_name_pkey'
}

/** input type for inserting data into table "lot_display_name" */
export type LotDisplayNameInsertInput = {
  display_name?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LotDisplayNameMaxFields = {
  __typename?: 'lot_display_name_max_fields';
  display_name?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "lot_display_name" */
export type LotDisplayNameMaxOrderBy = {
  display_name?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LotDisplayNameMinFields = {
  __typename?: 'lot_display_name_min_fields';
  display_name?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "lot_display_name" */
export type LotDisplayNameMinOrderBy = {
  display_name?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lot_display_name" */
export type LotDisplayNameMutationResponse = {
  __typename?: 'lot_display_name_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotDisplayName>;
};

/** on_conflict condition type for table "lot_display_name" */
export type LotDisplayNameOnConflict = {
  constraint: LotDisplayNameConstraint;
  update_columns?: Array<LotDisplayNameUpdateColumn>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};

/** Ordering options when selecting data from "lot_display_name". */
export type LotDisplayNameOrderBy = {
  display_name?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_display_name */
export type LotDisplayNamePkColumnsInput = {
  lot_id: Scalars['String'];
};

/** select columns of table "lot_display_name" */
export enum LotDisplayNameSelectColumn {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LotId = 'lot_id'
}

/** input type for updating data in table "lot_display_name" */
export type LotDisplayNameSetInput = {
  display_name?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lot_display_name" */
export type LotDisplayNameStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotDisplayNameStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotDisplayNameStreamCursorValueInput = {
  display_name?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lot_display_name" */
export enum LotDisplayNameUpdateColumn {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LotId = 'lot_id'
}

export type LotDisplayNameUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotDisplayNameSetInput>;
  /** filter the rows which have to be updated */
  where: LotDisplayNameBoolExp;
};

/** Table to model company hierarchies on a parking lot level using the ltree extension */
export type LotHierarchy = {
  __typename?: 'lot_hierarchy';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  lot_id: Scalars['String'];
  path: Scalars['ltree'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "lot_hierarchy" */
export type LotHierarchyAggregate = {
  __typename?: 'lot_hierarchy_aggregate';
  aggregate?: Maybe<LotHierarchyAggregateFields>;
  nodes: Array<LotHierarchy>;
};

export type LotHierarchyAggregateBoolExp = {
  count?: InputMaybe<LotHierarchyAggregateBoolExpCount>;
};

export type LotHierarchyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LotHierarchySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotHierarchyBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lot_hierarchy" */
export type LotHierarchyAggregateFields = {
  __typename?: 'lot_hierarchy_aggregate_fields';
  avg?: Maybe<LotHierarchyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LotHierarchyMaxFields>;
  min?: Maybe<LotHierarchyMinFields>;
  stddev?: Maybe<LotHierarchyStddevFields>;
  stddev_pop?: Maybe<LotHierarchyStddevPopFields>;
  stddev_samp?: Maybe<LotHierarchyStddevSampFields>;
  sum?: Maybe<LotHierarchySumFields>;
  var_pop?: Maybe<LotHierarchyVarPopFields>;
  var_samp?: Maybe<LotHierarchyVarSampFields>;
  variance?: Maybe<LotHierarchyVarianceFields>;
};


/** aggregate fields of "lot_hierarchy" */
export type LotHierarchyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotHierarchySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lot_hierarchy" */
export type LotHierarchyAggregateOrderBy = {
  avg?: InputMaybe<LotHierarchyAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LotHierarchyMaxOrderBy>;
  min?: InputMaybe<LotHierarchyMinOrderBy>;
  stddev?: InputMaybe<LotHierarchyStddevOrderBy>;
  stddev_pop?: InputMaybe<LotHierarchyStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LotHierarchyStddevSampOrderBy>;
  sum?: InputMaybe<LotHierarchySumOrderBy>;
  var_pop?: InputMaybe<LotHierarchyVarPopOrderBy>;
  var_samp?: InputMaybe<LotHierarchyVarSampOrderBy>;
  variance?: InputMaybe<LotHierarchyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lot_hierarchy" */
export type LotHierarchyArrRelInsertInput = {
  data: Array<LotHierarchyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LotHierarchyOnConflict>;
};

/** aggregate avg on columns */
export type LotHierarchyAvgFields = {
  __typename?: 'lot_hierarchy_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lot_hierarchy" */
export type LotHierarchyAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lot_hierarchy". All fields are combined with a logical 'AND'. */
export type LotHierarchyBoolExp = {
  _and?: InputMaybe<Array<LotHierarchyBoolExp>>;
  _not?: InputMaybe<LotHierarchyBoolExp>;
  _or?: InputMaybe<Array<LotHierarchyBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  path?: InputMaybe<LtreeComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lot_hierarchy" */
export enum LotHierarchyConstraint {
  /** unique or primary key constraint on columns "path" */
  LotHierarchyPathKey = 'lot_hierarchy_path_key',
  /** unique or primary key constraint on columns "id" */
  LotHierarchyPkey = 'lot_hierarchy_pkey'
}

/** input type for incrementing numeric columns in table "lot_hierarchy" */
export type LotHierarchyIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lot_hierarchy" */
export type LotHierarchyInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LotHierarchyMaxFields = {
  __typename?: 'lot_hierarchy_max_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lot_hierarchy" */
export type LotHierarchyMaxOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LotHierarchyMinFields = {
  __typename?: 'lot_hierarchy_min_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lot_hierarchy" */
export type LotHierarchyMinOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lot_hierarchy" */
export type LotHierarchyMutationResponse = {
  __typename?: 'lot_hierarchy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotHierarchy>;
};

/** on_conflict condition type for table "lot_hierarchy" */
export type LotHierarchyOnConflict = {
  constraint: LotHierarchyConstraint;
  update_columns?: Array<LotHierarchyUpdateColumn>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};

/** Ordering options when selecting data from "lot_hierarchy". */
export type LotHierarchyOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_hierarchy */
export type LotHierarchyPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lot_hierarchy" */
export enum LotHierarchySelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lot_hierarchy" */
export type LotHierarchySetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LotHierarchyStddevFields = {
  __typename?: 'lot_hierarchy_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lot_hierarchy" */
export type LotHierarchyStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LotHierarchyStddevPopFields = {
  __typename?: 'lot_hierarchy_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lot_hierarchy" */
export type LotHierarchyStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LotHierarchyStddevSampFields = {
  __typename?: 'lot_hierarchy_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lot_hierarchy" */
export type LotHierarchyStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lot_hierarchy" */
export type LotHierarchyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotHierarchyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotHierarchyStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LotHierarchySumFields = {
  __typename?: 'lot_hierarchy_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "lot_hierarchy" */
export type LotHierarchySumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "lot_hierarchy" */
export enum LotHierarchyUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type LotHierarchyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LotHierarchyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotHierarchySetInput>;
  /** filter the rows which have to be updated */
  where: LotHierarchyBoolExp;
};

/** aggregate var_pop on columns */
export type LotHierarchyVarPopFields = {
  __typename?: 'lot_hierarchy_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lot_hierarchy" */
export type LotHierarchyVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LotHierarchyVarSampFields = {
  __typename?: 'lot_hierarchy_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lot_hierarchy" */
export type LotHierarchyVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LotHierarchyVarianceFields = {
  __typename?: 'lot_hierarchy_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lot_hierarchy" */
export type LotHierarchyVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "lot" */
export type LotIncInput = {
  country_uuid?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lot" */
export type LotInsertInput = {
  address?: InputMaybe<Scalars['String']>;
  carpay_lot?: InputMaybe<CarpayLotObjRelInsertInput>;
  cepik_registration_date?: InputMaybe<Scalars['date']>;
  country?: InputMaybe<Scalars['String']>;
  country_object?: InputMaybe<CountryObjRelInsertInput>;
  country_uuid?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  kba_registered?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  legal_language?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  lot_display_names?: InputMaybe<LotDisplayNameArrRelInsertInput>;
  lot_hierarchies?: InputMaybe<LotHierarchyArrRelInsertInput>;
  lot_sections?: InputMaybe<LotSectionArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  parking_contexts?: InputMaybe<ParkingContextArrRelInsertInput>;
  rental_policy?: InputMaybe<Scalars['jsonb']>;
  rental_pricings?: InputMaybe<RentalPricingArrRelInsertInput>;
  size?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<TaxObjRelInsertInput>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelists?: InputMaybe<WhitelistArrRelInsertInput>;
};

/** columns and relationships of "lot_legal_entity" */
export type LotLegalEntity = {
  __typename?: 'lot_legal_entity';
  company_id: Scalars['String'];
  /** An object relationship */
  company_vat_id: CompanyVatId;
  lot_id: Scalars['String'];
  product: ParkdepotProductEnum;
};

/** aggregated selection of "lot_legal_entity" */
export type LotLegalEntityAggregate = {
  __typename?: 'lot_legal_entity_aggregate';
  aggregate?: Maybe<LotLegalEntityAggregateFields>;
  nodes: Array<LotLegalEntity>;
};

/** aggregate fields of "lot_legal_entity" */
export type LotLegalEntityAggregateFields = {
  __typename?: 'lot_legal_entity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LotLegalEntityMaxFields>;
  min?: Maybe<LotLegalEntityMinFields>;
};


/** aggregate fields of "lot_legal_entity" */
export type LotLegalEntityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotLegalEntitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lot_legal_entity". All fields are combined with a logical 'AND'. */
export type LotLegalEntityBoolExp = {
  _and?: InputMaybe<Array<LotLegalEntityBoolExp>>;
  _not?: InputMaybe<LotLegalEntityBoolExp>;
  _or?: InputMaybe<Array<LotLegalEntityBoolExp>>;
  company_id?: InputMaybe<StringComparisonExp>;
  company_vat_id?: InputMaybe<CompanyVatIdBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  product?: InputMaybe<ParkdepotProductEnumComparisonExp>;
};

/** unique or primary key constraints on table "lot_legal_entity" */
export enum LotLegalEntityConstraint {
  /** unique or primary key constraint on columns "product", "lot_id" */
  LotLegalEntityPkey = 'lot_legal_entity_pkey'
}

/** input type for inserting data into table "lot_legal_entity" */
export type LotLegalEntityInsertInput = {
  company_id?: InputMaybe<Scalars['String']>;
  company_vat_id?: InputMaybe<CompanyVatIdObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ParkdepotProductEnum>;
};

/** aggregate max on columns */
export type LotLegalEntityMaxFields = {
  __typename?: 'lot_legal_entity_max_fields';
  company_id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LotLegalEntityMinFields = {
  __typename?: 'lot_legal_entity_min_fields';
  company_id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lot_legal_entity" */
export type LotLegalEntityMutationResponse = {
  __typename?: 'lot_legal_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotLegalEntity>;
};

/** on_conflict condition type for table "lot_legal_entity" */
export type LotLegalEntityOnConflict = {
  constraint: LotLegalEntityConstraint;
  update_columns?: Array<LotLegalEntityUpdateColumn>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};

/** Ordering options when selecting data from "lot_legal_entity". */
export type LotLegalEntityOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  company_vat_id?: InputMaybe<CompanyVatIdOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_legal_entity */
export type LotLegalEntityPkColumnsInput = {
  lot_id: Scalars['String'];
  product: ParkdepotProductEnum;
};

/** select columns of table "lot_legal_entity" */
export enum LotLegalEntitySelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Product = 'product'
}

/** input type for updating data in table "lot_legal_entity" */
export type LotLegalEntitySetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ParkdepotProductEnum>;
};

/** Streaming cursor of the table "lot_legal_entity" */
export type LotLegalEntityStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotLegalEntityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotLegalEntityStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ParkdepotProductEnum>;
};

/** update columns of table "lot_legal_entity" */
export enum LotLegalEntityUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Product = 'product'
}

export type LotLegalEntityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotLegalEntitySetInput>;
  /** filter the rows which have to be updated */
  where: LotLegalEntityBoolExp;
};

/** aggregate max on columns */
export type LotMaxFields = {
  __typename?: 'lot_max_fields';
  address?: Maybe<Scalars['String']>;
  cepik_registration_date?: Maybe<Scalars['date']>;
  country?: Maybe<Scalars['String']>;
  country_uuid?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  legal_language?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  tax_uuid?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lot" */
export type LotMaxOrderBy = {
  address?: InputMaybe<OrderBy>;
  cepik_registration_date?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  country_uuid?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  go_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  legal_language?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LotMinFields = {
  __typename?: 'lot_min_fields';
  address?: Maybe<Scalars['String']>;
  cepik_registration_date?: Maybe<Scalars['date']>;
  country?: Maybe<Scalars['String']>;
  country_uuid?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  legal_language?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  tax_uuid?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lot" */
export type LotMinOrderBy = {
  address?: InputMaybe<OrderBy>;
  cepik_registration_date?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  country_uuid?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  go_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  legal_language?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lot" */
export type LotMutationResponse = {
  __typename?: 'lot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lot>;
};

/** input type for inserting object relation for remote table "lot" */
export type LotObjRelInsertInput = {
  data: LotInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LotOnConflict>;
};

/** on_conflict condition type for table "lot" */
export type LotOnConflict = {
  constraint: LotConstraint;
  update_columns?: Array<LotUpdateColumn>;
  where?: InputMaybe<LotBoolExp>;
};

/** Ordering options when selecting data from "lot". */
export type LotOrderBy = {
  address?: InputMaybe<OrderBy>;
  carpay_lot?: InputMaybe<CarpayLotOrderBy>;
  cepik_registration_date?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  country_object?: InputMaybe<CountryOrderBy>;
  country_uuid?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  go_live_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kba_registered?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  legal_language?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  lot_display_names_aggregate?: InputMaybe<LotDisplayNameAggregateOrderBy>;
  lot_hierarchies_aggregate?: InputMaybe<LotHierarchyAggregateOrderBy>;
  lot_sections_aggregate?: InputMaybe<LotSectionAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  parking_contexts_aggregate?: InputMaybe<ParkingContextAggregateOrderBy>;
  rental_policy?: InputMaybe<OrderBy>;
  rental_pricings_aggregate?: InputMaybe<RentalPricingAggregateOrderBy>;
  size?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  tax?: InputMaybe<TaxOrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelists_aggregate?: InputMaybe<WhitelistAggregateOrderBy>;
};

/** primary key columns input for table: lot */
export type LotPkColumnsInput = {
  id: Scalars['String'];
};

/** columns and relationships of "lot_policy_history" */
export type LotPolicyHistory = {
  __typename?: 'lot_policy_history';
  created_at: Scalars['timestamptz'];
  hasura_user?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  lot_section_id: Scalars['String'];
  new_policy: Scalars['jsonb'];
};


/** columns and relationships of "lot_policy_history" */
export type LotPolicyHistoryNewPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "lot_policy_history" */
export type LotPolicyHistoryAggregate = {
  __typename?: 'lot_policy_history_aggregate';
  aggregate?: Maybe<LotPolicyHistoryAggregateFields>;
  nodes: Array<LotPolicyHistory>;
};

/** aggregate fields of "lot_policy_history" */
export type LotPolicyHistoryAggregateFields = {
  __typename?: 'lot_policy_history_aggregate_fields';
  avg?: Maybe<LotPolicyHistoryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LotPolicyHistoryMaxFields>;
  min?: Maybe<LotPolicyHistoryMinFields>;
  stddev?: Maybe<LotPolicyHistoryStddevFields>;
  stddev_pop?: Maybe<LotPolicyHistoryStddevPopFields>;
  stddev_samp?: Maybe<LotPolicyHistoryStddevSampFields>;
  sum?: Maybe<LotPolicyHistorySumFields>;
  var_pop?: Maybe<LotPolicyHistoryVarPopFields>;
  var_samp?: Maybe<LotPolicyHistoryVarSampFields>;
  variance?: Maybe<LotPolicyHistoryVarianceFields>;
};


/** aggregate fields of "lot_policy_history" */
export type LotPolicyHistoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotPolicyHistorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LotPolicyHistoryAppendInput = {
  new_policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type LotPolicyHistoryAvgFields = {
  __typename?: 'lot_policy_history_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lot_policy_history". All fields are combined with a logical 'AND'. */
export type LotPolicyHistoryBoolExp = {
  _and?: InputMaybe<Array<LotPolicyHistoryBoolExp>>;
  _not?: InputMaybe<LotPolicyHistoryBoolExp>;
  _or?: InputMaybe<Array<LotPolicyHistoryBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  hasura_user?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
  new_policy?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "lot_policy_history" */
export enum LotPolicyHistoryConstraint {
  /** unique or primary key constraint on columns "id" */
  LotPolicyHistoryPkey = 'lot_policy_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LotPolicyHistoryDeleteAtPathInput = {
  new_policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LotPolicyHistoryDeleteElemInput = {
  new_policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LotPolicyHistoryDeleteKeyInput = {
  new_policy?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "lot_policy_history" */
export type LotPolicyHistoryIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lot_policy_history" */
export type LotPolicyHistoryInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hasura_user?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  new_policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type LotPolicyHistoryMaxFields = {
  __typename?: 'lot_policy_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hasura_user?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  lot_section_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LotPolicyHistoryMinFields = {
  __typename?: 'lot_policy_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hasura_user?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  lot_section_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lot_policy_history" */
export type LotPolicyHistoryMutationResponse = {
  __typename?: 'lot_policy_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotPolicyHistory>;
};

/** on_conflict condition type for table "lot_policy_history" */
export type LotPolicyHistoryOnConflict = {
  constraint: LotPolicyHistoryConstraint;
  update_columns?: Array<LotPolicyHistoryUpdateColumn>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};

/** Ordering options when selecting data from "lot_policy_history". */
export type LotPolicyHistoryOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  hasura_user?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  new_policy?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_policy_history */
export type LotPolicyHistoryPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LotPolicyHistoryPrependInput = {
  new_policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "lot_policy_history" */
export enum LotPolicyHistorySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  NewPolicy = 'new_policy'
}

/** input type for updating data in table "lot_policy_history" */
export type LotPolicyHistorySetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hasura_user?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  new_policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type LotPolicyHistoryStddevFields = {
  __typename?: 'lot_policy_history_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LotPolicyHistoryStddevPopFields = {
  __typename?: 'lot_policy_history_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LotPolicyHistoryStddevSampFields = {
  __typename?: 'lot_policy_history_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lot_policy_history" */
export type LotPolicyHistoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotPolicyHistoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotPolicyHistoryStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hasura_user?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  new_policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type LotPolicyHistorySumFields = {
  __typename?: 'lot_policy_history_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lot_policy_history" */
export enum LotPolicyHistoryUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasuraUser = 'hasura_user',
  /** column name */
  Id = 'id',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  NewPolicy = 'new_policy'
}

export type LotPolicyHistoryUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LotPolicyHistoryAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LotPolicyHistoryDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LotPolicyHistoryDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LotPolicyHistoryDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LotPolicyHistoryIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LotPolicyHistoryPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotPolicyHistorySetInput>;
  /** filter the rows which have to be updated */
  where: LotPolicyHistoryBoolExp;
};

/** aggregate var_pop on columns */
export type LotPolicyHistoryVarPopFields = {
  __typename?: 'lot_policy_history_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LotPolicyHistoryVarSampFields = {
  __typename?: 'lot_policy_history_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LotPolicyHistoryVarianceFields = {
  __typename?: 'lot_policy_history_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LotPrependInput = {
  rental_policy?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "lot_section" */
export type LotSection = {
  __typename?: 'lot_section';
  /** An array relationship */
  company_lot_sections: Array<CompanyLotSection>;
  /** An aggregate relationship */
  company_lot_sections_aggregate: CompanyLotSectionAggregate;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  daily_failures: Array<DailyFailure>;
  /** An aggregate relationship */
  daily_failures_aggregate: DailyFailureAggregate;
  /** An array relationship */
  daily_stats: Array<DailyStats>;
  /** An aggregate relationship */
  daily_stats_aggregate: DailyStatsAggregate;
  id: Scalars['String'];
  /** An object relationship */
  lot: Lot;
  lot_id: Scalars['String'];
  policy?: Maybe<Scalars['jsonb']>;
  section_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "lot_section" */
export type LotSectionCompanyLotSectionsArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionCompanyLotSectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionDailyFailuresArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionDailyFailuresAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionDailyStatsArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionDailyStatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


/** columns and relationships of "lot_section" */
export type LotSectionPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "lot_section" */
export type LotSectionAggregate = {
  __typename?: 'lot_section_aggregate';
  aggregate?: Maybe<LotSectionAggregateFields>;
  nodes: Array<LotSection>;
};

export type LotSectionAggregateBoolExp = {
  count?: InputMaybe<LotSectionAggregateBoolExpCount>;
};

export type LotSectionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LotSectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LotSectionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lot_section" */
export type LotSectionAggregateFields = {
  __typename?: 'lot_section_aggregate_fields';
  avg?: Maybe<LotSectionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LotSectionMaxFields>;
  min?: Maybe<LotSectionMinFields>;
  stddev?: Maybe<LotSectionStddevFields>;
  stddev_pop?: Maybe<LotSectionStddevPopFields>;
  stddev_samp?: Maybe<LotSectionStddevSampFields>;
  sum?: Maybe<LotSectionSumFields>;
  var_pop?: Maybe<LotSectionVarPopFields>;
  var_samp?: Maybe<LotSectionVarSampFields>;
  variance?: Maybe<LotSectionVarianceFields>;
};


/** aggregate fields of "lot_section" */
export type LotSectionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LotSectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lot_section" */
export type LotSectionAggregateOrderBy = {
  avg?: InputMaybe<LotSectionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LotSectionMaxOrderBy>;
  min?: InputMaybe<LotSectionMinOrderBy>;
  stddev?: InputMaybe<LotSectionStddevOrderBy>;
  stddev_pop?: InputMaybe<LotSectionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LotSectionStddevSampOrderBy>;
  sum?: InputMaybe<LotSectionSumOrderBy>;
  var_pop?: InputMaybe<LotSectionVarPopOrderBy>;
  var_samp?: InputMaybe<LotSectionVarSampOrderBy>;
  variance?: InputMaybe<LotSectionVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LotSectionAppendInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "lot_section" */
export type LotSectionArrRelInsertInput = {
  data: Array<LotSectionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LotSectionOnConflict>;
};

/** aggregate avg on columns */
export type LotSectionAvgFields = {
  __typename?: 'lot_section_avg_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lot_section" */
export type LotSectionAvgOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lot_section". All fields are combined with a logical 'AND'. */
export type LotSectionBoolExp = {
  _and?: InputMaybe<Array<LotSectionBoolExp>>;
  _not?: InputMaybe<LotSectionBoolExp>;
  _or?: InputMaybe<Array<LotSectionBoolExp>>;
  company_lot_sections?: InputMaybe<CompanyLotSectionBoolExp>;
  company_lot_sections_aggregate?: InputMaybe<CompanyLotSectionAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  daily_failures?: InputMaybe<DailyFailureBoolExp>;
  daily_failures_aggregate?: InputMaybe<DailyFailureAggregateBoolExp>;
  daily_stats?: InputMaybe<DailyStatsBoolExp>;
  daily_stats_aggregate?: InputMaybe<DailyStatsAggregateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  policy?: InputMaybe<JsonbComparisonExp>;
  section_id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lot_section" */
export enum LotSectionConstraint {
  /** unique or primary key constraint on columns "section_id", "lot_id" */
  LotSectionLotIdSectionIdKey = 'lot_section_lot_id_section_id_key',
  /** unique or primary key constraint on columns "id" */
  LotSectionPkey = 'lot_section_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LotSectionDeleteAtPathInput = {
  policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LotSectionDeleteElemInput = {
  policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LotSectionDeleteKeyInput = {
  policy?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "lot_section" */
export type LotSectionIncInput = {
  section_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lot_section" */
export type LotSectionInsertInput = {
  company_lot_sections?: InputMaybe<CompanyLotSectionArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  daily_failures?: InputMaybe<DailyFailureArrRelInsertInput>;
  daily_stats?: InputMaybe<DailyStatsArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  section_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LotSectionMaxFields = {
  __typename?: 'lot_section_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lot_section" */
export type LotSectionMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LotSectionMinFields = {
  __typename?: 'lot_section_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  lot_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lot_section" */
export type LotSectionMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lot_section" */
export type LotSectionMutationResponse = {
  __typename?: 'lot_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LotSection>;
};

/** input type for inserting object relation for remote table "lot_section" */
export type LotSectionObjRelInsertInput = {
  data: LotSectionInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LotSectionOnConflict>;
};

/** on_conflict condition type for table "lot_section" */
export type LotSectionOnConflict = {
  constraint: LotSectionConstraint;
  update_columns?: Array<LotSectionUpdateColumn>;
  where?: InputMaybe<LotSectionBoolExp>;
};

/** Ordering options when selecting data from "lot_section". */
export type LotSectionOrderBy = {
  company_lot_sections_aggregate?: InputMaybe<CompanyLotSectionAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  daily_failures_aggregate?: InputMaybe<DailyFailureAggregateOrderBy>;
  daily_stats_aggregate?: InputMaybe<DailyStatsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  section_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lot_section */
export type LotSectionPkColumnsInput = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LotSectionPrependInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "lot_section" */
export enum LotSectionSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lot_section" */
export type LotSectionSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  section_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LotSectionStddevFields = {
  __typename?: 'lot_section_stddev_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lot_section" */
export type LotSectionStddevOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LotSectionStddevPopFields = {
  __typename?: 'lot_section_stddev_pop_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lot_section" */
export type LotSectionStddevPopOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LotSectionStddevSampFields = {
  __typename?: 'lot_section_stddev_samp_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lot_section" */
export type LotSectionStddevSampOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lot_section" */
export type LotSectionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotSectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotSectionStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  section_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LotSectionSumFields = {
  __typename?: 'lot_section_sum_fields';
  section_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lot_section" */
export type LotSectionSumOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** update columns of table "lot_section" */
export enum LotSectionUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type LotSectionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LotSectionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LotSectionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LotSectionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LotSectionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LotSectionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LotSectionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotSectionSetInput>;
  /** filter the rows which have to be updated */
  where: LotSectionBoolExp;
};

/** aggregate var_pop on columns */
export type LotSectionVarPopFields = {
  __typename?: 'lot_section_var_pop_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lot_section" */
export type LotSectionVarPopOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LotSectionVarSampFields = {
  __typename?: 'lot_section_var_samp_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lot_section" */
export type LotSectionVarSampOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LotSectionVarianceFields = {
  __typename?: 'lot_section_variance_fields';
  section_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lot_section" */
export type LotSectionVarianceOrderBy = {
  section_id?: InputMaybe<OrderBy>;
};

/** select columns of table "lot" */
export enum LotSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CepikRegistrationDate = 'cepik_registration_date',
  /** column name */
  Country = 'country',
  /** column name */
  CountryUuid = 'country_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  KbaRegistered = 'kba_registered',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LegalLanguage = 'legal_language',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  RentalPolicy = 'rental_policy',
  /** column name */
  Size = 'size',
  /** column name */
  State = 'state',
  /** column name */
  TaxUuid = 'tax_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "lot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lot" */
export enum LotSelectColumnLotAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  KbaRegistered = 'kba_registered'
}

/** select "lot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lot" */
export enum LotSelectColumnLotAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  KbaRegistered = 'kba_registered'
}

/** input type for updating data in table "lot" */
export type LotSetInput = {
  address?: InputMaybe<Scalars['String']>;
  cepik_registration_date?: InputMaybe<Scalars['date']>;
  country?: InputMaybe<Scalars['String']>;
  country_uuid?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  kba_registered?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  legal_language?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  rental_policy?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LotStddevFields = {
  __typename?: 'lot_stddev_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lot" */
export type LotStddevOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LotStddevPopFields = {
  __typename?: 'lot_stddev_pop_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lot" */
export type LotStddevPopOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LotStddevSampFields = {
  __typename?: 'lot_stddev_samp_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lot" */
export type LotStddevSampOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lot" */
export type LotStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LotStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LotStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']>;
  cepik_registration_date?: InputMaybe<Scalars['date']>;
  country?: InputMaybe<Scalars['String']>;
  country_uuid?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['String']>;
  kba_registered?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  legal_language?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  rental_policy?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LotSumFields = {
  __typename?: 'lot_sum_fields';
  country_uuid?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tax_uuid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lot" */
export type LotSumOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** update columns of table "lot" */
export enum LotUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CepikRegistrationDate = 'cepik_registration_date',
  /** column name */
  Country = 'country',
  /** column name */
  CountryUuid = 'country_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  KbaRegistered = 'kba_registered',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LegalLanguage = 'legal_language',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  RentalPolicy = 'rental_policy',
  /** column name */
  Size = 'size',
  /** column name */
  State = 'state',
  /** column name */
  TaxUuid = 'tax_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type LotUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LotAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LotDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LotDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LotDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LotIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LotPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LotSetInput>;
  /** filter the rows which have to be updated */
  where: LotBoolExp;
};

/** aggregate var_pop on columns */
export type LotVarPopFields = {
  __typename?: 'lot_var_pop_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lot" */
export type LotVarPopOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LotVarSampFields = {
  __typename?: 'lot_var_samp_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lot" */
export type LotVarSampOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LotVarianceFields = {
  __typename?: 'lot_variance_fields';
  country_uuid?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lot" */
export type LotVarianceOrderBy = {
  country_uuid?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lp_contingent" */
export type LpContingent = {
  __typename?: 'lp_contingent';
  contingent: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  updated_at?: Maybe<Scalars['timestamp']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
};

/** aggregated selection of "lp_contingent" */
export type LpContingentAggregate = {
  __typename?: 'lp_contingent_aggregate';
  aggregate?: Maybe<LpContingentAggregateFields>;
  nodes: Array<LpContingent>;
};

/** aggregate fields of "lp_contingent" */
export type LpContingentAggregateFields = {
  __typename?: 'lp_contingent_aggregate_fields';
  avg?: Maybe<LpContingentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpContingentMaxFields>;
  min?: Maybe<LpContingentMinFields>;
  stddev?: Maybe<LpContingentStddevFields>;
  stddev_pop?: Maybe<LpContingentStddevPopFields>;
  stddev_samp?: Maybe<LpContingentStddevSampFields>;
  sum?: Maybe<LpContingentSumFields>;
  var_pop?: Maybe<LpContingentVarPopFields>;
  var_samp?: Maybe<LpContingentVarSampFields>;
  variance?: Maybe<LpContingentVarianceFields>;
};


/** aggregate fields of "lp_contingent" */
export type LpContingentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpContingentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LpContingentAvgFields = {
  __typename?: 'lp_contingent_avg_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lp_contingent". All fields are combined with a logical 'AND'. */
export type LpContingentBoolExp = {
  _and?: InputMaybe<Array<LpContingentBoolExp>>;
  _not?: InputMaybe<LpContingentBoolExp>;
  _or?: InputMaybe<Array<LpContingentBoolExp>>;
  contingent?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestampComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lp_contingent" */
export enum LpContingentConstraint {
  /** unique or primary key constraint on columns "id" */
  LpContingentPkey = 'lp_contingent_pkey'
}

/** input type for incrementing numeric columns in table "lp_contingent" */
export type LpContingentIncInput = {
  contingent?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_contingent" */
export type LpContingentInsertInput = {
  contingent?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LpContingentMaxFields = {
  __typename?: 'lp_contingent_max_fields';
  contingent?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LpContingentMinFields = {
  __typename?: 'lp_contingent_min_fields';
  contingent?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lp_contingent" */
export type LpContingentMutationResponse = {
  __typename?: 'lp_contingent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpContingent>;
};

/** on_conflict condition type for table "lp_contingent" */
export type LpContingentOnConflict = {
  constraint: LpContingentConstraint;
  update_columns?: Array<LpContingentUpdateColumn>;
  where?: InputMaybe<LpContingentBoolExp>;
};

/** Ordering options when selecting data from "lp_contingent". */
export type LpContingentOrderBy = {
  contingent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_contingent */
export type LpContingentPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_contingent" */
export enum LpContingentSelectColumn {
  /** column name */
  Contingent = 'contingent',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "lp_contingent" */
export type LpContingentSetInput = {
  contingent?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LpContingentStddevFields = {
  __typename?: 'lp_contingent_stddev_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LpContingentStddevPopFields = {
  __typename?: 'lp_contingent_stddev_pop_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LpContingentStddevSampFields = {
  __typename?: 'lp_contingent_stddev_samp_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lp_contingent" */
export type LpContingentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpContingentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpContingentStreamCursorValueInput = {
  contingent?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LpContingentSumFields = {
  __typename?: 'lp_contingent_sum_fields';
  contingent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lp_contingent" */
export enum LpContingentUpdateColumn {
  /** column name */
  Contingent = 'contingent',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type LpContingentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpContingentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpContingentSetInput>;
  /** filter the rows which have to be updated */
  where: LpContingentBoolExp;
};

/** aggregate var_pop on columns */
export type LpContingentVarPopFields = {
  __typename?: 'lp_contingent_var_pop_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LpContingentVarSampFields = {
  __typename?: 'lp_contingent_var_samp_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LpContingentVarianceFields = {
  __typename?: 'lp_contingent_variance_fields';
  contingent?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "lp_group" */
export type LpGroup = {
  __typename?: 'lp_group';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An array relationship */
  lp_group_members: Array<LpGroupMember>;
  /** An aggregate relationship */
  lp_group_members_aggregate: LpGroupMemberAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from: Scalars['timestamptz'];
  valid_to?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "lp_group" */
export type LpGroupLpGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


/** columns and relationships of "lp_group" */
export type LpGroupLpGroupMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};

/** aggregated selection of "lp_group" */
export type LpGroupAggregate = {
  __typename?: 'lp_group_aggregate';
  aggregate?: Maybe<LpGroupAggregateFields>;
  nodes: Array<LpGroup>;
};

/** aggregate fields of "lp_group" */
export type LpGroupAggregateFields = {
  __typename?: 'lp_group_aggregate_fields';
  avg?: Maybe<LpGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpGroupMaxFields>;
  min?: Maybe<LpGroupMinFields>;
  stddev?: Maybe<LpGroupStddevFields>;
  stddev_pop?: Maybe<LpGroupStddevPopFields>;
  stddev_samp?: Maybe<LpGroupStddevSampFields>;
  sum?: Maybe<LpGroupSumFields>;
  var_pop?: Maybe<LpGroupVarPopFields>;
  var_samp?: Maybe<LpGroupVarSampFields>;
  variance?: Maybe<LpGroupVarianceFields>;
};


/** aggregate fields of "lp_group" */
export type LpGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LpGroupAvgFields = {
  __typename?: 'lp_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lp_group". All fields are combined with a logical 'AND'. */
export type LpGroupBoolExp = {
  _and?: InputMaybe<Array<LpGroupBoolExp>>;
  _not?: InputMaybe<LpGroupBoolExp>;
  _or?: InputMaybe<Array<LpGroupBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_members?: InputMaybe<LpGroupMemberBoolExp>;
  lp_group_members_aggregate?: InputMaybe<LpGroupMemberAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
};

/** columns and relationships of "lp_group_config_group" */
export type LpGroupConfigGroup = {
  __typename?: 'lp_group_config_group';
  config_group_id: Scalars['bigint'];
  id: Scalars['bigint'];
  lp_group_id: Scalars['bigint'];
};

/** aggregated selection of "lp_group_config_group" */
export type LpGroupConfigGroupAggregate = {
  __typename?: 'lp_group_config_group_aggregate';
  aggregate?: Maybe<LpGroupConfigGroupAggregateFields>;
  nodes: Array<LpGroupConfigGroup>;
};

/** aggregate fields of "lp_group_config_group" */
export type LpGroupConfigGroupAggregateFields = {
  __typename?: 'lp_group_config_group_aggregate_fields';
  avg?: Maybe<LpGroupConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpGroupConfigGroupMaxFields>;
  min?: Maybe<LpGroupConfigGroupMinFields>;
  stddev?: Maybe<LpGroupConfigGroupStddevFields>;
  stddev_pop?: Maybe<LpGroupConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<LpGroupConfigGroupStddevSampFields>;
  sum?: Maybe<LpGroupConfigGroupSumFields>;
  var_pop?: Maybe<LpGroupConfigGroupVarPopFields>;
  var_samp?: Maybe<LpGroupConfigGroupVarSampFields>;
  variance?: Maybe<LpGroupConfigGroupVarianceFields>;
};


/** aggregate fields of "lp_group_config_group" */
export type LpGroupConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpGroupConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LpGroupConfigGroupAvgFields = {
  __typename?: 'lp_group_config_group_avg_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lp_group_config_group". All fields are combined with a logical 'AND'. */
export type LpGroupConfigGroupBoolExp = {
  _and?: InputMaybe<Array<LpGroupConfigGroupBoolExp>>;
  _not?: InputMaybe<LpGroupConfigGroupBoolExp>;
  _or?: InputMaybe<Array<LpGroupConfigGroupBoolExp>>;
  config_group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "lp_group_config_group" */
export enum LpGroupConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  LpGroupConfigGroupPkey = 'lp_group_config_group_pkey'
}

/** input type for incrementing numeric columns in table "lp_group_config_group" */
export type LpGroupConfigGroupIncInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_group_config_group" */
export type LpGroupConfigGroupInsertInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type LpGroupConfigGroupMaxFields = {
  __typename?: 'lp_group_config_group_max_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type LpGroupConfigGroupMinFields = {
  __typename?: 'lp_group_config_group_min_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "lp_group_config_group" */
export type LpGroupConfigGroupMutationResponse = {
  __typename?: 'lp_group_config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpGroupConfigGroup>;
};

/** on_conflict condition type for table "lp_group_config_group" */
export type LpGroupConfigGroupOnConflict = {
  constraint: LpGroupConfigGroupConstraint;
  update_columns?: Array<LpGroupConfigGroupUpdateColumn>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "lp_group_config_group". */
export type LpGroupConfigGroupOrderBy = {
  config_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_group_config_group */
export type LpGroupConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_group_config_group" */
export enum LpGroupConfigGroupSelectColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id'
}

/** input type for updating data in table "lp_group_config_group" */
export type LpGroupConfigGroupSetInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type LpGroupConfigGroupStddevFields = {
  __typename?: 'lp_group_config_group_stddev_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LpGroupConfigGroupStddevPopFields = {
  __typename?: 'lp_group_config_group_stddev_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LpGroupConfigGroupStddevSampFields = {
  __typename?: 'lp_group_config_group_stddev_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lp_group_config_group" */
export type LpGroupConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpGroupConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpGroupConfigGroupStreamCursorValueInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LpGroupConfigGroupSumFields = {
  __typename?: 'lp_group_config_group_sum_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lp_group_config_group" */
export enum LpGroupConfigGroupUpdateColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id'
}

export type LpGroupConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpGroupConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpGroupConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: LpGroupConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type LpGroupConfigGroupVarPopFields = {
  __typename?: 'lp_group_config_group_var_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LpGroupConfigGroupVarSampFields = {
  __typename?: 'lp_group_config_group_var_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LpGroupConfigGroupVarianceFields = {
  __typename?: 'lp_group_config_group_variance_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "lp_group" */
export enum LpGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  LpGroupPkey = 'lp_group_pkey'
}

/** columns and relationships of "lp_group_details" */
export type LpGroupDetails = {
  __typename?: 'lp_group_details';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  lp_group_id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "lp_group_details" */
export type LpGroupDetailsAggregate = {
  __typename?: 'lp_group_details_aggregate';
  aggregate?: Maybe<LpGroupDetailsAggregateFields>;
  nodes: Array<LpGroupDetails>;
};

/** aggregate fields of "lp_group_details" */
export type LpGroupDetailsAggregateFields = {
  __typename?: 'lp_group_details_aggregate_fields';
  avg?: Maybe<LpGroupDetailsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpGroupDetailsMaxFields>;
  min?: Maybe<LpGroupDetailsMinFields>;
  stddev?: Maybe<LpGroupDetailsStddevFields>;
  stddev_pop?: Maybe<LpGroupDetailsStddevPopFields>;
  stddev_samp?: Maybe<LpGroupDetailsStddevSampFields>;
  sum?: Maybe<LpGroupDetailsSumFields>;
  var_pop?: Maybe<LpGroupDetailsVarPopFields>;
  var_samp?: Maybe<LpGroupDetailsVarSampFields>;
  variance?: Maybe<LpGroupDetailsVarianceFields>;
};


/** aggregate fields of "lp_group_details" */
export type LpGroupDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpGroupDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LpGroupDetailsAvgFields = {
  __typename?: 'lp_group_details_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lp_group_details". All fields are combined with a logical 'AND'. */
export type LpGroupDetailsBoolExp = {
  _and?: InputMaybe<Array<LpGroupDetailsBoolExp>>;
  _not?: InputMaybe<LpGroupDetailsBoolExp>;
  _or?: InputMaybe<Array<LpGroupDetailsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lp_group_details" */
export enum LpGroupDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  LpGroupDetailsPkey = 'lp_group_details_pkey'
}

/** input type for incrementing numeric columns in table "lp_group_details" */
export type LpGroupDetailsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_group_details" */
export type LpGroupDetailsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LpGroupDetailsMaxFields = {
  __typename?: 'lp_group_details_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LpGroupDetailsMinFields = {
  __typename?: 'lp_group_details_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lp_group_details" */
export type LpGroupDetailsMutationResponse = {
  __typename?: 'lp_group_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpGroupDetails>;
};

/** on_conflict condition type for table "lp_group_details" */
export type LpGroupDetailsOnConflict = {
  constraint: LpGroupDetailsConstraint;
  update_columns?: Array<LpGroupDetailsUpdateColumn>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};

/** Ordering options when selecting data from "lp_group_details". */
export type LpGroupDetailsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_group_details */
export type LpGroupDetailsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_group_details" */
export enum LpGroupDetailsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lp_group_details" */
export type LpGroupDetailsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LpGroupDetailsStddevFields = {
  __typename?: 'lp_group_details_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LpGroupDetailsStddevPopFields = {
  __typename?: 'lp_group_details_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LpGroupDetailsStddevSampFields = {
  __typename?: 'lp_group_details_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lp_group_details" */
export type LpGroupDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpGroupDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpGroupDetailsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LpGroupDetailsSumFields = {
  __typename?: 'lp_group_details_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lp_group_details" */
export enum LpGroupDetailsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type LpGroupDetailsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpGroupDetailsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpGroupDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: LpGroupDetailsBoolExp;
};

/** aggregate var_pop on columns */
export type LpGroupDetailsVarPopFields = {
  __typename?: 'lp_group_details_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LpGroupDetailsVarSampFields = {
  __typename?: 'lp_group_details_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LpGroupDetailsVarianceFields = {
  __typename?: 'lp_group_details_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "lp_group" */
export type LpGroupIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_group" */
export type LpGroupInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_members?: InputMaybe<LpGroupMemberArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LpGroupMaxFields = {
  __typename?: 'lp_group_max_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "lp_group_member" */
export type LpGroupMember = {
  __typename?: 'lp_group_member';
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  lp_group_id: Scalars['bigint'];
  plate: Scalars['String'];
  raw_plate: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from: Scalars['timestamptz'];
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "lp_group_member" */
export type LpGroupMemberAggregate = {
  __typename?: 'lp_group_member_aggregate';
  aggregate?: Maybe<LpGroupMemberAggregateFields>;
  nodes: Array<LpGroupMember>;
};

export type LpGroupMemberAggregateBoolExp = {
  count?: InputMaybe<LpGroupMemberAggregateBoolExpCount>;
};

export type LpGroupMemberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LpGroupMemberBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lp_group_member" */
export type LpGroupMemberAggregateFields = {
  __typename?: 'lp_group_member_aggregate_fields';
  avg?: Maybe<LpGroupMemberAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpGroupMemberMaxFields>;
  min?: Maybe<LpGroupMemberMinFields>;
  stddev?: Maybe<LpGroupMemberStddevFields>;
  stddev_pop?: Maybe<LpGroupMemberStddevPopFields>;
  stddev_samp?: Maybe<LpGroupMemberStddevSampFields>;
  sum?: Maybe<LpGroupMemberSumFields>;
  var_pop?: Maybe<LpGroupMemberVarPopFields>;
  var_samp?: Maybe<LpGroupMemberVarSampFields>;
  variance?: Maybe<LpGroupMemberVarianceFields>;
};


/** aggregate fields of "lp_group_member" */
export type LpGroupMemberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lp_group_member" */
export type LpGroupMemberAggregateOrderBy = {
  avg?: InputMaybe<LpGroupMemberAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LpGroupMemberMaxOrderBy>;
  min?: InputMaybe<LpGroupMemberMinOrderBy>;
  stddev?: InputMaybe<LpGroupMemberStddevOrderBy>;
  stddev_pop?: InputMaybe<LpGroupMemberStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LpGroupMemberStddevSampOrderBy>;
  sum?: InputMaybe<LpGroupMemberSumOrderBy>;
  var_pop?: InputMaybe<LpGroupMemberVarPopOrderBy>;
  var_samp?: InputMaybe<LpGroupMemberVarSampOrderBy>;
  variance?: InputMaybe<LpGroupMemberVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lp_group_member" */
export type LpGroupMemberArrRelInsertInput = {
  data: Array<LpGroupMemberInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LpGroupMemberOnConflict>;
};

/** aggregate avg on columns */
export type LpGroupMemberAvgFields = {
  __typename?: 'lp_group_member_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lp_group_member" */
export type LpGroupMemberAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lp_group_member". All fields are combined with a logical 'AND'. */
export type LpGroupMemberBoolExp = {
  _and?: InputMaybe<Array<LpGroupMemberBoolExp>>;
  _not?: InputMaybe<LpGroupMemberBoolExp>;
  _or?: InputMaybe<Array<LpGroupMemberBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_id?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  raw_plate?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lp_group_member" */
export enum LpGroupMemberConstraint {
  /** unique or primary key constraint on columns "id" */
  LpGroupMemberPkey = 'lp_group_member_pkey'
}

/** columns and relationships of "lp_group_member_details" */
export type LpGroupMemberDetails = {
  __typename?: 'lp_group_member_details';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  lp_group_member_id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "lp_group_member_details" */
export type LpGroupMemberDetailsAggregate = {
  __typename?: 'lp_group_member_details_aggregate';
  aggregate?: Maybe<LpGroupMemberDetailsAggregateFields>;
  nodes: Array<LpGroupMemberDetails>;
};

/** aggregate fields of "lp_group_member_details" */
export type LpGroupMemberDetailsAggregateFields = {
  __typename?: 'lp_group_member_details_aggregate_fields';
  avg?: Maybe<LpGroupMemberDetailsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LpGroupMemberDetailsMaxFields>;
  min?: Maybe<LpGroupMemberDetailsMinFields>;
  stddev?: Maybe<LpGroupMemberDetailsStddevFields>;
  stddev_pop?: Maybe<LpGroupMemberDetailsStddevPopFields>;
  stddev_samp?: Maybe<LpGroupMemberDetailsStddevSampFields>;
  sum?: Maybe<LpGroupMemberDetailsSumFields>;
  var_pop?: Maybe<LpGroupMemberDetailsVarPopFields>;
  var_samp?: Maybe<LpGroupMemberDetailsVarSampFields>;
  variance?: Maybe<LpGroupMemberDetailsVarianceFields>;
};


/** aggregate fields of "lp_group_member_details" */
export type LpGroupMemberDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LpGroupMemberDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LpGroupMemberDetailsAvgFields = {
  __typename?: 'lp_group_member_details_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lp_group_member_details". All fields are combined with a logical 'AND'. */
export type LpGroupMemberDetailsBoolExp = {
  _and?: InputMaybe<Array<LpGroupMemberDetailsBoolExp>>;
  _not?: InputMaybe<LpGroupMemberDetailsBoolExp>;
  _or?: InputMaybe<Array<LpGroupMemberDetailsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_member_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lp_group_member_details" */
export enum LpGroupMemberDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  LpGroupMemberDetailsPkey = 'lp_group_member_details_pkey'
}

/** input type for incrementing numeric columns in table "lp_group_member_details" */
export type LpGroupMemberDetailsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_group_member_details" */
export type LpGroupMemberDetailsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LpGroupMemberDetailsMaxFields = {
  __typename?: 'lp_group_member_details_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LpGroupMemberDetailsMinFields = {
  __typename?: 'lp_group_member_details_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lp_group_member_details" */
export type LpGroupMemberDetailsMutationResponse = {
  __typename?: 'lp_group_member_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpGroupMemberDetails>;
};

/** on_conflict condition type for table "lp_group_member_details" */
export type LpGroupMemberDetailsOnConflict = {
  constraint: LpGroupMemberDetailsConstraint;
  update_columns?: Array<LpGroupMemberDetailsUpdateColumn>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};

/** Ordering options when selecting data from "lp_group_member_details". */
export type LpGroupMemberDetailsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_member_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_group_member_details */
export type LpGroupMemberDetailsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_group_member_details" */
export enum LpGroupMemberDetailsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupMemberId = 'lp_group_member_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lp_group_member_details" */
export type LpGroupMemberDetailsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LpGroupMemberDetailsStddevFields = {
  __typename?: 'lp_group_member_details_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LpGroupMemberDetailsStddevPopFields = {
  __typename?: 'lp_group_member_details_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LpGroupMemberDetailsStddevSampFields = {
  __typename?: 'lp_group_member_details_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lp_group_member_details" */
export type LpGroupMemberDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpGroupMemberDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpGroupMemberDetailsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LpGroupMemberDetailsSumFields = {
  __typename?: 'lp_group_member_details_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lp_group_member_details" */
export enum LpGroupMemberDetailsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupMemberId = 'lp_group_member_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type LpGroupMemberDetailsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpGroupMemberDetailsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpGroupMemberDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: LpGroupMemberDetailsBoolExp;
};

/** aggregate var_pop on columns */
export type LpGroupMemberDetailsVarPopFields = {
  __typename?: 'lp_group_member_details_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LpGroupMemberDetailsVarSampFields = {
  __typename?: 'lp_group_member_details_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LpGroupMemberDetailsVarianceFields = {
  __typename?: 'lp_group_member_details_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "lp_group_member" */
export type LpGroupMemberIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lp_group_member" */
export type LpGroupMemberInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LpGroupMemberMaxFields = {
  __typename?: 'lp_group_member_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lp_group_member" */
export type LpGroupMemberMaxOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LpGroupMemberMinFields = {
  __typename?: 'lp_group_member_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lp_group_member" */
export type LpGroupMemberMinOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lp_group_member" */
export type LpGroupMemberMutationResponse = {
  __typename?: 'lp_group_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpGroupMember>;
};

/** on_conflict condition type for table "lp_group_member" */
export type LpGroupMemberOnConflict = {
  constraint: LpGroupMemberConstraint;
  update_columns?: Array<LpGroupMemberUpdateColumn>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};

/** Ordering options when selecting data from "lp_group_member". */
export type LpGroupMemberOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_group_member */
export type LpGroupMemberPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_group_member" */
export enum LpGroupMemberSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "lp_group_member" */
export type LpGroupMemberSetInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LpGroupMemberStddevFields = {
  __typename?: 'lp_group_member_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lp_group_member" */
export type LpGroupMemberStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LpGroupMemberStddevPopFields = {
  __typename?: 'lp_group_member_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lp_group_member" */
export type LpGroupMemberStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LpGroupMemberStddevSampFields = {
  __typename?: 'lp_group_member_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lp_group_member" */
export type LpGroupMemberStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lp_group_member" */
export type LpGroupMemberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpGroupMemberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpGroupMemberStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LpGroupMemberSumFields = {
  __typename?: 'lp_group_member_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "lp_group_member" */
export type LpGroupMemberSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** update columns of table "lp_group_member" */
export enum LpGroupMemberUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type LpGroupMemberUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpGroupMemberIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpGroupMemberSetInput>;
  /** filter the rows which have to be updated */
  where: LpGroupMemberBoolExp;
};

/** aggregate var_pop on columns */
export type LpGroupMemberVarPopFields = {
  __typename?: 'lp_group_member_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lp_group_member" */
export type LpGroupMemberVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LpGroupMemberVarSampFields = {
  __typename?: 'lp_group_member_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lp_group_member" */
export type LpGroupMemberVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LpGroupMemberVarianceFields = {
  __typename?: 'lp_group_member_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lp_group_member" */
export type LpGroupMemberVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LpGroupMinFields = {
  __typename?: 'lp_group_min_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lp_group" */
export type LpGroupMutationResponse = {
  __typename?: 'lp_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LpGroup>;
};

/** input type for inserting object relation for remote table "lp_group" */
export type LpGroupObjRelInsertInput = {
  data: LpGroupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LpGroupOnConflict>;
};

/** on_conflict condition type for table "lp_group" */
export type LpGroupOnConflict = {
  constraint: LpGroupConstraint;
  update_columns?: Array<LpGroupUpdateColumn>;
  where?: InputMaybe<LpGroupBoolExp>;
};

/** Ordering options when selecting data from "lp_group". */
export type LpGroupOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_group_members_aggregate?: InputMaybe<LpGroupMemberAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lp_group */
export type LpGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "lp_group" */
export enum LpGroupSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "lp_group" */
export type LpGroupSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LpGroupStddevFields = {
  __typename?: 'lp_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LpGroupStddevPopFields = {
  __typename?: 'lp_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LpGroupStddevSampFields = {
  __typename?: 'lp_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lp_group" */
export type LpGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LpGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LpGroupStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LpGroupSumFields = {
  __typename?: 'lp_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "lp_group" */
export enum LpGroupUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type LpGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LpGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LpGroupSetInput>;
  /** filter the rows which have to be updated */
  where: LpGroupBoolExp;
};

/** aggregate var_pop on columns */
export type LpGroupVarPopFields = {
  __typename?: 'lp_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LpGroupVarSampFields = {
  __typename?: 'lp_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LpGroupVarianceFields = {
  __typename?: 'lp_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** columns and relationships of "mail" */
export type Mail = {
  __typename?: 'mail';
  created_at: Scalars['timestamptz'];
  due?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  sent?: Maybe<Scalars['date']>;
  /** An array relationship */
  stages: Array<Stages>;
  /** An array relationship */
  stagesByStage2: Array<Stages>;
  /** An aggregate relationship */
  stagesByStage2_aggregate: StagesAggregate;
  /** An array relationship */
  stagesByStage3: Array<Stages>;
  /** An aggregate relationship */
  stagesByStage3_aggregate: StagesAggregate;
  /** An array relationship */
  stagesByStage4: Array<Stages>;
  /** An aggregate relationship */
  stagesByStage4_aggregate: StagesAggregate;
  /** An aggregate relationship */
  stages_aggregate: StagesAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "mail" */
export type MailStagesArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage2Args = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage2AggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage3Args = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage3AggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage4Args = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesByStage4AggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


/** columns and relationships of "mail" */
export type MailStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};

/** aggregated selection of "mail" */
export type MailAggregate = {
  __typename?: 'mail_aggregate';
  aggregate?: Maybe<MailAggregateFields>;
  nodes: Array<Mail>;
};

/** aggregate fields of "mail" */
export type MailAggregateFields = {
  __typename?: 'mail_aggregate_fields';
  avg?: Maybe<MailAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MailMaxFields>;
  min?: Maybe<MailMinFields>;
  stddev?: Maybe<MailStddevFields>;
  stddev_pop?: Maybe<MailStddevPopFields>;
  stddev_samp?: Maybe<MailStddevSampFields>;
  sum?: Maybe<MailSumFields>;
  var_pop?: Maybe<MailVarPopFields>;
  var_samp?: Maybe<MailVarSampFields>;
  variance?: Maybe<MailVarianceFields>;
};


/** aggregate fields of "mail" */
export type MailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MailAvgFields = {
  __typename?: 'mail_avg_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mail". All fields are combined with a logical 'AND'. */
export type MailBoolExp = {
  _and?: InputMaybe<Array<MailBoolExp>>;
  _not?: InputMaybe<MailBoolExp>;
  _or?: InputMaybe<Array<MailBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  due?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  sent?: InputMaybe<DateComparisonExp>;
  stages?: InputMaybe<StagesBoolExp>;
  stagesByStage2?: InputMaybe<StagesBoolExp>;
  stagesByStage2_aggregate?: InputMaybe<StagesAggregateBoolExp>;
  stagesByStage3?: InputMaybe<StagesBoolExp>;
  stagesByStage3_aggregate?: InputMaybe<StagesAggregateBoolExp>;
  stagesByStage4?: InputMaybe<StagesBoolExp>;
  stagesByStage4_aggregate?: InputMaybe<StagesAggregateBoolExp>;
  stages_aggregate?: InputMaybe<StagesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "mail" */
export enum MailConstraint {
  /** unique or primary key constraint on columns "id" */
  MailPkey = 'mail_pkey'
}

/** input type for incrementing numeric columns in table "mail" */
export type MailIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "mail" */
export type MailInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  due?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  sent?: InputMaybe<Scalars['date']>;
  stages?: InputMaybe<StagesArrRelInsertInput>;
  stagesByStage2?: InputMaybe<StagesArrRelInsertInput>;
  stagesByStage3?: InputMaybe<StagesArrRelInsertInput>;
  stagesByStage4?: InputMaybe<StagesArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type MailMaxFields = {
  __typename?: 'mail_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  due?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  sent?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MailMinFields = {
  __typename?: 'mail_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  due?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  sent?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "mail_misc" */
export type MailMisc = {
  __typename?: 'mail_misc';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  letter_template: Scalars['String'];
  sender?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['date']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  violation_case_id: Scalars['bigint'];
};

/** aggregated selection of "mail_misc" */
export type MailMiscAggregate = {
  __typename?: 'mail_misc_aggregate';
  aggregate?: Maybe<MailMiscAggregateFields>;
  nodes: Array<MailMisc>;
};

/** aggregate fields of "mail_misc" */
export type MailMiscAggregateFields = {
  __typename?: 'mail_misc_aggregate_fields';
  avg?: Maybe<MailMiscAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MailMiscMaxFields>;
  min?: Maybe<MailMiscMinFields>;
  stddev?: Maybe<MailMiscStddevFields>;
  stddev_pop?: Maybe<MailMiscStddevPopFields>;
  stddev_samp?: Maybe<MailMiscStddevSampFields>;
  sum?: Maybe<MailMiscSumFields>;
  var_pop?: Maybe<MailMiscVarPopFields>;
  var_samp?: Maybe<MailMiscVarSampFields>;
  variance?: Maybe<MailMiscVarianceFields>;
};


/** aggregate fields of "mail_misc" */
export type MailMiscAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MailMiscSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MailMiscAvgFields = {
  __typename?: 'mail_misc_avg_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mail_misc". All fields are combined with a logical 'AND'. */
export type MailMiscBoolExp = {
  _and?: InputMaybe<Array<MailMiscBoolExp>>;
  _not?: InputMaybe<MailMiscBoolExp>;
  _or?: InputMaybe<Array<MailMiscBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  letter_template?: InputMaybe<StringComparisonExp>;
  sender?: InputMaybe<StringComparisonExp>;
  sent_at?: InputMaybe<DateComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violation_case_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "mail_misc" */
export enum MailMiscConstraint {
  /** unique or primary key constraint on columns "id" */
  SpecialLettersPkey = 'special_letters_pkey'
}

/** input type for incrementing numeric columns in table "mail_misc" */
export type MailMiscIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "mail_misc" */
export type MailMiscInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  letter_template?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type MailMiscMaxFields = {
  __typename?: 'mail_misc_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  letter_template?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MailMiscMinFields = {
  __typename?: 'mail_misc_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  letter_template?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "mail_misc" */
export type MailMiscMutationResponse = {
  __typename?: 'mail_misc_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MailMisc>;
};

/** on_conflict condition type for table "mail_misc" */
export type MailMiscOnConflict = {
  constraint: MailMiscConstraint;
  update_columns?: Array<MailMiscUpdateColumn>;
  where?: InputMaybe<MailMiscBoolExp>;
};

/** Ordering options when selecting data from "mail_misc". */
export type MailMiscOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  letter_template?: InputMaybe<OrderBy>;
  sender?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mail_misc */
export type MailMiscPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "mail_misc" */
export enum MailMiscSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LetterTemplate = 'letter_template',
  /** column name */
  Sender = 'sender',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

/** input type for updating data in table "mail_misc" */
export type MailMiscSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  letter_template?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type MailMiscStddevFields = {
  __typename?: 'mail_misc_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MailMiscStddevPopFields = {
  __typename?: 'mail_misc_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MailMiscStddevSampFields = {
  __typename?: 'mail_misc_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mail_misc" */
export type MailMiscStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MailMiscStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MailMiscStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  letter_template?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MailMiscSumFields = {
  __typename?: 'mail_misc_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "mail_misc" */
export enum MailMiscUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LetterTemplate = 'letter_template',
  /** column name */
  Sender = 'sender',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

export type MailMiscUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MailMiscIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MailMiscSetInput>;
  /** filter the rows which have to be updated */
  where: MailMiscBoolExp;
};

/** aggregate var_pop on columns */
export type MailMiscVarPopFields = {
  __typename?: 'mail_misc_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MailMiscVarSampFields = {
  __typename?: 'mail_misc_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MailMiscVarianceFields = {
  __typename?: 'mail_misc_variance_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "mail" */
export type MailMutationResponse = {
  __typename?: 'mail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mail>;
};

/** input type for inserting object relation for remote table "mail" */
export type MailObjRelInsertInput = {
  data: MailInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MailOnConflict>;
};

/** on_conflict condition type for table "mail" */
export type MailOnConflict = {
  constraint: MailConstraint;
  update_columns?: Array<MailUpdateColumn>;
  where?: InputMaybe<MailBoolExp>;
};

/** Ordering options when selecting data from "mail". */
export type MailOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  due?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sent?: InputMaybe<OrderBy>;
  stagesByStage2_aggregate?: InputMaybe<StagesAggregateOrderBy>;
  stagesByStage3_aggregate?: InputMaybe<StagesAggregateOrderBy>;
  stagesByStage4_aggregate?: InputMaybe<StagesAggregateOrderBy>;
  stages_aggregate?: InputMaybe<StagesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mail */
export type MailPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "mail" */
export enum MailSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Due = 'due',
  /** column name */
  Id = 'id',
  /** column name */
  Sent = 'sent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "mail" */
export type MailSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  due?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  sent?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type MailStddevFields = {
  __typename?: 'mail_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MailStddevPopFields = {
  __typename?: 'mail_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MailStddevSampFields = {
  __typename?: 'mail_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mail" */
export type MailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MailStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  due?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  sent?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MailSumFields = {
  __typename?: 'mail_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['bigint']>;
};

/** update columns of table "mail" */
export enum MailUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Due = 'due',
  /** column name */
  Id = 'id',
  /** column name */
  Sent = 'sent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Version = 'version'
}

export type MailUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MailIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MailSetInput>;
  /** filter the rows which have to be updated */
  where: MailBoolExp;
};

/** aggregate var_pop on columns */
export type MailVarPopFields = {
  __typename?: 'mail_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MailVarSampFields = {
  __typename?: 'mail_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MailVarianceFields = {
  __typename?: 'mail_variance_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Table containing violators for the MLP check */
export type MlpCases = {
  __typename?: 'mlp_cases';
  category: Scalars['String'];
  image_request_status_in?: Maybe<Scalars['String']>;
  image_request_status_out?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  parking_results_uuid: Scalars['uuid'];
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};


/** Table containing violators for the MLP check */
export type MlpCasesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "mlp_cases" */
export type MlpCasesAggregate = {
  __typename?: 'mlp_cases_aggregate';
  aggregate?: Maybe<MlpCasesAggregateFields>;
  nodes: Array<MlpCases>;
};

/** aggregate fields of "mlp_cases" */
export type MlpCasesAggregateFields = {
  __typename?: 'mlp_cases_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<MlpCasesMaxFields>;
  min?: Maybe<MlpCasesMinFields>;
};


/** aggregate fields of "mlp_cases" */
export type MlpCasesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MlpCasesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MlpCasesAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "mlp_cases". All fields are combined with a logical 'AND'. */
export type MlpCasesBoolExp = {
  _and?: InputMaybe<Array<MlpCasesBoolExp>>;
  _not?: InputMaybe<MlpCasesBoolExp>;
  _or?: InputMaybe<Array<MlpCasesBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  image_request_status_in?: InputMaybe<StringComparisonExp>;
  image_request_status_out?: InputMaybe<StringComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  parking_results_uuid?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "mlp_cases" */
export enum MlpCasesConstraint {
  /** unique or primary key constraint on columns "parking_results_uuid" */
  MlpCasesPkey = 'mlp_cases_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MlpCasesDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MlpCasesDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MlpCasesDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "mlp_cases" */
export type MlpCasesInsertInput = {
  category?: InputMaybe<Scalars['String']>;
  image_request_status_in?: InputMaybe<Scalars['String']>;
  image_request_status_out?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_results_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MlpCasesMaxFields = {
  __typename?: 'mlp_cases_max_fields';
  category?: Maybe<Scalars['String']>;
  image_request_status_in?: Maybe<Scalars['String']>;
  image_request_status_out?: Maybe<Scalars['String']>;
  parking_results_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MlpCasesMinFields = {
  __typename?: 'mlp_cases_min_fields';
  category?: Maybe<Scalars['String']>;
  image_request_status_in?: Maybe<Scalars['String']>;
  image_request_status_out?: Maybe<Scalars['String']>;
  parking_results_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "mlp_cases" */
export type MlpCasesMutationResponse = {
  __typename?: 'mlp_cases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MlpCases>;
};

/** on_conflict condition type for table "mlp_cases" */
export type MlpCasesOnConflict = {
  constraint: MlpCasesConstraint;
  update_columns?: Array<MlpCasesUpdateColumn>;
  where?: InputMaybe<MlpCasesBoolExp>;
};

/** Ordering options when selecting data from "mlp_cases". */
export type MlpCasesOrderBy = {
  category?: InputMaybe<OrderBy>;
  image_request_status_in?: InputMaybe<OrderBy>;
  image_request_status_out?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  parking_results_uuid?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mlp_cases */
export type MlpCasesPkColumnsInput = {
  parking_results_uuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MlpCasesPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "mlp_cases" */
export enum MlpCasesSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ImageRequestStatusIn = 'image_request_status_in',
  /** column name */
  ImageRequestStatusOut = 'image_request_status_out',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ParkingResultsUuid = 'parking_results_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out'
}

/** input type for updating data in table "mlp_cases" */
export type MlpCasesSetInput = {
  category?: InputMaybe<Scalars['String']>;
  image_request_status_in?: InputMaybe<Scalars['String']>;
  image_request_status_out?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_results_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "mlp_cases" */
export type MlpCasesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MlpCasesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MlpCasesStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']>;
  image_request_status_in?: InputMaybe<Scalars['String']>;
  image_request_status_out?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_results_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "mlp_cases" */
export enum MlpCasesUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ImageRequestStatusIn = 'image_request_status_in',
  /** column name */
  ImageRequestStatusOut = 'image_request_status_out',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ParkingResultsUuid = 'parking_results_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out'
}

export type MlpCasesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MlpCasesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MlpCasesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MlpCasesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MlpCasesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MlpCasesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MlpCasesSetInput>;
  /** filter the rows which have to be updated */
  where: MlpCasesBoolExp;
};

/** contains the mapping of an mlp case and it's corresponding similar detections */
export type MlpMappings = {
  __typename?: 'mlp_mappings';
  id: Scalars['uuid'];
  mlp_case_uuid: Scalars['uuid'];
  similar_detection_uuid: Scalars['uuid'];
};

/** aggregated selection of "mlp_mappings" */
export type MlpMappingsAggregate = {
  __typename?: 'mlp_mappings_aggregate';
  aggregate?: Maybe<MlpMappingsAggregateFields>;
  nodes: Array<MlpMappings>;
};

/** aggregate fields of "mlp_mappings" */
export type MlpMappingsAggregateFields = {
  __typename?: 'mlp_mappings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<MlpMappingsMaxFields>;
  min?: Maybe<MlpMappingsMinFields>;
};


/** aggregate fields of "mlp_mappings" */
export type MlpMappingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MlpMappingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "mlp_mappings". All fields are combined with a logical 'AND'. */
export type MlpMappingsBoolExp = {
  _and?: InputMaybe<Array<MlpMappingsBoolExp>>;
  _not?: InputMaybe<MlpMappingsBoolExp>;
  _or?: InputMaybe<Array<MlpMappingsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  mlp_case_uuid?: InputMaybe<UuidComparisonExp>;
  similar_detection_uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "mlp_mappings" */
export enum MlpMappingsConstraint {
  /** unique or primary key constraint on columns "id" */
  MlpMappingsPkey = 'mlp_mappings_pkey'
}

/** input type for inserting data into table "mlp_mappings" */
export type MlpMappingsInsertInput = {
  id?: InputMaybe<Scalars['uuid']>;
  mlp_case_uuid?: InputMaybe<Scalars['uuid']>;
  similar_detection_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type MlpMappingsMaxFields = {
  __typename?: 'mlp_mappings_max_fields';
  id?: Maybe<Scalars['uuid']>;
  mlp_case_uuid?: Maybe<Scalars['uuid']>;
  similar_detection_uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type MlpMappingsMinFields = {
  __typename?: 'mlp_mappings_min_fields';
  id?: Maybe<Scalars['uuid']>;
  mlp_case_uuid?: Maybe<Scalars['uuid']>;
  similar_detection_uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "mlp_mappings" */
export type MlpMappingsMutationResponse = {
  __typename?: 'mlp_mappings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MlpMappings>;
};

/** on_conflict condition type for table "mlp_mappings" */
export type MlpMappingsOnConflict = {
  constraint: MlpMappingsConstraint;
  update_columns?: Array<MlpMappingsUpdateColumn>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};

/** Ordering options when selecting data from "mlp_mappings". */
export type MlpMappingsOrderBy = {
  id?: InputMaybe<OrderBy>;
  mlp_case_uuid?: InputMaybe<OrderBy>;
  similar_detection_uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mlp_mappings */
export type MlpMappingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "mlp_mappings" */
export enum MlpMappingsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  MlpCaseUuid = 'mlp_case_uuid',
  /** column name */
  SimilarDetectionUuid = 'similar_detection_uuid'
}

/** input type for updating data in table "mlp_mappings" */
export type MlpMappingsSetInput = {
  id?: InputMaybe<Scalars['uuid']>;
  mlp_case_uuid?: InputMaybe<Scalars['uuid']>;
  similar_detection_uuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "mlp_mappings" */
export type MlpMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MlpMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MlpMappingsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  mlp_case_uuid?: InputMaybe<Scalars['uuid']>;
  similar_detection_uuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "mlp_mappings" */
export enum MlpMappingsUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  MlpCaseUuid = 'mlp_case_uuid',
  /** column name */
  SimilarDetectionUuid = 'similar_detection_uuid'
}

export type MlpMappingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MlpMappingsSetInput>;
  /** filter the rows which have to be updated */
  where: MlpMappingsBoolExp;
};

/** columns and relationships of "mqtt_request" */
export type MqttRequest = {
  __typename?: 'mqtt_request';
  device_uuid: Scalars['String'];
  expiration_timestamp?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  mqtt_payload: Scalars['String'];
  mqtt_topic: Scalars['String'];
  retry_duration_s: Scalars['numeric'];
  retry_timestamp: Scalars['timestamptz'];
  return_data?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "mqtt_request" */
export type MqttRequestReturnDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "mqtt_request" */
export type MqttRequestAggregate = {
  __typename?: 'mqtt_request_aggregate';
  aggregate?: Maybe<MqttRequestAggregateFields>;
  nodes: Array<MqttRequest>;
};

/** aggregate fields of "mqtt_request" */
export type MqttRequestAggregateFields = {
  __typename?: 'mqtt_request_aggregate_fields';
  avg?: Maybe<MqttRequestAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MqttRequestMaxFields>;
  min?: Maybe<MqttRequestMinFields>;
  stddev?: Maybe<MqttRequestStddevFields>;
  stddev_pop?: Maybe<MqttRequestStddevPopFields>;
  stddev_samp?: Maybe<MqttRequestStddevSampFields>;
  sum?: Maybe<MqttRequestSumFields>;
  var_pop?: Maybe<MqttRequestVarPopFields>;
  var_samp?: Maybe<MqttRequestVarSampFields>;
  variance?: Maybe<MqttRequestVarianceFields>;
};


/** aggregate fields of "mqtt_request" */
export type MqttRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MqttRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MqttRequestAppendInput = {
  return_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type MqttRequestAvgFields = {
  __typename?: 'mqtt_request_avg_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mqtt_request". All fields are combined with a logical 'AND'. */
export type MqttRequestBoolExp = {
  _and?: InputMaybe<Array<MqttRequestBoolExp>>;
  _not?: InputMaybe<MqttRequestBoolExp>;
  _or?: InputMaybe<Array<MqttRequestBoolExp>>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  expiration_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mqtt_payload?: InputMaybe<StringComparisonExp>;
  mqtt_topic?: InputMaybe<StringComparisonExp>;
  retry_duration_s?: InputMaybe<NumericComparisonExp>;
  retry_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  return_data?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "mqtt_request" */
export enum MqttRequestConstraint {
  /** unique or primary key constraint on columns "id" */
  MqttRequestPkey = 'mqtt_request_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MqttRequestDeleteAtPathInput = {
  return_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MqttRequestDeleteElemInput = {
  return_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MqttRequestDeleteKeyInput = {
  return_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "mqtt_request" */
export type MqttRequestIncInput = {
  retry_duration_s?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "mqtt_request" */
export type MqttRequestInsertInput = {
  device_uuid?: InputMaybe<Scalars['String']>;
  expiration_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mqtt_payload?: InputMaybe<Scalars['String']>;
  mqtt_topic?: InputMaybe<Scalars['String']>;
  retry_duration_s?: InputMaybe<Scalars['numeric']>;
  retry_timestamp?: InputMaybe<Scalars['timestamptz']>;
  return_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type MqttRequestMaxFields = {
  __typename?: 'mqtt_request_max_fields';
  device_uuid?: Maybe<Scalars['String']>;
  expiration_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mqtt_payload?: Maybe<Scalars['String']>;
  mqtt_topic?: Maybe<Scalars['String']>;
  retry_duration_s?: Maybe<Scalars['numeric']>;
  retry_timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MqttRequestMinFields = {
  __typename?: 'mqtt_request_min_fields';
  device_uuid?: Maybe<Scalars['String']>;
  expiration_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mqtt_payload?: Maybe<Scalars['String']>;
  mqtt_topic?: Maybe<Scalars['String']>;
  retry_duration_s?: Maybe<Scalars['numeric']>;
  retry_timestamp?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "mqtt_request" */
export type MqttRequestMutationResponse = {
  __typename?: 'mqtt_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MqttRequest>;
};

/** on_conflict condition type for table "mqtt_request" */
export type MqttRequestOnConflict = {
  constraint: MqttRequestConstraint;
  update_columns?: Array<MqttRequestUpdateColumn>;
  where?: InputMaybe<MqttRequestBoolExp>;
};

/** Ordering options when selecting data from "mqtt_request". */
export type MqttRequestOrderBy = {
  device_uuid?: InputMaybe<OrderBy>;
  expiration_timestamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mqtt_payload?: InputMaybe<OrderBy>;
  mqtt_topic?: InputMaybe<OrderBy>;
  retry_duration_s?: InputMaybe<OrderBy>;
  retry_timestamp?: InputMaybe<OrderBy>;
  return_data?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mqtt_request */
export type MqttRequestPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MqttRequestPrependInput = {
  return_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "mqtt_request" */
export enum MqttRequestSelectColumn {
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  ExpirationTimestamp = 'expiration_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  MqttPayload = 'mqtt_payload',
  /** column name */
  MqttTopic = 'mqtt_topic',
  /** column name */
  RetryDurationS = 'retry_duration_s',
  /** column name */
  RetryTimestamp = 'retry_timestamp',
  /** column name */
  ReturnData = 'return_data'
}

/** input type for updating data in table "mqtt_request" */
export type MqttRequestSetInput = {
  device_uuid?: InputMaybe<Scalars['String']>;
  expiration_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mqtt_payload?: InputMaybe<Scalars['String']>;
  mqtt_topic?: InputMaybe<Scalars['String']>;
  retry_duration_s?: InputMaybe<Scalars['numeric']>;
  retry_timestamp?: InputMaybe<Scalars['timestamptz']>;
  return_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type MqttRequestStddevFields = {
  __typename?: 'mqtt_request_stddev_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MqttRequestStddevPopFields = {
  __typename?: 'mqtt_request_stddev_pop_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MqttRequestStddevSampFields = {
  __typename?: 'mqtt_request_stddev_samp_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mqtt_request" */
export type MqttRequestStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MqttRequestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MqttRequestStreamCursorValueInput = {
  device_uuid?: InputMaybe<Scalars['String']>;
  expiration_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mqtt_payload?: InputMaybe<Scalars['String']>;
  mqtt_topic?: InputMaybe<Scalars['String']>;
  retry_duration_s?: InputMaybe<Scalars['numeric']>;
  retry_timestamp?: InputMaybe<Scalars['timestamptz']>;
  return_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type MqttRequestSumFields = {
  __typename?: 'mqtt_request_sum_fields';
  retry_duration_s?: Maybe<Scalars['numeric']>;
};

/** update columns of table "mqtt_request" */
export enum MqttRequestUpdateColumn {
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  ExpirationTimestamp = 'expiration_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  MqttPayload = 'mqtt_payload',
  /** column name */
  MqttTopic = 'mqtt_topic',
  /** column name */
  RetryDurationS = 'retry_duration_s',
  /** column name */
  RetryTimestamp = 'retry_timestamp',
  /** column name */
  ReturnData = 'return_data'
}

export type MqttRequestUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MqttRequestAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MqttRequestDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MqttRequestDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MqttRequestDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MqttRequestIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MqttRequestPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MqttRequestSetInput>;
  /** filter the rows which have to be updated */
  where: MqttRequestBoolExp;
};

/** aggregate var_pop on columns */
export type MqttRequestVarPopFields = {
  __typename?: 'mqtt_request_var_pop_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MqttRequestVarSampFields = {
  __typename?: 'mqtt_request_var_samp_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MqttRequestVarianceFields = {
  __typename?: 'mqtt_request_variance_fields';
  retry_duration_s?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  add_users_to_ppm?: Maybe<UploadUsersToPpmResponse>;
  b2c_apply_discount: B2CCarpayOrderView;
  b2c_delete_payment_method: B2CDeletePaymentMethodResponse;
  b2c_save_payment_method: B2CSavePaymentMethodResponse;
  booking_cancel_user_subscription: BookingCancelUserSubscriptionResponse;
  booking_create_booking?: Maybe<BookingCreateBookingResponse>;
  booking_create_booking_hourly?: Maybe<BookingCreateBookingResponse>;
  booking_create_lot_configuration?: Maybe<BookingCreateLotConfigurationResponse>;
  booking_create_subs_session: BookingCreateAdyenSessionResponse;
  booking_create_user?: Maybe<CreateBookingUserResponse>;
  booking_create_user_booking?: Maybe<BookingCreateBookingResponse>;
  booking_create_user_booking_hourly?: Maybe<BookingCreateBookingResponse>;
  booking_update_lot_configuration?: Maybe<BookingUpdateLotConfigurationResponse>;
  booking_update_user?: Maybe<UpdateBookingUserResponse>;
  /** Cancel an existing reimbursement request */
  cancel_reimbursement_request?: Maybe<CancelReimbursementOutput>;
  /** cancel violation case api */
  cancel_violation_case_api?: Maybe<CancelViolationCaseApiOutput>;
  cancel_violations_by_case_ids?: Maybe<CancelViolationsByCaseIdsOutput>;
  cancel_violations_by_plate?: Maybe<CancelViolationsByPlateOutput>;
  carpay_apply_discount_code: ApplyDiscountCodeResult;
  /** Endpoint to cancel carpay orders */
  carpay_cancel_order_internal_dashboard?: Maybe<CarpayOrderCancelResponse>;
  carpay_create_terminal_notification?: Maybe<CarpayCreateTerminalNotificationResponse>;
  /** Endpoint to create carpay discount batches */
  carpay_discount_batch_internal_dashboard_create?: Maybe<CarpayDiscountBatchCreateResponse>;
  /** Endpoint to delete carpay discount batch */
  carpay_discount_batch_internal_dashboard_delete?: Maybe<DeleteDiscountBatchResponse>;
  /** Endpoint to update carpay batch */
  carpay_discount_batch_internal_dashboard_update?: Maybe<CarpayDiscountBatchResponse>;
  /** Endpoint to create carpay discount models into the internal dashboard */
  carpay_discount_model_internal_dashboard_create?: Maybe<CarpayDiscountModelResponse>;
  /** Endpoint to delete carpay discount models into the internal dashboard */
  carpay_discount_model_internal_dashboard_delete?: Maybe<DeleteDiscountModelResponse>;
  /** Endpoint to update carpay discount models into the internal dashboard */
  carpay_discount_model_internal_dashboard_update?: Maybe<CarpayDiscountModelResponse>;
  /** This endpoint allows us to create the easypark configuration for a certain lot */
  carpay_easypark_internal_dashboard_create: CarpayEasyParkResponse;
  /** This endpoint allows us to update the easypark configuration for a certain lot */
  carpay_easypark_internal_dashboard_update: CarpayEasyParkResponse;
  carpay_license_order_internal_dashboard: Array<LicenseOrderInternalDashboardResponse>;
  carpay_lot_action_create_schedule: CarpayLotActionCreateScheduleResponse;
  carpay_lot_create: CarpayLotResponse;
  carpay_lot_update: CarpayLotResponse;
  /** Endpoint to create carpay notification config into the internal dashboard */
  carpay_notification_config_internal_dashboard_create: CarpayNotificationConfig;
  /** Endpoint to delete carpay notification config into the internal dashboard */
  carpay_notification_config_internal_dashboard_delete: DeleteNotificationConfigResponse;
  /** Endpoint to update carpay notification config into the internal dashboard */
  carpay_notification_config_internal_dashboard_update: CarpayNotificationConfig;
  /** This endpoint allows us to create the paybyphone configuration for a certain lot */
  carpay_paybyphone_internal_dashboard_create: CarpayPayByPhoneResponse;
  /** This endpoint allows us to update the paybyphone configuration for a certain lot */
  carpay_paybyphone_internal_dashboard_update: CarpayPayByPhoneResponse;
  /** Endpoint to delete carpay subscription into the internal dashboard */
  carpay_subscription_internal_dashboard_delete: CarpayDeleteSubscriptionResponse;
  /** Endpoint to upsert carpay subscription into the internal dashboard */
  carpay_subscription_internal_dashboard_update: CarpaySubscriptionResponse;
  carpay_terminal_confirm_order: TerminalConfirmOrderResult;
  /** Order confirmation with discount v2 */
  carpay_terminal_confirm_order_v2: TerminalConfirmOrderResult;
  carpay_update_service_provider: CarpayUpdateServiceProviderResponse;
  change_license_plate?: Maybe<ChangeLicensePlateOutput>;
  change_transaction_status?: Maybe<ChangeTransactionStatusOutput>;
  clean_company_data?: Maybe<CleanCompanyDataOutput>;
  clean_person_data?: Maybe<CleanPersonDataOutput>;
  company_addresses_preprocessing?: Maybe<CompanyAddressesPreprocessingOutput>;
  create_datenhaus_request?: Maybe<CreateDatenhausRequestOutput>;
  create_driver_information_request: Scalars['uuid'];
  create_legal_entity: Array<EnrichedLotLegalEntity>;
  create_lp_group_permit: LpGroupCreationResponse;
  create_night_parking_booking?: Maybe<BookingCreateBookingResponse>;
  create_owner_information_request?: Maybe<CreateOwnerInformationRequestOutput>;
  create_parking_result?: Maybe<CreateParkingResultOutput>;
  /** Create a reimbursement request */
  create_reimbursement_request?: Maybe<CreateReimbursementOutput>;
  create_user_license_plate?: Maybe<CreateUserLicensePlateResponse>;
  create_user_vehicle?: Maybe<CreateUserVehicleResponse>;
  customer_delete_lp_groups: LpGroupDeletionResponse;
  customer_update_lp_group_permit: LpGroupUpdateResponse;
  /** delete data from the table: "adyen_report" */
  delete_adyen_report?: Maybe<AdyenReportMutationResponse>;
  /** delete single row from the table: "adyen_report" */
  delete_adyen_report_by_pk?: Maybe<AdyenReport>;
  /** delete data from the table: "adyen_transaction" */
  delete_adyen_transaction?: Maybe<AdyenTransactionMutationResponse>;
  /** delete single row from the table: "adyen_transaction" */
  delete_adyen_transaction_by_pk?: Maybe<AdyenTransaction>;
  /** delete data from the table: "applied_permit" */
  delete_applied_permit?: Maybe<AppliedPermitMutationResponse>;
  /** delete single row from the table: "applied_permit" */
  delete_applied_permit_by_pk?: Maybe<AppliedPermit>;
  /** delete data from the table: "applied_whitelist" */
  delete_applied_whitelist?: Maybe<AppliedWhitelistMutationResponse>;
  /** delete single row from the table: "applied_whitelist" */
  delete_applied_whitelist_by_pk?: Maybe<AppliedWhitelist>;
  /** delete data from the table: "audit.logged_actions" */
  delete_audit_logged_actions?: Maybe<AuditLoggedActionsMutationResponse>;
  /** delete single row from the table: "audit.logged_actions" */
  delete_audit_logged_actions_by_pk?: Maybe<AuditLoggedActions>;
  delete_b2b_user?: Maybe<UserDeletionResponse>;
  /** delete data from the table: "blacklist" */
  delete_blacklist?: Maybe<BlacklistMutationResponse>;
  /** delete single row from the table: "blacklist" */
  delete_blacklist_by_pk?: Maybe<Blacklist>;
  delete_blacklist_entries: DeleteBlacklistEntriesResponse;
  /** delete data from the table: "booking.booking" */
  delete_booking_booking?: Maybe<BookingBookingMutationResponse>;
  /** delete single row from the table: "booking.booking" */
  delete_booking_booking_by_pk?: Maybe<BookingBooking>;
  /** delete data from the table: "booking.booking_invoice" */
  delete_booking_booking_invoice?: Maybe<BookingBookingInvoiceMutationResponse>;
  /** delete single row from the table: "booking.booking_invoice" */
  delete_booking_booking_invoice_by_pk?: Maybe<BookingBookingInvoice>;
  /** delete data from the table: "booking.booking_plate" */
  delete_booking_booking_plate?: Maybe<BookingBookingPlateMutationResponse>;
  /** delete single row from the table: "booking.booking_plate" */
  delete_booking_booking_plate_by_pk?: Maybe<BookingBookingPlate>;
  /** delete data from the table: "booking.booking_type" */
  delete_booking_booking_type?: Maybe<BookingBookingTypeMutationResponse>;
  /** delete single row from the table: "booking.booking_type" */
  delete_booking_booking_type_by_pk?: Maybe<BookingBookingType>;
  /** delete data from the table: "booking.booking_whitelist" */
  delete_booking_booking_whitelist?: Maybe<BookingBookingWhitelistMutationResponse>;
  /** delete single row from the table: "booking.booking_whitelist" */
  delete_booking_booking_whitelist_by_pk?: Maybe<BookingBookingWhitelist>;
  /** delete data from the table: "booking.enum_booking_status" */
  delete_booking_enum_booking_status?: Maybe<BookingEnumBookingStatusMutationResponse>;
  /** delete single row from the table: "booking.enum_booking_status" */
  delete_booking_enum_booking_status_by_pk?: Maybe<BookingEnumBookingStatus>;
  /** delete data from the table: "booking.hourly_booking" */
  delete_booking_hourly_booking?: Maybe<BookingHourlyBookingMutationResponse>;
  /** delete single row from the table: "booking.hourly_booking" */
  delete_booking_hourly_booking_by_pk?: Maybe<BookingHourlyBooking>;
  /** delete data from the table: "booking.license_plate" */
  delete_booking_license_plate?: Maybe<BookingLicensePlateMutationResponse>;
  /** delete single row from the table: "booking.license_plate" */
  delete_booking_license_plate_by_pk?: Maybe<BookingLicensePlate>;
  /** delete data from the table: "booking.lot" */
  delete_booking_lot?: Maybe<BookingLotMutationResponse>;
  /** delete single row from the table: "booking.lot" */
  delete_booking_lot_by_pk?: Maybe<BookingLot>;
  /** delete data from the table: "booking.lot_configuration" */
  delete_booking_lot_configuration?: Maybe<BookingLotConfigurationMutationResponse>;
  /** delete single row from the table: "booking.lot_configuration" */
  delete_booking_lot_configuration_by_pk?: Maybe<BookingLotConfiguration>;
  /** delete data from the table: "booking.payment" */
  delete_booking_payment?: Maybe<BookingPaymentMutationResponse>;
  /** delete single row from the table: "booking.payment" */
  delete_booking_payment_by_pk?: Maybe<BookingPayment>;
  /** delete data from the table: "booking.pricing_rules" */
  delete_booking_pricing_rules?: Maybe<BookingPricingRulesMutationResponse>;
  /** delete single row from the table: "booking.pricing_rules" */
  delete_booking_pricing_rules_by_pk?: Maybe<BookingPricingRules>;
  /** delete data from the table: "booking.pricing_type" */
  delete_booking_pricing_type?: Maybe<BookingPricingTypeMutationResponse>;
  /** delete single row from the table: "booking.pricing_type" */
  delete_booking_pricing_type_by_pk?: Maybe<BookingPricingType>;
  /** delete data from the table: "booking.private_pricing_user" */
  delete_booking_private_pricing_user?: Maybe<BookingPrivatePricingUserMutationResponse>;
  /** delete single row from the table: "booking.private_pricing_user" */
  delete_booking_private_pricing_user_by_pk?: Maybe<BookingPrivatePricingUser>;
  /** delete data from the table: "booking.recurring_booking" */
  delete_booking_recurring_booking?: Maybe<BookingRecurringBookingMutationResponse>;
  /** delete single row from the table: "booking.recurring_booking" */
  delete_booking_recurring_booking_by_pk?: Maybe<BookingRecurringBooking>;
  /** delete data from the table: "booking.subscription_booking" */
  delete_booking_subscription_booking?: Maybe<BookingSubscriptionBookingMutationResponse>;
  /** delete single row from the table: "booking.subscription_booking" */
  delete_booking_subscription_booking_by_pk?: Maybe<BookingSubscriptionBooking>;
  /** delete data from the table: "booking.subscription_license_plate" */
  delete_booking_subscription_license_plate?: Maybe<BookingSubscriptionLicensePlateMutationResponse>;
  /** delete single row from the table: "booking.subscription_license_plate" */
  delete_booking_subscription_license_plate_by_pk?: Maybe<BookingSubscriptionLicensePlate>;
  /** delete data from the table: "booking.subscription_status" */
  delete_booking_subscription_status?: Maybe<BookingSubscriptionStatusMutationResponse>;
  /** delete single row from the table: "booking.subscription_status" */
  delete_booking_subscription_status_by_pk?: Maybe<BookingSubscriptionStatus>;
  /** delete data from the table: "booking.user" */
  delete_booking_user?: Maybe<BookingUserMutationResponse>;
  /** delete data from the table: "booking.user_booking" */
  delete_booking_user_booking?: Maybe<BookingUserBookingMutationResponse>;
  /** delete single row from the table: "booking.user_booking" */
  delete_booking_user_booking_by_pk?: Maybe<BookingUserBooking>;
  /** delete single row from the table: "booking.user" */
  delete_booking_user_by_pk?: Maybe<BookingUser>;
  /** delete data from the table: "booking.user_payment_method" */
  delete_booking_user_payment_method?: Maybe<BookingUserPaymentMethodMutationResponse>;
  /** delete single row from the table: "booking.user_payment_method" */
  delete_booking_user_payment_method_by_pk?: Maybe<BookingUserPaymentMethod>;
  /** delete data from the table: "booking.user_subscription" */
  delete_booking_user_subscription?: Maybe<BookingUserSubscriptionMutationResponse>;
  /** delete single row from the table: "booking.user_subscription" */
  delete_booking_user_subscription_by_pk?: Maybe<BookingUserSubscription>;
  /** delete data from the table: "booking.vehicle" */
  delete_booking_vehicle?: Maybe<BookingVehicleMutationResponse>;
  /** delete single row from the table: "booking.vehicle" */
  delete_booking_vehicle_by_pk?: Maybe<BookingVehicle>;
  /** delete data from the table: "booking.vehicle_type" */
  delete_booking_vehicle_type?: Maybe<BookingVehicleTypeMutationResponse>;
  /** delete single row from the table: "booking.vehicle_type" */
  delete_booking_vehicle_type_by_pk?: Maybe<BookingVehicleType>;
  /** delete data from the table: "booking.whitelist_type" */
  delete_booking_whitelist_type?: Maybe<BookingWhitelistTypeMutationResponse>;
  /** delete single row from the table: "booking.whitelist_type" */
  delete_booking_whitelist_type_by_pk?: Maybe<BookingWhitelistType>;
  /** delete data from the table: "calendar_event_policy" */
  delete_calendar_event_policy?: Maybe<CalendarEventPolicyMutationResponse>;
  /** delete single row from the table: "calendar_event_policy" */
  delete_calendar_event_policy_by_pk?: Maybe<CalendarEventPolicy>;
  /** delete data from the table: "cancellations" */
  delete_cancellations?: Maybe<CancellationsMutationResponse>;
  /** delete single row from the table: "cancellations" */
  delete_cancellations_by_pk?: Maybe<Cancellations>;
  /** delete data from the table: "car_driver" */
  delete_car_driver?: Maybe<CarDriverMutationResponse>;
  /** delete single row from the table: "car_driver" */
  delete_car_driver_by_pk?: Maybe<CarDriver>;
  /** delete data from the table: "car_owner" */
  delete_car_owner?: Maybe<CarOwnerMutationResponse>;
  /** delete single row from the table: "car_owner" */
  delete_car_owner_by_pk?: Maybe<CarOwner>;
  /** delete data from the table: "car_owner_requests" */
  delete_car_owner_requests?: Maybe<CarOwnerRequestsMutationResponse>;
  /** delete single row from the table: "car_owner_requests" */
  delete_car_owner_requests_by_pk?: Maybe<CarOwnerRequests>;
  /** delete data from the table: "carpay_access_control_lp_pin" */
  delete_carpay_access_control_lp_pin?: Maybe<CarpayAccessControlLpPinMutationResponse>;
  /** delete single row from the table: "carpay_access_control_lp_pin" */
  delete_carpay_access_control_lp_pin_by_pk?: Maybe<CarpayAccessControlLpPin>;
  /** delete data from the table: "carpay_discount_batch" */
  delete_carpay_discount_batch?: Maybe<CarpayDiscountBatchMutationResponse>;
  /** delete single row from the table: "carpay_discount_batch" */
  delete_carpay_discount_batch_by_pk?: Maybe<CarpayDiscountBatch>;
  /** delete data from the table: "carpay_discount_model" */
  delete_carpay_discount_model?: Maybe<CarpayDiscountModelMutationResponse>;
  /** delete single row from the table: "carpay_discount_model" */
  delete_carpay_discount_model_by_pk?: Maybe<CarpayDiscountModel>;
  /** delete data from the table: "carpay_lot" */
  delete_carpay_lot?: Maybe<CarpayLotMutationResponse>;
  /** delete single row from the table: "carpay_lot" */
  delete_carpay_lot_by_pk?: Maybe<CarpayLot>;
  /** delete data from the table: "carpay_notification_subscriber" */
  delete_carpay_notification_subscriber?: Maybe<CarpayNotificationSubscriberMutationResponse>;
  /** delete single row from the table: "carpay_notification_subscriber" */
  delete_carpay_notification_subscriber_by_pk?: Maybe<CarpayNotificationSubscriber>;
  /** delete data from the table: "carpay_notification_subscription" */
  delete_carpay_notification_subscription?: Maybe<CarpayNotificationSubscriptionMutationResponse>;
  /** delete single row from the table: "carpay_notification_subscription" */
  delete_carpay_notification_subscription_by_pk?: Maybe<CarpayNotificationSubscription>;
  /** delete data from the table: "carpay_notification_subscription_category" */
  delete_carpay_notification_subscription_category?: Maybe<CarpayNotificationSubscriptionCategoryMutationResponse>;
  /** delete single row from the table: "carpay_notification_subscription_category" */
  delete_carpay_notification_subscription_category_by_pk?: Maybe<CarpayNotificationSubscriptionCategory>;
  /** delete data from the table: "carpay_order" */
  delete_carpay_order?: Maybe<CarpayOrderMutationResponse>;
  /** delete single row from the table: "carpay_order" */
  delete_carpay_order_by_pk?: Maybe<CarpayOrder>;
  /** delete data from the table: "carpay_order_matches" */
  delete_carpay_order_matches?: Maybe<CarpayOrderMatchesMutationResponse>;
  /** delete single row from the table: "carpay_order_matches" */
  delete_carpay_order_matches_by_pk?: Maybe<CarpayOrderMatches>;
  /** delete data from the table: "carpay_order_user" */
  delete_carpay_order_user?: Maybe<CarpayOrderUserMutationResponse>;
  /** delete single row from the table: "carpay_order_user" */
  delete_carpay_order_user_by_pk?: Maybe<CarpayOrderUser>;
  /** delete data from the table: "carpay_parking_detection" */
  delete_carpay_parking_detection?: Maybe<CarpayParkingDetectionMutationResponse>;
  /** delete single row from the table: "carpay_parking_detection" */
  delete_carpay_parking_detection_by_pk?: Maybe<CarpayParkingDetection>;
  /** delete data from the table: "carpay_pricing" */
  delete_carpay_pricing?: Maybe<CarpayPricingMutationResponse>;
  /** delete single row from the table: "carpay_pricing" */
  delete_carpay_pricing_by_pk?: Maybe<CarpayPricing>;
  /** delete data from the table: "carpay_pricing_config_group" */
  delete_carpay_pricing_config_group?: Maybe<CarpayPricingConfigGroupMutationResponse>;
  /** delete single row from the table: "carpay_pricing_config_group" */
  delete_carpay_pricing_config_group_by_pk?: Maybe<CarpayPricingConfigGroup>;
  /** delete data from the table: "carpay_pricing_period" */
  delete_carpay_pricing_period?: Maybe<CarpayPricingPeriodMutationResponse>;
  /** delete single row from the table: "carpay_pricing_period" */
  delete_carpay_pricing_period_by_pk?: Maybe<CarpayPricingPeriod>;
  /** delete data from the table: "carpay_pricing_recurrence" */
  delete_carpay_pricing_recurrence?: Maybe<CarpayPricingRecurrenceMutationResponse>;
  /** delete single row from the table: "carpay_pricing_recurrence" */
  delete_carpay_pricing_recurrence_by_pk?: Maybe<CarpayPricingRecurrence>;
  /** delete data from the table: "carpay_pricing_rules" */
  delete_carpay_pricing_rules?: Maybe<CarpayPricingRulesMutationResponse>;
  /** delete single row from the table: "carpay_pricing_rules" */
  delete_carpay_pricing_rules_by_pk?: Maybe<CarpayPricingRules>;
  /** delete data from the table: "carpay_scanned_codes" */
  delete_carpay_scanned_codes?: Maybe<CarpayScannedCodesMutationResponse>;
  /** delete single row from the table: "carpay_scanned_codes" */
  delete_carpay_scanned_codes_by_pk?: Maybe<CarpayScannedCodes>;
  /** delete data from the table: "carpay_terminal_cash_cut_notification" */
  delete_carpay_terminal_cash_cut_notification?: Maybe<CarpayTerminalCashCutNotificationMutationResponse>;
  /** delete single row from the table: "carpay_terminal_cash_cut_notification" */
  delete_carpay_terminal_cash_cut_notification_by_pk?: Maybe<CarpayTerminalCashCutNotification>;
  /** delete data from the table: "carpay_terminal_cash_fill_level_notification" */
  delete_carpay_terminal_cash_fill_level_notification?: Maybe<CarpayTerminalCashFillLevelNotificationMutationResponse>;
  /** delete single row from the table: "carpay_terminal_cash_fill_level_notification" */
  delete_carpay_terminal_cash_fill_level_notification_by_pk?: Maybe<CarpayTerminalCashFillLevelNotification>;
  /** delete data from the table: "carpay_terminal_notification_config" */
  delete_carpay_terminal_notification_config?: Maybe<CarpayTerminalNotificationConfigMutationResponse>;
  /** delete single row from the table: "carpay_terminal_notification_config" */
  delete_carpay_terminal_notification_config_by_pk?: Maybe<CarpayTerminalNotificationConfig>;
  /** delete data from the table: "carpay_terminal_printer_status_notification" */
  delete_carpay_terminal_printer_status_notification?: Maybe<CarpayTerminalPrinterStatusNotificationMutationResponse>;
  /** delete single row from the table: "carpay_terminal_printer_status_notification" */
  delete_carpay_terminal_printer_status_notification_by_pk?: Maybe<CarpayTerminalPrinterStatusNotification>;
  /** delete data from the table: "carpay_user_verified_plate" */
  delete_carpay_user_verified_plate?: Maybe<CarpayUserVerifiedPlateMutationResponse>;
  /** delete single row from the table: "carpay_user_verified_plate" */
  delete_carpay_user_verified_plate_by_pk?: Maybe<CarpayUserVerifiedPlate>;
  /** delete data from the table: "chain" */
  delete_chain?: Maybe<ChainMutationResponse>;
  /** delete single row from the table: "chain" */
  delete_chain_by_pk?: Maybe<Chain>;
  /** delete data from the table: "city_codes" */
  delete_city_codes?: Maybe<CityCodesMutationResponse>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<CompanyMutationResponse>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "company_config_group" */
  delete_company_config_group?: Maybe<CompanyConfigGroupMutationResponse>;
  /** delete single row from the table: "company_config_group" */
  delete_company_config_group_by_pk?: Maybe<CompanyConfigGroup>;
  /** delete data from the table: "company_hierarchy" */
  delete_company_hierarchy?: Maybe<CompanyHierarchyMutationResponse>;
  /** delete single row from the table: "company_hierarchy" */
  delete_company_hierarchy_by_pk?: Maybe<CompanyHierarchy>;
  /** delete data from the table: "company_lot_section" */
  delete_company_lot_section?: Maybe<CompanyLotSectionMutationResponse>;
  /** delete single row from the table: "company_lot_section" */
  delete_company_lot_section_by_pk?: Maybe<CompanyLotSection>;
  /** delete data from the table: "company_vat_id" */
  delete_company_vat_id?: Maybe<CompanyVatIdMutationResponse>;
  /** delete single row from the table: "company_vat_id" */
  delete_company_vat_id_by_pk?: Maybe<CompanyVatId>;
  /** delete data from the table: "company_violator" */
  delete_company_violator?: Maybe<CompanyViolatorMutationResponse>;
  /** delete single row from the table: "company_violator" */
  delete_company_violator_by_pk?: Maybe<CompanyViolator>;
  /** delete data from the table: "config_group" */
  delete_config_group?: Maybe<ConfigGroupMutationResponse>;
  /** delete single row from the table: "config_group" */
  delete_config_group_by_pk?: Maybe<ConfigGroup>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<CountryMutationResponse>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "currency" */
  delete_currency?: Maybe<CurrencyMutationResponse>;
  /** delete single row from the table: "currency" */
  delete_currency_by_pk?: Maybe<Currency>;
  /** delete data from the table: "customer_dashboard_nps_feedback" */
  delete_customer_dashboard_nps_feedback?: Maybe<CustomerDashboardNpsFeedbackMutationResponse>;
  /** delete single row from the table: "customer_dashboard_nps_feedback" */
  delete_customer_dashboard_nps_feedback_by_pk?: Maybe<CustomerDashboardNpsFeedback>;
  /** delete data from the table: "daily_failure" */
  delete_daily_failure?: Maybe<DailyFailureMutationResponse>;
  /** delete single row from the table: "daily_failure" */
  delete_daily_failure_by_pk?: Maybe<DailyFailure>;
  /** delete data from the table: "daily_stats" */
  delete_daily_stats?: Maybe<DailyStatsMutationResponse>;
  /** delete single row from the table: "daily_stats" */
  delete_daily_stats_by_pk?: Maybe<DailyStats>;
  /** delete data from the table: "department" */
  delete_department?: Maybe<DepartmentMutationResponse>;
  /** delete single row from the table: "department" */
  delete_department_by_pk?: Maybe<Department>;
  /** delete data from the table: "detection_type_enum" */
  delete_detection_type_enum?: Maybe<DetectionTypeEnumMutationResponse>;
  /** delete single row from the table: "detection_type_enum" */
  delete_detection_type_enum_by_pk?: Maybe<DetectionTypeEnum>;
  /** delete data from the table: "device" */
  delete_device?: Maybe<DeviceMutationResponse>;
  /** delete single row from the table: "device" */
  delete_device_by_pk?: Maybe<Device>;
  /** delete data from the table: "easypark_lot" */
  delete_easypark_lot?: Maybe<EasyparkLotMutationResponse>;
  /** delete single row from the table: "easypark_lot" */
  delete_easypark_lot_by_pk?: Maybe<EasyparkLot>;
  /** delete data from the table: "easypark_order" */
  delete_easypark_order?: Maybe<EasyparkOrderMutationResponse>;
  /** delete single row from the table: "easypark_order" */
  delete_easypark_order_by_pk?: Maybe<EasyparkOrder>;
  /** delete data from the table: "easypark_order_v2" */
  delete_easypark_order_v2?: Maybe<EasyparkOrderV2MutationResponse>;
  /** delete single row from the table: "easypark_order_v2" */
  delete_easypark_order_v2_by_pk?: Maybe<EasyparkOrderV2>;
  /** delete data from the table: "easypark_parking_info" */
  delete_easypark_parking_info?: Maybe<EasyparkParkingInfoMutationResponse>;
  /** delete single row from the table: "easypark_parking_info" */
  delete_easypark_parking_info_by_pk?: Maybe<EasyparkParkingInfo>;
  /** delete data from the table: "enforcement_daily_stats" */
  delete_enforcement_daily_stats?: Maybe<EnforcementDailyStatsMutationResponse>;
  /** delete single row from the table: "enforcement_daily_stats" */
  delete_enforcement_daily_stats_by_pk?: Maybe<EnforcementDailyStats>;
  /** delete data from the table: "enum_carpay_discount_model_code_type" */
  delete_enum_carpay_discount_model_code_type?: Maybe<EnumCarpayDiscountModelCodeTypeMutationResponse>;
  /** delete single row from the table: "enum_carpay_discount_model_code_type" */
  delete_enum_carpay_discount_model_code_type_by_pk?: Maybe<EnumCarpayDiscountModelCodeType>;
  /** delete data from the table: "enum_country_code" */
  delete_enum_country_code?: Maybe<EnumCountryCodeMutationResponse>;
  /** delete single row from the table: "enum_country_code" */
  delete_enum_country_code_by_pk?: Maybe<EnumCountryCode>;
  /** delete data from the table: "enum_customer_whitelist_purpose" */
  delete_enum_customer_whitelist_purpose?: Maybe<EnumCustomerWhitelistPurposeMutationResponse>;
  /** delete single row from the table: "enum_customer_whitelist_purpose" */
  delete_enum_customer_whitelist_purpose_by_pk?: Maybe<EnumCustomerWhitelistPurpose>;
  /** delete data from the table: "enum_customer_whitelist_status" */
  delete_enum_customer_whitelist_status?: Maybe<EnumCustomerWhitelistStatusMutationResponse>;
  /** delete single row from the table: "enum_customer_whitelist_status" */
  delete_enum_customer_whitelist_status_by_pk?: Maybe<EnumCustomerWhitelistStatus>;
  /** delete data from the table: "enum_device_type" */
  delete_enum_device_type?: Maybe<EnumDeviceTypeMutationResponse>;
  /** delete single row from the table: "enum_device_type" */
  delete_enum_device_type_by_pk?: Maybe<EnumDeviceType>;
  /** delete data from the table: "enum_driver_request_type" */
  delete_enum_driver_request_type?: Maybe<EnumDriverRequestTypeMutationResponse>;
  /** delete single row from the table: "enum_driver_request_type" */
  delete_enum_driver_request_type_by_pk?: Maybe<EnumDriverRequestType>;
  /** delete data from the table: "enum_guest_jwt_purpose" */
  delete_enum_guest_jwt_purpose?: Maybe<EnumGuestJwtPurposeMutationResponse>;
  /** delete single row from the table: "enum_guest_jwt_purpose" */
  delete_enum_guest_jwt_purpose_by_pk?: Maybe<EnumGuestJwtPurpose>;
  /** delete data from the table: "enum_supervision_mlp_request_status" */
  delete_enum_supervision_mlp_request_status?: Maybe<EnumSupervisionMlpRequestStatusMutationResponse>;
  /** delete single row from the table: "enum_supervision_mlp_request_status" */
  delete_enum_supervision_mlp_request_status_by_pk?: Maybe<EnumSupervisionMlpRequestStatus>;
  /** delete data from the table: "enum_violation_cancellation" */
  delete_enum_violation_cancellation?: Maybe<EnumViolationCancellationMutationResponse>;
  /** delete single row from the table: "enum_violation_cancellation" */
  delete_enum_violation_cancellation_by_pk?: Maybe<EnumViolationCancellation>;
  /** delete data from the table: "enum_violation_case_charges_invalidation_reason" */
  delete_enum_violation_case_charges_invalidation_reason?: Maybe<EnumViolationCaseChargesInvalidationReasonMutationResponse>;
  /** delete single row from the table: "enum_violation_case_charges_invalidation_reason" */
  delete_enum_violation_case_charges_invalidation_reason_by_pk?: Maybe<EnumViolationCaseChargesInvalidationReason>;
  /** delete data from the table: "enum_violation_case_charges_type" */
  delete_enum_violation_case_charges_type?: Maybe<EnumViolationCaseChargesTypeMutationResponse>;
  /** delete single row from the table: "enum_violation_case_charges_type" */
  delete_enum_violation_case_charges_type_by_pk?: Maybe<EnumViolationCaseChargesType>;
  /** delete data from the table: "enum_whitelist_paid_parking_types" */
  delete_enum_whitelist_paid_parking_types?: Maybe<EnumWhitelistPaidParkingTypesMutationResponse>;
  /** delete single row from the table: "enum_whitelist_paid_parking_types" */
  delete_enum_whitelist_paid_parking_types_by_pk?: Maybe<EnumWhitelistPaidParkingTypes>;
  /** delete data from the table: "enum_whitelist_scope" */
  delete_enum_whitelist_scope?: Maybe<EnumWhitelistScopeMutationResponse>;
  /** delete single row from the table: "enum_whitelist_scope" */
  delete_enum_whitelist_scope_by_pk?: Maybe<EnumWhitelistScope>;
  /** delete data from the table: "enum_whitelist_status" */
  delete_enum_whitelist_status?: Maybe<EnumWhitelistStatusMutationResponse>;
  /** delete single row from the table: "enum_whitelist_status" */
  delete_enum_whitelist_status_by_pk?: Maybe<EnumWhitelistStatus>;
  /** delete data from the table: "enum_whitelist_types" */
  delete_enum_whitelist_types?: Maybe<EnumWhitelistTypesMutationResponse>;
  /** delete single row from the table: "enum_whitelist_types" */
  delete_enum_whitelist_types_by_pk?: Maybe<EnumWhitelistTypes>;
  /** delete data from the table: "guest_jwt" */
  delete_guest_jwt?: Maybe<GuestJwtMutationResponse>;
  /** delete single row from the table: "guest_jwt" */
  delete_guest_jwt_by_pk?: Maybe<GuestJwt>;
  /** delete data from the table: "guest_qr" */
  delete_guest_qr?: Maybe<GuestQrMutationResponse>;
  /** delete single row from the table: "guest_qr" */
  delete_guest_qr_by_pk?: Maybe<GuestQr>;
  /** delete data from the table: "lot" */
  delete_lot?: Maybe<LotMutationResponse>;
  /** delete single row from the table: "lot" */
  delete_lot_by_pk?: Maybe<Lot>;
  /** delete data from the table: "lot_config_group" */
  delete_lot_config_group?: Maybe<LotConfigGroupMutationResponse>;
  /** delete single row from the table: "lot_config_group" */
  delete_lot_config_group_by_pk?: Maybe<LotConfigGroup>;
  /** delete data from the table: "lot_display_name" */
  delete_lot_display_name?: Maybe<LotDisplayNameMutationResponse>;
  /** delete single row from the table: "lot_display_name" */
  delete_lot_display_name_by_pk?: Maybe<LotDisplayName>;
  /** delete data from the table: "lot_hierarchy" */
  delete_lot_hierarchy?: Maybe<LotHierarchyMutationResponse>;
  /** delete single row from the table: "lot_hierarchy" */
  delete_lot_hierarchy_by_pk?: Maybe<LotHierarchy>;
  /** delete data from the table: "lot_legal_entity" */
  delete_lot_legal_entity?: Maybe<LotLegalEntityMutationResponse>;
  /** delete single row from the table: "lot_legal_entity" */
  delete_lot_legal_entity_by_pk?: Maybe<LotLegalEntity>;
  /** delete data from the table: "lot_policy_history" */
  delete_lot_policy_history?: Maybe<LotPolicyHistoryMutationResponse>;
  /** delete single row from the table: "lot_policy_history" */
  delete_lot_policy_history_by_pk?: Maybe<LotPolicyHistory>;
  /** delete data from the table: "lot_section" */
  delete_lot_section?: Maybe<LotSectionMutationResponse>;
  /** delete single row from the table: "lot_section" */
  delete_lot_section_by_pk?: Maybe<LotSection>;
  /** delete data from the table: "lp_contingent" */
  delete_lp_contingent?: Maybe<LpContingentMutationResponse>;
  /** delete single row from the table: "lp_contingent" */
  delete_lp_contingent_by_pk?: Maybe<LpContingent>;
  /** delete data from the table: "lp_group" */
  delete_lp_group?: Maybe<LpGroupMutationResponse>;
  /** delete single row from the table: "lp_group" */
  delete_lp_group_by_pk?: Maybe<LpGroup>;
  /** delete data from the table: "lp_group_config_group" */
  delete_lp_group_config_group?: Maybe<LpGroupConfigGroupMutationResponse>;
  /** delete single row from the table: "lp_group_config_group" */
  delete_lp_group_config_group_by_pk?: Maybe<LpGroupConfigGroup>;
  /** delete data from the table: "lp_group_details" */
  delete_lp_group_details?: Maybe<LpGroupDetailsMutationResponse>;
  /** delete single row from the table: "lp_group_details" */
  delete_lp_group_details_by_pk?: Maybe<LpGroupDetails>;
  /** delete data from the table: "lp_group_member" */
  delete_lp_group_member?: Maybe<LpGroupMemberMutationResponse>;
  /** delete single row from the table: "lp_group_member" */
  delete_lp_group_member_by_pk?: Maybe<LpGroupMember>;
  /** delete data from the table: "lp_group_member_details" */
  delete_lp_group_member_details?: Maybe<LpGroupMemberDetailsMutationResponse>;
  /** delete single row from the table: "lp_group_member_details" */
  delete_lp_group_member_details_by_pk?: Maybe<LpGroupMemberDetails>;
  /** delete data from the table: "mail" */
  delete_mail?: Maybe<MailMutationResponse>;
  /** delete single row from the table: "mail" */
  delete_mail_by_pk?: Maybe<Mail>;
  /** delete data from the table: "mail_misc" */
  delete_mail_misc?: Maybe<MailMiscMutationResponse>;
  /** delete single row from the table: "mail_misc" */
  delete_mail_misc_by_pk?: Maybe<MailMisc>;
  /** delete data from the table: "mlp_cases" */
  delete_mlp_cases?: Maybe<MlpCasesMutationResponse>;
  /** delete single row from the table: "mlp_cases" */
  delete_mlp_cases_by_pk?: Maybe<MlpCases>;
  /** delete data from the table: "mlp_mappings" */
  delete_mlp_mappings?: Maybe<MlpMappingsMutationResponse>;
  /** delete single row from the table: "mlp_mappings" */
  delete_mlp_mappings_by_pk?: Maybe<MlpMappings>;
  /** delete data from the table: "mqtt_request" */
  delete_mqtt_request?: Maybe<MqttRequestMutationResponse>;
  /** delete single row from the table: "mqtt_request" */
  delete_mqtt_request_by_pk?: Maybe<MqttRequest>;
  /** delete data from the table: "offence_parking_events" */
  delete_offence_parking_events?: Maybe<OffenceParkingEventsMutationResponse>;
  /** delete single row from the table: "offence_parking_events" */
  delete_offence_parking_events_by_pk?: Maybe<OffenceParkingEvents>;
  /** delete data from the table: "offence_ticket_requests" */
  delete_offence_ticket_requests?: Maybe<OffenceTicketRequestsMutationResponse>;
  /** delete single row from the table: "offence_ticket_requests" */
  delete_offence_ticket_requests_by_pk?: Maybe<OffenceTicketRequests>;
  /** delete data from the table: "overuse_group" */
  delete_overuse_group?: Maybe<OveruseGroupMutationResponse>;
  /** delete single row from the table: "overuse_group" */
  delete_overuse_group_by_pk?: Maybe<OveruseGroup>;
  /** delete data from the table: "overuse_group_member" */
  delete_overuse_group_member?: Maybe<OveruseGroupMemberMutationResponse>;
  /** delete single row from the table: "overuse_group_member" */
  delete_overuse_group_member_by_pk?: Maybe<OveruseGroupMember>;
  /** delete data from the table: "parkdepot_product" */
  delete_parkdepot_product?: Maybe<ParkdepotProductMutationResponse>;
  /** delete single row from the table: "parkdepot_product" */
  delete_parkdepot_product_by_pk?: Maybe<ParkdepotProduct>;
  /** delete data from the table: "parking_context" */
  delete_parking_context?: Maybe<ParkingContextMutationResponse>;
  /** delete single row from the table: "parking_context" */
  delete_parking_context_by_pk?: Maybe<ParkingContext>;
  /** delete data from the table: "parking_detections" */
  delete_parking_detections?: Maybe<ParkingDetectionsMutationResponse>;
  /** delete data from the table: "parking_detections_archive" */
  delete_parking_detections_archive?: Maybe<ParkingDetectionsArchiveMutationResponse>;
  /** delete single row from the table: "parking_detections_archive" */
  delete_parking_detections_archive_by_pk?: Maybe<ParkingDetectionsArchive>;
  /** delete single row from the table: "parking_detections" */
  delete_parking_detections_by_pk?: Maybe<ParkingDetections>;
  /** delete data from the table: "parking_incoming" */
  delete_parking_incoming?: Maybe<ParkingIncomingMutationResponse>;
  /** delete single row from the table: "parking_incoming" */
  delete_parking_incoming_by_pk?: Maybe<ParkingIncoming>;
  /** delete data from the table: "parking_processing" */
  delete_parking_processing?: Maybe<ParkingProcessingMutationResponse>;
  /** delete single row from the table: "parking_processing" */
  delete_parking_processing_by_pk?: Maybe<ParkingProcessing>;
  /** delete data from the table: "parking_results" */
  delete_parking_results?: Maybe<ParkingResultsMutationResponse>;
  /** delete data from the table: "parking_results_archive" */
  delete_parking_results_archive?: Maybe<ParkingResultsArchiveMutationResponse>;
  /** delete single row from the table: "parking_results_archive" */
  delete_parking_results_archive_by_pk?: Maybe<ParkingResultsArchive>;
  /** delete single row from the table: "parking_results" */
  delete_parking_results_by_pk?: Maybe<ParkingResults>;
  /** delete data from the table: "parking_temp" */
  delete_parking_temp?: Maybe<ParkingTempMutationResponse>;
  /** delete single row from the table: "parking_temp" */
  delete_parking_temp_by_pk?: Maybe<ParkingTemp>;
  /** delete data from the table: "paybyphone_lot" */
  delete_paybyphone_lot?: Maybe<PaybyphoneLotMutationResponse>;
  /** delete single row from the table: "paybyphone_lot" */
  delete_paybyphone_lot_by_pk?: Maybe<PaybyphoneLot>;
  /** delete data from the table: "paybyphone_order" */
  delete_paybyphone_order?: Maybe<PaybyphoneOrderMutationResponse>;
  /** delete single row from the table: "paybyphone_order" */
  delete_paybyphone_order_by_pk?: Maybe<PaybyphoneOrder>;
  /** delete data from the table: "person" */
  delete_person?: Maybe<PersonMutationResponse>;
  /** delete single row from the table: "person" */
  delete_person_by_pk?: Maybe<Person>;
  /** delete data from the table: "policy_schedule" */
  delete_policy_schedule?: Maybe<PolicyScheduleMutationResponse>;
  /** delete single row from the table: "policy_schedule" */
  delete_policy_schedule_by_pk?: Maybe<PolicySchedule>;
  /** delete data from the table: "regional_codes_austria" */
  delete_regional_codes_austria?: Maybe<RegionalCodesAustriaMutationResponse>;
  /** delete single row from the table: "regional_codes_austria" */
  delete_regional_codes_austria_by_pk?: Maybe<RegionalCodesAustria>;
  /** delete data from the table: "rental_pricing" */
  delete_rental_pricing?: Maybe<RentalPricingMutationResponse>;
  /** delete single row from the table: "rental_pricing" */
  delete_rental_pricing_by_pk?: Maybe<RentalPricing>;
  /** delete data from the table: "rental_subscription" */
  delete_rental_subscription?: Maybe<RentalSubscriptionMutationResponse>;
  /** delete single row from the table: "rental_subscription" */
  delete_rental_subscription_by_pk?: Maybe<RentalSubscription>;
  /** delete data from the table: "serverless_async_work" */
  delete_serverless_async_work?: Maybe<ServerlessAsyncWorkMutationResponse>;
  /** delete single row from the table: "serverless_async_work" */
  delete_serverless_async_work_by_pk?: Maybe<ServerlessAsyncWork>;
  /** delete data from the table: "similar_detections" */
  delete_similar_detections?: Maybe<SimilarDetectionsMutationResponse>;
  /** delete single row from the table: "similar_detections" */
  delete_similar_detections_by_pk?: Maybe<SimilarDetections>;
  /** delete data from the table: "stages" */
  delete_stages?: Maybe<StagesMutationResponse>;
  /** delete single row from the table: "stages" */
  delete_stages_by_pk?: Maybe<Stages>;
  /** delete data from the table: "station" */
  delete_station?: Maybe<StationMutationResponse>;
  /** delete single row from the table: "station" */
  delete_station_by_pk?: Maybe<Station>;
  /** delete data from the table: "supervision_car_rental_partners" */
  delete_supervision_car_rental_partners?: Maybe<SupervisionCarRentalPartnersMutationResponse>;
  /** delete single row from the table: "supervision_car_rental_partners" */
  delete_supervision_car_rental_partners_by_pk?: Maybe<SupervisionCarRentalPartners>;
  /** delete data from the table: "supervision_debt_collection_case" */
  delete_supervision_debt_collection_case?: Maybe<SupervisionDebtCollectionCaseMutationResponse>;
  /** delete single row from the table: "supervision_debt_collection_case" */
  delete_supervision_debt_collection_case_by_pk?: Maybe<SupervisionDebtCollectionCase>;
  /** delete data from the table: "supervision_image_requests" */
  delete_supervision_image_requests?: Maybe<SupervisionImageRequestsMutationResponse>;
  /** delete single row from the table: "supervision_image_requests" */
  delete_supervision_image_requests_by_pk?: Maybe<SupervisionImageRequests>;
  /** delete data from the table: "supervision_mlp_requests" */
  delete_supervision_mlp_requests?: Maybe<SupervisionMlpRequestsMutationResponse>;
  /** delete single row from the table: "supervision_mlp_requests" */
  delete_supervision_mlp_requests_by_pk?: Maybe<SupervisionMlpRequests>;
  /** delete data from the table: "supervision_multivisit_offender_group" */
  delete_supervision_multivisit_offender_group?: Maybe<SupervisionMultivisitOffenderGroupMutationResponse>;
  /** delete single row from the table: "supervision_multivisit_offender_group" */
  delete_supervision_multivisit_offender_group_by_pk?: Maybe<SupervisionMultivisitOffenderGroup>;
  /** delete data from the table: "supervision_multivisit_offender_group_member" */
  delete_supervision_multivisit_offender_group_member?: Maybe<SupervisionMultivisitOffenderGroupMemberMutationResponse>;
  /** delete single row from the table: "supervision_multivisit_offender_group_member" */
  delete_supervision_multivisit_offender_group_member_by_pk?: Maybe<SupervisionMultivisitOffenderGroupMember>;
  /** delete data from the table: "supervision_ticket_request" */
  delete_supervision_ticket_request?: Maybe<SupervisionTicketRequestMutationResponse>;
  /** delete single row from the table: "supervision_ticket_request" */
  delete_supervision_ticket_request_by_pk?: Maybe<SupervisionTicketRequest>;
  /** delete data from the table: "supervision_violation_case_debt_collection_case" */
  delete_supervision_violation_case_debt_collection_case?: Maybe<SupervisionViolationCaseDebtCollectionCaseMutationResponse>;
  /** delete single row from the table: "supervision_violation_case_debt_collection_case" */
  delete_supervision_violation_case_debt_collection_case_by_pk?: Maybe<SupervisionViolationCaseDebtCollectionCase>;
  /** delete data from the table: "tax" */
  delete_tax?: Maybe<TaxMutationResponse>;
  /** delete single row from the table: "tax" */
  delete_tax_by_pk?: Maybe<Tax>;
  /** delete data from the table: "terminal_status" */
  delete_terminal_status?: Maybe<TerminalStatusMutationResponse>;
  /** delete single row from the table: "terminal_status" */
  delete_terminal_status_by_pk?: Maybe<TerminalStatus>;
  /** delete data from the table: "ticket_website_feedback" */
  delete_ticket_website_feedback?: Maybe<TicketWebsiteFeedbackMutationResponse>;
  /** delete single row from the table: "ticket_website_feedback" */
  delete_ticket_website_feedback_by_pk?: Maybe<TicketWebsiteFeedback>;
  /** delete data from the table: "time_discount" */
  delete_time_discount?: Maybe<TimeDiscountMutationResponse>;
  /** delete single row from the table: "time_discount" */
  delete_time_discount_by_pk?: Maybe<TimeDiscount>;
  delete_user_license_plate?: Maybe<DeleteUserLicensePlateResponse>;
  /** delete data from the table: "user_preference" */
  delete_user_preference?: Maybe<UserPreferenceMutationResponse>;
  /** delete single row from the table: "user_preference" */
  delete_user_preference_by_pk?: Maybe<UserPreference>;
  delete_user_vehicle?: Maybe<DeleteUserVehicleResponse>;
  /** delete data from the table: "vehicle_type" */
  delete_vehicle_type?: Maybe<VehicleTypeMutationResponse>;
  /** delete single row from the table: "vehicle_type" */
  delete_vehicle_type_by_pk?: Maybe<VehicleType>;
  /** delete data from the table: "vehicle_type_config_group" */
  delete_vehicle_type_config_group?: Maybe<VehicleTypeConfigGroupMutationResponse>;
  /** delete single row from the table: "vehicle_type_config_group" */
  delete_vehicle_type_config_group_by_pk?: Maybe<VehicleTypeConfigGroup>;
  /** delete data from the table: "violation_case" */
  delete_violation_case?: Maybe<ViolationCaseMutationResponse>;
  /** delete single row from the table: "violation_case" */
  delete_violation_case_by_pk?: Maybe<ViolationCase>;
  /** delete data from the table: "violation_case_charges" */
  delete_violation_case_charges?: Maybe<ViolationCaseChargesMutationResponse>;
  /** delete single row from the table: "violation_case_charges" */
  delete_violation_case_charges_by_pk?: Maybe<ViolationCaseCharges>;
  /** delete data from the table: "violation_case_tags" */
  delete_violation_case_tags?: Maybe<ViolationCaseTagsMutationResponse>;
  /** delete single row from the table: "violation_case_tags" */
  delete_violation_case_tags_by_pk?: Maybe<ViolationCaseTags>;
  /** delete data from the table: "violation_event_analysis" */
  delete_violation_event_analysis?: Maybe<ViolationEventAnalysisMutationResponse>;
  /** delete single row from the table: "violation_event_analysis" */
  delete_violation_event_analysis_by_pk?: Maybe<ViolationEventAnalysis>;
  /** delete data from the table: "violator_transactions" */
  delete_violator_transactions?: Maybe<ViolatorTransactionsMutationResponse>;
  /** delete single row from the table: "violator_transactions" */
  delete_violator_transactions_by_pk?: Maybe<ViolatorTransactions>;
  /** delete data from the table: "whitelist" */
  delete_whitelist?: Maybe<WhitelistMutationResponse>;
  /** delete data from the table: "whitelist_applied_permit" */
  delete_whitelist_applied_permit?: Maybe<WhitelistAppliedPermitMutationResponse>;
  /** delete single row from the table: "whitelist_applied_permit" */
  delete_whitelist_applied_permit_by_pk?: Maybe<WhitelistAppliedPermit>;
  /** delete single row from the table: "whitelist" */
  delete_whitelist_by_pk?: Maybe<Whitelist>;
  /** delete data from the table: "whitelist_calendar_event_policy" */
  delete_whitelist_calendar_event_policy?: Maybe<WhitelistCalendarEventPolicyMutationResponse>;
  /** delete single row from the table: "whitelist_calendar_event_policy" */
  delete_whitelist_calendar_event_policy_by_pk?: Maybe<WhitelistCalendarEventPolicy>;
  delete_whitelist_entries: DeleteWhitelistEntriesResponse;
  /** delete data from the table: "whitelist_lp_contingent" */
  delete_whitelist_lp_contingent?: Maybe<WhitelistLpContingentMutationResponse>;
  /** delete single row from the table: "whitelist_lp_contingent" */
  delete_whitelist_lp_contingent_by_pk?: Maybe<WhitelistLpContingent>;
  /** delete data from the table: "whitelist_paid_parking" */
  delete_whitelist_paid_parking?: Maybe<WhitelistPaidParkingMutationResponse>;
  /** delete single row from the table: "whitelist_paid_parking" */
  delete_whitelist_paid_parking_by_pk?: Maybe<WhitelistPaidParking>;
  /** delete data from the table: "whitelist_subscription" */
  delete_whitelist_subscription?: Maybe<WhitelistSubscriptionMutationResponse>;
  /** delete single row from the table: "whitelist_subscription" */
  delete_whitelist_subscription_by_pk?: Maybe<WhitelistSubscription>;
  /** delete data from the table: "wireguard_config" */
  delete_wireguard_config?: Maybe<WireguardConfigMutationResponse>;
  /** delete single row from the table: "wireguard_config" */
  delete_wireguard_config_by_pk?: Maybe<WireguardConfig>;
  /** This endpoint allows us to generate invoices on demand from the frontend for specific orders (for example orders that have been enforced and are in UNPAID status) */
  generate_carpay_invoice?: Maybe<CarpayInvoiceGenerationOutput>;
  generate_guest_JWT?: Maybe<GeneratedGuestJwt>;
  generate_letter?: Maybe<GenerateLetterOutput>;
  generate_special_letter?: Maybe<GenerateSpecLetterOutput>;
  generate_violation_case?: Maybe<GenerateViolationCaseResult>;
  get_car_owner_requests_response_at?: Maybe<GetAtCarOwnerRequestsResponseOutput>;
  get_kba_response?: Maybe<GetKbaResponseOutput>;
  group_violations_by_violator?: Maybe<ViolationsByViolatorOutput>;
  group_violations_by_violator_with_config?: Maybe<ViolationsByViolatorOutput>;
  /** insert data into the table: "adyen_report" */
  insert_adyen_report?: Maybe<AdyenReportMutationResponse>;
  /** insert a single row into the table: "adyen_report" */
  insert_adyen_report_one?: Maybe<AdyenReport>;
  /** insert data into the table: "adyen_transaction" */
  insert_adyen_transaction?: Maybe<AdyenTransactionMutationResponse>;
  /** insert a single row into the table: "adyen_transaction" */
  insert_adyen_transaction_one?: Maybe<AdyenTransaction>;
  /** insert data into the table: "applied_permit" */
  insert_applied_permit?: Maybe<AppliedPermitMutationResponse>;
  /** insert a single row into the table: "applied_permit" */
  insert_applied_permit_one?: Maybe<AppliedPermit>;
  /** insert data into the table: "applied_whitelist" */
  insert_applied_whitelist?: Maybe<AppliedWhitelistMutationResponse>;
  /** insert a single row into the table: "applied_whitelist" */
  insert_applied_whitelist_one?: Maybe<AppliedWhitelist>;
  /** insert data into the table: "audit.logged_actions" */
  insert_audit_logged_actions?: Maybe<AuditLoggedActionsMutationResponse>;
  /** insert a single row into the table: "audit.logged_actions" */
  insert_audit_logged_actions_one?: Maybe<AuditLoggedActions>;
  insert_auth0_user?: Maybe<UserData>;
  /** insert data into the table: "blacklist" */
  insert_blacklist?: Maybe<BlacklistMutationResponse>;
  insert_blacklist_customer: InsertBlacklistResponse;
  /** insert a single row into the table: "blacklist" */
  insert_blacklist_one?: Maybe<Blacklist>;
  /** insert data into the table: "booking.booking" */
  insert_booking_booking?: Maybe<BookingBookingMutationResponse>;
  /** insert data into the table: "booking.booking_invoice" */
  insert_booking_booking_invoice?: Maybe<BookingBookingInvoiceMutationResponse>;
  /** insert a single row into the table: "booking.booking_invoice" */
  insert_booking_booking_invoice_one?: Maybe<BookingBookingInvoice>;
  /** insert a single row into the table: "booking.booking" */
  insert_booking_booking_one?: Maybe<BookingBooking>;
  /** insert data into the table: "booking.booking_plate" */
  insert_booking_booking_plate?: Maybe<BookingBookingPlateMutationResponse>;
  /** insert a single row into the table: "booking.booking_plate" */
  insert_booking_booking_plate_one?: Maybe<BookingBookingPlate>;
  /** insert data into the table: "booking.booking_type" */
  insert_booking_booking_type?: Maybe<BookingBookingTypeMutationResponse>;
  /** insert a single row into the table: "booking.booking_type" */
  insert_booking_booking_type_one?: Maybe<BookingBookingType>;
  /** insert data into the table: "booking.booking_whitelist" */
  insert_booking_booking_whitelist?: Maybe<BookingBookingWhitelistMutationResponse>;
  /** insert a single row into the table: "booking.booking_whitelist" */
  insert_booking_booking_whitelist_one?: Maybe<BookingBookingWhitelist>;
  /** insert data into the table: "booking.enum_booking_status" */
  insert_booking_enum_booking_status?: Maybe<BookingEnumBookingStatusMutationResponse>;
  /** insert a single row into the table: "booking.enum_booking_status" */
  insert_booking_enum_booking_status_one?: Maybe<BookingEnumBookingStatus>;
  /** insert data into the table: "booking.hourly_booking" */
  insert_booking_hourly_booking?: Maybe<BookingHourlyBookingMutationResponse>;
  /** insert a single row into the table: "booking.hourly_booking" */
  insert_booking_hourly_booking_one?: Maybe<BookingHourlyBooking>;
  /** insert data into the table: "booking.license_plate" */
  insert_booking_license_plate?: Maybe<BookingLicensePlateMutationResponse>;
  /** insert a single row into the table: "booking.license_plate" */
  insert_booking_license_plate_one?: Maybe<BookingLicensePlate>;
  /** insert data into the table: "booking.lot" */
  insert_booking_lot?: Maybe<BookingLotMutationResponse>;
  /** insert data into the table: "booking.lot_configuration" */
  insert_booking_lot_configuration?: Maybe<BookingLotConfigurationMutationResponse>;
  /** insert a single row into the table: "booking.lot_configuration" */
  insert_booking_lot_configuration_one?: Maybe<BookingLotConfiguration>;
  /** insert a single row into the table: "booking.lot" */
  insert_booking_lot_one?: Maybe<BookingLot>;
  /** insert data into the table: "booking.payment" */
  insert_booking_payment?: Maybe<BookingPaymentMutationResponse>;
  /** insert a single row into the table: "booking.payment" */
  insert_booking_payment_one?: Maybe<BookingPayment>;
  /** insert data into the table: "booking.pricing_rules" */
  insert_booking_pricing_rules?: Maybe<BookingPricingRulesMutationResponse>;
  /** insert a single row into the table: "booking.pricing_rules" */
  insert_booking_pricing_rules_one?: Maybe<BookingPricingRules>;
  /** insert data into the table: "booking.pricing_type" */
  insert_booking_pricing_type?: Maybe<BookingPricingTypeMutationResponse>;
  /** insert a single row into the table: "booking.pricing_type" */
  insert_booking_pricing_type_one?: Maybe<BookingPricingType>;
  /** insert data into the table: "booking.private_pricing_user" */
  insert_booking_private_pricing_user?: Maybe<BookingPrivatePricingUserMutationResponse>;
  /** insert a single row into the table: "booking.private_pricing_user" */
  insert_booking_private_pricing_user_one?: Maybe<BookingPrivatePricingUser>;
  /** insert data into the table: "booking.recurring_booking" */
  insert_booking_recurring_booking?: Maybe<BookingRecurringBookingMutationResponse>;
  /** insert a single row into the table: "booking.recurring_booking" */
  insert_booking_recurring_booking_one?: Maybe<BookingRecurringBooking>;
  /** insert data into the table: "booking.subscription_booking" */
  insert_booking_subscription_booking?: Maybe<BookingSubscriptionBookingMutationResponse>;
  /** insert a single row into the table: "booking.subscription_booking" */
  insert_booking_subscription_booking_one?: Maybe<BookingSubscriptionBooking>;
  /** insert data into the table: "booking.subscription_license_plate" */
  insert_booking_subscription_license_plate?: Maybe<BookingSubscriptionLicensePlateMutationResponse>;
  /** insert a single row into the table: "booking.subscription_license_plate" */
  insert_booking_subscription_license_plate_one?: Maybe<BookingSubscriptionLicensePlate>;
  /** insert data into the table: "booking.subscription_status" */
  insert_booking_subscription_status?: Maybe<BookingSubscriptionStatusMutationResponse>;
  /** insert a single row into the table: "booking.subscription_status" */
  insert_booking_subscription_status_one?: Maybe<BookingSubscriptionStatus>;
  /** insert data into the table: "booking.user" */
  insert_booking_user?: Maybe<BookingUserMutationResponse>;
  /** insert data into the table: "booking.user_booking" */
  insert_booking_user_booking?: Maybe<BookingUserBookingMutationResponse>;
  /** insert a single row into the table: "booking.user_booking" */
  insert_booking_user_booking_one?: Maybe<BookingUserBooking>;
  /** insert a single row into the table: "booking.user" */
  insert_booking_user_one?: Maybe<BookingUser>;
  /** insert data into the table: "booking.user_payment_method" */
  insert_booking_user_payment_method?: Maybe<BookingUserPaymentMethodMutationResponse>;
  /** insert a single row into the table: "booking.user_payment_method" */
  insert_booking_user_payment_method_one?: Maybe<BookingUserPaymentMethod>;
  /** insert data into the table: "booking.user_subscription" */
  insert_booking_user_subscription?: Maybe<BookingUserSubscriptionMutationResponse>;
  /** insert a single row into the table: "booking.user_subscription" */
  insert_booking_user_subscription_one?: Maybe<BookingUserSubscription>;
  /** insert data into the table: "booking.vehicle" */
  insert_booking_vehicle?: Maybe<BookingVehicleMutationResponse>;
  /** insert a single row into the table: "booking.vehicle" */
  insert_booking_vehicle_one?: Maybe<BookingVehicle>;
  /** insert data into the table: "booking.vehicle_type" */
  insert_booking_vehicle_type?: Maybe<BookingVehicleTypeMutationResponse>;
  /** insert a single row into the table: "booking.vehicle_type" */
  insert_booking_vehicle_type_one?: Maybe<BookingVehicleType>;
  /** insert data into the table: "booking.whitelist_type" */
  insert_booking_whitelist_type?: Maybe<BookingWhitelistTypeMutationResponse>;
  /** insert a single row into the table: "booking.whitelist_type" */
  insert_booking_whitelist_type_one?: Maybe<BookingWhitelistType>;
  /** insert data into the table: "calendar_event_policy" */
  insert_calendar_event_policy?: Maybe<CalendarEventPolicyMutationResponse>;
  /** insert a single row into the table: "calendar_event_policy" */
  insert_calendar_event_policy_one?: Maybe<CalendarEventPolicy>;
  /** insert data into the table: "cancellations" */
  insert_cancellations?: Maybe<CancellationsMutationResponse>;
  /** insert a single row into the table: "cancellations" */
  insert_cancellations_one?: Maybe<Cancellations>;
  /** insert data into the table: "car_driver" */
  insert_car_driver?: Maybe<CarDriverMutationResponse>;
  /** insert a single row into the table: "car_driver" */
  insert_car_driver_one?: Maybe<CarDriver>;
  /** insert data into the table: "car_owner" */
  insert_car_owner?: Maybe<CarOwnerMutationResponse>;
  /** insert a single row into the table: "car_owner" */
  insert_car_owner_one?: Maybe<CarOwner>;
  /** insert data into the table: "car_owner_requests" */
  insert_car_owner_requests?: Maybe<CarOwnerRequestsMutationResponse>;
  /** insert a single row into the table: "car_owner_requests" */
  insert_car_owner_requests_one?: Maybe<CarOwnerRequests>;
  /** insert data into the table: "carpay_access_control_lp_pin" */
  insert_carpay_access_control_lp_pin?: Maybe<CarpayAccessControlLpPinMutationResponse>;
  /** insert a single row into the table: "carpay_access_control_lp_pin" */
  insert_carpay_access_control_lp_pin_one?: Maybe<CarpayAccessControlLpPin>;
  /** insert data into the table: "carpay_discount_batch" */
  insert_carpay_discount_batch?: Maybe<CarpayDiscountBatchMutationResponse>;
  /** insert a single row into the table: "carpay_discount_batch" */
  insert_carpay_discount_batch_one?: Maybe<CarpayDiscountBatch>;
  /** insert data into the table: "carpay_discount_model" */
  insert_carpay_discount_model?: Maybe<CarpayDiscountModelMutationResponse>;
  /** insert a single row into the table: "carpay_discount_model" */
  insert_carpay_discount_model_one?: Maybe<CarpayDiscountModel>;
  /** insert data into the table: "carpay_lot" */
  insert_carpay_lot?: Maybe<CarpayLotMutationResponse>;
  /** insert a single row into the table: "carpay_lot" */
  insert_carpay_lot_one?: Maybe<CarpayLot>;
  /** insert data into the table: "carpay_notification_subscriber" */
  insert_carpay_notification_subscriber?: Maybe<CarpayNotificationSubscriberMutationResponse>;
  /** insert a single row into the table: "carpay_notification_subscriber" */
  insert_carpay_notification_subscriber_one?: Maybe<CarpayNotificationSubscriber>;
  /** insert data into the table: "carpay_notification_subscription" */
  insert_carpay_notification_subscription?: Maybe<CarpayNotificationSubscriptionMutationResponse>;
  /** insert data into the table: "carpay_notification_subscription_category" */
  insert_carpay_notification_subscription_category?: Maybe<CarpayNotificationSubscriptionCategoryMutationResponse>;
  /** insert a single row into the table: "carpay_notification_subscription_category" */
  insert_carpay_notification_subscription_category_one?: Maybe<CarpayNotificationSubscriptionCategory>;
  /** insert a single row into the table: "carpay_notification_subscription" */
  insert_carpay_notification_subscription_one?: Maybe<CarpayNotificationSubscription>;
  /** insert data into the table: "carpay_order" */
  insert_carpay_order?: Maybe<CarpayOrderMutationResponse>;
  /** insert data into the table: "carpay_order_matches" */
  insert_carpay_order_matches?: Maybe<CarpayOrderMatchesMutationResponse>;
  /** insert a single row into the table: "carpay_order_matches" */
  insert_carpay_order_matches_one?: Maybe<CarpayOrderMatches>;
  /** insert a single row into the table: "carpay_order" */
  insert_carpay_order_one?: Maybe<CarpayOrder>;
  /** insert data into the table: "carpay_order_user" */
  insert_carpay_order_user?: Maybe<CarpayOrderUserMutationResponse>;
  /** insert a single row into the table: "carpay_order_user" */
  insert_carpay_order_user_one?: Maybe<CarpayOrderUser>;
  /** insert data into the table: "carpay_parking_detection" */
  insert_carpay_parking_detection?: Maybe<CarpayParkingDetectionMutationResponse>;
  /** insert a single row into the table: "carpay_parking_detection" */
  insert_carpay_parking_detection_one?: Maybe<CarpayParkingDetection>;
  /** insert data into the table: "carpay_pricing" */
  insert_carpay_pricing?: Maybe<CarpayPricingMutationResponse>;
  /** insert data into the table: "carpay_pricing_config_group" */
  insert_carpay_pricing_config_group?: Maybe<CarpayPricingConfigGroupMutationResponse>;
  /** insert a single row into the table: "carpay_pricing_config_group" */
  insert_carpay_pricing_config_group_one?: Maybe<CarpayPricingConfigGroup>;
  /** insert a single row into the table: "carpay_pricing" */
  insert_carpay_pricing_one?: Maybe<CarpayPricing>;
  /** insert data into the table: "carpay_pricing_period" */
  insert_carpay_pricing_period?: Maybe<CarpayPricingPeriodMutationResponse>;
  /** insert a single row into the table: "carpay_pricing_period" */
  insert_carpay_pricing_period_one?: Maybe<CarpayPricingPeriod>;
  /** insert data into the table: "carpay_pricing_recurrence" */
  insert_carpay_pricing_recurrence?: Maybe<CarpayPricingRecurrenceMutationResponse>;
  /** insert a single row into the table: "carpay_pricing_recurrence" */
  insert_carpay_pricing_recurrence_one?: Maybe<CarpayPricingRecurrence>;
  /** insert data into the table: "carpay_pricing_rules" */
  insert_carpay_pricing_rules?: Maybe<CarpayPricingRulesMutationResponse>;
  /** insert a single row into the table: "carpay_pricing_rules" */
  insert_carpay_pricing_rules_one?: Maybe<CarpayPricingRules>;
  /** insert data into the table: "carpay_scanned_codes" */
  insert_carpay_scanned_codes?: Maybe<CarpayScannedCodesMutationResponse>;
  /** insert a single row into the table: "carpay_scanned_codes" */
  insert_carpay_scanned_codes_one?: Maybe<CarpayScannedCodes>;
  /** insert data into the table: "carpay_terminal_cash_cut_notification" */
  insert_carpay_terminal_cash_cut_notification?: Maybe<CarpayTerminalCashCutNotificationMutationResponse>;
  /** insert a single row into the table: "carpay_terminal_cash_cut_notification" */
  insert_carpay_terminal_cash_cut_notification_one?: Maybe<CarpayTerminalCashCutNotification>;
  /** insert data into the table: "carpay_terminal_cash_fill_level_notification" */
  insert_carpay_terminal_cash_fill_level_notification?: Maybe<CarpayTerminalCashFillLevelNotificationMutationResponse>;
  /** insert a single row into the table: "carpay_terminal_cash_fill_level_notification" */
  insert_carpay_terminal_cash_fill_level_notification_one?: Maybe<CarpayTerminalCashFillLevelNotification>;
  /** insert data into the table: "carpay_terminal_notification_config" */
  insert_carpay_terminal_notification_config?: Maybe<CarpayTerminalNotificationConfigMutationResponse>;
  /** insert a single row into the table: "carpay_terminal_notification_config" */
  insert_carpay_terminal_notification_config_one?: Maybe<CarpayTerminalNotificationConfig>;
  /** insert data into the table: "carpay_terminal_printer_status_notification" */
  insert_carpay_terminal_printer_status_notification?: Maybe<CarpayTerminalPrinterStatusNotificationMutationResponse>;
  /** insert a single row into the table: "carpay_terminal_printer_status_notification" */
  insert_carpay_terminal_printer_status_notification_one?: Maybe<CarpayTerminalPrinterStatusNotification>;
  /** insert data into the table: "carpay_user_verified_plate" */
  insert_carpay_user_verified_plate?: Maybe<CarpayUserVerifiedPlateMutationResponse>;
  /** insert a single row into the table: "carpay_user_verified_plate" */
  insert_carpay_user_verified_plate_one?: Maybe<CarpayUserVerifiedPlate>;
  /** insert data into the table: "chain" */
  insert_chain?: Maybe<ChainMutationResponse>;
  /** insert a single row into the table: "chain" */
  insert_chain_one?: Maybe<Chain>;
  /** insert data into the table: "city_codes" */
  insert_city_codes?: Maybe<CityCodesMutationResponse>;
  /** insert a single row into the table: "city_codes" */
  insert_city_codes_one?: Maybe<CityCodes>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<CompanyMutationResponse>;
  /** insert data into the table: "company_config_group" */
  insert_company_config_group?: Maybe<CompanyConfigGroupMutationResponse>;
  /** insert a single row into the table: "company_config_group" */
  insert_company_config_group_one?: Maybe<CompanyConfigGroup>;
  /** insert data into the table: "company_hierarchy" */
  insert_company_hierarchy?: Maybe<CompanyHierarchyMutationResponse>;
  /** insert a single row into the table: "company_hierarchy" */
  insert_company_hierarchy_one?: Maybe<CompanyHierarchy>;
  /** insert data into the table: "company_lot_section" */
  insert_company_lot_section?: Maybe<CompanyLotSectionMutationResponse>;
  /** insert a single row into the table: "company_lot_section" */
  insert_company_lot_section_one?: Maybe<CompanyLotSection>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "company_vat_id" */
  insert_company_vat_id?: Maybe<CompanyVatIdMutationResponse>;
  /** insert a single row into the table: "company_vat_id" */
  insert_company_vat_id_one?: Maybe<CompanyVatId>;
  /** insert data into the table: "company_violator" */
  insert_company_violator?: Maybe<CompanyViolatorMutationResponse>;
  /** insert a single row into the table: "company_violator" */
  insert_company_violator_one?: Maybe<CompanyViolator>;
  /** insert data into the table: "config_group" */
  insert_config_group?: Maybe<ConfigGroupMutationResponse>;
  /** insert a single row into the table: "config_group" */
  insert_config_group_one?: Maybe<ConfigGroup>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<CountryMutationResponse>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "currency" */
  insert_currency?: Maybe<CurrencyMutationResponse>;
  /** insert a single row into the table: "currency" */
  insert_currency_one?: Maybe<Currency>;
  /** insert data into the table: "customer_dashboard_nps_feedback" */
  insert_customer_dashboard_nps_feedback?: Maybe<CustomerDashboardNpsFeedbackMutationResponse>;
  /** insert a single row into the table: "customer_dashboard_nps_feedback" */
  insert_customer_dashboard_nps_feedback_one?: Maybe<CustomerDashboardNpsFeedback>;
  /** insert data into the table: "daily_failure" */
  insert_daily_failure?: Maybe<DailyFailureMutationResponse>;
  /** insert a single row into the table: "daily_failure" */
  insert_daily_failure_one?: Maybe<DailyFailure>;
  /** insert data into the table: "daily_stats" */
  insert_daily_stats?: Maybe<DailyStatsMutationResponse>;
  /** insert a single row into the table: "daily_stats" */
  insert_daily_stats_one?: Maybe<DailyStats>;
  /** insert data into the table: "department" */
  insert_department?: Maybe<DepartmentMutationResponse>;
  /** insert a single row into the table: "department" */
  insert_department_one?: Maybe<Department>;
  /** insert data into the table: "detection_type_enum" */
  insert_detection_type_enum?: Maybe<DetectionTypeEnumMutationResponse>;
  /** insert a single row into the table: "detection_type_enum" */
  insert_detection_type_enum_one?: Maybe<DetectionTypeEnum>;
  /** insert data into the table: "device" */
  insert_device?: Maybe<DeviceMutationResponse>;
  /** insert a single row into the table: "device" */
  insert_device_one?: Maybe<Device>;
  /** insert data into the table: "easypark_lot" */
  insert_easypark_lot?: Maybe<EasyparkLotMutationResponse>;
  /** insert a single row into the table: "easypark_lot" */
  insert_easypark_lot_one?: Maybe<EasyparkLot>;
  /** insert data into the table: "easypark_order" */
  insert_easypark_order?: Maybe<EasyparkOrderMutationResponse>;
  /** insert a single row into the table: "easypark_order" */
  insert_easypark_order_one?: Maybe<EasyparkOrder>;
  /** insert data into the table: "easypark_order_v2" */
  insert_easypark_order_v2?: Maybe<EasyparkOrderV2MutationResponse>;
  /** insert a single row into the table: "easypark_order_v2" */
  insert_easypark_order_v2_one?: Maybe<EasyparkOrderV2>;
  /** insert data into the table: "easypark_parking_info" */
  insert_easypark_parking_info?: Maybe<EasyparkParkingInfoMutationResponse>;
  /** insert a single row into the table: "easypark_parking_info" */
  insert_easypark_parking_info_one?: Maybe<EasyparkParkingInfo>;
  /** insert data into the table: "enforcement_daily_stats" */
  insert_enforcement_daily_stats?: Maybe<EnforcementDailyStatsMutationResponse>;
  /** insert a single row into the table: "enforcement_daily_stats" */
  insert_enforcement_daily_stats_one?: Maybe<EnforcementDailyStats>;
  /** insert data into the table: "enum_carpay_discount_model_code_type" */
  insert_enum_carpay_discount_model_code_type?: Maybe<EnumCarpayDiscountModelCodeTypeMutationResponse>;
  /** insert a single row into the table: "enum_carpay_discount_model_code_type" */
  insert_enum_carpay_discount_model_code_type_one?: Maybe<EnumCarpayDiscountModelCodeType>;
  /** insert data into the table: "enum_country_code" */
  insert_enum_country_code?: Maybe<EnumCountryCodeMutationResponse>;
  /** insert a single row into the table: "enum_country_code" */
  insert_enum_country_code_one?: Maybe<EnumCountryCode>;
  /** insert data into the table: "enum_customer_whitelist_purpose" */
  insert_enum_customer_whitelist_purpose?: Maybe<EnumCustomerWhitelistPurposeMutationResponse>;
  /** insert a single row into the table: "enum_customer_whitelist_purpose" */
  insert_enum_customer_whitelist_purpose_one?: Maybe<EnumCustomerWhitelistPurpose>;
  /** insert data into the table: "enum_customer_whitelist_status" */
  insert_enum_customer_whitelist_status?: Maybe<EnumCustomerWhitelistStatusMutationResponse>;
  /** insert a single row into the table: "enum_customer_whitelist_status" */
  insert_enum_customer_whitelist_status_one?: Maybe<EnumCustomerWhitelistStatus>;
  /** insert data into the table: "enum_device_type" */
  insert_enum_device_type?: Maybe<EnumDeviceTypeMutationResponse>;
  /** insert a single row into the table: "enum_device_type" */
  insert_enum_device_type_one?: Maybe<EnumDeviceType>;
  /** insert data into the table: "enum_driver_request_type" */
  insert_enum_driver_request_type?: Maybe<EnumDriverRequestTypeMutationResponse>;
  /** insert a single row into the table: "enum_driver_request_type" */
  insert_enum_driver_request_type_one?: Maybe<EnumDriverRequestType>;
  /** insert data into the table: "enum_guest_jwt_purpose" */
  insert_enum_guest_jwt_purpose?: Maybe<EnumGuestJwtPurposeMutationResponse>;
  /** insert a single row into the table: "enum_guest_jwt_purpose" */
  insert_enum_guest_jwt_purpose_one?: Maybe<EnumGuestJwtPurpose>;
  /** insert data into the table: "enum_supervision_mlp_request_status" */
  insert_enum_supervision_mlp_request_status?: Maybe<EnumSupervisionMlpRequestStatusMutationResponse>;
  /** insert a single row into the table: "enum_supervision_mlp_request_status" */
  insert_enum_supervision_mlp_request_status_one?: Maybe<EnumSupervisionMlpRequestStatus>;
  /** insert data into the table: "enum_violation_cancellation" */
  insert_enum_violation_cancellation?: Maybe<EnumViolationCancellationMutationResponse>;
  /** insert a single row into the table: "enum_violation_cancellation" */
  insert_enum_violation_cancellation_one?: Maybe<EnumViolationCancellation>;
  /** insert data into the table: "enum_violation_case_charges_invalidation_reason" */
  insert_enum_violation_case_charges_invalidation_reason?: Maybe<EnumViolationCaseChargesInvalidationReasonMutationResponse>;
  /** insert a single row into the table: "enum_violation_case_charges_invalidation_reason" */
  insert_enum_violation_case_charges_invalidation_reason_one?: Maybe<EnumViolationCaseChargesInvalidationReason>;
  /** insert data into the table: "enum_violation_case_charges_type" */
  insert_enum_violation_case_charges_type?: Maybe<EnumViolationCaseChargesTypeMutationResponse>;
  /** insert a single row into the table: "enum_violation_case_charges_type" */
  insert_enum_violation_case_charges_type_one?: Maybe<EnumViolationCaseChargesType>;
  /** insert data into the table: "enum_whitelist_paid_parking_types" */
  insert_enum_whitelist_paid_parking_types?: Maybe<EnumWhitelistPaidParkingTypesMutationResponse>;
  /** insert a single row into the table: "enum_whitelist_paid_parking_types" */
  insert_enum_whitelist_paid_parking_types_one?: Maybe<EnumWhitelistPaidParkingTypes>;
  /** insert data into the table: "enum_whitelist_scope" */
  insert_enum_whitelist_scope?: Maybe<EnumWhitelistScopeMutationResponse>;
  /** insert a single row into the table: "enum_whitelist_scope" */
  insert_enum_whitelist_scope_one?: Maybe<EnumWhitelistScope>;
  /** insert data into the table: "enum_whitelist_status" */
  insert_enum_whitelist_status?: Maybe<EnumWhitelistStatusMutationResponse>;
  /** insert a single row into the table: "enum_whitelist_status" */
  insert_enum_whitelist_status_one?: Maybe<EnumWhitelistStatus>;
  /** insert data into the table: "enum_whitelist_types" */
  insert_enum_whitelist_types?: Maybe<EnumWhitelistTypesMutationResponse>;
  /** insert a single row into the table: "enum_whitelist_types" */
  insert_enum_whitelist_types_one?: Maybe<EnumWhitelistTypes>;
  /** insert data into the table: "guest_jwt" */
  insert_guest_jwt?: Maybe<GuestJwtMutationResponse>;
  /** insert a single row into the table: "guest_jwt" */
  insert_guest_jwt_one?: Maybe<GuestJwt>;
  /** insert data into the table: "guest_qr" */
  insert_guest_qr?: Maybe<GuestQrMutationResponse>;
  /** insert a single row into the table: "guest_qr" */
  insert_guest_qr_one?: Maybe<GuestQr>;
  /** insert data into the table: "lot" */
  insert_lot?: Maybe<LotMutationResponse>;
  /** insert data into the table: "lot_config_group" */
  insert_lot_config_group?: Maybe<LotConfigGroupMutationResponse>;
  /** insert a single row into the table: "lot_config_group" */
  insert_lot_config_group_one?: Maybe<LotConfigGroup>;
  /** insert data into the table: "lot_display_name" */
  insert_lot_display_name?: Maybe<LotDisplayNameMutationResponse>;
  /** insert a single row into the table: "lot_display_name" */
  insert_lot_display_name_one?: Maybe<LotDisplayName>;
  /** insert data into the table: "lot_hierarchy" */
  insert_lot_hierarchy?: Maybe<LotHierarchyMutationResponse>;
  /** insert a single row into the table: "lot_hierarchy" */
  insert_lot_hierarchy_one?: Maybe<LotHierarchy>;
  /** insert data into the table: "lot_legal_entity" */
  insert_lot_legal_entity?: Maybe<LotLegalEntityMutationResponse>;
  /** insert a single row into the table: "lot_legal_entity" */
  insert_lot_legal_entity_one?: Maybe<LotLegalEntity>;
  /** insert a single row into the table: "lot" */
  insert_lot_one?: Maybe<Lot>;
  /** insert data into the table: "lot_policy_history" */
  insert_lot_policy_history?: Maybe<LotPolicyHistoryMutationResponse>;
  /** insert a single row into the table: "lot_policy_history" */
  insert_lot_policy_history_one?: Maybe<LotPolicyHistory>;
  /** insert data into the table: "lot_section" */
  insert_lot_section?: Maybe<LotSectionMutationResponse>;
  /** insert a single row into the table: "lot_section" */
  insert_lot_section_one?: Maybe<LotSection>;
  /** insert data into the table: "lp_contingent" */
  insert_lp_contingent?: Maybe<LpContingentMutationResponse>;
  /** insert a single row into the table: "lp_contingent" */
  insert_lp_contingent_one?: Maybe<LpContingent>;
  /** insert data into the table: "lp_group" */
  insert_lp_group?: Maybe<LpGroupMutationResponse>;
  /** insert data into the table: "lp_group_config_group" */
  insert_lp_group_config_group?: Maybe<LpGroupConfigGroupMutationResponse>;
  /** insert a single row into the table: "lp_group_config_group" */
  insert_lp_group_config_group_one?: Maybe<LpGroupConfigGroup>;
  /** insert data into the table: "lp_group_details" */
  insert_lp_group_details?: Maybe<LpGroupDetailsMutationResponse>;
  /** insert a single row into the table: "lp_group_details" */
  insert_lp_group_details_one?: Maybe<LpGroupDetails>;
  /** insert data into the table: "lp_group_member" */
  insert_lp_group_member?: Maybe<LpGroupMemberMutationResponse>;
  /** insert data into the table: "lp_group_member_details" */
  insert_lp_group_member_details?: Maybe<LpGroupMemberDetailsMutationResponse>;
  /** insert a single row into the table: "lp_group_member_details" */
  insert_lp_group_member_details_one?: Maybe<LpGroupMemberDetails>;
  /** insert a single row into the table: "lp_group_member" */
  insert_lp_group_member_one?: Maybe<LpGroupMember>;
  /** insert a single row into the table: "lp_group" */
  insert_lp_group_one?: Maybe<LpGroup>;
  /** insert data into the table: "mail" */
  insert_mail?: Maybe<MailMutationResponse>;
  /** insert data into the table: "mail_misc" */
  insert_mail_misc?: Maybe<MailMiscMutationResponse>;
  /** insert a single row into the table: "mail_misc" */
  insert_mail_misc_one?: Maybe<MailMisc>;
  /** insert a single row into the table: "mail" */
  insert_mail_one?: Maybe<Mail>;
  /** insert data into the table: "mlp_cases" */
  insert_mlp_cases?: Maybe<MlpCasesMutationResponse>;
  /** insert a single row into the table: "mlp_cases" */
  insert_mlp_cases_one?: Maybe<MlpCases>;
  /** insert data into the table: "mlp_mappings" */
  insert_mlp_mappings?: Maybe<MlpMappingsMutationResponse>;
  /** insert a single row into the table: "mlp_mappings" */
  insert_mlp_mappings_one?: Maybe<MlpMappings>;
  /** insert data into the table: "mqtt_request" */
  insert_mqtt_request?: Maybe<MqttRequestMutationResponse>;
  /** insert a single row into the table: "mqtt_request" */
  insert_mqtt_request_one?: Maybe<MqttRequest>;
  /** insert data into the table: "offence_parking_events" */
  insert_offence_parking_events?: Maybe<OffenceParkingEventsMutationResponse>;
  /** insert a single row into the table: "offence_parking_events" */
  insert_offence_parking_events_one?: Maybe<OffenceParkingEvents>;
  /** insert data into the table: "offence_ticket_requests" */
  insert_offence_ticket_requests?: Maybe<OffenceTicketRequestsMutationResponse>;
  /** insert a single row into the table: "offence_ticket_requests" */
  insert_offence_ticket_requests_one?: Maybe<OffenceTicketRequests>;
  /** insert data into the table: "overuse_group" */
  insert_overuse_group?: Maybe<OveruseGroupMutationResponse>;
  /** insert data into the table: "overuse_group_member" */
  insert_overuse_group_member?: Maybe<OveruseGroupMemberMutationResponse>;
  /** insert a single row into the table: "overuse_group_member" */
  insert_overuse_group_member_one?: Maybe<OveruseGroupMember>;
  /** insert a single row into the table: "overuse_group" */
  insert_overuse_group_one?: Maybe<OveruseGroup>;
  /** insert data into the table: "parkdepot_product" */
  insert_parkdepot_product?: Maybe<ParkdepotProductMutationResponse>;
  /** insert a single row into the table: "parkdepot_product" */
  insert_parkdepot_product_one?: Maybe<ParkdepotProduct>;
  /** insert data into the table: "parking_context" */
  insert_parking_context?: Maybe<ParkingContextMutationResponse>;
  /** insert a single row into the table: "parking_context" */
  insert_parking_context_one?: Maybe<ParkingContext>;
  /** insert data into the table: "parking_detections" */
  insert_parking_detections?: Maybe<ParkingDetectionsMutationResponse>;
  /** insert data into the table: "parking_detections_archive" */
  insert_parking_detections_archive?: Maybe<ParkingDetectionsArchiveMutationResponse>;
  /** insert a single row into the table: "parking_detections_archive" */
  insert_parking_detections_archive_one?: Maybe<ParkingDetectionsArchive>;
  /** insert a single row into the table: "parking_detections" */
  insert_parking_detections_one?: Maybe<ParkingDetections>;
  /** insert data into the table: "parking_incoming" */
  insert_parking_incoming?: Maybe<ParkingIncomingMutationResponse>;
  /** insert a single row into the table: "parking_incoming" */
  insert_parking_incoming_one?: Maybe<ParkingIncoming>;
  /** insert data into the table: "parking_processing" */
  insert_parking_processing?: Maybe<ParkingProcessingMutationResponse>;
  /** insert a single row into the table: "parking_processing" */
  insert_parking_processing_one?: Maybe<ParkingProcessing>;
  /** insert data into the table: "parking_results" */
  insert_parking_results?: Maybe<ParkingResultsMutationResponse>;
  /** insert data into the table: "parking_results_archive" */
  insert_parking_results_archive?: Maybe<ParkingResultsArchiveMutationResponse>;
  /** insert a single row into the table: "parking_results_archive" */
  insert_parking_results_archive_one?: Maybe<ParkingResultsArchive>;
  /** insert a single row into the table: "parking_results" */
  insert_parking_results_one?: Maybe<ParkingResults>;
  /** insert data into the table: "parking_temp" */
  insert_parking_temp?: Maybe<ParkingTempMutationResponse>;
  /** insert a single row into the table: "parking_temp" */
  insert_parking_temp_one?: Maybe<ParkingTemp>;
  /** insert data into the table: "paybyphone_lot" */
  insert_paybyphone_lot?: Maybe<PaybyphoneLotMutationResponse>;
  /** insert a single row into the table: "paybyphone_lot" */
  insert_paybyphone_lot_one?: Maybe<PaybyphoneLot>;
  /** insert data into the table: "paybyphone_order" */
  insert_paybyphone_order?: Maybe<PaybyphoneOrderMutationResponse>;
  /** insert a single row into the table: "paybyphone_order" */
  insert_paybyphone_order_one?: Maybe<PaybyphoneOrder>;
  /** insert data into the table: "person" */
  insert_person?: Maybe<PersonMutationResponse>;
  /** insert a single row into the table: "person" */
  insert_person_one?: Maybe<Person>;
  /** insert data into the table: "policy_schedule" */
  insert_policy_schedule?: Maybe<PolicyScheduleMutationResponse>;
  /** insert a single row into the table: "policy_schedule" */
  insert_policy_schedule_one?: Maybe<PolicySchedule>;
  /** insert data into the table: "regional_codes_austria" */
  insert_regional_codes_austria?: Maybe<RegionalCodesAustriaMutationResponse>;
  /** insert a single row into the table: "regional_codes_austria" */
  insert_regional_codes_austria_one?: Maybe<RegionalCodesAustria>;
  /** insert data into the table: "rental_pricing" */
  insert_rental_pricing?: Maybe<RentalPricingMutationResponse>;
  /** insert a single row into the table: "rental_pricing" */
  insert_rental_pricing_one?: Maybe<RentalPricing>;
  /** insert data into the table: "rental_subscription" */
  insert_rental_subscription?: Maybe<RentalSubscriptionMutationResponse>;
  /** insert a single row into the table: "rental_subscription" */
  insert_rental_subscription_one?: Maybe<RentalSubscription>;
  /** insert data into the table: "serverless_async_work" */
  insert_serverless_async_work?: Maybe<ServerlessAsyncWorkMutationResponse>;
  /** insert a single row into the table: "serverless_async_work" */
  insert_serverless_async_work_one?: Maybe<ServerlessAsyncWork>;
  /** insert data into the table: "similar_detections" */
  insert_similar_detections?: Maybe<SimilarDetectionsMutationResponse>;
  /** insert a single row into the table: "similar_detections" */
  insert_similar_detections_one?: Maybe<SimilarDetections>;
  insert_single_car_owner_information?: Maybe<InsertSingleCarOwnerInformationOutput>;
  /** insert data into the table: "stages" */
  insert_stages?: Maybe<StagesMutationResponse>;
  /** insert a single row into the table: "stages" */
  insert_stages_one?: Maybe<Stages>;
  /** insert data into the table: "station" */
  insert_station?: Maybe<StationMutationResponse>;
  /** insert a single row into the table: "station" */
  insert_station_one?: Maybe<Station>;
  /** insert data into the table: "supervision_car_rental_partners" */
  insert_supervision_car_rental_partners?: Maybe<SupervisionCarRentalPartnersMutationResponse>;
  /** insert a single row into the table: "supervision_car_rental_partners" */
  insert_supervision_car_rental_partners_one?: Maybe<SupervisionCarRentalPartners>;
  /** insert data into the table: "supervision_debt_collection_case" */
  insert_supervision_debt_collection_case?: Maybe<SupervisionDebtCollectionCaseMutationResponse>;
  /** insert a single row into the table: "supervision_debt_collection_case" */
  insert_supervision_debt_collection_case_one?: Maybe<SupervisionDebtCollectionCase>;
  /** insert data into the table: "supervision_image_requests" */
  insert_supervision_image_requests?: Maybe<SupervisionImageRequestsMutationResponse>;
  /** insert a single row into the table: "supervision_image_requests" */
  insert_supervision_image_requests_one?: Maybe<SupervisionImageRequests>;
  /** insert data into the table: "supervision_mlp_requests" */
  insert_supervision_mlp_requests?: Maybe<SupervisionMlpRequestsMutationResponse>;
  /** insert a single row into the table: "supervision_mlp_requests" */
  insert_supervision_mlp_requests_one?: Maybe<SupervisionMlpRequests>;
  /** insert data into the table: "supervision_multivisit_offender_group" */
  insert_supervision_multivisit_offender_group?: Maybe<SupervisionMultivisitOffenderGroupMutationResponse>;
  /** insert data into the table: "supervision_multivisit_offender_group_member" */
  insert_supervision_multivisit_offender_group_member?: Maybe<SupervisionMultivisitOffenderGroupMemberMutationResponse>;
  /** insert a single row into the table: "supervision_multivisit_offender_group_member" */
  insert_supervision_multivisit_offender_group_member_one?: Maybe<SupervisionMultivisitOffenderGroupMember>;
  /** insert a single row into the table: "supervision_multivisit_offender_group" */
  insert_supervision_multivisit_offender_group_one?: Maybe<SupervisionMultivisitOffenderGroup>;
  /** insert data into the table: "supervision_ticket_request" */
  insert_supervision_ticket_request?: Maybe<SupervisionTicketRequestMutationResponse>;
  /** insert a single row into the table: "supervision_ticket_request" */
  insert_supervision_ticket_request_one?: Maybe<SupervisionTicketRequest>;
  /** insert data into the table: "supervision_violation_case_debt_collection_case" */
  insert_supervision_violation_case_debt_collection_case?: Maybe<SupervisionViolationCaseDebtCollectionCaseMutationResponse>;
  /** insert a single row into the table: "supervision_violation_case_debt_collection_case" */
  insert_supervision_violation_case_debt_collection_case_one?: Maybe<SupervisionViolationCaseDebtCollectionCase>;
  /** insert data into the table: "tax" */
  insert_tax?: Maybe<TaxMutationResponse>;
  /** insert a single row into the table: "tax" */
  insert_tax_one?: Maybe<Tax>;
  /** insert data into the table: "terminal_status" */
  insert_terminal_status?: Maybe<TerminalStatusMutationResponse>;
  /** insert a single row into the table: "terminal_status" */
  insert_terminal_status_one?: Maybe<TerminalStatus>;
  /** insert data into the table: "ticket_website_feedback" */
  insert_ticket_website_feedback?: Maybe<TicketWebsiteFeedbackMutationResponse>;
  /** insert a single row into the table: "ticket_website_feedback" */
  insert_ticket_website_feedback_one?: Maybe<TicketWebsiteFeedback>;
  /** insert data into the table: "time_discount" */
  insert_time_discount?: Maybe<TimeDiscountMutationResponse>;
  /** insert a single row into the table: "time_discount" */
  insert_time_discount_one?: Maybe<TimeDiscount>;
  /** insert data into the table: "user_preference" */
  insert_user_preference?: Maybe<UserPreferenceMutationResponse>;
  /** insert a single row into the table: "user_preference" */
  insert_user_preference_one?: Maybe<UserPreference>;
  /** insert data into the table: "vehicle_type" */
  insert_vehicle_type?: Maybe<VehicleTypeMutationResponse>;
  /** insert data into the table: "vehicle_type_config_group" */
  insert_vehicle_type_config_group?: Maybe<VehicleTypeConfigGroupMutationResponse>;
  /** insert a single row into the table: "vehicle_type_config_group" */
  insert_vehicle_type_config_group_one?: Maybe<VehicleTypeConfigGroup>;
  /** insert a single row into the table: "vehicle_type" */
  insert_vehicle_type_one?: Maybe<VehicleType>;
  /** insert data into the table: "violation_case" */
  insert_violation_case?: Maybe<ViolationCaseMutationResponse>;
  /** insert data into the table: "violation_case_charges" */
  insert_violation_case_charges?: Maybe<ViolationCaseChargesMutationResponse>;
  /** insert a single row into the table: "violation_case_charges" */
  insert_violation_case_charges_one?: Maybe<ViolationCaseCharges>;
  /** insert a single row into the table: "violation_case" */
  insert_violation_case_one?: Maybe<ViolationCase>;
  /** insert data into the table: "violation_case_tags" */
  insert_violation_case_tags?: Maybe<ViolationCaseTagsMutationResponse>;
  /** insert a single row into the table: "violation_case_tags" */
  insert_violation_case_tags_one?: Maybe<ViolationCaseTags>;
  /** insert data into the table: "violation_event_analysis" */
  insert_violation_event_analysis?: Maybe<ViolationEventAnalysisMutationResponse>;
  /** insert a single row into the table: "violation_event_analysis" */
  insert_violation_event_analysis_one?: Maybe<ViolationEventAnalysis>;
  /** insert data into the table: "violator_transactions" */
  insert_violator_transactions?: Maybe<ViolatorTransactionsMutationResponse>;
  /** insert a single row into the table: "violator_transactions" */
  insert_violator_transactions_one?: Maybe<ViolatorTransactions>;
  /** insert data into the table: "whitelist" */
  insert_whitelist?: Maybe<WhitelistMutationResponse>;
  /** insert data into the table: "whitelist_applied_permit" */
  insert_whitelist_applied_permit?: Maybe<WhitelistAppliedPermitMutationResponse>;
  /** insert a single row into the table: "whitelist_applied_permit" */
  insert_whitelist_applied_permit_one?: Maybe<WhitelistAppliedPermit>;
  /** insert data into the table: "whitelist_calendar_event_policy" */
  insert_whitelist_calendar_event_policy?: Maybe<WhitelistCalendarEventPolicyMutationResponse>;
  /** insert a single row into the table: "whitelist_calendar_event_policy" */
  insert_whitelist_calendar_event_policy_one?: Maybe<WhitelistCalendarEventPolicy>;
  insert_whitelist_customer: InsertWhitelistResponse;
  /** insert data into the table: "whitelist_lp_contingent" */
  insert_whitelist_lp_contingent?: Maybe<WhitelistLpContingentMutationResponse>;
  /** insert a single row into the table: "whitelist_lp_contingent" */
  insert_whitelist_lp_contingent_one?: Maybe<WhitelistLpContingent>;
  /** insert a single row into the table: "whitelist" */
  insert_whitelist_one?: Maybe<Whitelist>;
  /** insert data into the table: "whitelist_paid_parking" */
  insert_whitelist_paid_parking?: Maybe<WhitelistPaidParkingMutationResponse>;
  /** insert a single row into the table: "whitelist_paid_parking" */
  insert_whitelist_paid_parking_one?: Maybe<WhitelistPaidParking>;
  /** insert data into the table: "whitelist_subscription" */
  insert_whitelist_subscription?: Maybe<WhitelistSubscriptionMutationResponse>;
  /** insert a single row into the table: "whitelist_subscription" */
  insert_whitelist_subscription_one?: Maybe<WhitelistSubscription>;
  /** insert data into the table: "wireguard_config" */
  insert_wireguard_config?: Maybe<WireguardConfigMutationResponse>;
  /** insert a single row into the table: "wireguard_config" */
  insert_wireguard_config_one?: Maybe<WireguardConfig>;
  link_transaction?: Maybe<LinkTransactionOutput>;
  merge_letters?: Maybe<MergeLettersOutput>;
  move_user_to_new_company?: Maybe<MoveUserToNewCompanyResponse>;
  parse_transactions?: Maybe<ParseTransactionsOutput>;
  provide_nps_feedback: ProvideNpsFeedbackResponse;
  purge_queue?: Maybe<PurgeQueueOutput>;
  /** hasura action to trigger the push_checked_mlps lambda */
  push_checked_mlps?: Maybe<PushCheckedMlPsOutput>;
  remove_user_from_ppm?: Maybe<RemoveUserFromPpmResponse>;
  replace_whitelist?: Maybe<ReplaceWhitelistResponse>;
  /** revert cancelled violation case api */
  revert_cancelled_violation_case_api?: Maybe<RevertCancelledViolationCaseApiOutput>;
  revert_parking_result_confirmation?: Maybe<RevertParkingResultConfirmationOutput>;
  revert_written_off_violation_case_api?: Maybe<RevertWrittenOffViolationCaseApiOutput>;
  send_car_owner_requests_austria?: Maybe<SendCarOwnerRequestsAustriaOutput>;
  send_car_owner_requests_germany: Scalars['uuid'];
  send_extended_kba_request_email?: Maybe<SendExtendedKbaRequestEmailOutput>;
  /** Send a SMS command to a device */
  send_sms_command?: Maybe<SmsCommandOutput>;
  send_special_letters_to_sftp?: Maybe<SendSpecialLettersToSftpOutput>;
  send_to_queue?: Maybe<SendToQueueOutput>;
  set_device_force_update_mutation?: Maybe<UpdateDeviceOutput>;
  split_transaction?: Maybe<SplitTransactionOutput>;
  start_generation_of_special_letters: Scalars['uuid'];
  /** tolerate parking result api */
  tolerate_parking_result_api?: Maybe<TolerateParkingResultsApiOutput>;
  /** This hasura action will trigger an endpoint which is responsible for transferring a violation case based on the input. */
  transfer_violation_case?: Maybe<TransferViolationCaseOutput>;
  unlink_transaction?: Maybe<UnlinkTransactionOutput>;
  /** update data of the table: "adyen_report" */
  update_adyen_report?: Maybe<AdyenReportMutationResponse>;
  /** update single row of the table: "adyen_report" */
  update_adyen_report_by_pk?: Maybe<AdyenReport>;
  /** update multiples rows of table: "adyen_report" */
  update_adyen_report_many?: Maybe<Array<Maybe<AdyenReportMutationResponse>>>;
  /** update data of the table: "adyen_transaction" */
  update_adyen_transaction?: Maybe<AdyenTransactionMutationResponse>;
  /** update single row of the table: "adyen_transaction" */
  update_adyen_transaction_by_pk?: Maybe<AdyenTransaction>;
  /** update multiples rows of table: "adyen_transaction" */
  update_adyen_transaction_many?: Maybe<Array<Maybe<AdyenTransactionMutationResponse>>>;
  /** update data of the table: "applied_permit" */
  update_applied_permit?: Maybe<AppliedPermitMutationResponse>;
  /** update single row of the table: "applied_permit" */
  update_applied_permit_by_pk?: Maybe<AppliedPermit>;
  /** update multiples rows of table: "applied_permit" */
  update_applied_permit_many?: Maybe<Array<Maybe<AppliedPermitMutationResponse>>>;
  /** update data of the table: "applied_whitelist" */
  update_applied_whitelist?: Maybe<AppliedWhitelistMutationResponse>;
  /** update single row of the table: "applied_whitelist" */
  update_applied_whitelist_by_pk?: Maybe<AppliedWhitelist>;
  /** update multiples rows of table: "applied_whitelist" */
  update_applied_whitelist_many?: Maybe<Array<Maybe<AppliedWhitelistMutationResponse>>>;
  /** update data of the table: "audit.logged_actions" */
  update_audit_logged_actions?: Maybe<AuditLoggedActionsMutationResponse>;
  /** update single row of the table: "audit.logged_actions" */
  update_audit_logged_actions_by_pk?: Maybe<AuditLoggedActions>;
  /** update multiples rows of table: "audit.logged_actions" */
  update_audit_logged_actions_many?: Maybe<Array<Maybe<AuditLoggedActionsMutationResponse>>>;
  update_auth0_user?: Maybe<UserData>;
  /** update data of the table: "blacklist" */
  update_blacklist?: Maybe<BlacklistMutationResponse>;
  /** update single row of the table: "blacklist" */
  update_blacklist_by_pk?: Maybe<Blacklist>;
  /** update multiples rows of table: "blacklist" */
  update_blacklist_many?: Maybe<Array<Maybe<BlacklistMutationResponse>>>;
  /** update data of the table: "booking.booking" */
  update_booking_booking?: Maybe<BookingBookingMutationResponse>;
  /** update single row of the table: "booking.booking" */
  update_booking_booking_by_pk?: Maybe<BookingBooking>;
  /** update data of the table: "booking.booking_invoice" */
  update_booking_booking_invoice?: Maybe<BookingBookingInvoiceMutationResponse>;
  /** update single row of the table: "booking.booking_invoice" */
  update_booking_booking_invoice_by_pk?: Maybe<BookingBookingInvoice>;
  /** update multiples rows of table: "booking.booking_invoice" */
  update_booking_booking_invoice_many?: Maybe<Array<Maybe<BookingBookingInvoiceMutationResponse>>>;
  /** update multiples rows of table: "booking.booking" */
  update_booking_booking_many?: Maybe<Array<Maybe<BookingBookingMutationResponse>>>;
  /** update data of the table: "booking.booking_plate" */
  update_booking_booking_plate?: Maybe<BookingBookingPlateMutationResponse>;
  /** update single row of the table: "booking.booking_plate" */
  update_booking_booking_plate_by_pk?: Maybe<BookingBookingPlate>;
  /** update multiples rows of table: "booking.booking_plate" */
  update_booking_booking_plate_many?: Maybe<Array<Maybe<BookingBookingPlateMutationResponse>>>;
  /** update data of the table: "booking.booking_type" */
  update_booking_booking_type?: Maybe<BookingBookingTypeMutationResponse>;
  /** update single row of the table: "booking.booking_type" */
  update_booking_booking_type_by_pk?: Maybe<BookingBookingType>;
  /** update multiples rows of table: "booking.booking_type" */
  update_booking_booking_type_many?: Maybe<Array<Maybe<BookingBookingTypeMutationResponse>>>;
  /** update data of the table: "booking.booking_whitelist" */
  update_booking_booking_whitelist?: Maybe<BookingBookingWhitelistMutationResponse>;
  /** update single row of the table: "booking.booking_whitelist" */
  update_booking_booking_whitelist_by_pk?: Maybe<BookingBookingWhitelist>;
  /** update multiples rows of table: "booking.booking_whitelist" */
  update_booking_booking_whitelist_many?: Maybe<Array<Maybe<BookingBookingWhitelistMutationResponse>>>;
  /** update data of the table: "booking.enum_booking_status" */
  update_booking_enum_booking_status?: Maybe<BookingEnumBookingStatusMutationResponse>;
  /** update single row of the table: "booking.enum_booking_status" */
  update_booking_enum_booking_status_by_pk?: Maybe<BookingEnumBookingStatus>;
  /** update multiples rows of table: "booking.enum_booking_status" */
  update_booking_enum_booking_status_many?: Maybe<Array<Maybe<BookingEnumBookingStatusMutationResponse>>>;
  /** update data of the table: "booking.hourly_booking" */
  update_booking_hourly_booking?: Maybe<BookingHourlyBookingMutationResponse>;
  /** update single row of the table: "booking.hourly_booking" */
  update_booking_hourly_booking_by_pk?: Maybe<BookingHourlyBooking>;
  /** update multiples rows of table: "booking.hourly_booking" */
  update_booking_hourly_booking_many?: Maybe<Array<Maybe<BookingHourlyBookingMutationResponse>>>;
  /** update data of the table: "booking.license_plate" */
  update_booking_license_plate?: Maybe<BookingLicensePlateMutationResponse>;
  /** update single row of the table: "booking.license_plate" */
  update_booking_license_plate_by_pk?: Maybe<BookingLicensePlate>;
  /** update multiples rows of table: "booking.license_plate" */
  update_booking_license_plate_many?: Maybe<Array<Maybe<BookingLicensePlateMutationResponse>>>;
  /** update data of the table: "booking.lot" */
  update_booking_lot?: Maybe<BookingLotMutationResponse>;
  /** update single row of the table: "booking.lot" */
  update_booking_lot_by_pk?: Maybe<BookingLot>;
  /** update data of the table: "booking.lot_configuration" */
  update_booking_lot_configuration?: Maybe<BookingLotConfigurationMutationResponse>;
  /** update single row of the table: "booking.lot_configuration" */
  update_booking_lot_configuration_by_pk?: Maybe<BookingLotConfiguration>;
  /** update multiples rows of table: "booking.lot_configuration" */
  update_booking_lot_configuration_many?: Maybe<Array<Maybe<BookingLotConfigurationMutationResponse>>>;
  /** update multiples rows of table: "booking.lot" */
  update_booking_lot_many?: Maybe<Array<Maybe<BookingLotMutationResponse>>>;
  /** update data of the table: "booking.payment" */
  update_booking_payment?: Maybe<BookingPaymentMutationResponse>;
  /** update single row of the table: "booking.payment" */
  update_booking_payment_by_pk?: Maybe<BookingPayment>;
  /** update multiples rows of table: "booking.payment" */
  update_booking_payment_many?: Maybe<Array<Maybe<BookingPaymentMutationResponse>>>;
  /** update data of the table: "booking.pricing_rules" */
  update_booking_pricing_rules?: Maybe<BookingPricingRulesMutationResponse>;
  /** update single row of the table: "booking.pricing_rules" */
  update_booking_pricing_rules_by_pk?: Maybe<BookingPricingRules>;
  /** update multiples rows of table: "booking.pricing_rules" */
  update_booking_pricing_rules_many?: Maybe<Array<Maybe<BookingPricingRulesMutationResponse>>>;
  /** update data of the table: "booking.pricing_type" */
  update_booking_pricing_type?: Maybe<BookingPricingTypeMutationResponse>;
  /** update single row of the table: "booking.pricing_type" */
  update_booking_pricing_type_by_pk?: Maybe<BookingPricingType>;
  /** update multiples rows of table: "booking.pricing_type" */
  update_booking_pricing_type_many?: Maybe<Array<Maybe<BookingPricingTypeMutationResponse>>>;
  /** update data of the table: "booking.private_pricing_user" */
  update_booking_private_pricing_user?: Maybe<BookingPrivatePricingUserMutationResponse>;
  /** update single row of the table: "booking.private_pricing_user" */
  update_booking_private_pricing_user_by_pk?: Maybe<BookingPrivatePricingUser>;
  /** update multiples rows of table: "booking.private_pricing_user" */
  update_booking_private_pricing_user_many?: Maybe<Array<Maybe<BookingPrivatePricingUserMutationResponse>>>;
  /** update data of the table: "booking.recurring_booking" */
  update_booking_recurring_booking?: Maybe<BookingRecurringBookingMutationResponse>;
  /** update single row of the table: "booking.recurring_booking" */
  update_booking_recurring_booking_by_pk?: Maybe<BookingRecurringBooking>;
  /** update multiples rows of table: "booking.recurring_booking" */
  update_booking_recurring_booking_many?: Maybe<Array<Maybe<BookingRecurringBookingMutationResponse>>>;
  /** update data of the table: "booking.subscription_booking" */
  update_booking_subscription_booking?: Maybe<BookingSubscriptionBookingMutationResponse>;
  /** update single row of the table: "booking.subscription_booking" */
  update_booking_subscription_booking_by_pk?: Maybe<BookingSubscriptionBooking>;
  /** update multiples rows of table: "booking.subscription_booking" */
  update_booking_subscription_booking_many?: Maybe<Array<Maybe<BookingSubscriptionBookingMutationResponse>>>;
  /** update data of the table: "booking.subscription_license_plate" */
  update_booking_subscription_license_plate?: Maybe<BookingSubscriptionLicensePlateMutationResponse>;
  /** update single row of the table: "booking.subscription_license_plate" */
  update_booking_subscription_license_plate_by_pk?: Maybe<BookingSubscriptionLicensePlate>;
  /** update multiples rows of table: "booking.subscription_license_plate" */
  update_booking_subscription_license_plate_many?: Maybe<Array<Maybe<BookingSubscriptionLicensePlateMutationResponse>>>;
  /** update data of the table: "booking.subscription_status" */
  update_booking_subscription_status?: Maybe<BookingSubscriptionStatusMutationResponse>;
  /** update single row of the table: "booking.subscription_status" */
  update_booking_subscription_status_by_pk?: Maybe<BookingSubscriptionStatus>;
  /** update multiples rows of table: "booking.subscription_status" */
  update_booking_subscription_status_many?: Maybe<Array<Maybe<BookingSubscriptionStatusMutationResponse>>>;
  /** update data of the table: "booking.user" */
  update_booking_user?: Maybe<BookingUserMutationResponse>;
  /** update data of the table: "booking.user_booking" */
  update_booking_user_booking?: Maybe<BookingUserBookingMutationResponse>;
  /** update single row of the table: "booking.user_booking" */
  update_booking_user_booking_by_pk?: Maybe<BookingUserBooking>;
  /** update multiples rows of table: "booking.user_booking" */
  update_booking_user_booking_many?: Maybe<Array<Maybe<BookingUserBookingMutationResponse>>>;
  /** update single row of the table: "booking.user" */
  update_booking_user_by_pk?: Maybe<BookingUser>;
  /** update multiples rows of table: "booking.user" */
  update_booking_user_many?: Maybe<Array<Maybe<BookingUserMutationResponse>>>;
  /** update data of the table: "booking.user_payment_method" */
  update_booking_user_payment_method?: Maybe<BookingUserPaymentMethodMutationResponse>;
  /** update single row of the table: "booking.user_payment_method" */
  update_booking_user_payment_method_by_pk?: Maybe<BookingUserPaymentMethod>;
  /** update multiples rows of table: "booking.user_payment_method" */
  update_booking_user_payment_method_many?: Maybe<Array<Maybe<BookingUserPaymentMethodMutationResponse>>>;
  /** update data of the table: "booking.user_subscription" */
  update_booking_user_subscription?: Maybe<BookingUserSubscriptionMutationResponse>;
  /** update single row of the table: "booking.user_subscription" */
  update_booking_user_subscription_by_pk?: Maybe<BookingUserSubscription>;
  /** update multiples rows of table: "booking.user_subscription" */
  update_booking_user_subscription_many?: Maybe<Array<Maybe<BookingUserSubscriptionMutationResponse>>>;
  /** update data of the table: "booking.vehicle" */
  update_booking_vehicle?: Maybe<BookingVehicleMutationResponse>;
  /** update single row of the table: "booking.vehicle" */
  update_booking_vehicle_by_pk?: Maybe<BookingVehicle>;
  /** update multiples rows of table: "booking.vehicle" */
  update_booking_vehicle_many?: Maybe<Array<Maybe<BookingVehicleMutationResponse>>>;
  /** update data of the table: "booking.vehicle_type" */
  update_booking_vehicle_type?: Maybe<BookingVehicleTypeMutationResponse>;
  /** update single row of the table: "booking.vehicle_type" */
  update_booking_vehicle_type_by_pk?: Maybe<BookingVehicleType>;
  /** update multiples rows of table: "booking.vehicle_type" */
  update_booking_vehicle_type_many?: Maybe<Array<Maybe<BookingVehicleTypeMutationResponse>>>;
  /** update data of the table: "booking.whitelist_type" */
  update_booking_whitelist_type?: Maybe<BookingWhitelistTypeMutationResponse>;
  /** update single row of the table: "booking.whitelist_type" */
  update_booking_whitelist_type_by_pk?: Maybe<BookingWhitelistType>;
  /** update multiples rows of table: "booking.whitelist_type" */
  update_booking_whitelist_type_many?: Maybe<Array<Maybe<BookingWhitelistTypeMutationResponse>>>;
  /** update data of the table: "calendar_event_policy" */
  update_calendar_event_policy?: Maybe<CalendarEventPolicyMutationResponse>;
  /** update single row of the table: "calendar_event_policy" */
  update_calendar_event_policy_by_pk?: Maybe<CalendarEventPolicy>;
  /** update multiples rows of table: "calendar_event_policy" */
  update_calendar_event_policy_many?: Maybe<Array<Maybe<CalendarEventPolicyMutationResponse>>>;
  /** update data of the table: "cancellations" */
  update_cancellations?: Maybe<CancellationsMutationResponse>;
  /** update single row of the table: "cancellations" */
  update_cancellations_by_pk?: Maybe<Cancellations>;
  /** update multiples rows of table: "cancellations" */
  update_cancellations_many?: Maybe<Array<Maybe<CancellationsMutationResponse>>>;
  /** update data of the table: "car_driver" */
  update_car_driver?: Maybe<CarDriverMutationResponse>;
  /** update single row of the table: "car_driver" */
  update_car_driver_by_pk?: Maybe<CarDriver>;
  /** update multiples rows of table: "car_driver" */
  update_car_driver_many?: Maybe<Array<Maybe<CarDriverMutationResponse>>>;
  /** update data of the table: "car_owner" */
  update_car_owner?: Maybe<CarOwnerMutationResponse>;
  /** update single row of the table: "car_owner" */
  update_car_owner_by_pk?: Maybe<CarOwner>;
  /** update multiples rows of table: "car_owner" */
  update_car_owner_many?: Maybe<Array<Maybe<CarOwnerMutationResponse>>>;
  /** update data of the table: "car_owner_requests" */
  update_car_owner_requests?: Maybe<CarOwnerRequestsMutationResponse>;
  /** update single row of the table: "car_owner_requests" */
  update_car_owner_requests_by_pk?: Maybe<CarOwnerRequests>;
  /** update multiples rows of table: "car_owner_requests" */
  update_car_owner_requests_many?: Maybe<Array<Maybe<CarOwnerRequestsMutationResponse>>>;
  /** update data of the table: "carpay_access_control_lp_pin" */
  update_carpay_access_control_lp_pin?: Maybe<CarpayAccessControlLpPinMutationResponse>;
  /** update single row of the table: "carpay_access_control_lp_pin" */
  update_carpay_access_control_lp_pin_by_pk?: Maybe<CarpayAccessControlLpPin>;
  /** update multiples rows of table: "carpay_access_control_lp_pin" */
  update_carpay_access_control_lp_pin_many?: Maybe<Array<Maybe<CarpayAccessControlLpPinMutationResponse>>>;
  /** update data of the table: "carpay_discount_batch" */
  update_carpay_discount_batch?: Maybe<CarpayDiscountBatchMutationResponse>;
  /** update single row of the table: "carpay_discount_batch" */
  update_carpay_discount_batch_by_pk?: Maybe<CarpayDiscountBatch>;
  /** update multiples rows of table: "carpay_discount_batch" */
  update_carpay_discount_batch_many?: Maybe<Array<Maybe<CarpayDiscountBatchMutationResponse>>>;
  /** update data of the table: "carpay_discount_model" */
  update_carpay_discount_model?: Maybe<CarpayDiscountModelMutationResponse>;
  /** update single row of the table: "carpay_discount_model" */
  update_carpay_discount_model_by_pk?: Maybe<CarpayDiscountModel>;
  /** update multiples rows of table: "carpay_discount_model" */
  update_carpay_discount_model_many?: Maybe<Array<Maybe<CarpayDiscountModelMutationResponse>>>;
  /** update data of the table: "carpay_lot" */
  update_carpay_lot?: Maybe<CarpayLotMutationResponse>;
  /** update single row of the table: "carpay_lot" */
  update_carpay_lot_by_pk?: Maybe<CarpayLot>;
  /** update multiples rows of table: "carpay_lot" */
  update_carpay_lot_many?: Maybe<Array<Maybe<CarpayLotMutationResponse>>>;
  /** update data of the table: "carpay_notification_subscriber" */
  update_carpay_notification_subscriber?: Maybe<CarpayNotificationSubscriberMutationResponse>;
  /** update single row of the table: "carpay_notification_subscriber" */
  update_carpay_notification_subscriber_by_pk?: Maybe<CarpayNotificationSubscriber>;
  /** update multiples rows of table: "carpay_notification_subscriber" */
  update_carpay_notification_subscriber_many?: Maybe<Array<Maybe<CarpayNotificationSubscriberMutationResponse>>>;
  /** update data of the table: "carpay_notification_subscription" */
  update_carpay_notification_subscription?: Maybe<CarpayNotificationSubscriptionMutationResponse>;
  /** update single row of the table: "carpay_notification_subscription" */
  update_carpay_notification_subscription_by_pk?: Maybe<CarpayNotificationSubscription>;
  /** update data of the table: "carpay_notification_subscription_category" */
  update_carpay_notification_subscription_category?: Maybe<CarpayNotificationSubscriptionCategoryMutationResponse>;
  /** update single row of the table: "carpay_notification_subscription_category" */
  update_carpay_notification_subscription_category_by_pk?: Maybe<CarpayNotificationSubscriptionCategory>;
  /** update multiples rows of table: "carpay_notification_subscription_category" */
  update_carpay_notification_subscription_category_many?: Maybe<Array<Maybe<CarpayNotificationSubscriptionCategoryMutationResponse>>>;
  /** update multiples rows of table: "carpay_notification_subscription" */
  update_carpay_notification_subscription_many?: Maybe<Array<Maybe<CarpayNotificationSubscriptionMutationResponse>>>;
  /** update data of the table: "carpay_order" */
  update_carpay_order?: Maybe<CarpayOrderMutationResponse>;
  /** update single row of the table: "carpay_order" */
  update_carpay_order_by_pk?: Maybe<CarpayOrder>;
  /** update multiples rows of table: "carpay_order" */
  update_carpay_order_many?: Maybe<Array<Maybe<CarpayOrderMutationResponse>>>;
  /** update data of the table: "carpay_order_matches" */
  update_carpay_order_matches?: Maybe<CarpayOrderMatchesMutationResponse>;
  /** update single row of the table: "carpay_order_matches" */
  update_carpay_order_matches_by_pk?: Maybe<CarpayOrderMatches>;
  /** update multiples rows of table: "carpay_order_matches" */
  update_carpay_order_matches_many?: Maybe<Array<Maybe<CarpayOrderMatchesMutationResponse>>>;
  /** update data of the table: "carpay_order_user" */
  update_carpay_order_user?: Maybe<CarpayOrderUserMutationResponse>;
  /** update single row of the table: "carpay_order_user" */
  update_carpay_order_user_by_pk?: Maybe<CarpayOrderUser>;
  /** update multiples rows of table: "carpay_order_user" */
  update_carpay_order_user_many?: Maybe<Array<Maybe<CarpayOrderUserMutationResponse>>>;
  /** update data of the table: "carpay_parking_detection" */
  update_carpay_parking_detection?: Maybe<CarpayParkingDetectionMutationResponse>;
  /** update single row of the table: "carpay_parking_detection" */
  update_carpay_parking_detection_by_pk?: Maybe<CarpayParkingDetection>;
  /** update multiples rows of table: "carpay_parking_detection" */
  update_carpay_parking_detection_many?: Maybe<Array<Maybe<CarpayParkingDetectionMutationResponse>>>;
  /** update data of the table: "carpay_pricing" */
  update_carpay_pricing?: Maybe<CarpayPricingMutationResponse>;
  /** update single row of the table: "carpay_pricing" */
  update_carpay_pricing_by_pk?: Maybe<CarpayPricing>;
  /** update data of the table: "carpay_pricing_config_group" */
  update_carpay_pricing_config_group?: Maybe<CarpayPricingConfigGroupMutationResponse>;
  /** update single row of the table: "carpay_pricing_config_group" */
  update_carpay_pricing_config_group_by_pk?: Maybe<CarpayPricingConfigGroup>;
  /** update multiples rows of table: "carpay_pricing_config_group" */
  update_carpay_pricing_config_group_many?: Maybe<Array<Maybe<CarpayPricingConfigGroupMutationResponse>>>;
  /** update multiples rows of table: "carpay_pricing" */
  update_carpay_pricing_many?: Maybe<Array<Maybe<CarpayPricingMutationResponse>>>;
  /** update data of the table: "carpay_pricing_period" */
  update_carpay_pricing_period?: Maybe<CarpayPricingPeriodMutationResponse>;
  /** update single row of the table: "carpay_pricing_period" */
  update_carpay_pricing_period_by_pk?: Maybe<CarpayPricingPeriod>;
  /** update multiples rows of table: "carpay_pricing_period" */
  update_carpay_pricing_period_many?: Maybe<Array<Maybe<CarpayPricingPeriodMutationResponse>>>;
  /** update data of the table: "carpay_pricing_recurrence" */
  update_carpay_pricing_recurrence?: Maybe<CarpayPricingRecurrenceMutationResponse>;
  /** update single row of the table: "carpay_pricing_recurrence" */
  update_carpay_pricing_recurrence_by_pk?: Maybe<CarpayPricingRecurrence>;
  /** update multiples rows of table: "carpay_pricing_recurrence" */
  update_carpay_pricing_recurrence_many?: Maybe<Array<Maybe<CarpayPricingRecurrenceMutationResponse>>>;
  /** update data of the table: "carpay_pricing_rules" */
  update_carpay_pricing_rules?: Maybe<CarpayPricingRulesMutationResponse>;
  /** update single row of the table: "carpay_pricing_rules" */
  update_carpay_pricing_rules_by_pk?: Maybe<CarpayPricingRules>;
  /** update multiples rows of table: "carpay_pricing_rules" */
  update_carpay_pricing_rules_many?: Maybe<Array<Maybe<CarpayPricingRulesMutationResponse>>>;
  /** update data of the table: "carpay_scanned_codes" */
  update_carpay_scanned_codes?: Maybe<CarpayScannedCodesMutationResponse>;
  /** update single row of the table: "carpay_scanned_codes" */
  update_carpay_scanned_codes_by_pk?: Maybe<CarpayScannedCodes>;
  /** update multiples rows of table: "carpay_scanned_codes" */
  update_carpay_scanned_codes_many?: Maybe<Array<Maybe<CarpayScannedCodesMutationResponse>>>;
  /** update data of the table: "carpay_terminal_cash_cut_notification" */
  update_carpay_terminal_cash_cut_notification?: Maybe<CarpayTerminalCashCutNotificationMutationResponse>;
  /** update single row of the table: "carpay_terminal_cash_cut_notification" */
  update_carpay_terminal_cash_cut_notification_by_pk?: Maybe<CarpayTerminalCashCutNotification>;
  /** update multiples rows of table: "carpay_terminal_cash_cut_notification" */
  update_carpay_terminal_cash_cut_notification_many?: Maybe<Array<Maybe<CarpayTerminalCashCutNotificationMutationResponse>>>;
  /** update data of the table: "carpay_terminal_cash_fill_level_notification" */
  update_carpay_terminal_cash_fill_level_notification?: Maybe<CarpayTerminalCashFillLevelNotificationMutationResponse>;
  /** update single row of the table: "carpay_terminal_cash_fill_level_notification" */
  update_carpay_terminal_cash_fill_level_notification_by_pk?: Maybe<CarpayTerminalCashFillLevelNotification>;
  /** update multiples rows of table: "carpay_terminal_cash_fill_level_notification" */
  update_carpay_terminal_cash_fill_level_notification_many?: Maybe<Array<Maybe<CarpayTerminalCashFillLevelNotificationMutationResponse>>>;
  /** update data of the table: "carpay_terminal_notification_config" */
  update_carpay_terminal_notification_config?: Maybe<CarpayTerminalNotificationConfigMutationResponse>;
  /** update single row of the table: "carpay_terminal_notification_config" */
  update_carpay_terminal_notification_config_by_pk?: Maybe<CarpayTerminalNotificationConfig>;
  /** update multiples rows of table: "carpay_terminal_notification_config" */
  update_carpay_terminal_notification_config_many?: Maybe<Array<Maybe<CarpayTerminalNotificationConfigMutationResponse>>>;
  /** update data of the table: "carpay_terminal_printer_status_notification" */
  update_carpay_terminal_printer_status_notification?: Maybe<CarpayTerminalPrinterStatusNotificationMutationResponse>;
  /** update single row of the table: "carpay_terminal_printer_status_notification" */
  update_carpay_terminal_printer_status_notification_by_pk?: Maybe<CarpayTerminalPrinterStatusNotification>;
  /** update multiples rows of table: "carpay_terminal_printer_status_notification" */
  update_carpay_terminal_printer_status_notification_many?: Maybe<Array<Maybe<CarpayTerminalPrinterStatusNotificationMutationResponse>>>;
  /** update data of the table: "carpay_user_verified_plate" */
  update_carpay_user_verified_plate?: Maybe<CarpayUserVerifiedPlateMutationResponse>;
  /** update single row of the table: "carpay_user_verified_plate" */
  update_carpay_user_verified_plate_by_pk?: Maybe<CarpayUserVerifiedPlate>;
  /** update multiples rows of table: "carpay_user_verified_plate" */
  update_carpay_user_verified_plate_many?: Maybe<Array<Maybe<CarpayUserVerifiedPlateMutationResponse>>>;
  /** update data of the table: "chain" */
  update_chain?: Maybe<ChainMutationResponse>;
  /** update single row of the table: "chain" */
  update_chain_by_pk?: Maybe<Chain>;
  /** update multiples rows of table: "chain" */
  update_chain_many?: Maybe<Array<Maybe<ChainMutationResponse>>>;
  /** update data of the table: "city_codes" */
  update_city_codes?: Maybe<CityCodesMutationResponse>;
  /** update multiples rows of table: "city_codes" */
  update_city_codes_many?: Maybe<Array<Maybe<CityCodesMutationResponse>>>;
  /** update data of the table: "company" */
  update_company?: Maybe<CompanyMutationResponse>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update data of the table: "company_config_group" */
  update_company_config_group?: Maybe<CompanyConfigGroupMutationResponse>;
  /** update single row of the table: "company_config_group" */
  update_company_config_group_by_pk?: Maybe<CompanyConfigGroup>;
  /** update multiples rows of table: "company_config_group" */
  update_company_config_group_many?: Maybe<Array<Maybe<CompanyConfigGroupMutationResponse>>>;
  /** update data of the table: "company_hierarchy" */
  update_company_hierarchy?: Maybe<CompanyHierarchyMutationResponse>;
  /** update single row of the table: "company_hierarchy" */
  update_company_hierarchy_by_pk?: Maybe<CompanyHierarchy>;
  /** update multiples rows of table: "company_hierarchy" */
  update_company_hierarchy_many?: Maybe<Array<Maybe<CompanyHierarchyMutationResponse>>>;
  /** update data of the table: "company_lot_section" */
  update_company_lot_section?: Maybe<CompanyLotSectionMutationResponse>;
  /** update single row of the table: "company_lot_section" */
  update_company_lot_section_by_pk?: Maybe<CompanyLotSection>;
  /** update multiples rows of table: "company_lot_section" */
  update_company_lot_section_many?: Maybe<Array<Maybe<CompanyLotSectionMutationResponse>>>;
  /** update multiples rows of table: "company" */
  update_company_many?: Maybe<Array<Maybe<CompanyMutationResponse>>>;
  /** update data of the table: "company_vat_id" */
  update_company_vat_id?: Maybe<CompanyVatIdMutationResponse>;
  /** update single row of the table: "company_vat_id" */
  update_company_vat_id_by_pk?: Maybe<CompanyVatId>;
  /** update multiples rows of table: "company_vat_id" */
  update_company_vat_id_many?: Maybe<Array<Maybe<CompanyVatIdMutationResponse>>>;
  /** update data of the table: "company_violator" */
  update_company_violator?: Maybe<CompanyViolatorMutationResponse>;
  /** update single row of the table: "company_violator" */
  update_company_violator_by_pk?: Maybe<CompanyViolator>;
  /** update multiples rows of table: "company_violator" */
  update_company_violator_many?: Maybe<Array<Maybe<CompanyViolatorMutationResponse>>>;
  /** update data of the table: "config_group" */
  update_config_group?: Maybe<ConfigGroupMutationResponse>;
  /** update single row of the table: "config_group" */
  update_config_group_by_pk?: Maybe<ConfigGroup>;
  /** update multiples rows of table: "config_group" */
  update_config_group_many?: Maybe<Array<Maybe<ConfigGroupMutationResponse>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<CountryMutationResponse>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<CountryMutationResponse>>>;
  /** update data of the table: "currency" */
  update_currency?: Maybe<CurrencyMutationResponse>;
  /** update single row of the table: "currency" */
  update_currency_by_pk?: Maybe<Currency>;
  /** update multiples rows of table: "currency" */
  update_currency_many?: Maybe<Array<Maybe<CurrencyMutationResponse>>>;
  /** update data of the table: "customer_dashboard_nps_feedback" */
  update_customer_dashboard_nps_feedback?: Maybe<CustomerDashboardNpsFeedbackMutationResponse>;
  /** update single row of the table: "customer_dashboard_nps_feedback" */
  update_customer_dashboard_nps_feedback_by_pk?: Maybe<CustomerDashboardNpsFeedback>;
  /** update multiples rows of table: "customer_dashboard_nps_feedback" */
  update_customer_dashboard_nps_feedback_many?: Maybe<Array<Maybe<CustomerDashboardNpsFeedbackMutationResponse>>>;
  /** update data of the table: "daily_failure" */
  update_daily_failure?: Maybe<DailyFailureMutationResponse>;
  /** update single row of the table: "daily_failure" */
  update_daily_failure_by_pk?: Maybe<DailyFailure>;
  /** update multiples rows of table: "daily_failure" */
  update_daily_failure_many?: Maybe<Array<Maybe<DailyFailureMutationResponse>>>;
  /** update data of the table: "daily_stats" */
  update_daily_stats?: Maybe<DailyStatsMutationResponse>;
  /** update single row of the table: "daily_stats" */
  update_daily_stats_by_pk?: Maybe<DailyStats>;
  /** update multiples rows of table: "daily_stats" */
  update_daily_stats_many?: Maybe<Array<Maybe<DailyStatsMutationResponse>>>;
  /** update data of the table: "department" */
  update_department?: Maybe<DepartmentMutationResponse>;
  /** update single row of the table: "department" */
  update_department_by_pk?: Maybe<Department>;
  /** update multiples rows of table: "department" */
  update_department_many?: Maybe<Array<Maybe<DepartmentMutationResponse>>>;
  /** update data of the table: "detection_type_enum" */
  update_detection_type_enum?: Maybe<DetectionTypeEnumMutationResponse>;
  /** update single row of the table: "detection_type_enum" */
  update_detection_type_enum_by_pk?: Maybe<DetectionTypeEnum>;
  /** update multiples rows of table: "detection_type_enum" */
  update_detection_type_enum_many?: Maybe<Array<Maybe<DetectionTypeEnumMutationResponse>>>;
  /** update data of the table: "device" */
  update_device?: Maybe<DeviceMutationResponse>;
  /** update single row of the table: "device" */
  update_device_by_pk?: Maybe<Device>;
  update_device_config_mutation?: Maybe<UpdateDeviceOutput>;
  /** update multiples rows of table: "device" */
  update_device_many?: Maybe<Array<Maybe<DeviceMutationResponse>>>;
  /** update data of the table: "easypark_lot" */
  update_easypark_lot?: Maybe<EasyparkLotMutationResponse>;
  /** update single row of the table: "easypark_lot" */
  update_easypark_lot_by_pk?: Maybe<EasyparkLot>;
  /** update multiples rows of table: "easypark_lot" */
  update_easypark_lot_many?: Maybe<Array<Maybe<EasyparkLotMutationResponse>>>;
  /** update data of the table: "easypark_order" */
  update_easypark_order?: Maybe<EasyparkOrderMutationResponse>;
  /** update single row of the table: "easypark_order" */
  update_easypark_order_by_pk?: Maybe<EasyparkOrder>;
  /** update multiples rows of table: "easypark_order" */
  update_easypark_order_many?: Maybe<Array<Maybe<EasyparkOrderMutationResponse>>>;
  /** update data of the table: "easypark_order_v2" */
  update_easypark_order_v2?: Maybe<EasyparkOrderV2MutationResponse>;
  /** update single row of the table: "easypark_order_v2" */
  update_easypark_order_v2_by_pk?: Maybe<EasyparkOrderV2>;
  /** update multiples rows of table: "easypark_order_v2" */
  update_easypark_order_v2_many?: Maybe<Array<Maybe<EasyparkOrderV2MutationResponse>>>;
  /** update data of the table: "easypark_parking_info" */
  update_easypark_parking_info?: Maybe<EasyparkParkingInfoMutationResponse>;
  /** update single row of the table: "easypark_parking_info" */
  update_easypark_parking_info_by_pk?: Maybe<EasyparkParkingInfo>;
  /** update multiples rows of table: "easypark_parking_info" */
  update_easypark_parking_info_many?: Maybe<Array<Maybe<EasyparkParkingInfoMutationResponse>>>;
  /** update data of the table: "enforcement_daily_stats" */
  update_enforcement_daily_stats?: Maybe<EnforcementDailyStatsMutationResponse>;
  /** update single row of the table: "enforcement_daily_stats" */
  update_enforcement_daily_stats_by_pk?: Maybe<EnforcementDailyStats>;
  /** update multiples rows of table: "enforcement_daily_stats" */
  update_enforcement_daily_stats_many?: Maybe<Array<Maybe<EnforcementDailyStatsMutationResponse>>>;
  /** update data of the table: "enum_carpay_discount_model_code_type" */
  update_enum_carpay_discount_model_code_type?: Maybe<EnumCarpayDiscountModelCodeTypeMutationResponse>;
  /** update single row of the table: "enum_carpay_discount_model_code_type" */
  update_enum_carpay_discount_model_code_type_by_pk?: Maybe<EnumCarpayDiscountModelCodeType>;
  /** update multiples rows of table: "enum_carpay_discount_model_code_type" */
  update_enum_carpay_discount_model_code_type_many?: Maybe<Array<Maybe<EnumCarpayDiscountModelCodeTypeMutationResponse>>>;
  /** update data of the table: "enum_country_code" */
  update_enum_country_code?: Maybe<EnumCountryCodeMutationResponse>;
  /** update single row of the table: "enum_country_code" */
  update_enum_country_code_by_pk?: Maybe<EnumCountryCode>;
  /** update multiples rows of table: "enum_country_code" */
  update_enum_country_code_many?: Maybe<Array<Maybe<EnumCountryCodeMutationResponse>>>;
  /** update data of the table: "enum_customer_whitelist_purpose" */
  update_enum_customer_whitelist_purpose?: Maybe<EnumCustomerWhitelistPurposeMutationResponse>;
  /** update single row of the table: "enum_customer_whitelist_purpose" */
  update_enum_customer_whitelist_purpose_by_pk?: Maybe<EnumCustomerWhitelistPurpose>;
  /** update multiples rows of table: "enum_customer_whitelist_purpose" */
  update_enum_customer_whitelist_purpose_many?: Maybe<Array<Maybe<EnumCustomerWhitelistPurposeMutationResponse>>>;
  /** update data of the table: "enum_customer_whitelist_status" */
  update_enum_customer_whitelist_status?: Maybe<EnumCustomerWhitelistStatusMutationResponse>;
  /** update single row of the table: "enum_customer_whitelist_status" */
  update_enum_customer_whitelist_status_by_pk?: Maybe<EnumCustomerWhitelistStatus>;
  /** update multiples rows of table: "enum_customer_whitelist_status" */
  update_enum_customer_whitelist_status_many?: Maybe<Array<Maybe<EnumCustomerWhitelistStatusMutationResponse>>>;
  /** update data of the table: "enum_device_type" */
  update_enum_device_type?: Maybe<EnumDeviceTypeMutationResponse>;
  /** update single row of the table: "enum_device_type" */
  update_enum_device_type_by_pk?: Maybe<EnumDeviceType>;
  /** update multiples rows of table: "enum_device_type" */
  update_enum_device_type_many?: Maybe<Array<Maybe<EnumDeviceTypeMutationResponse>>>;
  /** update data of the table: "enum_driver_request_type" */
  update_enum_driver_request_type?: Maybe<EnumDriverRequestTypeMutationResponse>;
  /** update single row of the table: "enum_driver_request_type" */
  update_enum_driver_request_type_by_pk?: Maybe<EnumDriverRequestType>;
  /** update multiples rows of table: "enum_driver_request_type" */
  update_enum_driver_request_type_many?: Maybe<Array<Maybe<EnumDriverRequestTypeMutationResponse>>>;
  /** update data of the table: "enum_guest_jwt_purpose" */
  update_enum_guest_jwt_purpose?: Maybe<EnumGuestJwtPurposeMutationResponse>;
  /** update single row of the table: "enum_guest_jwt_purpose" */
  update_enum_guest_jwt_purpose_by_pk?: Maybe<EnumGuestJwtPurpose>;
  /** update multiples rows of table: "enum_guest_jwt_purpose" */
  update_enum_guest_jwt_purpose_many?: Maybe<Array<Maybe<EnumGuestJwtPurposeMutationResponse>>>;
  /** update data of the table: "enum_supervision_mlp_request_status" */
  update_enum_supervision_mlp_request_status?: Maybe<EnumSupervisionMlpRequestStatusMutationResponse>;
  /** update single row of the table: "enum_supervision_mlp_request_status" */
  update_enum_supervision_mlp_request_status_by_pk?: Maybe<EnumSupervisionMlpRequestStatus>;
  /** update multiples rows of table: "enum_supervision_mlp_request_status" */
  update_enum_supervision_mlp_request_status_many?: Maybe<Array<Maybe<EnumSupervisionMlpRequestStatusMutationResponse>>>;
  /** update data of the table: "enum_violation_cancellation" */
  update_enum_violation_cancellation?: Maybe<EnumViolationCancellationMutationResponse>;
  /** update single row of the table: "enum_violation_cancellation" */
  update_enum_violation_cancellation_by_pk?: Maybe<EnumViolationCancellation>;
  /** update multiples rows of table: "enum_violation_cancellation" */
  update_enum_violation_cancellation_many?: Maybe<Array<Maybe<EnumViolationCancellationMutationResponse>>>;
  /** update data of the table: "enum_violation_case_charges_invalidation_reason" */
  update_enum_violation_case_charges_invalidation_reason?: Maybe<EnumViolationCaseChargesInvalidationReasonMutationResponse>;
  /** update single row of the table: "enum_violation_case_charges_invalidation_reason" */
  update_enum_violation_case_charges_invalidation_reason_by_pk?: Maybe<EnumViolationCaseChargesInvalidationReason>;
  /** update multiples rows of table: "enum_violation_case_charges_invalidation_reason" */
  update_enum_violation_case_charges_invalidation_reason_many?: Maybe<Array<Maybe<EnumViolationCaseChargesInvalidationReasonMutationResponse>>>;
  /** update data of the table: "enum_violation_case_charges_type" */
  update_enum_violation_case_charges_type?: Maybe<EnumViolationCaseChargesTypeMutationResponse>;
  /** update single row of the table: "enum_violation_case_charges_type" */
  update_enum_violation_case_charges_type_by_pk?: Maybe<EnumViolationCaseChargesType>;
  /** update multiples rows of table: "enum_violation_case_charges_type" */
  update_enum_violation_case_charges_type_many?: Maybe<Array<Maybe<EnumViolationCaseChargesTypeMutationResponse>>>;
  /** update data of the table: "enum_whitelist_paid_parking_types" */
  update_enum_whitelist_paid_parking_types?: Maybe<EnumWhitelistPaidParkingTypesMutationResponse>;
  /** update single row of the table: "enum_whitelist_paid_parking_types" */
  update_enum_whitelist_paid_parking_types_by_pk?: Maybe<EnumWhitelistPaidParkingTypes>;
  /** update multiples rows of table: "enum_whitelist_paid_parking_types" */
  update_enum_whitelist_paid_parking_types_many?: Maybe<Array<Maybe<EnumWhitelistPaidParkingTypesMutationResponse>>>;
  /** update data of the table: "enum_whitelist_scope" */
  update_enum_whitelist_scope?: Maybe<EnumWhitelistScopeMutationResponse>;
  /** update single row of the table: "enum_whitelist_scope" */
  update_enum_whitelist_scope_by_pk?: Maybe<EnumWhitelistScope>;
  /** update multiples rows of table: "enum_whitelist_scope" */
  update_enum_whitelist_scope_many?: Maybe<Array<Maybe<EnumWhitelistScopeMutationResponse>>>;
  /** update data of the table: "enum_whitelist_status" */
  update_enum_whitelist_status?: Maybe<EnumWhitelistStatusMutationResponse>;
  /** update single row of the table: "enum_whitelist_status" */
  update_enum_whitelist_status_by_pk?: Maybe<EnumWhitelistStatus>;
  /** update multiples rows of table: "enum_whitelist_status" */
  update_enum_whitelist_status_many?: Maybe<Array<Maybe<EnumWhitelistStatusMutationResponse>>>;
  /** update data of the table: "enum_whitelist_types" */
  update_enum_whitelist_types?: Maybe<EnumWhitelistTypesMutationResponse>;
  /** update single row of the table: "enum_whitelist_types" */
  update_enum_whitelist_types_by_pk?: Maybe<EnumWhitelistTypes>;
  /** update multiples rows of table: "enum_whitelist_types" */
  update_enum_whitelist_types_many?: Maybe<Array<Maybe<EnumWhitelistTypesMutationResponse>>>;
  /** update data of the table: "guest_jwt" */
  update_guest_jwt?: Maybe<GuestJwtMutationResponse>;
  /** update single row of the table: "guest_jwt" */
  update_guest_jwt_by_pk?: Maybe<GuestJwt>;
  /** update multiples rows of table: "guest_jwt" */
  update_guest_jwt_many?: Maybe<Array<Maybe<GuestJwtMutationResponse>>>;
  /** update data of the table: "guest_qr" */
  update_guest_qr?: Maybe<GuestQrMutationResponse>;
  /** update single row of the table: "guest_qr" */
  update_guest_qr_by_pk?: Maybe<GuestQr>;
  /** update multiples rows of table: "guest_qr" */
  update_guest_qr_many?: Maybe<Array<Maybe<GuestQrMutationResponse>>>;
  /** update data of the table: "lot" */
  update_lot?: Maybe<LotMutationResponse>;
  /** update single row of the table: "lot" */
  update_lot_by_pk?: Maybe<Lot>;
  /** update data of the table: "lot_config_group" */
  update_lot_config_group?: Maybe<LotConfigGroupMutationResponse>;
  /** update single row of the table: "lot_config_group" */
  update_lot_config_group_by_pk?: Maybe<LotConfigGroup>;
  /** update multiples rows of table: "lot_config_group" */
  update_lot_config_group_many?: Maybe<Array<Maybe<LotConfigGroupMutationResponse>>>;
  /** update data of the table: "lot_display_name" */
  update_lot_display_name?: Maybe<LotDisplayNameMutationResponse>;
  /** update single row of the table: "lot_display_name" */
  update_lot_display_name_by_pk?: Maybe<LotDisplayName>;
  /** update multiples rows of table: "lot_display_name" */
  update_lot_display_name_many?: Maybe<Array<Maybe<LotDisplayNameMutationResponse>>>;
  /** update data of the table: "lot_hierarchy" */
  update_lot_hierarchy?: Maybe<LotHierarchyMutationResponse>;
  /** update single row of the table: "lot_hierarchy" */
  update_lot_hierarchy_by_pk?: Maybe<LotHierarchy>;
  /** update multiples rows of table: "lot_hierarchy" */
  update_lot_hierarchy_many?: Maybe<Array<Maybe<LotHierarchyMutationResponse>>>;
  /** update data of the table: "lot_legal_entity" */
  update_lot_legal_entity?: Maybe<LotLegalEntityMutationResponse>;
  /** update single row of the table: "lot_legal_entity" */
  update_lot_legal_entity_by_pk?: Maybe<LotLegalEntity>;
  /** update multiples rows of table: "lot_legal_entity" */
  update_lot_legal_entity_many?: Maybe<Array<Maybe<LotLegalEntityMutationResponse>>>;
  /** update multiples rows of table: "lot" */
  update_lot_many?: Maybe<Array<Maybe<LotMutationResponse>>>;
  /** update data of the table: "lot_policy_history" */
  update_lot_policy_history?: Maybe<LotPolicyHistoryMutationResponse>;
  /** update single row of the table: "lot_policy_history" */
  update_lot_policy_history_by_pk?: Maybe<LotPolicyHistory>;
  /** update multiples rows of table: "lot_policy_history" */
  update_lot_policy_history_many?: Maybe<Array<Maybe<LotPolicyHistoryMutationResponse>>>;
  /** update data of the table: "lot_section" */
  update_lot_section?: Maybe<LotSectionMutationResponse>;
  /** update single row of the table: "lot_section" */
  update_lot_section_by_pk?: Maybe<LotSection>;
  /** update multiples rows of table: "lot_section" */
  update_lot_section_many?: Maybe<Array<Maybe<LotSectionMutationResponse>>>;
  /** update data of the table: "lp_contingent" */
  update_lp_contingent?: Maybe<LpContingentMutationResponse>;
  /** update single row of the table: "lp_contingent" */
  update_lp_contingent_by_pk?: Maybe<LpContingent>;
  /** update multiples rows of table: "lp_contingent" */
  update_lp_contingent_many?: Maybe<Array<Maybe<LpContingentMutationResponse>>>;
  /** update data of the table: "lp_group" */
  update_lp_group?: Maybe<LpGroupMutationResponse>;
  /** update single row of the table: "lp_group" */
  update_lp_group_by_pk?: Maybe<LpGroup>;
  /** update data of the table: "lp_group_config_group" */
  update_lp_group_config_group?: Maybe<LpGroupConfigGroupMutationResponse>;
  /** update single row of the table: "lp_group_config_group" */
  update_lp_group_config_group_by_pk?: Maybe<LpGroupConfigGroup>;
  /** update multiples rows of table: "lp_group_config_group" */
  update_lp_group_config_group_many?: Maybe<Array<Maybe<LpGroupConfigGroupMutationResponse>>>;
  /** update data of the table: "lp_group_details" */
  update_lp_group_details?: Maybe<LpGroupDetailsMutationResponse>;
  /** update single row of the table: "lp_group_details" */
  update_lp_group_details_by_pk?: Maybe<LpGroupDetails>;
  /** update multiples rows of table: "lp_group_details" */
  update_lp_group_details_many?: Maybe<Array<Maybe<LpGroupDetailsMutationResponse>>>;
  /** update multiples rows of table: "lp_group" */
  update_lp_group_many?: Maybe<Array<Maybe<LpGroupMutationResponse>>>;
  /** update data of the table: "lp_group_member" */
  update_lp_group_member?: Maybe<LpGroupMemberMutationResponse>;
  /** update single row of the table: "lp_group_member" */
  update_lp_group_member_by_pk?: Maybe<LpGroupMember>;
  /** update data of the table: "lp_group_member_details" */
  update_lp_group_member_details?: Maybe<LpGroupMemberDetailsMutationResponse>;
  /** update single row of the table: "lp_group_member_details" */
  update_lp_group_member_details_by_pk?: Maybe<LpGroupMemberDetails>;
  /** update multiples rows of table: "lp_group_member_details" */
  update_lp_group_member_details_many?: Maybe<Array<Maybe<LpGroupMemberDetailsMutationResponse>>>;
  /** update multiples rows of table: "lp_group_member" */
  update_lp_group_member_many?: Maybe<Array<Maybe<LpGroupMemberMutationResponse>>>;
  /** update data of the table: "mail" */
  update_mail?: Maybe<MailMutationResponse>;
  /** update single row of the table: "mail" */
  update_mail_by_pk?: Maybe<Mail>;
  /** update multiples rows of table: "mail" */
  update_mail_many?: Maybe<Array<Maybe<MailMutationResponse>>>;
  /** update data of the table: "mail_misc" */
  update_mail_misc?: Maybe<MailMiscMutationResponse>;
  /** update single row of the table: "mail_misc" */
  update_mail_misc_by_pk?: Maybe<MailMisc>;
  /** update multiples rows of table: "mail_misc" */
  update_mail_misc_many?: Maybe<Array<Maybe<MailMiscMutationResponse>>>;
  /** update data of the table: "mlp_cases" */
  update_mlp_cases?: Maybe<MlpCasesMutationResponse>;
  /** update single row of the table: "mlp_cases" */
  update_mlp_cases_by_pk?: Maybe<MlpCases>;
  /** update multiples rows of table: "mlp_cases" */
  update_mlp_cases_many?: Maybe<Array<Maybe<MlpCasesMutationResponse>>>;
  /** update data of the table: "mlp_mappings" */
  update_mlp_mappings?: Maybe<MlpMappingsMutationResponse>;
  /** update single row of the table: "mlp_mappings" */
  update_mlp_mappings_by_pk?: Maybe<MlpMappings>;
  /** update multiples rows of table: "mlp_mappings" */
  update_mlp_mappings_many?: Maybe<Array<Maybe<MlpMappingsMutationResponse>>>;
  /** update data of the table: "mqtt_request" */
  update_mqtt_request?: Maybe<MqttRequestMutationResponse>;
  /** update single row of the table: "mqtt_request" */
  update_mqtt_request_by_pk?: Maybe<MqttRequest>;
  /** update multiples rows of table: "mqtt_request" */
  update_mqtt_request_many?: Maybe<Array<Maybe<MqttRequestMutationResponse>>>;
  /** update data of the table: "offence_parking_events" */
  update_offence_parking_events?: Maybe<OffenceParkingEventsMutationResponse>;
  /** update single row of the table: "offence_parking_events" */
  update_offence_parking_events_by_pk?: Maybe<OffenceParkingEvents>;
  /** update multiples rows of table: "offence_parking_events" */
  update_offence_parking_events_many?: Maybe<Array<Maybe<OffenceParkingEventsMutationResponse>>>;
  /** update data of the table: "offence_ticket_requests" */
  update_offence_ticket_requests?: Maybe<OffenceTicketRequestsMutationResponse>;
  /** update single row of the table: "offence_ticket_requests" */
  update_offence_ticket_requests_by_pk?: Maybe<OffenceTicketRequests>;
  /** update multiples rows of table: "offence_ticket_requests" */
  update_offence_ticket_requests_many?: Maybe<Array<Maybe<OffenceTicketRequestsMutationResponse>>>;
  /** update data of the table: "overuse_group" */
  update_overuse_group?: Maybe<OveruseGroupMutationResponse>;
  /** update single row of the table: "overuse_group" */
  update_overuse_group_by_pk?: Maybe<OveruseGroup>;
  /** update multiples rows of table: "overuse_group" */
  update_overuse_group_many?: Maybe<Array<Maybe<OveruseGroupMutationResponse>>>;
  /** update data of the table: "overuse_group_member" */
  update_overuse_group_member?: Maybe<OveruseGroupMemberMutationResponse>;
  /** update single row of the table: "overuse_group_member" */
  update_overuse_group_member_by_pk?: Maybe<OveruseGroupMember>;
  /** update multiples rows of table: "overuse_group_member" */
  update_overuse_group_member_many?: Maybe<Array<Maybe<OveruseGroupMemberMutationResponse>>>;
  /** update data of the table: "parkdepot_product" */
  update_parkdepot_product?: Maybe<ParkdepotProductMutationResponse>;
  /** update single row of the table: "parkdepot_product" */
  update_parkdepot_product_by_pk?: Maybe<ParkdepotProduct>;
  /** update multiples rows of table: "parkdepot_product" */
  update_parkdepot_product_many?: Maybe<Array<Maybe<ParkdepotProductMutationResponse>>>;
  /** update data of the table: "parking_context" */
  update_parking_context?: Maybe<ParkingContextMutationResponse>;
  /** update single row of the table: "parking_context" */
  update_parking_context_by_pk?: Maybe<ParkingContext>;
  /** update multiples rows of table: "parking_context" */
  update_parking_context_many?: Maybe<Array<Maybe<ParkingContextMutationResponse>>>;
  /** update data of the table: "parking_detections" */
  update_parking_detections?: Maybe<ParkingDetectionsMutationResponse>;
  /** update data of the table: "parking_detections_archive" */
  update_parking_detections_archive?: Maybe<ParkingDetectionsArchiveMutationResponse>;
  /** update single row of the table: "parking_detections_archive" */
  update_parking_detections_archive_by_pk?: Maybe<ParkingDetectionsArchive>;
  /** update multiples rows of table: "parking_detections_archive" */
  update_parking_detections_archive_many?: Maybe<Array<Maybe<ParkingDetectionsArchiveMutationResponse>>>;
  /** update single row of the table: "parking_detections" */
  update_parking_detections_by_pk?: Maybe<ParkingDetections>;
  /** update multiples rows of table: "parking_detections" */
  update_parking_detections_many?: Maybe<Array<Maybe<ParkingDetectionsMutationResponse>>>;
  /** update data of the table: "parking_incoming" */
  update_parking_incoming?: Maybe<ParkingIncomingMutationResponse>;
  /** update single row of the table: "parking_incoming" */
  update_parking_incoming_by_pk?: Maybe<ParkingIncoming>;
  /** update multiples rows of table: "parking_incoming" */
  update_parking_incoming_many?: Maybe<Array<Maybe<ParkingIncomingMutationResponse>>>;
  /** update data of the table: "parking_processing" */
  update_parking_processing?: Maybe<ParkingProcessingMutationResponse>;
  /** update single row of the table: "parking_processing" */
  update_parking_processing_by_pk?: Maybe<ParkingProcessing>;
  /** update multiples rows of table: "parking_processing" */
  update_parking_processing_many?: Maybe<Array<Maybe<ParkingProcessingMutationResponse>>>;
  /** update data of the table: "parking_results" */
  update_parking_results?: Maybe<ParkingResultsMutationResponse>;
  /** update data of the table: "parking_results_archive" */
  update_parking_results_archive?: Maybe<ParkingResultsArchiveMutationResponse>;
  /** update single row of the table: "parking_results_archive" */
  update_parking_results_archive_by_pk?: Maybe<ParkingResultsArchive>;
  /** update multiples rows of table: "parking_results_archive" */
  update_parking_results_archive_many?: Maybe<Array<Maybe<ParkingResultsArchiveMutationResponse>>>;
  /** update single row of the table: "parking_results" */
  update_parking_results_by_pk?: Maybe<ParkingResults>;
  /** update multiples rows of table: "parking_results" */
  update_parking_results_many?: Maybe<Array<Maybe<ParkingResultsMutationResponse>>>;
  /** update data of the table: "parking_temp" */
  update_parking_temp?: Maybe<ParkingTempMutationResponse>;
  /** update single row of the table: "parking_temp" */
  update_parking_temp_by_pk?: Maybe<ParkingTemp>;
  /** update multiples rows of table: "parking_temp" */
  update_parking_temp_many?: Maybe<Array<Maybe<ParkingTempMutationResponse>>>;
  /** update data of the table: "paybyphone_lot" */
  update_paybyphone_lot?: Maybe<PaybyphoneLotMutationResponse>;
  /** update single row of the table: "paybyphone_lot" */
  update_paybyphone_lot_by_pk?: Maybe<PaybyphoneLot>;
  /** update multiples rows of table: "paybyphone_lot" */
  update_paybyphone_lot_many?: Maybe<Array<Maybe<PaybyphoneLotMutationResponse>>>;
  /** update data of the table: "paybyphone_order" */
  update_paybyphone_order?: Maybe<PaybyphoneOrderMutationResponse>;
  /** update single row of the table: "paybyphone_order" */
  update_paybyphone_order_by_pk?: Maybe<PaybyphoneOrder>;
  /** update multiples rows of table: "paybyphone_order" */
  update_paybyphone_order_many?: Maybe<Array<Maybe<PaybyphoneOrderMutationResponse>>>;
  /** update data of the table: "person" */
  update_person?: Maybe<PersonMutationResponse>;
  /** update single row of the table: "person" */
  update_person_by_pk?: Maybe<Person>;
  /** update multiples rows of table: "person" */
  update_person_many?: Maybe<Array<Maybe<PersonMutationResponse>>>;
  /** update data of the table: "policy_schedule" */
  update_policy_schedule?: Maybe<PolicyScheduleMutationResponse>;
  /** update single row of the table: "policy_schedule" */
  update_policy_schedule_by_pk?: Maybe<PolicySchedule>;
  /** update multiples rows of table: "policy_schedule" */
  update_policy_schedule_many?: Maybe<Array<Maybe<PolicyScheduleMutationResponse>>>;
  /** update data of the table: "regional_codes_austria" */
  update_regional_codes_austria?: Maybe<RegionalCodesAustriaMutationResponse>;
  /** update single row of the table: "regional_codes_austria" */
  update_regional_codes_austria_by_pk?: Maybe<RegionalCodesAustria>;
  /** update multiples rows of table: "regional_codes_austria" */
  update_regional_codes_austria_many?: Maybe<Array<Maybe<RegionalCodesAustriaMutationResponse>>>;
  /** update data of the table: "rental_pricing" */
  update_rental_pricing?: Maybe<RentalPricingMutationResponse>;
  /** update single row of the table: "rental_pricing" */
  update_rental_pricing_by_pk?: Maybe<RentalPricing>;
  /** update multiples rows of table: "rental_pricing" */
  update_rental_pricing_many?: Maybe<Array<Maybe<RentalPricingMutationResponse>>>;
  /** update data of the table: "rental_subscription" */
  update_rental_subscription?: Maybe<RentalSubscriptionMutationResponse>;
  /** update single row of the table: "rental_subscription" */
  update_rental_subscription_by_pk?: Maybe<RentalSubscription>;
  /** update multiples rows of table: "rental_subscription" */
  update_rental_subscription_many?: Maybe<Array<Maybe<RentalSubscriptionMutationResponse>>>;
  /** update data of the table: "serverless_async_work" */
  update_serverless_async_work?: Maybe<ServerlessAsyncWorkMutationResponse>;
  /** update single row of the table: "serverless_async_work" */
  update_serverless_async_work_by_pk?: Maybe<ServerlessAsyncWork>;
  /** update multiples rows of table: "serverless_async_work" */
  update_serverless_async_work_many?: Maybe<Array<Maybe<ServerlessAsyncWorkMutationResponse>>>;
  /** update data of the table: "similar_detections" */
  update_similar_detections?: Maybe<SimilarDetectionsMutationResponse>;
  /** update single row of the table: "similar_detections" */
  update_similar_detections_by_pk?: Maybe<SimilarDetections>;
  /** update multiples rows of table: "similar_detections" */
  update_similar_detections_many?: Maybe<Array<Maybe<SimilarDetectionsMutationResponse>>>;
  /** update data of the table: "stages" */
  update_stages?: Maybe<StagesMutationResponse>;
  /** update single row of the table: "stages" */
  update_stages_by_pk?: Maybe<Stages>;
  /** update multiples rows of table: "stages" */
  update_stages_many?: Maybe<Array<Maybe<StagesMutationResponse>>>;
  /** update data of the table: "station" */
  update_station?: Maybe<StationMutationResponse>;
  /** update single row of the table: "station" */
  update_station_by_pk?: Maybe<Station>;
  update_station_config_mutation?: Maybe<UpdateStationOutput>;
  update_station_data_mutation?: Maybe<UpdateDeviceOutput>;
  /** update multiples rows of table: "station" */
  update_station_many?: Maybe<Array<Maybe<StationMutationResponse>>>;
  /** update data of the table: "supervision_car_rental_partners" */
  update_supervision_car_rental_partners?: Maybe<SupervisionCarRentalPartnersMutationResponse>;
  /** update single row of the table: "supervision_car_rental_partners" */
  update_supervision_car_rental_partners_by_pk?: Maybe<SupervisionCarRentalPartners>;
  /** update multiples rows of table: "supervision_car_rental_partners" */
  update_supervision_car_rental_partners_many?: Maybe<Array<Maybe<SupervisionCarRentalPartnersMutationResponse>>>;
  /** update data of the table: "supervision_debt_collection_case" */
  update_supervision_debt_collection_case?: Maybe<SupervisionDebtCollectionCaseMutationResponse>;
  /** update single row of the table: "supervision_debt_collection_case" */
  update_supervision_debt_collection_case_by_pk?: Maybe<SupervisionDebtCollectionCase>;
  /** update multiples rows of table: "supervision_debt_collection_case" */
  update_supervision_debt_collection_case_many?: Maybe<Array<Maybe<SupervisionDebtCollectionCaseMutationResponse>>>;
  /** update data of the table: "supervision_image_requests" */
  update_supervision_image_requests?: Maybe<SupervisionImageRequestsMutationResponse>;
  /** update single row of the table: "supervision_image_requests" */
  update_supervision_image_requests_by_pk?: Maybe<SupervisionImageRequests>;
  /** update multiples rows of table: "supervision_image_requests" */
  update_supervision_image_requests_many?: Maybe<Array<Maybe<SupervisionImageRequestsMutationResponse>>>;
  /** update data of the table: "supervision_mlp_requests" */
  update_supervision_mlp_requests?: Maybe<SupervisionMlpRequestsMutationResponse>;
  /** update single row of the table: "supervision_mlp_requests" */
  update_supervision_mlp_requests_by_pk?: Maybe<SupervisionMlpRequests>;
  /** update multiples rows of table: "supervision_mlp_requests" */
  update_supervision_mlp_requests_many?: Maybe<Array<Maybe<SupervisionMlpRequestsMutationResponse>>>;
  /** update data of the table: "supervision_multivisit_offender_group" */
  update_supervision_multivisit_offender_group?: Maybe<SupervisionMultivisitOffenderGroupMutationResponse>;
  /** update single row of the table: "supervision_multivisit_offender_group" */
  update_supervision_multivisit_offender_group_by_pk?: Maybe<SupervisionMultivisitOffenderGroup>;
  /** update multiples rows of table: "supervision_multivisit_offender_group" */
  update_supervision_multivisit_offender_group_many?: Maybe<Array<Maybe<SupervisionMultivisitOffenderGroupMutationResponse>>>;
  /** update data of the table: "supervision_multivisit_offender_group_member" */
  update_supervision_multivisit_offender_group_member?: Maybe<SupervisionMultivisitOffenderGroupMemberMutationResponse>;
  /** update single row of the table: "supervision_multivisit_offender_group_member" */
  update_supervision_multivisit_offender_group_member_by_pk?: Maybe<SupervisionMultivisitOffenderGroupMember>;
  /** update multiples rows of table: "supervision_multivisit_offender_group_member" */
  update_supervision_multivisit_offender_group_member_many?: Maybe<Array<Maybe<SupervisionMultivisitOffenderGroupMemberMutationResponse>>>;
  /** update data of the table: "supervision_ticket_request" */
  update_supervision_ticket_request?: Maybe<SupervisionTicketRequestMutationResponse>;
  /** update single row of the table: "supervision_ticket_request" */
  update_supervision_ticket_request_by_pk?: Maybe<SupervisionTicketRequest>;
  /** update multiples rows of table: "supervision_ticket_request" */
  update_supervision_ticket_request_many?: Maybe<Array<Maybe<SupervisionTicketRequestMutationResponse>>>;
  /** update data of the table: "supervision_violation_case_debt_collection_case" */
  update_supervision_violation_case_debt_collection_case?: Maybe<SupervisionViolationCaseDebtCollectionCaseMutationResponse>;
  /** update single row of the table: "supervision_violation_case_debt_collection_case" */
  update_supervision_violation_case_debt_collection_case_by_pk?: Maybe<SupervisionViolationCaseDebtCollectionCase>;
  /** update multiples rows of table: "supervision_violation_case_debt_collection_case" */
  update_supervision_violation_case_debt_collection_case_many?: Maybe<Array<Maybe<SupervisionViolationCaseDebtCollectionCaseMutationResponse>>>;
  /** update data of the table: "tax" */
  update_tax?: Maybe<TaxMutationResponse>;
  /** update single row of the table: "tax" */
  update_tax_by_pk?: Maybe<Tax>;
  /** update multiples rows of table: "tax" */
  update_tax_many?: Maybe<Array<Maybe<TaxMutationResponse>>>;
  /** update data of the table: "terminal_status" */
  update_terminal_status?: Maybe<TerminalStatusMutationResponse>;
  /** update single row of the table: "terminal_status" */
  update_terminal_status_by_pk?: Maybe<TerminalStatus>;
  /** update multiples rows of table: "terminal_status" */
  update_terminal_status_many?: Maybe<Array<Maybe<TerminalStatusMutationResponse>>>;
  /** update data of the table: "ticket_website_feedback" */
  update_ticket_website_feedback?: Maybe<TicketWebsiteFeedbackMutationResponse>;
  /** update single row of the table: "ticket_website_feedback" */
  update_ticket_website_feedback_by_pk?: Maybe<TicketWebsiteFeedback>;
  /** update multiples rows of table: "ticket_website_feedback" */
  update_ticket_website_feedback_many?: Maybe<Array<Maybe<TicketWebsiteFeedbackMutationResponse>>>;
  /** update data of the table: "time_discount" */
  update_time_discount?: Maybe<TimeDiscountMutationResponse>;
  /** update single row of the table: "time_discount" */
  update_time_discount_by_pk?: Maybe<TimeDiscount>;
  /** update multiples rows of table: "time_discount" */
  update_time_discount_many?: Maybe<Array<Maybe<TimeDiscountMutationResponse>>>;
  update_user_license_plate?: Maybe<UpdateUserLicensePlateResponse>;
  /** update data of the table: "user_preference" */
  update_user_preference?: Maybe<UserPreferenceMutationResponse>;
  /** update single row of the table: "user_preference" */
  update_user_preference_by_pk?: Maybe<UserPreference>;
  /** update multiples rows of table: "user_preference" */
  update_user_preference_many?: Maybe<Array<Maybe<UserPreferenceMutationResponse>>>;
  update_user_vehicle?: Maybe<UpdateUserVehicleResponse>;
  /** update data of the table: "vehicle_type" */
  update_vehicle_type?: Maybe<VehicleTypeMutationResponse>;
  /** update single row of the table: "vehicle_type" */
  update_vehicle_type_by_pk?: Maybe<VehicleType>;
  /** update data of the table: "vehicle_type_config_group" */
  update_vehicle_type_config_group?: Maybe<VehicleTypeConfigGroupMutationResponse>;
  /** update single row of the table: "vehicle_type_config_group" */
  update_vehicle_type_config_group_by_pk?: Maybe<VehicleTypeConfigGroup>;
  /** update multiples rows of table: "vehicle_type_config_group" */
  update_vehicle_type_config_group_many?: Maybe<Array<Maybe<VehicleTypeConfigGroupMutationResponse>>>;
  /** update multiples rows of table: "vehicle_type" */
  update_vehicle_type_many?: Maybe<Array<Maybe<VehicleTypeMutationResponse>>>;
  /** update data of the table: "violation_case" */
  update_violation_case?: Maybe<ViolationCaseMutationResponse>;
  /** update single row of the table: "violation_case" */
  update_violation_case_by_pk?: Maybe<ViolationCase>;
  /** update data of the table: "violation_case_charges" */
  update_violation_case_charges?: Maybe<ViolationCaseChargesMutationResponse>;
  /** update single row of the table: "violation_case_charges" */
  update_violation_case_charges_by_pk?: Maybe<ViolationCaseCharges>;
  /** update multiples rows of table: "violation_case_charges" */
  update_violation_case_charges_many?: Maybe<Array<Maybe<ViolationCaseChargesMutationResponse>>>;
  /** update multiples rows of table: "violation_case" */
  update_violation_case_many?: Maybe<Array<Maybe<ViolationCaseMutationResponse>>>;
  /** update data of the table: "violation_case_tags" */
  update_violation_case_tags?: Maybe<ViolationCaseTagsMutationResponse>;
  /** update single row of the table: "violation_case_tags" */
  update_violation_case_tags_by_pk?: Maybe<ViolationCaseTags>;
  /** update multiples rows of table: "violation_case_tags" */
  update_violation_case_tags_many?: Maybe<Array<Maybe<ViolationCaseTagsMutationResponse>>>;
  /** update data of the table: "violation_event_analysis" */
  update_violation_event_analysis?: Maybe<ViolationEventAnalysisMutationResponse>;
  /** update single row of the table: "violation_event_analysis" */
  update_violation_event_analysis_by_pk?: Maybe<ViolationEventAnalysis>;
  /** update multiples rows of table: "violation_event_analysis" */
  update_violation_event_analysis_many?: Maybe<Array<Maybe<ViolationEventAnalysisMutationResponse>>>;
  update_violation_transaction?: Maybe<UpdateViolationTransactionOutput>;
  update_violator_image?: Maybe<UpdateViolatorImageOutput>;
  /** update data of the table: "violator_transactions" */
  update_violator_transactions?: Maybe<ViolatorTransactionsMutationResponse>;
  /** update single row of the table: "violator_transactions" */
  update_violator_transactions_by_pk?: Maybe<ViolatorTransactions>;
  /** update multiples rows of table: "violator_transactions" */
  update_violator_transactions_many?: Maybe<Array<Maybe<ViolatorTransactionsMutationResponse>>>;
  /** update data of the table: "whitelist" */
  update_whitelist?: Maybe<WhitelistMutationResponse>;
  /** update data of the table: "whitelist_applied_permit" */
  update_whitelist_applied_permit?: Maybe<WhitelistAppliedPermitMutationResponse>;
  /** update single row of the table: "whitelist_applied_permit" */
  update_whitelist_applied_permit_by_pk?: Maybe<WhitelistAppliedPermit>;
  /** update multiples rows of table: "whitelist_applied_permit" */
  update_whitelist_applied_permit_many?: Maybe<Array<Maybe<WhitelistAppliedPermitMutationResponse>>>;
  /** update single row of the table: "whitelist" */
  update_whitelist_by_pk?: Maybe<Whitelist>;
  /** update data of the table: "whitelist_calendar_event_policy" */
  update_whitelist_calendar_event_policy?: Maybe<WhitelistCalendarEventPolicyMutationResponse>;
  /** update single row of the table: "whitelist_calendar_event_policy" */
  update_whitelist_calendar_event_policy_by_pk?: Maybe<WhitelistCalendarEventPolicy>;
  /** update multiples rows of table: "whitelist_calendar_event_policy" */
  update_whitelist_calendar_event_policy_many?: Maybe<Array<Maybe<WhitelistCalendarEventPolicyMutationResponse>>>;
  /** update data of the table: "whitelist_lp_contingent" */
  update_whitelist_lp_contingent?: Maybe<WhitelistLpContingentMutationResponse>;
  /** update single row of the table: "whitelist_lp_contingent" */
  update_whitelist_lp_contingent_by_pk?: Maybe<WhitelistLpContingent>;
  /** update multiples rows of table: "whitelist_lp_contingent" */
  update_whitelist_lp_contingent_many?: Maybe<Array<Maybe<WhitelistLpContingentMutationResponse>>>;
  /** update multiples rows of table: "whitelist" */
  update_whitelist_many?: Maybe<Array<Maybe<WhitelistMutationResponse>>>;
  /** update data of the table: "whitelist_paid_parking" */
  update_whitelist_paid_parking?: Maybe<WhitelistPaidParkingMutationResponse>;
  /** update single row of the table: "whitelist_paid_parking" */
  update_whitelist_paid_parking_by_pk?: Maybe<WhitelistPaidParking>;
  /** update multiples rows of table: "whitelist_paid_parking" */
  update_whitelist_paid_parking_many?: Maybe<Array<Maybe<WhitelistPaidParkingMutationResponse>>>;
  /** update data of the table: "whitelist_subscription" */
  update_whitelist_subscription?: Maybe<WhitelistSubscriptionMutationResponse>;
  /** update single row of the table: "whitelist_subscription" */
  update_whitelist_subscription_by_pk?: Maybe<WhitelistSubscription>;
  /** update multiples rows of table: "whitelist_subscription" */
  update_whitelist_subscription_many?: Maybe<Array<Maybe<WhitelistSubscriptionMutationResponse>>>;
  /** update data of the table: "wireguard_config" */
  update_wireguard_config?: Maybe<WireguardConfigMutationResponse>;
  /** update single row of the table: "wireguard_config" */
  update_wireguard_config_by_pk?: Maybe<WireguardConfig>;
  /** update multiples rows of table: "wireguard_config" */
  update_wireguard_config_many?: Maybe<Array<Maybe<WireguardConfigMutationResponse>>>;
  upload_violator_image?: Maybe<UploadViolatorImageOutput>;
  validate_personal_information?: Maybe<ValidatePersonalInformationOutput>;
  vio_transactions_preprocessing?: Maybe<VioTransactionsPreprocessingOutput>;
  whitelist_preprocessing?: Maybe<WhitelistPreprocessingOutput>;
  write_off_violation_case_api?: Maybe<WriteOffViolationCaseApiOutput>;
};


/** mutation root */
export type MutationRootAddUsersToPpmArgs = {
  arg: UploadUsersToPpmRequest;
};


/** mutation root */
export type MutationRootB2cApplyDiscountArgs = {
  code: Scalars['String'];
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootB2cDeletePaymentMethodArgs = {
  payment_method_id: Scalars['String'];
};


/** mutation root */
export type MutationRootB2cSavePaymentMethodArgs = {
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  top_level_domain: Scalars['String'];
};


/** mutation root */
export type MutationRootBookingCancelUserSubscriptionArgs = {
  reason?: InputMaybe<Scalars['String']>;
  subscription_id: Scalars['String'];
};


/** mutation root */
export type MutationRootBookingCreateBookingArgs = {
  email: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate>>;
  shopper_locale: Scalars['String'];
  start_datetime: Scalars['timestamptz'];
  total_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootBookingCreateBookingHourlyArgs = {
  duration_hours: Scalars['Int'];
  email: Scalars['String'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate>>;
  shopper_locale: Scalars['String'];
  total_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootBookingCreateLotConfigurationArgs = {
  adyen_merchant_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  display_name?: InputMaybe<Scalars['String']>;
  earliest_booking_date?: InputMaybe<Scalars['String']>;
  end_of_live_date?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<BookingFeatureInput>>>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  lot_capacity?: InputMaybe<Scalars['Int']>;
  lot_id: Scalars['String'];
  max_booking_duration?: InputMaybe<Scalars['String']>;
  min_booking_duration?: InputMaybe<Scalars['String']>;
  night_lot_capacity?: InputMaybe<Scalars['Int']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  pricing?: InputMaybe<Array<InputMaybe<BookingPriceInput>>>;
};


/** mutation root */
export type MutationRootBookingCreateSubsSessionArgs = {
  license_plate_id?: InputMaybe<Scalars['String']>;
  lot_id: Scalars['String'];
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  start_date: Scalars['String'];
  top_level_domain?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootBookingCreateUserArgs = {
  request: CreateBookingUserRequest;
};


/** mutation root */
export type MutationRootBookingCreateUserBookingArgs = {
  email: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate>>;
  pricing_type: BookingPricingModelType;
  shopper_locale: Scalars['String'];
  start_datetime: Scalars['timestamptz'];
  total_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootBookingCreateUserBookingHourlyArgs = {
  duration_hours: Scalars['Int'];
  email: Scalars['String'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate>>;
  pricing_type: BookingPricingModelType;
  shopper_locale: Scalars['String'];
  total_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootBookingUpdateLotConfigurationArgs = {
  adyen_merchant_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  display_name?: InputMaybe<Scalars['String']>;
  earliest_booking_date?: InputMaybe<Scalars['String']>;
  end_of_live_date?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<BookingFeatureInput>>>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  lot_capacity?: InputMaybe<Scalars['Int']>;
  lot_id: Scalars['String'];
  max_booking_duration?: InputMaybe<Scalars['String']>;
  min_booking_duration?: InputMaybe<Scalars['String']>;
  night_lot_capacity?: InputMaybe<Scalars['Int']>;
  opening_hours?: InputMaybe<Scalars['jsonb']>;
  pricing?: InputMaybe<Array<InputMaybe<BookingPriceInput>>>;
};


/** mutation root */
export type MutationRootBookingUpdateUserArgs = {
  request: UpdateBookingUserRequest;
};


/** mutation root */
export type MutationRootCancelReimbursementRequestArgs = {
  transaction_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootCancelViolationCaseApiArgs = {
  cancellation_issuer: Scalars['String'];
  cancellation_mode: Scalars['String'];
  cancellation_reason: Scalars['String'];
  case_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  true_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** mutation root */
export type MutationRootCancelViolationsByCaseIdsArgs = {
  cancellation_comment?: InputMaybe<Scalars['String']>;
  cancellation_issuers?: InputMaybe<Array<Scalars['String']>>;
  cancellation_reason: Scalars['String'];
  case_ids: Array<Scalars['String']>;
  language: Scalars['String'];
  lokalised_cancellation_reason?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootCancelViolationsByPlateArgs = {
  cancellation_comment?: InputMaybe<Scalars['String']>;
  cancellation_issuers?: InputMaybe<Array<Scalars['String']>>;
  cancellation_reason: Scalars['String'];
  country: Scalars['String'];
  language: Scalars['String'];
  lokalised_cancellation_reason?: InputMaybe<Scalars['String']>;
  lot_ids: Array<Scalars['String']>;
  plate: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayApplyDiscountCodeArgs = {
  code: Scalars['String'];
  expected_parking_time_end?: InputMaybe<Scalars['String']>;
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootCarpayCancelOrderInternalDashboardArgs = {
  order_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayCreateTerminalNotificationArgs = {
  data: Scalars['jsonb'];
  event_type: TerminalNotificationEventType;
  lot_id: Scalars['String'];
  terminal_id: Scalars['Int'];
  timestamp_in_lot_tz: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootCarpayDiscountBatchInternalDashboardCreateArgs = {
  count: Scalars['Int'];
  discount_model_id: Scalars['Int'];
  domain: Scalars['String'];
  expiration_date?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['jsonb']>;
};


/** mutation root */
export type MutationRootCarpayDiscountBatchInternalDashboardDeleteArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootCarpayDiscountBatchInternalDashboardUpdateArgs = {
  count?: InputMaybe<Scalars['Int']>;
  expiration_date?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  value?: InputMaybe<Scalars['jsonb']>;
};


/** mutation root */
export type MutationRootCarpayDiscountModelInternalDashboardCreateArgs = {
  code_type: Scalars['String'];
  company_id?: InputMaybe<Scalars['String']>;
  extractor_variables?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  validator_variables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};


/** mutation root */
export type MutationRootCarpayDiscountModelInternalDashboardDeleteArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootCarpayDiscountModelInternalDashboardUpdateArgs = {
  company_id?: InputMaybe<Scalars['String']>;
  extractor_variables?: InputMaybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  lot_id?: InputMaybe<Scalars['String']>;
  validator_variables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};


/** mutation root */
export type MutationRootCarpayEasyparkInternalDashboardCreateArgs = {
  area_no: Scalars['Int'];
  lot_id: Scalars['String'];
  parking_operator_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootCarpayEasyparkInternalDashboardUpdateArgs = {
  area_no?: InputMaybe<Scalars['Int']>;
  lot_id: Scalars['String'];
  parking_operator_id?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type MutationRootCarpayLicenseOrderInternalDashboardArgs = {
  order_ids: Array<Scalars['String']>;
};


/** mutation root */
export type MutationRootCarpayLotActionCreateScheduleArgs = {
  payload: CarpayLotActionCreateSchedulePayload;
  scheduler_timestamp: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayLotCreateArgs = {
  lot_id: Scalars['String'];
  policy: CarpayLotCreatePolicyRequest;
};


/** mutation root */
export type MutationRootCarpayLotUpdateArgs = {
  lot_id: Scalars['String'];
  policy: CarpayLotUpdatePolicyRequest;
};


/** mutation root */
export type MutationRootCarpayNotificationConfigInternalDashboardCreateArgs = {
  fill_level_thresholds: Array<Scalars['Float']>;
  lot_id: Scalars['String'];
  max_cash: Scalars['Int'];
};


/** mutation root */
export type MutationRootCarpayNotificationConfigInternalDashboardDeleteArgs = {
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayNotificationConfigInternalDashboardUpdateArgs = {
  fill_level_thresholds?: InputMaybe<Array<Scalars['Float']>>;
  lot_id: Scalars['String'];
  max_cash?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type MutationRootCarpayPaybyphoneInternalDashboardCreateArgs = {
  lot_id: Scalars['String'];
  paybyphone_lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayPaybyphoneInternalDashboardUpdateArgs = {
  lot_id: Scalars['String'];
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootCarpaySubscriptionInternalDashboardDeleteArgs = {
  category?: InputMaybe<CarpaySubscriptionCategories>;
  email: Scalars['String'];
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpaySubscriptionInternalDashboardUpdateArgs = {
  categories: Array<CarpaySubscriptionCategories>;
  email: Scalars['String'];
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCarpayTerminalConfirmOrderArgs = {
  carpay_scanned_codes: Array<TerminalScannedCode>;
  country: Scalars['String'];
  currency: Scalars['String'];
  end_date: Scalars['String'];
  errorflow: Scalars['Boolean'];
  invoice_id: Scalars['String'];
  lot_id: Scalars['String'];
  order_id: Scalars['String'];
  original_price: Scalars['Float'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  payment: TerminalPayment;
  plate: Scalars['String'];
  price: Scalars['Float'];
  price_valid_from?: InputMaybe<Scalars['String']>;
  price_valid_until: Scalars['String'];
  start_date: Scalars['String'];
  terminal_id: Scalars['Int'];
  vat_rate: Scalars['Float'];
};


/** mutation root */
export type MutationRootCarpayTerminalConfirmOrderV2Args = {
  carpay_scanned_codes: Array<TerminalScannedCodeV2>;
  country: Scalars['String'];
  currency: Scalars['String'];
  end_date: Scalars['String'];
  errorflow: Scalars['Boolean'];
  invoice_id: Scalars['String'];
  lot_id: Scalars['String'];
  order_id: Scalars['String'];
  original_price: Scalars['Float'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  payment: TerminalPayment;
  plate: Scalars['String'];
  price: Scalars['Float'];
  price_valid_from?: InputMaybe<Scalars['String']>;
  price_valid_until: Scalars['String'];
  start_date: Scalars['String'];
  terminal_id: Scalars['Int'];
  vat_rate: Scalars['Float'];
};


/** mutation root */
export type MutationRootCarpayUpdateServiceProviderArgs = {
  lot_id: Scalars['String'];
  service_provider: Array<ServiceProviderInput>;
};


/** mutation root */
export type MutationRootChangeLicensePlateArgs = {
  _set: ChangeLicensePlateData;
  parking_results_id: Scalars['String'];
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};


/** mutation root */
export type MutationRootChangeTransactionStatusArgs = {
  new_status: Scalars['String'];
  transaction_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootCleanCompanyDataArgs = {
  city: Scalars['String'];
  company_name: Scalars['String'];
  house_number: Scalars['String'];
  postal_code: Scalars['String'];
  street: Scalars['String'];
};


/** mutation root */
export type MutationRootCleanPersonDataArgs = {
  city: Scalars['String'];
  first_name: Scalars['String'];
  house_number: Scalars['String'];
  last_name: Scalars['String'];
  postal_code: Scalars['String'];
  street: Scalars['String'];
};


/** mutation root */
export type MutationRootCompanyAddressesPreprocessingArgs = {
  addresses: Array<InputMaybe<Scalars['json']>>;
};


/** mutation root */
export type MutationRootCreateDriverInformationRequestArgs = {
  company_group: Scalars['String'];
};


/** mutation root */
export type MutationRootCreateLegalEntityArgs = {
  company_id: Scalars['String'];
  lot_id: Scalars['String'];
  product: Scalars['String'];
  vat_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCreateLpGroupPermitArgs = {
  lp_group_members: Array<InsertLpGroupMember>;
  lp_group_permit_config: LicensePlateGroupPermitConfig;
};


/** mutation root */
export type MutationRootCreateNightParkingBookingArgs = {
  email: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  night_parking_config: Array<InputMaybe<NightParkingConfig>>;
  plates?: InputMaybe<Array<InputBookingPlate>>;
  shopper_locale: Scalars['String'];
  start_datetime: Scalars['timestamptz'];
  total_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootCreateOwnerInformationRequestArgs = {
  request_options?: InputMaybe<Array<Scalars['String']>>;
  request_type: Scalars['String'];
};


/** mutation root */
export type MutationRootCreateParkingResultArgs = {
  category: Scalars['String'];
  country: Scalars['String'];
  device_id_in: Scalars['Int'];
  device_id_out: Scalars['Int'];
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootCreateReimbursementRequestArgs = {
  transaction_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootCreateUserLicensePlateArgs = {
  request: CreateUserLicensePlateRequest;
};


/** mutation root */
export type MutationRootCreateUserVehicleArgs = {
  request: CreateUserVehicleRequest;
};


/** mutation root */
export type MutationRootCustomerDeleteLpGroupsArgs = {
  lp_group_ids?: InputMaybe<Array<Scalars['Int']>>;
  lp_group_member_ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** mutation root */
export type MutationRootCustomerUpdateLpGroupPermitArgs = {
  lp_group_id: Scalars['bigint'];
  lp_group_members?: InputMaybe<Array<UpdateLicensePlateGroupMember>>;
  lp_group_permit_config?: InputMaybe<UpdateLicensePlateGroupPermitConfig>;
};


/** mutation root */
export type MutationRootDeleteAdyenReportArgs = {
  where: AdyenReportBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdyenReportByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAdyenTransactionArgs = {
  where: AdyenTransactionBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdyenTransactionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAppliedPermitArgs = {
  where: AppliedPermitBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteAppliedWhitelistArgs = {
  where: AppliedWhitelistBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppliedWhitelistByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteAuditLoggedActionsArgs = {
  where: AuditLoggedActionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAuditLoggedActionsByPkArgs = {
  event_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteB2bUserArgs = {
  company_id: Scalars['String'];
  new_company_id?: InputMaybe<Scalars['String']>;
  new_user?: InputMaybe<Scalars['String']>;
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBlacklistArgs = {
  where: BlacklistBoolExp;
};


/** mutation root */
export type MutationRootDeleteBlacklistByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteBlacklistEntriesArgs = {
  by_plates?: InputMaybe<Array<DeleteBlacklistEntry>>;
  by_true_ids?: InputMaybe<Array<Scalars['Int']>>;
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationRootDeleteBookingBookingArgs = {
  where: BookingBookingBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingBookingByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBookingBookingInvoiceArgs = {
  where: BookingBookingInvoiceBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingBookingInvoiceByPkArgs = {
  booking_id: Scalars['Int'];
  invoice_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingBookingPlateArgs = {
  where: BookingBookingPlateBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingBookingPlateByPkArgs = {
  booking_id: Scalars['Int'];
  plate: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingBookingTypeArgs = {
  where: BookingBookingTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingBookingTypeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingBookingWhitelistArgs = {
  where: BookingBookingWhitelistBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingBookingWhitelistByPkArgs = {
  booking_id: Scalars['Int'];
  whitelist_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBookingEnumBookingStatusArgs = {
  where: BookingEnumBookingStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingEnumBookingStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingHourlyBookingArgs = {
  where: BookingHourlyBookingBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingHourlyBookingByPkArgs = {
  booking_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBookingLicensePlateArgs = {
  where: BookingLicensePlateBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingLicensePlateByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingLotArgs = {
  where: BookingLotBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingLotByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingLotConfigurationArgs = {
  where: BookingLotConfigurationBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingLotConfigurationByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteBookingPaymentArgs = {
  where: BookingPaymentBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingPaymentByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBookingPricingRulesArgs = {
  where: BookingPricingRulesBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingPricingRulesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBookingPricingTypeArgs = {
  where: BookingPricingTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingPricingTypeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingPrivatePricingUserArgs = {
  where: BookingPrivatePricingUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingPrivatePricingUserByPkArgs = {
  price_model_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingRecurringBookingArgs = {
  where: BookingRecurringBookingBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingRecurringBookingByPkArgs = {
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionBookingArgs = {
  where: BookingSubscriptionBookingBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionLicensePlateArgs = {
  where: BookingSubscriptionLicensePlateBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionLicensePlateByPkArgs = {
  license_plate_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionStatusArgs = {
  where: BookingSubscriptionStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingSubscriptionStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingUserArgs = {
  where: BookingUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingUserBookingArgs = {
  where: BookingUserBookingBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingUserBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingUserByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingUserPaymentMethodArgs = {
  where: BookingUserPaymentMethodBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingUserPaymentMethodByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingUserSubscriptionArgs = {
  where: BookingUserSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingUserSubscriptionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingVehicleArgs = {
  where: BookingVehicleBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingVehicleByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBookingVehicleTypeArgs = {
  where: BookingVehicleTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingVehicleTypeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteBookingWhitelistTypeArgs = {
  where: BookingWhitelistTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteBookingWhitelistTypeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCalendarEventPolicyArgs = {
  where: CalendarEventPolicyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCancellationsArgs = {
  where: CancellationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteCancellationsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarDriverArgs = {
  where: CarDriverBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarDriverByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarOwnerArgs = {
  where: CarOwnerBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarOwnerByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarOwnerRequestsArgs = {
  where: CarOwnerRequestsBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarOwnerRequestsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarpayAccessControlLpPinArgs = {
  where: CarpayAccessControlLpPinBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayAccessControlLpPinByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayDiscountBatchArgs = {
  where: CarpayDiscountBatchBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayDiscountBatchByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayDiscountModelArgs = {
  where: CarpayDiscountModelBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayDiscountModelByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayLotArgs = {
  where: CarpayLotBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayLotByPkArgs = {
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriberArgs = {
  where: CarpayNotificationSubscriberBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriberByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriptionArgs = {
  where: CarpayNotificationSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriptionByPkArgs = {
  category_id: Scalars['Int'];
  lot_id: Scalars['String'];
  subscriber_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriptionCategoryArgs = {
  where: CarpayNotificationSubscriptionCategoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayNotificationSubscriptionCategoryByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayOrderArgs = {
  where: CarpayOrderBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayOrderByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarpayOrderMatchesArgs = {
  where: CarpayOrderMatchesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayOrderMatchesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayOrderUserArgs = {
  where: CarpayOrderUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayOrderUserByPkArgs = {
  order_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayParkingDetectionArgs = {
  where: CarpayParkingDetectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayParkingDetectionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayPricingArgs = {
  where: CarpayPricingBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayPricingByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayPricingConfigGroupArgs = {
  where: CarpayPricingConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayPricingConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarpayPricingPeriodArgs = {
  where: CarpayPricingPeriodBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayPricingPeriodByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayPricingRecurrenceArgs = {
  where: CarpayPricingRecurrenceBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayPricingRecurrenceByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayPricingRulesArgs = {
  where: CarpayPricingRulesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayPricingRulesByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayScannedCodesArgs = {
  where: CarpayScannedCodesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayScannedCodesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalCashCutNotificationArgs = {
  where: CarpayTerminalCashCutNotificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalCashCutNotificationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalCashFillLevelNotificationArgs = {
  where: CarpayTerminalCashFillLevelNotificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalCashFillLevelNotificationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalNotificationConfigArgs = {
  where: CarpayTerminalNotificationConfigBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalNotificationConfigByPkArgs = {
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalPrinterStatusNotificationArgs = {
  where: CarpayTerminalPrinterStatusNotificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayTerminalPrinterStatusNotificationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCarpayUserVerifiedPlateArgs = {
  where: CarpayUserVerifiedPlateBoolExp;
};


/** mutation root */
export type MutationRootDeleteCarpayUserVerifiedPlateByPkArgs = {
  normalized_plate: Scalars['String'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteChainArgs = {
  where: ChainBoolExp;
};


/** mutation root */
export type MutationRootDeleteChainByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCityCodesArgs = {
  where: CityCodesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyArgs = {
  where: CompanyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCompanyConfigGroupArgs = {
  where: CompanyConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCompanyHierarchyArgs = {
  where: CompanyHierarchyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCompanyLotSectionArgs = {
  where: CompanyLotSectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyLotSectionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCompanyVatIdArgs = {
  where: CompanyVatIdBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyVatIdByPkArgs = {
  company_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCompanyViolatorArgs = {
  where: CompanyViolatorBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyViolatorByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteConfigGroupArgs = {
  where: ConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteCountryArgs = {
  where: CountryBoolExp;
};


/** mutation root */
export type MutationRootDeleteCountryByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCurrencyArgs = {
  where: CurrencyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCurrencyByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCustomerDashboardNpsFeedbackArgs = {
  where: CustomerDashboardNpsFeedbackBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomerDashboardNpsFeedbackByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDailyFailureArgs = {
  where: DailyFailureBoolExp;
};


/** mutation root */
export type MutationRootDeleteDailyFailureByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDailyStatsArgs = {
  where: DailyStatsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDailyStatsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDepartmentArgs = {
  where: DepartmentBoolExp;
};


/** mutation root */
export type MutationRootDeleteDepartmentByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteDetectionTypeEnumArgs = {
  where: DetectionTypeEnumBoolExp;
};


/** mutation root */
export type MutationRootDeleteDetectionTypeEnumByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteDeviceArgs = {
  where: DeviceBoolExp;
};


/** mutation root */
export type MutationRootDeleteDeviceByPkArgs = {
  uuid: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEasyparkLotArgs = {
  where: EasyparkLotBoolExp;
};


/** mutation root */
export type MutationRootDeleteEasyparkLotByPkArgs = {
  uuid: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteEasyparkOrderArgs = {
  where: EasyparkOrderBoolExp;
};


/** mutation root */
export type MutationRootDeleteEasyparkOrderByPkArgs = {
  uuid: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteEasyparkOrderV2Args = {
  where: EasyparkOrderV2BoolExp;
};


/** mutation root */
export type MutationRootDeleteEasyparkOrderV2ByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteEasyparkParkingInfoArgs = {
  where: EasyparkParkingInfoBoolExp;
};


/** mutation root */
export type MutationRootDeleteEasyparkParkingInfoByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteEnforcementDailyStatsArgs = {
  where: EnforcementDailyStatsBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnforcementDailyStatsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteEnumCarpayDiscountModelCodeTypeArgs = {
  where: EnumCarpayDiscountModelCodeTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumCarpayDiscountModelCodeTypeByPkArgs = {
  code_type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumCountryCodeArgs = {
  where: EnumCountryCodeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumCountryCodeByPkArgs = {
  country: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumCustomerWhitelistPurposeArgs = {
  where: EnumCustomerWhitelistPurposeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumCustomerWhitelistPurposeByPkArgs = {
  purpose: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumCustomerWhitelistStatusArgs = {
  where: EnumCustomerWhitelistStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumCustomerWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumDeviceTypeArgs = {
  where: EnumDeviceTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumDeviceTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumDriverRequestTypeArgs = {
  where: EnumDriverRequestTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumDriverRequestTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumGuestJwtPurposeArgs = {
  where: EnumGuestJwtPurposeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumGuestJwtPurposeByPkArgs = {
  purpose: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumSupervisionMlpRequestStatusArgs = {
  where: EnumSupervisionMlpRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumSupervisionMlpRequestStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumViolationCancellationArgs = {
  where: EnumViolationCancellationBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumViolationCancellationByPkArgs = {
  violation_cancellation: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumViolationCaseChargesInvalidationReasonArgs = {
  where: EnumViolationCaseChargesInvalidationReasonBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumViolationCaseChargesInvalidationReasonByPkArgs = {
  invalidation_reason: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumViolationCaseChargesTypeArgs = {
  where: EnumViolationCaseChargesTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumViolationCaseChargesTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistPaidParkingTypesArgs = {
  where: EnumWhitelistPaidParkingTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistPaidParkingTypesByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistScopeArgs = {
  where: EnumWhitelistScopeBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistScopeByPkArgs = {
  scope: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistStatusArgs = {
  where: EnumWhitelistStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistTypesArgs = {
  where: EnumWhitelistTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteEnumWhitelistTypesByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGuestJwtArgs = {
  where: GuestJwtBoolExp;
};


/** mutation root */
export type MutationRootDeleteGuestJwtByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteGuestQrArgs = {
  where: GuestQrBoolExp;
};


/** mutation root */
export type MutationRootDeleteGuestQrByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteLotArgs = {
  where: LotBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteLotConfigGroupArgs = {
  where: LotConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLotDisplayNameArgs = {
  where: LotDisplayNameBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotDisplayNameByPkArgs = {
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteLotHierarchyArgs = {
  where: LotHierarchyBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLotLegalEntityArgs = {
  where: LotLegalEntityBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotLegalEntityByPkArgs = {
  lot_id: Scalars['String'];
  product: ParkdepotProductEnum;
};


/** mutation root */
export type MutationRootDeleteLotPolicyHistoryArgs = {
  where: LotPolicyHistoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotPolicyHistoryByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLotSectionArgs = {
  where: LotSectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteLotSectionByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteLpContingentArgs = {
  where: LpContingentBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLpGroupArgs = {
  where: LpGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLpGroupConfigGroupArgs = {
  where: LpGroupConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpGroupConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLpGroupDetailsArgs = {
  where: LpGroupDetailsBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpGroupDetailsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLpGroupMemberArgs = {
  where: LpGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteLpGroupMemberDetailsArgs = {
  where: LpGroupMemberDetailsBoolExp;
};


/** mutation root */
export type MutationRootDeleteLpGroupMemberDetailsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteMailArgs = {
  where: MailBoolExp;
};


/** mutation root */
export type MutationRootDeleteMailByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteMailMiscArgs = {
  where: MailMiscBoolExp;
};


/** mutation root */
export type MutationRootDeleteMailMiscByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteMlpCasesArgs = {
  where: MlpCasesBoolExp;
};


/** mutation root */
export type MutationRootDeleteMlpCasesByPkArgs = {
  parking_results_uuid: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMlpMappingsArgs = {
  where: MlpMappingsBoolExp;
};


/** mutation root */
export type MutationRootDeleteMlpMappingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMqttRequestArgs = {
  where: MqttRequestBoolExp;
};


/** mutation root */
export type MutationRootDeleteMqttRequestByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteOffenceParkingEventsArgs = {
  where: OffenceParkingEventsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOffenceParkingEventsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteOffenceTicketRequestsArgs = {
  where: OffenceTicketRequestsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOffenceTicketRequestsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteOveruseGroupArgs = {
  where: OveruseGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteOveruseGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteOveruseGroupMemberArgs = {
  where: OveruseGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootDeleteOveruseGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteParkdepotProductArgs = {
  where: ParkdepotProductBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkdepotProductByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteParkingContextArgs = {
  where: ParkingContextBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingContextByPkArgs = {
  uuid: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteParkingDetectionsArgs = {
  where: ParkingDetectionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingDetectionsArchiveArgs = {
  where: ParkingDetectionsArchiveBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingDetectionsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootDeleteParkingDetectionsByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootDeleteParkingIncomingArgs = {
  where: ParkingIncomingBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingIncomingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteParkingProcessingArgs = {
  where: ParkingProcessingBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingProcessingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteParkingResultsArgs = {
  where: ParkingResultsBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingResultsArchiveArgs = {
  where: ParkingResultsArchiveBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingResultsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootDeleteParkingResultsByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootDeleteParkingTempArgs = {
  where: ParkingTempBoolExp;
};


/** mutation root */
export type MutationRootDeleteParkingTempByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeletePaybyphoneLotArgs = {
  where: PaybyphoneLotBoolExp;
};


/** mutation root */
export type MutationRootDeletePaybyphoneLotByPkArgs = {
  lot_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeletePaybyphoneOrderArgs = {
  where: PaybyphoneOrderBoolExp;
};


/** mutation root */
export type MutationRootDeletePaybyphoneOrderByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeletePersonArgs = {
  where: PersonBoolExp;
};


/** mutation root */
export type MutationRootDeletePersonByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeletePolicyScheduleArgs = {
  where: PolicyScheduleBoolExp;
};


/** mutation root */
export type MutationRootDeletePolicyScheduleByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteRegionalCodesAustriaArgs = {
  where: RegionalCodesAustriaBoolExp;
};


/** mutation root */
export type MutationRootDeleteRegionalCodesAustriaByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRentalPricingArgs = {
  where: RentalPricingBoolExp;
};


/** mutation root */
export type MutationRootDeleteRentalPricingByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteRentalSubscriptionArgs = {
  where: RentalSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootDeleteRentalSubscriptionByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteServerlessAsyncWorkArgs = {
  where: ServerlessAsyncWorkBoolExp;
};


/** mutation root */
export type MutationRootDeleteServerlessAsyncWorkByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteSimilarDetectionsArgs = {
  where: SimilarDetectionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSimilarDetectionsByPkArgs = {
  parking_detections_uuid: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteStagesArgs = {
  where: StagesBoolExp;
};


/** mutation root */
export type MutationRootDeleteStagesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteStationArgs = {
  where: StationBoolExp;
};


/** mutation root */
export type MutationRootDeleteStationByPkArgs = {
  station_name: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteSupervisionCarRentalPartnersArgs = {
  where: SupervisionCarRentalPartnersBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionCarRentalPartnersByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSupervisionDebtCollectionCaseArgs = {
  where: SupervisionDebtCollectionCaseBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionImageRequestsArgs = {
  where: SupervisionImageRequestsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionImageRequestsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionMlpRequestsArgs = {
  where: SupervisionMlpRequestsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionMlpRequestsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionMultivisitOffenderGroupArgs = {
  where: SupervisionMultivisitOffenderGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionMultivisitOffenderGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionMultivisitOffenderGroupMemberArgs = {
  where: SupervisionMultivisitOffenderGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionMultivisitOffenderGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionTicketRequestArgs = {
  where: SupervisionTicketRequestBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionTicketRequestByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSupervisionViolationCaseDebtCollectionCaseArgs = {
  where: SupervisionViolationCaseDebtCollectionCaseBoolExp;
};


/** mutation root */
export type MutationRootDeleteSupervisionViolationCaseDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteTaxArgs = {
  where: TaxBoolExp;
};


/** mutation root */
export type MutationRootDeleteTaxByPkArgs = {
  uuid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTerminalStatusArgs = {
  where: TerminalStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteTerminalStatusByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTicketWebsiteFeedbackArgs = {
  where: TicketWebsiteFeedbackBoolExp;
};


/** mutation root */
export type MutationRootDeleteTicketWebsiteFeedbackByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteTimeDiscountArgs = {
  where: TimeDiscountBoolExp;
};


/** mutation root */
export type MutationRootDeleteTimeDiscountByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteUserLicensePlateArgs = {
  request: DeleteUserLicensePlateRequest;
};


/** mutation root */
export type MutationRootDeleteUserPreferenceArgs = {
  where: UserPreferenceBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserPreferenceByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteUserVehicleArgs = {
  request: DeleteUserVehicleRequest;
};


/** mutation root */
export type MutationRootDeleteVehicleTypeArgs = {
  where: VehicleTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteVehicleTypeByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteVehicleTypeConfigGroupArgs = {
  where: VehicleTypeConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteVehicleTypeConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteViolationCaseArgs = {
  where: ViolationCaseBoolExp;
};


/** mutation root */
export type MutationRootDeleteViolationCaseByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteViolationCaseChargesArgs = {
  where: ViolationCaseChargesBoolExp;
};


/** mutation root */
export type MutationRootDeleteViolationCaseChargesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteViolationCaseTagsArgs = {
  where: ViolationCaseTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteViolationCaseTagsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteViolationEventAnalysisArgs = {
  where: ViolationEventAnalysisBoolExp;
};


/** mutation root */
export type MutationRootDeleteViolationEventAnalysisByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteViolatorTransactionsArgs = {
  where: ViolatorTransactionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteViolatorTransactionsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteWhitelistArgs = {
  where: WhitelistBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistAppliedPermitArgs = {
  where: WhitelistAppliedPermitBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteWhitelistByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteWhitelistCalendarEventPolicyArgs = {
  where: WhitelistCalendarEventPolicyBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteWhitelistEntriesArgs = {
  by_plates?: InputMaybe<Array<DeleteWhitelistEntry>>;
  by_true_ids?: InputMaybe<Array<Scalars['Int']>>;
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationRootDeleteWhitelistLpContingentArgs = {
  where: WhitelistLpContingentBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteWhitelistPaidParkingArgs = {
  where: WhitelistPaidParkingBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistPaidParkingByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteWhitelistSubscriptionArgs = {
  where: WhitelistSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootDeleteWhitelistSubscriptionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteWireguardConfigArgs = {
  where: WireguardConfigBoolExp;
};


/** mutation root */
export type MutationRootDeleteWireguardConfigByPkArgs = {
  public_key: Scalars['String'];
};


/** mutation root */
export type MutationRootGenerateCarpayInvoiceArgs = {
  order_id: Scalars['String'];
};


/** mutation root */
export type MutationRootGenerateGuestJwtArgs = {
  anonymous: Scalars['Boolean'];
  company_id: Scalars['String'];
  email_for_update: Scalars['String'];
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  language: Scalars['String'];
  lot_ids: Array<Scalars['String']>;
  purpose: Scalars['String'];
  scans_per_day?: InputMaybe<Scalars['Int']>;
  send_email?: InputMaybe<Scalars['Boolean']>;
  template: Scalars['String'];
  token_expiration_in_days?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
  validity_rrule_duration?: InputMaybe<Scalars['String']>;
  validity_rrule_string?: InputMaybe<Scalars['String']>;
  whitelist_duration?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootGenerateLetterArgs = {
  letter_type: Scalars['String'];
  violation_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootGenerateSpecialLetterArgs = {
  body?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  violation_case_id?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type MutationRootGenerateViolationCaseArgs = {
  classification: Scalars['String'];
  classification_details?: InputMaybe<Scalars['jsonb']>;
  classified_at?: InputMaybe<Scalars['timestamptz']>;
  classifier?: InputMaybe<Scalars['String']>;
  country_plate?: InputMaybe<Scalars['String']>;
  license_plate?: InputMaybe<Scalars['String']>;
  lot_id: Scalars['String'];
  new_country_plate?: InputMaybe<Scalars['String']>;
  new_license_plate?: InputMaybe<Scalars['String']>;
  parking_result_id: Scalars['String'];
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};


/** mutation root */
export type MutationRootGroupViolationsByViolatorArgs = {
  violation_ids: Array<Scalars['bigint']>;
};


/** mutation root */
export type MutationRootGroupViolationsByViolatorWithConfigArgs = {
  country_stage: Scalars['jsonb'];
  limit: Scalars['Int'];
};


/** mutation root */
export type MutationRootInsertAdyenReportArgs = {
  objects: Array<AdyenReportInsertInput>;
  on_conflict?: InputMaybe<AdyenReportOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdyenReportOneArgs = {
  object: AdyenReportInsertInput;
  on_conflict?: InputMaybe<AdyenReportOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdyenTransactionArgs = {
  objects: Array<AdyenTransactionInsertInput>;
  on_conflict?: InputMaybe<AdyenTransactionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdyenTransactionOneArgs = {
  object: AdyenTransactionInsertInput;
  on_conflict?: InputMaybe<AdyenTransactionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppliedPermitArgs = {
  objects: Array<AppliedPermitInsertInput>;
  on_conflict?: InputMaybe<AppliedPermitOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppliedPermitOneArgs = {
  object: AppliedPermitInsertInput;
  on_conflict?: InputMaybe<AppliedPermitOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppliedWhitelistArgs = {
  objects: Array<AppliedWhitelistInsertInput>;
  on_conflict?: InputMaybe<AppliedWhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppliedWhitelistOneArgs = {
  object: AppliedWhitelistInsertInput;
  on_conflict?: InputMaybe<AppliedWhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuditLoggedActionsArgs = {
  objects: Array<AuditLoggedActionsInsertInput>;
  on_conflict?: InputMaybe<AuditLoggedActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuditLoggedActionsOneArgs = {
  object: AuditLoggedActionsInsertInput;
  on_conflict?: InputMaybe<AuditLoggedActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuth0UserArgs = {
  object?: InputMaybe<InsertUserData>;
};


/** mutation root */
export type MutationRootInsertBlacklistArgs = {
  objects: Array<BlacklistInsertInput>;
  on_conflict?: InputMaybe<BlacklistOnConflict>;
};


/** mutation root */
export type MutationRootInsertBlacklistCustomerArgs = {
  objects: Array<InsertBlacklistInput>;
};


/** mutation root */
export type MutationRootInsertBlacklistOneArgs = {
  object: BlacklistInsertInput;
  on_conflict?: InputMaybe<BlacklistOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingArgs = {
  objects: Array<BookingBookingInsertInput>;
  on_conflict?: InputMaybe<BookingBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingInvoiceArgs = {
  objects: Array<BookingBookingInvoiceInsertInput>;
  on_conflict?: InputMaybe<BookingBookingInvoiceOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingInvoiceOneArgs = {
  object: BookingBookingInvoiceInsertInput;
  on_conflict?: InputMaybe<BookingBookingInvoiceOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingOneArgs = {
  object: BookingBookingInsertInput;
  on_conflict?: InputMaybe<BookingBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingPlateArgs = {
  objects: Array<BookingBookingPlateInsertInput>;
  on_conflict?: InputMaybe<BookingBookingPlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingPlateOneArgs = {
  object: BookingBookingPlateInsertInput;
  on_conflict?: InputMaybe<BookingBookingPlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingTypeArgs = {
  objects: Array<BookingBookingTypeInsertInput>;
  on_conflict?: InputMaybe<BookingBookingTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingTypeOneArgs = {
  object: BookingBookingTypeInsertInput;
  on_conflict?: InputMaybe<BookingBookingTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingWhitelistArgs = {
  objects: Array<BookingBookingWhitelistInsertInput>;
  on_conflict?: InputMaybe<BookingBookingWhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingBookingWhitelistOneArgs = {
  object: BookingBookingWhitelistInsertInput;
  on_conflict?: InputMaybe<BookingBookingWhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingEnumBookingStatusArgs = {
  objects: Array<BookingEnumBookingStatusInsertInput>;
  on_conflict?: InputMaybe<BookingEnumBookingStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingEnumBookingStatusOneArgs = {
  object: BookingEnumBookingStatusInsertInput;
  on_conflict?: InputMaybe<BookingEnumBookingStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingHourlyBookingArgs = {
  objects: Array<BookingHourlyBookingInsertInput>;
  on_conflict?: InputMaybe<BookingHourlyBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingHourlyBookingOneArgs = {
  object: BookingHourlyBookingInsertInput;
  on_conflict?: InputMaybe<BookingHourlyBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLicensePlateArgs = {
  objects: Array<BookingLicensePlateInsertInput>;
  on_conflict?: InputMaybe<BookingLicensePlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLicensePlateOneArgs = {
  object: BookingLicensePlateInsertInput;
  on_conflict?: InputMaybe<BookingLicensePlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLotArgs = {
  objects: Array<BookingLotInsertInput>;
  on_conflict?: InputMaybe<BookingLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLotConfigurationArgs = {
  objects: Array<BookingLotConfigurationInsertInput>;
  on_conflict?: InputMaybe<BookingLotConfigurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLotConfigurationOneArgs = {
  object: BookingLotConfigurationInsertInput;
  on_conflict?: InputMaybe<BookingLotConfigurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingLotOneArgs = {
  object: BookingLotInsertInput;
  on_conflict?: InputMaybe<BookingLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPaymentArgs = {
  objects: Array<BookingPaymentInsertInput>;
  on_conflict?: InputMaybe<BookingPaymentOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPaymentOneArgs = {
  object: BookingPaymentInsertInput;
  on_conflict?: InputMaybe<BookingPaymentOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPricingRulesArgs = {
  objects: Array<BookingPricingRulesInsertInput>;
  on_conflict?: InputMaybe<BookingPricingRulesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPricingRulesOneArgs = {
  object: BookingPricingRulesInsertInput;
  on_conflict?: InputMaybe<BookingPricingRulesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPricingTypeArgs = {
  objects: Array<BookingPricingTypeInsertInput>;
  on_conflict?: InputMaybe<BookingPricingTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPricingTypeOneArgs = {
  object: BookingPricingTypeInsertInput;
  on_conflict?: InputMaybe<BookingPricingTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPrivatePricingUserArgs = {
  objects: Array<BookingPrivatePricingUserInsertInput>;
  on_conflict?: InputMaybe<BookingPrivatePricingUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingPrivatePricingUserOneArgs = {
  object: BookingPrivatePricingUserInsertInput;
  on_conflict?: InputMaybe<BookingPrivatePricingUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingRecurringBookingArgs = {
  objects: Array<BookingRecurringBookingInsertInput>;
  on_conflict?: InputMaybe<BookingRecurringBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingRecurringBookingOneArgs = {
  object: BookingRecurringBookingInsertInput;
  on_conflict?: InputMaybe<BookingRecurringBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionBookingArgs = {
  objects: Array<BookingSubscriptionBookingInsertInput>;
  on_conflict?: InputMaybe<BookingSubscriptionBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionBookingOneArgs = {
  object: BookingSubscriptionBookingInsertInput;
  on_conflict?: InputMaybe<BookingSubscriptionBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionLicensePlateArgs = {
  objects: Array<BookingSubscriptionLicensePlateInsertInput>;
  on_conflict?: InputMaybe<BookingSubscriptionLicensePlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionLicensePlateOneArgs = {
  object: BookingSubscriptionLicensePlateInsertInput;
  on_conflict?: InputMaybe<BookingSubscriptionLicensePlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionStatusArgs = {
  objects: Array<BookingSubscriptionStatusInsertInput>;
  on_conflict?: InputMaybe<BookingSubscriptionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingSubscriptionStatusOneArgs = {
  object: BookingSubscriptionStatusInsertInput;
  on_conflict?: InputMaybe<BookingSubscriptionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserArgs = {
  objects: Array<BookingUserInsertInput>;
  on_conflict?: InputMaybe<BookingUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserBookingArgs = {
  objects: Array<BookingUserBookingInsertInput>;
  on_conflict?: InputMaybe<BookingUserBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserBookingOneArgs = {
  object: BookingUserBookingInsertInput;
  on_conflict?: InputMaybe<BookingUserBookingOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserOneArgs = {
  object: BookingUserInsertInput;
  on_conflict?: InputMaybe<BookingUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserPaymentMethodArgs = {
  objects: Array<BookingUserPaymentMethodInsertInput>;
  on_conflict?: InputMaybe<BookingUserPaymentMethodOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserPaymentMethodOneArgs = {
  object: BookingUserPaymentMethodInsertInput;
  on_conflict?: InputMaybe<BookingUserPaymentMethodOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserSubscriptionArgs = {
  objects: Array<BookingUserSubscriptionInsertInput>;
  on_conflict?: InputMaybe<BookingUserSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingUserSubscriptionOneArgs = {
  object: BookingUserSubscriptionInsertInput;
  on_conflict?: InputMaybe<BookingUserSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingVehicleArgs = {
  objects: Array<BookingVehicleInsertInput>;
  on_conflict?: InputMaybe<BookingVehicleOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingVehicleOneArgs = {
  object: BookingVehicleInsertInput;
  on_conflict?: InputMaybe<BookingVehicleOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingVehicleTypeArgs = {
  objects: Array<BookingVehicleTypeInsertInput>;
  on_conflict?: InputMaybe<BookingVehicleTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingVehicleTypeOneArgs = {
  object: BookingVehicleTypeInsertInput;
  on_conflict?: InputMaybe<BookingVehicleTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingWhitelistTypeArgs = {
  objects: Array<BookingWhitelistTypeInsertInput>;
  on_conflict?: InputMaybe<BookingWhitelistTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertBookingWhitelistTypeOneArgs = {
  object: BookingWhitelistTypeInsertInput;
  on_conflict?: InputMaybe<BookingWhitelistTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertCalendarEventPolicyArgs = {
  objects: Array<CalendarEventPolicyInsertInput>;
  on_conflict?: InputMaybe<CalendarEventPolicyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCalendarEventPolicyOneArgs = {
  object: CalendarEventPolicyInsertInput;
  on_conflict?: InputMaybe<CalendarEventPolicyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCancellationsArgs = {
  objects: Array<CancellationsInsertInput>;
  on_conflict?: InputMaybe<CancellationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCancellationsOneArgs = {
  object: CancellationsInsertInput;
  on_conflict?: InputMaybe<CancellationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarDriverArgs = {
  objects: Array<CarDriverInsertInput>;
  on_conflict?: InputMaybe<CarDriverOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarDriverOneArgs = {
  object: CarDriverInsertInput;
  on_conflict?: InputMaybe<CarDriverOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarOwnerArgs = {
  objects: Array<CarOwnerInsertInput>;
  on_conflict?: InputMaybe<CarOwnerOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarOwnerOneArgs = {
  object: CarOwnerInsertInput;
  on_conflict?: InputMaybe<CarOwnerOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarOwnerRequestsArgs = {
  objects: Array<CarOwnerRequestsInsertInput>;
  on_conflict?: InputMaybe<CarOwnerRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarOwnerRequestsOneArgs = {
  object: CarOwnerRequestsInsertInput;
  on_conflict?: InputMaybe<CarOwnerRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayAccessControlLpPinArgs = {
  objects: Array<CarpayAccessControlLpPinInsertInput>;
  on_conflict?: InputMaybe<CarpayAccessControlLpPinOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayAccessControlLpPinOneArgs = {
  object: CarpayAccessControlLpPinInsertInput;
  on_conflict?: InputMaybe<CarpayAccessControlLpPinOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayDiscountBatchArgs = {
  objects: Array<CarpayDiscountBatchInsertInput>;
  on_conflict?: InputMaybe<CarpayDiscountBatchOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayDiscountBatchOneArgs = {
  object: CarpayDiscountBatchInsertInput;
  on_conflict?: InputMaybe<CarpayDiscountBatchOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayDiscountModelArgs = {
  objects: Array<CarpayDiscountModelInsertInput>;
  on_conflict?: InputMaybe<CarpayDiscountModelOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayDiscountModelOneArgs = {
  object: CarpayDiscountModelInsertInput;
  on_conflict?: InputMaybe<CarpayDiscountModelOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayLotArgs = {
  objects: Array<CarpayLotInsertInput>;
  on_conflict?: InputMaybe<CarpayLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayLotOneArgs = {
  object: CarpayLotInsertInput;
  on_conflict?: InputMaybe<CarpayLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriberArgs = {
  objects: Array<CarpayNotificationSubscriberInsertInput>;
  on_conflict?: InputMaybe<CarpayNotificationSubscriberOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriberOneArgs = {
  object: CarpayNotificationSubscriberInsertInput;
  on_conflict?: InputMaybe<CarpayNotificationSubscriberOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriptionArgs = {
  objects: Array<CarpayNotificationSubscriptionInsertInput>;
  on_conflict?: InputMaybe<CarpayNotificationSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriptionCategoryArgs = {
  objects: Array<CarpayNotificationSubscriptionCategoryInsertInput>;
  on_conflict?: InputMaybe<CarpayNotificationSubscriptionCategoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriptionCategoryOneArgs = {
  object: CarpayNotificationSubscriptionCategoryInsertInput;
  on_conflict?: InputMaybe<CarpayNotificationSubscriptionCategoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayNotificationSubscriptionOneArgs = {
  object: CarpayNotificationSubscriptionInsertInput;
  on_conflict?: InputMaybe<CarpayNotificationSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderArgs = {
  objects: Array<CarpayOrderInsertInput>;
  on_conflict?: InputMaybe<CarpayOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderMatchesArgs = {
  objects: Array<CarpayOrderMatchesInsertInput>;
  on_conflict?: InputMaybe<CarpayOrderMatchesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderMatchesOneArgs = {
  object: CarpayOrderMatchesInsertInput;
  on_conflict?: InputMaybe<CarpayOrderMatchesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderOneArgs = {
  object: CarpayOrderInsertInput;
  on_conflict?: InputMaybe<CarpayOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderUserArgs = {
  objects: Array<CarpayOrderUserInsertInput>;
  on_conflict?: InputMaybe<CarpayOrderUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayOrderUserOneArgs = {
  object: CarpayOrderUserInsertInput;
  on_conflict?: InputMaybe<CarpayOrderUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayParkingDetectionArgs = {
  objects: Array<CarpayParkingDetectionInsertInput>;
  on_conflict?: InputMaybe<CarpayParkingDetectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayParkingDetectionOneArgs = {
  object: CarpayParkingDetectionInsertInput;
  on_conflict?: InputMaybe<CarpayParkingDetectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingArgs = {
  objects: Array<CarpayPricingInsertInput>;
  on_conflict?: InputMaybe<CarpayPricingOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingConfigGroupArgs = {
  objects: Array<CarpayPricingConfigGroupInsertInput>;
  on_conflict?: InputMaybe<CarpayPricingConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingConfigGroupOneArgs = {
  object: CarpayPricingConfigGroupInsertInput;
  on_conflict?: InputMaybe<CarpayPricingConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingOneArgs = {
  object: CarpayPricingInsertInput;
  on_conflict?: InputMaybe<CarpayPricingOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingPeriodArgs = {
  objects: Array<CarpayPricingPeriodInsertInput>;
  on_conflict?: InputMaybe<CarpayPricingPeriodOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingPeriodOneArgs = {
  object: CarpayPricingPeriodInsertInput;
  on_conflict?: InputMaybe<CarpayPricingPeriodOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingRecurrenceArgs = {
  objects: Array<CarpayPricingRecurrenceInsertInput>;
  on_conflict?: InputMaybe<CarpayPricingRecurrenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingRecurrenceOneArgs = {
  object: CarpayPricingRecurrenceInsertInput;
  on_conflict?: InputMaybe<CarpayPricingRecurrenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingRulesArgs = {
  objects: Array<CarpayPricingRulesInsertInput>;
  on_conflict?: InputMaybe<CarpayPricingRulesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayPricingRulesOneArgs = {
  object: CarpayPricingRulesInsertInput;
  on_conflict?: InputMaybe<CarpayPricingRulesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayScannedCodesArgs = {
  objects: Array<CarpayScannedCodesInsertInput>;
  on_conflict?: InputMaybe<CarpayScannedCodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayScannedCodesOneArgs = {
  object: CarpayScannedCodesInsertInput;
  on_conflict?: InputMaybe<CarpayScannedCodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalCashCutNotificationArgs = {
  objects: Array<CarpayTerminalCashCutNotificationInsertInput>;
  on_conflict?: InputMaybe<CarpayTerminalCashCutNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalCashCutNotificationOneArgs = {
  object: CarpayTerminalCashCutNotificationInsertInput;
  on_conflict?: InputMaybe<CarpayTerminalCashCutNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalCashFillLevelNotificationArgs = {
  objects: Array<CarpayTerminalCashFillLevelNotificationInsertInput>;
  on_conflict?: InputMaybe<CarpayTerminalCashFillLevelNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalCashFillLevelNotificationOneArgs = {
  object: CarpayTerminalCashFillLevelNotificationInsertInput;
  on_conflict?: InputMaybe<CarpayTerminalCashFillLevelNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalNotificationConfigArgs = {
  objects: Array<CarpayTerminalNotificationConfigInsertInput>;
  on_conflict?: InputMaybe<CarpayTerminalNotificationConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalNotificationConfigOneArgs = {
  object: CarpayTerminalNotificationConfigInsertInput;
  on_conflict?: InputMaybe<CarpayTerminalNotificationConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalPrinterStatusNotificationArgs = {
  objects: Array<CarpayTerminalPrinterStatusNotificationInsertInput>;
  on_conflict?: InputMaybe<CarpayTerminalPrinterStatusNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayTerminalPrinterStatusNotificationOneArgs = {
  object: CarpayTerminalPrinterStatusNotificationInsertInput;
  on_conflict?: InputMaybe<CarpayTerminalPrinterStatusNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayUserVerifiedPlateArgs = {
  objects: Array<CarpayUserVerifiedPlateInsertInput>;
  on_conflict?: InputMaybe<CarpayUserVerifiedPlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertCarpayUserVerifiedPlateOneArgs = {
  object: CarpayUserVerifiedPlateInsertInput;
  on_conflict?: InputMaybe<CarpayUserVerifiedPlateOnConflict>;
};


/** mutation root */
export type MutationRootInsertChainArgs = {
  objects: Array<ChainInsertInput>;
  on_conflict?: InputMaybe<ChainOnConflict>;
};


/** mutation root */
export type MutationRootInsertChainOneArgs = {
  object: ChainInsertInput;
  on_conflict?: InputMaybe<ChainOnConflict>;
};


/** mutation root */
export type MutationRootInsertCityCodesArgs = {
  objects: Array<CityCodesInsertInput>;
};


/** mutation root */
export type MutationRootInsertCityCodesOneArgs = {
  object: CityCodesInsertInput;
};


/** mutation root */
export type MutationRootInsertCompanyArgs = {
  objects: Array<CompanyInsertInput>;
  on_conflict?: InputMaybe<CompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyConfigGroupArgs = {
  objects: Array<CompanyConfigGroupInsertInput>;
  on_conflict?: InputMaybe<CompanyConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyConfigGroupOneArgs = {
  object: CompanyConfigGroupInsertInput;
  on_conflict?: InputMaybe<CompanyConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyHierarchyArgs = {
  objects: Array<CompanyHierarchyInsertInput>;
  on_conflict?: InputMaybe<CompanyHierarchyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyHierarchyOneArgs = {
  object: CompanyHierarchyInsertInput;
  on_conflict?: InputMaybe<CompanyHierarchyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyLotSectionArgs = {
  objects: Array<CompanyLotSectionInsertInput>;
  on_conflict?: InputMaybe<CompanyLotSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyLotSectionOneArgs = {
  object: CompanyLotSectionInsertInput;
  on_conflict?: InputMaybe<CompanyLotSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyOneArgs = {
  object: CompanyInsertInput;
  on_conflict?: InputMaybe<CompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyVatIdArgs = {
  objects: Array<CompanyVatIdInsertInput>;
  on_conflict?: InputMaybe<CompanyVatIdOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyVatIdOneArgs = {
  object: CompanyVatIdInsertInput;
  on_conflict?: InputMaybe<CompanyVatIdOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyViolatorArgs = {
  objects: Array<CompanyViolatorInsertInput>;
  on_conflict?: InputMaybe<CompanyViolatorOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyViolatorOneArgs = {
  object: CompanyViolatorInsertInput;
  on_conflict?: InputMaybe<CompanyViolatorOnConflict>;
};


/** mutation root */
export type MutationRootInsertConfigGroupArgs = {
  objects: Array<ConfigGroupInsertInput>;
  on_conflict?: InputMaybe<ConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertConfigGroupOneArgs = {
  object: ConfigGroupInsertInput;
  on_conflict?: InputMaybe<ConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryArgs = {
  objects: Array<CountryInsertInput>;
  on_conflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryOneArgs = {
  object: CountryInsertInput;
  on_conflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCurrencyArgs = {
  objects: Array<CurrencyInsertInput>;
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCurrencyOneArgs = {
  object: CurrencyInsertInput;
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomerDashboardNpsFeedbackArgs = {
  objects: Array<CustomerDashboardNpsFeedbackInsertInput>;
  on_conflict?: InputMaybe<CustomerDashboardNpsFeedbackOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomerDashboardNpsFeedbackOneArgs = {
  object: CustomerDashboardNpsFeedbackInsertInput;
  on_conflict?: InputMaybe<CustomerDashboardNpsFeedbackOnConflict>;
};


/** mutation root */
export type MutationRootInsertDailyFailureArgs = {
  objects: Array<DailyFailureInsertInput>;
  on_conflict?: InputMaybe<DailyFailureOnConflict>;
};


/** mutation root */
export type MutationRootInsertDailyFailureOneArgs = {
  object: DailyFailureInsertInput;
  on_conflict?: InputMaybe<DailyFailureOnConflict>;
};


/** mutation root */
export type MutationRootInsertDailyStatsArgs = {
  objects: Array<DailyStatsInsertInput>;
  on_conflict?: InputMaybe<DailyStatsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDailyStatsOneArgs = {
  object: DailyStatsInsertInput;
  on_conflict?: InputMaybe<DailyStatsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentArgs = {
  objects: Array<DepartmentInsertInput>;
  on_conflict?: InputMaybe<DepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentOneArgs = {
  object: DepartmentInsertInput;
  on_conflict?: InputMaybe<DepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertDetectionTypeEnumArgs = {
  objects: Array<DetectionTypeEnumInsertInput>;
  on_conflict?: InputMaybe<DetectionTypeEnumOnConflict>;
};


/** mutation root */
export type MutationRootInsertDetectionTypeEnumOneArgs = {
  object: DetectionTypeEnumInsertInput;
  on_conflict?: InputMaybe<DetectionTypeEnumOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceArgs = {
  objects: Array<DeviceInsertInput>;
  on_conflict?: InputMaybe<DeviceOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceOneArgs = {
  object: DeviceInsertInput;
  on_conflict?: InputMaybe<DeviceOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkLotArgs = {
  objects: Array<EasyparkLotInsertInput>;
  on_conflict?: InputMaybe<EasyparkLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkLotOneArgs = {
  object: EasyparkLotInsertInput;
  on_conflict?: InputMaybe<EasyparkLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkOrderArgs = {
  objects: Array<EasyparkOrderInsertInput>;
  on_conflict?: InputMaybe<EasyparkOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkOrderOneArgs = {
  object: EasyparkOrderInsertInput;
  on_conflict?: InputMaybe<EasyparkOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkOrderV2Args = {
  objects: Array<EasyparkOrderV2InsertInput>;
  on_conflict?: InputMaybe<EasyparkOrderV2OnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkOrderV2OneArgs = {
  object: EasyparkOrderV2InsertInput;
  on_conflict?: InputMaybe<EasyparkOrderV2OnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkParkingInfoArgs = {
  objects: Array<EasyparkParkingInfoInsertInput>;
  on_conflict?: InputMaybe<EasyparkParkingInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertEasyparkParkingInfoOneArgs = {
  object: EasyparkParkingInfoInsertInput;
  on_conflict?: InputMaybe<EasyparkParkingInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnforcementDailyStatsArgs = {
  objects: Array<EnforcementDailyStatsInsertInput>;
  on_conflict?: InputMaybe<EnforcementDailyStatsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnforcementDailyStatsOneArgs = {
  object: EnforcementDailyStatsInsertInput;
  on_conflict?: InputMaybe<EnforcementDailyStatsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCarpayDiscountModelCodeTypeArgs = {
  objects: Array<EnumCarpayDiscountModelCodeTypeInsertInput>;
  on_conflict?: InputMaybe<EnumCarpayDiscountModelCodeTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCarpayDiscountModelCodeTypeOneArgs = {
  object: EnumCarpayDiscountModelCodeTypeInsertInput;
  on_conflict?: InputMaybe<EnumCarpayDiscountModelCodeTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCountryCodeArgs = {
  objects: Array<EnumCountryCodeInsertInput>;
  on_conflict?: InputMaybe<EnumCountryCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCountryCodeOneArgs = {
  object: EnumCountryCodeInsertInput;
  on_conflict?: InputMaybe<EnumCountryCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCustomerWhitelistPurposeArgs = {
  objects: Array<EnumCustomerWhitelistPurposeInsertInput>;
  on_conflict?: InputMaybe<EnumCustomerWhitelistPurposeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCustomerWhitelistPurposeOneArgs = {
  object: EnumCustomerWhitelistPurposeInsertInput;
  on_conflict?: InputMaybe<EnumCustomerWhitelistPurposeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCustomerWhitelistStatusArgs = {
  objects: Array<EnumCustomerWhitelistStatusInsertInput>;
  on_conflict?: InputMaybe<EnumCustomerWhitelistStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumCustomerWhitelistStatusOneArgs = {
  object: EnumCustomerWhitelistStatusInsertInput;
  on_conflict?: InputMaybe<EnumCustomerWhitelistStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumDeviceTypeArgs = {
  objects: Array<EnumDeviceTypeInsertInput>;
  on_conflict?: InputMaybe<EnumDeviceTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumDeviceTypeOneArgs = {
  object: EnumDeviceTypeInsertInput;
  on_conflict?: InputMaybe<EnumDeviceTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumDriverRequestTypeArgs = {
  objects: Array<EnumDriverRequestTypeInsertInput>;
  on_conflict?: InputMaybe<EnumDriverRequestTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumDriverRequestTypeOneArgs = {
  object: EnumDriverRequestTypeInsertInput;
  on_conflict?: InputMaybe<EnumDriverRequestTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumGuestJwtPurposeArgs = {
  objects: Array<EnumGuestJwtPurposeInsertInput>;
  on_conflict?: InputMaybe<EnumGuestJwtPurposeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumGuestJwtPurposeOneArgs = {
  object: EnumGuestJwtPurposeInsertInput;
  on_conflict?: InputMaybe<EnumGuestJwtPurposeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumSupervisionMlpRequestStatusArgs = {
  objects: Array<EnumSupervisionMlpRequestStatusInsertInput>;
  on_conflict?: InputMaybe<EnumSupervisionMlpRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumSupervisionMlpRequestStatusOneArgs = {
  object: EnumSupervisionMlpRequestStatusInsertInput;
  on_conflict?: InputMaybe<EnumSupervisionMlpRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCancellationArgs = {
  objects: Array<EnumViolationCancellationInsertInput>;
  on_conflict?: InputMaybe<EnumViolationCancellationOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCancellationOneArgs = {
  object: EnumViolationCancellationInsertInput;
  on_conflict?: InputMaybe<EnumViolationCancellationOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCaseChargesInvalidationReasonArgs = {
  objects: Array<EnumViolationCaseChargesInvalidationReasonInsertInput>;
  on_conflict?: InputMaybe<EnumViolationCaseChargesInvalidationReasonOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCaseChargesInvalidationReasonOneArgs = {
  object: EnumViolationCaseChargesInvalidationReasonInsertInput;
  on_conflict?: InputMaybe<EnumViolationCaseChargesInvalidationReasonOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCaseChargesTypeArgs = {
  objects: Array<EnumViolationCaseChargesTypeInsertInput>;
  on_conflict?: InputMaybe<EnumViolationCaseChargesTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumViolationCaseChargesTypeOneArgs = {
  object: EnumViolationCaseChargesTypeInsertInput;
  on_conflict?: InputMaybe<EnumViolationCaseChargesTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistPaidParkingTypesArgs = {
  objects: Array<EnumWhitelistPaidParkingTypesInsertInput>;
  on_conflict?: InputMaybe<EnumWhitelistPaidParkingTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistPaidParkingTypesOneArgs = {
  object: EnumWhitelistPaidParkingTypesInsertInput;
  on_conflict?: InputMaybe<EnumWhitelistPaidParkingTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistScopeArgs = {
  objects: Array<EnumWhitelistScopeInsertInput>;
  on_conflict?: InputMaybe<EnumWhitelistScopeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistScopeOneArgs = {
  object: EnumWhitelistScopeInsertInput;
  on_conflict?: InputMaybe<EnumWhitelistScopeOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistStatusArgs = {
  objects: Array<EnumWhitelistStatusInsertInput>;
  on_conflict?: InputMaybe<EnumWhitelistStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistStatusOneArgs = {
  object: EnumWhitelistStatusInsertInput;
  on_conflict?: InputMaybe<EnumWhitelistStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistTypesArgs = {
  objects: Array<EnumWhitelistTypesInsertInput>;
  on_conflict?: InputMaybe<EnumWhitelistTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertEnumWhitelistTypesOneArgs = {
  object: EnumWhitelistTypesInsertInput;
  on_conflict?: InputMaybe<EnumWhitelistTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertGuestJwtArgs = {
  objects: Array<GuestJwtInsertInput>;
  on_conflict?: InputMaybe<GuestJwtOnConflict>;
};


/** mutation root */
export type MutationRootInsertGuestJwtOneArgs = {
  object: GuestJwtInsertInput;
  on_conflict?: InputMaybe<GuestJwtOnConflict>;
};


/** mutation root */
export type MutationRootInsertGuestQrArgs = {
  objects: Array<GuestQrInsertInput>;
  on_conflict?: InputMaybe<GuestQrOnConflict>;
};


/** mutation root */
export type MutationRootInsertGuestQrOneArgs = {
  object: GuestQrInsertInput;
  on_conflict?: InputMaybe<GuestQrOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotArgs = {
  objects: Array<LotInsertInput>;
  on_conflict?: InputMaybe<LotOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotConfigGroupArgs = {
  objects: Array<LotConfigGroupInsertInput>;
  on_conflict?: InputMaybe<LotConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotConfigGroupOneArgs = {
  object: LotConfigGroupInsertInput;
  on_conflict?: InputMaybe<LotConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotDisplayNameArgs = {
  objects: Array<LotDisplayNameInsertInput>;
  on_conflict?: InputMaybe<LotDisplayNameOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotDisplayNameOneArgs = {
  object: LotDisplayNameInsertInput;
  on_conflict?: InputMaybe<LotDisplayNameOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotHierarchyArgs = {
  objects: Array<LotHierarchyInsertInput>;
  on_conflict?: InputMaybe<LotHierarchyOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotHierarchyOneArgs = {
  object: LotHierarchyInsertInput;
  on_conflict?: InputMaybe<LotHierarchyOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotLegalEntityArgs = {
  objects: Array<LotLegalEntityInsertInput>;
  on_conflict?: InputMaybe<LotLegalEntityOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotLegalEntityOneArgs = {
  object: LotLegalEntityInsertInput;
  on_conflict?: InputMaybe<LotLegalEntityOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotOneArgs = {
  object: LotInsertInput;
  on_conflict?: InputMaybe<LotOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotPolicyHistoryArgs = {
  objects: Array<LotPolicyHistoryInsertInput>;
  on_conflict?: InputMaybe<LotPolicyHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotPolicyHistoryOneArgs = {
  object: LotPolicyHistoryInsertInput;
  on_conflict?: InputMaybe<LotPolicyHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotSectionArgs = {
  objects: Array<LotSectionInsertInput>;
  on_conflict?: InputMaybe<LotSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertLotSectionOneArgs = {
  object: LotSectionInsertInput;
  on_conflict?: InputMaybe<LotSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpContingentArgs = {
  objects: Array<LpContingentInsertInput>;
  on_conflict?: InputMaybe<LpContingentOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpContingentOneArgs = {
  object: LpContingentInsertInput;
  on_conflict?: InputMaybe<LpContingentOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupArgs = {
  objects: Array<LpGroupInsertInput>;
  on_conflict?: InputMaybe<LpGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupConfigGroupArgs = {
  objects: Array<LpGroupConfigGroupInsertInput>;
  on_conflict?: InputMaybe<LpGroupConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupConfigGroupOneArgs = {
  object: LpGroupConfigGroupInsertInput;
  on_conflict?: InputMaybe<LpGroupConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupDetailsArgs = {
  objects: Array<LpGroupDetailsInsertInput>;
  on_conflict?: InputMaybe<LpGroupDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupDetailsOneArgs = {
  object: LpGroupDetailsInsertInput;
  on_conflict?: InputMaybe<LpGroupDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupMemberArgs = {
  objects: Array<LpGroupMemberInsertInput>;
  on_conflict?: InputMaybe<LpGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupMemberDetailsArgs = {
  objects: Array<LpGroupMemberDetailsInsertInput>;
  on_conflict?: InputMaybe<LpGroupMemberDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupMemberDetailsOneArgs = {
  object: LpGroupMemberDetailsInsertInput;
  on_conflict?: InputMaybe<LpGroupMemberDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupMemberOneArgs = {
  object: LpGroupMemberInsertInput;
  on_conflict?: InputMaybe<LpGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertLpGroupOneArgs = {
  object: LpGroupInsertInput;
  on_conflict?: InputMaybe<LpGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertMailArgs = {
  objects: Array<MailInsertInput>;
  on_conflict?: InputMaybe<MailOnConflict>;
};


/** mutation root */
export type MutationRootInsertMailMiscArgs = {
  objects: Array<MailMiscInsertInput>;
  on_conflict?: InputMaybe<MailMiscOnConflict>;
};


/** mutation root */
export type MutationRootInsertMailMiscOneArgs = {
  object: MailMiscInsertInput;
  on_conflict?: InputMaybe<MailMiscOnConflict>;
};


/** mutation root */
export type MutationRootInsertMailOneArgs = {
  object: MailInsertInput;
  on_conflict?: InputMaybe<MailOnConflict>;
};


/** mutation root */
export type MutationRootInsertMlpCasesArgs = {
  objects: Array<MlpCasesInsertInput>;
  on_conflict?: InputMaybe<MlpCasesOnConflict>;
};


/** mutation root */
export type MutationRootInsertMlpCasesOneArgs = {
  object: MlpCasesInsertInput;
  on_conflict?: InputMaybe<MlpCasesOnConflict>;
};


/** mutation root */
export type MutationRootInsertMlpMappingsArgs = {
  objects: Array<MlpMappingsInsertInput>;
  on_conflict?: InputMaybe<MlpMappingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertMlpMappingsOneArgs = {
  object: MlpMappingsInsertInput;
  on_conflict?: InputMaybe<MlpMappingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertMqttRequestArgs = {
  objects: Array<MqttRequestInsertInput>;
  on_conflict?: InputMaybe<MqttRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertMqttRequestOneArgs = {
  object: MqttRequestInsertInput;
  on_conflict?: InputMaybe<MqttRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertOffenceParkingEventsArgs = {
  objects: Array<OffenceParkingEventsInsertInput>;
  on_conflict?: InputMaybe<OffenceParkingEventsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOffenceParkingEventsOneArgs = {
  object: OffenceParkingEventsInsertInput;
  on_conflict?: InputMaybe<OffenceParkingEventsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOffenceTicketRequestsArgs = {
  objects: Array<OffenceTicketRequestsInsertInput>;
  on_conflict?: InputMaybe<OffenceTicketRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOffenceTicketRequestsOneArgs = {
  object: OffenceTicketRequestsInsertInput;
  on_conflict?: InputMaybe<OffenceTicketRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOveruseGroupArgs = {
  objects: Array<OveruseGroupInsertInput>;
  on_conflict?: InputMaybe<OveruseGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertOveruseGroupMemberArgs = {
  objects: Array<OveruseGroupMemberInsertInput>;
  on_conflict?: InputMaybe<OveruseGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertOveruseGroupMemberOneArgs = {
  object: OveruseGroupMemberInsertInput;
  on_conflict?: InputMaybe<OveruseGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertOveruseGroupOneArgs = {
  object: OveruseGroupInsertInput;
  on_conflict?: InputMaybe<OveruseGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkdepotProductArgs = {
  objects: Array<ParkdepotProductInsertInput>;
  on_conflict?: InputMaybe<ParkdepotProductOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkdepotProductOneArgs = {
  object: ParkdepotProductInsertInput;
  on_conflict?: InputMaybe<ParkdepotProductOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingContextArgs = {
  objects: Array<ParkingContextInsertInput>;
  on_conflict?: InputMaybe<ParkingContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingContextOneArgs = {
  object: ParkingContextInsertInput;
  on_conflict?: InputMaybe<ParkingContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingDetectionsArgs = {
  objects: Array<ParkingDetectionsInsertInput>;
  on_conflict?: InputMaybe<ParkingDetectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingDetectionsArchiveArgs = {
  objects: Array<ParkingDetectionsArchiveInsertInput>;
  on_conflict?: InputMaybe<ParkingDetectionsArchiveOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingDetectionsArchiveOneArgs = {
  object: ParkingDetectionsArchiveInsertInput;
  on_conflict?: InputMaybe<ParkingDetectionsArchiveOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingDetectionsOneArgs = {
  object: ParkingDetectionsInsertInput;
  on_conflict?: InputMaybe<ParkingDetectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingIncomingArgs = {
  objects: Array<ParkingIncomingInsertInput>;
  on_conflict?: InputMaybe<ParkingIncomingOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingIncomingOneArgs = {
  object: ParkingIncomingInsertInput;
  on_conflict?: InputMaybe<ParkingIncomingOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingProcessingArgs = {
  objects: Array<ParkingProcessingInsertInput>;
  on_conflict?: InputMaybe<ParkingProcessingOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingProcessingOneArgs = {
  object: ParkingProcessingInsertInput;
  on_conflict?: InputMaybe<ParkingProcessingOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingResultsArgs = {
  objects: Array<ParkingResultsInsertInput>;
  on_conflict?: InputMaybe<ParkingResultsOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingResultsArchiveArgs = {
  objects: Array<ParkingResultsArchiveInsertInput>;
  on_conflict?: InputMaybe<ParkingResultsArchiveOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingResultsArchiveOneArgs = {
  object: ParkingResultsArchiveInsertInput;
  on_conflict?: InputMaybe<ParkingResultsArchiveOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingResultsOneArgs = {
  object: ParkingResultsInsertInput;
  on_conflict?: InputMaybe<ParkingResultsOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingTempArgs = {
  objects: Array<ParkingTempInsertInput>;
  on_conflict?: InputMaybe<ParkingTempOnConflict>;
};


/** mutation root */
export type MutationRootInsertParkingTempOneArgs = {
  object: ParkingTempInsertInput;
  on_conflict?: InputMaybe<ParkingTempOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaybyphoneLotArgs = {
  objects: Array<PaybyphoneLotInsertInput>;
  on_conflict?: InputMaybe<PaybyphoneLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaybyphoneLotOneArgs = {
  object: PaybyphoneLotInsertInput;
  on_conflict?: InputMaybe<PaybyphoneLotOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaybyphoneOrderArgs = {
  objects: Array<PaybyphoneOrderInsertInput>;
  on_conflict?: InputMaybe<PaybyphoneOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaybyphoneOrderOneArgs = {
  object: PaybyphoneOrderInsertInput;
  on_conflict?: InputMaybe<PaybyphoneOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertPersonArgs = {
  objects: Array<PersonInsertInput>;
  on_conflict?: InputMaybe<PersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertPersonOneArgs = {
  object: PersonInsertInput;
  on_conflict?: InputMaybe<PersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertPolicyScheduleArgs = {
  objects: Array<PolicyScheduleInsertInput>;
  on_conflict?: InputMaybe<PolicyScheduleOnConflict>;
};


/** mutation root */
export type MutationRootInsertPolicyScheduleOneArgs = {
  object: PolicyScheduleInsertInput;
  on_conflict?: InputMaybe<PolicyScheduleOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegionalCodesAustriaArgs = {
  objects: Array<RegionalCodesAustriaInsertInput>;
  on_conflict?: InputMaybe<RegionalCodesAustriaOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegionalCodesAustriaOneArgs = {
  object: RegionalCodesAustriaInsertInput;
  on_conflict?: InputMaybe<RegionalCodesAustriaOnConflict>;
};


/** mutation root */
export type MutationRootInsertRentalPricingArgs = {
  objects: Array<RentalPricingInsertInput>;
  on_conflict?: InputMaybe<RentalPricingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRentalPricingOneArgs = {
  object: RentalPricingInsertInput;
  on_conflict?: InputMaybe<RentalPricingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRentalSubscriptionArgs = {
  objects: Array<RentalSubscriptionInsertInput>;
  on_conflict?: InputMaybe<RentalSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertRentalSubscriptionOneArgs = {
  object: RentalSubscriptionInsertInput;
  on_conflict?: InputMaybe<RentalSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertServerlessAsyncWorkArgs = {
  objects: Array<ServerlessAsyncWorkInsertInput>;
  on_conflict?: InputMaybe<ServerlessAsyncWorkOnConflict>;
};


/** mutation root */
export type MutationRootInsertServerlessAsyncWorkOneArgs = {
  object: ServerlessAsyncWorkInsertInput;
  on_conflict?: InputMaybe<ServerlessAsyncWorkOnConflict>;
};


/** mutation root */
export type MutationRootInsertSimilarDetectionsArgs = {
  objects: Array<SimilarDetectionsInsertInput>;
  on_conflict?: InputMaybe<SimilarDetectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSimilarDetectionsOneArgs = {
  object: SimilarDetectionsInsertInput;
  on_conflict?: InputMaybe<SimilarDetectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSingleCarOwnerInformationArgs = {
  birthdate: Scalars['String'];
  birthplace: Scalars['String'];
  car_make: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  country_of_department: Scalars['String'];
  department_code: Scalars['String'];
  first_name: Scalars['String'];
  gender: Scalars['String'];
  house_number: Scalars['String'];
  last_name: Scalars['String'];
  plate: Scalars['String'];
  postal_code: Scalars['String'];
  street: Scalars['String'];
};


/** mutation root */
export type MutationRootInsertStagesArgs = {
  objects: Array<StagesInsertInput>;
  on_conflict?: InputMaybe<StagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertStagesOneArgs = {
  object: StagesInsertInput;
  on_conflict?: InputMaybe<StagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertStationArgs = {
  objects: Array<StationInsertInput>;
  on_conflict?: InputMaybe<StationOnConflict>;
};


/** mutation root */
export type MutationRootInsertStationOneArgs = {
  object: StationInsertInput;
  on_conflict?: InputMaybe<StationOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionCarRentalPartnersArgs = {
  objects: Array<SupervisionCarRentalPartnersInsertInput>;
  on_conflict?: InputMaybe<SupervisionCarRentalPartnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionCarRentalPartnersOneArgs = {
  object: SupervisionCarRentalPartnersInsertInput;
  on_conflict?: InputMaybe<SupervisionCarRentalPartnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionDebtCollectionCaseArgs = {
  objects: Array<SupervisionDebtCollectionCaseInsertInput>;
  on_conflict?: InputMaybe<SupervisionDebtCollectionCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionDebtCollectionCaseOneArgs = {
  object: SupervisionDebtCollectionCaseInsertInput;
  on_conflict?: InputMaybe<SupervisionDebtCollectionCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionImageRequestsArgs = {
  objects: Array<SupervisionImageRequestsInsertInput>;
  on_conflict?: InputMaybe<SupervisionImageRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionImageRequestsOneArgs = {
  object: SupervisionImageRequestsInsertInput;
  on_conflict?: InputMaybe<SupervisionImageRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMlpRequestsArgs = {
  objects: Array<SupervisionMlpRequestsInsertInput>;
  on_conflict?: InputMaybe<SupervisionMlpRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMlpRequestsOneArgs = {
  object: SupervisionMlpRequestsInsertInput;
  on_conflict?: InputMaybe<SupervisionMlpRequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMultivisitOffenderGroupArgs = {
  objects: Array<SupervisionMultivisitOffenderGroupInsertInput>;
  on_conflict?: InputMaybe<SupervisionMultivisitOffenderGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMultivisitOffenderGroupMemberArgs = {
  objects: Array<SupervisionMultivisitOffenderGroupMemberInsertInput>;
  on_conflict?: InputMaybe<SupervisionMultivisitOffenderGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMultivisitOffenderGroupMemberOneArgs = {
  object: SupervisionMultivisitOffenderGroupMemberInsertInput;
  on_conflict?: InputMaybe<SupervisionMultivisitOffenderGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionMultivisitOffenderGroupOneArgs = {
  object: SupervisionMultivisitOffenderGroupInsertInput;
  on_conflict?: InputMaybe<SupervisionMultivisitOffenderGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionTicketRequestArgs = {
  objects: Array<SupervisionTicketRequestInsertInput>;
  on_conflict?: InputMaybe<SupervisionTicketRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionTicketRequestOneArgs = {
  object: SupervisionTicketRequestInsertInput;
  on_conflict?: InputMaybe<SupervisionTicketRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionViolationCaseDebtCollectionCaseArgs = {
  objects: Array<SupervisionViolationCaseDebtCollectionCaseInsertInput>;
  on_conflict?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertSupervisionViolationCaseDebtCollectionCaseOneArgs = {
  object: SupervisionViolationCaseDebtCollectionCaseInsertInput;
  on_conflict?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertTaxArgs = {
  objects: Array<TaxInsertInput>;
  on_conflict?: InputMaybe<TaxOnConflict>;
};


/** mutation root */
export type MutationRootInsertTaxOneArgs = {
  object: TaxInsertInput;
  on_conflict?: InputMaybe<TaxOnConflict>;
};


/** mutation root */
export type MutationRootInsertTerminalStatusArgs = {
  objects: Array<TerminalStatusInsertInput>;
  on_conflict?: InputMaybe<TerminalStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertTerminalStatusOneArgs = {
  object: TerminalStatusInsertInput;
  on_conflict?: InputMaybe<TerminalStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertTicketWebsiteFeedbackArgs = {
  objects: Array<TicketWebsiteFeedbackInsertInput>;
  on_conflict?: InputMaybe<TicketWebsiteFeedbackOnConflict>;
};


/** mutation root */
export type MutationRootInsertTicketWebsiteFeedbackOneArgs = {
  object: TicketWebsiteFeedbackInsertInput;
  on_conflict?: InputMaybe<TicketWebsiteFeedbackOnConflict>;
};


/** mutation root */
export type MutationRootInsertTimeDiscountArgs = {
  objects: Array<TimeDiscountInsertInput>;
  on_conflict?: InputMaybe<TimeDiscountOnConflict>;
};


/** mutation root */
export type MutationRootInsertTimeDiscountOneArgs = {
  object: TimeDiscountInsertInput;
  on_conflict?: InputMaybe<TimeDiscountOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserPreferenceArgs = {
  objects: Array<UserPreferenceInsertInput>;
  on_conflict?: InputMaybe<UserPreferenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserPreferenceOneArgs = {
  object: UserPreferenceInsertInput;
  on_conflict?: InputMaybe<UserPreferenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertVehicleTypeArgs = {
  objects: Array<VehicleTypeInsertInput>;
  on_conflict?: InputMaybe<VehicleTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertVehicleTypeConfigGroupArgs = {
  objects: Array<VehicleTypeConfigGroupInsertInput>;
  on_conflict?: InputMaybe<VehicleTypeConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertVehicleTypeConfigGroupOneArgs = {
  object: VehicleTypeConfigGroupInsertInput;
  on_conflict?: InputMaybe<VehicleTypeConfigGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertVehicleTypeOneArgs = {
  object: VehicleTypeInsertInput;
  on_conflict?: InputMaybe<VehicleTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseArgs = {
  objects: Array<ViolationCaseInsertInput>;
  on_conflict?: InputMaybe<ViolationCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseChargesArgs = {
  objects: Array<ViolationCaseChargesInsertInput>;
  on_conflict?: InputMaybe<ViolationCaseChargesOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseChargesOneArgs = {
  object: ViolationCaseChargesInsertInput;
  on_conflict?: InputMaybe<ViolationCaseChargesOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseOneArgs = {
  object: ViolationCaseInsertInput;
  on_conflict?: InputMaybe<ViolationCaseOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseTagsArgs = {
  objects: Array<ViolationCaseTagsInsertInput>;
  on_conflict?: InputMaybe<ViolationCaseTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationCaseTagsOneArgs = {
  object: ViolationCaseTagsInsertInput;
  on_conflict?: InputMaybe<ViolationCaseTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationEventAnalysisArgs = {
  objects: Array<ViolationEventAnalysisInsertInput>;
  on_conflict?: InputMaybe<ViolationEventAnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolationEventAnalysisOneArgs = {
  object: ViolationEventAnalysisInsertInput;
  on_conflict?: InputMaybe<ViolationEventAnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolatorTransactionsArgs = {
  objects: Array<ViolatorTransactionsInsertInput>;
  on_conflict?: InputMaybe<ViolatorTransactionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertViolatorTransactionsOneArgs = {
  object: ViolatorTransactionsInsertInput;
  on_conflict?: InputMaybe<ViolatorTransactionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistArgs = {
  objects: Array<WhitelistInsertInput>;
  on_conflict?: InputMaybe<WhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistAppliedPermitArgs = {
  objects: Array<WhitelistAppliedPermitInsertInput>;
  on_conflict?: InputMaybe<WhitelistAppliedPermitOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistAppliedPermitOneArgs = {
  object: WhitelistAppliedPermitInsertInput;
  on_conflict?: InputMaybe<WhitelistAppliedPermitOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistCalendarEventPolicyArgs = {
  objects: Array<WhitelistCalendarEventPolicyInsertInput>;
  on_conflict?: InputMaybe<WhitelistCalendarEventPolicyOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistCalendarEventPolicyOneArgs = {
  object: WhitelistCalendarEventPolicyInsertInput;
  on_conflict?: InputMaybe<WhitelistCalendarEventPolicyOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistCustomerArgs = {
  objects: Array<InsertWhitelistInput>;
  rrule_duration?: InputMaybe<Scalars['String']>;
  rrule_string?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootInsertWhitelistLpContingentArgs = {
  objects: Array<WhitelistLpContingentInsertInput>;
  on_conflict?: InputMaybe<WhitelistLpContingentOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistLpContingentOneArgs = {
  object: WhitelistLpContingentInsertInput;
  on_conflict?: InputMaybe<WhitelistLpContingentOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistOneArgs = {
  object: WhitelistInsertInput;
  on_conflict?: InputMaybe<WhitelistOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistPaidParkingArgs = {
  objects: Array<WhitelistPaidParkingInsertInput>;
  on_conflict?: InputMaybe<WhitelistPaidParkingOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistPaidParkingOneArgs = {
  object: WhitelistPaidParkingInsertInput;
  on_conflict?: InputMaybe<WhitelistPaidParkingOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistSubscriptionArgs = {
  objects: Array<WhitelistSubscriptionInsertInput>;
  on_conflict?: InputMaybe<WhitelistSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertWhitelistSubscriptionOneArgs = {
  object: WhitelistSubscriptionInsertInput;
  on_conflict?: InputMaybe<WhitelistSubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertWireguardConfigArgs = {
  objects: Array<WireguardConfigInsertInput>;
  on_conflict?: InputMaybe<WireguardConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertWireguardConfigOneArgs = {
  object: WireguardConfigInsertInput;
  on_conflict?: InputMaybe<WireguardConfigOnConflict>;
};


/** mutation root */
export type MutationRootLinkTransactionArgs = {
  true_offence_id: Scalars['bigint'];
  true_transaction_id: Scalars['bigint'];
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootMergeLettersArgs = {
  foldername: Scalars['String'];
  mail_ids?: InputMaybe<Array<Scalars['bigint']>>;
};


/** mutation root */
export type MutationRootMoveUserToNewCompanyArgs = {
  move_permissions?: InputMaybe<Scalars['Boolean']>;
  new_company_id: Scalars['String'];
  old_company_id: Scalars['String'];
  user_email: Scalars['String'];
};


/** mutation root */
export type MutationRootProvideNpsFeedbackArgs = {
  feedback?: InputMaybe<Scalars['String']>;
  nps: Scalars['Int'];
};


/** mutation root */
export type MutationRootPurgeQueueArgs = {
  queue_name: Scalars['String'];
};


/** mutation root */
export type MutationRootPushCheckedMlpsArgs = {
  checked_mlps: Scalars['jsonb'];
};


/** mutation root */
export type MutationRootRemoveUserFromPpmArgs = {
  arg: RemoveUserFromPpmRequest;
};


/** mutation root */
export type MutationRootReplaceWhitelistArgs = {
  replaceWith: ReplaceWhitelistInput;
  whitelistId: Scalars['Int'];
};


/** mutation root */
export type MutationRootRevertCancelledViolationCaseApiArgs = {
  case_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  revert_issuer: Scalars['String'];
  revert_mode: Scalars['String'];
  true_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** mutation root */
export type MutationRootRevertParkingResultConfirmationArgs = {
  parking_result_id: Scalars['String'];
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};


/** mutation root */
export type MutationRootRevertWrittenOffViolationCaseApiArgs = {
  case_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  revert_issuer: Scalars['String'];
  revert_mode: Scalars['String'];
  true_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** mutation root */
export type MutationRootSendSmsCommandArgs = {
  command: Scalars['String'];
  device_uuid: Scalars['String'];
};


/** mutation root */
export type MutationRootSendSpecialLettersToSftpArgs = {
  mail_misc_ids?: InputMaybe<Array<Scalars['bigint']>>;
  sender: Scalars['String'];
};


/** mutation root */
export type MutationRootSendToQueueArgs = {
  messages_to_send: Array<InputMaybe<Scalars['json']>>;
  queue_name: Scalars['String'];
};


/** mutation root */
export type MutationRootSetDeviceForceUpdateMutationArgs = {
  device_uuid: Scalars['String'];
};


/** mutation root */
export type MutationRootSplitTransactionArgs = {
  new_transactions: Array<InputMaybe<NewTransactionsInput>>;
  original_transaction: Scalars['bigint'];
};


/** mutation root */
export type MutationRootStartGenerationOfSpecialLettersArgs = {
  body: Array<InputMaybe<Scalars['String']>>;
  languages_to_cases: Scalars['jsonb'];
  template: Scalars['String'];
};


/** mutation root */
export type MutationRootTolerateParkingResultApiArgs = {
  new_category?: InputMaybe<Scalars['String']>;
  parking_results_id: Scalars['String'];
  timestamp_out: Scalars['String'];
  toleration_issuer: Scalars['String'];
};


/** mutation root */
export type MutationRootTransferViolationCaseArgs = {
  new_company_violator?: InputMaybe<NewCompanyViolator>;
  new_person?: InputMaybe<NewPerson>;
  new_violation_case?: InputMaybe<NewViolationCase>;
  old_violation_case_changes?: InputMaybe<OldViolationCaseChanges>;
  old_violation_case_id: Scalars['bigint'];
  old_violation_case_status: Scalars['String'];
  transfer_reason: Scalars['String'];
};


/** mutation root */
export type MutationRootUnlinkTransactionArgs = {
  transaction_id: Scalars['bigint'];
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateAdyenReportArgs = {
  _inc?: InputMaybe<AdyenReportIncInput>;
  _set?: InputMaybe<AdyenReportSetInput>;
  where: AdyenReportBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdyenReportByPkArgs = {
  _inc?: InputMaybe<AdyenReportIncInput>;
  _set?: InputMaybe<AdyenReportSetInput>;
  pk_columns: AdyenReportPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdyenReportManyArgs = {
  updates: Array<AdyenReportUpdates>;
};


/** mutation root */
export type MutationRootUpdateAdyenTransactionArgs = {
  _inc?: InputMaybe<AdyenTransactionIncInput>;
  _set?: InputMaybe<AdyenTransactionSetInput>;
  where: AdyenTransactionBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdyenTransactionByPkArgs = {
  _inc?: InputMaybe<AdyenTransactionIncInput>;
  _set?: InputMaybe<AdyenTransactionSetInput>;
  pk_columns: AdyenTransactionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdyenTransactionManyArgs = {
  updates: Array<AdyenTransactionUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppliedPermitArgs = {
  _inc?: InputMaybe<AppliedPermitIncInput>;
  _set?: InputMaybe<AppliedPermitSetInput>;
  where: AppliedPermitBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppliedPermitByPkArgs = {
  _inc?: InputMaybe<AppliedPermitIncInput>;
  _set?: InputMaybe<AppliedPermitSetInput>;
  pk_columns: AppliedPermitPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppliedPermitManyArgs = {
  updates: Array<AppliedPermitUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppliedWhitelistArgs = {
  _inc?: InputMaybe<AppliedWhitelistIncInput>;
  _set?: InputMaybe<AppliedWhitelistSetInput>;
  where: AppliedWhitelistBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppliedWhitelistByPkArgs = {
  _inc?: InputMaybe<AppliedWhitelistIncInput>;
  _set?: InputMaybe<AppliedWhitelistSetInput>;
  pk_columns: AppliedWhitelistPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppliedWhitelistManyArgs = {
  updates: Array<AppliedWhitelistUpdates>;
};


/** mutation root */
export type MutationRootUpdateAuditLoggedActionsArgs = {
  _append?: InputMaybe<AuditLoggedActionsAppendInput>;
  _delete_at_path?: InputMaybe<AuditLoggedActionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AuditLoggedActionsDeleteElemInput>;
  _delete_key?: InputMaybe<AuditLoggedActionsDeleteKeyInput>;
  _inc?: InputMaybe<AuditLoggedActionsIncInput>;
  _prepend?: InputMaybe<AuditLoggedActionsPrependInput>;
  _set?: InputMaybe<AuditLoggedActionsSetInput>;
  where: AuditLoggedActionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAuditLoggedActionsByPkArgs = {
  _append?: InputMaybe<AuditLoggedActionsAppendInput>;
  _delete_at_path?: InputMaybe<AuditLoggedActionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AuditLoggedActionsDeleteElemInput>;
  _delete_key?: InputMaybe<AuditLoggedActionsDeleteKeyInput>;
  _inc?: InputMaybe<AuditLoggedActionsIncInput>;
  _prepend?: InputMaybe<AuditLoggedActionsPrependInput>;
  _set?: InputMaybe<AuditLoggedActionsSetInput>;
  pk_columns: AuditLoggedActionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAuditLoggedActionsManyArgs = {
  updates: Array<AuditLoggedActionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAuth0UserArgs = {
  _set?: InputMaybe<UpdateUserData>;
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateBlacklistArgs = {
  _inc?: InputMaybe<BlacklistIncInput>;
  _set?: InputMaybe<BlacklistSetInput>;
  where: BlacklistBoolExp;
};


/** mutation root */
export type MutationRootUpdateBlacklistByPkArgs = {
  _inc?: InputMaybe<BlacklistIncInput>;
  _set?: InputMaybe<BlacklistSetInput>;
  pk_columns: BlacklistPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBlacklistManyArgs = {
  updates: Array<BlacklistUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingBookingArgs = {
  _inc?: InputMaybe<BookingBookingIncInput>;
  _set?: InputMaybe<BookingBookingSetInput>;
  where: BookingBookingBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingBookingByPkArgs = {
  _inc?: InputMaybe<BookingBookingIncInput>;
  _set?: InputMaybe<BookingBookingSetInput>;
  pk_columns: BookingBookingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingBookingInvoiceArgs = {
  _inc?: InputMaybe<BookingBookingInvoiceIncInput>;
  _set?: InputMaybe<BookingBookingInvoiceSetInput>;
  where: BookingBookingInvoiceBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingBookingInvoiceByPkArgs = {
  _inc?: InputMaybe<BookingBookingInvoiceIncInput>;
  _set?: InputMaybe<BookingBookingInvoiceSetInput>;
  pk_columns: BookingBookingInvoicePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingBookingInvoiceManyArgs = {
  updates: Array<BookingBookingInvoiceUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingBookingManyArgs = {
  updates: Array<BookingBookingUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingBookingPlateArgs = {
  _inc?: InputMaybe<BookingBookingPlateIncInput>;
  _set?: InputMaybe<BookingBookingPlateSetInput>;
  where: BookingBookingPlateBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingBookingPlateByPkArgs = {
  _inc?: InputMaybe<BookingBookingPlateIncInput>;
  _set?: InputMaybe<BookingBookingPlateSetInput>;
  pk_columns: BookingBookingPlatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingBookingPlateManyArgs = {
  updates: Array<BookingBookingPlateUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingBookingTypeArgs = {
  _set?: InputMaybe<BookingBookingTypeSetInput>;
  where: BookingBookingTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingBookingTypeByPkArgs = {
  _set?: InputMaybe<BookingBookingTypeSetInput>;
  pk_columns: BookingBookingTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingBookingTypeManyArgs = {
  updates: Array<BookingBookingTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingBookingWhitelistArgs = {
  _inc?: InputMaybe<BookingBookingWhitelistIncInput>;
  _set?: InputMaybe<BookingBookingWhitelistSetInput>;
  where: BookingBookingWhitelistBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingBookingWhitelistByPkArgs = {
  _inc?: InputMaybe<BookingBookingWhitelistIncInput>;
  _set?: InputMaybe<BookingBookingWhitelistSetInput>;
  pk_columns: BookingBookingWhitelistPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingBookingWhitelistManyArgs = {
  updates: Array<BookingBookingWhitelistUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingEnumBookingStatusArgs = {
  _set?: InputMaybe<BookingEnumBookingStatusSetInput>;
  where: BookingEnumBookingStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingEnumBookingStatusByPkArgs = {
  _set?: InputMaybe<BookingEnumBookingStatusSetInput>;
  pk_columns: BookingEnumBookingStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingEnumBookingStatusManyArgs = {
  updates: Array<BookingEnumBookingStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingHourlyBookingArgs = {
  _inc?: InputMaybe<BookingHourlyBookingIncInput>;
  _set?: InputMaybe<BookingHourlyBookingSetInput>;
  where: BookingHourlyBookingBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingHourlyBookingByPkArgs = {
  _inc?: InputMaybe<BookingHourlyBookingIncInput>;
  _set?: InputMaybe<BookingHourlyBookingSetInput>;
  pk_columns: BookingHourlyBookingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingHourlyBookingManyArgs = {
  updates: Array<BookingHourlyBookingUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingLicensePlateArgs = {
  _set?: InputMaybe<BookingLicensePlateSetInput>;
  where: BookingLicensePlateBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingLicensePlateByPkArgs = {
  _set?: InputMaybe<BookingLicensePlateSetInput>;
  pk_columns: BookingLicensePlatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingLicensePlateManyArgs = {
  updates: Array<BookingLicensePlateUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingLotArgs = {
  _set?: InputMaybe<BookingLotSetInput>;
  where: BookingLotBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingLotByPkArgs = {
  _set?: InputMaybe<BookingLotSetInput>;
  pk_columns: BookingLotPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingLotConfigurationArgs = {
  _append?: InputMaybe<BookingLotConfigurationAppendInput>;
  _delete_at_path?: InputMaybe<BookingLotConfigurationDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingLotConfigurationDeleteElemInput>;
  _delete_key?: InputMaybe<BookingLotConfigurationDeleteKeyInput>;
  _inc?: InputMaybe<BookingLotConfigurationIncInput>;
  _prepend?: InputMaybe<BookingLotConfigurationPrependInput>;
  _set?: InputMaybe<BookingLotConfigurationSetInput>;
  where: BookingLotConfigurationBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingLotConfigurationByPkArgs = {
  _append?: InputMaybe<BookingLotConfigurationAppendInput>;
  _delete_at_path?: InputMaybe<BookingLotConfigurationDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingLotConfigurationDeleteElemInput>;
  _delete_key?: InputMaybe<BookingLotConfigurationDeleteKeyInput>;
  _inc?: InputMaybe<BookingLotConfigurationIncInput>;
  _prepend?: InputMaybe<BookingLotConfigurationPrependInput>;
  _set?: InputMaybe<BookingLotConfigurationSetInput>;
  pk_columns: BookingLotConfigurationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingLotConfigurationManyArgs = {
  updates: Array<BookingLotConfigurationUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingLotManyArgs = {
  updates: Array<BookingLotUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingPaymentArgs = {
  _append?: InputMaybe<BookingPaymentAppendInput>;
  _delete_at_path?: InputMaybe<BookingPaymentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingPaymentDeleteElemInput>;
  _delete_key?: InputMaybe<BookingPaymentDeleteKeyInput>;
  _inc?: InputMaybe<BookingPaymentIncInput>;
  _prepend?: InputMaybe<BookingPaymentPrependInput>;
  _set?: InputMaybe<BookingPaymentSetInput>;
  where: BookingPaymentBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingPaymentByPkArgs = {
  _append?: InputMaybe<BookingPaymentAppendInput>;
  _delete_at_path?: InputMaybe<BookingPaymentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingPaymentDeleteElemInput>;
  _delete_key?: InputMaybe<BookingPaymentDeleteKeyInput>;
  _inc?: InputMaybe<BookingPaymentIncInput>;
  _prepend?: InputMaybe<BookingPaymentPrependInput>;
  _set?: InputMaybe<BookingPaymentSetInput>;
  pk_columns: BookingPaymentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingPaymentManyArgs = {
  updates: Array<BookingPaymentUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingPricingRulesArgs = {
  _append?: InputMaybe<BookingPricingRulesAppendInput>;
  _delete_at_path?: InputMaybe<BookingPricingRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingPricingRulesDeleteElemInput>;
  _delete_key?: InputMaybe<BookingPricingRulesDeleteKeyInput>;
  _inc?: InputMaybe<BookingPricingRulesIncInput>;
  _prepend?: InputMaybe<BookingPricingRulesPrependInput>;
  _set?: InputMaybe<BookingPricingRulesSetInput>;
  where: BookingPricingRulesBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingPricingRulesByPkArgs = {
  _append?: InputMaybe<BookingPricingRulesAppendInput>;
  _delete_at_path?: InputMaybe<BookingPricingRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingPricingRulesDeleteElemInput>;
  _delete_key?: InputMaybe<BookingPricingRulesDeleteKeyInput>;
  _inc?: InputMaybe<BookingPricingRulesIncInput>;
  _prepend?: InputMaybe<BookingPricingRulesPrependInput>;
  _set?: InputMaybe<BookingPricingRulesSetInput>;
  pk_columns: BookingPricingRulesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingPricingRulesManyArgs = {
  updates: Array<BookingPricingRulesUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingPricingTypeArgs = {
  _set?: InputMaybe<BookingPricingTypeSetInput>;
  where: BookingPricingTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingPricingTypeByPkArgs = {
  _set?: InputMaybe<BookingPricingTypeSetInput>;
  pk_columns: BookingPricingTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingPricingTypeManyArgs = {
  updates: Array<BookingPricingTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingPrivatePricingUserArgs = {
  _inc?: InputMaybe<BookingPrivatePricingUserIncInput>;
  _set?: InputMaybe<BookingPrivatePricingUserSetInput>;
  where: BookingPrivatePricingUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingPrivatePricingUserByPkArgs = {
  _inc?: InputMaybe<BookingPrivatePricingUserIncInput>;
  _set?: InputMaybe<BookingPrivatePricingUserSetInput>;
  pk_columns: BookingPrivatePricingUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingPrivatePricingUserManyArgs = {
  updates: Array<BookingPrivatePricingUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingRecurringBookingArgs = {
  _inc?: InputMaybe<BookingRecurringBookingIncInput>;
  _set?: InputMaybe<BookingRecurringBookingSetInput>;
  where: BookingRecurringBookingBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingRecurringBookingByPkArgs = {
  _inc?: InputMaybe<BookingRecurringBookingIncInput>;
  _set?: InputMaybe<BookingRecurringBookingSetInput>;
  pk_columns: BookingRecurringBookingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingRecurringBookingManyArgs = {
  updates: Array<BookingRecurringBookingUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionBookingArgs = {
  _inc?: InputMaybe<BookingSubscriptionBookingIncInput>;
  _set?: InputMaybe<BookingSubscriptionBookingSetInput>;
  where: BookingSubscriptionBookingBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionBookingByPkArgs = {
  _inc?: InputMaybe<BookingSubscriptionBookingIncInput>;
  _set?: InputMaybe<BookingSubscriptionBookingSetInput>;
  pk_columns: BookingSubscriptionBookingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionBookingManyArgs = {
  updates: Array<BookingSubscriptionBookingUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionLicensePlateArgs = {
  _set?: InputMaybe<BookingSubscriptionLicensePlateSetInput>;
  where: BookingSubscriptionLicensePlateBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionLicensePlateByPkArgs = {
  _set?: InputMaybe<BookingSubscriptionLicensePlateSetInput>;
  pk_columns: BookingSubscriptionLicensePlatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionLicensePlateManyArgs = {
  updates: Array<BookingSubscriptionLicensePlateUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionStatusArgs = {
  _set?: InputMaybe<BookingSubscriptionStatusSetInput>;
  where: BookingSubscriptionStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionStatusByPkArgs = {
  _set?: InputMaybe<BookingSubscriptionStatusSetInput>;
  pk_columns: BookingSubscriptionStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingSubscriptionStatusManyArgs = {
  updates: Array<BookingSubscriptionStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingUserArgs = {
  _set?: InputMaybe<BookingUserSetInput>;
  where: BookingUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingUserBookingArgs = {
  _inc?: InputMaybe<BookingUserBookingIncInput>;
  _set?: InputMaybe<BookingUserBookingSetInput>;
  where: BookingUserBookingBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingUserBookingByPkArgs = {
  _inc?: InputMaybe<BookingUserBookingIncInput>;
  _set?: InputMaybe<BookingUserBookingSetInput>;
  pk_columns: BookingUserBookingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingUserBookingManyArgs = {
  updates: Array<BookingUserBookingUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingUserByPkArgs = {
  _set?: InputMaybe<BookingUserSetInput>;
  pk_columns: BookingUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingUserManyArgs = {
  updates: Array<BookingUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingUserPaymentMethodArgs = {
  _append?: InputMaybe<BookingUserPaymentMethodAppendInput>;
  _delete_at_path?: InputMaybe<BookingUserPaymentMethodDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingUserPaymentMethodDeleteElemInput>;
  _delete_key?: InputMaybe<BookingUserPaymentMethodDeleteKeyInput>;
  _prepend?: InputMaybe<BookingUserPaymentMethodPrependInput>;
  _set?: InputMaybe<BookingUserPaymentMethodSetInput>;
  where: BookingUserPaymentMethodBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingUserPaymentMethodByPkArgs = {
  _append?: InputMaybe<BookingUserPaymentMethodAppendInput>;
  _delete_at_path?: InputMaybe<BookingUserPaymentMethodDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BookingUserPaymentMethodDeleteElemInput>;
  _delete_key?: InputMaybe<BookingUserPaymentMethodDeleteKeyInput>;
  _prepend?: InputMaybe<BookingUserPaymentMethodPrependInput>;
  _set?: InputMaybe<BookingUserPaymentMethodSetInput>;
  pk_columns: BookingUserPaymentMethodPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingUserPaymentMethodManyArgs = {
  updates: Array<BookingUserPaymentMethodUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingUserSubscriptionArgs = {
  _set?: InputMaybe<BookingUserSubscriptionSetInput>;
  where: BookingUserSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingUserSubscriptionByPkArgs = {
  _set?: InputMaybe<BookingUserSubscriptionSetInput>;
  pk_columns: BookingUserSubscriptionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingUserSubscriptionManyArgs = {
  updates: Array<BookingUserSubscriptionUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleArgs = {
  _set?: InputMaybe<BookingVehicleSetInput>;
  where: BookingVehicleBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleByPkArgs = {
  _set?: InputMaybe<BookingVehicleSetInput>;
  pk_columns: BookingVehiclePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleManyArgs = {
  updates: Array<BookingVehicleUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleTypeArgs = {
  _set?: InputMaybe<BookingVehicleTypeSetInput>;
  where: BookingVehicleTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleTypeByPkArgs = {
  _set?: InputMaybe<BookingVehicleTypeSetInput>;
  pk_columns: BookingVehicleTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingVehicleTypeManyArgs = {
  updates: Array<BookingVehicleTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateBookingWhitelistTypeArgs = {
  _set?: InputMaybe<BookingWhitelistTypeSetInput>;
  where: BookingWhitelistTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateBookingWhitelistTypeByPkArgs = {
  _set?: InputMaybe<BookingWhitelistTypeSetInput>;
  pk_columns: BookingWhitelistTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBookingWhitelistTypeManyArgs = {
  updates: Array<BookingWhitelistTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateCalendarEventPolicyArgs = {
  _inc?: InputMaybe<CalendarEventPolicyIncInput>;
  _set?: InputMaybe<CalendarEventPolicySetInput>;
  where: CalendarEventPolicyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCalendarEventPolicyByPkArgs = {
  _inc?: InputMaybe<CalendarEventPolicyIncInput>;
  _set?: InputMaybe<CalendarEventPolicySetInput>;
  pk_columns: CalendarEventPolicyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCalendarEventPolicyManyArgs = {
  updates: Array<CalendarEventPolicyUpdates>;
};


/** mutation root */
export type MutationRootUpdateCancellationsArgs = {
  _append?: InputMaybe<CancellationsAppendInput>;
  _delete_at_path?: InputMaybe<CancellationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CancellationsDeleteElemInput>;
  _delete_key?: InputMaybe<CancellationsDeleteKeyInput>;
  _inc?: InputMaybe<CancellationsIncInput>;
  _prepend?: InputMaybe<CancellationsPrependInput>;
  _set?: InputMaybe<CancellationsSetInput>;
  where: CancellationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCancellationsByPkArgs = {
  _append?: InputMaybe<CancellationsAppendInput>;
  _delete_at_path?: InputMaybe<CancellationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CancellationsDeleteElemInput>;
  _delete_key?: InputMaybe<CancellationsDeleteKeyInput>;
  _inc?: InputMaybe<CancellationsIncInput>;
  _prepend?: InputMaybe<CancellationsPrependInput>;
  _set?: InputMaybe<CancellationsSetInput>;
  pk_columns: CancellationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCancellationsManyArgs = {
  updates: Array<CancellationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarDriverArgs = {
  _inc?: InputMaybe<CarDriverIncInput>;
  _set?: InputMaybe<CarDriverSetInput>;
  where: CarDriverBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarDriverByPkArgs = {
  _inc?: InputMaybe<CarDriverIncInput>;
  _set?: InputMaybe<CarDriverSetInput>;
  pk_columns: CarDriverPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarDriverManyArgs = {
  updates: Array<CarDriverUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarOwnerArgs = {
  _inc?: InputMaybe<CarOwnerIncInput>;
  _set?: InputMaybe<CarOwnerSetInput>;
  where: CarOwnerBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarOwnerByPkArgs = {
  _inc?: InputMaybe<CarOwnerIncInput>;
  _set?: InputMaybe<CarOwnerSetInput>;
  pk_columns: CarOwnerPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarOwnerManyArgs = {
  updates: Array<CarOwnerUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarOwnerRequestsArgs = {
  _inc?: InputMaybe<CarOwnerRequestsIncInput>;
  _set?: InputMaybe<CarOwnerRequestsSetInput>;
  where: CarOwnerRequestsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarOwnerRequestsByPkArgs = {
  _inc?: InputMaybe<CarOwnerRequestsIncInput>;
  _set?: InputMaybe<CarOwnerRequestsSetInput>;
  pk_columns: CarOwnerRequestsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarOwnerRequestsManyArgs = {
  updates: Array<CarOwnerRequestsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayAccessControlLpPinArgs = {
  _inc?: InputMaybe<CarpayAccessControlLpPinIncInput>;
  _set?: InputMaybe<CarpayAccessControlLpPinSetInput>;
  where: CarpayAccessControlLpPinBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayAccessControlLpPinByPkArgs = {
  _inc?: InputMaybe<CarpayAccessControlLpPinIncInput>;
  _set?: InputMaybe<CarpayAccessControlLpPinSetInput>;
  pk_columns: CarpayAccessControlLpPinPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayAccessControlLpPinManyArgs = {
  updates: Array<CarpayAccessControlLpPinUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountBatchArgs = {
  _append?: InputMaybe<CarpayDiscountBatchAppendInput>;
  _delete_at_path?: InputMaybe<CarpayDiscountBatchDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayDiscountBatchDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayDiscountBatchDeleteKeyInput>;
  _inc?: InputMaybe<CarpayDiscountBatchIncInput>;
  _prepend?: InputMaybe<CarpayDiscountBatchPrependInput>;
  _set?: InputMaybe<CarpayDiscountBatchSetInput>;
  where: CarpayDiscountBatchBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountBatchByPkArgs = {
  _append?: InputMaybe<CarpayDiscountBatchAppendInput>;
  _delete_at_path?: InputMaybe<CarpayDiscountBatchDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayDiscountBatchDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayDiscountBatchDeleteKeyInput>;
  _inc?: InputMaybe<CarpayDiscountBatchIncInput>;
  _prepend?: InputMaybe<CarpayDiscountBatchPrependInput>;
  _set?: InputMaybe<CarpayDiscountBatchSetInput>;
  pk_columns: CarpayDiscountBatchPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountBatchManyArgs = {
  updates: Array<CarpayDiscountBatchUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountModelArgs = {
  _append?: InputMaybe<CarpayDiscountModelAppendInput>;
  _delete_at_path?: InputMaybe<CarpayDiscountModelDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayDiscountModelDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayDiscountModelDeleteKeyInput>;
  _inc?: InputMaybe<CarpayDiscountModelIncInput>;
  _prepend?: InputMaybe<CarpayDiscountModelPrependInput>;
  _set?: InputMaybe<CarpayDiscountModelSetInput>;
  where: CarpayDiscountModelBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountModelByPkArgs = {
  _append?: InputMaybe<CarpayDiscountModelAppendInput>;
  _delete_at_path?: InputMaybe<CarpayDiscountModelDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayDiscountModelDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayDiscountModelDeleteKeyInput>;
  _inc?: InputMaybe<CarpayDiscountModelIncInput>;
  _prepend?: InputMaybe<CarpayDiscountModelPrependInput>;
  _set?: InputMaybe<CarpayDiscountModelSetInput>;
  pk_columns: CarpayDiscountModelPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayDiscountModelManyArgs = {
  updates: Array<CarpayDiscountModelUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayLotArgs = {
  _append?: InputMaybe<CarpayLotAppendInput>;
  _delete_at_path?: InputMaybe<CarpayLotDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayLotDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayLotDeleteKeyInput>;
  _prepend?: InputMaybe<CarpayLotPrependInput>;
  _set?: InputMaybe<CarpayLotSetInput>;
  where: CarpayLotBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayLotByPkArgs = {
  _append?: InputMaybe<CarpayLotAppendInput>;
  _delete_at_path?: InputMaybe<CarpayLotDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayLotDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayLotDeleteKeyInput>;
  _prepend?: InputMaybe<CarpayLotPrependInput>;
  _set?: InputMaybe<CarpayLotSetInput>;
  pk_columns: CarpayLotPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayLotManyArgs = {
  updates: Array<CarpayLotUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriberArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriberIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriberSetInput>;
  where: CarpayNotificationSubscriberBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriberByPkArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriberIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriberSetInput>;
  pk_columns: CarpayNotificationSubscriberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriberManyArgs = {
  updates: Array<CarpayNotificationSubscriberUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriptionIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriptionSetInput>;
  where: CarpayNotificationSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionByPkArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriptionIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriptionSetInput>;
  pk_columns: CarpayNotificationSubscriptionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionCategoryArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriptionCategoryIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriptionCategorySetInput>;
  where: CarpayNotificationSubscriptionCategoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionCategoryByPkArgs = {
  _inc?: InputMaybe<CarpayNotificationSubscriptionCategoryIncInput>;
  _set?: InputMaybe<CarpayNotificationSubscriptionCategorySetInput>;
  pk_columns: CarpayNotificationSubscriptionCategoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionCategoryManyArgs = {
  updates: Array<CarpayNotificationSubscriptionCategoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayNotificationSubscriptionManyArgs = {
  updates: Array<CarpayNotificationSubscriptionUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderArgs = {
  _append?: InputMaybe<CarpayOrderAppendInput>;
  _delete_at_path?: InputMaybe<CarpayOrderDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayOrderDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayOrderDeleteKeyInput>;
  _inc?: InputMaybe<CarpayOrderIncInput>;
  _prepend?: InputMaybe<CarpayOrderPrependInput>;
  _set?: InputMaybe<CarpayOrderSetInput>;
  where: CarpayOrderBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderByPkArgs = {
  _append?: InputMaybe<CarpayOrderAppendInput>;
  _delete_at_path?: InputMaybe<CarpayOrderDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayOrderDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayOrderDeleteKeyInput>;
  _inc?: InputMaybe<CarpayOrderIncInput>;
  _prepend?: InputMaybe<CarpayOrderPrependInput>;
  _set?: InputMaybe<CarpayOrderSetInput>;
  pk_columns: CarpayOrderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderManyArgs = {
  updates: Array<CarpayOrderUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderMatchesArgs = {
  _inc?: InputMaybe<CarpayOrderMatchesIncInput>;
  _set?: InputMaybe<CarpayOrderMatchesSetInput>;
  where: CarpayOrderMatchesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderMatchesByPkArgs = {
  _inc?: InputMaybe<CarpayOrderMatchesIncInput>;
  _set?: InputMaybe<CarpayOrderMatchesSetInput>;
  pk_columns: CarpayOrderMatchesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderMatchesManyArgs = {
  updates: Array<CarpayOrderMatchesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderUserArgs = {
  _inc?: InputMaybe<CarpayOrderUserIncInput>;
  _set?: InputMaybe<CarpayOrderUserSetInput>;
  where: CarpayOrderUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderUserByPkArgs = {
  _inc?: InputMaybe<CarpayOrderUserIncInput>;
  _set?: InputMaybe<CarpayOrderUserSetInput>;
  pk_columns: CarpayOrderUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayOrderUserManyArgs = {
  updates: Array<CarpayOrderUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayParkingDetectionArgs = {
  _append?: InputMaybe<CarpayParkingDetectionAppendInput>;
  _delete_at_path?: InputMaybe<CarpayParkingDetectionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayParkingDetectionDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayParkingDetectionDeleteKeyInput>;
  _inc?: InputMaybe<CarpayParkingDetectionIncInput>;
  _prepend?: InputMaybe<CarpayParkingDetectionPrependInput>;
  _set?: InputMaybe<CarpayParkingDetectionSetInput>;
  where: CarpayParkingDetectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayParkingDetectionByPkArgs = {
  _append?: InputMaybe<CarpayParkingDetectionAppendInput>;
  _delete_at_path?: InputMaybe<CarpayParkingDetectionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayParkingDetectionDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayParkingDetectionDeleteKeyInput>;
  _inc?: InputMaybe<CarpayParkingDetectionIncInput>;
  _prepend?: InputMaybe<CarpayParkingDetectionPrependInput>;
  _set?: InputMaybe<CarpayParkingDetectionSetInput>;
  pk_columns: CarpayParkingDetectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayParkingDetectionManyArgs = {
  updates: Array<CarpayParkingDetectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingArgs = {
  _append?: InputMaybe<CarpayPricingAppendInput>;
  _delete_at_path?: InputMaybe<CarpayPricingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayPricingDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayPricingDeleteKeyInput>;
  _inc?: InputMaybe<CarpayPricingIncInput>;
  _prepend?: InputMaybe<CarpayPricingPrependInput>;
  _set?: InputMaybe<CarpayPricingSetInput>;
  where: CarpayPricingBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingByPkArgs = {
  _append?: InputMaybe<CarpayPricingAppendInput>;
  _delete_at_path?: InputMaybe<CarpayPricingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayPricingDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayPricingDeleteKeyInput>;
  _inc?: InputMaybe<CarpayPricingIncInput>;
  _prepend?: InputMaybe<CarpayPricingPrependInput>;
  _set?: InputMaybe<CarpayPricingSetInput>;
  pk_columns: CarpayPricingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingConfigGroupArgs = {
  _inc?: InputMaybe<CarpayPricingConfigGroupIncInput>;
  _set?: InputMaybe<CarpayPricingConfigGroupSetInput>;
  where: CarpayPricingConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingConfigGroupByPkArgs = {
  _inc?: InputMaybe<CarpayPricingConfigGroupIncInput>;
  _set?: InputMaybe<CarpayPricingConfigGroupSetInput>;
  pk_columns: CarpayPricingConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingConfigGroupManyArgs = {
  updates: Array<CarpayPricingConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingManyArgs = {
  updates: Array<CarpayPricingUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingPeriodArgs = {
  _inc?: InputMaybe<CarpayPricingPeriodIncInput>;
  _set?: InputMaybe<CarpayPricingPeriodSetInput>;
  where: CarpayPricingPeriodBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingPeriodByPkArgs = {
  _inc?: InputMaybe<CarpayPricingPeriodIncInput>;
  _set?: InputMaybe<CarpayPricingPeriodSetInput>;
  pk_columns: CarpayPricingPeriodPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingPeriodManyArgs = {
  updates: Array<CarpayPricingPeriodUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRecurrenceArgs = {
  _inc?: InputMaybe<CarpayPricingRecurrenceIncInput>;
  _set?: InputMaybe<CarpayPricingRecurrenceSetInput>;
  where: CarpayPricingRecurrenceBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRecurrenceByPkArgs = {
  _inc?: InputMaybe<CarpayPricingRecurrenceIncInput>;
  _set?: InputMaybe<CarpayPricingRecurrenceSetInput>;
  pk_columns: CarpayPricingRecurrencePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRecurrenceManyArgs = {
  updates: Array<CarpayPricingRecurrenceUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRulesArgs = {
  _append?: InputMaybe<CarpayPricingRulesAppendInput>;
  _delete_at_path?: InputMaybe<CarpayPricingRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayPricingRulesDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayPricingRulesDeleteKeyInput>;
  _inc?: InputMaybe<CarpayPricingRulesIncInput>;
  _prepend?: InputMaybe<CarpayPricingRulesPrependInput>;
  _set?: InputMaybe<CarpayPricingRulesSetInput>;
  where: CarpayPricingRulesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRulesByPkArgs = {
  _append?: InputMaybe<CarpayPricingRulesAppendInput>;
  _delete_at_path?: InputMaybe<CarpayPricingRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayPricingRulesDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayPricingRulesDeleteKeyInput>;
  _inc?: InputMaybe<CarpayPricingRulesIncInput>;
  _prepend?: InputMaybe<CarpayPricingRulesPrependInput>;
  _set?: InputMaybe<CarpayPricingRulesSetInput>;
  pk_columns: CarpayPricingRulesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayPricingRulesManyArgs = {
  updates: Array<CarpayPricingRulesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayScannedCodesArgs = {
  _append?: InputMaybe<CarpayScannedCodesAppendInput>;
  _delete_at_path?: InputMaybe<CarpayScannedCodesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayScannedCodesDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayScannedCodesDeleteKeyInput>;
  _inc?: InputMaybe<CarpayScannedCodesIncInput>;
  _prepend?: InputMaybe<CarpayScannedCodesPrependInput>;
  _set?: InputMaybe<CarpayScannedCodesSetInput>;
  where: CarpayScannedCodesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayScannedCodesByPkArgs = {
  _append?: InputMaybe<CarpayScannedCodesAppendInput>;
  _delete_at_path?: InputMaybe<CarpayScannedCodesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CarpayScannedCodesDeleteElemInput>;
  _delete_key?: InputMaybe<CarpayScannedCodesDeleteKeyInput>;
  _inc?: InputMaybe<CarpayScannedCodesIncInput>;
  _prepend?: InputMaybe<CarpayScannedCodesPrependInput>;
  _set?: InputMaybe<CarpayScannedCodesSetInput>;
  pk_columns: CarpayScannedCodesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayScannedCodesManyArgs = {
  updates: Array<CarpayScannedCodesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashCutNotificationArgs = {
  _inc?: InputMaybe<CarpayTerminalCashCutNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalCashCutNotificationSetInput>;
  where: CarpayTerminalCashCutNotificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashCutNotificationByPkArgs = {
  _inc?: InputMaybe<CarpayTerminalCashCutNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalCashCutNotificationSetInput>;
  pk_columns: CarpayTerminalCashCutNotificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashCutNotificationManyArgs = {
  updates: Array<CarpayTerminalCashCutNotificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashFillLevelNotificationArgs = {
  _inc?: InputMaybe<CarpayTerminalCashFillLevelNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalCashFillLevelNotificationSetInput>;
  where: CarpayTerminalCashFillLevelNotificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashFillLevelNotificationByPkArgs = {
  _inc?: InputMaybe<CarpayTerminalCashFillLevelNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalCashFillLevelNotificationSetInput>;
  pk_columns: CarpayTerminalCashFillLevelNotificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalCashFillLevelNotificationManyArgs = {
  updates: Array<CarpayTerminalCashFillLevelNotificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalNotificationConfigArgs = {
  _inc?: InputMaybe<CarpayTerminalNotificationConfigIncInput>;
  _set?: InputMaybe<CarpayTerminalNotificationConfigSetInput>;
  where: CarpayTerminalNotificationConfigBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalNotificationConfigByPkArgs = {
  _inc?: InputMaybe<CarpayTerminalNotificationConfigIncInput>;
  _set?: InputMaybe<CarpayTerminalNotificationConfigSetInput>;
  pk_columns: CarpayTerminalNotificationConfigPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalNotificationConfigManyArgs = {
  updates: Array<CarpayTerminalNotificationConfigUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalPrinterStatusNotificationArgs = {
  _inc?: InputMaybe<CarpayTerminalPrinterStatusNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalPrinterStatusNotificationSetInput>;
  where: CarpayTerminalPrinterStatusNotificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalPrinterStatusNotificationByPkArgs = {
  _inc?: InputMaybe<CarpayTerminalPrinterStatusNotificationIncInput>;
  _set?: InputMaybe<CarpayTerminalPrinterStatusNotificationSetInput>;
  pk_columns: CarpayTerminalPrinterStatusNotificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayTerminalPrinterStatusNotificationManyArgs = {
  updates: Array<CarpayTerminalPrinterStatusNotificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateCarpayUserVerifiedPlateArgs = {
  _set?: InputMaybe<CarpayUserVerifiedPlateSetInput>;
  where: CarpayUserVerifiedPlateBoolExp;
};


/** mutation root */
export type MutationRootUpdateCarpayUserVerifiedPlateByPkArgs = {
  _set?: InputMaybe<CarpayUserVerifiedPlateSetInput>;
  pk_columns: CarpayUserVerifiedPlatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCarpayUserVerifiedPlateManyArgs = {
  updates: Array<CarpayUserVerifiedPlateUpdates>;
};


/** mutation root */
export type MutationRootUpdateChainArgs = {
  _set?: InputMaybe<ChainSetInput>;
  where: ChainBoolExp;
};


/** mutation root */
export type MutationRootUpdateChainByPkArgs = {
  _set?: InputMaybe<ChainSetInput>;
  pk_columns: ChainPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateChainManyArgs = {
  updates: Array<ChainUpdates>;
};


/** mutation root */
export type MutationRootUpdateCityCodesArgs = {
  _inc?: InputMaybe<CityCodesIncInput>;
  _set?: InputMaybe<CityCodesSetInput>;
  where: CityCodesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCityCodesManyArgs = {
  updates: Array<CityCodesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyArgs = {
  _set?: InputMaybe<CompanySetInput>;
  where: CompanyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyByPkArgs = {
  _set?: InputMaybe<CompanySetInput>;
  pk_columns: CompanyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyConfigGroupArgs = {
  _inc?: InputMaybe<CompanyConfigGroupIncInput>;
  _set?: InputMaybe<CompanyConfigGroupSetInput>;
  where: CompanyConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyConfigGroupByPkArgs = {
  _inc?: InputMaybe<CompanyConfigGroupIncInput>;
  _set?: InputMaybe<CompanyConfigGroupSetInput>;
  pk_columns: CompanyConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyConfigGroupManyArgs = {
  updates: Array<CompanyConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyHierarchyArgs = {
  _inc?: InputMaybe<CompanyHierarchyIncInput>;
  _set?: InputMaybe<CompanyHierarchySetInput>;
  where: CompanyHierarchyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyHierarchyByPkArgs = {
  _inc?: InputMaybe<CompanyHierarchyIncInput>;
  _set?: InputMaybe<CompanyHierarchySetInput>;
  pk_columns: CompanyHierarchyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyHierarchyManyArgs = {
  updates: Array<CompanyHierarchyUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyLotSectionArgs = {
  _inc?: InputMaybe<CompanyLotSectionIncInput>;
  _set?: InputMaybe<CompanyLotSectionSetInput>;
  where: CompanyLotSectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyLotSectionByPkArgs = {
  _inc?: InputMaybe<CompanyLotSectionIncInput>;
  _set?: InputMaybe<CompanyLotSectionSetInput>;
  pk_columns: CompanyLotSectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyLotSectionManyArgs = {
  updates: Array<CompanyLotSectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyManyArgs = {
  updates: Array<CompanyUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyVatIdArgs = {
  _set?: InputMaybe<CompanyVatIdSetInput>;
  where: CompanyVatIdBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyVatIdByPkArgs = {
  _set?: InputMaybe<CompanyVatIdSetInput>;
  pk_columns: CompanyVatIdPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyVatIdManyArgs = {
  updates: Array<CompanyVatIdUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyViolatorArgs = {
  _inc?: InputMaybe<CompanyViolatorIncInput>;
  _set?: InputMaybe<CompanyViolatorSetInput>;
  where: CompanyViolatorBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyViolatorByPkArgs = {
  _inc?: InputMaybe<CompanyViolatorIncInput>;
  _set?: InputMaybe<CompanyViolatorSetInput>;
  pk_columns: CompanyViolatorPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyViolatorManyArgs = {
  updates: Array<CompanyViolatorUpdates>;
};


/** mutation root */
export type MutationRootUpdateConfigGroupArgs = {
  _inc?: InputMaybe<ConfigGroupIncInput>;
  _set?: InputMaybe<ConfigGroupSetInput>;
  where: ConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateConfigGroupByPkArgs = {
  _inc?: InputMaybe<ConfigGroupIncInput>;
  _set?: InputMaybe<ConfigGroupSetInput>;
  pk_columns: ConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateConfigGroupManyArgs = {
  updates: Array<ConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateCountryArgs = {
  _inc?: InputMaybe<CountryIncInput>;
  _set?: InputMaybe<CountrySetInput>;
  where: CountryBoolExp;
};


/** mutation root */
export type MutationRootUpdateCountryByPkArgs = {
  _inc?: InputMaybe<CountryIncInput>;
  _set?: InputMaybe<CountrySetInput>;
  pk_columns: CountryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCountryManyArgs = {
  updates: Array<CountryUpdates>;
};


/** mutation root */
export type MutationRootUpdateCurrencyArgs = {
  _inc?: InputMaybe<CurrencyIncInput>;
  _set?: InputMaybe<CurrencySetInput>;
  where: CurrencyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCurrencyByPkArgs = {
  _inc?: InputMaybe<CurrencyIncInput>;
  _set?: InputMaybe<CurrencySetInput>;
  pk_columns: CurrencyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCurrencyManyArgs = {
  updates: Array<CurrencyUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomerDashboardNpsFeedbackArgs = {
  _inc?: InputMaybe<CustomerDashboardNpsFeedbackIncInput>;
  _set?: InputMaybe<CustomerDashboardNpsFeedbackSetInput>;
  where: CustomerDashboardNpsFeedbackBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomerDashboardNpsFeedbackByPkArgs = {
  _inc?: InputMaybe<CustomerDashboardNpsFeedbackIncInput>;
  _set?: InputMaybe<CustomerDashboardNpsFeedbackSetInput>;
  pk_columns: CustomerDashboardNpsFeedbackPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomerDashboardNpsFeedbackManyArgs = {
  updates: Array<CustomerDashboardNpsFeedbackUpdates>;
};


/** mutation root */
export type MutationRootUpdateDailyFailureArgs = {
  _inc?: InputMaybe<DailyFailureIncInput>;
  _set?: InputMaybe<DailyFailureSetInput>;
  where: DailyFailureBoolExp;
};


/** mutation root */
export type MutationRootUpdateDailyFailureByPkArgs = {
  _inc?: InputMaybe<DailyFailureIncInput>;
  _set?: InputMaybe<DailyFailureSetInput>;
  pk_columns: DailyFailurePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDailyFailureManyArgs = {
  updates: Array<DailyFailureUpdates>;
};


/** mutation root */
export type MutationRootUpdateDailyStatsArgs = {
  _inc?: InputMaybe<DailyStatsIncInput>;
  _set?: InputMaybe<DailyStatsSetInput>;
  where: DailyStatsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDailyStatsByPkArgs = {
  _inc?: InputMaybe<DailyStatsIncInput>;
  _set?: InputMaybe<DailyStatsSetInput>;
  pk_columns: DailyStatsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDailyStatsManyArgs = {
  updates: Array<DailyStatsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDepartmentArgs = {
  _append?: InputMaybe<DepartmentAppendInput>;
  _delete_at_path?: InputMaybe<DepartmentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DepartmentDeleteElemInput>;
  _delete_key?: InputMaybe<DepartmentDeleteKeyInput>;
  _inc?: InputMaybe<DepartmentIncInput>;
  _prepend?: InputMaybe<DepartmentPrependInput>;
  _set?: InputMaybe<DepartmentSetInput>;
  where: DepartmentBoolExp;
};


/** mutation root */
export type MutationRootUpdateDepartmentByPkArgs = {
  _append?: InputMaybe<DepartmentAppendInput>;
  _delete_at_path?: InputMaybe<DepartmentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DepartmentDeleteElemInput>;
  _delete_key?: InputMaybe<DepartmentDeleteKeyInput>;
  _inc?: InputMaybe<DepartmentIncInput>;
  _prepend?: InputMaybe<DepartmentPrependInput>;
  _set?: InputMaybe<DepartmentSetInput>;
  pk_columns: DepartmentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDepartmentManyArgs = {
  updates: Array<DepartmentUpdates>;
};


/** mutation root */
export type MutationRootUpdateDetectionTypeEnumArgs = {
  _inc?: InputMaybe<DetectionTypeEnumIncInput>;
  _set?: InputMaybe<DetectionTypeEnumSetInput>;
  where: DetectionTypeEnumBoolExp;
};


/** mutation root */
export type MutationRootUpdateDetectionTypeEnumByPkArgs = {
  _inc?: InputMaybe<DetectionTypeEnumIncInput>;
  _set?: InputMaybe<DetectionTypeEnumSetInput>;
  pk_columns: DetectionTypeEnumPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDetectionTypeEnumManyArgs = {
  updates: Array<DetectionTypeEnumUpdates>;
};


/** mutation root */
export type MutationRootUpdateDeviceArgs = {
  _append?: InputMaybe<DeviceAppendInput>;
  _delete_at_path?: InputMaybe<DeviceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DeviceDeleteElemInput>;
  _delete_key?: InputMaybe<DeviceDeleteKeyInput>;
  _prepend?: InputMaybe<DevicePrependInput>;
  _set?: InputMaybe<DeviceSetInput>;
  where: DeviceBoolExp;
};


/** mutation root */
export type MutationRootUpdateDeviceByPkArgs = {
  _append?: InputMaybe<DeviceAppendInput>;
  _delete_at_path?: InputMaybe<DeviceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DeviceDeleteElemInput>;
  _delete_key?: InputMaybe<DeviceDeleteKeyInput>;
  _prepend?: InputMaybe<DevicePrependInput>;
  _set?: InputMaybe<DeviceSetInput>;
  pk_columns: DevicePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDeviceConfigMutationArgs = {
  device_uuid: Scalars['String'];
  diff_config: Scalars['json'];
  timestamp: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateDeviceManyArgs = {
  updates: Array<DeviceUpdates>;
};


/** mutation root */
export type MutationRootUpdateEasyparkLotArgs = {
  _inc?: InputMaybe<EasyparkLotIncInput>;
  _set?: InputMaybe<EasyparkLotSetInput>;
  where: EasyparkLotBoolExp;
};


/** mutation root */
export type MutationRootUpdateEasyparkLotByPkArgs = {
  _inc?: InputMaybe<EasyparkLotIncInput>;
  _set?: InputMaybe<EasyparkLotSetInput>;
  pk_columns: EasyparkLotPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEasyparkLotManyArgs = {
  updates: Array<EasyparkLotUpdates>;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderArgs = {
  _inc?: InputMaybe<EasyparkOrderIncInput>;
  _set?: InputMaybe<EasyparkOrderSetInput>;
  where: EasyparkOrderBoolExp;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderByPkArgs = {
  _inc?: InputMaybe<EasyparkOrderIncInput>;
  _set?: InputMaybe<EasyparkOrderSetInput>;
  pk_columns: EasyparkOrderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderManyArgs = {
  updates: Array<EasyparkOrderUpdates>;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderV2Args = {
  _append?: InputMaybe<EasyparkOrderV2AppendInput>;
  _delete_at_path?: InputMaybe<EasyparkOrderV2DeleteAtPathInput>;
  _delete_elem?: InputMaybe<EasyparkOrderV2DeleteElemInput>;
  _delete_key?: InputMaybe<EasyparkOrderV2DeleteKeyInput>;
  _inc?: InputMaybe<EasyparkOrderV2IncInput>;
  _prepend?: InputMaybe<EasyparkOrderV2PrependInput>;
  _set?: InputMaybe<EasyparkOrderV2SetInput>;
  where: EasyparkOrderV2BoolExp;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderV2ByPkArgs = {
  _append?: InputMaybe<EasyparkOrderV2AppendInput>;
  _delete_at_path?: InputMaybe<EasyparkOrderV2DeleteAtPathInput>;
  _delete_elem?: InputMaybe<EasyparkOrderV2DeleteElemInput>;
  _delete_key?: InputMaybe<EasyparkOrderV2DeleteKeyInput>;
  _inc?: InputMaybe<EasyparkOrderV2IncInput>;
  _prepend?: InputMaybe<EasyparkOrderV2PrependInput>;
  _set?: InputMaybe<EasyparkOrderV2SetInput>;
  pk_columns: EasyparkOrderV2PkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEasyparkOrderV2ManyArgs = {
  updates: Array<EasyparkOrderV2Updates>;
};


/** mutation root */
export type MutationRootUpdateEasyparkParkingInfoArgs = {
  _append?: InputMaybe<EasyparkParkingInfoAppendInput>;
  _delete_at_path?: InputMaybe<EasyparkParkingInfoDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EasyparkParkingInfoDeleteElemInput>;
  _delete_key?: InputMaybe<EasyparkParkingInfoDeleteKeyInput>;
  _inc?: InputMaybe<EasyparkParkingInfoIncInput>;
  _prepend?: InputMaybe<EasyparkParkingInfoPrependInput>;
  _set?: InputMaybe<EasyparkParkingInfoSetInput>;
  where: EasyparkParkingInfoBoolExp;
};


/** mutation root */
export type MutationRootUpdateEasyparkParkingInfoByPkArgs = {
  _append?: InputMaybe<EasyparkParkingInfoAppendInput>;
  _delete_at_path?: InputMaybe<EasyparkParkingInfoDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EasyparkParkingInfoDeleteElemInput>;
  _delete_key?: InputMaybe<EasyparkParkingInfoDeleteKeyInput>;
  _inc?: InputMaybe<EasyparkParkingInfoIncInput>;
  _prepend?: InputMaybe<EasyparkParkingInfoPrependInput>;
  _set?: InputMaybe<EasyparkParkingInfoSetInput>;
  pk_columns: EasyparkParkingInfoPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEasyparkParkingInfoManyArgs = {
  updates: Array<EasyparkParkingInfoUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnforcementDailyStatsArgs = {
  _append?: InputMaybe<EnforcementDailyStatsAppendInput>;
  _delete_at_path?: InputMaybe<EnforcementDailyStatsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EnforcementDailyStatsDeleteElemInput>;
  _delete_key?: InputMaybe<EnforcementDailyStatsDeleteKeyInput>;
  _inc?: InputMaybe<EnforcementDailyStatsIncInput>;
  _prepend?: InputMaybe<EnforcementDailyStatsPrependInput>;
  _set?: InputMaybe<EnforcementDailyStatsSetInput>;
  where: EnforcementDailyStatsBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnforcementDailyStatsByPkArgs = {
  _append?: InputMaybe<EnforcementDailyStatsAppendInput>;
  _delete_at_path?: InputMaybe<EnforcementDailyStatsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EnforcementDailyStatsDeleteElemInput>;
  _delete_key?: InputMaybe<EnforcementDailyStatsDeleteKeyInput>;
  _inc?: InputMaybe<EnforcementDailyStatsIncInput>;
  _prepend?: InputMaybe<EnforcementDailyStatsPrependInput>;
  _set?: InputMaybe<EnforcementDailyStatsSetInput>;
  pk_columns: EnforcementDailyStatsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnforcementDailyStatsManyArgs = {
  updates: Array<EnforcementDailyStatsUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumCarpayDiscountModelCodeTypeArgs = {
  _set?: InputMaybe<EnumCarpayDiscountModelCodeTypeSetInput>;
  where: EnumCarpayDiscountModelCodeTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumCarpayDiscountModelCodeTypeByPkArgs = {
  _set?: InputMaybe<EnumCarpayDiscountModelCodeTypeSetInput>;
  pk_columns: EnumCarpayDiscountModelCodeTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumCarpayDiscountModelCodeTypeManyArgs = {
  updates: Array<EnumCarpayDiscountModelCodeTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumCountryCodeArgs = {
  _set?: InputMaybe<EnumCountryCodeSetInput>;
  where: EnumCountryCodeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumCountryCodeByPkArgs = {
  _set?: InputMaybe<EnumCountryCodeSetInput>;
  pk_columns: EnumCountryCodePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumCountryCodeManyArgs = {
  updates: Array<EnumCountryCodeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistPurposeArgs = {
  _set?: InputMaybe<EnumCustomerWhitelistPurposeSetInput>;
  where: EnumCustomerWhitelistPurposeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistPurposeByPkArgs = {
  _set?: InputMaybe<EnumCustomerWhitelistPurposeSetInput>;
  pk_columns: EnumCustomerWhitelistPurposePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistPurposeManyArgs = {
  updates: Array<EnumCustomerWhitelistPurposeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistStatusArgs = {
  _set?: InputMaybe<EnumCustomerWhitelistStatusSetInput>;
  where: EnumCustomerWhitelistStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistStatusByPkArgs = {
  _set?: InputMaybe<EnumCustomerWhitelistStatusSetInput>;
  pk_columns: EnumCustomerWhitelistStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumCustomerWhitelistStatusManyArgs = {
  updates: Array<EnumCustomerWhitelistStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumDeviceTypeArgs = {
  _set?: InputMaybe<EnumDeviceTypeSetInput>;
  where: EnumDeviceTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumDeviceTypeByPkArgs = {
  _set?: InputMaybe<EnumDeviceTypeSetInput>;
  pk_columns: EnumDeviceTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumDeviceTypeManyArgs = {
  updates: Array<EnumDeviceTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumDriverRequestTypeArgs = {
  _set?: InputMaybe<EnumDriverRequestTypeSetInput>;
  where: EnumDriverRequestTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumDriverRequestTypeByPkArgs = {
  _set?: InputMaybe<EnumDriverRequestTypeSetInput>;
  pk_columns: EnumDriverRequestTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumDriverRequestTypeManyArgs = {
  updates: Array<EnumDriverRequestTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumGuestJwtPurposeArgs = {
  _set?: InputMaybe<EnumGuestJwtPurposeSetInput>;
  where: EnumGuestJwtPurposeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumGuestJwtPurposeByPkArgs = {
  _set?: InputMaybe<EnumGuestJwtPurposeSetInput>;
  pk_columns: EnumGuestJwtPurposePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumGuestJwtPurposeManyArgs = {
  updates: Array<EnumGuestJwtPurposeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumSupervisionMlpRequestStatusArgs = {
  _set?: InputMaybe<EnumSupervisionMlpRequestStatusSetInput>;
  where: EnumSupervisionMlpRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumSupervisionMlpRequestStatusByPkArgs = {
  _set?: InputMaybe<EnumSupervisionMlpRequestStatusSetInput>;
  pk_columns: EnumSupervisionMlpRequestStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumSupervisionMlpRequestStatusManyArgs = {
  updates: Array<EnumSupervisionMlpRequestStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCancellationArgs = {
  _set?: InputMaybe<EnumViolationCancellationSetInput>;
  where: EnumViolationCancellationBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCancellationByPkArgs = {
  _set?: InputMaybe<EnumViolationCancellationSetInput>;
  pk_columns: EnumViolationCancellationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCancellationManyArgs = {
  updates: Array<EnumViolationCancellationUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesInvalidationReasonArgs = {
  _set?: InputMaybe<EnumViolationCaseChargesInvalidationReasonSetInput>;
  where: EnumViolationCaseChargesInvalidationReasonBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesInvalidationReasonByPkArgs = {
  _set?: InputMaybe<EnumViolationCaseChargesInvalidationReasonSetInput>;
  pk_columns: EnumViolationCaseChargesInvalidationReasonPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesInvalidationReasonManyArgs = {
  updates: Array<EnumViolationCaseChargesInvalidationReasonUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesTypeArgs = {
  _set?: InputMaybe<EnumViolationCaseChargesTypeSetInput>;
  where: EnumViolationCaseChargesTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesTypeByPkArgs = {
  _set?: InputMaybe<EnumViolationCaseChargesTypeSetInput>;
  pk_columns: EnumViolationCaseChargesTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumViolationCaseChargesTypeManyArgs = {
  updates: Array<EnumViolationCaseChargesTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistPaidParkingTypesArgs = {
  _set?: InputMaybe<EnumWhitelistPaidParkingTypesSetInput>;
  where: EnumWhitelistPaidParkingTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistPaidParkingTypesByPkArgs = {
  _set?: InputMaybe<EnumWhitelistPaidParkingTypesSetInput>;
  pk_columns: EnumWhitelistPaidParkingTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistPaidParkingTypesManyArgs = {
  updates: Array<EnumWhitelistPaidParkingTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistScopeArgs = {
  _set?: InputMaybe<EnumWhitelistScopeSetInput>;
  where: EnumWhitelistScopeBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistScopeByPkArgs = {
  _set?: InputMaybe<EnumWhitelistScopeSetInput>;
  pk_columns: EnumWhitelistScopePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistScopeManyArgs = {
  updates: Array<EnumWhitelistScopeUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistStatusArgs = {
  _set?: InputMaybe<EnumWhitelistStatusSetInput>;
  where: EnumWhitelistStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistStatusByPkArgs = {
  _set?: InputMaybe<EnumWhitelistStatusSetInput>;
  pk_columns: EnumWhitelistStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistStatusManyArgs = {
  updates: Array<EnumWhitelistStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistTypesArgs = {
  _set?: InputMaybe<EnumWhitelistTypesSetInput>;
  where: EnumWhitelistTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistTypesByPkArgs = {
  _set?: InputMaybe<EnumWhitelistTypesSetInput>;
  pk_columns: EnumWhitelistTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEnumWhitelistTypesManyArgs = {
  updates: Array<EnumWhitelistTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateGuestJwtArgs = {
  _append?: InputMaybe<GuestJwtAppendInput>;
  _delete_at_path?: InputMaybe<GuestJwtDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GuestJwtDeleteElemInput>;
  _delete_key?: InputMaybe<GuestJwtDeleteKeyInput>;
  _inc?: InputMaybe<GuestJwtIncInput>;
  _prepend?: InputMaybe<GuestJwtPrependInput>;
  _set?: InputMaybe<GuestJwtSetInput>;
  where: GuestJwtBoolExp;
};


/** mutation root */
export type MutationRootUpdateGuestJwtByPkArgs = {
  _append?: InputMaybe<GuestJwtAppendInput>;
  _delete_at_path?: InputMaybe<GuestJwtDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GuestJwtDeleteElemInput>;
  _delete_key?: InputMaybe<GuestJwtDeleteKeyInput>;
  _inc?: InputMaybe<GuestJwtIncInput>;
  _prepend?: InputMaybe<GuestJwtPrependInput>;
  _set?: InputMaybe<GuestJwtSetInput>;
  pk_columns: GuestJwtPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGuestJwtManyArgs = {
  updates: Array<GuestJwtUpdates>;
};


/** mutation root */
export type MutationRootUpdateGuestQrArgs = {
  _inc?: InputMaybe<GuestQrIncInput>;
  _set?: InputMaybe<GuestQrSetInput>;
  where: GuestQrBoolExp;
};


/** mutation root */
export type MutationRootUpdateGuestQrByPkArgs = {
  _inc?: InputMaybe<GuestQrIncInput>;
  _set?: InputMaybe<GuestQrSetInput>;
  pk_columns: GuestQrPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGuestQrManyArgs = {
  updates: Array<GuestQrUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotArgs = {
  _append?: InputMaybe<LotAppendInput>;
  _delete_at_path?: InputMaybe<LotDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotDeleteElemInput>;
  _delete_key?: InputMaybe<LotDeleteKeyInput>;
  _inc?: InputMaybe<LotIncInput>;
  _prepend?: InputMaybe<LotPrependInput>;
  _set?: InputMaybe<LotSetInput>;
  where: LotBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotByPkArgs = {
  _append?: InputMaybe<LotAppendInput>;
  _delete_at_path?: InputMaybe<LotDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotDeleteElemInput>;
  _delete_key?: InputMaybe<LotDeleteKeyInput>;
  _inc?: InputMaybe<LotIncInput>;
  _prepend?: InputMaybe<LotPrependInput>;
  _set?: InputMaybe<LotSetInput>;
  pk_columns: LotPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotConfigGroupArgs = {
  _inc?: InputMaybe<LotConfigGroupIncInput>;
  _set?: InputMaybe<LotConfigGroupSetInput>;
  where: LotConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotConfigGroupByPkArgs = {
  _inc?: InputMaybe<LotConfigGroupIncInput>;
  _set?: InputMaybe<LotConfigGroupSetInput>;
  pk_columns: LotConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotConfigGroupManyArgs = {
  updates: Array<LotConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotDisplayNameArgs = {
  _set?: InputMaybe<LotDisplayNameSetInput>;
  where: LotDisplayNameBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotDisplayNameByPkArgs = {
  _set?: InputMaybe<LotDisplayNameSetInput>;
  pk_columns: LotDisplayNamePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotDisplayNameManyArgs = {
  updates: Array<LotDisplayNameUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotHierarchyArgs = {
  _inc?: InputMaybe<LotHierarchyIncInput>;
  _set?: InputMaybe<LotHierarchySetInput>;
  where: LotHierarchyBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotHierarchyByPkArgs = {
  _inc?: InputMaybe<LotHierarchyIncInput>;
  _set?: InputMaybe<LotHierarchySetInput>;
  pk_columns: LotHierarchyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotHierarchyManyArgs = {
  updates: Array<LotHierarchyUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotLegalEntityArgs = {
  _set?: InputMaybe<LotLegalEntitySetInput>;
  where: LotLegalEntityBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotLegalEntityByPkArgs = {
  _set?: InputMaybe<LotLegalEntitySetInput>;
  pk_columns: LotLegalEntityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotLegalEntityManyArgs = {
  updates: Array<LotLegalEntityUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotManyArgs = {
  updates: Array<LotUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotPolicyHistoryArgs = {
  _append?: InputMaybe<LotPolicyHistoryAppendInput>;
  _delete_at_path?: InputMaybe<LotPolicyHistoryDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotPolicyHistoryDeleteElemInput>;
  _delete_key?: InputMaybe<LotPolicyHistoryDeleteKeyInput>;
  _inc?: InputMaybe<LotPolicyHistoryIncInput>;
  _prepend?: InputMaybe<LotPolicyHistoryPrependInput>;
  _set?: InputMaybe<LotPolicyHistorySetInput>;
  where: LotPolicyHistoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotPolicyHistoryByPkArgs = {
  _append?: InputMaybe<LotPolicyHistoryAppendInput>;
  _delete_at_path?: InputMaybe<LotPolicyHistoryDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotPolicyHistoryDeleteElemInput>;
  _delete_key?: InputMaybe<LotPolicyHistoryDeleteKeyInput>;
  _inc?: InputMaybe<LotPolicyHistoryIncInput>;
  _prepend?: InputMaybe<LotPolicyHistoryPrependInput>;
  _set?: InputMaybe<LotPolicyHistorySetInput>;
  pk_columns: LotPolicyHistoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotPolicyHistoryManyArgs = {
  updates: Array<LotPolicyHistoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateLotSectionArgs = {
  _append?: InputMaybe<LotSectionAppendInput>;
  _delete_at_path?: InputMaybe<LotSectionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotSectionDeleteElemInput>;
  _delete_key?: InputMaybe<LotSectionDeleteKeyInput>;
  _inc?: InputMaybe<LotSectionIncInput>;
  _prepend?: InputMaybe<LotSectionPrependInput>;
  _set?: InputMaybe<LotSectionSetInput>;
  where: LotSectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateLotSectionByPkArgs = {
  _append?: InputMaybe<LotSectionAppendInput>;
  _delete_at_path?: InputMaybe<LotSectionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LotSectionDeleteElemInput>;
  _delete_key?: InputMaybe<LotSectionDeleteKeyInput>;
  _inc?: InputMaybe<LotSectionIncInput>;
  _prepend?: InputMaybe<LotSectionPrependInput>;
  _set?: InputMaybe<LotSectionSetInput>;
  pk_columns: LotSectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLotSectionManyArgs = {
  updates: Array<LotSectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpContingentArgs = {
  _inc?: InputMaybe<LpContingentIncInput>;
  _set?: InputMaybe<LpContingentSetInput>;
  where: LpContingentBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpContingentByPkArgs = {
  _inc?: InputMaybe<LpContingentIncInput>;
  _set?: InputMaybe<LpContingentSetInput>;
  pk_columns: LpContingentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpContingentManyArgs = {
  updates: Array<LpContingentUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpGroupArgs = {
  _inc?: InputMaybe<LpGroupIncInput>;
  _set?: InputMaybe<LpGroupSetInput>;
  where: LpGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpGroupByPkArgs = {
  _inc?: InputMaybe<LpGroupIncInput>;
  _set?: InputMaybe<LpGroupSetInput>;
  pk_columns: LpGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpGroupConfigGroupArgs = {
  _inc?: InputMaybe<LpGroupConfigGroupIncInput>;
  _set?: InputMaybe<LpGroupConfigGroupSetInput>;
  where: LpGroupConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpGroupConfigGroupByPkArgs = {
  _inc?: InputMaybe<LpGroupConfigGroupIncInput>;
  _set?: InputMaybe<LpGroupConfigGroupSetInput>;
  pk_columns: LpGroupConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpGroupConfigGroupManyArgs = {
  updates: Array<LpGroupConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpGroupDetailsArgs = {
  _inc?: InputMaybe<LpGroupDetailsIncInput>;
  _set?: InputMaybe<LpGroupDetailsSetInput>;
  where: LpGroupDetailsBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpGroupDetailsByPkArgs = {
  _inc?: InputMaybe<LpGroupDetailsIncInput>;
  _set?: InputMaybe<LpGroupDetailsSetInput>;
  pk_columns: LpGroupDetailsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpGroupDetailsManyArgs = {
  updates: Array<LpGroupDetailsUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpGroupManyArgs = {
  updates: Array<LpGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberArgs = {
  _inc?: InputMaybe<LpGroupMemberIncInput>;
  _set?: InputMaybe<LpGroupMemberSetInput>;
  where: LpGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberByPkArgs = {
  _inc?: InputMaybe<LpGroupMemberIncInput>;
  _set?: InputMaybe<LpGroupMemberSetInput>;
  pk_columns: LpGroupMemberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberDetailsArgs = {
  _inc?: InputMaybe<LpGroupMemberDetailsIncInput>;
  _set?: InputMaybe<LpGroupMemberDetailsSetInput>;
  where: LpGroupMemberDetailsBoolExp;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberDetailsByPkArgs = {
  _inc?: InputMaybe<LpGroupMemberDetailsIncInput>;
  _set?: InputMaybe<LpGroupMemberDetailsSetInput>;
  pk_columns: LpGroupMemberDetailsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberDetailsManyArgs = {
  updates: Array<LpGroupMemberDetailsUpdates>;
};


/** mutation root */
export type MutationRootUpdateLpGroupMemberManyArgs = {
  updates: Array<LpGroupMemberUpdates>;
};


/** mutation root */
export type MutationRootUpdateMailArgs = {
  _inc?: InputMaybe<MailIncInput>;
  _set?: InputMaybe<MailSetInput>;
  where: MailBoolExp;
};


/** mutation root */
export type MutationRootUpdateMailByPkArgs = {
  _inc?: InputMaybe<MailIncInput>;
  _set?: InputMaybe<MailSetInput>;
  pk_columns: MailPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMailManyArgs = {
  updates: Array<MailUpdates>;
};


/** mutation root */
export type MutationRootUpdateMailMiscArgs = {
  _inc?: InputMaybe<MailMiscIncInput>;
  _set?: InputMaybe<MailMiscSetInput>;
  where: MailMiscBoolExp;
};


/** mutation root */
export type MutationRootUpdateMailMiscByPkArgs = {
  _inc?: InputMaybe<MailMiscIncInput>;
  _set?: InputMaybe<MailMiscSetInput>;
  pk_columns: MailMiscPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMailMiscManyArgs = {
  updates: Array<MailMiscUpdates>;
};


/** mutation root */
export type MutationRootUpdateMlpCasesArgs = {
  _append?: InputMaybe<MlpCasesAppendInput>;
  _delete_at_path?: InputMaybe<MlpCasesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MlpCasesDeleteElemInput>;
  _delete_key?: InputMaybe<MlpCasesDeleteKeyInput>;
  _prepend?: InputMaybe<MlpCasesPrependInput>;
  _set?: InputMaybe<MlpCasesSetInput>;
  where: MlpCasesBoolExp;
};


/** mutation root */
export type MutationRootUpdateMlpCasesByPkArgs = {
  _append?: InputMaybe<MlpCasesAppendInput>;
  _delete_at_path?: InputMaybe<MlpCasesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MlpCasesDeleteElemInput>;
  _delete_key?: InputMaybe<MlpCasesDeleteKeyInput>;
  _prepend?: InputMaybe<MlpCasesPrependInput>;
  _set?: InputMaybe<MlpCasesSetInput>;
  pk_columns: MlpCasesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMlpCasesManyArgs = {
  updates: Array<MlpCasesUpdates>;
};


/** mutation root */
export type MutationRootUpdateMlpMappingsArgs = {
  _set?: InputMaybe<MlpMappingsSetInput>;
  where: MlpMappingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateMlpMappingsByPkArgs = {
  _set?: InputMaybe<MlpMappingsSetInput>;
  pk_columns: MlpMappingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMlpMappingsManyArgs = {
  updates: Array<MlpMappingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateMqttRequestArgs = {
  _append?: InputMaybe<MqttRequestAppendInput>;
  _delete_at_path?: InputMaybe<MqttRequestDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MqttRequestDeleteElemInput>;
  _delete_key?: InputMaybe<MqttRequestDeleteKeyInput>;
  _inc?: InputMaybe<MqttRequestIncInput>;
  _prepend?: InputMaybe<MqttRequestPrependInput>;
  _set?: InputMaybe<MqttRequestSetInput>;
  where: MqttRequestBoolExp;
};


/** mutation root */
export type MutationRootUpdateMqttRequestByPkArgs = {
  _append?: InputMaybe<MqttRequestAppendInput>;
  _delete_at_path?: InputMaybe<MqttRequestDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MqttRequestDeleteElemInput>;
  _delete_key?: InputMaybe<MqttRequestDeleteKeyInput>;
  _inc?: InputMaybe<MqttRequestIncInput>;
  _prepend?: InputMaybe<MqttRequestPrependInput>;
  _set?: InputMaybe<MqttRequestSetInput>;
  pk_columns: MqttRequestPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMqttRequestManyArgs = {
  updates: Array<MqttRequestUpdates>;
};


/** mutation root */
export type MutationRootUpdateOffenceParkingEventsArgs = {
  _inc?: InputMaybe<OffenceParkingEventsIncInput>;
  _set?: InputMaybe<OffenceParkingEventsSetInput>;
  where: OffenceParkingEventsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOffenceParkingEventsByPkArgs = {
  _inc?: InputMaybe<OffenceParkingEventsIncInput>;
  _set?: InputMaybe<OffenceParkingEventsSetInput>;
  pk_columns: OffenceParkingEventsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOffenceParkingEventsManyArgs = {
  updates: Array<OffenceParkingEventsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOffenceTicketRequestsArgs = {
  _append?: InputMaybe<OffenceTicketRequestsAppendInput>;
  _delete_at_path?: InputMaybe<OffenceTicketRequestsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<OffenceTicketRequestsDeleteElemInput>;
  _delete_key?: InputMaybe<OffenceTicketRequestsDeleteKeyInput>;
  _inc?: InputMaybe<OffenceTicketRequestsIncInput>;
  _prepend?: InputMaybe<OffenceTicketRequestsPrependInput>;
  _set?: InputMaybe<OffenceTicketRequestsSetInput>;
  where: OffenceTicketRequestsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOffenceTicketRequestsByPkArgs = {
  _append?: InputMaybe<OffenceTicketRequestsAppendInput>;
  _delete_at_path?: InputMaybe<OffenceTicketRequestsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<OffenceTicketRequestsDeleteElemInput>;
  _delete_key?: InputMaybe<OffenceTicketRequestsDeleteKeyInput>;
  _inc?: InputMaybe<OffenceTicketRequestsIncInput>;
  _prepend?: InputMaybe<OffenceTicketRequestsPrependInput>;
  _set?: InputMaybe<OffenceTicketRequestsSetInput>;
  pk_columns: OffenceTicketRequestsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOffenceTicketRequestsManyArgs = {
  updates: Array<OffenceTicketRequestsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupArgs = {
  _inc?: InputMaybe<OveruseGroupIncInput>;
  _set?: InputMaybe<OveruseGroupSetInput>;
  where: OveruseGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupByPkArgs = {
  _inc?: InputMaybe<OveruseGroupIncInput>;
  _set?: InputMaybe<OveruseGroupSetInput>;
  pk_columns: OveruseGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupManyArgs = {
  updates: Array<OveruseGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupMemberArgs = {
  _inc?: InputMaybe<OveruseGroupMemberIncInput>;
  _set?: InputMaybe<OveruseGroupMemberSetInput>;
  where: OveruseGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupMemberByPkArgs = {
  _inc?: InputMaybe<OveruseGroupMemberIncInput>;
  _set?: InputMaybe<OveruseGroupMemberSetInput>;
  pk_columns: OveruseGroupMemberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOveruseGroupMemberManyArgs = {
  updates: Array<OveruseGroupMemberUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkdepotProductArgs = {
  _set?: InputMaybe<ParkdepotProductSetInput>;
  where: ParkdepotProductBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkdepotProductByPkArgs = {
  _set?: InputMaybe<ParkdepotProductSetInput>;
  pk_columns: ParkdepotProductPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkdepotProductManyArgs = {
  updates: Array<ParkdepotProductUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingContextArgs = {
  _append?: InputMaybe<ParkingContextAppendInput>;
  _delete_at_path?: InputMaybe<ParkingContextDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ParkingContextDeleteElemInput>;
  _delete_key?: InputMaybe<ParkingContextDeleteKeyInput>;
  _prepend?: InputMaybe<ParkingContextPrependInput>;
  _set?: InputMaybe<ParkingContextSetInput>;
  where: ParkingContextBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingContextByPkArgs = {
  _append?: InputMaybe<ParkingContextAppendInput>;
  _delete_at_path?: InputMaybe<ParkingContextDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ParkingContextDeleteElemInput>;
  _delete_key?: InputMaybe<ParkingContextDeleteKeyInput>;
  _prepend?: InputMaybe<ParkingContextPrependInput>;
  _set?: InputMaybe<ParkingContextSetInput>;
  pk_columns: ParkingContextPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingContextManyArgs = {
  updates: Array<ParkingContextUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsArgs = {
  _inc?: InputMaybe<ParkingDetectionsIncInput>;
  _set?: InputMaybe<ParkingDetectionsSetInput>;
  where: ParkingDetectionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsArchiveArgs = {
  _inc?: InputMaybe<ParkingDetectionsArchiveIncInput>;
  _set?: InputMaybe<ParkingDetectionsArchiveSetInput>;
  where: ParkingDetectionsArchiveBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsArchiveByPkArgs = {
  _inc?: InputMaybe<ParkingDetectionsArchiveIncInput>;
  _set?: InputMaybe<ParkingDetectionsArchiveSetInput>;
  pk_columns: ParkingDetectionsArchivePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsArchiveManyArgs = {
  updates: Array<ParkingDetectionsArchiveUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsByPkArgs = {
  _inc?: InputMaybe<ParkingDetectionsIncInput>;
  _set?: InputMaybe<ParkingDetectionsSetInput>;
  pk_columns: ParkingDetectionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingDetectionsManyArgs = {
  updates: Array<ParkingDetectionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingIncomingArgs = {
  _inc?: InputMaybe<ParkingIncomingIncInput>;
  _set?: InputMaybe<ParkingIncomingSetInput>;
  where: ParkingIncomingBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingIncomingByPkArgs = {
  _inc?: InputMaybe<ParkingIncomingIncInput>;
  _set?: InputMaybe<ParkingIncomingSetInput>;
  pk_columns: ParkingIncomingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingIncomingManyArgs = {
  updates: Array<ParkingIncomingUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingProcessingArgs = {
  _inc?: InputMaybe<ParkingProcessingIncInput>;
  _set?: InputMaybe<ParkingProcessingSetInput>;
  where: ParkingProcessingBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingProcessingByPkArgs = {
  _inc?: InputMaybe<ParkingProcessingIncInput>;
  _set?: InputMaybe<ParkingProcessingSetInput>;
  pk_columns: ParkingProcessingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingProcessingManyArgs = {
  updates: Array<ParkingProcessingUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingResultsArgs = {
  _inc?: InputMaybe<ParkingResultsIncInput>;
  _set?: InputMaybe<ParkingResultsSetInput>;
  where: ParkingResultsBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingResultsArchiveArgs = {
  _inc?: InputMaybe<ParkingResultsArchiveIncInput>;
  _set?: InputMaybe<ParkingResultsArchiveSetInput>;
  where: ParkingResultsArchiveBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingResultsArchiveByPkArgs = {
  _inc?: InputMaybe<ParkingResultsArchiveIncInput>;
  _set?: InputMaybe<ParkingResultsArchiveSetInput>;
  pk_columns: ParkingResultsArchivePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingResultsArchiveManyArgs = {
  updates: Array<ParkingResultsArchiveUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingResultsByPkArgs = {
  _inc?: InputMaybe<ParkingResultsIncInput>;
  _set?: InputMaybe<ParkingResultsSetInput>;
  pk_columns: ParkingResultsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingResultsManyArgs = {
  updates: Array<ParkingResultsUpdates>;
};


/** mutation root */
export type MutationRootUpdateParkingTempArgs = {
  _inc?: InputMaybe<ParkingTempIncInput>;
  _set?: InputMaybe<ParkingTempSetInput>;
  where: ParkingTempBoolExp;
};


/** mutation root */
export type MutationRootUpdateParkingTempByPkArgs = {
  _inc?: InputMaybe<ParkingTempIncInput>;
  _set?: InputMaybe<ParkingTempSetInput>;
  pk_columns: ParkingTempPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateParkingTempManyArgs = {
  updates: Array<ParkingTempUpdates>;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneLotArgs = {
  _set?: InputMaybe<PaybyphoneLotSetInput>;
  where: PaybyphoneLotBoolExp;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneLotByPkArgs = {
  _set?: InputMaybe<PaybyphoneLotSetInput>;
  pk_columns: PaybyphoneLotPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneLotManyArgs = {
  updates: Array<PaybyphoneLotUpdates>;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneOrderArgs = {
  _inc?: InputMaybe<PaybyphoneOrderIncInput>;
  _set?: InputMaybe<PaybyphoneOrderSetInput>;
  where: PaybyphoneOrderBoolExp;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneOrderByPkArgs = {
  _inc?: InputMaybe<PaybyphoneOrderIncInput>;
  _set?: InputMaybe<PaybyphoneOrderSetInput>;
  pk_columns: PaybyphoneOrderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePaybyphoneOrderManyArgs = {
  updates: Array<PaybyphoneOrderUpdates>;
};


/** mutation root */
export type MutationRootUpdatePersonArgs = {
  _inc?: InputMaybe<PersonIncInput>;
  _set?: InputMaybe<PersonSetInput>;
  where: PersonBoolExp;
};


/** mutation root */
export type MutationRootUpdatePersonByPkArgs = {
  _inc?: InputMaybe<PersonIncInput>;
  _set?: InputMaybe<PersonSetInput>;
  pk_columns: PersonPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePersonManyArgs = {
  updates: Array<PersonUpdates>;
};


/** mutation root */
export type MutationRootUpdatePolicyScheduleArgs = {
  _append?: InputMaybe<PolicyScheduleAppendInput>;
  _delete_at_path?: InputMaybe<PolicyScheduleDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PolicyScheduleDeleteElemInput>;
  _delete_key?: InputMaybe<PolicyScheduleDeleteKeyInput>;
  _inc?: InputMaybe<PolicyScheduleIncInput>;
  _prepend?: InputMaybe<PolicySchedulePrependInput>;
  _set?: InputMaybe<PolicyScheduleSetInput>;
  where: PolicyScheduleBoolExp;
};


/** mutation root */
export type MutationRootUpdatePolicyScheduleByPkArgs = {
  _append?: InputMaybe<PolicyScheduleAppendInput>;
  _delete_at_path?: InputMaybe<PolicyScheduleDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PolicyScheduleDeleteElemInput>;
  _delete_key?: InputMaybe<PolicyScheduleDeleteKeyInput>;
  _inc?: InputMaybe<PolicyScheduleIncInput>;
  _prepend?: InputMaybe<PolicySchedulePrependInput>;
  _set?: InputMaybe<PolicyScheduleSetInput>;
  pk_columns: PolicySchedulePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePolicyScheduleManyArgs = {
  updates: Array<PolicyScheduleUpdates>;
};


/** mutation root */
export type MutationRootUpdateRegionalCodesAustriaArgs = {
  _inc?: InputMaybe<RegionalCodesAustriaIncInput>;
  _set?: InputMaybe<RegionalCodesAustriaSetInput>;
  where: RegionalCodesAustriaBoolExp;
};


/** mutation root */
export type MutationRootUpdateRegionalCodesAustriaByPkArgs = {
  _inc?: InputMaybe<RegionalCodesAustriaIncInput>;
  _set?: InputMaybe<RegionalCodesAustriaSetInput>;
  pk_columns: RegionalCodesAustriaPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRegionalCodesAustriaManyArgs = {
  updates: Array<RegionalCodesAustriaUpdates>;
};


/** mutation root */
export type MutationRootUpdateRentalPricingArgs = {
  _append?: InputMaybe<RentalPricingAppendInput>;
  _delete_at_path?: InputMaybe<RentalPricingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RentalPricingDeleteElemInput>;
  _delete_key?: InputMaybe<RentalPricingDeleteKeyInput>;
  _inc?: InputMaybe<RentalPricingIncInput>;
  _prepend?: InputMaybe<RentalPricingPrependInput>;
  _set?: InputMaybe<RentalPricingSetInput>;
  where: RentalPricingBoolExp;
};


/** mutation root */
export type MutationRootUpdateRentalPricingByPkArgs = {
  _append?: InputMaybe<RentalPricingAppendInput>;
  _delete_at_path?: InputMaybe<RentalPricingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RentalPricingDeleteElemInput>;
  _delete_key?: InputMaybe<RentalPricingDeleteKeyInput>;
  _inc?: InputMaybe<RentalPricingIncInput>;
  _prepend?: InputMaybe<RentalPricingPrependInput>;
  _set?: InputMaybe<RentalPricingSetInput>;
  pk_columns: RentalPricingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRentalPricingManyArgs = {
  updates: Array<RentalPricingUpdates>;
};


/** mutation root */
export type MutationRootUpdateRentalSubscriptionArgs = {
  _inc?: InputMaybe<RentalSubscriptionIncInput>;
  _set?: InputMaybe<RentalSubscriptionSetInput>;
  where: RentalSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootUpdateRentalSubscriptionByPkArgs = {
  _inc?: InputMaybe<RentalSubscriptionIncInput>;
  _set?: InputMaybe<RentalSubscriptionSetInput>;
  pk_columns: RentalSubscriptionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRentalSubscriptionManyArgs = {
  updates: Array<RentalSubscriptionUpdates>;
};


/** mutation root */
export type MutationRootUpdateServerlessAsyncWorkArgs = {
  _append?: InputMaybe<ServerlessAsyncWorkAppendInput>;
  _delete_at_path?: InputMaybe<ServerlessAsyncWorkDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ServerlessAsyncWorkDeleteElemInput>;
  _delete_key?: InputMaybe<ServerlessAsyncWorkDeleteKeyInput>;
  _prepend?: InputMaybe<ServerlessAsyncWorkPrependInput>;
  _set?: InputMaybe<ServerlessAsyncWorkSetInput>;
  where: ServerlessAsyncWorkBoolExp;
};


/** mutation root */
export type MutationRootUpdateServerlessAsyncWorkByPkArgs = {
  _append?: InputMaybe<ServerlessAsyncWorkAppendInput>;
  _delete_at_path?: InputMaybe<ServerlessAsyncWorkDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ServerlessAsyncWorkDeleteElemInput>;
  _delete_key?: InputMaybe<ServerlessAsyncWorkDeleteKeyInput>;
  _prepend?: InputMaybe<ServerlessAsyncWorkPrependInput>;
  _set?: InputMaybe<ServerlessAsyncWorkSetInput>;
  pk_columns: ServerlessAsyncWorkPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateServerlessAsyncWorkManyArgs = {
  updates: Array<ServerlessAsyncWorkUpdates>;
};


/** mutation root */
export type MutationRootUpdateSimilarDetectionsArgs = {
  _append?: InputMaybe<SimilarDetectionsAppendInput>;
  _delete_at_path?: InputMaybe<SimilarDetectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SimilarDetectionsDeleteElemInput>;
  _delete_key?: InputMaybe<SimilarDetectionsDeleteKeyInput>;
  _prepend?: InputMaybe<SimilarDetectionsPrependInput>;
  _set?: InputMaybe<SimilarDetectionsSetInput>;
  where: SimilarDetectionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSimilarDetectionsByPkArgs = {
  _append?: InputMaybe<SimilarDetectionsAppendInput>;
  _delete_at_path?: InputMaybe<SimilarDetectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SimilarDetectionsDeleteElemInput>;
  _delete_key?: InputMaybe<SimilarDetectionsDeleteKeyInput>;
  _prepend?: InputMaybe<SimilarDetectionsPrependInput>;
  _set?: InputMaybe<SimilarDetectionsSetInput>;
  pk_columns: SimilarDetectionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSimilarDetectionsManyArgs = {
  updates: Array<SimilarDetectionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateStagesArgs = {
  _inc?: InputMaybe<StagesIncInput>;
  _set?: InputMaybe<StagesSetInput>;
  where: StagesBoolExp;
};


/** mutation root */
export type MutationRootUpdateStagesByPkArgs = {
  _inc?: InputMaybe<StagesIncInput>;
  _set?: InputMaybe<StagesSetInput>;
  pk_columns: StagesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateStagesManyArgs = {
  updates: Array<StagesUpdates>;
};


/** mutation root */
export type MutationRootUpdateStationArgs = {
  _append?: InputMaybe<StationAppendInput>;
  _delete_at_path?: InputMaybe<StationDeleteAtPathInput>;
  _delete_elem?: InputMaybe<StationDeleteElemInput>;
  _delete_key?: InputMaybe<StationDeleteKeyInput>;
  _prepend?: InputMaybe<StationPrependInput>;
  _set?: InputMaybe<StationSetInput>;
  where: StationBoolExp;
};


/** mutation root */
export type MutationRootUpdateStationByPkArgs = {
  _append?: InputMaybe<StationAppendInput>;
  _delete_at_path?: InputMaybe<StationDeleteAtPathInput>;
  _delete_elem?: InputMaybe<StationDeleteElemInput>;
  _delete_key?: InputMaybe<StationDeleteKeyInput>;
  _prepend?: InputMaybe<StationPrependInput>;
  _set?: InputMaybe<StationSetInput>;
  pk_columns: StationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateStationConfigMutationArgs = {
  config: Scalars['json'];
  station_name: Scalars['String'];
  timestamp: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateStationDataMutationArgs = {
  device_direction: Scalars['String'];
  device_uuid?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  station_name: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateStationManyArgs = {
  updates: Array<StationUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionCarRentalPartnersArgs = {
  _append?: InputMaybe<SupervisionCarRentalPartnersAppendInput>;
  _delete_at_path?: InputMaybe<SupervisionCarRentalPartnersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SupervisionCarRentalPartnersDeleteElemInput>;
  _delete_key?: InputMaybe<SupervisionCarRentalPartnersDeleteKeyInput>;
  _inc?: InputMaybe<SupervisionCarRentalPartnersIncInput>;
  _prepend?: InputMaybe<SupervisionCarRentalPartnersPrependInput>;
  _set?: InputMaybe<SupervisionCarRentalPartnersSetInput>;
  where: SupervisionCarRentalPartnersBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionCarRentalPartnersByPkArgs = {
  _append?: InputMaybe<SupervisionCarRentalPartnersAppendInput>;
  _delete_at_path?: InputMaybe<SupervisionCarRentalPartnersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SupervisionCarRentalPartnersDeleteElemInput>;
  _delete_key?: InputMaybe<SupervisionCarRentalPartnersDeleteKeyInput>;
  _inc?: InputMaybe<SupervisionCarRentalPartnersIncInput>;
  _prepend?: InputMaybe<SupervisionCarRentalPartnersPrependInput>;
  _set?: InputMaybe<SupervisionCarRentalPartnersSetInput>;
  pk_columns: SupervisionCarRentalPartnersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionCarRentalPartnersManyArgs = {
  updates: Array<SupervisionCarRentalPartnersUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionDebtCollectionCaseArgs = {
  _inc?: InputMaybe<SupervisionDebtCollectionCaseIncInput>;
  _set?: InputMaybe<SupervisionDebtCollectionCaseSetInput>;
  where: SupervisionDebtCollectionCaseBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionDebtCollectionCaseByPkArgs = {
  _inc?: InputMaybe<SupervisionDebtCollectionCaseIncInput>;
  _set?: InputMaybe<SupervisionDebtCollectionCaseSetInput>;
  pk_columns: SupervisionDebtCollectionCasePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionDebtCollectionCaseManyArgs = {
  updates: Array<SupervisionDebtCollectionCaseUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionImageRequestsArgs = {
  _inc?: InputMaybe<SupervisionImageRequestsIncInput>;
  _set?: InputMaybe<SupervisionImageRequestsSetInput>;
  where: SupervisionImageRequestsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionImageRequestsByPkArgs = {
  _inc?: InputMaybe<SupervisionImageRequestsIncInput>;
  _set?: InputMaybe<SupervisionImageRequestsSetInput>;
  pk_columns: SupervisionImageRequestsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionImageRequestsManyArgs = {
  updates: Array<SupervisionImageRequestsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionMlpRequestsArgs = {
  _inc?: InputMaybe<SupervisionMlpRequestsIncInput>;
  _set?: InputMaybe<SupervisionMlpRequestsSetInput>;
  where: SupervisionMlpRequestsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionMlpRequestsByPkArgs = {
  _inc?: InputMaybe<SupervisionMlpRequestsIncInput>;
  _set?: InputMaybe<SupervisionMlpRequestsSetInput>;
  pk_columns: SupervisionMlpRequestsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionMlpRequestsManyArgs = {
  updates: Array<SupervisionMlpRequestsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupArgs = {
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupIncInput>;
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupSetInput>;
  where: SupervisionMultivisitOffenderGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupByPkArgs = {
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupIncInput>;
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupSetInput>;
  pk_columns: SupervisionMultivisitOffenderGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupManyArgs = {
  updates: Array<SupervisionMultivisitOffenderGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupMemberArgs = {
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupMemberIncInput>;
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupMemberSetInput>;
  where: SupervisionMultivisitOffenderGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupMemberByPkArgs = {
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupMemberIncInput>;
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupMemberSetInput>;
  pk_columns: SupervisionMultivisitOffenderGroupMemberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionMultivisitOffenderGroupMemberManyArgs = {
  updates: Array<SupervisionMultivisitOffenderGroupMemberUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionTicketRequestArgs = {
  _inc?: InputMaybe<SupervisionTicketRequestIncInput>;
  _set?: InputMaybe<SupervisionTicketRequestSetInput>;
  where: SupervisionTicketRequestBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionTicketRequestByPkArgs = {
  _inc?: InputMaybe<SupervisionTicketRequestIncInput>;
  _set?: InputMaybe<SupervisionTicketRequestSetInput>;
  pk_columns: SupervisionTicketRequestPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionTicketRequestManyArgs = {
  updates: Array<SupervisionTicketRequestUpdates>;
};


/** mutation root */
export type MutationRootUpdateSupervisionViolationCaseDebtCollectionCaseArgs = {
  _inc?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseIncInput>;
  _set?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseSetInput>;
  where: SupervisionViolationCaseDebtCollectionCaseBoolExp;
};


/** mutation root */
export type MutationRootUpdateSupervisionViolationCaseDebtCollectionCaseByPkArgs = {
  _inc?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseIncInput>;
  _set?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseSetInput>;
  pk_columns: SupervisionViolationCaseDebtCollectionCasePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSupervisionViolationCaseDebtCollectionCaseManyArgs = {
  updates: Array<SupervisionViolationCaseDebtCollectionCaseUpdates>;
};


/** mutation root */
export type MutationRootUpdateTaxArgs = {
  _append?: InputMaybe<TaxAppendInput>;
  _delete_at_path?: InputMaybe<TaxDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TaxDeleteElemInput>;
  _delete_key?: InputMaybe<TaxDeleteKeyInput>;
  _inc?: InputMaybe<TaxIncInput>;
  _prepend?: InputMaybe<TaxPrependInput>;
  _set?: InputMaybe<TaxSetInput>;
  where: TaxBoolExp;
};


/** mutation root */
export type MutationRootUpdateTaxByPkArgs = {
  _append?: InputMaybe<TaxAppendInput>;
  _delete_at_path?: InputMaybe<TaxDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TaxDeleteElemInput>;
  _delete_key?: InputMaybe<TaxDeleteKeyInput>;
  _inc?: InputMaybe<TaxIncInput>;
  _prepend?: InputMaybe<TaxPrependInput>;
  _set?: InputMaybe<TaxSetInput>;
  pk_columns: TaxPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTaxManyArgs = {
  updates: Array<TaxUpdates>;
};


/** mutation root */
export type MutationRootUpdateTerminalStatusArgs = {
  _append?: InputMaybe<TerminalStatusAppendInput>;
  _delete_at_path?: InputMaybe<TerminalStatusDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TerminalStatusDeleteElemInput>;
  _delete_key?: InputMaybe<TerminalStatusDeleteKeyInput>;
  _inc?: InputMaybe<TerminalStatusIncInput>;
  _prepend?: InputMaybe<TerminalStatusPrependInput>;
  _set?: InputMaybe<TerminalStatusSetInput>;
  where: TerminalStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateTerminalStatusByPkArgs = {
  _append?: InputMaybe<TerminalStatusAppendInput>;
  _delete_at_path?: InputMaybe<TerminalStatusDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TerminalStatusDeleteElemInput>;
  _delete_key?: InputMaybe<TerminalStatusDeleteKeyInput>;
  _inc?: InputMaybe<TerminalStatusIncInput>;
  _prepend?: InputMaybe<TerminalStatusPrependInput>;
  _set?: InputMaybe<TerminalStatusSetInput>;
  pk_columns: TerminalStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTerminalStatusManyArgs = {
  updates: Array<TerminalStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateTicketWebsiteFeedbackArgs = {
  _append?: InputMaybe<TicketWebsiteFeedbackAppendInput>;
  _delete_at_path?: InputMaybe<TicketWebsiteFeedbackDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TicketWebsiteFeedbackDeleteElemInput>;
  _delete_key?: InputMaybe<TicketWebsiteFeedbackDeleteKeyInput>;
  _inc?: InputMaybe<TicketWebsiteFeedbackIncInput>;
  _prepend?: InputMaybe<TicketWebsiteFeedbackPrependInput>;
  _set?: InputMaybe<TicketWebsiteFeedbackSetInput>;
  where: TicketWebsiteFeedbackBoolExp;
};


/** mutation root */
export type MutationRootUpdateTicketWebsiteFeedbackByPkArgs = {
  _append?: InputMaybe<TicketWebsiteFeedbackAppendInput>;
  _delete_at_path?: InputMaybe<TicketWebsiteFeedbackDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TicketWebsiteFeedbackDeleteElemInput>;
  _delete_key?: InputMaybe<TicketWebsiteFeedbackDeleteKeyInput>;
  _inc?: InputMaybe<TicketWebsiteFeedbackIncInput>;
  _prepend?: InputMaybe<TicketWebsiteFeedbackPrependInput>;
  _set?: InputMaybe<TicketWebsiteFeedbackSetInput>;
  pk_columns: TicketWebsiteFeedbackPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTicketWebsiteFeedbackManyArgs = {
  updates: Array<TicketWebsiteFeedbackUpdates>;
};


/** mutation root */
export type MutationRootUpdateTimeDiscountArgs = {
  _inc?: InputMaybe<TimeDiscountIncInput>;
  _set?: InputMaybe<TimeDiscountSetInput>;
  where: TimeDiscountBoolExp;
};


/** mutation root */
export type MutationRootUpdateTimeDiscountByPkArgs = {
  _inc?: InputMaybe<TimeDiscountIncInput>;
  _set?: InputMaybe<TimeDiscountSetInput>;
  pk_columns: TimeDiscountPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTimeDiscountManyArgs = {
  updates: Array<TimeDiscountUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserLicensePlateArgs = {
  request: UpdateUserLicensePlateRequest;
};


/** mutation root */
export type MutationRootUpdateUserPreferenceArgs = {
  _append?: InputMaybe<UserPreferenceAppendInput>;
  _delete_at_path?: InputMaybe<UserPreferenceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UserPreferenceDeleteElemInput>;
  _delete_key?: InputMaybe<UserPreferenceDeleteKeyInput>;
  _prepend?: InputMaybe<UserPreferencePrependInput>;
  _set?: InputMaybe<UserPreferenceSetInput>;
  where: UserPreferenceBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserPreferenceByPkArgs = {
  _append?: InputMaybe<UserPreferenceAppendInput>;
  _delete_at_path?: InputMaybe<UserPreferenceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UserPreferenceDeleteElemInput>;
  _delete_key?: InputMaybe<UserPreferenceDeleteKeyInput>;
  _prepend?: InputMaybe<UserPreferencePrependInput>;
  _set?: InputMaybe<UserPreferenceSetInput>;
  pk_columns: UserPreferencePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserPreferenceManyArgs = {
  updates: Array<UserPreferenceUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserVehicleArgs = {
  request: UpdateUserVehicleRequest;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeArgs = {
  _inc?: InputMaybe<VehicleTypeIncInput>;
  _set?: InputMaybe<VehicleTypeSetInput>;
  where: VehicleTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeByPkArgs = {
  _inc?: InputMaybe<VehicleTypeIncInput>;
  _set?: InputMaybe<VehicleTypeSetInput>;
  pk_columns: VehicleTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeConfigGroupArgs = {
  _inc?: InputMaybe<VehicleTypeConfigGroupIncInput>;
  _set?: InputMaybe<VehicleTypeConfigGroupSetInput>;
  where: VehicleTypeConfigGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeConfigGroupByPkArgs = {
  _inc?: InputMaybe<VehicleTypeConfigGroupIncInput>;
  _set?: InputMaybe<VehicleTypeConfigGroupSetInput>;
  pk_columns: VehicleTypeConfigGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeConfigGroupManyArgs = {
  updates: Array<VehicleTypeConfigGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateVehicleTypeManyArgs = {
  updates: Array<VehicleTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateViolationCaseArgs = {
  _append?: InputMaybe<ViolationCaseAppendInput>;
  _delete_at_path?: InputMaybe<ViolationCaseDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ViolationCaseDeleteElemInput>;
  _delete_key?: InputMaybe<ViolationCaseDeleteKeyInput>;
  _inc?: InputMaybe<ViolationCaseIncInput>;
  _prepend?: InputMaybe<ViolationCasePrependInput>;
  _set?: InputMaybe<ViolationCaseSetInput>;
  where: ViolationCaseBoolExp;
};


/** mutation root */
export type MutationRootUpdateViolationCaseByPkArgs = {
  _append?: InputMaybe<ViolationCaseAppendInput>;
  _delete_at_path?: InputMaybe<ViolationCaseDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ViolationCaseDeleteElemInput>;
  _delete_key?: InputMaybe<ViolationCaseDeleteKeyInput>;
  _inc?: InputMaybe<ViolationCaseIncInput>;
  _prepend?: InputMaybe<ViolationCasePrependInput>;
  _set?: InputMaybe<ViolationCaseSetInput>;
  pk_columns: ViolationCasePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateViolationCaseChargesArgs = {
  _inc?: InputMaybe<ViolationCaseChargesIncInput>;
  _set?: InputMaybe<ViolationCaseChargesSetInput>;
  where: ViolationCaseChargesBoolExp;
};


/** mutation root */
export type MutationRootUpdateViolationCaseChargesByPkArgs = {
  _inc?: InputMaybe<ViolationCaseChargesIncInput>;
  _set?: InputMaybe<ViolationCaseChargesSetInput>;
  pk_columns: ViolationCaseChargesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateViolationCaseChargesManyArgs = {
  updates: Array<ViolationCaseChargesUpdates>;
};


/** mutation root */
export type MutationRootUpdateViolationCaseManyArgs = {
  updates: Array<ViolationCaseUpdates>;
};


/** mutation root */
export type MutationRootUpdateViolationCaseTagsArgs = {
  _inc?: InputMaybe<ViolationCaseTagsIncInput>;
  _set?: InputMaybe<ViolationCaseTagsSetInput>;
  where: ViolationCaseTagsBoolExp;
};


/** mutation root */
export type MutationRootUpdateViolationCaseTagsByPkArgs = {
  _inc?: InputMaybe<ViolationCaseTagsIncInput>;
  _set?: InputMaybe<ViolationCaseTagsSetInput>;
  pk_columns: ViolationCaseTagsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateViolationCaseTagsManyArgs = {
  updates: Array<ViolationCaseTagsUpdates>;
};


/** mutation root */
export type MutationRootUpdateViolationEventAnalysisArgs = {
  _append?: InputMaybe<ViolationEventAnalysisAppendInput>;
  _delete_at_path?: InputMaybe<ViolationEventAnalysisDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ViolationEventAnalysisDeleteElemInput>;
  _delete_key?: InputMaybe<ViolationEventAnalysisDeleteKeyInput>;
  _inc?: InputMaybe<ViolationEventAnalysisIncInput>;
  _prepend?: InputMaybe<ViolationEventAnalysisPrependInput>;
  _set?: InputMaybe<ViolationEventAnalysisSetInput>;
  where: ViolationEventAnalysisBoolExp;
};


/** mutation root */
export type MutationRootUpdateViolationEventAnalysisByPkArgs = {
  _append?: InputMaybe<ViolationEventAnalysisAppendInput>;
  _delete_at_path?: InputMaybe<ViolationEventAnalysisDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ViolationEventAnalysisDeleteElemInput>;
  _delete_key?: InputMaybe<ViolationEventAnalysisDeleteKeyInput>;
  _inc?: InputMaybe<ViolationEventAnalysisIncInput>;
  _prepend?: InputMaybe<ViolationEventAnalysisPrependInput>;
  _set?: InputMaybe<ViolationEventAnalysisSetInput>;
  pk_columns: ViolationEventAnalysisPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateViolationEventAnalysisManyArgs = {
  updates: Array<ViolationEventAnalysisUpdates>;
};


/** mutation root */
export type MutationRootUpdateViolationTransactionArgs = {
  case_id: Scalars['String'];
  multiple: Scalars['Boolean'];
  transaction_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootUpdateViolatorImageArgs = {
  _set?: InputMaybe<UpdateViolatorImageData>;
  lot: Scalars['String'];
  plate: Scalars['String'];
  station: Scalars['Int'];
  timestamp: Scalars['timestamp'];
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateViolatorTransactionsArgs = {
  _inc?: InputMaybe<ViolatorTransactionsIncInput>;
  _set?: InputMaybe<ViolatorTransactionsSetInput>;
  where: ViolatorTransactionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateViolatorTransactionsByPkArgs = {
  _inc?: InputMaybe<ViolatorTransactionsIncInput>;
  _set?: InputMaybe<ViolatorTransactionsSetInput>;
  pk_columns: ViolatorTransactionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateViolatorTransactionsManyArgs = {
  updates: Array<ViolatorTransactionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistArgs = {
  _append?: InputMaybe<WhitelistAppendInput>;
  _delete_at_path?: InputMaybe<WhitelistDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WhitelistDeleteElemInput>;
  _delete_key?: InputMaybe<WhitelistDeleteKeyInput>;
  _inc?: InputMaybe<WhitelistIncInput>;
  _prepend?: InputMaybe<WhitelistPrependInput>;
  _set?: InputMaybe<WhitelistSetInput>;
  where: WhitelistBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistAppliedPermitArgs = {
  _inc?: InputMaybe<WhitelistAppliedPermitIncInput>;
  _set?: InputMaybe<WhitelistAppliedPermitSetInput>;
  where: WhitelistAppliedPermitBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistAppliedPermitByPkArgs = {
  _inc?: InputMaybe<WhitelistAppliedPermitIncInput>;
  _set?: InputMaybe<WhitelistAppliedPermitSetInput>;
  pk_columns: WhitelistAppliedPermitPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistAppliedPermitManyArgs = {
  updates: Array<WhitelistAppliedPermitUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistByPkArgs = {
  _append?: InputMaybe<WhitelistAppendInput>;
  _delete_at_path?: InputMaybe<WhitelistDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WhitelistDeleteElemInput>;
  _delete_key?: InputMaybe<WhitelistDeleteKeyInput>;
  _inc?: InputMaybe<WhitelistIncInput>;
  _prepend?: InputMaybe<WhitelistPrependInput>;
  _set?: InputMaybe<WhitelistSetInput>;
  pk_columns: WhitelistPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistCalendarEventPolicyArgs = {
  _inc?: InputMaybe<WhitelistCalendarEventPolicyIncInput>;
  _set?: InputMaybe<WhitelistCalendarEventPolicySetInput>;
  where: WhitelistCalendarEventPolicyBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistCalendarEventPolicyByPkArgs = {
  _inc?: InputMaybe<WhitelistCalendarEventPolicyIncInput>;
  _set?: InputMaybe<WhitelistCalendarEventPolicySetInput>;
  pk_columns: WhitelistCalendarEventPolicyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistCalendarEventPolicyManyArgs = {
  updates: Array<WhitelistCalendarEventPolicyUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistLpContingentArgs = {
  _inc?: InputMaybe<WhitelistLpContingentIncInput>;
  _set?: InputMaybe<WhitelistLpContingentSetInput>;
  where: WhitelistLpContingentBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistLpContingentByPkArgs = {
  _inc?: InputMaybe<WhitelistLpContingentIncInput>;
  _set?: InputMaybe<WhitelistLpContingentSetInput>;
  pk_columns: WhitelistLpContingentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistLpContingentManyArgs = {
  updates: Array<WhitelistLpContingentUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistManyArgs = {
  updates: Array<WhitelistUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistPaidParkingArgs = {
  _inc?: InputMaybe<WhitelistPaidParkingIncInput>;
  _set?: InputMaybe<WhitelistPaidParkingSetInput>;
  where: WhitelistPaidParkingBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistPaidParkingByPkArgs = {
  _inc?: InputMaybe<WhitelistPaidParkingIncInput>;
  _set?: InputMaybe<WhitelistPaidParkingSetInput>;
  pk_columns: WhitelistPaidParkingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistPaidParkingManyArgs = {
  updates: Array<WhitelistPaidParkingUpdates>;
};


/** mutation root */
export type MutationRootUpdateWhitelistSubscriptionArgs = {
  _append?: InputMaybe<WhitelistSubscriptionAppendInput>;
  _delete_at_path?: InputMaybe<WhitelistSubscriptionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WhitelistSubscriptionDeleteElemInput>;
  _delete_key?: InputMaybe<WhitelistSubscriptionDeleteKeyInput>;
  _inc?: InputMaybe<WhitelistSubscriptionIncInput>;
  _prepend?: InputMaybe<WhitelistSubscriptionPrependInput>;
  _set?: InputMaybe<WhitelistSubscriptionSetInput>;
  where: WhitelistSubscriptionBoolExp;
};


/** mutation root */
export type MutationRootUpdateWhitelistSubscriptionByPkArgs = {
  _append?: InputMaybe<WhitelistSubscriptionAppendInput>;
  _delete_at_path?: InputMaybe<WhitelistSubscriptionDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WhitelistSubscriptionDeleteElemInput>;
  _delete_key?: InputMaybe<WhitelistSubscriptionDeleteKeyInput>;
  _inc?: InputMaybe<WhitelistSubscriptionIncInput>;
  _prepend?: InputMaybe<WhitelistSubscriptionPrependInput>;
  _set?: InputMaybe<WhitelistSubscriptionSetInput>;
  pk_columns: WhitelistSubscriptionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWhitelistSubscriptionManyArgs = {
  updates: Array<WhitelistSubscriptionUpdates>;
};


/** mutation root */
export type MutationRootUpdateWireguardConfigArgs = {
  _set?: InputMaybe<WireguardConfigSetInput>;
  where: WireguardConfigBoolExp;
};


/** mutation root */
export type MutationRootUpdateWireguardConfigByPkArgs = {
  _set?: InputMaybe<WireguardConfigSetInput>;
  pk_columns: WireguardConfigPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWireguardConfigManyArgs = {
  updates: Array<WireguardConfigUpdates>;
};


/** mutation root */
export type MutationRootUploadViolatorImageArgs = {
  device_id: Scalars['Int'];
  image: Scalars['String'];
  image_type: Scalars['String'];
  parking_lot: Scalars['String'];
  plate: Scalars['String'];
  timestamp: Scalars['timestamptz'];
};


/** mutation root */
export type MutationRootValidatePersonalInformationArgs = {
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  information_type: Scalars['String'];
  last_name?: InputMaybe<Scalars['String']>;
  place_of_birth?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootVioTransactionsPreprocessingArgs = {
  transactions: Array<InputMaybe<Scalars['json']>>;
};


/** mutation root */
export type MutationRootWhitelistPreprocessingArgs = {
  whitelist: Array<InputMaybe<Scalars['json']>>;
};


/** mutation root */
export type MutationRootWriteOffViolationCaseApiArgs = {
  case_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  true_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  write_off_mode: Scalars['String'];
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['numeric']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['numeric']>>;
  _eq?: InputMaybe<Array<Scalars['numeric']>>;
  _gt?: InputMaybe<Array<Scalars['numeric']>>;
  _gte?: InputMaybe<Array<Scalars['numeric']>>;
  _in?: InputMaybe<Array<Array<Scalars['numeric']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['numeric']>>;
  _lte?: InputMaybe<Array<Scalars['numeric']>>;
  _neq?: InputMaybe<Array<Scalars['numeric']>>;
  _nin?: InputMaybe<Array<Array<Scalars['numeric']>>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "offence_parking_events" */
export type OffenceParkingEvents = {
  __typename?: 'offence_parking_events';
  billable_duration_min?: Maybe<Scalars['Int']>;
  category: Scalars['String'];
  created_at: Scalars['timestamptz'];
  device_id_in?: Maybe<Scalars['Int']>;
  device_id_out?: Maybe<Scalars['Int']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  parking_duration_min?: Maybe<Scalars['Int']>;
  parking_during_active_rules_min?: Maybe<Scalars['Int']>;
  parking_lot: Scalars['String'];
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  true_violation_case_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  vehicle_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "offence_parking_events" */
export type OffenceParkingEventsAggregate = {
  __typename?: 'offence_parking_events_aggregate';
  aggregate?: Maybe<OffenceParkingEventsAggregateFields>;
  nodes: Array<OffenceParkingEvents>;
};

/** aggregate fields of "offence_parking_events" */
export type OffenceParkingEventsAggregateFields = {
  __typename?: 'offence_parking_events_aggregate_fields';
  avg?: Maybe<OffenceParkingEventsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OffenceParkingEventsMaxFields>;
  min?: Maybe<OffenceParkingEventsMinFields>;
  stddev?: Maybe<OffenceParkingEventsStddevFields>;
  stddev_pop?: Maybe<OffenceParkingEventsStddevPopFields>;
  stddev_samp?: Maybe<OffenceParkingEventsStddevSampFields>;
  sum?: Maybe<OffenceParkingEventsSumFields>;
  var_pop?: Maybe<OffenceParkingEventsVarPopFields>;
  var_samp?: Maybe<OffenceParkingEventsVarSampFields>;
  variance?: Maybe<OffenceParkingEventsVarianceFields>;
};


/** aggregate fields of "offence_parking_events" */
export type OffenceParkingEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OffenceParkingEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OffenceParkingEventsAvgFields = {
  __typename?: 'offence_parking_events_avg_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "offence_parking_events". All fields are combined with a logical 'AND'. */
export type OffenceParkingEventsBoolExp = {
  _and?: InputMaybe<Array<OffenceParkingEventsBoolExp>>;
  _not?: InputMaybe<OffenceParkingEventsBoolExp>;
  _or?: InputMaybe<Array<OffenceParkingEventsBoolExp>>;
  billable_duration_min?: InputMaybe<IntComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_id_in?: InputMaybe<IntComparisonExp>;
  device_id_out?: InputMaybe<IntComparisonExp>;
  device_uuid_in?: InputMaybe<StringComparisonExp>;
  device_uuid_out?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  parking_duration_min?: InputMaybe<IntComparisonExp>;
  parking_during_active_rules_min?: InputMaybe<IntComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  plate_changed?: InputMaybe<StringComparisonExp>;
  plate_country?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
  true_violation_case_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  vehicle_type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "offence_parking_events" */
export enum OffenceParkingEventsConstraint {
  /** unique or primary key constraint on columns "id" */
  OffenceParkingEventsPkey = 'offence_parking_events_pkey'
}

/** input type for incrementing numeric columns in table "offence_parking_events" */
export type OffenceParkingEventsIncInput = {
  billable_duration_min?: InputMaybe<Scalars['Int']>;
  device_id_in?: InputMaybe<Scalars['Int']>;
  device_id_out?: InputMaybe<Scalars['Int']>;
  parking_duration_min?: InputMaybe<Scalars['Int']>;
  parking_during_active_rules_min?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  true_violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "offence_parking_events" */
export type OffenceParkingEventsInsertInput = {
  billable_duration_min?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['Int']>;
  device_id_out?: InputMaybe<Scalars['Int']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parking_duration_min?: InputMaybe<Scalars['Int']>;
  parking_during_active_rules_min?: InputMaybe<Scalars['Int']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  true_violation_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type OffenceParkingEventsMaxFields = {
  __typename?: 'offence_parking_events_max_fields';
  billable_duration_min?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id_in?: Maybe<Scalars['Int']>;
  device_id_out?: Maybe<Scalars['Int']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parking_duration_min?: Maybe<Scalars['Int']>;
  parking_during_active_rules_min?: Maybe<Scalars['Int']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  true_violation_case_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type OffenceParkingEventsMinFields = {
  __typename?: 'offence_parking_events_min_fields';
  billable_duration_min?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id_in?: Maybe<Scalars['Int']>;
  device_id_out?: Maybe<Scalars['Int']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parking_duration_min?: Maybe<Scalars['Int']>;
  parking_during_active_rules_min?: Maybe<Scalars['Int']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  true_violation_case_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "offence_parking_events" */
export type OffenceParkingEventsMutationResponse = {
  __typename?: 'offence_parking_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OffenceParkingEvents>;
};

/** on_conflict condition type for table "offence_parking_events" */
export type OffenceParkingEventsOnConflict = {
  constraint: OffenceParkingEventsConstraint;
  update_columns?: Array<OffenceParkingEventsUpdateColumn>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};

/** Ordering options when selecting data from "offence_parking_events". */
export type OffenceParkingEventsOrderBy = {
  billable_duration_min?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_id_in?: InputMaybe<OrderBy>;
  device_id_out?: InputMaybe<OrderBy>;
  device_uuid_in?: InputMaybe<OrderBy>;
  device_uuid_out?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_duration_min?: InputMaybe<OrderBy>;
  parking_during_active_rules_min?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_changed?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  true_violation_case_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  vehicle_type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: offence_parking_events */
export type OffenceParkingEventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "offence_parking_events" */
export enum OffenceParkingEventsSelectColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingDurationMin = 'parking_duration_min',
  /** column name */
  ParkingDuringActiveRulesMin = 'parking_during_active_rules_min',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  TrueViolationCaseId = 'true_violation_case_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleType = 'vehicle_type'
}

/** input type for updating data in table "offence_parking_events" */
export type OffenceParkingEventsSetInput = {
  billable_duration_min?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['Int']>;
  device_id_out?: InputMaybe<Scalars['Int']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parking_duration_min?: InputMaybe<Scalars['Int']>;
  parking_during_active_rules_min?: InputMaybe<Scalars['Int']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  true_violation_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type OffenceParkingEventsStddevFields = {
  __typename?: 'offence_parking_events_stddev_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OffenceParkingEventsStddevPopFields = {
  __typename?: 'offence_parking_events_stddev_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OffenceParkingEventsStddevSampFields = {
  __typename?: 'offence_parking_events_stddev_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "offence_parking_events" */
export type OffenceParkingEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OffenceParkingEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OffenceParkingEventsStreamCursorValueInput = {
  billable_duration_min?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['Int']>;
  device_id_out?: InputMaybe<Scalars['Int']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parking_duration_min?: InputMaybe<Scalars['Int']>;
  parking_during_active_rules_min?: InputMaybe<Scalars['Int']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  true_violation_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type OffenceParkingEventsSumFields = {
  __typename?: 'offence_parking_events_sum_fields';
  billable_duration_min?: Maybe<Scalars['Int']>;
  device_id_in?: Maybe<Scalars['Int']>;
  device_id_out?: Maybe<Scalars['Int']>;
  parking_duration_min?: Maybe<Scalars['Int']>;
  parking_during_active_rules_min?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
  true_violation_case_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "offence_parking_events" */
export enum OffenceParkingEventsUpdateColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingDurationMin = 'parking_duration_min',
  /** column name */
  ParkingDuringActiveRulesMin = 'parking_during_active_rules_min',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  TrueViolationCaseId = 'true_violation_case_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleType = 'vehicle_type'
}

export type OffenceParkingEventsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OffenceParkingEventsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OffenceParkingEventsSetInput>;
  /** filter the rows which have to be updated */
  where: OffenceParkingEventsBoolExp;
};

/** aggregate var_pop on columns */
export type OffenceParkingEventsVarPopFields = {
  __typename?: 'offence_parking_events_var_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OffenceParkingEventsVarSampFields = {
  __typename?: 'offence_parking_events_var_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OffenceParkingEventsVarianceFields = {
  __typename?: 'offence_parking_events_variance_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  parking_duration_min?: Maybe<Scalars['Float']>;
  parking_during_active_rules_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
  true_violation_case_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "offence_ticket_requests" */
export type OffenceTicketRequests = {
  __typename?: 'offence_ticket_requests';
  created_at: Scalars['timestamp'];
  id: Scalars['Int'];
  info?: Maybe<Scalars['jsonb']>;
  offence_case_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  status: Scalars['String'];
  true_offence_case_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "offence_ticket_requests" */
export type OffenceTicketRequestsInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "offence_ticket_requests" */
export type OffenceTicketRequestsAggregate = {
  __typename?: 'offence_ticket_requests_aggregate';
  aggregate?: Maybe<OffenceTicketRequestsAggregateFields>;
  nodes: Array<OffenceTicketRequests>;
};

/** aggregate fields of "offence_ticket_requests" */
export type OffenceTicketRequestsAggregateFields = {
  __typename?: 'offence_ticket_requests_aggregate_fields';
  avg?: Maybe<OffenceTicketRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OffenceTicketRequestsMaxFields>;
  min?: Maybe<OffenceTicketRequestsMinFields>;
  stddev?: Maybe<OffenceTicketRequestsStddevFields>;
  stddev_pop?: Maybe<OffenceTicketRequestsStddevPopFields>;
  stddev_samp?: Maybe<OffenceTicketRequestsStddevSampFields>;
  sum?: Maybe<OffenceTicketRequestsSumFields>;
  var_pop?: Maybe<OffenceTicketRequestsVarPopFields>;
  var_samp?: Maybe<OffenceTicketRequestsVarSampFields>;
  variance?: Maybe<OffenceTicketRequestsVarianceFields>;
};


/** aggregate fields of "offence_ticket_requests" */
export type OffenceTicketRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OffenceTicketRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OffenceTicketRequestsAppendInput = {
  info?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type OffenceTicketRequestsAvgFields = {
  __typename?: 'offence_ticket_requests_avg_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "offence_ticket_requests". All fields are combined with a logical 'AND'. */
export type OffenceTicketRequestsBoolExp = {
  _and?: InputMaybe<Array<OffenceTicketRequestsBoolExp>>;
  _not?: InputMaybe<OffenceTicketRequestsBoolExp>;
  _or?: InputMaybe<Array<OffenceTicketRequestsBoolExp>>;
  created_at?: InputMaybe<TimestampComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  info?: InputMaybe<JsonbComparisonExp>;
  offence_case_id?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  true_offence_case_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "offence_ticket_requests" */
export enum OffenceTicketRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  OffenceTicketRequestsPkey = 'offence_ticket_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OffenceTicketRequestsDeleteAtPathInput = {
  info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OffenceTicketRequestsDeleteElemInput = {
  info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OffenceTicketRequestsDeleteKeyInput = {
  info?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "offence_ticket_requests" */
export type OffenceTicketRequestsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "offence_ticket_requests" */
export type OffenceTicketRequestsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<Scalars['jsonb']>;
  offence_case_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OffenceTicketRequestsMaxFields = {
  __typename?: 'offence_ticket_requests_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  offence_case_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type OffenceTicketRequestsMinFields = {
  __typename?: 'offence_ticket_requests_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  offence_case_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "offence_ticket_requests" */
export type OffenceTicketRequestsMutationResponse = {
  __typename?: 'offence_ticket_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OffenceTicketRequests>;
};

/** on_conflict condition type for table "offence_ticket_requests" */
export type OffenceTicketRequestsOnConflict = {
  constraint: OffenceTicketRequestsConstraint;
  update_columns?: Array<OffenceTicketRequestsUpdateColumn>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};

/** Ordering options when selecting data from "offence_ticket_requests". */
export type OffenceTicketRequestsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  info?: InputMaybe<OrderBy>;
  offence_case_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  true_offence_case_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: offence_ticket_requests */
export type OffenceTicketRequestsPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OffenceTicketRequestsPrependInput = {
  info?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "offence_ticket_requests" */
export enum OffenceTicketRequestsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  OffenceCaseId = 'offence_case_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  TrueOffenceCaseId = 'true_offence_case_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "offence_ticket_requests" */
export type OffenceTicketRequestsSetInput = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<Scalars['jsonb']>;
  offence_case_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type OffenceTicketRequestsStddevFields = {
  __typename?: 'offence_ticket_requests_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OffenceTicketRequestsStddevPopFields = {
  __typename?: 'offence_ticket_requests_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OffenceTicketRequestsStddevSampFields = {
  __typename?: 'offence_ticket_requests_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "offence_ticket_requests" */
export type OffenceTicketRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OffenceTicketRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OffenceTicketRequestsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<Scalars['jsonb']>;
  offence_case_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type OffenceTicketRequestsSumFields = {
  __typename?: 'offence_ticket_requests_sum_fields';
  id?: Maybe<Scalars['Int']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "offence_ticket_requests" */
export enum OffenceTicketRequestsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  OffenceCaseId = 'offence_case_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  TrueOffenceCaseId = 'true_offence_case_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type OffenceTicketRequestsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OffenceTicketRequestsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OffenceTicketRequestsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OffenceTicketRequestsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OffenceTicketRequestsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OffenceTicketRequestsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OffenceTicketRequestsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OffenceTicketRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: OffenceTicketRequestsBoolExp;
};

/** aggregate var_pop on columns */
export type OffenceTicketRequestsVarPopFields = {
  __typename?: 'offence_ticket_requests_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OffenceTicketRequestsVarSampFields = {
  __typename?: 'offence_ticket_requests_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OffenceTicketRequestsVarianceFields = {
  __typename?: 'offence_ticket_requests_variance_fields';
  id?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "oid". All fields are combined with logical 'AND'. */
export type OidComparisonExp = {
  _eq?: InputMaybe<Scalars['oid']>;
  _gt?: InputMaybe<Scalars['oid']>;
  _gte?: InputMaybe<Scalars['oid']>;
  _in?: InputMaybe<Array<Scalars['oid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['oid']>;
  _lte?: InputMaybe<Scalars['oid']>;
  _neq?: InputMaybe<Scalars['oid']>;
  _nin?: InputMaybe<Array<Scalars['oid']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "overuse_group" */
export type OveruseGroup = {
  __typename?: 'overuse_group';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  leader_lp_group_member_id: Scalars['bigint'];
  lot_id: Scalars['String'];
  lp_contingent_id: Scalars['bigint'];
  lp_group_id: Scalars['bigint'];
  overuse_at_start: Scalars['Int'];
  overuse_end: Scalars['timestamptz'];
  overuse_price?: Maybe<Scalars['Float']>;
  overuse_start: Scalars['timestamptz'];
};

/** aggregated selection of "overuse_group" */
export type OveruseGroupAggregate = {
  __typename?: 'overuse_group_aggregate';
  aggregate?: Maybe<OveruseGroupAggregateFields>;
  nodes: Array<OveruseGroup>;
};

/** aggregate fields of "overuse_group" */
export type OveruseGroupAggregateFields = {
  __typename?: 'overuse_group_aggregate_fields';
  avg?: Maybe<OveruseGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OveruseGroupMaxFields>;
  min?: Maybe<OveruseGroupMinFields>;
  stddev?: Maybe<OveruseGroupStddevFields>;
  stddev_pop?: Maybe<OveruseGroupStddevPopFields>;
  stddev_samp?: Maybe<OveruseGroupStddevSampFields>;
  sum?: Maybe<OveruseGroupSumFields>;
  var_pop?: Maybe<OveruseGroupVarPopFields>;
  var_samp?: Maybe<OveruseGroupVarSampFields>;
  variance?: Maybe<OveruseGroupVarianceFields>;
};


/** aggregate fields of "overuse_group" */
export type OveruseGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OveruseGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OveruseGroupAvgFields = {
  __typename?: 'overuse_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "overuse_group". All fields are combined with a logical 'AND'. */
export type OveruseGroupBoolExp = {
  _and?: InputMaybe<Array<OveruseGroupBoolExp>>;
  _not?: InputMaybe<OveruseGroupBoolExp>;
  _or?: InputMaybe<Array<OveruseGroupBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  leader_lp_group_member_id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  lp_contingent_id?: InputMaybe<BigintComparisonExp>;
  lp_group_id?: InputMaybe<BigintComparisonExp>;
  overuse_at_start?: InputMaybe<IntComparisonExp>;
  overuse_end?: InputMaybe<TimestamptzComparisonExp>;
  overuse_price?: InputMaybe<FloatComparisonExp>;
  overuse_start?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "overuse_group" */
export enum OveruseGroupConstraint {
  /** unique or primary key constraint on columns "overuse_end", "lp_group_id", "leader_lp_group_member_id", "lot_id", "overuse_start" */
  OveruseGroupOveruseEndOveruseStartLotIdLpGroupIdLead = 'overuse_group_overuse_end_overuse_start_lot_id_lp_group_id_lead',
  /** unique or primary key constraint on columns "id" */
  OveruseGroupPkey = 'overuse_group_pkey'
}

/** input type for incrementing numeric columns in table "overuse_group" */
export type OveruseGroupIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  leader_lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_at_start?: InputMaybe<Scalars['Int']>;
  overuse_price?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "overuse_group" */
export type OveruseGroupInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  leader_lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_at_start?: InputMaybe<Scalars['Int']>;
  overuse_end?: InputMaybe<Scalars['timestamptz']>;
  overuse_price?: InputMaybe<Scalars['Float']>;
  overuse_start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OveruseGroupMaxFields = {
  __typename?: 'overuse_group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  leader_lp_group_member_id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  overuse_at_start?: Maybe<Scalars['Int']>;
  overuse_end?: Maybe<Scalars['timestamptz']>;
  overuse_price?: Maybe<Scalars['Float']>;
  overuse_start?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "overuse_group_member" */
export type OveruseGroupMember = {
  __typename?: 'overuse_group_member';
  id: Scalars['bigint'];
  lp_group_member_id: Scalars['bigint'];
  overuse_group_id: Scalars['bigint'];
  overuse_type: Scalars['String'];
  parking_results_id: Scalars['uuid'];
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
};

/** aggregated selection of "overuse_group_member" */
export type OveruseGroupMemberAggregate = {
  __typename?: 'overuse_group_member_aggregate';
  aggregate?: Maybe<OveruseGroupMemberAggregateFields>;
  nodes: Array<OveruseGroupMember>;
};

/** aggregate fields of "overuse_group_member" */
export type OveruseGroupMemberAggregateFields = {
  __typename?: 'overuse_group_member_aggregate_fields';
  avg?: Maybe<OveruseGroupMemberAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OveruseGroupMemberMaxFields>;
  min?: Maybe<OveruseGroupMemberMinFields>;
  stddev?: Maybe<OveruseGroupMemberStddevFields>;
  stddev_pop?: Maybe<OveruseGroupMemberStddevPopFields>;
  stddev_samp?: Maybe<OveruseGroupMemberStddevSampFields>;
  sum?: Maybe<OveruseGroupMemberSumFields>;
  var_pop?: Maybe<OveruseGroupMemberVarPopFields>;
  var_samp?: Maybe<OveruseGroupMemberVarSampFields>;
  variance?: Maybe<OveruseGroupMemberVarianceFields>;
};


/** aggregate fields of "overuse_group_member" */
export type OveruseGroupMemberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OveruseGroupMemberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OveruseGroupMemberAvgFields = {
  __typename?: 'overuse_group_member_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "overuse_group_member". All fields are combined with a logical 'AND'. */
export type OveruseGroupMemberBoolExp = {
  _and?: InputMaybe<Array<OveruseGroupMemberBoolExp>>;
  _not?: InputMaybe<OveruseGroupMemberBoolExp>;
  _or?: InputMaybe<Array<OveruseGroupMemberBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_group_member_id?: InputMaybe<BigintComparisonExp>;
  overuse_group_id?: InputMaybe<BigintComparisonExp>;
  overuse_type?: InputMaybe<StringComparisonExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "overuse_group_member" */
export enum OveruseGroupMemberConstraint {
  /** unique or primary key constraint on columns "parking_results_id", "overuse_group_id", "lp_group_member_id", "overuse_type" */
  OveruseGroupMemberLpGroupMemberIdOveruseGroupIdOverus = 'overuse_group_member_lp_group_member_id_overuse_group_id_overus',
  /** unique or primary key constraint on columns "id" */
  OveruseGroupMemberPkey = 'overuse_group_member_pkey'
}

/** input type for incrementing numeric columns in table "overuse_group_member" */
export type OveruseGroupMemberIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  overuse_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "overuse_group_member" */
export type OveruseGroupMemberInsertInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  overuse_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_type?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OveruseGroupMemberMaxFields = {
  __typename?: 'overuse_group_member_max_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
  overuse_group_id?: Maybe<Scalars['bigint']>;
  overuse_type?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type OveruseGroupMemberMinFields = {
  __typename?: 'overuse_group_member_min_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
  overuse_group_id?: Maybe<Scalars['bigint']>;
  overuse_type?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "overuse_group_member" */
export type OveruseGroupMemberMutationResponse = {
  __typename?: 'overuse_group_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OveruseGroupMember>;
};

/** on_conflict condition type for table "overuse_group_member" */
export type OveruseGroupMemberOnConflict = {
  constraint: OveruseGroupMemberConstraint;
  update_columns?: Array<OveruseGroupMemberUpdateColumn>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};

/** Ordering options when selecting data from "overuse_group_member". */
export type OveruseGroupMemberOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_member_id?: InputMaybe<OrderBy>;
  overuse_group_id?: InputMaybe<OrderBy>;
  overuse_type?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: overuse_group_member */
export type OveruseGroupMemberPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "overuse_group_member" */
export enum OveruseGroupMemberSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupMemberId = 'lp_group_member_id',
  /** column name */
  OveruseGroupId = 'overuse_group_id',
  /** column name */
  OveruseType = 'overuse_type',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out'
}

/** input type for updating data in table "overuse_group_member" */
export type OveruseGroupMemberSetInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  overuse_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_type?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type OveruseGroupMemberStddevFields = {
  __typename?: 'overuse_group_member_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OveruseGroupMemberStddevPopFields = {
  __typename?: 'overuse_group_member_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OveruseGroupMemberStddevSampFields = {
  __typename?: 'overuse_group_member_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "overuse_group_member" */
export type OveruseGroupMemberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OveruseGroupMemberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OveruseGroupMemberStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  overuse_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_type?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type OveruseGroupMemberSumFields = {
  __typename?: 'overuse_group_member_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_group_member_id?: Maybe<Scalars['bigint']>;
  overuse_group_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "overuse_group_member" */
export enum OveruseGroupMemberUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LpGroupMemberId = 'lp_group_member_id',
  /** column name */
  OveruseGroupId = 'overuse_group_id',
  /** column name */
  OveruseType = 'overuse_type',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out'
}

export type OveruseGroupMemberUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OveruseGroupMemberIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OveruseGroupMemberSetInput>;
  /** filter the rows which have to be updated */
  where: OveruseGroupMemberBoolExp;
};

/** aggregate var_pop on columns */
export type OveruseGroupMemberVarPopFields = {
  __typename?: 'overuse_group_member_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OveruseGroupMemberVarSampFields = {
  __typename?: 'overuse_group_member_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OveruseGroupMemberVarianceFields = {
  __typename?: 'overuse_group_member_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_member_id?: Maybe<Scalars['Float']>;
  overuse_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type OveruseGroupMinFields = {
  __typename?: 'overuse_group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  leader_lp_group_member_id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  overuse_at_start?: Maybe<Scalars['Int']>;
  overuse_end?: Maybe<Scalars['timestamptz']>;
  overuse_price?: Maybe<Scalars['Float']>;
  overuse_start?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "overuse_group" */
export type OveruseGroupMutationResponse = {
  __typename?: 'overuse_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OveruseGroup>;
};

/** on_conflict condition type for table "overuse_group" */
export type OveruseGroupOnConflict = {
  constraint: OveruseGroupConstraint;
  update_columns?: Array<OveruseGroupUpdateColumn>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};

/** Ordering options when selecting data from "overuse_group". */
export type OveruseGroupOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leader_lp_group_member_id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  lp_contingent_id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  overuse_at_start?: InputMaybe<OrderBy>;
  overuse_end?: InputMaybe<OrderBy>;
  overuse_price?: InputMaybe<OrderBy>;
  overuse_start?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: overuse_group */
export type OveruseGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "overuse_group" */
export enum OveruseGroupSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeaderLpGroupMemberId = 'leader_lp_group_member_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  LpContingentId = 'lp_contingent_id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  OveruseAtStart = 'overuse_at_start',
  /** column name */
  OveruseEnd = 'overuse_end',
  /** column name */
  OverusePrice = 'overuse_price',
  /** column name */
  OveruseStart = 'overuse_start'
}

/** input type for updating data in table "overuse_group" */
export type OveruseGroupSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  leader_lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_at_start?: InputMaybe<Scalars['Int']>;
  overuse_end?: InputMaybe<Scalars['timestamptz']>;
  overuse_price?: InputMaybe<Scalars['Float']>;
  overuse_start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type OveruseGroupStddevFields = {
  __typename?: 'overuse_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OveruseGroupStddevPopFields = {
  __typename?: 'overuse_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OveruseGroupStddevSampFields = {
  __typename?: 'overuse_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "overuse_group" */
export type OveruseGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OveruseGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OveruseGroupStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  leader_lp_group_member_id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  overuse_at_start?: InputMaybe<Scalars['Int']>;
  overuse_end?: InputMaybe<Scalars['timestamptz']>;
  overuse_price?: InputMaybe<Scalars['Float']>;
  overuse_start?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type OveruseGroupSumFields = {
  __typename?: 'overuse_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  leader_lp_group_member_id?: Maybe<Scalars['bigint']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  overuse_at_start?: Maybe<Scalars['Int']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** update columns of table "overuse_group" */
export enum OveruseGroupUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeaderLpGroupMemberId = 'leader_lp_group_member_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  LpContingentId = 'lp_contingent_id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  OveruseAtStart = 'overuse_at_start',
  /** column name */
  OveruseEnd = 'overuse_end',
  /** column name */
  OverusePrice = 'overuse_price',
  /** column name */
  OveruseStart = 'overuse_start'
}

export type OveruseGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OveruseGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OveruseGroupSetInput>;
  /** filter the rows which have to be updated */
  where: OveruseGroupBoolExp;
};

/** aggregate var_pop on columns */
export type OveruseGroupVarPopFields = {
  __typename?: 'overuse_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OveruseGroupVarSampFields = {
  __typename?: 'overuse_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OveruseGroupVarianceFields = {
  __typename?: 'overuse_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  leader_lp_group_member_id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  overuse_at_start?: Maybe<Scalars['Float']>;
  overuse_price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "parkdepot_product" */
export type ParkdepotProduct = {
  __typename?: 'parkdepot_product';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "parkdepot_product" */
export type ParkdepotProductAggregate = {
  __typename?: 'parkdepot_product_aggregate';
  aggregate?: Maybe<ParkdepotProductAggregateFields>;
  nodes: Array<ParkdepotProduct>;
};

/** aggregate fields of "parkdepot_product" */
export type ParkdepotProductAggregateFields = {
  __typename?: 'parkdepot_product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ParkdepotProductMaxFields>;
  min?: Maybe<ParkdepotProductMinFields>;
};


/** aggregate fields of "parkdepot_product" */
export type ParkdepotProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkdepotProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "parkdepot_product". All fields are combined with a logical 'AND'. */
export type ParkdepotProductBoolExp = {
  _and?: InputMaybe<Array<ParkdepotProductBoolExp>>;
  _not?: InputMaybe<ParkdepotProductBoolExp>;
  _or?: InputMaybe<Array<ParkdepotProductBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parkdepot_product" */
export enum ParkdepotProductConstraint {
  /** unique or primary key constraint on columns "value" */
  ParkdepotProductPkey = 'parkdepot_product_pkey'
}

export enum ParkdepotProductEnum {
  /** Booking platform */
  Booking = 'BOOKING',
  /** Carpay product */
  Carpay = 'CARPAY',
  /** Supervision product */
  Supervision = 'SUPERVISION'
}

/** Boolean expression to compare columns of type "parkdepot_product_enum". All fields are combined with logical 'AND'. */
export type ParkdepotProductEnumComparisonExp = {
  _eq?: InputMaybe<ParkdepotProductEnum>;
  _in?: InputMaybe<Array<ParkdepotProductEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ParkdepotProductEnum>;
  _nin?: InputMaybe<Array<ParkdepotProductEnum>>;
};

/** input type for inserting data into table "parkdepot_product" */
export type ParkdepotProductInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkdepotProductMaxFields = {
  __typename?: 'parkdepot_product_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkdepotProductMinFields = {
  __typename?: 'parkdepot_product_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parkdepot_product" */
export type ParkdepotProductMutationResponse = {
  __typename?: 'parkdepot_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkdepotProduct>;
};

/** on_conflict condition type for table "parkdepot_product" */
export type ParkdepotProductOnConflict = {
  constraint: ParkdepotProductConstraint;
  update_columns?: Array<ParkdepotProductUpdateColumn>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};

/** Ordering options when selecting data from "parkdepot_product". */
export type ParkdepotProductOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parkdepot_product */
export type ParkdepotProductPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "parkdepot_product" */
export enum ParkdepotProductSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "parkdepot_product" */
export type ParkdepotProductSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "parkdepot_product" */
export type ParkdepotProductStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkdepotProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkdepotProductStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "parkdepot_product" */
export enum ParkdepotProductUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type ParkdepotProductUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkdepotProductSetInput>;
  /** filter the rows which have to be updated */
  where: ParkdepotProductBoolExp;
};

/** columns and relationships of "parking_context" */
export type ParkingContext = {
  __typename?: 'parking_context';
  definition: Scalars['jsonb'];
  lot_id: Scalars['String'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "parking_context" */
export type ParkingContextDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "parking_context" */
export type ParkingContextAggregate = {
  __typename?: 'parking_context_aggregate';
  aggregate?: Maybe<ParkingContextAggregateFields>;
  nodes: Array<ParkingContext>;
};

export type ParkingContextAggregateBoolExp = {
  count?: InputMaybe<ParkingContextAggregateBoolExpCount>;
};

export type ParkingContextAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ParkingContextSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ParkingContextBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "parking_context" */
export type ParkingContextAggregateFields = {
  __typename?: 'parking_context_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ParkingContextMaxFields>;
  min?: Maybe<ParkingContextMinFields>;
};


/** aggregate fields of "parking_context" */
export type ParkingContextAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingContextSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "parking_context" */
export type ParkingContextAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ParkingContextMaxOrderBy>;
  min?: InputMaybe<ParkingContextMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ParkingContextAppendInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "parking_context" */
export type ParkingContextArrRelInsertInput = {
  data: Array<ParkingContextInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ParkingContextOnConflict>;
};

/** Boolean expression to filter rows from the table "parking_context". All fields are combined with a logical 'AND'. */
export type ParkingContextBoolExp = {
  _and?: InputMaybe<Array<ParkingContextBoolExp>>;
  _not?: InputMaybe<ParkingContextBoolExp>;
  _or?: InputMaybe<Array<ParkingContextBoolExp>>;
  definition?: InputMaybe<JsonbComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "parking_context" */
export enum ParkingContextConstraint {
  /** unique or primary key constraint on columns "lot_id", "definition" */
  ParkingContextLotIdDefinitionKey = 'parking_context_lot_id_definition_key',
  /** unique or primary key constraint on columns "uuid" */
  ParkingContextPkey = 'parking_context_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ParkingContextDeleteAtPathInput = {
  definition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ParkingContextDeleteElemInput = {
  definition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ParkingContextDeleteKeyInput = {
  definition?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "parking_context" */
export type ParkingContextInsertInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ParkingContextMaxFields = {
  __typename?: 'parking_context_max_fields';
  lot_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "parking_context" */
export type ParkingContextMaxOrderBy = {
  lot_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ParkingContextMinFields = {
  __typename?: 'parking_context_min_fields';
  lot_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "parking_context" */
export type ParkingContextMinOrderBy = {
  lot_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "parking_context" */
export type ParkingContextMutationResponse = {
  __typename?: 'parking_context_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingContext>;
};

/** input type for inserting object relation for remote table "parking_context" */
export type ParkingContextObjRelInsertInput = {
  data: ParkingContextInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ParkingContextOnConflict>;
};

/** on_conflict condition type for table "parking_context" */
export type ParkingContextOnConflict = {
  constraint: ParkingContextConstraint;
  update_columns?: Array<ParkingContextUpdateColumn>;
  where?: InputMaybe<ParkingContextBoolExp>;
};

/** Ordering options when selecting data from "parking_context". */
export type ParkingContextOrderBy = {
  definition?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_context */
export type ParkingContextPkColumnsInput = {
  uuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ParkingContextPrependInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "parking_context" */
export enum ParkingContextSelectColumn {
  /** column name */
  Definition = 'definition',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "parking_context" */
export type ParkingContextSetInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "parking_context" */
export type ParkingContextStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingContextStreamCursorValueInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  lot_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "parking_context" */
export enum ParkingContextUpdateColumn {
  /** column name */
  Definition = 'definition',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Uuid = 'uuid'
}

export type ParkingContextUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ParkingContextAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ParkingContextDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ParkingContextDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ParkingContextDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ParkingContextPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingContextSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingContextBoolExp;
};

/** columns and relationships of "parking_detections" */
export type ParkingDetections = {
  __typename?: 'parking_detections';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  detection_type?: Maybe<Scalars['smallint']>;
  device_id: Scalars['Int'];
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  missing_lp?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_detections" */
export type ParkingDetectionsAggregate = {
  __typename?: 'parking_detections_aggregate';
  aggregate?: Maybe<ParkingDetectionsAggregateFields>;
  nodes: Array<ParkingDetections>;
};

/** aggregate fields of "parking_detections" */
export type ParkingDetectionsAggregateFields = {
  __typename?: 'parking_detections_aggregate_fields';
  avg?: Maybe<ParkingDetectionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingDetectionsMaxFields>;
  min?: Maybe<ParkingDetectionsMinFields>;
  stddev?: Maybe<ParkingDetectionsStddevFields>;
  stddev_pop?: Maybe<ParkingDetectionsStddevPopFields>;
  stddev_samp?: Maybe<ParkingDetectionsStddevSampFields>;
  sum?: Maybe<ParkingDetectionsSumFields>;
  var_pop?: Maybe<ParkingDetectionsVarPopFields>;
  var_samp?: Maybe<ParkingDetectionsVarSampFields>;
  variance?: Maybe<ParkingDetectionsVarianceFields>;
};


/** aggregate fields of "parking_detections" */
export type ParkingDetectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingDetectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "parking_detections_archive" */
export type ParkingDetectionsArchive = {
  __typename?: 'parking_detections_archive';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id: Scalars['Int'];
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  missing_lp?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_detections_archive" */
export type ParkingDetectionsArchiveAggregate = {
  __typename?: 'parking_detections_archive_aggregate';
  aggregate?: Maybe<ParkingDetectionsArchiveAggregateFields>;
  nodes: Array<ParkingDetectionsArchive>;
};

/** aggregate fields of "parking_detections_archive" */
export type ParkingDetectionsArchiveAggregateFields = {
  __typename?: 'parking_detections_archive_aggregate_fields';
  avg?: Maybe<ParkingDetectionsArchiveAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingDetectionsArchiveMaxFields>;
  min?: Maybe<ParkingDetectionsArchiveMinFields>;
  stddev?: Maybe<ParkingDetectionsArchiveStddevFields>;
  stddev_pop?: Maybe<ParkingDetectionsArchiveStddevPopFields>;
  stddev_samp?: Maybe<ParkingDetectionsArchiveStddevSampFields>;
  sum?: Maybe<ParkingDetectionsArchiveSumFields>;
  var_pop?: Maybe<ParkingDetectionsArchiveVarPopFields>;
  var_samp?: Maybe<ParkingDetectionsArchiveVarSampFields>;
  variance?: Maybe<ParkingDetectionsArchiveVarianceFields>;
};


/** aggregate fields of "parking_detections_archive" */
export type ParkingDetectionsArchiveAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingDetectionsArchiveSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ParkingDetectionsArchiveAvgFields = {
  __typename?: 'parking_detections_archive_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_detections_archive". All fields are combined with a logical 'AND'. */
export type ParkingDetectionsArchiveBoolExp = {
  _and?: InputMaybe<Array<ParkingDetectionsArchiveBoolExp>>;
  _not?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
  _or?: InputMaybe<Array<ParkingDetectionsArchiveBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  missing_lp?: InputMaybe<BooleanComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_detections_archive" */
export enum ParkingDetectionsArchiveConstraint {
  /** unique or primary key constraint on columns "id", "timestamp" */
  ParkingDetectionsArchivePkey = 'parking_detections_archive_pkey'
}

/** input type for incrementing numeric columns in table "parking_detections_archive" */
export type ParkingDetectionsArchiveIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "parking_detections_archive" */
export type ParkingDetectionsArchiveInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingDetectionsArchiveMaxFields = {
  __typename?: 'parking_detections_archive_max_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingDetectionsArchiveMinFields = {
  __typename?: 'parking_detections_archive_min_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_detections_archive" */
export type ParkingDetectionsArchiveMutationResponse = {
  __typename?: 'parking_detections_archive_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingDetectionsArchive>;
};

/** on_conflict condition type for table "parking_detections_archive" */
export type ParkingDetectionsArchiveOnConflict = {
  constraint: ParkingDetectionsArchiveConstraint;
  update_columns?: Array<ParkingDetectionsArchiveUpdateColumn>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};

/** Ordering options when selecting data from "parking_detections_archive". */
export type ParkingDetectionsArchiveOrderBy = {
  color?: InputMaybe<OrderBy>;
  coordinates?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  missing_lp?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_detections_archive */
export type ParkingDetectionsArchivePkColumnsInput = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};

/** select columns of table "parking_detections_archive" */
export enum ParkingDetectionsArchiveSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_detections_archive" */
export type ParkingDetectionsArchiveSetInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingDetectionsArchiveStddevFields = {
  __typename?: 'parking_detections_archive_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingDetectionsArchiveStddevPopFields = {
  __typename?: 'parking_detections_archive_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingDetectionsArchiveStddevSampFields = {
  __typename?: 'parking_detections_archive_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_detections_archive" */
export type ParkingDetectionsArchiveStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingDetectionsArchiveStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingDetectionsArchiveStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingDetectionsArchiveSumFields = {
  __typename?: 'parking_detections_archive_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
};

/** update columns of table "parking_detections_archive" */
export enum ParkingDetectionsArchiveUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

export type ParkingDetectionsArchiveUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingDetectionsArchiveIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingDetectionsArchiveSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingDetectionsArchiveBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingDetectionsArchiveVarPopFields = {
  __typename?: 'parking_detections_archive_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingDetectionsArchiveVarSampFields = {
  __typename?: 'parking_detections_archive_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingDetectionsArchiveVarianceFields = {
  __typename?: 'parking_detections_archive_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type ParkingDetectionsAvgFields = {
  __typename?: 'parking_detections_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_detections". All fields are combined with a logical 'AND'. */
export type ParkingDetectionsBoolExp = {
  _and?: InputMaybe<Array<ParkingDetectionsBoolExp>>;
  _not?: InputMaybe<ParkingDetectionsBoolExp>;
  _or?: InputMaybe<Array<ParkingDetectionsBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  missing_lp?: InputMaybe<BooleanComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_detections" */
export enum ParkingDetectionsConstraint {
  /** unique or primary key constraint on columns "id", "timestamp" */
  ParkingDetectionsPartitionedPkey = 'parking_detections_partitioned_pkey',
  /** unique or primary key constraint on columns "id", "timestamp" */
  ParkingDetectionsPartitionedUnique = 'parking_detections_partitioned_unique'
}

/** input type for incrementing numeric columns in table "parking_detections" */
export type ParkingDetectionsIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "parking_detections" */
export type ParkingDetectionsInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingDetectionsMaxFields = {
  __typename?: 'parking_detections_max_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingDetectionsMinFields = {
  __typename?: 'parking_detections_min_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_detections" */
export type ParkingDetectionsMutationResponse = {
  __typename?: 'parking_detections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingDetections>;
};

/** on_conflict condition type for table "parking_detections" */
export type ParkingDetectionsOnConflict = {
  constraint: ParkingDetectionsConstraint;
  update_columns?: Array<ParkingDetectionsUpdateColumn>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};

/** Ordering options when selecting data from "parking_detections". */
export type ParkingDetectionsOrderBy = {
  color?: InputMaybe<OrderBy>;
  coordinates?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  missing_lp?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_detections */
export type ParkingDetectionsPkColumnsInput = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};

/** select columns of table "parking_detections" */
export enum ParkingDetectionsSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_detections" */
export type ParkingDetectionsSetInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingDetectionsStddevFields = {
  __typename?: 'parking_detections_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingDetectionsStddevPopFields = {
  __typename?: 'parking_detections_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingDetectionsStddevSampFields = {
  __typename?: 'parking_detections_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_detections" */
export type ParkingDetectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingDetectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingDetectionsStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingDetectionsSumFields = {
  __typename?: 'parking_detections_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
};

/** update columns of table "parking_detections" */
export enum ParkingDetectionsUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

export type ParkingDetectionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingDetectionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingDetectionsSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingDetectionsBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingDetectionsVarPopFields = {
  __typename?: 'parking_detections_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingDetectionsVarSampFields = {
  __typename?: 'parking_detections_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingDetectionsVarianceFields = {
  __typename?: 'parking_detections_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "parking_incoming" */
export type ParkingIncoming = {
  __typename?: 'parking_incoming';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id: Scalars['Int'];
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  missing_lp?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_incoming" */
export type ParkingIncomingAggregate = {
  __typename?: 'parking_incoming_aggregate';
  aggregate?: Maybe<ParkingIncomingAggregateFields>;
  nodes: Array<ParkingIncoming>;
};

/** aggregate fields of "parking_incoming" */
export type ParkingIncomingAggregateFields = {
  __typename?: 'parking_incoming_aggregate_fields';
  avg?: Maybe<ParkingIncomingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingIncomingMaxFields>;
  min?: Maybe<ParkingIncomingMinFields>;
  stddev?: Maybe<ParkingIncomingStddevFields>;
  stddev_pop?: Maybe<ParkingIncomingStddevPopFields>;
  stddev_samp?: Maybe<ParkingIncomingStddevSampFields>;
  sum?: Maybe<ParkingIncomingSumFields>;
  var_pop?: Maybe<ParkingIncomingVarPopFields>;
  var_samp?: Maybe<ParkingIncomingVarSampFields>;
  variance?: Maybe<ParkingIncomingVarianceFields>;
};


/** aggregate fields of "parking_incoming" */
export type ParkingIncomingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingIncomingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ParkingIncomingAvgFields = {
  __typename?: 'parking_incoming_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_incoming". All fields are combined with a logical 'AND'. */
export type ParkingIncomingBoolExp = {
  _and?: InputMaybe<Array<ParkingIncomingBoolExp>>;
  _not?: InputMaybe<ParkingIncomingBoolExp>;
  _or?: InputMaybe<Array<ParkingIncomingBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  missing_lp?: InputMaybe<BooleanComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_incoming" */
export enum ParkingIncomingConstraint {
  /** unique or primary key constraint on columns "id" */
  ParkingIncomingPkey = 'parking_incoming_pkey'
}

/** input type for incrementing numeric columns in table "parking_incoming" */
export type ParkingIncomingIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "parking_incoming" */
export type ParkingIncomingInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingIncomingMaxFields = {
  __typename?: 'parking_incoming_max_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingIncomingMinFields = {
  __typename?: 'parking_incoming_min_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_incoming" */
export type ParkingIncomingMutationResponse = {
  __typename?: 'parking_incoming_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingIncoming>;
};

/** on_conflict condition type for table "parking_incoming" */
export type ParkingIncomingOnConflict = {
  constraint: ParkingIncomingConstraint;
  update_columns?: Array<ParkingIncomingUpdateColumn>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};

/** Ordering options when selecting data from "parking_incoming". */
export type ParkingIncomingOrderBy = {
  color?: InputMaybe<OrderBy>;
  coordinates?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  missing_lp?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_incoming */
export type ParkingIncomingPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "parking_incoming" */
export enum ParkingIncomingSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_incoming" */
export type ParkingIncomingSetInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingIncomingStddevFields = {
  __typename?: 'parking_incoming_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingIncomingStddevPopFields = {
  __typename?: 'parking_incoming_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingIncomingStddevSampFields = {
  __typename?: 'parking_incoming_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_incoming" */
export type ParkingIncomingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingIncomingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingIncomingStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingIncomingSumFields = {
  __typename?: 'parking_incoming_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
};

/** update columns of table "parking_incoming" */
export enum ParkingIncomingUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

export type ParkingIncomingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingIncomingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingIncomingSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingIncomingBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingIncomingVarPopFields = {
  __typename?: 'parking_incoming_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingIncomingVarSampFields = {
  __typename?: 'parking_incoming_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingIncomingVarianceFields = {
  __typename?: 'parking_incoming_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "parking_processing" */
export type ParkingProcessing = {
  __typename?: 'parking_processing';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id: Scalars['Int'];
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  missing_lp?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  similar_plate?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_processing" */
export type ParkingProcessingAggregate = {
  __typename?: 'parking_processing_aggregate';
  aggregate?: Maybe<ParkingProcessingAggregateFields>;
  nodes: Array<ParkingProcessing>;
};

/** aggregate fields of "parking_processing" */
export type ParkingProcessingAggregateFields = {
  __typename?: 'parking_processing_aggregate_fields';
  avg?: Maybe<ParkingProcessingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingProcessingMaxFields>;
  min?: Maybe<ParkingProcessingMinFields>;
  stddev?: Maybe<ParkingProcessingStddevFields>;
  stddev_pop?: Maybe<ParkingProcessingStddevPopFields>;
  stddev_samp?: Maybe<ParkingProcessingStddevSampFields>;
  sum?: Maybe<ParkingProcessingSumFields>;
  var_pop?: Maybe<ParkingProcessingVarPopFields>;
  var_samp?: Maybe<ParkingProcessingVarSampFields>;
  variance?: Maybe<ParkingProcessingVarianceFields>;
};


/** aggregate fields of "parking_processing" */
export type ParkingProcessingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingProcessingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ParkingProcessingAvgFields = {
  __typename?: 'parking_processing_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_processing". All fields are combined with a logical 'AND'. */
export type ParkingProcessingBoolExp = {
  _and?: InputMaybe<Array<ParkingProcessingBoolExp>>;
  _not?: InputMaybe<ParkingProcessingBoolExp>;
  _or?: InputMaybe<Array<ParkingProcessingBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  missing_lp?: InputMaybe<BooleanComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  similar_plate?: InputMaybe<BooleanComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_processing" */
export enum ParkingProcessingConstraint {
  /** unique or primary key constraint on columns "id" */
  ParkingProcessingPkey = 'parking_processing_pkey'
}

/** input type for incrementing numeric columns in table "parking_processing" */
export type ParkingProcessingIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "parking_processing" */
export type ParkingProcessingInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  similar_plate?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingProcessingMaxFields = {
  __typename?: 'parking_processing_max_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingProcessingMinFields = {
  __typename?: 'parking_processing_min_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_processing" */
export type ParkingProcessingMutationResponse = {
  __typename?: 'parking_processing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingProcessing>;
};

/** on_conflict condition type for table "parking_processing" */
export type ParkingProcessingOnConflict = {
  constraint: ParkingProcessingConstraint;
  update_columns?: Array<ParkingProcessingUpdateColumn>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};

/** Ordering options when selecting data from "parking_processing". */
export type ParkingProcessingOrderBy = {
  color?: InputMaybe<OrderBy>;
  coordinates?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  missing_lp?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  similar_plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_processing */
export type ParkingProcessingPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "parking_processing" */
export enum ParkingProcessingSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  SimilarPlate = 'similar_plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_processing" */
export type ParkingProcessingSetInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  similar_plate?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingProcessingStddevFields = {
  __typename?: 'parking_processing_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingProcessingStddevPopFields = {
  __typename?: 'parking_processing_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingProcessingStddevSampFields = {
  __typename?: 'parking_processing_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_processing" */
export type ParkingProcessingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingProcessingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingProcessingStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  similar_plate?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingProcessingSumFields = {
  __typename?: 'parking_processing_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
};

/** update columns of table "parking_processing" */
export enum ParkingProcessingUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  SimilarPlate = 'similar_plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

export type ParkingProcessingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingProcessingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingProcessingSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingProcessingBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingProcessingVarPopFields = {
  __typename?: 'parking_processing_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingProcessingVarSampFields = {
  __typename?: 'parking_processing_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingProcessingVarianceFields = {
  __typename?: 'parking_processing_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "parking_results" */
export type ParkingResults = {
  __typename?: 'parking_results';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  car_owner: Array<CarOwner>;
  /** An aggregate relationship */
  car_owner_aggregate: CarOwnerAggregate;
  /** An object relationship */
  car_owner_request?: Maybe<CarOwnerRequests>;
  category: Scalars['String'];
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  electric?: Maybe<Scalars['Boolean']>;
  error_rate?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lot?: Maybe<Lot>;
  /** An object relationship */
  lot_section?: Maybe<LotSection>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['bigint'];
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed: Scalars['String'];
  repeat_offense?: Maybe<Scalars['bigint']>;
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  violation_case?: Maybe<ViolationCase>;
  year?: Maybe<Scalars['String']>;
};


/** columns and relationships of "parking_results" */
export type ParkingResultsCarOwnerArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


/** columns and relationships of "parking_results" */
export type ParkingResultsCarOwnerAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};

/** aggregated selection of "parking_results" */
export type ParkingResultsAggregate = {
  __typename?: 'parking_results_aggregate';
  aggregate?: Maybe<ParkingResultsAggregateFields>;
  nodes: Array<ParkingResults>;
};

/** aggregate fields of "parking_results" */
export type ParkingResultsAggregateFields = {
  __typename?: 'parking_results_aggregate_fields';
  avg?: Maybe<ParkingResultsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingResultsMaxFields>;
  min?: Maybe<ParkingResultsMinFields>;
  stddev?: Maybe<ParkingResultsStddevFields>;
  stddev_pop?: Maybe<ParkingResultsStddevPopFields>;
  stddev_samp?: Maybe<ParkingResultsStddevSampFields>;
  sum?: Maybe<ParkingResultsSumFields>;
  var_pop?: Maybe<ParkingResultsVarPopFields>;
  var_samp?: Maybe<ParkingResultsVarSampFields>;
  variance?: Maybe<ParkingResultsVarianceFields>;
};


/** aggregate fields of "parking_results" */
export type ParkingResultsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingResultsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "parking_results_archive" */
export type ParkingResultsArchive = {
  __typename?: 'parking_results_archive';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  category: Scalars['String'];
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['bigint'];
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed: Scalars['String'];
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_results_archive" */
export type ParkingResultsArchiveAggregate = {
  __typename?: 'parking_results_archive_aggregate';
  aggregate?: Maybe<ParkingResultsArchiveAggregateFields>;
  nodes: Array<ParkingResultsArchive>;
};

/** aggregate fields of "parking_results_archive" */
export type ParkingResultsArchiveAggregateFields = {
  __typename?: 'parking_results_archive_aggregate_fields';
  avg?: Maybe<ParkingResultsArchiveAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingResultsArchiveMaxFields>;
  min?: Maybe<ParkingResultsArchiveMinFields>;
  stddev?: Maybe<ParkingResultsArchiveStddevFields>;
  stddev_pop?: Maybe<ParkingResultsArchiveStddevPopFields>;
  stddev_samp?: Maybe<ParkingResultsArchiveStddevSampFields>;
  sum?: Maybe<ParkingResultsArchiveSumFields>;
  var_pop?: Maybe<ParkingResultsArchiveVarPopFields>;
  var_samp?: Maybe<ParkingResultsArchiveVarSampFields>;
  variance?: Maybe<ParkingResultsArchiveVarianceFields>;
};


/** aggregate fields of "parking_results_archive" */
export type ParkingResultsArchiveAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingResultsArchiveSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ParkingResultsArchiveAvgFields = {
  __typename?: 'parking_results_archive_avg_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_results_archive". All fields are combined with a logical 'AND'. */
export type ParkingResultsArchiveBoolExp = {
  _and?: InputMaybe<Array<ParkingResultsArchiveBoolExp>>;
  _not?: InputMaybe<ParkingResultsArchiveBoolExp>;
  _or?: InputMaybe<Array<ParkingResultsArchiveBoolExp>>;
  billable_duration_min?: InputMaybe<BigintComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  city_code?: InputMaybe<StringComparisonExp>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates_in?: InputMaybe<StringComparisonExp>;
  coordinates_out?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  detection_type_in?: InputMaybe<SmallintComparisonExp>;
  detection_type_out?: InputMaybe<SmallintComparisonExp>;
  device_id_in?: InputMaybe<BigintComparisonExp>;
  device_id_out?: InputMaybe<BigintComparisonExp>;
  device_uuid_in?: InputMaybe<StringComparisonExp>;
  device_uuid_out?: InputMaybe<StringComparisonExp>;
  direction_in?: InputMaybe<StringComparisonExp>;
  direction_out?: InputMaybe<StringComparisonExp>;
  duration_min?: InputMaybe<BigintComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  plate_changed?: InputMaybe<StringComparisonExp>;
  plate_hashed?: InputMaybe<StringComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_results_archive" */
export enum ParkingResultsArchiveConstraint {
  /** unique or primary key constraint on columns "id", "timestamp_out" */
  ParkingResultsArchivePkey = 'parking_results_archive_pkey'
}

/** input type for incrementing numeric columns in table "parking_results_archive" */
export type ParkingResultsArchiveIncInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "parking_results_archive" */
export type ParkingResultsArchiveInsertInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingResultsArchiveMaxFields = {
  __typename?: 'parking_results_archive_max_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingResultsArchiveMinFields = {
  __typename?: 'parking_results_archive_min_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_results_archive" */
export type ParkingResultsArchiveMutationResponse = {
  __typename?: 'parking_results_archive_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingResultsArchive>;
};

/** on_conflict condition type for table "parking_results_archive" */
export type ParkingResultsArchiveOnConflict = {
  constraint: ParkingResultsArchiveConstraint;
  update_columns?: Array<ParkingResultsArchiveUpdateColumn>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};

/** Ordering options when selecting data from "parking_results_archive". */
export type ParkingResultsArchiveOrderBy = {
  billable_duration_min?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  city_code?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  coordinates_in?: InputMaybe<OrderBy>;
  coordinates_out?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  detection_type_in?: InputMaybe<OrderBy>;
  detection_type_out?: InputMaybe<OrderBy>;
  device_id_in?: InputMaybe<OrderBy>;
  device_id_out?: InputMaybe<OrderBy>;
  device_uuid_in?: InputMaybe<OrderBy>;
  device_uuid_out?: InputMaybe<OrderBy>;
  direction_in?: InputMaybe<OrderBy>;
  direction_out?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_changed?: InputMaybe<OrderBy>;
  plate_hashed?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_results_archive */
export type ParkingResultsArchivePkColumnsInput = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};

/** select columns of table "parking_results_archive" */
export enum ParkingResultsArchiveSelectColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CityCode = 'city_code',
  /** column name */
  Color = 'color',
  /** column name */
  CoordinatesIn = 'coordinates_in',
  /** column name */
  CoordinatesOut = 'coordinates_out',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionTypeIn = 'detection_type_in',
  /** column name */
  DetectionTypeOut = 'detection_type_out',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  DirectionIn = 'direction_in',
  /** column name */
  DirectionOut = 'direction_out',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateHashed = 'plate_hashed',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_results_archive" */
export type ParkingResultsArchiveSetInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingResultsArchiveStddevFields = {
  __typename?: 'parking_results_archive_stddev_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingResultsArchiveStddevPopFields = {
  __typename?: 'parking_results_archive_stddev_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingResultsArchiveStddevSampFields = {
  __typename?: 'parking_results_archive_stddev_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_results_archive" */
export type ParkingResultsArchiveStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingResultsArchiveStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingResultsArchiveStreamCursorValueInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingResultsArchiveSumFields = {
  __typename?: 'parking_results_archive_sum_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  parking_section?: Maybe<Scalars['bigint']>;
};

/** update columns of table "parking_results_archive" */
export enum ParkingResultsArchiveUpdateColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CityCode = 'city_code',
  /** column name */
  Color = 'color',
  /** column name */
  CoordinatesIn = 'coordinates_in',
  /** column name */
  CoordinatesOut = 'coordinates_out',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionTypeIn = 'detection_type_in',
  /** column name */
  DetectionTypeOut = 'detection_type_out',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  DirectionIn = 'direction_in',
  /** column name */
  DirectionOut = 'direction_out',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateHashed = 'plate_hashed',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

export type ParkingResultsArchiveUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingResultsArchiveIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingResultsArchiveSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingResultsArchiveBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingResultsArchiveVarPopFields = {
  __typename?: 'parking_results_archive_var_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingResultsArchiveVarSampFields = {
  __typename?: 'parking_results_archive_var_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingResultsArchiveVarianceFields = {
  __typename?: 'parking_results_archive_variance_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type ParkingResultsAvgFields = {
  __typename?: 'parking_results_avg_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "parking_results". All fields are combined with a logical 'AND'. */
export type ParkingResultsBoolExp = {
  _and?: InputMaybe<Array<ParkingResultsBoolExp>>;
  _not?: InputMaybe<ParkingResultsBoolExp>;
  _or?: InputMaybe<Array<ParkingResultsBoolExp>>;
  billable_duration_min?: InputMaybe<BigintComparisonExp>;
  car_owner?: InputMaybe<CarOwnerBoolExp>;
  car_owner_aggregate?: InputMaybe<CarOwnerAggregateBoolExp>;
  car_owner_request?: InputMaybe<CarOwnerRequestsBoolExp>;
  category?: InputMaybe<StringComparisonExp>;
  city_code?: InputMaybe<StringComparisonExp>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates_in?: InputMaybe<StringComparisonExp>;
  coordinates_out?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  detection_type_in?: InputMaybe<SmallintComparisonExp>;
  detection_type_out?: InputMaybe<SmallintComparisonExp>;
  device_id_in?: InputMaybe<BigintComparisonExp>;
  device_id_out?: InputMaybe<BigintComparisonExp>;
  device_uuid_in?: InputMaybe<StringComparisonExp>;
  device_uuid_out?: InputMaybe<StringComparisonExp>;
  direction_in?: InputMaybe<StringComparisonExp>;
  direction_out?: InputMaybe<StringComparisonExp>;
  duration_min?: InputMaybe<BigintComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  error_rate?: InputMaybe<Float8ComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_section?: InputMaybe<LotSectionBoolExp>;
  make?: InputMaybe<StringComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  plate_changed?: InputMaybe<StringComparisonExp>;
  plate_hashed?: InputMaybe<StringComparisonExp>;
  repeat_offense?: InputMaybe<BigintComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violation_case?: InputMaybe<ViolationCaseBoolExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_results" */
export enum ParkingResultsConstraint {
  /** unique or primary key constraint on columns "id", "timestamp_out" */
  ParkingResultsPkey1 = 'parking_results_pkey1'
}

/** input type for incrementing numeric columns in table "parking_results" */
export type ParkingResultsIncInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "parking_results" */
export type ParkingResultsInsertInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  car_owner?: InputMaybe<CarOwnerArrRelInsertInput>;
  car_owner_request?: InputMaybe<CarOwnerRequestsObjRelInsertInput>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_section?: InputMaybe<LotSectionObjRelInsertInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case?: InputMaybe<ViolationCaseObjRelInsertInput>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingResultsMaxFields = {
  __typename?: 'parking_results_max_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  error_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed?: Maybe<Scalars['String']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingResultsMinFields = {
  __typename?: 'parking_results_min_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  city_code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  coordinates_in?: Maybe<Scalars['String']>;
  coordinates_out?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  direction_in?: Maybe<Scalars['String']>;
  direction_out?: Maybe<Scalars['String']>;
  duration_min?: Maybe<Scalars['bigint']>;
  error_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  plate_changed?: Maybe<Scalars['String']>;
  plate_hashed?: Maybe<Scalars['String']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_results" */
export type ParkingResultsMutationResponse = {
  __typename?: 'parking_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingResults>;
};

/** input type for inserting object relation for remote table "parking_results" */
export type ParkingResultsObjRelInsertInput = {
  data: ParkingResultsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ParkingResultsOnConflict>;
};

/** on_conflict condition type for table "parking_results" */
export type ParkingResultsOnConflict = {
  constraint: ParkingResultsConstraint;
  update_columns?: Array<ParkingResultsUpdateColumn>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};

/** Ordering options when selecting data from "parking_results". */
export type ParkingResultsOrderBy = {
  billable_duration_min?: InputMaybe<OrderBy>;
  car_owner_aggregate?: InputMaybe<CarOwnerAggregateOrderBy>;
  car_owner_request?: InputMaybe<CarOwnerRequestsOrderBy>;
  category?: InputMaybe<OrderBy>;
  city_code?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  coordinates_in?: InputMaybe<OrderBy>;
  coordinates_out?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  detection_type_in?: InputMaybe<OrderBy>;
  detection_type_out?: InputMaybe<OrderBy>;
  device_id_in?: InputMaybe<OrderBy>;
  device_id_out?: InputMaybe<OrderBy>;
  device_uuid_in?: InputMaybe<OrderBy>;
  device_uuid_out?: InputMaybe<OrderBy>;
  direction_in?: InputMaybe<OrderBy>;
  direction_out?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  error_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_section?: InputMaybe<LotSectionOrderBy>;
  make?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_changed?: InputMaybe<OrderBy>;
  plate_hashed?: InputMaybe<OrderBy>;
  repeat_offense?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_case?: InputMaybe<ViolationCaseOrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_results */
export type ParkingResultsPkColumnsInput = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};

/** select columns of table "parking_results" */
export enum ParkingResultsSelectColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CityCode = 'city_code',
  /** column name */
  Color = 'color',
  /** column name */
  CoordinatesIn = 'coordinates_in',
  /** column name */
  CoordinatesOut = 'coordinates_out',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionTypeIn = 'detection_type_in',
  /** column name */
  DetectionTypeOut = 'detection_type_out',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  DirectionIn = 'direction_in',
  /** column name */
  DirectionOut = 'direction_out',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateHashed = 'plate_hashed',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_results" */
export type ParkingResultsSetInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingResultsStddevFields = {
  __typename?: 'parking_results_stddev_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** aggregate stddev_pop on columns */
export type ParkingResultsStddevPopFields = {
  __typename?: 'parking_results_stddev_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** aggregate stddev_samp on columns */
export type ParkingResultsStddevSampFields = {
  __typename?: 'parking_results_stddev_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "parking_results" */
export type ParkingResultsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingResultsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingResultsStreamCursorValueInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Scalars['String']>;
  city_code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  coordinates_in?: InputMaybe<Scalars['String']>;
  coordinates_out?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_type_in?: InputMaybe<Scalars['smallint']>;
  detection_type_out?: InputMaybe<Scalars['smallint']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  direction_in?: InputMaybe<Scalars['String']>;
  direction_out?: InputMaybe<Scalars['String']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_changed?: InputMaybe<Scalars['String']>;
  plate_hashed?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingResultsSumFields = {
  __typename?: 'parking_results_sum_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  detection_type_in?: Maybe<Scalars['smallint']>;
  detection_type_out?: Maybe<Scalars['smallint']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['bigint']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** update columns of table "parking_results" */
export enum ParkingResultsUpdateColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  Category = 'category',
  /** column name */
  CityCode = 'city_code',
  /** column name */
  Color = 'color',
  /** column name */
  CoordinatesIn = 'coordinates_in',
  /** column name */
  CoordinatesOut = 'coordinates_out',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionTypeIn = 'detection_type_in',
  /** column name */
  DetectionTypeOut = 'detection_type_out',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  DirectionIn = 'direction_in',
  /** column name */
  DirectionOut = 'direction_out',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateChanged = 'plate_changed',
  /** column name */
  PlateHashed = 'plate_hashed',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

export type ParkingResultsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingResultsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingResultsSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingResultsBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingResultsVarPopFields = {
  __typename?: 'parking_results_var_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** aggregate var_samp on columns */
export type ParkingResultsVarSampFields = {
  __typename?: 'parking_results_var_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** aggregate variance on columns */
export type ParkingResultsVarianceFields = {
  __typename?: 'parking_results_variance_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  detection_type_in?: Maybe<Scalars['Float']>;
  detection_type_out?: Maybe<Scalars['Float']>;
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  error_rate?: Maybe<Scalars['float8']>;
  parking_section?: Maybe<Scalars['Float']>;
  repeat_offense?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "parking_temp" */
export type ParkingTemp = {
  __typename?: 'parking_temp';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id: Scalars['Int'];
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  electric?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  make?: Maybe<Scalars['String']>;
  missing_lp?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  oldtimer?: Maybe<Scalars['Boolean']>;
  parking_lot: Scalars['String'];
  parking_section: Scalars['Int'];
  plate: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parking_temp" */
export type ParkingTempAggregate = {
  __typename?: 'parking_temp_aggregate';
  aggregate?: Maybe<ParkingTempAggregateFields>;
  nodes: Array<ParkingTemp>;
};

/** aggregate fields of "parking_temp" */
export type ParkingTempAggregateFields = {
  __typename?: 'parking_temp_aggregate_fields';
  avg?: Maybe<ParkingTempAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ParkingTempMaxFields>;
  min?: Maybe<ParkingTempMinFields>;
  stddev?: Maybe<ParkingTempStddevFields>;
  stddev_pop?: Maybe<ParkingTempStddevPopFields>;
  stddev_samp?: Maybe<ParkingTempStddevSampFields>;
  sum?: Maybe<ParkingTempSumFields>;
  var_pop?: Maybe<ParkingTempVarPopFields>;
  var_samp?: Maybe<ParkingTempVarSampFields>;
  variance?: Maybe<ParkingTempVarianceFields>;
};


/** aggregate fields of "parking_temp" */
export type ParkingTempAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParkingTempSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ParkingTempAvgFields = {
  __typename?: 'parking_temp_avg_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parking_temp". All fields are combined with a logical 'AND'. */
export type ParkingTempBoolExp = {
  _and?: InputMaybe<Array<ParkingTempBoolExp>>;
  _not?: InputMaybe<ParkingTempBoolExp>;
  _or?: InputMaybe<Array<ParkingTempBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  coordinates?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  detection_type?: InputMaybe<SmallintComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  electric?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  make?: InputMaybe<StringComparisonExp>;
  missing_lp?: InputMaybe<BooleanComparisonExp>;
  model?: InputMaybe<StringComparisonExp>;
  oldtimer?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_section?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  year?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parking_temp" */
export enum ParkingTempConstraint {
  /** unique or primary key constraint on columns "id" */
  ParkingTempPkey = 'parking_temp_pkey'
}

/** input type for incrementing numeric columns in table "parking_temp" */
export type ParkingTempIncInput = {
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  parking_section?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "parking_temp" */
export type ParkingTempInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkingTempMaxFields = {
  __typename?: 'parking_temp_max_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkingTempMinFields = {
  __typename?: 'parking_temp_min_fields';
  color?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_uuid?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_section?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "parking_temp" */
export type ParkingTempMutationResponse = {
  __typename?: 'parking_temp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkingTemp>;
};

/** on_conflict condition type for table "parking_temp" */
export type ParkingTempOnConflict = {
  constraint: ParkingTempConstraint;
  update_columns?: Array<ParkingTempUpdateColumn>;
  where?: InputMaybe<ParkingTempBoolExp>;
};

/** Ordering options when selecting data from "parking_temp". */
export type ParkingTempOrderBy = {
  color?: InputMaybe<OrderBy>;
  coordinates?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  detection_type?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  electric?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  make?: InputMaybe<OrderBy>;
  missing_lp?: InputMaybe<OrderBy>;
  model?: InputMaybe<OrderBy>;
  oldtimer?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_section?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parking_temp */
export type ParkingTempPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "parking_temp" */
export enum ParkingTempSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "parking_temp" */
export type ParkingTempSetInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkingTempStddevFields = {
  __typename?: 'parking_temp_stddev_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkingTempStddevPopFields = {
  __typename?: 'parking_temp_stddev_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkingTempStddevSampFields = {
  __typename?: 'parking_temp_stddev_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parking_temp" */
export type ParkingTempStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ParkingTempStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParkingTempStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  detection_type?: InputMaybe<Scalars['smallint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  electric?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  missing_lp?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  oldtimer?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_section?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkingTempSumFields = {
  __typename?: 'parking_temp_sum_fields';
  detection_type?: Maybe<Scalars['smallint']>;
  device_id?: Maybe<Scalars['Int']>;
  parking_section?: Maybe<Scalars['Int']>;
};

/** update columns of table "parking_temp" */
export enum ParkingTempUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  DetectionType = 'detection_type',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Direction = 'direction',
  /** column name */
  Electric = 'electric',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  MissingLp = 'missing_lp',
  /** column name */
  Model = 'model',
  /** column name */
  Oldtimer = 'oldtimer',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingSection = 'parking_section',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Year = 'year'
}

export type ParkingTempUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkingTempIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkingTempSetInput>;
  /** filter the rows which have to be updated */
  where: ParkingTempBoolExp;
};

/** aggregate var_pop on columns */
export type ParkingTempVarPopFields = {
  __typename?: 'parking_temp_var_pop_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkingTempVarSampFields = {
  __typename?: 'parking_temp_var_samp_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkingTempVarianceFields = {
  __typename?: 'parking_temp_variance_fields';
  detection_type?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  parking_section?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "paybyphone_lot" */
export type PaybyphoneLot = {
  __typename?: 'paybyphone_lot';
  /** An object relationship */
  lot: Lot;
  lot_id: Scalars['String'];
  paybyphone_enabled: Scalars['Boolean'];
  paybyphone_lot_id: Scalars['String'];
};

/** aggregated selection of "paybyphone_lot" */
export type PaybyphoneLotAggregate = {
  __typename?: 'paybyphone_lot_aggregate';
  aggregate?: Maybe<PaybyphoneLotAggregateFields>;
  nodes: Array<PaybyphoneLot>;
};

/** aggregate fields of "paybyphone_lot" */
export type PaybyphoneLotAggregateFields = {
  __typename?: 'paybyphone_lot_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PaybyphoneLotMaxFields>;
  min?: Maybe<PaybyphoneLotMinFields>;
};


/** aggregate fields of "paybyphone_lot" */
export type PaybyphoneLotAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaybyphoneLotSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "paybyphone_lot". All fields are combined with a logical 'AND'. */
export type PaybyphoneLotBoolExp = {
  _and?: InputMaybe<Array<PaybyphoneLotBoolExp>>;
  _not?: InputMaybe<PaybyphoneLotBoolExp>;
  _or?: InputMaybe<Array<PaybyphoneLotBoolExp>>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  paybyphone_enabled?: InputMaybe<BooleanComparisonExp>;
  paybyphone_lot_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "paybyphone_lot" */
export enum PaybyphoneLotConstraint {
  /** unique or primary key constraint on columns "paybyphone_lot_id" */
  PaybyphoneLotPaybyphoneLotIdKey = 'paybyphone_lot_paybyphone_lot_id_key',
  /** unique or primary key constraint on columns "lot_id" */
  PaybyphoneLotPkey = 'paybyphone_lot_pkey'
}

/** input type for inserting data into table "paybyphone_lot" */
export type PaybyphoneLotInsertInput = {
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_enabled?: InputMaybe<Scalars['Boolean']>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaybyphoneLotMaxFields = {
  __typename?: 'paybyphone_lot_max_fields';
  lot_id?: Maybe<Scalars['String']>;
  paybyphone_lot_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaybyphoneLotMinFields = {
  __typename?: 'paybyphone_lot_min_fields';
  lot_id?: Maybe<Scalars['String']>;
  paybyphone_lot_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "paybyphone_lot" */
export type PaybyphoneLotMutationResponse = {
  __typename?: 'paybyphone_lot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaybyphoneLot>;
};

/** input type for inserting object relation for remote table "paybyphone_lot" */
export type PaybyphoneLotObjRelInsertInput = {
  data: PaybyphoneLotInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaybyphoneLotOnConflict>;
};

/** on_conflict condition type for table "paybyphone_lot" */
export type PaybyphoneLotOnConflict = {
  constraint: PaybyphoneLotConstraint;
  update_columns?: Array<PaybyphoneLotUpdateColumn>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};

/** Ordering options when selecting data from "paybyphone_lot". */
export type PaybyphoneLotOrderBy = {
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  paybyphone_enabled?: InputMaybe<OrderBy>;
  paybyphone_lot_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: paybyphone_lot */
export type PaybyphoneLotPkColumnsInput = {
  lot_id: Scalars['String'];
};

/** select columns of table "paybyphone_lot" */
export enum PaybyphoneLotSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PaybyphoneEnabled = 'paybyphone_enabled',
  /** column name */
  PaybyphoneLotId = 'paybyphone_lot_id'
}

/** input type for updating data in table "paybyphone_lot" */
export type PaybyphoneLotSetInput = {
  lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_enabled?: InputMaybe<Scalars['Boolean']>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "paybyphone_lot" */
export type PaybyphoneLotStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PaybyphoneLotStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaybyphoneLotStreamCursorValueInput = {
  lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_enabled?: InputMaybe<Scalars['Boolean']>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "paybyphone_lot" */
export enum PaybyphoneLotUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PaybyphoneEnabled = 'paybyphone_enabled',
  /** column name */
  PaybyphoneLotId = 'paybyphone_lot_id'
}

export type PaybyphoneLotUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaybyphoneLotSetInput>;
  /** filter the rows which have to be updated */
  where: PaybyphoneLotBoolExp;
};

/** columns and relationships of "paybyphone_order" */
export type PaybyphoneOrder = {
  __typename?: 'paybyphone_order';
  country: Scalars['String'];
  currency: Scalars['String'];
  end_date: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  paybyphone_lot: PaybyphoneLot;
  paybyphone_lot_id: Scalars['String'];
  paybyphone_order_id: Scalars['String'];
  plate: Scalars['String'];
  price: Scalars['Float'];
  start_date: Scalars['timestamptz'];
  /** An object relationship */
  time_discount?: Maybe<TimeDiscount>;
  time_discount_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "paybyphone_order" */
export type PaybyphoneOrderAggregate = {
  __typename?: 'paybyphone_order_aggregate';
  aggregate?: Maybe<PaybyphoneOrderAggregateFields>;
  nodes: Array<PaybyphoneOrder>;
};

/** aggregate fields of "paybyphone_order" */
export type PaybyphoneOrderAggregateFields = {
  __typename?: 'paybyphone_order_aggregate_fields';
  avg?: Maybe<PaybyphoneOrderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PaybyphoneOrderMaxFields>;
  min?: Maybe<PaybyphoneOrderMinFields>;
  stddev?: Maybe<PaybyphoneOrderStddevFields>;
  stddev_pop?: Maybe<PaybyphoneOrderStddevPopFields>;
  stddev_samp?: Maybe<PaybyphoneOrderStddevSampFields>;
  sum?: Maybe<PaybyphoneOrderSumFields>;
  var_pop?: Maybe<PaybyphoneOrderVarPopFields>;
  var_samp?: Maybe<PaybyphoneOrderVarSampFields>;
  variance?: Maybe<PaybyphoneOrderVarianceFields>;
};


/** aggregate fields of "paybyphone_order" */
export type PaybyphoneOrderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaybyphoneOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PaybyphoneOrderAvgFields = {
  __typename?: 'paybyphone_order_avg_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "paybyphone_order". All fields are combined with a logical 'AND'. */
export type PaybyphoneOrderBoolExp = {
  _and?: InputMaybe<Array<PaybyphoneOrderBoolExp>>;
  _not?: InputMaybe<PaybyphoneOrderBoolExp>;
  _or?: InputMaybe<Array<PaybyphoneOrderBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotBoolExp>;
  paybyphone_lot_id?: InputMaybe<StringComparisonExp>;
  paybyphone_order_id?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  price?: InputMaybe<FloatComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
  time_discount?: InputMaybe<TimeDiscountBoolExp>;
  time_discount_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "paybyphone_order" */
export enum PaybyphoneOrderConstraint {
  /** unique or primary key constraint on columns "paybyphone_order_id" */
  PaybyphoneOrderPaybyphoneOrderIdKey = 'paybyphone_order_paybyphone_order_id_key',
  /** unique or primary key constraint on columns "id" */
  PaybyphoneOrderPkey = 'paybyphone_order_pkey'
}

/** input type for incrementing numeric columns in table "paybyphone_order" */
export type PaybyphoneOrderIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  time_discount_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "paybyphone_order" */
export type PaybyphoneOrderInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotObjRelInsertInput>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_order_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  time_discount?: InputMaybe<TimeDiscountObjRelInsertInput>;
  time_discount_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PaybyphoneOrderMaxFields = {
  __typename?: 'paybyphone_order_max_fields';
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paybyphone_lot_id?: Maybe<Scalars['String']>;
  paybyphone_order_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  time_discount_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type PaybyphoneOrderMinFields = {
  __typename?: 'paybyphone_order_min_fields';
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paybyphone_lot_id?: Maybe<Scalars['String']>;
  paybyphone_order_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  time_discount_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "paybyphone_order" */
export type PaybyphoneOrderMutationResponse = {
  __typename?: 'paybyphone_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaybyphoneOrder>;
};

/** on_conflict condition type for table "paybyphone_order" */
export type PaybyphoneOrderOnConflict = {
  constraint: PaybyphoneOrderConstraint;
  update_columns?: Array<PaybyphoneOrderUpdateColumn>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};

/** Ordering options when selecting data from "paybyphone_order". */
export type PaybyphoneOrderOrderBy = {
  country?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  paybyphone_lot?: InputMaybe<PaybyphoneLotOrderBy>;
  paybyphone_lot_id?: InputMaybe<OrderBy>;
  paybyphone_order_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  time_discount?: InputMaybe<TimeDiscountOrderBy>;
  time_discount_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: paybyphone_order */
export type PaybyphoneOrderPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "paybyphone_order" */
export enum PaybyphoneOrderSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  Currency = 'currency',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaybyphoneLotId = 'paybyphone_lot_id',
  /** column name */
  PaybyphoneOrderId = 'paybyphone_order_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Price = 'price',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TimeDiscountId = 'time_discount_id'
}

/** input type for updating data in table "paybyphone_order" */
export type PaybyphoneOrderSetInput = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_order_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  time_discount_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PaybyphoneOrderStddevFields = {
  __typename?: 'paybyphone_order_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PaybyphoneOrderStddevPopFields = {
  __typename?: 'paybyphone_order_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PaybyphoneOrderStddevSampFields = {
  __typename?: 'paybyphone_order_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "paybyphone_order" */
export type PaybyphoneOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PaybyphoneOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaybyphoneOrderStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paybyphone_lot_id?: InputMaybe<Scalars['String']>;
  paybyphone_order_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  time_discount_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PaybyphoneOrderSumFields = {
  __typename?: 'paybyphone_order_sum_fields';
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "paybyphone_order" */
export enum PaybyphoneOrderUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  Currency = 'currency',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaybyphoneLotId = 'paybyphone_lot_id',
  /** column name */
  PaybyphoneOrderId = 'paybyphone_order_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  Price = 'price',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TimeDiscountId = 'time_discount_id'
}

export type PaybyphoneOrderUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaybyphoneOrderIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaybyphoneOrderSetInput>;
  /** filter the rows which have to be updated */
  where: PaybyphoneOrderBoolExp;
};

/** aggregate var_pop on columns */
export type PaybyphoneOrderVarPopFields = {
  __typename?: 'paybyphone_order_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PaybyphoneOrderVarSampFields = {
  __typename?: 'paybyphone_order_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PaybyphoneOrderVarianceFields = {
  __typename?: 'paybyphone_order_variance_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  time_discount_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "person" */
export type Person = {
  __typename?: 'person';
  /** An object relationship */
  car_driver?: Maybe<CarDriver>;
  /** An object relationship */
  car_owner?: Maybe<CarOwner>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  data_source?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['date']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  last_name?: Maybe<Scalars['String']>;
  place_of_birth?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "person" */
export type PersonAggregate = {
  __typename?: 'person_aggregate';
  aggregate?: Maybe<PersonAggregateFields>;
  nodes: Array<Person>;
};

/** aggregate fields of "person" */
export type PersonAggregateFields = {
  __typename?: 'person_aggregate_fields';
  avg?: Maybe<PersonAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PersonMaxFields>;
  min?: Maybe<PersonMinFields>;
  stddev?: Maybe<PersonStddevFields>;
  stddev_pop?: Maybe<PersonStddevPopFields>;
  stddev_samp?: Maybe<PersonStddevSampFields>;
  sum?: Maybe<PersonSumFields>;
  var_pop?: Maybe<PersonVarPopFields>;
  var_samp?: Maybe<PersonVarSampFields>;
  variance?: Maybe<PersonVarianceFields>;
};


/** aggregate fields of "person" */
export type PersonAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PersonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PersonAvgFields = {
  __typename?: 'person_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "person". All fields are combined with a logical 'AND'. */
export type PersonBoolExp = {
  _and?: InputMaybe<Array<PersonBoolExp>>;
  _not?: InputMaybe<PersonBoolExp>;
  _or?: InputMaybe<Array<PersonBoolExp>>;
  car_driver?: InputMaybe<CarDriverBoolExp>;
  car_owner?: InputMaybe<CarOwnerBoolExp>;
  city?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  data_source?: InputMaybe<StringComparisonExp>;
  date_of_birth?: InputMaybe<DateComparisonExp>;
  first_name?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  house_number?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_name?: InputMaybe<StringComparisonExp>;
  place_of_birth?: InputMaybe<StringComparisonExp>;
  postal_code?: InputMaybe<StringComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "person" */
export enum PersonConstraint {
  /** unique or primary key constraint on columns "id" */
  PersonPkey = 'person_pkey'
}

/** input type for incrementing numeric columns in table "person" */
export type PersonIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "person" */
export type PersonInsertInput = {
  car_driver?: InputMaybe<CarDriverObjRelInsertInput>;
  car_owner?: InputMaybe<CarOwnerObjRelInsertInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_name?: InputMaybe<Scalars['String']>;
  place_of_birth?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PersonMaxFields = {
  __typename?: 'person_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_source?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['date']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_name?: Maybe<Scalars['String']>;
  place_of_birth?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PersonMinFields = {
  __typename?: 'person_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_source?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['date']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_name?: Maybe<Scalars['String']>;
  place_of_birth?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "person" */
export type PersonMutationResponse = {
  __typename?: 'person_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Person>;
};

/** input type for inserting object relation for remote table "person" */
export type PersonObjRelInsertInput = {
  data: PersonInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PersonOnConflict>;
};

/** on_conflict condition type for table "person" */
export type PersonOnConflict = {
  constraint: PersonConstraint;
  update_columns?: Array<PersonUpdateColumn>;
  where?: InputMaybe<PersonBoolExp>;
};

/** Ordering options when selecting data from "person". */
export type PersonOrderBy = {
  car_driver?: InputMaybe<CarDriverOrderBy>;
  car_owner?: InputMaybe<CarOwnerOrderBy>;
  city?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  data_source?: InputMaybe<OrderBy>;
  date_of_birth?: InputMaybe<OrderBy>;
  first_name?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  house_number?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_name?: InputMaybe<OrderBy>;
  place_of_birth?: InputMaybe<OrderBy>;
  postal_code?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: person */
export type PersonPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "person" */
export enum PersonSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PlaceOfBirth = 'place_of_birth',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "person" */
export type PersonSetInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_name?: InputMaybe<Scalars['String']>;
  place_of_birth?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PersonStddevFields = {
  __typename?: 'person_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PersonStddevPopFields = {
  __typename?: 'person_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PersonStddevSampFields = {
  __typename?: 'person_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "person" */
export type PersonStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PersonStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PersonStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_source?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  house_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_name?: InputMaybe<Scalars['String']>;
  place_of_birth?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PersonSumFields = {
  __typename?: 'person_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "person" */
export enum PersonUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PlaceOfBirth = 'place_of_birth',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type PersonUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PersonIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PersonSetInput>;
  /** filter the rows which have to be updated */
  where: PersonBoolExp;
};

/** aggregate var_pop on columns */
export type PersonVarPopFields = {
  __typename?: 'person_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PersonVarSampFields = {
  __typename?: 'person_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PersonVarianceFields = {
  __typename?: 'person_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "policy_schedule" */
export type PolicySchedule = {
  __typename?: 'policy_schedule';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  issuer?: Maybe<Scalars['String']>;
  lot_section_id: Scalars['String'];
  policy: Scalars['jsonb'];
  start_date: Scalars['timestamptz'];
};


/** columns and relationships of "policy_schedule" */
export type PolicySchedulePolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "policy_schedule" */
export type PolicyScheduleAggregate = {
  __typename?: 'policy_schedule_aggregate';
  aggregate?: Maybe<PolicyScheduleAggregateFields>;
  nodes: Array<PolicySchedule>;
};

/** aggregate fields of "policy_schedule" */
export type PolicyScheduleAggregateFields = {
  __typename?: 'policy_schedule_aggregate_fields';
  avg?: Maybe<PolicyScheduleAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyScheduleMaxFields>;
  min?: Maybe<PolicyScheduleMinFields>;
  stddev?: Maybe<PolicyScheduleStddevFields>;
  stddev_pop?: Maybe<PolicyScheduleStddevPopFields>;
  stddev_samp?: Maybe<PolicyScheduleStddevSampFields>;
  sum?: Maybe<PolicyScheduleSumFields>;
  var_pop?: Maybe<PolicyScheduleVarPopFields>;
  var_samp?: Maybe<PolicyScheduleVarSampFields>;
  variance?: Maybe<PolicyScheduleVarianceFields>;
};


/** aggregate fields of "policy_schedule" */
export type PolicyScheduleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyScheduleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyScheduleAppendInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PolicyScheduleAvgFields = {
  __typename?: 'policy_schedule_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "policy_schedule". All fields are combined with a logical 'AND'. */
export type PolicyScheduleBoolExp = {
  _and?: InputMaybe<Array<PolicyScheduleBoolExp>>;
  _not?: InputMaybe<PolicyScheduleBoolExp>;
  _or?: InputMaybe<Array<PolicyScheduleBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  issuer?: InputMaybe<StringComparisonExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
  policy?: InputMaybe<JsonbComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "policy_schedule" */
export enum PolicyScheduleConstraint {
  /** unique or primary key constraint on columns "id" */
  PolicySchedulePkey = 'policy_schedule_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyScheduleDeleteAtPathInput = {
  policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyScheduleDeleteElemInput = {
  policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyScheduleDeleteKeyInput = {
  policy?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "policy_schedule" */
export type PolicyScheduleIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "policy_schedule" */
export type PolicyScheduleInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  issuer?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyScheduleMaxFields = {
  __typename?: 'policy_schedule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  issuer?: Maybe<Scalars['String']>;
  lot_section_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PolicyScheduleMinFields = {
  __typename?: 'policy_schedule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  issuer?: Maybe<Scalars['String']>;
  lot_section_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "policy_schedule" */
export type PolicyScheduleMutationResponse = {
  __typename?: 'policy_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicySchedule>;
};

/** on_conflict condition type for table "policy_schedule" */
export type PolicyScheduleOnConflict = {
  constraint: PolicyScheduleConstraint;
  update_columns?: Array<PolicyScheduleUpdateColumn>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};

/** Ordering options when selecting data from "policy_schedule". */
export type PolicyScheduleOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issuer?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: policy_schedule */
export type PolicySchedulePkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicySchedulePrependInput = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "policy_schedule" */
export enum PolicyScheduleSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Issuer = 'issuer',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  StartDate = 'start_date'
}

/** input type for updating data in table "policy_schedule" */
export type PolicyScheduleSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  issuer?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyScheduleStddevFields = {
  __typename?: 'policy_schedule_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyScheduleStddevPopFields = {
  __typename?: 'policy_schedule_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyScheduleStddevSampFields = {
  __typename?: 'policy_schedule_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policy_schedule" */
export type PolicyScheduleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PolicyScheduleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyScheduleStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  issuer?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyScheduleSumFields = {
  __typename?: 'policy_schedule_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "policy_schedule" */
export enum PolicyScheduleUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Issuer = 'issuer',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  Policy = 'policy',
  /** column name */
  StartDate = 'start_date'
}

export type PolicyScheduleUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyScheduleAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyScheduleDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyScheduleDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyScheduleDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyScheduleIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicySchedulePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyScheduleSetInput>;
  /** filter the rows which have to be updated */
  where: PolicyScheduleBoolExp;
};

/** aggregate var_pop on columns */
export type PolicyScheduleVarPopFields = {
  __typename?: 'policy_schedule_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyScheduleVarSampFields = {
  __typename?: 'policy_schedule_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyScheduleVarianceFields = {
  __typename?: 'policy_schedule_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "adyen_report" */
  adyen_report: Array<AdyenReport>;
  /** fetch aggregated fields from the table: "adyen_report" */
  adyen_report_aggregate: AdyenReportAggregate;
  /** fetch data from the table: "adyen_report" using primary key columns */
  adyen_report_by_pk?: Maybe<AdyenReport>;
  /** fetch data from the table: "adyen_transaction" */
  adyen_transaction: Array<AdyenTransaction>;
  /** fetch aggregated fields from the table: "adyen_transaction" */
  adyen_transaction_aggregate: AdyenTransactionAggregate;
  /** fetch data from the table: "adyen_transaction" using primary key columns */
  adyen_transaction_by_pk?: Maybe<AdyenTransaction>;
  /** fetch data from the table: "applied_permit" */
  applied_permit: Array<AppliedPermit>;
  /** fetch aggregated fields from the table: "applied_permit" */
  applied_permit_aggregate: AppliedPermitAggregate;
  /** fetch data from the table: "applied_permit" using primary key columns */
  applied_permit_by_pk?: Maybe<AppliedPermit>;
  /** fetch data from the table: "applied_whitelist" */
  applied_whitelist: Array<AppliedWhitelist>;
  /** fetch aggregated fields from the table: "applied_whitelist" */
  applied_whitelist_aggregate: AppliedWhitelistAggregate;
  /** fetch data from the table: "applied_whitelist" using primary key columns */
  applied_whitelist_by_pk?: Maybe<AppliedWhitelist>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<AuditLoggedActions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: AuditLoggedActionsAggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: Maybe<AuditLoggedActions>;
  auth0_user?: Maybe<Array<Maybe<UserData>>>;
  b2c_checkout: B2CAdyenCheckoutResponse;
  b2c_errorflow_checkout: B2CAdyenCheckoutResponse;
  b2c_get_carpay_lot: B2CCarpayLotExtendedInfo;
  b2c_get_carpay_lots: B2CCarpayLots;
  b2c_get_completed_orders: B2CCarpayOrderResponse;
  b2c_get_errorflow_price: B2CCarpayOrderView;
  b2c_get_invoice: B2CInvoice;
  /** b2c_get_lot_occupancy */
  b2c_get_lot_occupancy: B2CLotOccupancy;
  /** b2c_get_open_orders */
  b2c_get_open_orders: B2CCarpayOrderResponse;
  b2c_get_order_by_id: B2CCarpayOrderView;
  b2c_get_payment_methods?: Maybe<Array<Maybe<B2CPaymentMethod>>>;
  b2c_get_price: B2CCarpayOrderView;
  /** An array relationship */
  blacklist: Array<Blacklist>;
  /** An aggregate relationship */
  blacklist_aggregate: BlacklistAggregate;
  /** fetch data from the table: "blacklist" using primary key columns */
  blacklist_by_pk?: Maybe<Blacklist>;
  /** fetch data from the table: "blacklist_by_plate_view" */
  blacklist_by_plate_view: Array<BlacklistByPlateView>;
  /** fetch aggregated fields from the table: "blacklist_by_plate_view" */
  blacklist_by_plate_view_aggregate: BlacklistByPlateViewAggregate;
  /** fetch data from the table: "booking.booking" */
  booking_booking: Array<BookingBooking>;
  /** fetch aggregated fields from the table: "booking.booking" */
  booking_booking_aggregate: BookingBookingAggregate;
  /** fetch data from the table: "booking.booking" using primary key columns */
  booking_booking_by_pk?: Maybe<BookingBooking>;
  /** fetch data from the table: "booking.booking_invoice" */
  booking_booking_invoice: Array<BookingBookingInvoice>;
  /** fetch aggregated fields from the table: "booking.booking_invoice" */
  booking_booking_invoice_aggregate: BookingBookingInvoiceAggregate;
  /** fetch data from the table: "booking.booking_invoice" using primary key columns */
  booking_booking_invoice_by_pk?: Maybe<BookingBookingInvoice>;
  /** fetch data from the table: "booking.booking_plate" */
  booking_booking_plate: Array<BookingBookingPlate>;
  /** fetch aggregated fields from the table: "booking.booking_plate" */
  booking_booking_plate_aggregate: BookingBookingPlateAggregate;
  /** fetch data from the table: "booking.booking_plate" using primary key columns */
  booking_booking_plate_by_pk?: Maybe<BookingBookingPlate>;
  /** fetch data from the table: "booking.booking_type" */
  booking_booking_type: Array<BookingBookingType>;
  /** fetch aggregated fields from the table: "booking.booking_type" */
  booking_booking_type_aggregate: BookingBookingTypeAggregate;
  /** fetch data from the table: "booking.booking_type" using primary key columns */
  booking_booking_type_by_pk?: Maybe<BookingBookingType>;
  /** fetch data from the table: "booking.booking_whitelist" */
  booking_booking_whitelist: Array<BookingBookingWhitelist>;
  /** fetch aggregated fields from the table: "booking.booking_whitelist" */
  booking_booking_whitelist_aggregate: BookingBookingWhitelistAggregate;
  /** fetch data from the table: "booking.booking_whitelist" using primary key columns */
  booking_booking_whitelist_by_pk?: Maybe<BookingBookingWhitelist>;
  booking_create_adyen_session: BookingCreateAdyenSessionResponse;
  /** fetch data from the table: "booking.enum_booking_status" */
  booking_enum_booking_status: Array<BookingEnumBookingStatus>;
  /** fetch aggregated fields from the table: "booking.enum_booking_status" */
  booking_enum_booking_status_aggregate: BookingEnumBookingStatusAggregate;
  /** fetch data from the table: "booking.enum_booking_status" using primary key columns */
  booking_enum_booking_status_by_pk?: Maybe<BookingEnumBookingStatus>;
  booking_get_lot: BookingGetLotResponse;
  booking_get_lot_availability?: Maybe<BookingGetLotAvailabilityResponse>;
  booking_get_lot_configuration: BookingGetLotConfigurationResponse;
  booking_get_lot_image_urls: BookingGetLotImageUrls;
  booking_get_lots: Array<BookingGetLotsResponse>;
  booking_get_price?: Maybe<BookingGetPriceResponse>;
  booking_get_price_hourly?: Maybe<BookingGetPriceHourlyResponse>;
  booking_get_public_lots?: Maybe<BookingGetPublicLotsResponse>;
  /** fetch data from the table: "booking.hourly_booking" */
  booking_hourly_booking: Array<BookingHourlyBooking>;
  /** fetch aggregated fields from the table: "booking.hourly_booking" */
  booking_hourly_booking_aggregate: BookingHourlyBookingAggregate;
  /** fetch data from the table: "booking.hourly_booking" using primary key columns */
  booking_hourly_booking_by_pk?: Maybe<BookingHourlyBooking>;
  /** fetch data from the table: "booking.license_plate" */
  booking_license_plate: Array<BookingLicensePlate>;
  /** fetch aggregated fields from the table: "booking.license_plate" */
  booking_license_plate_aggregate: BookingLicensePlateAggregate;
  /** fetch data from the table: "booking.license_plate" using primary key columns */
  booking_license_plate_by_pk?: Maybe<BookingLicensePlate>;
  /** fetch data from the table: "booking.lot" */
  booking_lot: Array<BookingLot>;
  /** fetch aggregated fields from the table: "booking.lot" */
  booking_lot_aggregate: BookingLotAggregate;
  /** fetch data from the table: "booking.lot" using primary key columns */
  booking_lot_by_pk?: Maybe<BookingLot>;
  /** fetch data from the table: "booking.lot_configuration" */
  booking_lot_configuration: Array<BookingLotConfiguration>;
  /** fetch aggregated fields from the table: "booking.lot_configuration" */
  booking_lot_configuration_aggregate: BookingLotConfigurationAggregate;
  /** fetch data from the table: "booking.lot_configuration" using primary key columns */
  booking_lot_configuration_by_pk?: Maybe<BookingLotConfiguration>;
  /** fetch data from the table: "booking.payment" */
  booking_payment: Array<BookingPayment>;
  /** fetch aggregated fields from the table: "booking.payment" */
  booking_payment_aggregate: BookingPaymentAggregate;
  /** fetch data from the table: "booking.payment" using primary key columns */
  booking_payment_by_pk?: Maybe<BookingPayment>;
  /** fetch data from the table: "booking.pricing_rules" */
  booking_pricing_rules: Array<BookingPricingRules>;
  /** fetch aggregated fields from the table: "booking.pricing_rules" */
  booking_pricing_rules_aggregate: BookingPricingRulesAggregate;
  /** fetch data from the table: "booking.pricing_rules" using primary key columns */
  booking_pricing_rules_by_pk?: Maybe<BookingPricingRules>;
  /** fetch data from the table: "booking.pricing_type" */
  booking_pricing_type: Array<BookingPricingType>;
  /** fetch aggregated fields from the table: "booking.pricing_type" */
  booking_pricing_type_aggregate: BookingPricingTypeAggregate;
  /** fetch data from the table: "booking.pricing_type" using primary key columns */
  booking_pricing_type_by_pk?: Maybe<BookingPricingType>;
  /** fetch data from the table: "booking.private_pricing_user" */
  booking_private_pricing_user: Array<BookingPrivatePricingUser>;
  /** fetch aggregated fields from the table: "booking.private_pricing_user" */
  booking_private_pricing_user_aggregate: BookingPrivatePricingUserAggregate;
  /** fetch data from the table: "booking.private_pricing_user" using primary key columns */
  booking_private_pricing_user_by_pk?: Maybe<BookingPrivatePricingUser>;
  /** fetch data from the table: "booking.recurring_booking" */
  booking_recurring_booking: Array<BookingRecurringBooking>;
  /** fetch aggregated fields from the table: "booking.recurring_booking" */
  booking_recurring_booking_aggregate: BookingRecurringBookingAggregate;
  /** fetch data from the table: "booking.recurring_booking" using primary key columns */
  booking_recurring_booking_by_pk?: Maybe<BookingRecurringBooking>;
  /** fetch data from the table: "booking.subscription_booking" */
  booking_subscription_booking: Array<BookingSubscriptionBooking>;
  /** fetch aggregated fields from the table: "booking.subscription_booking" */
  booking_subscription_booking_aggregate: BookingSubscriptionBookingAggregate;
  /** fetch data from the table: "booking.subscription_booking" using primary key columns */
  booking_subscription_booking_by_pk?: Maybe<BookingSubscriptionBooking>;
  /** fetch data from the table: "booking.subscription_license_plate" */
  booking_subscription_license_plate: Array<BookingSubscriptionLicensePlate>;
  /** fetch aggregated fields from the table: "booking.subscription_license_plate" */
  booking_subscription_license_plate_aggregate: BookingSubscriptionLicensePlateAggregate;
  /** fetch data from the table: "booking.subscription_license_plate" using primary key columns */
  booking_subscription_license_plate_by_pk?: Maybe<BookingSubscriptionLicensePlate>;
  /** fetch data from the table: "booking.subscription_status" */
  booking_subscription_status: Array<BookingSubscriptionStatus>;
  /** fetch aggregated fields from the table: "booking.subscription_status" */
  booking_subscription_status_aggregate: BookingSubscriptionStatusAggregate;
  /** fetch data from the table: "booking.subscription_status" using primary key columns */
  booking_subscription_status_by_pk?: Maybe<BookingSubscriptionStatus>;
  /** fetch data from the table: "booking.user" */
  booking_user: Array<BookingUser>;
  /** fetch aggregated fields from the table: "booking.user" */
  booking_user_aggregate: BookingUserAggregate;
  /** fetch data from the table: "booking.user_booking" */
  booking_user_booking: Array<BookingUserBooking>;
  /** fetch aggregated fields from the table: "booking.user_booking" */
  booking_user_booking_aggregate: BookingUserBookingAggregate;
  /** fetch data from the table: "booking.user_booking" using primary key columns */
  booking_user_booking_by_pk?: Maybe<BookingUserBooking>;
  /** fetch data from the table: "booking.user" using primary key columns */
  booking_user_by_pk?: Maybe<BookingUser>;
  /** fetch data from the table: "booking.user_payment_method" */
  booking_user_payment_method: Array<BookingUserPaymentMethod>;
  /** fetch aggregated fields from the table: "booking.user_payment_method" */
  booking_user_payment_method_aggregate: BookingUserPaymentMethodAggregate;
  /** fetch data from the table: "booking.user_payment_method" using primary key columns */
  booking_user_payment_method_by_pk?: Maybe<BookingUserPaymentMethod>;
  /** fetch data from the table: "booking.user_subscription" */
  booking_user_subscription: Array<BookingUserSubscription>;
  /** fetch aggregated fields from the table: "booking.user_subscription" */
  booking_user_subscription_aggregate: BookingUserSubscriptionAggregate;
  /** fetch data from the table: "booking.user_subscription" using primary key columns */
  booking_user_subscription_by_pk?: Maybe<BookingUserSubscription>;
  /** fetch data from the table: "booking.vehicle" */
  booking_vehicle: Array<BookingVehicle>;
  /** fetch aggregated fields from the table: "booking.vehicle" */
  booking_vehicle_aggregate: BookingVehicleAggregate;
  /** fetch data from the table: "booking.vehicle" using primary key columns */
  booking_vehicle_by_pk?: Maybe<BookingVehicle>;
  /** fetch data from the table: "booking.vehicle_type" */
  booking_vehicle_type: Array<BookingVehicleType>;
  /** fetch aggregated fields from the table: "booking.vehicle_type" */
  booking_vehicle_type_aggregate: BookingVehicleTypeAggregate;
  /** fetch data from the table: "booking.vehicle_type" using primary key columns */
  booking_vehicle_type_by_pk?: Maybe<BookingVehicleType>;
  /** fetch data from the table: "booking.whitelist_type" */
  booking_whitelist_type: Array<BookingWhitelistType>;
  /** fetch aggregated fields from the table: "booking.whitelist_type" */
  booking_whitelist_type_aggregate: BookingWhitelistTypeAggregate;
  /** fetch data from the table: "booking.whitelist_type" using primary key columns */
  booking_whitelist_type_by_pk?: Maybe<BookingWhitelistType>;
  /** fetch data from the table: "calendar_event_policy" */
  calendar_event_policy: Array<CalendarEventPolicy>;
  /** fetch aggregated fields from the table: "calendar_event_policy" */
  calendar_event_policy_aggregate: CalendarEventPolicyAggregate;
  /** fetch data from the table: "calendar_event_policy" using primary key columns */
  calendar_event_policy_by_pk?: Maybe<CalendarEventPolicy>;
  /** fetch data from the table: "cancellation_reason_view" */
  cancellation_reason_view: Array<CancellationReasonView>;
  /** fetch aggregated fields from the table: "cancellation_reason_view" */
  cancellation_reason_view_aggregate: CancellationReasonViewAggregate;
  /** fetch data from the table: "cancellations" */
  cancellations: Array<Cancellations>;
  /** fetch aggregated fields from the table: "cancellations" */
  cancellations_aggregate: CancellationsAggregate;
  /** fetch data from the table: "cancellations" using primary key columns */
  cancellations_by_pk?: Maybe<Cancellations>;
  cancellations_customer?: Maybe<CancellationsCustomerOutput>;
  cancellations_customer_aggregate?: Maybe<CancellationsCustomerAggregate>;
  /** fetch data from the table: "car_driver" */
  car_driver: Array<CarDriver>;
  /** fetch aggregated fields from the table: "car_driver" */
  car_driver_aggregate: CarDriverAggregate;
  /** fetch data from the table: "car_driver" using primary key columns */
  car_driver_by_pk?: Maybe<CarDriver>;
  /** An array relationship */
  car_owner: Array<CarOwner>;
  /** An aggregate relationship */
  car_owner_aggregate: CarOwnerAggregate;
  /** fetch data from the table: "car_owner" using primary key columns */
  car_owner_by_pk?: Maybe<CarOwner>;
  /** fetch data from the table: "car_owner_requests" */
  car_owner_requests: Array<CarOwnerRequests>;
  /** fetch aggregated fields from the table: "car_owner_requests" */
  car_owner_requests_aggregate: CarOwnerRequestsAggregate;
  /** fetch data from the table: "car_owner_requests" using primary key columns */
  car_owner_requests_by_pk?: Maybe<CarOwnerRequests>;
  carpay_access_control_get_pin: AccessControlGetPinResponse;
  /** fetch data from the table: "carpay_access_control_lp_pin" */
  carpay_access_control_lp_pin: Array<CarpayAccessControlLpPin>;
  /** fetch aggregated fields from the table: "carpay_access_control_lp_pin" */
  carpay_access_control_lp_pin_aggregate: CarpayAccessControlLpPinAggregate;
  /** fetch data from the table: "carpay_access_control_lp_pin" using primary key columns */
  carpay_access_control_lp_pin_by_pk?: Maybe<CarpayAccessControlLpPin>;
  carpay_access_control_send_pin_sms: AccessControlSendPinSmsResponse;
  carpay_adyen_get_result_code?: Maybe<AdyenResultCodeResponse>;
  /** Endpoint to calculate the price of an order. It will take into account the judge information. */
  carpay_calculate_order_price: Array<Order>;
  carpay_checkout_session?: Maybe<CarpayCheckoutResult>;
  /** fetch data from the table: "carpay_discount_batch" */
  carpay_discount_batch: Array<CarpayDiscountBatch>;
  /** fetch aggregated fields from the table: "carpay_discount_batch" */
  carpay_discount_batch_aggregate: CarpayDiscountBatchAggregate;
  /** fetch data from the table: "carpay_discount_batch" using primary key columns */
  carpay_discount_batch_by_pk?: Maybe<CarpayDiscountBatch>;
  /** This endpoint allows us to get all the batches for a certain lot or for a certain discount_model */
  carpay_discount_batches_internal_dashboard?: Maybe<CarpayDiscountBatchesInternalDashboardResponse>;
  /** This endpoint allows us to get batch by id */
  carpay_discount_batches_internal_dashboard_by_id: CarpayDiscountBatchResponse;
  /** fetch data from the table: "carpay_discount_model" */
  carpay_discount_model: Array<CarpayDiscountModel>;
  /** fetch aggregated fields from the table: "carpay_discount_model" */
  carpay_discount_model_aggregate: CarpayDiscountModelAggregate;
  /** fetch data from the table: "carpay_discount_model" using primary key columns */
  carpay_discount_model_by_pk?: Maybe<CarpayDiscountModel>;
  /** Endpoint to get carpay discount models by ID */
  carpay_discount_model_internal_dashbaord_by_id: CarpayDiscountModelResponse;
  /** Endpoint to get carpay discount models by lot ID */
  carpay_discount_models_internal_dashbaord_by_lot_id?: Maybe<CarpayDiscountModelsInternalDashboardResponse>;
  /** This endpoint allows us to get the easypark configuration for a certain lot */
  carpay_easypark_internal_dashboard_by_lot_id: CarpayEasyParkResponse;
  carpay_get_lot_configuration: CarpayGetLotConfigurationResponse;
  carpay_get_orders: Array<Order>;
  carpay_get_qr_flyer_batch: GetQrFlyerBatchResponse;
  carpay_invoice?: Maybe<CarpayInvoiceOutput>;
  /** fetch data from the table: "carpay_lot" */
  carpay_lot: Array<CarpayLot>;
  carpay_lot_action_get_schedules: Array<CarpayLotActionGetScheduleResponse>;
  /** fetch aggregated fields from the table: "carpay_lot" */
  carpay_lot_aggregate: CarpayLotAggregate;
  /** fetch data from the table: "carpay_lot" using primary key columns */
  carpay_lot_by_pk?: Maybe<CarpayLot>;
  carpay_lot_get_by_id: CarpayLotResponse;
  /** Endpoint to get carpay notification configs by lot id */
  carpay_notification_config_internal_dashbaord_by_lot_id: CarpayNotificationConfig;
  /** fetch data from the table: "carpay_notification_subscriber" */
  carpay_notification_subscriber: Array<CarpayNotificationSubscriber>;
  /** fetch aggregated fields from the table: "carpay_notification_subscriber" */
  carpay_notification_subscriber_aggregate: CarpayNotificationSubscriberAggregate;
  /** fetch data from the table: "carpay_notification_subscriber" using primary key columns */
  carpay_notification_subscriber_by_pk?: Maybe<CarpayNotificationSubscriber>;
  /** fetch data from the table: "carpay_notification_subscription" */
  carpay_notification_subscription: Array<CarpayNotificationSubscription>;
  /** fetch aggregated fields from the table: "carpay_notification_subscription" */
  carpay_notification_subscription_aggregate: CarpayNotificationSubscriptionAggregate;
  /** fetch data from the table: "carpay_notification_subscription" using primary key columns */
  carpay_notification_subscription_by_pk?: Maybe<CarpayNotificationSubscription>;
  /** fetch data from the table: "carpay_notification_subscription_category" */
  carpay_notification_subscription_category: Array<CarpayNotificationSubscriptionCategory>;
  /** fetch aggregated fields from the table: "carpay_notification_subscription_category" */
  carpay_notification_subscription_category_aggregate: CarpayNotificationSubscriptionCategoryAggregate;
  /** fetch data from the table: "carpay_notification_subscription_category" using primary key columns */
  carpay_notification_subscription_category_by_pk?: Maybe<CarpayNotificationSubscriptionCategory>;
  /** fetch data from the table: "carpay_order" */
  carpay_order: Array<CarpayOrder>;
  /** fetch aggregated fields from the table: "carpay_order" */
  carpay_order_aggregate: CarpayOrderAggregate;
  /** fetch data from the table: "carpay_order" using primary key columns */
  carpay_order_by_pk?: Maybe<CarpayOrder>;
  /** fetch data from the table: "carpay_order_matches" */
  carpay_order_matches: Array<CarpayOrderMatches>;
  /** fetch aggregated fields from the table: "carpay_order_matches" */
  carpay_order_matches_aggregate: CarpayOrderMatchesAggregate;
  /** fetch data from the table: "carpay_order_matches" using primary key columns */
  carpay_order_matches_by_pk?: Maybe<CarpayOrderMatches>;
  /** fetch data from the table: "carpay_order_user" */
  carpay_order_user: Array<CarpayOrderUser>;
  /** fetch aggregated fields from the table: "carpay_order_user" */
  carpay_order_user_aggregate: CarpayOrderUserAggregate;
  /** fetch data from the table: "carpay_order_user" using primary key columns */
  carpay_order_user_by_pk?: Maybe<CarpayOrderUser>;
  /** fetch data from the table: "carpay_parking_detection" */
  carpay_parking_detection: Array<CarpayParkingDetection>;
  /** fetch aggregated fields from the table: "carpay_parking_detection" */
  carpay_parking_detection_aggregate: CarpayParkingDetectionAggregate;
  /** fetch data from the table: "carpay_parking_detection" using primary key columns */
  carpay_parking_detection_by_pk?: Maybe<CarpayParkingDetection>;
  /** This endpoint allows us to get the paybyphone configuration for a certain lot */
  carpay_paybyphone_internal_dashboard_by_lot_id: CarpayPayByPhoneResponse;
  /** fetch data from the table: "carpay_pricing" */
  carpay_pricing: Array<CarpayPricing>;
  /** fetch aggregated fields from the table: "carpay_pricing" */
  carpay_pricing_aggregate: CarpayPricingAggregate;
  /** fetch data from the table: "carpay_pricing" using primary key columns */
  carpay_pricing_by_pk?: Maybe<CarpayPricing>;
  /** fetch data from the table: "carpay_pricing_config_group" */
  carpay_pricing_config_group: Array<CarpayPricingConfigGroup>;
  /** fetch aggregated fields from the table: "carpay_pricing_config_group" */
  carpay_pricing_config_group_aggregate: CarpayPricingConfigGroupAggregate;
  /** fetch data from the table: "carpay_pricing_config_group" using primary key columns */
  carpay_pricing_config_group_by_pk?: Maybe<CarpayPricingConfigGroup>;
  /** fetch data from the table: "carpay_pricing_period" */
  carpay_pricing_period: Array<CarpayPricingPeriod>;
  /** fetch aggregated fields from the table: "carpay_pricing_period" */
  carpay_pricing_period_aggregate: CarpayPricingPeriodAggregate;
  /** fetch data from the table: "carpay_pricing_period" using primary key columns */
  carpay_pricing_period_by_pk?: Maybe<CarpayPricingPeriod>;
  /** fetch data from the table: "carpay_pricing_recurrence" */
  carpay_pricing_recurrence: Array<CarpayPricingRecurrence>;
  /** fetch aggregated fields from the table: "carpay_pricing_recurrence" */
  carpay_pricing_recurrence_aggregate: CarpayPricingRecurrenceAggregate;
  /** fetch data from the table: "carpay_pricing_recurrence" using primary key columns */
  carpay_pricing_recurrence_by_pk?: Maybe<CarpayPricingRecurrence>;
  /** fetch data from the table: "carpay_pricing_rules" */
  carpay_pricing_rules: Array<CarpayPricingRules>;
  /** fetch aggregated fields from the table: "carpay_pricing_rules" */
  carpay_pricing_rules_aggregate: CarpayPricingRulesAggregate;
  /** fetch data from the table: "carpay_pricing_rules" using primary key columns */
  carpay_pricing_rules_by_pk?: Maybe<CarpayPricingRules>;
  /** An array relationship */
  carpay_scanned_codes: Array<CarpayScannedCodes>;
  /** An aggregate relationship */
  carpay_scanned_codes_aggregate: CarpayScannedCodesAggregate;
  /** fetch data from the table: "carpay_scanned_codes" using primary key columns */
  carpay_scanned_codes_by_pk?: Maybe<CarpayScannedCodes>;
  /** This endpoint allows us to get all the carpay subscriptions for a certain lot */
  carpay_subscription_internal_dashboard_by_lot_id: CarpaySubscriptionResponse;
  /** fetch data from the table: "carpay_terminal_cash_cut_notification" */
  carpay_terminal_cash_cut_notification: Array<CarpayTerminalCashCutNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_cash_cut_notification" */
  carpay_terminal_cash_cut_notification_aggregate: CarpayTerminalCashCutNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_cash_cut_notification" using primary key columns */
  carpay_terminal_cash_cut_notification_by_pk?: Maybe<CarpayTerminalCashCutNotification>;
  /** fetch data from the table: "carpay_terminal_cash_fill_level_notification" */
  carpay_terminal_cash_fill_level_notification: Array<CarpayTerminalCashFillLevelNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_cash_fill_level_notification" */
  carpay_terminal_cash_fill_level_notification_aggregate: CarpayTerminalCashFillLevelNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_cash_fill_level_notification" using primary key columns */
  carpay_terminal_cash_fill_level_notification_by_pk?: Maybe<CarpayTerminalCashFillLevelNotification>;
  /** Action to get terminal config */
  carpay_terminal_config: CarpayTerminalConfigResponse;
  carpay_terminal_get_legal_status: CarpayLegalStatusResult;
  carpay_terminal_get_orders: Array<CarpayTerminalOrderResult>;
  carpay_terminal_get_orders_v2: Array<CarpayTerminalOrderResultV2>;
  /** fetch data from the table: "carpay_terminal_notification_config" */
  carpay_terminal_notification_config: Array<CarpayTerminalNotificationConfig>;
  /** fetch aggregated fields from the table: "carpay_terminal_notification_config" */
  carpay_terminal_notification_config_aggregate: CarpayTerminalNotificationConfigAggregate;
  /** fetch data from the table: "carpay_terminal_notification_config" using primary key columns */
  carpay_terminal_notification_config_by_pk?: Maybe<CarpayTerminalNotificationConfig>;
  /** fetch data from the table: "carpay_terminal_printer_status_notification" */
  carpay_terminal_printer_status_notification: Array<CarpayTerminalPrinterStatusNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_printer_status_notification" */
  carpay_terminal_printer_status_notification_aggregate: CarpayTerminalPrinterStatusNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_printer_status_notification" using primary key columns */
  carpay_terminal_printer_status_notification_by_pk?: Maybe<CarpayTerminalPrinterStatusNotification>;
  /** fetch data from the table: "carpay_user_verified_plate" */
  carpay_user_verified_plate: Array<CarpayUserVerifiedPlate>;
  /** fetch aggregated fields from the table: "carpay_user_verified_plate" */
  carpay_user_verified_plate_aggregate: CarpayUserVerifiedPlateAggregate;
  /** fetch data from the table: "carpay_user_verified_plate" using primary key columns */
  carpay_user_verified_plate_by_pk?: Maybe<CarpayUserVerifiedPlate>;
  /** fetch data from the table: "chain" */
  chain: Array<Chain>;
  /** fetch aggregated fields from the table: "chain" */
  chain_aggregate: ChainAggregate;
  /** fetch data from the table: "chain" using primary key columns */
  chain_by_pk?: Maybe<Chain>;
  /** fetch data from the table: "city_codes" */
  city_codes: Array<CityCodes>;
  /** fetch aggregated fields from the table: "city_codes" */
  city_codes_aggregate: CityCodesAggregate;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: CompanyAggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_config_group" */
  company_config_group: Array<CompanyConfigGroup>;
  /** fetch aggregated fields from the table: "company_config_group" */
  company_config_group_aggregate: CompanyConfigGroupAggregate;
  /** fetch data from the table: "company_config_group" using primary key columns */
  company_config_group_by_pk?: Maybe<CompanyConfigGroup>;
  /** An array relationship */
  company_hierarchy: Array<CompanyHierarchy>;
  /** An aggregate relationship */
  company_hierarchy_aggregate: CompanyHierarchyAggregate;
  /** fetch data from the table: "company_hierarchy" using primary key columns */
  company_hierarchy_by_pk?: Maybe<CompanyHierarchy>;
  /** fetch data from the table: "company_lot_section" */
  company_lot_section: Array<CompanyLotSection>;
  /** fetch aggregated fields from the table: "company_lot_section" */
  company_lot_section_aggregate: CompanyLotSectionAggregate;
  /** fetch data from the table: "company_lot_section" using primary key columns */
  company_lot_section_by_pk?: Maybe<CompanyLotSection>;
  /** fetch data from the table: "company_vat_id" */
  company_vat_id: Array<CompanyVatId>;
  /** fetch aggregated fields from the table: "company_vat_id" */
  company_vat_id_aggregate: CompanyVatIdAggregate;
  /** fetch data from the table: "company_vat_id" using primary key columns */
  company_vat_id_by_pk?: Maybe<CompanyVatId>;
  /** fetch data from the table: "company_violator" */
  company_violator: Array<CompanyViolator>;
  /** fetch aggregated fields from the table: "company_violator" */
  company_violator_aggregate: CompanyViolatorAggregate;
  /** fetch data from the table: "company_violator" using primary key columns */
  company_violator_by_pk?: Maybe<CompanyViolator>;
  /** fetch data from the table: "config_group" */
  config_group: Array<ConfigGroup>;
  /** fetch aggregated fields from the table: "config_group" */
  config_group_aggregate: ConfigGroupAggregate;
  /** fetch data from the table: "config_group" using primary key columns */
  config_group_by_pk?: Maybe<ConfigGroup>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  create_driver_information_request?: Maybe<CreateDriverInformationRequest>;
  create_error_rate_prediction_request?: Maybe<CreateErrorRatePredictionRequestOutput>;
  create_lot_analysis_request?: Maybe<CreateLotAnalysisRequestOutput>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: CurrencyAggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "customer_dashboard_nps_feedback" */
  customer_dashboard_nps_feedback: Array<CustomerDashboardNpsFeedback>;
  /** fetch aggregated fields from the table: "customer_dashboard_nps_feedback" */
  customer_dashboard_nps_feedback_aggregate: CustomerDashboardNpsFeedbackAggregate;
  /** fetch data from the table: "customer_dashboard_nps_feedback" using primary key columns */
  customer_dashboard_nps_feedback_by_pk?: Maybe<CustomerDashboardNpsFeedback>;
  /** Retrieves user metadata for specified customer dashboard user as JWT */
  customer_preflight_request?: Maybe<CustomerPreflightResponse>;
  customer_read_lp_groups?: Maybe<Array<LpGroupEntry>>;
  /** fetch data from the table: "daily_failure" */
  daily_failure: Array<DailyFailure>;
  /** fetch aggregated fields from the table: "daily_failure" */
  daily_failure_aggregate: DailyFailureAggregate;
  /** fetch data from the table: "daily_failure" using primary key columns */
  daily_failure_by_pk?: Maybe<DailyFailure>;
  /** An array relationship */
  daily_stats: Array<DailyStats>;
  /** An aggregate relationship */
  daily_stats_aggregate: DailyStatsAggregate;
  /** fetch data from the table: "daily_stats" using primary key columns */
  daily_stats_by_pk?: Maybe<DailyStats>;
  /** hasura action to decrypt encrypted images */
  decrypt_image_manual?: Maybe<DecryptImageOutput>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: DepartmentAggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table: "detection_type_enum" */
  detection_type_enum: Array<DetectionTypeEnum>;
  /** fetch aggregated fields from the table: "detection_type_enum" */
  detection_type_enum_aggregate: DetectionTypeEnumAggregate;
  /** fetch data from the table: "detection_type_enum" using primary key columns */
  detection_type_enum_by_pk?: Maybe<DetectionTypeEnum>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: DeviceAggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  download_letters?: Maybe<DownloadLettersOutput>;
  /** fetch data from the table: "easypark_lot" */
  easypark_lot: Array<EasyparkLot>;
  /** fetch aggregated fields from the table: "easypark_lot" */
  easypark_lot_aggregate: EasyparkLotAggregate;
  /** fetch data from the table: "easypark_lot" using primary key columns */
  easypark_lot_by_pk?: Maybe<EasyparkLot>;
  /** fetch data from the table: "easypark_order" */
  easypark_order: Array<EasyparkOrder>;
  /** fetch aggregated fields from the table: "easypark_order" */
  easypark_order_aggregate: EasyparkOrderAggregate;
  /** fetch data from the table: "easypark_order" using primary key columns */
  easypark_order_by_pk?: Maybe<EasyparkOrder>;
  /** fetch data from the table: "easypark_order_v2" */
  easypark_order_v2: Array<EasyparkOrderV2>;
  /** fetch aggregated fields from the table: "easypark_order_v2" */
  easypark_order_v2_aggregate: EasyparkOrderV2Aggregate;
  /** fetch data from the table: "easypark_order_v2" using primary key columns */
  easypark_order_v2_by_pk?: Maybe<EasyparkOrderV2>;
  /** fetch data from the table: "easypark_parking_info" */
  easypark_parking_info: Array<EasyparkParkingInfo>;
  /** fetch aggregated fields from the table: "easypark_parking_info" */
  easypark_parking_info_aggregate: EasyparkParkingInfoAggregate;
  /** fetch data from the table: "easypark_parking_info" using primary key columns */
  easypark_parking_info_by_pk?: Maybe<EasyparkParkingInfo>;
  /** fetch data from the table: "enforcement_daily_stats" */
  enforcement_daily_stats: Array<EnforcementDailyStats>;
  /** fetch aggregated fields from the table: "enforcement_daily_stats" */
  enforcement_daily_stats_aggregate: EnforcementDailyStatsAggregate;
  /** fetch data from the table: "enforcement_daily_stats" using primary key columns */
  enforcement_daily_stats_by_pk?: Maybe<EnforcementDailyStats>;
  /** fetch data from the table: "enum_carpay_discount_model_code_type" */
  enum_carpay_discount_model_code_type: Array<EnumCarpayDiscountModelCodeType>;
  /** fetch aggregated fields from the table: "enum_carpay_discount_model_code_type" */
  enum_carpay_discount_model_code_type_aggregate: EnumCarpayDiscountModelCodeTypeAggregate;
  /** fetch data from the table: "enum_carpay_discount_model_code_type" using primary key columns */
  enum_carpay_discount_model_code_type_by_pk?: Maybe<EnumCarpayDiscountModelCodeType>;
  /** fetch data from the table: "enum_country_code" */
  enum_country_code: Array<EnumCountryCode>;
  /** fetch aggregated fields from the table: "enum_country_code" */
  enum_country_code_aggregate: EnumCountryCodeAggregate;
  /** fetch data from the table: "enum_country_code" using primary key columns */
  enum_country_code_by_pk?: Maybe<EnumCountryCode>;
  /** fetch data from the table: "enum_customer_whitelist_purpose" */
  enum_customer_whitelist_purpose: Array<EnumCustomerWhitelistPurpose>;
  /** fetch aggregated fields from the table: "enum_customer_whitelist_purpose" */
  enum_customer_whitelist_purpose_aggregate: EnumCustomerWhitelistPurposeAggregate;
  /** fetch data from the table: "enum_customer_whitelist_purpose" using primary key columns */
  enum_customer_whitelist_purpose_by_pk?: Maybe<EnumCustomerWhitelistPurpose>;
  /** fetch data from the table: "enum_customer_whitelist_status" */
  enum_customer_whitelist_status: Array<EnumCustomerWhitelistStatus>;
  /** fetch aggregated fields from the table: "enum_customer_whitelist_status" */
  enum_customer_whitelist_status_aggregate: EnumCustomerWhitelistStatusAggregate;
  /** fetch data from the table: "enum_customer_whitelist_status" using primary key columns */
  enum_customer_whitelist_status_by_pk?: Maybe<EnumCustomerWhitelistStatus>;
  /** fetch data from the table: "enum_device_type" */
  enum_device_type: Array<EnumDeviceType>;
  /** fetch aggregated fields from the table: "enum_device_type" */
  enum_device_type_aggregate: EnumDeviceTypeAggregate;
  /** fetch data from the table: "enum_device_type" using primary key columns */
  enum_device_type_by_pk?: Maybe<EnumDeviceType>;
  /** fetch data from the table: "enum_driver_request_type" */
  enum_driver_request_type: Array<EnumDriverRequestType>;
  /** fetch aggregated fields from the table: "enum_driver_request_type" */
  enum_driver_request_type_aggregate: EnumDriverRequestTypeAggregate;
  /** fetch data from the table: "enum_driver_request_type" using primary key columns */
  enum_driver_request_type_by_pk?: Maybe<EnumDriverRequestType>;
  /** fetch data from the table: "enum_guest_jwt_purpose" */
  enum_guest_jwt_purpose: Array<EnumGuestJwtPurpose>;
  /** fetch aggregated fields from the table: "enum_guest_jwt_purpose" */
  enum_guest_jwt_purpose_aggregate: EnumGuestJwtPurposeAggregate;
  /** fetch data from the table: "enum_guest_jwt_purpose" using primary key columns */
  enum_guest_jwt_purpose_by_pk?: Maybe<EnumGuestJwtPurpose>;
  /** fetch data from the table: "enum_supervision_mlp_request_status" */
  enum_supervision_mlp_request_status: Array<EnumSupervisionMlpRequestStatus>;
  /** fetch aggregated fields from the table: "enum_supervision_mlp_request_status" */
  enum_supervision_mlp_request_status_aggregate: EnumSupervisionMlpRequestStatusAggregate;
  /** fetch data from the table: "enum_supervision_mlp_request_status" using primary key columns */
  enum_supervision_mlp_request_status_by_pk?: Maybe<EnumSupervisionMlpRequestStatus>;
  /** fetch data from the table: "enum_violation_cancellation" */
  enum_violation_cancellation: Array<EnumViolationCancellation>;
  /** fetch aggregated fields from the table: "enum_violation_cancellation" */
  enum_violation_cancellation_aggregate: EnumViolationCancellationAggregate;
  /** fetch data from the table: "enum_violation_cancellation" using primary key columns */
  enum_violation_cancellation_by_pk?: Maybe<EnumViolationCancellation>;
  /** fetch data from the table: "enum_violation_case_charges_invalidation_reason" */
  enum_violation_case_charges_invalidation_reason: Array<EnumViolationCaseChargesInvalidationReason>;
  /** fetch aggregated fields from the table: "enum_violation_case_charges_invalidation_reason" */
  enum_violation_case_charges_invalidation_reason_aggregate: EnumViolationCaseChargesInvalidationReasonAggregate;
  /** fetch data from the table: "enum_violation_case_charges_invalidation_reason" using primary key columns */
  enum_violation_case_charges_invalidation_reason_by_pk?: Maybe<EnumViolationCaseChargesInvalidationReason>;
  /** fetch data from the table: "enum_violation_case_charges_type" */
  enum_violation_case_charges_type: Array<EnumViolationCaseChargesType>;
  /** fetch aggregated fields from the table: "enum_violation_case_charges_type" */
  enum_violation_case_charges_type_aggregate: EnumViolationCaseChargesTypeAggregate;
  /** fetch data from the table: "enum_violation_case_charges_type" using primary key columns */
  enum_violation_case_charges_type_by_pk?: Maybe<EnumViolationCaseChargesType>;
  /** fetch data from the table: "enum_whitelist_paid_parking_types" */
  enum_whitelist_paid_parking_types: Array<EnumWhitelistPaidParkingTypes>;
  /** fetch aggregated fields from the table: "enum_whitelist_paid_parking_types" */
  enum_whitelist_paid_parking_types_aggregate: EnumWhitelistPaidParkingTypesAggregate;
  /** fetch data from the table: "enum_whitelist_paid_parking_types" using primary key columns */
  enum_whitelist_paid_parking_types_by_pk?: Maybe<EnumWhitelistPaidParkingTypes>;
  /** fetch data from the table: "enum_whitelist_scope" */
  enum_whitelist_scope: Array<EnumWhitelistScope>;
  /** fetch aggregated fields from the table: "enum_whitelist_scope" */
  enum_whitelist_scope_aggregate: EnumWhitelistScopeAggregate;
  /** fetch data from the table: "enum_whitelist_scope" using primary key columns */
  enum_whitelist_scope_by_pk?: Maybe<EnumWhitelistScope>;
  /** fetch data from the table: "enum_whitelist_status" */
  enum_whitelist_status: Array<EnumWhitelistStatus>;
  /** fetch aggregated fields from the table: "enum_whitelist_status" */
  enum_whitelist_status_aggregate: EnumWhitelistStatusAggregate;
  /** fetch data from the table: "enum_whitelist_status" using primary key columns */
  enum_whitelist_status_by_pk?: Maybe<EnumWhitelistStatus>;
  /** fetch data from the table: "enum_whitelist_types" */
  enum_whitelist_types: Array<EnumWhitelistTypes>;
  /** fetch aggregated fields from the table: "enum_whitelist_types" */
  enum_whitelist_types_aggregate: EnumWhitelistTypesAggregate;
  /** fetch data from the table: "enum_whitelist_types" using primary key columns */
  enum_whitelist_types_by_pk?: Maybe<EnumWhitelistTypes>;
  export_accounting_data?: Maybe<Array<AccountingDataExport>>;
  fetch_accounting_data: AccountingRecordsByMonth;
  fetch_aggregated_visits_by_day?: Maybe<Array<ParkingVisitsByDay>>;
  fetch_booking_accounting_data: BookingAccountingRecordsByMonth;
  fetch_booking_duration_by_type: BookingAnalyticsDurationByTypeResponse;
  fetch_booking_revenue_daily: BookingAnalyticsRevenueDailyResponse;
  fetch_cancellation_aggregate_by_day?: Maybe<CancellationAggregateByDayResponse>;
  fetch_carpay_revenue_by_day?: Maybe<Array<DailyCarpayRevenue>>;
  fetch_electric_aggregate_by_day?: Maybe<ElectricAggregateByDayResponse>;
  fetch_grouped_payments_by_duration?: Maybe<Array<ParkingPaymentsByInterval>>;
  fetch_hourly_occupancy_by_day?: Maybe<Array<HourlyOccupancyEntry>>;
  fetch_letter_url: LetterUrl;
  fetch_occupancy_by_day?: Maybe<OccupancyByDayResponse>;
  fetch_parking_distribution_by_interval?: Maybe<Array<ParkingDistributionByInterval>>;
  fetch_top_city_codes_by_day?: Maybe<TopCityCodesByDayResponse>;
  fetch_visits_by_weekday?: Maybe<Array<GroupedVisitsByWeekday>>;
  /** fetch data from the table: "generated_id_view" */
  generated_id_view: Array<GeneratedIdView>;
  /** fetch aggregated fields from the table: "generated_id_view" */
  generated_id_view_aggregate: GeneratedIdViewAggregate;
  get_balena_device?: Maybe<BalenaDeviceOutput>;
  get_balena_release?: Maybe<BalenaReleaseOutput>;
  get_blacklist_entries_by_plate?: Maybe<Array<Maybe<BlacklistEntriesByPlateResponse>>>;
  get_device_dashboard_url?: Maybe<GetMetabaseDashboardUrlOutput>;
  get_devices_by_config?: Maybe<DevicesByConfigOutput>;
  get_driver_information_response?: Maybe<GetDriverInformationResponseOutput>;
  get_env_parameter_endpoint?: Maybe<GetEnvParameterEndpointOutput>;
  /** Obtains all company ids and lot ids that should be visible to a provided company ID */
  get_hierarchy?: Maybe<GetHierarchyOutput>;
  /** This endpoint allows us to get all legal entities */
  get_legal_entities: Array<LegalEntity>;
  get_letter_generated_count?: Maybe<LetterGeneratedCount>;
  get_letter_generated_examples: Scalars['jsonb'];
  get_lot_companies: CarpayGetLotCompaniesResponse;
  get_lot_image_upload_url?: Maybe<LotImageUploadUrlResponse>;
  get_lot_legal_entities: Array<EnrichedLotLegalEntity>;
  /** This endpoint allows us to calculate the prices for different lot tariffs (prepayment) */
  get_lot_tariff_prices: Array<LotTariffPrices>;
  get_new_violation_cases_file?: Maybe<GetNewViolationCasesFileOutput>;
  get_overuse_report?: Maybe<Array<OveruseGroupReport>>;
  get_overuse_report_by_day?: Maybe<Array<OveruseReportByDay>>;
  get_overuse_report_by_group?: Maybe<OveruseReportByGroup>;
  get_paid_parking_claims?: Maybe<GetPaidParkingClaimsOutput>;
  get_paid_parking_claims_v2?: Maybe<Array<Maybe<GetPaidParkingClaimsV2Output>>>;
  get_plate_events?: Maybe<GetPlateEventsOutput>;
  /** hasura action to trigger the get_potential_mlps lambda */
  get_potential_mlps?: Maybe<GetPotentialMlPsOutput>;
  get_queue_length?: Maybe<GetQueueLengthOutput>;
  /** Get SMS status for a device */
  get_sms_status: Array<SmsStatusOutput>;
  get_special_letter?: Maybe<GetSpecialLetterOutput>;
  get_special_letter_preview?: Maybe<GetSpecialLetterPreviewResponse>;
  get_special_letter_templates?: Maybe<GetSpecialLetterTemplatesResponse>;
  get_system_image?: Maybe<SystemImageOutput>;
  get_template?: Maybe<GetTemplateOutput>;
  get_user_bookings?: Maybe<Array<Maybe<UserBookingResponse>>>;
  get_user_data?: Maybe<UserInfo>;
  get_user_invoice_url: GetUserInvoiceUrlResponse;
  get_user_subscriptions?: Maybe<Array<Maybe<UserSubscriptionResponse>>>;
  get_violation_info?: Maybe<GetViolationInfoOutput>;
  get_visible_lots_and_companies?: Maybe<VisibleLotsAndCompanies>;
  get_whitelist_entries?: Maybe<Array<ExportedWhitelistEntry>>;
  /** Returns active whitelist entries for a specified plate for the customer dashboard */
  get_whitelist_entries_by_plate?: Maybe<Array<Maybe<WhitelistEntriesByPlateResponse>>>;
  group_blacklist_entries_by_plate?: Maybe<BlacklistEntriesGroupedByPlateResponse>;
  /** Returns active whitelist entries grouped by plate for the customer dashboard */
  group_whitelist_entries_by_plate?: Maybe<Array<WhitelistEntry>>;
  /** fetch data from the table: "guest_jwt" */
  guest_jwt: Array<GuestJwt>;
  /** fetch aggregated fields from the table: "guest_jwt" */
  guest_jwt_aggregate: GuestJwtAggregate;
  /** fetch data from the table: "guest_jwt" using primary key columns */
  guest_jwt_by_pk?: Maybe<GuestJwt>;
  /** fetch data from the table: "guest_qr" */
  guest_qr: Array<GuestQr>;
  /** fetch aggregated fields from the table: "guest_qr" */
  guest_qr_aggregate: GuestQrAggregate;
  /** fetch data from the table: "guest_qr" using primary key columns */
  guest_qr_by_pk?: Maybe<GuestQr>;
  is_internal_user?: Maybe<IsInternalUserOutput>;
  /** fetch data from the table: "lot" */
  lot: Array<Lot>;
  /** fetch aggregated fields from the table: "lot" */
  lot_aggregate: LotAggregate;
  /** fetch data from the table: "lot" using primary key columns */
  lot_by_pk?: Maybe<Lot>;
  /** fetch data from the table: "lot_config_group" */
  lot_config_group: Array<LotConfigGroup>;
  /** fetch aggregated fields from the table: "lot_config_group" */
  lot_config_group_aggregate: LotConfigGroupAggregate;
  /** fetch data from the table: "lot_config_group" using primary key columns */
  lot_config_group_by_pk?: Maybe<LotConfigGroup>;
  /** fetch data from the table: "lot_display_name" */
  lot_display_name: Array<LotDisplayName>;
  /** fetch aggregated fields from the table: "lot_display_name" */
  lot_display_name_aggregate: LotDisplayNameAggregate;
  /** fetch data from the table: "lot_display_name" using primary key columns */
  lot_display_name_by_pk?: Maybe<LotDisplayName>;
  /** fetch data from the table: "lot_hierarchy" */
  lot_hierarchy: Array<LotHierarchy>;
  /** fetch aggregated fields from the table: "lot_hierarchy" */
  lot_hierarchy_aggregate: LotHierarchyAggregate;
  /** fetch data from the table: "lot_hierarchy" using primary key columns */
  lot_hierarchy_by_pk?: Maybe<LotHierarchy>;
  /** fetch data from the table: "lot_legal_entity" */
  lot_legal_entity: Array<LotLegalEntity>;
  /** fetch aggregated fields from the table: "lot_legal_entity" */
  lot_legal_entity_aggregate: LotLegalEntityAggregate;
  /** fetch data from the table: "lot_legal_entity" using primary key columns */
  lot_legal_entity_by_pk?: Maybe<LotLegalEntity>;
  /** fetch data from the table: "lot_policy_history" */
  lot_policy_history: Array<LotPolicyHistory>;
  /** fetch aggregated fields from the table: "lot_policy_history" */
  lot_policy_history_aggregate: LotPolicyHistoryAggregate;
  /** fetch data from the table: "lot_policy_history" using primary key columns */
  lot_policy_history_by_pk?: Maybe<LotPolicyHistory>;
  /** fetch data from the table: "lot_section" */
  lot_section: Array<LotSection>;
  /** fetch aggregated fields from the table: "lot_section" */
  lot_section_aggregate: LotSectionAggregate;
  /** fetch data from the table: "lot_section" using primary key columns */
  lot_section_by_pk?: Maybe<LotSection>;
  /** fetch data from the table: "lp_contingent" */
  lp_contingent: Array<LpContingent>;
  /** fetch aggregated fields from the table: "lp_contingent" */
  lp_contingent_aggregate: LpContingentAggregate;
  /** fetch data from the table: "lp_contingent" using primary key columns */
  lp_contingent_by_pk?: Maybe<LpContingent>;
  /** fetch data from the table: "lp_group" */
  lp_group: Array<LpGroup>;
  /** fetch aggregated fields from the table: "lp_group" */
  lp_group_aggregate: LpGroupAggregate;
  /** fetch data from the table: "lp_group" using primary key columns */
  lp_group_by_pk?: Maybe<LpGroup>;
  /** fetch data from the table: "lp_group_config_group" */
  lp_group_config_group: Array<LpGroupConfigGroup>;
  /** fetch aggregated fields from the table: "lp_group_config_group" */
  lp_group_config_group_aggregate: LpGroupConfigGroupAggregate;
  /** fetch data from the table: "lp_group_config_group" using primary key columns */
  lp_group_config_group_by_pk?: Maybe<LpGroupConfigGroup>;
  /** fetch data from the table: "lp_group_details" */
  lp_group_details: Array<LpGroupDetails>;
  /** fetch aggregated fields from the table: "lp_group_details" */
  lp_group_details_aggregate: LpGroupDetailsAggregate;
  /** fetch data from the table: "lp_group_details" using primary key columns */
  lp_group_details_by_pk?: Maybe<LpGroupDetails>;
  /** fetch data from the table: "lp_group_member" */
  lp_group_member: Array<LpGroupMember>;
  /** fetch aggregated fields from the table: "lp_group_member" */
  lp_group_member_aggregate: LpGroupMemberAggregate;
  /** fetch data from the table: "lp_group_member" using primary key columns */
  lp_group_member_by_pk?: Maybe<LpGroupMember>;
  /** fetch data from the table: "lp_group_member_details" */
  lp_group_member_details: Array<LpGroupMemberDetails>;
  /** fetch aggregated fields from the table: "lp_group_member_details" */
  lp_group_member_details_aggregate: LpGroupMemberDetailsAggregate;
  /** fetch data from the table: "lp_group_member_details" using primary key columns */
  lp_group_member_details_by_pk?: Maybe<LpGroupMemberDetails>;
  /** fetch data from the table: "mail" */
  mail: Array<Mail>;
  /** fetch aggregated fields from the table: "mail" */
  mail_aggregate: MailAggregate;
  /** fetch data from the table: "mail" using primary key columns */
  mail_by_pk?: Maybe<Mail>;
  /** fetch data from the table: "mail_misc" */
  mail_misc: Array<MailMisc>;
  /** fetch aggregated fields from the table: "mail_misc" */
  mail_misc_aggregate: MailMiscAggregate;
  /** fetch data from the table: "mail_misc" using primary key columns */
  mail_misc_by_pk?: Maybe<MailMisc>;
  merge_cases_by_language?: Maybe<MergeCasesByLanguagesResponse>;
  /** fetch data from the table: "mlp_cases" */
  mlp_cases: Array<MlpCases>;
  /** fetch aggregated fields from the table: "mlp_cases" */
  mlp_cases_aggregate: MlpCasesAggregate;
  /** fetch data from the table: "mlp_cases" using primary key columns */
  mlp_cases_by_pk?: Maybe<MlpCases>;
  /** fetch data from the table: "mlp_mappings" */
  mlp_mappings: Array<MlpMappings>;
  /** fetch aggregated fields from the table: "mlp_mappings" */
  mlp_mappings_aggregate: MlpMappingsAggregate;
  /** fetch data from the table: "mlp_mappings" using primary key columns */
  mlp_mappings_by_pk?: Maybe<MlpMappings>;
  /** fetch data from the table: "mqtt_request" */
  mqtt_request: Array<MqttRequest>;
  /** fetch aggregated fields from the table: "mqtt_request" */
  mqtt_request_aggregate: MqttRequestAggregate;
  /** fetch data from the table: "mqtt_request" using primary key columns */
  mqtt_request_by_pk?: Maybe<MqttRequest>;
  /** fetch data from the table: "offence_parking_events" */
  offence_parking_events: Array<OffenceParkingEvents>;
  /** fetch aggregated fields from the table: "offence_parking_events" */
  offence_parking_events_aggregate: OffenceParkingEventsAggregate;
  /** fetch data from the table: "offence_parking_events" using primary key columns */
  offence_parking_events_by_pk?: Maybe<OffenceParkingEvents>;
  /** fetch data from the table: "offence_ticket_requests" */
  offence_ticket_requests: Array<OffenceTicketRequests>;
  /** fetch aggregated fields from the table: "offence_ticket_requests" */
  offence_ticket_requests_aggregate: OffenceTicketRequestsAggregate;
  /** fetch data from the table: "offence_ticket_requests" using primary key columns */
  offence_ticket_requests_by_pk?: Maybe<OffenceTicketRequests>;
  /** fetch data from the table: "overuse_group" */
  overuse_group: Array<OveruseGroup>;
  /** fetch aggregated fields from the table: "overuse_group" */
  overuse_group_aggregate: OveruseGroupAggregate;
  /** fetch data from the table: "overuse_group" using primary key columns */
  overuse_group_by_pk?: Maybe<OveruseGroup>;
  /** fetch data from the table: "overuse_group_member" */
  overuse_group_member: Array<OveruseGroupMember>;
  /** fetch aggregated fields from the table: "overuse_group_member" */
  overuse_group_member_aggregate: OveruseGroupMemberAggregate;
  /** fetch data from the table: "overuse_group_member" using primary key columns */
  overuse_group_member_by_pk?: Maybe<OveruseGroupMember>;
  /** fetch data from the table: "parkdepot_product" */
  parkdepot_product: Array<ParkdepotProduct>;
  /** fetch aggregated fields from the table: "parkdepot_product" */
  parkdepot_product_aggregate: ParkdepotProductAggregate;
  /** fetch data from the table: "parkdepot_product" using primary key columns */
  parkdepot_product_by_pk?: Maybe<ParkdepotProduct>;
  /** fetch data from the table: "parking_context" */
  parking_context: Array<ParkingContext>;
  /** fetch aggregated fields from the table: "parking_context" */
  parking_context_aggregate: ParkingContextAggregate;
  /** fetch data from the table: "parking_context" using primary key columns */
  parking_context_by_pk?: Maybe<ParkingContext>;
  /** fetch data from the table: "parking_detections" */
  parking_detections: Array<ParkingDetections>;
  /** fetch aggregated fields from the table: "parking_detections" */
  parking_detections_aggregate: ParkingDetectionsAggregate;
  /** fetch data from the table: "parking_detections_archive" */
  parking_detections_archive: Array<ParkingDetectionsArchive>;
  /** fetch aggregated fields from the table: "parking_detections_archive" */
  parking_detections_archive_aggregate: ParkingDetectionsArchiveAggregate;
  /** fetch data from the table: "parking_detections_archive" using primary key columns */
  parking_detections_archive_by_pk?: Maybe<ParkingDetectionsArchive>;
  /** fetch data from the table: "parking_detections" using primary key columns */
  parking_detections_by_pk?: Maybe<ParkingDetections>;
  /** fetch data from the table: "parking_incoming" */
  parking_incoming: Array<ParkingIncoming>;
  /** fetch aggregated fields from the table: "parking_incoming" */
  parking_incoming_aggregate: ParkingIncomingAggregate;
  /** fetch data from the table: "parking_incoming" using primary key columns */
  parking_incoming_by_pk?: Maybe<ParkingIncoming>;
  /** fetch data from the table: "parking_processing" */
  parking_processing: Array<ParkingProcessing>;
  /** fetch aggregated fields from the table: "parking_processing" */
  parking_processing_aggregate: ParkingProcessingAggregate;
  /** fetch data from the table: "parking_processing" using primary key columns */
  parking_processing_by_pk?: Maybe<ParkingProcessing>;
  /** fetch data from the table: "parking_results" */
  parking_results: Array<ParkingResults>;
  /** fetch aggregated fields from the table: "parking_results" */
  parking_results_aggregate: ParkingResultsAggregate;
  /** fetch data from the table: "parking_results_archive" */
  parking_results_archive: Array<ParkingResultsArchive>;
  /** fetch aggregated fields from the table: "parking_results_archive" */
  parking_results_archive_aggregate: ParkingResultsArchiveAggregate;
  /** fetch data from the table: "parking_results_archive" using primary key columns */
  parking_results_archive_by_pk?: Maybe<ParkingResultsArchive>;
  /** fetch data from the table: "parking_results" using primary key columns */
  parking_results_by_pk?: Maybe<ParkingResults>;
  /** fetch data from the table: "parking_temp" */
  parking_temp: Array<ParkingTemp>;
  /** fetch aggregated fields from the table: "parking_temp" */
  parking_temp_aggregate: ParkingTempAggregate;
  /** fetch data from the table: "parking_temp" using primary key columns */
  parking_temp_by_pk?: Maybe<ParkingTemp>;
  /** fetch data from the table: "paybyphone_lot" */
  paybyphone_lot: Array<PaybyphoneLot>;
  /** fetch aggregated fields from the table: "paybyphone_lot" */
  paybyphone_lot_aggregate: PaybyphoneLotAggregate;
  /** fetch data from the table: "paybyphone_lot" using primary key columns */
  paybyphone_lot_by_pk?: Maybe<PaybyphoneLot>;
  /** fetch data from the table: "paybyphone_order" */
  paybyphone_order: Array<PaybyphoneOrder>;
  /** fetch aggregated fields from the table: "paybyphone_order" */
  paybyphone_order_aggregate: PaybyphoneOrderAggregate;
  /** fetch data from the table: "paybyphone_order" using primary key columns */
  paybyphone_order_by_pk?: Maybe<PaybyphoneOrder>;
  /** fetch data from the table: "person" */
  person: Array<Person>;
  /** fetch aggregated fields from the table: "person" */
  person_aggregate: PersonAggregate;
  /** fetch data from the table: "person" using primary key columns */
  person_by_pk?: Maybe<Person>;
  /** fetch data from the table: "policy_schedule" */
  policy_schedule: Array<PolicySchedule>;
  /** fetch aggregated fields from the table: "policy_schedule" */
  policy_schedule_aggregate: PolicyScheduleAggregate;
  /** fetch data from the table: "policy_schedule" using primary key columns */
  policy_schedule_by_pk?: Maybe<PolicySchedule>;
  /** fetch data from the table: "regional_codes_austria" */
  regional_codes_austria: Array<RegionalCodesAustria>;
  /** fetch aggregated fields from the table: "regional_codes_austria" */
  regional_codes_austria_aggregate: RegionalCodesAustriaAggregate;
  /** fetch data from the table: "regional_codes_austria" using primary key columns */
  regional_codes_austria_by_pk?: Maybe<RegionalCodesAustria>;
  /** fetch data from the table: "rental_pricing" */
  rental_pricing: Array<RentalPricing>;
  /** fetch aggregated fields from the table: "rental_pricing" */
  rental_pricing_aggregate: RentalPricingAggregate;
  /** fetch data from the table: "rental_pricing" using primary key columns */
  rental_pricing_by_pk?: Maybe<RentalPricing>;
  /** fetch data from the table: "rental_subscription" */
  rental_subscription: Array<RentalSubscription>;
  /** fetch aggregated fields from the table: "rental_subscription" */
  rental_subscription_aggregate: RentalSubscriptionAggregate;
  /** fetch data from the table: "rental_subscription" using primary key columns */
  rental_subscription_by_pk?: Maybe<RentalSubscription>;
  /** fetch data from the table: "repeat_offense_view" */
  repeat_offense_view: Array<RepeatOffenseView>;
  /** fetch aggregated fields from the table: "repeat_offense_view" */
  repeat_offense_view_aggregate: RepeatOffenseViewAggregate;
  send_car_owner_requests_germany?: Maybe<SendCarOwnerRequestsGermany>;
  send_invoice?: Maybe<SendInvoiceOutput>;
  /** fetch data from the table: "serverless_async_work" */
  serverless_async_work: Array<ServerlessAsyncWork>;
  /** fetch aggregated fields from the table: "serverless_async_work" */
  serverless_async_work_aggregate: ServerlessAsyncWorkAggregate;
  /** fetch data from the table: "serverless_async_work" using primary key columns */
  serverless_async_work_by_pk?: Maybe<ServerlessAsyncWork>;
  set_device_force_update?: Maybe<UpdateDeviceOutput>;
  /** fetch data from the table: "similar_detections" */
  similar_detections: Array<SimilarDetections>;
  /** fetch aggregated fields from the table: "similar_detections" */
  similar_detections_aggregate: SimilarDetectionsAggregate;
  /** fetch data from the table: "similar_detections" using primary key columns */
  similar_detections_by_pk?: Maybe<SimilarDetections>;
  /** An array relationship */
  stages: Array<Stages>;
  /** An aggregate relationship */
  stages_aggregate: StagesAggregate;
  /** fetch data from the table: "stages" using primary key columns */
  stages_by_pk?: Maybe<Stages>;
  start_generation_of_special_letters?: Maybe<StartGenerationOfSpecialLetters>;
  /** fetch data from the table: "station" */
  station: Array<Station>;
  /** fetch aggregated fields from the table: "station" */
  station_aggregate: StationAggregate;
  /** fetch data from the table: "station" using primary key columns */
  station_by_pk?: Maybe<Station>;
  /** fetch data from the table: "supervision_car_rental_partners" */
  supervision_car_rental_partners: Array<SupervisionCarRentalPartners>;
  /** fetch aggregated fields from the table: "supervision_car_rental_partners" */
  supervision_car_rental_partners_aggregate: SupervisionCarRentalPartnersAggregate;
  /** fetch data from the table: "supervision_car_rental_partners" using primary key columns */
  supervision_car_rental_partners_by_pk?: Maybe<SupervisionCarRentalPartners>;
  /** fetch data from the table: "supervision_debt_collection_case" */
  supervision_debt_collection_case: Array<SupervisionDebtCollectionCase>;
  /** fetch aggregated fields from the table: "supervision_debt_collection_case" */
  supervision_debt_collection_case_aggregate: SupervisionDebtCollectionCaseAggregate;
  /** fetch data from the table: "supervision_debt_collection_case" using primary key columns */
  supervision_debt_collection_case_by_pk?: Maybe<SupervisionDebtCollectionCase>;
  /** fetch data from the table: "supervision_image_requests" */
  supervision_image_requests: Array<SupervisionImageRequests>;
  /** fetch aggregated fields from the table: "supervision_image_requests" */
  supervision_image_requests_aggregate: SupervisionImageRequestsAggregate;
  /** fetch data from the table: "supervision_image_requests" using primary key columns */
  supervision_image_requests_by_pk?: Maybe<SupervisionImageRequests>;
  /** fetch data from the table: "supervision_mlp_requests" */
  supervision_mlp_requests: Array<SupervisionMlpRequests>;
  /** fetch aggregated fields from the table: "supervision_mlp_requests" */
  supervision_mlp_requests_aggregate: SupervisionMlpRequestsAggregate;
  /** fetch data from the table: "supervision_mlp_requests" using primary key columns */
  supervision_mlp_requests_by_pk?: Maybe<SupervisionMlpRequests>;
  /** fetch data from the table: "supervision_multivisit_offender_group" */
  supervision_multivisit_offender_group: Array<SupervisionMultivisitOffenderGroup>;
  /** fetch aggregated fields from the table: "supervision_multivisit_offender_group" */
  supervision_multivisit_offender_group_aggregate: SupervisionMultivisitOffenderGroupAggregate;
  /** fetch data from the table: "supervision_multivisit_offender_group" using primary key columns */
  supervision_multivisit_offender_group_by_pk?: Maybe<SupervisionMultivisitOffenderGroup>;
  /** fetch data from the table: "supervision_multivisit_offender_group_member" */
  supervision_multivisit_offender_group_member: Array<SupervisionMultivisitOffenderGroupMember>;
  /** fetch aggregated fields from the table: "supervision_multivisit_offender_group_member" */
  supervision_multivisit_offender_group_member_aggregate: SupervisionMultivisitOffenderGroupMemberAggregate;
  /** fetch data from the table: "supervision_multivisit_offender_group_member" using primary key columns */
  supervision_multivisit_offender_group_member_by_pk?: Maybe<SupervisionMultivisitOffenderGroupMember>;
  /** fetch data from the table: "supervision_ticket_request" */
  supervision_ticket_request: Array<SupervisionTicketRequest>;
  /** fetch aggregated fields from the table: "supervision_ticket_request" */
  supervision_ticket_request_aggregate: SupervisionTicketRequestAggregate;
  /** fetch data from the table: "supervision_ticket_request" using primary key columns */
  supervision_ticket_request_by_pk?: Maybe<SupervisionTicketRequest>;
  /** fetch data from the table: "supervision_violation_case_debt_collection_case" */
  supervision_violation_case_debt_collection_case: Array<SupervisionViolationCaseDebtCollectionCase>;
  /** fetch aggregated fields from the table: "supervision_violation_case_debt_collection_case" */
  supervision_violation_case_debt_collection_case_aggregate: SupervisionViolationCaseDebtCollectionCaseAggregate;
  /** fetch data from the table: "supervision_violation_case_debt_collection_case" using primary key columns */
  supervision_violation_case_debt_collection_case_by_pk?: Maybe<SupervisionViolationCaseDebtCollectionCase>;
  sync_device_diff_config?: Maybe<UpdateDeviceOutput>;
  /** fetch data from the table: "tax" */
  tax: Array<Tax>;
  /** fetch aggregated fields from the table: "tax" */
  tax_aggregate: TaxAggregate;
  /** fetch data from the table: "tax" using primary key columns */
  tax_by_pk?: Maybe<Tax>;
  /** fetch data from the table: "terminal_status" */
  terminal_status: Array<TerminalStatus>;
  /** fetch aggregated fields from the table: "terminal_status" */
  terminal_status_aggregate: TerminalStatusAggregate;
  /** fetch data from the table: "terminal_status" using primary key columns */
  terminal_status_by_pk?: Maybe<TerminalStatus>;
  /** fetch data from the table: "ticket_website_feedback" */
  ticket_website_feedback: Array<TicketWebsiteFeedback>;
  /** fetch aggregated fields from the table: "ticket_website_feedback" */
  ticket_website_feedback_aggregate: TicketWebsiteFeedbackAggregate;
  /** fetch data from the table: "ticket_website_feedback" using primary key columns */
  ticket_website_feedback_by_pk?: Maybe<TicketWebsiteFeedback>;
  /** fetch data from the table: "time_discount" */
  time_discount: Array<TimeDiscount>;
  /** fetch aggregated fields from the table: "time_discount" */
  time_discount_aggregate: TimeDiscountAggregate;
  /** fetch data from the table: "time_discount" using primary key columns */
  time_discount_by_pk?: Maybe<TimeDiscount>;
  /** hasrua action to trigger lambda to update mlp cases and push output to sqs */
  update_and_push_mlp_cases?: Maybe<UpdateAndPushMlpCasesOutput>;
  update_device_config?: Maybe<UpdateDeviceOutput>;
  update_station_config?: Maybe<UpdateStationOutput>;
  update_station_data?: Maybe<UpdateDeviceOutput>;
  /** fetch data from the table: "user_preference" */
  user_preference: Array<UserPreference>;
  /** fetch aggregated fields from the table: "user_preference" */
  user_preference_aggregate: UserPreferenceAggregate;
  /** fetch data from the table: "user_preference" using primary key columns */
  user_preference_by_pk?: Maybe<UserPreference>;
  /** fetch data from the table: "vehicle_type" */
  vehicle_type: Array<VehicleType>;
  /** fetch aggregated fields from the table: "vehicle_type" */
  vehicle_type_aggregate: VehicleTypeAggregate;
  /** fetch data from the table: "vehicle_type" using primary key columns */
  vehicle_type_by_pk?: Maybe<VehicleType>;
  /** fetch data from the table: "vehicle_type_config_group" */
  vehicle_type_config_group: Array<VehicleTypeConfigGroup>;
  /** fetch aggregated fields from the table: "vehicle_type_config_group" */
  vehicle_type_config_group_aggregate: VehicleTypeConfigGroupAggregate;
  /** fetch data from the table: "vehicle_type_config_group" using primary key columns */
  vehicle_type_config_group_by_pk?: Maybe<VehicleTypeConfigGroup>;
  /** fetch data from the table: "violation_case" */
  violation_case: Array<ViolationCase>;
  /** fetch aggregated fields from the table: "violation_case" */
  violation_case_aggregate: ViolationCaseAggregate;
  /** fetch data from the table: "violation_case" using primary key columns */
  violation_case_by_pk?: Maybe<ViolationCase>;
  /** An array relationship */
  violation_case_charges: Array<ViolationCaseCharges>;
  /** An aggregate relationship */
  violation_case_charges_aggregate: ViolationCaseChargesAggregate;
  /** fetch data from the table: "violation_case_charges" using primary key columns */
  violation_case_charges_by_pk?: Maybe<ViolationCaseCharges>;
  /** fetch data from the table: "violation_case_tags" */
  violation_case_tags: Array<ViolationCaseTags>;
  /** fetch aggregated fields from the table: "violation_case_tags" */
  violation_case_tags_aggregate: ViolationCaseTagsAggregate;
  /** fetch data from the table: "violation_case_tags" using primary key columns */
  violation_case_tags_by_pk?: Maybe<ViolationCaseTags>;
  /** fetch data from the table: "violation_event_analysis" */
  violation_event_analysis: Array<ViolationEventAnalysis>;
  /** fetch aggregated fields from the table: "violation_event_analysis" */
  violation_event_analysis_aggregate: ViolationEventAnalysisAggregate;
  /** fetch data from the table: "violation_event_analysis" using primary key columns */
  violation_event_analysis_by_pk?: Maybe<ViolationEventAnalysis>;
  violator_image?: Maybe<ViolatorImageOutput>;
  /** An array relationship */
  violator_transactions: Array<ViolatorTransactions>;
  /** An aggregate relationship */
  violator_transactions_aggregate: ViolatorTransactionsAggregate;
  /** fetch data from the table: "violator_transactions" using primary key columns */
  violator_transactions_by_pk?: Maybe<ViolatorTransactions>;
  /** An array relationship */
  whitelist: Array<Whitelist>;
  /** An aggregate relationship */
  whitelist_aggregate: WhitelistAggregate;
  /** fetch data from the table: "whitelist_applied_permit" */
  whitelist_applied_permit: Array<WhitelistAppliedPermit>;
  /** fetch aggregated fields from the table: "whitelist_applied_permit" */
  whitelist_applied_permit_aggregate: WhitelistAppliedPermitAggregate;
  /** fetch data from the table: "whitelist_applied_permit" using primary key columns */
  whitelist_applied_permit_by_pk?: Maybe<WhitelistAppliedPermit>;
  /** fetch data from the table: "whitelist" using primary key columns */
  whitelist_by_pk?: Maybe<Whitelist>;
  /** fetch data from the table: "whitelist_by_plate_view" */
  whitelist_by_plate_view: Array<WhitelistByPlateView>;
  /** fetch aggregated fields from the table: "whitelist_by_plate_view" */
  whitelist_by_plate_view_aggregate: WhitelistByPlateViewAggregate;
  /** fetch data from the table: "whitelist_calendar_event_policy" */
  whitelist_calendar_event_policy: Array<WhitelistCalendarEventPolicy>;
  /** fetch aggregated fields from the table: "whitelist_calendar_event_policy" */
  whitelist_calendar_event_policy_aggregate: WhitelistCalendarEventPolicyAggregate;
  /** fetch data from the table: "whitelist_calendar_event_policy" using primary key columns */
  whitelist_calendar_event_policy_by_pk?: Maybe<WhitelistCalendarEventPolicy>;
  /** fetch data from the table: "whitelist_guest_by_plate_view" */
  whitelist_guest_by_plate_view: Array<WhitelistGuestByPlateView>;
  /** fetch aggregated fields from the table: "whitelist_guest_by_plate_view" */
  whitelist_guest_by_plate_view_aggregate: WhitelistGuestByPlateViewAggregate;
  /** fetch data from the table: "whitelist_lp_contingent" */
  whitelist_lp_contingent: Array<WhitelistLpContingent>;
  /** fetch aggregated fields from the table: "whitelist_lp_contingent" */
  whitelist_lp_contingent_aggregate: WhitelistLpContingentAggregate;
  /** fetch data from the table: "whitelist_lp_contingent" using primary key columns */
  whitelist_lp_contingent_by_pk?: Maybe<WhitelistLpContingent>;
  /** fetch data from the table: "whitelist_paid_parking" */
  whitelist_paid_parking: Array<WhitelistPaidParking>;
  /** fetch aggregated fields from the table: "whitelist_paid_parking" */
  whitelist_paid_parking_aggregate: WhitelistPaidParkingAggregate;
  /** fetch data from the table: "whitelist_paid_parking" using primary key columns */
  whitelist_paid_parking_by_pk?: Maybe<WhitelistPaidParking>;
  /** fetch data from the table: "whitelist_subscription" */
  whitelist_subscription: Array<WhitelistSubscription>;
  /** fetch aggregated fields from the table: "whitelist_subscription" */
  whitelist_subscription_aggregate: WhitelistSubscriptionAggregate;
  /** fetch data from the table: "whitelist_subscription" using primary key columns */
  whitelist_subscription_by_pk?: Maybe<WhitelistSubscription>;
  /** fetch data from the table: "wireguard_config" */
  wireguard_config: Array<WireguardConfig>;
  /** fetch aggregated fields from the table: "wireguard_config" */
  wireguard_config_aggregate: WireguardConfigAggregate;
  /** fetch data from the table: "wireguard_config" using primary key columns */
  wireguard_config_by_pk?: Maybe<WireguardConfig>;
};


export type QueryRootAdyenReportArgs = {
  distinct_on?: InputMaybe<Array<AdyenReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenReportOrderBy>>;
  where?: InputMaybe<AdyenReportBoolExp>;
};


export type QueryRootAdyenReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdyenReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenReportOrderBy>>;
  where?: InputMaybe<AdyenReportBoolExp>;
};


export type QueryRootAdyenReportByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAdyenTransactionArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


export type QueryRootAdyenTransactionAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


export type QueryRootAdyenTransactionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAppliedPermitArgs = {
  distinct_on?: InputMaybe<Array<AppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedPermitOrderBy>>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};


export type QueryRootAppliedPermitAggregateArgs = {
  distinct_on?: InputMaybe<Array<AppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedPermitOrderBy>>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};


export type QueryRootAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootAppliedWhitelistArgs = {
  distinct_on?: InputMaybe<Array<AppliedWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedWhitelistOrderBy>>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};


export type QueryRootAppliedWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<AppliedWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedWhitelistOrderBy>>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};


export type QueryRootAppliedWhitelistByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootAuditLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<AuditLoggedActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditLoggedActionsOrderBy>>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};


export type QueryRootAuditLoggedActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuditLoggedActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditLoggedActionsOrderBy>>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};


export type QueryRootAuditLoggedActionsByPkArgs = {
  event_id: Scalars['bigint'];
};


export type QueryRootAuth0UserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereFields>;
};


export type QueryRootB2cCheckoutArgs = {
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
};


export type QueryRootB2cErrorflowCheckoutArgs = {
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  language?: InputMaybe<Scalars['String']>;
  lot_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
};


export type QueryRootB2cGetCarpayLotArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootB2cGetCompletedOrdersArgs = {
  plates: Array<Scalars['String']>;
};


export type QueryRootB2cGetErrorflowPriceArgs = {
  country: Scalars['String'];
  end_date?: InputMaybe<Scalars['timestamptz']>;
  lot_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  plate: Scalars['String'];
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
};


export type QueryRootB2cGetInvoiceArgs = {
  order_id: Scalars['String'];
};


export type QueryRootB2cGetLotOccupancyArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootB2cGetOpenOrdersArgs = {
  plates: Array<Scalars['String']>;
};


export type QueryRootB2cGetOrderByIdArgs = {
  order_id: Scalars['String'];
};


export type QueryRootB2cGetPriceArgs = {
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  selected_parking_tariff: Scalars['String'];
};


export type QueryRootBlacklistArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type QueryRootBlacklistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type QueryRootBlacklistByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootBlacklistByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<BlacklistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistByPlateViewOrderBy>>;
  where?: InputMaybe<BlacklistByPlateViewBoolExp>;
};


export type QueryRootBlacklistByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistByPlateViewOrderBy>>;
  where?: InputMaybe<BlacklistByPlateViewBoolExp>;
};


export type QueryRootBookingBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


export type QueryRootBookingBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


export type QueryRootBookingBookingByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBookingBookingInvoiceArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


export type QueryRootBookingBookingInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


export type QueryRootBookingBookingInvoiceByPkArgs = {
  booking_id: Scalars['Int'];
  invoice_id: Scalars['String'];
};


export type QueryRootBookingBookingPlateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


export type QueryRootBookingBookingPlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


export type QueryRootBookingBookingPlateByPkArgs = {
  booking_id: Scalars['Int'];
  plate: Scalars['String'];
};


export type QueryRootBookingBookingTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingTypeOrderBy>>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};


export type QueryRootBookingBookingTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingTypeOrderBy>>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};


export type QueryRootBookingBookingTypeByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootBookingBookingWhitelistArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


export type QueryRootBookingBookingWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


export type QueryRootBookingBookingWhitelistByPkArgs = {
  booking_id: Scalars['Int'];
  whitelist_id: Scalars['Int'];
};


export type QueryRootBookingCreateAdyenSessionArgs = {
  id: Scalars['Int'];
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  top_level_domain?: InputMaybe<Scalars['String']>;
};


export type QueryRootBookingEnumBookingStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingEnumBookingStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingEnumBookingStatusOrderBy>>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};


export type QueryRootBookingEnumBookingStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingEnumBookingStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingEnumBookingStatusOrderBy>>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};


export type QueryRootBookingEnumBookingStatusByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootBookingGetLotArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootBookingGetLotAvailabilityArgs = {
  from_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  to_datetime: Scalars['timestamptz'];
};


export type QueryRootBookingGetLotConfigurationArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootBookingGetLotImageUrlsArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootBookingGetLotsArgs = {
  end_datetime?: InputMaybe<Scalars['timestamptz']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  start_datetime?: InputMaybe<Scalars['timestamptz']>;
};


export type QueryRootBookingGetPriceArgs = {
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  pricing_type: BookingPricingModelType;
  start_datetime: Scalars['timestamptz'];
};


export type QueryRootBookingGetPriceHourlyArgs = {
  lot_id: Scalars['String'];
  num_hours: Scalars['Int'];
  pricing_type: BookingPricingModelType;
};


export type QueryRootBookingHourlyBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingHourlyBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingHourlyBookingOrderBy>>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};


export type QueryRootBookingHourlyBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingHourlyBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingHourlyBookingOrderBy>>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};


export type QueryRootBookingHourlyBookingByPkArgs = {
  booking_id: Scalars['Int'];
};


export type QueryRootBookingLicensePlateArgs = {
  distinct_on?: InputMaybe<Array<BookingLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLicensePlateOrderBy>>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};


export type QueryRootBookingLicensePlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLicensePlateOrderBy>>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};


export type QueryRootBookingLicensePlateByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBookingLotArgs = {
  distinct_on?: InputMaybe<Array<BookingLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotOrderBy>>;
  where?: InputMaybe<BookingLotBoolExp>;
};


export type QueryRootBookingLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotOrderBy>>;
  where?: InputMaybe<BookingLotBoolExp>;
};


export type QueryRootBookingLotByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootBookingLotConfigurationArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


export type QueryRootBookingLotConfigurationAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


export type QueryRootBookingLotConfigurationByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootBookingPaymentArgs = {
  distinct_on?: InputMaybe<Array<BookingPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPaymentOrderBy>>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};


export type QueryRootBookingPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPaymentOrderBy>>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};


export type QueryRootBookingPaymentByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBookingPricingRulesArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


export type QueryRootBookingPricingRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


export type QueryRootBookingPricingRulesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBookingPricingTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingTypeOrderBy>>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};


export type QueryRootBookingPricingTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingTypeOrderBy>>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};


export type QueryRootBookingPricingTypeByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootBookingPrivatePricingUserArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


export type QueryRootBookingPrivatePricingUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


export type QueryRootBookingPrivatePricingUserByPkArgs = {
  price_model_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};


export type QueryRootBookingRecurringBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


export type QueryRootBookingRecurringBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


export type QueryRootBookingRecurringBookingByPkArgs = {
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};


export type QueryRootBookingSubscriptionBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


export type QueryRootBookingSubscriptionBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


export type QueryRootBookingSubscriptionBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


export type QueryRootBookingSubscriptionLicensePlateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


export type QueryRootBookingSubscriptionLicensePlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


export type QueryRootBookingSubscriptionLicensePlateByPkArgs = {
  license_plate_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


export type QueryRootBookingSubscriptionStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionStatusOrderBy>>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};


export type QueryRootBookingSubscriptionStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionStatusOrderBy>>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};


export type QueryRootBookingSubscriptionStatusByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootBookingUserArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserOrderBy>>;
  where?: InputMaybe<BookingUserBoolExp>;
};


export type QueryRootBookingUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserOrderBy>>;
  where?: InputMaybe<BookingUserBoolExp>;
};


export type QueryRootBookingUserBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingUserBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserBookingOrderBy>>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};


export type QueryRootBookingUserBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserBookingOrderBy>>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};


export type QueryRootBookingUserBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};


export type QueryRootBookingUserByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBookingUserPaymentMethodArgs = {
  distinct_on?: InputMaybe<Array<BookingUserPaymentMethodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserPaymentMethodOrderBy>>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};


export type QueryRootBookingUserPaymentMethodAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserPaymentMethodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserPaymentMethodOrderBy>>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};


export type QueryRootBookingUserPaymentMethodByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBookingUserSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserSubscriptionOrderBy>>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};


export type QueryRootBookingUserSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserSubscriptionOrderBy>>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};


export type QueryRootBookingUserSubscriptionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBookingVehicleArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleOrderBy>>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};


export type QueryRootBookingVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleOrderBy>>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};


export type QueryRootBookingVehicleByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBookingVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleTypeOrderBy>>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};


export type QueryRootBookingVehicleTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleTypeOrderBy>>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};


export type QueryRootBookingVehicleTypeByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootBookingWhitelistTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingWhitelistTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingWhitelistTypeOrderBy>>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};


export type QueryRootBookingWhitelistTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingWhitelistTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingWhitelistTypeOrderBy>>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};


export type QueryRootBookingWhitelistTypeByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootCalendarEventPolicyArgs = {
  distinct_on?: InputMaybe<Array<CalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CalendarEventPolicyOrderBy>>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};


export type QueryRootCalendarEventPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CalendarEventPolicyOrderBy>>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};


export type QueryRootCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCancellationReasonViewArgs = {
  distinct_on?: InputMaybe<Array<CancellationReasonViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationReasonViewOrderBy>>;
  where?: InputMaybe<CancellationReasonViewBoolExp>;
};


export type QueryRootCancellationReasonViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationReasonViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationReasonViewOrderBy>>;
  where?: InputMaybe<CancellationReasonViewBoolExp>;
};


export type QueryRootCancellationsArgs = {
  distinct_on?: InputMaybe<Array<CancellationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationsOrderBy>>;
  where?: InputMaybe<CancellationsBoolExp>;
};


export type QueryRootCancellationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationsOrderBy>>;
  where?: InputMaybe<CancellationsBoolExp>;
};


export type QueryRootCancellationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCancellationsCustomerArgs = {
  cancellation_reasons?: InputMaybe<Array<Scalars['String']>>;
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  datetime_end?: InputMaybe<Scalars['String']>;
  datetime_start?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  offset: Scalars['Int'];
  search_text?: InputMaybe<Scalars['String']>;
};


export type QueryRootCancellationsCustomerAggregateArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootCarDriverArgs = {
  distinct_on?: InputMaybe<Array<CarDriverSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarDriverOrderBy>>;
  where?: InputMaybe<CarDriverBoolExp>;
};


export type QueryRootCarDriverAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarDriverSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarDriverOrderBy>>;
  where?: InputMaybe<CarDriverBoolExp>;
};


export type QueryRootCarDriverByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarOwnerArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


export type QueryRootCarOwnerAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


export type QueryRootCarOwnerByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarOwnerRequestsArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerRequestsOrderBy>>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};


export type QueryRootCarOwnerRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerRequestsOrderBy>>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};


export type QueryRootCarOwnerRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarpayAccessControlGetPinArgs = {
  plate: Scalars['String'];
  site_id: Scalars['String'];
};


export type QueryRootCarpayAccessControlLpPinArgs = {
  distinct_on?: InputMaybe<Array<CarpayAccessControlLpPinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayAccessControlLpPinOrderBy>>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};


export type QueryRootCarpayAccessControlLpPinAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayAccessControlLpPinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayAccessControlLpPinOrderBy>>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};


export type QueryRootCarpayAccessControlLpPinByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayAccessControlSendPinSmsArgs = {
  phone_number: Scalars['String'];
  plate: Scalars['String'];
  site_id: Scalars['String'];
};


export type QueryRootCarpayAdyenGetResultCodeArgs = {
  order_id: Scalars['String'];
  redirect_result: Scalars['String'];
};


export type QueryRootCarpayCalculateOrderPriceArgs = {
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  selected_parking_tariff: Scalars['String'];
};


export type QueryRootCarpayCheckoutSessionArgs = {
  email: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
};


export type QueryRootCarpayDiscountBatchArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


export type QueryRootCarpayDiscountBatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


export type QueryRootCarpayDiscountBatchByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayDiscountBatchesInternalDashboardArgs = {
  discount_model_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  show_deleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRootCarpayDiscountBatchesInternalDashboardByIdArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayDiscountModelArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


export type QueryRootCarpayDiscountModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


export type QueryRootCarpayDiscountModelByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayDiscountModelInternalDashbaordByIdArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayDiscountModelsInternalDashbaordByLotIdArgs = {
  lot_id: Scalars['String'];
  show_deleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRootCarpayEasyparkInternalDashboardByLotIdArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayGetLotConfigurationArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayGetOrdersArgs = {
  plate: Scalars['String'];
  return_free?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRootCarpayGetQrFlyerBatchArgs = {
  batch_id: Scalars['Int'];
  discount_value: Scalars['Int'];
  domain: Scalars['String'];
  expiration: Scalars['String'];
  lot_id: Scalars['String'];
  lot_name: Scalars['String'];
  num_codes: Scalars['Int'];
};


export type QueryRootCarpayInvoiceArgs = {
  invoice_id: Scalars['String'];
  order_id: Scalars['String'];
};


export type QueryRootCarpayLotArgs = {
  distinct_on?: InputMaybe<Array<CarpayLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayLotOrderBy>>;
  where?: InputMaybe<CarpayLotBoolExp>;
};


export type QueryRootCarpayLotActionGetSchedulesArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayLotOrderBy>>;
  where?: InputMaybe<CarpayLotBoolExp>;
};


export type QueryRootCarpayLotByPkArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayLotGetByIdArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayNotificationConfigInternalDashbaordByLotIdArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayNotificationSubscriberArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriberOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};


export type QueryRootCarpayNotificationSubscriberAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriberOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};


export type QueryRootCarpayNotificationSubscriberByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayNotificationSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};


export type QueryRootCarpayNotificationSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};


export type QueryRootCarpayNotificationSubscriptionByPkArgs = {
  category_id: Scalars['Int'];
  lot_id: Scalars['String'];
  subscriber_id: Scalars['Int'];
};


export type QueryRootCarpayNotificationSubscriptionCategoryArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};


export type QueryRootCarpayNotificationSubscriptionCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};


export type QueryRootCarpayNotificationSubscriptionCategoryByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayOrderArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


export type QueryRootCarpayOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


export type QueryRootCarpayOrderByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarpayOrderMatchesArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


export type QueryRootCarpayOrderMatchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


export type QueryRootCarpayOrderMatchesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayOrderUserArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderUserOrderBy>>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};


export type QueryRootCarpayOrderUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderUserOrderBy>>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};


export type QueryRootCarpayOrderUserByPkArgs = {
  order_id: Scalars['Int'];
};


export type QueryRootCarpayParkingDetectionArgs = {
  distinct_on?: InputMaybe<Array<CarpayParkingDetectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayParkingDetectionOrderBy>>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};


export type QueryRootCarpayParkingDetectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayParkingDetectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayParkingDetectionOrderBy>>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};


export type QueryRootCarpayParkingDetectionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayPaybyphoneInternalDashboardByLotIdArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayPricingArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


export type QueryRootCarpayPricingAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


export type QueryRootCarpayPricingByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayPricingConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingConfigGroupOrderBy>>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};


export type QueryRootCarpayPricingConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingConfigGroupOrderBy>>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};


export type QueryRootCarpayPricingConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarpayPricingPeriodArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


export type QueryRootCarpayPricingPeriodAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


export type QueryRootCarpayPricingPeriodByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootCarpayPricingRecurrenceArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


export type QueryRootCarpayPricingRecurrenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


export type QueryRootCarpayPricingRecurrenceByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootCarpayPricingRulesArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRulesOrderBy>>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};


export type QueryRootCarpayPricingRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRulesOrderBy>>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};


export type QueryRootCarpayPricingRulesByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootCarpayScannedCodesArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


export type QueryRootCarpayScannedCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


export type QueryRootCarpayScannedCodesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCarpaySubscriptionInternalDashboardByLotIdArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayTerminalCashCutNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashCutNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashCutNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};


export type QueryRootCarpayTerminalCashCutNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashCutNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashCutNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};


export type QueryRootCarpayTerminalCashCutNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayTerminalCashFillLevelNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};


export type QueryRootCarpayTerminalCashFillLevelNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};


export type QueryRootCarpayTerminalCashFillLevelNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayTerminalConfigArgs = {
  lot_ids: Array<Scalars['String']>;
};


export type QueryRootCarpayTerminalGetLegalStatusArgs = {
  country: Scalars['String'];
  end: Scalars['String'];
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  start: Scalars['String'];
};


export type QueryRootCarpayTerminalGetOrdersArgs = {
  lot_id: Scalars['String'];
  plate?: InputMaybe<Scalars['String']>;
};


export type QueryRootCarpayTerminalGetOrdersV2Args = {
  include_paid?: InputMaybe<Scalars['Boolean']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  plate?: InputMaybe<Scalars['String']>;
};


export type QueryRootCarpayTerminalNotificationConfigArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalNotificationConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalNotificationConfigOrderBy>>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};


export type QueryRootCarpayTerminalNotificationConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalNotificationConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalNotificationConfigOrderBy>>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};


export type QueryRootCarpayTerminalNotificationConfigByPkArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootCarpayTerminalPrinterStatusNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};


export type QueryRootCarpayTerminalPrinterStatusNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};


export type QueryRootCarpayTerminalPrinterStatusNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCarpayUserVerifiedPlateArgs = {
  distinct_on?: InputMaybe<Array<CarpayUserVerifiedPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayUserVerifiedPlateOrderBy>>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};


export type QueryRootCarpayUserVerifiedPlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayUserVerifiedPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayUserVerifiedPlateOrderBy>>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};


export type QueryRootCarpayUserVerifiedPlateByPkArgs = {
  normalized_plate: Scalars['String'];
  user_id: Scalars['uuid'];
};


export type QueryRootChainArgs = {
  distinct_on?: InputMaybe<Array<ChainSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChainOrderBy>>;
  where?: InputMaybe<ChainBoolExp>;
};


export type QueryRootChainAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChainSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChainOrderBy>>;
  where?: InputMaybe<ChainBoolExp>;
};


export type QueryRootChainByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCityCodesArgs = {
  distinct_on?: InputMaybe<Array<CityCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CityCodesOrderBy>>;
  where?: InputMaybe<CityCodesBoolExp>;
};


export type QueryRootCityCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CityCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CityCodesOrderBy>>;
  where?: InputMaybe<CityCodesBoolExp>;
};


export type QueryRootCompanyArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type QueryRootCompanyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type QueryRootCompanyByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCompanyConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<CompanyConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyConfigGroupOrderBy>>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};


export type QueryRootCompanyConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyConfigGroupOrderBy>>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};


export type QueryRootCompanyConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCompanyHierarchyArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


export type QueryRootCompanyHierarchyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


export type QueryRootCompanyHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCompanyLotSectionArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


export type QueryRootCompanyLotSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


export type QueryRootCompanyLotSectionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCompanyVatIdArgs = {
  distinct_on?: InputMaybe<Array<CompanyVatIdSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyVatIdOrderBy>>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};


export type QueryRootCompanyVatIdAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyVatIdSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyVatIdOrderBy>>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};


export type QueryRootCompanyVatIdByPkArgs = {
  company_id: Scalars['String'];
};


export type QueryRootCompanyViolatorArgs = {
  distinct_on?: InputMaybe<Array<CompanyViolatorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyViolatorOrderBy>>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};


export type QueryRootCompanyViolatorAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyViolatorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyViolatorOrderBy>>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};


export type QueryRootCompanyViolatorByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<ConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigGroupOrderBy>>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};


export type QueryRootConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigGroupOrderBy>>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};


export type QueryRootConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootCountryArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type QueryRootCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type QueryRootCountryByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootCreateDriverInformationRequestArgs = {
  id: Scalars['uuid'];
};


export type QueryRootCreateErrorRatePredictionRequestArgs = {
  initial_params?: InputMaybe<Scalars['jsonb']>;
  modified_params?: InputMaybe<Scalars['jsonb']>;
  parking_lot: Scalars['String'];
  station_name: Scalars['String'];
};


export type QueryRootCreateLotAnalysisRequestArgs = {
  parking_lot: Scalars['String'];
};


export type QueryRootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type QueryRootCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type QueryRootCurrencyByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootCustomerDashboardNpsFeedbackArgs = {
  distinct_on?: InputMaybe<Array<CustomerDashboardNpsFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomerDashboardNpsFeedbackOrderBy>>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};


export type QueryRootCustomerDashboardNpsFeedbackAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomerDashboardNpsFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomerDashboardNpsFeedbackOrderBy>>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};


export type QueryRootCustomerDashboardNpsFeedbackByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCustomerReadLpGroupsArgs = {
  filter?: InputMaybe<LicensePlateGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryRootDailyFailureArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


export type QueryRootDailyFailureAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


export type QueryRootDailyFailureByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDailyStatsArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


export type QueryRootDailyStatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


export type QueryRootDailyStatsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDecryptImageManualArgs = {
  images_encrypted: Scalars['String'];
};


export type QueryRootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type QueryRootDepartmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type QueryRootDepartmentByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootDetectionTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<DetectionTypeEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionTypeEnumOrderBy>>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};


export type QueryRootDetectionTypeEnumAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionTypeEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionTypeEnumOrderBy>>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};


export type QueryRootDetectionTypeEnumByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootDeviceArgs = {
  distinct_on?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type QueryRootDeviceAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type QueryRootDeviceByPkArgs = {
  uuid: Scalars['String'];
};


export type QueryRootDownloadLettersArgs = {
  where?: InputMaybe<DownloadLettersWhereFields>;
};


export type QueryRootEasyparkLotArgs = {
  distinct_on?: InputMaybe<Array<EasyparkLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkLotOrderBy>>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};


export type QueryRootEasyparkLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkLotOrderBy>>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};


export type QueryRootEasyparkLotByPkArgs = {
  uuid: Scalars['bigint'];
};


export type QueryRootEasyparkOrderArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


export type QueryRootEasyparkOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


export type QueryRootEasyparkOrderByPkArgs = {
  uuid: Scalars['bigint'];
};


export type QueryRootEasyparkOrderV2Args = {
  distinct_on?: InputMaybe<Array<EasyparkOrderV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderV2OrderBy>>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};


export type QueryRootEasyparkOrderV2AggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderV2OrderBy>>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};


export type QueryRootEasyparkOrderV2ByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootEasyparkParkingInfoArgs = {
  distinct_on?: InputMaybe<Array<EasyparkParkingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkParkingInfoOrderBy>>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};


export type QueryRootEasyparkParkingInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkParkingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkParkingInfoOrderBy>>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};


export type QueryRootEasyparkParkingInfoByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootEnforcementDailyStatsArgs = {
  distinct_on?: InputMaybe<Array<EnforcementDailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnforcementDailyStatsOrderBy>>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};


export type QueryRootEnforcementDailyStatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnforcementDailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnforcementDailyStatsOrderBy>>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};


export type QueryRootEnforcementDailyStatsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootEnumCarpayDiscountModelCodeTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeOrderBy>>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};


export type QueryRootEnumCarpayDiscountModelCodeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeOrderBy>>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};


export type QueryRootEnumCarpayDiscountModelCodeTypeByPkArgs = {
  code_type: Scalars['String'];
};


export type QueryRootEnumCountryCodeArgs = {
  distinct_on?: InputMaybe<Array<EnumCountryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCountryCodeOrderBy>>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};


export type QueryRootEnumCountryCodeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCountryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCountryCodeOrderBy>>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};


export type QueryRootEnumCountryCodeByPkArgs = {
  country: Scalars['String'];
};


export type QueryRootEnumCustomerWhitelistPurposeArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistPurposeOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};


export type QueryRootEnumCustomerWhitelistPurposeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistPurposeOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};


export type QueryRootEnumCustomerWhitelistPurposeByPkArgs = {
  purpose: Scalars['String'];
};


export type QueryRootEnumCustomerWhitelistStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};


export type QueryRootEnumCustomerWhitelistStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};


export type QueryRootEnumCustomerWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootEnumDeviceTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumDeviceTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDeviceTypeOrderBy>>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};


export type QueryRootEnumDeviceTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumDeviceTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDeviceTypeOrderBy>>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};


export type QueryRootEnumDeviceTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootEnumDriverRequestTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumDriverRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDriverRequestTypeOrderBy>>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};


export type QueryRootEnumDriverRequestTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumDriverRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDriverRequestTypeOrderBy>>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};


export type QueryRootEnumDriverRequestTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootEnumGuestJwtPurposeArgs = {
  distinct_on?: InputMaybe<Array<EnumGuestJwtPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumGuestJwtPurposeOrderBy>>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};


export type QueryRootEnumGuestJwtPurposeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumGuestJwtPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumGuestJwtPurposeOrderBy>>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};


export type QueryRootEnumGuestJwtPurposeByPkArgs = {
  purpose: Scalars['String'];
};


export type QueryRootEnumSupervisionMlpRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumSupervisionMlpRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumSupervisionMlpRequestStatusOrderBy>>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};


export type QueryRootEnumSupervisionMlpRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumSupervisionMlpRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumSupervisionMlpRequestStatusOrderBy>>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};


export type QueryRootEnumSupervisionMlpRequestStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootEnumViolationCancellationArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCancellationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCancellationOrderBy>>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};


export type QueryRootEnumViolationCancellationAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCancellationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCancellationOrderBy>>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};


export type QueryRootEnumViolationCancellationByPkArgs = {
  violation_cancellation: Scalars['String'];
};


export type QueryRootEnumViolationCaseChargesInvalidationReasonArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};


export type QueryRootEnumViolationCaseChargesInvalidationReasonAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};


export type QueryRootEnumViolationCaseChargesInvalidationReasonByPkArgs = {
  invalidation_reason: Scalars['String'];
};


export type QueryRootEnumViolationCaseChargesTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesTypeOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};


export type QueryRootEnumViolationCaseChargesTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesTypeOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};


export type QueryRootEnumViolationCaseChargesTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootEnumWhitelistPaidParkingTypesArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistPaidParkingTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistPaidParkingTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};


export type QueryRootEnumWhitelistPaidParkingTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistPaidParkingTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistPaidParkingTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};


export type QueryRootEnumWhitelistPaidParkingTypesByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootEnumWhitelistScopeArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistScopeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistScopeOrderBy>>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};


export type QueryRootEnumWhitelistScopeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistScopeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistScopeOrderBy>>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};


export type QueryRootEnumWhitelistScopeByPkArgs = {
  scope: Scalars['String'];
};


export type QueryRootEnumWhitelistStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};


export type QueryRootEnumWhitelistStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};


export type QueryRootEnumWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootEnumWhitelistTypesArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};


export type QueryRootEnumWhitelistTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};


export type QueryRootEnumWhitelistTypesByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootExportAccountingDataArgs = {
  accounting_type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  file_formats?: InputMaybe<Array<Scalars['String']>>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  months?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchAccountingDataArgs = {
  lot_ids: Array<Scalars['String']>;
  months: Array<Scalars['String']>;
};


export type QueryRootFetchAggregatedVisitsByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchBookingAccountingDataArgs = {
  lot_ids: Array<Scalars['String']>;
  months: Array<Scalars['String']>;
};


export type QueryRootFetchBookingDurationByTypeArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchBookingRevenueDailyArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  period: BookingAnalyticsPeriodType;
};


export type QueryRootFetchCancellationAggregateByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchCarpayRevenueByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchElectricAggregateByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchGroupedPaymentsByDurationArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchHourlyOccupancyByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchLetterUrlArgs = {
  where?: InputMaybe<FetchLetterUrlWhereFields>;
};


export type QueryRootFetchOccupancyByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchParkingDistributionByIntervalArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchTopCityCodesByDayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootFetchVisitsByWeekdayArgs = {
  datetime_end: Scalars['String'];
  datetime_start: Scalars['String'];
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootGeneratedIdViewArgs = {
  distinct_on?: InputMaybe<Array<GeneratedIdViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GeneratedIdViewOrderBy>>;
  where?: InputMaybe<GeneratedIdViewBoolExp>;
};


export type QueryRootGeneratedIdViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<GeneratedIdViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GeneratedIdViewOrderBy>>;
  where?: InputMaybe<GeneratedIdViewBoolExp>;
};


export type QueryRootGetBalenaDeviceArgs = {
  device_uuid: Scalars['String'];
};


export type QueryRootGetBalenaReleaseArgs = {
  release_id: Scalars['String'];
};


export type QueryRootGetBlacklistEntriesByPlateArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  is_limited?: InputMaybe<Scalars['Boolean']>;
  is_unlimited?: InputMaybe<Scalars['Boolean']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  plate: Scalars['String'];
  search_text?: InputMaybe<Scalars['String']>;
};


export type QueryRootGetDeviceDashboardUrlArgs = {
  dashboard_id: Scalars['Int'];
  params?: InputMaybe<Scalars['jsonb']>;
};


export type QueryRootGetDevicesByConfigArgs = {
  path: Array<Scalars['String']>;
  value: Scalars['String'];
};


export type QueryRootGetDriverInformationResponseArgs = {
  company_group: Scalars['String'];
};


export type QueryRootGetEnvParameterEndpointArgs = {
  parameter_name: Scalars['String'];
};


export type QueryRootGetHierarchyArgs = {
  company_id?: InputMaybe<Scalars['String']>;
  lot_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootGetLetterGeneratedCountArgs = {
  country_stage: Scalars['jsonb'];
};


export type QueryRootGetLetterGeneratedExamplesArgs = {
  country_stage: Scalars['jsonb'];
};


export type QueryRootGetLotCompaniesArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootGetLotImageUploadUrlArgs = {
  request: LotImageUploadUrlRequest;
};


export type QueryRootGetLotLegalEntitiesArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootGetLotTariffPricesArgs = {
  order_id: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
};


export type QueryRootGetNewViolationCasesFileArgs = {
  country: Scalars['String'];
};


export type QueryRootGetOveruseReportArgs = {
  datetime_end: Scalars['timestamptz'];
  datetime_start: Scalars['timestamptz'];
  lot_id: Scalars['String'];
};


export type QueryRootGetOveruseReportByDayArgs = {
  datetime_end: Scalars['timestamptz'];
  datetime_start: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  overuse_group_ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryRootGetOveruseReportByGroupArgs = {
  datetime_end: Scalars['timestamptz'];
  datetime_start: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  overuse_group_id: Scalars['Int'];
};


export type QueryRootGetPaidParkingClaimsArgs = {
  billable_duration?: InputMaybe<Scalars['float8']>;
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  timestamp_in: Scalars['timestamptz'];
  timestamp_out: Scalars['timestamptz'];
};


export type QueryRootGetPaidParkingClaimsV2Args = {
  claims: Array<GetPaidParkingClaimsV2Input>;
};


export type QueryRootGetPlateEventsArgs = {
  directions: Array<Scalars['String']>;
  parking_lot: Scalars['String'];
  plate: Scalars['String'];
};


export type QueryRootGetPotentialMlpsArgs = {
  lower_timestamp_threshold?: InputMaybe<Scalars['timestamptz']>;
};


export type QueryRootGetQueueLengthArgs = {
  queue_name: Scalars['String'];
};


export type QueryRootGetSmsStatusArgs = {
  device_uuid: Scalars['String'];
};


export type QueryRootGetSpecialLetterArgs = {
  mail_misc_id?: InputMaybe<Scalars['bigint']>;
};


export type QueryRootGetSpecialLetterPreviewArgs = {
  body?: InputMaybe<Array<Scalars['String']>>;
  language: Scalars['String'];
  template: Scalars['String'];
  violation_case_id: Scalars['bigint'];
};


export type QueryRootGetSystemImageArgs = {
  device_id?: InputMaybe<Scalars['Int']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  end_hour?: InputMaybe<Scalars['Int']>;
  expire_in_s?: InputMaybe<Scalars['Int']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  roi_image?: InputMaybe<Scalars['Boolean']>;
  start_hour?: InputMaybe<Scalars['Int']>;
};


export type QueryRootGetTemplateArgs = {
  language: Scalars['String'];
  template: Scalars['String'];
};


export type QueryRootGetUserInvoiceUrlArgs = {
  booking_id: Scalars['String'];
};


export type QueryRootGetViolationInfoArgs = {
  case_id: Scalars['String'];
  plate: Scalars['String'];
};


export type QueryRootGetWhitelistEntriesArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  is_limited?: InputMaybe<Scalars['Boolean']>;
  is_unlimited?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  reasons?: InputMaybe<Array<Scalars['String']>>;
  search_text?: InputMaybe<Scalars['String']>;
  user_ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRootGetWhitelistEntriesByPlateArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  is_limited?: InputMaybe<Scalars['Boolean']>;
  is_unlimited?: InputMaybe<Scalars['Boolean']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  plate: Scalars['String'];
  reasons?: InputMaybe<Array<Scalars['String']>>;
  search_text?: InputMaybe<Scalars['String']>;
};


export type QueryRootGroupBlacklistEntriesByPlateArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  is_limited?: InputMaybe<Scalars['Boolean']>;
  is_unlimited?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  offset: Scalars['Int'];
  search_text?: InputMaybe<Scalars['String']>;
};


export type QueryRootGroupWhitelistEntriesByPlateArgs = {
  company_ids?: InputMaybe<Array<Scalars['String']>>;
  is_limited?: InputMaybe<Scalars['Boolean']>;
  is_unlimited?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lot_ids?: InputMaybe<Array<Scalars['String']>>;
  offset: Scalars['Int'];
  reasons?: InputMaybe<Array<Scalars['String']>>;
  search_text?: InputMaybe<Scalars['String']>;
};


export type QueryRootGuestJwtArgs = {
  distinct_on?: InputMaybe<Array<GuestJwtSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestJwtOrderBy>>;
  where?: InputMaybe<GuestJwtBoolExp>;
};


export type QueryRootGuestJwtAggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestJwtSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestJwtOrderBy>>;
  where?: InputMaybe<GuestJwtBoolExp>;
};


export type QueryRootGuestJwtByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootGuestQrArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


export type QueryRootGuestQrAggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


export type QueryRootGuestQrByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootIsInternalUserArgs = {
  username: Scalars['String'];
};


export type QueryRootLotArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};


export type QueryRootLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};


export type QueryRootLotByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootLotConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<LotConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotConfigGroupOrderBy>>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};


export type QueryRootLotConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotConfigGroupOrderBy>>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};


export type QueryRootLotConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLotDisplayNameArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


export type QueryRootLotDisplayNameAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


export type QueryRootLotDisplayNameByPkArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootLotHierarchyArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


export type QueryRootLotHierarchyAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


export type QueryRootLotHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLotLegalEntityArgs = {
  distinct_on?: InputMaybe<Array<LotLegalEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotLegalEntityOrderBy>>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};


export type QueryRootLotLegalEntityAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotLegalEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotLegalEntityOrderBy>>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};


export type QueryRootLotLegalEntityByPkArgs = {
  lot_id: Scalars['String'];
  product: ParkdepotProductEnum;
};


export type QueryRootLotPolicyHistoryArgs = {
  distinct_on?: InputMaybe<Array<LotPolicyHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotPolicyHistoryOrderBy>>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};


export type QueryRootLotPolicyHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotPolicyHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotPolicyHistoryOrderBy>>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};


export type QueryRootLotPolicyHistoryByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLotSectionArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


export type QueryRootLotSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


export type QueryRootLotSectionByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootLpContingentArgs = {
  distinct_on?: InputMaybe<Array<LpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpContingentOrderBy>>;
  where?: InputMaybe<LpContingentBoolExp>;
};


export type QueryRootLpContingentAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpContingentOrderBy>>;
  where?: InputMaybe<LpContingentBoolExp>;
};


export type QueryRootLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLpGroupArgs = {
  distinct_on?: InputMaybe<Array<LpGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupOrderBy>>;
  where?: InputMaybe<LpGroupBoolExp>;
};


export type QueryRootLpGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupOrderBy>>;
  where?: InputMaybe<LpGroupBoolExp>;
};


export type QueryRootLpGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLpGroupConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<LpGroupConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupConfigGroupOrderBy>>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};


export type QueryRootLpGroupConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupConfigGroupOrderBy>>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};


export type QueryRootLpGroupConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLpGroupDetailsArgs = {
  distinct_on?: InputMaybe<Array<LpGroupDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupDetailsOrderBy>>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};


export type QueryRootLpGroupDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupDetailsOrderBy>>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};


export type QueryRootLpGroupDetailsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLpGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


export type QueryRootLpGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


export type QueryRootLpGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootLpGroupMemberDetailsArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberDetailsOrderBy>>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};


export type QueryRootLpGroupMemberDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberDetailsOrderBy>>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};


export type QueryRootLpGroupMemberDetailsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootMailArgs = {
  distinct_on?: InputMaybe<Array<MailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailOrderBy>>;
  where?: InputMaybe<MailBoolExp>;
};


export type QueryRootMailAggregateArgs = {
  distinct_on?: InputMaybe<Array<MailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailOrderBy>>;
  where?: InputMaybe<MailBoolExp>;
};


export type QueryRootMailByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootMailMiscArgs = {
  distinct_on?: InputMaybe<Array<MailMiscSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailMiscOrderBy>>;
  where?: InputMaybe<MailMiscBoolExp>;
};


export type QueryRootMailMiscAggregateArgs = {
  distinct_on?: InputMaybe<Array<MailMiscSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailMiscOrderBy>>;
  where?: InputMaybe<MailMiscBoolExp>;
};


export type QueryRootMailMiscByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootMergeCasesByLanguageArgs = {
  violation_cases: Array<Scalars['jsonb']>;
};


export type QueryRootMlpCasesArgs = {
  distinct_on?: InputMaybe<Array<MlpCasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpCasesOrderBy>>;
  where?: InputMaybe<MlpCasesBoolExp>;
};


export type QueryRootMlpCasesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MlpCasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpCasesOrderBy>>;
  where?: InputMaybe<MlpCasesBoolExp>;
};


export type QueryRootMlpCasesByPkArgs = {
  parking_results_uuid: Scalars['uuid'];
};


export type QueryRootMlpMappingsArgs = {
  distinct_on?: InputMaybe<Array<MlpMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpMappingsOrderBy>>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};


export type QueryRootMlpMappingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MlpMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpMappingsOrderBy>>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};


export type QueryRootMlpMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootMqttRequestArgs = {
  distinct_on?: InputMaybe<Array<MqttRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MqttRequestOrderBy>>;
  where?: InputMaybe<MqttRequestBoolExp>;
};


export type QueryRootMqttRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<MqttRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MqttRequestOrderBy>>;
  where?: InputMaybe<MqttRequestBoolExp>;
};


export type QueryRootMqttRequestByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootOffenceParkingEventsArgs = {
  distinct_on?: InputMaybe<Array<OffenceParkingEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceParkingEventsOrderBy>>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};


export type QueryRootOffenceParkingEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OffenceParkingEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceParkingEventsOrderBy>>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};


export type QueryRootOffenceParkingEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootOffenceTicketRequestsArgs = {
  distinct_on?: InputMaybe<Array<OffenceTicketRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceTicketRequestsOrderBy>>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};


export type QueryRootOffenceTicketRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OffenceTicketRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceTicketRequestsOrderBy>>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};


export type QueryRootOffenceTicketRequestsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootOveruseGroupArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupOrderBy>>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};


export type QueryRootOveruseGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupOrderBy>>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};


export type QueryRootOveruseGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootOveruseGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupMemberOrderBy>>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};


export type QueryRootOveruseGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupMemberOrderBy>>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};


export type QueryRootOveruseGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootParkdepotProductArgs = {
  distinct_on?: InputMaybe<Array<ParkdepotProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkdepotProductOrderBy>>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};


export type QueryRootParkdepotProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkdepotProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkdepotProductOrderBy>>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};


export type QueryRootParkdepotProductByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootParkingContextArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


export type QueryRootParkingContextAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


export type QueryRootParkingContextByPkArgs = {
  uuid: Scalars['uuid'];
};


export type QueryRootParkingDetectionsArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsOrderBy>>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};


export type QueryRootParkingDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsOrderBy>>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};


export type QueryRootParkingDetectionsArchiveArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsArchiveOrderBy>>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};


export type QueryRootParkingDetectionsArchiveAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsArchiveOrderBy>>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};


export type QueryRootParkingDetectionsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


export type QueryRootParkingDetectionsByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


export type QueryRootParkingIncomingArgs = {
  distinct_on?: InputMaybe<Array<ParkingIncomingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingIncomingOrderBy>>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};


export type QueryRootParkingIncomingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingIncomingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingIncomingOrderBy>>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};


export type QueryRootParkingIncomingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootParkingProcessingArgs = {
  distinct_on?: InputMaybe<Array<ParkingProcessingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingProcessingOrderBy>>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};


export type QueryRootParkingProcessingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingProcessingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingProcessingOrderBy>>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};


export type QueryRootParkingProcessingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootParkingResultsArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsOrderBy>>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};


export type QueryRootParkingResultsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsOrderBy>>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};


export type QueryRootParkingResultsArchiveArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsArchiveOrderBy>>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};


export type QueryRootParkingResultsArchiveAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsArchiveOrderBy>>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};


export type QueryRootParkingResultsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


export type QueryRootParkingResultsByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


export type QueryRootParkingTempArgs = {
  distinct_on?: InputMaybe<Array<ParkingTempSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingTempOrderBy>>;
  where?: InputMaybe<ParkingTempBoolExp>;
};


export type QueryRootParkingTempAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingTempSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingTempOrderBy>>;
  where?: InputMaybe<ParkingTempBoolExp>;
};


export type QueryRootParkingTempByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootPaybyphoneLotArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneLotOrderBy>>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};


export type QueryRootPaybyphoneLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneLotOrderBy>>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};


export type QueryRootPaybyphoneLotByPkArgs = {
  lot_id: Scalars['String'];
};


export type QueryRootPaybyphoneOrderArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneOrderOrderBy>>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};


export type QueryRootPaybyphoneOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneOrderOrderBy>>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};


export type QueryRootPaybyphoneOrderByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootPersonArgs = {
  distinct_on?: InputMaybe<Array<PersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonOrderBy>>;
  where?: InputMaybe<PersonBoolExp>;
};


export type QueryRootPersonAggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonOrderBy>>;
  where?: InputMaybe<PersonBoolExp>;
};


export type QueryRootPersonByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootPolicyScheduleArgs = {
  distinct_on?: InputMaybe<Array<PolicyScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyScheduleOrderBy>>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};


export type QueryRootPolicyScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyScheduleOrderBy>>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};


export type QueryRootPolicyScheduleByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootRegionalCodesAustriaArgs = {
  distinct_on?: InputMaybe<Array<RegionalCodesAustriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionalCodesAustriaOrderBy>>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};


export type QueryRootRegionalCodesAustriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionalCodesAustriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionalCodesAustriaOrderBy>>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};


export type QueryRootRegionalCodesAustriaByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootRentalPricingArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


export type QueryRootRentalPricingAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


export type QueryRootRentalPricingByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootRentalSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


export type QueryRootRentalSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


export type QueryRootRentalSubscriptionByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootRepeatOffenseViewArgs = {
  distinct_on?: InputMaybe<Array<RepeatOffenseViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatOffenseViewOrderBy>>;
  where?: InputMaybe<RepeatOffenseViewBoolExp>;
};


export type QueryRootRepeatOffenseViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatOffenseViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatOffenseViewOrderBy>>;
  where?: InputMaybe<RepeatOffenseViewBoolExp>;
};


export type QueryRootSendCarOwnerRequestsGermanyArgs = {
  id: Scalars['uuid'];
};


export type QueryRootSendInvoiceArgs = {
  carpay_order_order_id: Scalars['String'];
  customer_email: Scalars['String'];
};


export type QueryRootServerlessAsyncWorkArgs = {
  distinct_on?: InputMaybe<Array<ServerlessAsyncWorkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerlessAsyncWorkOrderBy>>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};


export type QueryRootServerlessAsyncWorkAggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerlessAsyncWorkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerlessAsyncWorkOrderBy>>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};


export type QueryRootServerlessAsyncWorkByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootSetDeviceForceUpdateArgs = {
  device_uuid: Scalars['String'];
};


export type QueryRootSimilarDetectionsArgs = {
  distinct_on?: InputMaybe<Array<SimilarDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SimilarDetectionsOrderBy>>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};


export type QueryRootSimilarDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SimilarDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SimilarDetectionsOrderBy>>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};


export type QueryRootSimilarDetectionsByPkArgs = {
  parking_detections_uuid: Scalars['uuid'];
};


export type QueryRootStagesArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


export type QueryRootStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


export type QueryRootStagesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootStartGenerationOfSpecialLettersArgs = {
  id: Scalars['uuid'];
};


export type QueryRootStationArgs = {
  distinct_on?: InputMaybe<Array<StationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StationOrderBy>>;
  where?: InputMaybe<StationBoolExp>;
};


export type QueryRootStationAggregateArgs = {
  distinct_on?: InputMaybe<Array<StationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StationOrderBy>>;
  where?: InputMaybe<StationBoolExp>;
};


export type QueryRootStationByPkArgs = {
  station_name: Scalars['String'];
};


export type QueryRootSupervisionCarRentalPartnersArgs = {
  distinct_on?: InputMaybe<Array<SupervisionCarRentalPartnersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionCarRentalPartnersOrderBy>>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};


export type QueryRootSupervisionCarRentalPartnersAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionCarRentalPartnersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionCarRentalPartnersOrderBy>>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};


export type QueryRootSupervisionCarRentalPartnersByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSupervisionDebtCollectionCaseArgs = {
  distinct_on?: InputMaybe<Array<SupervisionDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};


export type QueryRootSupervisionDebtCollectionCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};


export type QueryRootSupervisionDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionImageRequestsArgs = {
  distinct_on?: InputMaybe<Array<SupervisionImageRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionImageRequestsOrderBy>>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};


export type QueryRootSupervisionImageRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionImageRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionImageRequestsOrderBy>>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};


export type QueryRootSupervisionImageRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionMlpRequestsArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMlpRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMlpRequestsOrderBy>>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};


export type QueryRootSupervisionMlpRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMlpRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMlpRequestsOrderBy>>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};


export type QueryRootSupervisionMlpRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionMultivisitOffenderGroupArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};


export type QueryRootSupervisionMultivisitOffenderGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};


export type QueryRootSupervisionMultivisitOffenderGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionMultivisitOffenderGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};


export type QueryRootSupervisionMultivisitOffenderGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};


export type QueryRootSupervisionMultivisitOffenderGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionTicketRequestArgs = {
  distinct_on?: InputMaybe<Array<SupervisionTicketRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionTicketRequestOrderBy>>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};


export type QueryRootSupervisionTicketRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionTicketRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionTicketRequestOrderBy>>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};


export type QueryRootSupervisionTicketRequestByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSupervisionViolationCaseDebtCollectionCaseArgs = {
  distinct_on?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};


export type QueryRootSupervisionViolationCaseDebtCollectionCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};


export type QueryRootSupervisionViolationCaseDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSyncDeviceDiffConfigArgs = {
  device_uuid: Scalars['String'];
  diff_config?: InputMaybe<Scalars['json']>;
};


export type QueryRootTaxArgs = {
  distinct_on?: InputMaybe<Array<TaxSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxOrderBy>>;
  where?: InputMaybe<TaxBoolExp>;
};


export type QueryRootTaxAggregateArgs = {
  distinct_on?: InputMaybe<Array<TaxSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxOrderBy>>;
  where?: InputMaybe<TaxBoolExp>;
};


export type QueryRootTaxByPkArgs = {
  uuid: Scalars['Int'];
};


export type QueryRootTerminalStatusArgs = {
  distinct_on?: InputMaybe<Array<TerminalStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TerminalStatusOrderBy>>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};


export type QueryRootTerminalStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<TerminalStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TerminalStatusOrderBy>>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};


export type QueryRootTerminalStatusByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTicketWebsiteFeedbackArgs = {
  distinct_on?: InputMaybe<Array<TicketWebsiteFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TicketWebsiteFeedbackOrderBy>>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};


export type QueryRootTicketWebsiteFeedbackAggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketWebsiteFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TicketWebsiteFeedbackOrderBy>>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};


export type QueryRootTicketWebsiteFeedbackByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootTimeDiscountArgs = {
  distinct_on?: InputMaybe<Array<TimeDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TimeDiscountOrderBy>>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};


export type QueryRootTimeDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TimeDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TimeDiscountOrderBy>>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};


export type QueryRootTimeDiscountByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootUpdateAndPushMlpCasesArgs = {
  cases: Array<Scalars['jsonb']>;
};


export type QueryRootUpdateDeviceConfigArgs = {
  device_uuid: Scalars['String'];
  diff_config: Scalars['json'];
  timestamp: Scalars['String'];
};


export type QueryRootUpdateStationConfigArgs = {
  config: Scalars['json'];
  station_name: Scalars['String'];
  timestamp: Scalars['String'];
};


export type QueryRootUpdateStationDataArgs = {
  device_direction: Scalars['String'];
  device_uuid?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  station_name: Scalars['String'];
};


export type QueryRootUserPreferenceArgs = {
  distinct_on?: InputMaybe<Array<UserPreferenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPreferenceOrderBy>>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};


export type QueryRootUserPreferenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPreferenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPreferenceOrderBy>>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};


export type QueryRootUserPreferenceByPkArgs = {
  user_id: Scalars['String'];
};


export type QueryRootVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeOrderBy>>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};


export type QueryRootVehicleTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeOrderBy>>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};


export type QueryRootVehicleTypeByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootVehicleTypeConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeConfigGroupOrderBy>>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};


export type QueryRootVehicleTypeConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeConfigGroupOrderBy>>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};


export type QueryRootVehicleTypeConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootViolationCaseArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


export type QueryRootViolationCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


export type QueryRootViolationCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootViolationCaseChargesArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


export type QueryRootViolationCaseChargesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


export type QueryRootViolationCaseChargesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootViolationCaseTagsArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseTagsOrderBy>>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};


export type QueryRootViolationCaseTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseTagsOrderBy>>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};


export type QueryRootViolationCaseTagsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootViolationEventAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ViolationEventAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationEventAnalysisOrderBy>>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};


export type QueryRootViolationEventAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationEventAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationEventAnalysisOrderBy>>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};


export type QueryRootViolationEventAnalysisByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootViolatorImageArgs = {
  lot: Scalars['String'];
  plate: Scalars['String'];
  station: Scalars['Int'];
  timestamp: Scalars['timestamp'];
  type: Scalars['String'];
};


export type QueryRootViolatorTransactionsArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


export type QueryRootViolatorTransactionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


export type QueryRootViolatorTransactionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootWhitelistArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


export type QueryRootWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


export type QueryRootWhitelistAppliedPermitArgs = {
  distinct_on?: InputMaybe<Array<WhitelistAppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistAppliedPermitOrderBy>>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};


export type QueryRootWhitelistAppliedPermitAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistAppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistAppliedPermitOrderBy>>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};


export type QueryRootWhitelistAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootWhitelistByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootWhitelistByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<WhitelistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistByPlateViewBoolExp>;
};


export type QueryRootWhitelistByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistByPlateViewBoolExp>;
};


export type QueryRootWhitelistCalendarEventPolicyArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


export type QueryRootWhitelistCalendarEventPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


export type QueryRootWhitelistCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootWhitelistGuestByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<WhitelistGuestByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistGuestByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
};


export type QueryRootWhitelistGuestByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistGuestByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistGuestByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
};


export type QueryRootWhitelistLpContingentArgs = {
  distinct_on?: InputMaybe<Array<WhitelistLpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistLpContingentOrderBy>>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};


export type QueryRootWhitelistLpContingentAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistLpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistLpContingentOrderBy>>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};


export type QueryRootWhitelistLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootWhitelistPaidParkingArgs = {
  distinct_on?: InputMaybe<Array<WhitelistPaidParkingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistPaidParkingOrderBy>>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};


export type QueryRootWhitelistPaidParkingAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistPaidParkingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistPaidParkingOrderBy>>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};


export type QueryRootWhitelistPaidParkingByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootWhitelistSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


export type QueryRootWhitelistSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


export type QueryRootWhitelistSubscriptionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootWireguardConfigArgs = {
  distinct_on?: InputMaybe<Array<WireguardConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WireguardConfigOrderBy>>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};


export type QueryRootWireguardConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<WireguardConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WireguardConfigOrderBy>>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};


export type QueryRootWireguardConfigByPkArgs = {
  public_key: Scalars['String'];
};

/** columns and relationships of "regional_codes_austria" */
export type RegionalCodesAustria = {
  __typename?: 'regional_codes_austria';
  id: Scalars['Int'];
  region: Scalars['String'];
  regional_code: Scalars['String'];
  state: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "regional_codes_austria" */
export type RegionalCodesAustriaAggregate = {
  __typename?: 'regional_codes_austria_aggregate';
  aggregate?: Maybe<RegionalCodesAustriaAggregateFields>;
  nodes: Array<RegionalCodesAustria>;
};

/** aggregate fields of "regional_codes_austria" */
export type RegionalCodesAustriaAggregateFields = {
  __typename?: 'regional_codes_austria_aggregate_fields';
  avg?: Maybe<RegionalCodesAustriaAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RegionalCodesAustriaMaxFields>;
  min?: Maybe<RegionalCodesAustriaMinFields>;
  stddev?: Maybe<RegionalCodesAustriaStddevFields>;
  stddev_pop?: Maybe<RegionalCodesAustriaStddevPopFields>;
  stddev_samp?: Maybe<RegionalCodesAustriaStddevSampFields>;
  sum?: Maybe<RegionalCodesAustriaSumFields>;
  var_pop?: Maybe<RegionalCodesAustriaVarPopFields>;
  var_samp?: Maybe<RegionalCodesAustriaVarSampFields>;
  variance?: Maybe<RegionalCodesAustriaVarianceFields>;
};


/** aggregate fields of "regional_codes_austria" */
export type RegionalCodesAustriaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RegionalCodesAustriaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RegionalCodesAustriaAvgFields = {
  __typename?: 'regional_codes_austria_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "regional_codes_austria". All fields are combined with a logical 'AND'. */
export type RegionalCodesAustriaBoolExp = {
  _and?: InputMaybe<Array<RegionalCodesAustriaBoolExp>>;
  _not?: InputMaybe<RegionalCodesAustriaBoolExp>;
  _or?: InputMaybe<Array<RegionalCodesAustriaBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  regional_code?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "regional_codes_austria" */
export enum RegionalCodesAustriaConstraint {
  /** unique or primary key constraint on columns "id" */
  RegionalCodesAustriaPkey = 'regional_codes_austria_pkey',
  /** unique or primary key constraint on columns "regional_code" */
  RegionalCodesAustriaRegionalCodeKey = 'regional_codes_austria_regional_code_key'
}

/** input type for incrementing numeric columns in table "regional_codes_austria" */
export type RegionalCodesAustriaIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "regional_codes_austria" */
export type RegionalCodesAustriaInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  regional_code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RegionalCodesAustriaMaxFields = {
  __typename?: 'regional_codes_austria_max_fields';
  id?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  regional_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RegionalCodesAustriaMinFields = {
  __typename?: 'regional_codes_austria_min_fields';
  id?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  regional_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "regional_codes_austria" */
export type RegionalCodesAustriaMutationResponse = {
  __typename?: 'regional_codes_austria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RegionalCodesAustria>;
};

/** on_conflict condition type for table "regional_codes_austria" */
export type RegionalCodesAustriaOnConflict = {
  constraint: RegionalCodesAustriaConstraint;
  update_columns?: Array<RegionalCodesAustriaUpdateColumn>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};

/** Ordering options when selecting data from "regional_codes_austria". */
export type RegionalCodesAustriaOrderBy = {
  id?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  regional_code?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: regional_codes_austria */
export type RegionalCodesAustriaPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "regional_codes_austria" */
export enum RegionalCodesAustriaSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  RegionalCode = 'regional_code',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "regional_codes_austria" */
export type RegionalCodesAustriaSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  regional_code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RegionalCodesAustriaStddevFields = {
  __typename?: 'regional_codes_austria_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RegionalCodesAustriaStddevPopFields = {
  __typename?: 'regional_codes_austria_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RegionalCodesAustriaStddevSampFields = {
  __typename?: 'regional_codes_austria_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "regional_codes_austria" */
export type RegionalCodesAustriaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RegionalCodesAustriaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegionalCodesAustriaStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  regional_code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RegionalCodesAustriaSumFields = {
  __typename?: 'regional_codes_austria_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "regional_codes_austria" */
export enum RegionalCodesAustriaUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  RegionalCode = 'regional_code',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type RegionalCodesAustriaUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RegionalCodesAustriaIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegionalCodesAustriaSetInput>;
  /** filter the rows which have to be updated */
  where: RegionalCodesAustriaBoolExp;
};

/** aggregate var_pop on columns */
export type RegionalCodesAustriaVarPopFields = {
  __typename?: 'regional_codes_austria_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RegionalCodesAustriaVarSampFields = {
  __typename?: 'regional_codes_austria_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RegionalCodesAustriaVarianceFields = {
  __typename?: 'regional_codes_austria_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "rental_pricing" */
export type RentalPricing = {
  __typename?: 'rental_pricing';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  lot: Lot;
  lot_id: Scalars['String'];
  price_category?: Maybe<Scalars['String']>;
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing: Scalars['jsonb'];
};


/** columns and relationships of "rental_pricing" */
export type RentalPricingPricingArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rental_pricing" */
export type RentalPricingAggregate = {
  __typename?: 'rental_pricing_aggregate';
  aggregate?: Maybe<RentalPricingAggregateFields>;
  nodes: Array<RentalPricing>;
};

export type RentalPricingAggregateBoolExp = {
  count?: InputMaybe<RentalPricingAggregateBoolExpCount>;
};

export type RentalPricingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RentalPricingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RentalPricingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rental_pricing" */
export type RentalPricingAggregateFields = {
  __typename?: 'rental_pricing_aggregate_fields';
  avg?: Maybe<RentalPricingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RentalPricingMaxFields>;
  min?: Maybe<RentalPricingMinFields>;
  stddev?: Maybe<RentalPricingStddevFields>;
  stddev_pop?: Maybe<RentalPricingStddevPopFields>;
  stddev_samp?: Maybe<RentalPricingStddevSampFields>;
  sum?: Maybe<RentalPricingSumFields>;
  var_pop?: Maybe<RentalPricingVarPopFields>;
  var_samp?: Maybe<RentalPricingVarSampFields>;
  variance?: Maybe<RentalPricingVarianceFields>;
};


/** aggregate fields of "rental_pricing" */
export type RentalPricingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RentalPricingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rental_pricing" */
export type RentalPricingAggregateOrderBy = {
  avg?: InputMaybe<RentalPricingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RentalPricingMaxOrderBy>;
  min?: InputMaybe<RentalPricingMinOrderBy>;
  stddev?: InputMaybe<RentalPricingStddevOrderBy>;
  stddev_pop?: InputMaybe<RentalPricingStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RentalPricingStddevSampOrderBy>;
  sum?: InputMaybe<RentalPricingSumOrderBy>;
  var_pop?: InputMaybe<RentalPricingVarPopOrderBy>;
  var_samp?: InputMaybe<RentalPricingVarSampOrderBy>;
  variance?: InputMaybe<RentalPricingVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RentalPricingAppendInput = {
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "rental_pricing" */
export type RentalPricingArrRelInsertInput = {
  data: Array<RentalPricingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RentalPricingOnConflict>;
};

/** aggregate avg on columns */
export type RentalPricingAvgFields = {
  __typename?: 'rental_pricing_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "rental_pricing" */
export type RentalPricingAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "rental_pricing". All fields are combined with a logical 'AND'. */
export type RentalPricingBoolExp = {
  _and?: InputMaybe<Array<RentalPricingBoolExp>>;
  _not?: InputMaybe<RentalPricingBoolExp>;
  _or?: InputMaybe<Array<RentalPricingBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  price_category?: InputMaybe<StringComparisonExp>;
  pricing?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "rental_pricing" */
export enum RentalPricingConstraint {
  /** unique or primary key constraint on columns "id" */
  RentalPricingIdKey = 'rental_pricing_id_key',
  /** unique or primary key constraint on columns "lot_id" */
  RentalPricingLotIdKey = 'rental_pricing_lot_id_key',
  /** unique or primary key constraint on columns "id" */
  RentalPricingPkey = 'rental_pricing_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RentalPricingDeleteAtPathInput = {
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RentalPricingDeleteElemInput = {
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RentalPricingDeleteKeyInput = {
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "rental_pricing" */
export type RentalPricingIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "rental_pricing" */
export type RentalPricingInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  price_category?: InputMaybe<Scalars['String']>;
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type RentalPricingMaxFields = {
  __typename?: 'rental_pricing_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  price_category?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "rental_pricing" */
export type RentalPricingMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  price_category?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RentalPricingMinFields = {
  __typename?: 'rental_pricing_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  price_category?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "rental_pricing" */
export type RentalPricingMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  price_category?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rental_pricing" */
export type RentalPricingMutationResponse = {
  __typename?: 'rental_pricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RentalPricing>;
};

/** on_conflict condition type for table "rental_pricing" */
export type RentalPricingOnConflict = {
  constraint: RentalPricingConstraint;
  update_columns?: Array<RentalPricingUpdateColumn>;
  where?: InputMaybe<RentalPricingBoolExp>;
};

/** Ordering options when selecting data from "rental_pricing". */
export type RentalPricingOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  price_category?: InputMaybe<OrderBy>;
  pricing?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rental_pricing */
export type RentalPricingPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RentalPricingPrependInput = {
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rental_pricing" */
export enum RentalPricingSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PriceCategory = 'price_category',
  /** column name */
  Pricing = 'pricing'
}

/** input type for updating data in table "rental_pricing" */
export type RentalPricingSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  price_category?: InputMaybe<Scalars['String']>;
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type RentalPricingStddevFields = {
  __typename?: 'rental_pricing_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "rental_pricing" */
export type RentalPricingStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RentalPricingStddevPopFields = {
  __typename?: 'rental_pricing_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "rental_pricing" */
export type RentalPricingStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RentalPricingStddevSampFields = {
  __typename?: 'rental_pricing_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "rental_pricing" */
export type RentalPricingStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "rental_pricing" */
export type RentalPricingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RentalPricingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RentalPricingStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  price_category?: InputMaybe<Scalars['String']>;
  /** Each entry of the dicitonary holds a key which represents a time interval in minutes that is priced with the corresponding value in Euro. Each key hereby represents an upper price limit to the lower key. */
  pricing?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type RentalPricingSumFields = {
  __typename?: 'rental_pricing_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "rental_pricing" */
export type RentalPricingSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "rental_pricing" */
export enum RentalPricingUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PriceCategory = 'price_category',
  /** column name */
  Pricing = 'pricing'
}

export type RentalPricingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RentalPricingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RentalPricingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RentalPricingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RentalPricingDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RentalPricingIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RentalPricingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RentalPricingSetInput>;
  /** filter the rows which have to be updated */
  where: RentalPricingBoolExp;
};

/** aggregate var_pop on columns */
export type RentalPricingVarPopFields = {
  __typename?: 'rental_pricing_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "rental_pricing" */
export type RentalPricingVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RentalPricingVarSampFields = {
  __typename?: 'rental_pricing_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "rental_pricing" */
export type RentalPricingVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RentalPricingVarianceFields = {
  __typename?: 'rental_pricing_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "rental_pricing" */
export type RentalPricingVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "rental_subscription" */
export type RentalSubscription = {
  __typename?: 'rental_subscription';
  booked_at: Scalars['timestamptz'];
  booking_external_ref?: Maybe<Scalars['String']>;
  booking_internal_ref?: Maybe<Scalars['String']>;
  booking_platform: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  payment_method?: Maybe<Scalars['String']>;
  payment_ref?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  status: Scalars['String'];
  /** An object relationship */
  whitelist: Whitelist;
  whitelist_id: Scalars['Int'];
};

/** aggregated selection of "rental_subscription" */
export type RentalSubscriptionAggregate = {
  __typename?: 'rental_subscription_aggregate';
  aggregate?: Maybe<RentalSubscriptionAggregateFields>;
  nodes: Array<RentalSubscription>;
};

export type RentalSubscriptionAggregateBoolExp = {
  count?: InputMaybe<RentalSubscriptionAggregateBoolExpCount>;
};

export type RentalSubscriptionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RentalSubscriptionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rental_subscription" */
export type RentalSubscriptionAggregateFields = {
  __typename?: 'rental_subscription_aggregate_fields';
  avg?: Maybe<RentalSubscriptionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RentalSubscriptionMaxFields>;
  min?: Maybe<RentalSubscriptionMinFields>;
  stddev?: Maybe<RentalSubscriptionStddevFields>;
  stddev_pop?: Maybe<RentalSubscriptionStddevPopFields>;
  stddev_samp?: Maybe<RentalSubscriptionStddevSampFields>;
  sum?: Maybe<RentalSubscriptionSumFields>;
  var_pop?: Maybe<RentalSubscriptionVarPopFields>;
  var_samp?: Maybe<RentalSubscriptionVarSampFields>;
  variance?: Maybe<RentalSubscriptionVarianceFields>;
};


/** aggregate fields of "rental_subscription" */
export type RentalSubscriptionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rental_subscription" */
export type RentalSubscriptionAggregateOrderBy = {
  avg?: InputMaybe<RentalSubscriptionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RentalSubscriptionMaxOrderBy>;
  min?: InputMaybe<RentalSubscriptionMinOrderBy>;
  stddev?: InputMaybe<RentalSubscriptionStddevOrderBy>;
  stddev_pop?: InputMaybe<RentalSubscriptionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RentalSubscriptionStddevSampOrderBy>;
  sum?: InputMaybe<RentalSubscriptionSumOrderBy>;
  var_pop?: InputMaybe<RentalSubscriptionVarPopOrderBy>;
  var_samp?: InputMaybe<RentalSubscriptionVarSampOrderBy>;
  variance?: InputMaybe<RentalSubscriptionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "rental_subscription" */
export type RentalSubscriptionArrRelInsertInput = {
  data: Array<RentalSubscriptionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RentalSubscriptionOnConflict>;
};

/** aggregate avg on columns */
export type RentalSubscriptionAvgFields = {
  __typename?: 'rental_subscription_avg_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "rental_subscription" */
export type RentalSubscriptionAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "rental_subscription". All fields are combined with a logical 'AND'. */
export type RentalSubscriptionBoolExp = {
  _and?: InputMaybe<Array<RentalSubscriptionBoolExp>>;
  _not?: InputMaybe<RentalSubscriptionBoolExp>;
  _or?: InputMaybe<Array<RentalSubscriptionBoolExp>>;
  booked_at?: InputMaybe<TimestamptzComparisonExp>;
  booking_external_ref?: InputMaybe<StringComparisonExp>;
  booking_internal_ref?: InputMaybe<StringComparisonExp>;
  booking_platform?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  payment_method?: InputMaybe<StringComparisonExp>;
  payment_ref?: InputMaybe<StringComparisonExp>;
  price?: InputMaybe<FloatComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  whitelist?: InputMaybe<WhitelistBoolExp>;
  whitelist_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "rental_subscription" */
export enum RentalSubscriptionConstraint {
  /** unique or primary key constraint on columns "id" */
  RentalSubscriptionPkey = 'rental_subscription_pkey'
}

/** input type for incrementing numeric columns in table "rental_subscription" */
export type RentalSubscriptionIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['Float']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rental_subscription" */
export type RentalSubscriptionInsertInput = {
  booked_at?: InputMaybe<Scalars['timestamptz']>;
  booking_external_ref?: InputMaybe<Scalars['String']>;
  booking_internal_ref?: InputMaybe<Scalars['String']>;
  booking_platform?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_ref?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  whitelist?: InputMaybe<WhitelistObjRelInsertInput>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type RentalSubscriptionMaxFields = {
  __typename?: 'rental_subscription_max_fields';
  booked_at?: Maybe<Scalars['timestamptz']>;
  booking_external_ref?: Maybe<Scalars['String']>;
  booking_internal_ref?: Maybe<Scalars['String']>;
  booking_platform?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  payment_method?: Maybe<Scalars['String']>;
  payment_ref?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "rental_subscription" */
export type RentalSubscriptionMaxOrderBy = {
  booked_at?: InputMaybe<OrderBy>;
  booking_external_ref?: InputMaybe<OrderBy>;
  booking_internal_ref?: InputMaybe<OrderBy>;
  booking_platform?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_ref?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RentalSubscriptionMinFields = {
  __typename?: 'rental_subscription_min_fields';
  booked_at?: Maybe<Scalars['timestamptz']>;
  booking_external_ref?: Maybe<Scalars['String']>;
  booking_internal_ref?: Maybe<Scalars['String']>;
  booking_platform?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  payment_method?: Maybe<Scalars['String']>;
  payment_ref?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "rental_subscription" */
export type RentalSubscriptionMinOrderBy = {
  booked_at?: InputMaybe<OrderBy>;
  booking_external_ref?: InputMaybe<OrderBy>;
  booking_internal_ref?: InputMaybe<OrderBy>;
  booking_platform?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_ref?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rental_subscription" */
export type RentalSubscriptionMutationResponse = {
  __typename?: 'rental_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RentalSubscription>;
};

/** on_conflict condition type for table "rental_subscription" */
export type RentalSubscriptionOnConflict = {
  constraint: RentalSubscriptionConstraint;
  update_columns?: Array<RentalSubscriptionUpdateColumn>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};

/** Ordering options when selecting data from "rental_subscription". */
export type RentalSubscriptionOrderBy = {
  booked_at?: InputMaybe<OrderBy>;
  booking_external_ref?: InputMaybe<OrderBy>;
  booking_internal_ref?: InputMaybe<OrderBy>;
  booking_platform?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payment_method?: InputMaybe<OrderBy>;
  payment_ref?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  whitelist?: InputMaybe<WhitelistOrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rental_subscription */
export type RentalSubscriptionPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "rental_subscription" */
export enum RentalSubscriptionSelectColumn {
  /** column name */
  BookedAt = 'booked_at',
  /** column name */
  BookingExternalRef = 'booking_external_ref',
  /** column name */
  BookingInternalRef = 'booking_internal_ref',
  /** column name */
  BookingPlatform = 'booking_platform',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentRef = 'payment_ref',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "rental_subscription" */
export type RentalSubscriptionSetInput = {
  booked_at?: InputMaybe<Scalars['timestamptz']>;
  booking_external_ref?: InputMaybe<Scalars['String']>;
  booking_internal_ref?: InputMaybe<Scalars['String']>;
  booking_platform?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_ref?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type RentalSubscriptionStddevFields = {
  __typename?: 'rental_subscription_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "rental_subscription" */
export type RentalSubscriptionStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RentalSubscriptionStddevPopFields = {
  __typename?: 'rental_subscription_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "rental_subscription" */
export type RentalSubscriptionStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RentalSubscriptionStddevSampFields = {
  __typename?: 'rental_subscription_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "rental_subscription" */
export type RentalSubscriptionStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "rental_subscription" */
export type RentalSubscriptionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RentalSubscriptionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RentalSubscriptionStreamCursorValueInput = {
  booked_at?: InputMaybe<Scalars['timestamptz']>;
  booking_external_ref?: InputMaybe<Scalars['String']>;
  booking_internal_ref?: InputMaybe<Scalars['String']>;
  booking_platform?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_method?: InputMaybe<Scalars['String']>;
  payment_ref?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type RentalSubscriptionSumFields = {
  __typename?: 'rental_subscription_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "rental_subscription" */
export type RentalSubscriptionSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** update columns of table "rental_subscription" */
export enum RentalSubscriptionUpdateColumn {
  /** column name */
  BookedAt = 'booked_at',
  /** column name */
  BookingExternalRef = 'booking_external_ref',
  /** column name */
  BookingInternalRef = 'booking_internal_ref',
  /** column name */
  BookingPlatform = 'booking_platform',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentRef = 'payment_ref',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type RentalSubscriptionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RentalSubscriptionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RentalSubscriptionSetInput>;
  /** filter the rows which have to be updated */
  where: RentalSubscriptionBoolExp;
};

/** aggregate var_pop on columns */
export type RentalSubscriptionVarPopFields = {
  __typename?: 'rental_subscription_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "rental_subscription" */
export type RentalSubscriptionVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RentalSubscriptionVarSampFields = {
  __typename?: 'rental_subscription_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "rental_subscription" */
export type RentalSubscriptionVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RentalSubscriptionVarianceFields = {
  __typename?: 'rental_subscription_variance_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "rental_subscription" */
export type RentalSubscriptionVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "repeat_offense_view" */
export type RepeatOffenseView = {
  __typename?: 'repeat_offense_view';
  id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "repeat_offense_view" */
export type RepeatOffenseViewAggregate = {
  __typename?: 'repeat_offense_view_aggregate';
  aggregate?: Maybe<RepeatOffenseViewAggregateFields>;
  nodes: Array<RepeatOffenseView>;
};

/** aggregate fields of "repeat_offense_view" */
export type RepeatOffenseViewAggregateFields = {
  __typename?: 'repeat_offense_view_aggregate_fields';
  avg?: Maybe<RepeatOffenseViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RepeatOffenseViewMaxFields>;
  min?: Maybe<RepeatOffenseViewMinFields>;
  stddev?: Maybe<RepeatOffenseViewStddevFields>;
  stddev_pop?: Maybe<RepeatOffenseViewStddevPopFields>;
  stddev_samp?: Maybe<RepeatOffenseViewStddevSampFields>;
  sum?: Maybe<RepeatOffenseViewSumFields>;
  var_pop?: Maybe<RepeatOffenseViewVarPopFields>;
  var_samp?: Maybe<RepeatOffenseViewVarSampFields>;
  variance?: Maybe<RepeatOffenseViewVarianceFields>;
};


/** aggregate fields of "repeat_offense_view" */
export type RepeatOffenseViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepeatOffenseViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RepeatOffenseViewAvgFields = {
  __typename?: 'repeat_offense_view_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "repeat_offense_view". All fields are combined with a logical 'AND'. */
export type RepeatOffenseViewBoolExp = {
  _and?: InputMaybe<Array<RepeatOffenseViewBoolExp>>;
  _not?: InputMaybe<RepeatOffenseViewBoolExp>;
  _or?: InputMaybe<Array<RepeatOffenseViewBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type RepeatOffenseViewMaxFields = {
  __typename?: 'repeat_offense_view_max_fields';
  id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RepeatOffenseViewMinFields = {
  __typename?: 'repeat_offense_view_min_fields';
  id?: Maybe<Scalars['bigint']>;
  plate?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "repeat_offense_view". */
export type RepeatOffenseViewOrderBy = {
  id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
};

/** select columns of table "repeat_offense_view" */
export enum RepeatOffenseViewSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Plate = 'plate',
  /** column name */
  TimestampIn = 'timestamp_in'
}

/** aggregate stddev on columns */
export type RepeatOffenseViewStddevFields = {
  __typename?: 'repeat_offense_view_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RepeatOffenseViewStddevPopFields = {
  __typename?: 'repeat_offense_view_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RepeatOffenseViewStddevSampFields = {
  __typename?: 'repeat_offense_view_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "repeat_offense_view" */
export type RepeatOffenseViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RepeatOffenseViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepeatOffenseViewStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RepeatOffenseViewSumFields = {
  __typename?: 'repeat_offense_view_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type RepeatOffenseViewVarPopFields = {
  __typename?: 'repeat_offense_view_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RepeatOffenseViewVarSampFields = {
  __typename?: 'repeat_offense_view_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RepeatOffenseViewVarianceFields = {
  __typename?: 'repeat_offense_view_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type RevertCancelledViolationCaseApiOutput = {
  __typename?: 'revertCancelledViolationCaseAPIOutput';
  message: Scalars['String'];
};

export type RevertWrittenOffViolationCaseApiOutput = {
  __typename?: 'revertWrittenOffViolationCaseAPIOutput';
  message: Scalars['String'];
};

/** fields of action: "send_car_owner_requests_germany" */
export type SendCarOwnerRequestsGermany = {
  __typename?: 'send_car_owner_requests_germany';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<SendCarOwnerRequestsGermanyOutput>;
};

/** columns and relationships of "serverless_async_work" */
export type ServerlessAsyncWork = {
  __typename?: 'serverless_async_work';
  arguments?: Maybe<Scalars['jsonb']>;
  delete_timestamp: Scalars['timestamptz'];
  id: Scalars['uuid'];
  job_name: Scalars['String'];
  result?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
};


/** columns and relationships of "serverless_async_work" */
export type ServerlessAsyncWorkArgumentsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "serverless_async_work" */
export type ServerlessAsyncWorkResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "serverless_async_work" */
export type ServerlessAsyncWorkAggregate = {
  __typename?: 'serverless_async_work_aggregate';
  aggregate?: Maybe<ServerlessAsyncWorkAggregateFields>;
  nodes: Array<ServerlessAsyncWork>;
};

/** aggregate fields of "serverless_async_work" */
export type ServerlessAsyncWorkAggregateFields = {
  __typename?: 'serverless_async_work_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ServerlessAsyncWorkMaxFields>;
  min?: Maybe<ServerlessAsyncWorkMinFields>;
};


/** aggregate fields of "serverless_async_work" */
export type ServerlessAsyncWorkAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ServerlessAsyncWorkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ServerlessAsyncWorkAppendInput = {
  arguments?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "serverless_async_work". All fields are combined with a logical 'AND'. */
export type ServerlessAsyncWorkBoolExp = {
  _and?: InputMaybe<Array<ServerlessAsyncWorkBoolExp>>;
  _not?: InputMaybe<ServerlessAsyncWorkBoolExp>;
  _or?: InputMaybe<Array<ServerlessAsyncWorkBoolExp>>;
  arguments?: InputMaybe<JsonbComparisonExp>;
  delete_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_name?: InputMaybe<StringComparisonExp>;
  result?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "serverless_async_work" */
export enum ServerlessAsyncWorkConstraint {
  /** unique or primary key constraint on columns "id" */
  ServerlessAsyncWorkPkey = 'serverless_async_work_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ServerlessAsyncWorkDeleteAtPathInput = {
  arguments?: InputMaybe<Array<Scalars['String']>>;
  result?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ServerlessAsyncWorkDeleteElemInput = {
  arguments?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ServerlessAsyncWorkDeleteKeyInput = {
  arguments?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "serverless_async_work" */
export type ServerlessAsyncWorkInsertInput = {
  arguments?: InputMaybe<Scalars['jsonb']>;
  delete_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_name?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ServerlessAsyncWorkMaxFields = {
  __typename?: 'serverless_async_work_max_fields';
  delete_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ServerlessAsyncWorkMinFields = {
  __typename?: 'serverless_async_work_min_fields';
  delete_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "serverless_async_work" */
export type ServerlessAsyncWorkMutationResponse = {
  __typename?: 'serverless_async_work_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ServerlessAsyncWork>;
};

/** on_conflict condition type for table "serverless_async_work" */
export type ServerlessAsyncWorkOnConflict = {
  constraint: ServerlessAsyncWorkConstraint;
  update_columns?: Array<ServerlessAsyncWorkUpdateColumn>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};

/** Ordering options when selecting data from "serverless_async_work". */
export type ServerlessAsyncWorkOrderBy = {
  arguments?: InputMaybe<OrderBy>;
  delete_timestamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_name?: InputMaybe<OrderBy>;
  result?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: serverless_async_work */
export type ServerlessAsyncWorkPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ServerlessAsyncWorkPrependInput = {
  arguments?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "serverless_async_work" */
export enum ServerlessAsyncWorkSelectColumn {
  /** column name */
  Arguments = 'arguments',
  /** column name */
  DeleteTimestamp = 'delete_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  JobName = 'job_name',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "serverless_async_work" */
export type ServerlessAsyncWorkSetInput = {
  arguments?: InputMaybe<Scalars['jsonb']>;
  delete_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_name?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "serverless_async_work" */
export type ServerlessAsyncWorkStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ServerlessAsyncWorkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ServerlessAsyncWorkStreamCursorValueInput = {
  arguments?: InputMaybe<Scalars['jsonb']>;
  delete_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_name?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "serverless_async_work" */
export enum ServerlessAsyncWorkUpdateColumn {
  /** column name */
  Arguments = 'arguments',
  /** column name */
  DeleteTimestamp = 'delete_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  JobName = 'job_name',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status'
}

export type ServerlessAsyncWorkUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ServerlessAsyncWorkAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ServerlessAsyncWorkDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ServerlessAsyncWorkDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ServerlessAsyncWorkDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ServerlessAsyncWorkPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServerlessAsyncWorkSetInput>;
  /** filter the rows which have to be updated */
  where: ServerlessAsyncWorkBoolExp;
};

/** corresponding similar detections to an MLP case */
export type SimilarDetections = {
  __typename?: 'similar_detections';
  image_request_status: Scalars['String'];
  metadata: Scalars['jsonb'];
  parking_detections_uuid: Scalars['uuid'];
  plate?: Maybe<Scalars['String']>;
  timestamp: Scalars['timestamptz'];
};


/** corresponding similar detections to an MLP case */
export type SimilarDetectionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "similar_detections" */
export type SimilarDetectionsAggregate = {
  __typename?: 'similar_detections_aggregate';
  aggregate?: Maybe<SimilarDetectionsAggregateFields>;
  nodes: Array<SimilarDetections>;
};

/** aggregate fields of "similar_detections" */
export type SimilarDetectionsAggregateFields = {
  __typename?: 'similar_detections_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<SimilarDetectionsMaxFields>;
  min?: Maybe<SimilarDetectionsMinFields>;
};


/** aggregate fields of "similar_detections" */
export type SimilarDetectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SimilarDetectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SimilarDetectionsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "similar_detections". All fields are combined with a logical 'AND'. */
export type SimilarDetectionsBoolExp = {
  _and?: InputMaybe<Array<SimilarDetectionsBoolExp>>;
  _not?: InputMaybe<SimilarDetectionsBoolExp>;
  _or?: InputMaybe<Array<SimilarDetectionsBoolExp>>;
  image_request_status?: InputMaybe<StringComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  parking_detections_uuid?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "similar_detections" */
export enum SimilarDetectionsConstraint {
  /** unique or primary key constraint on columns "parking_detections_uuid" */
  SimilarDetectionsPkey = 'similar_detections_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SimilarDetectionsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SimilarDetectionsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SimilarDetectionsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "similar_detections" */
export type SimilarDetectionsInsertInput = {
  image_request_status?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_detections_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SimilarDetectionsMaxFields = {
  __typename?: 'similar_detections_max_fields';
  image_request_status?: Maybe<Scalars['String']>;
  parking_detections_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SimilarDetectionsMinFields = {
  __typename?: 'similar_detections_min_fields';
  image_request_status?: Maybe<Scalars['String']>;
  parking_detections_uuid?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "similar_detections" */
export type SimilarDetectionsMutationResponse = {
  __typename?: 'similar_detections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SimilarDetections>;
};

/** on_conflict condition type for table "similar_detections" */
export type SimilarDetectionsOnConflict = {
  constraint: SimilarDetectionsConstraint;
  update_columns?: Array<SimilarDetectionsUpdateColumn>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};

/** Ordering options when selecting data from "similar_detections". */
export type SimilarDetectionsOrderBy = {
  image_request_status?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  parking_detections_uuid?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: similar_detections */
export type SimilarDetectionsPkColumnsInput = {
  parking_detections_uuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SimilarDetectionsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "similar_detections" */
export enum SimilarDetectionsSelectColumn {
  /** column name */
  ImageRequestStatus = 'image_request_status',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ParkingDetectionsUuid = 'parking_detections_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "similar_detections" */
export type SimilarDetectionsSetInput = {
  image_request_status?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_detections_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "similar_detections" */
export type SimilarDetectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SimilarDetectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SimilarDetectionsStreamCursorValueInput = {
  image_request_status?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parking_detections_uuid?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "similar_detections" */
export enum SimilarDetectionsUpdateColumn {
  /** column name */
  ImageRequestStatus = 'image_request_status',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ParkingDetectionsUuid = 'parking_detections_uuid',
  /** column name */
  Plate = 'plate',
  /** column name */
  Timestamp = 'timestamp'
}

export type SimilarDetectionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SimilarDetectionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SimilarDetectionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SimilarDetectionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SimilarDetectionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SimilarDetectionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SimilarDetectionsSetInput>;
  /** filter the rows which have to be updated */
  where: SimilarDetectionsBoolExp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "stages" */
export type Stages = {
  __typename?: 'stages';
  id: Scalars['bigint'];
  mail_1?: Maybe<Scalars['Int']>;
  mail_2?: Maybe<Scalars['Int']>;
  mail_3?: Maybe<Scalars['Int']>;
  mail_4?: Maybe<Scalars['Int']>;
  /** An object relationship */
  mail_stage_1?: Maybe<Mail>;
  /** An object relationship */
  mail_stage_2?: Maybe<Mail>;
  /** An object relationship */
  mail_stage_3?: Maybe<Mail>;
  /** An object relationship */
  mail_stage_4?: Maybe<Mail>;
};

/** aggregated selection of "stages" */
export type StagesAggregate = {
  __typename?: 'stages_aggregate';
  aggregate?: Maybe<StagesAggregateFields>;
  nodes: Array<Stages>;
};

export type StagesAggregateBoolExp = {
  count?: InputMaybe<StagesAggregateBoolExpCount>;
};

export type StagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<StagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<StagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "stages" */
export type StagesAggregateFields = {
  __typename?: 'stages_aggregate_fields';
  avg?: Maybe<StagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<StagesMaxFields>;
  min?: Maybe<StagesMinFields>;
  stddev?: Maybe<StagesStddevFields>;
  stddev_pop?: Maybe<StagesStddevPopFields>;
  stddev_samp?: Maybe<StagesStddevSampFields>;
  sum?: Maybe<StagesSumFields>;
  var_pop?: Maybe<StagesVarPopFields>;
  var_samp?: Maybe<StagesVarSampFields>;
  variance?: Maybe<StagesVarianceFields>;
};


/** aggregate fields of "stages" */
export type StagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stages" */
export type StagesAggregateOrderBy = {
  avg?: InputMaybe<StagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<StagesMaxOrderBy>;
  min?: InputMaybe<StagesMinOrderBy>;
  stddev?: InputMaybe<StagesStddevOrderBy>;
  stddev_pop?: InputMaybe<StagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<StagesStddevSampOrderBy>;
  sum?: InputMaybe<StagesSumOrderBy>;
  var_pop?: InputMaybe<StagesVarPopOrderBy>;
  var_samp?: InputMaybe<StagesVarSampOrderBy>;
  variance?: InputMaybe<StagesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "stages" */
export type StagesArrRelInsertInput = {
  data: Array<StagesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<StagesOnConflict>;
};

/** aggregate avg on columns */
export type StagesAvgFields = {
  __typename?: 'stages_avg_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stages" */
export type StagesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "stages". All fields are combined with a logical 'AND'. */
export type StagesBoolExp = {
  _and?: InputMaybe<Array<StagesBoolExp>>;
  _not?: InputMaybe<StagesBoolExp>;
  _or?: InputMaybe<Array<StagesBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  mail_1?: InputMaybe<IntComparisonExp>;
  mail_2?: InputMaybe<IntComparisonExp>;
  mail_3?: InputMaybe<IntComparisonExp>;
  mail_4?: InputMaybe<IntComparisonExp>;
  mail_stage_1?: InputMaybe<MailBoolExp>;
  mail_stage_2?: InputMaybe<MailBoolExp>;
  mail_stage_3?: InputMaybe<MailBoolExp>;
  mail_stage_4?: InputMaybe<MailBoolExp>;
};

/** unique or primary key constraints on table "stages" */
export enum StagesConstraint {
  /** unique or primary key constraint on columns "id" */
  StagePkey = 'stage_pkey'
}

/** input type for incrementing numeric columns in table "stages" */
export type StagesIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  mail_1?: InputMaybe<Scalars['Int']>;
  mail_2?: InputMaybe<Scalars['Int']>;
  mail_3?: InputMaybe<Scalars['Int']>;
  mail_4?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stages" */
export type StagesInsertInput = {
  id?: InputMaybe<Scalars['bigint']>;
  mail_1?: InputMaybe<Scalars['Int']>;
  mail_2?: InputMaybe<Scalars['Int']>;
  mail_3?: InputMaybe<Scalars['Int']>;
  mail_4?: InputMaybe<Scalars['Int']>;
  mail_stage_1?: InputMaybe<MailObjRelInsertInput>;
  mail_stage_2?: InputMaybe<MailObjRelInsertInput>;
  mail_stage_3?: InputMaybe<MailObjRelInsertInput>;
  mail_stage_4?: InputMaybe<MailObjRelInsertInput>;
};

/** aggregate max on columns */
export type StagesMaxFields = {
  __typename?: 'stages_max_fields';
  id?: Maybe<Scalars['bigint']>;
  mail_1?: Maybe<Scalars['Int']>;
  mail_2?: Maybe<Scalars['Int']>;
  mail_3?: Maybe<Scalars['Int']>;
  mail_4?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "stages" */
export type StagesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type StagesMinFields = {
  __typename?: 'stages_min_fields';
  id?: Maybe<Scalars['bigint']>;
  mail_1?: Maybe<Scalars['Int']>;
  mail_2?: Maybe<Scalars['Int']>;
  mail_3?: Maybe<Scalars['Int']>;
  mail_4?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "stages" */
export type StagesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "stages" */
export type StagesMutationResponse = {
  __typename?: 'stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stages>;
};

/** input type for inserting object relation for remote table "stages" */
export type StagesObjRelInsertInput = {
  data: StagesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<StagesOnConflict>;
};

/** on_conflict condition type for table "stages" */
export type StagesOnConflict = {
  constraint: StagesConstraint;
  update_columns?: Array<StagesUpdateColumn>;
  where?: InputMaybe<StagesBoolExp>;
};

/** Ordering options when selecting data from "stages". */
export type StagesOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
  mail_stage_1?: InputMaybe<MailOrderBy>;
  mail_stage_2?: InputMaybe<MailOrderBy>;
  mail_stage_3?: InputMaybe<MailOrderBy>;
  mail_stage_4?: InputMaybe<MailOrderBy>;
};

/** primary key columns input for table: stages */
export type StagesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "stages" */
export enum StagesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Mail_1 = 'mail_1',
  /** column name */
  Mail_2 = 'mail_2',
  /** column name */
  Mail_3 = 'mail_3',
  /** column name */
  Mail_4 = 'mail_4'
}

/** input type for updating data in table "stages" */
export type StagesSetInput = {
  id?: InputMaybe<Scalars['bigint']>;
  mail_1?: InputMaybe<Scalars['Int']>;
  mail_2?: InputMaybe<Scalars['Int']>;
  mail_3?: InputMaybe<Scalars['Int']>;
  mail_4?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type StagesStddevFields = {
  __typename?: 'stages_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stages" */
export type StagesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type StagesStddevPopFields = {
  __typename?: 'stages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stages" */
export type StagesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type StagesStddevSampFields = {
  __typename?: 'stages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stages" */
export type StagesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "stages" */
export type StagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: StagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StagesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  mail_1?: InputMaybe<Scalars['Int']>;
  mail_2?: InputMaybe<Scalars['Int']>;
  mail_3?: InputMaybe<Scalars['Int']>;
  mail_4?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type StagesSumFields = {
  __typename?: 'stages_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  mail_1?: Maybe<Scalars['Int']>;
  mail_2?: Maybe<Scalars['Int']>;
  mail_3?: Maybe<Scalars['Int']>;
  mail_4?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stages" */
export type StagesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** update columns of table "stages" */
export enum StagesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Mail_1 = 'mail_1',
  /** column name */
  Mail_2 = 'mail_2',
  /** column name */
  Mail_3 = 'mail_3',
  /** column name */
  Mail_4 = 'mail_4'
}

export type StagesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StagesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StagesSetInput>;
  /** filter the rows which have to be updated */
  where: StagesBoolExp;
};

/** aggregate var_pop on columns */
export type StagesVarPopFields = {
  __typename?: 'stages_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stages" */
export type StagesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type StagesVarSampFields = {
  __typename?: 'stages_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stages" */
export type StagesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type StagesVarianceFields = {
  __typename?: 'stages_variance_fields';
  id?: Maybe<Scalars['Float']>;
  mail_1?: Maybe<Scalars['Float']>;
  mail_2?: Maybe<Scalars['Float']>;
  mail_3?: Maybe<Scalars['Float']>;
  mail_4?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stages" */
export type StagesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  mail_1?: InputMaybe<OrderBy>;
  mail_2?: InputMaybe<OrderBy>;
  mail_3?: InputMaybe<OrderBy>;
  mail_4?: InputMaybe<OrderBy>;
};

/** fields of action: "start_generation_of_special_letters" */
export type StartGenerationOfSpecialLetters = {
  __typename?: 'start_generation_of_special_letters';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<StartGenerationOfSpecialLettersOutput>;
};

/** columns and relationships of "station" */
export type Station = {
  __typename?: 'station';
  config?: Maybe<Scalars['jsonb']>;
  config_timestamp?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  device?: Maybe<Device>;
  device_direction?: Maybe<Scalars['String']>;
  device_uuid?: Maybe<Scalars['String']>;
  lot_section_id?: Maybe<Scalars['String']>;
  station_name: Scalars['String'];
  type: Scalars['String'];
};


/** columns and relationships of "station" */
export type StationConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "station" */
export type StationAggregate = {
  __typename?: 'station_aggregate';
  aggregate?: Maybe<StationAggregateFields>;
  nodes: Array<Station>;
};

/** aggregate fields of "station" */
export type StationAggregateFields = {
  __typename?: 'station_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<StationMaxFields>;
  min?: Maybe<StationMinFields>;
};


/** aggregate fields of "station" */
export type StationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type StationAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "station". All fields are combined with a logical 'AND'. */
export type StationBoolExp = {
  _and?: InputMaybe<Array<StationBoolExp>>;
  _not?: InputMaybe<StationBoolExp>;
  _or?: InputMaybe<Array<StationBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  config_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  device_direction?: InputMaybe<StringComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  lot_section_id?: InputMaybe<StringComparisonExp>;
  station_name?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "station" */
export enum StationConstraint {
  /** unique or primary key constraint on columns "station_name" */
  StationPkey = 'station_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type StationDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type StationDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type StationDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "station" */
export type StationInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  device_direction?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  station_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type StationMaxFields = {
  __typename?: 'station_max_fields';
  config_timestamp?: Maybe<Scalars['timestamptz']>;
  device_direction?: Maybe<Scalars['String']>;
  device_uuid?: Maybe<Scalars['String']>;
  lot_section_id?: Maybe<Scalars['String']>;
  station_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type StationMinFields = {
  __typename?: 'station_min_fields';
  config_timestamp?: Maybe<Scalars['timestamptz']>;
  device_direction?: Maybe<Scalars['String']>;
  device_uuid?: Maybe<Scalars['String']>;
  lot_section_id?: Maybe<Scalars['String']>;
  station_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "station" */
export type StationMutationResponse = {
  __typename?: 'station_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Station>;
};

/** on_conflict condition type for table "station" */
export type StationOnConflict = {
  constraint: StationConstraint;
  update_columns?: Array<StationUpdateColumn>;
  where?: InputMaybe<StationBoolExp>;
};

/** Ordering options when selecting data from "station". */
export type StationOrderBy = {
  config?: InputMaybe<OrderBy>;
  config_timestamp?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  device_direction?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  lot_section_id?: InputMaybe<OrderBy>;
  station_name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: station */
export type StationPkColumnsInput = {
  station_name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type StationPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "station" */
export enum StationSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigTimestamp = 'config_timestamp',
  /** column name */
  DeviceDirection = 'device_direction',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  StationName = 'station_name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "station" */
export type StationSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device_direction?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  station_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "station" */
export type StationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: StationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StationStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_timestamp?: InputMaybe<Scalars['timestamptz']>;
  device_direction?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  lot_section_id?: InputMaybe<Scalars['String']>;
  station_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "station" */
export enum StationUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigTimestamp = 'config_timestamp',
  /** column name */
  DeviceDirection = 'device_direction',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  LotSectionId = 'lot_section_id',
  /** column name */
  StationName = 'station_name',
  /** column name */
  Type = 'type'
}

export type StationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<StationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<StationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<StationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<StationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<StationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StationSetInput>;
  /** filter the rows which have to be updated */
  where: StationBoolExp;
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "adyen_report" */
  adyen_report: Array<AdyenReport>;
  /** fetch aggregated fields from the table: "adyen_report" */
  adyen_report_aggregate: AdyenReportAggregate;
  /** fetch data from the table: "adyen_report" using primary key columns */
  adyen_report_by_pk?: Maybe<AdyenReport>;
  /** fetch data from the table in a streaming manner: "adyen_report" */
  adyen_report_stream: Array<AdyenReport>;
  /** fetch data from the table: "adyen_transaction" */
  adyen_transaction: Array<AdyenTransaction>;
  /** fetch aggregated fields from the table: "adyen_transaction" */
  adyen_transaction_aggregate: AdyenTransactionAggregate;
  /** fetch data from the table: "adyen_transaction" using primary key columns */
  adyen_transaction_by_pk?: Maybe<AdyenTransaction>;
  /** fetch data from the table in a streaming manner: "adyen_transaction" */
  adyen_transaction_stream: Array<AdyenTransaction>;
  /** fetch data from the table: "applied_permit" */
  applied_permit: Array<AppliedPermit>;
  /** fetch aggregated fields from the table: "applied_permit" */
  applied_permit_aggregate: AppliedPermitAggregate;
  /** fetch data from the table: "applied_permit" using primary key columns */
  applied_permit_by_pk?: Maybe<AppliedPermit>;
  /** fetch data from the table in a streaming manner: "applied_permit" */
  applied_permit_stream: Array<AppliedPermit>;
  /** fetch data from the table: "applied_whitelist" */
  applied_whitelist: Array<AppliedWhitelist>;
  /** fetch aggregated fields from the table: "applied_whitelist" */
  applied_whitelist_aggregate: AppliedWhitelistAggregate;
  /** fetch data from the table: "applied_whitelist" using primary key columns */
  applied_whitelist_by_pk?: Maybe<AppliedWhitelist>;
  /** fetch data from the table in a streaming manner: "applied_whitelist" */
  applied_whitelist_stream: Array<AppliedWhitelist>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<AuditLoggedActions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: AuditLoggedActionsAggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: Maybe<AuditLoggedActions>;
  /** fetch data from the table in a streaming manner: "audit.logged_actions" */
  audit_logged_actions_stream: Array<AuditLoggedActions>;
  /** An array relationship */
  blacklist: Array<Blacklist>;
  /** An aggregate relationship */
  blacklist_aggregate: BlacklistAggregate;
  /** fetch data from the table: "blacklist" using primary key columns */
  blacklist_by_pk?: Maybe<Blacklist>;
  /** fetch data from the table: "blacklist_by_plate_view" */
  blacklist_by_plate_view: Array<BlacklistByPlateView>;
  /** fetch aggregated fields from the table: "blacklist_by_plate_view" */
  blacklist_by_plate_view_aggregate: BlacklistByPlateViewAggregate;
  /** fetch data from the table in a streaming manner: "blacklist_by_plate_view" */
  blacklist_by_plate_view_stream: Array<BlacklistByPlateView>;
  /** fetch data from the table in a streaming manner: "blacklist" */
  blacklist_stream: Array<Blacklist>;
  /** fetch data from the table: "booking.booking" */
  booking_booking: Array<BookingBooking>;
  /** fetch aggregated fields from the table: "booking.booking" */
  booking_booking_aggregate: BookingBookingAggregate;
  /** fetch data from the table: "booking.booking" using primary key columns */
  booking_booking_by_pk?: Maybe<BookingBooking>;
  /** fetch data from the table: "booking.booking_invoice" */
  booking_booking_invoice: Array<BookingBookingInvoice>;
  /** fetch aggregated fields from the table: "booking.booking_invoice" */
  booking_booking_invoice_aggregate: BookingBookingInvoiceAggregate;
  /** fetch data from the table: "booking.booking_invoice" using primary key columns */
  booking_booking_invoice_by_pk?: Maybe<BookingBookingInvoice>;
  /** fetch data from the table in a streaming manner: "booking.booking_invoice" */
  booking_booking_invoice_stream: Array<BookingBookingInvoice>;
  /** fetch data from the table: "booking.booking_plate" */
  booking_booking_plate: Array<BookingBookingPlate>;
  /** fetch aggregated fields from the table: "booking.booking_plate" */
  booking_booking_plate_aggregate: BookingBookingPlateAggregate;
  /** fetch data from the table: "booking.booking_plate" using primary key columns */
  booking_booking_plate_by_pk?: Maybe<BookingBookingPlate>;
  /** fetch data from the table in a streaming manner: "booking.booking_plate" */
  booking_booking_plate_stream: Array<BookingBookingPlate>;
  /** fetch data from the table in a streaming manner: "booking.booking" */
  booking_booking_stream: Array<BookingBooking>;
  /** fetch data from the table: "booking.booking_type" */
  booking_booking_type: Array<BookingBookingType>;
  /** fetch aggregated fields from the table: "booking.booking_type" */
  booking_booking_type_aggregate: BookingBookingTypeAggregate;
  /** fetch data from the table: "booking.booking_type" using primary key columns */
  booking_booking_type_by_pk?: Maybe<BookingBookingType>;
  /** fetch data from the table in a streaming manner: "booking.booking_type" */
  booking_booking_type_stream: Array<BookingBookingType>;
  /** fetch data from the table: "booking.booking_whitelist" */
  booking_booking_whitelist: Array<BookingBookingWhitelist>;
  /** fetch aggregated fields from the table: "booking.booking_whitelist" */
  booking_booking_whitelist_aggregate: BookingBookingWhitelistAggregate;
  /** fetch data from the table: "booking.booking_whitelist" using primary key columns */
  booking_booking_whitelist_by_pk?: Maybe<BookingBookingWhitelist>;
  /** fetch data from the table in a streaming manner: "booking.booking_whitelist" */
  booking_booking_whitelist_stream: Array<BookingBookingWhitelist>;
  /** fetch data from the table: "booking.enum_booking_status" */
  booking_enum_booking_status: Array<BookingEnumBookingStatus>;
  /** fetch aggregated fields from the table: "booking.enum_booking_status" */
  booking_enum_booking_status_aggregate: BookingEnumBookingStatusAggregate;
  /** fetch data from the table: "booking.enum_booking_status" using primary key columns */
  booking_enum_booking_status_by_pk?: Maybe<BookingEnumBookingStatus>;
  /** fetch data from the table in a streaming manner: "booking.enum_booking_status" */
  booking_enum_booking_status_stream: Array<BookingEnumBookingStatus>;
  /** fetch data from the table: "booking.hourly_booking" */
  booking_hourly_booking: Array<BookingHourlyBooking>;
  /** fetch aggregated fields from the table: "booking.hourly_booking" */
  booking_hourly_booking_aggregate: BookingHourlyBookingAggregate;
  /** fetch data from the table: "booking.hourly_booking" using primary key columns */
  booking_hourly_booking_by_pk?: Maybe<BookingHourlyBooking>;
  /** fetch data from the table in a streaming manner: "booking.hourly_booking" */
  booking_hourly_booking_stream: Array<BookingHourlyBooking>;
  /** fetch data from the table: "booking.license_plate" */
  booking_license_plate: Array<BookingLicensePlate>;
  /** fetch aggregated fields from the table: "booking.license_plate" */
  booking_license_plate_aggregate: BookingLicensePlateAggregate;
  /** fetch data from the table: "booking.license_plate" using primary key columns */
  booking_license_plate_by_pk?: Maybe<BookingLicensePlate>;
  /** fetch data from the table in a streaming manner: "booking.license_plate" */
  booking_license_plate_stream: Array<BookingLicensePlate>;
  /** fetch data from the table: "booking.lot" */
  booking_lot: Array<BookingLot>;
  /** fetch aggregated fields from the table: "booking.lot" */
  booking_lot_aggregate: BookingLotAggregate;
  /** fetch data from the table: "booking.lot" using primary key columns */
  booking_lot_by_pk?: Maybe<BookingLot>;
  /** fetch data from the table: "booking.lot_configuration" */
  booking_lot_configuration: Array<BookingLotConfiguration>;
  /** fetch aggregated fields from the table: "booking.lot_configuration" */
  booking_lot_configuration_aggregate: BookingLotConfigurationAggregate;
  /** fetch data from the table: "booking.lot_configuration" using primary key columns */
  booking_lot_configuration_by_pk?: Maybe<BookingLotConfiguration>;
  /** fetch data from the table in a streaming manner: "booking.lot_configuration" */
  booking_lot_configuration_stream: Array<BookingLotConfiguration>;
  /** fetch data from the table in a streaming manner: "booking.lot" */
  booking_lot_stream: Array<BookingLot>;
  /** fetch data from the table: "booking.payment" */
  booking_payment: Array<BookingPayment>;
  /** fetch aggregated fields from the table: "booking.payment" */
  booking_payment_aggregate: BookingPaymentAggregate;
  /** fetch data from the table: "booking.payment" using primary key columns */
  booking_payment_by_pk?: Maybe<BookingPayment>;
  /** fetch data from the table in a streaming manner: "booking.payment" */
  booking_payment_stream: Array<BookingPayment>;
  /** fetch data from the table: "booking.pricing_rules" */
  booking_pricing_rules: Array<BookingPricingRules>;
  /** fetch aggregated fields from the table: "booking.pricing_rules" */
  booking_pricing_rules_aggregate: BookingPricingRulesAggregate;
  /** fetch data from the table: "booking.pricing_rules" using primary key columns */
  booking_pricing_rules_by_pk?: Maybe<BookingPricingRules>;
  /** fetch data from the table in a streaming manner: "booking.pricing_rules" */
  booking_pricing_rules_stream: Array<BookingPricingRules>;
  /** fetch data from the table: "booking.pricing_type" */
  booking_pricing_type: Array<BookingPricingType>;
  /** fetch aggregated fields from the table: "booking.pricing_type" */
  booking_pricing_type_aggregate: BookingPricingTypeAggregate;
  /** fetch data from the table: "booking.pricing_type" using primary key columns */
  booking_pricing_type_by_pk?: Maybe<BookingPricingType>;
  /** fetch data from the table in a streaming manner: "booking.pricing_type" */
  booking_pricing_type_stream: Array<BookingPricingType>;
  /** fetch data from the table: "booking.private_pricing_user" */
  booking_private_pricing_user: Array<BookingPrivatePricingUser>;
  /** fetch aggregated fields from the table: "booking.private_pricing_user" */
  booking_private_pricing_user_aggregate: BookingPrivatePricingUserAggregate;
  /** fetch data from the table: "booking.private_pricing_user" using primary key columns */
  booking_private_pricing_user_by_pk?: Maybe<BookingPrivatePricingUser>;
  /** fetch data from the table in a streaming manner: "booking.private_pricing_user" */
  booking_private_pricing_user_stream: Array<BookingPrivatePricingUser>;
  /** fetch data from the table: "booking.recurring_booking" */
  booking_recurring_booking: Array<BookingRecurringBooking>;
  /** fetch aggregated fields from the table: "booking.recurring_booking" */
  booking_recurring_booking_aggregate: BookingRecurringBookingAggregate;
  /** fetch data from the table: "booking.recurring_booking" using primary key columns */
  booking_recurring_booking_by_pk?: Maybe<BookingRecurringBooking>;
  /** fetch data from the table in a streaming manner: "booking.recurring_booking" */
  booking_recurring_booking_stream: Array<BookingRecurringBooking>;
  /** fetch data from the table: "booking.subscription_booking" */
  booking_subscription_booking: Array<BookingSubscriptionBooking>;
  /** fetch aggregated fields from the table: "booking.subscription_booking" */
  booking_subscription_booking_aggregate: BookingSubscriptionBookingAggregate;
  /** fetch data from the table: "booking.subscription_booking" using primary key columns */
  booking_subscription_booking_by_pk?: Maybe<BookingSubscriptionBooking>;
  /** fetch data from the table in a streaming manner: "booking.subscription_booking" */
  booking_subscription_booking_stream: Array<BookingSubscriptionBooking>;
  /** fetch data from the table: "booking.subscription_license_plate" */
  booking_subscription_license_plate: Array<BookingSubscriptionLicensePlate>;
  /** fetch aggregated fields from the table: "booking.subscription_license_plate" */
  booking_subscription_license_plate_aggregate: BookingSubscriptionLicensePlateAggregate;
  /** fetch data from the table: "booking.subscription_license_plate" using primary key columns */
  booking_subscription_license_plate_by_pk?: Maybe<BookingSubscriptionLicensePlate>;
  /** fetch data from the table in a streaming manner: "booking.subscription_license_plate" */
  booking_subscription_license_plate_stream: Array<BookingSubscriptionLicensePlate>;
  /** fetch data from the table: "booking.subscription_status" */
  booking_subscription_status: Array<BookingSubscriptionStatus>;
  /** fetch aggregated fields from the table: "booking.subscription_status" */
  booking_subscription_status_aggregate: BookingSubscriptionStatusAggregate;
  /** fetch data from the table: "booking.subscription_status" using primary key columns */
  booking_subscription_status_by_pk?: Maybe<BookingSubscriptionStatus>;
  /** fetch data from the table in a streaming manner: "booking.subscription_status" */
  booking_subscription_status_stream: Array<BookingSubscriptionStatus>;
  /** fetch data from the table: "booking.user" */
  booking_user: Array<BookingUser>;
  /** fetch aggregated fields from the table: "booking.user" */
  booking_user_aggregate: BookingUserAggregate;
  /** fetch data from the table: "booking.user_booking" */
  booking_user_booking: Array<BookingUserBooking>;
  /** fetch aggregated fields from the table: "booking.user_booking" */
  booking_user_booking_aggregate: BookingUserBookingAggregate;
  /** fetch data from the table: "booking.user_booking" using primary key columns */
  booking_user_booking_by_pk?: Maybe<BookingUserBooking>;
  /** fetch data from the table in a streaming manner: "booking.user_booking" */
  booking_user_booking_stream: Array<BookingUserBooking>;
  /** fetch data from the table: "booking.user" using primary key columns */
  booking_user_by_pk?: Maybe<BookingUser>;
  /** fetch data from the table: "booking.user_payment_method" */
  booking_user_payment_method: Array<BookingUserPaymentMethod>;
  /** fetch aggregated fields from the table: "booking.user_payment_method" */
  booking_user_payment_method_aggregate: BookingUserPaymentMethodAggregate;
  /** fetch data from the table: "booking.user_payment_method" using primary key columns */
  booking_user_payment_method_by_pk?: Maybe<BookingUserPaymentMethod>;
  /** fetch data from the table in a streaming manner: "booking.user_payment_method" */
  booking_user_payment_method_stream: Array<BookingUserPaymentMethod>;
  /** fetch data from the table in a streaming manner: "booking.user" */
  booking_user_stream: Array<BookingUser>;
  /** fetch data from the table: "booking.user_subscription" */
  booking_user_subscription: Array<BookingUserSubscription>;
  /** fetch aggregated fields from the table: "booking.user_subscription" */
  booking_user_subscription_aggregate: BookingUserSubscriptionAggregate;
  /** fetch data from the table: "booking.user_subscription" using primary key columns */
  booking_user_subscription_by_pk?: Maybe<BookingUserSubscription>;
  /** fetch data from the table in a streaming manner: "booking.user_subscription" */
  booking_user_subscription_stream: Array<BookingUserSubscription>;
  /** fetch data from the table: "booking.vehicle" */
  booking_vehicle: Array<BookingVehicle>;
  /** fetch aggregated fields from the table: "booking.vehicle" */
  booking_vehicle_aggregate: BookingVehicleAggregate;
  /** fetch data from the table: "booking.vehicle" using primary key columns */
  booking_vehicle_by_pk?: Maybe<BookingVehicle>;
  /** fetch data from the table in a streaming manner: "booking.vehicle" */
  booking_vehicle_stream: Array<BookingVehicle>;
  /** fetch data from the table: "booking.vehicle_type" */
  booking_vehicle_type: Array<BookingVehicleType>;
  /** fetch aggregated fields from the table: "booking.vehicle_type" */
  booking_vehicle_type_aggregate: BookingVehicleTypeAggregate;
  /** fetch data from the table: "booking.vehicle_type" using primary key columns */
  booking_vehicle_type_by_pk?: Maybe<BookingVehicleType>;
  /** fetch data from the table in a streaming manner: "booking.vehicle_type" */
  booking_vehicle_type_stream: Array<BookingVehicleType>;
  /** fetch data from the table: "booking.whitelist_type" */
  booking_whitelist_type: Array<BookingWhitelistType>;
  /** fetch aggregated fields from the table: "booking.whitelist_type" */
  booking_whitelist_type_aggregate: BookingWhitelistTypeAggregate;
  /** fetch data from the table: "booking.whitelist_type" using primary key columns */
  booking_whitelist_type_by_pk?: Maybe<BookingWhitelistType>;
  /** fetch data from the table in a streaming manner: "booking.whitelist_type" */
  booking_whitelist_type_stream: Array<BookingWhitelistType>;
  /** fetch data from the table: "calendar_event_policy" */
  calendar_event_policy: Array<CalendarEventPolicy>;
  /** fetch aggregated fields from the table: "calendar_event_policy" */
  calendar_event_policy_aggregate: CalendarEventPolicyAggregate;
  /** fetch data from the table: "calendar_event_policy" using primary key columns */
  calendar_event_policy_by_pk?: Maybe<CalendarEventPolicy>;
  /** fetch data from the table in a streaming manner: "calendar_event_policy" */
  calendar_event_policy_stream: Array<CalendarEventPolicy>;
  /** fetch data from the table: "cancellation_reason_view" */
  cancellation_reason_view: Array<CancellationReasonView>;
  /** fetch aggregated fields from the table: "cancellation_reason_view" */
  cancellation_reason_view_aggregate: CancellationReasonViewAggregate;
  /** fetch data from the table in a streaming manner: "cancellation_reason_view" */
  cancellation_reason_view_stream: Array<CancellationReasonView>;
  /** fetch data from the table: "cancellations" */
  cancellations: Array<Cancellations>;
  /** fetch aggregated fields from the table: "cancellations" */
  cancellations_aggregate: CancellationsAggregate;
  /** fetch data from the table: "cancellations" using primary key columns */
  cancellations_by_pk?: Maybe<Cancellations>;
  /** fetch data from the table in a streaming manner: "cancellations" */
  cancellations_stream: Array<Cancellations>;
  /** fetch data from the table: "car_driver" */
  car_driver: Array<CarDriver>;
  /** fetch aggregated fields from the table: "car_driver" */
  car_driver_aggregate: CarDriverAggregate;
  /** fetch data from the table: "car_driver" using primary key columns */
  car_driver_by_pk?: Maybe<CarDriver>;
  /** fetch data from the table in a streaming manner: "car_driver" */
  car_driver_stream: Array<CarDriver>;
  /** An array relationship */
  car_owner: Array<CarOwner>;
  /** An aggregate relationship */
  car_owner_aggregate: CarOwnerAggregate;
  /** fetch data from the table: "car_owner" using primary key columns */
  car_owner_by_pk?: Maybe<CarOwner>;
  /** fetch data from the table: "car_owner_requests" */
  car_owner_requests: Array<CarOwnerRequests>;
  /** fetch aggregated fields from the table: "car_owner_requests" */
  car_owner_requests_aggregate: CarOwnerRequestsAggregate;
  /** fetch data from the table: "car_owner_requests" using primary key columns */
  car_owner_requests_by_pk?: Maybe<CarOwnerRequests>;
  /** fetch data from the table in a streaming manner: "car_owner_requests" */
  car_owner_requests_stream: Array<CarOwnerRequests>;
  /** fetch data from the table in a streaming manner: "car_owner" */
  car_owner_stream: Array<CarOwner>;
  /** fetch data from the table: "carpay_access_control_lp_pin" */
  carpay_access_control_lp_pin: Array<CarpayAccessControlLpPin>;
  /** fetch aggregated fields from the table: "carpay_access_control_lp_pin" */
  carpay_access_control_lp_pin_aggregate: CarpayAccessControlLpPinAggregate;
  /** fetch data from the table: "carpay_access_control_lp_pin" using primary key columns */
  carpay_access_control_lp_pin_by_pk?: Maybe<CarpayAccessControlLpPin>;
  /** fetch data from the table in a streaming manner: "carpay_access_control_lp_pin" */
  carpay_access_control_lp_pin_stream: Array<CarpayAccessControlLpPin>;
  /** fetch data from the table: "carpay_discount_batch" */
  carpay_discount_batch: Array<CarpayDiscountBatch>;
  /** fetch aggregated fields from the table: "carpay_discount_batch" */
  carpay_discount_batch_aggregate: CarpayDiscountBatchAggregate;
  /** fetch data from the table: "carpay_discount_batch" using primary key columns */
  carpay_discount_batch_by_pk?: Maybe<CarpayDiscountBatch>;
  /** fetch data from the table in a streaming manner: "carpay_discount_batch" */
  carpay_discount_batch_stream: Array<CarpayDiscountBatch>;
  /** fetch data from the table: "carpay_discount_model" */
  carpay_discount_model: Array<CarpayDiscountModel>;
  /** fetch aggregated fields from the table: "carpay_discount_model" */
  carpay_discount_model_aggregate: CarpayDiscountModelAggregate;
  /** fetch data from the table: "carpay_discount_model" using primary key columns */
  carpay_discount_model_by_pk?: Maybe<CarpayDiscountModel>;
  /** fetch data from the table in a streaming manner: "carpay_discount_model" */
  carpay_discount_model_stream: Array<CarpayDiscountModel>;
  /** fetch data from the table: "carpay_lot" */
  carpay_lot: Array<CarpayLot>;
  /** fetch aggregated fields from the table: "carpay_lot" */
  carpay_lot_aggregate: CarpayLotAggregate;
  /** fetch data from the table: "carpay_lot" using primary key columns */
  carpay_lot_by_pk?: Maybe<CarpayLot>;
  /** fetch data from the table in a streaming manner: "carpay_lot" */
  carpay_lot_stream: Array<CarpayLot>;
  /** fetch data from the table: "carpay_notification_subscriber" */
  carpay_notification_subscriber: Array<CarpayNotificationSubscriber>;
  /** fetch aggregated fields from the table: "carpay_notification_subscriber" */
  carpay_notification_subscriber_aggregate: CarpayNotificationSubscriberAggregate;
  /** fetch data from the table: "carpay_notification_subscriber" using primary key columns */
  carpay_notification_subscriber_by_pk?: Maybe<CarpayNotificationSubscriber>;
  /** fetch data from the table in a streaming manner: "carpay_notification_subscriber" */
  carpay_notification_subscriber_stream: Array<CarpayNotificationSubscriber>;
  /** fetch data from the table: "carpay_notification_subscription" */
  carpay_notification_subscription: Array<CarpayNotificationSubscription>;
  /** fetch aggregated fields from the table: "carpay_notification_subscription" */
  carpay_notification_subscription_aggregate: CarpayNotificationSubscriptionAggregate;
  /** fetch data from the table: "carpay_notification_subscription" using primary key columns */
  carpay_notification_subscription_by_pk?: Maybe<CarpayNotificationSubscription>;
  /** fetch data from the table: "carpay_notification_subscription_category" */
  carpay_notification_subscription_category: Array<CarpayNotificationSubscriptionCategory>;
  /** fetch aggregated fields from the table: "carpay_notification_subscription_category" */
  carpay_notification_subscription_category_aggregate: CarpayNotificationSubscriptionCategoryAggregate;
  /** fetch data from the table: "carpay_notification_subscription_category" using primary key columns */
  carpay_notification_subscription_category_by_pk?: Maybe<CarpayNotificationSubscriptionCategory>;
  /** fetch data from the table in a streaming manner: "carpay_notification_subscription_category" */
  carpay_notification_subscription_category_stream: Array<CarpayNotificationSubscriptionCategory>;
  /** fetch data from the table in a streaming manner: "carpay_notification_subscription" */
  carpay_notification_subscription_stream: Array<CarpayNotificationSubscription>;
  /** fetch data from the table: "carpay_order" */
  carpay_order: Array<CarpayOrder>;
  /** fetch aggregated fields from the table: "carpay_order" */
  carpay_order_aggregate: CarpayOrderAggregate;
  /** fetch data from the table: "carpay_order" using primary key columns */
  carpay_order_by_pk?: Maybe<CarpayOrder>;
  /** fetch data from the table: "carpay_order_matches" */
  carpay_order_matches: Array<CarpayOrderMatches>;
  /** fetch aggregated fields from the table: "carpay_order_matches" */
  carpay_order_matches_aggregate: CarpayOrderMatchesAggregate;
  /** fetch data from the table: "carpay_order_matches" using primary key columns */
  carpay_order_matches_by_pk?: Maybe<CarpayOrderMatches>;
  /** fetch data from the table in a streaming manner: "carpay_order_matches" */
  carpay_order_matches_stream: Array<CarpayOrderMatches>;
  /** fetch data from the table in a streaming manner: "carpay_order" */
  carpay_order_stream: Array<CarpayOrder>;
  /** fetch data from the table: "carpay_order_user" */
  carpay_order_user: Array<CarpayOrderUser>;
  /** fetch aggregated fields from the table: "carpay_order_user" */
  carpay_order_user_aggregate: CarpayOrderUserAggregate;
  /** fetch data from the table: "carpay_order_user" using primary key columns */
  carpay_order_user_by_pk?: Maybe<CarpayOrderUser>;
  /** fetch data from the table in a streaming manner: "carpay_order_user" */
  carpay_order_user_stream: Array<CarpayOrderUser>;
  /** fetch data from the table: "carpay_parking_detection" */
  carpay_parking_detection: Array<CarpayParkingDetection>;
  /** fetch aggregated fields from the table: "carpay_parking_detection" */
  carpay_parking_detection_aggregate: CarpayParkingDetectionAggregate;
  /** fetch data from the table: "carpay_parking_detection" using primary key columns */
  carpay_parking_detection_by_pk?: Maybe<CarpayParkingDetection>;
  /** fetch data from the table in a streaming manner: "carpay_parking_detection" */
  carpay_parking_detection_stream: Array<CarpayParkingDetection>;
  /** fetch data from the table: "carpay_pricing" */
  carpay_pricing: Array<CarpayPricing>;
  /** fetch aggregated fields from the table: "carpay_pricing" */
  carpay_pricing_aggregate: CarpayPricingAggregate;
  /** fetch data from the table: "carpay_pricing" using primary key columns */
  carpay_pricing_by_pk?: Maybe<CarpayPricing>;
  /** fetch data from the table: "carpay_pricing_config_group" */
  carpay_pricing_config_group: Array<CarpayPricingConfigGroup>;
  /** fetch aggregated fields from the table: "carpay_pricing_config_group" */
  carpay_pricing_config_group_aggregate: CarpayPricingConfigGroupAggregate;
  /** fetch data from the table: "carpay_pricing_config_group" using primary key columns */
  carpay_pricing_config_group_by_pk?: Maybe<CarpayPricingConfigGroup>;
  /** fetch data from the table in a streaming manner: "carpay_pricing_config_group" */
  carpay_pricing_config_group_stream: Array<CarpayPricingConfigGroup>;
  /** fetch data from the table: "carpay_pricing_period" */
  carpay_pricing_period: Array<CarpayPricingPeriod>;
  /** fetch aggregated fields from the table: "carpay_pricing_period" */
  carpay_pricing_period_aggregate: CarpayPricingPeriodAggregate;
  /** fetch data from the table: "carpay_pricing_period" using primary key columns */
  carpay_pricing_period_by_pk?: Maybe<CarpayPricingPeriod>;
  /** fetch data from the table in a streaming manner: "carpay_pricing_period" */
  carpay_pricing_period_stream: Array<CarpayPricingPeriod>;
  /** fetch data from the table: "carpay_pricing_recurrence" */
  carpay_pricing_recurrence: Array<CarpayPricingRecurrence>;
  /** fetch aggregated fields from the table: "carpay_pricing_recurrence" */
  carpay_pricing_recurrence_aggregate: CarpayPricingRecurrenceAggregate;
  /** fetch data from the table: "carpay_pricing_recurrence" using primary key columns */
  carpay_pricing_recurrence_by_pk?: Maybe<CarpayPricingRecurrence>;
  /** fetch data from the table in a streaming manner: "carpay_pricing_recurrence" */
  carpay_pricing_recurrence_stream: Array<CarpayPricingRecurrence>;
  /** fetch data from the table: "carpay_pricing_rules" */
  carpay_pricing_rules: Array<CarpayPricingRules>;
  /** fetch aggregated fields from the table: "carpay_pricing_rules" */
  carpay_pricing_rules_aggregate: CarpayPricingRulesAggregate;
  /** fetch data from the table: "carpay_pricing_rules" using primary key columns */
  carpay_pricing_rules_by_pk?: Maybe<CarpayPricingRules>;
  /** fetch data from the table in a streaming manner: "carpay_pricing_rules" */
  carpay_pricing_rules_stream: Array<CarpayPricingRules>;
  /** fetch data from the table in a streaming manner: "carpay_pricing" */
  carpay_pricing_stream: Array<CarpayPricing>;
  /** An array relationship */
  carpay_scanned_codes: Array<CarpayScannedCodes>;
  /** An aggregate relationship */
  carpay_scanned_codes_aggregate: CarpayScannedCodesAggregate;
  /** fetch data from the table: "carpay_scanned_codes" using primary key columns */
  carpay_scanned_codes_by_pk?: Maybe<CarpayScannedCodes>;
  /** fetch data from the table in a streaming manner: "carpay_scanned_codes" */
  carpay_scanned_codes_stream: Array<CarpayScannedCodes>;
  /** fetch data from the table: "carpay_terminal_cash_cut_notification" */
  carpay_terminal_cash_cut_notification: Array<CarpayTerminalCashCutNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_cash_cut_notification" */
  carpay_terminal_cash_cut_notification_aggregate: CarpayTerminalCashCutNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_cash_cut_notification" using primary key columns */
  carpay_terminal_cash_cut_notification_by_pk?: Maybe<CarpayTerminalCashCutNotification>;
  /** fetch data from the table in a streaming manner: "carpay_terminal_cash_cut_notification" */
  carpay_terminal_cash_cut_notification_stream: Array<CarpayTerminalCashCutNotification>;
  /** fetch data from the table: "carpay_terminal_cash_fill_level_notification" */
  carpay_terminal_cash_fill_level_notification: Array<CarpayTerminalCashFillLevelNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_cash_fill_level_notification" */
  carpay_terminal_cash_fill_level_notification_aggregate: CarpayTerminalCashFillLevelNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_cash_fill_level_notification" using primary key columns */
  carpay_terminal_cash_fill_level_notification_by_pk?: Maybe<CarpayTerminalCashFillLevelNotification>;
  /** fetch data from the table in a streaming manner: "carpay_terminal_cash_fill_level_notification" */
  carpay_terminal_cash_fill_level_notification_stream: Array<CarpayTerminalCashFillLevelNotification>;
  /** fetch data from the table: "carpay_terminal_notification_config" */
  carpay_terminal_notification_config: Array<CarpayTerminalNotificationConfig>;
  /** fetch aggregated fields from the table: "carpay_terminal_notification_config" */
  carpay_terminal_notification_config_aggregate: CarpayTerminalNotificationConfigAggregate;
  /** fetch data from the table: "carpay_terminal_notification_config" using primary key columns */
  carpay_terminal_notification_config_by_pk?: Maybe<CarpayTerminalNotificationConfig>;
  /** fetch data from the table in a streaming manner: "carpay_terminal_notification_config" */
  carpay_terminal_notification_config_stream: Array<CarpayTerminalNotificationConfig>;
  /** fetch data from the table: "carpay_terminal_printer_status_notification" */
  carpay_terminal_printer_status_notification: Array<CarpayTerminalPrinterStatusNotification>;
  /** fetch aggregated fields from the table: "carpay_terminal_printer_status_notification" */
  carpay_terminal_printer_status_notification_aggregate: CarpayTerminalPrinterStatusNotificationAggregate;
  /** fetch data from the table: "carpay_terminal_printer_status_notification" using primary key columns */
  carpay_terminal_printer_status_notification_by_pk?: Maybe<CarpayTerminalPrinterStatusNotification>;
  /** fetch data from the table in a streaming manner: "carpay_terminal_printer_status_notification" */
  carpay_terminal_printer_status_notification_stream: Array<CarpayTerminalPrinterStatusNotification>;
  /** fetch data from the table: "carpay_user_verified_plate" */
  carpay_user_verified_plate: Array<CarpayUserVerifiedPlate>;
  /** fetch aggregated fields from the table: "carpay_user_verified_plate" */
  carpay_user_verified_plate_aggregate: CarpayUserVerifiedPlateAggregate;
  /** fetch data from the table: "carpay_user_verified_plate" using primary key columns */
  carpay_user_verified_plate_by_pk?: Maybe<CarpayUserVerifiedPlate>;
  /** fetch data from the table in a streaming manner: "carpay_user_verified_plate" */
  carpay_user_verified_plate_stream: Array<CarpayUserVerifiedPlate>;
  /** fetch data from the table: "chain" */
  chain: Array<Chain>;
  /** fetch aggregated fields from the table: "chain" */
  chain_aggregate: ChainAggregate;
  /** fetch data from the table: "chain" using primary key columns */
  chain_by_pk?: Maybe<Chain>;
  /** fetch data from the table in a streaming manner: "chain" */
  chain_stream: Array<Chain>;
  /** fetch data from the table: "city_codes" */
  city_codes: Array<CityCodes>;
  /** fetch aggregated fields from the table: "city_codes" */
  city_codes_aggregate: CityCodesAggregate;
  /** fetch data from the table in a streaming manner: "city_codes" */
  city_codes_stream: Array<CityCodes>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: CompanyAggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_config_group" */
  company_config_group: Array<CompanyConfigGroup>;
  /** fetch aggregated fields from the table: "company_config_group" */
  company_config_group_aggregate: CompanyConfigGroupAggregate;
  /** fetch data from the table: "company_config_group" using primary key columns */
  company_config_group_by_pk?: Maybe<CompanyConfigGroup>;
  /** fetch data from the table in a streaming manner: "company_config_group" */
  company_config_group_stream: Array<CompanyConfigGroup>;
  /** An array relationship */
  company_hierarchy: Array<CompanyHierarchy>;
  /** An aggregate relationship */
  company_hierarchy_aggregate: CompanyHierarchyAggregate;
  /** fetch data from the table: "company_hierarchy" using primary key columns */
  company_hierarchy_by_pk?: Maybe<CompanyHierarchy>;
  /** fetch data from the table in a streaming manner: "company_hierarchy" */
  company_hierarchy_stream: Array<CompanyHierarchy>;
  /** fetch data from the table: "company_lot_section" */
  company_lot_section: Array<CompanyLotSection>;
  /** fetch aggregated fields from the table: "company_lot_section" */
  company_lot_section_aggregate: CompanyLotSectionAggregate;
  /** fetch data from the table: "company_lot_section" using primary key columns */
  company_lot_section_by_pk?: Maybe<CompanyLotSection>;
  /** fetch data from the table in a streaming manner: "company_lot_section" */
  company_lot_section_stream: Array<CompanyLotSection>;
  /** fetch data from the table in a streaming manner: "company" */
  company_stream: Array<Company>;
  /** fetch data from the table: "company_vat_id" */
  company_vat_id: Array<CompanyVatId>;
  /** fetch aggregated fields from the table: "company_vat_id" */
  company_vat_id_aggregate: CompanyVatIdAggregate;
  /** fetch data from the table: "company_vat_id" using primary key columns */
  company_vat_id_by_pk?: Maybe<CompanyVatId>;
  /** fetch data from the table in a streaming manner: "company_vat_id" */
  company_vat_id_stream: Array<CompanyVatId>;
  /** fetch data from the table: "company_violator" */
  company_violator: Array<CompanyViolator>;
  /** fetch aggregated fields from the table: "company_violator" */
  company_violator_aggregate: CompanyViolatorAggregate;
  /** fetch data from the table: "company_violator" using primary key columns */
  company_violator_by_pk?: Maybe<CompanyViolator>;
  /** fetch data from the table in a streaming manner: "company_violator" */
  company_violator_stream: Array<CompanyViolator>;
  /** fetch data from the table: "config_group" */
  config_group: Array<ConfigGroup>;
  /** fetch aggregated fields from the table: "config_group" */
  config_group_aggregate: ConfigGroupAggregate;
  /** fetch data from the table: "config_group" using primary key columns */
  config_group_by_pk?: Maybe<ConfigGroup>;
  /** fetch data from the table in a streaming manner: "config_group" */
  config_group_stream: Array<ConfigGroup>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  create_driver_information_request?: Maybe<CreateDriverInformationRequest>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: CurrencyAggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table in a streaming manner: "currency" */
  currency_stream: Array<Currency>;
  /** fetch data from the table: "customer_dashboard_nps_feedback" */
  customer_dashboard_nps_feedback: Array<CustomerDashboardNpsFeedback>;
  /** fetch aggregated fields from the table: "customer_dashboard_nps_feedback" */
  customer_dashboard_nps_feedback_aggregate: CustomerDashboardNpsFeedbackAggregate;
  /** fetch data from the table: "customer_dashboard_nps_feedback" using primary key columns */
  customer_dashboard_nps_feedback_by_pk?: Maybe<CustomerDashboardNpsFeedback>;
  /** fetch data from the table in a streaming manner: "customer_dashboard_nps_feedback" */
  customer_dashboard_nps_feedback_stream: Array<CustomerDashboardNpsFeedback>;
  /** fetch data from the table: "daily_failure" */
  daily_failure: Array<DailyFailure>;
  /** fetch aggregated fields from the table: "daily_failure" */
  daily_failure_aggregate: DailyFailureAggregate;
  /** fetch data from the table: "daily_failure" using primary key columns */
  daily_failure_by_pk?: Maybe<DailyFailure>;
  /** fetch data from the table in a streaming manner: "daily_failure" */
  daily_failure_stream: Array<DailyFailure>;
  /** An array relationship */
  daily_stats: Array<DailyStats>;
  /** An aggregate relationship */
  daily_stats_aggregate: DailyStatsAggregate;
  /** fetch data from the table: "daily_stats" using primary key columns */
  daily_stats_by_pk?: Maybe<DailyStats>;
  /** fetch data from the table in a streaming manner: "daily_stats" */
  daily_stats_stream: Array<DailyStats>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: DepartmentAggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table in a streaming manner: "department" */
  department_stream: Array<Department>;
  /** fetch data from the table: "detection_type_enum" */
  detection_type_enum: Array<DetectionTypeEnum>;
  /** fetch aggregated fields from the table: "detection_type_enum" */
  detection_type_enum_aggregate: DetectionTypeEnumAggregate;
  /** fetch data from the table: "detection_type_enum" using primary key columns */
  detection_type_enum_by_pk?: Maybe<DetectionTypeEnum>;
  /** fetch data from the table in a streaming manner: "detection_type_enum" */
  detection_type_enum_stream: Array<DetectionTypeEnum>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: DeviceAggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  /** fetch data from the table in a streaming manner: "device" */
  device_stream: Array<Device>;
  /** fetch data from the table: "easypark_lot" */
  easypark_lot: Array<EasyparkLot>;
  /** fetch aggregated fields from the table: "easypark_lot" */
  easypark_lot_aggregate: EasyparkLotAggregate;
  /** fetch data from the table: "easypark_lot" using primary key columns */
  easypark_lot_by_pk?: Maybe<EasyparkLot>;
  /** fetch data from the table in a streaming manner: "easypark_lot" */
  easypark_lot_stream: Array<EasyparkLot>;
  /** fetch data from the table: "easypark_order" */
  easypark_order: Array<EasyparkOrder>;
  /** fetch aggregated fields from the table: "easypark_order" */
  easypark_order_aggregate: EasyparkOrderAggregate;
  /** fetch data from the table: "easypark_order" using primary key columns */
  easypark_order_by_pk?: Maybe<EasyparkOrder>;
  /** fetch data from the table in a streaming manner: "easypark_order" */
  easypark_order_stream: Array<EasyparkOrder>;
  /** fetch data from the table: "easypark_order_v2" */
  easypark_order_v2: Array<EasyparkOrderV2>;
  /** fetch aggregated fields from the table: "easypark_order_v2" */
  easypark_order_v2_aggregate: EasyparkOrderV2Aggregate;
  /** fetch data from the table: "easypark_order_v2" using primary key columns */
  easypark_order_v2_by_pk?: Maybe<EasyparkOrderV2>;
  /** fetch data from the table in a streaming manner: "easypark_order_v2" */
  easypark_order_v2_stream: Array<EasyparkOrderV2>;
  /** fetch data from the table: "easypark_parking_info" */
  easypark_parking_info: Array<EasyparkParkingInfo>;
  /** fetch aggregated fields from the table: "easypark_parking_info" */
  easypark_parking_info_aggregate: EasyparkParkingInfoAggregate;
  /** fetch data from the table: "easypark_parking_info" using primary key columns */
  easypark_parking_info_by_pk?: Maybe<EasyparkParkingInfo>;
  /** fetch data from the table in a streaming manner: "easypark_parking_info" */
  easypark_parking_info_stream: Array<EasyparkParkingInfo>;
  /** fetch data from the table: "enforcement_daily_stats" */
  enforcement_daily_stats: Array<EnforcementDailyStats>;
  /** fetch aggregated fields from the table: "enforcement_daily_stats" */
  enforcement_daily_stats_aggregate: EnforcementDailyStatsAggregate;
  /** fetch data from the table: "enforcement_daily_stats" using primary key columns */
  enforcement_daily_stats_by_pk?: Maybe<EnforcementDailyStats>;
  /** fetch data from the table in a streaming manner: "enforcement_daily_stats" */
  enforcement_daily_stats_stream: Array<EnforcementDailyStats>;
  /** fetch data from the table: "enum_carpay_discount_model_code_type" */
  enum_carpay_discount_model_code_type: Array<EnumCarpayDiscountModelCodeType>;
  /** fetch aggregated fields from the table: "enum_carpay_discount_model_code_type" */
  enum_carpay_discount_model_code_type_aggregate: EnumCarpayDiscountModelCodeTypeAggregate;
  /** fetch data from the table: "enum_carpay_discount_model_code_type" using primary key columns */
  enum_carpay_discount_model_code_type_by_pk?: Maybe<EnumCarpayDiscountModelCodeType>;
  /** fetch data from the table in a streaming manner: "enum_carpay_discount_model_code_type" */
  enum_carpay_discount_model_code_type_stream: Array<EnumCarpayDiscountModelCodeType>;
  /** fetch data from the table: "enum_country_code" */
  enum_country_code: Array<EnumCountryCode>;
  /** fetch aggregated fields from the table: "enum_country_code" */
  enum_country_code_aggregate: EnumCountryCodeAggregate;
  /** fetch data from the table: "enum_country_code" using primary key columns */
  enum_country_code_by_pk?: Maybe<EnumCountryCode>;
  /** fetch data from the table in a streaming manner: "enum_country_code" */
  enum_country_code_stream: Array<EnumCountryCode>;
  /** fetch data from the table: "enum_customer_whitelist_purpose" */
  enum_customer_whitelist_purpose: Array<EnumCustomerWhitelistPurpose>;
  /** fetch aggregated fields from the table: "enum_customer_whitelist_purpose" */
  enum_customer_whitelist_purpose_aggregate: EnumCustomerWhitelistPurposeAggregate;
  /** fetch data from the table: "enum_customer_whitelist_purpose" using primary key columns */
  enum_customer_whitelist_purpose_by_pk?: Maybe<EnumCustomerWhitelistPurpose>;
  /** fetch data from the table in a streaming manner: "enum_customer_whitelist_purpose" */
  enum_customer_whitelist_purpose_stream: Array<EnumCustomerWhitelistPurpose>;
  /** fetch data from the table: "enum_customer_whitelist_status" */
  enum_customer_whitelist_status: Array<EnumCustomerWhitelistStatus>;
  /** fetch aggregated fields from the table: "enum_customer_whitelist_status" */
  enum_customer_whitelist_status_aggregate: EnumCustomerWhitelistStatusAggregate;
  /** fetch data from the table: "enum_customer_whitelist_status" using primary key columns */
  enum_customer_whitelist_status_by_pk?: Maybe<EnumCustomerWhitelistStatus>;
  /** fetch data from the table in a streaming manner: "enum_customer_whitelist_status" */
  enum_customer_whitelist_status_stream: Array<EnumCustomerWhitelistStatus>;
  /** fetch data from the table: "enum_device_type" */
  enum_device_type: Array<EnumDeviceType>;
  /** fetch aggregated fields from the table: "enum_device_type" */
  enum_device_type_aggregate: EnumDeviceTypeAggregate;
  /** fetch data from the table: "enum_device_type" using primary key columns */
  enum_device_type_by_pk?: Maybe<EnumDeviceType>;
  /** fetch data from the table in a streaming manner: "enum_device_type" */
  enum_device_type_stream: Array<EnumDeviceType>;
  /** fetch data from the table: "enum_driver_request_type" */
  enum_driver_request_type: Array<EnumDriverRequestType>;
  /** fetch aggregated fields from the table: "enum_driver_request_type" */
  enum_driver_request_type_aggregate: EnumDriverRequestTypeAggregate;
  /** fetch data from the table: "enum_driver_request_type" using primary key columns */
  enum_driver_request_type_by_pk?: Maybe<EnumDriverRequestType>;
  /** fetch data from the table in a streaming manner: "enum_driver_request_type" */
  enum_driver_request_type_stream: Array<EnumDriverRequestType>;
  /** fetch data from the table: "enum_guest_jwt_purpose" */
  enum_guest_jwt_purpose: Array<EnumGuestJwtPurpose>;
  /** fetch aggregated fields from the table: "enum_guest_jwt_purpose" */
  enum_guest_jwt_purpose_aggregate: EnumGuestJwtPurposeAggregate;
  /** fetch data from the table: "enum_guest_jwt_purpose" using primary key columns */
  enum_guest_jwt_purpose_by_pk?: Maybe<EnumGuestJwtPurpose>;
  /** fetch data from the table in a streaming manner: "enum_guest_jwt_purpose" */
  enum_guest_jwt_purpose_stream: Array<EnumGuestJwtPurpose>;
  /** fetch data from the table: "enum_supervision_mlp_request_status" */
  enum_supervision_mlp_request_status: Array<EnumSupervisionMlpRequestStatus>;
  /** fetch aggregated fields from the table: "enum_supervision_mlp_request_status" */
  enum_supervision_mlp_request_status_aggregate: EnumSupervisionMlpRequestStatusAggregate;
  /** fetch data from the table: "enum_supervision_mlp_request_status" using primary key columns */
  enum_supervision_mlp_request_status_by_pk?: Maybe<EnumSupervisionMlpRequestStatus>;
  /** fetch data from the table in a streaming manner: "enum_supervision_mlp_request_status" */
  enum_supervision_mlp_request_status_stream: Array<EnumSupervisionMlpRequestStatus>;
  /** fetch data from the table: "enum_violation_cancellation" */
  enum_violation_cancellation: Array<EnumViolationCancellation>;
  /** fetch aggregated fields from the table: "enum_violation_cancellation" */
  enum_violation_cancellation_aggregate: EnumViolationCancellationAggregate;
  /** fetch data from the table: "enum_violation_cancellation" using primary key columns */
  enum_violation_cancellation_by_pk?: Maybe<EnumViolationCancellation>;
  /** fetch data from the table in a streaming manner: "enum_violation_cancellation" */
  enum_violation_cancellation_stream: Array<EnumViolationCancellation>;
  /** fetch data from the table: "enum_violation_case_charges_invalidation_reason" */
  enum_violation_case_charges_invalidation_reason: Array<EnumViolationCaseChargesInvalidationReason>;
  /** fetch aggregated fields from the table: "enum_violation_case_charges_invalidation_reason" */
  enum_violation_case_charges_invalidation_reason_aggregate: EnumViolationCaseChargesInvalidationReasonAggregate;
  /** fetch data from the table: "enum_violation_case_charges_invalidation_reason" using primary key columns */
  enum_violation_case_charges_invalidation_reason_by_pk?: Maybe<EnumViolationCaseChargesInvalidationReason>;
  /** fetch data from the table in a streaming manner: "enum_violation_case_charges_invalidation_reason" */
  enum_violation_case_charges_invalidation_reason_stream: Array<EnumViolationCaseChargesInvalidationReason>;
  /** fetch data from the table: "enum_violation_case_charges_type" */
  enum_violation_case_charges_type: Array<EnumViolationCaseChargesType>;
  /** fetch aggregated fields from the table: "enum_violation_case_charges_type" */
  enum_violation_case_charges_type_aggregate: EnumViolationCaseChargesTypeAggregate;
  /** fetch data from the table: "enum_violation_case_charges_type" using primary key columns */
  enum_violation_case_charges_type_by_pk?: Maybe<EnumViolationCaseChargesType>;
  /** fetch data from the table in a streaming manner: "enum_violation_case_charges_type" */
  enum_violation_case_charges_type_stream: Array<EnumViolationCaseChargesType>;
  /** fetch data from the table: "enum_whitelist_paid_parking_types" */
  enum_whitelist_paid_parking_types: Array<EnumWhitelistPaidParkingTypes>;
  /** fetch aggregated fields from the table: "enum_whitelist_paid_parking_types" */
  enum_whitelist_paid_parking_types_aggregate: EnumWhitelistPaidParkingTypesAggregate;
  /** fetch data from the table: "enum_whitelist_paid_parking_types" using primary key columns */
  enum_whitelist_paid_parking_types_by_pk?: Maybe<EnumWhitelistPaidParkingTypes>;
  /** fetch data from the table in a streaming manner: "enum_whitelist_paid_parking_types" */
  enum_whitelist_paid_parking_types_stream: Array<EnumWhitelistPaidParkingTypes>;
  /** fetch data from the table: "enum_whitelist_scope" */
  enum_whitelist_scope: Array<EnumWhitelistScope>;
  /** fetch aggregated fields from the table: "enum_whitelist_scope" */
  enum_whitelist_scope_aggregate: EnumWhitelistScopeAggregate;
  /** fetch data from the table: "enum_whitelist_scope" using primary key columns */
  enum_whitelist_scope_by_pk?: Maybe<EnumWhitelistScope>;
  /** fetch data from the table in a streaming manner: "enum_whitelist_scope" */
  enum_whitelist_scope_stream: Array<EnumWhitelistScope>;
  /** fetch data from the table: "enum_whitelist_status" */
  enum_whitelist_status: Array<EnumWhitelistStatus>;
  /** fetch aggregated fields from the table: "enum_whitelist_status" */
  enum_whitelist_status_aggregate: EnumWhitelistStatusAggregate;
  /** fetch data from the table: "enum_whitelist_status" using primary key columns */
  enum_whitelist_status_by_pk?: Maybe<EnumWhitelistStatus>;
  /** fetch data from the table in a streaming manner: "enum_whitelist_status" */
  enum_whitelist_status_stream: Array<EnumWhitelistStatus>;
  /** fetch data from the table: "enum_whitelist_types" */
  enum_whitelist_types: Array<EnumWhitelistTypes>;
  /** fetch aggregated fields from the table: "enum_whitelist_types" */
  enum_whitelist_types_aggregate: EnumWhitelistTypesAggregate;
  /** fetch data from the table: "enum_whitelist_types" using primary key columns */
  enum_whitelist_types_by_pk?: Maybe<EnumWhitelistTypes>;
  /** fetch data from the table in a streaming manner: "enum_whitelist_types" */
  enum_whitelist_types_stream: Array<EnumWhitelistTypes>;
  /** fetch data from the table: "generated_id_view" */
  generated_id_view: Array<GeneratedIdView>;
  /** fetch aggregated fields from the table: "generated_id_view" */
  generated_id_view_aggregate: GeneratedIdViewAggregate;
  /** fetch data from the table in a streaming manner: "generated_id_view" */
  generated_id_view_stream: Array<GeneratedIdView>;
  /** fetch data from the table: "guest_jwt" */
  guest_jwt: Array<GuestJwt>;
  /** fetch aggregated fields from the table: "guest_jwt" */
  guest_jwt_aggregate: GuestJwtAggregate;
  /** fetch data from the table: "guest_jwt" using primary key columns */
  guest_jwt_by_pk?: Maybe<GuestJwt>;
  /** fetch data from the table in a streaming manner: "guest_jwt" */
  guest_jwt_stream: Array<GuestJwt>;
  /** fetch data from the table: "guest_qr" */
  guest_qr: Array<GuestQr>;
  /** fetch aggregated fields from the table: "guest_qr" */
  guest_qr_aggregate: GuestQrAggregate;
  /** fetch data from the table: "guest_qr" using primary key columns */
  guest_qr_by_pk?: Maybe<GuestQr>;
  /** fetch data from the table in a streaming manner: "guest_qr" */
  guest_qr_stream: Array<GuestQr>;
  /** fetch data from the table: "lot" */
  lot: Array<Lot>;
  /** fetch aggregated fields from the table: "lot" */
  lot_aggregate: LotAggregate;
  /** fetch data from the table: "lot" using primary key columns */
  lot_by_pk?: Maybe<Lot>;
  /** fetch data from the table: "lot_config_group" */
  lot_config_group: Array<LotConfigGroup>;
  /** fetch aggregated fields from the table: "lot_config_group" */
  lot_config_group_aggregate: LotConfigGroupAggregate;
  /** fetch data from the table: "lot_config_group" using primary key columns */
  lot_config_group_by_pk?: Maybe<LotConfigGroup>;
  /** fetch data from the table in a streaming manner: "lot_config_group" */
  lot_config_group_stream: Array<LotConfigGroup>;
  /** fetch data from the table: "lot_display_name" */
  lot_display_name: Array<LotDisplayName>;
  /** fetch aggregated fields from the table: "lot_display_name" */
  lot_display_name_aggregate: LotDisplayNameAggregate;
  /** fetch data from the table: "lot_display_name" using primary key columns */
  lot_display_name_by_pk?: Maybe<LotDisplayName>;
  /** fetch data from the table in a streaming manner: "lot_display_name" */
  lot_display_name_stream: Array<LotDisplayName>;
  /** fetch data from the table: "lot_hierarchy" */
  lot_hierarchy: Array<LotHierarchy>;
  /** fetch aggregated fields from the table: "lot_hierarchy" */
  lot_hierarchy_aggregate: LotHierarchyAggregate;
  /** fetch data from the table: "lot_hierarchy" using primary key columns */
  lot_hierarchy_by_pk?: Maybe<LotHierarchy>;
  /** fetch data from the table in a streaming manner: "lot_hierarchy" */
  lot_hierarchy_stream: Array<LotHierarchy>;
  /** fetch data from the table: "lot_legal_entity" */
  lot_legal_entity: Array<LotLegalEntity>;
  /** fetch aggregated fields from the table: "lot_legal_entity" */
  lot_legal_entity_aggregate: LotLegalEntityAggregate;
  /** fetch data from the table: "lot_legal_entity" using primary key columns */
  lot_legal_entity_by_pk?: Maybe<LotLegalEntity>;
  /** fetch data from the table in a streaming manner: "lot_legal_entity" */
  lot_legal_entity_stream: Array<LotLegalEntity>;
  /** fetch data from the table: "lot_policy_history" */
  lot_policy_history: Array<LotPolicyHistory>;
  /** fetch aggregated fields from the table: "lot_policy_history" */
  lot_policy_history_aggregate: LotPolicyHistoryAggregate;
  /** fetch data from the table: "lot_policy_history" using primary key columns */
  lot_policy_history_by_pk?: Maybe<LotPolicyHistory>;
  /** fetch data from the table in a streaming manner: "lot_policy_history" */
  lot_policy_history_stream: Array<LotPolicyHistory>;
  /** fetch data from the table: "lot_section" */
  lot_section: Array<LotSection>;
  /** fetch aggregated fields from the table: "lot_section" */
  lot_section_aggregate: LotSectionAggregate;
  /** fetch data from the table: "lot_section" using primary key columns */
  lot_section_by_pk?: Maybe<LotSection>;
  /** fetch data from the table in a streaming manner: "lot_section" */
  lot_section_stream: Array<LotSection>;
  /** fetch data from the table in a streaming manner: "lot" */
  lot_stream: Array<Lot>;
  /** fetch data from the table: "lp_contingent" */
  lp_contingent: Array<LpContingent>;
  /** fetch aggregated fields from the table: "lp_contingent" */
  lp_contingent_aggregate: LpContingentAggregate;
  /** fetch data from the table: "lp_contingent" using primary key columns */
  lp_contingent_by_pk?: Maybe<LpContingent>;
  /** fetch data from the table in a streaming manner: "lp_contingent" */
  lp_contingent_stream: Array<LpContingent>;
  /** fetch data from the table: "lp_group" */
  lp_group: Array<LpGroup>;
  /** fetch aggregated fields from the table: "lp_group" */
  lp_group_aggregate: LpGroupAggregate;
  /** fetch data from the table: "lp_group" using primary key columns */
  lp_group_by_pk?: Maybe<LpGroup>;
  /** fetch data from the table: "lp_group_config_group" */
  lp_group_config_group: Array<LpGroupConfigGroup>;
  /** fetch aggregated fields from the table: "lp_group_config_group" */
  lp_group_config_group_aggregate: LpGroupConfigGroupAggregate;
  /** fetch data from the table: "lp_group_config_group" using primary key columns */
  lp_group_config_group_by_pk?: Maybe<LpGroupConfigGroup>;
  /** fetch data from the table in a streaming manner: "lp_group_config_group" */
  lp_group_config_group_stream: Array<LpGroupConfigGroup>;
  /** fetch data from the table: "lp_group_details" */
  lp_group_details: Array<LpGroupDetails>;
  /** fetch aggregated fields from the table: "lp_group_details" */
  lp_group_details_aggregate: LpGroupDetailsAggregate;
  /** fetch data from the table: "lp_group_details" using primary key columns */
  lp_group_details_by_pk?: Maybe<LpGroupDetails>;
  /** fetch data from the table in a streaming manner: "lp_group_details" */
  lp_group_details_stream: Array<LpGroupDetails>;
  /** fetch data from the table: "lp_group_member" */
  lp_group_member: Array<LpGroupMember>;
  /** fetch aggregated fields from the table: "lp_group_member" */
  lp_group_member_aggregate: LpGroupMemberAggregate;
  /** fetch data from the table: "lp_group_member" using primary key columns */
  lp_group_member_by_pk?: Maybe<LpGroupMember>;
  /** fetch data from the table: "lp_group_member_details" */
  lp_group_member_details: Array<LpGroupMemberDetails>;
  /** fetch aggregated fields from the table: "lp_group_member_details" */
  lp_group_member_details_aggregate: LpGroupMemberDetailsAggregate;
  /** fetch data from the table: "lp_group_member_details" using primary key columns */
  lp_group_member_details_by_pk?: Maybe<LpGroupMemberDetails>;
  /** fetch data from the table in a streaming manner: "lp_group_member_details" */
  lp_group_member_details_stream: Array<LpGroupMemberDetails>;
  /** fetch data from the table in a streaming manner: "lp_group_member" */
  lp_group_member_stream: Array<LpGroupMember>;
  /** fetch data from the table in a streaming manner: "lp_group" */
  lp_group_stream: Array<LpGroup>;
  /** fetch data from the table: "mail" */
  mail: Array<Mail>;
  /** fetch aggregated fields from the table: "mail" */
  mail_aggregate: MailAggregate;
  /** fetch data from the table: "mail" using primary key columns */
  mail_by_pk?: Maybe<Mail>;
  /** fetch data from the table: "mail_misc" */
  mail_misc: Array<MailMisc>;
  /** fetch aggregated fields from the table: "mail_misc" */
  mail_misc_aggregate: MailMiscAggregate;
  /** fetch data from the table: "mail_misc" using primary key columns */
  mail_misc_by_pk?: Maybe<MailMisc>;
  /** fetch data from the table in a streaming manner: "mail_misc" */
  mail_misc_stream: Array<MailMisc>;
  /** fetch data from the table in a streaming manner: "mail" */
  mail_stream: Array<Mail>;
  /** fetch data from the table: "mlp_cases" */
  mlp_cases: Array<MlpCases>;
  /** fetch aggregated fields from the table: "mlp_cases" */
  mlp_cases_aggregate: MlpCasesAggregate;
  /** fetch data from the table: "mlp_cases" using primary key columns */
  mlp_cases_by_pk?: Maybe<MlpCases>;
  /** fetch data from the table in a streaming manner: "mlp_cases" */
  mlp_cases_stream: Array<MlpCases>;
  /** fetch data from the table: "mlp_mappings" */
  mlp_mappings: Array<MlpMappings>;
  /** fetch aggregated fields from the table: "mlp_mappings" */
  mlp_mappings_aggregate: MlpMappingsAggregate;
  /** fetch data from the table: "mlp_mappings" using primary key columns */
  mlp_mappings_by_pk?: Maybe<MlpMappings>;
  /** fetch data from the table in a streaming manner: "mlp_mappings" */
  mlp_mappings_stream: Array<MlpMappings>;
  /** fetch data from the table: "mqtt_request" */
  mqtt_request: Array<MqttRequest>;
  /** fetch aggregated fields from the table: "mqtt_request" */
  mqtt_request_aggregate: MqttRequestAggregate;
  /** fetch data from the table: "mqtt_request" using primary key columns */
  mqtt_request_by_pk?: Maybe<MqttRequest>;
  /** fetch data from the table in a streaming manner: "mqtt_request" */
  mqtt_request_stream: Array<MqttRequest>;
  /** fetch data from the table: "offence_parking_events" */
  offence_parking_events: Array<OffenceParkingEvents>;
  /** fetch aggregated fields from the table: "offence_parking_events" */
  offence_parking_events_aggregate: OffenceParkingEventsAggregate;
  /** fetch data from the table: "offence_parking_events" using primary key columns */
  offence_parking_events_by_pk?: Maybe<OffenceParkingEvents>;
  /** fetch data from the table in a streaming manner: "offence_parking_events" */
  offence_parking_events_stream: Array<OffenceParkingEvents>;
  /** fetch data from the table: "offence_ticket_requests" */
  offence_ticket_requests: Array<OffenceTicketRequests>;
  /** fetch aggregated fields from the table: "offence_ticket_requests" */
  offence_ticket_requests_aggregate: OffenceTicketRequestsAggregate;
  /** fetch data from the table: "offence_ticket_requests" using primary key columns */
  offence_ticket_requests_by_pk?: Maybe<OffenceTicketRequests>;
  /** fetch data from the table in a streaming manner: "offence_ticket_requests" */
  offence_ticket_requests_stream: Array<OffenceTicketRequests>;
  /** fetch data from the table: "overuse_group" */
  overuse_group: Array<OveruseGroup>;
  /** fetch aggregated fields from the table: "overuse_group" */
  overuse_group_aggregate: OveruseGroupAggregate;
  /** fetch data from the table: "overuse_group" using primary key columns */
  overuse_group_by_pk?: Maybe<OveruseGroup>;
  /** fetch data from the table: "overuse_group_member" */
  overuse_group_member: Array<OveruseGroupMember>;
  /** fetch aggregated fields from the table: "overuse_group_member" */
  overuse_group_member_aggregate: OveruseGroupMemberAggregate;
  /** fetch data from the table: "overuse_group_member" using primary key columns */
  overuse_group_member_by_pk?: Maybe<OveruseGroupMember>;
  /** fetch data from the table in a streaming manner: "overuse_group_member" */
  overuse_group_member_stream: Array<OveruseGroupMember>;
  /** fetch data from the table in a streaming manner: "overuse_group" */
  overuse_group_stream: Array<OveruseGroup>;
  /** fetch data from the table: "parkdepot_product" */
  parkdepot_product: Array<ParkdepotProduct>;
  /** fetch aggregated fields from the table: "parkdepot_product" */
  parkdepot_product_aggregate: ParkdepotProductAggregate;
  /** fetch data from the table: "parkdepot_product" using primary key columns */
  parkdepot_product_by_pk?: Maybe<ParkdepotProduct>;
  /** fetch data from the table in a streaming manner: "parkdepot_product" */
  parkdepot_product_stream: Array<ParkdepotProduct>;
  /** fetch data from the table: "parking_context" */
  parking_context: Array<ParkingContext>;
  /** fetch aggregated fields from the table: "parking_context" */
  parking_context_aggregate: ParkingContextAggregate;
  /** fetch data from the table: "parking_context" using primary key columns */
  parking_context_by_pk?: Maybe<ParkingContext>;
  /** fetch data from the table in a streaming manner: "parking_context" */
  parking_context_stream: Array<ParkingContext>;
  /** fetch data from the table: "parking_detections" */
  parking_detections: Array<ParkingDetections>;
  /** fetch aggregated fields from the table: "parking_detections" */
  parking_detections_aggregate: ParkingDetectionsAggregate;
  /** fetch data from the table: "parking_detections_archive" */
  parking_detections_archive: Array<ParkingDetectionsArchive>;
  /** fetch aggregated fields from the table: "parking_detections_archive" */
  parking_detections_archive_aggregate: ParkingDetectionsArchiveAggregate;
  /** fetch data from the table: "parking_detections_archive" using primary key columns */
  parking_detections_archive_by_pk?: Maybe<ParkingDetectionsArchive>;
  /** fetch data from the table in a streaming manner: "parking_detections_archive" */
  parking_detections_archive_stream: Array<ParkingDetectionsArchive>;
  /** fetch data from the table: "parking_detections" using primary key columns */
  parking_detections_by_pk?: Maybe<ParkingDetections>;
  /** fetch data from the table in a streaming manner: "parking_detections" */
  parking_detections_stream: Array<ParkingDetections>;
  /** fetch data from the table: "parking_incoming" */
  parking_incoming: Array<ParkingIncoming>;
  /** fetch aggregated fields from the table: "parking_incoming" */
  parking_incoming_aggregate: ParkingIncomingAggregate;
  /** fetch data from the table: "parking_incoming" using primary key columns */
  parking_incoming_by_pk?: Maybe<ParkingIncoming>;
  /** fetch data from the table in a streaming manner: "parking_incoming" */
  parking_incoming_stream: Array<ParkingIncoming>;
  /** fetch data from the table: "parking_processing" */
  parking_processing: Array<ParkingProcessing>;
  /** fetch aggregated fields from the table: "parking_processing" */
  parking_processing_aggregate: ParkingProcessingAggregate;
  /** fetch data from the table: "parking_processing" using primary key columns */
  parking_processing_by_pk?: Maybe<ParkingProcessing>;
  /** fetch data from the table in a streaming manner: "parking_processing" */
  parking_processing_stream: Array<ParkingProcessing>;
  /** fetch data from the table: "parking_results" */
  parking_results: Array<ParkingResults>;
  /** fetch aggregated fields from the table: "parking_results" */
  parking_results_aggregate: ParkingResultsAggregate;
  /** fetch data from the table: "parking_results_archive" */
  parking_results_archive: Array<ParkingResultsArchive>;
  /** fetch aggregated fields from the table: "parking_results_archive" */
  parking_results_archive_aggregate: ParkingResultsArchiveAggregate;
  /** fetch data from the table: "parking_results_archive" using primary key columns */
  parking_results_archive_by_pk?: Maybe<ParkingResultsArchive>;
  /** fetch data from the table in a streaming manner: "parking_results_archive" */
  parking_results_archive_stream: Array<ParkingResultsArchive>;
  /** fetch data from the table: "parking_results" using primary key columns */
  parking_results_by_pk?: Maybe<ParkingResults>;
  /** fetch data from the table in a streaming manner: "parking_results" */
  parking_results_stream: Array<ParkingResults>;
  /** fetch data from the table: "parking_temp" */
  parking_temp: Array<ParkingTemp>;
  /** fetch aggregated fields from the table: "parking_temp" */
  parking_temp_aggregate: ParkingTempAggregate;
  /** fetch data from the table: "parking_temp" using primary key columns */
  parking_temp_by_pk?: Maybe<ParkingTemp>;
  /** fetch data from the table in a streaming manner: "parking_temp" */
  parking_temp_stream: Array<ParkingTemp>;
  /** fetch data from the table: "paybyphone_lot" */
  paybyphone_lot: Array<PaybyphoneLot>;
  /** fetch aggregated fields from the table: "paybyphone_lot" */
  paybyphone_lot_aggregate: PaybyphoneLotAggregate;
  /** fetch data from the table: "paybyphone_lot" using primary key columns */
  paybyphone_lot_by_pk?: Maybe<PaybyphoneLot>;
  /** fetch data from the table in a streaming manner: "paybyphone_lot" */
  paybyphone_lot_stream: Array<PaybyphoneLot>;
  /** fetch data from the table: "paybyphone_order" */
  paybyphone_order: Array<PaybyphoneOrder>;
  /** fetch aggregated fields from the table: "paybyphone_order" */
  paybyphone_order_aggregate: PaybyphoneOrderAggregate;
  /** fetch data from the table: "paybyphone_order" using primary key columns */
  paybyphone_order_by_pk?: Maybe<PaybyphoneOrder>;
  /** fetch data from the table in a streaming manner: "paybyphone_order" */
  paybyphone_order_stream: Array<PaybyphoneOrder>;
  /** fetch data from the table: "person" */
  person: Array<Person>;
  /** fetch aggregated fields from the table: "person" */
  person_aggregate: PersonAggregate;
  /** fetch data from the table: "person" using primary key columns */
  person_by_pk?: Maybe<Person>;
  /** fetch data from the table in a streaming manner: "person" */
  person_stream: Array<Person>;
  /** fetch data from the table: "policy_schedule" */
  policy_schedule: Array<PolicySchedule>;
  /** fetch aggregated fields from the table: "policy_schedule" */
  policy_schedule_aggregate: PolicyScheduleAggregate;
  /** fetch data from the table: "policy_schedule" using primary key columns */
  policy_schedule_by_pk?: Maybe<PolicySchedule>;
  /** fetch data from the table in a streaming manner: "policy_schedule" */
  policy_schedule_stream: Array<PolicySchedule>;
  /** fetch data from the table: "regional_codes_austria" */
  regional_codes_austria: Array<RegionalCodesAustria>;
  /** fetch aggregated fields from the table: "regional_codes_austria" */
  regional_codes_austria_aggregate: RegionalCodesAustriaAggregate;
  /** fetch data from the table: "regional_codes_austria" using primary key columns */
  regional_codes_austria_by_pk?: Maybe<RegionalCodesAustria>;
  /** fetch data from the table in a streaming manner: "regional_codes_austria" */
  regional_codes_austria_stream: Array<RegionalCodesAustria>;
  /** fetch data from the table: "rental_pricing" */
  rental_pricing: Array<RentalPricing>;
  /** fetch aggregated fields from the table: "rental_pricing" */
  rental_pricing_aggregate: RentalPricingAggregate;
  /** fetch data from the table: "rental_pricing" using primary key columns */
  rental_pricing_by_pk?: Maybe<RentalPricing>;
  /** fetch data from the table in a streaming manner: "rental_pricing" */
  rental_pricing_stream: Array<RentalPricing>;
  /** fetch data from the table: "rental_subscription" */
  rental_subscription: Array<RentalSubscription>;
  /** fetch aggregated fields from the table: "rental_subscription" */
  rental_subscription_aggregate: RentalSubscriptionAggregate;
  /** fetch data from the table: "rental_subscription" using primary key columns */
  rental_subscription_by_pk?: Maybe<RentalSubscription>;
  /** fetch data from the table in a streaming manner: "rental_subscription" */
  rental_subscription_stream: Array<RentalSubscription>;
  /** fetch data from the table: "repeat_offense_view" */
  repeat_offense_view: Array<RepeatOffenseView>;
  /** fetch aggregated fields from the table: "repeat_offense_view" */
  repeat_offense_view_aggregate: RepeatOffenseViewAggregate;
  /** fetch data from the table in a streaming manner: "repeat_offense_view" */
  repeat_offense_view_stream: Array<RepeatOffenseView>;
  send_car_owner_requests_germany?: Maybe<SendCarOwnerRequestsGermany>;
  /** fetch data from the table: "serverless_async_work" */
  serverless_async_work: Array<ServerlessAsyncWork>;
  /** fetch aggregated fields from the table: "serverless_async_work" */
  serverless_async_work_aggregate: ServerlessAsyncWorkAggregate;
  /** fetch data from the table: "serverless_async_work" using primary key columns */
  serverless_async_work_by_pk?: Maybe<ServerlessAsyncWork>;
  /** fetch data from the table in a streaming manner: "serverless_async_work" */
  serverless_async_work_stream: Array<ServerlessAsyncWork>;
  /** fetch data from the table: "similar_detections" */
  similar_detections: Array<SimilarDetections>;
  /** fetch aggregated fields from the table: "similar_detections" */
  similar_detections_aggregate: SimilarDetectionsAggregate;
  /** fetch data from the table: "similar_detections" using primary key columns */
  similar_detections_by_pk?: Maybe<SimilarDetections>;
  /** fetch data from the table in a streaming manner: "similar_detections" */
  similar_detections_stream: Array<SimilarDetections>;
  /** An array relationship */
  stages: Array<Stages>;
  /** An aggregate relationship */
  stages_aggregate: StagesAggregate;
  /** fetch data from the table: "stages" using primary key columns */
  stages_by_pk?: Maybe<Stages>;
  /** fetch data from the table in a streaming manner: "stages" */
  stages_stream: Array<Stages>;
  start_generation_of_special_letters?: Maybe<StartGenerationOfSpecialLetters>;
  /** fetch data from the table: "station" */
  station: Array<Station>;
  /** fetch aggregated fields from the table: "station" */
  station_aggregate: StationAggregate;
  /** fetch data from the table: "station" using primary key columns */
  station_by_pk?: Maybe<Station>;
  /** fetch data from the table in a streaming manner: "station" */
  station_stream: Array<Station>;
  /** fetch data from the table: "supervision_car_rental_partners" */
  supervision_car_rental_partners: Array<SupervisionCarRentalPartners>;
  /** fetch aggregated fields from the table: "supervision_car_rental_partners" */
  supervision_car_rental_partners_aggregate: SupervisionCarRentalPartnersAggregate;
  /** fetch data from the table: "supervision_car_rental_partners" using primary key columns */
  supervision_car_rental_partners_by_pk?: Maybe<SupervisionCarRentalPartners>;
  /** fetch data from the table in a streaming manner: "supervision_car_rental_partners" */
  supervision_car_rental_partners_stream: Array<SupervisionCarRentalPartners>;
  /** fetch data from the table: "supervision_debt_collection_case" */
  supervision_debt_collection_case: Array<SupervisionDebtCollectionCase>;
  /** fetch aggregated fields from the table: "supervision_debt_collection_case" */
  supervision_debt_collection_case_aggregate: SupervisionDebtCollectionCaseAggregate;
  /** fetch data from the table: "supervision_debt_collection_case" using primary key columns */
  supervision_debt_collection_case_by_pk?: Maybe<SupervisionDebtCollectionCase>;
  /** fetch data from the table in a streaming manner: "supervision_debt_collection_case" */
  supervision_debt_collection_case_stream: Array<SupervisionDebtCollectionCase>;
  /** fetch data from the table: "supervision_image_requests" */
  supervision_image_requests: Array<SupervisionImageRequests>;
  /** fetch aggregated fields from the table: "supervision_image_requests" */
  supervision_image_requests_aggregate: SupervisionImageRequestsAggregate;
  /** fetch data from the table: "supervision_image_requests" using primary key columns */
  supervision_image_requests_by_pk?: Maybe<SupervisionImageRequests>;
  /** fetch data from the table in a streaming manner: "supervision_image_requests" */
  supervision_image_requests_stream: Array<SupervisionImageRequests>;
  /** fetch data from the table: "supervision_mlp_requests" */
  supervision_mlp_requests: Array<SupervisionMlpRequests>;
  /** fetch aggregated fields from the table: "supervision_mlp_requests" */
  supervision_mlp_requests_aggregate: SupervisionMlpRequestsAggregate;
  /** fetch data from the table: "supervision_mlp_requests" using primary key columns */
  supervision_mlp_requests_by_pk?: Maybe<SupervisionMlpRequests>;
  /** fetch data from the table in a streaming manner: "supervision_mlp_requests" */
  supervision_mlp_requests_stream: Array<SupervisionMlpRequests>;
  /** fetch data from the table: "supervision_multivisit_offender_group" */
  supervision_multivisit_offender_group: Array<SupervisionMultivisitOffenderGroup>;
  /** fetch aggregated fields from the table: "supervision_multivisit_offender_group" */
  supervision_multivisit_offender_group_aggregate: SupervisionMultivisitOffenderGroupAggregate;
  /** fetch data from the table: "supervision_multivisit_offender_group" using primary key columns */
  supervision_multivisit_offender_group_by_pk?: Maybe<SupervisionMultivisitOffenderGroup>;
  /** fetch data from the table: "supervision_multivisit_offender_group_member" */
  supervision_multivisit_offender_group_member: Array<SupervisionMultivisitOffenderGroupMember>;
  /** fetch aggregated fields from the table: "supervision_multivisit_offender_group_member" */
  supervision_multivisit_offender_group_member_aggregate: SupervisionMultivisitOffenderGroupMemberAggregate;
  /** fetch data from the table: "supervision_multivisit_offender_group_member" using primary key columns */
  supervision_multivisit_offender_group_member_by_pk?: Maybe<SupervisionMultivisitOffenderGroupMember>;
  /** fetch data from the table in a streaming manner: "supervision_multivisit_offender_group_member" */
  supervision_multivisit_offender_group_member_stream: Array<SupervisionMultivisitOffenderGroupMember>;
  /** fetch data from the table in a streaming manner: "supervision_multivisit_offender_group" */
  supervision_multivisit_offender_group_stream: Array<SupervisionMultivisitOffenderGroup>;
  /** fetch data from the table: "supervision_ticket_request" */
  supervision_ticket_request: Array<SupervisionTicketRequest>;
  /** fetch aggregated fields from the table: "supervision_ticket_request" */
  supervision_ticket_request_aggregate: SupervisionTicketRequestAggregate;
  /** fetch data from the table: "supervision_ticket_request" using primary key columns */
  supervision_ticket_request_by_pk?: Maybe<SupervisionTicketRequest>;
  /** fetch data from the table in a streaming manner: "supervision_ticket_request" */
  supervision_ticket_request_stream: Array<SupervisionTicketRequest>;
  /** fetch data from the table: "supervision_violation_case_debt_collection_case" */
  supervision_violation_case_debt_collection_case: Array<SupervisionViolationCaseDebtCollectionCase>;
  /** fetch aggregated fields from the table: "supervision_violation_case_debt_collection_case" */
  supervision_violation_case_debt_collection_case_aggregate: SupervisionViolationCaseDebtCollectionCaseAggregate;
  /** fetch data from the table: "supervision_violation_case_debt_collection_case" using primary key columns */
  supervision_violation_case_debt_collection_case_by_pk?: Maybe<SupervisionViolationCaseDebtCollectionCase>;
  /** fetch data from the table in a streaming manner: "supervision_violation_case_debt_collection_case" */
  supervision_violation_case_debt_collection_case_stream: Array<SupervisionViolationCaseDebtCollectionCase>;
  /** fetch data from the table: "tax" */
  tax: Array<Tax>;
  /** fetch aggregated fields from the table: "tax" */
  tax_aggregate: TaxAggregate;
  /** fetch data from the table: "tax" using primary key columns */
  tax_by_pk?: Maybe<Tax>;
  /** fetch data from the table in a streaming manner: "tax" */
  tax_stream: Array<Tax>;
  /** fetch data from the table: "terminal_status" */
  terminal_status: Array<TerminalStatus>;
  /** fetch aggregated fields from the table: "terminal_status" */
  terminal_status_aggregate: TerminalStatusAggregate;
  /** fetch data from the table: "terminal_status" using primary key columns */
  terminal_status_by_pk?: Maybe<TerminalStatus>;
  /** fetch data from the table in a streaming manner: "terminal_status" */
  terminal_status_stream: Array<TerminalStatus>;
  /** fetch data from the table: "ticket_website_feedback" */
  ticket_website_feedback: Array<TicketWebsiteFeedback>;
  /** fetch aggregated fields from the table: "ticket_website_feedback" */
  ticket_website_feedback_aggregate: TicketWebsiteFeedbackAggregate;
  /** fetch data from the table: "ticket_website_feedback" using primary key columns */
  ticket_website_feedback_by_pk?: Maybe<TicketWebsiteFeedback>;
  /** fetch data from the table in a streaming manner: "ticket_website_feedback" */
  ticket_website_feedback_stream: Array<TicketWebsiteFeedback>;
  /** fetch data from the table: "time_discount" */
  time_discount: Array<TimeDiscount>;
  /** fetch aggregated fields from the table: "time_discount" */
  time_discount_aggregate: TimeDiscountAggregate;
  /** fetch data from the table: "time_discount" using primary key columns */
  time_discount_by_pk?: Maybe<TimeDiscount>;
  /** fetch data from the table in a streaming manner: "time_discount" */
  time_discount_stream: Array<TimeDiscount>;
  /** fetch data from the table: "user_preference" */
  user_preference: Array<UserPreference>;
  /** fetch aggregated fields from the table: "user_preference" */
  user_preference_aggregate: UserPreferenceAggregate;
  /** fetch data from the table: "user_preference" using primary key columns */
  user_preference_by_pk?: Maybe<UserPreference>;
  /** fetch data from the table in a streaming manner: "user_preference" */
  user_preference_stream: Array<UserPreference>;
  /** fetch data from the table: "vehicle_type" */
  vehicle_type: Array<VehicleType>;
  /** fetch aggregated fields from the table: "vehicle_type" */
  vehicle_type_aggregate: VehicleTypeAggregate;
  /** fetch data from the table: "vehicle_type" using primary key columns */
  vehicle_type_by_pk?: Maybe<VehicleType>;
  /** fetch data from the table: "vehicle_type_config_group" */
  vehicle_type_config_group: Array<VehicleTypeConfigGroup>;
  /** fetch aggregated fields from the table: "vehicle_type_config_group" */
  vehicle_type_config_group_aggregate: VehicleTypeConfigGroupAggregate;
  /** fetch data from the table: "vehicle_type_config_group" using primary key columns */
  vehicle_type_config_group_by_pk?: Maybe<VehicleTypeConfigGroup>;
  /** fetch data from the table in a streaming manner: "vehicle_type_config_group" */
  vehicle_type_config_group_stream: Array<VehicleTypeConfigGroup>;
  /** fetch data from the table in a streaming manner: "vehicle_type" */
  vehicle_type_stream: Array<VehicleType>;
  /** fetch data from the table: "violation_case" */
  violation_case: Array<ViolationCase>;
  /** fetch aggregated fields from the table: "violation_case" */
  violation_case_aggregate: ViolationCaseAggregate;
  /** fetch data from the table: "violation_case" using primary key columns */
  violation_case_by_pk?: Maybe<ViolationCase>;
  /** An array relationship */
  violation_case_charges: Array<ViolationCaseCharges>;
  /** An aggregate relationship */
  violation_case_charges_aggregate: ViolationCaseChargesAggregate;
  /** fetch data from the table: "violation_case_charges" using primary key columns */
  violation_case_charges_by_pk?: Maybe<ViolationCaseCharges>;
  /** fetch data from the table in a streaming manner: "violation_case_charges" */
  violation_case_charges_stream: Array<ViolationCaseCharges>;
  /** fetch data from the table in a streaming manner: "violation_case" */
  violation_case_stream: Array<ViolationCase>;
  /** fetch data from the table: "violation_case_tags" */
  violation_case_tags: Array<ViolationCaseTags>;
  /** fetch aggregated fields from the table: "violation_case_tags" */
  violation_case_tags_aggregate: ViolationCaseTagsAggregate;
  /** fetch data from the table: "violation_case_tags" using primary key columns */
  violation_case_tags_by_pk?: Maybe<ViolationCaseTags>;
  /** fetch data from the table in a streaming manner: "violation_case_tags" */
  violation_case_tags_stream: Array<ViolationCaseTags>;
  /** fetch data from the table: "violation_event_analysis" */
  violation_event_analysis: Array<ViolationEventAnalysis>;
  /** fetch aggregated fields from the table: "violation_event_analysis" */
  violation_event_analysis_aggregate: ViolationEventAnalysisAggregate;
  /** fetch data from the table: "violation_event_analysis" using primary key columns */
  violation_event_analysis_by_pk?: Maybe<ViolationEventAnalysis>;
  /** fetch data from the table in a streaming manner: "violation_event_analysis" */
  violation_event_analysis_stream: Array<ViolationEventAnalysis>;
  /** An array relationship */
  violator_transactions: Array<ViolatorTransactions>;
  /** An aggregate relationship */
  violator_transactions_aggregate: ViolatorTransactionsAggregate;
  /** fetch data from the table: "violator_transactions" using primary key columns */
  violator_transactions_by_pk?: Maybe<ViolatorTransactions>;
  /** fetch data from the table in a streaming manner: "violator_transactions" */
  violator_transactions_stream: Array<ViolatorTransactions>;
  /** An array relationship */
  whitelist: Array<Whitelist>;
  /** An aggregate relationship */
  whitelist_aggregate: WhitelistAggregate;
  /** fetch data from the table: "whitelist_applied_permit" */
  whitelist_applied_permit: Array<WhitelistAppliedPermit>;
  /** fetch aggregated fields from the table: "whitelist_applied_permit" */
  whitelist_applied_permit_aggregate: WhitelistAppliedPermitAggregate;
  /** fetch data from the table: "whitelist_applied_permit" using primary key columns */
  whitelist_applied_permit_by_pk?: Maybe<WhitelistAppliedPermit>;
  /** fetch data from the table in a streaming manner: "whitelist_applied_permit" */
  whitelist_applied_permit_stream: Array<WhitelistAppliedPermit>;
  /** fetch data from the table: "whitelist" using primary key columns */
  whitelist_by_pk?: Maybe<Whitelist>;
  /** fetch data from the table: "whitelist_by_plate_view" */
  whitelist_by_plate_view: Array<WhitelistByPlateView>;
  /** fetch aggregated fields from the table: "whitelist_by_plate_view" */
  whitelist_by_plate_view_aggregate: WhitelistByPlateViewAggregate;
  /** fetch data from the table in a streaming manner: "whitelist_by_plate_view" */
  whitelist_by_plate_view_stream: Array<WhitelistByPlateView>;
  /** fetch data from the table: "whitelist_calendar_event_policy" */
  whitelist_calendar_event_policy: Array<WhitelistCalendarEventPolicy>;
  /** fetch aggregated fields from the table: "whitelist_calendar_event_policy" */
  whitelist_calendar_event_policy_aggregate: WhitelistCalendarEventPolicyAggregate;
  /** fetch data from the table: "whitelist_calendar_event_policy" using primary key columns */
  whitelist_calendar_event_policy_by_pk?: Maybe<WhitelistCalendarEventPolicy>;
  /** fetch data from the table in a streaming manner: "whitelist_calendar_event_policy" */
  whitelist_calendar_event_policy_stream: Array<WhitelistCalendarEventPolicy>;
  /** fetch data from the table: "whitelist_guest_by_plate_view" */
  whitelist_guest_by_plate_view: Array<WhitelistGuestByPlateView>;
  /** fetch aggregated fields from the table: "whitelist_guest_by_plate_view" */
  whitelist_guest_by_plate_view_aggregate: WhitelistGuestByPlateViewAggregate;
  /** fetch data from the table in a streaming manner: "whitelist_guest_by_plate_view" */
  whitelist_guest_by_plate_view_stream: Array<WhitelistGuestByPlateView>;
  /** fetch data from the table: "whitelist_lp_contingent" */
  whitelist_lp_contingent: Array<WhitelistLpContingent>;
  /** fetch aggregated fields from the table: "whitelist_lp_contingent" */
  whitelist_lp_contingent_aggregate: WhitelistLpContingentAggregate;
  /** fetch data from the table: "whitelist_lp_contingent" using primary key columns */
  whitelist_lp_contingent_by_pk?: Maybe<WhitelistLpContingent>;
  /** fetch data from the table in a streaming manner: "whitelist_lp_contingent" */
  whitelist_lp_contingent_stream: Array<WhitelistLpContingent>;
  /** fetch data from the table: "whitelist_paid_parking" */
  whitelist_paid_parking: Array<WhitelistPaidParking>;
  /** fetch aggregated fields from the table: "whitelist_paid_parking" */
  whitelist_paid_parking_aggregate: WhitelistPaidParkingAggregate;
  /** fetch data from the table: "whitelist_paid_parking" using primary key columns */
  whitelist_paid_parking_by_pk?: Maybe<WhitelistPaidParking>;
  /** fetch data from the table in a streaming manner: "whitelist_paid_parking" */
  whitelist_paid_parking_stream: Array<WhitelistPaidParking>;
  /** fetch data from the table in a streaming manner: "whitelist" */
  whitelist_stream: Array<Whitelist>;
  /** fetch data from the table: "whitelist_subscription" */
  whitelist_subscription: Array<WhitelistSubscription>;
  /** fetch aggregated fields from the table: "whitelist_subscription" */
  whitelist_subscription_aggregate: WhitelistSubscriptionAggregate;
  /** fetch data from the table: "whitelist_subscription" using primary key columns */
  whitelist_subscription_by_pk?: Maybe<WhitelistSubscription>;
  /** fetch data from the table in a streaming manner: "whitelist_subscription" */
  whitelist_subscription_stream: Array<WhitelistSubscription>;
  /** fetch data from the table: "wireguard_config" */
  wireguard_config: Array<WireguardConfig>;
  /** fetch aggregated fields from the table: "wireguard_config" */
  wireguard_config_aggregate: WireguardConfigAggregate;
  /** fetch data from the table: "wireguard_config" using primary key columns */
  wireguard_config_by_pk?: Maybe<WireguardConfig>;
  /** fetch data from the table in a streaming manner: "wireguard_config" */
  wireguard_config_stream: Array<WireguardConfig>;
};


export type SubscriptionRootAdyenReportArgs = {
  distinct_on?: InputMaybe<Array<AdyenReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenReportOrderBy>>;
  where?: InputMaybe<AdyenReportBoolExp>;
};


export type SubscriptionRootAdyenReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdyenReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenReportOrderBy>>;
  where?: InputMaybe<AdyenReportBoolExp>;
};


export type SubscriptionRootAdyenReportByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAdyenReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdyenReportStreamCursorInput>>;
  where?: InputMaybe<AdyenReportBoolExp>;
};


export type SubscriptionRootAdyenTransactionArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


export type SubscriptionRootAdyenTransactionAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdyenTransactionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdyenTransactionOrderBy>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


export type SubscriptionRootAdyenTransactionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAdyenTransactionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdyenTransactionStreamCursorInput>>;
  where?: InputMaybe<AdyenTransactionBoolExp>;
};


export type SubscriptionRootAppliedPermitArgs = {
  distinct_on?: InputMaybe<Array<AppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedPermitOrderBy>>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};


export type SubscriptionRootAppliedPermitAggregateArgs = {
  distinct_on?: InputMaybe<Array<AppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedPermitOrderBy>>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};


export type SubscriptionRootAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootAppliedPermitStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AppliedPermitStreamCursorInput>>;
  where?: InputMaybe<AppliedPermitBoolExp>;
};


export type SubscriptionRootAppliedWhitelistArgs = {
  distinct_on?: InputMaybe<Array<AppliedWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedWhitelistOrderBy>>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};


export type SubscriptionRootAppliedWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<AppliedWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AppliedWhitelistOrderBy>>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};


export type SubscriptionRootAppliedWhitelistByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootAppliedWhitelistStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AppliedWhitelistStreamCursorInput>>;
  where?: InputMaybe<AppliedWhitelistBoolExp>;
};


export type SubscriptionRootAuditLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<AuditLoggedActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditLoggedActionsOrderBy>>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};


export type SubscriptionRootAuditLoggedActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuditLoggedActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditLoggedActionsOrderBy>>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};


export type SubscriptionRootAuditLoggedActionsByPkArgs = {
  event_id: Scalars['bigint'];
};


export type SubscriptionRootAuditLoggedActionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuditLoggedActionsStreamCursorInput>>;
  where?: InputMaybe<AuditLoggedActionsBoolExp>;
};


export type SubscriptionRootBlacklistArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type SubscriptionRootBlacklistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type SubscriptionRootBlacklistByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootBlacklistByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<BlacklistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistByPlateViewOrderBy>>;
  where?: InputMaybe<BlacklistByPlateViewBoolExp>;
};


export type SubscriptionRootBlacklistByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistByPlateViewOrderBy>>;
  where?: InputMaybe<BlacklistByPlateViewBoolExp>;
};


export type SubscriptionRootBlacklistByPlateViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BlacklistByPlateViewStreamCursorInput>>;
  where?: InputMaybe<BlacklistByPlateViewBoolExp>;
};


export type SubscriptionRootBlacklistStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BlacklistStreamCursorInput>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type SubscriptionRootBookingBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


export type SubscriptionRootBookingBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingOrderBy>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


export type SubscriptionRootBookingBookingByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBookingBookingInvoiceArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


export type SubscriptionRootBookingBookingInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingInvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingInvoiceOrderBy>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


export type SubscriptionRootBookingBookingInvoiceByPkArgs = {
  booking_id: Scalars['Int'];
  invoice_id: Scalars['String'];
};


export type SubscriptionRootBookingBookingInvoiceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingBookingInvoiceStreamCursorInput>>;
  where?: InputMaybe<BookingBookingInvoiceBoolExp>;
};


export type SubscriptionRootBookingBookingPlateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


export type SubscriptionRootBookingBookingPlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingPlateOrderBy>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


export type SubscriptionRootBookingBookingPlateByPkArgs = {
  booking_id: Scalars['Int'];
  plate: Scalars['String'];
};


export type SubscriptionRootBookingBookingPlateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingBookingPlateStreamCursorInput>>;
  where?: InputMaybe<BookingBookingPlateBoolExp>;
};


export type SubscriptionRootBookingBookingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingBookingStreamCursorInput>>;
  where?: InputMaybe<BookingBookingBoolExp>;
};


export type SubscriptionRootBookingBookingTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingTypeOrderBy>>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};


export type SubscriptionRootBookingBookingTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingTypeOrderBy>>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};


export type SubscriptionRootBookingBookingTypeByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingBookingTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingBookingTypeStreamCursorInput>>;
  where?: InputMaybe<BookingBookingTypeBoolExp>;
};


export type SubscriptionRootBookingBookingWhitelistArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


export type SubscriptionRootBookingBookingWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingBookingWhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingBookingWhitelistOrderBy>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


export type SubscriptionRootBookingBookingWhitelistByPkArgs = {
  booking_id: Scalars['Int'];
  whitelist_id: Scalars['Int'];
};


export type SubscriptionRootBookingBookingWhitelistStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingBookingWhitelistStreamCursorInput>>;
  where?: InputMaybe<BookingBookingWhitelistBoolExp>;
};


export type SubscriptionRootBookingEnumBookingStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingEnumBookingStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingEnumBookingStatusOrderBy>>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};


export type SubscriptionRootBookingEnumBookingStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingEnumBookingStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingEnumBookingStatusOrderBy>>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};


export type SubscriptionRootBookingEnumBookingStatusByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingEnumBookingStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingEnumBookingStatusStreamCursorInput>>;
  where?: InputMaybe<BookingEnumBookingStatusBoolExp>;
};


export type SubscriptionRootBookingHourlyBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingHourlyBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingHourlyBookingOrderBy>>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};


export type SubscriptionRootBookingHourlyBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingHourlyBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingHourlyBookingOrderBy>>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};


export type SubscriptionRootBookingHourlyBookingByPkArgs = {
  booking_id: Scalars['Int'];
};


export type SubscriptionRootBookingHourlyBookingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingHourlyBookingStreamCursorInput>>;
  where?: InputMaybe<BookingHourlyBookingBoolExp>;
};


export type SubscriptionRootBookingLicensePlateArgs = {
  distinct_on?: InputMaybe<Array<BookingLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLicensePlateOrderBy>>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};


export type SubscriptionRootBookingLicensePlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLicensePlateOrderBy>>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};


export type SubscriptionRootBookingLicensePlateByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBookingLicensePlateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingLicensePlateStreamCursorInput>>;
  where?: InputMaybe<BookingLicensePlateBoolExp>;
};


export type SubscriptionRootBookingLotArgs = {
  distinct_on?: InputMaybe<Array<BookingLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotOrderBy>>;
  where?: InputMaybe<BookingLotBoolExp>;
};


export type SubscriptionRootBookingLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotOrderBy>>;
  where?: InputMaybe<BookingLotBoolExp>;
};


export type SubscriptionRootBookingLotByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootBookingLotConfigurationArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


export type SubscriptionRootBookingLotConfigurationAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingLotConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingLotConfigurationOrderBy>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


export type SubscriptionRootBookingLotConfigurationByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootBookingLotConfigurationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingLotConfigurationStreamCursorInput>>;
  where?: InputMaybe<BookingLotConfigurationBoolExp>;
};


export type SubscriptionRootBookingLotStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingLotStreamCursorInput>>;
  where?: InputMaybe<BookingLotBoolExp>;
};


export type SubscriptionRootBookingPaymentArgs = {
  distinct_on?: InputMaybe<Array<BookingPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPaymentOrderBy>>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};


export type SubscriptionRootBookingPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPaymentOrderBy>>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};


export type SubscriptionRootBookingPaymentByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBookingPaymentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingPaymentStreamCursorInput>>;
  where?: InputMaybe<BookingPaymentBoolExp>;
};


export type SubscriptionRootBookingPricingRulesArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


export type SubscriptionRootBookingPricingRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingRulesOrderBy>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


export type SubscriptionRootBookingPricingRulesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBookingPricingRulesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingPricingRulesStreamCursorInput>>;
  where?: InputMaybe<BookingPricingRulesBoolExp>;
};


export type SubscriptionRootBookingPricingTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingTypeOrderBy>>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};


export type SubscriptionRootBookingPricingTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPricingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPricingTypeOrderBy>>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};


export type SubscriptionRootBookingPricingTypeByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingPricingTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingPricingTypeStreamCursorInput>>;
  where?: InputMaybe<BookingPricingTypeBoolExp>;
};


export type SubscriptionRootBookingPrivatePricingUserArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


export type SubscriptionRootBookingPrivatePricingUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingPrivatePricingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingPrivatePricingUserOrderBy>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


export type SubscriptionRootBookingPrivatePricingUserByPkArgs = {
  price_model_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};


export type SubscriptionRootBookingPrivatePricingUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingPrivatePricingUserStreamCursorInput>>;
  where?: InputMaybe<BookingPrivatePricingUserBoolExp>;
};


export type SubscriptionRootBookingRecurringBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


export type SubscriptionRootBookingRecurringBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingRecurringBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingRecurringBookingOrderBy>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


export type SubscriptionRootBookingRecurringBookingByPkArgs = {
  booking_id: Scalars['Int'];
  iso_duration: Scalars['String'];
  rrule: Scalars['String'];
};


export type SubscriptionRootBookingRecurringBookingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingRecurringBookingStreamCursorInput>>;
  where?: InputMaybe<BookingRecurringBookingBoolExp>;
};


export type SubscriptionRootBookingSubscriptionBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


export type SubscriptionRootBookingSubscriptionBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionBookingOrderBy>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


export type SubscriptionRootBookingSubscriptionBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


export type SubscriptionRootBookingSubscriptionBookingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingSubscriptionBookingStreamCursorInput>>;
  where?: InputMaybe<BookingSubscriptionBookingBoolExp>;
};


export type SubscriptionRootBookingSubscriptionLicensePlateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


export type SubscriptionRootBookingSubscriptionLicensePlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionLicensePlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionLicensePlateOrderBy>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


export type SubscriptionRootBookingSubscriptionLicensePlateByPkArgs = {
  license_plate_id: Scalars['uuid'];
  user_subscription_id: Scalars['uuid'];
};


export type SubscriptionRootBookingSubscriptionLicensePlateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingSubscriptionLicensePlateStreamCursorInput>>;
  where?: InputMaybe<BookingSubscriptionLicensePlateBoolExp>;
};


export type SubscriptionRootBookingSubscriptionStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionStatusOrderBy>>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};


export type SubscriptionRootBookingSubscriptionStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingSubscriptionStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingSubscriptionStatusOrderBy>>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};


export type SubscriptionRootBookingSubscriptionStatusByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingSubscriptionStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingSubscriptionStatusStreamCursorInput>>;
  where?: InputMaybe<BookingSubscriptionStatusBoolExp>;
};


export type SubscriptionRootBookingUserArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserOrderBy>>;
  where?: InputMaybe<BookingUserBoolExp>;
};


export type SubscriptionRootBookingUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserOrderBy>>;
  where?: InputMaybe<BookingUserBoolExp>;
};


export type SubscriptionRootBookingUserBookingArgs = {
  distinct_on?: InputMaybe<Array<BookingUserBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserBookingOrderBy>>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};


export type SubscriptionRootBookingUserBookingAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserBookingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserBookingOrderBy>>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};


export type SubscriptionRootBookingUserBookingByPkArgs = {
  booking_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};


export type SubscriptionRootBookingUserBookingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingUserBookingStreamCursorInput>>;
  where?: InputMaybe<BookingUserBookingBoolExp>;
};


export type SubscriptionRootBookingUserByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBookingUserPaymentMethodArgs = {
  distinct_on?: InputMaybe<Array<BookingUserPaymentMethodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserPaymentMethodOrderBy>>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};


export type SubscriptionRootBookingUserPaymentMethodAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserPaymentMethodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserPaymentMethodOrderBy>>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};


export type SubscriptionRootBookingUserPaymentMethodByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBookingUserPaymentMethodStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingUserPaymentMethodStreamCursorInput>>;
  where?: InputMaybe<BookingUserPaymentMethodBoolExp>;
};


export type SubscriptionRootBookingUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingUserStreamCursorInput>>;
  where?: InputMaybe<BookingUserBoolExp>;
};


export type SubscriptionRootBookingUserSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserSubscriptionOrderBy>>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};


export type SubscriptionRootBookingUserSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingUserSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingUserSubscriptionOrderBy>>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};


export type SubscriptionRootBookingUserSubscriptionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBookingUserSubscriptionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingUserSubscriptionStreamCursorInput>>;
  where?: InputMaybe<BookingUserSubscriptionBoolExp>;
};


export type SubscriptionRootBookingVehicleArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleOrderBy>>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};


export type SubscriptionRootBookingVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleOrderBy>>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};


export type SubscriptionRootBookingVehicleByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBookingVehicleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingVehicleStreamCursorInput>>;
  where?: InputMaybe<BookingVehicleBoolExp>;
};


export type SubscriptionRootBookingVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleTypeOrderBy>>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};


export type SubscriptionRootBookingVehicleTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingVehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingVehicleTypeOrderBy>>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};


export type SubscriptionRootBookingVehicleTypeByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingVehicleTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingVehicleTypeStreamCursorInput>>;
  where?: InputMaybe<BookingVehicleTypeBoolExp>;
};


export type SubscriptionRootBookingWhitelistTypeArgs = {
  distinct_on?: InputMaybe<Array<BookingWhitelistTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingWhitelistTypeOrderBy>>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};


export type SubscriptionRootBookingWhitelistTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingWhitelistTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BookingWhitelistTypeOrderBy>>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};


export type SubscriptionRootBookingWhitelistTypeByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootBookingWhitelistTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BookingWhitelistTypeStreamCursorInput>>;
  where?: InputMaybe<BookingWhitelistTypeBoolExp>;
};


export type SubscriptionRootCalendarEventPolicyArgs = {
  distinct_on?: InputMaybe<Array<CalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CalendarEventPolicyOrderBy>>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};


export type SubscriptionRootCalendarEventPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CalendarEventPolicyOrderBy>>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};


export type SubscriptionRootCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCalendarEventPolicyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarEventPolicyStreamCursorInput>>;
  where?: InputMaybe<CalendarEventPolicyBoolExp>;
};


export type SubscriptionRootCancellationReasonViewArgs = {
  distinct_on?: InputMaybe<Array<CancellationReasonViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationReasonViewOrderBy>>;
  where?: InputMaybe<CancellationReasonViewBoolExp>;
};


export type SubscriptionRootCancellationReasonViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationReasonViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationReasonViewOrderBy>>;
  where?: InputMaybe<CancellationReasonViewBoolExp>;
};


export type SubscriptionRootCancellationReasonViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancellationReasonViewStreamCursorInput>>;
  where?: InputMaybe<CancellationReasonViewBoolExp>;
};


export type SubscriptionRootCancellationsArgs = {
  distinct_on?: InputMaybe<Array<CancellationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationsOrderBy>>;
  where?: InputMaybe<CancellationsBoolExp>;
};


export type SubscriptionRootCancellationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationsOrderBy>>;
  where?: InputMaybe<CancellationsBoolExp>;
};


export type SubscriptionRootCancellationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCancellationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancellationsStreamCursorInput>>;
  where?: InputMaybe<CancellationsBoolExp>;
};


export type SubscriptionRootCarDriverArgs = {
  distinct_on?: InputMaybe<Array<CarDriverSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarDriverOrderBy>>;
  where?: InputMaybe<CarDriverBoolExp>;
};


export type SubscriptionRootCarDriverAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarDriverSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarDriverOrderBy>>;
  where?: InputMaybe<CarDriverBoolExp>;
};


export type SubscriptionRootCarDriverByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarDriverStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarDriverStreamCursorInput>>;
  where?: InputMaybe<CarDriverBoolExp>;
};


export type SubscriptionRootCarOwnerArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


export type SubscriptionRootCarOwnerAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerOrderBy>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


export type SubscriptionRootCarOwnerByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarOwnerRequestsArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerRequestsOrderBy>>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};


export type SubscriptionRootCarOwnerRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarOwnerRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarOwnerRequestsOrderBy>>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};


export type SubscriptionRootCarOwnerRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarOwnerRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarOwnerRequestsStreamCursorInput>>;
  where?: InputMaybe<CarOwnerRequestsBoolExp>;
};


export type SubscriptionRootCarOwnerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarOwnerStreamCursorInput>>;
  where?: InputMaybe<CarOwnerBoolExp>;
};


export type SubscriptionRootCarpayAccessControlLpPinArgs = {
  distinct_on?: InputMaybe<Array<CarpayAccessControlLpPinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayAccessControlLpPinOrderBy>>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};


export type SubscriptionRootCarpayAccessControlLpPinAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayAccessControlLpPinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayAccessControlLpPinOrderBy>>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};


export type SubscriptionRootCarpayAccessControlLpPinByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayAccessControlLpPinStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayAccessControlLpPinStreamCursorInput>>;
  where?: InputMaybe<CarpayAccessControlLpPinBoolExp>;
};


export type SubscriptionRootCarpayDiscountBatchArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


export type SubscriptionRootCarpayDiscountBatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountBatchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountBatchOrderBy>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


export type SubscriptionRootCarpayDiscountBatchByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayDiscountBatchStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayDiscountBatchStreamCursorInput>>;
  where?: InputMaybe<CarpayDiscountBatchBoolExp>;
};


export type SubscriptionRootCarpayDiscountModelArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


export type SubscriptionRootCarpayDiscountModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayDiscountModelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayDiscountModelOrderBy>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


export type SubscriptionRootCarpayDiscountModelByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayDiscountModelStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayDiscountModelStreamCursorInput>>;
  where?: InputMaybe<CarpayDiscountModelBoolExp>;
};


export type SubscriptionRootCarpayLotArgs = {
  distinct_on?: InputMaybe<Array<CarpayLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayLotOrderBy>>;
  where?: InputMaybe<CarpayLotBoolExp>;
};


export type SubscriptionRootCarpayLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayLotOrderBy>>;
  where?: InputMaybe<CarpayLotBoolExp>;
};


export type SubscriptionRootCarpayLotByPkArgs = {
  lot_id: Scalars['String'];
};


export type SubscriptionRootCarpayLotStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayLotStreamCursorInput>>;
  where?: InputMaybe<CarpayLotBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriberArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriberOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriberAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriberOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriberByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayNotificationSubscriberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayNotificationSubscriberStreamCursorInput>>;
  where?: InputMaybe<CarpayNotificationSubscriberBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionByPkArgs = {
  category_id: Scalars['Int'];
  lot_id: Scalars['String'];
  subscriber_id: Scalars['Int'];
};


export type SubscriptionRootCarpayNotificationSubscriptionCategoryArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayNotificationSubscriptionCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayNotificationSubscriptionCategoryOrderBy>>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionCategoryByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayNotificationSubscriptionCategoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayNotificationSubscriptionCategoryStreamCursorInput>>;
  where?: InputMaybe<CarpayNotificationSubscriptionCategoryBoolExp>;
};


export type SubscriptionRootCarpayNotificationSubscriptionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayNotificationSubscriptionStreamCursorInput>>;
  where?: InputMaybe<CarpayNotificationSubscriptionBoolExp>;
};


export type SubscriptionRootCarpayOrderArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


export type SubscriptionRootCarpayOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderOrderBy>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


export type SubscriptionRootCarpayOrderByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarpayOrderMatchesArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


export type SubscriptionRootCarpayOrderMatchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderMatchesOrderBy>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


export type SubscriptionRootCarpayOrderMatchesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayOrderMatchesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayOrderMatchesStreamCursorInput>>;
  where?: InputMaybe<CarpayOrderMatchesBoolExp>;
};


export type SubscriptionRootCarpayOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayOrderStreamCursorInput>>;
  where?: InputMaybe<CarpayOrderBoolExp>;
};


export type SubscriptionRootCarpayOrderUserArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderUserOrderBy>>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};


export type SubscriptionRootCarpayOrderUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayOrderUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayOrderUserOrderBy>>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};


export type SubscriptionRootCarpayOrderUserByPkArgs = {
  order_id: Scalars['Int'];
};


export type SubscriptionRootCarpayOrderUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayOrderUserStreamCursorInput>>;
  where?: InputMaybe<CarpayOrderUserBoolExp>;
};


export type SubscriptionRootCarpayParkingDetectionArgs = {
  distinct_on?: InputMaybe<Array<CarpayParkingDetectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayParkingDetectionOrderBy>>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};


export type SubscriptionRootCarpayParkingDetectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayParkingDetectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayParkingDetectionOrderBy>>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};


export type SubscriptionRootCarpayParkingDetectionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayParkingDetectionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayParkingDetectionStreamCursorInput>>;
  where?: InputMaybe<CarpayParkingDetectionBoolExp>;
};


export type SubscriptionRootCarpayPricingArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


export type SubscriptionRootCarpayPricingAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingOrderBy>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


export type SubscriptionRootCarpayPricingByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayPricingConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingConfigGroupOrderBy>>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};


export type SubscriptionRootCarpayPricingConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingConfigGroupOrderBy>>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};


export type SubscriptionRootCarpayPricingConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarpayPricingConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayPricingConfigGroupStreamCursorInput>>;
  where?: InputMaybe<CarpayPricingConfigGroupBoolExp>;
};


export type SubscriptionRootCarpayPricingPeriodArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


export type SubscriptionRootCarpayPricingPeriodAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingPeriodOrderBy>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


export type SubscriptionRootCarpayPricingPeriodByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootCarpayPricingPeriodStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayPricingPeriodStreamCursorInput>>;
  where?: InputMaybe<CarpayPricingPeriodBoolExp>;
};


export type SubscriptionRootCarpayPricingRecurrenceArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


export type SubscriptionRootCarpayPricingRecurrenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRecurrenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRecurrenceOrderBy>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


export type SubscriptionRootCarpayPricingRecurrenceByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootCarpayPricingRecurrenceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayPricingRecurrenceStreamCursorInput>>;
  where?: InputMaybe<CarpayPricingRecurrenceBoolExp>;
};


export type SubscriptionRootCarpayPricingRulesArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRulesOrderBy>>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};


export type SubscriptionRootCarpayPricingRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayPricingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayPricingRulesOrderBy>>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};


export type SubscriptionRootCarpayPricingRulesByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootCarpayPricingRulesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayPricingRulesStreamCursorInput>>;
  where?: InputMaybe<CarpayPricingRulesBoolExp>;
};


export type SubscriptionRootCarpayPricingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayPricingStreamCursorInput>>;
  where?: InputMaybe<CarpayPricingBoolExp>;
};


export type SubscriptionRootCarpayScannedCodesArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


export type SubscriptionRootCarpayScannedCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayScannedCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayScannedCodesOrderBy>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


export type SubscriptionRootCarpayScannedCodesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCarpayScannedCodesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayScannedCodesStreamCursorInput>>;
  where?: InputMaybe<CarpayScannedCodesBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashCutNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashCutNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashCutNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashCutNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashCutNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashCutNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashCutNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayTerminalCashCutNotificationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayTerminalCashCutNotificationStreamCursorInput>>;
  where?: InputMaybe<CarpayTerminalCashCutNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashFillLevelNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashFillLevelNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalCashFillLevelNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalCashFillLevelNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayTerminalCashFillLevelNotificationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayTerminalCashFillLevelNotificationStreamCursorInput>>;
  where?: InputMaybe<CarpayTerminalCashFillLevelNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalNotificationConfigArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalNotificationConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalNotificationConfigOrderBy>>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};


export type SubscriptionRootCarpayTerminalNotificationConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalNotificationConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalNotificationConfigOrderBy>>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};


export type SubscriptionRootCarpayTerminalNotificationConfigByPkArgs = {
  lot_id: Scalars['String'];
};


export type SubscriptionRootCarpayTerminalNotificationConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayTerminalNotificationConfigStreamCursorInput>>;
  where?: InputMaybe<CarpayTerminalNotificationConfigBoolExp>;
};


export type SubscriptionRootCarpayTerminalPrinterStatusNotificationArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalPrinterStatusNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayTerminalPrinterStatusNotificationOrderBy>>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};


export type SubscriptionRootCarpayTerminalPrinterStatusNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCarpayTerminalPrinterStatusNotificationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayTerminalPrinterStatusNotificationStreamCursorInput>>;
  where?: InputMaybe<CarpayTerminalPrinterStatusNotificationBoolExp>;
};


export type SubscriptionRootCarpayUserVerifiedPlateArgs = {
  distinct_on?: InputMaybe<Array<CarpayUserVerifiedPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayUserVerifiedPlateOrderBy>>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};


export type SubscriptionRootCarpayUserVerifiedPlateAggregateArgs = {
  distinct_on?: InputMaybe<Array<CarpayUserVerifiedPlateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CarpayUserVerifiedPlateOrderBy>>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};


export type SubscriptionRootCarpayUserVerifiedPlateByPkArgs = {
  normalized_plate: Scalars['String'];
  user_id: Scalars['uuid'];
};


export type SubscriptionRootCarpayUserVerifiedPlateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CarpayUserVerifiedPlateStreamCursorInput>>;
  where?: InputMaybe<CarpayUserVerifiedPlateBoolExp>;
};


export type SubscriptionRootChainArgs = {
  distinct_on?: InputMaybe<Array<ChainSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChainOrderBy>>;
  where?: InputMaybe<ChainBoolExp>;
};


export type SubscriptionRootChainAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChainSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChainOrderBy>>;
  where?: InputMaybe<ChainBoolExp>;
};


export type SubscriptionRootChainByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootChainStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ChainStreamCursorInput>>;
  where?: InputMaybe<ChainBoolExp>;
};


export type SubscriptionRootCityCodesArgs = {
  distinct_on?: InputMaybe<Array<CityCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CityCodesOrderBy>>;
  where?: InputMaybe<CityCodesBoolExp>;
};


export type SubscriptionRootCityCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CityCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CityCodesOrderBy>>;
  where?: InputMaybe<CityCodesBoolExp>;
};


export type SubscriptionRootCityCodesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CityCodesStreamCursorInput>>;
  where?: InputMaybe<CityCodesBoolExp>;
};


export type SubscriptionRootCompanyArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCompanyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCompanyByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCompanyConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<CompanyConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyConfigGroupOrderBy>>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};


export type SubscriptionRootCompanyConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyConfigGroupOrderBy>>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};


export type SubscriptionRootCompanyConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCompanyConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyConfigGroupStreamCursorInput>>;
  where?: InputMaybe<CompanyConfigGroupBoolExp>;
};


export type SubscriptionRootCompanyHierarchyArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


export type SubscriptionRootCompanyHierarchyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyHierarchyOrderBy>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


export type SubscriptionRootCompanyHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootCompanyHierarchyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyHierarchyStreamCursorInput>>;
  where?: InputMaybe<CompanyHierarchyBoolExp>;
};


export type SubscriptionRootCompanyLotSectionArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


export type SubscriptionRootCompanyLotSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyLotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyLotSectionOrderBy>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


export type SubscriptionRootCompanyLotSectionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCompanyLotSectionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyLotSectionStreamCursorInput>>;
  where?: InputMaybe<CompanyLotSectionBoolExp>;
};


export type SubscriptionRootCompanyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyStreamCursorInput>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCompanyVatIdArgs = {
  distinct_on?: InputMaybe<Array<CompanyVatIdSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyVatIdOrderBy>>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};


export type SubscriptionRootCompanyVatIdAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyVatIdSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyVatIdOrderBy>>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};


export type SubscriptionRootCompanyVatIdByPkArgs = {
  company_id: Scalars['String'];
};


export type SubscriptionRootCompanyVatIdStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyVatIdStreamCursorInput>>;
  where?: InputMaybe<CompanyVatIdBoolExp>;
};


export type SubscriptionRootCompanyViolatorArgs = {
  distinct_on?: InputMaybe<Array<CompanyViolatorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyViolatorOrderBy>>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};


export type SubscriptionRootCompanyViolatorAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyViolatorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyViolatorOrderBy>>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};


export type SubscriptionRootCompanyViolatorByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCompanyViolatorStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyViolatorStreamCursorInput>>;
  where?: InputMaybe<CompanyViolatorBoolExp>;
};


export type SubscriptionRootConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<ConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigGroupOrderBy>>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};


export type SubscriptionRootConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigGroupOrderBy>>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};


export type SubscriptionRootConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigGroupStreamCursorInput>>;
  where?: InputMaybe<ConfigGroupBoolExp>;
};


export type SubscriptionRootCountryArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type SubscriptionRootCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type SubscriptionRootCountryByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootCountryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CountryStreamCursorInput>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type SubscriptionRootCreateDriverInformationRequestArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type SubscriptionRootCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type SubscriptionRootCurrencyByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootCurrencyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CurrencyStreamCursorInput>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type SubscriptionRootCustomerDashboardNpsFeedbackArgs = {
  distinct_on?: InputMaybe<Array<CustomerDashboardNpsFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomerDashboardNpsFeedbackOrderBy>>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};


export type SubscriptionRootCustomerDashboardNpsFeedbackAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomerDashboardNpsFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomerDashboardNpsFeedbackOrderBy>>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};


export type SubscriptionRootCustomerDashboardNpsFeedbackByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCustomerDashboardNpsFeedbackStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomerDashboardNpsFeedbackStreamCursorInput>>;
  where?: InputMaybe<CustomerDashboardNpsFeedbackBoolExp>;
};


export type SubscriptionRootDailyFailureArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


export type SubscriptionRootDailyFailureAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyFailureSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyFailureOrderBy>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


export type SubscriptionRootDailyFailureByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDailyFailureStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DailyFailureStreamCursorInput>>;
  where?: InputMaybe<DailyFailureBoolExp>;
};


export type SubscriptionRootDailyStatsArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


export type SubscriptionRootDailyStatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DailyStatsOrderBy>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


export type SubscriptionRootDailyStatsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDailyStatsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DailyStatsStreamCursorInput>>;
  where?: InputMaybe<DailyStatsBoolExp>;
};


export type SubscriptionRootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootDepartmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootDepartmentByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootDepartmentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DepartmentStreamCursorInput>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootDetectionTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<DetectionTypeEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionTypeEnumOrderBy>>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};


export type SubscriptionRootDetectionTypeEnumAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionTypeEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionTypeEnumOrderBy>>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};


export type SubscriptionRootDetectionTypeEnumByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootDetectionTypeEnumStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DetectionTypeEnumStreamCursorInput>>;
  where?: InputMaybe<DetectionTypeEnumBoolExp>;
};


export type SubscriptionRootDeviceArgs = {
  distinct_on?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type SubscriptionRootDeviceAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type SubscriptionRootDeviceByPkArgs = {
  uuid: Scalars['String'];
};


export type SubscriptionRootDeviceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DeviceStreamCursorInput>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type SubscriptionRootEasyparkLotArgs = {
  distinct_on?: InputMaybe<Array<EasyparkLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkLotOrderBy>>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};


export type SubscriptionRootEasyparkLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkLotOrderBy>>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};


export type SubscriptionRootEasyparkLotByPkArgs = {
  uuid: Scalars['bigint'];
};


export type SubscriptionRootEasyparkLotStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EasyparkLotStreamCursorInput>>;
  where?: InputMaybe<EasyparkLotBoolExp>;
};


export type SubscriptionRootEasyparkOrderArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


export type SubscriptionRootEasyparkOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderOrderBy>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


export type SubscriptionRootEasyparkOrderByPkArgs = {
  uuid: Scalars['bigint'];
};


export type SubscriptionRootEasyparkOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EasyparkOrderStreamCursorInput>>;
  where?: InputMaybe<EasyparkOrderBoolExp>;
};


export type SubscriptionRootEasyparkOrderV2Args = {
  distinct_on?: InputMaybe<Array<EasyparkOrderV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderV2OrderBy>>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};


export type SubscriptionRootEasyparkOrderV2AggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkOrderV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkOrderV2OrderBy>>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};


export type SubscriptionRootEasyparkOrderV2ByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootEasyparkOrderV2StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EasyparkOrderV2StreamCursorInput>>;
  where?: InputMaybe<EasyparkOrderV2BoolExp>;
};


export type SubscriptionRootEasyparkParkingInfoArgs = {
  distinct_on?: InputMaybe<Array<EasyparkParkingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkParkingInfoOrderBy>>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};


export type SubscriptionRootEasyparkParkingInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<EasyparkParkingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EasyparkParkingInfoOrderBy>>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};


export type SubscriptionRootEasyparkParkingInfoByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootEasyparkParkingInfoStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EasyparkParkingInfoStreamCursorInput>>;
  where?: InputMaybe<EasyparkParkingInfoBoolExp>;
};


export type SubscriptionRootEnforcementDailyStatsArgs = {
  distinct_on?: InputMaybe<Array<EnforcementDailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnforcementDailyStatsOrderBy>>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};


export type SubscriptionRootEnforcementDailyStatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnforcementDailyStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnforcementDailyStatsOrderBy>>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};


export type SubscriptionRootEnforcementDailyStatsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootEnforcementDailyStatsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnforcementDailyStatsStreamCursorInput>>;
  where?: InputMaybe<EnforcementDailyStatsBoolExp>;
};


export type SubscriptionRootEnumCarpayDiscountModelCodeTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeOrderBy>>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};


export type SubscriptionRootEnumCarpayDiscountModelCodeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCarpayDiscountModelCodeTypeOrderBy>>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};


export type SubscriptionRootEnumCarpayDiscountModelCodeTypeByPkArgs = {
  code_type: Scalars['String'];
};


export type SubscriptionRootEnumCarpayDiscountModelCodeTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumCarpayDiscountModelCodeTypeStreamCursorInput>>;
  where?: InputMaybe<EnumCarpayDiscountModelCodeTypeBoolExp>;
};


export type SubscriptionRootEnumCountryCodeArgs = {
  distinct_on?: InputMaybe<Array<EnumCountryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCountryCodeOrderBy>>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};


export type SubscriptionRootEnumCountryCodeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCountryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCountryCodeOrderBy>>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};


export type SubscriptionRootEnumCountryCodeByPkArgs = {
  country: Scalars['String'];
};


export type SubscriptionRootEnumCountryCodeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumCountryCodeStreamCursorInput>>;
  where?: InputMaybe<EnumCountryCodeBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistPurposeArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistPurposeOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistPurposeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistPurposeOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistPurposeByPkArgs = {
  purpose: Scalars['String'];
};


export type SubscriptionRootEnumCustomerWhitelistPurposeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumCustomerWhitelistPurposeStreamCursorInput>>;
  where?: InputMaybe<EnumCustomerWhitelistPurposeBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCustomerWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumCustomerWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumCustomerWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootEnumCustomerWhitelistStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumCustomerWhitelistStatusStreamCursorInput>>;
  where?: InputMaybe<EnumCustomerWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumDeviceTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumDeviceTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDeviceTypeOrderBy>>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};


export type SubscriptionRootEnumDeviceTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumDeviceTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDeviceTypeOrderBy>>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};


export type SubscriptionRootEnumDeviceTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootEnumDeviceTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumDeviceTypeStreamCursorInput>>;
  where?: InputMaybe<EnumDeviceTypeBoolExp>;
};


export type SubscriptionRootEnumDriverRequestTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumDriverRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDriverRequestTypeOrderBy>>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};


export type SubscriptionRootEnumDriverRequestTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumDriverRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumDriverRequestTypeOrderBy>>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};


export type SubscriptionRootEnumDriverRequestTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootEnumDriverRequestTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumDriverRequestTypeStreamCursorInput>>;
  where?: InputMaybe<EnumDriverRequestTypeBoolExp>;
};


export type SubscriptionRootEnumGuestJwtPurposeArgs = {
  distinct_on?: InputMaybe<Array<EnumGuestJwtPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumGuestJwtPurposeOrderBy>>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};


export type SubscriptionRootEnumGuestJwtPurposeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumGuestJwtPurposeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumGuestJwtPurposeOrderBy>>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};


export type SubscriptionRootEnumGuestJwtPurposeByPkArgs = {
  purpose: Scalars['String'];
};


export type SubscriptionRootEnumGuestJwtPurposeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumGuestJwtPurposeStreamCursorInput>>;
  where?: InputMaybe<EnumGuestJwtPurposeBoolExp>;
};


export type SubscriptionRootEnumSupervisionMlpRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumSupervisionMlpRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumSupervisionMlpRequestStatusOrderBy>>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};


export type SubscriptionRootEnumSupervisionMlpRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumSupervisionMlpRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumSupervisionMlpRequestStatusOrderBy>>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};


export type SubscriptionRootEnumSupervisionMlpRequestStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootEnumSupervisionMlpRequestStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumSupervisionMlpRequestStatusStreamCursorInput>>;
  where?: InputMaybe<EnumSupervisionMlpRequestStatusBoolExp>;
};


export type SubscriptionRootEnumViolationCancellationArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCancellationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCancellationOrderBy>>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};


export type SubscriptionRootEnumViolationCancellationAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCancellationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCancellationOrderBy>>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};


export type SubscriptionRootEnumViolationCancellationByPkArgs = {
  violation_cancellation: Scalars['String'];
};


export type SubscriptionRootEnumViolationCancellationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumViolationCancellationStreamCursorInput>>;
  where?: InputMaybe<EnumViolationCancellationBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesInvalidationReasonArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesInvalidationReasonAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesInvalidationReasonOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesInvalidationReasonByPkArgs = {
  invalidation_reason: Scalars['String'];
};


export type SubscriptionRootEnumViolationCaseChargesInvalidationReasonStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumViolationCaseChargesInvalidationReasonStreamCursorInput>>;
  where?: InputMaybe<EnumViolationCaseChargesInvalidationReasonBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesTypeOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumViolationCaseChargesTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumViolationCaseChargesTypeOrderBy>>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};


export type SubscriptionRootEnumViolationCaseChargesTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootEnumViolationCaseChargesTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumViolationCaseChargesTypeStreamCursorInput>>;
  where?: InputMaybe<EnumViolationCaseChargesTypeBoolExp>;
};


export type SubscriptionRootEnumWhitelistPaidParkingTypesArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistPaidParkingTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistPaidParkingTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};


export type SubscriptionRootEnumWhitelistPaidParkingTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistPaidParkingTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistPaidParkingTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};


export type SubscriptionRootEnumWhitelistPaidParkingTypesByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootEnumWhitelistPaidParkingTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumWhitelistPaidParkingTypesStreamCursorInput>>;
  where?: InputMaybe<EnumWhitelistPaidParkingTypesBoolExp>;
};


export type SubscriptionRootEnumWhitelistScopeArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistScopeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistScopeOrderBy>>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};


export type SubscriptionRootEnumWhitelistScopeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistScopeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistScopeOrderBy>>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};


export type SubscriptionRootEnumWhitelistScopeByPkArgs = {
  scope: Scalars['String'];
};


export type SubscriptionRootEnumWhitelistScopeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumWhitelistScopeStreamCursorInput>>;
  where?: InputMaybe<EnumWhitelistScopeBoolExp>;
};


export type SubscriptionRootEnumWhitelistStatusArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumWhitelistStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistStatusOrderBy>>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumWhitelistStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootEnumWhitelistStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumWhitelistStatusStreamCursorInput>>;
  where?: InputMaybe<EnumWhitelistStatusBoolExp>;
};


export type SubscriptionRootEnumWhitelistTypesArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};


export type SubscriptionRootEnumWhitelistTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumWhitelistTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EnumWhitelistTypesOrderBy>>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};


export type SubscriptionRootEnumWhitelistTypesByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootEnumWhitelistTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EnumWhitelistTypesStreamCursorInput>>;
  where?: InputMaybe<EnumWhitelistTypesBoolExp>;
};


export type SubscriptionRootGeneratedIdViewArgs = {
  distinct_on?: InputMaybe<Array<GeneratedIdViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GeneratedIdViewOrderBy>>;
  where?: InputMaybe<GeneratedIdViewBoolExp>;
};


export type SubscriptionRootGeneratedIdViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<GeneratedIdViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GeneratedIdViewOrderBy>>;
  where?: InputMaybe<GeneratedIdViewBoolExp>;
};


export type SubscriptionRootGeneratedIdViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GeneratedIdViewStreamCursorInput>>;
  where?: InputMaybe<GeneratedIdViewBoolExp>;
};


export type SubscriptionRootGuestJwtArgs = {
  distinct_on?: InputMaybe<Array<GuestJwtSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestJwtOrderBy>>;
  where?: InputMaybe<GuestJwtBoolExp>;
};


export type SubscriptionRootGuestJwtAggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestJwtSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestJwtOrderBy>>;
  where?: InputMaybe<GuestJwtBoolExp>;
};


export type SubscriptionRootGuestJwtByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootGuestJwtStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GuestJwtStreamCursorInput>>;
  where?: InputMaybe<GuestJwtBoolExp>;
};


export type SubscriptionRootGuestQrArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


export type SubscriptionRootGuestQrAggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestQrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestQrOrderBy>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


export type SubscriptionRootGuestQrByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootGuestQrStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GuestQrStreamCursorInput>>;
  where?: InputMaybe<GuestQrBoolExp>;
};


export type SubscriptionRootLotArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};


export type SubscriptionRootLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotOrderBy>>;
  where?: InputMaybe<LotBoolExp>;
};


export type SubscriptionRootLotByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootLotConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<LotConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotConfigGroupOrderBy>>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};


export type SubscriptionRootLotConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotConfigGroupOrderBy>>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};


export type SubscriptionRootLotConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLotConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotConfigGroupStreamCursorInput>>;
  where?: InputMaybe<LotConfigGroupBoolExp>;
};


export type SubscriptionRootLotDisplayNameArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


export type SubscriptionRootLotDisplayNameAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotDisplayNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotDisplayNameOrderBy>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


export type SubscriptionRootLotDisplayNameByPkArgs = {
  lot_id: Scalars['String'];
};


export type SubscriptionRootLotDisplayNameStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotDisplayNameStreamCursorInput>>;
  where?: InputMaybe<LotDisplayNameBoolExp>;
};


export type SubscriptionRootLotHierarchyArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


export type SubscriptionRootLotHierarchyAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotHierarchySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotHierarchyOrderBy>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


export type SubscriptionRootLotHierarchyByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLotHierarchyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotHierarchyStreamCursorInput>>;
  where?: InputMaybe<LotHierarchyBoolExp>;
};


export type SubscriptionRootLotLegalEntityArgs = {
  distinct_on?: InputMaybe<Array<LotLegalEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotLegalEntityOrderBy>>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};


export type SubscriptionRootLotLegalEntityAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotLegalEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotLegalEntityOrderBy>>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};


export type SubscriptionRootLotLegalEntityByPkArgs = {
  lot_id: Scalars['String'];
  product: ParkdepotProductEnum;
};


export type SubscriptionRootLotLegalEntityStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotLegalEntityStreamCursorInput>>;
  where?: InputMaybe<LotLegalEntityBoolExp>;
};


export type SubscriptionRootLotPolicyHistoryArgs = {
  distinct_on?: InputMaybe<Array<LotPolicyHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotPolicyHistoryOrderBy>>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};


export type SubscriptionRootLotPolicyHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotPolicyHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotPolicyHistoryOrderBy>>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};


export type SubscriptionRootLotPolicyHistoryByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLotPolicyHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotPolicyHistoryStreamCursorInput>>;
  where?: InputMaybe<LotPolicyHistoryBoolExp>;
};


export type SubscriptionRootLotSectionArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


export type SubscriptionRootLotSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<LotSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LotSectionOrderBy>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


export type SubscriptionRootLotSectionByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootLotSectionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotSectionStreamCursorInput>>;
  where?: InputMaybe<LotSectionBoolExp>;
};


export type SubscriptionRootLotStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LotStreamCursorInput>>;
  where?: InputMaybe<LotBoolExp>;
};


export type SubscriptionRootLpContingentArgs = {
  distinct_on?: InputMaybe<Array<LpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpContingentOrderBy>>;
  where?: InputMaybe<LpContingentBoolExp>;
};


export type SubscriptionRootLpContingentAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpContingentOrderBy>>;
  where?: InputMaybe<LpContingentBoolExp>;
};


export type SubscriptionRootLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpContingentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpContingentStreamCursorInput>>;
  where?: InputMaybe<LpContingentBoolExp>;
};


export type SubscriptionRootLpGroupArgs = {
  distinct_on?: InputMaybe<Array<LpGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupOrderBy>>;
  where?: InputMaybe<LpGroupBoolExp>;
};


export type SubscriptionRootLpGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupOrderBy>>;
  where?: InputMaybe<LpGroupBoolExp>;
};


export type SubscriptionRootLpGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpGroupConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<LpGroupConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupConfigGroupOrderBy>>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};


export type SubscriptionRootLpGroupConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupConfigGroupOrderBy>>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};


export type SubscriptionRootLpGroupConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpGroupConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpGroupConfigGroupStreamCursorInput>>;
  where?: InputMaybe<LpGroupConfigGroupBoolExp>;
};


export type SubscriptionRootLpGroupDetailsArgs = {
  distinct_on?: InputMaybe<Array<LpGroupDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupDetailsOrderBy>>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};


export type SubscriptionRootLpGroupDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupDetailsOrderBy>>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};


export type SubscriptionRootLpGroupDetailsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpGroupDetailsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpGroupDetailsStreamCursorInput>>;
  where?: InputMaybe<LpGroupDetailsBoolExp>;
};


export type SubscriptionRootLpGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


export type SubscriptionRootLpGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberOrderBy>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


export type SubscriptionRootLpGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpGroupMemberDetailsArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberDetailsOrderBy>>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};


export type SubscriptionRootLpGroupMemberDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LpGroupMemberDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LpGroupMemberDetailsOrderBy>>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};


export type SubscriptionRootLpGroupMemberDetailsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootLpGroupMemberDetailsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpGroupMemberDetailsStreamCursorInput>>;
  where?: InputMaybe<LpGroupMemberDetailsBoolExp>;
};


export type SubscriptionRootLpGroupMemberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpGroupMemberStreamCursorInput>>;
  where?: InputMaybe<LpGroupMemberBoolExp>;
};


export type SubscriptionRootLpGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LpGroupStreamCursorInput>>;
  where?: InputMaybe<LpGroupBoolExp>;
};


export type SubscriptionRootMailArgs = {
  distinct_on?: InputMaybe<Array<MailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailOrderBy>>;
  where?: InputMaybe<MailBoolExp>;
};


export type SubscriptionRootMailAggregateArgs = {
  distinct_on?: InputMaybe<Array<MailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailOrderBy>>;
  where?: InputMaybe<MailBoolExp>;
};


export type SubscriptionRootMailByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootMailMiscArgs = {
  distinct_on?: InputMaybe<Array<MailMiscSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailMiscOrderBy>>;
  where?: InputMaybe<MailMiscBoolExp>;
};


export type SubscriptionRootMailMiscAggregateArgs = {
  distinct_on?: InputMaybe<Array<MailMiscSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MailMiscOrderBy>>;
  where?: InputMaybe<MailMiscBoolExp>;
};


export type SubscriptionRootMailMiscByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootMailMiscStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MailMiscStreamCursorInput>>;
  where?: InputMaybe<MailMiscBoolExp>;
};


export type SubscriptionRootMailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MailStreamCursorInput>>;
  where?: InputMaybe<MailBoolExp>;
};


export type SubscriptionRootMlpCasesArgs = {
  distinct_on?: InputMaybe<Array<MlpCasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpCasesOrderBy>>;
  where?: InputMaybe<MlpCasesBoolExp>;
};


export type SubscriptionRootMlpCasesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MlpCasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpCasesOrderBy>>;
  where?: InputMaybe<MlpCasesBoolExp>;
};


export type SubscriptionRootMlpCasesByPkArgs = {
  parking_results_uuid: Scalars['uuid'];
};


export type SubscriptionRootMlpCasesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MlpCasesStreamCursorInput>>;
  where?: InputMaybe<MlpCasesBoolExp>;
};


export type SubscriptionRootMlpMappingsArgs = {
  distinct_on?: InputMaybe<Array<MlpMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpMappingsOrderBy>>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};


export type SubscriptionRootMlpMappingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MlpMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MlpMappingsOrderBy>>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};


export type SubscriptionRootMlpMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMlpMappingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MlpMappingsStreamCursorInput>>;
  where?: InputMaybe<MlpMappingsBoolExp>;
};


export type SubscriptionRootMqttRequestArgs = {
  distinct_on?: InputMaybe<Array<MqttRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MqttRequestOrderBy>>;
  where?: InputMaybe<MqttRequestBoolExp>;
};


export type SubscriptionRootMqttRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<MqttRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MqttRequestOrderBy>>;
  where?: InputMaybe<MqttRequestBoolExp>;
};


export type SubscriptionRootMqttRequestByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMqttRequestStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MqttRequestStreamCursorInput>>;
  where?: InputMaybe<MqttRequestBoolExp>;
};


export type SubscriptionRootOffenceParkingEventsArgs = {
  distinct_on?: InputMaybe<Array<OffenceParkingEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceParkingEventsOrderBy>>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};


export type SubscriptionRootOffenceParkingEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OffenceParkingEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceParkingEventsOrderBy>>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};


export type SubscriptionRootOffenceParkingEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootOffenceParkingEventsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OffenceParkingEventsStreamCursorInput>>;
  where?: InputMaybe<OffenceParkingEventsBoolExp>;
};


export type SubscriptionRootOffenceTicketRequestsArgs = {
  distinct_on?: InputMaybe<Array<OffenceTicketRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceTicketRequestsOrderBy>>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};


export type SubscriptionRootOffenceTicketRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OffenceTicketRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OffenceTicketRequestsOrderBy>>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};


export type SubscriptionRootOffenceTicketRequestsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootOffenceTicketRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OffenceTicketRequestsStreamCursorInput>>;
  where?: InputMaybe<OffenceTicketRequestsBoolExp>;
};


export type SubscriptionRootOveruseGroupArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupOrderBy>>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};


export type SubscriptionRootOveruseGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupOrderBy>>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};


export type SubscriptionRootOveruseGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootOveruseGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupMemberOrderBy>>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};


export type SubscriptionRootOveruseGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<OveruseGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OveruseGroupMemberOrderBy>>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};


export type SubscriptionRootOveruseGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootOveruseGroupMemberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OveruseGroupMemberStreamCursorInput>>;
  where?: InputMaybe<OveruseGroupMemberBoolExp>;
};


export type SubscriptionRootOveruseGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OveruseGroupStreamCursorInput>>;
  where?: InputMaybe<OveruseGroupBoolExp>;
};


export type SubscriptionRootParkdepotProductArgs = {
  distinct_on?: InputMaybe<Array<ParkdepotProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkdepotProductOrderBy>>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};


export type SubscriptionRootParkdepotProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkdepotProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkdepotProductOrderBy>>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};


export type SubscriptionRootParkdepotProductByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootParkdepotProductStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkdepotProductStreamCursorInput>>;
  where?: InputMaybe<ParkdepotProductBoolExp>;
};


export type SubscriptionRootParkingContextArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


export type SubscriptionRootParkingContextAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingContextOrderBy>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


export type SubscriptionRootParkingContextByPkArgs = {
  uuid: Scalars['uuid'];
};


export type SubscriptionRootParkingContextStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingContextStreamCursorInput>>;
  where?: InputMaybe<ParkingContextBoolExp>;
};


export type SubscriptionRootParkingDetectionsArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsOrderBy>>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};


export type SubscriptionRootParkingDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsOrderBy>>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};


export type SubscriptionRootParkingDetectionsArchiveArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsArchiveOrderBy>>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};


export type SubscriptionRootParkingDetectionsArchiveAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingDetectionsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingDetectionsArchiveOrderBy>>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};


export type SubscriptionRootParkingDetectionsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


export type SubscriptionRootParkingDetectionsArchiveStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingDetectionsArchiveStreamCursorInput>>;
  where?: InputMaybe<ParkingDetectionsArchiveBoolExp>;
};


export type SubscriptionRootParkingDetectionsByPkArgs = {
  id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
};


export type SubscriptionRootParkingDetectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingDetectionsStreamCursorInput>>;
  where?: InputMaybe<ParkingDetectionsBoolExp>;
};


export type SubscriptionRootParkingIncomingArgs = {
  distinct_on?: InputMaybe<Array<ParkingIncomingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingIncomingOrderBy>>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};


export type SubscriptionRootParkingIncomingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingIncomingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingIncomingOrderBy>>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};


export type SubscriptionRootParkingIncomingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootParkingIncomingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingIncomingStreamCursorInput>>;
  where?: InputMaybe<ParkingIncomingBoolExp>;
};


export type SubscriptionRootParkingProcessingArgs = {
  distinct_on?: InputMaybe<Array<ParkingProcessingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingProcessingOrderBy>>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};


export type SubscriptionRootParkingProcessingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingProcessingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingProcessingOrderBy>>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};


export type SubscriptionRootParkingProcessingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootParkingProcessingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingProcessingStreamCursorInput>>;
  where?: InputMaybe<ParkingProcessingBoolExp>;
};


export type SubscriptionRootParkingResultsArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsOrderBy>>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};


export type SubscriptionRootParkingResultsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsOrderBy>>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};


export type SubscriptionRootParkingResultsArchiveArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsArchiveOrderBy>>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};


export type SubscriptionRootParkingResultsArchiveAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingResultsArchiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingResultsArchiveOrderBy>>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};


export type SubscriptionRootParkingResultsArchiveByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


export type SubscriptionRootParkingResultsArchiveStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingResultsArchiveStreamCursorInput>>;
  where?: InputMaybe<ParkingResultsArchiveBoolExp>;
};


export type SubscriptionRootParkingResultsByPkArgs = {
  id: Scalars['uuid'];
  timestamp_out: Scalars['timestamptz'];
};


export type SubscriptionRootParkingResultsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingResultsStreamCursorInput>>;
  where?: InputMaybe<ParkingResultsBoolExp>;
};


export type SubscriptionRootParkingTempArgs = {
  distinct_on?: InputMaybe<Array<ParkingTempSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingTempOrderBy>>;
  where?: InputMaybe<ParkingTempBoolExp>;
};


export type SubscriptionRootParkingTempAggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkingTempSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkingTempOrderBy>>;
  where?: InputMaybe<ParkingTempBoolExp>;
};


export type SubscriptionRootParkingTempByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootParkingTempStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkingTempStreamCursorInput>>;
  where?: InputMaybe<ParkingTempBoolExp>;
};


export type SubscriptionRootPaybyphoneLotArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneLotOrderBy>>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};


export type SubscriptionRootPaybyphoneLotAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneLotSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneLotOrderBy>>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};


export type SubscriptionRootPaybyphoneLotByPkArgs = {
  lot_id: Scalars['String'];
};


export type SubscriptionRootPaybyphoneLotStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaybyphoneLotStreamCursorInput>>;
  where?: InputMaybe<PaybyphoneLotBoolExp>;
};


export type SubscriptionRootPaybyphoneOrderArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneOrderOrderBy>>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};


export type SubscriptionRootPaybyphoneOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaybyphoneOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaybyphoneOrderOrderBy>>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};


export type SubscriptionRootPaybyphoneOrderByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootPaybyphoneOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaybyphoneOrderStreamCursorInput>>;
  where?: InputMaybe<PaybyphoneOrderBoolExp>;
};


export type SubscriptionRootPersonArgs = {
  distinct_on?: InputMaybe<Array<PersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonOrderBy>>;
  where?: InputMaybe<PersonBoolExp>;
};


export type SubscriptionRootPersonAggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonOrderBy>>;
  where?: InputMaybe<PersonBoolExp>;
};


export type SubscriptionRootPersonByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootPersonStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PersonStreamCursorInput>>;
  where?: InputMaybe<PersonBoolExp>;
};


export type SubscriptionRootPolicyScheduleArgs = {
  distinct_on?: InputMaybe<Array<PolicyScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyScheduleOrderBy>>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};


export type SubscriptionRootPolicyScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyScheduleOrderBy>>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};


export type SubscriptionRootPolicyScheduleByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootPolicyScheduleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyScheduleStreamCursorInput>>;
  where?: InputMaybe<PolicyScheduleBoolExp>;
};


export type SubscriptionRootRegionalCodesAustriaArgs = {
  distinct_on?: InputMaybe<Array<RegionalCodesAustriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionalCodesAustriaOrderBy>>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};


export type SubscriptionRootRegionalCodesAustriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionalCodesAustriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionalCodesAustriaOrderBy>>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};


export type SubscriptionRootRegionalCodesAustriaByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootRegionalCodesAustriaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RegionalCodesAustriaStreamCursorInput>>;
  where?: InputMaybe<RegionalCodesAustriaBoolExp>;
};


export type SubscriptionRootRentalPricingArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


export type SubscriptionRootRentalPricingAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalPricingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalPricingOrderBy>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


export type SubscriptionRootRentalPricingByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootRentalPricingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RentalPricingStreamCursorInput>>;
  where?: InputMaybe<RentalPricingBoolExp>;
};


export type SubscriptionRootRentalSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


export type SubscriptionRootRentalSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


export type SubscriptionRootRentalSubscriptionByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootRentalSubscriptionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RentalSubscriptionStreamCursorInput>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


export type SubscriptionRootRepeatOffenseViewArgs = {
  distinct_on?: InputMaybe<Array<RepeatOffenseViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatOffenseViewOrderBy>>;
  where?: InputMaybe<RepeatOffenseViewBoolExp>;
};


export type SubscriptionRootRepeatOffenseViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatOffenseViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatOffenseViewOrderBy>>;
  where?: InputMaybe<RepeatOffenseViewBoolExp>;
};


export type SubscriptionRootRepeatOffenseViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RepeatOffenseViewStreamCursorInput>>;
  where?: InputMaybe<RepeatOffenseViewBoolExp>;
};


export type SubscriptionRootSendCarOwnerRequestsGermanyArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootServerlessAsyncWorkArgs = {
  distinct_on?: InputMaybe<Array<ServerlessAsyncWorkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerlessAsyncWorkOrderBy>>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};


export type SubscriptionRootServerlessAsyncWorkAggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerlessAsyncWorkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerlessAsyncWorkOrderBy>>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};


export type SubscriptionRootServerlessAsyncWorkByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootServerlessAsyncWorkStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ServerlessAsyncWorkStreamCursorInput>>;
  where?: InputMaybe<ServerlessAsyncWorkBoolExp>;
};


export type SubscriptionRootSimilarDetectionsArgs = {
  distinct_on?: InputMaybe<Array<SimilarDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SimilarDetectionsOrderBy>>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};


export type SubscriptionRootSimilarDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SimilarDetectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SimilarDetectionsOrderBy>>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};


export type SubscriptionRootSimilarDetectionsByPkArgs = {
  parking_detections_uuid: Scalars['uuid'];
};


export type SubscriptionRootSimilarDetectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SimilarDetectionsStreamCursorInput>>;
  where?: InputMaybe<SimilarDetectionsBoolExp>;
};


export type SubscriptionRootStagesArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


export type SubscriptionRootStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<StagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StagesOrderBy>>;
  where?: InputMaybe<StagesBoolExp>;
};


export type SubscriptionRootStagesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootStagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StagesStreamCursorInput>>;
  where?: InputMaybe<StagesBoolExp>;
};


export type SubscriptionRootStartGenerationOfSpecialLettersArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootStationArgs = {
  distinct_on?: InputMaybe<Array<StationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StationOrderBy>>;
  where?: InputMaybe<StationBoolExp>;
};


export type SubscriptionRootStationAggregateArgs = {
  distinct_on?: InputMaybe<Array<StationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StationOrderBy>>;
  where?: InputMaybe<StationBoolExp>;
};


export type SubscriptionRootStationByPkArgs = {
  station_name: Scalars['String'];
};


export type SubscriptionRootStationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StationStreamCursorInput>>;
  where?: InputMaybe<StationBoolExp>;
};


export type SubscriptionRootSupervisionCarRentalPartnersArgs = {
  distinct_on?: InputMaybe<Array<SupervisionCarRentalPartnersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionCarRentalPartnersOrderBy>>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};


export type SubscriptionRootSupervisionCarRentalPartnersAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionCarRentalPartnersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionCarRentalPartnersOrderBy>>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};


export type SubscriptionRootSupervisionCarRentalPartnersByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSupervisionCarRentalPartnersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionCarRentalPartnersStreamCursorInput>>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};


export type SubscriptionRootSupervisionDebtCollectionCaseArgs = {
  distinct_on?: InputMaybe<Array<SupervisionDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootSupervisionDebtCollectionCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootSupervisionDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionDebtCollectionCaseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionDebtCollectionCaseStreamCursorInput>>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootSupervisionImageRequestsArgs = {
  distinct_on?: InputMaybe<Array<SupervisionImageRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionImageRequestsOrderBy>>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};


export type SubscriptionRootSupervisionImageRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionImageRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionImageRequestsOrderBy>>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};


export type SubscriptionRootSupervisionImageRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionImageRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionImageRequestsStreamCursorInput>>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};


export type SubscriptionRootSupervisionMlpRequestsArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMlpRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMlpRequestsOrderBy>>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};


export type SubscriptionRootSupervisionMlpRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMlpRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMlpRequestsOrderBy>>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};


export type SubscriptionRootSupervisionMlpRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionMlpRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionMlpRequestsStreamCursorInput>>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupMemberArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupMemberAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberOrderBy>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupMemberByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupMemberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionMultivisitOffenderGroupMemberStreamCursorInput>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};


export type SubscriptionRootSupervisionMultivisitOffenderGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionMultivisitOffenderGroupStreamCursorInput>>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};


export type SubscriptionRootSupervisionTicketRequestArgs = {
  distinct_on?: InputMaybe<Array<SupervisionTicketRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionTicketRequestOrderBy>>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};


export type SubscriptionRootSupervisionTicketRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionTicketRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionTicketRequestOrderBy>>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};


export type SubscriptionRootSupervisionTicketRequestByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionTicketRequestStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionTicketRequestStreamCursorInput>>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};


export type SubscriptionRootSupervisionViolationCaseDebtCollectionCaseArgs = {
  distinct_on?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootSupervisionViolationCaseDebtCollectionCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseOrderBy>>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootSupervisionViolationCaseDebtCollectionCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSupervisionViolationCaseDebtCollectionCaseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupervisionViolationCaseDebtCollectionCaseStreamCursorInput>>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};


export type SubscriptionRootTaxArgs = {
  distinct_on?: InputMaybe<Array<TaxSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxOrderBy>>;
  where?: InputMaybe<TaxBoolExp>;
};


export type SubscriptionRootTaxAggregateArgs = {
  distinct_on?: InputMaybe<Array<TaxSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxOrderBy>>;
  where?: InputMaybe<TaxBoolExp>;
};


export type SubscriptionRootTaxByPkArgs = {
  uuid: Scalars['Int'];
};


export type SubscriptionRootTaxStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TaxStreamCursorInput>>;
  where?: InputMaybe<TaxBoolExp>;
};


export type SubscriptionRootTerminalStatusArgs = {
  distinct_on?: InputMaybe<Array<TerminalStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TerminalStatusOrderBy>>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};


export type SubscriptionRootTerminalStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<TerminalStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TerminalStatusOrderBy>>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};


export type SubscriptionRootTerminalStatusByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTerminalStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TerminalStatusStreamCursorInput>>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};


export type SubscriptionRootTicketWebsiteFeedbackArgs = {
  distinct_on?: InputMaybe<Array<TicketWebsiteFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TicketWebsiteFeedbackOrderBy>>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};


export type SubscriptionRootTicketWebsiteFeedbackAggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketWebsiteFeedbackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TicketWebsiteFeedbackOrderBy>>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};


export type SubscriptionRootTicketWebsiteFeedbackByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootTicketWebsiteFeedbackStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TicketWebsiteFeedbackStreamCursorInput>>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};


export type SubscriptionRootTimeDiscountArgs = {
  distinct_on?: InputMaybe<Array<TimeDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TimeDiscountOrderBy>>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};


export type SubscriptionRootTimeDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TimeDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TimeDiscountOrderBy>>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};


export type SubscriptionRootTimeDiscountByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootTimeDiscountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TimeDiscountStreamCursorInput>>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};


export type SubscriptionRootUserPreferenceArgs = {
  distinct_on?: InputMaybe<Array<UserPreferenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPreferenceOrderBy>>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};


export type SubscriptionRootUserPreferenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPreferenceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPreferenceOrderBy>>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};


export type SubscriptionRootUserPreferenceByPkArgs = {
  user_id: Scalars['String'];
};


export type SubscriptionRootUserPreferenceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserPreferenceStreamCursorInput>>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};


export type SubscriptionRootVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeOrderBy>>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};


export type SubscriptionRootVehicleTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeOrderBy>>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};


export type SubscriptionRootVehicleTypeByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootVehicleTypeConfigGroupArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeConfigGroupOrderBy>>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};


export type SubscriptionRootVehicleTypeConfigGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleTypeConfigGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleTypeConfigGroupOrderBy>>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};


export type SubscriptionRootVehicleTypeConfigGroupByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootVehicleTypeConfigGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleTypeConfigGroupStreamCursorInput>>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};


export type SubscriptionRootVehicleTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleTypeStreamCursorInput>>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};


export type SubscriptionRootViolationCaseArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


export type SubscriptionRootViolationCaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseOrderBy>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


export type SubscriptionRootViolationCaseByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootViolationCaseChargesArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


export type SubscriptionRootViolationCaseChargesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


export type SubscriptionRootViolationCaseChargesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootViolationCaseChargesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ViolationCaseChargesStreamCursorInput>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


export type SubscriptionRootViolationCaseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ViolationCaseStreamCursorInput>>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};


export type SubscriptionRootViolationCaseTagsArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseTagsOrderBy>>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};


export type SubscriptionRootViolationCaseTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseTagsOrderBy>>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};


export type SubscriptionRootViolationCaseTagsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootViolationCaseTagsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ViolationCaseTagsStreamCursorInput>>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};


export type SubscriptionRootViolationEventAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ViolationEventAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationEventAnalysisOrderBy>>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};


export type SubscriptionRootViolationEventAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationEventAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationEventAnalysisOrderBy>>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};


export type SubscriptionRootViolationEventAnalysisByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootViolationEventAnalysisStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ViolationEventAnalysisStreamCursorInput>>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};


export type SubscriptionRootViolatorTransactionsArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


export type SubscriptionRootViolatorTransactionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


export type SubscriptionRootViolatorTransactionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootViolatorTransactionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ViolatorTransactionsStreamCursorInput>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


export type SubscriptionRootWhitelistArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


export type SubscriptionRootWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


export type SubscriptionRootWhitelistAppliedPermitArgs = {
  distinct_on?: InputMaybe<Array<WhitelistAppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistAppliedPermitOrderBy>>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};


export type SubscriptionRootWhitelistAppliedPermitAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistAppliedPermitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistAppliedPermitOrderBy>>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};


export type SubscriptionRootWhitelistAppliedPermitByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootWhitelistAppliedPermitStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistAppliedPermitStreamCursorInput>>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};


export type SubscriptionRootWhitelistByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootWhitelistByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<WhitelistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistByPlateViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistByPlateViewStreamCursorInput>>;
  where?: InputMaybe<WhitelistByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistCalendarEventPolicyArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


export type SubscriptionRootWhitelistCalendarEventPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


export type SubscriptionRootWhitelistCalendarEventPolicyByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootWhitelistCalendarEventPolicyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistCalendarEventPolicyStreamCursorInput>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


export type SubscriptionRootWhitelistGuestByPlateViewArgs = {
  distinct_on?: InputMaybe<Array<WhitelistGuestByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistGuestByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistGuestByPlateViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistGuestByPlateViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistGuestByPlateViewOrderBy>>;
  where?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistGuestByPlateViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistGuestByPlateViewStreamCursorInput>>;
  where?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
};


export type SubscriptionRootWhitelistLpContingentArgs = {
  distinct_on?: InputMaybe<Array<WhitelistLpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistLpContingentOrderBy>>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};


export type SubscriptionRootWhitelistLpContingentAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistLpContingentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistLpContingentOrderBy>>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};


export type SubscriptionRootWhitelistLpContingentByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootWhitelistLpContingentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistLpContingentStreamCursorInput>>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};


export type SubscriptionRootWhitelistPaidParkingArgs = {
  distinct_on?: InputMaybe<Array<WhitelistPaidParkingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistPaidParkingOrderBy>>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};


export type SubscriptionRootWhitelistPaidParkingAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistPaidParkingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistPaidParkingOrderBy>>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};


export type SubscriptionRootWhitelistPaidParkingByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootWhitelistPaidParkingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistPaidParkingStreamCursorInput>>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};


export type SubscriptionRootWhitelistStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistStreamCursorInput>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


export type SubscriptionRootWhitelistSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


export type SubscriptionRootWhitelistSubscriptionAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


export type SubscriptionRootWhitelistSubscriptionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootWhitelistSubscriptionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WhitelistSubscriptionStreamCursorInput>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


export type SubscriptionRootWireguardConfigArgs = {
  distinct_on?: InputMaybe<Array<WireguardConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WireguardConfigOrderBy>>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};


export type SubscriptionRootWireguardConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<WireguardConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WireguardConfigOrderBy>>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};


export type SubscriptionRootWireguardConfigByPkArgs = {
  public_key: Scalars['String'];
};


export type SubscriptionRootWireguardConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WireguardConfigStreamCursorInput>>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};

export type SummaryNotCancelled = {
  __typename?: 'summaryNotCancelled';
  case_id: Scalars['String'];
  id: Scalars['Int'];
  reason?: Maybe<Array<Scalars['String']>>;
};

export type SummaryNotWrittenOff = {
  __typename?: 'summaryNotWrittenOff';
  case_id: Scalars['String'];
  id: Scalars['Int'];
  reason?: Maybe<Array<Scalars['String']>>;
};

/** A rental partner is a third party company which provides us driver information on offences done in vehicles owned by the rental partners. */
export type SupervisionCarRentalPartners = {
  __typename?: 'supervision_car_rental_partners';
  address: Scalars['String'];
  company_group: Scalars['String'];
  driver_request_settings?: Maybe<Scalars['jsonb']>;
  driver_request_type: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** A rental partner is a third party company which provides us driver information on offences done in vehicles owned by the rental partners. */
export type SupervisionCarRentalPartnersDriverRequestSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersAggregate = {
  __typename?: 'supervision_car_rental_partners_aggregate';
  aggregate?: Maybe<SupervisionCarRentalPartnersAggregateFields>;
  nodes: Array<SupervisionCarRentalPartners>;
};

/** aggregate fields of "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersAggregateFields = {
  __typename?: 'supervision_car_rental_partners_aggregate_fields';
  avg?: Maybe<SupervisionCarRentalPartnersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionCarRentalPartnersMaxFields>;
  min?: Maybe<SupervisionCarRentalPartnersMinFields>;
  stddev?: Maybe<SupervisionCarRentalPartnersStddevFields>;
  stddev_pop?: Maybe<SupervisionCarRentalPartnersStddevPopFields>;
  stddev_samp?: Maybe<SupervisionCarRentalPartnersStddevSampFields>;
  sum?: Maybe<SupervisionCarRentalPartnersSumFields>;
  var_pop?: Maybe<SupervisionCarRentalPartnersVarPopFields>;
  var_samp?: Maybe<SupervisionCarRentalPartnersVarSampFields>;
  variance?: Maybe<SupervisionCarRentalPartnersVarianceFields>;
};


/** aggregate fields of "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionCarRentalPartnersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SupervisionCarRentalPartnersAppendInput = {
  driver_request_settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SupervisionCarRentalPartnersAvgFields = {
  __typename?: 'supervision_car_rental_partners_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_car_rental_partners". All fields are combined with a logical 'AND'. */
export type SupervisionCarRentalPartnersBoolExp = {
  _and?: InputMaybe<Array<SupervisionCarRentalPartnersBoolExp>>;
  _not?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
  _or?: InputMaybe<Array<SupervisionCarRentalPartnersBoolExp>>;
  address?: InputMaybe<StringComparisonExp>;
  company_group?: InputMaybe<StringComparisonExp>;
  driver_request_settings?: InputMaybe<JsonbComparisonExp>;
  driver_request_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "supervision_car_rental_partners" */
export enum SupervisionCarRentalPartnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RentalPartnersPkey = 'rental_partners_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SupervisionCarRentalPartnersDeleteAtPathInput = {
  driver_request_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SupervisionCarRentalPartnersDeleteElemInput = {
  driver_request_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SupervisionCarRentalPartnersDeleteKeyInput = {
  driver_request_settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersInsertInput = {
  address?: InputMaybe<Scalars['String']>;
  company_group?: InputMaybe<Scalars['String']>;
  driver_request_settings?: InputMaybe<Scalars['jsonb']>;
  driver_request_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SupervisionCarRentalPartnersMaxFields = {
  __typename?: 'supervision_car_rental_partners_max_fields';
  address?: Maybe<Scalars['String']>;
  company_group?: Maybe<Scalars['String']>;
  driver_request_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SupervisionCarRentalPartnersMinFields = {
  __typename?: 'supervision_car_rental_partners_min_fields';
  address?: Maybe<Scalars['String']>;
  company_group?: Maybe<Scalars['String']>;
  driver_request_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersMutationResponse = {
  __typename?: 'supervision_car_rental_partners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionCarRentalPartners>;
};

/** on_conflict condition type for table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersOnConflict = {
  constraint: SupervisionCarRentalPartnersConstraint;
  update_columns?: Array<SupervisionCarRentalPartnersUpdateColumn>;
  where?: InputMaybe<SupervisionCarRentalPartnersBoolExp>;
};

/** Ordering options when selecting data from "supervision_car_rental_partners". */
export type SupervisionCarRentalPartnersOrderBy = {
  address?: InputMaybe<OrderBy>;
  company_group?: InputMaybe<OrderBy>;
  driver_request_settings?: InputMaybe<OrderBy>;
  driver_request_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_car_rental_partners */
export type SupervisionCarRentalPartnersPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SupervisionCarRentalPartnersPrependInput = {
  driver_request_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "supervision_car_rental_partners" */
export enum SupervisionCarRentalPartnersSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CompanyGroup = 'company_group',
  /** column name */
  DriverRequestSettings = 'driver_request_settings',
  /** column name */
  DriverRequestType = 'driver_request_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersSetInput = {
  address?: InputMaybe<Scalars['String']>;
  company_group?: InputMaybe<Scalars['String']>;
  driver_request_settings?: InputMaybe<Scalars['jsonb']>;
  driver_request_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SupervisionCarRentalPartnersStddevFields = {
  __typename?: 'supervision_car_rental_partners_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionCarRentalPartnersStddevPopFields = {
  __typename?: 'supervision_car_rental_partners_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionCarRentalPartnersStddevSampFields = {
  __typename?: 'supervision_car_rental_partners_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_car_rental_partners" */
export type SupervisionCarRentalPartnersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionCarRentalPartnersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionCarRentalPartnersStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']>;
  company_group?: InputMaybe<Scalars['String']>;
  driver_request_settings?: InputMaybe<Scalars['jsonb']>;
  driver_request_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SupervisionCarRentalPartnersSumFields = {
  __typename?: 'supervision_car_rental_partners_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "supervision_car_rental_partners" */
export enum SupervisionCarRentalPartnersUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CompanyGroup = 'company_group',
  /** column name */
  DriverRequestSettings = 'driver_request_settings',
  /** column name */
  DriverRequestType = 'driver_request_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type SupervisionCarRentalPartnersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SupervisionCarRentalPartnersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SupervisionCarRentalPartnersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SupervisionCarRentalPartnersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SupervisionCarRentalPartnersDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionCarRentalPartnersIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SupervisionCarRentalPartnersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionCarRentalPartnersSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionCarRentalPartnersBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionCarRentalPartnersVarPopFields = {
  __typename?: 'supervision_car_rental_partners_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionCarRentalPartnersVarSampFields = {
  __typename?: 'supervision_car_rental_partners_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionCarRentalPartnersVarianceFields = {
  __typename?: 'supervision_car_rental_partners_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Table to track all cases that handed over to a debt collector */
export type SupervisionDebtCollectionCase = {
  __typename?: 'supervision_debt_collection_case';
  created_at: Scalars['timestamptz'];
  debt_collector_case_id: Scalars['String'];
  id: Scalars['bigint'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseAggregate = {
  __typename?: 'supervision_debt_collection_case_aggregate';
  aggregate?: Maybe<SupervisionDebtCollectionCaseAggregateFields>;
  nodes: Array<SupervisionDebtCollectionCase>;
};

/** aggregate fields of "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseAggregateFields = {
  __typename?: 'supervision_debt_collection_case_aggregate_fields';
  avg?: Maybe<SupervisionDebtCollectionCaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionDebtCollectionCaseMaxFields>;
  min?: Maybe<SupervisionDebtCollectionCaseMinFields>;
  stddev?: Maybe<SupervisionDebtCollectionCaseStddevFields>;
  stddev_pop?: Maybe<SupervisionDebtCollectionCaseStddevPopFields>;
  stddev_samp?: Maybe<SupervisionDebtCollectionCaseStddevSampFields>;
  sum?: Maybe<SupervisionDebtCollectionCaseSumFields>;
  var_pop?: Maybe<SupervisionDebtCollectionCaseVarPopFields>;
  var_samp?: Maybe<SupervisionDebtCollectionCaseVarSampFields>;
  variance?: Maybe<SupervisionDebtCollectionCaseVarianceFields>;
};


/** aggregate fields of "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionDebtCollectionCaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionDebtCollectionCaseAvgFields = {
  __typename?: 'supervision_debt_collection_case_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_debt_collection_case". All fields are combined with a logical 'AND'. */
export type SupervisionDebtCollectionCaseBoolExp = {
  _and?: InputMaybe<Array<SupervisionDebtCollectionCaseBoolExp>>;
  _not?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
  _or?: InputMaybe<Array<SupervisionDebtCollectionCaseBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  debt_collector_case_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_debt_collection_case" */
export enum SupervisionDebtCollectionCaseConstraint {
  /** unique or primary key constraint on columns "debt_collector_case_id" */
  SupervisionDebtCollectionCaseDebtCollectorCaseIdKey = 'supervision_debt_collection_case_debt_collector_case_id_key',
  /** unique or primary key constraint on columns "id" */
  SupervisionDebtCollectionCasePkey = 'supervision_debt_collection_case_pkey'
}

/** input type for incrementing numeric columns in table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collector_case_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionDebtCollectionCaseMaxFields = {
  __typename?: 'supervision_debt_collection_case_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collector_case_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SupervisionDebtCollectionCaseMinFields = {
  __typename?: 'supervision_debt_collection_case_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collector_case_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseMutationResponse = {
  __typename?: 'supervision_debt_collection_case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionDebtCollectionCase>;
};

/** on_conflict condition type for table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseOnConflict = {
  constraint: SupervisionDebtCollectionCaseConstraint;
  update_columns?: Array<SupervisionDebtCollectionCaseUpdateColumn>;
  where?: InputMaybe<SupervisionDebtCollectionCaseBoolExp>;
};

/** Ordering options when selecting data from "supervision_debt_collection_case". */
export type SupervisionDebtCollectionCaseOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  debt_collector_case_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_debt_collection_case */
export type SupervisionDebtCollectionCasePkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_debt_collection_case" */
export enum SupervisionDebtCollectionCaseSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectorCaseId = 'debt_collector_case_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collector_case_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionDebtCollectionCaseStddevFields = {
  __typename?: 'supervision_debt_collection_case_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionDebtCollectionCaseStddevPopFields = {
  __typename?: 'supervision_debt_collection_case_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionDebtCollectionCaseStddevSampFields = {
  __typename?: 'supervision_debt_collection_case_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_debt_collection_case" */
export type SupervisionDebtCollectionCaseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionDebtCollectionCaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionDebtCollectionCaseStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collector_case_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionDebtCollectionCaseSumFields = {
  __typename?: 'supervision_debt_collection_case_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_debt_collection_case" */
export enum SupervisionDebtCollectionCaseUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectorCaseId = 'debt_collector_case_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionDebtCollectionCaseUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionDebtCollectionCaseIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionDebtCollectionCaseSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionDebtCollectionCaseBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionDebtCollectionCaseVarPopFields = {
  __typename?: 'supervision_debt_collection_case_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionDebtCollectionCaseVarSampFields = {
  __typename?: 'supervision_debt_collection_case_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionDebtCollectionCaseVarianceFields = {
  __typename?: 'supervision_debt_collection_case_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "supervision_image_requests" */
export type SupervisionImageRequests = {
  __typename?: 'supervision_image_requests';
  created_at: Scalars['timestamptz'];
  device_id: Scalars['bigint'];
  device_uuid: Scalars['String'];
  id: Scalars['bigint'];
  lp_stored: Scalars['Boolean'];
  parking_lot: Scalars['String'];
  parking_results_id: Scalars['uuid'];
  plate?: Maybe<Scalars['String']>;
  render_stored: Scalars['Boolean'];
  roi_stored: Scalars['Boolean'];
  status: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_image_requests" */
export type SupervisionImageRequestsAggregate = {
  __typename?: 'supervision_image_requests_aggregate';
  aggregate?: Maybe<SupervisionImageRequestsAggregateFields>;
  nodes: Array<SupervisionImageRequests>;
};

/** aggregate fields of "supervision_image_requests" */
export type SupervisionImageRequestsAggregateFields = {
  __typename?: 'supervision_image_requests_aggregate_fields';
  avg?: Maybe<SupervisionImageRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionImageRequestsMaxFields>;
  min?: Maybe<SupervisionImageRequestsMinFields>;
  stddev?: Maybe<SupervisionImageRequestsStddevFields>;
  stddev_pop?: Maybe<SupervisionImageRequestsStddevPopFields>;
  stddev_samp?: Maybe<SupervisionImageRequestsStddevSampFields>;
  sum?: Maybe<SupervisionImageRequestsSumFields>;
  var_pop?: Maybe<SupervisionImageRequestsVarPopFields>;
  var_samp?: Maybe<SupervisionImageRequestsVarSampFields>;
  variance?: Maybe<SupervisionImageRequestsVarianceFields>;
};


/** aggregate fields of "supervision_image_requests" */
export type SupervisionImageRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionImageRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionImageRequestsAvgFields = {
  __typename?: 'supervision_image_requests_avg_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_image_requests". All fields are combined with a logical 'AND'. */
export type SupervisionImageRequestsBoolExp = {
  _and?: InputMaybe<Array<SupervisionImageRequestsBoolExp>>;
  _not?: InputMaybe<SupervisionImageRequestsBoolExp>;
  _or?: InputMaybe<Array<SupervisionImageRequestsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_id?: InputMaybe<BigintComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_stored?: InputMaybe<BooleanComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  render_stored?: InputMaybe<BooleanComparisonExp>;
  roi_stored?: InputMaybe<BooleanComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_image_requests" */
export enum SupervisionImageRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionImageRequestsPkey = 'supervision_image_requests_pkey'
}

/** input type for incrementing numeric columns in table "supervision_image_requests" */
export type SupervisionImageRequestsIncInput = {
  device_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_image_requests" */
export type SupervisionImageRequestsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['bigint']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_stored?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  render_stored?: InputMaybe<Scalars['Boolean']>;
  roi_stored?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionImageRequestsMaxFields = {
  __typename?: 'supervision_image_requests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['bigint']>;
  device_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SupervisionImageRequestsMinFields = {
  __typename?: 'supervision_image_requests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['bigint']>;
  device_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_image_requests" */
export type SupervisionImageRequestsMutationResponse = {
  __typename?: 'supervision_image_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionImageRequests>;
};

/** on_conflict condition type for table "supervision_image_requests" */
export type SupervisionImageRequestsOnConflict = {
  constraint: SupervisionImageRequestsConstraint;
  update_columns?: Array<SupervisionImageRequestsUpdateColumn>;
  where?: InputMaybe<SupervisionImageRequestsBoolExp>;
};

/** Ordering options when selecting data from "supervision_image_requests". */
export type SupervisionImageRequestsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lp_stored?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  render_stored?: InputMaybe<OrderBy>;
  roi_stored?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_image_requests */
export type SupervisionImageRequestsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_image_requests" */
export enum SupervisionImageRequestsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  LpStored = 'lp_stored',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RenderStored = 'render_stored',
  /** column name */
  RoiStored = 'roi_stored',
  /** column name */
  Status = 'status',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_image_requests" */
export type SupervisionImageRequestsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['bigint']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_stored?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  render_stored?: InputMaybe<Scalars['Boolean']>;
  roi_stored?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionImageRequestsStddevFields = {
  __typename?: 'supervision_image_requests_stddev_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionImageRequestsStddevPopFields = {
  __typename?: 'supervision_image_requests_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionImageRequestsStddevSampFields = {
  __typename?: 'supervision_image_requests_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_image_requests" */
export type SupervisionImageRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionImageRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionImageRequestsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['bigint']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  lp_stored?: InputMaybe<Scalars['Boolean']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate?: InputMaybe<Scalars['String']>;
  render_stored?: InputMaybe<Scalars['Boolean']>;
  roi_stored?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionImageRequestsSumFields = {
  __typename?: 'supervision_image_requests_sum_fields';
  device_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_image_requests" */
export enum SupervisionImageRequestsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  LpStored = 'lp_stored',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RenderStored = 'render_stored',
  /** column name */
  RoiStored = 'roi_stored',
  /** column name */
  Status = 'status',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionImageRequestsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionImageRequestsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionImageRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionImageRequestsBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionImageRequestsVarPopFields = {
  __typename?: 'supervision_image_requests_var_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionImageRequestsVarSampFields = {
  __typename?: 'supervision_image_requests_var_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionImageRequestsVarianceFields = {
  __typename?: 'supervision_image_requests_variance_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Table used to store information about the MLP requests done by supervision */
export type SupervisionMlpRequests = {
  __typename?: 'supervision_mlp_requests';
  check_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  parking_results_id: Scalars['uuid'];
  received_at?: Maybe<Scalars['timestamptz']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_mlp_requests" */
export type SupervisionMlpRequestsAggregate = {
  __typename?: 'supervision_mlp_requests_aggregate';
  aggregate?: Maybe<SupervisionMlpRequestsAggregateFields>;
  nodes: Array<SupervisionMlpRequests>;
};

/** aggregate fields of "supervision_mlp_requests" */
export type SupervisionMlpRequestsAggregateFields = {
  __typename?: 'supervision_mlp_requests_aggregate_fields';
  avg?: Maybe<SupervisionMlpRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionMlpRequestsMaxFields>;
  min?: Maybe<SupervisionMlpRequestsMinFields>;
  stddev?: Maybe<SupervisionMlpRequestsStddevFields>;
  stddev_pop?: Maybe<SupervisionMlpRequestsStddevPopFields>;
  stddev_samp?: Maybe<SupervisionMlpRequestsStddevSampFields>;
  sum?: Maybe<SupervisionMlpRequestsSumFields>;
  var_pop?: Maybe<SupervisionMlpRequestsVarPopFields>;
  var_samp?: Maybe<SupervisionMlpRequestsVarSampFields>;
  variance?: Maybe<SupervisionMlpRequestsVarianceFields>;
};


/** aggregate fields of "supervision_mlp_requests" */
export type SupervisionMlpRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionMlpRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionMlpRequestsAvgFields = {
  __typename?: 'supervision_mlp_requests_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_mlp_requests". All fields are combined with a logical 'AND'. */
export type SupervisionMlpRequestsBoolExp = {
  _and?: InputMaybe<Array<SupervisionMlpRequestsBoolExp>>;
  _not?: InputMaybe<SupervisionMlpRequestsBoolExp>;
  _or?: InputMaybe<Array<SupervisionMlpRequestsBoolExp>>;
  check_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  received_at?: InputMaybe<TimestamptzComparisonExp>;
  sent_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_mlp_requests" */
export enum SupervisionMlpRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionMlpRequestsPkey = 'supervision_mlp_requests_pkey'
}

/** input type for incrementing numeric columns in table "supervision_mlp_requests" */
export type SupervisionMlpRequestsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_mlp_requests" */
export type SupervisionMlpRequestsInsertInput = {
  check_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamptz']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionMlpRequestsMaxFields = {
  __typename?: 'supervision_mlp_requests_max_fields';
  check_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SupervisionMlpRequestsMinFields = {
  __typename?: 'supervision_mlp_requests_min_fields';
  check_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_mlp_requests" */
export type SupervisionMlpRequestsMutationResponse = {
  __typename?: 'supervision_mlp_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionMlpRequests>;
};

/** on_conflict condition type for table "supervision_mlp_requests" */
export type SupervisionMlpRequestsOnConflict = {
  constraint: SupervisionMlpRequestsConstraint;
  update_columns?: Array<SupervisionMlpRequestsUpdateColumn>;
  where?: InputMaybe<SupervisionMlpRequestsBoolExp>;
};

/** Ordering options when selecting data from "supervision_mlp_requests". */
export type SupervisionMlpRequestsOrderBy = {
  check_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  received_at?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_mlp_requests */
export type SupervisionMlpRequestsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_mlp_requests" */
export enum SupervisionMlpRequestsSelectColumn {
  /** column name */
  CheckType = 'check_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_mlp_requests" */
export type SupervisionMlpRequestsSetInput = {
  check_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamptz']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionMlpRequestsStddevFields = {
  __typename?: 'supervision_mlp_requests_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionMlpRequestsStddevPopFields = {
  __typename?: 'supervision_mlp_requests_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionMlpRequestsStddevSampFields = {
  __typename?: 'supervision_mlp_requests_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_mlp_requests" */
export type SupervisionMlpRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionMlpRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionMlpRequestsStreamCursorValueInput = {
  check_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamptz']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionMlpRequestsSumFields = {
  __typename?: 'supervision_mlp_requests_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_mlp_requests" */
export enum SupervisionMlpRequestsUpdateColumn {
  /** column name */
  CheckType = 'check_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionMlpRequestsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionMlpRequestsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionMlpRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionMlpRequestsBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionMlpRequestsVarPopFields = {
  __typename?: 'supervision_mlp_requests_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionMlpRequestsVarSampFields = {
  __typename?: 'supervision_mlp_requests_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionMlpRequestsVarianceFields = {
  __typename?: 'supervision_mlp_requests_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroup = {
  __typename?: 'supervision_multivisit_offender_group';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  date?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  lot_id: Scalars['String'];
  offence_type?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  true_offence_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupAggregate = {
  __typename?: 'supervision_multivisit_offender_group_aggregate';
  aggregate?: Maybe<SupervisionMultivisitOffenderGroupAggregateFields>;
  nodes: Array<SupervisionMultivisitOffenderGroup>;
};

/** aggregate fields of "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupAggregateFields = {
  __typename?: 'supervision_multivisit_offender_group_aggregate_fields';
  avg?: Maybe<SupervisionMultivisitOffenderGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionMultivisitOffenderGroupMaxFields>;
  min?: Maybe<SupervisionMultivisitOffenderGroupMinFields>;
  stddev?: Maybe<SupervisionMultivisitOffenderGroupStddevFields>;
  stddev_pop?: Maybe<SupervisionMultivisitOffenderGroupStddevPopFields>;
  stddev_samp?: Maybe<SupervisionMultivisitOffenderGroupStddevSampFields>;
  sum?: Maybe<SupervisionMultivisitOffenderGroupSumFields>;
  var_pop?: Maybe<SupervisionMultivisitOffenderGroupVarPopFields>;
  var_samp?: Maybe<SupervisionMultivisitOffenderGroupVarSampFields>;
  variance?: Maybe<SupervisionMultivisitOffenderGroupVarianceFields>;
};


/** aggregate fields of "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionMultivisitOffenderGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionMultivisitOffenderGroupAvgFields = {
  __typename?: 'supervision_multivisit_offender_group_avg_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_multivisit_offender_group". All fields are combined with a logical 'AND'. */
export type SupervisionMultivisitOffenderGroupBoolExp = {
  _and?: InputMaybe<Array<SupervisionMultivisitOffenderGroupBoolExp>>;
  _not?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
  _or?: InputMaybe<Array<SupervisionMultivisitOffenderGroupBoolExp>>;
  billable_duration_min?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  date?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  offence_type?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  true_offence_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_multivisit_offender_group" */
export enum SupervisionMultivisitOffenderGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionMultivisitOffenderGroupPkey = 'supervision_multivisit_offender_group_pkey'
}

/** input type for incrementing numeric columns in table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupIncInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupInsertInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  offence_type?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionMultivisitOffenderGroupMaxFields = {
  __typename?: 'supervision_multivisit_offender_group_max_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  offence_type?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMember = {
  __typename?: 'supervision_multivisit_offender_group_member';
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  group_id: Scalars['bigint'];
  id: Scalars['bigint'];
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id: Scalars['uuid'];
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberAggregate = {
  __typename?: 'supervision_multivisit_offender_group_member_aggregate';
  aggregate?: Maybe<SupervisionMultivisitOffenderGroupMemberAggregateFields>;
  nodes: Array<SupervisionMultivisitOffenderGroupMember>;
};

/** aggregate fields of "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberAggregateFields = {
  __typename?: 'supervision_multivisit_offender_group_member_aggregate_fields';
  avg?: Maybe<SupervisionMultivisitOffenderGroupMemberAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionMultivisitOffenderGroupMemberMaxFields>;
  min?: Maybe<SupervisionMultivisitOffenderGroupMemberMinFields>;
  stddev?: Maybe<SupervisionMultivisitOffenderGroupMemberStddevFields>;
  stddev_pop?: Maybe<SupervisionMultivisitOffenderGroupMemberStddevPopFields>;
  stddev_samp?: Maybe<SupervisionMultivisitOffenderGroupMemberStddevSampFields>;
  sum?: Maybe<SupervisionMultivisitOffenderGroupMemberSumFields>;
  var_pop?: Maybe<SupervisionMultivisitOffenderGroupMemberVarPopFields>;
  var_samp?: Maybe<SupervisionMultivisitOffenderGroupMemberVarSampFields>;
  variance?: Maybe<SupervisionMultivisitOffenderGroupMemberVarianceFields>;
};


/** aggregate fields of "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionMultivisitOffenderGroupMemberAvgFields = {
  __typename?: 'supervision_multivisit_offender_group_member_avg_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_multivisit_offender_group_member". All fields are combined with a logical 'AND'. */
export type SupervisionMultivisitOffenderGroupMemberBoolExp = {
  _and?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberBoolExp>>;
  _not?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
  _or?: InputMaybe<Array<SupervisionMultivisitOffenderGroupMemberBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_id_in?: InputMaybe<BigintComparisonExp>;
  device_id_out?: InputMaybe<BigintComparisonExp>;
  device_uuid_in?: InputMaybe<StringComparisonExp>;
  device_uuid_out?: InputMaybe<StringComparisonExp>;
  group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_multivisit_offender_group_member" */
export enum SupervisionMultivisitOffenderGroupMemberConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionMultivisitOffenderGroupMemberPkey = 'supervision_multivisit_offender_group_member_pkey'
}

/** input type for incrementing numeric columns in table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberIncInput = {
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionMultivisitOffenderGroupMemberMaxFields = {
  __typename?: 'supervision_multivisit_offender_group_member_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SupervisionMultivisitOffenderGroupMemberMinFields = {
  __typename?: 'supervision_multivisit_offender_group_member_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  device_uuid_in?: Maybe<Scalars['String']>;
  device_uuid_out?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberMutationResponse = {
  __typename?: 'supervision_multivisit_offender_group_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionMultivisitOffenderGroupMember>;
};

/** on_conflict condition type for table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberOnConflict = {
  constraint: SupervisionMultivisitOffenderGroupMemberConstraint;
  update_columns?: Array<SupervisionMultivisitOffenderGroupMemberUpdateColumn>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupMemberBoolExp>;
};

/** Ordering options when selecting data from "supervision_multivisit_offender_group_member". */
export type SupervisionMultivisitOffenderGroupMemberOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_id_in?: InputMaybe<OrderBy>;
  device_id_out?: InputMaybe<OrderBy>;
  device_uuid_in?: InputMaybe<OrderBy>;
  device_uuid_out?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_multivisit_offender_group_member */
export type SupervisionMultivisitOffenderGroupMemberPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_multivisit_offender_group_member" */
export enum SupervisionMultivisitOffenderGroupMemberSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberSetInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionMultivisitOffenderGroupMemberStddevFields = {
  __typename?: 'supervision_multivisit_offender_group_member_stddev_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionMultivisitOffenderGroupMemberStddevPopFields = {
  __typename?: 'supervision_multivisit_offender_group_member_stddev_pop_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionMultivisitOffenderGroupMemberStddevSampFields = {
  __typename?: 'supervision_multivisit_offender_group_member_stddev_samp_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_multivisit_offender_group_member" */
export type SupervisionMultivisitOffenderGroupMemberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionMultivisitOffenderGroupMemberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionMultivisitOffenderGroupMemberStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id_in?: InputMaybe<Scalars['bigint']>;
  device_id_out?: InputMaybe<Scalars['bigint']>;
  device_uuid_in?: InputMaybe<Scalars['String']>;
  device_uuid_out?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionMultivisitOffenderGroupMemberSumFields = {
  __typename?: 'supervision_multivisit_offender_group_member_sum_fields';
  device_id_in?: Maybe<Scalars['bigint']>;
  device_id_out?: Maybe<Scalars['bigint']>;
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_multivisit_offender_group_member" */
export enum SupervisionMultivisitOffenderGroupMemberUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdIn = 'device_id_in',
  /** column name */
  DeviceIdOut = 'device_id_out',
  /** column name */
  DeviceUuidIn = 'device_uuid_in',
  /** column name */
  DeviceUuidOut = 'device_uuid_out',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionMultivisitOffenderGroupMemberUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupMemberIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupMemberSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionMultivisitOffenderGroupMemberBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionMultivisitOffenderGroupMemberVarPopFields = {
  __typename?: 'supervision_multivisit_offender_group_member_var_pop_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionMultivisitOffenderGroupMemberVarSampFields = {
  __typename?: 'supervision_multivisit_offender_group_member_var_samp_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionMultivisitOffenderGroupMemberVarianceFields = {
  __typename?: 'supervision_multivisit_offender_group_member_variance_fields';
  device_id_in?: Maybe<Scalars['Float']>;
  device_id_out?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type SupervisionMultivisitOffenderGroupMinFields = {
  __typename?: 'supervision_multivisit_offender_group_min_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  offence_type?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupMutationResponse = {
  __typename?: 'supervision_multivisit_offender_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionMultivisitOffenderGroup>;
};

/** on_conflict condition type for table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupOnConflict = {
  constraint: SupervisionMultivisitOffenderGroupConstraint;
  update_columns?: Array<SupervisionMultivisitOffenderGroupUpdateColumn>;
  where?: InputMaybe<SupervisionMultivisitOffenderGroupBoolExp>;
};

/** Ordering options when selecting data from "supervision_multivisit_offender_group". */
export type SupervisionMultivisitOffenderGroupOrderBy = {
  billable_duration_min?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  offence_type?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  true_offence_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_multivisit_offender_group */
export type SupervisionMultivisitOffenderGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_multivisit_offender_group" */
export enum SupervisionMultivisitOffenderGroupSelectColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OffenceType = 'offence_type',
  /** column name */
  Plate = 'plate',
  /** column name */
  Status = 'status',
  /** column name */
  TrueOffenceId = 'true_offence_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupSetInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  offence_type?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionMultivisitOffenderGroupStddevFields = {
  __typename?: 'supervision_multivisit_offender_group_stddev_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionMultivisitOffenderGroupStddevPopFields = {
  __typename?: 'supervision_multivisit_offender_group_stddev_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionMultivisitOffenderGroupStddevSampFields = {
  __typename?: 'supervision_multivisit_offender_group_stddev_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_multivisit_offender_group" */
export type SupervisionMultivisitOffenderGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionMultivisitOffenderGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionMultivisitOffenderGroupStreamCursorValueInput = {
  billable_duration_min?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  offence_type?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionMultivisitOffenderGroupSumFields = {
  __typename?: 'supervision_multivisit_offender_group_sum_fields';
  billable_duration_min?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_multivisit_offender_group" */
export enum SupervisionMultivisitOffenderGroupUpdateColumn {
  /** column name */
  BillableDurationMin = 'billable_duration_min',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OffenceType = 'offence_type',
  /** column name */
  Plate = 'plate',
  /** column name */
  Status = 'status',
  /** column name */
  TrueOffenceId = 'true_offence_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionMultivisitOffenderGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionMultivisitOffenderGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionMultivisitOffenderGroupSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionMultivisitOffenderGroupBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionMultivisitOffenderGroupVarPopFields = {
  __typename?: 'supervision_multivisit_offender_group_var_pop_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionMultivisitOffenderGroupVarSampFields = {
  __typename?: 'supervision_multivisit_offender_group_var_samp_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionMultivisitOffenderGroupVarianceFields = {
  __typename?: 'supervision_multivisit_offender_group_variance_fields';
  billable_duration_min?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "supervision_ticket_request" */
export type SupervisionTicketRequest = {
  __typename?: 'supervision_ticket_request';
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  guest_jwt: GuestJwt;
  id: Scalars['bigint'];
  jwt_id: Scalars['Int'];
  plate: Scalars['String'];
  salesforce_id: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "supervision_ticket_request" */
export type SupervisionTicketRequestAggregate = {
  __typename?: 'supervision_ticket_request_aggregate';
  aggregate?: Maybe<SupervisionTicketRequestAggregateFields>;
  nodes: Array<SupervisionTicketRequest>;
};

/** aggregate fields of "supervision_ticket_request" */
export type SupervisionTicketRequestAggregateFields = {
  __typename?: 'supervision_ticket_request_aggregate_fields';
  avg?: Maybe<SupervisionTicketRequestAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionTicketRequestMaxFields>;
  min?: Maybe<SupervisionTicketRequestMinFields>;
  stddev?: Maybe<SupervisionTicketRequestStddevFields>;
  stddev_pop?: Maybe<SupervisionTicketRequestStddevPopFields>;
  stddev_samp?: Maybe<SupervisionTicketRequestStddevSampFields>;
  sum?: Maybe<SupervisionTicketRequestSumFields>;
  var_pop?: Maybe<SupervisionTicketRequestVarPopFields>;
  var_samp?: Maybe<SupervisionTicketRequestVarSampFields>;
  variance?: Maybe<SupervisionTicketRequestVarianceFields>;
};


/** aggregate fields of "supervision_ticket_request" */
export type SupervisionTicketRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionTicketRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionTicketRequestAvgFields = {
  __typename?: 'supervision_ticket_request_avg_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_ticket_request". All fields are combined with a logical 'AND'. */
export type SupervisionTicketRequestBoolExp = {
  _and?: InputMaybe<Array<SupervisionTicketRequestBoolExp>>;
  _not?: InputMaybe<SupervisionTicketRequestBoolExp>;
  _or?: InputMaybe<Array<SupervisionTicketRequestBoolExp>>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  guest_jwt?: InputMaybe<GuestJwtBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  jwt_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  salesforce_id?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "supervision_ticket_request" */
export enum SupervisionTicketRequestConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionTicketRequestPkey = 'supervision_ticket_request_pkey'
}

/** input type for incrementing numeric columns in table "supervision_ticket_request" */
export type SupervisionTicketRequestIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "supervision_ticket_request" */
export type SupervisionTicketRequestInsertInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guest_jwt?: InputMaybe<GuestJwtObjRelInsertInput>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SupervisionTicketRequestMaxFields = {
  __typename?: 'supervision_ticket_request_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SupervisionTicketRequestMinFields = {
  __typename?: 'supervision_ticket_request_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervision_ticket_request" */
export type SupervisionTicketRequestMutationResponse = {
  __typename?: 'supervision_ticket_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionTicketRequest>;
};

/** on_conflict condition type for table "supervision_ticket_request" */
export type SupervisionTicketRequestOnConflict = {
  constraint: SupervisionTicketRequestConstraint;
  update_columns?: Array<SupervisionTicketRequestUpdateColumn>;
  where?: InputMaybe<SupervisionTicketRequestBoolExp>;
};

/** Ordering options when selecting data from "supervision_ticket_request". */
export type SupervisionTicketRequestOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  guest_jwt?: InputMaybe<GuestJwtOrderBy>;
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  salesforce_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_ticket_request */
export type SupervisionTicketRequestPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_ticket_request" */
export enum SupervisionTicketRequestSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supervision_ticket_request" */
export type SupervisionTicketRequestSetInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SupervisionTicketRequestStddevFields = {
  __typename?: 'supervision_ticket_request_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionTicketRequestStddevPopFields = {
  __typename?: 'supervision_ticket_request_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionTicketRequestStddevSampFields = {
  __typename?: 'supervision_ticket_request_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_ticket_request" */
export type SupervisionTicketRequestStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionTicketRequestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionTicketRequestStreamCursorValueInput = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SupervisionTicketRequestSumFields = {
  __typename?: 'supervision_ticket_request_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "supervision_ticket_request" */
export enum SupervisionTicketRequestUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type SupervisionTicketRequestUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionTicketRequestIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionTicketRequestSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionTicketRequestBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionTicketRequestVarPopFields = {
  __typename?: 'supervision_ticket_request_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionTicketRequestVarSampFields = {
  __typename?: 'supervision_ticket_request_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionTicketRequestVarianceFields = {
  __typename?: 'supervision_ticket_request_variance_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Junction table to link violation case to a debt collection case */
export type SupervisionViolationCaseDebtCollectionCase = {
  __typename?: 'supervision_violation_case_debt_collection_case';
  created_at: Scalars['timestamptz'];
  debt_collection_case_id: Scalars['bigint'];
  id: Scalars['bigint'];
  true_offence_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseAggregate = {
  __typename?: 'supervision_violation_case_debt_collection_case_aggregate';
  aggregate?: Maybe<SupervisionViolationCaseDebtCollectionCaseAggregateFields>;
  nodes: Array<SupervisionViolationCaseDebtCollectionCase>;
};

/** aggregate fields of "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseAggregateFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_aggregate_fields';
  avg?: Maybe<SupervisionViolationCaseDebtCollectionCaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SupervisionViolationCaseDebtCollectionCaseMaxFields>;
  min?: Maybe<SupervisionViolationCaseDebtCollectionCaseMinFields>;
  stddev?: Maybe<SupervisionViolationCaseDebtCollectionCaseStddevFields>;
  stddev_pop?: Maybe<SupervisionViolationCaseDebtCollectionCaseStddevPopFields>;
  stddev_samp?: Maybe<SupervisionViolationCaseDebtCollectionCaseStddevSampFields>;
  sum?: Maybe<SupervisionViolationCaseDebtCollectionCaseSumFields>;
  var_pop?: Maybe<SupervisionViolationCaseDebtCollectionCaseVarPopFields>;
  var_samp?: Maybe<SupervisionViolationCaseDebtCollectionCaseVarSampFields>;
  variance?: Maybe<SupervisionViolationCaseDebtCollectionCaseVarianceFields>;
};


/** aggregate fields of "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupervisionViolationCaseDebtCollectionCaseAvgFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_avg_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervision_violation_case_debt_collection_case". All fields are combined with a logical 'AND'. */
export type SupervisionViolationCaseDebtCollectionCaseBoolExp = {
  _and?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseBoolExp>>;
  _not?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
  _or?: InputMaybe<Array<SupervisionViolationCaseDebtCollectionCaseBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  debt_collection_case_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  true_offence_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "supervision_violation_case_debt_collection_case" */
export enum SupervisionViolationCaseDebtCollectionCaseConstraint {
  /** unique or primary key constraint on columns "id" */
  SupervisionViolationCaseDebtCollectionCasePkey = 'supervision_violation_case_debt_collection_case_pkey'
}

/** input type for incrementing numeric columns in table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseIncInput = {
  debt_collection_case_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_case_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SupervisionViolationCaseDebtCollectionCaseMaxFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collection_case_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SupervisionViolationCaseDebtCollectionCaseMinFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collection_case_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseMutationResponse = {
  __typename?: 'supervision_violation_case_debt_collection_case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupervisionViolationCaseDebtCollectionCase>;
};

/** on_conflict condition type for table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseOnConflict = {
  constraint: SupervisionViolationCaseDebtCollectionCaseConstraint;
  update_columns?: Array<SupervisionViolationCaseDebtCollectionCaseUpdateColumn>;
  where?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseBoolExp>;
};

/** Ordering options when selecting data from "supervision_violation_case_debt_collection_case". */
export type SupervisionViolationCaseDebtCollectionCaseOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  debt_collection_case_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  true_offence_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: supervision_violation_case_debt_collection_case */
export type SupervisionViolationCaseDebtCollectionCasePkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "supervision_violation_case_debt_collection_case" */
export enum SupervisionViolationCaseDebtCollectionCaseSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectionCaseId = 'debt_collection_case_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrueOffenceId = 'true_offence_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_case_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SupervisionViolationCaseDebtCollectionCaseStddevFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_stddev_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupervisionViolationCaseDebtCollectionCaseStddevPopFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_stddev_pop_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupervisionViolationCaseDebtCollectionCaseStddevSampFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_stddev_samp_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervision_violation_case_debt_collection_case" */
export type SupervisionViolationCaseDebtCollectionCaseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupervisionViolationCaseDebtCollectionCaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupervisionViolationCaseDebtCollectionCaseStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_case_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  true_offence_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SupervisionViolationCaseDebtCollectionCaseSumFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_sum_fields';
  debt_collection_case_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  true_offence_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "supervision_violation_case_debt_collection_case" */
export enum SupervisionViolationCaseDebtCollectionCaseUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectionCaseId = 'debt_collection_case_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrueOffenceId = 'true_offence_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type SupervisionViolationCaseDebtCollectionCaseUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SupervisionViolationCaseDebtCollectionCaseSetInput>;
  /** filter the rows which have to be updated */
  where: SupervisionViolationCaseDebtCollectionCaseBoolExp;
};

/** aggregate var_pop on columns */
export type SupervisionViolationCaseDebtCollectionCaseVarPopFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_var_pop_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupervisionViolationCaseDebtCollectionCaseVarSampFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_var_samp_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupervisionViolationCaseDebtCollectionCaseVarianceFields = {
  __typename?: 'supervision_violation_case_debt_collection_case_variance_fields';
  debt_collection_case_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  true_offence_id?: Maybe<Scalars['Float']>;
};

/** Versioned list of taxation rules that apply in certain scenarios (region and subregion definitions) that are only defined verbally */
export type Tax = {
  __typename?: 'tax';
  application_scenario: Scalars['String'];
  country?: Maybe<EnumCountryCodeEnum>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  uuid: Scalars['Int'];
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
  vat_rate: Scalars['numeric'];
  vat_rates: Scalars['jsonb'];
};


/** Versioned list of taxation rules that apply in certain scenarios (region and subregion definitions) that are only defined verbally */
export type TaxVatRatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tax" */
export type TaxAggregate = {
  __typename?: 'tax_aggregate';
  aggregate?: Maybe<TaxAggregateFields>;
  nodes: Array<Tax>;
};

/** aggregate fields of "tax" */
export type TaxAggregateFields = {
  __typename?: 'tax_aggregate_fields';
  avg?: Maybe<TaxAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TaxMaxFields>;
  min?: Maybe<TaxMinFields>;
  stddev?: Maybe<TaxStddevFields>;
  stddev_pop?: Maybe<TaxStddevPopFields>;
  stddev_samp?: Maybe<TaxStddevSampFields>;
  sum?: Maybe<TaxSumFields>;
  var_pop?: Maybe<TaxVarPopFields>;
  var_samp?: Maybe<TaxVarSampFields>;
  variance?: Maybe<TaxVarianceFields>;
};


/** aggregate fields of "tax" */
export type TaxAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TaxSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TaxAppendInput = {
  vat_rates?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type TaxAvgFields = {
  __typename?: 'tax_avg_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tax". All fields are combined with a logical 'AND'. */
export type TaxBoolExp = {
  _and?: InputMaybe<Array<TaxBoolExp>>;
  _not?: InputMaybe<TaxBoolExp>;
  _or?: InputMaybe<Array<TaxBoolExp>>;
  application_scenario?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<EnumCountryCodeEnumComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  uuid?: InputMaybe<IntComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
  vat_rate?: InputMaybe<NumericComparisonExp>;
  vat_rates?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "tax" */
export enum TaxConstraint {
  /** unique or primary key constraint on columns "uuid" */
  TaxPkey = 'tax_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TaxDeleteAtPathInput = {
  vat_rates?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TaxDeleteElemInput = {
  vat_rates?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TaxDeleteKeyInput = {
  vat_rates?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "tax" */
export type TaxIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "tax" */
export type TaxInsertInput = {
  application_scenario?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_rates?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type TaxMaxFields = {
  __typename?: 'tax_max_fields';
  application_scenario?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
  vat_rate?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type TaxMinFields = {
  __typename?: 'tax_min_fields';
  application_scenario?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
  vat_rate?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "tax" */
export type TaxMutationResponse = {
  __typename?: 'tax_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tax>;
};

/** input type for inserting object relation for remote table "tax" */
export type TaxObjRelInsertInput = {
  data: TaxInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TaxOnConflict>;
};

/** on_conflict condition type for table "tax" */
export type TaxOnConflict = {
  constraint: TaxConstraint;
  update_columns?: Array<TaxUpdateColumn>;
  where?: InputMaybe<TaxBoolExp>;
};

/** Ordering options when selecting data from "tax". */
export type TaxOrderBy = {
  application_scenario?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
  vat_rate?: InputMaybe<OrderBy>;
  vat_rates?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tax */
export type TaxPkColumnsInput = {
  uuid: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TaxPrependInput = {
  vat_rates?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tax" */
export enum TaxSelectColumn {
  /** column name */
  ApplicationScenario = 'application_scenario',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatRates = 'vat_rates'
}

/** input type for updating data in table "tax" */
export type TaxSetInput = {
  application_scenario?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_rates?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type TaxStddevFields = {
  __typename?: 'tax_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TaxStddevPopFields = {
  __typename?: 'tax_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TaxStddevSampFields = {
  __typename?: 'tax_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tax" */
export type TaxStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TaxStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaxStreamCursorValueInput = {
  application_scenario?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_rates?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type TaxSumFields = {
  __typename?: 'tax_sum_fields';
  id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
  vat_rate?: Maybe<Scalars['numeric']>;
};

/** update columns of table "tax" */
export enum TaxUpdateColumn {
  /** column name */
  ApplicationScenario = 'application_scenario',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatRates = 'vat_rates'
}

export type TaxUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TaxAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TaxDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TaxDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TaxDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TaxIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TaxPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaxSetInput>;
  /** filter the rows which have to be updated */
  where: TaxBoolExp;
};

/** aggregate var_pop on columns */
export type TaxVarPopFields = {
  __typename?: 'tax_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TaxVarSampFields = {
  __typename?: 'tax_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TaxVarianceFields = {
  __typename?: 'tax_variance_fields';
  id?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['Float']>;
  vat_rate?: Maybe<Scalars['Float']>;
};

/** Contains States published by Carpay Terminals */
export type TerminalStatus = {
  __typename?: 'terminal_status';
  created_at: Scalars['timestamptz'];
  device_uuid: Scalars['String'];
  id: Scalars['Int'];
  lot_id: Scalars['String'];
  status_data: Scalars['jsonb'];
  terminal_id: Scalars['numeric'];
};


/** Contains States published by Carpay Terminals */
export type TerminalStatusStatusDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "terminal_status" */
export type TerminalStatusAggregate = {
  __typename?: 'terminal_status_aggregate';
  aggregate?: Maybe<TerminalStatusAggregateFields>;
  nodes: Array<TerminalStatus>;
};

/** aggregate fields of "terminal_status" */
export type TerminalStatusAggregateFields = {
  __typename?: 'terminal_status_aggregate_fields';
  avg?: Maybe<TerminalStatusAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TerminalStatusMaxFields>;
  min?: Maybe<TerminalStatusMinFields>;
  stddev?: Maybe<TerminalStatusStddevFields>;
  stddev_pop?: Maybe<TerminalStatusStddevPopFields>;
  stddev_samp?: Maybe<TerminalStatusStddevSampFields>;
  sum?: Maybe<TerminalStatusSumFields>;
  var_pop?: Maybe<TerminalStatusVarPopFields>;
  var_samp?: Maybe<TerminalStatusVarSampFields>;
  variance?: Maybe<TerminalStatusVarianceFields>;
};


/** aggregate fields of "terminal_status" */
export type TerminalStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TerminalStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TerminalStatusAppendInput = {
  status_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type TerminalStatusAvgFields = {
  __typename?: 'terminal_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "terminal_status". All fields are combined with a logical 'AND'. */
export type TerminalStatusBoolExp = {
  _and?: InputMaybe<Array<TerminalStatusBoolExp>>;
  _not?: InputMaybe<TerminalStatusBoolExp>;
  _or?: InputMaybe<Array<TerminalStatusBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  status_data?: InputMaybe<JsonbComparisonExp>;
  terminal_id?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "terminal_status" */
export enum TerminalStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  TerminalStatusPkey = 'terminal_status_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TerminalStatusDeleteAtPathInput = {
  status_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TerminalStatusDeleteElemInput = {
  status_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TerminalStatusDeleteKeyInput = {
  status_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "terminal_status" */
export type TerminalStatusIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "terminal_status" */
export type TerminalStatusInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  status_data?: InputMaybe<Scalars['jsonb']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type TerminalStatusMaxFields = {
  __typename?: 'terminal_status_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type TerminalStatusMinFields = {
  __typename?: 'terminal_status_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "terminal_status" */
export type TerminalStatusMutationResponse = {
  __typename?: 'terminal_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TerminalStatus>;
};

/** on_conflict condition type for table "terminal_status" */
export type TerminalStatusOnConflict = {
  constraint: TerminalStatusConstraint;
  update_columns?: Array<TerminalStatusUpdateColumn>;
  where?: InputMaybe<TerminalStatusBoolExp>;
};

/** Ordering options when selecting data from "terminal_status". */
export type TerminalStatusOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  status_data?: InputMaybe<OrderBy>;
  terminal_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: terminal_status */
export type TerminalStatusPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TerminalStatusPrependInput = {
  status_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "terminal_status" */
export enum TerminalStatusSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  StatusData = 'status_data',
  /** column name */
  TerminalId = 'terminal_id'
}

/** input type for updating data in table "terminal_status" */
export type TerminalStatusSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  status_data?: InputMaybe<Scalars['jsonb']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type TerminalStatusStddevFields = {
  __typename?: 'terminal_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TerminalStatusStddevPopFields = {
  __typename?: 'terminal_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TerminalStatusStddevSampFields = {
  __typename?: 'terminal_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "terminal_status" */
export type TerminalStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TerminalStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TerminalStatusStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  status_data?: InputMaybe<Scalars['jsonb']>;
  terminal_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type TerminalStatusSumFields = {
  __typename?: 'terminal_status_sum_fields';
  id?: Maybe<Scalars['Int']>;
  terminal_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "terminal_status" */
export enum TerminalStatusUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  StatusData = 'status_data',
  /** column name */
  TerminalId = 'terminal_id'
}

export type TerminalStatusUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TerminalStatusAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TerminalStatusDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TerminalStatusDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TerminalStatusDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TerminalStatusIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TerminalStatusPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TerminalStatusSetInput>;
  /** filter the rows which have to be updated */
  where: TerminalStatusBoolExp;
};

/** aggregate var_pop on columns */
export type TerminalStatusVarPopFields = {
  __typename?: 'terminal_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TerminalStatusVarSampFields = {
  __typename?: 'terminal_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TerminalStatusVarianceFields = {
  __typename?: 'terminal_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
  terminal_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticket_website_feedback" */
export type TicketWebsiteFeedback = {
  __typename?: 'ticket_website_feedback';
  callback_consent: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  info?: Maybe<Scalars['jsonb']>;
  rating: Scalars['Int'];
  true_offence_case_id: Scalars['bigint'];
};


/** columns and relationships of "ticket_website_feedback" */
export type TicketWebsiteFeedbackInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ticket_website_feedback" */
export type TicketWebsiteFeedbackAggregate = {
  __typename?: 'ticket_website_feedback_aggregate';
  aggregate?: Maybe<TicketWebsiteFeedbackAggregateFields>;
  nodes: Array<TicketWebsiteFeedback>;
};

/** aggregate fields of "ticket_website_feedback" */
export type TicketWebsiteFeedbackAggregateFields = {
  __typename?: 'ticket_website_feedback_aggregate_fields';
  avg?: Maybe<TicketWebsiteFeedbackAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TicketWebsiteFeedbackMaxFields>;
  min?: Maybe<TicketWebsiteFeedbackMinFields>;
  stddev?: Maybe<TicketWebsiteFeedbackStddevFields>;
  stddev_pop?: Maybe<TicketWebsiteFeedbackStddevPopFields>;
  stddev_samp?: Maybe<TicketWebsiteFeedbackStddevSampFields>;
  sum?: Maybe<TicketWebsiteFeedbackSumFields>;
  var_pop?: Maybe<TicketWebsiteFeedbackVarPopFields>;
  var_samp?: Maybe<TicketWebsiteFeedbackVarSampFields>;
  variance?: Maybe<TicketWebsiteFeedbackVarianceFields>;
};


/** aggregate fields of "ticket_website_feedback" */
export type TicketWebsiteFeedbackAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TicketWebsiteFeedbackSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TicketWebsiteFeedbackAppendInput = {
  info?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type TicketWebsiteFeedbackAvgFields = {
  __typename?: 'ticket_website_feedback_avg_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticket_website_feedback". All fields are combined with a logical 'AND'. */
export type TicketWebsiteFeedbackBoolExp = {
  _and?: InputMaybe<Array<TicketWebsiteFeedbackBoolExp>>;
  _not?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
  _or?: InputMaybe<Array<TicketWebsiteFeedbackBoolExp>>;
  callback_consent?: InputMaybe<BooleanComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  info?: InputMaybe<JsonbComparisonExp>;
  rating?: InputMaybe<IntComparisonExp>;
  true_offence_case_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ticket_website_feedback" */
export enum TicketWebsiteFeedbackConstraint {
  /** unique or primary key constraint on columns "id" */
  TicketWebsiteFeedbackIdKey = 'ticket_website_feedback_id_key',
  /** unique or primary key constraint on columns "id" */
  TicketWebsiteFeedbackPkey = 'ticket_website_feedback_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TicketWebsiteFeedbackDeleteAtPathInput = {
  info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TicketWebsiteFeedbackDeleteElemInput = {
  info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TicketWebsiteFeedbackDeleteKeyInput = {
  info?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ticket_website_feedback" */
export type TicketWebsiteFeedbackIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  rating?: InputMaybe<Scalars['Int']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "ticket_website_feedback" */
export type TicketWebsiteFeedbackInsertInput = {
  callback_consent?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  info?: InputMaybe<Scalars['jsonb']>;
  rating?: InputMaybe<Scalars['Int']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type TicketWebsiteFeedbackMaxFields = {
  __typename?: 'ticket_website_feedback_max_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  rating?: Maybe<Scalars['Int']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TicketWebsiteFeedbackMinFields = {
  __typename?: 'ticket_website_feedback_min_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  rating?: Maybe<Scalars['Int']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ticket_website_feedback" */
export type TicketWebsiteFeedbackMutationResponse = {
  __typename?: 'ticket_website_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TicketWebsiteFeedback>;
};

/** on_conflict condition type for table "ticket_website_feedback" */
export type TicketWebsiteFeedbackOnConflict = {
  constraint: TicketWebsiteFeedbackConstraint;
  update_columns?: Array<TicketWebsiteFeedbackUpdateColumn>;
  where?: InputMaybe<TicketWebsiteFeedbackBoolExp>;
};

/** Ordering options when selecting data from "ticket_website_feedback". */
export type TicketWebsiteFeedbackOrderBy = {
  callback_consent?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  info?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  true_offence_case_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ticket_website_feedback */
export type TicketWebsiteFeedbackPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TicketWebsiteFeedbackPrependInput = {
  info?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ticket_website_feedback" */
export enum TicketWebsiteFeedbackSelectColumn {
  /** column name */
  CallbackConsent = 'callback_consent',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  Rating = 'rating',
  /** column name */
  TrueOffenceCaseId = 'true_offence_case_id'
}

/** input type for updating data in table "ticket_website_feedback" */
export type TicketWebsiteFeedbackSetInput = {
  callback_consent?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  info?: InputMaybe<Scalars['jsonb']>;
  rating?: InputMaybe<Scalars['Int']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type TicketWebsiteFeedbackStddevFields = {
  __typename?: 'ticket_website_feedback_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TicketWebsiteFeedbackStddevPopFields = {
  __typename?: 'ticket_website_feedback_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TicketWebsiteFeedbackStddevSampFields = {
  __typename?: 'ticket_website_feedback_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticket_website_feedback" */
export type TicketWebsiteFeedbackStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TicketWebsiteFeedbackStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TicketWebsiteFeedbackStreamCursorValueInput = {
  callback_consent?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  info?: InputMaybe<Scalars['jsonb']>;
  rating?: InputMaybe<Scalars['Int']>;
  true_offence_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TicketWebsiteFeedbackSumFields = {
  __typename?: 'ticket_website_feedback_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  rating?: Maybe<Scalars['Int']>;
  true_offence_case_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ticket_website_feedback" */
export enum TicketWebsiteFeedbackUpdateColumn {
  /** column name */
  CallbackConsent = 'callback_consent',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  Rating = 'rating',
  /** column name */
  TrueOffenceCaseId = 'true_offence_case_id'
}

export type TicketWebsiteFeedbackUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TicketWebsiteFeedbackAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TicketWebsiteFeedbackDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TicketWebsiteFeedbackDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TicketWebsiteFeedbackDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TicketWebsiteFeedbackIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TicketWebsiteFeedbackPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TicketWebsiteFeedbackSetInput>;
  /** filter the rows which have to be updated */
  where: TicketWebsiteFeedbackBoolExp;
};

/** aggregate var_pop on columns */
export type TicketWebsiteFeedbackVarPopFields = {
  __typename?: 'ticket_website_feedback_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TicketWebsiteFeedbackVarSampFields = {
  __typename?: 'ticket_website_feedback_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TicketWebsiteFeedbackVarianceFields = {
  __typename?: 'ticket_website_feedback_variance_fields';
  id?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  true_offence_case_id?: Maybe<Scalars['Float']>;
};

/** Table for time discounts that will be deducted from the billable duration of a parking event on a specific parking lot */
export type TimeDiscount = {
  __typename?: 'time_discount';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  discount_duration: Scalars['String'];
  id: Scalars['bigint'];
  jwt_id?: Maybe<Scalars['Int']>;
  lot_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  plate: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "time_discount" */
export type TimeDiscountAggregate = {
  __typename?: 'time_discount_aggregate';
  aggregate?: Maybe<TimeDiscountAggregateFields>;
  nodes: Array<TimeDiscount>;
};

/** aggregate fields of "time_discount" */
export type TimeDiscountAggregateFields = {
  __typename?: 'time_discount_aggregate_fields';
  avg?: Maybe<TimeDiscountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TimeDiscountMaxFields>;
  min?: Maybe<TimeDiscountMinFields>;
  stddev?: Maybe<TimeDiscountStddevFields>;
  stddev_pop?: Maybe<TimeDiscountStddevPopFields>;
  stddev_samp?: Maybe<TimeDiscountStddevSampFields>;
  sum?: Maybe<TimeDiscountSumFields>;
  var_pop?: Maybe<TimeDiscountVarPopFields>;
  var_samp?: Maybe<TimeDiscountVarSampFields>;
  variance?: Maybe<TimeDiscountVarianceFields>;
};


/** aggregate fields of "time_discount" */
export type TimeDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TimeDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TimeDiscountAvgFields = {
  __typename?: 'time_discount_avg_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "time_discount". All fields are combined with a logical 'AND'. */
export type TimeDiscountBoolExp = {
  _and?: InputMaybe<Array<TimeDiscountBoolExp>>;
  _not?: InputMaybe<TimeDiscountBoolExp>;
  _or?: InputMaybe<Array<TimeDiscountBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  discount_duration?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  jwt_id?: InputMaybe<IntComparisonExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "time_discount" */
export enum TimeDiscountConstraint {
  /** unique or primary key constraint on columns "id" */
  TimeDiscountPkey = 'time_discount_pkey'
}

/** input type for incrementing numeric columns in table "time_discount" */
export type TimeDiscountIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "time_discount" */
export type TimeDiscountInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TimeDiscountMaxFields = {
  __typename?: 'time_discount_max_fields';
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TimeDiscountMinFields = {
  __typename?: 'time_discount_min_fields';
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "time_discount" */
export type TimeDiscountMutationResponse = {
  __typename?: 'time_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TimeDiscount>;
};

/** input type for inserting object relation for remote table "time_discount" */
export type TimeDiscountObjRelInsertInput = {
  data: TimeDiscountInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TimeDiscountOnConflict>;
};

/** on_conflict condition type for table "time_discount" */
export type TimeDiscountOnConflict = {
  constraint: TimeDiscountConstraint;
  update_columns?: Array<TimeDiscountUpdateColumn>;
  where?: InputMaybe<TimeDiscountBoolExp>;
};

/** Ordering options when selecting data from "time_discount". */
export type TimeDiscountOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  discount_duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jwt_id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: time_discount */
export type TimeDiscountPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "time_discount" */
export enum TimeDiscountSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountDuration = 'discount_duration',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Plate = 'plate',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "time_discount" */
export type TimeDiscountSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type TimeDiscountStddevFields = {
  __typename?: 'time_discount_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TimeDiscountStddevPopFields = {
  __typename?: 'time_discount_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TimeDiscountStddevSampFields = {
  __typename?: 'time_discount_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "time_discount" */
export type TimeDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TimeDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TimeDiscountStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  jwt_id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type TimeDiscountSumFields = {
  __typename?: 'time_discount_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  jwt_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "time_discount" */
export enum TimeDiscountUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountDuration = 'discount_duration',
  /** column name */
  Id = 'id',
  /** column name */
  JwtId = 'jwt_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Plate = 'plate',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type TimeDiscountUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TimeDiscountIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TimeDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TimeDiscountBoolExp;
};

/** aggregate var_pop on columns */
export type TimeDiscountVarPopFields = {
  __typename?: 'time_discount_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TimeDiscountVarSampFields = {
  __typename?: 'time_discount_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TimeDiscountVarianceFields = {
  __typename?: 'time_discount_variance_fields';
  id?: Maybe<Scalars['Float']>;
  jwt_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type TimetzComparisonExp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

export type TolerateParkingResultsApiOutput = {
  __typename?: 'tolerateParkingResultsAPIOutput';
  message: Scalars['String'];
};

/** columns and relationships of "user_preference" */
export type UserPreference = {
  __typename?: 'user_preference';
  blacklist: Scalars['jsonb'];
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  general: Scalars['jsonb'];
  notification: Scalars['jsonb'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id: Scalars['String'];
  user_metadata?: Maybe<Scalars['jsonb']>;
  user_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "user_preference" */
export type UserPreferenceBlacklistArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_preference" */
export type UserPreferenceGeneralArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_preference" */
export type UserPreferenceNotificationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_preference" */
export type UserPreferenceUserMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_preference" */
export type UserPreferenceAggregate = {
  __typename?: 'user_preference_aggregate';
  aggregate?: Maybe<UserPreferenceAggregateFields>;
  nodes: Array<UserPreference>;
};

/** aggregate fields of "user_preference" */
export type UserPreferenceAggregateFields = {
  __typename?: 'user_preference_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserPreferenceMaxFields>;
  min?: Maybe<UserPreferenceMinFields>;
};


/** aggregate fields of "user_preference" */
export type UserPreferenceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPreferenceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserPreferenceAppendInput = {
  blacklist?: InputMaybe<Scalars['jsonb']>;
  general?: InputMaybe<Scalars['jsonb']>;
  notification?: InputMaybe<Scalars['jsonb']>;
  user_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "user_preference". All fields are combined with a logical 'AND'. */
export type UserPreferenceBoolExp = {
  _and?: InputMaybe<Array<UserPreferenceBoolExp>>;
  _not?: InputMaybe<UserPreferenceBoolExp>;
  _or?: InputMaybe<Array<UserPreferenceBoolExp>>;
  blacklist?: InputMaybe<JsonbComparisonExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  general?: InputMaybe<JsonbComparisonExp>;
  notification?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
  user_metadata?: InputMaybe<JsonbComparisonExp>;
  user_name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_preference" */
export enum UserPreferenceConstraint {
  /** unique or primary key constraint on columns "user_id" */
  UserPreferencePkey = 'user_preference_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserPreferenceDeleteAtPathInput = {
  blacklist?: InputMaybe<Array<Scalars['String']>>;
  general?: InputMaybe<Array<Scalars['String']>>;
  notification?: InputMaybe<Array<Scalars['String']>>;
  user_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserPreferenceDeleteElemInput = {
  blacklist?: InputMaybe<Scalars['Int']>;
  general?: InputMaybe<Scalars['Int']>;
  notification?: InputMaybe<Scalars['Int']>;
  user_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserPreferenceDeleteKeyInput = {
  blacklist?: InputMaybe<Scalars['String']>;
  general?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<Scalars['String']>;
  user_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "user_preference" */
export type UserPreferenceInsertInput = {
  blacklist?: InputMaybe<Scalars['jsonb']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  general?: InputMaybe<Scalars['jsonb']>;
  notification?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  user_metadata?: InputMaybe<Scalars['jsonb']>;
  user_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserPreferenceMaxFields = {
  __typename?: 'user_preference_max_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserPreferenceMinFields = {
  __typename?: 'user_preference_min_fields';
  company_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_preference" */
export type UserPreferenceMutationResponse = {
  __typename?: 'user_preference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPreference>;
};

/** on_conflict condition type for table "user_preference" */
export type UserPreferenceOnConflict = {
  constraint: UserPreferenceConstraint;
  update_columns?: Array<UserPreferenceUpdateColumn>;
  where?: InputMaybe<UserPreferenceBoolExp>;
};

/** Ordering options when selecting data from "user_preference". */
export type UserPreferenceOrderBy = {
  blacklist?: InputMaybe<OrderBy>;
  company_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  general?: InputMaybe<OrderBy>;
  notification?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_metadata?: InputMaybe<OrderBy>;
  user_name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_preference */
export type UserPreferencePkColumnsInput = {
  user_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserPreferencePrependInput = {
  blacklist?: InputMaybe<Scalars['jsonb']>;
  general?: InputMaybe<Scalars['jsonb']>;
  notification?: InputMaybe<Scalars['jsonb']>;
  user_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_preference" */
export enum UserPreferenceSelectColumn {
  /** column name */
  Blacklist = 'blacklist',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  General = 'general',
  /** column name */
  Notification = 'notification',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMetadata = 'user_metadata',
  /** column name */
  UserName = 'user_name'
}

/** input type for updating data in table "user_preference" */
export type UserPreferenceSetInput = {
  blacklist?: InputMaybe<Scalars['jsonb']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  general?: InputMaybe<Scalars['jsonb']>;
  notification?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  user_metadata?: InputMaybe<Scalars['jsonb']>;
  user_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_preference" */
export type UserPreferenceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserPreferenceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPreferenceStreamCursorValueInput = {
  blacklist?: InputMaybe<Scalars['jsonb']>;
  company_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  general?: InputMaybe<Scalars['jsonb']>;
  notification?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  user_metadata?: InputMaybe<Scalars['jsonb']>;
  user_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_preference" */
export enum UserPreferenceUpdateColumn {
  /** column name */
  Blacklist = 'blacklist',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  General = 'general',
  /** column name */
  Notification = 'notification',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMetadata = 'user_metadata',
  /** column name */
  UserName = 'user_name'
}

export type UserPreferenceUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UserPreferenceAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UserPreferenceDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UserPreferenceDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UserPreferenceDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UserPreferencePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPreferenceSetInput>;
  /** filter the rows which have to be updated */
  where: UserPreferenceBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vehicle_type" */
export type VehicleType = {
  __typename?: 'vehicle_type';
  id: Scalars['Int'];
  vehicle_type: Scalars['String'];
};

/** aggregated selection of "vehicle_type" */
export type VehicleTypeAggregate = {
  __typename?: 'vehicle_type_aggregate';
  aggregate?: Maybe<VehicleTypeAggregateFields>;
  nodes: Array<VehicleType>;
};

/** aggregate fields of "vehicle_type" */
export type VehicleTypeAggregateFields = {
  __typename?: 'vehicle_type_aggregate_fields';
  avg?: Maybe<VehicleTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VehicleTypeMaxFields>;
  min?: Maybe<VehicleTypeMinFields>;
  stddev?: Maybe<VehicleTypeStddevFields>;
  stddev_pop?: Maybe<VehicleTypeStddevPopFields>;
  stddev_samp?: Maybe<VehicleTypeStddevSampFields>;
  sum?: Maybe<VehicleTypeSumFields>;
  var_pop?: Maybe<VehicleTypeVarPopFields>;
  var_samp?: Maybe<VehicleTypeVarSampFields>;
  variance?: Maybe<VehicleTypeVarianceFields>;
};


/** aggregate fields of "vehicle_type" */
export type VehicleTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VehicleTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VehicleTypeAvgFields = {
  __typename?: 'vehicle_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vehicle_type". All fields are combined with a logical 'AND'. */
export type VehicleTypeBoolExp = {
  _and?: InputMaybe<Array<VehicleTypeBoolExp>>;
  _not?: InputMaybe<VehicleTypeBoolExp>;
  _or?: InputMaybe<Array<VehicleTypeBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  vehicle_type?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "vehicle_type_config_group" */
export type VehicleTypeConfigGroup = {
  __typename?: 'vehicle_type_config_group';
  config_group_id: Scalars['bigint'];
  id: Scalars['bigint'];
  vehicle_type_id: Scalars['Int'];
};

/** aggregated selection of "vehicle_type_config_group" */
export type VehicleTypeConfigGroupAggregate = {
  __typename?: 'vehicle_type_config_group_aggregate';
  aggregate?: Maybe<VehicleTypeConfigGroupAggregateFields>;
  nodes: Array<VehicleTypeConfigGroup>;
};

/** aggregate fields of "vehicle_type_config_group" */
export type VehicleTypeConfigGroupAggregateFields = {
  __typename?: 'vehicle_type_config_group_aggregate_fields';
  avg?: Maybe<VehicleTypeConfigGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VehicleTypeConfigGroupMaxFields>;
  min?: Maybe<VehicleTypeConfigGroupMinFields>;
  stddev?: Maybe<VehicleTypeConfigGroupStddevFields>;
  stddev_pop?: Maybe<VehicleTypeConfigGroupStddevPopFields>;
  stddev_samp?: Maybe<VehicleTypeConfigGroupStddevSampFields>;
  sum?: Maybe<VehicleTypeConfigGroupSumFields>;
  var_pop?: Maybe<VehicleTypeConfigGroupVarPopFields>;
  var_samp?: Maybe<VehicleTypeConfigGroupVarSampFields>;
  variance?: Maybe<VehicleTypeConfigGroupVarianceFields>;
};


/** aggregate fields of "vehicle_type_config_group" */
export type VehicleTypeConfigGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VehicleTypeConfigGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VehicleTypeConfigGroupAvgFields = {
  __typename?: 'vehicle_type_config_group_avg_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vehicle_type_config_group". All fields are combined with a logical 'AND'. */
export type VehicleTypeConfigGroupBoolExp = {
  _and?: InputMaybe<Array<VehicleTypeConfigGroupBoolExp>>;
  _not?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
  _or?: InputMaybe<Array<VehicleTypeConfigGroupBoolExp>>;
  config_group_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  vehicle_type_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "vehicle_type_config_group" */
export enum VehicleTypeConfigGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  VehicleTypeConfigGroupPkey = 'vehicle_type_config_group_pkey'
}

/** input type for incrementing numeric columns in table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupIncInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  vehicle_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupInsertInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  vehicle_type_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VehicleTypeConfigGroupMaxFields = {
  __typename?: 'vehicle_type_config_group_max_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  vehicle_type_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VehicleTypeConfigGroupMinFields = {
  __typename?: 'vehicle_type_config_group_min_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  vehicle_type_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupMutationResponse = {
  __typename?: 'vehicle_type_config_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleTypeConfigGroup>;
};

/** on_conflict condition type for table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupOnConflict = {
  constraint: VehicleTypeConfigGroupConstraint;
  update_columns?: Array<VehicleTypeConfigGroupUpdateColumn>;
  where?: InputMaybe<VehicleTypeConfigGroupBoolExp>;
};

/** Ordering options when selecting data from "vehicle_type_config_group". */
export type VehicleTypeConfigGroupOrderBy = {
  config_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  vehicle_type_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: vehicle_type_config_group */
export type VehicleTypeConfigGroupPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "vehicle_type_config_group" */
export enum VehicleTypeConfigGroupSelectColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  VehicleTypeId = 'vehicle_type_id'
}

/** input type for updating data in table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupSetInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  vehicle_type_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VehicleTypeConfigGroupStddevFields = {
  __typename?: 'vehicle_type_config_group_stddev_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleTypeConfigGroupStddevPopFields = {
  __typename?: 'vehicle_type_config_group_stddev_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleTypeConfigGroupStddevSampFields = {
  __typename?: 'vehicle_type_config_group_stddev_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vehicle_type_config_group" */
export type VehicleTypeConfigGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: VehicleTypeConfigGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleTypeConfigGroupStreamCursorValueInput = {
  config_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  vehicle_type_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VehicleTypeConfigGroupSumFields = {
  __typename?: 'vehicle_type_config_group_sum_fields';
  config_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  vehicle_type_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vehicle_type_config_group" */
export enum VehicleTypeConfigGroupUpdateColumn {
  /** column name */
  ConfigGroupId = 'config_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  VehicleTypeId = 'vehicle_type_id'
}

export type VehicleTypeConfigGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleTypeConfigGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleTypeConfigGroupSetInput>;
  /** filter the rows which have to be updated */
  where: VehicleTypeConfigGroupBoolExp;
};

/** aggregate var_pop on columns */
export type VehicleTypeConfigGroupVarPopFields = {
  __typename?: 'vehicle_type_config_group_var_pop_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleTypeConfigGroupVarSampFields = {
  __typename?: 'vehicle_type_config_group_var_samp_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleTypeConfigGroupVarianceFields = {
  __typename?: 'vehicle_type_config_group_variance_fields';
  config_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_type_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "vehicle_type" */
export enum VehicleTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  VehicleTypePkey = 'vehicle_type_pkey'
}

/** input type for incrementing numeric columns in table "vehicle_type" */
export type VehicleTypeIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_type" */
export type VehicleTypeInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VehicleTypeMaxFields = {
  __typename?: 'vehicle_type_max_fields';
  id?: Maybe<Scalars['Int']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleTypeMinFields = {
  __typename?: 'vehicle_type_min_fields';
  id?: Maybe<Scalars['Int']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vehicle_type" */
export type VehicleTypeMutationResponse = {
  __typename?: 'vehicle_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleType>;
};

/** on_conflict condition type for table "vehicle_type" */
export type VehicleTypeOnConflict = {
  constraint: VehicleTypeConstraint;
  update_columns?: Array<VehicleTypeUpdateColumn>;
  where?: InputMaybe<VehicleTypeBoolExp>;
};

/** Ordering options when selecting data from "vehicle_type". */
export type VehicleTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  vehicle_type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: vehicle_type */
export type VehicleTypePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "vehicle_type" */
export enum VehicleTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  VehicleType = 'vehicle_type'
}

/** input type for updating data in table "vehicle_type" */
export type VehicleTypeSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VehicleTypeStddevFields = {
  __typename?: 'vehicle_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleTypeStddevPopFields = {
  __typename?: 'vehicle_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleTypeStddevSampFields = {
  __typename?: 'vehicle_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vehicle_type" */
export type VehicleTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: VehicleTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleTypeStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VehicleTypeSumFields = {
  __typename?: 'vehicle_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vehicle_type" */
export enum VehicleTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  VehicleType = 'vehicle_type'
}

export type VehicleTypeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleTypeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleTypeSetInput>;
  /** filter the rows which have to be updated */
  where: VehicleTypeBoolExp;
};

/** aggregate var_pop on columns */
export type VehicleTypeVarPopFields = {
  __typename?: 'vehicle_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleTypeVarSampFields = {
  __typename?: 'vehicle_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleTypeVarianceFields = {
  __typename?: 'vehicle_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "violation_case" */
export type ViolationCase = {
  __typename?: 'violation_case';
  already_paid: Scalars['float8'];
  cancellation_date?: Maybe<Scalars['date']>;
  cancellation_issuer?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  car_driver?: Maybe<CarDriver>;
  /** An object relationship */
  car_owner?: Maybe<CarOwner>;
  case_id?: Maybe<Scalars['String']>;
  changelog?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collection_date?: Maybe<Scalars['date']>;
  driver_id?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  fee?: Maybe<Scalars['float8']>;
  id: Scalars['bigint'];
  note?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  /** An object relationship */
  parking_results?: Maybe<ParkingResults>;
  parking_results_id: Scalars['uuid'];
  payment_date?: Maybe<Scalars['date']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  policy: Scalars['jsonb'];
  reason_info?: Maybe<Scalars['jsonb']>;
  reminder_charges: Scalars['float8'];
  /** An object relationship */
  stage?: Maybe<Stages>;
  stage_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  violated_rule?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  violation_case_charges: Array<ViolationCaseCharges>;
  /** An aggregate relationship */
  violation_case_charges_aggregate: ViolationCaseChargesAggregate;
  /** An array relationship */
  violator_transactions: Array<ViolatorTransactions>;
  /** An aggregate relationship */
  violator_transactions_aggregate: ViolatorTransactionsAggregate;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseChangelogArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "violation_case" */
export type ViolationCasePolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseReasonInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseViolatedRuleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseViolationCaseChargesArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseViolationCaseChargesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolationCaseChargesOrderBy>>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseViolatorTransactionsArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};


/** columns and relationships of "violation_case" */
export type ViolationCaseViolatorTransactionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ViolatorTransactionsOrderBy>>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};

/** aggregated selection of "violation_case" */
export type ViolationCaseAggregate = {
  __typename?: 'violation_case_aggregate';
  aggregate?: Maybe<ViolationCaseAggregateFields>;
  nodes: Array<ViolationCase>;
};

export type ViolationCaseAggregateBoolExp = {
  avg?: InputMaybe<ViolationCaseAggregateBoolExpAvg>;
  corr?: InputMaybe<ViolationCaseAggregateBoolExpCorr>;
  count?: InputMaybe<ViolationCaseAggregateBoolExpCount>;
  covar_samp?: InputMaybe<ViolationCaseAggregateBoolExpCovarSamp>;
  max?: InputMaybe<ViolationCaseAggregateBoolExpMax>;
  min?: InputMaybe<ViolationCaseAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<ViolationCaseAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<ViolationCaseAggregateBoolExpSum>;
  var_samp?: InputMaybe<ViolationCaseAggregateBoolExpVarSamp>;
};

export type ViolationCaseAggregateBoolExpAvg = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpCorr = {
  arguments: ViolationCaseAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpCorrArguments = {
  X: ViolationCaseSelectColumnViolationCaseAggregateBoolExpCorrArgumentsColumns;
  Y: ViolationCaseSelectColumnViolationCaseAggregateBoolExpCorrArgumentsColumns;
};

export type ViolationCaseAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: IntComparisonExp;
};

export type ViolationCaseAggregateBoolExpCovarSamp = {
  arguments: ViolationCaseAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpCovarSampArguments = {
  X: ViolationCaseSelectColumnViolationCaseAggregateBoolExpCovarSampArgumentsColumns;
  Y: ViolationCaseSelectColumnViolationCaseAggregateBoolExpCovarSampArgumentsColumns;
};

export type ViolationCaseAggregateBoolExpMax = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpMin = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpStddevSamp = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpSum = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolationCaseAggregateBoolExpVarSamp = {
  arguments: ViolationCaseSelectColumnViolationCaseAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "violation_case" */
export type ViolationCaseAggregateFields = {
  __typename?: 'violation_case_aggregate_fields';
  avg?: Maybe<ViolationCaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViolationCaseMaxFields>;
  min?: Maybe<ViolationCaseMinFields>;
  stddev?: Maybe<ViolationCaseStddevFields>;
  stddev_pop?: Maybe<ViolationCaseStddevPopFields>;
  stddev_samp?: Maybe<ViolationCaseStddevSampFields>;
  sum?: Maybe<ViolationCaseSumFields>;
  var_pop?: Maybe<ViolationCaseVarPopFields>;
  var_samp?: Maybe<ViolationCaseVarSampFields>;
  variance?: Maybe<ViolationCaseVarianceFields>;
};


/** aggregate fields of "violation_case" */
export type ViolationCaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViolationCaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "violation_case" */
export type ViolationCaseAggregateOrderBy = {
  avg?: InputMaybe<ViolationCaseAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ViolationCaseMaxOrderBy>;
  min?: InputMaybe<ViolationCaseMinOrderBy>;
  stddev?: InputMaybe<ViolationCaseStddevOrderBy>;
  stddev_pop?: InputMaybe<ViolationCaseStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ViolationCaseStddevSampOrderBy>;
  sum?: InputMaybe<ViolationCaseSumOrderBy>;
  var_pop?: InputMaybe<ViolationCaseVarPopOrderBy>;
  var_samp?: InputMaybe<ViolationCaseVarSampOrderBy>;
  variance?: InputMaybe<ViolationCaseVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ViolationCaseAppendInput = {
  changelog?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  violated_rule?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "violation_case" */
export type ViolationCaseArrRelInsertInput = {
  data: Array<ViolationCaseInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ViolationCaseOnConflict>;
};

/** aggregate avg on columns */
export type ViolationCaseAvgFields = {
  __typename?: 'violation_case_avg_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "violation_case" */
export type ViolationCaseAvgOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "violation_case". All fields are combined with a logical 'AND'. */
export type ViolationCaseBoolExp = {
  _and?: InputMaybe<Array<ViolationCaseBoolExp>>;
  _not?: InputMaybe<ViolationCaseBoolExp>;
  _or?: InputMaybe<Array<ViolationCaseBoolExp>>;
  already_paid?: InputMaybe<Float8ComparisonExp>;
  cancellation_date?: InputMaybe<DateComparisonExp>;
  cancellation_issuer?: InputMaybe<StringComparisonExp>;
  cancellation_reason?: InputMaybe<StringComparisonExp>;
  car_driver?: InputMaybe<CarDriverBoolExp>;
  car_owner?: InputMaybe<CarOwnerBoolExp>;
  case_id?: InputMaybe<StringComparisonExp>;
  changelog?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  debt_collection_date?: InputMaybe<DateComparisonExp>;
  driver_id?: InputMaybe<BigintComparisonExp>;
  duration_min?: InputMaybe<BigintComparisonExp>;
  fee?: InputMaybe<Float8ComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  owner_id?: InputMaybe<BigintComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_results?: InputMaybe<ParkingResultsBoolExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  payment_date?: InputMaybe<DateComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  plate_country?: InputMaybe<StringComparisonExp>;
  policy?: InputMaybe<JsonbComparisonExp>;
  reason_info?: InputMaybe<JsonbComparisonExp>;
  reminder_charges?: InputMaybe<Float8ComparisonExp>;
  stage?: InputMaybe<StagesBoolExp>;
  stage_id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  timestamp_in?: InputMaybe<TimestamptzComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
  transferred_from?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violated_rule?: InputMaybe<JsonbComparisonExp>;
  violation_case_charges?: InputMaybe<ViolationCaseChargesBoolExp>;
  violation_case_charges_aggregate?: InputMaybe<ViolationCaseChargesAggregateBoolExp>;
  violator_transactions?: InputMaybe<ViolatorTransactionsBoolExp>;
  violator_transactions_aggregate?: InputMaybe<ViolatorTransactionsAggregateBoolExp>;
};

/** Table to track all charges that have been applied to a violation case */
export type ViolationCaseCharges = {
  __typename?: 'violation_case_charges';
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['bigint'];
  invalidation_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  tax?: Maybe<Tax>;
  tax_uuid?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['bigint']>;
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Scalars['timestamptz'];
  /** An object relationship */
  violation_case: ViolationCase;
  violation_case_id: Scalars['bigint'];
};

/** aggregated selection of "violation_case_charges" */
export type ViolationCaseChargesAggregate = {
  __typename?: 'violation_case_charges_aggregate';
  aggregate?: Maybe<ViolationCaseChargesAggregateFields>;
  nodes: Array<ViolationCaseCharges>;
};

export type ViolationCaseChargesAggregateBoolExp = {
  count?: InputMaybe<ViolationCaseChargesAggregateBoolExpCount>;
};

export type ViolationCaseChargesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolationCaseChargesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "violation_case_charges" */
export type ViolationCaseChargesAggregateFields = {
  __typename?: 'violation_case_charges_aggregate_fields';
  avg?: Maybe<ViolationCaseChargesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViolationCaseChargesMaxFields>;
  min?: Maybe<ViolationCaseChargesMinFields>;
  stddev?: Maybe<ViolationCaseChargesStddevFields>;
  stddev_pop?: Maybe<ViolationCaseChargesStddevPopFields>;
  stddev_samp?: Maybe<ViolationCaseChargesStddevSampFields>;
  sum?: Maybe<ViolationCaseChargesSumFields>;
  var_pop?: Maybe<ViolationCaseChargesVarPopFields>;
  var_samp?: Maybe<ViolationCaseChargesVarSampFields>;
  variance?: Maybe<ViolationCaseChargesVarianceFields>;
};


/** aggregate fields of "violation_case_charges" */
export type ViolationCaseChargesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViolationCaseChargesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "violation_case_charges" */
export type ViolationCaseChargesAggregateOrderBy = {
  avg?: InputMaybe<ViolationCaseChargesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ViolationCaseChargesMaxOrderBy>;
  min?: InputMaybe<ViolationCaseChargesMinOrderBy>;
  stddev?: InputMaybe<ViolationCaseChargesStddevOrderBy>;
  stddev_pop?: InputMaybe<ViolationCaseChargesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ViolationCaseChargesStddevSampOrderBy>;
  sum?: InputMaybe<ViolationCaseChargesSumOrderBy>;
  var_pop?: InputMaybe<ViolationCaseChargesVarPopOrderBy>;
  var_samp?: InputMaybe<ViolationCaseChargesVarSampOrderBy>;
  variance?: InputMaybe<ViolationCaseChargesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "violation_case_charges" */
export type ViolationCaseChargesArrRelInsertInput = {
  data: Array<ViolationCaseChargesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ViolationCaseChargesOnConflict>;
};

/** aggregate avg on columns */
export type ViolationCaseChargesAvgFields = {
  __typename?: 'violation_case_charges_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "violation_case_charges" */
export type ViolationCaseChargesAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "violation_case_charges". All fields are combined with a logical 'AND'. */
export type ViolationCaseChargesBoolExp = {
  _and?: InputMaybe<Array<ViolationCaseChargesBoolExp>>;
  _not?: InputMaybe<ViolationCaseChargesBoolExp>;
  _or?: InputMaybe<Array<ViolationCaseChargesBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  invalidation_reason?: InputMaybe<StringComparisonExp>;
  tax?: InputMaybe<TaxBoolExp>;
  tax_uuid?: InputMaybe<IntComparisonExp>;
  transferred_to?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  valid_from?: InputMaybe<TimestamptzComparisonExp>;
  valid_to?: InputMaybe<TimestamptzComparisonExp>;
  violation_case?: InputMaybe<ViolationCaseBoolExp>;
  violation_case_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "violation_case_charges" */
export enum ViolationCaseChargesConstraint {
  /** unique or primary key constraint on columns "id" */
  ViolationCaseChargesPkey = 'violation_case_charges_pkey'
}

/** input type for incrementing numeric columns in table "violation_case_charges" */
export type ViolationCaseChargesIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['bigint']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "violation_case_charges" */
export type ViolationCaseChargesInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<TaxObjRelInsertInput>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  violation_case?: InputMaybe<ViolationCaseObjRelInsertInput>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ViolationCaseChargesMaxFields = {
  __typename?: 'violation_case_charges_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  invalidation_reason?: Maybe<Scalars['String']>;
  tax_uuid?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "violation_case_charges" */
export type ViolationCaseChargesMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invalidation_reason?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ViolationCaseChargesMinFields = {
  __typename?: 'violation_case_charges_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  invalidation_reason?: Maybe<Scalars['String']>;
  tax_uuid?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_to?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "violation_case_charges" */
export type ViolationCaseChargesMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invalidation_reason?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "violation_case_charges" */
export type ViolationCaseChargesMutationResponse = {
  __typename?: 'violation_case_charges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ViolationCaseCharges>;
};

/** on_conflict condition type for table "violation_case_charges" */
export type ViolationCaseChargesOnConflict = {
  constraint: ViolationCaseChargesConstraint;
  update_columns?: Array<ViolationCaseChargesUpdateColumn>;
  where?: InputMaybe<ViolationCaseChargesBoolExp>;
};

/** Ordering options when selecting data from "violation_case_charges". */
export type ViolationCaseChargesOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invalidation_reason?: InputMaybe<OrderBy>;
  tax?: InputMaybe<TaxOrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  valid_from?: InputMaybe<OrderBy>;
  valid_to?: InputMaybe<OrderBy>;
  violation_case?: InputMaybe<ViolationCaseOrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: violation_case_charges */
export type ViolationCaseChargesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "violation_case_charges" */
export enum ViolationCaseChargesSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidationReason = 'invalidation_reason',
  /** column name */
  TaxUuid = 'tax_uuid',
  /** column name */
  TransferredTo = 'transferred_to',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

/** input type for updating data in table "violation_case_charges" */
export type ViolationCaseChargesSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ViolationCaseChargesStddevFields = {
  __typename?: 'violation_case_charges_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "violation_case_charges" */
export type ViolationCaseChargesStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ViolationCaseChargesStddevPopFields = {
  __typename?: 'violation_case_charges_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "violation_case_charges" */
export type ViolationCaseChargesStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ViolationCaseChargesStddevSampFields = {
  __typename?: 'violation_case_charges_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "violation_case_charges" */
export type ViolationCaseChargesStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "violation_case_charges" */
export type ViolationCaseChargesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ViolationCaseChargesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViolationCaseChargesStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  invalidation_reason?: InputMaybe<Scalars['String']>;
  tax_uuid?: InputMaybe<Scalars['Int']>;
  transferred_to?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ViolationCaseChargesSumFields = {
  __typename?: 'violation_case_charges_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  tax_uuid?: Maybe<Scalars['Int']>;
  transferred_to?: Maybe<Scalars['bigint']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "violation_case_charges" */
export type ViolationCaseChargesSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** update columns of table "violation_case_charges" */
export enum ViolationCaseChargesUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidationReason = 'invalidation_reason',
  /** column name */
  TaxUuid = 'tax_uuid',
  /** column name */
  TransferredTo = 'transferred_to',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

export type ViolationCaseChargesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ViolationCaseChargesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ViolationCaseChargesSetInput>;
  /** filter the rows which have to be updated */
  where: ViolationCaseChargesBoolExp;
};

/** aggregate var_pop on columns */
export type ViolationCaseChargesVarPopFields = {
  __typename?: 'violation_case_charges_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "violation_case_charges" */
export type ViolationCaseChargesVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ViolationCaseChargesVarSampFields = {
  __typename?: 'violation_case_charges_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "violation_case_charges" */
export type ViolationCaseChargesVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ViolationCaseChargesVarianceFields = {
  __typename?: 'violation_case_charges_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tax_uuid?: Maybe<Scalars['Float']>;
  transferred_to?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "violation_case_charges" */
export type ViolationCaseChargesVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tax_uuid?: InputMaybe<OrderBy>;
  transferred_to?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "violation_case" */
export enum ViolationCaseConstraint {
  /** unique or primary key constraint on columns "id" */
  ViolationCasePkey = 'violation_case_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ViolationCaseDeleteAtPathInput = {
  changelog?: InputMaybe<Array<Scalars['String']>>;
  policy?: InputMaybe<Array<Scalars['String']>>;
  reason_info?: InputMaybe<Array<Scalars['String']>>;
  violated_rule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ViolationCaseDeleteElemInput = {
  changelog?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['Int']>;
  reason_info?: InputMaybe<Scalars['Int']>;
  violated_rule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ViolationCaseDeleteKeyInput = {
  changelog?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['String']>;
  violated_rule?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "violation_case" */
export type ViolationCaseIncInput = {
  already_paid?: InputMaybe<Scalars['float8']>;
  driver_id?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  fee?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  reminder_charges?: InputMaybe<Scalars['float8']>;
  stage_id?: InputMaybe<Scalars['bigint']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "violation_case" */
export type ViolationCaseInsertInput = {
  already_paid?: InputMaybe<Scalars['float8']>;
  cancellation_date?: InputMaybe<Scalars['date']>;
  cancellation_issuer?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  car_driver?: InputMaybe<CarDriverObjRelInsertInput>;
  car_owner?: InputMaybe<CarOwnerObjRelInsertInput>;
  case_id?: InputMaybe<Scalars['String']>;
  changelog?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_date?: InputMaybe<Scalars['date']>;
  driver_id?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  fee?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  note?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results?: InputMaybe<ParkingResultsObjRelInsertInput>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  payment_date?: InputMaybe<Scalars['date']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  reminder_charges?: InputMaybe<Scalars['float8']>;
  stage?: InputMaybe<StagesObjRelInsertInput>;
  stage_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violated_rule?: InputMaybe<Scalars['jsonb']>;
  violation_case_charges?: InputMaybe<ViolationCaseChargesArrRelInsertInput>;
  violator_transactions?: InputMaybe<ViolatorTransactionsArrRelInsertInput>;
};

/** aggregate max on columns */
export type ViolationCaseMaxFields = {
  __typename?: 'violation_case_max_fields';
  already_paid?: Maybe<Scalars['float8']>;
  cancellation_date?: Maybe<Scalars['date']>;
  cancellation_issuer?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collection_date?: Maybe<Scalars['date']>;
  driver_id?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  fee?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  note?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  payment_date?: Maybe<Scalars['date']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  reminder_charges?: Maybe<Scalars['float8']>;
  stage_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "violation_case" */
export type ViolationCaseMaxOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  cancellation_date?: InputMaybe<OrderBy>;
  cancellation_issuer?: InputMaybe<OrderBy>;
  cancellation_reason?: InputMaybe<OrderBy>;
  case_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  debt_collection_date?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  payment_date?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ViolationCaseMinFields = {
  __typename?: 'violation_case_min_fields';
  already_paid?: Maybe<Scalars['float8']>;
  cancellation_date?: Maybe<Scalars['date']>;
  cancellation_issuer?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  case_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debt_collection_date?: Maybe<Scalars['date']>;
  driver_id?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  fee?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  note?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['bigint']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  payment_date?: Maybe<Scalars['date']>;
  plate?: Maybe<Scalars['String']>;
  plate_country?: Maybe<Scalars['String']>;
  reminder_charges?: Maybe<Scalars['float8']>;
  stage_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  timestamp_in?: Maybe<Scalars['timestamptz']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "violation_case" */
export type ViolationCaseMinOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  cancellation_date?: InputMaybe<OrderBy>;
  cancellation_issuer?: InputMaybe<OrderBy>;
  cancellation_reason?: InputMaybe<OrderBy>;
  case_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  debt_collection_date?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  payment_date?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "violation_case" */
export type ViolationCaseMutationResponse = {
  __typename?: 'violation_case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ViolationCase>;
};

/** input type for inserting object relation for remote table "violation_case" */
export type ViolationCaseObjRelInsertInput = {
  data: ViolationCaseInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ViolationCaseOnConflict>;
};

/** on_conflict condition type for table "violation_case" */
export type ViolationCaseOnConflict = {
  constraint: ViolationCaseConstraint;
  update_columns?: Array<ViolationCaseUpdateColumn>;
  where?: InputMaybe<ViolationCaseBoolExp>;
};

/** Ordering options when selecting data from "violation_case". */
export type ViolationCaseOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  cancellation_date?: InputMaybe<OrderBy>;
  cancellation_issuer?: InputMaybe<OrderBy>;
  cancellation_reason?: InputMaybe<OrderBy>;
  car_driver?: InputMaybe<CarDriverOrderBy>;
  car_owner?: InputMaybe<CarOwnerOrderBy>;
  case_id?: InputMaybe<OrderBy>;
  changelog?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  debt_collection_date?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results?: InputMaybe<ParkingResultsOrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  payment_date?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  reason_info?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage?: InputMaybe<StagesOrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timestamp_in?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violated_rule?: InputMaybe<OrderBy>;
  violation_case_charges_aggregate?: InputMaybe<ViolationCaseChargesAggregateOrderBy>;
  violator_transactions_aggregate?: InputMaybe<ViolatorTransactionsAggregateOrderBy>;
};

/** primary key columns input for table: violation_case */
export type ViolationCasePkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ViolationCasePrependInput = {
  changelog?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  violated_rule?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "violation_case" */
export enum ViolationCaseSelectColumn {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  CancellationDate = 'cancellation_date',
  /** column name */
  CancellationIssuer = 'cancellation_issuer',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  Changelog = 'changelog',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectionDate = 'debt_collection_date',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Policy = 'policy',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  ReminderCharges = 'reminder_charges',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  TransferredFrom = 'transferred_from',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolatedRule = 'violated_rule'
}

/** select "violation_case_aggregate_bool_exp_avg_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_corr_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_max_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_min_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_sum_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** select "violation_case_aggregate_bool_exp_var_samp_arguments_columns" columns of table "violation_case" */
export enum ViolationCaseSelectColumnViolationCaseAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  Fee = 'fee',
  /** column name */
  ReminderCharges = 'reminder_charges'
}

/** input type for updating data in table "violation_case" */
export type ViolationCaseSetInput = {
  already_paid?: InputMaybe<Scalars['float8']>;
  cancellation_date?: InputMaybe<Scalars['date']>;
  cancellation_issuer?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  case_id?: InputMaybe<Scalars['String']>;
  changelog?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_date?: InputMaybe<Scalars['date']>;
  driver_id?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  fee?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  note?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  payment_date?: InputMaybe<Scalars['date']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  reminder_charges?: InputMaybe<Scalars['float8']>;
  stage_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violated_rule?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type ViolationCaseStddevFields = {
  __typename?: 'violation_case_stddev_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "violation_case" */
export type ViolationCaseStddevOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ViolationCaseStddevPopFields = {
  __typename?: 'violation_case_stddev_pop_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "violation_case" */
export type ViolationCaseStddevPopOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ViolationCaseStddevSampFields = {
  __typename?: 'violation_case_stddev_samp_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "violation_case" */
export type ViolationCaseStddevSampOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "violation_case" */
export type ViolationCaseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ViolationCaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViolationCaseStreamCursorValueInput = {
  already_paid?: InputMaybe<Scalars['float8']>;
  cancellation_date?: InputMaybe<Scalars['date']>;
  cancellation_issuer?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  case_id?: InputMaybe<Scalars['String']>;
  changelog?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  debt_collection_date?: InputMaybe<Scalars['date']>;
  driver_id?: InputMaybe<Scalars['bigint']>;
  duration_min?: InputMaybe<Scalars['bigint']>;
  fee?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  note?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  payment_date?: InputMaybe<Scalars['date']>;
  plate?: InputMaybe<Scalars['String']>;
  plate_country?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  reminder_charges?: InputMaybe<Scalars['float8']>;
  stage_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp_in?: InputMaybe<Scalars['timestamptz']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violated_rule?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type ViolationCaseSumFields = {
  __typename?: 'violation_case_sum_fields';
  already_paid?: Maybe<Scalars['float8']>;
  driver_id?: Maybe<Scalars['bigint']>;
  duration_min?: Maybe<Scalars['bigint']>;
  fee?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  owner_id?: Maybe<Scalars['bigint']>;
  reminder_charges?: Maybe<Scalars['float8']>;
  stage_id?: Maybe<Scalars['bigint']>;
  transferred_from?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "violation_case" */
export type ViolationCaseSumOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** columns and relationships of "violation_case_tags" */
export type ViolationCaseTags = {
  __typename?: 'violation_case_tags';
  author: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  violation_case_id: Scalars['bigint'];
  visible: Scalars['Boolean'];
};

/** aggregated selection of "violation_case_tags" */
export type ViolationCaseTagsAggregate = {
  __typename?: 'violation_case_tags_aggregate';
  aggregate?: Maybe<ViolationCaseTagsAggregateFields>;
  nodes: Array<ViolationCaseTags>;
};

/** aggregate fields of "violation_case_tags" */
export type ViolationCaseTagsAggregateFields = {
  __typename?: 'violation_case_tags_aggregate_fields';
  avg?: Maybe<ViolationCaseTagsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViolationCaseTagsMaxFields>;
  min?: Maybe<ViolationCaseTagsMinFields>;
  stddev?: Maybe<ViolationCaseTagsStddevFields>;
  stddev_pop?: Maybe<ViolationCaseTagsStddevPopFields>;
  stddev_samp?: Maybe<ViolationCaseTagsStddevSampFields>;
  sum?: Maybe<ViolationCaseTagsSumFields>;
  var_pop?: Maybe<ViolationCaseTagsVarPopFields>;
  var_samp?: Maybe<ViolationCaseTagsVarSampFields>;
  variance?: Maybe<ViolationCaseTagsVarianceFields>;
};


/** aggregate fields of "violation_case_tags" */
export type ViolationCaseTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViolationCaseTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ViolationCaseTagsAvgFields = {
  __typename?: 'violation_case_tags_avg_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "violation_case_tags". All fields are combined with a logical 'AND'. */
export type ViolationCaseTagsBoolExp = {
  _and?: InputMaybe<Array<ViolationCaseTagsBoolExp>>;
  _not?: InputMaybe<ViolationCaseTagsBoolExp>;
  _or?: InputMaybe<Array<ViolationCaseTagsBoolExp>>;
  author?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  violation_case_id?: InputMaybe<BigintComparisonExp>;
  visible?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "violation_case_tags" */
export enum ViolationCaseTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  ViolationCaseTagsPkey = 'violation_case_tags_pkey'
}

/** input type for incrementing numeric columns in table "violation_case_tags" */
export type ViolationCaseTagsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "violation_case_tags" */
export type ViolationCaseTagsInsertInput = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ViolationCaseTagsMaxFields = {
  __typename?: 'violation_case_tags_max_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ViolationCaseTagsMinFields = {
  __typename?: 'violation_case_tags_min_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "violation_case_tags" */
export type ViolationCaseTagsMutationResponse = {
  __typename?: 'violation_case_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ViolationCaseTags>;
};

/** on_conflict condition type for table "violation_case_tags" */
export type ViolationCaseTagsOnConflict = {
  constraint: ViolationCaseTagsConstraint;
  update_columns?: Array<ViolationCaseTagsUpdateColumn>;
  where?: InputMaybe<ViolationCaseTagsBoolExp>;
};

/** Ordering options when selecting data from "violation_case_tags". */
export type ViolationCaseTagsOrderBy = {
  author?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
  visible?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: violation_case_tags */
export type ViolationCaseTagsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "violation_case_tags" */
export enum ViolationCaseTagsSelectColumn {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ViolationCaseId = 'violation_case_id',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "violation_case_tags" */
export type ViolationCaseTagsSetInput = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ViolationCaseTagsStddevFields = {
  __typename?: 'violation_case_tags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ViolationCaseTagsStddevPopFields = {
  __typename?: 'violation_case_tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ViolationCaseTagsStddevSampFields = {
  __typename?: 'violation_case_tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "violation_case_tags" */
export type ViolationCaseTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ViolationCaseTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViolationCaseTagsStreamCursorValueInput = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type ViolationCaseTagsSumFields = {
  __typename?: 'violation_case_tags_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "violation_case_tags" */
export enum ViolationCaseTagsUpdateColumn {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ViolationCaseId = 'violation_case_id',
  /** column name */
  Visible = 'visible'
}

export type ViolationCaseTagsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ViolationCaseTagsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ViolationCaseTagsSetInput>;
  /** filter the rows which have to be updated */
  where: ViolationCaseTagsBoolExp;
};

/** aggregate var_pop on columns */
export type ViolationCaseTagsVarPopFields = {
  __typename?: 'violation_case_tags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ViolationCaseTagsVarSampFields = {
  __typename?: 'violation_case_tags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ViolationCaseTagsVarianceFields = {
  __typename?: 'violation_case_tags_variance_fields';
  id?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** update columns of table "violation_case" */
export enum ViolationCaseUpdateColumn {
  /** column name */
  AlreadyPaid = 'already_paid',
  /** column name */
  CancellationDate = 'cancellation_date',
  /** column name */
  CancellationIssuer = 'cancellation_issuer',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  Changelog = 'changelog',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebtCollectionDate = 'debt_collection_date',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DurationMin = 'duration_min',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Plate = 'plate',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  Policy = 'policy',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  ReminderCharges = 'reminder_charges',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TimestampIn = 'timestamp_in',
  /** column name */
  TimestampOut = 'timestamp_out',
  /** column name */
  TransferredFrom = 'transferred_from',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolatedRule = 'violated_rule'
}

export type ViolationCaseUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ViolationCaseAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ViolationCaseDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ViolationCaseDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ViolationCaseDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ViolationCaseIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ViolationCasePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ViolationCaseSetInput>;
  /** filter the rows which have to be updated */
  where: ViolationCaseBoolExp;
};

/** aggregate var_pop on columns */
export type ViolationCaseVarPopFields = {
  __typename?: 'violation_case_var_pop_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "violation_case" */
export type ViolationCaseVarPopOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ViolationCaseVarSampFields = {
  __typename?: 'violation_case_var_samp_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "violation_case" */
export type ViolationCaseVarSampOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ViolationCaseVarianceFields = {
  __typename?: 'violation_case_variance_fields';
  already_paid?: Maybe<Scalars['Float']>;
  driver_id?: Maybe<Scalars['Float']>;
  duration_min?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  reminder_charges?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "violation_case" */
export type ViolationCaseVarianceOrderBy = {
  already_paid?: InputMaybe<OrderBy>;
  driver_id?: InputMaybe<OrderBy>;
  duration_min?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  owner_id?: InputMaybe<OrderBy>;
  reminder_charges?: InputMaybe<OrderBy>;
  stage_id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
};

/** columns and relationships of "violation_event_analysis" */
export type ViolationEventAnalysis = {
  __typename?: 'violation_event_analysis';
  analysis_metrics: Scalars['jsonb'];
  bypass: Scalars['Boolean'];
  classified_at?: Maybe<Scalars['timestamptz']>;
  classifier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_tags: Scalars['jsonb'];
  id: Scalars['bigint'];
  initial_classification_category?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id: Scalars['uuid'];
  plate_country?: Maybe<Scalars['String']>;
  specific_error_rate?: Maybe<Scalars['numeric']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "violation_event_analysis" */
export type ViolationEventAnalysisAnalysisMetricsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "violation_event_analysis" */
export type ViolationEventAnalysisEventTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "violation_event_analysis" */
export type ViolationEventAnalysisAggregate = {
  __typename?: 'violation_event_analysis_aggregate';
  aggregate?: Maybe<ViolationEventAnalysisAggregateFields>;
  nodes: Array<ViolationEventAnalysis>;
};

/** aggregate fields of "violation_event_analysis" */
export type ViolationEventAnalysisAggregateFields = {
  __typename?: 'violation_event_analysis_aggregate_fields';
  avg?: Maybe<ViolationEventAnalysisAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViolationEventAnalysisMaxFields>;
  min?: Maybe<ViolationEventAnalysisMinFields>;
  stddev?: Maybe<ViolationEventAnalysisStddevFields>;
  stddev_pop?: Maybe<ViolationEventAnalysisStddevPopFields>;
  stddev_samp?: Maybe<ViolationEventAnalysisStddevSampFields>;
  sum?: Maybe<ViolationEventAnalysisSumFields>;
  var_pop?: Maybe<ViolationEventAnalysisVarPopFields>;
  var_samp?: Maybe<ViolationEventAnalysisVarSampFields>;
  variance?: Maybe<ViolationEventAnalysisVarianceFields>;
};


/** aggregate fields of "violation_event_analysis" */
export type ViolationEventAnalysisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViolationEventAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ViolationEventAnalysisAppendInput = {
  analysis_metrics?: InputMaybe<Scalars['jsonb']>;
  event_tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ViolationEventAnalysisAvgFields = {
  __typename?: 'violation_event_analysis_avg_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "violation_event_analysis". All fields are combined with a logical 'AND'. */
export type ViolationEventAnalysisBoolExp = {
  _and?: InputMaybe<Array<ViolationEventAnalysisBoolExp>>;
  _not?: InputMaybe<ViolationEventAnalysisBoolExp>;
  _or?: InputMaybe<Array<ViolationEventAnalysisBoolExp>>;
  analysis_metrics?: InputMaybe<JsonbComparisonExp>;
  bypass?: InputMaybe<BooleanComparisonExp>;
  classified_at?: InputMaybe<TimestamptzComparisonExp>;
  classifier?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  event_tags?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  initial_classification_category?: InputMaybe<StringComparisonExp>;
  parking_lot?: InputMaybe<StringComparisonExp>;
  parking_results_id?: InputMaybe<UuidComparisonExp>;
  plate_country?: InputMaybe<StringComparisonExp>;
  specific_error_rate?: InputMaybe<NumericComparisonExp>;
  timestamp_out?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "violation_event_analysis" */
export enum ViolationEventAnalysisConstraint {
  /** unique or primary key constraint on columns "id" */
  ViolationEventAnalysisPkey = 'violation_event_analysis_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ViolationEventAnalysisDeleteAtPathInput = {
  analysis_metrics?: InputMaybe<Array<Scalars['String']>>;
  event_tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ViolationEventAnalysisDeleteElemInput = {
  analysis_metrics?: InputMaybe<Scalars['Int']>;
  event_tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ViolationEventAnalysisDeleteKeyInput = {
  analysis_metrics?: InputMaybe<Scalars['String']>;
  event_tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "violation_event_analysis" */
export type ViolationEventAnalysisIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  specific_error_rate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "violation_event_analysis" */
export type ViolationEventAnalysisInsertInput = {
  analysis_metrics?: InputMaybe<Scalars['jsonb']>;
  bypass?: InputMaybe<Scalars['Boolean']>;
  classified_at?: InputMaybe<Scalars['timestamptz']>;
  classifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_tags?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_classification_category?: InputMaybe<Scalars['String']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate_country?: InputMaybe<Scalars['String']>;
  specific_error_rate?: InputMaybe<Scalars['numeric']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ViolationEventAnalysisMaxFields = {
  __typename?: 'violation_event_analysis_max_fields';
  classified_at?: Maybe<Scalars['timestamptz']>;
  classifier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  initial_classification_category?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate_country?: Maybe<Scalars['String']>;
  specific_error_rate?: Maybe<Scalars['numeric']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ViolationEventAnalysisMinFields = {
  __typename?: 'violation_event_analysis_min_fields';
  classified_at?: Maybe<Scalars['timestamptz']>;
  classifier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  initial_classification_category?: Maybe<Scalars['String']>;
  parking_lot?: Maybe<Scalars['String']>;
  parking_results_id?: Maybe<Scalars['uuid']>;
  plate_country?: Maybe<Scalars['String']>;
  specific_error_rate?: Maybe<Scalars['numeric']>;
  timestamp_out?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "violation_event_analysis" */
export type ViolationEventAnalysisMutationResponse = {
  __typename?: 'violation_event_analysis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ViolationEventAnalysis>;
};

/** on_conflict condition type for table "violation_event_analysis" */
export type ViolationEventAnalysisOnConflict = {
  constraint: ViolationEventAnalysisConstraint;
  update_columns?: Array<ViolationEventAnalysisUpdateColumn>;
  where?: InputMaybe<ViolationEventAnalysisBoolExp>;
};

/** Ordering options when selecting data from "violation_event_analysis". */
export type ViolationEventAnalysisOrderBy = {
  analysis_metrics?: InputMaybe<OrderBy>;
  bypass?: InputMaybe<OrderBy>;
  classified_at?: InputMaybe<OrderBy>;
  classifier?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  event_tags?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initial_classification_category?: InputMaybe<OrderBy>;
  parking_lot?: InputMaybe<OrderBy>;
  parking_results_id?: InputMaybe<OrderBy>;
  plate_country?: InputMaybe<OrderBy>;
  specific_error_rate?: InputMaybe<OrderBy>;
  timestamp_out?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: violation_event_analysis */
export type ViolationEventAnalysisPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ViolationEventAnalysisPrependInput = {
  analysis_metrics?: InputMaybe<Scalars['jsonb']>;
  event_tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "violation_event_analysis" */
export enum ViolationEventAnalysisSelectColumn {
  /** column name */
  AnalysisMetrics = 'analysis_metrics',
  /** column name */
  Bypass = 'bypass',
  /** column name */
  ClassifiedAt = 'classified_at',
  /** column name */
  Classifier = 'classifier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventTags = 'event_tags',
  /** column name */
  Id = 'id',
  /** column name */
  InitialClassificationCategory = 'initial_classification_category',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  SpecificErrorRate = 'specific_error_rate',
  /** column name */
  TimestampOut = 'timestamp_out'
}

/** input type for updating data in table "violation_event_analysis" */
export type ViolationEventAnalysisSetInput = {
  analysis_metrics?: InputMaybe<Scalars['jsonb']>;
  bypass?: InputMaybe<Scalars['Boolean']>;
  classified_at?: InputMaybe<Scalars['timestamptz']>;
  classifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_tags?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_classification_category?: InputMaybe<Scalars['String']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate_country?: InputMaybe<Scalars['String']>;
  specific_error_rate?: InputMaybe<Scalars['numeric']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ViolationEventAnalysisStddevFields = {
  __typename?: 'violation_event_analysis_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ViolationEventAnalysisStddevPopFields = {
  __typename?: 'violation_event_analysis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ViolationEventAnalysisStddevSampFields = {
  __typename?: 'violation_event_analysis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "violation_event_analysis" */
export type ViolationEventAnalysisStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ViolationEventAnalysisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViolationEventAnalysisStreamCursorValueInput = {
  analysis_metrics?: InputMaybe<Scalars['jsonb']>;
  bypass?: InputMaybe<Scalars['Boolean']>;
  classified_at?: InputMaybe<Scalars['timestamptz']>;
  classifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_tags?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_classification_category?: InputMaybe<Scalars['String']>;
  parking_lot?: InputMaybe<Scalars['String']>;
  parking_results_id?: InputMaybe<Scalars['uuid']>;
  plate_country?: InputMaybe<Scalars['String']>;
  specific_error_rate?: InputMaybe<Scalars['numeric']>;
  timestamp_out?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ViolationEventAnalysisSumFields = {
  __typename?: 'violation_event_analysis_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  specific_error_rate?: Maybe<Scalars['numeric']>;
};

/** update columns of table "violation_event_analysis" */
export enum ViolationEventAnalysisUpdateColumn {
  /** column name */
  AnalysisMetrics = 'analysis_metrics',
  /** column name */
  Bypass = 'bypass',
  /** column name */
  ClassifiedAt = 'classified_at',
  /** column name */
  Classifier = 'classifier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventTags = 'event_tags',
  /** column name */
  Id = 'id',
  /** column name */
  InitialClassificationCategory = 'initial_classification_category',
  /** column name */
  ParkingLot = 'parking_lot',
  /** column name */
  ParkingResultsId = 'parking_results_id',
  /** column name */
  PlateCountry = 'plate_country',
  /** column name */
  SpecificErrorRate = 'specific_error_rate',
  /** column name */
  TimestampOut = 'timestamp_out'
}

export type ViolationEventAnalysisUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ViolationEventAnalysisAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ViolationEventAnalysisDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ViolationEventAnalysisDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ViolationEventAnalysisDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ViolationEventAnalysisIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ViolationEventAnalysisPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ViolationEventAnalysisSetInput>;
  /** filter the rows which have to be updated */
  where: ViolationEventAnalysisBoolExp;
};

/** aggregate var_pop on columns */
export type ViolationEventAnalysisVarPopFields = {
  __typename?: 'violation_event_analysis_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ViolationEventAnalysisVarSampFields = {
  __typename?: 'violation_event_analysis_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ViolationEventAnalysisVarianceFields = {
  __typename?: 'violation_event_analysis_variance_fields';
  id?: Maybe<Scalars['Float']>;
  specific_error_rate?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "violator_transactions" */
export type ViolatorTransactions = {
  __typename?: 'violator_transactions';
  account_number?: Maybe<Scalars['String']>;
  amount: Scalars['float8'];
  bank_account_country?: Maybe<Scalars['String']>;
  booking_date?: Maybe<Scalars['date']>;
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['bigint'];
  matched_at?: Maybe<Scalars['date']>;
  parsed_case_id?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  payment_reference: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  violation_case?: Maybe<ViolationCase>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "violator_transactions" */
export type ViolatorTransactionsAggregate = {
  __typename?: 'violator_transactions_aggregate';
  aggregate?: Maybe<ViolatorTransactionsAggregateFields>;
  nodes: Array<ViolatorTransactions>;
};

export type ViolatorTransactionsAggregateBoolExp = {
  avg?: InputMaybe<ViolatorTransactionsAggregateBoolExpAvg>;
  corr?: InputMaybe<ViolatorTransactionsAggregateBoolExpCorr>;
  count?: InputMaybe<ViolatorTransactionsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<ViolatorTransactionsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<ViolatorTransactionsAggregateBoolExpMax>;
  min?: InputMaybe<ViolatorTransactionsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<ViolatorTransactionsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<ViolatorTransactionsAggregateBoolExpSum>;
  var_samp?: InputMaybe<ViolatorTransactionsAggregateBoolExpVarSamp>;
};

export type ViolatorTransactionsAggregateBoolExpAvg = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpCorr = {
  arguments: ViolatorTransactionsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpCorrArguments = {
  X: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCorrArgumentsColumns;
  Y: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCorrArgumentsColumns;
};

export type ViolatorTransactionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: IntComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpCovarSamp = {
  arguments: ViolatorTransactionsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpCovarSampArguments = {
  X: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCovarSampArgumentsColumns;
  Y: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCovarSampArgumentsColumns;
};

export type ViolatorTransactionsAggregateBoolExpMax = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpMin = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpStddevSamp = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpSum = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type ViolatorTransactionsAggregateBoolExpVarSamp = {
  arguments: ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ViolatorTransactionsBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "violator_transactions" */
export type ViolatorTransactionsAggregateFields = {
  __typename?: 'violator_transactions_aggregate_fields';
  avg?: Maybe<ViolatorTransactionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViolatorTransactionsMaxFields>;
  min?: Maybe<ViolatorTransactionsMinFields>;
  stddev?: Maybe<ViolatorTransactionsStddevFields>;
  stddev_pop?: Maybe<ViolatorTransactionsStddevPopFields>;
  stddev_samp?: Maybe<ViolatorTransactionsStddevSampFields>;
  sum?: Maybe<ViolatorTransactionsSumFields>;
  var_pop?: Maybe<ViolatorTransactionsVarPopFields>;
  var_samp?: Maybe<ViolatorTransactionsVarSampFields>;
  variance?: Maybe<ViolatorTransactionsVarianceFields>;
};


/** aggregate fields of "violator_transactions" */
export type ViolatorTransactionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViolatorTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "violator_transactions" */
export type ViolatorTransactionsAggregateOrderBy = {
  avg?: InputMaybe<ViolatorTransactionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ViolatorTransactionsMaxOrderBy>;
  min?: InputMaybe<ViolatorTransactionsMinOrderBy>;
  stddev?: InputMaybe<ViolatorTransactionsStddevOrderBy>;
  stddev_pop?: InputMaybe<ViolatorTransactionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ViolatorTransactionsStddevSampOrderBy>;
  sum?: InputMaybe<ViolatorTransactionsSumOrderBy>;
  var_pop?: InputMaybe<ViolatorTransactionsVarPopOrderBy>;
  var_samp?: InputMaybe<ViolatorTransactionsVarSampOrderBy>;
  variance?: InputMaybe<ViolatorTransactionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "violator_transactions" */
export type ViolatorTransactionsArrRelInsertInput = {
  data: Array<ViolatorTransactionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ViolatorTransactionsOnConflict>;
};

/** aggregate avg on columns */
export type ViolatorTransactionsAvgFields = {
  __typename?: 'violator_transactions_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "violator_transactions" */
export type ViolatorTransactionsAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "violator_transactions". All fields are combined with a logical 'AND'. */
export type ViolatorTransactionsBoolExp = {
  _and?: InputMaybe<Array<ViolatorTransactionsBoolExp>>;
  _not?: InputMaybe<ViolatorTransactionsBoolExp>;
  _or?: InputMaybe<Array<ViolatorTransactionsBoolExp>>;
  account_number?: InputMaybe<StringComparisonExp>;
  amount?: InputMaybe<Float8ComparisonExp>;
  bank_account_country?: InputMaybe<StringComparisonExp>;
  booking_date?: InputMaybe<DateComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  matched_at?: InputMaybe<DateComparisonExp>;
  parsed_case_id?: InputMaybe<StringComparisonExp>;
  payee?: InputMaybe<StringComparisonExp>;
  payment_reference?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  transaction_id?: InputMaybe<StringComparisonExp>;
  transaction_type?: InputMaybe<StringComparisonExp>;
  transferred_from?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  violation_case?: InputMaybe<ViolationCaseBoolExp>;
  violation_case_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "violator_transactions" */
export enum ViolatorTransactionsConstraint {
  /** unique or primary key constraint on columns "id" */
  TransactionsIdKey = 'transactions_id_key',
  /** unique or primary key constraint on columns "id" */
  TransactionsPkey = 'transactions_pkey'
}

/** input type for incrementing numeric columns in table "violator_transactions" */
export type ViolatorTransactionsIncInput = {
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "violator_transactions" */
export type ViolatorTransactionsInsertInput = {
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_account_country?: InputMaybe<Scalars['String']>;
  booking_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  matched_at?: InputMaybe<Scalars['date']>;
  parsed_case_id?: InputMaybe<Scalars['String']>;
  payee?: InputMaybe<Scalars['String']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  transaction_type?: InputMaybe<Scalars['String']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case?: InputMaybe<ViolationCaseObjRelInsertInput>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ViolatorTransactionsMaxFields = {
  __typename?: 'violator_transactions_max_fields';
  account_number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['float8']>;
  bank_account_country?: Maybe<Scalars['String']>;
  booking_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  matched_at?: Maybe<Scalars['date']>;
  parsed_case_id?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  payment_reference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "violator_transactions" */
export type ViolatorTransactionsMaxOrderBy = {
  account_number?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  bank_account_country?: InputMaybe<OrderBy>;
  booking_date?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matched_at?: InputMaybe<OrderBy>;
  parsed_case_id?: InputMaybe<OrderBy>;
  payee?: InputMaybe<OrderBy>;
  payment_reference?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  transaction_id?: InputMaybe<OrderBy>;
  transaction_type?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ViolatorTransactionsMinFields = {
  __typename?: 'violator_transactions_min_fields';
  account_number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['float8']>;
  bank_account_country?: Maybe<Scalars['String']>;
  booking_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  matched_at?: Maybe<Scalars['date']>;
  parsed_case_id?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  payment_reference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "violator_transactions" */
export type ViolatorTransactionsMinOrderBy = {
  account_number?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  bank_account_country?: InputMaybe<OrderBy>;
  booking_date?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matched_at?: InputMaybe<OrderBy>;
  parsed_case_id?: InputMaybe<OrderBy>;
  payee?: InputMaybe<OrderBy>;
  payment_reference?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  transaction_id?: InputMaybe<OrderBy>;
  transaction_type?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "violator_transactions" */
export type ViolatorTransactionsMutationResponse = {
  __typename?: 'violator_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ViolatorTransactions>;
};

/** on_conflict condition type for table "violator_transactions" */
export type ViolatorTransactionsOnConflict = {
  constraint: ViolatorTransactionsConstraint;
  update_columns?: Array<ViolatorTransactionsUpdateColumn>;
  where?: InputMaybe<ViolatorTransactionsBoolExp>;
};

/** Ordering options when selecting data from "violator_transactions". */
export type ViolatorTransactionsOrderBy = {
  account_number?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  bank_account_country?: InputMaybe<OrderBy>;
  booking_date?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matched_at?: InputMaybe<OrderBy>;
  parsed_case_id?: InputMaybe<OrderBy>;
  payee?: InputMaybe<OrderBy>;
  payment_reference?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  transaction_id?: InputMaybe<OrderBy>;
  transaction_type?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  violation_case?: InputMaybe<ViolationCaseOrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: violator_transactions */
export type ViolatorTransactionsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumn {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankAccountCountry = 'bank_account_country',
  /** column name */
  BookingDate = 'booking_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  MatchedAt = 'matched_at',
  /** column name */
  ParsedCaseId = 'parsed_case_id',
  /** column name */
  Payee = 'payee',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  TransferredFrom = 'transferred_from',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

/** select "violator_transactions_aggregate_bool_exp_avg_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_corr_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_max_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_min_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_sum_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** select "violator_transactions_aggregate_bool_exp_var_samp_arguments_columns" columns of table "violator_transactions" */
export enum ViolatorTransactionsSelectColumnViolatorTransactionsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

/** input type for updating data in table "violator_transactions" */
export type ViolatorTransactionsSetInput = {
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_account_country?: InputMaybe<Scalars['String']>;
  booking_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  matched_at?: InputMaybe<Scalars['date']>;
  parsed_case_id?: InputMaybe<Scalars['String']>;
  payee?: InputMaybe<Scalars['String']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  transaction_type?: InputMaybe<Scalars['String']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ViolatorTransactionsStddevFields = {
  __typename?: 'violator_transactions_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "violator_transactions" */
export type ViolatorTransactionsStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ViolatorTransactionsStddevPopFields = {
  __typename?: 'violator_transactions_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "violator_transactions" */
export type ViolatorTransactionsStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ViolatorTransactionsStddevSampFields = {
  __typename?: 'violator_transactions_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "violator_transactions" */
export type ViolatorTransactionsStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "violator_transactions" */
export type ViolatorTransactionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ViolatorTransactionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViolatorTransactionsStreamCursorValueInput = {
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_account_country?: InputMaybe<Scalars['String']>;
  booking_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  matched_at?: InputMaybe<Scalars['date']>;
  parsed_case_id?: InputMaybe<Scalars['String']>;
  payee?: InputMaybe<Scalars['String']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  transaction_type?: InputMaybe<Scalars['String']>;
  transferred_from?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  violation_case_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ViolatorTransactionsSumFields = {
  __typename?: 'violator_transactions_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  transferred_from?: Maybe<Scalars['bigint']>;
  violation_case_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "violator_transactions" */
export type ViolatorTransactionsSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** update columns of table "violator_transactions" */
export enum ViolatorTransactionsUpdateColumn {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankAccountCountry = 'bank_account_country',
  /** column name */
  BookingDate = 'booking_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  MatchedAt = 'matched_at',
  /** column name */
  ParsedCaseId = 'parsed_case_id',
  /** column name */
  Payee = 'payee',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  TransferredFrom = 'transferred_from',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViolationCaseId = 'violation_case_id'
}

export type ViolatorTransactionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ViolatorTransactionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ViolatorTransactionsSetInput>;
  /** filter the rows which have to be updated */
  where: ViolatorTransactionsBoolExp;
};

/** aggregate var_pop on columns */
export type ViolatorTransactionsVarPopFields = {
  __typename?: 'violator_transactions_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "violator_transactions" */
export type ViolatorTransactionsVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ViolatorTransactionsVarSampFields = {
  __typename?: 'violator_transactions_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "violator_transactions" */
export type ViolatorTransactionsVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ViolatorTransactionsVarianceFields = {
  __typename?: 'violator_transactions_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transferred_from?: Maybe<Scalars['Float']>;
  violation_case_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "violator_transactions" */
export type ViolatorTransactionsVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transferred_from?: InputMaybe<OrderBy>;
  violation_case_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "whitelist" */
export type Whitelist = {
  __typename?: 'whitelist';
  /** An object relationship */
  company: Company;
  company_id: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  lot?: Maybe<Lot>;
  lot_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  lp_group?: Maybe<LpGroup>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  max_duration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  purpose: Scalars['String'];
  raw_plate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reason_info?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  rental_subscriptions: Array<RentalSubscription>;
  /** An aggregate relationship */
  rental_subscriptions_aggregate: RentalSubscriptionAggregate;
  scope: Scalars['String'];
  start_date?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  whitelist_calendar_event_policies: Array<WhitelistCalendarEventPolicy>;
  /** An aggregate relationship */
  whitelist_calendar_event_policies_aggregate: WhitelistCalendarEventPolicyAggregate;
  /** An array relationship */
  whitelist_subscriptions: Array<WhitelistSubscription>;
  /** An aggregate relationship */
  whitelist_subscriptions_aggregate: WhitelistSubscriptionAggregate;
};


/** columns and relationships of "whitelist" */
export type WhitelistReasonInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "whitelist" */
export type WhitelistRentalSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


/** columns and relationships of "whitelist" */
export type WhitelistRentalSubscriptionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RentalSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RentalSubscriptionOrderBy>>;
  where?: InputMaybe<RentalSubscriptionBoolExp>;
};


/** columns and relationships of "whitelist" */
export type WhitelistWhitelistCalendarEventPoliciesArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


/** columns and relationships of "whitelist" */
export type WhitelistWhitelistCalendarEventPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistCalendarEventPolicyOrderBy>>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};


/** columns and relationships of "whitelist" */
export type WhitelistWhitelistSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};


/** columns and relationships of "whitelist" */
export type WhitelistWhitelistSubscriptionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistSubscriptionOrderBy>>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};

/** aggregated selection of "whitelist" */
export type WhitelistAggregate = {
  __typename?: 'whitelist_aggregate';
  aggregate?: Maybe<WhitelistAggregateFields>;
  nodes: Array<Whitelist>;
};

export type WhitelistAggregateBoolExp = {
  count?: InputMaybe<WhitelistAggregateBoolExpCount>;
};

export type WhitelistAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WhitelistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WhitelistBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "whitelist" */
export type WhitelistAggregateFields = {
  __typename?: 'whitelist_aggregate_fields';
  avg?: Maybe<WhitelistAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistMaxFields>;
  min?: Maybe<WhitelistMinFields>;
  stddev?: Maybe<WhitelistStddevFields>;
  stddev_pop?: Maybe<WhitelistStddevPopFields>;
  stddev_samp?: Maybe<WhitelistStddevSampFields>;
  sum?: Maybe<WhitelistSumFields>;
  var_pop?: Maybe<WhitelistVarPopFields>;
  var_samp?: Maybe<WhitelistVarSampFields>;
  variance?: Maybe<WhitelistVarianceFields>;
};


/** aggregate fields of "whitelist" */
export type WhitelistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "whitelist" */
export type WhitelistAggregateOrderBy = {
  avg?: InputMaybe<WhitelistAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WhitelistMaxOrderBy>;
  min?: InputMaybe<WhitelistMinOrderBy>;
  stddev?: InputMaybe<WhitelistStddevOrderBy>;
  stddev_pop?: InputMaybe<WhitelistStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WhitelistStddevSampOrderBy>;
  sum?: InputMaybe<WhitelistSumOrderBy>;
  var_pop?: InputMaybe<WhitelistVarPopOrderBy>;
  var_samp?: InputMaybe<WhitelistVarSampOrderBy>;
  variance?: InputMaybe<WhitelistVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WhitelistAppendInput = {
  reason_info?: InputMaybe<Scalars['jsonb']>;
};

/** Hypertable that links the applied whitelist with the whitelist table */
export type WhitelistAppliedPermit = {
  __typename?: 'whitelist_applied_permit';
  applied_permit_id: Scalars['bigint'];
  id: Scalars['bigint'];
  whitelist_id: Scalars['bigint'];
};

/** aggregated selection of "whitelist_applied_permit" */
export type WhitelistAppliedPermitAggregate = {
  __typename?: 'whitelist_applied_permit_aggregate';
  aggregate?: Maybe<WhitelistAppliedPermitAggregateFields>;
  nodes: Array<WhitelistAppliedPermit>;
};

/** aggregate fields of "whitelist_applied_permit" */
export type WhitelistAppliedPermitAggregateFields = {
  __typename?: 'whitelist_applied_permit_aggregate_fields';
  avg?: Maybe<WhitelistAppliedPermitAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistAppliedPermitMaxFields>;
  min?: Maybe<WhitelistAppliedPermitMinFields>;
  stddev?: Maybe<WhitelistAppliedPermitStddevFields>;
  stddev_pop?: Maybe<WhitelistAppliedPermitStddevPopFields>;
  stddev_samp?: Maybe<WhitelistAppliedPermitStddevSampFields>;
  sum?: Maybe<WhitelistAppliedPermitSumFields>;
  var_pop?: Maybe<WhitelistAppliedPermitVarPopFields>;
  var_samp?: Maybe<WhitelistAppliedPermitVarSampFields>;
  variance?: Maybe<WhitelistAppliedPermitVarianceFields>;
};


/** aggregate fields of "whitelist_applied_permit" */
export type WhitelistAppliedPermitAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistAppliedPermitSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WhitelistAppliedPermitAvgFields = {
  __typename?: 'whitelist_applied_permit_avg_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whitelist_applied_permit". All fields are combined with a logical 'AND'. */
export type WhitelistAppliedPermitBoolExp = {
  _and?: InputMaybe<Array<WhitelistAppliedPermitBoolExp>>;
  _not?: InputMaybe<WhitelistAppliedPermitBoolExp>;
  _or?: InputMaybe<Array<WhitelistAppliedPermitBoolExp>>;
  applied_permit_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  whitelist_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "whitelist_applied_permit" */
export enum WhitelistAppliedPermitConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistAppliedWhitelistPkey = 'whitelist_applied_whitelist_pkey'
}

/** input type for incrementing numeric columns in table "whitelist_applied_permit" */
export type WhitelistAppliedPermitIncInput = {
  applied_permit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "whitelist_applied_permit" */
export type WhitelistAppliedPermitInsertInput = {
  applied_permit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type WhitelistAppliedPermitMaxFields = {
  __typename?: 'whitelist_applied_permit_max_fields';
  applied_permit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type WhitelistAppliedPermitMinFields = {
  __typename?: 'whitelist_applied_permit_min_fields';
  applied_permit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "whitelist_applied_permit" */
export type WhitelistAppliedPermitMutationResponse = {
  __typename?: 'whitelist_applied_permit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WhitelistAppliedPermit>;
};

/** on_conflict condition type for table "whitelist_applied_permit" */
export type WhitelistAppliedPermitOnConflict = {
  constraint: WhitelistAppliedPermitConstraint;
  update_columns?: Array<WhitelistAppliedPermitUpdateColumn>;
  where?: InputMaybe<WhitelistAppliedPermitBoolExp>;
};

/** Ordering options when selecting data from "whitelist_applied_permit". */
export type WhitelistAppliedPermitOrderBy = {
  applied_permit_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: whitelist_applied_permit */
export type WhitelistAppliedPermitPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "whitelist_applied_permit" */
export enum WhitelistAppliedPermitSelectColumn {
  /** column name */
  AppliedPermitId = 'applied_permit_id',
  /** column name */
  Id = 'id',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "whitelist_applied_permit" */
export type WhitelistAppliedPermitSetInput = {
  applied_permit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type WhitelistAppliedPermitStddevFields = {
  __typename?: 'whitelist_applied_permit_stddev_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WhitelistAppliedPermitStddevPopFields = {
  __typename?: 'whitelist_applied_permit_stddev_pop_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WhitelistAppliedPermitStddevSampFields = {
  __typename?: 'whitelist_applied_permit_stddev_samp_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whitelist_applied_permit" */
export type WhitelistAppliedPermitStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistAppliedPermitStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistAppliedPermitStreamCursorValueInput = {
  applied_permit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type WhitelistAppliedPermitSumFields = {
  __typename?: 'whitelist_applied_permit_sum_fields';
  applied_permit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "whitelist_applied_permit" */
export enum WhitelistAppliedPermitUpdateColumn {
  /** column name */
  AppliedPermitId = 'applied_permit_id',
  /** column name */
  Id = 'id',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type WhitelistAppliedPermitUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistAppliedPermitIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistAppliedPermitSetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistAppliedPermitBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistAppliedPermitVarPopFields = {
  __typename?: 'whitelist_applied_permit_var_pop_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WhitelistAppliedPermitVarSampFields = {
  __typename?: 'whitelist_applied_permit_var_samp_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WhitelistAppliedPermitVarianceFields = {
  __typename?: 'whitelist_applied_permit_variance_fields';
  applied_permit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting array relation for remote table "whitelist" */
export type WhitelistArrRelInsertInput = {
  data: Array<WhitelistInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WhitelistOnConflict>;
};

/** aggregate avg on columns */
export type WhitelistAvgFields = {
  __typename?: 'whitelist_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "whitelist" */
export type WhitelistAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "whitelist". All fields are combined with a logical 'AND'. */
export type WhitelistBoolExp = {
  _and?: InputMaybe<Array<WhitelistBoolExp>>;
  _not?: InputMaybe<WhitelistBoolExp>;
  _or?: InputMaybe<Array<WhitelistBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  company_id?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  lp_group?: InputMaybe<LpGroupBoolExp>;
  lp_group_id?: InputMaybe<BigintComparisonExp>;
  max_duration?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  purpose?: InputMaybe<StringComparisonExp>;
  raw_plate?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  reason_info?: InputMaybe<JsonbComparisonExp>;
  rental_subscriptions?: InputMaybe<RentalSubscriptionBoolExp>;
  rental_subscriptions_aggregate?: InputMaybe<RentalSubscriptionAggregateBoolExp>;
  scope?: InputMaybe<StringComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<StringComparisonExp>;
  whitelist_calendar_event_policies?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
  whitelist_calendar_event_policies_aggregate?: InputMaybe<WhitelistCalendarEventPolicyAggregateBoolExp>;
  whitelist_subscriptions?: InputMaybe<WhitelistSubscriptionBoolExp>;
  whitelist_subscriptions_aggregate?: InputMaybe<WhitelistSubscriptionAggregateBoolExp>;
};

/** columns and relationships of "whitelist_by_plate_view" */
export type WhitelistByPlateView = {
  __typename?: 'whitelist_by_plate_view';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  /** An array relationship */
  whitelist: Array<Whitelist>;
  /** An aggregate relationship */
  whitelist_aggregate: WhitelistAggregate;
};


/** columns and relationships of "whitelist_by_plate_view" */
export type WhitelistByPlateViewWhitelistArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


/** columns and relationships of "whitelist_by_plate_view" */
export type WhitelistByPlateViewWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};

/** aggregated selection of "whitelist_by_plate_view" */
export type WhitelistByPlateViewAggregate = {
  __typename?: 'whitelist_by_plate_view_aggregate';
  aggregate?: Maybe<WhitelistByPlateViewAggregateFields>;
  nodes: Array<WhitelistByPlateView>;
};

/** aggregate fields of "whitelist_by_plate_view" */
export type WhitelistByPlateViewAggregateFields = {
  __typename?: 'whitelist_by_plate_view_aggregate_fields';
  avg?: Maybe<WhitelistByPlateViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistByPlateViewMaxFields>;
  min?: Maybe<WhitelistByPlateViewMinFields>;
  stddev?: Maybe<WhitelistByPlateViewStddevFields>;
  stddev_pop?: Maybe<WhitelistByPlateViewStddevPopFields>;
  stddev_samp?: Maybe<WhitelistByPlateViewStddevSampFields>;
  sum?: Maybe<WhitelistByPlateViewSumFields>;
  var_pop?: Maybe<WhitelistByPlateViewVarPopFields>;
  var_samp?: Maybe<WhitelistByPlateViewVarSampFields>;
  variance?: Maybe<WhitelistByPlateViewVarianceFields>;
};


/** aggregate fields of "whitelist_by_plate_view" */
export type WhitelistByPlateViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistByPlateViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WhitelistByPlateViewAvgFields = {
  __typename?: 'whitelist_by_plate_view_avg_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whitelist_by_plate_view". All fields are combined with a logical 'AND'. */
export type WhitelistByPlateViewBoolExp = {
  _and?: InputMaybe<Array<WhitelistByPlateViewBoolExp>>;
  _not?: InputMaybe<WhitelistByPlateViewBoolExp>;
  _or?: InputMaybe<Array<WhitelistByPlateViewBoolExp>>;
  max_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  whitelist?: InputMaybe<WhitelistBoolExp>;
  whitelist_aggregate?: InputMaybe<WhitelistAggregateBoolExp>;
};

/** aggregate max on columns */
export type WhitelistByPlateViewMaxFields = {
  __typename?: 'whitelist_by_plate_view_max_fields';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WhitelistByPlateViewMinFields = {
  __typename?: 'whitelist_by_plate_view_min_fields';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "whitelist_by_plate_view". */
export type WhitelistByPlateViewOrderBy = {
  max_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  whitelist_aggregate?: InputMaybe<WhitelistAggregateOrderBy>;
};

/** select columns of table "whitelist_by_plate_view" */
export enum WhitelistByPlateViewSelectColumn {
  /** column name */
  MaxId = 'max_id',
  /** column name */
  Plate = 'plate'
}

/** aggregate stddev on columns */
export type WhitelistByPlateViewStddevFields = {
  __typename?: 'whitelist_by_plate_view_stddev_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WhitelistByPlateViewStddevPopFields = {
  __typename?: 'whitelist_by_plate_view_stddev_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WhitelistByPlateViewStddevSampFields = {
  __typename?: 'whitelist_by_plate_view_stddev_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whitelist_by_plate_view" */
export type WhitelistByPlateViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistByPlateViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistByPlateViewStreamCursorValueInput = {
  max_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type WhitelistByPlateViewSumFields = {
  __typename?: 'whitelist_by_plate_view_sum_fields';
  max_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type WhitelistByPlateViewVarPopFields = {
  __typename?: 'whitelist_by_plate_view_var_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WhitelistByPlateViewVarSampFields = {
  __typename?: 'whitelist_by_plate_view_var_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WhitelistByPlateViewVarianceFields = {
  __typename?: 'whitelist_by_plate_view_variance_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Junction table to connect the whitelist table with the calendar_event_policy table */
export type WhitelistCalendarEventPolicy = {
  __typename?: 'whitelist_calendar_event_policy';
  /** An object relationship */
  calendar_event_policy: CalendarEventPolicy;
  calendar_event_policy_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  whitelist: Whitelist;
  whitelist_id: Scalars['Int'];
};

/** aggregated selection of "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyAggregate = {
  __typename?: 'whitelist_calendar_event_policy_aggregate';
  aggregate?: Maybe<WhitelistCalendarEventPolicyAggregateFields>;
  nodes: Array<WhitelistCalendarEventPolicy>;
};

export type WhitelistCalendarEventPolicyAggregateBoolExp = {
  count?: InputMaybe<WhitelistCalendarEventPolicyAggregateBoolExpCount>;
};

export type WhitelistCalendarEventPolicyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyAggregateFields = {
  __typename?: 'whitelist_calendar_event_policy_aggregate_fields';
  avg?: Maybe<WhitelistCalendarEventPolicyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistCalendarEventPolicyMaxFields>;
  min?: Maybe<WhitelistCalendarEventPolicyMinFields>;
  stddev?: Maybe<WhitelistCalendarEventPolicyStddevFields>;
  stddev_pop?: Maybe<WhitelistCalendarEventPolicyStddevPopFields>;
  stddev_samp?: Maybe<WhitelistCalendarEventPolicyStddevSampFields>;
  sum?: Maybe<WhitelistCalendarEventPolicySumFields>;
  var_pop?: Maybe<WhitelistCalendarEventPolicyVarPopFields>;
  var_samp?: Maybe<WhitelistCalendarEventPolicyVarSampFields>;
  variance?: Maybe<WhitelistCalendarEventPolicyVarianceFields>;
};


/** aggregate fields of "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistCalendarEventPolicySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyAggregateOrderBy = {
  avg?: InputMaybe<WhitelistCalendarEventPolicyAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WhitelistCalendarEventPolicyMaxOrderBy>;
  min?: InputMaybe<WhitelistCalendarEventPolicyMinOrderBy>;
  stddev?: InputMaybe<WhitelistCalendarEventPolicyStddevOrderBy>;
  stddev_pop?: InputMaybe<WhitelistCalendarEventPolicyStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WhitelistCalendarEventPolicyStddevSampOrderBy>;
  sum?: InputMaybe<WhitelistCalendarEventPolicySumOrderBy>;
  var_pop?: InputMaybe<WhitelistCalendarEventPolicyVarPopOrderBy>;
  var_samp?: InputMaybe<WhitelistCalendarEventPolicyVarSampOrderBy>;
  variance?: InputMaybe<WhitelistCalendarEventPolicyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyArrRelInsertInput = {
  data: Array<WhitelistCalendarEventPolicyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WhitelistCalendarEventPolicyOnConflict>;
};

/** aggregate avg on columns */
export type WhitelistCalendarEventPolicyAvgFields = {
  __typename?: 'whitelist_calendar_event_policy_avg_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyAvgOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "whitelist_calendar_event_policy". All fields are combined with a logical 'AND'. */
export type WhitelistCalendarEventPolicyBoolExp = {
  _and?: InputMaybe<Array<WhitelistCalendarEventPolicyBoolExp>>;
  _not?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
  _or?: InputMaybe<Array<WhitelistCalendarEventPolicyBoolExp>>;
  calendar_event_policy?: InputMaybe<CalendarEventPolicyBoolExp>;
  calendar_event_policy_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  whitelist?: InputMaybe<WhitelistBoolExp>;
  whitelist_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "whitelist_calendar_event_policy" */
export enum WhitelistCalendarEventPolicyConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistCalendarEventPolicyPkey = 'whitelist_calendar_event_policy_pkey'
}

/** input type for incrementing numeric columns in table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyIncInput = {
  calendar_event_policy_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyInsertInput = {
  calendar_event_policy?: InputMaybe<CalendarEventPolicyObjRelInsertInput>;
  calendar_event_policy_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist?: InputMaybe<WhitelistObjRelInsertInput>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type WhitelistCalendarEventPolicyMaxFields = {
  __typename?: 'whitelist_calendar_event_policy_max_fields';
  calendar_event_policy_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyMaxOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WhitelistCalendarEventPolicyMinFields = {
  __typename?: 'whitelist_calendar_event_policy_min_fields';
  calendar_event_policy_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyMinOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyMutationResponse = {
  __typename?: 'whitelist_calendar_event_policy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WhitelistCalendarEventPolicy>;
};

/** on_conflict condition type for table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyOnConflict = {
  constraint: WhitelistCalendarEventPolicyConstraint;
  update_columns?: Array<WhitelistCalendarEventPolicyUpdateColumn>;
  where?: InputMaybe<WhitelistCalendarEventPolicyBoolExp>;
};

/** Ordering options when selecting data from "whitelist_calendar_event_policy". */
export type WhitelistCalendarEventPolicyOrderBy = {
  calendar_event_policy?: InputMaybe<CalendarEventPolicyOrderBy>;
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whitelist?: InputMaybe<WhitelistOrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: whitelist_calendar_event_policy */
export type WhitelistCalendarEventPolicyPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "whitelist_calendar_event_policy" */
export enum WhitelistCalendarEventPolicySelectColumn {
  /** column name */
  CalendarEventPolicyId = 'calendar_event_policy_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicySetInput = {
  calendar_event_policy_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type WhitelistCalendarEventPolicyStddevFields = {
  __typename?: 'whitelist_calendar_event_policy_stddev_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyStddevOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WhitelistCalendarEventPolicyStddevPopFields = {
  __typename?: 'whitelist_calendar_event_policy_stddev_pop_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyStddevPopOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WhitelistCalendarEventPolicyStddevSampFields = {
  __typename?: 'whitelist_calendar_event_policy_stddev_samp_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyStddevSampOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistCalendarEventPolicyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistCalendarEventPolicyStreamCursorValueInput = {
  calendar_event_policy_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type WhitelistCalendarEventPolicySumFields = {
  __typename?: 'whitelist_calendar_event_policy_sum_fields';
  calendar_event_policy_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicySumOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** update columns of table "whitelist_calendar_event_policy" */
export enum WhitelistCalendarEventPolicyUpdateColumn {
  /** column name */
  CalendarEventPolicyId = 'calendar_event_policy_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type WhitelistCalendarEventPolicyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistCalendarEventPolicyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistCalendarEventPolicySetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistCalendarEventPolicyBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistCalendarEventPolicyVarPopFields = {
  __typename?: 'whitelist_calendar_event_policy_var_pop_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyVarPopOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WhitelistCalendarEventPolicyVarSampFields = {
  __typename?: 'whitelist_calendar_event_policy_var_samp_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyVarSampOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WhitelistCalendarEventPolicyVarianceFields = {
  __typename?: 'whitelist_calendar_event_policy_variance_fields';
  calendar_event_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "whitelist_calendar_event_policy" */
export type WhitelistCalendarEventPolicyVarianceOrderBy = {
  calendar_event_policy_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "whitelist" */
export enum WhitelistConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistPkey = 'whitelist_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WhitelistDeleteAtPathInput = {
  reason_info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WhitelistDeleteElemInput = {
  reason_info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WhitelistDeleteKeyInput = {
  reason_info?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateView = {
  __typename?: 'whitelist_guest_by_plate_view';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
  /** An array relationship */
  whitelist: Array<Whitelist>;
  /** An aggregate relationship */
  whitelist_aggregate: WhitelistAggregate;
};


/** columns and relationships of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewWhitelistArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};


/** columns and relationships of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewWhitelistAggregateArgs = {
  distinct_on?: InputMaybe<Array<WhitelistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WhitelistOrderBy>>;
  where?: InputMaybe<WhitelistBoolExp>;
};

/** aggregated selection of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewAggregate = {
  __typename?: 'whitelist_guest_by_plate_view_aggregate';
  aggregate?: Maybe<WhitelistGuestByPlateViewAggregateFields>;
  nodes: Array<WhitelistGuestByPlateView>;
};

/** aggregate fields of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewAggregateFields = {
  __typename?: 'whitelist_guest_by_plate_view_aggregate_fields';
  avg?: Maybe<WhitelistGuestByPlateViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistGuestByPlateViewMaxFields>;
  min?: Maybe<WhitelistGuestByPlateViewMinFields>;
  stddev?: Maybe<WhitelistGuestByPlateViewStddevFields>;
  stddev_pop?: Maybe<WhitelistGuestByPlateViewStddevPopFields>;
  stddev_samp?: Maybe<WhitelistGuestByPlateViewStddevSampFields>;
  sum?: Maybe<WhitelistGuestByPlateViewSumFields>;
  var_pop?: Maybe<WhitelistGuestByPlateViewVarPopFields>;
  var_samp?: Maybe<WhitelistGuestByPlateViewVarSampFields>;
  variance?: Maybe<WhitelistGuestByPlateViewVarianceFields>;
};


/** aggregate fields of "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistGuestByPlateViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WhitelistGuestByPlateViewAvgFields = {
  __typename?: 'whitelist_guest_by_plate_view_avg_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whitelist_guest_by_plate_view". All fields are combined with a logical 'AND'. */
export type WhitelistGuestByPlateViewBoolExp = {
  _and?: InputMaybe<Array<WhitelistGuestByPlateViewBoolExp>>;
  _not?: InputMaybe<WhitelistGuestByPlateViewBoolExp>;
  _or?: InputMaybe<Array<WhitelistGuestByPlateViewBoolExp>>;
  max_id?: InputMaybe<IntComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  whitelist?: InputMaybe<WhitelistBoolExp>;
  whitelist_aggregate?: InputMaybe<WhitelistAggregateBoolExp>;
};

/** aggregate max on columns */
export type WhitelistGuestByPlateViewMaxFields = {
  __typename?: 'whitelist_guest_by_plate_view_max_fields';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WhitelistGuestByPlateViewMinFields = {
  __typename?: 'whitelist_guest_by_plate_view_min_fields';
  max_id?: Maybe<Scalars['Int']>;
  plate?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "whitelist_guest_by_plate_view". */
export type WhitelistGuestByPlateViewOrderBy = {
  max_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  whitelist_aggregate?: InputMaybe<WhitelistAggregateOrderBy>;
};

/** select columns of table "whitelist_guest_by_plate_view" */
export enum WhitelistGuestByPlateViewSelectColumn {
  /** column name */
  MaxId = 'max_id',
  /** column name */
  Plate = 'plate'
}

/** aggregate stddev on columns */
export type WhitelistGuestByPlateViewStddevFields = {
  __typename?: 'whitelist_guest_by_plate_view_stddev_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WhitelistGuestByPlateViewStddevPopFields = {
  __typename?: 'whitelist_guest_by_plate_view_stddev_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WhitelistGuestByPlateViewStddevSampFields = {
  __typename?: 'whitelist_guest_by_plate_view_stddev_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whitelist_guest_by_plate_view" */
export type WhitelistGuestByPlateViewStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistGuestByPlateViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistGuestByPlateViewStreamCursorValueInput = {
  max_id?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type WhitelistGuestByPlateViewSumFields = {
  __typename?: 'whitelist_guest_by_plate_view_sum_fields';
  max_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type WhitelistGuestByPlateViewVarPopFields = {
  __typename?: 'whitelist_guest_by_plate_view_var_pop_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WhitelistGuestByPlateViewVarSampFields = {
  __typename?: 'whitelist_guest_by_plate_view_var_samp_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WhitelistGuestByPlateViewVarianceFields = {
  __typename?: 'whitelist_guest_by_plate_view_variance_fields';
  max_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "whitelist" */
export type WhitelistIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  max_duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whitelist" */
export type WhitelistInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_group?: InputMaybe<LpGroupObjRelInsertInput>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  max_duration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  rental_subscriptions?: InputMaybe<RentalSubscriptionArrRelInsertInput>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  whitelist_calendar_event_policies?: InputMaybe<WhitelistCalendarEventPolicyArrRelInsertInput>;
  whitelist_subscriptions?: InputMaybe<WhitelistSubscriptionArrRelInsertInput>;
};

/** columns and relationships of "whitelist_lp_contingent" */
export type WhitelistLpContingent = {
  __typename?: 'whitelist_lp_contingent';
  id: Scalars['bigint'];
  lp_contingent_id: Scalars['bigint'];
  whitelist_id: Scalars['bigint'];
};

/** aggregated selection of "whitelist_lp_contingent" */
export type WhitelistLpContingentAggregate = {
  __typename?: 'whitelist_lp_contingent_aggregate';
  aggregate?: Maybe<WhitelistLpContingentAggregateFields>;
  nodes: Array<WhitelistLpContingent>;
};

/** aggregate fields of "whitelist_lp_contingent" */
export type WhitelistLpContingentAggregateFields = {
  __typename?: 'whitelist_lp_contingent_aggregate_fields';
  avg?: Maybe<WhitelistLpContingentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistLpContingentMaxFields>;
  min?: Maybe<WhitelistLpContingentMinFields>;
  stddev?: Maybe<WhitelistLpContingentStddevFields>;
  stddev_pop?: Maybe<WhitelistLpContingentStddevPopFields>;
  stddev_samp?: Maybe<WhitelistLpContingentStddevSampFields>;
  sum?: Maybe<WhitelistLpContingentSumFields>;
  var_pop?: Maybe<WhitelistLpContingentVarPopFields>;
  var_samp?: Maybe<WhitelistLpContingentVarSampFields>;
  variance?: Maybe<WhitelistLpContingentVarianceFields>;
};


/** aggregate fields of "whitelist_lp_contingent" */
export type WhitelistLpContingentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistLpContingentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WhitelistLpContingentAvgFields = {
  __typename?: 'whitelist_lp_contingent_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whitelist_lp_contingent". All fields are combined with a logical 'AND'. */
export type WhitelistLpContingentBoolExp = {
  _and?: InputMaybe<Array<WhitelistLpContingentBoolExp>>;
  _not?: InputMaybe<WhitelistLpContingentBoolExp>;
  _or?: InputMaybe<Array<WhitelistLpContingentBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  lp_contingent_id?: InputMaybe<BigintComparisonExp>;
  whitelist_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "whitelist_lp_contingent" */
export enum WhitelistLpContingentConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistLpContingentPkey = 'whitelist_lp_contingent_pkey'
}

/** input type for incrementing numeric columns in table "whitelist_lp_contingent" */
export type WhitelistLpContingentIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "whitelist_lp_contingent" */
export type WhitelistLpContingentInsertInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type WhitelistLpContingentMaxFields = {
  __typename?: 'whitelist_lp_contingent_max_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type WhitelistLpContingentMinFields = {
  __typename?: 'whitelist_lp_contingent_min_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "whitelist_lp_contingent" */
export type WhitelistLpContingentMutationResponse = {
  __typename?: 'whitelist_lp_contingent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WhitelistLpContingent>;
};

/** on_conflict condition type for table "whitelist_lp_contingent" */
export type WhitelistLpContingentOnConflict = {
  constraint: WhitelistLpContingentConstraint;
  update_columns?: Array<WhitelistLpContingentUpdateColumn>;
  where?: InputMaybe<WhitelistLpContingentBoolExp>;
};

/** Ordering options when selecting data from "whitelist_lp_contingent". */
export type WhitelistLpContingentOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_contingent_id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: whitelist_lp_contingent */
export type WhitelistLpContingentPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "whitelist_lp_contingent" */
export enum WhitelistLpContingentSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LpContingentId = 'lp_contingent_id',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "whitelist_lp_contingent" */
export type WhitelistLpContingentSetInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type WhitelistLpContingentStddevFields = {
  __typename?: 'whitelist_lp_contingent_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WhitelistLpContingentStddevPopFields = {
  __typename?: 'whitelist_lp_contingent_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WhitelistLpContingentStddevSampFields = {
  __typename?: 'whitelist_lp_contingent_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whitelist_lp_contingent" */
export type WhitelistLpContingentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistLpContingentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistLpContingentStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  lp_contingent_id?: InputMaybe<Scalars['bigint']>;
  whitelist_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type WhitelistLpContingentSumFields = {
  __typename?: 'whitelist_lp_contingent_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  lp_contingent_id?: Maybe<Scalars['bigint']>;
  whitelist_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "whitelist_lp_contingent" */
export enum WhitelistLpContingentUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LpContingentId = 'lp_contingent_id',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type WhitelistLpContingentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistLpContingentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistLpContingentSetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistLpContingentBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistLpContingentVarPopFields = {
  __typename?: 'whitelist_lp_contingent_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WhitelistLpContingentVarSampFields = {
  __typename?: 'whitelist_lp_contingent_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WhitelistLpContingentVarianceFields = {
  __typename?: 'whitelist_lp_contingent_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_contingent_id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type WhitelistMaxFields = {
  __typename?: 'whitelist_max_fields';
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  max_duration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "whitelist" */
export type WhitelistMaxOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WhitelistMinFields = {
  __typename?: 'whitelist_min_fields';
  company_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lot_id?: Maybe<Scalars['String']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  max_duration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "whitelist" */
export type WhitelistMinOrderBy = {
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "whitelist" */
export type WhitelistMutationResponse = {
  __typename?: 'whitelist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whitelist>;
};

/** input type for inserting object relation for remote table "whitelist" */
export type WhitelistObjRelInsertInput = {
  data: WhitelistInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WhitelistOnConflict>;
};

/** on_conflict condition type for table "whitelist" */
export type WhitelistOnConflict = {
  constraint: WhitelistConstraint;
  update_columns?: Array<WhitelistUpdateColumn>;
  where?: InputMaybe<WhitelistBoolExp>;
};

/** Ordering options when selecting data from "whitelist". */
export type WhitelistOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  company_id?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  lp_group?: InputMaybe<LpGroupOrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  reason_info?: InputMaybe<OrderBy>;
  rental_subscriptions_aggregate?: InputMaybe<RentalSubscriptionAggregateOrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  whitelist_calendar_event_policies_aggregate?: InputMaybe<WhitelistCalendarEventPolicyAggregateOrderBy>;
  whitelist_subscriptions_aggregate?: InputMaybe<WhitelistSubscriptionAggregateOrderBy>;
};

/** columns and relationships of "whitelist_paid_parking" */
export type WhitelistPaidParking = {
  __typename?: 'whitelist_paid_parking';
  country: EnumCountryCodeEnum;
  created_at: Scalars['timestamptz'];
  end_date: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  lot: Lot;
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  raw_plate?: Maybe<Scalars['String']>;
  scope: EnumWhitelistScopeEnum;
  start_date: Scalars['timestamptz'];
  status: EnumWhitelistStatusEnum;
  /** An object relationship */
  status_description: EnumWhitelistStatus;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "whitelist_paid_parking" */
export type WhitelistPaidParkingAggregate = {
  __typename?: 'whitelist_paid_parking_aggregate';
  aggregate?: Maybe<WhitelistPaidParkingAggregateFields>;
  nodes: Array<WhitelistPaidParking>;
};

/** aggregate fields of "whitelist_paid_parking" */
export type WhitelistPaidParkingAggregateFields = {
  __typename?: 'whitelist_paid_parking_aggregate_fields';
  avg?: Maybe<WhitelistPaidParkingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistPaidParkingMaxFields>;
  min?: Maybe<WhitelistPaidParkingMinFields>;
  stddev?: Maybe<WhitelistPaidParkingStddevFields>;
  stddev_pop?: Maybe<WhitelistPaidParkingStddevPopFields>;
  stddev_samp?: Maybe<WhitelistPaidParkingStddevSampFields>;
  sum?: Maybe<WhitelistPaidParkingSumFields>;
  var_pop?: Maybe<WhitelistPaidParkingVarPopFields>;
  var_samp?: Maybe<WhitelistPaidParkingVarSampFields>;
  variance?: Maybe<WhitelistPaidParkingVarianceFields>;
};


/** aggregate fields of "whitelist_paid_parking" */
export type WhitelistPaidParkingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistPaidParkingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WhitelistPaidParkingAvgFields = {
  __typename?: 'whitelist_paid_parking_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whitelist_paid_parking". All fields are combined with a logical 'AND'. */
export type WhitelistPaidParkingBoolExp = {
  _and?: InputMaybe<Array<WhitelistPaidParkingBoolExp>>;
  _not?: InputMaybe<WhitelistPaidParkingBoolExp>;
  _or?: InputMaybe<Array<WhitelistPaidParkingBoolExp>>;
  country?: InputMaybe<EnumCountryCodeEnumComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_date?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lot?: InputMaybe<LotBoolExp>;
  lot_id?: InputMaybe<StringComparisonExp>;
  plate?: InputMaybe<StringComparisonExp>;
  raw_plate?: InputMaybe<StringComparisonExp>;
  scope?: InputMaybe<EnumWhitelistScopeEnumComparisonExp>;
  start_date?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<EnumWhitelistStatusEnumComparisonExp>;
  status_description?: InputMaybe<EnumWhitelistStatusBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "whitelist_paid_parking" */
export enum WhitelistPaidParkingConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistPaidParkingPkey = 'whitelist_paid_parking_pkey'
}

/** input type for incrementing numeric columns in table "whitelist_paid_parking" */
export type WhitelistPaidParkingIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "whitelist_paid_parking" */
export type WhitelistPaidParkingInsertInput = {
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot?: InputMaybe<LotObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<EnumWhitelistScopeEnum>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EnumWhitelistStatusEnum>;
  status_description?: InputMaybe<EnumWhitelistStatusObjRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type WhitelistPaidParkingMaxFields = {
  __typename?: 'whitelist_paid_parking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type WhitelistPaidParkingMinFields = {
  __typename?: 'whitelist_paid_parking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  lot_id?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  raw_plate?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "whitelist_paid_parking" */
export type WhitelistPaidParkingMutationResponse = {
  __typename?: 'whitelist_paid_parking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WhitelistPaidParking>;
};

/** input type for inserting object relation for remote table "whitelist_paid_parking" */
export type WhitelistPaidParkingObjRelInsertInput = {
  data: WhitelistPaidParkingInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WhitelistPaidParkingOnConflict>;
};

/** on_conflict condition type for table "whitelist_paid_parking" */
export type WhitelistPaidParkingOnConflict = {
  constraint: WhitelistPaidParkingConstraint;
  update_columns?: Array<WhitelistPaidParkingUpdateColumn>;
  where?: InputMaybe<WhitelistPaidParkingBoolExp>;
};

/** Ordering options when selecting data from "whitelist_paid_parking". */
export type WhitelistPaidParkingOrderBy = {
  country?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_date?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lot?: InputMaybe<LotOrderBy>;
  lot_id?: InputMaybe<OrderBy>;
  plate?: InputMaybe<OrderBy>;
  raw_plate?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  start_date?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_description?: InputMaybe<EnumWhitelistStatusOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: whitelist_paid_parking */
export type WhitelistPaidParkingPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "whitelist_paid_parking" */
export enum WhitelistPaidParkingSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whitelist_paid_parking" */
export type WhitelistPaidParkingSetInput = {
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<EnumWhitelistScopeEnum>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EnumWhitelistStatusEnum>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type WhitelistPaidParkingStddevFields = {
  __typename?: 'whitelist_paid_parking_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WhitelistPaidParkingStddevPopFields = {
  __typename?: 'whitelist_paid_parking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WhitelistPaidParkingStddevSampFields = {
  __typename?: 'whitelist_paid_parking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whitelist_paid_parking" */
export type WhitelistPaidParkingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistPaidParkingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistPaidParkingStreamCursorValueInput = {
  country?: InputMaybe<EnumCountryCodeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<EnumWhitelistScopeEnum>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EnumWhitelistStatusEnum>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type WhitelistPaidParkingSumFields = {
  __typename?: 'whitelist_paid_parking_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "whitelist_paid_parking" */
export enum WhitelistPaidParkingUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Plate = 'plate',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type WhitelistPaidParkingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistPaidParkingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistPaidParkingSetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistPaidParkingBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistPaidParkingVarPopFields = {
  __typename?: 'whitelist_paid_parking_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WhitelistPaidParkingVarSampFields = {
  __typename?: 'whitelist_paid_parking_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WhitelistPaidParkingVarianceFields = {
  __typename?: 'whitelist_paid_parking_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: whitelist */
export type WhitelistPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WhitelistPrependInput = {
  reason_info?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "whitelist" */
export enum WhitelistSelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  MaxDuration = 'max_duration',
  /** column name */
  Name = 'name',
  /** column name */
  Plate = 'plate',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "whitelist" */
export type WhitelistSetInput = {
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  max_duration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type WhitelistStddevFields = {
  __typename?: 'whitelist_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "whitelist" */
export type WhitelistStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WhitelistStddevPopFields = {
  __typename?: 'whitelist_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "whitelist" */
export type WhitelistStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WhitelistStddevSampFields = {
  __typename?: 'whitelist_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "whitelist" */
export type WhitelistStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "whitelist" */
export type WhitelistStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistStreamCursorValueInput = {
  company_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lot_id?: InputMaybe<Scalars['String']>;
  lp_group_id?: InputMaybe<Scalars['bigint']>;
  max_duration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  raw_plate?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reason_info?: InputMaybe<Scalars['jsonb']>;
  scope?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "whitelist_subscription" */
export type WhitelistSubscription = {
  __typename?: 'whitelist_subscription';
  id: Scalars['Int'];
  subscriber: Scalars['jsonb'];
  /** An object relationship */
  whitelist: Whitelist;
  whitelist_id: Scalars['Int'];
};


/** columns and relationships of "whitelist_subscription" */
export type WhitelistSubscriptionSubscriberArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "whitelist_subscription" */
export type WhitelistSubscriptionAggregate = {
  __typename?: 'whitelist_subscription_aggregate';
  aggregate?: Maybe<WhitelistSubscriptionAggregateFields>;
  nodes: Array<WhitelistSubscription>;
};

export type WhitelistSubscriptionAggregateBoolExp = {
  count?: InputMaybe<WhitelistSubscriptionAggregateBoolExpCount>;
};

export type WhitelistSubscriptionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WhitelistSubscriptionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "whitelist_subscription" */
export type WhitelistSubscriptionAggregateFields = {
  __typename?: 'whitelist_subscription_aggregate_fields';
  avg?: Maybe<WhitelistSubscriptionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WhitelistSubscriptionMaxFields>;
  min?: Maybe<WhitelistSubscriptionMinFields>;
  stddev?: Maybe<WhitelistSubscriptionStddevFields>;
  stddev_pop?: Maybe<WhitelistSubscriptionStddevPopFields>;
  stddev_samp?: Maybe<WhitelistSubscriptionStddevSampFields>;
  sum?: Maybe<WhitelistSubscriptionSumFields>;
  var_pop?: Maybe<WhitelistSubscriptionVarPopFields>;
  var_samp?: Maybe<WhitelistSubscriptionVarSampFields>;
  variance?: Maybe<WhitelistSubscriptionVarianceFields>;
};


/** aggregate fields of "whitelist_subscription" */
export type WhitelistSubscriptionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WhitelistSubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "whitelist_subscription" */
export type WhitelistSubscriptionAggregateOrderBy = {
  avg?: InputMaybe<WhitelistSubscriptionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WhitelistSubscriptionMaxOrderBy>;
  min?: InputMaybe<WhitelistSubscriptionMinOrderBy>;
  stddev?: InputMaybe<WhitelistSubscriptionStddevOrderBy>;
  stddev_pop?: InputMaybe<WhitelistSubscriptionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WhitelistSubscriptionStddevSampOrderBy>;
  sum?: InputMaybe<WhitelistSubscriptionSumOrderBy>;
  var_pop?: InputMaybe<WhitelistSubscriptionVarPopOrderBy>;
  var_samp?: InputMaybe<WhitelistSubscriptionVarSampOrderBy>;
  variance?: InputMaybe<WhitelistSubscriptionVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WhitelistSubscriptionAppendInput = {
  subscriber?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "whitelist_subscription" */
export type WhitelistSubscriptionArrRelInsertInput = {
  data: Array<WhitelistSubscriptionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WhitelistSubscriptionOnConflict>;
};

/** aggregate avg on columns */
export type WhitelistSubscriptionAvgFields = {
  __typename?: 'whitelist_subscription_avg_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "whitelist_subscription". All fields are combined with a logical 'AND'. */
export type WhitelistSubscriptionBoolExp = {
  _and?: InputMaybe<Array<WhitelistSubscriptionBoolExp>>;
  _not?: InputMaybe<WhitelistSubscriptionBoolExp>;
  _or?: InputMaybe<Array<WhitelistSubscriptionBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  subscriber?: InputMaybe<JsonbComparisonExp>;
  whitelist?: InputMaybe<WhitelistBoolExp>;
  whitelist_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "whitelist_subscription" */
export enum WhitelistSubscriptionConstraint {
  /** unique or primary key constraint on columns "id" */
  WhitelistSubscriptionPkey = 'whitelist_subscription_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WhitelistSubscriptionDeleteAtPathInput = {
  subscriber?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WhitelistSubscriptionDeleteElemInput = {
  subscriber?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WhitelistSubscriptionDeleteKeyInput = {
  subscriber?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "whitelist_subscription" */
export type WhitelistSubscriptionIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whitelist_subscription" */
export type WhitelistSubscriptionInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  subscriber?: InputMaybe<Scalars['jsonb']>;
  whitelist?: InputMaybe<WhitelistObjRelInsertInput>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type WhitelistSubscriptionMaxFields = {
  __typename?: 'whitelist_subscription_max_fields';
  id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WhitelistSubscriptionMinFields = {
  __typename?: 'whitelist_subscription_min_fields';
  id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "whitelist_subscription" */
export type WhitelistSubscriptionMutationResponse = {
  __typename?: 'whitelist_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WhitelistSubscription>;
};

/** on_conflict condition type for table "whitelist_subscription" */
export type WhitelistSubscriptionOnConflict = {
  constraint: WhitelistSubscriptionConstraint;
  update_columns?: Array<WhitelistSubscriptionUpdateColumn>;
  where?: InputMaybe<WhitelistSubscriptionBoolExp>;
};

/** Ordering options when selecting data from "whitelist_subscription". */
export type WhitelistSubscriptionOrderBy = {
  id?: InputMaybe<OrderBy>;
  subscriber?: InputMaybe<OrderBy>;
  whitelist?: InputMaybe<WhitelistOrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: whitelist_subscription */
export type WhitelistSubscriptionPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WhitelistSubscriptionPrependInput = {
  subscriber?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "whitelist_subscription" */
export enum WhitelistSubscriptionSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Subscriber = 'subscriber',
  /** column name */
  WhitelistId = 'whitelist_id'
}

/** input type for updating data in table "whitelist_subscription" */
export type WhitelistSubscriptionSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  subscriber?: InputMaybe<Scalars['jsonb']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type WhitelistSubscriptionStddevFields = {
  __typename?: 'whitelist_subscription_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WhitelistSubscriptionStddevPopFields = {
  __typename?: 'whitelist_subscription_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WhitelistSubscriptionStddevSampFields = {
  __typename?: 'whitelist_subscription_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "whitelist_subscription" */
export type WhitelistSubscriptionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WhitelistSubscriptionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WhitelistSubscriptionStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  subscriber?: InputMaybe<Scalars['jsonb']>;
  whitelist_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type WhitelistSubscriptionSumFields = {
  __typename?: 'whitelist_subscription_sum_fields';
  id?: Maybe<Scalars['Int']>;
  whitelist_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** update columns of table "whitelist_subscription" */
export enum WhitelistSubscriptionUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Subscriber = 'subscriber',
  /** column name */
  WhitelistId = 'whitelist_id'
}

export type WhitelistSubscriptionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WhitelistSubscriptionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WhitelistSubscriptionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WhitelistSubscriptionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WhitelistSubscriptionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistSubscriptionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WhitelistSubscriptionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistSubscriptionSetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistSubscriptionBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistSubscriptionVarPopFields = {
  __typename?: 'whitelist_subscription_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WhitelistSubscriptionVarSampFields = {
  __typename?: 'whitelist_subscription_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WhitelistSubscriptionVarianceFields = {
  __typename?: 'whitelist_subscription_variance_fields';
  id?: Maybe<Scalars['Float']>;
  whitelist_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "whitelist_subscription" */
export type WhitelistSubscriptionVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  whitelist_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type WhitelistSumFields = {
  __typename?: 'whitelist_sum_fields';
  id?: Maybe<Scalars['Int']>;
  lp_group_id?: Maybe<Scalars['bigint']>;
  max_duration?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "whitelist" */
export type WhitelistSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** update columns of table "whitelist" */
export enum WhitelistUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  LpGroupId = 'lp_group_id',
  /** column name */
  MaxDuration = 'max_duration',
  /** column name */
  Name = 'name',
  /** column name */
  Plate = 'plate',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  RawPlate = 'raw_plate',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonInfo = 'reason_info',
  /** column name */
  Scope = 'scope',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type WhitelistUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WhitelistAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WhitelistDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WhitelistDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WhitelistDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WhitelistIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WhitelistPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WhitelistSetInput>;
  /** filter the rows which have to be updated */
  where: WhitelistBoolExp;
};

/** aggregate var_pop on columns */
export type WhitelistVarPopFields = {
  __typename?: 'whitelist_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "whitelist" */
export type WhitelistVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WhitelistVarSampFields = {
  __typename?: 'whitelist_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "whitelist" */
export type WhitelistVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WhitelistVarianceFields = {
  __typename?: 'whitelist_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lp_group_id?: Maybe<Scalars['Float']>;
  max_duration?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "whitelist" */
export type WhitelistVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  lp_group_id?: InputMaybe<OrderBy>;
  max_duration?: InputMaybe<OrderBy>;
};

/** columns and relationships of "wireguard_config" */
export type WireguardConfig = {
  __typename?: 'wireguard_config';
  comment?: Maybe<Scalars['String']>;
  /** An object relationship */
  device?: Maybe<Device>;
  device_uuid?: Maybe<Scalars['String']>;
  ip: Scalars['String'];
  private_key?: Maybe<Scalars['String']>;
  public_key: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "wireguard_config" */
export type WireguardConfigAggregate = {
  __typename?: 'wireguard_config_aggregate';
  aggregate?: Maybe<WireguardConfigAggregateFields>;
  nodes: Array<WireguardConfig>;
};

/** aggregate fields of "wireguard_config" */
export type WireguardConfigAggregateFields = {
  __typename?: 'wireguard_config_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<WireguardConfigMaxFields>;
  min?: Maybe<WireguardConfigMinFields>;
};


/** aggregate fields of "wireguard_config" */
export type WireguardConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WireguardConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "wireguard_config". All fields are combined with a logical 'AND'. */
export type WireguardConfigBoolExp = {
  _and?: InputMaybe<Array<WireguardConfigBoolExp>>;
  _not?: InputMaybe<WireguardConfigBoolExp>;
  _or?: InputMaybe<Array<WireguardConfigBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  device_uuid?: InputMaybe<StringComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  private_key?: InputMaybe<StringComparisonExp>;
  public_key?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "wireguard_config" */
export enum WireguardConfigConstraint {
  /** unique or primary key constraint on columns "ip" */
  WireguardConfigIpKey = 'wireguard_config_ip_key',
  /** unique or primary key constraint on columns "public_key" */
  WireguardConfigPkey = 'wireguard_config_pkey'
}

/** input type for inserting data into table "wireguard_config" */
export type WireguardConfigInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  device_uuid?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  private_key?: InputMaybe<Scalars['String']>;
  public_key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WireguardConfigMaxFields = {
  __typename?: 'wireguard_config_max_fields';
  comment?: Maybe<Scalars['String']>;
  device_uuid?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  private_key?: Maybe<Scalars['String']>;
  public_key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WireguardConfigMinFields = {
  __typename?: 'wireguard_config_min_fields';
  comment?: Maybe<Scalars['String']>;
  device_uuid?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  private_key?: Maybe<Scalars['String']>;
  public_key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "wireguard_config" */
export type WireguardConfigMutationResponse = {
  __typename?: 'wireguard_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WireguardConfig>;
};

/** on_conflict condition type for table "wireguard_config" */
export type WireguardConfigOnConflict = {
  constraint: WireguardConfigConstraint;
  update_columns?: Array<WireguardConfigUpdateColumn>;
  where?: InputMaybe<WireguardConfigBoolExp>;
};

/** Ordering options when selecting data from "wireguard_config". */
export type WireguardConfigOrderBy = {
  comment?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  device_uuid?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  private_key?: InputMaybe<OrderBy>;
  public_key?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: wireguard_config */
export type WireguardConfigPkColumnsInput = {
  public_key: Scalars['String'];
};

/** select columns of table "wireguard_config" */
export enum WireguardConfigSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Ip = 'ip',
  /** column name */
  PrivateKey = 'private_key',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "wireguard_config" */
export type WireguardConfigSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  private_key?: InputMaybe<Scalars['String']>;
  public_key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "wireguard_config" */
export type WireguardConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WireguardConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WireguardConfigStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  private_key?: InputMaybe<Scalars['String']>;
  public_key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "wireguard_config" */
export enum WireguardConfigUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  DeviceUuid = 'device_uuid',
  /** column name */
  Ip = 'ip',
  /** column name */
  PrivateKey = 'private_key',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  Type = 'type'
}

export type WireguardConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WireguardConfigSetInput>;
  /** filter the rows which have to be updated */
  where: WireguardConfigBoolExp;
};

export type WriteOffViolationCaseApiOutput = {
  __typename?: 'writeOffViolationCaseAPIOutput';
  message: Scalars['String'];
  not_written_off?: Maybe<Array<Maybe<SummaryNotWrittenOff>>>;
  written_off?: Maybe<Array<Scalars['Int']>>;
};

export type GetAccessControlPinQueryVariables = Exact<{
  plate: Scalars['String'];
  site_id: Scalars['String'];
}>;


export type GetAccessControlPinQuery = { __typename?: 'query_root', carpay_access_control_get_pin: { __typename?: 'AccessControlGetPinResponse', pin?: string | null, valid_until?: string | null } };

export type SendAccessControlSmsPinQueryVariables = Exact<{
  plate: Scalars['String'];
  site_id: Scalars['String'];
  phone_number: Scalars['String'];
}>;


export type SendAccessControlSmsPinQuery = { __typename?: 'query_root', carpay_access_control_send_pin_sms: { __typename?: 'AccessControlSendPinSmsResponse', sent: boolean } };

export type PaidParkingCarpayInsertOrderMutationVariables = Exact<{
  order_id: Scalars['String'];
  plate: Scalars['String'];
  country: Scalars['String'];
  lot_id: Scalars['String'];
  price_valid_until: Scalars['String'];
  start_date: Scalars['String'];
  end_date: Scalars['String'];
  price: Scalars['Float'];
  invoice_id: Scalars['String'];
  original_price: Scalars['Float'];
  currency: Scalars['String'];
  vat_rate: Scalars['Float'];
  carpay_scanned_codes: Array<TerminalScannedCodeV2> | TerminalScannedCodeV2;
  terminal_id: Scalars['Int'];
  payment: TerminalPayment;
  errorflow: Scalars['Boolean'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  price_valid_from?: InputMaybe<Scalars['String']>;
}>;


export type PaidParkingCarpayInsertOrderMutation = { __typename?: 'mutation_root', carpay_terminal_confirm_order_v2: { __typename?: 'TerminalConfirmOrderResult', message: string } };

export type PaidParkingCarpaySendTerminalNotificationMutationVariables = Exact<{
  lot_id: Scalars['String'];
  terminal_id: Scalars['Int'];
  timestamp_in_lot_tz: Scalars['timestamptz'];
  event_type: TerminalNotificationEventType;
  data: Scalars['jsonb'];
}>;


export type PaidParkingCarpaySendTerminalNotificationMutation = { __typename?: 'mutation_root', carpay_create_terminal_notification?: { __typename?: 'CarpayCreateTerminalNotificationResponse', success: boolean } | null };

export type GetLegalStatusQueryVariables = Exact<{
  plate: Scalars['String'];
  country: Scalars['String'];
  lot_id: Scalars['String'];
  start: Scalars['String'];
  end: Scalars['String'];
}>;


export type GetLegalStatusQuery = { __typename?: 'query_root', carpay_terminal_get_legal_status: { __typename?: 'CarpayLegalStatusResult', billable_start: string, billable_end: string, billable: boolean, legal_timeranges: Array<{ __typename?: 'CarpayLegalStatusTimerange', start: string, end: string, type: string }>, illegal_timeranges: Array<{ __typename?: 'CarpayLegalStatusTimerange', start: string, end: string, type: string }> } };

export type LotFragment = { __typename?: 'lot', id: string, name: string, address: string, country?: string | null, legal_language: string, tax?: { __typename?: 'tax', vat_rates: any } | null, country_object?: { __typename?: 'country', currency: { __typename?: 'currency', iso_code: string, iso_num: number } } | null, carpay_lot?: { __typename?: 'carpay_lot', policy: any, carpay_terminal_notification_config?: { __typename?: 'carpay_terminal_notification_config', max_cash: number } | null } | null } & { ' $fragmentName'?: 'LotFragment' };

export type LotLegalEntityFragment = { __typename?: 'lot_legal_entity', company_vat_id: { __typename?: 'company_vat_id', vat_id: string, company: { __typename?: 'company', address: string, name: string } } } & { ' $fragmentName'?: 'LotLegalEntityFragment' };

export type LotContextPoliciesFragment = { __typename?: 'parking_context', definition: any, uuid: string } & { ' $fragmentName'?: 'LotContextPoliciesFragment' };

export type LotSectionFragment = { __typename?: 'lot_section', policy?: any | null } & { ' $fragmentName'?: 'LotSectionFragment' };

export type LotInformationQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type LotInformationQuery = { __typename?: 'query_root', lot: Array<(
    { __typename?: 'lot' }
    & { ' $fragmentRefs'?: { 'LotFragment': LotFragment } }
  )>, lot_legal_entity: Array<(
    { __typename?: 'lot_legal_entity' }
    & { ' $fragmentRefs'?: { 'LotLegalEntityFragment': LotLegalEntityFragment } }
  )>, parking_context: Array<(
    { __typename?: 'parking_context' }
    & { ' $fragmentRefs'?: { 'LotContextPoliciesFragment': LotContextPoliciesFragment } }
  )>, lot_section: Array<(
    { __typename?: 'lot_section' }
    & { ' $fragmentRefs'?: { 'LotSectionFragment': LotSectionFragment } }
  )> };

export type GetCarpayOrdersQueryVariables = Exact<{
  lot_id?: InputMaybe<Scalars['String']>;
  plate?: InputMaybe<Scalars['String']>;
  lot_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  include_paid?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCarpayOrdersQuery = { __typename?: 'query_root', carpay_terminal_get_orders_v2: Array<{ __typename?: 'CarpayTerminalOrderResultV2', order_id: string, lot_id: string, plate: string, start_date: string, end_date?: string | null, drive_in_timestamp?: string | null, drive_out_timestamp?: string | null, status: string, price?: number | null, price_valid_until?: string | null, invoice_id?: string | null, country: string, whitelist_id?: number | null, legal_status?: { __typename?: 'CarpayTerminalLegalStatus', legal_timeranges: Array<{ __typename?: 'CarpayLegalStatusTimerange', start: string, end: string, type: string }>, illegal_timeranges: Array<{ __typename?: 'CarpayLegalStatusTimerange', start: string, end: string, type: string }> } | null, payment: { __typename?: 'CarpayTerminalPaymentResultV2', paid_amount?: number | null, timestamp?: string | null }, carpay_scanned_codes: Array<{ __typename?: 'CarpayTerminalScannedCodeResultV2', code: string, value: number, extractor_result: any, carpay_discount_model_id: number, carpay_discount_batch_id?: number | null, original_value?: any | null }> }> };

export type SiblingLotInfoQueryVariables = Exact<{
  lot_ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type SiblingLotInfoQuery = { __typename?: 'query_root', lot: Array<{ __typename?: 'lot', id: string, name: string }> };

export type SendInvoiceQueryVariables = Exact<{
  customer_email: Scalars['String'];
  carpay_order_order_id: Scalars['String'];
}>;


export type SendInvoiceQuery = { __typename?: 'query_root', send_invoice?: { __typename?: 'SendInvoiceOutput', sent: boolean } | null };

export type GetDeviceUuidsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeviceUuidsQuery = { __typename?: 'query_root', device: Array<{ __typename?: 'device', uuid: string, device_name?: string | null }> };

export type GetDeviceDataQueryVariables = Exact<{
  device_uuid: Scalars['String'];
}>;


export type GetDeviceDataQuery = { __typename?: 'query_root', device: Array<{ __typename?: 'device', uuid: string, device_name?: string | null, config_error?: string | null, config_force_update: boolean, config_current_timestamp?: string | null, config_target_timestamp?: string | null, config?: any | null }> };

export type UpdateDeviceConfigMutationVariables = Exact<{
  device_uuid: Scalars['String'];
  diff_config: Scalars['json'];
  timestamp: Scalars['String'];
}>;


export type UpdateDeviceConfigMutation = { __typename?: 'mutation_root', update_device_config_mutation?: { __typename?: 'UpdateDeviceOutput', message: string } | null };

export type SetDeviceForceUpdateMutationVariables = Exact<{
  device_uuid: Scalars['String'];
}>;


export type SetDeviceForceUpdateMutation = { __typename?: 'mutation_root', set_device_force_update_mutation?: { __typename?: 'UpdateDeviceOutput', message: string } | null };

export type SearchDeviceConfigQueryVariables = Exact<{
  path: Array<Scalars['String']> | Scalars['String'];
  value: Scalars['String'];
}>;


export type SearchDeviceConfigQuery = { __typename?: 'query_root', get_devices_by_config?: { __typename?: 'DevicesByConfigOutput', matching_devices: Array<{ __typename?: 'DeviceByConfig', device_name: string, device_uuid: string, general_config: any }>, non_matching_devices: Array<{ __typename?: 'DeviceByConfig', device_name: string, device_uuid: string, general_config: any }> } | null };

export type GetSmsStatusQueryVariables = Exact<{
  device_uuid: Scalars['String'];
}>;


export type GetSmsStatusQuery = { __typename?: 'query_root', get_sms_status: Array<{ __typename?: 'SMSStatusOutput', date: string, content: string, delivery_status: string }> };

export type SendSmsCommandMutationVariables = Exact<{
  device_uuid: Scalars['String'];
  command: Scalars['String'];
}>;


export type SendSmsCommandMutation = { __typename?: 'mutation_root', send_sms_command?: { __typename?: 'SMSCommandOutput', message: string } | null };

export type GetDevicesForLotQueryVariables = Exact<{
  parking_lot: Scalars['String'];
}>;


export type GetDevicesForLotQuery = { __typename?: 'query_root', station: Array<{ __typename?: 'station', station_name: string, device_uuid?: string | null }> };

export type CreateLotAnalysisRequestQueryVariables = Exact<{
  parking_lot: Scalars['String'];
}>;


export type CreateLotAnalysisRequestQuery = { __typename?: 'query_root', create_lot_analysis_request?: { __typename?: 'CreateLotAnalysisRequestOutput', request_entry_id: string, message: string } | null };

export type GetLaResultQueryVariables = Exact<{
  request_entry_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetLaResultQuery = { __typename?: 'query_root', serverless_async_work: Array<{ __typename?: 'serverless_async_work', result?: any | null, status: string }> };

export type GetParkingLotNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParkingLotNamesQuery = { __typename?: 'query_root', lot_section: Array<{ __typename?: 'lot_section', id: string }> };

export type GetLotSectionNamesByParkingLotQueryVariables = Exact<{
  selected_lot_id: Scalars['String'];
}>;


export type GetLotSectionNamesByParkingLotQuery = { __typename?: 'query_root', lot_section: Array<{ __typename?: 'lot_section', id: string }> };

export type GetLotIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotIdsQuery = { __typename?: 'query_root', lot: Array<{ __typename?: 'lot', id: string }> };

export type GetLotSectionDataQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type GetLotSectionDataQuery = { __typename?: 'query_root', lot_section: Array<{ __typename?: 'lot_section', id: string, lot_id: string, section_id: number }> };

export type GetStationByParkingLotQueryVariables = Exact<{
  lot_section_id: Scalars['String'];
}>;


export type GetStationByParkingLotQuery = { __typename?: 'query_root', station: Array<{ __typename?: 'station', device_uuid?: string | null, station_name: string, lot_section_id?: string | null, device_direction?: string | null, config?: any | null, config_timestamp?: string | null, device?: { __typename?: 'device', uuid: string, config?: any | null, config_target_timestamp?: string | null, device_name?: string | null } | null }> };

export type GetPotentialMlPsQueryVariables = Exact<{
  lower_timestamp_threshold: Scalars['timestamptz'];
}>;


export type GetPotentialMlPsQuery = { __typename?: 'query_root', get_potential_mlps?: { __typename?: 'GetPotentialMLPsOutput', potential_mlps: Array<any | null>, latest_timestamp?: string | null } | null };

export type PushCheckedMlPsMutationVariables = Exact<{
  checkedMlps: Scalars['jsonb'];
}>;


export type PushCheckedMlPsMutation = { __typename?: 'mutation_root', push_checked_mlps?: { __typename?: 'PushCheckedMLPsOutput', message: string } | null };

export type GetDeviceDashboardUrlQueryVariables = Exact<{
  dashboardId: Scalars['Int'];
  params: Scalars['jsonb'];
}>;


export type GetDeviceDashboardUrlQuery = { __typename?: 'query_root', get_device_dashboard_url?: { __typename?: 'GetMetabaseDashboardUrlOutput', metabase_url: string } | null };

export type GetBalenaDeviceQueryVariables = Exact<{
  device_uuid: Scalars['String'];
}>;


export type GetBalenaDeviceQuery = { __typename?: 'query_root', get_balena_device?: { __typename?: 'BalenaDeviceOutput', devices: any } | null };

export type GetBalenaReleaseQueryVariables = Exact<{
  release_id: Scalars['String'];
}>;


export type GetBalenaReleaseQuery = { __typename?: 'query_root', get_balena_release?: { __typename?: 'BalenaReleaseOutput', releases: any } | null };

export type GetStationNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStationNamesQuery = { __typename?: 'query_root', station: Array<{ __typename?: 'station', station_name: string }> };

export type GetStationDataByNameQueryVariables = Exact<{
  station_name: Scalars['String'];
}>;


export type GetStationDataByNameQuery = { __typename?: 'query_root', station: Array<{ __typename?: 'station', station_name: string, lot_section_id?: string | null, device_uuid?: string | null, config_timestamp?: string | null, config?: any | null, device_direction?: string | null }> };

export type UpdateStationConfigQueryVariables = Exact<{
  station_name: Scalars['String'];
  config: Scalars['json'];
  timestamp: Scalars['String'];
}>;


export type UpdateStationConfigQuery = { __typename?: 'query_root', update_station_config?: { __typename?: 'UpdateStationOutput', message: string } | null };

export type UpdateStationDataQueryVariables = Exact<{
  station_name: Scalars['String'];
  lot_section_id: Scalars['String'];
  device_uuid: Scalars['String'];
  device_direction: Scalars['String'];
}>;


export type UpdateStationDataQuery = { __typename?: 'query_root', update_station_data?: { __typename?: 'UpdateDeviceOutput', message: string } | null };

export type DeleteStationMutationVariables = Exact<{
  station_name: Scalars['String'];
}>;


export type DeleteStationMutation = { __typename?: 'mutation_root', delete_station?: { __typename?: 'station_mutation_response', affected_rows: number } | null };

export type GetStationByDeviceIdQueryVariables = Exact<{
  device_uuid: Scalars['String'];
}>;


export type GetStationByDeviceIdQuery = { __typename?: 'query_root', station: Array<{ __typename?: 'station', station_name: string }> };

export type UpdateStationDataMutationMutationVariables = Exact<{
  station_name: Scalars['String'];
  lot_section_id?: InputMaybe<Scalars['String']>;
  device_uuid?: InputMaybe<Scalars['String']>;
  device_direction: Scalars['String'];
}>;


export type UpdateStationDataMutationMutation = { __typename?: 'mutation_root', update_station_data_mutation?: { __typename?: 'UpdateDeviceOutput', message: string } | null };

export type UpdateStationConfigMutationMutationVariables = Exact<{
  station_name: Scalars['String'];
  config: Scalars['json'];
  timestamp: Scalars['String'];
}>;


export type UpdateStationConfigMutationMutation = { __typename?: 'mutation_root', update_station_config_mutation?: { __typename?: 'UpdateStationOutput', message: string } | null };

export type GetDeviceSystemImageQueryVariables = Exact<{
  device_uuid: Scalars['String'];
  latest: Scalars['Boolean'];
  roi_image?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDeviceSystemImageQuery = { __typename?: 'query_root', get_system_image?: { __typename?: 'SystemImageOutput', signed_url: string, timestamp: string } | null };

export type CreateErrorRatePredictionRequestQueryVariables = Exact<{
  parking_lot: Scalars['String'];
  station_name: Scalars['String'];
  initial_filters?: InputMaybe<Scalars['jsonb']>;
  modified_filters?: InputMaybe<Scalars['jsonb']>;
}>;


export type CreateErrorRatePredictionRequestQuery = { __typename?: 'query_root', create_error_rate_prediction_request?: { __typename?: 'CreateErrorRatePredictionRequestOutput', request_entry_id: string } | null };

export type GetErrorPredictionResultQueryVariables = Exact<{
  request_entry_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetErrorPredictionResultQuery = { __typename?: 'query_root', serverless_async_work: Array<{ __typename?: 'serverless_async_work', result?: any | null, status: string }> };

export type GetCoordinateParkingDetectionsQueryVariables = Exact<{
  device_uuid: Scalars['String'];
  direction: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  limit: Scalars['Int'];
  missing_lp: Scalars['Boolean'];
  parking_lot: Scalars['String'];
}>;


export type GetCoordinateParkingDetectionsQuery = { __typename?: 'query_root', parking_detections: Array<{ __typename?: 'parking_detections', missing_lp?: boolean | null, coordinates?: string | null, device_uuid?: string | null }> };

export type B2CApplyCarpayVoucherMutationVariables = Exact<{
  order_id: Scalars['String'];
  code: Scalars['String'];
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['String']>;
}>;


export type B2CApplyCarpayVoucherMutation = { __typename?: 'mutation_root', b2c_apply_discount: (
    { __typename?: 'B2CCarpayOrderView' }
    & { ' $fragmentRefs'?: { 'B2COrderResponseFragment': B2COrderResponseFragment } }
  ) };

export type BookingCancelUserSubscriptionMutationVariables = Exact<{
  subscription_id: Scalars['String'];
  reason: Scalars['String'];
}>;


export type BookingCancelUserSubscriptionMutation = { __typename?: 'mutation_root', booking_cancel_user_subscription: { __typename?: 'BookingCancelUserSubscriptionResponse', success: boolean } };

export type BookingCreateBookingMutationVariables = Exact<{
  email: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate> | InputBookingPlate>;
  start_datetime: Scalars['timestamptz'];
  total_amount: Scalars['numeric'];
  shopper_locale: Scalars['String'];
}>;


export type BookingCreateBookingMutation = { __typename?: 'mutation_root', booking_create_booking?: { __typename?: 'BookingCreateBookingResponse', id?: number | null, booking_reference?: string | null, success: boolean, unavailable_dates?: Array<string | null> | null } | null };

export type BookingCreateBookingHourlyMutationVariables = Exact<{
  email: Scalars['String'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate> | InputBookingPlate>;
  duration_hours: Scalars['Int'];
  total_amount: Scalars['numeric'];
  shopper_locale: Scalars['String'];
}>;


export type BookingCreateBookingHourlyMutation = { __typename?: 'mutation_root', booking_create_booking_hourly?: { __typename?: 'BookingCreateBookingResponse', id?: number | null, booking_reference?: string | null, success: boolean, unavailable_dates?: Array<string | null> | null } | null };

export type BookingCreateBookingNightlyMutationVariables = Exact<{
  email: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate> | InputBookingPlate>;
  lot_id: Scalars['String'];
  total_amount: Scalars['numeric'];
  shopper_locale: Scalars['String'];
  start_datetime: Scalars['timestamptz'];
  end_datetime: Scalars['timestamptz'];
  night_parking_config: Array<InputMaybe<NightParkingConfig>> | InputMaybe<NightParkingConfig>;
}>;


export type BookingCreateBookingNightlyMutation = { __typename?: 'mutation_root', create_night_parking_booking?: { __typename?: 'BookingCreateBookingResponse', id?: number | null, booking_reference?: string | null, success: boolean, unavailable_dates?: Array<string | null> | null } | null };

export type B2cSavePaymentMethodMutationVariables = Exact<{
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  top_level_domain: Scalars['String'];
}>;


export type B2cSavePaymentMethodMutation = { __typename?: 'mutation_root', b2c_save_payment_method: { __typename?: 'B2CSavePaymentMethodResponse', session_data: string, session_id: string } };

export type BookingCreateSubsSessionMutationVariables = Exact<{
  lot_id: Scalars['String'];
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  start_date: Scalars['String'];
  top_level_domain?: InputMaybe<Scalars['String']>;
  license_plate_id?: InputMaybe<Scalars['String']>;
}>;


export type BookingCreateSubsSessionMutation = { __typename?: 'mutation_root', booking_create_subs_session: { __typename?: 'BookingCreateAdyenSessionResponse', session_data: string, session_id: string } };

export type BookingCreateUserMutationVariables = Exact<{
  request: CreateBookingUserRequest;
}>;


export type BookingCreateUserMutation = { __typename?: 'mutation_root', booking_create_user?: { __typename?: 'CreateBookingUserResponse', success: boolean } | null };

export type BookingCreateUserBookingMutationVariables = Exact<{
  email: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate> | InputBookingPlate>;
  start_datetime: Scalars['timestamptz'];
  total_amount: Scalars['numeric'];
  shopper_locale: Scalars['String'];
  pricing_type: BookingPricingModelType;
}>;


export type BookingCreateUserBookingMutation = { __typename?: 'mutation_root', booking_create_user_booking?: { __typename?: 'BookingCreateBookingResponse', id?: number | null, booking_reference?: string | null, success: boolean, unavailable_dates?: Array<string | null> | null } | null };

export type BookingCreateUserBookingHourlyMutationVariables = Exact<{
  email: Scalars['String'];
  lot_id: Scalars['String'];
  plates?: InputMaybe<Array<InputBookingPlate> | InputBookingPlate>;
  duration_hours: Scalars['Int'];
  total_amount: Scalars['numeric'];
  shopper_locale: Scalars['String'];
  pricing_type: BookingPricingModelType;
}>;


export type BookingCreateUserBookingHourlyMutation = { __typename?: 'mutation_root', booking_create_user_booking_hourly?: { __typename?: 'BookingCreateBookingResponse', id?: number | null, booking_reference?: string | null, success: boolean, unavailable_dates?: Array<string | null> | null } | null };

export type CreateUserLicensePlateMutationVariables = Exact<{
  request: CreateUserLicensePlateRequest;
}>;


export type CreateUserLicensePlateMutation = { __typename?: 'mutation_root', create_user_license_plate?: { __typename?: 'CreateUserLicensePlateResponse', id: string } | null };

export type CreateUserVehicleMutationVariables = Exact<{
  request: CreateUserVehicleRequest;
}>;


export type CreateUserVehicleMutation = { __typename?: 'mutation_root', create_user_vehicle?: { __typename?: 'CreateUserVehicleResponse', id: string } | null };

export type B2cDeletePaymentMethodMutationVariables = Exact<{
  payment_method_id: Scalars['String'];
}>;


export type B2cDeletePaymentMethodMutation = { __typename?: 'mutation_root', b2c_delete_payment_method: { __typename?: 'B2CDeletePaymentMethodResponse', success: boolean } };

export type DeleteUserLicensePlateMutationVariables = Exact<{
  request: DeleteUserLicensePlateRequest;
}>;


export type DeleteUserLicensePlateMutation = { __typename?: 'mutation_root', delete_user_license_plate?: { __typename?: 'DeleteUserLicensePlateResponse', success: boolean } | null };

export type DeleteUserVehicleMutationVariables = Exact<{
  request: DeleteUserVehicleRequest;
}>;


export type DeleteUserVehicleMutation = { __typename?: 'mutation_root', delete_user_vehicle?: { __typename?: 'DeleteUserVehicleResponse', success: boolean } | null };

export type BookingUpdateUserMutationVariables = Exact<{
  request: UpdateBookingUserRequest;
}>;


export type BookingUpdateUserMutation = { __typename?: 'mutation_root', booking_update_user?: { __typename?: 'UpdateBookingUserResponse', success: boolean } | null };

export type UpdateUserLicensePlateMutationVariables = Exact<{
  request: UpdateUserLicensePlateRequest;
}>;


export type UpdateUserLicensePlateMutation = { __typename?: 'mutation_root', update_user_license_plate?: { __typename?: 'UpdateUserLicensePlateResponse', success: boolean } | null };

export type UpdateUserVehicleMutationVariables = Exact<{
  request: UpdateUserVehicleRequest;
}>;


export type UpdateUserVehicleMutation = { __typename?: 'mutation_root', update_user_vehicle?: { __typename?: 'UpdateUserVehicleResponse', success: boolean } | null };

export type BookingGetPublicLotsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingGetPublicLotsQuery = { __typename?: 'query_root', booking_get_public_lots?: { __typename?: 'BookingGetPublicLotsResponse', lots: Array<any | null> } | null };

export type B2CGetCheckoutSessionQueryVariables = Exact<{
  order_id: Scalars['String'];
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type B2CGetCheckoutSessionQuery = { __typename?: 'query_root', b2c_checkout: { __typename?: 'B2CAdyenCheckoutResponse', adyen_id: string, adyen_session_data: string } };

export type B2CGetErrorFlowCheckoutSessionQueryVariables = Exact<{
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  country: Scalars['String'];
  start_date: Scalars['timestamptz'];
  end_date?: InputMaybe<Scalars['timestamptz']>;
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type B2CGetErrorFlowCheckoutSessionQuery = { __typename?: 'query_root', b2c_errorflow_checkout: { __typename?: 'B2CAdyenCheckoutResponse', adyen_id: string, adyen_session_data: string } };

export type GetErrorflowPriceQueryVariables = Exact<{
  lot_id: Scalars['String'];
  plate: Scalars['String'];
  country: Scalars['String'];
  start_date: Scalars['timestamptz'];
  end_date?: InputMaybe<Scalars['timestamptz']>;
  selected_parking_tariff?: InputMaybe<Scalars['String']>;
  parking_context_uuid?: InputMaybe<Scalars['String']>;
}>;


export type GetErrorflowPriceQuery = { __typename?: 'query_root', b2c_get_errorflow_price: { __typename?: 'B2CCarpayOrderView', scanned_codes: Array<string>, order: { __typename?: 'B2CCarpayOrderInfo', order_id: string, plate: string, start_date: string, end_date?: string | null, status: string, invoice_available: boolean }, price: { __typename?: 'B2CCarpayPriceInfo', currency: string, vat_rate: number, price_valid_until: string, parking_price: number, illegal_parking_price: number, discounted_parking_price: number, applied_discount: number, billable: boolean, billable_start: string, billable_end: string, payment_deadline?: string | null }, lot: { __typename?: 'B2CCarpayLotInfo', lot_id: string, name: string, address: string, lot_type: LotType, lot_tariffs: Array<string>, sv_lot_type: SvLotType, discount_types: Array<DiscountType>, visible_toleration_time?: number | null, arrival_detection_time?: number | null, longitude?: number | null, latitude?: number | null }, parking_contexts: Array<{ __typename?: 'OrderParkingContext', uuid: string, vehicle_type?: string | null }> } };

export type B2CGetLotByIdQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type B2CGetLotByIdQuery = { __typename?: 'query_root', b2c_get_carpay_lot: { __typename?: 'B2CCarpayLotExtendedInfo', lot: { __typename?: 'B2CCarpayLotInfo', lot_id: string, name: string, address: string, lot_type: LotType, lot_tariffs: Array<string>, sv_lot_type: SvLotType, discount_types: Array<DiscountType>, longitude?: number | null, latitude?: number | null }, parking_contexts: Array<{ __typename?: 'OrderParkingContext', uuid: string, vehicle_type?: string | null }> } };

export type B2cGetCarpayLotsQueryVariables = Exact<{ [key: string]: never; }>;


export type B2cGetCarpayLotsQuery = { __typename?: 'query_root', b2c_get_carpay_lots: { __typename?: 'B2CCarpayLots', lots: Array<{ __typename?: 'B2CCarpayLotShortInfo', lot_id: string, name: string, address: string, longitude?: number | null, latitude?: number | null }> } };

export type BookingCreateAdyenSessionQueryVariables = Exact<{
  id: Scalars['Int'];
  shopper_email: Scalars['String'];
  shopper_locale: Scalars['String'];
  top_level_domain: Scalars['String'];
}>;


export type BookingCreateAdyenSessionQuery = { __typename?: 'query_root', booking_create_adyen_session: { __typename?: 'BookingCreateAdyenSessionResponse', session_data: string, session_id: string } };

export type B2CGetCompletedOrdersQueryVariables = Exact<{
  plates: Array<Scalars['String']> | Scalars['String'];
}>;


export type B2CGetCompletedOrdersQuery = { __typename?: 'query_root', b2c_get_completed_orders: { __typename?: 'B2CCarpayOrderResponse', orders: Array<(
      { __typename?: 'B2CCarpayOrderView' }
      & { ' $fragmentRefs'?: { 'B2COrderResponseFragment': B2COrderResponseFragment } }
    )> } };

export type BookingGetDailyPriceQueryVariables = Exact<{
  lot_id: Scalars['String'];
  end_datetime: Scalars['timestamptz'];
  start_datetime: Scalars['timestamptz'];
  pricing_type: BookingPricingModelType;
}>;


export type BookingGetDailyPriceQuery = { __typename?: 'query_root', booking_get_price?: { __typename?: 'BookingGetPriceResponse', price?: number | null } | null };

export type BookingGetHourlyPriceQueryVariables = Exact<{
  lot_id: Scalars['String'];
  num_hours: Scalars['Int'];
  pricing_type: BookingPricingModelType;
}>;


export type BookingGetHourlyPriceQuery = { __typename?: 'query_root', booking_get_price_hourly?: { __typename?: 'BookingGetPriceHourlyResponse', offered_prices?: Array<number | null> | null } | null };

export type BookingGetLotImageUrlsQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type BookingGetLotImageUrlsQuery = { __typename?: 'query_root', booking_get_lot_image_urls: { __typename?: 'BookingGetLotImageUrls', primary_url: string, secondary_urls: Array<string | null> } };

export type B2cGetLotOccupancyQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type B2cGetLotOccupancyQuery = { __typename?: 'query_root', b2c_get_lot_occupancy: { __typename?: 'B2CLotOccupancy', free_spots?: number | null, last_updated_at: string, occupancy_distribution?: Array<number> | null } };

export type BookingGetLotQueryVariables = Exact<{
  lot_id: Scalars['String'];
}>;


export type BookingGetLotQuery = { __typename?: 'query_root', booking_get_lot: { __typename?: 'BookingGetLotResponse', id: string, is_live?: boolean | null, name: string, address: string, description: string, earliest_booking_date?: string | null, end_of_live_date?: string | null, lot_country_code?: string | null, min_booking_duration?: string | null, max_booking_duration?: string | null, opening_hours: { __typename?: 'OpeningHours', opening_hours_rrules?: Array<{ __typename?: 'OpeningHoursRrules', duration?: string | null, rrule?: string | null } | null> | null }, prices: Array<{ __typename?: 'BookingPrice', day?: number | null, hour?: number | null, month?: number | null, week?: number | null, pricing_type?: string | null } | null>, active_features: Array<{ __typename?: 'BookingFeature', config?: any | null, enabled: boolean, name: string } | null> } };

export type BookingGetLotsQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type BookingGetLotsQuery = { __typename?: 'query_root', booking_get_lots: Array<{ __typename?: 'BookingGetLotsResponse', id: string, name: string, address: string, proximity_meters: number, latitude: number, longitude: number }> };

export type B2COrderResponseFragment = { __typename?: 'B2CCarpayOrderView', scanned_codes: Array<string>, order: { __typename?: 'B2CCarpayOrderInfo', order_id: string, plate: string, start_date: string, end_date?: string | null, status: string, invoice_available: boolean }, lot: { __typename?: 'B2CCarpayLotInfo', lot_id: string, name: string, address: string, lot_type: LotType, lot_tariffs: Array<string>, sv_lot_type: SvLotType, discount_types: Array<DiscountType>, visible_toleration_time?: number | null, arrival_detection_time?: number | null }, price: { __typename?: 'B2CCarpayPriceInfo', currency: string, vat_rate: number, price_valid_until: string, parking_price: number, illegal_parking_price: number, discounted_parking_price: number, applied_discount: number, billable: boolean, billable_start: string, billable_end: string, payment_deadline?: string | null }, parking_contexts: Array<{ __typename?: 'OrderParkingContext', uuid: string, vehicle_type?: string | null }> } & { ' $fragmentName'?: 'B2COrderResponseFragment' };

export type B2CGetOpenOrdersQueryVariables = Exact<{
  plates: Array<Scalars['String']> | Scalars['String'];
}>;


export type B2CGetOpenOrdersQuery = { __typename?: 'query_root', b2c_get_open_orders: { __typename?: 'B2CCarpayOrderResponse', orders: Array<(
      { __typename?: 'B2CCarpayOrderView' }
      & { ' $fragmentRefs'?: { 'B2COrderResponseFragment': B2COrderResponseFragment } }
    )> } };

export type B2CGetOrderByIdQueryVariables = Exact<{
  order_id: Scalars['String'];
}>;


export type B2CGetOrderByIdQuery = { __typename?: 'query_root', b2c_get_order_by_id: (
    { __typename?: 'B2CCarpayOrderView' }
    & { ' $fragmentRefs'?: { 'B2COrderResponseFragment': B2COrderResponseFragment } }
  ) };

export type B2CGetOrderInvoiceQueryVariables = Exact<{
  order_id: Scalars['String'];
}>;


export type B2CGetOrderInvoiceQuery = { __typename?: 'query_root', b2c_get_invoice: { __typename?: 'B2CInvoice', invoice_id: string, url: string } };

export type B2COrderPriceResponseFragment = { __typename?: 'B2CCarpayOrderView', price: { __typename?: 'B2CCarpayPriceInfo', price_valid_until: string, parking_price: number, illegal_parking_price: number, discounted_parking_price: number, applied_discount: number } } & { ' $fragmentName'?: 'B2COrderPriceResponseFragment' };

export type B2CGetOrderPriceQueryVariables = Exact<{
  order_id: Scalars['String'];
  selected_parking_tariff: Scalars['String'];
  parking_context_uuid?: InputMaybe<Scalars['String']>;
}>;


export type B2CGetOrderPriceQuery = { __typename?: 'query_root', b2c_get_price: (
    { __typename?: 'B2CCarpayOrderView' }
    & { ' $fragmentRefs'?: { 'B2COrderPriceResponseFragment': B2COrderPriceResponseFragment } }
  ) };

export type B2cGetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type B2cGetPaymentMethodsQuery = { __typename?: 'query_root', b2c_get_payment_methods?: Array<{ __typename?: 'B2CPaymentMethod', id: string, created_at: string, variant?: string | null, card_data?: { __typename?: 'CardPaymentMethod', expiry_month?: string | null, expiry_year?: string | null, number?: string | null } | null } | null> | null };

export type GetUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDataQuery = { __typename?: 'query_root', get_user_data?: { __typename?: 'UserInfo', first_name: string, last_name: string, email: string, private_pricing_lots?: Array<{ __typename?: 'PrivatePricingLot', lot_id?: string | null, pricing_type?: BookingPricingModelType | null } | null> | null, vehicles?: Array<{ __typename?: 'Vehicle', name: string, manufacturer: string, model: string, vehicle_type: string, plate_id: string, id: string } | null> | null, license_plates?: Array<{ __typename?: 'BookingUserLicensePlate', id: string, plate: string, country: string } | null> | null } | null };

export type GetUserBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBookingsQuery = { __typename?: 'query_root', get_user_bookings?: Array<{ __typename?: 'UserBookingResponse', start_date: string, price: number, payment_method: string, lot_name: string, lot_id: string, lot_address: string, end_date: string, email: string, created_at_iso_str: string, booking_ref: string, booking_type: BookingType, plates?: Array<{ __typename?: 'BookingPlate', plate: string }> | null, invoices?: Array<{ __typename?: 'BookingInvoice', invoice_id: string }> | null, night_parking_data?: { __typename?: 'NightParkingData', iso_duration: string, rrule: string } | null } | null> | null };

export type GetUserInvoiceUrlQueryVariables = Exact<{
  booking_id: Scalars['String'];
}>;


export type GetUserInvoiceUrlQuery = { __typename?: 'query_root', get_user_invoice_url: { __typename?: 'GetUserInvoiceUrlResponse', signed_url: string } };

export type GetUserSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSubscriptionsQuery = { __typename?: 'query_root', get_user_subscriptions?: Array<{ __typename?: 'UserSubscriptionResponse', id: string, lot_id: string, start_date: string, end_date?: string | null, subscription_status?: SubscriptionStatus | null, user_email: string, plates?: Array<string | null> | null, subscription_price: number, lot_name?: string | null, lot_address?: string | null, subscription_bookings?: Array<{ __typename?: 'UserBookingResponse', start_date: string, price: number, payment_method: string, lot_name: string, lot_id: string, lot_address: string, end_date: string, email: string, created_at_iso_str: string, booking_ref: string, booking_type: BookingType, plates?: Array<{ __typename?: 'BookingPlate', plate: string }> | null, invoices?: Array<{ __typename?: 'BookingInvoice', invoice_id: string }> | null, night_parking_data?: { __typename?: 'NightParkingData', iso_duration: string, rrule: string } | null } | null> | null } | null> | null };

export type BookingVehicleTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingVehicleTypeQuery = { __typename?: 'query_root', booking_vehicle_type: Array<{ __typename?: 'booking_vehicle_type', value: string, description: string }> };

export const LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"legal_language"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat_rates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso_code"}},{"kind":"Field","name":{"kind":"Name","value":"iso_num"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carpay_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"carpay_terminal_notification_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_cash"}}]}}]}}]}}]} as unknown as DocumentNode<LotFragment, unknown>;
export const LotLegalEntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotLegalEntity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot_legal_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_vat_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat_id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LotLegalEntityFragment, unknown>;
export const LotContextPoliciesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotContextPolicies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parking_context"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]} as unknown as DocumentNode<LotContextPoliciesFragment, unknown>;
export const LotSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot_section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}}]}}]} as unknown as DocumentNode<LotSectionFragment, unknown>;
export const B2COrderResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]} as unknown as DocumentNode<B2COrderResponseFragment, unknown>;
export const B2COrderPriceResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderPriceResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}}]}}]}}]} as unknown as DocumentNode<B2COrderPriceResponseFragment, unknown>;
export const GetAccessControlPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessControlPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_access_control_get_pin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"site_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}}]}}]}}]} as unknown as DocumentNode<GetAccessControlPinQuery, GetAccessControlPinQueryVariables>;
export const SendAccessControlSmsPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SendAccessControlSMSPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_access_control_send_pin_sms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"site_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone_number"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}}]}}]}}]} as unknown as DocumentNode<SendAccessControlSmsPinQuery, SendAccessControlSmsPinQueryVariables>;
export const PaidParkingCarpayInsertOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaidParkingCarpayInsertOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_valid_until"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoice_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"original_price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vat_rate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carpay_scanned_codes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TerminalScannedCodeV2"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"terminal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TerminalPayment"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"errorflow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_valid_from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_terminal_confirm_order_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"price_valid_until"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_valid_until"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoice_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoice_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"original_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"original_price"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"Argument","name":{"kind":"Name","value":"vat_rate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vat_rate"}}},{"kind":"Argument","name":{"kind":"Name","value":"carpay_scanned_codes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carpay_scanned_codes"}}},{"kind":"Argument","name":{"kind":"Name","value":"terminal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"terminal_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment"}}},{"kind":"Argument","name":{"kind":"Name","value":"errorflow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"errorflow"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"price_valid_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_valid_from"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PaidParkingCarpayInsertOrderMutation, PaidParkingCarpayInsertOrderMutationVariables>;
export const PaidParkingCarpaySendTerminalNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaidParkingCarpaySendTerminalNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"terminal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp_in_lot_tz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TerminalNotificationEventType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_create_terminal_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"terminal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"terminal_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"timestamp_in_lot_tz"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp_in_lot_tz"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_type"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PaidParkingCarpaySendTerminalNotificationMutation, PaidParkingCarpaySendTerminalNotificationMutationVariables>;
export const GetLegalStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegalStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_terminal_get_legal_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legal_timeranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"illegal_timeranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}}]}}]}}]} as unknown as DocumentNode<GetLegalStatusQuery, GetLegalStatusQueryVariables>;
export const LotInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Lot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_legal_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"CARPAY"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotLegalEntity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_context"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotContextPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_section"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"legal_language"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat_rates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso_code"}},{"kind":"Field","name":{"kind":"Name","value":"iso_num"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carpay_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"carpay_terminal_notification_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_cash"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotLegalEntity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot_legal_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_vat_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat_id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotContextPolicies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parking_context"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lot_section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}}]}}]} as unknown as DocumentNode<LotInformationQuery, LotInformationQueryVariables>;
export const GetCarpayOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCarpayOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_paid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carpay_terminal_get_orders_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"include_paid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_paid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"drive_in_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"drive_out_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"legal_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legal_timeranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"illegal_timeranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"whitelist_id"}},{"kind":"Field","name":{"kind":"Name","value":"carpay_scanned_codes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"extractor_result"}},{"kind":"Field","name":{"kind":"Name","value":"carpay_discount_model_id"}},{"kind":"Field","name":{"kind":"Name","value":"carpay_discount_batch_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_value"}}]}}]}}]}}]} as unknown as DocumentNode<GetCarpayOrdersQuery, GetCarpayOrdersQueryVariables>;
export const SiblingLotInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiblingLotInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SiblingLotInfoQuery, SiblingLotInfoQueryVariables>;
export const SendInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sendInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carpay_order_order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"send_invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"carpay_order_order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carpay_order_order_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}}]}}]}}]} as unknown as DocumentNode<SendInvoiceQuery, SendInvoiceQueryVariables>;
export const GetDeviceUuidsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDeviceUuids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}}]}}]}}]} as unknown as DocumentNode<GetDeviceUuidsQuery, GetDeviceUuidsQueryVariables>;
export const GetDeviceDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDeviceData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"config_error"}},{"kind":"Field","name":{"kind":"Name","value":"config_force_update"}},{"kind":"Field","name":{"kind":"Name","value":"config_current_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"config_target_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"config"}}]}}]}}]} as unknown as DocumentNode<GetDeviceDataQuery, GetDeviceDataQueryVariables>;
export const UpdateDeviceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"diff_config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_device_config_mutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"diff_config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"diff_config"}}},{"kind":"Argument","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceConfigMutation, UpdateDeviceConfigMutationVariables>;
export const SetDeviceForceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDeviceForceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_device_force_update_mutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SetDeviceForceUpdateMutation, SetDeviceForceUpdateMutationVariables>;
export const SearchDeviceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchDeviceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_devices_by_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matching_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"general_config"}}]}},{"kind":"Field","name":{"kind":"Name","value":"non_matching_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"general_config"}}]}}]}}]}}]} as unknown as DocumentNode<SearchDeviceConfigQuery, SearchDeviceConfigQueryVariables>;
export const GetSmsStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSMSStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_sms_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_status"}}]}}]}}]} as unknown as DocumentNode<GetSmsStatusQuery, GetSmsStatusQueryVariables>;
export const SendSmsCommandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendSMSCommand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"send_sms_command"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SendSmsCommandMutation, SendSmsCommandMutationVariables>;
export const GetDevicesForLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DEVICES_FOR_LOT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"station_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}}]}}]}}]} as unknown as DocumentNode<GetDevicesForLotQuery, GetDevicesForLotQueryVariables>;
export const CreateLotAnalysisRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"create_lot_analysis_request"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_lot_analysis_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parking_lot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_entry_id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateLotAnalysisRequestQuery, CreateLotAnalysisRequestQueryVariables>;
export const GetLaResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_la_result"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request_entry_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverless_async_work"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request_entry_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetLaResultQuery, GetLaResultQueryVariables>;
export const GetParkingLotNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParkingLotNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetParkingLotNamesQuery, GetParkingLotNamesQueryVariables>;
export const GetLotSectionNamesByParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotSectionNamesByParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_section"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_lot_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLotSectionNamesByParkingLotQuery, GetLotSectionNamesByParkingLotQueryVariables>;
export const GetLotIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLotIdsQuery, GetLotIdsQueryVariables>;
export const GetLotSectionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotSectionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_section"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_id"}}]}}]}}]} as unknown as DocumentNode<GetLotSectionDataQuery, GetLotSectionDataQueryVariables>;
export const GetStationByParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStationByParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_section_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"station_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot_section_id"}},{"kind":"Field","name":{"kind":"Name","value":"device_direction"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"config_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"config_target_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetStationByParkingLotQuery, GetStationByParkingLotQueryVariables>;
export const GetPotentialMlPsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPotentialMLPs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lower_timestamp_threshold"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_potential_mlps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lower_timestamp_threshold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lower_timestamp_threshold"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"potential_mlps"}},{"kind":"Field","name":{"kind":"Name","value":"latest_timestamp"}}]}}]}}]} as unknown as DocumentNode<GetPotentialMlPsQuery, GetPotentialMlPsQueryVariables>;
export const PushCheckedMlPsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PushCheckedMLPs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkedMlps"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push_checked_mlps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checked_mlps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkedMlps"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PushCheckedMlPsMutation, PushCheckedMlPsMutationVariables>;
export const GetDeviceDashboardUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_device_dashboard_url"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_device_dashboard_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dashboard_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metabase_url"}}]}}]}}]} as unknown as DocumentNode<GetDeviceDashboardUrlQuery, GetDeviceDashboardUrlQueryVariables>;
export const GetBalenaDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBalenaDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_balena_device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"}}]}}]}}]} as unknown as DocumentNode<GetBalenaDeviceQuery, GetBalenaDeviceQueryVariables>;
export const GetBalenaReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBalenaRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"release_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_balena_release"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"release_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"release_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releases"}}]}}]}}]} as unknown as DocumentNode<GetBalenaReleaseQuery, GetBalenaReleaseQueryVariables>;
export const GetStationNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStationNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station_name"}}]}}]}}]} as unknown as DocumentNode<GetStationNamesQuery, GetStationNamesQueryVariables>;
export const GetStationDataByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStationDataByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"station_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot_section_id"}},{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"config_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"device_direction"}}]}}]}}]} as unknown as DocumentNode<GetStationDataByNameQuery, GetStationDataByNameQueryVariables>;
export const UpdateStationConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdateStationConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_station_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"station_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateStationConfigQuery, UpdateStationConfigQueryVariables>;
export const UpdateStationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdateStationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_direction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_station_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"station_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_section_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"device_direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateStationDataQuery, UpdateStationDataQueryVariables>;
export const DeleteStationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_station"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"station_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteStationMutation, DeleteStationMutationVariables>;
export const GetStationByDeviceIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStationByDeviceId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"station_name"}}]}}]}}]} as unknown as DocumentNode<GetStationByDeviceIdQuery, GetStationByDeviceIdQueryVariables>;
export const UpdateStationDataMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStationDataMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_direction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_station_data_mutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"station_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_section_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_section_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"device_direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateStationDataMutationMutation, UpdateStationDataMutationMutationVariables>;
export const UpdateStationConfigMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStationConfigMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_station_config_mutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"station_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateStationConfigMutationMutation, UpdateStationConfigMutationMutationVariables>;
export const GetDeviceSystemImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_device_system_image"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roi_image"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_system_image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"latest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest"}}},{"kind":"Argument","name":{"kind":"Name","value":"roi_image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roi_image"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signed_url"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<GetDeviceSystemImageQuery, GetDeviceSystemImageQueryVariables>;
export const CreateErrorRatePredictionRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"create_error_rate_prediction_request"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initial_filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modified_filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_error_rate_prediction_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parking_lot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}}},{"kind":"Argument","name":{"kind":"Name","value":"station_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"initial_params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initial_filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"modified_params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modified_filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_entry_id"}}]}}]}}]} as unknown as DocumentNode<CreateErrorRatePredictionRequestQuery, CreateErrorRatePredictionRequestQueryVariables>;
export const GetErrorPredictionResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_error_prediction_result"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request_entry_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverless_async_work"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request_entry_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetErrorPredictionResultQuery, GetErrorPredictionResultQueryVariables>;
export const GetCoordinateParkingDetectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_coordinate_parking_detections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"missing_lp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parking_detections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"device_uuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device_uuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"missing_lp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"missing_lp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parking_lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_lot"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"missing_lp"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}},{"kind":"Field","name":{"kind":"Name","value":"device_uuid"}}]}}]}}]} as unknown as DocumentNode<GetCoordinateParkingDetectionsQuery, GetCoordinateParkingDetectionsQueryVariables>;
export const B2CApplyCarpayVoucherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"B2CApplyCarpayVoucher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_apply_discount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"selected_parking_tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2COrderResponse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]} as unknown as DocumentNode<B2CApplyCarpayVoucherMutation, B2CApplyCarpayVoucherMutationVariables>;
export const BookingCancelUserSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"booking_cancel_user_subscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscription_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_cancel_user_subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscription_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscription_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BookingCancelUserSubscriptionMutation, BookingCancelUserSubscriptionMutationVariables>;
export const BookingCreateBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BookingCreateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputBookingPlate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_reference"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"unavailable_dates"}}]}}]}}]} as unknown as DocumentNode<BookingCreateBookingMutation, BookingCreateBookingMutationVariables>;
export const BookingCreateBookingHourlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BookingCreateBookingHourly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputBookingPlate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration_hours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_booking_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}},{"kind":"Argument","name":{"kind":"Name","value":"duration_hours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration_hours"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_reference"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"unavailable_dates"}}]}}]}}]} as unknown as DocumentNode<BookingCreateBookingHourlyMutation, BookingCreateBookingHourlyMutationVariables>;
export const BookingCreateBookingNightlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BookingCreateBookingNightly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputBookingPlate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"night_parking_config"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NightParkingConfig"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_night_parking_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"night_parking_config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"night_parking_config"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_reference"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"unavailable_dates"}}]}}]}}]} as unknown as DocumentNode<BookingCreateBookingNightlyMutation, BookingCreateBookingNightlyMutationVariables>;
export const B2cSavePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"b2c_save_payment_method"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_save_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopper_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"top_level_domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_data"}},{"kind":"Field","name":{"kind":"Name","value":"session_id"}}]}}]}}]} as unknown as DocumentNode<B2cSavePaymentMethodMutation, B2cSavePaymentMethodMutationVariables>;
export const BookingCreateSubsSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"booking_create_subs_session"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"license_plate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_subs_session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"top_level_domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}}},{"kind":"Argument","name":{"kind":"Name","value":"license_plate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"license_plate_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_data"}},{"kind":"Field","name":{"kind":"Name","value":"session_id"}}]}}]}}]} as unknown as DocumentNode<BookingCreateSubsSessionMutation, BookingCreateSubsSessionMutationVariables>;
export const BookingCreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"booking_create_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBookingUserRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BookingCreateUserMutation, BookingCreateUserMutationVariables>;
export const BookingCreateUserBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BookingCreateUserBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputBookingPlate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingPricingModelType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_user_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"pricing_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_reference"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"unavailable_dates"}}]}}]}}]} as unknown as DocumentNode<BookingCreateUserBookingMutation, BookingCreateUserBookingMutationVariables>;
export const BookingCreateUserBookingHourlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BookingCreateUserBookingHourly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputBookingPlate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration_hours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingPricingModelType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_user_booking_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}},{"kind":"Argument","name":{"kind":"Name","value":"duration_hours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration_hours"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"pricing_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_reference"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"unavailable_dates"}}]}}]}}]} as unknown as DocumentNode<BookingCreateUserBookingHourlyMutation, BookingCreateUserBookingHourlyMutationVariables>;
export const CreateUserLicensePlateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"create_user_license_plate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserLicensePlateRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_user_license_plate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserLicensePlateMutation, CreateUserLicensePlateMutationVariables>;
export const CreateUserVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"create_user_vehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserVehicleRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_user_vehicle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserVehicleMutation, CreateUserVehicleMutationVariables>;
export const B2cDeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"b2c_delete_payment_method"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_method_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_delete_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_method_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_method_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<B2cDeletePaymentMethodMutation, B2cDeletePaymentMethodMutationVariables>;
export const DeleteUserLicensePlateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delete_user_license_plate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserLicensePlateRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_license_plate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteUserLicensePlateMutation, DeleteUserLicensePlateMutationVariables>;
export const DeleteUserVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delete_user_vehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserVehicleRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_vehicle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteUserVehicleMutation, DeleteUserVehicleMutationVariables>;
export const BookingUpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"booking_update_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBookingUserRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BookingUpdateUserMutation, BookingUpdateUserMutationVariables>;
export const UpdateUserLicensePlateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"update_user_license_plate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserLicensePlateRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_license_plate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLicensePlateMutation, UpdateUserLicensePlateMutationVariables>;
export const UpdateUserVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"update_user_vehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserVehicleRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_vehicle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserVehicleMutation, UpdateUserVehicleMutationVariables>;
export const BookingGetPublicLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"booking_get_public_lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_public_lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"}}]}}]}}]} as unknown as DocumentNode<BookingGetPublicLotsQuery, BookingGetPublicLotsQueryVariables>;
export const B2CGetCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"selected_parking_tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adyen_id"}},{"kind":"Field","name":{"kind":"Name","value":"adyen_session_data"}}]}}]}}]} as unknown as DocumentNode<B2CGetCheckoutSessionQuery, B2CGetCheckoutSessionQueryVariables>;
export const B2CGetErrorFlowCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetErrorFlowCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_errorflow_checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"selected_parking_tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adyen_id"}},{"kind":"Field","name":{"kind":"Name","value":"adyen_session_data"}}]}}]}}]} as unknown as DocumentNode<B2CGetErrorFlowCheckoutSessionQuery, B2CGetErrorFlowCheckoutSessionQueryVariables>;
export const GetErrorflowPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetErrorflowPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_errorflow_price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"plate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plate"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"selected_parking_tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]}}]} as unknown as DocumentNode<GetErrorflowPriceQuery, GetErrorflowPriceQueryVariables>;
export const B2CGetLotByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetLotById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_carpay_lot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}}]}}]}}]} as unknown as DocumentNode<B2CGetLotByIdQuery, B2CGetLotByIdQueryVariables>;
export const B2cGetCarpayLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"b2c_get_carpay_lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_carpay_lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]} as unknown as DocumentNode<B2cGetCarpayLotsQuery, B2cGetCarpayLotsQueryVariables>;
export const BookingCreateAdyenSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingCreateAdyenSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_create_adyen_session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopper_locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopper_locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"top_level_domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"top_level_domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_data"}},{"kind":"Field","name":{"kind":"Name","value":"session_id"}}]}}]}}]} as unknown as DocumentNode<BookingCreateAdyenSessionQuery, BookingCreateAdyenSessionQueryVariables>;
export const B2CGetCompletedOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetCompletedOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_completed_orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2COrderResponse"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]} as unknown as DocumentNode<B2CGetCompletedOrdersQuery, B2CGetCompletedOrdersQueryVariables>;
export const BookingGetDailyPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingGetDailyPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingPricingModelType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_datetime"}}},{"kind":"Argument","name":{"kind":"Name","value":"pricing_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<BookingGetDailyPriceQuery, BookingGetDailyPriceQueryVariables>;
export const BookingGetHourlyPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingGetHourlyPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"num_hours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingPricingModelType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_price_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"num_hours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"num_hours"}}},{"kind":"Argument","name":{"kind":"Name","value":"pricing_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricing_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offered_prices"}}]}}]}}]} as unknown as DocumentNode<BookingGetHourlyPriceQuery, BookingGetHourlyPriceQueryVariables>;
export const BookingGetLotImageUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"booking_get_lot_image_urls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_lot_image_urls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_url"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_urls"}}]}}]}}]} as unknown as DocumentNode<BookingGetLotImageUrlsQuery, BookingGetLotImageUrlsQueryVariables>;
export const B2cGetLotOccupancyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"b2c_get_lot_occupancy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_lot_occupancy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_spots"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"occupancy_distribution"}}]}}]}}]} as unknown as DocumentNode<B2cGetLotOccupancyQuery, B2cGetLotOccupancyQueryVariables>;
export const BookingGetLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"booking_get_lot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_lot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_live"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"opening_hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opening_hours_rrules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"pricing_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earliest_booking_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_of_live_date"}},{"kind":"Field","name":{"kind":"Name","value":"lot_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"min_booking_duration"}},{"kind":"Field","name":{"kind":"Name","value":"max_booking_duration"}}]}}]}}]} as unknown as DocumentNode<BookingGetLotQuery, BookingGetLotQueryVariables>;
export const BookingGetLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"booking_get_lots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_get_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"proximity_meters"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<BookingGetLotsQuery, BookingGetLotsQueryVariables>;
export const B2CGetOpenOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetOpenOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_open_orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2COrderResponse"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]} as unknown as DocumentNode<B2CGetOpenOrdersQuery, B2CGetOpenOrdersQueryVariables>;
export const B2CGetOrderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetOrderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_order_by_id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2COrderResponse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_tariffs"}},{"kind":"Field","name":{"kind":"Name","value":"sv_lot_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_types"}},{"kind":"Field","name":{"kind":"Name","value":"visible_toleration_time"}},{"kind":"Field","name":{"kind":"Name","value":"arrival_detection_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billable_start"}},{"kind":"Field","name":{"kind":"Name","value":"billable_end"}},{"kind":"Field","name":{"kind":"Name","value":"payment_deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_contexts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scanned_codes"}}]}}]} as unknown as DocumentNode<B2CGetOrderByIdQuery, B2CGetOrderByIdQueryVariables>;
export const B2CGetOrderInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetOrderInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<B2CGetOrderInvoiceQuery, B2CGetOrderInvoiceQueryVariables>;
export const B2CGetOrderPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2CGetOrderPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"selected_parking_tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected_parking_tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"parking_context_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parking_context_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2COrderPriceResponse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2COrderPriceResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2CCarpayOrderView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"illegal_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"discounted_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"applied_discount"}}]}}]}}]} as unknown as DocumentNode<B2CGetOrderPriceQuery, B2CGetOrderPriceQueryVariables>;
export const B2cGetPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"b2c_get_payment_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2c_get_payment_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"card_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<B2cGetPaymentMethodsQuery, B2cGetPaymentMethodsQueryVariables>;
export const GetUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_user_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"private_pricing_lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"pricing_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_type"}},{"kind":"Field","name":{"kind":"Name","value":"plate_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"license_plates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDataQuery, GetUserDataQueryVariables>;
export const GetUserBookingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_user_bookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_bookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"plates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"lot_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_address"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at_iso_str"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_ref"}},{"kind":"Field","name":{"kind":"Name","value":"booking_type"}},{"kind":"Field","name":{"kind":"Name","value":"night_parking_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso_duration"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserBookingsQuery, GetUserBookingsQueryVariables>;
export const GetUserInvoiceUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_user_invoice_url"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"booking_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_invoice_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"booking_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"booking_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signed_url"}}]}}]}}]} as unknown as DocumentNode<GetUserInvoiceUrlQuery, GetUserInvoiceUrlQueryVariables>;
export const GetUserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get_user_subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_status"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_bookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"plates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"lot_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_address"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at_iso_str"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_ref"}},{"kind":"Field","name":{"kind":"Name","value":"booking_type"}},{"kind":"Field","name":{"kind":"Name","value":"night_parking_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iso_duration"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_email"}},{"kind":"Field","name":{"kind":"Name","value":"plates"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot_address"}}]}}]}}]} as unknown as DocumentNode<GetUserSubscriptionsQuery, GetUserSubscriptionsQueryVariables>;
export const BookingVehicleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"booking_vehicle_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_vehicle_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<BookingVehicleTypeQuery, BookingVehicleTypeQueryVariables>;